
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaa85"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaa85"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6Lt8S", function(module, exports) {
$parcel$export(module.exports, "SocialModule", () => (parcelRequire("cRdul")).SocialModule);
$parcel$export(module.exports, "SocialService", () => (parcelRequire("2cx1H")).SocialService);
parcelRequire("9zeC7");
parcelRequire("cRdul");
parcelRequire("2cx1H");
parcelRequire("hvId1");
parcelRequire("9hU4p");

});
parcelRegister("9zeC7", function(module, exports) {

var $4XQlz = parcelRequire("4XQlz");
const $ca489e6aa0afeab8$export$810137c0d4bae87d = new (0, $4XQlz.InjectionToken)('firestore-database');
const $ca489e6aa0afeab8$export$38c95526226ae95e = new (0, $4XQlz.InjectionToken)('firebase-database');

});
parcelRegister("4XQlz", function(module, exports) {
"use strict";
var $39d5471bd27d170a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $39d5471bd27d170a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $39d5471bd27d170a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("iWLGv");

$39d5471bd27d170a$var$__exportStar((parcelRequire("4q6qh")), module.exports);

$39d5471bd27d170a$var$__exportStar((parcelRequire("kHLvy")), module.exports);

$39d5471bd27d170a$var$__exportStar((parcelRequire("ckLEO")), module.exports);

$39d5471bd27d170a$var$__exportStar((parcelRequire("fx7Of")), module.exports);

});
parcelRegister("iWLGv", function(module, exports) {
const $dcb2a1eea9ce7383$var$Metadata = new WeakMap();
function $dcb2a1eea9ce7383$var$decorateProperty(decorators, target, propertyKey, descriptor) {
    decorators.reverse().forEach((decorator)=>{
        descriptor = decorator(target, propertyKey, descriptor) || descriptor;
    });
    return descriptor;
}
function $dcb2a1eea9ce7383$var$decorateConstructor(decorators, target) {
    decorators.reverse().forEach((decorator)=>{
        const decorated = decorator(target);
        if (decorated) target = decorated;
    });
    return target;
}
function $dcb2a1eea9ce7383$export$c80826d3392ea781(decorators, target, propertyKey, attributes) {
    if (!Array.isArray(decorators) || decorators.length === 0) throw new TypeError();
    if (propertyKey !== undefined) return $dcb2a1eea9ce7383$var$decorateProperty(decorators, target, propertyKey, attributes);
    if (typeof target === 'function') return $dcb2a1eea9ce7383$var$decorateConstructor(decorators, target);
    return;
}
function $dcb2a1eea9ce7383$var$getMetadataMap(target, propertyKey) {
    return $dcb2a1eea9ce7383$var$Metadata.get(target) && $dcb2a1eea9ce7383$var$Metadata.get(target).get(propertyKey);
}
function $dcb2a1eea9ce7383$var$ordinaryGetOwnMetadata(metadataKey, target, propertyKey) {
    if (target === undefined) throw new TypeError();
    const metadataMap = $dcb2a1eea9ce7383$var$getMetadataMap(target, propertyKey);
    return metadataMap && metadataMap.get(metadataKey);
}
function $dcb2a1eea9ce7383$var$createMetadataMap(target, propertyKey) {
    const targetMetadata = $dcb2a1eea9ce7383$var$Metadata.get(target) || new Map();
    $dcb2a1eea9ce7383$var$Metadata.set(target, targetMetadata);
    const metadataMap = targetMetadata.get(propertyKey) || new Map();
    targetMetadata.set(propertyKey, metadataMap);
    return metadataMap;
}
function $dcb2a1eea9ce7383$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey) {
    if (propertyKey && ![
        'string',
        'symbol'
    ].includes(typeof propertyKey)) throw new TypeError();
    ($dcb2a1eea9ce7383$var$getMetadataMap(target, propertyKey) || $dcb2a1eea9ce7383$var$createMetadataMap(target, propertyKey)).set(metadataKey, metadataValue);
}
function $dcb2a1eea9ce7383$var$ordinaryGetMetadata(metadataKey, target, propertyKey) {
    return $dcb2a1eea9ce7383$var$ordinaryGetOwnMetadata(metadataKey, target, propertyKey) ? $dcb2a1eea9ce7383$var$ordinaryGetOwnMetadata(metadataKey, target, propertyKey) : Object.getPrototypeOf(target) ? $dcb2a1eea9ce7383$var$ordinaryGetMetadata(metadataKey, Object.getPrototypeOf(target), propertyKey) : undefined;
}
function $dcb2a1eea9ce7383$export$dbb5e893e736e4ee(metadataKey, metadataValue) {
    return function decorator(target, propertyKey) {
        $dcb2a1eea9ce7383$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
    };
}
function $dcb2a1eea9ce7383$export$8548546c0aa631e6(metadataKey, target, propertyKey) {
    return $dcb2a1eea9ce7383$var$ordinaryGetMetadata(metadataKey, target, propertyKey);
}
function $dcb2a1eea9ce7383$export$cc60eefbe5c9bad7(metadataKey, target, propertyKey) {
    return $dcb2a1eea9ce7383$var$ordinaryGetOwnMetadata(metadataKey, target, propertyKey);
}
function $dcb2a1eea9ce7383$export$38cb5e4e0f9aedfe(metadataKey, target, propertyKey) {
    return !!$dcb2a1eea9ce7383$var$ordinaryGetOwnMetadata(metadataKey, target, propertyKey);
}
function $dcb2a1eea9ce7383$export$fc04a41421709487(metadataKey, target, propertyKey) {
    return !!$dcb2a1eea9ce7383$var$ordinaryGetMetadata(metadataKey, target, propertyKey);
}
function $dcb2a1eea9ce7383$export$70bbf20791f57d90(metadataKey, metadataValue, target, propertyKey) {
    $dcb2a1eea9ce7383$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
}
const $dcb2a1eea9ce7383$export$7c4bec61e60f667b = {
    decorate: $dcb2a1eea9ce7383$export$c80826d3392ea781,
    defineMetadata: $dcb2a1eea9ce7383$export$70bbf20791f57d90,
    getMetadata: $dcb2a1eea9ce7383$export$8548546c0aa631e6,
    getOwnMetadata: $dcb2a1eea9ce7383$export$cc60eefbe5c9bad7,
    hasMetadata: $dcb2a1eea9ce7383$export$fc04a41421709487,
    hasOwnMetadata: $dcb2a1eea9ce7383$export$38cb5e4e0f9aedfe,
    metadata: $dcb2a1eea9ce7383$export$dbb5e893e736e4ee
};
Object.assign(Reflect, $dcb2a1eea9ce7383$export$7c4bec61e60f667b);

});

parcelRegister("4q6qh", function(module, exports) {
"use strict";
var $337e9298615de2be$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $337e9298615de2be$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $337e9298615de2be$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InjectionToken = module.exports.ContainerInstance = module.exports.Container = module.exports.Injectable = void 0;

var $8DS2b = parcelRequire("8DS2b");
Object.defineProperty(module.exports, "Injectable", {
    enumerable: true,
    get: function() {
        return $8DS2b.Service;
    }
});

var $9m0Ub = parcelRequire("9m0Ub");
Object.defineProperty(module.exports, "Container", {
    enumerable: true,
    get: function() {
        return $9m0Ub.Container;
    }
});

var $7HsI4 = parcelRequire("7HsI4");
Object.defineProperty(module.exports, "ContainerInstance", {
    enumerable: true,
    get: function() {
        return $7HsI4.ContainerInstance;
    }
});

var $7OIQ0 = parcelRequire("7OIQ0");
Object.defineProperty(module.exports, "InjectionToken", {
    enumerable: true,
    get: function() {
        return $7OIQ0.Token;
    }
});

$337e9298615de2be$var$__exportStar((parcelRequire("gX91L")), module.exports);

});
parcelRegister("8DS2b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Service = $64abe151e35800a2$var$Service;

var $9je1N = parcelRequire("9je1N");
/**
 * Marks class as a service that can be injected using container.
 */ function $64abe151e35800a2$var$Service(options) {
    return (0, $9je1N.ReflectDecorator)(options, {
        type: 'service'
    });
}

});
parcelRegister("9je1N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReflectDecorator = $6c70c512be60e07a$var$ReflectDecorator;

var $aZzCP = parcelRequire("aZzCP");

var $9m0Ub = parcelRequire("9m0Ub");

var $7OIQ0 = parcelRequire("7OIQ0");
function $6c70c512be60e07a$var$ReflectDecorator(options, metaOptions) {
    return (target)=>{
        const uniqueHashForClass = (0, $aZzCP.createUniqueHash)(`${target}${JSON.stringify(options, null, 4)}`);
        Object.defineProperty(target, 'originalName', {
            value: target.name || target.constructor.name,
            writable: false
        });
        Object.defineProperty(target, 'name', {
            value: uniqueHashForClass,
            writable: true
        });
        const nameCapitalized = (name)=>name.charAt(0).toUpperCase() + name.slice(1);
        target['metadata'] = {
            moduleName: target['originalName'],
            moduleHash: uniqueHashForClass,
            options: options || null,
            type: metaOptions.type,
            raw: `
        ---- @${nameCapitalized(metaOptions.type)} '${target.name}' metadata----
        @${nameCapitalized(metaOptions.type)}(${JSON.stringify(options, null, 4)})
        ${target['originalName']}
        `
        };
        const service = {
            type: target
        };
        if (typeof options === 'string' || options instanceof $7OIQ0.Token) {
            service.id = options;
            service.multiple = options.multiple;
            service.global = options.global || false;
            service.transient = options.transient;
        } else if (options) {
            service.id = options.id;
            service.factory = options.factory;
            service.multiple = options.multiple;
            service.global = options.global || false;
            service.transient = options.transient;
        }
        $9m0Ub.Container.set(service);
    };
}

});
parcelRegister("aZzCP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUniqueHash = $800b3c58244ed737$var$createUniqueHash;

var $cl9dc = parcelRequire("cl9dc");
function $800b3c58244ed737$var$createUniqueHash(key) {
    return $cl9dc.sha256.hash(key);
}

});
parcelRegister("cl9dc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha256 = module.exports.Sha256 = void 0;
class $8fbe97819b967015$var$Sha256 {
    /**
     * Generates SHA-256 hash of string.
     *
     * @param   {string} msg - (Unicode) string to be hashed.
     * @param   {Object} [options]
     * @param   {string} [options.msgFormat=string] - Message format: 'string' for JavaScript string
     *   (gets converted to UTF-8 for hashing); 'hex-bytes' for string of hex bytes ('616263' ≡ 'abc') .
     * @param   {string} [options.outFormat=hex] - Output format: 'hex' for string of contiguous
     *   hex bytes; 'hex-w' for grouping hex bytes into groups of (4 byte / 8 character) words.
     * @returns {string} Hash of msg as hex character string.
     */ hash(msg, options) {
        const defaults = {
            msgFormat: 'string',
            outFormat: 'hex'
        };
        const opt = Object.assign(defaults, options);
        // note use throughout this routine of 'n >>> 0' to coerce Number 'n' to unsigned 32-bit integer
        msg = utf8Encode(msg);
        switch(opt.msgFormat){
            default:
            case 'string':
                msg = utf8Encode(msg);
                break;
            case 'hex-bytes':
                msg = hexBytesToString(msg);
                break; // mostly for running tests
        }
        // constants [§4.2.2]
        const K = [
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ];
        // initial hash value [§5.3.3]
        const H = [
            0x6a09e667,
            0xbb67ae85,
            0x3c6ef372,
            0xa54ff53a,
            0x510e527f,
            0x9b05688c,
            0x1f83d9ab,
            0x5be0cd19
        ];
        // PREPROCESSING [§6.2.1]
        msg += String.fromCharCode(0x80); // add trailing '1' bit (+ 0's padding) to string [§5.1.1]
        // convert string msg into 512-bit blocks (array of 16 32-bit integers) [§5.2.1]
        const l = msg.length / 4 + 2; // length (in 32-bit integers) of msg + ‘1’ + appended length
        const N = Math.ceil(l / 16); // number of 16-integer (512-bit) blocks required to hold 'l' ints
        const M = new Array(N); // message M is N×16 array of 32-bit integers
        for(let i = 0; i < N; i++){
            M[i] = new Array(16);
            for(let j = 0; j < 16; j++)M[i][j] = msg.charCodeAt(i * 64 + j * 4 + 0) << 24 | msg.charCodeAt(i * 64 + j * 4 + 1) << 16 | msg.charCodeAt(i * 64 + j * 4 + 2) << 8 | msg.charCodeAt(i * 64 + j * 4 + 3) << 0;
             // note running off the end of msg is ok 'cos bitwise ops on NaN return 0
        }
        // add length (in bits) into final pair of 32-bit integers (big-endian) [§5.1.1]
        // note: most significant word would be (len-1)*8 >>> 32, but since JS converts
        // bitwise-op args to 32 bits, we need to simulate this by arithmetic operators
        const lenHi = (msg.length - 1) * 8 / Math.pow(2, 32);
        const lenLo = (msg.length - 1) * 8 >>> 0;
        M[N - 1][14] = Math.floor(lenHi);
        M[N - 1][15] = lenLo;
        // HASH COMPUTATION [§6.2.2]
        for(let i = 0; i < N; i++){
            const W = new Array(64);
            // 1 - prepare message schedule 'W'
            for(let t = 0; t < 16; t++)W[t] = M[i][t];
            for(let t = 16; t < 64; t++)W[t] = this.\u03C31(W[t - 2]) + W[t - 7] + this.\u03C30(W[t - 15]) + W[t - 16] >>> 0;
            // 2 - initialise working variables a, b, c, d, e, f, g, h with previous hash value
            let a = H[0], b = H[1], c = H[2], d = H[3], e = H[4], f = H[5], g = H[6], h = H[7];
            // 3 - main loop (note '>>> 0' for 'addition modulo 2^32')
            for(let t = 0; t < 64; t++){
                const T1 = h + this.\u03A31(e) + this.Ch(e, f, g) + K[t] + W[t];
                const T2 = this.\u03A30(a) + this.Maj(a, b, c);
                h = g;
                g = f;
                f = e;
                e = d + T1 >>> 0;
                d = c;
                c = b;
                b = a;
                a = T1 + T2 >>> 0;
            }
            // 4 - compute the new intermediate hash value (note '>>> 0' for 'addition modulo 2^32')
            H[0] = H[0] + a >>> 0;
            H[1] = H[1] + b >>> 0;
            H[2] = H[2] + c >>> 0;
            H[3] = H[3] + d >>> 0;
            H[4] = H[4] + e >>> 0;
            H[5] = H[5] + f >>> 0;
            H[6] = H[6] + g >>> 0;
            H[7] = H[7] + h >>> 0;
        }
        // convert H0..H7 to hex strings (with leading zeros)
        for(let h = 0; h < H.length; h++)H[h] = ('00000000' + H[h].toString(16)).slice(-8);
        // concatenate H0..H7, with separator if required
        const separator = opt.outFormat == 'hex-w' ? ' ' : '';
        return H.join(separator);
        /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */ function utf8Encode(str) {
            try {
                return new TextEncoder().encode(str).reduce((prev, curr)=>prev + String.fromCharCode(curr), '');
            } catch (e) {
                return unescape(encodeURIComponent(str)); // monsur.hossa.in/2012/07/20/utf-8-in-javascript.html
            }
        }
        function hexBytesToString(hexStr) {
            const str = hexStr.replace(' ', ''); // allow space-separated groups
            return str == '' ? '' : str.match(/.{2}/g).map((byte)=>String.fromCharCode(parseInt(byte, 16))).join('');
        }
    }
    /**
     * Rotates right (circular right shift) value x by n positions [§3.2.4].
     * @private
     */ ROTR(n, x) {
        return x >>> n | x << 32 - n;
    }
    /**
     * Logical functions [§4.1.2].
     * @private
     */ \u03A30(x) {
        return this.ROTR(2, x) ^ this.ROTR(13, x) ^ this.ROTR(22, x);
    }
    \u03A31(x) {
        return this.ROTR(6, x) ^ this.ROTR(11, x) ^ this.ROTR(25, x);
    }
    \u03C30(x) {
        return this.ROTR(7, x) ^ this.ROTR(18, x) ^ x >>> 3;
    }
    \u03C31(x) {
        return this.ROTR(17, x) ^ this.ROTR(19, x) ^ x >>> 10;
    }
    Ch(x, y, z) {
        return x & y ^ ~x & z;
    }
    Maj(x, y, z) {
        return x & y ^ x & z ^ y & z;
    }
}
module.exports.Sha256 = $8fbe97819b967015$var$Sha256;
module.exports.sha256 = new $8fbe97819b967015$var$Sha256();

});


parcelRegister("9m0Ub", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Container = void 0;

var $7HsI4 = parcelRequire("7HsI4");
/**
 * Service container.
 */ class $6cf6dede85b406b9$var$Container {
    // -------------------------------------------------------------------------
    // Public Static Methods
    // -------------------------------------------------------------------------
    /**
     * Gets a separate container instance for the given instance id.
     */ static of(instanceId) {
        if (instanceId === undefined) return this.globalInstance;
        let container = this.instances.get(instanceId);
        if (!container) {
            container = new $7HsI4.ContainerInstance(instanceId);
            this.instances.set(instanceId, container);
        }
        return container;
    }
    /**
     * Checks if the service with given name or type is registered service container.
     * Optionally, parameters can be passed in case if instance is initialized in the container for the first time.
     */ static has(identifier) {
        return this.globalInstance.has(identifier);
    }
    /**
     * Retrieves the service with given name or type from the service container.
     * Optionally, parameters can be passed in case if instance is initialized in the container for the first time.
     */ static get(identifier) {
        return this.globalInstance.get(identifier);
    }
    /**
     * Gets all instances registered in the container of the given service identifier.
     * Used when service defined with multiple: true flag.
     */ static getMany(id) {
        return this.globalInstance.getMany(id);
    }
    /**
     * Sets a value for the given type or service name in the container.
     */ static set(identifierOrServiceMetadata, value) {
        this.globalInstance.set(identifierOrServiceMetadata, value);
        return this;
    }
    /**
     * Removes services with a given service identifiers (tokens or types).
     */ static remove(...ids) {
        this.globalInstance.remove(...ids);
        return this;
    }
    /**
     * Completely resets the container by removing all previously registered services and handlers from it.
     */ static reset(containerId) {
        if (containerId) {
            const instance = this.instances.get(containerId);
            if (instance) {
                instance.reset();
                this.instances.delete(containerId);
            }
        } else {
            this.globalInstance.reset();
            Array.from(this.instances.values()).forEach((i)=>i.reset());
        }
        return this;
    }
    /**
     * Registers a new handler.
     */ static registerHandler(handler) {
        this.handlers.set(handler, handler);
        return this;
    }
    /**
     * Helper method that imports given services.
     */ static import(services) {
        return this;
    }
}
module.exports.Container = $6cf6dede85b406b9$var$Container;
// -------------------------------------------------------------------------
// Private Static Properties
// -------------------------------------------------------------------------
/**
 * Global container instance.
 */ $6cf6dede85b406b9$var$Container.globalInstance = new $7HsI4.ContainerInstance(undefined);
/**
 * Other containers created using Container.of method.
 */ $6cf6dede85b406b9$var$Container.instances = new Map();
/**
 * All registered handlers.
 */ $6cf6dede85b406b9$var$Container.handlers = new Map();

});
parcelRegister("7HsI4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerInstance = void 0;

var $9m0Ub = parcelRequire("9m0Ub");

var $k3uYL = parcelRequire("k3uYL");

var $7T0ew = parcelRequire("7T0ew");

var $7OIQ0 = parcelRequire("7OIQ0");

var $a77jh = parcelRequire("a77jh");
/**
 * TypeDI can have multiple containers.
 * One container is ContainerInstance.
 */ class $59b2d1beb773a95f$var$ContainerInstance {
    // -------------------------------------------------------------------------
    // Constructor
    // -------------------------------------------------------------------------
    constructor(id){
        // -------------------------------------------------------------------------
        // Private Properties
        // -------------------------------------------------------------------------
        /**
         * All registered services.
         */ this.services = new Map();
        this.id = id;
    }
    /**
     * Checks if the service with given name or type is registered service container.
     * Optionally, parameters can be passed in case if instance is initialized in the container for the first time.
     */ has(identifier) {
        return !!this.findService(identifier);
    }
    /**
     * Retrieves the service with given name or type from the service container.
     * Optionally, parameters can be passed in case if instance is initialized in the container for the first time.
     */ get(identifier) {
        const globalContainer = $9m0Ub.Container.of(undefined);
        const service = globalContainer.findService(identifier);
        const scopedService = this.findService(identifier);
        if (service && service.global === true) return this.getServiceValue(identifier, service);
        if (scopedService) return this.getServiceValue(identifier, scopedService);
        if (service && this !== globalContainer) {
            const clonedService = Object.assign({}, service);
            clonedService.value = undefined;
            const value = this.getServiceValue(identifier, clonedService);
            this.set(identifier, value);
            return value;
        }
        return this.getServiceValue(identifier, service);
    }
    /**
     * Gets all instances registered in the container of the given service identifier.
     * Used when service defined with multiple: true flag.
     */ getMany(id) {
        return this.filterServices(id).map((service)=>this.getServiceValue(id, service));
    }
    /**
     * Sets a value for the given type or service name in the container.
     */ set(identifierOrServiceMetadata, value) {
        if (identifierOrServiceMetadata instanceof Array) {
            identifierOrServiceMetadata.forEach((v)=>this.set(v));
            return this;
        }
        if (typeof identifierOrServiceMetadata === 'string' || identifierOrServiceMetadata instanceof $7OIQ0.Token) return this.set({
            id: identifierOrServiceMetadata,
            value: value
        });
        if (typeof identifierOrServiceMetadata === 'object' && identifierOrServiceMetadata.service) return this.set({
            id: identifierOrServiceMetadata.service,
            value: value
        });
        if (identifierOrServiceMetadata instanceof Function) return this.set({
            type: identifierOrServiceMetadata,
            id: identifierOrServiceMetadata,
            value: value
        });
        // const newService: ServiceMetadata<any, any> = arguments.length === 1 && typeof identifierOrServiceMetadata === 'object'  && !(identifierOrServiceMetadata instanceof Token) ? identifierOrServiceMetadata : undefined;
        const newService = identifierOrServiceMetadata;
        const service = this.services.get(newService);
        if (service && service.multiple !== true) Object.assign(service, newService);
        else this.services.set(newService, newService);
        return this;
    }
    /**
     * Removes services with a given service identifiers (tokens or types).
     */ remove(...ids) {
        ids.forEach((id)=>{
            this.filterServices(id).forEach((service)=>{
                this.services.delete(service);
            });
        });
        return this;
    }
    /**
     * Completely resets the container by removing all previously registered services from it.
     */ reset() {
        this.services.clear();
        return this;
    }
    // -------------------------------------------------------------------------
    // Private Methods
    // -------------------------------------------------------------------------
    /**
     * Filters registered service in the with a given service identifier.
     */ filterServices(identifier) {
        return Array.from(this.services.values()).filter((service)=>{
            if (service.id) return service.id === identifier;
            if (service.type && identifier instanceof Function) return service.type === identifier || identifier.prototype instanceof service.type;
            return false;
        });
    }
    /**
     * Finds registered service in the with a given service identifier.
     */ findService(identifier) {
        return Array.from(this.services.values()).find((service)=>{
            if (service.id) {
                if (identifier instanceof Object && service.id instanceof $7OIQ0.Token && identifier.service instanceof $7OIQ0.Token) return service.id === identifier.service;
                return service.id === identifier;
            }
            if (service.type && identifier instanceof Function) return service.type === identifier; // todo: not sure why it was here || identifier.prototype instanceof service.type;
            return false;
        });
    }
    /**
     * Gets service value.
     */ getServiceValue(identifier, service) {
        // find if instance of this object already initialized in the container and return it if it is
        if (service && service.value !== undefined) return service.value;
        // if named service was requested and its instance was not found plus there is not type to know what to initialize,
        // this means service was not pre-registered and we throw an exception
        if ((!service || !service.type) && (!service || !service.factory) && (typeof identifier === 'string' || identifier instanceof $7OIQ0.Token)) throw new $7T0ew.ServiceNotFoundError(identifier);
        // at this point we either have type in service registered, either identifier is a target type
        let type = undefined;
        if (service && service.type) type = service.type;
        else if (service && service.id instanceof Function) type = service.id;
        else if (identifier instanceof Function) type = identifier;
        // if service was not found then create a new one and register it
        if (!service) {
            if (!type) throw new $k3uYL.MissingProvidedServiceTypeError(identifier);
            service = {
                type: type
            };
            this.services.set(service, service);
        }
        // setup constructor parameters for a newly initialized service
        const paramTypes = type && Reflect && Reflect.getMetadata ? Reflect.getMetadata('design:paramtypes', type) : undefined;
        let params = paramTypes ? this.initializeParams(type, paramTypes) : [];
        // if factory is set then use it to create service instance
        let value;
        if (service.factory) {
            // filter out non-service parameters from created service constructor
            // non-service parameters can be, lets say Car(name: string, isNew: boolean, engine: Engine)
            // where name and isNew are non-service parameters and engine is a service parameter
            params = params.filter((param)=>param !== undefined);
            if (service.factory instanceof Array) // use special [Type, 'create'] syntax to allow factory services
            // in this case Type instance will be obtained from Container and its method 'create' will be called
            value = this.get(service.factory[0])[service.factory[1]](...params);
            else // regular factory function
            value = service.factory(...params, this);
        } else {
            // otherwise simply create a new object instance
            if (!type) throw new $k3uYL.MissingProvidedServiceTypeError(identifier);
            params.unshift(null);
            // 'extra feature' - always pass container instance as the last argument to the service function
            // this allows us to support javascript where we don't have decorators and emitted metadata about dependencies
            // need to be injected, and user can use provided container to get instances he needs
            params.push(this);
            if (type.prototype.OnBefore) type.prototype.OnBefore.bind(type)();
            value = new (type.bind.apply(type, params))();
            $a77jh.constructorWatcherService.createConstructor(type['name'], {
                type: type,
                value: value
            });
            // if (value.render) {
            //     debugger
            // //    const test = new value['__proto__'].constructor()
            // Extend React class Correctly
            //    Object.assign(value['__proto__'].constructor.prototype, value);
            //    console.log(value['__proto__'].constructor.prototype);
            //     console.log(type['metadata']['moduleName'], value);
            //     console.log(value['__proto__'].constructor)
            // }
            if (value.OnInit) value.OnInit.bind(value)();
        }
        if (service && !service.transient && value) service.value = value;
        if (type) this.applyPropertyHandlers(type, value);
        return value;
    }
    /**
     * Initializes all parameter types for a given target service class.
     */ initializeParams(type, paramTypes) {
        return paramTypes.map((paramType, index)=>{
            const paramHandler = Array.from($9m0Ub.Container.handlers.values()).find((handler)=>handler.object === type && handler.index === index);
            if (paramHandler) return paramHandler.value(this);
            if (paramType && paramType.name && !this.isTypePrimitive(paramType.name)) return this.get(paramType);
            return undefined;
        });
    }
    /**
     * Checks if given type is primitive (e.g. string, boolean, number, object).
     */ isTypePrimitive(param) {
        return [
            'string',
            'boolean',
            'number',
            'object'
        ].indexOf(param.toLowerCase()) !== -1;
    }
    /**
     * Applies all registered handlers on a given target class.
     */ applyPropertyHandlers(target, instance) {
        $9m0Ub.Container.handlers.forEach((handler)=>{
            if (typeof handler.index === 'number') return;
            if (handler.object.constructor !== target && !(target.prototype instanceof handler.object.constructor)) return;
            instance[handler.propertyName] = handler.value(this);
        });
    }
}
module.exports.ContainerInstance = $59b2d1beb773a95f$var$ContainerInstance;

});
parcelRegister("k3uYL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MissingProvidedServiceTypeError = void 0;
/**
 * Thrown when service is registered without type.
 */ class $e99c1e3e1cf50300$var$MissingProvidedServiceTypeError extends Error {
    constructor(identifier){
        super(`Cannot determine a class of the requesting service '${JSON.stringify(identifier)}'`);
        this.name = 'ServiceNotFoundError';
        Object.setPrototypeOf(this, $e99c1e3e1cf50300$var$MissingProvidedServiceTypeError.prototype);
    }
}
module.exports.MissingProvidedServiceTypeError = $e99c1e3e1cf50300$var$MissingProvidedServiceTypeError;

});

parcelRegister("7T0ew", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceNotFoundError = void 0;

var $7OIQ0 = parcelRequire("7OIQ0");
/**
 * Thrown when requested service was not found.
 */ class $5bddd9c5718dab45$var$ServiceNotFoundError extends Error {
    constructor(identifier){
        super();
        this.name = 'ServiceNotFoundError';
        if (typeof identifier === 'string') this.message = `Service '${identifier}' was not found, looks like it was not registered in the container. ` + `Register it by calling Container.set('${JSON.stringify(identifier)}', ...) before using service.`;
        else if (identifier instanceof $7OIQ0.Token && identifier.name) this.message = `Service '${identifier.name}' was not found, looks like it was not registered in the container. ` + `Register it by calling Container.set before using service.`;
        else if (identifier instanceof $7OIQ0.Token) this.message = `Service with a given token was not found, looks like it was not registered in the container. ` + `Register it by calling Container.set before using service.`;
        Object.setPrototypeOf(this, $5bddd9c5718dab45$var$ServiceNotFoundError.prototype);
    }
}
module.exports.ServiceNotFoundError = $5bddd9c5718dab45$var$ServiceNotFoundError;

});
parcelRegister("7OIQ0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InjectionToken = module.exports.Token = void 0;
/**
 * Used to create unique typed service identifier.
 * Useful when service has only interface, but don't have a class.
 */ class $5b0ffbbf606eed94$var$Token {
    /**
     * @param name Token name, optional and only used for debugging purposes.
     */ constructor(name){
        this.name = name;
    }
}
module.exports.Token = $5b0ffbbf606eed94$var$Token;
class $5b0ffbbf606eed94$var$InjectionToken extends $5b0ffbbf606eed94$var$Token {
}
module.exports.InjectionToken = $5b0ffbbf606eed94$var$InjectionToken;

});


parcelRegister("a77jh", function(module, exports) {
"use strict";
var $75d03a6fcb1dca91$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $75d03a6fcb1dca91$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $75d03a6fcb1dca91$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$75d03a6fcb1dca91$var$__exportStar((parcelRequire("e8IK8")), module.exports);

});
parcelRegister("e8IK8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.constructorWatcherService = module.exports.ConstructorWatcherService = void 0;
class $a4b48511b6b4b163$var$ConstructorWatcherService {
    constructor(){
        this._constructors = new Map();
    }
    getConstructor(name) {
        return this._constructors.get(name);
    }
    getByClass(currentClass) {
        return this._constructors.get(currentClass.name)['value'];
    }
    createConstructor(name, value) {
        if (this._constructors.has(name)) return this.getConstructor(name);
        this._constructors.set(name, value);
        return this.getConstructor(name);
    }
    triggerOnInit(currentClass) {
        const currentConstructor = this._constructors.get(currentClass.name);
        if (currentConstructor['value'] && currentConstructor['value'].OnInit) currentConstructor['value'].OnInit.bind(currentConstructor['value'])();
    }
}
module.exports.ConstructorWatcherService = $a4b48511b6b4b163$var$ConstructorWatcherService;
module.exports.constructorWatcherService = new $a4b48511b6b4b163$var$ConstructorWatcherService();

});






parcelRegister("gX91L", function(module, exports) {
"use strict";
var $c57928b74684ddd6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c57928b74684ddd6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c57928b74684ddd6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c57928b74684ddd6$var$__exportStar((parcelRequire("9RiDg")), module.exports);

$c57928b74684ddd6$var$__exportStar((parcelRequire("gZrUy")), module.exports);

});
parcelRegister("9RiDg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gZrUy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("kHLvy", function(module, exports) {
"use strict";
var $f12cacded58b7a47$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f12cacded58b7a47$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f12cacded58b7a47$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Injectable = void 0;

$f12cacded58b7a47$var$__exportStar((parcelRequire("cMmWN")), module.exports);

$f12cacded58b7a47$var$__exportStar((parcelRequire("4Ko5i")), module.exports);

$f12cacded58b7a47$var$__exportStar((parcelRequire("3lzEJ")), module.exports);

$f12cacded58b7a47$var$__exportStar((parcelRequire("99uf8")), module.exports);

$f12cacded58b7a47$var$__exportStar((parcelRequire("kW0nR")), module.exports);

$f12cacded58b7a47$var$__exportStar((parcelRequire("iZGkn")), module.exports);

$f12cacded58b7a47$var$__exportStar((parcelRequire("lH46f")), module.exports);

$f12cacded58b7a47$var$__exportStar((parcelRequire("8DS2b")), module.exports);

$f12cacded58b7a47$var$__exportStar((parcelRequire("j6E3l")), module.exports);

$f12cacded58b7a47$var$__exportStar((parcelRequire("kMdeS")), module.exports);

Object.defineProperty(module.exports, "Injectable", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8DS2b")).Service;
    }
});

});
parcelRegister("cMmWN", function(module, exports) {
"use strict";
var $94dbc495d5eee9d5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $94dbc495d5eee9d5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $94dbc495d5eee9d5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$94dbc495d5eee9d5$var$__exportStar((parcelRequire("3eDkT")), module.exports);

$94dbc495d5eee9d5$var$__exportStar((parcelRequire("123g4")), module.exports);

});
parcelRegister("3eDkT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NgModule = void 0;
module.exports.Module = $25b1313abc3d7140$var$Module;

var $4q6qh = parcelRequire("4q6qh");

var $8afYX = parcelRequire("8afYX");

var $lxoqV = parcelRequire("lxoqV");

var $3O0qi = parcelRequire("3O0qi");

var $4O6sX = parcelRequire("4O6sX");

var $7aNg8 = parcelRequire("7aNg8");

var $axVJe = parcelRequire("axVJe");
const $25b1313abc3d7140$var$bootstrapLogger = $4q6qh.Container.get($3O0qi.BootstrapLogger);
const $25b1313abc3d7140$var$resolverService = $4q6qh.Container.get($4O6sX.ResolverService);
const $25b1313abc3d7140$var$cacheService = $4q6qh.Container.get($8afYX.CacheService);
const $25b1313abc3d7140$var$metadataService = $4q6qh.Container.get($7aNg8.MetadataService);
const $25b1313abc3d7140$var$moduleService = $4q6qh.Container.get($axVJe.ModuleService);
function $25b1313abc3d7140$var$Module(module) {
    return (target)=>{
        module = module || {};
        const original = Object.assign(target);
        const moduleName = target.name || target.constructor.name;
        const generatedHashData = $25b1313abc3d7140$var$metadataService.generateHashData(module, original);
        const uniqueModuleTemplate = $25b1313abc3d7140$var$metadataService.parseModuleTemplate(moduleName, generatedHashData, `${target}`);
        const uniqueHashForClass = $25b1313abc3d7140$var$metadataService.createUniqueHash(uniqueModuleTemplate);
        // console.log(`--------- ${moduleName} --------- Hash: ${uniqueHashForClass}---------`);
        // console.log(uniqueModuleTemplate);
        Object.defineProperty(original, 'originalName', {
            value: original.name || original.constructor.name,
            writable: false
        });
        Object.defineProperty(original, 'name', {
            value: uniqueHashForClass,
            writable: true
        });
        const currentModuleLayer = $25b1313abc3d7140$var$cacheService.createLayer({
            name: uniqueHashForClass
        });
        original.metadata = {
            moduleName: original.originalName,
            moduleHash: uniqueHashForClass,
            options: null,
            type: 'module',
            raw: uniqueModuleTemplate
        };
        const constructorFunction = function(...args) {
            $25b1313abc3d7140$var$bootstrapLogger.log(`Bootstrap -> @Module('${original.originalName}')${$25b1313abc3d7140$var$bootstrapLogger.logHashes(`(${original.name})`)}: loading...`);
            return (0, $lxoqV.GenericConstruct)(module, original, currentModuleLayer)(original, args);
        };
        Object.assign(constructorFunction, original);
        $25b1313abc3d7140$var$resolverService.resolveDependencies(uniqueHashForClass, original, moduleName).subscribe(()=>$25b1313abc3d7140$var$bootstrapLogger.log(`Start -> @Module('${original.originalName}')${$25b1313abc3d7140$var$bootstrapLogger.logHashes(`(${original.name})`)}: loaded!`));
        Object.getOwnPropertyNames(original).filter((prop)=>typeof original[prop] === 'function').map((descriptor)=>Object.defineProperty(constructorFunction, descriptor, {
                configurable: true,
                writable: true,
                value: original[descriptor]
            }));
        if (original.forRoot) {
            const originalForRoot = constructorFunction.forRoot;
            constructorFunction.forRoot = function(...args) {
                const result = originalForRoot(...args);
                if (!result) throw new Error(`forRoot configuration inside ${constructorFunction.name} is returning undefined or null`);
                if (result.frameworkImports) $25b1313abc3d7140$var$moduleService.setImports(result.frameworkImports, original);
                if (result.services) $25b1313abc3d7140$var$moduleService.setServices(result.services, original, currentModuleLayer);
                if (result.providers) $25b1313abc3d7140$var$moduleService.setServices(result.providers, original, currentModuleLayer);
                if (result.components) $25b1313abc3d7140$var$moduleService.setComponents(result.components, original, currentModuleLayer);
                if (result.effects) $25b1313abc3d7140$var$moduleService.setEffects(result.effects, original, currentModuleLayer);
                if (result.controllers) $25b1313abc3d7140$var$moduleService.setControllers(result.controllers, original, currentModuleLayer);
                if (result.beforePlugins) $25b1313abc3d7140$var$moduleService.setBeforePlugins(result.beforePlugins, original, currentModuleLayer);
                if (result.plugins) $25b1313abc3d7140$var$moduleService.setPlugins(result.plugins, original, currentModuleLayer);
                if (result.afterPlugins) $25b1313abc3d7140$var$moduleService.setAfterPlugins(result.afterPlugins, original, currentModuleLayer);
                /** @angular compatability */ if (result.ngModule) return result.ngModule;
                return result.module ? result.module : result;
            };
        }
        const service = {
            type: constructorFunction
        };
        $4q6qh.Container.set(service);
        return constructorFunction;
    };
}
/** @angular module compatability */ module.exports.NgModule = $25b1313abc3d7140$var$Module;

});
parcelRegister("8afYX", function(module, exports) {
"use strict";
var $5f1ba7a34a632ef3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5f1ba7a34a632ef3$var$CacheService_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CacheService = void 0;

var $jS6MW = parcelRequire("jS6MW");
var $82Kdl = parcelRequire("82Kdl");
var $8fifx = parcelRequire("8fifx");

var $3XkaH = parcelRequire("3XkaH");
var $jxiZx = parcelRequire("jxiZx");
var $hgiLQ = parcelRequire("hgiLQ");
var $g8AQ2 = parcelRequire("g8AQ2");

var $k97PP = parcelRequire("k97PP");

var $cYPHp = parcelRequire("cYPHp");

var $8DS2b = parcelRequire("8DS2b");
let $5f1ba7a34a632ef3$var$CacheService = $5f1ba7a34a632ef3$var$CacheService_1 = class CacheService {
    constructor(){
        this._cachedLayers = new $jS6MW.BehaviorSubject([]);
        this.map = new Map();
        this.config = {};
    }
    static createCacheInstance(cacheLayer) {
        return new $k97PP.CacheLayer(cacheLayer);
    }
    getLayer(name) {
        const exists = this.map.has(name);
        if (!exists) return this.createLayer({
            name: name
        });
        return this.map.get(name);
    }
    getLayersByName(name) {
        return Array.from(this.map.keys()).map((item)=>{
            if (item !== $cYPHp.InternalLayers.modules && item !== $cYPHp.InternalLayers.globalConfig) {
                const config = this.getLayer(item).getItem($cYPHp.InternalEvents.config);
                if (config && config.data && name === config.data.moduleName) return this.getLayer(config.data.moduleHash);
            }
        }).filter((i)=>!!i);
    }
    searchForDuplicateDependenciesInsideApp() {
        const uniq = [].concat.apply([], Array.from(this.map.keys()).map((key)=>Array.from(this.getLayer(key).map.keys()).map((key)=>!this.isExcludedEvent(key) ? key : null).filter((i)=>!!i))).map((name)=>Object.create({
                count: 1,
                name: name
            })).reduce((a, b)=>{
            a[b.name] = (a[b.name] || 0) + b.count;
            return a;
        }, {});
        const duplicates = Object.keys(uniq).filter((a)=>uniq[a] > 1);
        if (duplicates.length) {
            const dups = this.searchForDuplicatesByHash(duplicates[0]);
            const moduleType = dups[0].class['metadata']['type'].charAt(0).toUpperCase() + dups[0].class['metadata']['type'].slice(1);
            throw new Error(`
                ${dups[0].class['metadata'].raw}
                ${moduleType}: '${dups[0].originalName}' found multiple times!
                ${moduleType} hash: ${dups[0].moduleHash}
                Modules: [${dups[0].moduleName}, ${dups[1].moduleName}]

                Hint: '${dups[0].originalName}' class identity hash is identical in both
                imported files inside ${dups[0].moduleName} and ${dups[1].moduleName}
                consider removing one of the '${dups[0].originalName}'
            `);
        }
        return duplicates;
    }
    isExcludedEvent(i) {
        return i === $cYPHp.InternalEvents.config || i === $cYPHp.InternalEvents.load;
    }
    searchForItem(classItem) {
        return Array.from(this.map.keys()).map((module)=>{
            const currentModule = this.getLayer(module);
            const currentModuleDependencies = Array.from(currentModule.map.keys());
            const found = currentModuleDependencies.filter((i)=>{
                if (this.isExcludedEvent(i)) return;
                else return i === classItem.name;
            });
            if (found.length) return currentModule.getItem(found[0]).data;
        }).filter((i)=>!!i)[0];
    }
    searchForDuplicatesByHash(key) {
        return Array.from(this.map.keys()).map((module)=>{
            const currentModule = this.getLayer(module);
            const found = Array.from(currentModule.map.keys()).filter((i)=>{
                if (this.isExcludedEvent(i)) return;
                return i === key;
            });
            if (found.length) {
                const currentFoundItem = currentModule.getItem(found[0]);
                const currentModuleName = this.getLayer(module).getItem($cYPHp.InternalEvents.config);
                return {
                    moduleName: currentModuleName.data.moduleName,
                    moduleHash: currentModuleName.data.moduleHash,
                    originalName: currentFoundItem.data.originalName,
                    dupeName: currentFoundItem.key,
                    raw: currentModuleName.data.raw,
                    class: currentFoundItem.data
                };
            }
        }).filter((i)=>!!i);
    }
    createLayer(layer) {
        const exists = this.map.has(layer.name);
        if (exists) return this.map.get(layer.name);
        layer.items = layer.items || [];
        layer.config = layer.config || this.config;
        const cacheLayer = $5f1ba7a34a632ef3$var$CacheService_1.createCacheInstance(layer);
        this.map.set(cacheLayer.name, cacheLayer);
        this._cachedLayers.next([
            ...this._cachedLayers.getValue(),
            cacheLayer
        ]);
        this.LayerHook(cacheLayer);
        return cacheLayer;
    }
    LayerHook(layerInstance) {
        this.protectLayerFromInvaders(layerInstance);
        if (layerInstance.config.cacheFlushInterval || this.config.cacheFlushInterval) this.OnExpire(layerInstance);
    }
    protectLayerFromInvaders(cacheLayer) {
        cacheLayer.items.constructor.prototype.unsubsribeFromLayer = cacheLayer.items.constructor.prototype.unsubscribe;
        cacheLayer.items.constructor.prototype.unsubscribe = ()=>{};
    }
    OnExpire(layerInstance) {
        return new $82Kdl.Observable((observer)=>observer.next(true)).pipe((0, $g8AQ2.timeoutWith)(layerInstance.config.cacheFlushInterval || this.config.cacheFlushInterval, (0, $8fifx.of)(1)), (0, $jxiZx.skip)(1), (0, $hgiLQ.take)(1)).subscribe(()=>this.removeLayer(layerInstance));
    }
    removeLayer(layerInstance) {
        this.map.delete(layerInstance.name);
        this._cachedLayers.next([
            ...this._cachedLayers.getValue().filter((layer)=>layer.name !== layerInstance.name)
        ]);
    }
    transferItems(name, newCacheLayers) {
        const oldLayer = this.getLayer(name);
        const newLayers = [];
        newCacheLayers.forEach((layerName)=>{
            const newLayer = this.createLayer(layerName);
            oldLayer.items.getValue().forEach((item)=>newLayer.putItem(item));
            newLayers.push(newLayer);
        });
        return newLayers;
    }
    flushCache() {
        let oldLayersNames;
        return this._cachedLayers.pipe((0, $hgiLQ.take)(1), (0, $3XkaH.map)((layers)=>{
            oldLayersNames = layers.map((l)=>l.name);
            layers.forEach((layer)=>this.removeLayer(layer));
            oldLayersNames.forEach((l)=>this.createLayer({
                    name: l
                }));
            return true;
        }));
    }
};
module.exports.CacheService = $5f1ba7a34a632ef3$var$CacheService;
module.exports.CacheService = $5f1ba7a34a632ef3$var$CacheService = $5f1ba7a34a632ef3$var$CacheService_1 = $5f1ba7a34a632ef3$var$__decorate([
    (0, $8DS2b.Service)()
], $5f1ba7a34a632ef3$var$CacheService);

});
parcelRegister("jS6MW", function(module, exports) {

$parcel$export(module.exports, "BehaviorSubject", () => $e778538105ccad5f$export$cc3d42e6b2b9cf8b);

var $cAivK = parcelRequire("cAivK");

var $35ZUd = parcelRequire("35ZUd");
var $e778538105ccad5f$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $cAivK.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $35ZUd.Subject));

});
parcelRegister("cAivK", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $929734b99fdd627c$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__awaiter", () => $929734b99fdd627c$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $929734b99fdd627c$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $929734b99fdd627c$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $929734b99fdd627c$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $929734b99fdd627c$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $929734b99fdd627c$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $929734b99fdd627c$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $929734b99fdd627c$export$e3b29a3d6162315f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $929734b99fdd627c$var$extendStatics = function(d, b) {
    $929734b99fdd627c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $929734b99fdd627c$var$extendStatics(d, b);
};
function $929734b99fdd627c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $929734b99fdd627c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $929734b99fdd627c$export$18ce0697a983be9b = function() {
    $929734b99fdd627c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $929734b99fdd627c$export$18ce0697a983be9b.apply(this, arguments);
};
function $929734b99fdd627c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $929734b99fdd627c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $929734b99fdd627c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $929734b99fdd627c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $929734b99fdd627c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $929734b99fdd627c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $929734b99fdd627c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $929734b99fdd627c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $929734b99fdd627c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $929734b99fdd627c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $929734b99fdd627c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $929734b99fdd627c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $929734b99fdd627c$export$45d3717a4c69092e(o, m, p);
}
function $929734b99fdd627c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $929734b99fdd627c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $929734b99fdd627c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($929734b99fdd627c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $929734b99fdd627c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $929734b99fdd627c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $929734b99fdd627c$export$10c90e4f7922046c(v) {
    return this instanceof $929734b99fdd627c$export$10c90e4f7922046c ? (this.v = v, this) : new $929734b99fdd627c$export$10c90e4f7922046c(v);
}
function $929734b99fdd627c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $929734b99fdd627c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $929734b99fdd627c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $929734b99fdd627c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $929734b99fdd627c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $929734b99fdd627c$export$19a8beecd37a4c45 === "function" ? $929734b99fdd627c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $929734b99fdd627c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $929734b99fdd627c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $929734b99fdd627c$var$ownKeys = function(o) {
    $929734b99fdd627c$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $929734b99fdd627c$var$ownKeys(o);
};
function $929734b99fdd627c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $929734b99fdd627c$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $929734b99fdd627c$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $929734b99fdd627c$var$__setModuleDefault(result, mod);
    return result;
}
function $929734b99fdd627c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $929734b99fdd627c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $929734b99fdd627c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $929734b99fdd627c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $929734b99fdd627c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $929734b99fdd627c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $929734b99fdd627c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $929734b99fdd627c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $929734b99fdd627c$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $929734b99fdd627c$export$2e2bcd8739ae039 = {
    __extends: $929734b99fdd627c$export$a8ba968b8961cb8a,
    __assign: $929734b99fdd627c$export$18ce0697a983be9b,
    __rest: $929734b99fdd627c$export$3c9a16f847548506,
    __decorate: $929734b99fdd627c$export$29e00dfd3077644b,
    __param: $929734b99fdd627c$export$d5ad3fd78186038f,
    __esDecorate: $929734b99fdd627c$export$3a84e1ae4e97e9b0,
    __runInitializers: $929734b99fdd627c$export$d831c04e792af3d,
    __propKey: $929734b99fdd627c$export$6a2a36740a146cb8,
    __setFunctionName: $929734b99fdd627c$export$d1a06452d3489bc7,
    __metadata: $929734b99fdd627c$export$f1db080c865becb9,
    __awaiter: $929734b99fdd627c$export$1050f835b63b671e,
    __generator: $929734b99fdd627c$export$67ebef60e6f28a6,
    __createBinding: $929734b99fdd627c$export$45d3717a4c69092e,
    __exportStar: $929734b99fdd627c$export$f33643c0debef087,
    __values: $929734b99fdd627c$export$19a8beecd37a4c45,
    __read: $929734b99fdd627c$export$8d051b38c9118094,
    __spread: $929734b99fdd627c$export$afc72e2116322959,
    __spreadArrays: $929734b99fdd627c$export$6388937ca91ccae8,
    __spreadArray: $929734b99fdd627c$export$1216008129fb82ed,
    __await: $929734b99fdd627c$export$10c90e4f7922046c,
    __asyncGenerator: $929734b99fdd627c$export$e427f37a30a4de9b,
    __asyncDelegator: $929734b99fdd627c$export$bbd80228419bb833,
    __asyncValues: $929734b99fdd627c$export$e3b29a3d6162315f,
    __makeTemplateObject: $929734b99fdd627c$export$4fb47efe1390b86f,
    __importStar: $929734b99fdd627c$export$c21735bcef00d192,
    __importDefault: $929734b99fdd627c$export$da59b14a69baef04,
    __classPrivateFieldGet: $929734b99fdd627c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $929734b99fdd627c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $929734b99fdd627c$export$81fdc39f203e4e04,
    __addDisposableResource: $929734b99fdd627c$export$88ac25d8e944e405,
    __disposeResources: $929734b99fdd627c$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $929734b99fdd627c$export$889dfb5d17574b0b
};

});

parcelRegister("35ZUd", function(module, exports) {

$parcel$export(module.exports, "Subject", () => $2411dbe8e51619ce$export$b6bbab5a9b109038);

var $cAivK = parcelRequire("cAivK");

var $82Kdl = parcelRequire("82Kdl");

var $70uhi = parcelRequire("70uhi");

var $ceQTp = parcelRequire("ceQTp");

var $h0JpQ = parcelRequire("h0JpQ");

var $NBxg8 = parcelRequire("NBxg8");
var $2411dbe8e51619ce$export$b6bbab5a9b109038 = function(_super) {
    (0, $cAivK.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2411dbe8e51619ce$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $ceQTp.ObjectUnsubscribedError)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $NBxg8.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $cAivK.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $NBxg8.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $NBxg8.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $70uhi.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $70uhi.Subscription)(function() {
            _this.currentObservers = null;
            (0, $h0JpQ.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $82Kdl.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2411dbe8e51619ce$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $82Kdl.Observable));
var $2411dbe8e51619ce$export$155189cde295587d = function(_super) {
    (0, $cAivK.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $70uhi.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}($2411dbe8e51619ce$export$b6bbab5a9b109038);

});
parcelRegister("82Kdl", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $5db25bcba81a0700$export$77cea355fa80b5f4);

var $ehgY6 = parcelRequire("ehgY6");

var $70uhi = parcelRequire("70uhi");

var $2KzBr = parcelRequire("2KzBr");

var $4ArhZ = parcelRequire("4ArhZ");

var $hXg0t = parcelRequire("hXg0t");

var $1hO6f = parcelRequire("1hO6f");

var $NBxg8 = parcelRequire("NBxg8");
var $5db25bcba81a0700$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $5db25bcba81a0700$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $ehgY6.SafeSubscriber)(observerOrNext, error, complete);
        (0, $NBxg8.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $5db25bcba81a0700$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $ehgY6.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $2KzBr.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $4ArhZ.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $5db25bcba81a0700$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $5db25bcba81a0700$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $hXg0t.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $5db25bcba81a0700$var$isObserver(value) {
    return value && (0, $1hO6f.isFunction)(value.next) && (0, $1hO6f.isFunction)(value.error) && (0, $1hO6f.isFunction)(value.complete);
}
function $5db25bcba81a0700$var$isSubscriber(value) {
    return value && value instanceof (0, $ehgY6.Subscriber) || $5db25bcba81a0700$var$isObserver(value) && (0, $70uhi.isSubscription)(value);
}

});
parcelRegister("ehgY6", function(module, exports) {

$parcel$export(module.exports, "Subscriber", () => $a64fd0c6c43b7185$export$60959659b2c22881);
$parcel$export(module.exports, "SafeSubscriber", () => $a64fd0c6c43b7185$export$94eeb6a328cab6c7);

var $cAivK = parcelRequire("cAivK");

var $1hO6f = parcelRequire("1hO6f");

var $70uhi = parcelRequire("70uhi");

var $hXg0t = parcelRequire("hXg0t");

var $6eoc9 = parcelRequire("6eoc9");

var $3CHs3 = parcelRequire("3CHs3");

var $90cRW = parcelRequire("90cRW");

var $kVPKD = parcelRequire("kVPKD");

var $NBxg8 = parcelRequire("NBxg8");
var $a64fd0c6c43b7185$export$60959659b2c22881 = function(_super) {
    (0, $cAivK.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $70uhi.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = $a64fd0c6c43b7185$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $a64fd0c6c43b7185$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $a64fd0c6c43b7185$var$handleStoppedNotification((0, $90cRW.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $a64fd0c6c43b7185$var$handleStoppedNotification((0, $90cRW.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $a64fd0c6c43b7185$var$handleStoppedNotification((0, $90cRW.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $70uhi.Subscription));
var $a64fd0c6c43b7185$var$_bind = Function.prototype.bind;
function $a64fd0c6c43b7185$var$bind(fn, thisArg) {
    return $a64fd0c6c43b7185$var$_bind.call(fn, thisArg);
}
var $a64fd0c6c43b7185$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $a64fd0c6c43b7185$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $a64fd0c6c43b7185$var$handleUnhandledError(error);
        }
        else $a64fd0c6c43b7185$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $a64fd0c6c43b7185$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $a64fd0c6c43b7185$export$94eeb6a328cab6c7 = function(_super) {
    (0, $cAivK.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $1hO6f.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $hXg0t.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $a64fd0c6c43b7185$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $a64fd0c6c43b7185$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $a64fd0c6c43b7185$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $a64fd0c6c43b7185$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($a64fd0c6c43b7185$export$60959659b2c22881);
function $a64fd0c6c43b7185$var$handleUnhandledError(error) {
    if ((0, $hXg0t.config).useDeprecatedSynchronousErrorHandling) (0, $NBxg8.captureError)(error);
    else (0, $6eoc9.reportUnhandledError)(error);
}
function $a64fd0c6c43b7185$var$defaultErrorHandler(err) {
    throw err;
}
function $a64fd0c6c43b7185$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $hXg0t.config).onStoppedNotification;
    onStoppedNotification && (0, $kVPKD.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $a64fd0c6c43b7185$export$88d395d20619a0af = {
    closed: true,
    next: (0, $3CHs3.noop),
    error: $a64fd0c6c43b7185$var$defaultErrorHandler,
    complete: (0, $3CHs3.noop)
};

});
parcelRegister("1hO6f", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $0efe3dc539a133fd$export$f6e2535fb5126e54);
function $0efe3dc539a133fd$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}

});

parcelRegister("70uhi", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $51a0050fbba33fea$export$f55210826850c514);
$parcel$export(module.exports, "EMPTY_SUBSCRIPTION", () => $51a0050fbba33fea$export$610f9c3ca1a38dd8);
$parcel$export(module.exports, "isSubscription", () => $51a0050fbba33fea$export$4f9221cbada3c4fc);

var $cAivK = parcelRequire("cAivK");

var $1hO6f = parcelRequire("1hO6f");

var $iuouP = parcelRequire("iuouP");

var $h0JpQ = parcelRequire("h0JpQ");
var $51a0050fbba33fea$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $cAivK.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $1hO6f.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $iuouP.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $cAivK.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $51a0050fbba33fea$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $iuouP.UnsubscriptionError)) errors = (0, $cAivK.__spreadArray)((0, $cAivK.__spreadArray)([], (0, $cAivK.__read)(errors)), (0, $cAivK.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $iuouP.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $51a0050fbba33fea$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $h0JpQ.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $h0JpQ.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $51a0050fbba33fea$export$610f9c3ca1a38dd8 = $51a0050fbba33fea$export$f55210826850c514.EMPTY;
function $51a0050fbba33fea$export$4f9221cbada3c4fc(value) {
    return value instanceof $51a0050fbba33fea$export$f55210826850c514 || value && 'closed' in value && (0, $1hO6f.isFunction)(value.remove) && (0, $1hO6f.isFunction)(value.add) && (0, $1hO6f.isFunction)(value.unsubscribe);
}
function $51a0050fbba33fea$var$execFinalizer(finalizer) {
    if ((0, $1hO6f.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("iuouP", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", () => $d75e07cd72a7add1$export$c9648b76fd580c34);

var $4syGL = parcelRequire("4syGL");
var $d75e07cd72a7add1$export$c9648b76fd580c34 = (0, $4syGL.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

});
parcelRegister("4syGL", function(module, exports) {

$parcel$export(module.exports, "createErrorClass", () => $33f4af6b59fd7f9f$export$128a15b65d1b6041);
function $33f4af6b59fd7f9f$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

});


parcelRegister("h0JpQ", function(module, exports) {

$parcel$export(module.exports, "arrRemove", () => $c625aa60729226ba$export$dae3f38077fc36c0);
function $c625aa60729226ba$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

});


parcelRegister("hXg0t", function(module, exports) {

$parcel$export(module.exports, "config", () => $d1245cf07b7f230a$export$e506a1d27d1eaa20);
var $d1245cf07b7f230a$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("6eoc9", function(module, exports) {

$parcel$export(module.exports, "reportUnhandledError", () => $4896d1851713ce7f$export$ebf645db02d3e99f);

var $hXg0t = parcelRequire("hXg0t");

var $kVPKD = parcelRequire("kVPKD");
function $4896d1851713ce7f$export$ebf645db02d3e99f(err) {
    (0, $kVPKD.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, $hXg0t.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

});
parcelRegister("kVPKD", function(module, exports) {

$parcel$export(module.exports, "timeoutProvider", () => $f3d1463c92aaeddf$export$365aa6bd3c788e3d);

var $cAivK = parcelRequire("cAivK");
var $f3d1463c92aaeddf$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $f3d1463c92aaeddf$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $cAivK.__spreadArray)([
            handler,
            timeout
        ], (0, $cAivK.__read)(args)));
        return setTimeout.apply(void 0, (0, $cAivK.__spreadArray)([
            handler,
            timeout
        ], (0, $cAivK.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $f3d1463c92aaeddf$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("3CHs3", function(module, exports) {

$parcel$export(module.exports, "noop", () => $2a36a0476c9b6a75$export$8793edee2d425525);
function $2a36a0476c9b6a75$export$8793edee2d425525() {}

});

parcelRegister("90cRW", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_NOTIFICATION", () => $68de18a418f31d15$export$b7f97edb34bc1f87);
$parcel$export(module.exports, "errorNotification", () => $68de18a418f31d15$export$dd472c3d8fe5a85a);
$parcel$export(module.exports, "nextNotification", () => $68de18a418f31d15$export$ff9346b0d1d30313);
var $68de18a418f31d15$export$b7f97edb34bc1f87 = function() {
    return $68de18a418f31d15$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $68de18a418f31d15$export$dd472c3d8fe5a85a(error) {
    return $68de18a418f31d15$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $68de18a418f31d15$export$ff9346b0d1d30313(value) {
    return $68de18a418f31d15$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $68de18a418f31d15$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

});

parcelRegister("NBxg8", function(module, exports) {

$parcel$export(module.exports, "errorContext", () => $0951b17956931753$export$d974811edc77eafa);
$parcel$export(module.exports, "captureError", () => $0951b17956931753$export$3e205fbb5df021e0);

var $hXg0t = parcelRequire("hXg0t");
var $0951b17956931753$var$context = null;
function $0951b17956931753$export$d974811edc77eafa(cb) {
    if ((0, $hXg0t.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$0951b17956931753$var$context;
        if (isRoot) $0951b17956931753$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $0951b17956931753$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $0951b17956931753$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $0951b17956931753$export$3e205fbb5df021e0(err) {
    if ((0, $hXg0t.config).useDeprecatedSynchronousErrorHandling && $0951b17956931753$var$context) {
        $0951b17956931753$var$context.errorThrown = true;
        $0951b17956931753$var$context.error = err;
    }
}

});


parcelRegister("2KzBr", function(module, exports) {

$parcel$export(module.exports, "observable", () => $200b7ea88f4c58c1$export$5ab46cbf6120b33a);
var $200b7ea88f4c58c1$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

});

parcelRegister("4ArhZ", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $356fb1405156a52e$export$a4627e546088548d);
$parcel$export(module.exports, "pipeFromArray", () => $356fb1405156a52e$export$71f88a61afaa14d7);

var $4YhJE = parcelRequire("4YhJE");
function $356fb1405156a52e$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $356fb1405156a52e$export$71f88a61afaa14d7(fns);
}
function $356fb1405156a52e$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $4YhJE.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("4YhJE", function(module, exports) {

$parcel$export(module.exports, "identity", () => $39ea85e0cf190682$export$f0954fd7d5368655);
function $39ea85e0cf190682$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("ceQTp", function(module, exports) {

$parcel$export(module.exports, "ObjectUnsubscribedError", () => $8e8fd2353a3f7884$export$f708eee25634bc80);

var $4syGL = parcelRequire("4syGL");
var $8e8fd2353a3f7884$export$f708eee25634bc80 = (0, $4syGL.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});

});



parcelRegister("8fifx", function(module, exports) {

$parcel$export(module.exports, "of", () => $600de17057f7fdb4$export$ba255e9e49e00608);

var $3jBRy = parcelRequire("3jBRy");

var $lBKT3 = parcelRequire("lBKT3");
function $600de17057f7fdb4$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3jBRy.popScheduler)(args);
    return (0, $lBKT3.from)(args, scheduler);
}

});
parcelRegister("3jBRy", function(module, exports) {

$parcel$export(module.exports, "popResultSelector", () => $26a0842ea89614ee$export$9ae19b645239a61b);
$parcel$export(module.exports, "popScheduler", () => $26a0842ea89614ee$export$29534b2f653ae592);

var $1hO6f = parcelRequire("1hO6f");

var $a2zXt = parcelRequire("a2zXt");
function $26a0842ea89614ee$var$last(arr) {
    return arr[arr.length - 1];
}
function $26a0842ea89614ee$export$9ae19b645239a61b(args) {
    return (0, $1hO6f.isFunction)($26a0842ea89614ee$var$last(args)) ? args.pop() : undefined;
}
function $26a0842ea89614ee$export$29534b2f653ae592(args) {
    return (0, $a2zXt.isScheduler)($26a0842ea89614ee$var$last(args)) ? args.pop() : undefined;
}
function $26a0842ea89614ee$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $26a0842ea89614ee$var$last(args) === 'number' ? args.pop() : defaultValue;
}

});
parcelRegister("a2zXt", function(module, exports) {

$parcel$export(module.exports, "isScheduler", () => $74f5fbd6dc200e52$export$187e35932e88c15c);

var $1hO6f = parcelRequire("1hO6f");
function $74f5fbd6dc200e52$export$187e35932e88c15c(value) {
    return value && (0, $1hO6f.isFunction)(value.schedule);
}

});


parcelRegister("lBKT3", function(module, exports) {

$parcel$export(module.exports, "from", () => $fbb16c72537564f3$export$6788812c4e6611e6);

var $j4sdR = parcelRequire("j4sdR");

var $9IWtL = parcelRequire("9IWtL");
function $fbb16c72537564f3$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $j4sdR.scheduled)(input, scheduler) : (0, $9IWtL.innerFrom)(input);
}

});
parcelRegister("j4sdR", function(module, exports) {

$parcel$export(module.exports, "scheduled", () => $de24487118842975$export$49c44dfc2bb21d70);

var $8kRnb = parcelRequire("8kRnb");

var $p0QgJ = parcelRequire("p0QgJ");

var $7bGpE = parcelRequire("7bGpE");

var $elKuH = parcelRequire("elKuH");

var $jO2Gk = parcelRequire("jO2Gk");

var $9CZcX = parcelRequire("9CZcX");

var $hy8k5 = parcelRequire("hy8k5");

var $hv4Mv = parcelRequire("hv4Mv");

var $jX50K = parcelRequire("jX50K");

var $92fqP = parcelRequire("92fqP");

var $le5nW = parcelRequire("le5nW");

var $7ok89 = parcelRequire("7ok89");

var $ghxH3 = parcelRequire("ghxH3");
function $de24487118842975$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $9CZcX.isInteropObservable)(input)) return (0, $8kRnb.scheduleObservable)(input, scheduler);
        if ((0, $hv4Mv.isArrayLike)(input)) return (0, $7bGpE.scheduleArray)(input, scheduler);
        if ((0, $hy8k5.isPromise)(input)) return (0, $p0QgJ.schedulePromise)(input, scheduler);
        if ((0, $92fqP.isAsyncIterable)(input)) return (0, $jO2Gk.scheduleAsyncIterable)(input, scheduler);
        if ((0, $jX50K.isIterable)(input)) return (0, $elKuH.scheduleIterable)(input, scheduler);
        if ((0, $7ok89.isReadableStreamLike)(input)) return (0, $ghxH3.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, $le5nW.createInvalidObservableTypeError)(input);
}

});
parcelRegister("8kRnb", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", () => $611997bb1e7fca58$export$ed8bd553a12b6a30);

var $9IWtL = parcelRequire("9IWtL");

var $dTo9y = parcelRequire("dTo9y");

var $ieAir = parcelRequire("ieAir");
function $611997bb1e7fca58$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $9IWtL.innerFrom)(input).pipe((0, $ieAir.subscribeOn)(scheduler), (0, $dTo9y.observeOn)(scheduler));
}

});
parcelRegister("9IWtL", function(module, exports) {

$parcel$export(module.exports, "innerFrom", () => $714595da1cddbd14$export$6a9cfa3ebc765910);

var $cAivK = parcelRequire("cAivK");

var $hv4Mv = parcelRequire("hv4Mv");

var $hy8k5 = parcelRequire("hy8k5");

var $82Kdl = parcelRequire("82Kdl");

var $9CZcX = parcelRequire("9CZcX");

var $92fqP = parcelRequire("92fqP");

var $le5nW = parcelRequire("le5nW");

var $jX50K = parcelRequire("jX50K");

var $7ok89 = parcelRequire("7ok89");

var $1hO6f = parcelRequire("1hO6f");

var $6eoc9 = parcelRequire("6eoc9");

var $2KzBr = parcelRequire("2KzBr");
function $714595da1cddbd14$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $82Kdl.Observable)) return input;
    if (input != null) {
        if ((0, $9CZcX.isInteropObservable)(input)) return $714595da1cddbd14$export$aa3d41784b3267fa(input);
        if ((0, $hv4Mv.isArrayLike)(input)) return $714595da1cddbd14$export$4cb2acdbcda2c253(input);
        if ((0, $hy8k5.isPromise)(input)) return $714595da1cddbd14$export$60f45028237c39d1(input);
        if ((0, $92fqP.isAsyncIterable)(input)) return $714595da1cddbd14$export$e073fccf36d78cc1(input);
        if ((0, $jX50K.isIterable)(input)) return $714595da1cddbd14$export$dcccc29c315dd646(input);
        if ((0, $7ok89.isReadableStreamLike)(input)) return $714595da1cddbd14$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $le5nW.createInvalidObservableTypeError)(input);
}
function $714595da1cddbd14$export$aa3d41784b3267fa(obj) {
    return new (0, $82Kdl.Observable)(function(subscriber) {
        var obs = obj[0, $2KzBr.observable]();
        if ((0, $1hO6f.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $714595da1cddbd14$export$4cb2acdbcda2c253(array) {
    return new (0, $82Kdl.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $714595da1cddbd14$export$60f45028237c39d1(promise) {
    return new (0, $82Kdl.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $6eoc9.reportUnhandledError));
    });
}
function $714595da1cddbd14$export$dcccc29c315dd646(iterable) {
    return new (0, $82Kdl.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $cAivK.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $714595da1cddbd14$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $82Kdl.Observable)(function(subscriber) {
        $714595da1cddbd14$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $714595da1cddbd14$export$b2dcb11d46e7a4ad(readableStream) {
    return $714595da1cddbd14$export$e073fccf36d78cc1((0, $7ok89.readableStreamLikeToAsyncGenerator)(readableStream));
}
function $714595da1cddbd14$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $cAivK.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $cAivK.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $cAivK.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("hv4Mv", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $cbd90a69679b4de6$export$1e2f57719e155213);
var $cbd90a69679b4de6$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};

});

parcelRegister("hy8k5", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $cc6c116bc65129bd$export$4369c812aac99591);

var $1hO6f = parcelRequire("1hO6f");
function $cc6c116bc65129bd$export$4369c812aac99591(value) {
    return (0, $1hO6f.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

});

parcelRegister("9CZcX", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", () => $70272451aa13277d$export$48c0cddbc99c45c2);

var $2KzBr = parcelRequire("2KzBr");

var $1hO6f = parcelRequire("1hO6f");
function $70272451aa13277d$export$48c0cddbc99c45c2(input) {
    return (0, $1hO6f.isFunction)(input[0, $2KzBr.observable]);
}

});

parcelRegister("92fqP", function(module, exports) {

$parcel$export(module.exports, "isAsyncIterable", () => $6940456102e700b1$export$edb10ab8dd75a915);

var $1hO6f = parcelRequire("1hO6f");
function $6940456102e700b1$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $1hO6f.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

});

parcelRegister("le5nW", function(module, exports) {

$parcel$export(module.exports, "createInvalidObservableTypeError", () => $f73f1522daaefce2$export$7cbe71b9fa263484);
function $f73f1522daaefce2$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

});

parcelRegister("jX50K", function(module, exports) {

$parcel$export(module.exports, "isIterable", () => $e8676a16740c689e$export$9652023d9040757);

var $lcCOR = parcelRequire("lcCOR");

var $1hO6f = parcelRequire("1hO6f");
function $e8676a16740c689e$export$9652023d9040757(input) {
    return (0, $1hO6f.isFunction)(input === null || input === void 0 ? void 0 : input[0, $lcCOR.iterator]);
}

});
parcelRegister("lcCOR", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $f6f8d4ac0a94b0bb$export$6f58e2338da23f4d);
function $f6f8d4ac0a94b0bb$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $f6f8d4ac0a94b0bb$export$6f58e2338da23f4d = $f6f8d4ac0a94b0bb$export$aa9956be4ae4fe8();

});


parcelRegister("7ok89", function(module, exports) {

$parcel$export(module.exports, "readableStreamLikeToAsyncGenerator", () => $561a63c40afba3fb$export$cf4785e597badab3);
$parcel$export(module.exports, "isReadableStreamLike", () => $561a63c40afba3fb$export$c088ffafdba7405f);

var $cAivK = parcelRequire("cAivK");

var $1hO6f = parcelRequire("1hO6f");
function $561a63c40afba3fb$export$cf4785e597badab3(readableStream) {
    return (0, $cAivK.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $cAivK.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $cAivK.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $cAivK.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $cAivK.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $561a63c40afba3fb$export$c088ffafdba7405f(obj) {
    return (0, $1hO6f.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

});


parcelRegister("dTo9y", function(module, exports) {

$parcel$export(module.exports, "observeOn", () => $a1d325bc3491efe6$export$9007f49c319d1ac7);

var $6X9r0 = parcelRequire("6X9r0");

var $4J4s9 = parcelRequire("4J4s9");

var $fyrlr = parcelRequire("fyrlr");
function $a1d325bc3491efe6$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $4J4s9.operate)(function(source, subscriber) {
        source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(value) {
            return (0, $6X9r0.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $6X9r0.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $6X9r0.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

});
parcelRegister("6X9r0", function(module, exports) {

$parcel$export(module.exports, "executeSchedule", () => $50ff92426c150fa7$export$a2b7447487315232);
function $50ff92426c150fa7$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

});

parcelRegister("4J4s9", function(module, exports) {

$parcel$export(module.exports, "operate", () => $370ed1b25daaef5c$export$871731df685d7753);

var $1hO6f = parcelRequire("1hO6f");
function $370ed1b25daaef5c$export$ebec8610810318c5(source) {
    return (0, $1hO6f.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function $370ed1b25daaef5c$export$871731df685d7753(init) {
    return function(source) {
        if ($370ed1b25daaef5c$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

});

parcelRegister("fyrlr", function(module, exports) {

$parcel$export(module.exports, "createOperatorSubscriber", () => $b52f3e1947d105d4$export$b9e075132cc6937f);

var $cAivK = parcelRequire("cAivK");

var $ehgY6 = parcelRequire("ehgY6");
function $b52f3e1947d105d4$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $b52f3e1947d105d4$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $b52f3e1947d105d4$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $cAivK.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $ehgY6.Subscriber));

});


parcelRegister("ieAir", function(module, exports) {

$parcel$export(module.exports, "subscribeOn", () => $d465b080d5c37bef$export$1eb44d8f5f64733b);

var $4J4s9 = parcelRequire("4J4s9");
function $d465b080d5c37bef$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $4J4s9.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

});


parcelRegister("p0QgJ", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", () => $04b2fd2074c4cd68$export$fc9afd948577f0a8);

var $9IWtL = parcelRequire("9IWtL");

var $dTo9y = parcelRequire("dTo9y");

var $ieAir = parcelRequire("ieAir");
function $04b2fd2074c4cd68$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $9IWtL.innerFrom)(input).pipe((0, $ieAir.subscribeOn)(scheduler), (0, $dTo9y.observeOn)(scheduler));
}

});

parcelRegister("7bGpE", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", () => $53ba75c5b37ae950$export$b34673931371729a);

var $82Kdl = parcelRequire("82Kdl");
function $53ba75c5b37ae950$export$b34673931371729a(input, scheduler) {
    return new (0, $82Kdl.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

});

parcelRegister("elKuH", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", () => $a72717a398e53ca2$export$2b75c58ab9b5b766);

var $82Kdl = parcelRequire("82Kdl");

var $lcCOR = parcelRequire("lcCOR");

var $1hO6f = parcelRequire("1hO6f");

var $6X9r0 = parcelRequire("6X9r0");
function $a72717a398e53ca2$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $82Kdl.Observable)(function(subscriber) {
        var iterator;
        (0, $6X9r0.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, $lcCOR.iterator]();
            (0, $6X9r0.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $1hO6f.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

});

parcelRegister("jO2Gk", function(module, exports) {

$parcel$export(module.exports, "scheduleAsyncIterable", () => $e6b4c45d31e457b0$export$7c7f0979b56a32f3);

var $82Kdl = parcelRequire("82Kdl");

var $6X9r0 = parcelRequire("6X9r0");
function $e6b4c45d31e457b0$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $82Kdl.Observable)(function(subscriber) {
        (0, $6X9r0.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $6X9r0.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

});

parcelRegister("ghxH3", function(module, exports) {

$parcel$export(module.exports, "scheduleReadableStreamLike", () => $bda85ead65e41237$export$3385251aeecad28a);

var $jO2Gk = parcelRequire("jO2Gk");

var $7ok89 = parcelRequire("7ok89");
function $bda85ead65e41237$export$3385251aeecad28a(input, scheduler) {
    return (0, $jO2Gk.scheduleAsyncIterable)((0, $7ok89.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

});




parcelRegister("3XkaH", function(module, exports) {

$parcel$export(module.exports, "map", () => $2e1687756e22bf2d$export$871de8747c9eaa88);

var $4J4s9 = parcelRequire("4J4s9");

var $fyrlr = parcelRequire("fyrlr");
function $2e1687756e22bf2d$export$871de8747c9eaa88(project, thisArg) {
    return (0, $4J4s9.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

});

parcelRegister("jxiZx", function(module, exports) {

$parcel$export(module.exports, "skip", () => $e38fd4bbc2ddb9ac$export$955fc4a6c4be454d);

var $dY50F = parcelRequire("dY50F");
function $e38fd4bbc2ddb9ac$export$955fc4a6c4be454d(count) {
    return (0, $dY50F.filter)(function(_, index) {
        return count <= index;
    });
}

});
parcelRegister("dY50F", function(module, exports) {

$parcel$export(module.exports, "filter", () => $a2b4c3ca09352755$export$3dea766d36a8935f);

var $4J4s9 = parcelRequire("4J4s9");

var $fyrlr = parcelRequire("fyrlr");
function $a2b4c3ca09352755$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $4J4s9.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

});


parcelRegister("hgiLQ", function(module, exports) {

$parcel$export(module.exports, "take", () => $c9127dbe6dc2c95e$export$b7df5d561049483a);

var $cmBHM = parcelRequire("cmBHM");

var $4J4s9 = parcelRequire("4J4s9");

var $fyrlr = parcelRequire("fyrlr");
function $c9127dbe6dc2c95e$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $cmBHM.EMPTY;
    } : (0, $4J4s9.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

});
parcelRegister("cmBHM", function(module, exports) {

$parcel$export(module.exports, "EMPTY", () => $9004c9923e968188$export$ccb33e29d92c9a58);

var $82Kdl = parcelRequire("82Kdl");
var $9004c9923e968188$export$ccb33e29d92c9a58 = new (0, $82Kdl.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $9004c9923e968188$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $9004c9923e968188$var$emptyScheduled(scheduler) : $9004c9923e968188$export$ccb33e29d92c9a58;
}
function $9004c9923e968188$var$emptyScheduled(scheduler) {
    return new (0, $82Kdl.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});


parcelRegister("g8AQ2", function(module, exports) {

$parcel$export(module.exports, "timeoutWith", () => $bbf9f800ffa8c48a$export$86fe999fba7953f2);

var $knJUy = parcelRequire("knJUy");

var $8xmUq = parcelRequire("8xmUq");

var $g5afk = parcelRequire("g5afk");
function $bbf9f800ffa8c48a$export$86fe999fba7953f2(due, withObservable, scheduler) {
    var first;
    var each;
    var _with;
    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : (0, $knJUy.async);
    if ((0, $8xmUq.isValidDate)(due)) first = due;
    else if (typeof due === 'number') each = due;
    if (withObservable) _with = function() {
        return withObservable;
    };
    else throw new TypeError('No observable provided to switch to');
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, $g5afk.timeout)({
        first: first,
        each: each,
        scheduler: scheduler,
        with: _with
    });
}

});
parcelRegister("knJUy", function(module, exports) {

$parcel$export(module.exports, "asyncScheduler", () => $ed6991a3d6a0c881$export$8d6b71a2b178fc32);
$parcel$export(module.exports, "async", () => $ed6991a3d6a0c881$export$12af436354f1a4f7);

var $a1wxg = parcelRequire("a1wxg");

var $bxkz9 = parcelRequire("bxkz9");
var $ed6991a3d6a0c881$export$8d6b71a2b178fc32 = new (0, $bxkz9.AsyncScheduler)((0, $a1wxg.AsyncAction));
var $ed6991a3d6a0c881$export$12af436354f1a4f7 = $ed6991a3d6a0c881$export$8d6b71a2b178fc32;

});
parcelRegister("a1wxg", function(module, exports) {

$parcel$export(module.exports, "AsyncAction", () => $74c33c4385e5d412$export$b5369ffd7cb2211b);

var $cAivK = parcelRequire("cAivK");

var $dGB5W = parcelRequire("dGB5W");

var $gUO0w = parcelRequire("gUO0w");

var $h0JpQ = parcelRequire("h0JpQ");
var $74c33c4385e5d412$export$b5369ffd7cb2211b = function(_super) {
    (0, $cAivK.__extends)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $gUO0w.intervalProvider).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $gUO0w.intervalProvider).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $h0JpQ.arrRemove)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $dGB5W.Action));

});
parcelRegister("dGB5W", function(module, exports) {

$parcel$export(module.exports, "Action", () => $9f6bf8dbf13613ca$export$e19cd5f9376f8cee);

var $cAivK = parcelRequire("cAivK");

var $70uhi = parcelRequire("70uhi");
var $9f6bf8dbf13613ca$export$e19cd5f9376f8cee = function(_super) {
    (0, $cAivK.__extends)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $70uhi.Subscription));

});

parcelRegister("gUO0w", function(module, exports) {

$parcel$export(module.exports, "intervalProvider", () => $c508aabab46134a9$export$f0ca5e16f6f68711);

var $cAivK = parcelRequire("cAivK");
var $c508aabab46134a9$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c508aabab46134a9$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $cAivK.__spreadArray)([
            handler,
            timeout
        ], (0, $cAivK.__read)(args)));
        return setInterval.apply(void 0, (0, $cAivK.__spreadArray)([
            handler,
            timeout
        ], (0, $cAivK.__read)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $c508aabab46134a9$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};

});


parcelRegister("bxkz9", function(module, exports) {

$parcel$export(module.exports, "AsyncScheduler", () => $8662babc67ca693c$export$4114a3ec92faa3c6);

var $cAivK = parcelRequire("cAivK");

var $7Ds8v = parcelRequire("7Ds8v");
var $8662babc67ca693c$export$4114a3ec92faa3c6 = function(_super) {
    (0, $cAivK.__extends)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $7Ds8v.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $7Ds8v.Scheduler));

});
parcelRegister("7Ds8v", function(module, exports) {

$parcel$export(module.exports, "Scheduler", () => $58f2002d7637d979$export$d3e54bb8584cda7c);

var $5Mtdz = parcelRequire("5Mtdz");
var $58f2002d7637d979$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $5Mtdz.dateTimestampProvider).now;
    return Scheduler;
}();

});
parcelRegister("5Mtdz", function(module, exports) {

$parcel$export(module.exports, "dateTimestampProvider", () => $4358198711a00bab$export$c1895ea2d519a677);
var $4358198711a00bab$export$c1895ea2d519a677 = {
    now: function() {
        return ($4358198711a00bab$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};

});




parcelRegister("8xmUq", function(module, exports) {

$parcel$export(module.exports, "isValidDate", () => $63732d0f9281e74b$export$c03bb0116ee09d4b);
function $63732d0f9281e74b$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}

});

parcelRegister("g5afk", function(module, exports) {

$parcel$export(module.exports, "timeout", () => $bb550fabb135ff1e$export$83e74882c5df8fe1);

var $knJUy = parcelRequire("knJUy");

var $8xmUq = parcelRequire("8xmUq");

var $4J4s9 = parcelRequire("4J4s9");

var $9IWtL = parcelRequire("9IWtL");

var $4syGL = parcelRequire("4syGL");

var $fyrlr = parcelRequire("fyrlr");

var $6X9r0 = parcelRequire("6X9r0");
var $bb550fabb135ff1e$export$66d311bf29d5c89c = (0, $4syGL.createErrorClass)(function(_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) info = null;
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function $bb550fabb135ff1e$export$83e74882c5df8fe1(config, schedulerArg) {
    var _a = (0, $8xmUq.isValidDate)(config) ? {
        first: config
    } : typeof config === 'number' ? {
        each: config
    } : config, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? $bb550fabb135ff1e$var$timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : (0, $knJUy.asyncScheduler) : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, $4J4s9.operate)(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function(delay) {
            timerSubscription = (0, $6X9r0.executeSchedule)(subscriber, scheduler, function() {
                try {
                    originalSourceSubscription.unsubscribe();
                    (0, $9IWtL.innerFrom)(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen
                    })).subscribe(subscriber);
                } catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(value) {
            timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            seen++;
            subscriber.next(lastValue = value);
            each > 0 && startTimer(each);
        }, undefined, undefined, function() {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === 'number' ? first : +first - scheduler.now() : each);
    });
}
function $bb550fabb135ff1e$var$timeoutErrorFactory(info) {
    throw new $bb550fabb135ff1e$export$66d311bf29d5c89c(info);
}

});


parcelRegister("k97PP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CacheLayer = void 0;

var $jS6MW = parcelRequire("jS6MW");
var $82Kdl = parcelRequire("82Kdl");
var $8fifx = parcelRequire("8fifx");

var $dY50F = parcelRequire("dY50F");
var $3XkaH = parcelRequire("3XkaH");
var $jxiZx = parcelRequire("jxiZx");
var $hgiLQ = parcelRequire("hgiLQ");
var $g8AQ2 = parcelRequire("g8AQ2");
class $eaaab9c68b7f0d4f$var$CacheLayer {
    get(name) {
        return this.map.get(name);
    }
    constructor(layer){
        this.items = new $jS6MW.BehaviorSubject([]);
        this.map = new Map();
        this.name = layer.name;
        this.config = layer.config;
        this.initHook(layer);
    }
    initHook(layer) {
        if (this.config.maxAge) this.onExpireAll(layer);
    }
    onExpireAll(layer) {
        layer.items.forEach((item)=>this.onExpire(item['key']));
    }
    putItemHook(layerItem) {
        if (this.config.maxAge) this.onExpire(layerItem['key']);
    }
    getItem(key) {
        if (this.map.has(key)) return this.get(key);
        else return null;
    }
    putItem(layerItem) {
        this.map.set(layerItem['key'], layerItem);
        const item = this.get(layerItem['key']);
        const filteredItems = this.items.getValue().filter((item)=>item['key'] !== layerItem['key']);
        this.items.next([
            ...filteredItems,
            item
        ]);
        this.putItemHook(layerItem);
        return layerItem;
    }
    onExpire(key) {
        return new $82Kdl.Observable((observer)=>observer.next(true)).pipe((0, $g8AQ2.timeoutWith)(this.config.maxAge, (0, $8fifx.of)(1)), (0, $jxiZx.skip)(1), (0, $hgiLQ.take)(1)).subscribe(()=>this.removeItem(key));
    }
    removeItem(key) {
        const newLayerItems = this.items.getValue().filter((item)=>item['key'] !== key);
        this.map.delete(key);
        this.items.next(newLayerItems);
    }
    getItemObservable(key) {
        return this.items.asObservable().pipe((0, $dY50F.filter)(()=>!!this.map.has(key)), (0, $3XkaH.map)(()=>this.map.get(key)));
    }
    flushCache() {
        return this.items.asObservable().pipe((0, $3XkaH.map)((items)=>{
            items.forEach((i)=>this.removeItem(i['key']));
            return true;
        }));
    }
}
module.exports.CacheLayer = $eaaab9c68b7f0d4f$var$CacheLayer;

});

parcelRegister("cYPHp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternalLayers = module.exports.InternalEvents = void 0;
function $973330febc889b18$var$strEnum(o) {
    return o.reduce((res, key)=>{
        res[key] = key;
        return res;
    }, Object.create(null));
}
module.exports.InternalEvents = $973330febc889b18$var$strEnum([
    'load',
    'config'
]);
module.exports.InternalLayers = $973330febc889b18$var$strEnum([
    'globalConfig',
    'modules'
]);

});


parcelRegister("lxoqV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GenericConstruct = $fadfa1f9531fb4fb$var$GenericConstruct;

var $4q6qh = parcelRequire("4q6qh");

var $fx7Of = parcelRequire("fx7Of");
const $fadfa1f9531fb4fb$var$moduleService = $4q6qh.Container.get($fx7Of.ModuleService);
const $fadfa1f9531fb4fb$var$bootstrapLogger = $4q6qh.Container.get($fx7Of.BootstrapLogger);
function $fadfa1f9531fb4fb$var$GenericConstruct(module, original, currentModule) {
    return function construct(constructor, args) {
        if (!module) return new constructor();
        if (module.imports) $fadfa1f9531fb4fb$var$moduleService.setImports(module.imports, original);
        if (module.services) $fadfa1f9531fb4fb$var$moduleService.setServices(module.services, original, currentModule);
        if (module.providers) $fadfa1f9531fb4fb$var$moduleService.setServices(module.providers, original, currentModule);
        if (module.controllers) $fadfa1f9531fb4fb$var$moduleService.setControllers(module.controllers, original, currentModule);
        if (module.effects) $fadfa1f9531fb4fb$var$moduleService.setEffects(module.effects, original, currentModule);
        if (module.components) $fadfa1f9531fb4fb$var$moduleService.setComponents(module.components, original, currentModule);
        if (module.beforePlugins) $fadfa1f9531fb4fb$var$moduleService.setBeforePlugins(module.beforePlugins, original, currentModule);
        if (module.plugins) $fadfa1f9531fb4fb$var$moduleService.setPlugins(module.plugins, original, currentModule);
        if (module.afterPlugins) $fadfa1f9531fb4fb$var$moduleService.setAfterPlugins(module.afterPlugins, original, currentModule);
        if (module.bootstrap) $fadfa1f9531fb4fb$var$moduleService.setBootstraps(module.bootstrap, original, currentModule);
        $fadfa1f9531fb4fb$var$bootstrapLogger.log(`Bootstrap -> @Module('${constructor.originalName}')${$fadfa1f9531fb4fb$var$bootstrapLogger.logHashes(`(${constructor.name})`)}: finished!`);
        return $4q6qh.Container.get(constructor);
    };
}

});
parcelRegister("fx7Of", function(module, exports) {
"use strict";
var $b4effedb02702e79$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b4effedb02702e79$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b4effedb02702e79$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b4effedb02702e79$var$__exportStar((parcelRequire("5bpLp")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("72AdI")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("l3vts")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("2byAY")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("cq07L")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("2ENVg")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("8migr")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("TeV5f")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("dvi7U")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("a77jh")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("6sEU4")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("eQPWm")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("2C6Os")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("dnIrd")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("dC70L")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("gEWm7")), module.exports);

$b4effedb02702e79$var$__exportStar((parcelRequire("8d4NV")), module.exports);

});
parcelRegister("5bpLp", function(module, exports) {
"use strict";
var $3c61f6f949733253$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3c61f6f949733253$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3c61f6f949733253$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3c61f6f949733253$var$__exportStar((parcelRequire("8afYX")), module.exports);

$3c61f6f949733253$var$__exportStar((parcelRequire("k97PP")), module.exports);

$3c61f6f949733253$var$__exportStar((parcelRequire("cemeC")), module.exports);

});
parcelRegister("cemeC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CacheServiceConfigInterface = void 0;
class $8e780a316847b47c$var$CacheServiceConfigInterface {
    constructor(){
        this.deleteOnExpire = 'aggressive';
        this.cacheFlushInterval = 3600000;
        this.maxAge = 900000;
        this.localStorage = false;
    }
}
module.exports.CacheServiceConfigInterface = $8e780a316847b47c$var$CacheServiceConfigInterface;

});


parcelRegister("72AdI", function(module, exports) {
"use strict";
var $0152a887c965ef2a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PluginService = void 0;

var $jS6MW = parcelRequire("jS6MW");

var $8DS2b = parcelRequire("8DS2b");
let $0152a887c965ef2a$var$PluginService = class PluginService {
    constructor(){
        this.plugins = new $jS6MW.BehaviorSubject([]);
        this.beforePlugins = new $jS6MW.BehaviorSubject([]);
        this.afterPlugins = new $jS6MW.BehaviorSubject([]);
    }
    register(plugin) {
        this.plugins.next([
            ...this.plugins.getValue(),
            plugin
        ]);
    }
    registerBefore(plugin) {
        this.beforePlugins.next([
            ...this.plugins.getValue(),
            plugin
        ]);
    }
    registerAfter(plugin) {
        this.afterPlugins.next([
            ...this.plugins.getValue(),
            plugin
        ]);
    }
    getPlugins() {
        return this.plugins.getValue();
    }
    getAfterPlugins() {
        return this.afterPlugins.getValue();
    }
    getBeforePlugins() {
        return this.beforePlugins.getValue();
    }
};
module.exports.PluginService = $0152a887c965ef2a$var$PluginService;
module.exports.PluginService = $0152a887c965ef2a$var$PluginService = $0152a887c965ef2a$var$__decorate([
    (0, $8DS2b.Service)()
], $0152a887c965ef2a$var$PluginService);

});

parcelRegister("l3vts", function(module, exports) {
"use strict";
var $f5424ae72138fe74$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f5424ae72138fe74$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f5424ae72138fe74$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f5424ae72138fe74$var$__exportStar((parcelRequire("3O0qi")), module.exports);

});
parcelRegister("3O0qi", function(module, exports) {
"use strict";
var $2c565ea019bfa35a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2c565ea019bfa35a$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BootstrapLogger = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $8migr = parcelRequire("8migr");

var $fyRWr = parcelRequire("fyRWr");
let $2c565ea019bfa35a$var$BootstrapLogger = class BootstrapLogger {
    log(message) {
        if (this.configService.config.logger.logging) {
            const m = [
                this.logDate(),
                message
            ];
            console.log(...m);
            return m;
        }
    }
    error(message) {
        console.error(message);
    }
    logImporter(message) {
        if (this.configService.config.logger.logging) return this.log(message);
    }
    logDate() {
        if (this.configService.config.logger.date) return `${Date.now().toPrecision()}`;
        else return '';
    }
    logHashes(message) {
        if (this.configService.config.logger.hashes) return message;
        else return '';
    }
    logExitHandler(message) {
        if (this.configService.config.logger.exitHandler) this.log(message);
        else return '';
    }
};
module.exports.BootstrapLogger = $2c565ea019bfa35a$var$BootstrapLogger;
$2c565ea019bfa35a$var$__decorate([
    (0, $fyRWr.Injector)($8migr.ConfigService),
    $2c565ea019bfa35a$var$__metadata("design:type", $8migr.ConfigService)
], $2c565ea019bfa35a$var$BootstrapLogger.prototype, "configService", void 0);
module.exports.BootstrapLogger = $2c565ea019bfa35a$var$BootstrapLogger = $2c565ea019bfa35a$var$__decorate([
    (0, $8DS2b.Service)()
], $2c565ea019bfa35a$var$BootstrapLogger);

});
parcelRegister("8migr", function(module, exports) {
"use strict";
var $615e8bacbd6ca7bb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $615e8bacbd6ca7bb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $615e8bacbd6ca7bb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$615e8bacbd6ca7bb$var$__exportStar((parcelRequire("5Tmye")), module.exports);

$615e8bacbd6ca7bb$var$__exportStar((parcelRequire("7s27r")), module.exports);

});
parcelRegister("5Tmye", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigModel = module.exports.InitOptionsConfig = module.exports.ExperimentalFeatures = module.exports.PrivateCryptoModel = module.exports.LoggerConfig = void 0;
class $44a394ff78d2bb58$var$LoggerConfig {
    constructor(){
        this.logging = false;
        this.hashes = true;
        this.date = true;
        this.exitHandler = true;
    }
}
module.exports.LoggerConfig = $44a394ff78d2bb58$var$LoggerConfig;
class $44a394ff78d2bb58$var$PrivateCryptoModel {
}
module.exports.PrivateCryptoModel = $44a394ff78d2bb58$var$PrivateCryptoModel;
class $44a394ff78d2bb58$var$ExperimentalFeatures {
}
module.exports.ExperimentalFeatures = $44a394ff78d2bb58$var$ExperimentalFeatures;
class $44a394ff78d2bb58$var$InitOptionsConfig {
}
module.exports.InitOptionsConfig = $44a394ff78d2bb58$var$InitOptionsConfig;
class $44a394ff78d2bb58$var$ConfigModel {
    constructor(){
        this.init = true;
        this.initOptions = new $44a394ff78d2bb58$var$InitOptionsConfig();
        this.experimental = new $44a394ff78d2bb58$var$ExperimentalFeatures();
        this.logger = new $44a394ff78d2bb58$var$LoggerConfig();
    }
}
module.exports.ConfigModel = $44a394ff78d2bb58$var$ConfigModel;

});

parcelRegister("7s27r", function(module, exports) {
"use strict";
var $56cccabb51f9961c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigService = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $5Tmye = parcelRequire("5Tmye");
let $56cccabb51f9961c$var$ConfigService = class ConfigService {
    constructor(){
        this.config = new $5Tmye.ConfigModel();
    }
    setConfig(config) {
        Object.assign(this.config, config);
    }
};
module.exports.ConfigService = $56cccabb51f9961c$var$ConfigService;
module.exports.ConfigService = $56cccabb51f9961c$var$ConfigService = $56cccabb51f9961c$var$__decorate([
    (0, $8DS2b.Service)()
], $56cccabb51f9961c$var$ConfigService);

});


parcelRegister("fyRWr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Injector = $b543dfaca041ef0b$var$Injector;

var $4q6qh = parcelRequire("4q6qh");
function $b543dfaca041ef0b$var$Injector(Service) {
    return function(target, propertyName) {
        Object.defineProperty(target, propertyName, {
            get: ()=>$4q6qh.Container.get(Service)
        });
    };
}

});



parcelRegister("2byAY", function(module, exports) {
"use strict";
var $197771c8f3aac472$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $197771c8f3aac472$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $197771c8f3aac472$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$197771c8f3aac472$var$__exportStar((parcelRequire("e40eu")), module.exports);

});
parcelRegister("e40eu", function(module, exports) {

var $ioBC3 = parcelRequire("ioBC3");
"use strict";
var $a3d19e98a50ee6b3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a3d19e98a50ee6b3$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExitHandlerService = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $l3vts = parcelRequire("l3vts");

var $fyRWr = parcelRequire("fyRWr");

var $82Kdl = parcelRequire("82Kdl");
var $35ZUd = parcelRequire("35ZUd");
let $a3d19e98a50ee6b3$var$ExitHandlerService = class ExitHandlerService {
    constructor(){
        this.errorHandler = new $35ZUd.Subject();
    }
    init() {}
    exitHandler(options, err) {
        this.errorHandler.next(err);
        if (options.cleanup) this.logger.logExitHandler('AppStopped');
        if (options.exit) this.logger.logExitHandler('Unhandled error rejection');
        if (err) {
            console.log(err);
            return $ioBC3.exit(1);
        }
        return $ioBC3.exit(0);
    }
    onExitApp(events) {
        return new $82Kdl.Observable((o)=>events && events.length && events.forEach((event)=>$ioBC3.on(event, (e)=>o.next(e))));
    }
};
module.exports.ExitHandlerService = $a3d19e98a50ee6b3$var$ExitHandlerService;
$a3d19e98a50ee6b3$var$__decorate([
    (0, $fyRWr.Injector)($l3vts.BootstrapLogger),
    $a3d19e98a50ee6b3$var$__metadata("design:type", $l3vts.BootstrapLogger)
], $a3d19e98a50ee6b3$var$ExitHandlerService.prototype, "logger", void 0);
module.exports.ExitHandlerService = $a3d19e98a50ee6b3$var$ExitHandlerService = $a3d19e98a50ee6b3$var$__decorate([
    (0, $8DS2b.Service)()
], $a3d19e98a50ee6b3$var$ExitHandlerService);

});
parcelRegister("ioBC3", function(module, exports) {
// shim for using process in browser
var $d647a4fdfd521fda$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d647a4fdfd521fda$var$cachedSetTimeout;
var $d647a4fdfd521fda$var$cachedClearTimeout;
function $d647a4fdfd521fda$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d647a4fdfd521fda$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d647a4fdfd521fda$var$cachedSetTimeout = setTimeout;
        else $d647a4fdfd521fda$var$cachedSetTimeout = $d647a4fdfd521fda$var$defaultSetTimout;
    } catch (e) {
        $d647a4fdfd521fda$var$cachedSetTimeout = $d647a4fdfd521fda$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d647a4fdfd521fda$var$cachedClearTimeout = clearTimeout;
        else $d647a4fdfd521fda$var$cachedClearTimeout = $d647a4fdfd521fda$var$defaultClearTimeout;
    } catch (e) {
        $d647a4fdfd521fda$var$cachedClearTimeout = $d647a4fdfd521fda$var$defaultClearTimeout;
    }
})();
function $d647a4fdfd521fda$var$runTimeout(fun) {
    if ($d647a4fdfd521fda$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d647a4fdfd521fda$var$cachedSetTimeout === $d647a4fdfd521fda$var$defaultSetTimout || !$d647a4fdfd521fda$var$cachedSetTimeout) && setTimeout) {
        $d647a4fdfd521fda$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d647a4fdfd521fda$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d647a4fdfd521fda$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d647a4fdfd521fda$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d647a4fdfd521fda$var$runClearTimeout(marker) {
    if ($d647a4fdfd521fda$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d647a4fdfd521fda$var$cachedClearTimeout === $d647a4fdfd521fda$var$defaultClearTimeout || !$d647a4fdfd521fda$var$cachedClearTimeout) && clearTimeout) {
        $d647a4fdfd521fda$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d647a4fdfd521fda$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d647a4fdfd521fda$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d647a4fdfd521fda$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d647a4fdfd521fda$var$queue = [];
var $d647a4fdfd521fda$var$draining = false;
var $d647a4fdfd521fda$var$currentQueue;
var $d647a4fdfd521fda$var$queueIndex = -1;
function $d647a4fdfd521fda$var$cleanUpNextTick() {
    if (!$d647a4fdfd521fda$var$draining || !$d647a4fdfd521fda$var$currentQueue) return;
    $d647a4fdfd521fda$var$draining = false;
    if ($d647a4fdfd521fda$var$currentQueue.length) $d647a4fdfd521fda$var$queue = $d647a4fdfd521fda$var$currentQueue.concat($d647a4fdfd521fda$var$queue);
    else $d647a4fdfd521fda$var$queueIndex = -1;
    if ($d647a4fdfd521fda$var$queue.length) $d647a4fdfd521fda$var$drainQueue();
}
function $d647a4fdfd521fda$var$drainQueue() {
    if ($d647a4fdfd521fda$var$draining) return;
    var timeout = $d647a4fdfd521fda$var$runTimeout($d647a4fdfd521fda$var$cleanUpNextTick);
    $d647a4fdfd521fda$var$draining = true;
    var len = $d647a4fdfd521fda$var$queue.length;
    while(len){
        $d647a4fdfd521fda$var$currentQueue = $d647a4fdfd521fda$var$queue;
        $d647a4fdfd521fda$var$queue = [];
        while(++$d647a4fdfd521fda$var$queueIndex < len)if ($d647a4fdfd521fda$var$currentQueue) $d647a4fdfd521fda$var$currentQueue[$d647a4fdfd521fda$var$queueIndex].run();
        $d647a4fdfd521fda$var$queueIndex = -1;
        len = $d647a4fdfd521fda$var$queue.length;
    }
    $d647a4fdfd521fda$var$currentQueue = null;
    $d647a4fdfd521fda$var$draining = false;
    $d647a4fdfd521fda$var$runClearTimeout(timeout);
}
$d647a4fdfd521fda$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d647a4fdfd521fda$var$queue.push(new $d647a4fdfd521fda$var$Item(fun, args));
    if ($d647a4fdfd521fda$var$queue.length === 1 && !$d647a4fdfd521fda$var$draining) $d647a4fdfd521fda$var$runTimeout($d647a4fdfd521fda$var$drainQueue);
};
// v8 likes predictible objects
function $d647a4fdfd521fda$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d647a4fdfd521fda$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d647a4fdfd521fda$var$process.title = 'browser';
$d647a4fdfd521fda$var$process.browser = true;
$d647a4fdfd521fda$var$process.env = {};
$d647a4fdfd521fda$var$process.argv = [];
$d647a4fdfd521fda$var$process.version = ''; // empty string to avoid regexp issues
$d647a4fdfd521fda$var$process.versions = {};
function $d647a4fdfd521fda$var$noop() {}
$d647a4fdfd521fda$var$process.on = $d647a4fdfd521fda$var$noop;
$d647a4fdfd521fda$var$process.addListener = $d647a4fdfd521fda$var$noop;
$d647a4fdfd521fda$var$process.once = $d647a4fdfd521fda$var$noop;
$d647a4fdfd521fda$var$process.off = $d647a4fdfd521fda$var$noop;
$d647a4fdfd521fda$var$process.removeListener = $d647a4fdfd521fda$var$noop;
$d647a4fdfd521fda$var$process.removeAllListeners = $d647a4fdfd521fda$var$noop;
$d647a4fdfd521fda$var$process.emit = $d647a4fdfd521fda$var$noop;
$d647a4fdfd521fda$var$process.prependListener = $d647a4fdfd521fda$var$noop;
$d647a4fdfd521fda$var$process.prependOnceListener = $d647a4fdfd521fda$var$noop;
$d647a4fdfd521fda$var$process.listeners = function(name) {
    return [];
};
$d647a4fdfd521fda$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d647a4fdfd521fda$var$process.cwd = function() {
    return '/';
};
$d647a4fdfd521fda$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d647a4fdfd521fda$var$process.umask = function() {
    return 0;
};

});



parcelRegister("cq07L", function(module, exports) {
"use strict";
var $90a80262fa8b5ce5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $90a80262fa8b5ce5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $90a80262fa8b5ce5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$90a80262fa8b5ce5$var$__exportStar((parcelRequire("axVJe")), module.exports);

$90a80262fa8b5ce5$var$__exportStar((parcelRequire("lbrrK")), module.exports);

});
parcelRegister("axVJe", function(module, exports) {
"use strict";
var $7ad9c42144c62c6a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7ad9c42144c62c6a$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModuleService = void 0;

var $8fifx = parcelRequire("8fifx");

var $4q6qh = parcelRequire("4q6qh");

var $8DS2b = parcelRequire("8DS2b");

var $a8du2 = parcelRequire("a8du2");

var $72AdI = parcelRequire("72AdI");

var $fyRWr = parcelRequire("fyRWr");

var $lbrrK = parcelRequire("lbrrK");

var $e8IK8 = parcelRequire("e8IK8");

var $cvmB8 = parcelRequire("cvmB8");

var $jDZOm = parcelRequire("jDZOm");

var $1yyJ0 = parcelRequire("1yyJ0");

var $d4ufv = parcelRequire("d4ufv");

var $5XSSl = parcelRequire("5XSSl");

var $9je1N = parcelRequire("9je1N");
let $7ad9c42144c62c6a$var$ModuleService = class ModuleService {
    constructor(){
        this.watcherService = $e8IK8.constructorWatcherService;
    }
    setServices(services, original, currentModule) {
        services.forEach((service)=>{
            this.validators.validateServices(service, original);
            this.setInjectedDependencies(service);
            if (service.provide && service.provide.constructor === Function) service.provide = service.provide['name'];
            if (service.provide && service.useFactory) this.setUseFactory(service);
            else if (service.provide && service.useClass && service.useClass.constructor === Function) this.setUseClass(service);
            else if (service.provide && service.useValue) this.setUseValue(service);
            else {
                currentModule.putItem({
                    data: service,
                    key: service.name
                });
                this.servicesService.register(service);
            }
        });
    }
    setInjectedDependencies(service) {
        service.deps = service.deps || [];
        if (service.deps.length) service.deps = service.deps.map((dep)=>$4q6qh.Container.get(dep));
    }
    setUseValue(service) {
        $4q6qh.Container.set(service.provide, service.useValue);
        if (service.lazy) this.lazyFactoryService.setLazyFactory(service.provide, (0, $8fifx.of)($4q6qh.Container.get(service.provide)));
    }
    setUseClass(service) {
        if (service.lazy) this.lazyFactoryService.setLazyFactory(service.provide, (0, $8fifx.of)($4q6qh.Container.get(service.useClass)));
        else $4q6qh.Container.set(service.provide, $4q6qh.Container.get(service.useClass));
    }
    setUseFactory(service) {
        const factory = service.useFactory;
        service.useFactory = ()=>factory(...service.deps);
        if (service.lazy) this.lazyFactoryService.setLazyFactory(service.provide, service.useFactory());
        else $4q6qh.Container.set(service.provide, service.useFactory());
    }
    setControllers(controllers, original, currentModule) {
        controllers.forEach((controller)=>{
            this.validators.validateController(controller, original);
            currentModule.putItem({
                data: controller,
                key: controller.name
            });
            this.controllersService.register(controller);
        });
    }
    setEffects(effects, original, currentModule) {
        effects.forEach((effect)=>{
            this.validators.validateEffect(effect, original);
            currentModule.putItem({
                data: effect,
                key: effect.name
            });
            this.effectsService.register(effect);
        });
    }
    setComponents(components, original, currentModule) {
        components.forEach((component)=>{
            if (!component['metadata']) (0, $9je1N.ReflectDecorator)({}, {
                type: 'component'
            })(component);
            this.validators.validateComponent(component, original);
            currentModule.putItem({
                data: component,
                key: component.name
            });
            this.componentsService.register(component);
        });
    }
    setPlugins(plugins, original, currentModule) {
        plugins.forEach((plugin)=>{
            this.validators.validatePlugin(plugin, original);
            currentModule.putItem({
                data: plugin,
                key: plugin.name
            });
            this.pluginService.register(plugin);
        });
    }
    setBootstraps(bootstraps, original, currentModule) {
        bootstraps.forEach((bootstrap)=>{
            if (!bootstrap['metadata']) (0, $9je1N.ReflectDecorator)({}, {
                type: 'component'
            })(bootstrap);
            this.validators.validateEmpty(bootstrap, original, bootstrap['metadata']['type']);
            currentModule.putItem({
                data: bootstrap,
                key: bootstrap.name
            });
            this.bootstraps.register(bootstrap);
        });
    }
    setAfterPlugins(plugins, original, currentModule) {
        plugins.forEach((plugin)=>{
            this.validators.validatePlugin(plugin, original);
            currentModule.putItem({
                data: plugin,
                key: plugin.name
            });
            this.pluginService.registerAfter(plugin);
        });
    }
    setBeforePlugins(plugins, original, currentModule) {
        plugins.forEach((plugin)=>{
            this.validators.validatePlugin(plugin, original);
            currentModule.putItem({
                data: plugin,
                key: plugin.name
            });
            this.pluginService.registerBefore(plugin);
        });
    }
    setImports(imports, original) {
        imports.forEach((m)=>{
            this.validators.validateImports(m, original);
            if (!m) throw new Error('Missing import module');
            else $4q6qh.Container.get(m);
        });
    }
};
module.exports.ModuleService = $7ad9c42144c62c6a$var$ModuleService;
$7ad9c42144c62c6a$var$__decorate([
    (0, $fyRWr.Injector)($a8du2.LazyFactory),
    $7ad9c42144c62c6a$var$__metadata("design:type", $a8du2.LazyFactory)
], $7ad9c42144c62c6a$var$ModuleService.prototype, "lazyFactoryService", void 0);
$7ad9c42144c62c6a$var$__decorate([
    (0, $fyRWr.Injector)($72AdI.PluginService),
    $7ad9c42144c62c6a$var$__metadata("design:type", $72AdI.PluginService)
], $7ad9c42144c62c6a$var$ModuleService.prototype, "pluginService", void 0);
$7ad9c42144c62c6a$var$__decorate([
    (0, $fyRWr.Injector)($1yyJ0.ComponentsService),
    $7ad9c42144c62c6a$var$__metadata("design:type", $1yyJ0.ComponentsService)
], $7ad9c42144c62c6a$var$ModuleService.prototype, "componentsService", void 0);
$7ad9c42144c62c6a$var$__decorate([
    (0, $fyRWr.Injector)($cvmB8.ControllersService),
    $7ad9c42144c62c6a$var$__metadata("design:type", $cvmB8.ControllersService)
], $7ad9c42144c62c6a$var$ModuleService.prototype, "controllersService", void 0);
$7ad9c42144c62c6a$var$__decorate([
    (0, $fyRWr.Injector)($jDZOm.EffectsService),
    $7ad9c42144c62c6a$var$__metadata("design:type", $jDZOm.EffectsService)
], $7ad9c42144c62c6a$var$ModuleService.prototype, "effectsService", void 0);
$7ad9c42144c62c6a$var$__decorate([
    (0, $fyRWr.Injector)($d4ufv.BootstrapsServices),
    $7ad9c42144c62c6a$var$__metadata("design:type", $d4ufv.BootstrapsServices)
], $7ad9c42144c62c6a$var$ModuleService.prototype, "bootstraps", void 0);
$7ad9c42144c62c6a$var$__decorate([
    (0, $fyRWr.Injector)($lbrrK.ModuleValidators),
    $7ad9c42144c62c6a$var$__metadata("design:type", $lbrrK.ModuleValidators)
], $7ad9c42144c62c6a$var$ModuleService.prototype, "validators", void 0);
$7ad9c42144c62c6a$var$__decorate([
    (0, $fyRWr.Injector)($5XSSl.ServicesService),
    $7ad9c42144c62c6a$var$__metadata("design:type", $5XSSl.ServicesService)
], $7ad9c42144c62c6a$var$ModuleService.prototype, "servicesService", void 0);
module.exports.ModuleService = $7ad9c42144c62c6a$var$ModuleService = $7ad9c42144c62c6a$var$__decorate([
    (0, $8DS2b.Service)()
], $7ad9c42144c62c6a$var$ModuleService);

});
parcelRegister("a8du2", function(module, exports) {
"use strict";
var $76051c40d93a4061$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LazyFactory = void 0;

var $8DS2b = parcelRequire("8DS2b");
let $76051c40d93a4061$var$LazyFactory = class LazyFactory {
    constructor(){
        this.lazyFactories = new Map();
    }
    setLazyFactory(provide, factory) {
        this.lazyFactories.set(provide, factory);
        return this.getLazyFactory(provide);
    }
    getLazyFactory(provide) {
        return this.lazyFactories.get(provide);
    }
};
module.exports.LazyFactory = $76051c40d93a4061$var$LazyFactory;
module.exports.LazyFactory = $76051c40d93a4061$var$LazyFactory = $76051c40d93a4061$var$__decorate([
    (0, $8DS2b.Service)()
], $76051c40d93a4061$var$LazyFactory);

});

parcelRegister("lbrrK", function(module, exports) {
"use strict";
var $f6bfea58b61d1c17$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModuleValidators = void 0;

var $8DS2b = parcelRequire("8DS2b");
let $f6bfea58b61d1c17$var$ModuleValidators = class ModuleValidators {
    validateEmpty(m, original, type) {
        if (!m) {
            const requiredType = type.charAt(0).toUpperCase() + type.slice(1);
            throw new Error(`
            ${original.metadata.raw}
            -> @Module: ${original.metadata.moduleName}
            -> @Module hash: ${original.metadata.moduleHash}
                --> Maybe you forgot to import some ${requiredType} inside ${original.metadata.moduleName} ?

                Hint: run ts-lint again, looks like imported ${requiredType} is undefined or null inside ${original.metadata.moduleName}
            `);
        }
    }
    genericWrongPluggableError(m, original, type) {
        if (m.metadata.type !== type) {
            const moduleType = m.metadata.type.charAt(0).toUpperCase() + m.metadata.type.slice(1);
            const requiredType = type.charAt(0).toUpperCase() + type.slice(1);
            throw new Error(`
            ${original.metadata.raw}
            -> @Module: '${original.metadata.moduleName}'
            -> @Module hash: '${original.metadata.moduleHash}'
                --> @${moduleType} '${m.metadata.moduleName}' provided, where expected class decorated with '@${requiredType}' instead,
            -> @Hint: please provide class with @Service decorator or remove ${m.metadata.moduleName} class
            `);
        }
    }
    validateImports(m, original) {
        if (m.metadata.type !== 'module') throw new Error(`
            ${original.metadata.raw}
            -> @Module: '${original.metadata.moduleName}'
            -> @Module hash: '${original.metadata.moduleHash}'
                --> @${m.metadata.type.charAt(0).toUpperCase() + m.metadata.type.slice(1)} '${m.originalName}' provided, where expected class decorated with '@Module' instead,
            -> @Hint: please provide class with @Module decorator or remove ${m.originalName} from imports
            `);
    }
    validateServices(m, original) {
        this.validateEmpty(m, original, 'service');
        if (m.provide) return;
        this.genericWrongPluggableError(m, original, 'service');
    }
    validatePlugin(m, original) {
        this.validateEmpty(m, original, 'plugin');
        if (m.provide) return;
        this.genericWrongPluggableError(m, original, 'plugin');
    }
    validateController(m, original) {
        this.validateEmpty(m, original, 'controller');
        if (m.provide) return;
        this.genericWrongPluggableError(m, original, 'controller');
    }
    validateEffect(m, original) {
        this.validateEmpty(m, original, 'effect');
        if (m.provide) return;
        this.genericWrongPluggableError(m, original, 'effect');
    }
    validateComponent(m, original) {
        this.validateEmpty(m, original, 'component');
        if (m.provide) return;
        this.genericWrongPluggableError(m, original, 'component');
    }
};
module.exports.ModuleValidators = $f6bfea58b61d1c17$var$ModuleValidators;
module.exports.ModuleValidators = $f6bfea58b61d1c17$var$ModuleValidators = $f6bfea58b61d1c17$var$__decorate([
    (0, $8DS2b.Service)()
], $f6bfea58b61d1c17$var$ModuleValidators);

});

parcelRegister("cvmB8", function(module, exports) {
"use strict";
var $91a9e8c5477a696b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ControllersService = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $jS6MW = parcelRequire("jS6MW");
let $91a9e8c5477a696b$var$ControllersService = class ControllersService {
    constructor(){
        this.controllers = new $jS6MW.BehaviorSubject([]);
    }
    register(plugin) {
        this.controllers.next([
            ...this.controllers.getValue(),
            plugin
        ]);
    }
    getControllers() {
        return this.controllers.getValue();
    }
};
module.exports.ControllersService = $91a9e8c5477a696b$var$ControllersService;
module.exports.ControllersService = $91a9e8c5477a696b$var$ControllersService = $91a9e8c5477a696b$var$__decorate([
    (0, $8DS2b.Service)()
], $91a9e8c5477a696b$var$ControllersService);

});

parcelRegister("jDZOm", function(module, exports) {
"use strict";
var $e4d19b4117920d50$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EffectsService = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $jS6MW = parcelRequire("jS6MW");
let $e4d19b4117920d50$var$EffectsService = class EffectsService {
    constructor(){
        this.effects = new $jS6MW.BehaviorSubject([]);
    }
    register(plugin) {
        this.effects.next([
            ...this.effects.getValue(),
            plugin
        ]);
    }
    getEffects() {
        return this.effects.getValue();
    }
};
module.exports.EffectsService = $e4d19b4117920d50$var$EffectsService;
module.exports.EffectsService = $e4d19b4117920d50$var$EffectsService = $e4d19b4117920d50$var$__decorate([
    (0, $8DS2b.Service)()
], $e4d19b4117920d50$var$EffectsService);

});

parcelRegister("1yyJ0", function(module, exports) {
"use strict";
var $1223e710524e2daf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComponentsService = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $jS6MW = parcelRequire("jS6MW");
let $1223e710524e2daf$var$ComponentsService = class ComponentsService {
    constructor(){
        this.components = new $jS6MW.BehaviorSubject([]);
    }
    register(plugin) {
        this.components.next([
            ...this.components.getValue(),
            plugin
        ]);
    }
    getComponents() {
        return this.components.getValue();
    }
};
module.exports.ComponentsService = $1223e710524e2daf$var$ComponentsService;
module.exports.ComponentsService = $1223e710524e2daf$var$ComponentsService = $1223e710524e2daf$var$__decorate([
    (0, $8DS2b.Service)()
], $1223e710524e2daf$var$ComponentsService);

});

parcelRegister("d4ufv", function(module, exports) {
"use strict";
var $98431ce7814efac5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BootstrapsServices = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $jS6MW = parcelRequire("jS6MW");
let $98431ce7814efac5$var$BootstrapsServices = class BootstrapsServices {
    constructor(){
        this.bootstraps = new $jS6MW.BehaviorSubject([]);
    }
    register(plugin) {
        this.bootstraps.next([
            ...this.bootstraps.getValue(),
            plugin
        ]);
    }
    getBootstraps() {
        return this.bootstraps.getValue();
    }
};
module.exports.BootstrapsServices = $98431ce7814efac5$var$BootstrapsServices;
module.exports.BootstrapsServices = $98431ce7814efac5$var$BootstrapsServices = $98431ce7814efac5$var$__decorate([
    (0, $8DS2b.Service)()
], $98431ce7814efac5$var$BootstrapsServices);

});

parcelRegister("5XSSl", function(module, exports) {
"use strict";
var $457d07922c9e1254$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServicesService = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $jS6MW = parcelRequire("jS6MW");
let $457d07922c9e1254$var$ServicesService = class ServicesService {
    constructor(){
        this.services = new $jS6MW.BehaviorSubject([]);
    }
    register(plugin) {
        this.services.next([
            ...this.services.getValue(),
            plugin
        ]);
    }
    getServices() {
        return this.services.getValue();
    }
};
module.exports.ServicesService = $457d07922c9e1254$var$ServicesService;
module.exports.ServicesService = $457d07922c9e1254$var$ServicesService = $457d07922c9e1254$var$__decorate([
    (0, $8DS2b.Service)()
], $457d07922c9e1254$var$ServicesService);

});



parcelRegister("2ENVg", function(module, exports) {
"use strict";
var $1ef60ac9c15a703b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1ef60ac9c15a703b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1ef60ac9c15a703b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1ef60ac9c15a703b$var$__exportStar((parcelRequire("4O6sX")), module.exports);

});
parcelRegister("4O6sX", function(module, exports) {
"use strict";
var $3800d8ef74ad8745$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3800d8ef74ad8745$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolverService = void 0;

var $4q6qh = parcelRequire("4q6qh");

var $8afYX = parcelRequire("8afYX");

var $cYPHp = parcelRequire("cYPHp");

var $dY50F = parcelRequire("dY50F");
var $3XkaH = parcelRequire("3XkaH");
var $iuXHq = parcelRequire("iuXHq");

var $8fifx = parcelRequire("8fifx");

var $3O0qi = parcelRequire("3O0qi");

var $fyRWr = parcelRequire("fyRWr");

var $8DS2b = parcelRequire("8DS2b");
let $3800d8ef74ad8745$var$ResolverService = class ResolverService {
    resolveDependencies(hash, target, moduleName) {
        this.cacheService.getLayer($cYPHp.InternalLayers.modules).putItem({
            key: hash,
            data: target
        });
        const currentModule = this.cacheService.getLayer(hash);
        currentModule.putItem({
            key: $cYPHp.InternalEvents.config,
            data: {
                moduleName: moduleName,
                moduleHash: hash
            }
        });
        return currentModule.getItemObservable($cYPHp.InternalEvents.load).pipe((0, $iuXHq.switchMap)((config)=>{
            if (!config.data) return (0, $8fifx.of)(null);
            return currentModule.items.asObservable();
        }), (0, $dY50F.filter)((res)=>!!(res === null || res === void 0 ? void 0 : res.length)), (0, $3XkaH.map)(this.resolveContainerDependencies(target, moduleName)));
    }
    resolveContainerDependencies(target, moduleName) {
        return (res)=>{
            res.forEach((i)=>{
                if (i.key === $cYPHp.InternalEvents.load || i.key === $cYPHp.InternalEvents.config) return;
                const found = this.cacheService.searchForItem(i.data);
                if (found) {
                    if (found.provide) return found;
                    const moduleType = found.metadata.type.charAt(0).toUpperCase() + found.metadata.type.slice(1);
                    this.bootstrapLogger.log(`Start -> @Module('${moduleName}')${this.bootstrapLogger.logHashes(`(${target.name})`)}: @${moduleType}('${found.originalName}')${this.bootstrapLogger.logHashes(`(${found.name})`)}` + ' initialized!');
                    return $4q6qh.Container.get(found);
                } else throw new Error('not found');
            });
            return res;
        };
    }
};
module.exports.ResolverService = $3800d8ef74ad8745$var$ResolverService;
$3800d8ef74ad8745$var$__decorate([
    (0, $fyRWr.Injector)($3O0qi.BootstrapLogger),
    $3800d8ef74ad8745$var$__metadata("design:type", $3O0qi.BootstrapLogger)
], $3800d8ef74ad8745$var$ResolverService.prototype, "bootstrapLogger", void 0);
$3800d8ef74ad8745$var$__decorate([
    (0, $fyRWr.Injector)($8afYX.CacheService),
    $3800d8ef74ad8745$var$__metadata("design:type", $8afYX.CacheService)
], $3800d8ef74ad8745$var$ResolverService.prototype, "cacheService", void 0);
module.exports.ResolverService = $3800d8ef74ad8745$var$ResolverService = $3800d8ef74ad8745$var$__decorate([
    (0, $8DS2b.Service)()
], $3800d8ef74ad8745$var$ResolverService);

});
parcelRegister("iuXHq", function(module, exports) {

$parcel$export(module.exports, "switchMap", () => $d779566bbeb9ac00$export$9f6ea8e48bc26eab);

var $9IWtL = parcelRequire("9IWtL");

var $4J4s9 = parcelRequire("4J4s9");

var $fyrlr = parcelRequire("fyrlr");
function $d779566bbeb9ac00$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $4J4s9.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $9IWtL.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $fyrlr.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

});



parcelRegister("TeV5f", function(module, exports) {
"use strict";
var $0a60b5e94ce82929$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a60b5e94ce82929$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0a60b5e94ce82929$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0a60b5e94ce82929$var$__exportStar((parcelRequire("7aNg8")), module.exports);

});
parcelRegister("7aNg8", function(module, exports) {
"use strict";
var $538fad693f8d9b42$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MetadataService = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $ckLEO = parcelRequire("ckLEO");
let $538fad693f8d9b42$var$MetadataService = class MetadataService {
    generateHashData(module, original) {
        const services = module.services || [];
        const imports = module.imports || [];
        const fillMetadata = (injectable)=>{
            if (injectable && injectable['provide']) return injectable['provide'];
            else if (injectable) {
                this.validateCustomInjectable(injectable, module, original);
                return {
                    moduleName: injectable['metadata']['moduleName'],
                    hash: injectable['metadata']['moduleHash']
                };
            }
        };
        return [
            [
                ...services.map((i)=>fillMetadata(i))
            ],
            [
                ...imports.map((i)=>fillMetadata(i))
            ]
        ];
    }
    validateCustomInjectableKeys(keys) {
    // keys.forEach(key => {
    //     console.log('TOVA NE E SHEGA', key);
    // });
    }
    validateCustomInjectable(injectable, module, original) {
        if (!injectable['metadata'] && !injectable['provide']) throw new Error(`
                ---- Wrong service ${JSON.stringify(injectable)} provided inside '${original.name}' ----
                @Module({
                    services: ${JSON.stringify([
            ...module.services.filter((i)=>!i['metadata']),
            ...module.services.filter((i)=>i && i['metadata'] && i['metadata']['moduleName']).map((i)=>i['metadata']['moduleName'])
        ])}
                })
                ${JSON.stringify(`${original}`, null, 2)}

                Hint: System recieved Object but it is not with appropriate format you must provide object with following parameters:

                YourObject: ${JSON.stringify(injectable)}

                Option 1. [YourClass]

                Option 2. [{provide: 'your-value', useClass: YourClass}]

                Option 3. [{provide: 'your-value', deps: [YourClass], useFactory: (test: YourClass) => {}}]

                Option 4. [{provide: 'your-value', useValue: 'your-value'}]
            `);
    }
    parseModuleTemplate(moduleName, generatedHashData, targetCurrentSymbol) {
        return `
            ---- @gapi module '${moduleName}' metadata----
            @Module({
                imports: ${JSON.stringify(generatedHashData[1], null, '\t')},
                services: ${JSON.stringify(generatedHashData[0], null, '\t')}
            })
            ${JSON.stringify(targetCurrentSymbol, null, 2)}
        `;
    }
    createUniqueHash(string) {
        return (0, $ckLEO.createUniqueHash)(string);
    }
};
module.exports.MetadataService = $538fad693f8d9b42$var$MetadataService;
module.exports.MetadataService = $538fad693f8d9b42$var$MetadataService = $538fad693f8d9b42$var$__decorate([
    (0, $8DS2b.Service)()
], $538fad693f8d9b42$var$MetadataService);

});
parcelRegister("ckLEO", function(module, exports) {
"use strict";
var $8fac5207483b2a7c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8fac5207483b2a7c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8fac5207483b2a7c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8fac5207483b2a7c$var$__exportStar((parcelRequire("7VYzf")), module.exports);

$8fac5207483b2a7c$var$__exportStar((parcelRequire("aZzCP")), module.exports);

$8fac5207483b2a7c$var$__exportStar((parcelRequire("lxoqV")), module.exports);

$8fac5207483b2a7c$var$__exportStar((parcelRequire("cl9dc")), module.exports); // export * from './testing';

});
parcelRegister("7VYzf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTestBed = module.exports.setup = module.exports.BootstrapFramework = module.exports.BootstrapPromisify = module.exports.Bootstrap = void 0;
parcelRequire("iWLGv");

var $4q6qh = parcelRequire("4q6qh");

var $hEVvo = parcelRequire("hEVvo");

var $5nyEo = parcelRequire("5nyEo");
(0, $5nyEo.exitHandlerInit)();
const $5c6cd6bd15fa557c$var$bootstrapService = $4q6qh.Container.get($hEVvo.BootstrapService);
const $5c6cd6bd15fa557c$var$Bootstrap = (app, config)=>$5c6cd6bd15fa557c$var$bootstrapService.start(app, config);
module.exports.Bootstrap = $5c6cd6bd15fa557c$var$Bootstrap;
const $5c6cd6bd15fa557c$var$BootstrapPromisify = (app, config)=>$5c6cd6bd15fa557c$var$bootstrapService.start(app, config).toPromise();
module.exports.BootstrapPromisify = $5c6cd6bd15fa557c$var$BootstrapPromisify;
const $5c6cd6bd15fa557c$var$BootstrapFramework = (app, modules, config)=>{
    $5c6cd6bd15fa557c$var$bootstrapService.configService.setConfig(config);
    modules.map((m)=>$4q6qh.Container.get(m));
    return $5c6cd6bd15fa557c$var$bootstrapService.start(app, config);
};
module.exports.BootstrapFramework = $5c6cd6bd15fa557c$var$BootstrapFramework;

const $5c6cd6bd15fa557c$var$setup = (options, frameworks = [], bootstrapOptions)=>{
    const Module = (parcelRequire("3eDkT")).Module;
    return (0, module.exports.BootstrapFramework)(Module({
        imports: options.imports || [],
        providers: options.providers || [],
        services: options.services || [],
        bootstrap: options.bootstrap || [],
        components: options.components || [],
        controllers: options.controllers || [],
        effects: options.effects || [],
        plugins: options.plugins || [],
        afterPlugins: options.afterPlugins || [],
        beforePlugins: options.beforePlugins || []
    })(function() {}), frameworks, bootstrapOptions);
};
module.exports.setup = $5c6cd6bd15fa557c$var$setup;
module.exports.createTestBed = module.exports.setup;

});
parcelRegister("hEVvo", function(module, exports) {
"use strict";
var $cdb2c776032e68a4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cdb2c776032e68a4$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $cdb2c776032e68a4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BootstrapService = void 0;

var $bj4Fa = parcelRequire("bj4Fa");
var $lBKT3 = parcelRequire("lBKT3");
var $8fifx = parcelRequire("8fifx");

var $4q6qh = parcelRequire("4q6qh");

var $3O0qi = parcelRequire("3O0qi");

var $8afYX = parcelRequire("8afYX");

var $cYPHp = parcelRequire("cYPHp");

var $a8du2 = parcelRequire("a8du2");

var $7s27r = parcelRequire("7s27r");

var $72AdI = parcelRequire("72AdI");

var $3XkaH = parcelRequire("3XkaH");
var $bzMF7 = parcelRequire("bzMF7");
var $iuXHq = parcelRequire("iuXHq");
var $hgiLQ = parcelRequire("hgiLQ");

var $jDZOm = parcelRequire("jDZOm");

var $cvmB8 = parcelRequire("cvmB8");

var $1yyJ0 = parcelRequire("1yyJ0");

var $d4ufv = parcelRequire("d4ufv");

var $5XSSl = parcelRequire("5XSSl");

var $8d4NV = parcelRequire("8d4NV");

var $3Jigk = parcelRequire("3Jigk");

var $8DS2b = parcelRequire("8DS2b");
let $cdb2c776032e68a4$var$BootstrapService = class BootstrapService {
    constructor(logger, cacheService, lazyFactoriesService, configService, controllersService, effectsService, pluginService, componentsService, bootstrapsService, servicesService, afterStarterService){
        this.logger = logger;
        this.cacheService = cacheService;
        this.lazyFactoriesService = lazyFactoriesService;
        this.configService = configService;
        this.controllersService = controllersService;
        this.effectsService = effectsService;
        this.pluginService = pluginService;
        this.componentsService = componentsService;
        this.bootstrapsService = bootstrapsService;
        this.servicesService = servicesService;
        this.afterStarterService = afterStarterService;
        this.globalConfig = this.cacheService.createLayer({
            name: $cYPHp.InternalLayers.globalConfig
        });
    }
    start(app, config) {
        this.configService.setConfig(config);
        this.globalConfig.putItem({
            key: $cYPHp.InternalEvents.config,
            data: config
        });
        $4q6qh.Container.get(app);
        const lazyFactoryKeys = Array.from(this.lazyFactoriesService.lazyFactories.keys());
        return (0, $8fifx.of)(lazyFactoryKeys).pipe((0, $3XkaH.map)((factories)=>this.prepareAsyncChainables(factories)), (0, $iuXHq.switchMap)((res)=>(0, $bj4Fa.combineLatest)(res).pipe((0, $hgiLQ.take)(1), (0, $3XkaH.map)((c)=>this.attachLazyLoadedChainables(lazyFactoryKeys, c)), (0, $3XkaH.map)(()=>this.validateSystem()), (0, $iuXHq.switchMap)(()=>(0, $bj4Fa.combineLatest)(this.asyncChainableControllers())), (0, $iuXHq.switchMap)(()=>(0, $bj4Fa.combineLatest)(this.asyncChainablePluginsBeforeRegister())), (0, $iuXHq.switchMap)(()=>(0, $bj4Fa.combineLatest)(this.asyncChainablePluginsRegister())), (0, $iuXHq.switchMap)(()=>(0, $bj4Fa.combineLatest)(this.asyncChainablePluginsAfterRegister())), (0, $iuXHq.switchMap)(()=>(0, $bj4Fa.combineLatest)(this.asyncChainableServices())), (0, $iuXHq.switchMap)(()=>(0, $bj4Fa.combineLatest)(this.asyncChainableEffects())), (0, $iuXHq.switchMap)(()=>(0, $bj4Fa.combineLatest)(this.asyncChainableComponents())), (0, $3XkaH.map)(()=>this.loadApplication()), (0, $iuXHq.switchMap)(()=>(0, $bj4Fa.combineLatest)(this.asyncChainableBootstraps())), (0, $3XkaH.map)(()=>this.final()))));
    }
    final() {
        this.afterStarterService.appStarted.next(true);
        if (!this.configService.config.init) this.logger.log('Bootstrap -> press start!');
        return $4q6qh.Container;
    }
    asyncChainableComponents() {
        return [
            (0, $8fifx.of)(true),
            ...this.componentsService.getComponents().filter((c)=>this.genericFilter(c, 'components')).map((c)=>$cdb2c776032e68a4$var$__awaiter(this, void 0, void 0, function*() {
                    return yield $4q6qh.Container.get(c);
                }))
        ];
    }
    asyncChainableBootstraps() {
        return [
            (0, $8fifx.of)(true),
            ...this.bootstrapsService.getBootstraps().map((c)=>$cdb2c776032e68a4$var$__awaiter(this, void 0, void 0, function*() {
                    return yield $4q6qh.Container.get(c);
                }))
        ];
    }
    asyncChainableEffects() {
        return [
            (0, $8fifx.of)(true),
            ...this.effectsService.getEffects().filter((c)=>this.genericFilter(c, 'effects')).map((c)=>$cdb2c776032e68a4$var$__awaiter(this, void 0, void 0, function*() {
                    return yield $4q6qh.Container.get(c);
                }))
        ];
    }
    asyncChainableServices() {
        return [
            (0, $8fifx.of)(true),
            ...this.servicesService.getServices().filter((c)=>this.genericFilter(c, 'services')).map((c)=>$cdb2c776032e68a4$var$__awaiter(this, void 0, void 0, function*() {
                    return yield $4q6qh.Container.get(c);
                }))
        ];
    }
    asyncChainableControllers() {
        return [
            (0, $8fifx.of)(true),
            ...this.controllersService.getControllers().filter((c)=>this.genericFilter(c, 'controllers')).map((c)=>$cdb2c776032e68a4$var$__awaiter(this, void 0, void 0, function*() {
                    return yield $4q6qh.Container.get(c);
                }))
        ];
    }
    asyncChainablePluginsRegister() {
        return [
            (0, $8fifx.of)(true),
            ...this.pluginService.getPlugins().filter((c)=>this.genericFilter(c, 'plugins')).map((c)=>$cdb2c776032e68a4$var$__awaiter(this, void 0, void 0, function*() {
                    return yield this.registerPlugin(c);
                }))
        ];
    }
    asyncChainablePluginsAfterRegister() {
        return [
            (0, $8fifx.of)(true),
            ...this.pluginService.getAfterPlugins().filter((c)=>this.genericFilter(c, 'pluginsAfter')).map((c)=>$cdb2c776032e68a4$var$__awaiter(this, void 0, void 0, function*() {
                    return yield this.registerPlugin(c);
                }))
        ];
    }
    asyncChainablePluginsBeforeRegister() {
        return [
            (0, $8fifx.of)(true),
            ...this.pluginService.getBeforePlugins().filter((c)=>this.genericFilter(c, 'pluginsBefore')).map((c)=>$cdb2c776032e68a4$var$__awaiter(this, void 0, void 0, function*() {
                    return yield this.registerPlugin(c);
                }))
        ];
    }
    genericFilter(c, name) {
        return this.configService.config.initOptions[name] || c.metadata.options && c.metadata.options['init'] || this.configService.config.init;
    }
    registerPlugin(pluggable) {
        return $cdb2c776032e68a4$var$__awaiter(this, void 0, void 0, function*() {
            const plugin = $4q6qh.Container.get(pluggable);
            if (typeof (plugin === null || plugin === void 0 ? void 0 : plugin.register) === 'function') yield plugin.register();
            return plugin;
        });
    }
    prepareAsyncChainables(injectables) {
        const asynChainables = [
            (0, $8fifx.of)(true)
        ];
        const injectableLog = {};
        const getName = (n)=>n.name || n;
        injectables.map((i)=>{
            const date = Date.now();
            injectableLog[getName(i)] = {
                started: date,
                end: null
            };
            this.logger.log(`Bootstrap -> @Service('${getName(i)}'): loading...`);
            const somethingAsync = (0, $lBKT3.from)(this.lazyFactoriesService.getLazyFactory(i)).pipe((0, $bzMF7.shareReplay)(1));
            asynChainables.push(somethingAsync);
            somethingAsync.subscribe(()=>{
                this.logger.log(`Bootstrap -> @Service('${getName(i)}'): loading finished after ${Date.now() - injectableLog[getName(i)].started}ms !`);
                delete injectableLog[getName(i)];
            });
        });
        return asynChainables;
    }
    validateSystem() {
        if (this.configService.config.strict) this.cacheService.searchForDuplicateDependenciesInsideApp();
    }
    attachLazyLoadedChainables(res, chainables) {
        // Remove first chainable unused observable
        chainables.splice(0, 1);
        let count = 0;
        res.map((name)=>{
            (0, $3Jigk.logExtendedInjectables)(name, this.configService.config.experimental.logExtendedInjectables);
            $4q6qh.Container.set(name, chainables[count++]);
        });
        return true;
    }
    loadApplication() {
        Array.from(this.cacheService.getLayer($cYPHp.InternalLayers.modules).map.keys()).forEach((m)=>this.cacheService.getLayer(m).putItem({
                key: $cYPHp.InternalEvents.load,
                data: this.configService.config.init
            }));
        return true;
    }
};
module.exports.BootstrapService = $cdb2c776032e68a4$var$BootstrapService;
module.exports.BootstrapService = $cdb2c776032e68a4$var$BootstrapService = $cdb2c776032e68a4$var$__decorate([
    (0, $8DS2b.Service)(),
    $cdb2c776032e68a4$var$__metadata("design:paramtypes", [
        $3O0qi.BootstrapLogger,
        $8afYX.CacheService,
        $a8du2.LazyFactory,
        $7s27r.ConfigService,
        $cvmB8.ControllersService,
        $jDZOm.EffectsService,
        $72AdI.PluginService,
        $1yyJ0.ComponentsService,
        $d4ufv.BootstrapsServices,
        $5XSSl.ServicesService,
        $8d4NV.AfterStarterService
    ])
], $cdb2c776032e68a4$var$BootstrapService);

});
parcelRegister("bj4Fa", function(module, exports) {

$parcel$export(module.exports, "combineLatest", () => $83b5160682579f04$export$77fa7d86f5204e8a);
$parcel$export(module.exports, "combineLatestInit", () => $83b5160682579f04$export$f04dcfb475ed2128);

var $82Kdl = parcelRequire("82Kdl");

var $f0CF8 = parcelRequire("f0CF8");

var $lBKT3 = parcelRequire("lBKT3");

var $4YhJE = parcelRequire("4YhJE");

var $d05JU = parcelRequire("d05JU");

var $3jBRy = parcelRequire("3jBRy");

var $10BdF = parcelRequire("10BdF");

var $fyrlr = parcelRequire("fyrlr");

var $6X9r0 = parcelRequire("6X9r0");
function $83b5160682579f04$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3jBRy.popScheduler)(args);
    var resultSelector = (0, $3jBRy.popResultSelector)(args);
    var _a = (0, $f0CF8.argsArgArrayOrObject)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, $lBKT3.from)([], scheduler);
    var result = new (0, $82Kdl.Observable)($83b5160682579f04$export$f04dcfb475ed2128(observables, scheduler, keys ? function(values) {
        return (0, $10BdF.createObject)(keys, values);
    } : (0, $4YhJE.identity)));
    return resultSelector ? result.pipe((0, $d05JU.mapOneOrManyArgs)(resultSelector)) : result;
}
function $83b5160682579f04$export$f04dcfb475ed2128(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, $4YhJE.identity);
    return function(subscriber) {
        $83b5160682579f04$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $83b5160682579f04$var$maybeSchedule(scheduler, function() {
                    var source = (0, $lBKT3.from)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function $83b5160682579f04$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, $6X9r0.executeSchedule)(subscription, scheduler, execute);
    else execute();
}

});
parcelRegister("f0CF8", function(module, exports) {

$parcel$export(module.exports, "argsArgArrayOrObject", () => $aed4d8ab93434122$export$8871b3799a14360f);
var $aed4d8ab93434122$var$isArray = Array.isArray;
var $aed4d8ab93434122$var$getPrototypeOf = Object.getPrototypeOf, $aed4d8ab93434122$var$objectProto = Object.prototype, $aed4d8ab93434122$var$getKeys = Object.keys;
function $aed4d8ab93434122$export$8871b3799a14360f(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($aed4d8ab93434122$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($aed4d8ab93434122$var$isPOJO(first_1)) {
            var keys = $aed4d8ab93434122$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function $aed4d8ab93434122$var$isPOJO(obj) {
    return obj && typeof obj === 'object' && $aed4d8ab93434122$var$getPrototypeOf(obj) === $aed4d8ab93434122$var$objectProto;
}

});

parcelRegister("d05JU", function(module, exports) {

$parcel$export(module.exports, "mapOneOrManyArgs", () => $976fba30861c641f$export$559affaa48f4288d);

var $cAivK = parcelRequire("cAivK");

var $3XkaH = parcelRequire("3XkaH");
var $976fba30861c641f$var$isArray = Array.isArray;
function $976fba30861c641f$var$callOrApply(fn, args) {
    return $976fba30861c641f$var$isArray(args) ? fn.apply(void 0, (0, $cAivK.__spreadArray)([], (0, $cAivK.__read)(args))) : fn(args);
}
function $976fba30861c641f$export$559affaa48f4288d(fn) {
    return (0, $3XkaH.map)(function(args) {
        return $976fba30861c641f$var$callOrApply(fn, args);
    });
}

});

parcelRegister("10BdF", function(module, exports) {

$parcel$export(module.exports, "createObject", () => $0bc2a9837c3de6d8$export$79c7e160a7743efd);
function $0bc2a9837c3de6d8$export$79c7e160a7743efd(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}

});


parcelRegister("bzMF7", function(module, exports) {

$parcel$export(module.exports, "shareReplay", () => $86d8b5e69242ccfc$export$db61d692014e534e);

var $5rqBH = parcelRequire("5rqBH");

var $2ulLq = parcelRequire("2ulLq");
function $86d8b5e69242ccfc$export$db61d692014e534e(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, $2ulLq.share)({
        connector: function() {
            return new (0, $5rqBH.ReplaySubject)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}

});
parcelRegister("5rqBH", function(module, exports) {

$parcel$export(module.exports, "ReplaySubject", () => $3f641cfd5a06ade6$export$915d2682b0aa0991);

var $cAivK = parcelRequire("cAivK");

var $35ZUd = parcelRequire("35ZUd");

var $5Mtdz = parcelRequire("5Mtdz");
var $3f641cfd5a06ade6$export$915d2682b0aa0991 = function(_super) {
    (0, $cAivK.__extends)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $5Mtdz.dateTimestampProvider);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $35ZUd.Subject));

});

parcelRegister("2ulLq", function(module, exports) {

$parcel$export(module.exports, "share", () => $1cff43ff7b380ea2$export$ed80d9de1d9df928);

var $cAivK = parcelRequire("cAivK");

var $9IWtL = parcelRequire("9IWtL");

var $35ZUd = parcelRequire("35ZUd");

var $ehgY6 = parcelRequire("ehgY6");

var $4J4s9 = parcelRequire("4J4s9");
function $1cff43ff7b380ea2$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $35ZUd.Subject)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $4J4s9.operate)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $1cff43ff7b380ea2$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $ehgY6.SafeSubscriber)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $1cff43ff7b380ea2$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $1cff43ff7b380ea2$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $9IWtL.innerFrom)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $1cff43ff7b380ea2$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $ehgY6.SafeSubscriber)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $9IWtL.innerFrom)(on.apply(void 0, (0, $cAivK.__spreadArray)([], (0, $cAivK.__read)(args)))).subscribe(onSubscriber);
}

});


parcelRegister("8d4NV", function(module, exports) {
"use strict";
var $5fa343a908a6c35e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AfterStarterService = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $35ZUd = parcelRequire("35ZUd");
let $5fa343a908a6c35e$var$AfterStarterService = class AfterStarterService {
    constructor(){
        this.appStarted = new $35ZUd.Subject();
    }
};
module.exports.AfterStarterService = $5fa343a908a6c35e$var$AfterStarterService;
module.exports.AfterStarterService = $5fa343a908a6c35e$var$AfterStarterService = $5fa343a908a6c35e$var$__decorate([
    (0, $8DS2b.Service)()
], $5fa343a908a6c35e$var$AfterStarterService);

});

parcelRegister("3Jigk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logExtendedInjectables = void 0;

var $9m0Ub = parcelRequire("9m0Ub");
const $2b73bd93eb2ee409$var$logExtendedInjectables = (name, logExtendedInjectables)=>{
    if ($9m0Ub.Container.has(name) && logExtendedInjectables) console.log(`Warn: Injection Token '${name.name || name}' is extended after it has being declared! ${JSON.stringify($9m0Ub.Container.get(name))}`);
};
module.exports.logExtendedInjectables = $2b73bd93eb2ee409$var$logExtendedInjectables;

});


parcelRegister("5nyEo", function(module, exports) {

var $ioBC3 = parcelRequire("ioBC3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exitHandlerInit = void 0;

var $e40eu = parcelRequire("e40eu");

var $4q6qh = parcelRequire("4q6qh");
const $3ea9fa9a0b4c8ac9$var$exitHandlerInit = ()=>{
    const handler = $4q6qh.Container.get($e40eu.ExitHandlerService);
    handler.init();
    // do something when app is closing
    $ioBC3.on('exit', handler.exitHandler.bind(handler, {
        cleanup: true
    }));
    // catches ctrl+c event
    $ioBC3.on('SIGINT', handler.exitHandler.bind(handler, {
        exit: true
    }));
    // catches 'kill pid' (for example: nodemon restart)
    $ioBC3.on('SIGUSR1', handler.exitHandler.bind(handler, {
        exit: true
    }));
    $ioBC3.on('SIGUSR2', handler.exitHandler.bind(handler, {
        exit: true
    }));
    // catches uncaught exceptions
    $ioBC3.on('uncaughtException', handler.exitHandler.bind(handler, {
        exit: true
    }));
};
module.exports.exitHandlerInit = $3ea9fa9a0b4c8ac9$var$exitHandlerInit;

});





parcelRegister("dvi7U", function(module, exports) {
"use strict";
var $9d4c3b29b1e7a5f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9d4c3b29b1e7a5f0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9d4c3b29b1e7a5f0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9d4c3b29b1e7a5f0$var$__exportStar((parcelRequire("jtzIb")), module.exports);

});
parcelRegister("jtzIb", function(module, exports) {
"use strict";
var $e2dc6d5776aa36d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e2dc6d5776aa36d6$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompressionService = void 0;

var $8DS2b = parcelRequire("8DS2b");

var $fyRWr = parcelRequire("fyRWr");

var $8migr = parcelRequire("8migr");
let $e2dc6d5776aa36d6$var$CompressionService = class CompressionService {
    // public gZipFile(input: string, output: string, options: PrivateCryptoModel = { cyperIv: '', algorithm: '', cyperKey: '' }) {
    //     const config = this.config.config.experimental.crypto || options;
    //     return Observable.create(observer => {
    //         createReadStream(input)
    //             .pipe(createGzip())
    //             // .pipe(createCipheriv(config.algorithm, config.cyperKey, config.cyperIv))
    //             .pipe(createWriteStream(output))
    //             .on('finish', () => observer.next(true))
    //             .on('error', (err) => observer.error(err));
    //     });
    // }
    // public readGzipFile(input: string, output: string, options: PrivateCryptoModel = { cyperIv: '', algorithm: '', cyperKey: '' }) {
    //     const config = this.config.config.experimental.crypto || options;
    //     return Observable.create(observer => {
    //         createReadStream(input)
    //             // .pipe(createDecipheriv(config.algorithm, config.cyperKey, config.cyperIv))
    //             .pipe(createGunzip())
    //             .pipe(createWriteStream(output))
    //             .on('finish', () => observer.next(true))
    //             .on('error', (err) => observer.error(err));
    //     });
    // }
    gZipAll() {
    // var archiver = require('archiver');
    // var output = createWriteStream('./example.tar.gz');
    // var archive = archiver('tar', {
    //     gzip: true,
    //     zlib: { level: 9 } // Sets the compression level.
    // });
    // archive.on('error', function (err) {
    //     throw err;
    // });
    // // pipe archive data to the output file
    // archive.pipe(output);
    // // append files
    // archive.file('/path/to/file0.txt', { name: 'file0-or-change-this-whatever.txt' });
    // archive.file('/path/to/README.md', { name: 'foobar.md' });
    // // Wait for streams to complete
    // archive.finalize();
    }
};
module.exports.CompressionService = $e2dc6d5776aa36d6$var$CompressionService;
$e2dc6d5776aa36d6$var$__decorate([
    (0, $fyRWr.Injector)($8migr.ConfigService),
    $e2dc6d5776aa36d6$var$__metadata("design:type", $8migr.ConfigService)
], $e2dc6d5776aa36d6$var$CompressionService.prototype, "config", void 0);
module.exports.CompressionService = $e2dc6d5776aa36d6$var$CompressionService = $e2dc6d5776aa36d6$var$__decorate([
    (0, $8DS2b.Service)()
], $e2dc6d5776aa36d6$var$CompressionService);

});


parcelRegister("6sEU4", function(module, exports) {
"use strict";
var $4b45162cb615c33a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4b45162cb615c33a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4b45162cb615c33a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4b45162cb615c33a$var$__exportStar((parcelRequire("jDZOm")), module.exports);

});

parcelRegister("eQPWm", function(module, exports) {
"use strict";
var $acfe364543143556$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $acfe364543143556$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $acfe364543143556$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$acfe364543143556$var$__exportStar((parcelRequire("cvmB8")), module.exports);

});

parcelRegister("2C6Os", function(module, exports) {
"use strict";
var $1e746a45602a11c9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1e746a45602a11c9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1e746a45602a11c9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1e746a45602a11c9$var$__exportStar((parcelRequire("1yyJ0")), module.exports);

});

parcelRegister("dnIrd", function(module, exports) {
"use strict";
var $9bdfe4cb1b795cf0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9bdfe4cb1b795cf0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9bdfe4cb1b795cf0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9bdfe4cb1b795cf0$var$__exportStar((parcelRequire("d4ufv")), module.exports);

});

parcelRegister("dC70L", function(module, exports) {
"use strict";
var $9e9443417a22e17c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9e9443417a22e17c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9e9443417a22e17c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9e9443417a22e17c$var$__exportStar((parcelRequire("5XSSl")), module.exports);

});

parcelRegister("gEWm7", function(module, exports) {
"use strict";
var $c20da5fc703f8964$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c20da5fc703f8964$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PluginManager = void 0;

var $72AdI = parcelRequire("72AdI");

var $8DS2b = parcelRequire("8DS2b");
let $c20da5fc703f8964$var$PluginManager = class PluginManager {
    constructor(pluginService){
        this.pluginService = pluginService;
    }
    listPlugins() {
        return this.pluginService.getPlugins();
    }
    getPlugin(pluginClass) {
        return this.pluginService.getPlugins().filter((p)=>p.name === pluginClass.name)[0];
    }
};
module.exports.PluginManager = $c20da5fc703f8964$var$PluginManager;
module.exports.PluginManager = $c20da5fc703f8964$var$PluginManager = $c20da5fc703f8964$var$__decorate([
    (0, $8DS2b.Service)(),
    $c20da5fc703f8964$var$__metadata("design:paramtypes", [
        $72AdI.PluginService
    ])
], $c20da5fc703f8964$var$PluginManager);

});




parcelRegister("123g4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("4Ko5i", function(module, exports) {
"use strict";
var $374e23f6df409fbe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $374e23f6df409fbe$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $374e23f6df409fbe$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$374e23f6df409fbe$var$__exportStar((parcelRequire("fyRWr")), module.exports);

});

parcelRegister("3lzEJ", function(module, exports) {
"use strict";
var $26fefdcbf4a3c328$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $26fefdcbf4a3c328$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $26fefdcbf4a3c328$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$26fefdcbf4a3c328$var$__exportStar((parcelRequire("9Y8LN")), module.exports);

});
parcelRegister("9Y8LN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InjectSoft = $7420852e7383a67d$var$InjectSoft;

var $4q6qh = parcelRequire("4q6qh");

var $axVJe = parcelRequire("axVJe");
function $7420852e7383a67d$var$InjectSoft(Service) {
    return $4q6qh.Container.get($axVJe.ModuleService).watcherService.getByClass(Service);
}

});


parcelRegister("99uf8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Inject = $6a9c69f6c89164ba$var$Inject;

var $9m0Ub = parcelRequire("9m0Ub");

var $6YGMG = parcelRequire("6YGMG");
/**
 * Injects a service into a class property or constructor parameter.
 */ function $6a9c69f6c89164ba$var$Inject(typeOrName) {
    return function(target, propertyName, index) {
        if ((0, $6YGMG.isClient)() && typeOrName && typeof typeOrName === 'function') {
            Object.defineProperty(target, propertyName, {
                get: ()=>$9m0Ub.Container.get(typeOrName)
            });
            return;
        }
        if (!typeOrName) typeOrName = ()=>Reflect.getMetadata('design:type', target, propertyName);
        $9m0Ub.Container.registerHandler({
            object: target,
            propertyName: propertyName,
            index: index,
            value: (instance)=>instance.get((0, $6YGMG.getIdentifier)(typeOrName, target, propertyName))
        });
    };
}

});
parcelRegister("6YGMG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClient = module.exports.getIdentifier = void 0;

var $7OIQ0 = parcelRequire("7OIQ0");

var $5kVAG = parcelRequire("5kVAG");
const $514988b6834d472e$var$getIdentifier = (typeOrName, target, propertyName)=>{
    let identifier;
    if (typeof typeOrName === 'string') identifier = typeOrName;
    else if (typeOrName instanceof $7OIQ0.Token) identifier = typeOrName;
    else identifier = typeOrName();
    if (identifier === Object) throw new $5kVAG.CannotInjectError(target, propertyName);
    return identifier;
};
module.exports.getIdentifier = $514988b6834d472e$var$getIdentifier;
const $514988b6834d472e$var$isClient = ()=>typeof window !== 'undefined' && typeof window.document !== 'undefined';
module.exports.isClient = $514988b6834d472e$var$isClient;

});
parcelRegister("5kVAG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CannotInjectError = void 0;
/**
 * Thrown when DI cannot inject value into property decorated by @Inject decorator.
 */ class $3e2b7e4f52fc4b2d$var$CannotInjectError extends Error {
    constructor(target, propertyName){
        super(`Cannot inject value into '${target.constructor.name}.${propertyName}'. ` + `Please make sure you setup @abraham/reflection properly and you don't use interfaces without service tokens as injection value.`);
        this.name = 'ServiceNotFoundError';
        Object.setPrototypeOf(this, $3e2b7e4f52fc4b2d$var$CannotInjectError.prototype);
    }
}
module.exports.CannotInjectError = $3e2b7e4f52fc4b2d$var$CannotInjectError;

});



parcelRegister("kW0nR", function(module, exports) {
"use strict";
var $f3d985a767287327$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f3d985a767287327$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f3d985a767287327$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f3d985a767287327$var$__exportStar((parcelRequire("3vGl2")), module.exports);

});
parcelRegister("3vGl2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Controller = $28e51bd99d2e07fb$var$Controller;

var $9je1N = parcelRequire("9je1N");
function $28e51bd99d2e07fb$var$Controller(options) {
    return (0, $9je1N.ReflectDecorator)(options, {
        type: 'controller'
    });
}

});


parcelRegister("iZGkn", function(module, exports) {
"use strict";
var $dd3ec1e7d87d1d05$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dd3ec1e7d87d1d05$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dd3ec1e7d87d1d05$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dd3ec1e7d87d1d05$var$__exportStar((parcelRequire("7QLKX")), module.exports);

});
parcelRegister("7QLKX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Effect = $5b726f2e177823f3$var$Effect;

var $9je1N = parcelRequire("9je1N");
function $5b726f2e177823f3$var$Effect(options) {
    return (0, $9je1N.ReflectDecorator)(options, {
        type: 'effect'
    });
}

});


parcelRegister("lH46f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Plugin = $fcb0cb3c500da5b5$var$Plugin;

var $9je1N = parcelRequire("9je1N");
function $fcb0cb3c500da5b5$var$Plugin(options) {
    return (0, $9je1N.ReflectDecorator)(options, {
        type: 'plugin'
    });
}

});

parcelRegister("j6E3l", function(module, exports) {
"use strict";
var $de8da58d6ac922a4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $de8da58d6ac922a4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $de8da58d6ac922a4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$de8da58d6ac922a4$var$__exportStar((parcelRequire("fC5oY")), module.exports);

});
parcelRegister("fC5oY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Component = $b5de9853b0b87067$var$Component;

var $9je1N = parcelRequire("9je1N");
function $b5de9853b0b87067$var$Component(options) {
    return (0, $9je1N.ReflectDecorator)(options, {
        type: 'component'
    });
}

});


parcelRegister("kMdeS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InjectMany = $f2028f58cfedab01$var$InjectMany;

var $9m0Ub = parcelRequire("9m0Ub");

var $7OIQ0 = parcelRequire("7OIQ0");

var $6YGMG = parcelRequire("6YGMG");
/**
 * Injects a service into a class property or constructor parameter.
 */ function $f2028f58cfedab01$var$InjectMany(typeOrName) {
    return function(target, propertyName, index) {
        if ((0, $6YGMG.isClient)() && typeOrName instanceof $7OIQ0.Token) {
            Object.defineProperty(target, propertyName, {
                get: ()=>$9m0Ub.Container.getMany((0, $6YGMG.getIdentifier)(typeOrName, target, propertyName))
            });
            return;
        }
        if (!typeOrName) typeOrName = ()=>Reflect.getMetadata('design:type', target, propertyName);
        $9m0Ub.Container.registerHandler({
            object: target,
            propertyName: propertyName,
            index: index,
            value: (instance)=>instance.getMany((0, $6YGMG.getIdentifier)(typeOrName, target, propertyName))
        });
    };
}

});




parcelRegister("cRdul", function(module, exports) {

$parcel$export(module.exports, "SocialModule", () => $4b82269c1e7bac86$export$a160666a9a51eeb5);
// Add the Firebase services that you want to use

var $g0n63 = parcelRequire("g0n63");
parcelRequire("2V0Bo");

var $4XQlz = parcelRequire("4XQlz");

var $aXvn5 = parcelRequire("aXvn5");

var $hvId1 = parcelRequire("hvId1");

var $2cx1H = parcelRequire("2cx1H");
class $4b82269c1e7bac86$export$a160666a9a51eeb5 {
    static forRoot(config) {
        try {
            $aXvn5.initializeApp(config);
        } catch (e) {
            console.error(e);
        }
        return {
            module: $4b82269c1e7bac86$export$a160666a9a51eeb5
        };
    }
}
$4b82269c1e7bac86$export$a160666a9a51eeb5 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Module)({
        components: [
            (0, $hvId1.SocialLoginButtonComponent)
        ],
        providers: [
            (0, $2cx1H.SocialService)
        ]
    })
], $4b82269c1e7bac86$export$a160666a9a51eeb5);

});
parcelRegister("g0n63", function(module, exports) {

$parcel$export(module.exports, "__decorate", () => $ba6e8feba93441fd$export$29e00dfd3077644b);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $ba6e8feba93441fd$var$extendStatics = function(d, b) {
    $ba6e8feba93441fd$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ba6e8feba93441fd$var$extendStatics(d, b);
};
function $ba6e8feba93441fd$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ba6e8feba93441fd$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ba6e8feba93441fd$export$18ce0697a983be9b = function() {
    $ba6e8feba93441fd$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ba6e8feba93441fd$export$18ce0697a983be9b.apply(this, arguments);
};
function $ba6e8feba93441fd$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ba6e8feba93441fd$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ba6e8feba93441fd$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ba6e8feba93441fd$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $ba6e8feba93441fd$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $ba6e8feba93441fd$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $ba6e8feba93441fd$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $ba6e8feba93441fd$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ba6e8feba93441fd$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ba6e8feba93441fd$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $ba6e8feba93441fd$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $ba6e8feba93441fd$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $ba6e8feba93441fd$export$45d3717a4c69092e(o, m, p);
}
function $ba6e8feba93441fd$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ba6e8feba93441fd$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ba6e8feba93441fd$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ba6e8feba93441fd$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ba6e8feba93441fd$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ba6e8feba93441fd$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $ba6e8feba93441fd$export$10c90e4f7922046c(v) {
    return this instanceof $ba6e8feba93441fd$export$10c90e4f7922046c ? (this.v = v, this) : new $ba6e8feba93441fd$export$10c90e4f7922046c(v);
}
function $ba6e8feba93441fd$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ba6e8feba93441fd$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ba6e8feba93441fd$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ba6e8feba93441fd$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $ba6e8feba93441fd$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ba6e8feba93441fd$export$19a8beecd37a4c45 === "function" ? $ba6e8feba93441fd$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ba6e8feba93441fd$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $ba6e8feba93441fd$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $ba6e8feba93441fd$var$ownKeys = function(o) {
    $ba6e8feba93441fd$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $ba6e8feba93441fd$var$ownKeys(o);
};
function $ba6e8feba93441fd$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $ba6e8feba93441fd$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $ba6e8feba93441fd$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $ba6e8feba93441fd$var$__setModuleDefault(result, mod);
    return result;
}
function $ba6e8feba93441fd$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ba6e8feba93441fd$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $ba6e8feba93441fd$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $ba6e8feba93441fd$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $ba6e8feba93441fd$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $ba6e8feba93441fd$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $ba6e8feba93441fd$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $ba6e8feba93441fd$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $ba6e8feba93441fd$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $ba6e8feba93441fd$export$2e2bcd8739ae039 = {
    __extends: $ba6e8feba93441fd$export$a8ba968b8961cb8a,
    __assign: $ba6e8feba93441fd$export$18ce0697a983be9b,
    __rest: $ba6e8feba93441fd$export$3c9a16f847548506,
    __decorate: $ba6e8feba93441fd$export$29e00dfd3077644b,
    __param: $ba6e8feba93441fd$export$d5ad3fd78186038f,
    __esDecorate: $ba6e8feba93441fd$export$3a84e1ae4e97e9b0,
    __runInitializers: $ba6e8feba93441fd$export$d831c04e792af3d,
    __propKey: $ba6e8feba93441fd$export$6a2a36740a146cb8,
    __setFunctionName: $ba6e8feba93441fd$export$d1a06452d3489bc7,
    __metadata: $ba6e8feba93441fd$export$f1db080c865becb9,
    __awaiter: $ba6e8feba93441fd$export$1050f835b63b671e,
    __generator: $ba6e8feba93441fd$export$67ebef60e6f28a6,
    __createBinding: $ba6e8feba93441fd$export$45d3717a4c69092e,
    __exportStar: $ba6e8feba93441fd$export$f33643c0debef087,
    __values: $ba6e8feba93441fd$export$19a8beecd37a4c45,
    __read: $ba6e8feba93441fd$export$8d051b38c9118094,
    __spread: $ba6e8feba93441fd$export$afc72e2116322959,
    __spreadArrays: $ba6e8feba93441fd$export$6388937ca91ccae8,
    __spreadArray: $ba6e8feba93441fd$export$1216008129fb82ed,
    __await: $ba6e8feba93441fd$export$10c90e4f7922046c,
    __asyncGenerator: $ba6e8feba93441fd$export$e427f37a30a4de9b,
    __asyncDelegator: $ba6e8feba93441fd$export$bbd80228419bb833,
    __asyncValues: $ba6e8feba93441fd$export$e3b29a3d6162315f,
    __makeTemplateObject: $ba6e8feba93441fd$export$4fb47efe1390b86f,
    __importStar: $ba6e8feba93441fd$export$c21735bcef00d192,
    __importDefault: $ba6e8feba93441fd$export$da59b14a69baef04,
    __classPrivateFieldGet: $ba6e8feba93441fd$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $ba6e8feba93441fd$export$d40a35129aaff81f,
    __classPrivateFieldIn: $ba6e8feba93441fd$export$81fdc39f203e4e04,
    __addDisposableResource: $ba6e8feba93441fd$export$88ac25d8e944e405,
    __disposeResources: $ba6e8feba93441fd$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $ba6e8feba93441fd$export$889dfb5d17574b0b
};

});

parcelRegister("2V0Bo", function(module, exports) {
parcelRequire("eVLsv");

});
parcelRegister("eVLsv", function(module, exports) {

var $cFTls = parcelRequire("cFTls");
(function() {
    var k, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        a != Array.prototype && a != Object.prototype && (a[b] = c.value);
    };
    function ba(a) {
        a = [
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global,
            a
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        return globalThis;
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                e in c || (c[e] = {});
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a) {
        var b = 0;
        return function() {
            return b < a.length ? {
                done: !1,
                value: a[b++]
            } : {
                done: !0
            };
        };
    }
    function fa(a) {
        var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
        return b ? b.call(a) : {
            next: ea(a)
        };
    }
    da("Promise", function(a) {
        function b(g) {
            this.b = 0;
            this.c = void 0;
            this.a = [];
            var h = this.f();
            try {
                g(h.resolve, h.reject);
            } catch (m) {
                h.reject(m);
            }
        }
        function c() {
            this.a = null;
        }
        function d(g) {
            return g instanceof b ? g : new b(function(h) {
                h(g);
            });
        }
        if (a) return a;
        c.prototype.b = function(g) {
            if (null == this.a) {
                this.a = [];
                var h = this;
                this.c(function() {
                    h.g();
                });
            }
            this.a.push(g);
        };
        var e = ca.setTimeout;
        c.prototype.c = function(g) {
            e(g, 0);
        };
        c.prototype.g = function() {
            for(; this.a && this.a.length;){
                var g = this.a;
                this.a = [];
                for(var h = 0; h < g.length; ++h){
                    var m = g[h];
                    g[h] = null;
                    try {
                        m();
                    } catch (p) {
                        this.f(p);
                    }
                }
            }
            this.a = null;
        };
        c.prototype.f = function(g) {
            this.c(function() {
                throw g;
            });
        };
        b.prototype.f = function() {
            function g(p) {
                return function(v) {
                    m || (m = !0, p.call(h, v));
                };
            }
            var h = this, m = !1;
            return {
                resolve: g(this.m),
                reject: g(this.g)
            };
        };
        b.prototype.m = function(g) {
            if (g === this) this.g(new TypeError("A Promise cannot resolve to itself"));
            else if (g instanceof b) this.s(g);
            else {
                a: switch(typeof g){
                    case "object":
                        var h = null != g;
                        break a;
                    case "function":
                        h = !0;
                        break a;
                    default:
                        h = !1;
                }
                h ? this.u(g) : this.h(g);
            }
        };
        b.prototype.u = function(g) {
            var h = void 0;
            try {
                h = g.then;
            } catch (m) {
                this.g(m);
                return;
            }
            "function" == typeof h ? this.w(h, g) : this.h(g);
        };
        b.prototype.g = function(g) {
            this.i(2, g);
        };
        b.prototype.h = function(g) {
            this.i(1, g);
        };
        b.prototype.i = function(g, h) {
            if (0 != this.b) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.b);
            this.b = g;
            this.c = h;
            this.l();
        };
        b.prototype.l = function() {
            if (null != this.a) {
                for(var g = 0; g < this.a.length; ++g)f.b(this.a[g]);
                this.a = null;
            }
        };
        var f = new c;
        b.prototype.s = function(g) {
            var h = this.f();
            g.Oa(h.resolve, h.reject);
        };
        b.prototype.w = function(g, h) {
            var m = this.f();
            try {
                g.call(h, m.resolve, m.reject);
            } catch (p) {
                m.reject(p);
            }
        };
        b.prototype.then = function(g, h) {
            function m(A, Q) {
                return "function" == typeof A ? function(xa) {
                    try {
                        p(A(xa));
                    } catch (ud) {
                        v(ud);
                    }
                } : Q;
            }
            var p, v, C = new b(function(A, Q) {
                p = A;
                v = Q;
            });
            this.Oa(m(g, p), m(h, v));
            return C;
        };
        b.prototype.catch = function(g) {
            return this.then(void 0, g);
        };
        b.prototype.Oa = function(g, h) {
            function m() {
                switch(p.b){
                    case 1:
                        g(p.c);
                        break;
                    case 2:
                        h(p.c);
                        break;
                    default:
                        throw Error("Unexpected state: " + p.b);
                }
            }
            var p = this;
            null == this.a ? f.b(m) : this.a.push(m);
        };
        b.resolve = d;
        b.reject = function(g) {
            return new b(function(h, m) {
                m(g);
            });
        };
        b.race = function(g) {
            return new b(function(h, m) {
                for(var p = fa(g), v = p.next(); !v.done; v = p.next())d(v.value).Oa(h, m);
            });
        };
        b.all = function(g) {
            var h = fa(g), m = h.next();
            return m.done ? d([]) : new b(function(p, v) {
                function C(xa) {
                    return function(ud) {
                        A[xa] = ud;
                        Q--;
                        0 == Q && p(A);
                    };
                }
                var A = [], Q = 0;
                do A.push(void 0), Q++, d(m.value).Oa(C(A.length - 1), v), m = h.next();
                while (!m.done);
            });
        };
        return b;
    });
    var ha = ha || {}, l = this || self, ia = /^[\w+/_-]+[=]{0,2}$/, ja = null;
    function ka() {}
    function la(a) {
        var b = typeof a;
        if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";
                if (a instanceof Object) return b;
                var c = Object.prototype.toString.call(a);
                if ("[object Window]" == c) return "object";
                if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
                if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";
        return b;
    }
    function ma(a) {
        var b = la(a);
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function n(a) {
        return "function" == la(a);
    }
    function q(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function na(a) {
        return Object.prototype.hasOwnProperty.call(a, oa) && a[oa] || (a[oa] = ++pa);
    }
    var oa = "closure_uid_" + (1E9 * Math.random() >>> 0), pa = 0;
    function qa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ra(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function r(a, b, c) {
        Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? r = qa : r = ra;
        return r.apply(null, arguments);
    }
    function sa(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    var ta = Date.now || function() {
        return +new Date;
    };
    function t(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.Za = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
    }
    function u(a, b, c) {
        this.code = ua + a;
        this.message = b || va[a] || "";
        this.a = c || null;
    }
    t(u, Error);
    u.prototype.v = function() {
        var a = {
            code: this.code,
            message: this.message
        };
        this.a && (a.serverResponse = this.a);
        return a;
    };
    u.prototype.toJSON = function() {
        return this.v();
    };
    function wa(a) {
        var b = a && a.code;
        return b ? new u(b.substring(ua.length), a.message, a.serverResponse) : null;
    }
    var ua = "auth/", va = {
        "admin-restricted-operation": "This operation is restricted to administrators only.",
        "argument-error": "",
        "app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        "app-not-installed": "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        "captcha-check-failed": "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        "code-expired": "The SMS code has expired. Please re-send the verification code to try again.",
        "cordova-not-ready": "Cordova framework is not ready.",
        "cors-unsupported": "This browser is not supported.",
        "credential-already-in-use": "This credential is already associated with a different user account.",
        "custom-token-mismatch": "The custom token corresponds to a different audience.",
        "requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        "dynamic-link-not-activated": "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        "email-change-needs-verification": "Multi-factor users must always have a verified email.",
        "email-already-in-use": "The email address is already in use by another account.",
        "expired-action-code": "The action code has expired. ",
        "cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.",
        "internal-error": "An internal error has occurred.",
        "invalid-app-credential": "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        "invalid-app-id": "The mobile app identifier is not registed for the current project.",
        "invalid-user-token": "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        "invalid-auth-event": "An internal error has occurred.",
        "invalid-verification-code": "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
        "invalid-continue-uri": "The continue URL provided in the request is invalid.",
        "invalid-cordova-configuration": "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        "invalid-custom-token": "The custom token format is incorrect. Please check the documentation.",
        "invalid-dynamic-link-domain": "The provided dynamic link domain is not configured or authorized for the current project.",
        "invalid-email": "The email address is badly formatted.",
        "invalid-api-key": "Your API key is invalid, please check you have copied it correctly.",
        "invalid-cert-hash": "The SHA-1 certificate hash provided is invalid.",
        "invalid-credential": "The supplied auth credential is malformed or has expired.",
        "invalid-message-payload": "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        "invalid-multi-factor-session": "The request does not contain a valid proof of first factor successful sign-in.",
        "invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        "invalid-oauth-client-id": "The OAuth client ID provided is either invalid or does not match the specified API key.",
        "unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        "invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        "wrong-password": "The password is invalid or the user does not have a password.",
        "invalid-persistence-type": "The specified persistence type is invalid. It can only be local, session or none.",
        "invalid-phone-number": "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        "invalid-provider-id": "The specified provider ID is invalid.",
        "invalid-recipient-email": "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        "invalid-sender": "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        "invalid-verification-id": "The verification ID used to create the phone auth credential is invalid.",
        "invalid-tenant-id": "The Auth instance's tenant ID is invalid.",
        "multi-factor-info-not-found": "The user does not have a second factor matching the identifier provided.",
        "multi-factor-auth-required": "Proof of ownership of a second factor is required to complete sign-in.",
        "missing-android-pkg-name": "An Android Package Name must be provided if the Android App is required to be installed.",
        "auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        "missing-app-credential": "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        "missing-verification-code": "The phone auth credential was created with an empty SMS verification code.",
        "missing-continue-uri": "A continue URL must be provided in the request.",
        "missing-iframe-start": "An internal error has occurred.",
        "missing-ios-bundle-id": "An iOS Bundle ID must be provided if an App Store ID is provided.",
        "missing-multi-factor-info": "No second factor identifier is provided.",
        "missing-multi-factor-session": "The request is missing proof of first factor successful sign-in.",
        "missing-or-invalid-nonce": "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        "missing-phone-number": "To send verification codes, provide a phone number for the recipient.",
        "missing-verification-id": "The phone auth credential was created with an empty verification ID.",
        "app-deleted": "This instance of FirebaseApp has been deleted.",
        "account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        "network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
        "no-auth-event": "An internal error has occurred.",
        "no-such-provider": "User was not linked to an account with the given provider.",
        "null-user": "A null user object was provided as the argument for an operation which requires a non-null user object.",
        "operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        "operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        "popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        "popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.",
        "provider-already-linked": "User can only be linked to one identity for the given provider.",
        "quota-exceeded": "The project's quota for this operation has been exceeded.",
        "redirect-cancelled-by-user": "The redirect operation has been cancelled by the user before finalizing.",
        "redirect-operation-pending": "A redirect sign-in operation is already pending.",
        "rejected-credential": "The request contains malformed or mismatching credentials.",
        "second-factor-already-in-use": "The second factor is already enrolled on this account.",
        "maximum-second-factor-count-exceeded": "The maximum allowed number of second factors on a user has been exceeded.",
        "tenant-id-mismatch": "The provided tenant ID does not match the Auth instance's tenant ID",
        timeout: "The operation has timed out.",
        "user-token-expired": "The user's credential is no longer valid. The user must sign in again.",
        "too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
        "unauthorized-continue-uri": "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        "unsupported-first-factor": "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        "unsupported-persistence-type": "The current environment does not support the specified persistence type.",
        "unsupported-tenant-operation": "This operation is not supported in a multi-tenant context.",
        "unverified-email": "The operation requires a verified email.",
        "user-cancelled": "The user did not grant your application the permissions it requested.",
        "user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.",
        "user-disabled": "The user account has been disabled by an administrator.",
        "user-mismatch": "The supplied credentials do not correspond to the previously signed in user.",
        "user-signed-out": "",
        "weak-password": "The password must be 6 characters long or more.",
        "web-storage-unsupported": "This browser is not supported or 3rd party cookies and data may be disabled."
    };
    var ya = {
        hd: {
            Ra: "https://staging-identitytoolkit.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
            Ua: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "b"
        },
        pd: {
            Ra: "https://www.googleapis.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://securetoken.googleapis.com/v1/token",
            Ua: "https://identitytoolkit.googleapis.com/v2/",
            id: "p"
        },
        rd: {
            Ra: "https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
            Ua: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "s"
        },
        sd: {
            Ra: "https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://test-securetoken.sandbox.googleapis.com/v1/token",
            Ua: "https://test-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "t"
        }
    };
    function za(a) {
        for(var b in ya)if (ya[b].id === a) return a = ya[b], {
            firebaseEndpoint: a.Ra,
            secureTokenEndpoint: a.Xa,
            identityPlatformEndpoint: a.Ua
        };
        return null;
    }
    var Aa;
    Aa = za("__EID__") ? "__EID__" : void 0;
    function Ba(a) {
        if (!a) return !1;
        try {
            return !!a.$goog_Thenable;
        } catch (b) {
            return !1;
        }
    }
    function w(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, w);
        else {
            var b = Error().stack;
            b && (this.stack = b);
        }
        a && (this.message = String(a));
    }
    t(w, Error);
    w.prototype.name = "CustomError";
    function Ca(a, b) {
        a = a.split("%s");
        for(var c = "", d = a.length - 1, e = 0; e < d; e++)c += a[e] + (e < b.length ? b[e] : "%s");
        w.call(this, c + a[d]);
    }
    t(Ca, w);
    Ca.prototype.name = "AssertionError";
    function Da(a, b) {
        throw new Ca("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
    }
    function Ea(a, b) {
        this.c = a;
        this.f = b;
        this.b = 0;
        this.a = null;
    }
    Ea.prototype.get = function() {
        if (0 < this.b) {
            this.b--;
            var a = this.a;
            this.a = a.next;
            a.next = null;
        } else a = this.c();
        return a;
    };
    function Fa(a, b) {
        a.f(b);
        100 > a.b && (a.b++, b.next = a.a, a.a = b);
    }
    function Ga() {
        this.b = this.a = null;
    }
    var Ia = new Ea(function() {
        return new Ha;
    }, function(a) {
        a.reset();
    });
    Ga.prototype.add = function(a, b) {
        var c = Ia.get();
        c.set(a, b);
        this.b ? this.b.next = c : this.a = c;
        this.b = c;
    };
    function Ja() {
        var a = Ka, b = null;
        a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);
        return b;
    }
    function Ha() {
        this.next = this.b = this.a = null;
    }
    Ha.prototype.set = function(a, b) {
        this.a = a;
        this.b = b;
        this.next = null;
    };
    Ha.prototype.reset = function() {
        this.next = this.b = this.a = null;
    };
    var La = Array.prototype.indexOf ? function(a, b) {
        return Array.prototype.indexOf.call(a, b, void 0);
    } : function(a, b) {
        if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
        for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
        return -1;
    }, x = Array.prototype.forEach ? function(a, b, c) {
        Array.prototype.forEach.call(a, b, c);
    } : function(a, b, c) {
        for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
    };
    function Ma(a, b) {
        for(var c = "string" === typeof a ? a.split("") : a, d = a.length - 1; 0 <= d; --d)d in c && b.call(void 0, c[d], d, a);
    }
    var Na = Array.prototype.filter ? function(a, b) {
        return Array.prototype.filter.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = [], e = 0, f = "string" === typeof a ? a.split("") : a, g = 0; g < c; g++)if (g in f) {
            var h = f[g];
            b.call(void 0, h, g, a) && (d[e++] = h);
        }
        return d;
    }, Oa = Array.prototype.map ? function(a, b) {
        return Array.prototype.map.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = Array(c), e = "string" === typeof a ? a.split("") : a, f = 0; f < c; f++)f in e && (d[f] = b.call(void 0, e[f], f, a));
        return d;
    }, Pa = Array.prototype.some ? function(a, b) {
        return Array.prototype.some.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) return !0;
        return !1;
    };
    function Qa(a) {
        a: {
            var b = Ra;
            for(var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) {
                b = e;
                break a;
            }
            b = -1;
        }
        return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
    }
    function Sa(a, b) {
        return 0 <= La(a, b);
    }
    function Ta(a, b) {
        b = La(a, b);
        var c;
        (c = 0 <= b) && Array.prototype.splice.call(a, b, 1);
        return c;
    }
    function Ua(a, b) {
        var c = 0;
        Ma(a, function(d, e) {
            b.call(void 0, d, e, a) && 1 == Array.prototype.splice.call(a, e, 1).length && c++;
        });
    }
    function Va(a) {
        return Array.prototype.concat.apply([], arguments);
    }
    function Wa(a) {
        var b = a.length;
        if (0 < b) {
            for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    var Xa = String.prototype.trim ? function(a) {
        return a.trim();
    } : function(a) {
        return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
    }, Ya = /&/g, Za = /</g, $a = />/g, ab = /"/g, bb = /'/g, cb = /\x00/g, db = /[\x00&<>"']/;
    function y(a, b) {
        return -1 != a.indexOf(b);
    }
    function eb(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }
    var fb;
    a: {
        var gb = l.navigator;
        if (gb) {
            var hb = gb.userAgent;
            if (hb) {
                fb = hb;
                break a;
            }
        }
        fb = "";
    }
    function z(a) {
        return y(fb, a);
    }
    function ib(a, b) {
        for(var c in a)b.call(void 0, a[c], c, a);
    }
    function jb(a) {
        for(var b in a)return !1;
        return !0;
    }
    function kb(a) {
        var b = {}, c;
        for(c in a)b[c] = a[c];
        return b;
    }
    var lb = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function B(a, b) {
        for(var c, d, e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(var f = 0; f < lb.length; f++)c = lb[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function mb(a, b) {
        a: {
            try {
                var c = a && a.ownerDocument, d = c && (c.defaultView || c.parentWindow);
                d = d || l;
                if (d.Element && d.Location) {
                    var e = d;
                    break a;
                }
            } catch (g) {}
            e = null;
        }
        if (e && "undefined" != typeof e[b] && (!a || !(a instanceof e[b]) && (a instanceof e.Location || a instanceof e.Element))) {
            if (q(a)) try {
                var f = a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
            } catch (g) {
                f = "<object could not be stringified>";
            }
            else f = void 0 === a ? "undefined" : null === a ? "null" : typeof a;
            Da("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, f);
        }
    }
    function nb(a, b) {
        this.a = a === ob && b || "";
        this.b = pb;
    }
    nb.prototype.ra = !0;
    nb.prototype.qa = function() {
        return this.a;
    };
    nb.prototype.toString = function() {
        return "Const{" + this.a + "}";
    };
    function qb(a) {
        if (a instanceof nb && a.constructor === nb && a.b === pb) return a.a;
        Da("expected object of type Const, got '" + a + "'");
        return "type_error:Const";
    }
    var pb = {}, ob = {}, rb = new nb(ob, "");
    function sb(a, b) {
        this.a = a === tb && b || "";
        this.b = ub;
    }
    sb.prototype.ra = !0;
    sb.prototype.qa = function() {
        return this.a.toString();
    };
    sb.prototype.toString = function() {
        return "TrustedResourceUrl{" + this.a + "}";
    };
    function vb(a) {
        if (a instanceof sb && a.constructor === sb && a.b === ub) return a.a;
        Da("expected object of type TrustedResourceUrl, got '" + a + "' of type " + la(a));
        return "type_error:TrustedResourceUrl";
    }
    function wb(a, b) {
        var c = qb(a);
        if (!xb.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);
        a = c.replace(yb, function(d, e) {
            if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
            d = b[e];
            return d instanceof nb ? qb(d) : encodeURIComponent(String(d));
        });
        return new sb(tb, a);
    }
    var yb = /%{(\w+)}/g, xb = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, ub = {}, tb = {};
    function zb(a, b) {
        this.a = a === Ab && b || "";
        this.b = Bb;
    }
    zb.prototype.ra = !0;
    zb.prototype.qa = function() {
        return this.a.toString();
    };
    zb.prototype.toString = function() {
        return "SafeUrl{" + this.a + "}";
    };
    function Cb(a) {
        if (a instanceof zb && a.constructor === zb && a.b === Bb) return a.a;
        Da("expected object of type SafeUrl, got '" + a + "' of type " + la(a));
        return "type_error:SafeUrl";
    }
    var Db = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
    function Eb(a) {
        if (a instanceof zb) return a;
        a = "object" == typeof a && a.ra ? a.qa() : String(a);
        Db.test(a) || (a = "about:invalid#zClosurez");
        return new zb(Ab, a);
    }
    var Bb = {}, Ab = {};
    function Fb() {
        this.a = "";
        this.b = Gb;
    }
    Fb.prototype.ra = !0;
    Fb.prototype.qa = function() {
        return this.a.toString();
    };
    Fb.prototype.toString = function() {
        return "SafeHtml{" + this.a + "}";
    };
    function Hb(a) {
        if (a instanceof Fb && a.constructor === Fb && a.b === Gb) return a.a;
        Da("expected object of type SafeHtml, got '" + a + "' of type " + la(a));
        return "type_error:SafeHtml";
    }
    var Gb = {};
    function Ib(a) {
        var b = new Fb;
        b.a = a;
        return b;
    }
    Ib("<!DOCTYPE html>");
    var Jb = Ib("");
    Ib("<br>");
    function Kb(a) {
        var b = new sb(tb, qb(rb));
        mb(a, "HTMLIFrameElement");
        a.src = vb(b).toString();
    }
    function Lb(a, b) {
        mb(a, "HTMLScriptElement");
        a.src = vb(b);
        if (null === ja) b: {
            b = l.document;
            if ((b = b.querySelector && b.querySelector("script[nonce]")) && (b = b.nonce || b.getAttribute("nonce")) && ia.test(b)) {
                ja = b;
                break b;
            }
            ja = "";
        }
        b = ja;
        b && a.setAttribute("nonce", b);
    }
    function Mb(a, b) {
        for(var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;)d += c.shift() + e.shift();
        return d + c.join("%s");
    }
    function Nb(a) {
        db.test(a) && (-1 != a.indexOf("&") && (a = a.replace(Ya, "&amp;")), -1 != a.indexOf("<") && (a = a.replace(Za, "&lt;")), -1 != a.indexOf(">") && (a = a.replace($a, "&gt;")), -1 != a.indexOf('"') && (a = a.replace(ab, "&quot;")), -1 != a.indexOf("'") && (a = a.replace(bb, "&#39;")), -1 != a.indexOf("\x00") && (a = a.replace(cb, "&#0;")));
        return a;
    }
    function Ob(a) {
        Ob[" "](a);
        return a;
    }
    Ob[" "] = ka;
    function Pb(a, b) {
        var c = Qb;
        return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
    }
    var Rb = z("Opera"), Sb = z("Trident") || z("MSIE"), Tb = z("Edge"), Ub = Tb || Sb, Vb = z("Gecko") && !(y(fb.toLowerCase(), "webkit") && !z("Edge")) && !(z("Trident") || z("MSIE")) && !z("Edge"), Wb = y(fb.toLowerCase(), "webkit") && !z("Edge");
    function Xb() {
        var a = l.document;
        return a ? a.documentMode : void 0;
    }
    var Yb;
    a: {
        var Zb = "", $b = function() {
            var a = fb;
            if (Vb) return /rv:([^\);]+)(\)|;)/.exec(a);
            if (Tb) return /Edge\/([\d\.]+)/.exec(a);
            if (Sb) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
            if (Wb) return /WebKit\/(\S+)/.exec(a);
            if (Rb) return /(?:Version)[ \/]?(\S+)/.exec(a);
        }();
        $b && (Zb = $b ? $b[1] : "");
        if (Sb) {
            var ac = Xb();
            if (null != ac && ac > parseFloat(Zb)) {
                Yb = String(ac);
                break a;
            }
        }
        Yb = Zb;
    }
    var Qb = {};
    function bc(a) {
        return Pb(a, function() {
            for(var b = 0, c = Xa(String(Yb)).split("."), d = Xa(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++){
                var g = c[f] || "", h = d[f] || "";
                do {
                    g = /(\d*)(\D*)(.*)/.exec(g) || [
                        "",
                        "",
                        "",
                        ""
                    ];
                    h = /(\d*)(\D*)(.*)/.exec(h) || [
                        "",
                        "",
                        "",
                        ""
                    ];
                    if (0 == g[0].length && 0 == h[0].length) break;
                    b = eb(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == h[1].length ? 0 : parseInt(h[1], 10)) || eb(0 == g[2].length, 0 == h[2].length) || eb(g[2], h[2]);
                    g = g[3];
                    h = h[3];
                }while (0 == b);
            }
            return 0 <= b;
        });
    }
    var cc;
    cc = l.document && Sb ? Xb() : void 0;
    try {
        new self.OffscreenCanvas(0, 0).getContext("2d");
    } catch (a) {}
    var dc = !Sb || 9 <= Number(cc);
    function ec(a) {
        var b = document;
        return "string" === typeof a ? b.getElementById(a) : a;
    }
    function fc(a, b) {
        ib(b, function(c, d) {
            c && "object" == typeof c && c.ra && (c = c.qa());
            "style" == d ? a.style.cssText = c : "class" == d ? a.className = c : "for" == d ? a.htmlFor = c : gc.hasOwnProperty(d) ? a.setAttribute(gc[d], c) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, c) : a[d] = c;
        });
    }
    var gc = {
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        colspan: "colSpan",
        frameborder: "frameBorder",
        height: "height",
        maxlength: "maxLength",
        nonce: "nonce",
        role: "role",
        rowspan: "rowSpan",
        type: "type",
        usemap: "useMap",
        valign: "vAlign",
        width: "width"
    };
    function hc(a, b, c) {
        var d = arguments, e = document, f = String(d[0]), g = d[1];
        if (!dc && g && (g.name || g.type)) {
            f = [
                "<",
                f
            ];
            g.name && f.push(' name="', Nb(g.name), '"');
            if (g.type) {
                f.push(' type="', Nb(g.type), '"');
                var h = {};
                B(h, g);
                delete h.type;
                g = h;
            }
            f.push(">");
            f = f.join("");
        }
        f = ic(e, f);
        g && ("string" === typeof g ? f.className = g : Array.isArray(g) ? f.className = g.join(" ") : fc(f, g));
        2 < d.length && jc(e, f, d);
        return f;
    }
    function jc(a, b, c) {
        function d(g) {
            g && b.appendChild("string" === typeof g ? a.createTextNode(g) : g);
        }
        for(var e = 2; e < c.length; e++){
            var f = c[e];
            !ma(f) || q(f) && 0 < f.nodeType ? d(f) : x(kc(f) ? Wa(f) : f, d);
        }
    }
    function ic(a, b) {
        b = String(b);
        "application/xhtml+xml" === a.contentType && (b = b.toLowerCase());
        return a.createElement(b);
    }
    function kc(a) {
        if (a && "number" == typeof a.length) {
            if (q(a)) return "function" == typeof a.item || "string" == typeof a.item;
            if (n(a)) return "function" == typeof a.item;
        }
        return !1;
    }
    function lc(a) {
        l.setTimeout(function() {
            throw a;
        }, 0);
    }
    var mc;
    function nc() {
        var a = l.MessageChannel;
        "undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !z("Presto") && (a = function() {
            var e = ic(document, "IFRAME");
            e.style.display = "none";
            Kb(e);
            document.documentElement.appendChild(e);
            var f = e.contentWindow;
            e = f.document;
            e.open();
            e.write(Hb(Jb));
            e.close();
            var g = "callImmediate" + Math.random(), h = "file:" == f.location.protocol ? "*" : f.location.protocol + "//" + f.location.host;
            e = r(function(m) {
                if (("*" == h || m.origin == h) && m.data == g) this.port1.onmessage();
            }, this);
            f.addEventListener("message", e, !1);
            this.port1 = {};
            this.port2 = {
                postMessage: function() {
                    f.postMessage(g, h);
                }
            };
        });
        if ("undefined" !== typeof a && !z("Trident") && !z("MSIE")) {
            var b = new a, c = {}, d = c;
            b.port1.onmessage = function() {
                if (void 0 !== c.next) {
                    c = c.next;
                    var e = c.Db;
                    c.Db = null;
                    e();
                }
            };
            return function(e) {
                d.next = {
                    Db: e
                };
                d = d.next;
                b.port2.postMessage(0);
            };
        }
        return function(e) {
            l.setTimeout(e, 0);
        };
    }
    function oc(a, b) {
        pc || qc();
        rc || (pc(), rc = !0);
        Ka.add(a, b);
    }
    var pc;
    function qc() {
        if (l.Promise && l.Promise.resolve) {
            var a = l.Promise.resolve(void 0);
            pc = function() {
                a.then(sc);
            };
        } else pc = function() {
            var b = sc;
            !n(l.setImmediate) || l.Window && l.Window.prototype && !z("Edge") && l.Window.prototype.setImmediate == l.setImmediate ? (mc || (mc = nc()), mc(b)) : l.setImmediate(b);
        };
    }
    var rc = !1, Ka = new Ga;
    function sc() {
        for(var a; a = Ja();){
            try {
                a.a.call(a.b);
            } catch (b) {
                lc(b);
            }
            Fa(Ia, a);
        }
        rc = !1;
    }
    function D(a, b) {
        this.a = tc;
        this.i = void 0;
        this.f = this.b = this.c = null;
        this.g = this.h = !1;
        if (a != ka) try {
            var c = this;
            a.call(b, function(d) {
                uc(c, vc, d);
            }, function(d) {
                if (!(d instanceof wc)) try {
                    if (d instanceof Error) throw d;
                    throw Error("Promise rejected.");
                } catch (e) {}
                uc(c, xc, d);
            });
        } catch (d) {
            uc(this, xc, d);
        }
    }
    var tc = 0, vc = 2, xc = 3;
    function yc() {
        this.next = this.f = this.b = this.g = this.a = null;
        this.c = !1;
    }
    yc.prototype.reset = function() {
        this.f = this.b = this.g = this.a = null;
        this.c = !1;
    };
    var zc = new Ea(function() {
        return new yc;
    }, function(a) {
        a.reset();
    });
    function Ac(a, b, c) {
        var d = zc.get();
        d.g = a;
        d.b = b;
        d.f = c;
        return d;
    }
    function E(a) {
        if (a instanceof D) return a;
        var b = new D(ka);
        uc(b, vc, a);
        return b;
    }
    function F(a) {
        return new D(function(b, c) {
            c(a);
        });
    }
    function Bc(a, b, c) {
        Cc(a, b, c, null) || oc(sa(b, a));
    }
    function Dc(a) {
        return new D(function(b, c) {
            var d = a.length, e = [];
            if (d) for(var f = function(p, v) {
                d--;
                e[p] = v;
                0 == d && b(e);
            }, g = function(p) {
                c(p);
            }, h = 0, m; h < a.length; h++)m = a[h], Bc(m, sa(f, h), g);
            else b(e);
        });
    }
    function Ec(a) {
        return new D(function(b) {
            var c = a.length, d = [];
            if (c) for(var e = function(h, m, p) {
                c--;
                d[h] = m ? {
                    Mb: !0,
                    value: p
                } : {
                    Mb: !1,
                    reason: p
                };
                0 == c && b(d);
            }, f = 0, g; f < a.length; f++)g = a[f], Bc(g, sa(e, f, !0), sa(e, f, !1));
            else b(d);
        });
    }
    D.prototype.then = function(a, b, c) {
        return Fc(this, n(a) ? a : null, n(b) ? b : null, c);
    };
    D.prototype.$goog_Thenable = !0;
    k = D.prototype;
    k.ma = function(a, b) {
        a = Ac(a, a, b);
        a.c = !0;
        Gc(this, a);
        return this;
    };
    k.o = function(a, b) {
        return Fc(this, null, a, b);
    };
    k.cancel = function(a) {
        if (this.a == tc) {
            var b = new wc(a);
            oc(function() {
                Hc(this, b);
            }, this);
        }
    };
    function Hc(a, b) {
        if (a.a == tc) {
            if (a.c) {
                var c = a.c;
                if (c.b) {
                    for(var d = 0, e = null, f = null, g = c.b; g && (g.c || (d++, g.a == a && (e = g), !(e && 1 < d))); g = g.next)e || (f = g);
                    e && (c.a == tc && 1 == d ? Hc(c, b) : (f ? (d = f, d.next == c.f && (c.f = d), d.next = d.next.next) : Ic(c), Jc(c, e, xc, b)));
                }
                a.c = null;
            } else uc(a, xc, b);
        }
    }
    function Gc(a, b) {
        a.b || a.a != vc && a.a != xc || Kc(a);
        a.f ? a.f.next = b : a.b = b;
        a.f = b;
    }
    function Fc(a, b, c, d) {
        var e = Ac(null, null, null);
        e.a = new D(function(f, g) {
            e.g = b ? function(h) {
                try {
                    var m = b.call(d, h);
                    f(m);
                } catch (p) {
                    g(p);
                }
            } : f;
            e.b = c ? function(h) {
                try {
                    var m = c.call(d, h);
                    void 0 === m && h instanceof wc ? g(h) : f(m);
                } catch (p) {
                    g(p);
                }
            } : g;
        });
        e.a.c = a;
        Gc(a, e);
        return e.a;
    }
    k.Yc = function(a) {
        this.a = tc;
        uc(this, vc, a);
    };
    k.Zc = function(a) {
        this.a = tc;
        uc(this, xc, a);
    };
    function uc(a, b, c) {
        a.a == tc && (a === c && (b = xc, c = new TypeError("Promise cannot resolve to itself")), a.a = 1, Cc(c, a.Yc, a.Zc, a) || (a.i = c, a.a = b, a.c = null, Kc(a), b != xc || c instanceof wc || Lc(a, c)));
    }
    function Cc(a, b, c, d) {
        if (a instanceof D) return Gc(a, Ac(b || ka, c || null, d)), !0;
        if (Ba(a)) return a.then(b, c, d), !0;
        if (q(a)) try {
            var e = a.then;
            if (n(e)) return Mc(a, e, b, c, d), !0;
        } catch (f) {
            return c.call(d, f), !0;
        }
        return !1;
    }
    function Mc(a, b, c, d, e) {
        function f(m) {
            h || (h = !0, d.call(e, m));
        }
        function g(m) {
            h || (h = !0, c.call(e, m));
        }
        var h = !1;
        try {
            b.call(a, g, f);
        } catch (m) {
            f(m);
        }
    }
    function Kc(a) {
        a.h || (a.h = !0, oc(a.ec, a));
    }
    function Ic(a) {
        var b = null;
        a.b && (b = a.b, a.b = b.next, b.next = null);
        a.b || (a.f = null);
        return b;
    }
    k.ec = function() {
        for(var a; a = Ic(this);)Jc(this, a, this.a, this.i);
        this.h = !1;
    };
    function Jc(a, b, c, d) {
        if (c == xc && b.b && !b.c) for(; a && a.g; a = a.c)a.g = !1;
        if (b.a) b.a.c = null, Nc(b, c, d);
        else try {
            b.c ? b.g.call(b.f) : Nc(b, c, d);
        } catch (e) {
            Oc.call(null, e);
        }
        Fa(zc, b);
    }
    function Nc(a, b, c) {
        b == vc ? a.g.call(a.f, c) : a.b && a.b.call(a.f, c);
    }
    function Lc(a, b) {
        a.g = !0;
        oc(function() {
            a.g && Oc.call(null, b);
        });
    }
    var Oc = lc;
    function wc(a) {
        w.call(this, a);
    }
    t(wc, w);
    wc.prototype.name = "cancel";
    function Pc() {
        0 != Qc && (Rc[na(this)] = this);
        this.wa = this.wa;
        this.na = this.na;
    }
    var Qc = 0, Rc = {};
    Pc.prototype.wa = !1;
    function Sc(a) {
        if (!a.wa && (a.wa = !0, a.Ba(), 0 != Qc)) {
            var b = na(a);
            if (0 != Qc && a.na && 0 < a.na.length) throw Error(a + " did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");
            delete Rc[b];
        }
    }
    Pc.prototype.Ba = function() {
        if (this.na) for(; this.na.length;)this.na.shift()();
    };
    var Tc = Object.freeze || function(a) {
        return a;
    };
    var Uc = !Sb || 9 <= Number(cc), Vc = Sb && !bc("9"), Wc = function() {
        if (!l.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            l.addEventListener("test", ka, b), l.removeEventListener("test", ka, b);
        } catch (c) {}
        return a;
    }();
    function Xc(a, b) {
        this.type = a;
        this.b = this.target = b;
        this.defaultPrevented = !1;
    }
    Xc.prototype.preventDefault = function() {
        this.defaultPrevented = !0;
    };
    function Yc(a, b) {
        Xc.call(this, a ? a.type : "");
        this.relatedTarget = this.b = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.pointerId = 0;
        this.pointerType = "";
        this.a = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.b = b;
            if (b = a.relatedTarget) {
                if (Vb) {
                    a: {
                        try {
                            Ob(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Zc[a.pointerType] || "";
            this.a = a;
            a.defaultPrevented && this.preventDefault();
        }
    }
    t(Yc, Xc);
    var Zc = Tc({
        2: "touch",
        3: "pen",
        4: "mouse"
    });
    Yc.prototype.preventDefault = function() {
        Yc.Za.preventDefault.call(this);
        var a = this.a;
        if (a.preventDefault) a.preventDefault();
        else if (a.returnValue = !1, Vc) try {
            if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
        } catch (b) {}
    };
    Yc.prototype.f = function() {
        return this.a;
    };
    var $c = "closure_listenable_" + (1E6 * Math.random() | 0), ad = 0;
    function bd(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.Ta = e;
        this.key = ++ad;
        this.ua = this.Na = !1;
    }
    function cd(a) {
        a.ua = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.Ta = null;
    }
    function dd(a) {
        this.src = a;
        this.a = {};
        this.b = 0;
    }
    dd.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.a[f];
        a || (a = this.a[f] = [], this.b++);
        var g = ed(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.Na = !1)) : (b = new bd(b, this.src, f, !!d, e), b.Na = c, a.push(b));
        return b;
    };
    function fd(a, b) {
        var c = b.type;
        c in a.a && Ta(a.a[c], b) && (cd(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
    function ed(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.ua && f.listener == b && f.capture == !!c && f.Ta == d) return e;
        }
        return -1;
    }
    var gd = "closure_lm_" + (1E6 * Math.random() | 0), hd = {}, id = 0;
    function jd(a, b, c, d, e) {
        if (d && d.once) kd(a, b, c, d, e);
        else if (Array.isArray(b)) for(var f = 0; f < b.length; f++)jd(a, b[f], c, d, e);
        else c = ld(c), a && a[$c] ? md(a, b, c, q(d) ? !!d.capture : !!d, e) : nd(a, b, c, !1, d, e);
    }
    function nd(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = q(e) ? !!e.capture : !!e, h = od(a);
        h || (a[gd] = h = new dd(a));
        c = h.add(b, c, d, g, f);
        if (!c.proxy) {
            d = pd();
            c.proxy = d;
            d.src = a;
            d.listener = c;
            if (a.addEventListener) Wc || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
            else if (a.attachEvent) a.attachEvent(qd(b.toString()), d);
            else if (a.addListener && a.removeListener) a.addListener(d);
            else throw Error("addEventListener and attachEvent are unavailable.");
            id++;
        }
    }
    function pd() {
        var a = rd, b = Uc ? function(c) {
            return a.call(b.src, b.listener, c);
        } : function(c) {
            c = a.call(b.src, b.listener, c);
            if (!c) return c;
        };
        return b;
    }
    function kd(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)kd(a, b[f], c, d, e);
        else c = ld(c), a && a[$c] ? sd(a, b, c, q(d) ? !!d.capture : !!d, e) : nd(a, b, c, !0, d, e);
    }
    function td(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)td(a, b[f], c, d, e);
        else (d = q(d) ? !!d.capture : !!d, c = ld(c), a && a[$c]) ? (a = a.u, b = String(b).toString(), b in a.a && (f = a.a[b], c = ed(f, c, d, e), -1 < c && (cd(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = od(a)) && (b = a.a[b.toString()], a = -1, b && (a = ed(b, c, d, e)), (c = -1 < a ? b[a] : null) && vd(c));
    }
    function vd(a) {
        if ("number" !== typeof a && a && !a.ua) {
            var b = a.src;
            if (b && b[$c]) fd(b.u, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(qd(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                id--;
                (c = od(b)) ? (fd(c, a), 0 == c.b && (c.src = null, b[gd] = null)) : cd(a);
            }
        }
    }
    function qd(a) {
        return a in hd ? hd[a] : hd[a] = "on" + a;
    }
    function wd(a, b, c, d) {
        var e = !0;
        if (a = od(a)) {
            if (b = a.a[b.toString()]) for(b = b.concat(), a = 0; a < b.length; a++){
                var f = b[a];
                f && f.capture == c && !f.ua && (f = xd(f, d), e = e && !1 !== f);
            }
        }
        return e;
    }
    function xd(a, b) {
        var c = a.listener, d = a.Ta || a.src;
        a.Na && vd(a);
        return c.call(d, b);
    }
    function rd(a, b) {
        if (a.ua) return !0;
        if (!Uc) {
            if (!b) a: {
                b = [
                    "window",
                    "event"
                ];
                for(var c = l, d = 0; d < b.length; d++)if (c = c[b[d]], null == c) {
                    b = null;
                    break a;
                }
                b = c;
            }
            d = b;
            b = new Yc(d, this);
            c = !0;
            if (!(0 > d.keyCode || void 0 != d.returnValue)) {
                a: {
                    var e = !1;
                    if (0 == d.keyCode) try {
                        d.keyCode = -1;
                        break a;
                    } catch (g) {
                        e = !0;
                    }
                    if (e || void 0 == d.returnValue) d.returnValue = !0;
                }
                d = [];
                for(e = b.b; e; e = e.parentNode)d.push(e);
                a = a.type;
                for(e = d.length - 1; 0 <= e; e--){
                    b.b = d[e];
                    var f = wd(d[e], a, !0, b);
                    c = c && f;
                }
                for(e = 0; e < d.length; e++)b.b = d[e], f = wd(d[e], a, !1, b), c = c && f;
            }
            return c;
        }
        return xd(a, new Yc(b, this));
    }
    function od(a) {
        a = a[gd];
        return a instanceof dd ? a : null;
    }
    var yd = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function ld(a) {
        if (n(a)) return a;
        a[yd] || (a[yd] = function(b) {
            return a.handleEvent(b);
        });
        return a[yd];
    }
    function G() {
        Pc.call(this);
        this.u = new dd(this);
        this.Yb = this;
        this.eb = null;
    }
    t(G, Pc);
    G.prototype[$c] = !0;
    G.prototype.addEventListener = function(a, b, c, d) {
        jd(this, a, b, c, d);
    };
    G.prototype.removeEventListener = function(a, b, c, d) {
        td(this, a, b, c, d);
    };
    G.prototype.dispatchEvent = function(a) {
        var b, c = this.eb;
        if (c) for(b = []; c; c = c.eb)b.push(c);
        c = this.Yb;
        var d = a.type || a;
        if ("string" === typeof a) a = new Xc(a, c);
        else if (a instanceof Xc) a.target = a.target || c;
        else {
            var e = a;
            a = new Xc(d, c);
            B(a, e);
        }
        e = !0;
        if (b) for(var f = b.length - 1; 0 <= f; f--){
            var g = a.b = b[f];
            e = zd(g, d, !0, a) && e;
        }
        g = a.b = c;
        e = zd(g, d, !0, a) && e;
        e = zd(g, d, !1, a) && e;
        if (b) for(f = 0; f < b.length; f++)g = a.b = b[f], e = zd(g, d, !1, a) && e;
        return e;
    };
    G.prototype.Ba = function() {
        G.Za.Ba.call(this);
        if (this.u) {
            var a = this.u, b = 0, c;
            for(c in a.a){
                for(var d = a.a[c], e = 0; e < d.length; e++)++b, cd(d[e]);
                delete a.a[c];
                a.b--;
            }
        }
        this.eb = null;
    };
    function md(a, b, c, d, e) {
        a.u.add(String(b), c, !1, d, e);
    }
    function sd(a, b, c, d, e) {
        a.u.add(String(b), c, !0, d, e);
    }
    function zd(a, b, c, d) {
        b = a.u.a[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.ua && g.capture == c) {
                var h = g.listener, m = g.Ta || g.src;
                g.Na && fd(a.u, g);
                e = !1 !== h.call(m, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function Ad(a, b, c) {
        if (n(a)) c && (a = r(a, c));
        else if (a && "function" == typeof a.handleEvent) a = r(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : l.setTimeout(a, b || 0);
    }
    function Bd(a) {
        var b = null;
        return new D(function(c, d) {
            b = Ad(function() {
                c(void 0);
            }, a);
            -1 == b && d(Error("Failed to schedule timer."));
        }).o(function(c) {
            l.clearTimeout(b);
            throw c;
        });
    }
    function Cd(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("string" === typeof a) return a.split("");
        if (ma(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function Dd(a) {
        if (a.X && "function" == typeof a.X) return a.X();
        if (!a.V || "function" != typeof a.V) {
            if (ma(a) || "string" === typeof a) {
                var b = [];
                a = a.length;
                for(var c = 0; c < a; c++)b.push(c);
                return b;
            }
            b = [];
            c = 0;
            for(var d in a)b[c++] = d;
            return b;
        }
    }
    function Ed(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ma(a) || "string" === typeof a) x(a, b, void 0);
        else for(var c = Dd(a), d = Cd(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    function Fd(a, b) {
        this.b = {};
        this.a = [];
        this.c = 0;
        var c = arguments.length;
        if (1 < c) {
            if (c % 2) throw Error("Uneven number of arguments");
            for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
        } else if (a) {
            if (a instanceof Fd) for(c = a.X(), d = 0; d < c.length; d++)this.set(c[d], a.get(c[d]));
            else for(d in a)this.set(d, a[d]);
        }
    }
    k = Fd.prototype;
    k.V = function() {
        Gd(this);
        for(var a = [], b = 0; b < this.a.length; b++)a.push(this.b[this.a[b]]);
        return a;
    };
    k.X = function() {
        Gd(this);
        return this.a.concat();
    };
    k.clear = function() {
        this.b = {};
        this.c = this.a.length = 0;
    };
    function Gd(a) {
        if (a.c != a.a.length) {
            for(var b = 0, c = 0; b < a.a.length;){
                var d = a.a[b];
                Hd(a.b, d) && (a.a[c++] = d);
                b++;
            }
            a.a.length = c;
        }
        if (a.c != a.a.length) {
            var e = {};
            for(c = b = 0; b < a.a.length;)d = a.a[b], Hd(e, d) || (a.a[c++] = d, e[d] = 1), b++;
            a.a.length = c;
        }
    }
    k.get = function(a, b) {
        return Hd(this.b, a) ? this.b[a] : b;
    };
    k.set = function(a, b) {
        Hd(this.b, a) || (this.c++, this.a.push(a));
        this.b[a] = b;
    };
    k.forEach = function(a, b) {
        for(var c = this.X(), d = 0; d < c.length; d++){
            var e = c[d], f = this.get(e);
            a.call(b, f, e, this);
        }
    };
    function Hd(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    var Id = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/\\#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
    function Jd(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function Kd(a, b) {
        this.b = this.i = this.f = "";
        this.l = null;
        this.g = this.c = "";
        this.h = !1;
        var c;
        a instanceof Kd ? (this.h = void 0 !== b ? b : a.h, Ld(this, a.f), this.i = a.i, this.b = a.b, Md(this, a.l), this.c = a.c, Nd(this, Od(a.a)), this.g = a.g) : a && (c = String(a).match(Id)) ? (this.h = !!b, Ld(this, c[1] || "", !0), this.i = Pd(c[2] || ""), this.b = Pd(c[3] || "", !0), Md(this, c[4]), this.c = Pd(c[5] || "", !0), Nd(this, c[6] || "", !0), this.g = Pd(c[7] || "")) : (this.h = !!b, this.a = new Qd(null, this.h));
    }
    Kd.prototype.toString = function() {
        var a = [], b = this.f;
        b && a.push(Rd(b, Sd, !0), ":");
        var c = this.b;
        if (c || "file" == b) a.push("//"), (b = this.i) && a.push(Rd(b, Sd, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.l, null != c && a.push(":", String(c));
        if (c = this.c) this.b && "/" != c.charAt(0) && a.push("/"), a.push(Rd(c, "/" == c.charAt(0) ? Td : Ud, !0));
        (c = this.a.toString()) && a.push("?", c);
        (c = this.g) && a.push("#", Rd(c, Vd));
        return a.join("");
    };
    Kd.prototype.resolve = function(a) {
        var b = new Kd(this), c = !!a.f;
        c ? Ld(b, a.f) : c = !!a.i;
        c ? b.i = a.i : c = !!a.b;
        c ? b.b = a.b : c = null != a.l;
        var d = a.c;
        if (c) Md(b, a.l);
        else if (c = !!a.c) {
            if ("/" != d.charAt(0)) {
                if (this.b && !this.c) d = "/" + d;
                else {
                    var e = b.c.lastIndexOf("/");
                    -1 != e && (d = b.c.substr(0, e + 1) + d);
                }
            }
            e = d;
            if (".." == e || "." == e) d = "";
            else if (y(e, "./") || y(e, "/.")) {
                d = 0 == e.lastIndexOf("/", 0);
                e = e.split("/");
                for(var f = [], g = 0; g < e.length;){
                    var h = e[g++];
                    "." == h ? d && g == e.length && f.push("") : ".." == h ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && g == e.length && f.push("")) : (f.push(h), d = !0);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.c = d : c = "" !== a.a.toString();
        c ? Nd(b, Od(a.a)) : c = !!a.g;
        c && (b.g = a.g);
        return b;
    };
    function Ld(a, b, c) {
        a.f = c ? Pd(b, !0) : b;
        a.f && (a.f = a.f.replace(/:$/, ""));
    }
    function Md(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.l = b;
        } else a.l = null;
    }
    function Nd(a, b, c) {
        b instanceof Qd ? (a.a = b, Wd(a.a, a.h)) : (c || (b = Rd(b, Xd)), a.a = new Qd(b, a.h));
    }
    function H(a, b, c) {
        a.a.set(b, c);
    }
    function Yd(a, b) {
        return a.a.get(b);
    }
    function Zd(a) {
        return a instanceof Kd ? new Kd(a) : new Kd(a, void 0);
    }
    function $d(a, b) {
        var c = new Kd(null, void 0);
        Ld(c, "https");
        a && (c.b = a);
        b && (c.c = b);
        return c;
    }
    function Pd(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function Rd(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, ae), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function ae(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var Sd = /[#\/\?@]/g, Ud = /[#\?:]/g, Td = /[#\?]/g, Xd = /[#\?@]/g, Vd = /#/g;
    function Qd(a, b) {
        this.b = this.a = null;
        this.c = a || null;
        this.f = !!b;
    }
    function be(a) {
        a.a || (a.a = new Fd, a.b = 0, a.c && Jd(a.c, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    function ce(a) {
        var b = Dd(a);
        if ("undefined" == typeof b) throw Error("Keys are undefined");
        var c = new Qd(null, void 0);
        a = Cd(a);
        for(var d = 0; d < b.length; d++){
            var e = b[d], f = a[d];
            Array.isArray(f) ? de(c, e, f) : c.add(e, f);
        }
        return c;
    }
    k = Qd.prototype;
    k.add = function(a, b) {
        be(this);
        this.c = null;
        a = ee(this, a);
        var c = this.a.get(a);
        c || this.a.set(a, c = []);
        c.push(b);
        this.b += 1;
        return this;
    };
    function fe(a, b) {
        be(a);
        b = ee(a, b);
        Hd(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, a = a.a, Hd(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && Gd(a)));
    }
    k.clear = function() {
        this.a = this.c = null;
        this.b = 0;
    };
    function ge(a, b) {
        be(a);
        b = ee(a, b);
        return Hd(a.a.b, b);
    }
    k.forEach = function(a, b) {
        be(this);
        this.a.forEach(function(c, d) {
            x(c, function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    k.X = function() {
        be(this);
        for(var a = this.a.V(), b = this.a.X(), c = [], d = 0; d < b.length; d++)for(var e = a[d], f = 0; f < e.length; f++)c.push(b[d]);
        return c;
    };
    k.V = function(a) {
        be(this);
        var b = [];
        if ("string" === typeof a) ge(this, a) && (b = Va(b, this.a.get(ee(this, a))));
        else {
            a = this.a.V();
            for(var c = 0; c < a.length; c++)b = Va(b, a[c]);
        }
        return b;
    };
    k.set = function(a, b) {
        be(this);
        this.c = null;
        a = ee(this, a);
        ge(this, a) && (this.b -= this.a.get(a).length);
        this.a.set(a, [
            b
        ]);
        this.b += 1;
        return this;
    };
    k.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function de(a, b, c) {
        fe(a, b);
        0 < c.length && (a.c = null, a.a.set(ee(a, b), Wa(c)), a.b += c.length);
    }
    k.toString = function() {
        if (this.c) return this.c;
        if (!this.a) return "";
        for(var a = [], b = this.a.X(), c = 0; c < b.length; c++){
            var d = b[c], e = encodeURIComponent(String(d));
            d = this.V(d);
            for(var f = 0; f < d.length; f++){
                var g = e;
                "" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));
                a.push(g);
            }
        }
        return this.c = a.join("&");
    };
    function Od(a) {
        var b = new Qd;
        b.c = a.c;
        a.a && (b.a = new Fd(a.a), b.b = a.b);
        return b;
    }
    function ee(a, b) {
        b = String(b);
        a.f && (b = b.toLowerCase());
        return b;
    }
    function Wd(a, b) {
        b && !a.f && (be(a), a.c = null, a.a.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (fe(this, d), de(this, e, c));
        }, a));
        a.f = b;
    }
    function he(a) {
        var b = [];
        ie(new je, a, b);
        return b.join("");
    }
    function je() {}
    function ie(a, b, c) {
        if (null == b) c.push("null");
        else {
            if ("object" == typeof b) {
                if (Array.isArray(b)) {
                    var d = b;
                    b = d.length;
                    c.push("[");
                    for(var e = "", f = 0; f < b; f++)c.push(e), ie(a, d[f], c), e = ",";
                    c.push("]");
                    return;
                }
                if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();
                else {
                    c.push("{");
                    e = "";
                    for(d in b)Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), ke(d, c), c.push(":"), ie(a, f, c), e = ","));
                    c.push("}");
                    return;
                }
            }
            switch(typeof b){
                case "string":
                    ke(b, c);
                    break;
                case "number":
                    c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");
                    break;
                case "boolean":
                    c.push(String(b));
                    break;
                case "function":
                    c.push("null");
                    break;
                default:
                    throw Error("Unknown type: " + typeof b);
            }
        }
    }
    var le = {
        '"': '\\"',
        "\\": "\\\\",
        "/": "\\/",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "\t": "\\t",
        "\x0B": "\\u000b"
    }, me = /\uffff/.test("\uffff") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;
    function ke(a, b) {
        b.push('"', a.replace(me, function(c) {
            var d = le[c];
            d || (d = "\\u" + (c.charCodeAt(0) | 65536).toString(16).substr(1), le[c] = d);
            return d;
        }), '"');
    }
    function ne() {
        var a = I();
        return Sb && !!cc && 11 == cc || /Edge\/\d+/.test(a);
    }
    function oe() {
        return l.window && l.window.location.href || self && self.location && self.location.href || "";
    }
    function pe(a, b) {
        b = b || l.window;
        var c = "about:blank";
        a && (c = Cb(Eb(a)));
        b.location.href = c;
    }
    function qe(a, b) {
        var c = [], d;
        for(d in a)d in b ? typeof a[d] != typeof b[d] ? c.push(d) : "object" == typeof a[d] && null != a[d] && null != b[d] ? 0 < qe(a[d], b[d]).length && c.push(d) : a[d] !== b[d] && c.push(d) : c.push(d);
        for(d in b)d in a || c.push(d);
        return c;
    }
    function re() {
        var a = I();
        a = se(a) != te ? null : (a = a.match(/\sChrome\/(\d+)/i)) && 2 == a.length ? parseInt(a[1], 10) : null;
        return a && 30 > a ? !1 : !Sb || !cc || 9 < cc;
    }
    function ue(a) {
        a = (a || I()).toLowerCase();
        return a.match(/android/) || a.match(/webos/) || a.match(/iphone|ipad|ipod/) || a.match(/blackberry/) || a.match(/windows phone/) || a.match(/iemobile/) ? !0 : !1;
    }
    function ve(a) {
        a = a || l.window;
        try {
            a.close();
        } catch (b) {}
    }
    function we(a, b, c) {
        var d = Math.floor(1E9 * Math.random()).toString();
        b = b || 500;
        c = c || 600;
        var e = (window.screen.availHeight - c) / 2, f = (window.screen.availWidth - b) / 2;
        b = {
            width: b,
            height: c,
            top: 0 < e ? e : 0,
            left: 0 < f ? f : 0,
            location: !0,
            resizable: !0,
            statusbar: !0,
            toolbar: !1
        };
        c = I().toLowerCase();
        d && (b.target = d, y(c, "crios/") && (b.target = "_blank"));
        se(I()) == xe && (a = a || "http://localhost", b.scrollbars = !0);
        c = a || "";
        (a = b) || (a = {});
        d = window;
        b = c instanceof zb ? c : Eb("undefined" != typeof c.href ? c.href : String(c));
        c = a.target || c.target;
        e = [];
        for(g in a)switch(g){
            case "width":
            case "height":
            case "top":
            case "left":
                e.push(g + "=" + a[g]);
                break;
            case "target":
            case "noopener":
            case "noreferrer":
                break;
            default:
                e.push(g + "=" + (a[g] ? 1 : 0));
        }
        var g = e.join(",");
        if ((z("iPhone") && !z("iPod") && !z("iPad") || z("iPad") || z("iPod")) && d.navigator && d.navigator.standalone && c && "_self" != c) g = ic(document, "A"), mb(g, "HTMLAnchorElement"), b instanceof zb || b instanceof zb || (b = "object" == typeof b && b.ra ? b.qa() : String(b), Db.test(b) || (b = "about:invalid#zClosurez"), b = new zb(Ab, b)), g.href = Cb(b), g.setAttribute("target", c), a.noreferrer && g.setAttribute("rel", "noreferrer"), a = document.createEvent("MouseEvent"), a.initMouseEvent("click", !0, !0, d, 1), g.dispatchEvent(a), g = {};
        else if (a.noreferrer) {
            if (g = d.open("", c, g), a = Cb(b), g && (Ub && y(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'"), g.opener = null, a = Ib('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url=' + Nb(a) + '">'), d = g.document)) d.write(Hb(a)), d.close();
        } else (g = d.open(Cb(b), c, g)) && a.noopener && (g.opener = null);
        if (g) try {
            g.focus();
        } catch (h) {}
        return g;
    }
    function ye(a) {
        return new D(function(b) {
            function c() {
                Bd(2E3).then(function() {
                    if (!a || a.closed) b();
                    else return c();
                });
            }
            return c();
        });
    }
    var ze = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, Ae = /^[^@]+@[^@]+$/;
    function Be() {
        var a = null;
        return new D(function(b) {
            "complete" == l.document.readyState ? b() : (a = function() {
                b();
            }, kd(window, "load", a));
        }).o(function(b) {
            td(window, "load", a);
            throw b;
        });
    }
    function Ce() {
        return De(void 0) ? Be().then(function() {
            return new D(function(a, b) {
                var c = l.document, d = setTimeout(function() {
                    b(Error("Cordova framework is not ready."));
                }, 1E3);
                c.addEventListener("deviceready", function() {
                    clearTimeout(d);
                    a();
                }, !1);
            });
        }) : F(Error("Cordova must run in an Android or iOS file scheme."));
    }
    function De(a) {
        a = a || I();
        return !("file:" !== Ee() && "ionic:" !== Ee() || !a.toLowerCase().match(/iphone|ipad|ipod|android/));
    }
    function Fe() {
        var a = l.window;
        try {
            return !(!a || a == a.top);
        } catch (b) {
            return !1;
        }
    }
    function Ge() {
        return "undefined" !== typeof l.WorkerGlobalScope && "function" === typeof l.importScripts;
    }
    function He() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.hasOwnProperty("reactNative") ? "ReactNative" : (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.hasOwnProperty("node") ? "Node" : Ge() ? "Worker" : "Browser";
    }
    function Ie() {
        var a = He();
        return "ReactNative" === a || "Node" === a;
    }
    function Je() {
        for(var a = 50, b = []; 0 < a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
        return b.join("");
    }
    var xe = "Firefox", te = "Chrome";
    function se(a) {
        var b = a.toLowerCase();
        if (y(b, "opera/") || y(b, "opr/") || y(b, "opios/")) return "Opera";
        if (y(b, "iemobile")) return "IEMobile";
        if (y(b, "msie") || y(b, "trident/")) return "IE";
        if (y(b, "edge/")) return "Edge";
        if (y(b, "firefox/")) return xe;
        if (y(b, "silk/")) return "Silk";
        if (y(b, "blackberry")) return "Blackberry";
        if (y(b, "webos")) return "Webos";
        if (!y(b, "safari/") || y(b, "chrome/") || y(b, "crios/") || y(b, "android")) {
            if (!y(b, "chrome/") && !y(b, "crios/") || y(b, "edge/")) {
                if (y(b, "android")) return "Android";
                if ((a = a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/)) && 2 == a.length) return a[1];
            } else return te;
        } else return "Safari";
        return "Other";
    }
    var Ke = {
        jd: "FirebaseCore-web",
        ld: "FirebaseUI-web"
    };
    function Le(a, b) {
        b = b || [];
        var c = [], d = {}, e;
        for(e in Ke)d[Ke[e]] = !0;
        for(e = 0; e < b.length; e++)"undefined" !== typeof d[b[e]] && (delete d[b[e]], c.push(b[e]));
        c.sort();
        b = c;
        b.length || (b = [
            "FirebaseCore-web"
        ]);
        c = He();
        "Browser" === c ? (d = I(), c = se(d)) : "Worker" === c && (d = I(), c = se(d) + "-" + c);
        return c + "/JsCore/" + a + "/" + b.join(",");
    }
    function I() {
        return l.navigator && l.navigator.userAgent || "";
    }
    function J(a, b) {
        a = a.split(".");
        b = b || l;
        for(var c = 0; c < a.length && "object" == typeof b && null != b; c++)b = b[a[c]];
        c != a.length && (b = void 0);
        return b;
    }
    function Me() {
        try {
            var a = l.localStorage, b = Ne();
            if (a) return a.setItem(b, "1"), a.removeItem(b), ne() ? !!l.indexedDB : !0;
        } catch (c) {
            return Ge() && !!l.indexedDB;
        }
        return !1;
    }
    function Oe() {
        return (Pe() || "chrome-extension:" === Ee() || De()) && !Ie() && Me() && !Ge();
    }
    function Pe() {
        return "http:" === Ee() || "https:" === Ee();
    }
    function Ee() {
        return l.location && l.location.protocol || null;
    }
    function Qe(a) {
        a = a || I();
        return ue(a) || se(a) == xe ? !1 : !0;
    }
    function Re(a) {
        return "undefined" === typeof a ? null : he(a);
    }
    function Se(a) {
        var b = {}, c;
        for(c in a)a.hasOwnProperty(c) && null !== a[c] && void 0 !== a[c] && (b[c] = a[c]);
        return b;
    }
    function Te(a) {
        if (null !== a) return JSON.parse(a);
    }
    function Ne(a) {
        return a ? a : Math.floor(1E9 * Math.random()).toString();
    }
    function Ue(a) {
        a = a || I();
        return "Safari" == se(a) || a.toLowerCase().match(/iphone|ipad|ipod/) ? !1 : !0;
    }
    function Ve() {
        var a = l.___jsl;
        if (a && a.H) {
            for(var b in a.H)if (a.H[b].r = a.H[b].r || [], a.H[b].L = a.H[b].L || [], a.H[b].r = a.H[b].L.concat(), a.CP) for(var c = 0; c < a.CP.length; c++)a.CP[c] = null;
        }
    }
    function We(a, b) {
        if (a > b) throw Error("Short delay should be less than long delay!");
        this.a = a;
        this.c = b;
        a = I();
        b = He();
        this.b = ue(a) || "ReactNative" === b;
    }
    We.prototype.get = function() {
        var a = l.navigator;
        return (a && "boolean" === typeof a.onLine && (Pe() || "chrome-extension:" === Ee() || "undefined" !== typeof a.connection) ? a.onLine : 1) ? this.b ? this.c : this.a : Math.min(5E3, this.a);
    };
    function Xe() {
        var a = l.document;
        return a && "undefined" !== typeof a.visibilityState ? "visible" == a.visibilityState : !0;
    }
    function Ye() {
        var a = l.document, b = null;
        return Xe() || !a ? E() : new D(function(c) {
            b = function() {
                Xe() && (a.removeEventListener("visibilitychange", b, !1), c());
            };
            a.addEventListener("visibilitychange", b, !1);
        }).o(function(c) {
            a.removeEventListener("visibilitychange", b, !1);
            throw c;
        });
    }
    function Ze(a) {
        try {
            var b = new Date(parseInt(a, 10));
            if (!isNaN(b.getTime()) && !/[^0-9]/.test(a)) return b.toUTCString();
        } catch (c) {}
        return null;
    }
    function $e() {
        return !(!J("fireauth.oauthhelper", l) && !J("fireauth.iframe", l));
    }
    function af() {
        var a = l.navigator;
        return a && a.serviceWorker && a.serviceWorker.controller || null;
    }
    function bf() {
        var a = l.navigator;
        return a && a.serviceWorker ? E().then(function() {
            return a.serviceWorker.ready;
        }).then(function(b) {
            return b.active || null;
        }).o(function() {
            return null;
        }) : E(null);
    }
    var cf = {};
    function df(a) {
        cf[a] || (cf[a] = !0, "undefined" !== typeof console && "function" === typeof console.warn && console.warn(a));
    }
    var ef;
    try {
        var ff = {};
        Object.defineProperty(ff, "abcd", {
            configurable: !0,
            enumerable: !0,
            value: 1
        });
        Object.defineProperty(ff, "abcd", {
            configurable: !0,
            enumerable: !0,
            value: 2
        });
        ef = 2 == ff.abcd;
    } catch (a) {
        ef = !1;
    }
    function K(a, b, c) {
        ef ? Object.defineProperty(a, b, {
            configurable: !0,
            enumerable: !0,
            value: c
        }) : a[b] = c;
    }
    function L(a, b) {
        if (b) for(var c in b)b.hasOwnProperty(c) && K(a, c, b[c]);
    }
    function gf(a) {
        var b = {};
        L(b, a);
        return b;
    }
    function hf(a) {
        var b = {}, c;
        for(c in a)a.hasOwnProperty(c) && (b[c] = a[c]);
        return b;
    }
    function jf(a, b) {
        if (!b || !b.length) return !0;
        if (!a) return !1;
        for(var c = 0; c < b.length; c++){
            var d = a[b[c]];
            if (void 0 === d || null === d || "" === d) return !1;
        }
        return !0;
    }
    function kf(a) {
        var b = a;
        if ("object" == typeof a && null != a) {
            b = "length" in a ? [] : {};
            for(var c in a)K(b, c, kf(a[c]));
        }
        return b;
    }
    function lf(a) {
        var b = a && (a[mf] ? "phone" : null);
        if (b && a && a[nf]) {
            K(this, "uid", a[nf]);
            K(this, "displayName", a[of] || null);
            var c = null;
            a[pf] && (c = new Date(a[pf]).toUTCString());
            K(this, "enrollmentTime", c);
            K(this, "factorId", b);
        } else throw new u("internal-error", "Internal assert: invalid MultiFactorInfo object");
    }
    lf.prototype.v = function() {
        return {
            uid: this.uid,
            displayName: this.displayName,
            factorId: this.factorId,
            enrollmentTime: this.enrollmentTime
        };
    };
    function qf(a) {
        try {
            var b = new rf(a);
        } catch (c) {
            b = null;
        }
        return b;
    }
    var of = "displayName", pf = "enrolledAt", nf = "mfaEnrollmentId", mf = "phoneInfo";
    function rf(a) {
        lf.call(this, a);
        K(this, "phoneNumber", a[mf]);
    }
    t(rf, lf);
    rf.prototype.v = function() {
        var a = rf.Za.v.call(this);
        a.phoneNumber = this.phoneNumber;
        return a;
    };
    function sf(a) {
        var b = {}, c = a[tf], d = a[uf], e = a[vf];
        a = qf(a[wf]);
        if (!e || e != xf && e != yf && !c || e == yf && !d || e == zf && !a) throw Error("Invalid checkActionCode response!");
        e == yf ? (b[Af] = c || null, b[Bf] = c || null, b[Cf] = d) : (b[Af] = d || null, b[Bf] = d || null, b[Cf] = c || null);
        b[Df] = a || null;
        K(this, Ef, e);
        K(this, Ff, kf(b));
    }
    var zf = "REVERT_SECOND_FACTOR_ADDITION", xf = "EMAIL_SIGNIN", yf = "VERIFY_AND_CHANGE_EMAIL", tf = "email", wf = "mfaInfo", uf = "newEmail", vf = "requestType", Cf = "email", Af = "fromEmail", Df = "multiFactorInfo", Bf = "previousEmail", Ff = "data", Ef = "operation";
    function Gf(a) {
        a = Zd(a);
        var b = Yd(a, Hf) || null, c = Yd(a, If) || null, d = Yd(a, Jf) || null;
        d = d ? Kf[d] || null : null;
        if (!b || !c || !d) throw new u("argument-error", Hf + ", " + If + "and " + Jf + " are required in a valid action code URL.");
        L(this, {
            apiKey: b,
            operation: d,
            code: c,
            continueUrl: Yd(a, Lf) || null,
            languageCode: Yd(a, Mf) || null,
            tenantId: Yd(a, Nf) || null
        });
    }
    var Hf = "apiKey", If = "oobCode", Lf = "continueUrl", Mf = "languageCode", Jf = "mode", Nf = "tenantId", Kf = {
        recoverEmail: "RECOVER_EMAIL",
        resetPassword: "PASSWORD_RESET",
        revertSecondFactorAddition: zf,
        signIn: xf,
        verifyAndChangeEmail: yf,
        verifyEmail: "VERIFY_EMAIL"
    };
    function Of(a) {
        try {
            return new Gf(a);
        } catch (b) {
            return null;
        }
    }
    function Pf(a) {
        var b = a[Qf];
        if ("undefined" === typeof b) throw new u("missing-continue-uri");
        if ("string" !== typeof b || "string" === typeof b && !b.length) throw new u("invalid-continue-uri");
        this.h = b;
        this.b = this.a = null;
        this.g = !1;
        var c = a[Rf];
        if (c && "object" === typeof c) {
            b = c[Sf];
            var d = c[Tf];
            c = c[Uf];
            if ("string" === typeof b && b.length) {
                this.a = b;
                if ("undefined" !== typeof d && "boolean" !== typeof d) throw new u("argument-error", Tf + " property must be a boolean when specified.");
                this.g = !!d;
                if ("undefined" !== typeof c && ("string" !== typeof c || "string" === typeof c && !c.length)) throw new u("argument-error", Uf + " property must be a non empty string when specified.");
                this.b = c || null;
            } else {
                if ("undefined" !== typeof b) throw new u("argument-error", Sf + " property must be a non empty string when specified.");
                if ("undefined" !== typeof d || "undefined" !== typeof c) throw new u("missing-android-pkg-name");
            }
        } else if ("undefined" !== typeof c) throw new u("argument-error", Rf + " property must be a non null object when specified.");
        this.f = null;
        if ((b = a[Vf]) && "object" === typeof b) {
            if (b = b[Wf], "string" === typeof b && b.length) this.f = b;
            else {
                if ("undefined" !== typeof b) throw new u("argument-error", Wf + " property must be a non empty string when specified.");
            }
        } else if ("undefined" !== typeof b) throw new u("argument-error", Vf + " property must be a non null object when specified.");
        b = a[Xf];
        if ("undefined" !== typeof b && "boolean" !== typeof b) throw new u("argument-error", Xf + " property must be a boolean when specified.");
        this.c = !!b;
        a = a[Yf];
        if ("undefined" !== typeof a && ("string" !== typeof a || "string" === typeof a && !a.length)) throw new u("argument-error", Yf + " property must be a non empty string when specified.");
        this.i = a || null;
    }
    var Rf = "android", Yf = "dynamicLinkDomain", Xf = "handleCodeInApp", Vf = "iOS", Qf = "url", Tf = "installApp", Uf = "minimumVersion", Sf = "packageName", Wf = "bundleId";
    function Zf(a) {
        var b = {};
        b.continueUrl = a.h;
        b.canHandleCodeInApp = a.c;
        if (b.androidPackageName = a.a) b.androidMinimumVersion = a.b, b.androidInstallApp = a.g;
        b.iOSBundleId = a.f;
        b.dynamicLinkDomain = a.i;
        for(var c in b)null === b[c] && delete b[c];
        return b;
    }
    function $f(a) {
        return Oa(a, function(b) {
            b = b.toString(16);
            return 1 < b.length ? b : "0" + b;
        }).join("");
    }
    var ag = null;
    function bg(a) {
        var b = "";
        cg(a, function(c) {
            b += String.fromCharCode(c);
        });
        return b;
    }
    function cg(a, b) {
        function c(m) {
            for(; d < a.length;){
                var p = a.charAt(d++), v = ag[p];
                if (null != v) return v;
                if (!/^[\s\xa0]*$/.test(p)) throw Error("Unknown base64 encoding at char: " + p);
            }
            return m;
        }
        dg();
        for(var d = 0;;){
            var e = c(-1), f = c(0), g = c(64), h = c(64);
            if (64 === h && -1 === e) break;
            b(e << 2 | f >> 4);
            64 != g && (b(f << 4 & 240 | g >> 2), 64 != h && b(g << 6 & 192 | h));
        }
    }
    function dg() {
        if (!ag) {
            ag = {};
            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                "+/=",
                "+/",
                "-_=",
                "-_.",
                "-_"
            ], c = 0; 5 > c; c++)for(var d = a.concat(b[c].split("")), e = 0; e < d.length; e++){
                var f = d[e];
                void 0 === ag[f] && (ag[f] = e);
            }
        }
    }
    function eg(a) {
        var b = fg(a);
        if (!(b && b.sub && b.iss && b.aud && b.exp)) throw Error("Invalid JWT");
        this.g = a;
        this.c = b.exp;
        this.h = b.sub;
        ta();
        this.a = b.provider_id || b.firebase && b.firebase.sign_in_provider || null;
        this.f = b.firebase && b.firebase.tenant || null;
        this.b = !!b.is_anonymous || "anonymous" == this.a;
    }
    eg.prototype.S = function() {
        return this.f;
    };
    eg.prototype.i = function() {
        return this.b;
    };
    eg.prototype.toString = function() {
        return this.g;
    };
    function gg(a) {
        try {
            return new eg(a);
        } catch (b) {
            return null;
        }
    }
    function fg(a) {
        if (!a) return null;
        a = a.split(".");
        if (3 != a.length) return null;
        a = a[1];
        for(var b = (4 - a.length % 4) % 4, c = 0; c < b; c++)a += ".";
        try {
            return JSON.parse(bg(a));
        } catch (d) {}
        return null;
    }
    var hg = "oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "), ig = [
        "client_id",
        "response_type",
        "scope",
        "redirect_uri",
        "state"
    ], jg = {
        kd: {
            Ha: "locale",
            ta: 700,
            sa: 600,
            ea: "facebook.com",
            Va: ig
        },
        md: {
            Ha: null,
            ta: 500,
            sa: 750,
            ea: "github.com",
            Va: ig
        },
        nd: {
            Ha: "hl",
            ta: 515,
            sa: 680,
            ea: "google.com",
            Va: ig
        },
        td: {
            Ha: "lang",
            ta: 485,
            sa: 705,
            ea: "twitter.com",
            Va: hg
        },
        gd: {
            Ha: "locale",
            ta: 640,
            sa: 600,
            ea: "apple.com",
            Va: []
        }
    };
    function kg(a) {
        for(var b in jg)if (jg[b].ea == a) return jg[b];
        return null;
    }
    function lg(a) {
        var b = {};
        b["facebook.com"] = mg;
        b["google.com"] = ng;
        b["github.com"] = og;
        b["twitter.com"] = pg;
        var c = a && a[qg];
        try {
            if (c) return b[c] ? new b[c](a) : new rg(a);
            if ("undefined" !== typeof a[sg]) return new tg(a);
        } catch (d) {}
        return null;
    }
    var sg = "idToken", qg = "providerId";
    function tg(a) {
        var b = a[qg];
        if (!b && a[sg]) {
            var c = gg(a[sg]);
            c && c.a && (b = c.a);
        }
        if (!b) throw Error("Invalid additional user info!");
        if ("anonymous" == b || "custom" == b) b = null;
        c = !1;
        "undefined" !== typeof a.isNewUser ? c = !!a.isNewUser : "identitytoolkit#SignupNewUserResponse" === a.kind && (c = !0);
        K(this, "providerId", b);
        K(this, "isNewUser", c);
    }
    function rg(a) {
        tg.call(this, a);
        a = Te(a.rawUserInfo || "{}");
        K(this, "profile", kf(a || {}));
    }
    t(rg, tg);
    function mg(a) {
        rg.call(this, a);
        if ("facebook.com" != this.providerId) throw Error("Invalid provider ID!");
    }
    t(mg, rg);
    function og(a) {
        rg.call(this, a);
        if ("github.com" != this.providerId) throw Error("Invalid provider ID!");
        K(this, "username", this.profile && this.profile.login || null);
    }
    t(og, rg);
    function ng(a) {
        rg.call(this, a);
        if ("google.com" != this.providerId) throw Error("Invalid provider ID!");
    }
    t(ng, rg);
    function pg(a) {
        rg.call(this, a);
        if ("twitter.com" != this.providerId) throw Error("Invalid provider ID!");
        K(this, "username", a.screenName || null);
    }
    t(pg, rg);
    function ug(a) {
        var b = Zd(a), c = Yd(b, "link"), d = Yd(Zd(c), "link");
        b = Yd(b, "deep_link_id");
        return Yd(Zd(b), "link") || b || d || c || a;
    }
    function vg(a, b) {
        if (!a && !b) throw new u("internal-error", "Internal assert: no raw session string available");
        if (a && b) throw new u("internal-error", "Internal assert: unable to determine the session type");
        this.a = a || null;
        this.b = b || null;
        this.type = this.a ? wg : xg;
    }
    var wg = "enroll", xg = "signin";
    vg.prototype.Fa = function() {
        return this.a ? E(this.a) : E(this.b);
    };
    vg.prototype.v = function() {
        return this.type == wg ? {
            multiFactorSession: {
                idToken: this.a
            }
        } : {
            multiFactorSession: {
                pendingCredential: this.b
            }
        };
    };
    function yg() {}
    yg.prototype.ia = function() {};
    yg.prototype.b = function() {};
    yg.prototype.c = function() {};
    yg.prototype.v = function() {};
    function zg(a, b) {
        return a.then(function(c) {
            if (c[Ag]) {
                var d = gg(c[Ag]);
                if (!d || b != d.h) throw new u("user-mismatch");
                return c;
            }
            throw new u("user-mismatch");
        }).o(function(c) {
            throw c && c.code && c.code == ua + "user-not-found" ? new u("user-mismatch") : c;
        });
    }
    function Bg(a, b) {
        if (b) this.a = b;
        else throw new u("internal-error", "failed to construct a credential");
        K(this, "providerId", a);
        K(this, "signInMethod", a);
    }
    Bg.prototype.ia = function(a) {
        return Cg(a, Dg(this));
    };
    Bg.prototype.b = function(a, b) {
        var c = Dg(this);
        c.idToken = b;
        return Eg(a, c);
    };
    Bg.prototype.c = function(a, b) {
        return zg(Fg(a, Dg(this)), b);
    };
    function Dg(a) {
        return {
            pendingToken: a.a,
            requestUri: "http://localhost"
        };
    }
    Bg.prototype.v = function() {
        return {
            providerId: this.providerId,
            signInMethod: this.signInMethod,
            pendingToken: this.a
        };
    };
    function Gg(a) {
        if (a && a.providerId && a.signInMethod && 0 == a.providerId.indexOf("saml.") && a.pendingToken) try {
            return new Bg(a.providerId, a.pendingToken);
        } catch (b) {}
        return null;
    }
    function Hg(a, b, c) {
        this.a = null;
        if (b.idToken || b.accessToken) b.idToken && K(this, "idToken", b.idToken), b.accessToken && K(this, "accessToken", b.accessToken), b.nonce && !b.pendingToken && K(this, "nonce", b.nonce), b.pendingToken && (this.a = b.pendingToken);
        else if (b.oauthToken && b.oauthTokenSecret) K(this, "accessToken", b.oauthToken), K(this, "secret", b.oauthTokenSecret);
        else throw new u("internal-error", "failed to construct a credential");
        K(this, "providerId", a);
        K(this, "signInMethod", c);
    }
    Hg.prototype.ia = function(a) {
        return Cg(a, Ig(this));
    };
    Hg.prototype.b = function(a, b) {
        var c = Ig(this);
        c.idToken = b;
        return Eg(a, c);
    };
    Hg.prototype.c = function(a, b) {
        var c = Ig(this);
        return zg(Fg(a, c), b);
    };
    function Ig(a) {
        var b = {};
        a.idToken && (b.id_token = a.idToken);
        a.accessToken && (b.access_token = a.accessToken);
        a.secret && (b.oauth_token_secret = a.secret);
        b.providerId = a.providerId;
        a.nonce && !a.a && (b.nonce = a.nonce);
        b = {
            postBody: ce(b).toString(),
            requestUri: "http://localhost"
        };
        a.a && (delete b.postBody, b.pendingToken = a.a);
        return b;
    }
    Hg.prototype.v = function() {
        var a = {
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
        this.idToken && (a.oauthIdToken = this.idToken);
        this.accessToken && (a.oauthAccessToken = this.accessToken);
        this.secret && (a.oauthTokenSecret = this.secret);
        this.nonce && (a.nonce = this.nonce);
        this.a && (a.pendingToken = this.a);
        return a;
    };
    function Jg(a) {
        if (a && a.providerId && a.signInMethod) {
            var b = {
                idToken: a.oauthIdToken,
                accessToken: a.oauthTokenSecret ? null : a.oauthAccessToken,
                oauthTokenSecret: a.oauthTokenSecret,
                oauthToken: a.oauthTokenSecret && a.oauthAccessToken,
                nonce: a.nonce,
                pendingToken: a.pendingToken
            };
            try {
                return new Hg(a.providerId, b, a.signInMethod);
            } catch (c) {}
        }
        return null;
    }
    function Kg(a, b) {
        this.Oc = b || [];
        L(this, {
            providerId: a,
            isOAuthProvider: !0
        });
        this.Fb = {};
        this.lb = (kg(a) || {}).Ha || null;
        this.kb = null;
    }
    Kg.prototype.Ia = function(a) {
        this.Fb = kb(a);
        return this;
    };
    function Lg(a) {
        if ("string" !== typeof a || 0 != a.indexOf("saml.")) throw new u("argument-error", 'SAML provider IDs must be prefixed with "saml."');
        Kg.call(this, a, []);
    }
    t(Lg, Kg);
    function M(a) {
        Kg.call(this, a, ig);
        this.a = [];
    }
    t(M, Kg);
    M.prototype.Aa = function(a) {
        Sa(this.a, a) || this.a.push(a);
        return this;
    };
    M.prototype.Nb = function() {
        return Wa(this.a);
    };
    M.prototype.credential = function(a, b) {
        var c;
        q(a) ? c = {
            idToken: a.idToken || null,
            accessToken: a.accessToken || null,
            nonce: a.rawNonce || null
        } : c = {
            idToken: a || null,
            accessToken: b || null
        };
        if (!c.idToken && !c.accessToken) throw new u("argument-error", "credential failed: must provide the ID token and/or the access token.");
        return new Hg(this.providerId, c, this.providerId);
    };
    function Mg() {
        M.call(this, "facebook.com");
    }
    t(Mg, M);
    K(Mg, "PROVIDER_ID", "facebook.com");
    K(Mg, "FACEBOOK_SIGN_IN_METHOD", "facebook.com");
    function Ng(a) {
        if (!a) throw new u("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
        var b = a;
        q(a) && (b = a.accessToken);
        return (new Mg).credential({
            accessToken: b
        });
    }
    function Og() {
        M.call(this, "github.com");
    }
    t(Og, M);
    K(Og, "PROVIDER_ID", "github.com");
    K(Og, "GITHUB_SIGN_IN_METHOD", "github.com");
    function Pg(a) {
        if (!a) throw new u("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
        var b = a;
        q(a) && (b = a.accessToken);
        return (new Og).credential({
            accessToken: b
        });
    }
    function Qg() {
        M.call(this, "google.com");
        this.Aa("profile");
    }
    t(Qg, M);
    K(Qg, "PROVIDER_ID", "google.com");
    K(Qg, "GOOGLE_SIGN_IN_METHOD", "google.com");
    function Rg(a, b) {
        var c = a;
        q(a) && (c = a.idToken, b = a.accessToken);
        return (new Qg).credential({
            idToken: c,
            accessToken: b
        });
    }
    function Sg() {
        Kg.call(this, "twitter.com", hg);
    }
    t(Sg, Kg);
    K(Sg, "PROVIDER_ID", "twitter.com");
    K(Sg, "TWITTER_SIGN_IN_METHOD", "twitter.com");
    function Tg(a, b) {
        var c = a;
        q(c) || (c = {
            oauthToken: a,
            oauthTokenSecret: b
        });
        if (!c.oauthToken || !c.oauthTokenSecret) throw new u("argument-error", "credential failed: expected 2 arguments (the OAuth access token and secret).");
        return new Hg("twitter.com", c, "twitter.com");
    }
    function Ug(a, b, c) {
        this.a = a;
        this.f = b;
        K(this, "providerId", "password");
        K(this, "signInMethod", c === Vg.EMAIL_LINK_SIGN_IN_METHOD ? Vg.EMAIL_LINK_SIGN_IN_METHOD : Vg.EMAIL_PASSWORD_SIGN_IN_METHOD);
    }
    Ug.prototype.ia = function(a) {
        return this.signInMethod == Vg.EMAIL_LINK_SIGN_IN_METHOD ? N(a, Wg, {
            email: this.a,
            oobCode: this.f
        }) : N(a, Xg, {
            email: this.a,
            password: this.f
        });
    };
    Ug.prototype.b = function(a, b) {
        return this.signInMethod == Vg.EMAIL_LINK_SIGN_IN_METHOD ? N(a, Yg, {
            idToken: b,
            email: this.a,
            oobCode: this.f
        }) : N(a, Zg, {
            idToken: b,
            email: this.a,
            password: this.f
        });
    };
    Ug.prototype.c = function(a, b) {
        return zg(this.ia(a), b);
    };
    Ug.prototype.v = function() {
        return {
            email: this.a,
            password: this.f,
            signInMethod: this.signInMethod
        };
    };
    function $g(a) {
        return a && a.email && a.password ? new Ug(a.email, a.password, a.signInMethod) : null;
    }
    function Vg() {
        L(this, {
            providerId: "password",
            isOAuthProvider: !1
        });
    }
    function ah(a, b) {
        b = bh(b);
        if (!b) throw new u("argument-error", "Invalid email link!");
        return new Ug(a, b.code, Vg.EMAIL_LINK_SIGN_IN_METHOD);
    }
    function bh(a) {
        a = ug(a);
        return (a = Of(a)) && a.operation === xf ? a : null;
    }
    L(Vg, {
        PROVIDER_ID: "password"
    });
    L(Vg, {
        EMAIL_LINK_SIGN_IN_METHOD: "emailLink"
    });
    L(Vg, {
        EMAIL_PASSWORD_SIGN_IN_METHOD: "password"
    });
    function ch(a) {
        if (!(a.bb && a.ab || a.Ja && a.da)) throw new u("internal-error");
        this.a = a;
        K(this, "providerId", "phone");
        this.ea = "phone";
        K(this, "signInMethod", "phone");
    }
    ch.prototype.ia = function(a) {
        return a.cb(dh(this));
    };
    ch.prototype.b = function(a, b) {
        var c = dh(this);
        c.idToken = b;
        return N(a, eh, c);
    };
    ch.prototype.c = function(a, b) {
        var c = dh(this);
        c.operation = "REAUTH";
        a = N(a, fh, c);
        return zg(a, b);
    };
    ch.prototype.v = function() {
        var a = {
            providerId: "phone"
        };
        this.a.bb && (a.verificationId = this.a.bb);
        this.a.ab && (a.verificationCode = this.a.ab);
        this.a.Ja && (a.temporaryProof = this.a.Ja);
        this.a.da && (a.phoneNumber = this.a.da);
        return a;
    };
    function gh(a) {
        if (a && "phone" === a.providerId && (a.verificationId && a.verificationCode || a.temporaryProof && a.phoneNumber)) {
            var b = {};
            x([
                "verificationId",
                "verificationCode",
                "temporaryProof",
                "phoneNumber"
            ], function(c) {
                a[c] && (b[c] = a[c]);
            });
            return new ch(b);
        }
        return null;
    }
    function dh(a) {
        return a.a.Ja && a.a.da ? {
            temporaryProof: a.a.Ja,
            phoneNumber: a.a.da
        } : {
            sessionInfo: a.a.bb,
            code: a.a.ab
        };
    }
    function hh(a) {
        try {
            this.a = a || (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).auth();
        } catch (b) {
            throw new u("argument-error", "Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");
        }
        L(this, {
            providerId: "phone",
            isOAuthProvider: !1
        });
    }
    hh.prototype.cb = function(a, b) {
        var c = this.a.b;
        return E(b.verify()).then(function(d) {
            if ("string" !== typeof d) throw new u("argument-error", "An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");
            switch(b.type){
                case "recaptcha":
                    var e = q(a) ? a.session : null, f = q(a) ? a.phoneNumber : a, g;
                    e && e.type == wg ? g = e.Fa().then(function(h) {
                        return ih(c, {
                            idToken: h,
                            phoneEnrollmentInfo: {
                                phoneNumber: f,
                                recaptchaToken: d
                            }
                        });
                    }) : e && e.type == xg ? g = e.Fa().then(function(h) {
                        return jh(c, {
                            mfaPendingCredential: h,
                            mfaEnrollmentId: a.multiFactorHint && a.multiFactorHint.uid || a.multiFactorUid,
                            phoneSignInInfo: {
                                recaptchaToken: d
                            }
                        });
                    }) : g = kh(c, {
                        phoneNumber: f,
                        recaptchaToken: d
                    });
                    return g.then(function(h) {
                        "function" === typeof b.reset && b.reset();
                        return h;
                    }, function(h) {
                        "function" === typeof b.reset && b.reset();
                        throw h;
                    });
                default:
                    throw new u("argument-error", 'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');
            }
        });
    };
    function lh(a, b) {
        if (!a) throw new u("missing-verification-id");
        if (!b) throw new u("missing-verification-code");
        return new ch({
            bb: a,
            ab: b
        });
    }
    L(hh, {
        PROVIDER_ID: "phone"
    });
    L(hh, {
        PHONE_SIGN_IN_METHOD: "phone"
    });
    function mh(a) {
        if (a.temporaryProof && a.phoneNumber) return new ch({
            Ja: a.temporaryProof,
            da: a.phoneNumber
        });
        var b = a && a.providerId;
        if (!b || "password" === b) return null;
        var c = a && a.oauthAccessToken, d = a && a.oauthTokenSecret, e = a && a.nonce, f = a && a.oauthIdToken, g = a && a.pendingToken;
        try {
            switch(b){
                case "google.com":
                    return Rg(f, c);
                case "facebook.com":
                    return Ng(c);
                case "github.com":
                    return Pg(c);
                case "twitter.com":
                    return Tg(c, d);
                default:
                    return c || d || f || g ? g ? 0 == b.indexOf("saml.") ? new Bg(b, g) : new Hg(b, {
                        pendingToken: g,
                        idToken: a.oauthIdToken,
                        accessToken: a.oauthAccessToken
                    }, b) : new M(b).credential({
                        idToken: f,
                        accessToken: c,
                        rawNonce: e
                    }) : null;
            }
        } catch (h) {
            return null;
        }
    }
    function nh(a) {
        if (!a.isOAuthProvider) throw new u("invalid-oauth-provider");
    }
    function oh(a, b, c, d, e, f, g) {
        this.c = a;
        this.b = b || null;
        this.g = c || null;
        this.f = d || null;
        this.i = f || null;
        this.h = g || null;
        this.a = e || null;
        if (this.g || this.a) {
            if (this.g && this.a) throw new u("invalid-auth-event");
            if (this.g && !this.f) throw new u("invalid-auth-event");
        } else throw new u("invalid-auth-event");
    }
    oh.prototype.getUid = function() {
        var a = [];
        a.push(this.c);
        this.b && a.push(this.b);
        this.f && a.push(this.f);
        this.h && a.push(this.h);
        return a.join("-");
    };
    oh.prototype.S = function() {
        return this.h;
    };
    oh.prototype.v = function() {
        return {
            type: this.c,
            eventId: this.b,
            urlResponse: this.g,
            sessionId: this.f,
            postBody: this.i,
            tenantId: this.h,
            error: this.a && this.a.v()
        };
    };
    function ph(a) {
        a = a || {};
        return a.type ? new oh(a.type, a.eventId, a.urlResponse, a.sessionId, a.error && wa(a.error), a.postBody, a.tenantId) : null;
    }
    function qh() {
        this.b = null;
        this.a = [];
    }
    var rh = null;
    function sh(a) {
        var b = rh;
        b.a.push(a);
        b.b || (b.b = function(c) {
            for(var d = 0; d < b.a.length; d++)b.a[d](c);
        }, a = J("universalLinks.subscribe", l), "function" === typeof a && a(null, b.b));
    }
    function th(a) {
        var b = "unauthorized-domain", c = void 0, d = Zd(a);
        a = d.b;
        d = d.f;
        "chrome-extension" == d ? c = Mb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : "http" == d || "https" == d ? c = Mb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : b = "operation-not-supported-in-this-environment";
        u.call(this, b, c);
    }
    t(th, u);
    function uh(a, b, c) {
        u.call(this, a, c);
        a = b || {};
        a.Gb && K(this, "email", a.Gb);
        a.da && K(this, "phoneNumber", a.da);
        a.credential && K(this, "credential", a.credential);
        a.Wb && K(this, "tenantId", a.Wb);
    }
    t(uh, u);
    uh.prototype.v = function() {
        var a = {
            code: this.code,
            message: this.message
        };
        this.email && (a.email = this.email);
        this.phoneNumber && (a.phoneNumber = this.phoneNumber);
        this.tenantId && (a.tenantId = this.tenantId);
        var b = this.credential && this.credential.v();
        b && B(a, b);
        return a;
    };
    uh.prototype.toJSON = function() {
        return this.v();
    };
    function vh(a) {
        if (a.code) {
            var b = a.code || "";
            0 == b.indexOf(ua) && (b = b.substring(ua.length));
            var c = {
                credential: mh(a),
                Wb: a.tenantId
            };
            if (a.email) c.Gb = a.email;
            else if (a.phoneNumber) c.da = a.phoneNumber;
            else if (!c.credential) return new u(b, a.message || void 0);
            return new uh(b, c, a.message);
        }
        return null;
    }
    function wh() {}
    wh.prototype.c = null;
    function xh(a) {
        return a.c || (a.c = a.b());
    }
    var yh;
    function zh() {}
    t(zh, wh);
    zh.prototype.a = function() {
        var a = Ah(this);
        return a ? new ActiveXObject(a) : new XMLHttpRequest;
    };
    zh.prototype.b = function() {
        var a = {};
        Ah(this) && (a[0] = !0, a[1] = !0);
        return a;
    };
    function Ah(a) {
        if (!a.f && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
            for(var b = [
                "MSXML2.XMLHTTP.6.0",
                "MSXML2.XMLHTTP.3.0",
                "MSXML2.XMLHTTP",
                "Microsoft.XMLHTTP"
            ], c = 0; c < b.length; c++){
                var d = b[c];
                try {
                    return new ActiveXObject(d), a.f = d;
                } catch (e) {}
            }
            throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
        }
        return a.f;
    }
    yh = new zh;
    function Bh() {}
    t(Bh, wh);
    Bh.prototype.a = function() {
        var a = new XMLHttpRequest;
        if ("withCredentials" in a) return a;
        if ("undefined" != typeof XDomainRequest) return new Ch;
        throw Error("Unsupported browser");
    };
    Bh.prototype.b = function() {
        return {};
    };
    function Ch() {
        this.a = new XDomainRequest;
        this.readyState = 0;
        this.onreadystatechange = null;
        this.responseType = this.responseText = this.response = "";
        this.status = -1;
        this.statusText = "";
        this.a.onload = r(this.oc, this);
        this.a.onerror = r(this.Pb, this);
        this.a.onprogress = r(this.pc, this);
        this.a.ontimeout = r(this.tc, this);
    }
    k = Ch.prototype;
    k.open = function(a, b, c) {
        if (null != c && !c) throw Error("Only async requests are supported.");
        this.a.open(a, b);
    };
    k.send = function(a) {
        if (a) {
            if ("string" == typeof a) this.a.send(a);
            else throw Error("Only string data is supported");
        } else this.a.send();
    };
    k.abort = function() {
        this.a.abort();
    };
    k.setRequestHeader = function() {};
    k.getResponseHeader = function(a) {
        return "content-type" == a.toLowerCase() ? this.a.contentType : "";
    };
    k.oc = function() {
        this.status = 200;
        this.response = this.responseText = this.a.responseText;
        Dh(this, 4);
    };
    k.Pb = function() {
        this.status = 500;
        this.response = this.responseText = "";
        Dh(this, 4);
    };
    k.tc = function() {
        this.Pb();
    };
    k.pc = function() {
        this.status = 200;
        Dh(this, 1);
    };
    function Dh(a, b) {
        a.readyState = b;
        if (a.onreadystatechange) a.onreadystatechange();
    }
    k.getAllResponseHeaders = function() {
        return "content-type: " + this.a.contentType;
    };
    function Eh(a, b, c) {
        this.reset(a, b, c, void 0, void 0);
    }
    Eh.prototype.a = null;
    var Fh = 0;
    Eh.prototype.reset = function(a, b, c, d, e) {
        "number" == typeof e || Fh++;
        d || ta();
        delete this.a;
    };
    function Gh(a) {
        this.f = a;
        this.b = this.c = this.a = null;
    }
    function Hh(a, b) {
        this.name = a;
        this.value = b;
    }
    Hh.prototype.toString = function() {
        return this.name;
    };
    var Ih = new Hh("SEVERE", 1E3), Jh = new Hh("WARNING", 900), Kh = new Hh("CONFIG", 700), Lh = new Hh("FINE", 500);
    function Mh(a) {
        if (a.c) return a.c;
        if (a.a) return Mh(a.a);
        Da("Root logger has no level set.");
        return null;
    }
    Gh.prototype.log = function(a, b, c) {
        if (a.value >= Mh(this).value) for(n(b) && (b = b()), a = new Eh(a, String(b), this.f), c && (a.a = c), c = this; c;)c = c.a;
    };
    var Nh = {}, Oh = null;
    function Ph(a) {
        Oh || (Oh = new Gh(""), Nh[""] = Oh, Oh.c = Kh);
        var b;
        if (!(b = Nh[a])) {
            b = new Gh(a);
            var c = a.lastIndexOf("."), d = a.substr(c + 1);
            c = Ph(a.substr(0, c));
            c.b || (c.b = {});
            c.b[d] = b;
            b.a = c;
            Nh[a] = b;
        }
        return b;
    }
    function Qh(a, b) {
        a && a.log(Lh, b, void 0);
    }
    function Rh(a) {
        this.f = a;
    }
    t(Rh, wh);
    Rh.prototype.a = function() {
        return new Sh(this.f);
    };
    Rh.prototype.b = function(a) {
        return function() {
            return a;
        };
    }({});
    function Sh(a) {
        G.call(this);
        this.s = a;
        this.readyState = Th;
        this.status = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.i = new Headers;
        this.b = null;
        this.m = "GET";
        this.g = "";
        this.a = !1;
        this.h = Ph("goog.net.FetchXmlHttp");
        this.l = this.c = this.f = null;
    }
    t(Sh, G);
    var Th = 0;
    k = Sh.prototype;
    k.open = function(a, b) {
        if (this.readyState != Th) throw this.abort(), Error("Error reopening a connection");
        this.m = a;
        this.g = b;
        this.readyState = 1;
        Uh(this);
    };
    k.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.a = !0;
        var b = {
            headers: this.i,
            method: this.m,
            credentials: void 0,
            cache: void 0
        };
        a && (b.body = a);
        this.s.fetch(new Request(this.g, b)).then(this.sc.bind(this), this.Sa.bind(this));
    };
    k.abort = function() {
        this.response = this.responseText = "";
        this.i = new Headers;
        this.status = 0;
        this.c && this.c.cancel("Request was aborted.");
        1 <= this.readyState && this.a && 4 != this.readyState && (this.a = !1, Vh(this, !1));
        this.readyState = Th;
    };
    k.sc = function(a) {
        this.a && (this.f = a, this.b || (this.b = a.headers, this.readyState = 2, Uh(this)), this.a && (this.readyState = 3, Uh(this), this.a && ("arraybuffer" === this.responseType ? a.arrayBuffer().then(this.qc.bind(this), this.Sa.bind(this)) : "undefined" !== typeof l.ReadableStream && "body" in a ? (this.response = this.responseText = "", this.c = a.body.getReader(), this.l = new TextDecoder, Wh(this)) : a.text().then(this.rc.bind(this), this.Sa.bind(this)))));
    };
    function Wh(a) {
        a.c.read().then(a.nc.bind(a)).catch(a.Sa.bind(a));
    }
    k.nc = function(a) {
        if (this.a) {
            var b = this.l.decode(a.value ? a.value : new Uint8Array(0), {
                stream: !a.done
            });
            b && (this.response = this.responseText += b);
            a.done ? Vh(this, !0) : Uh(this);
            3 == this.readyState && Wh(this);
        }
    };
    k.rc = function(a) {
        this.a && (this.response = this.responseText = a, Vh(this, !0));
    };
    k.qc = function(a) {
        this.a && (this.response = a, Vh(this, !0));
    };
    k.Sa = function(a) {
        var b = this.h;
        b && b.log(Jh, "Failed to fetch url " + this.g, a instanceof Error ? a : Error(a));
        this.a && Vh(this, !0);
    };
    function Vh(a, b) {
        b && a.f && (a.status = a.f.status, a.statusText = a.f.statusText);
        a.readyState = 4;
        a.f = null;
        a.c = null;
        a.l = null;
        Uh(a);
    }
    k.setRequestHeader = function(a, b) {
        this.i.append(a, b);
    };
    k.getResponseHeader = function(a) {
        return this.b ? this.b.get(a.toLowerCase()) || "" : ((a = this.h) && a.log(Jh, "Attempting to get response header but no headers have been received for url: " + this.g, void 0), "");
    };
    k.getAllResponseHeaders = function() {
        if (!this.b) {
            var a = this.h;
            a && a.log(Jh, "Attempting to get all response headers but no headers have been received for url: " + this.g, void 0);
            return "";
        }
        a = [];
        for(var b = this.b.entries(), c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Uh(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    function Xh(a) {
        G.call(this);
        this.headers = new Fd;
        this.D = a || null;
        this.c = !1;
        this.B = this.a = null;
        this.h = this.P = this.l = "";
        this.f = this.O = this.i = this.N = !1;
        this.g = 0;
        this.s = null;
        this.m = Yh;
        this.w = this.R = !1;
    }
    t(Xh, G);
    var Yh = "";
    Xh.prototype.b = Ph("goog.net.XhrIo");
    var Zh = /^https?$/i, $h = [
        "POST",
        "PUT"
    ];
    function ai(a, b, c, d, e) {
        if (a.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + a.l + "; newUri=" + b);
        c = c ? c.toUpperCase() : "GET";
        a.l = b;
        a.h = "";
        a.P = c;
        a.N = !1;
        a.c = !0;
        a.a = a.D ? a.D.a() : yh.a();
        a.B = a.D ? xh(a.D) : xh(yh);
        a.a.onreadystatechange = r(a.Sb, a);
        try {
            Qh(a.b, bi(a, "Opening Xhr")), a.O = !0, a.a.open(c, String(b), !0), a.O = !1;
        } catch (g) {
            Qh(a.b, bi(a, "Error opening Xhr: " + g.message));
            ci(a, g);
            return;
        }
        b = d || "";
        var f = new Fd(a.headers);
        e && Ed(e, function(g, h) {
            f.set(h, g);
        });
        e = Qa(f.X());
        d = l.FormData && b instanceof l.FormData;
        !Sa($h, c) || e || d || f.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        f.forEach(function(g, h) {
            this.a.setRequestHeader(h, g);
        }, a);
        a.m && (a.a.responseType = a.m);
        "withCredentials" in a.a && a.a.withCredentials !== a.R && (a.a.withCredentials = a.R);
        try {
            di(a), 0 < a.g && (a.w = ei(a.a), Qh(a.b, bi(a, "Will abort after " + a.g + "ms if incomplete, xhr2 " + a.w)), a.w ? (a.a.timeout = a.g, a.a.ontimeout = r(a.Ka, a)) : a.s = Ad(a.Ka, a.g, a)), Qh(a.b, bi(a, "Sending request")), a.i = !0, a.a.send(b), a.i = !1;
        } catch (g) {
            Qh(a.b, bi(a, "Send error: " + g.message)), ci(a, g);
        }
    }
    function ei(a) {
        return Sb && bc(9) && "number" === typeof a.timeout && void 0 !== a.ontimeout;
    }
    function Ra(a) {
        return "content-type" == a.toLowerCase();
    }
    k = Xh.prototype;
    k.Ka = function() {
        "undefined" != typeof ha && this.a && (this.h = "Timed out after " + this.g + "ms, aborting", Qh(this.b, bi(this, this.h)), this.dispatchEvent("timeout"), this.abort(8));
    };
    function ci(a, b) {
        a.c = !1;
        a.a && (a.f = !0, a.a.abort(), a.f = !1);
        a.h = b;
        fi(a);
        gi(a);
    }
    function fi(a) {
        a.N || (a.N = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
    }
    k.abort = function() {
        this.a && this.c && (Qh(this.b, bi(this, "Aborting")), this.c = !1, this.f = !0, this.a.abort(), this.f = !1, this.dispatchEvent("complete"), this.dispatchEvent("abort"), gi(this));
    };
    k.Ba = function() {
        this.a && (this.c && (this.c = !1, this.f = !0, this.a.abort(), this.f = !1), gi(this, !0));
        Xh.Za.Ba.call(this);
    };
    k.Sb = function() {
        this.wa || (this.O || this.i || this.f ? hi(this) : this.Hc());
    };
    k.Hc = function() {
        hi(this);
    };
    function hi(a) {
        if (a.c && "undefined" != typeof ha) {
            if (a.B[1] && 4 == ii(a) && 2 == ji(a)) Qh(a.b, bi(a, "Local request error detected and ignored"));
            else if (a.i && 4 == ii(a)) Ad(a.Sb, 0, a);
            else if (a.dispatchEvent("readystatechange"), 4 == ii(a)) {
                Qh(a.b, bi(a, "Request complete"));
                a.c = !1;
                try {
                    var b = ji(a);
                    a: switch(b){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var c = !0;
                            break a;
                        default:
                            c = !1;
                    }
                    var d;
                    if (!(d = c)) {
                        var e;
                        if (e = 0 === b) {
                            var f = String(a.l).match(Id)[1] || null;
                            if (!f && l.self && l.self.location) {
                                var g = l.self.location.protocol;
                                f = g.substr(0, g.length - 1);
                            }
                            e = !Zh.test(f ? f.toLowerCase() : "");
                        }
                        d = e;
                    }
                    if (d) a.dispatchEvent("complete"), a.dispatchEvent("success");
                    else {
                        try {
                            var h = 2 < ii(a) ? a.a.statusText : "";
                        } catch (m) {
                            Qh(a.b, "Can not get status: " + m.message), h = "";
                        }
                        a.h = h + " [" + ji(a) + "]";
                        fi(a);
                    }
                } finally{
                    gi(a);
                }
            }
        }
    }
    function gi(a, b) {
        if (a.a) {
            di(a);
            var c = a.a, d = a.B[0] ? ka : null;
            a.a = null;
            a.B = null;
            b || a.dispatchEvent("ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {
                (a = a.b) && a.log(Ih, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
            }
        }
    }
    function di(a) {
        a.a && a.w && (a.a.ontimeout = null);
        a.s && (l.clearTimeout(a.s), a.s = null);
    }
    function ii(a) {
        return a.a ? a.a.readyState : 0;
    }
    function ji(a) {
        try {
            return 2 < ii(a) ? a.a.status : -1;
        } catch (b) {
            return -1;
        }
    }
    function ki(a) {
        try {
            return a.a ? a.a.responseText : "";
        } catch (b) {
            return Qh(a.b, "Can not get responseText: " + b.message), "";
        }
    }
    k.getResponse = function() {
        try {
            if (!this.a) return null;
            if ("response" in this.a) return this.a.response;
            switch(this.m){
                case Yh:
                case "text":
                    return this.a.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in this.a) return this.a.mozResponseArrayBuffer;
            }
            var a = this.b;
            a && a.log(Ih, "Response type " + this.m + " is not supported on this browser", void 0);
            return null;
        } catch (b) {
            return Qh(this.b, "Can not get response: " + b.message), null;
        }
    };
    function bi(a, b) {
        return b + " [" + a.P + " " + a.l + " " + ji(a) + "]";
    }
    function li(a) {
        var b = mi;
        this.g = [];
        this.w = b;
        this.s = a || null;
        this.f = this.a = !1;
        this.c = void 0;
        this.u = this.B = this.i = !1;
        this.h = 0;
        this.b = null;
        this.l = 0;
    }
    li.prototype.cancel = function(a) {
        if (this.a) this.c instanceof li && this.c.cancel();
        else {
            if (this.b) {
                var b = this.b;
                delete this.b;
                a ? b.cancel(a) : (b.l--, 0 >= b.l && b.cancel());
            }
            this.w ? this.w.call(this.s, this) : this.u = !0;
            this.a || (a = new ni(this), oi(this), pi(this, !1, a));
        }
    };
    li.prototype.m = function(a, b) {
        this.i = !1;
        pi(this, a, b);
    };
    function pi(a, b, c) {
        a.a = !0;
        a.c = c;
        a.f = !b;
        qi(a);
    }
    function oi(a) {
        if (a.a) {
            if (!a.u) throw new ri(a);
            a.u = !1;
        }
    }
    function si(a, b) {
        ti(a, null, b, void 0);
    }
    function ti(a, b, c, d) {
        a.g.push([
            b,
            c,
            d
        ]);
        a.a && qi(a);
    }
    li.prototype.then = function(a, b, c) {
        var d, e, f = new D(function(g, h) {
            d = g;
            e = h;
        });
        ti(this, d, function(g) {
            g instanceof ni ? f.cancel() : e(g);
        });
        return f.then(a, b, c);
    };
    li.prototype.$goog_Thenable = !0;
    function ui(a) {
        return Pa(a.g, function(b) {
            return n(b[1]);
        });
    }
    function qi(a) {
        if (a.h && a.a && ui(a)) {
            var b = a.h, c = vi[b];
            c && (l.clearTimeout(c.a), delete vi[b]);
            a.h = 0;
        }
        a.b && (a.b.l--, delete a.b);
        b = a.c;
        for(var d = c = !1; a.g.length && !a.i;){
            var e = a.g.shift(), f = e[0], g = e[1];
            e = e[2];
            if (f = a.f ? g : f) try {
                var h = f.call(e || a.s, b);
                void 0 !== h && (a.f = a.f && (h == b || h instanceof Error), a.c = b = h);
                if (Ba(b) || "function" === typeof l.Promise && b instanceof l.Promise) d = !0, a.i = !0;
            } catch (m) {
                b = m, a.f = !0, ui(a) || (c = !0);
            }
        }
        a.c = b;
        d && (h = r(a.m, a, !0), d = r(a.m, a, !1), b instanceof li ? (ti(b, h, d), b.B = !0) : b.then(h, d));
        c && (b = new wi(b), vi[b.a] = b, a.h = b.a);
    }
    function ri() {
        w.call(this);
    }
    t(ri, w);
    ri.prototype.message = "Deferred has already fired";
    ri.prototype.name = "AlreadyCalledError";
    function ni() {
        w.call(this);
    }
    t(ni, w);
    ni.prototype.message = "Deferred was canceled";
    ni.prototype.name = "CanceledError";
    function wi(a) {
        this.a = l.setTimeout(r(this.c, this), 0);
        this.b = a;
    }
    wi.prototype.c = function() {
        delete vi[this.a];
        throw this.b;
    };
    var vi = {};
    function xi(a) {
        var b = {}, c = b.document || document, d = vb(a).toString(), e = ic(document, "SCRIPT"), f = {
            Tb: e,
            Ka: void 0
        }, g = new li(f), h = null, m = null != b.timeout ? b.timeout : 5E3;
        0 < m && (h = window.setTimeout(function() {
            yi(e, !0);
            var p = new zi(Ai, "Timeout reached for loading script " + d);
            oi(g);
            pi(g, !1, p);
        }, m), f.Ka = h);
        e.onload = e.onreadystatechange = function() {
            e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (yi(e, b.ud || !1, h), oi(g), pi(g, !0, null));
        };
        e.onerror = function() {
            yi(e, !0, h);
            var p = new zi(Bi, "Error while loading script " + d);
            oi(g);
            pi(g, !1, p);
        };
        f = b.attributes || {};
        B(f, {
            type: "text/javascript",
            charset: "UTF-8"
        });
        fc(e, f);
        Lb(e, a);
        Ci(c).appendChild(e);
        return g;
    }
    function Ci(a) {
        var b;
        return (b = (a || document).getElementsByTagName("HEAD")) && 0 != b.length ? b[0] : a.documentElement;
    }
    function mi() {
        if (this && this.Tb) {
            var a = this.Tb;
            a && "SCRIPT" == a.tagName && yi(a, !0, this.Ka);
        }
    }
    function yi(a, b, c) {
        null != c && l.clearTimeout(c);
        a.onload = ka;
        a.onerror = ka;
        a.onreadystatechange = ka;
        b && window.setTimeout(function() {
            a && a.parentNode && a.parentNode.removeChild(a);
        }, 0);
    }
    var Bi = 0, Ai = 1;
    function zi(a, b) {
        var c = "Jsloader error (code #" + a + ")";
        b && (c += ": " + b);
        w.call(this, c);
        this.code = a;
    }
    t(zi, w);
    function Di(a) {
        this.f = a;
    }
    t(Di, wh);
    Di.prototype.a = function() {
        return new this.f;
    };
    Di.prototype.b = function() {
        return {};
    };
    function Ei(a, b, c) {
        this.c = a;
        a = b || {};
        this.u = a.secureTokenEndpoint || "https://securetoken.googleapis.com/v1/token";
        this.m = a.secureTokenTimeout || Fi;
        this.g = kb(a.secureTokenHeaders || Gi);
        this.h = a.firebaseEndpoint || "https://www.googleapis.com/identitytoolkit/v3/relyingparty/";
        this.l = a.identityPlatformEndpoint || "https://identitytoolkit.googleapis.com/v2/";
        this.i = a.firebaseTimeout || Hi;
        this.a = kb(a.firebaseHeaders || Ii);
        c && (this.a["X-Client-Version"] = c, this.g["X-Client-Version"] = c);
        c = "Node" == He();
        c = l.XMLHttpRequest || c && (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.node && (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.node.XMLHttpRequest;
        if (!c && !Ge()) throw new u("internal-error", "The XMLHttpRequest compatibility library was not found.");
        this.f = void 0;
        Ge() ? this.f = new Rh(self) : Ie() ? this.f = new Di(c) : this.f = new Bh;
        this.b = null;
    }
    var Ji, Ag = "idToken", Fi = new We(3E4, 6E4), Gi = {
        "Content-Type": "application/x-www-form-urlencoded"
    }, Hi = new We(3E4, 6E4), Ii = {
        "Content-Type": "application/json"
    };
    function Ki(a, b) {
        b ? a.a["X-Firebase-Locale"] = b : delete a.a["X-Firebase-Locale"];
    }
    function Li(a, b) {
        b ? (a.a["X-Client-Version"] = b, a.g["X-Client-Version"] = b) : (delete a.a["X-Client-Version"], delete a.g["X-Client-Version"]);
    }
    Ei.prototype.S = function() {
        return this.b;
    };
    function Mi(a, b, c, d, e, f, g) {
        re() || Ge() ? a = r(a.w, a) : (Ji || (Ji = new D(function(h, m) {
            Ni(h, m);
        })), a = r(a.s, a));
        a(b, c, d, e, f, g);
    }
    Ei.prototype.w = function(a, b, c, d, e, f) {
        if (Ge() && ("undefined" === typeof l.fetch || "undefined" === typeof l.Headers || "undefined" === typeof l.Request)) throw new u("operation-not-supported-in-this-environment", "fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");
        var g = new Xh(this.f);
        if (f) {
            g.g = Math.max(0, f);
            var h = setTimeout(function() {
                g.dispatchEvent("timeout");
            }, f);
        }
        md(g, "complete", function() {
            h && clearTimeout(h);
            var m = null;
            try {
                m = JSON.parse(ki(this)) || null;
            } catch (p) {
                m = null;
            }
            b && b(m);
        });
        sd(g, "ready", function() {
            h && clearTimeout(h);
            Sc(this);
        });
        sd(g, "timeout", function() {
            h && clearTimeout(h);
            Sc(this);
            b && b(null);
        });
        ai(g, a, c, d, e);
    };
    var Oi = new nb(ob, "https://apis.google.com/js/client.js?onload=%{onload}"), Pi = "__fcb" + Math.floor(1E6 * Math.random()).toString();
    function Ni(a, b) {
        if (((window.gapi || {}).client || {}).request) a();
        else {
            l[Pi] = function() {
                ((window.gapi || {}).client || {}).request ? a() : b(Error("CORS_UNSUPPORTED"));
            };
            var c = wb(Oi, {
                onload: Pi
            });
            si(xi(c), function() {
                b(Error("CORS_UNSUPPORTED"));
            });
        }
    }
    Ei.prototype.s = function(a, b, c, d, e) {
        var f = this;
        Ji.then(function() {
            window.gapi.client.setApiKey(f.c);
            var g = window.gapi.auth.getToken();
            window.gapi.auth.setToken(null);
            window.gapi.client.request({
                path: a,
                method: c,
                body: d,
                headers: e,
                authType: "none",
                callback: function(h) {
                    window.gapi.auth.setToken(g);
                    b && b(h);
                }
            });
        }).o(function(g) {
            b && b({
                error: {
                    message: g && g.message || "CORS_UNSUPPORTED"
                }
            });
        });
    };
    function Qi(a, b) {
        return new D(function(c, d) {
            "refresh_token" == b.grant_type && b.refresh_token || "authorization_code" == b.grant_type && b.code ? Mi(a, a.u + "?key=" + encodeURIComponent(a.c), function(e) {
                e ? e.error ? d(Ri(e)) : e.access_token && e.refresh_token ? c(e) : d(new u("internal-error")) : d(new u("network-request-failed"));
            }, "POST", ce(b).toString(), a.g, a.m.get()) : d(new u("internal-error"));
        });
    }
    function Si(a, b, c, d, e, f, g) {
        var h = Zd(b + c);
        H(h, "key", a.c);
        g && H(h, "cb", ta().toString());
        var m = "GET" == d;
        if (m) for(var p in e)e.hasOwnProperty(p) && H(h, p, e[p]);
        return new D(function(v, C) {
            Mi(a, h.toString(), function(A) {
                A ? A.error ? C(Ri(A, f || {})) : v(A) : C(new u("network-request-failed"));
            }, d, m ? void 0 : he(Se(e)), a.a, a.i.get());
        });
    }
    function Ti(a) {
        a = a.email;
        if ("string" !== typeof a || !Ae.test(a)) throw new u("invalid-email");
    }
    function Ui(a) {
        "email" in a && Ti(a);
    }
    function Vi(a, b) {
        return N(a, Wi, {
            identifier: b,
            continueUri: Pe() ? oe() : "http://localhost"
        }).then(function(c) {
            return c.signinMethods || [];
        });
    }
    function Xi(a) {
        return N(a, Yi, {}).then(function(b) {
            return b.authorizedDomains || [];
        });
    }
    function O(a) {
        if (!a[Ag]) {
            if (a.mfaPendingCredential) throw new u("multi-factor-auth-required", null, kb(a));
            throw new u("internal-error");
        }
    }
    function Zi(a) {
        if (a.phoneNumber || a.temporaryProof) {
            if (!a.phoneNumber || !a.temporaryProof) throw new u("internal-error");
        } else {
            if (!a.sessionInfo) throw new u("missing-verification-id");
            if (!a.code) throw new u("missing-verification-code");
        }
    }
    Ei.prototype.vb = function() {
        return N(this, $i, {});
    };
    Ei.prototype.xb = function(a, b) {
        return N(this, aj, {
            idToken: a,
            email: b
        });
    };
    Ei.prototype.yb = function(a, b) {
        return N(this, Zg, {
            idToken: a,
            password: b
        });
    };
    var bj = {
        displayName: "DISPLAY_NAME",
        photoUrl: "PHOTO_URL"
    };
    k = Ei.prototype;
    k.zb = function(a, b) {
        var c = {
            idToken: a
        }, d = [];
        ib(bj, function(e, f) {
            var g = b[f];
            null === g ? d.push(e) : f in b && (c[f] = g);
        });
        d.length && (c.deleteAttribute = d);
        return N(this, aj, c);
    };
    k.rb = function(a, b) {
        a = {
            requestType: "PASSWORD_RESET",
            email: a
        };
        B(a, b);
        return N(this, cj, a);
    };
    k.sb = function(a, b) {
        a = {
            requestType: "EMAIL_SIGNIN",
            email: a
        };
        B(a, b);
        return N(this, dj, a);
    };
    k.qb = function(a, b) {
        a = {
            requestType: "VERIFY_EMAIL",
            idToken: a
        };
        B(a, b);
        return N(this, ej, a);
    };
    k.Ab = function(a, b, c) {
        a = {
            requestType: "VERIFY_AND_CHANGE_EMAIL",
            idToken: a,
            newEmail: b
        };
        B(a, c);
        return N(this, fj, a);
    };
    function kh(a, b) {
        return N(a, gj, b);
    }
    k.cb = function(a) {
        return N(this, hj, a);
    };
    function ih(a, b) {
        return N(a, ij, b).then(function(c) {
            return c.phoneSessionInfo.sessionInfo;
        });
    }
    function jj(a) {
        if (!a.phoneVerificationInfo) throw new u("internal-error");
        if (!a.phoneVerificationInfo.sessionInfo) throw new u("missing-verification-id");
        if (!a.phoneVerificationInfo.code) throw new u("missing-verification-code");
    }
    function jh(a, b) {
        return N(a, kj, b).then(function(c) {
            return c.phoneResponseInfo.sessionInfo;
        });
    }
    function lj(a, b, c) {
        return N(a, mj, {
            idToken: b,
            deleteProvider: c
        });
    }
    function nj(a) {
        if (!a.requestUri || !a.sessionId && !a.postBody && !a.pendingToken) throw new u("internal-error");
    }
    function oj(a, b) {
        b.oauthIdToken && b.providerId && 0 == b.providerId.indexOf("oidc.") && !b.pendingToken && (a.sessionId ? b.nonce = a.sessionId : a.postBody && (a = new Qd(a.postBody), ge(a, "nonce") && (b.nonce = a.get("nonce"))));
        return b;
    }
    function pj(a) {
        var b = null;
        a.needConfirmation ? (a.code = "account-exists-with-different-credential", b = vh(a)) : "FEDERATED_USER_ID_ALREADY_LINKED" == a.errorMessage ? (a.code = "credential-already-in-use", b = vh(a)) : "EMAIL_EXISTS" == a.errorMessage ? (a.code = "email-already-in-use", b = vh(a)) : a.errorMessage && (b = qj(a.errorMessage));
        if (b) throw b;
        O(a);
    }
    function Cg(a, b) {
        b.returnIdpCredential = !0;
        return N(a, rj, b);
    }
    function Eg(a, b) {
        b.returnIdpCredential = !0;
        return N(a, sj, b);
    }
    function Fg(a, b) {
        b.returnIdpCredential = !0;
        b.autoCreate = !1;
        return N(a, tj, b);
    }
    function uj(a) {
        if (!a.oobCode) throw new u("invalid-action-code");
    }
    k.jb = function(a, b) {
        return N(this, vj, {
            oobCode: a,
            newPassword: b
        });
    };
    k.Pa = function(a) {
        return N(this, wj, {
            oobCode: a
        });
    };
    k.fb = function(a) {
        return N(this, xj, {
            oobCode: a
        });
    };
    var xj = {
        endpoint: "setAccountInfo",
        A: uj,
        Y: "email",
        C: !0
    }, wj = {
        endpoint: "resetPassword",
        A: uj,
        G: function(a) {
            var b = a.requestType;
            if (!b || !a.email && "EMAIL_SIGNIN" != b && "VERIFY_AND_CHANGE_EMAIL" != b) throw new u("internal-error");
        },
        C: !0
    }, yj = {
        endpoint: "signupNewUser",
        A: function(a) {
            Ti(a);
            if (!a.password) throw new u("weak-password");
        },
        G: O,
        U: !0,
        C: !0
    }, Wi = {
        endpoint: "createAuthUri",
        C: !0
    }, zj = {
        endpoint: "deleteAccount",
        M: [
            "idToken"
        ]
    }, mj = {
        endpoint: "setAccountInfo",
        M: [
            "idToken",
            "deleteProvider"
        ],
        A: function(a) {
            if ("array" != la(a.deleteProvider)) throw new u("internal-error");
        }
    }, Wg = {
        endpoint: "emailLinkSignin",
        M: [
            "email",
            "oobCode"
        ],
        A: Ti,
        G: O,
        U: !0,
        C: !0
    }, Yg = {
        endpoint: "emailLinkSignin",
        M: [
            "idToken",
            "email",
            "oobCode"
        ],
        A: Ti,
        G: O,
        U: !0
    }, Aj = {
        endpoint: "accounts/mfaEnrollment:finalize",
        M: [
            "idToken",
            "phoneVerificationInfo"
        ],
        A: jj,
        G: O,
        C: !0,
        La: !0
    }, Bj = {
        endpoint: "accounts/mfaSignIn:finalize",
        M: [
            "mfaPendingCredential",
            "phoneVerificationInfo"
        ],
        A: jj,
        G: O,
        C: !0,
        La: !0
    }, Cj = {
        endpoint: "getAccountInfo"
    }, dj = {
        endpoint: "getOobConfirmationCode",
        M: [
            "requestType"
        ],
        A: function(a) {
            if ("EMAIL_SIGNIN" != a.requestType) throw new u("internal-error");
            Ti(a);
        },
        Y: "email",
        C: !0
    }, ej = {
        endpoint: "getOobConfirmationCode",
        M: [
            "idToken",
            "requestType"
        ],
        A: function(a) {
            if ("VERIFY_EMAIL" != a.requestType) throw new u("internal-error");
        },
        Y: "email",
        C: !0
    }, fj = {
        endpoint: "getOobConfirmationCode",
        M: [
            "idToken",
            "newEmail",
            "requestType"
        ],
        A: function(a) {
            if ("VERIFY_AND_CHANGE_EMAIL" != a.requestType) throw new u("internal-error");
        },
        Y: "email",
        C: !0
    }, cj = {
        endpoint: "getOobConfirmationCode",
        M: [
            "requestType"
        ],
        A: function(a) {
            if ("PASSWORD_RESET" != a.requestType) throw new u("internal-error");
            Ti(a);
        },
        Y: "email",
        C: !0
    }, Yi = {
        hb: !0,
        endpoint: "getProjectConfig",
        Rb: "GET"
    }, Dj = {
        hb: !0,
        endpoint: "getRecaptchaParam",
        Rb: "GET",
        G: function(a) {
            if (!a.recaptchaSiteKey) throw new u("internal-error");
        }
    }, vj = {
        endpoint: "resetPassword",
        A: uj,
        Y: "email",
        C: !0
    }, gj = {
        endpoint: "sendVerificationCode",
        M: [
            "phoneNumber",
            "recaptchaToken"
        ],
        Y: "sessionInfo",
        C: !0
    }, aj = {
        endpoint: "setAccountInfo",
        M: [
            "idToken"
        ],
        A: Ui,
        U: !0
    }, Zg = {
        endpoint: "setAccountInfo",
        M: [
            "idToken"
        ],
        A: function(a) {
            Ui(a);
            if (!a.password) throw new u("weak-password");
        },
        G: O,
        U: !0
    }, $i = {
        endpoint: "signupNewUser",
        G: O,
        U: !0,
        C: !0
    }, ij = {
        endpoint: "accounts/mfaEnrollment:start",
        M: [
            "idToken",
            "phoneEnrollmentInfo"
        ],
        A: function(a) {
            if (!a.phoneEnrollmentInfo) throw new u("internal-error");
            if (!a.phoneEnrollmentInfo.phoneNumber) throw new u("missing-phone-number");
            if (!a.phoneEnrollmentInfo.recaptchaToken) throw new u("missing-app-credential");
        },
        G: function(a) {
            if (!a.phoneSessionInfo || !a.phoneSessionInfo.sessionInfo) throw new u("internal-error");
        },
        C: !0,
        La: !0
    }, kj = {
        endpoint: "accounts/mfaSignIn:start",
        M: [
            "mfaPendingCredential",
            "mfaEnrollmentId",
            "phoneSignInInfo"
        ],
        A: function(a) {
            if (!a.phoneSignInInfo || !a.phoneSignInInfo.recaptchaToken) throw new u("missing-app-credential");
        },
        G: function(a) {
            if (!a.phoneResponseInfo || !a.phoneResponseInfo.sessionInfo) throw new u("internal-error");
        },
        C: !0,
        La: !0
    }, rj = {
        endpoint: "verifyAssertion",
        A: nj,
        Wa: oj,
        G: pj,
        U: !0,
        C: !0
    }, tj = {
        endpoint: "verifyAssertion",
        A: nj,
        Wa: oj,
        G: function(a) {
            if (a.errorMessage && "USER_NOT_FOUND" == a.errorMessage) throw new u("user-not-found");
            if (a.errorMessage) throw qj(a.errorMessage);
            O(a);
        },
        U: !0,
        C: !0
    }, sj = {
        endpoint: "verifyAssertion",
        A: function(a) {
            nj(a);
            if (!a.idToken) throw new u("internal-error");
        },
        Wa: oj,
        G: pj,
        U: !0
    }, Ej = {
        endpoint: "verifyCustomToken",
        A: function(a) {
            if (!a.token) throw new u("invalid-custom-token");
        },
        G: O,
        U: !0,
        C: !0
    }, Xg = {
        endpoint: "verifyPassword",
        A: function(a) {
            Ti(a);
            if (!a.password) throw new u("wrong-password");
        },
        G: O,
        U: !0,
        C: !0
    }, hj = {
        endpoint: "verifyPhoneNumber",
        A: Zi,
        G: O,
        C: !0
    }, eh = {
        endpoint: "verifyPhoneNumber",
        A: function(a) {
            if (!a.idToken) throw new u("internal-error");
            Zi(a);
        },
        G: function(a) {
            if (a.temporaryProof) throw a.code = "credential-already-in-use", vh(a);
            O(a);
        }
    }, fh = {
        Eb: {
            USER_NOT_FOUND: "user-not-found"
        },
        endpoint: "verifyPhoneNumber",
        A: Zi,
        G: O,
        C: !0
    }, Fj = {
        endpoint: "accounts/mfaEnrollment:withdraw",
        M: [
            "idToken",
            "mfaEnrollmentId"
        ],
        G: function(a) {
            if (!!a[Ag] ^ !!a.refreshToken) throw new u("internal-error");
        },
        C: !0,
        La: !0
    };
    function N(a, b, c) {
        if (!jf(c, b.M)) return F(new u("internal-error"));
        var d = !!b.La, e = b.Rb || "POST", f;
        return E(c).then(b.A).then(function() {
            b.U && (c.returnSecureToken = !0);
            b.C && a.b && "undefined" === typeof c.tenantId && (c.tenantId = a.b);
            return d ? Si(a, a.l, b.endpoint, e, c, b.Eb, b.hb || !1) : Si(a, a.h, b.endpoint, e, c, b.Eb, b.hb || !1);
        }).then(function(g) {
            f = g;
            return b.Wa ? b.Wa(c, f) : f;
        }).then(b.G).then(function() {
            if (!b.Y) return f;
            if (!(b.Y in f)) throw new u("internal-error");
            return f[b.Y];
        });
    }
    function qj(a) {
        return Ri({
            error: {
                errors: [
                    {
                        message: a
                    }
                ],
                code: 400,
                message: a
            }
        });
    }
    function Ri(a, b) {
        var c = (a.error && a.error.errors && a.error.errors[0] || {}).reason || "";
        var d = {
            keyInvalid: "invalid-api-key",
            ipRefererBlocked: "app-not-authorized"
        };
        if (c = d[c] ? new u(d[c]) : null) return c;
        c = a.error && a.error.message || "";
        d = {
            INVALID_CUSTOM_TOKEN: "invalid-custom-token",
            CREDENTIAL_MISMATCH: "custom-token-mismatch",
            MISSING_CUSTOM_TOKEN: "internal-error",
            INVALID_IDENTIFIER: "invalid-email",
            MISSING_CONTINUE_URI: "internal-error",
            INVALID_EMAIL: "invalid-email",
            INVALID_PASSWORD: "wrong-password",
            USER_DISABLED: "user-disabled",
            MISSING_PASSWORD: "internal-error",
            EMAIL_EXISTS: "email-already-in-use",
            PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
            INVALID_IDP_RESPONSE: "invalid-credential",
            INVALID_PENDING_TOKEN: "invalid-credential",
            FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
            MISSING_OR_INVALID_NONCE: "missing-or-invalid-nonce",
            INVALID_MESSAGE_PAYLOAD: "invalid-message-payload",
            INVALID_RECIPIENT_EMAIL: "invalid-recipient-email",
            INVALID_SENDER: "invalid-sender",
            EMAIL_NOT_FOUND: "user-not-found",
            RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
            EXPIRED_OOB_CODE: "expired-action-code",
            INVALID_OOB_CODE: "invalid-action-code",
            MISSING_OOB_CODE: "internal-error",
            INVALID_PROVIDER_ID: "invalid-provider-id",
            CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
            INVALID_ID_TOKEN: "invalid-user-token",
            TOKEN_EXPIRED: "user-token-expired",
            USER_NOT_FOUND: "user-token-expired",
            CORS_UNSUPPORTED: "cors-unsupported",
            DYNAMIC_LINK_NOT_ACTIVATED: "dynamic-link-not-activated",
            INVALID_APP_ID: "invalid-app-id",
            TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
            WEAK_PASSWORD: "weak-password",
            OPERATION_NOT_ALLOWED: "operation-not-allowed",
            USER_CANCELLED: "user-cancelled",
            CAPTCHA_CHECK_FAILED: "captcha-check-failed",
            INVALID_APP_CREDENTIAL: "invalid-app-credential",
            INVALID_CODE: "invalid-verification-code",
            INVALID_PHONE_NUMBER: "invalid-phone-number",
            INVALID_SESSION_INFO: "invalid-verification-id",
            INVALID_TEMPORARY_PROOF: "invalid-credential",
            MISSING_APP_CREDENTIAL: "missing-app-credential",
            MISSING_CODE: "missing-verification-code",
            MISSING_PHONE_NUMBER: "missing-phone-number",
            MISSING_SESSION_INFO: "missing-verification-id",
            QUOTA_EXCEEDED: "quota-exceeded",
            SESSION_EXPIRED: "code-expired",
            REJECTED_CREDENTIAL: "rejected-credential",
            INVALID_CONTINUE_URI: "invalid-continue-uri",
            MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
            MISSING_IOS_BUNDLE_ID: "missing-ios-bundle-id",
            UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
            INVALID_DYNAMIC_LINK_DOMAIN: "invalid-dynamic-link-domain",
            INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
            INVALID_CERT_HASH: "invalid-cert-hash",
            UNSUPPORTED_TENANT_OPERATION: "unsupported-tenant-operation",
            INVALID_TENANT_ID: "invalid-tenant-id",
            TENANT_ID_MISMATCH: "tenant-id-mismatch",
            ADMIN_ONLY_OPERATION: "admin-restricted-operation",
            INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
            MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
            MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
            MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
            EMAIL_CHANGE_NEEDS_VERIFICATION: "email-change-needs-verification",
            SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
            SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
            UNSUPPORTED_FIRST_FACTOR: "unsupported-first-factor",
            UNVERIFIED_EMAIL: "unverified-email"
        };
        B(d, b || {});
        b = (b = c.match(/^[^\s]+\s*:\s*([\s\S]*)$/)) && 1 < b.length ? b[1] : void 0;
        for(var e in d)if (0 === c.indexOf(e)) return new u(d[e], b);
        !b && a && (b = Re(a));
        return new u("internal-error", b);
    }
    function Gj(a) {
        this.b = a;
        this.a = null;
        this.nb = Hj(this);
    }
    function Hj(a) {
        return Ij().then(function() {
            return new D(function(b, c) {
                J("gapi.iframes.getContext")().open({
                    where: document.body,
                    url: a.b,
                    messageHandlersFilter: J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),
                    attributes: {
                        style: {
                            position: "absolute",
                            top: "-100px",
                            width: "1px",
                            height: "1px"
                        }
                    },
                    dontclear: !0
                }, function(d) {
                    function e() {
                        clearTimeout(f);
                        b();
                    }
                    a.a = d;
                    a.a.restyle({
                        setHideOnLeave: !1
                    });
                    var f = setTimeout(function() {
                        c(Error("Network Error"));
                    }, Jj.get());
                    d.ping(e).then(e, function() {
                        c(Error("Network Error"));
                    });
                });
            });
        });
    }
    function Kj(a, b) {
        return a.nb.then(function() {
            return new D(function(c) {
                a.a.send(b.type, b, c, J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
            });
        });
    }
    function Lj(a, b) {
        a.nb.then(function() {
            a.a.register("authEvent", b, J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
        });
    }
    var Mj = new nb(ob, "https://apis.google.com/js/api.js?onload=%{onload}"), Nj = new We(3E4, 6E4), Jj = new We(5E3, 15E3), Oj = null;
    function Ij() {
        return Oj ? Oj : Oj = new D(function(a, b) {
            function c() {
                Ve();
                J("gapi.load")("gapi.iframes", {
                    callback: a,
                    ontimeout: function() {
                        Ve();
                        b(Error("Network Error"));
                    },
                    timeout: Nj.get()
                });
            }
            if (J("gapi.iframes.Iframe")) a();
            else if (J("gapi.load")) c();
            else {
                var d = "__iframefcb" + Math.floor(1E6 * Math.random()).toString();
                l[d] = function() {
                    J("gapi.load") ? c() : b(Error("Network Error"));
                };
                d = wb(Mj, {
                    onload: d
                });
                E(xi(d)).o(function() {
                    b(Error("Network Error"));
                });
            }
        }).o(function(a) {
            Oj = null;
            throw a;
        });
    }
    function Pj(a, b, c) {
        this.i = a;
        this.g = b;
        this.h = c;
        this.f = null;
        this.a = $d(this.i, "/__/auth/iframe");
        H(this.a, "apiKey", this.g);
        H(this.a, "appName", this.h);
        this.b = null;
        this.c = [];
    }
    Pj.prototype.toString = function() {
        this.f ? H(this.a, "v", this.f) : fe(this.a.a, "v");
        this.b ? H(this.a, "eid", this.b) : fe(this.a.a, "eid");
        this.c.length ? H(this.a, "fw", this.c.join(",")) : fe(this.a.a, "fw");
        return this.a.toString();
    };
    function Qj(a, b, c, d, e) {
        this.s = a;
        this.m = b;
        this.c = c;
        this.u = d;
        this.i = this.g = this.l = null;
        this.a = e;
        this.h = this.f = null;
    }
    Qj.prototype.ub = function(a) {
        this.h = a;
        return this;
    };
    Qj.prototype.toString = function() {
        var a = $d(this.s, "/__/auth/handler");
        H(a, "apiKey", this.m);
        H(a, "appName", this.c);
        H(a, "authType", this.u);
        if (this.a.isOAuthProvider) {
            var b = this.a;
            try {
                var c = (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).app(this.c).auth().ja();
            } catch (h) {
                c = null;
            }
            b.kb = c;
            H(a, "providerId", this.a.providerId);
            b = this.a;
            c = Se(b.Fb);
            for(var d in c)c[d] = c[d].toString();
            d = b.Oc;
            c = kb(c);
            for(var e = 0; e < d.length; e++){
                var f = d[e];
                f in c && delete c[f];
            }
            b.lb && b.kb && !c[b.lb] && (c[b.lb] = b.kb);
            jb(c) || H(a, "customParameters", Re(c));
        }
        "function" === typeof this.a.Nb && (b = this.a.Nb(), b.length && H(a, "scopes", b.join(",")));
        this.l ? H(a, "redirectUrl", this.l) : fe(a.a, "redirectUrl");
        this.g ? H(a, "eventId", this.g) : fe(a.a, "eventId");
        this.i ? H(a, "v", this.i) : fe(a.a, "v");
        if (this.b) for(var g in this.b)this.b.hasOwnProperty(g) && !Yd(a, g) && H(a, g, this.b[g]);
        this.h ? H(a, "tid", this.h) : fe(a.a, "tid");
        this.f ? H(a, "eid", this.f) : fe(a.a, "eid");
        g = Rj(this.c);
        g.length && H(a, "fw", g.join(","));
        return a.toString();
    };
    function Rj(a) {
        try {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).app(a).auth().Ea();
        } catch (b) {
            return [];
        }
    }
    function Sj(a, b, c, d, e) {
        this.u = a;
        this.f = b;
        this.b = c;
        this.c = d || null;
        this.h = e || null;
        this.m = this.s = this.w = null;
        this.g = [];
        this.l = this.a = null;
    }
    function Tj(a) {
        var b = oe();
        return Xi(a).then(function(c) {
            a: {
                var d = Zd(b), e = d.f;
                d = d.b;
                for(var f = 0; f < c.length; f++){
                    var g = c[f];
                    var h = d;
                    var m = e;
                    0 == g.indexOf("chrome-extension://") ? h = Zd(g).b == h && "chrome-extension" == m : "http" != m && "https" != m ? h = !1 : ze.test(g) ? h = h == g : (g = g.split(".").join("\\."), h = new RegExp("^(.+\\." + g + "|" + g + ")$", "i").test(h));
                    if (h) {
                        c = !0;
                        break a;
                    }
                }
                c = !1;
            }
            if (!c) throw new th(oe());
        });
    }
    function Uj(a) {
        if (a.l) return a.l;
        a.l = Be().then(function() {
            if (!a.s) {
                var b = a.c, c = a.h, d = Rj(a.b), e = new Pj(a.u, a.f, a.b);
                e.f = b;
                e.b = c;
                e.c = Wa(d || []);
                a.s = e.toString();
            }
            a.i = new Gj(a.s);
            Vj(a);
        });
        return a.l;
    }
    k = Sj.prototype;
    k.Lb = function(a, b, c) {
        var d = new u("popup-closed-by-user"), e = new u("web-storage-unsupported"), f = this, g = !1;
        return this.ka().then(function() {
            Wj(f).then(function(h) {
                h || (a && ve(a), b(e), g = !0);
            });
        }).o(function() {}).then(function() {
            if (!g) return ye(a);
        }).then(function() {
            if (!g) return Bd(c).then(function() {
                b(d);
            });
        });
    };
    k.Ub = function() {
        var a = I();
        return !Qe(a) && !Ue(a);
    };
    k.Qb = function() {
        return !1;
    };
    k.Jb = function(a, b, c, d, e, f, g, h) {
        if (!a) return F(new u("popup-blocked"));
        if (g && !Qe()) return this.ka().o(function(p) {
            ve(a);
            e(p);
        }), d(), E();
        this.a || (this.a = Tj(Xj(this)));
        var m = this;
        return this.a.then(function() {
            var p = m.ka().o(function(v) {
                ve(a);
                e(v);
                throw v;
            });
            d();
            return p;
        }).then(function() {
            nh(c);
            if (!g) {
                var p = Yj(m.u, m.f, m.b, b, c, null, f, m.c, void 0, m.h, h);
                pe(p, a);
            }
        }).o(function(p) {
            "auth/network-request-failed" == p.code && (m.a = null);
            throw p;
        });
    };
    function Xj(a) {
        a.m || (a.w = a.c ? Le(a.c, Rj(a.b)) : null, a.m = new Ei(a.f, za(a.h), a.w));
        return a.m;
    }
    k.Kb = function(a, b, c, d) {
        this.a || (this.a = Tj(Xj(this)));
        var e = this;
        return this.a.then(function() {
            nh(b);
            var f = Yj(e.u, e.f, e.b, a, b, oe(), c, e.c, void 0, e.h, d);
            pe(f);
        }).o(function(f) {
            "auth/network-request-failed" == f.code && (e.a = null);
            throw f;
        });
    };
    k.ka = function() {
        var a = this;
        return Uj(this).then(function() {
            return a.i.nb;
        }).o(function() {
            a.a = null;
            throw new u("network-request-failed");
        });
    };
    k.Xb = function() {
        return !0;
    };
    function Yj(a, b, c, d, e, f, g, h, m, p, v) {
        a = new Qj(a, b, c, d, e);
        a.l = f;
        a.g = g;
        a.i = h;
        a.b = kb(m || null);
        a.f = p;
        return a.ub(v).toString();
    }
    function Vj(a) {
        if (!a.i) throw Error("IfcHandler must be initialized!");
        Lj(a.i, function(b) {
            var c = {};
            if (b && b.authEvent) {
                var d = !1;
                b = ph(b.authEvent);
                for(c = 0; c < a.g.length; c++)d = a.g[c](b) || d;
                c = {};
                c.status = d ? "ACK" : "ERROR";
                return E(c);
            }
            c.status = "ERROR";
            return E(c);
        });
    }
    function Wj(a) {
        var b = {
            type: "webStorageSupport"
        };
        return Uj(a).then(function() {
            return Kj(a.i, b);
        }).then(function(c) {
            if (c && c.length && "undefined" !== typeof c[0].webStorageSupport) return c[0].webStorageSupport;
            throw Error();
        });
    }
    k.Ca = function(a) {
        this.g.push(a);
    };
    k.Qa = function(a) {
        Ua(this.g, function(b) {
            return b == a;
        });
    };
    function Zj(a) {
        this.a = a || (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.reactNative && (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.reactNative.AsyncStorage;
        if (!this.a) throw new u("internal-error", "The React Native compatibility library was not found.");
        this.type = "asyncStorage";
    }
    k = Zj.prototype;
    k.get = function(a) {
        return E(this.a.getItem(a)).then(function(b) {
            return b && Te(b);
        });
    };
    k.set = function(a, b) {
        return E(this.a.setItem(a, Re(b)));
    };
    k.T = function(a) {
        return E(this.a.removeItem(a));
    };
    k.ba = function() {};
    k.ha = function() {};
    function ak(a) {
        this.b = a;
        this.a = {};
        this.f = r(this.c, this);
    }
    var bk = [];
    function ck() {
        var a = Ge() ? self : null;
        x(bk, function(c) {
            c.b == a && (b = c);
        });
        if (!b) {
            var b = new ak(a);
            bk.push(b);
        }
        return b;
    }
    ak.prototype.c = function(a) {
        var b = a.data.eventType, c = a.data.eventId, d = this.a[b];
        if (d && 0 < d.length) {
            a.ports[0].postMessage({
                status: "ack",
                eventId: c,
                eventType: b,
                response: null
            });
            var e = [];
            x(d, function(f) {
                e.push(E().then(function() {
                    return f(a.origin, a.data.data);
                }));
            });
            Ec(e).then(function(f) {
                var g = [];
                x(f, function(h) {
                    g.push({
                        fulfilled: h.Mb,
                        value: h.value,
                        reason: h.reason ? h.reason.message : void 0
                    });
                });
                x(g, function(h) {
                    for(var m in h)"undefined" === typeof h[m] && delete h[m];
                });
                a.ports[0].postMessage({
                    status: "done",
                    eventId: c,
                    eventType: b,
                    response: g
                });
            });
        }
    };
    function dk(a, b, c) {
        jb(a.a) && a.b.addEventListener("message", a.f);
        "undefined" === typeof a.a[b] && (a.a[b] = []);
        a.a[b].push(c);
    }
    function ek(a) {
        this.a = a;
    }
    ek.prototype.postMessage = function(a, b) {
        this.a.postMessage(a, b);
    };
    function fk(a) {
        this.c = a;
        this.b = !1;
        this.a = [];
    }
    function gk(a, b, c, d) {
        var e, f = c || {}, g, h, m, p = null;
        if (a.b) return F(Error("connection_unavailable"));
        var v = d ? 800 : 50, C = "undefined" !== typeof MessageChannel ? new MessageChannel : null;
        return new D(function(A, Q) {
            C ? (e = Math.floor(Math.random() * Math.pow(10, 20)).toString(), C.port1.start(), h = setTimeout(function() {
                Q(Error("unsupported_event"));
            }, v), g = function(xa) {
                xa.data.eventId === e && ("ack" === xa.data.status ? (clearTimeout(h), m = setTimeout(function() {
                    Q(Error("timeout"));
                }, 3E3)) : "done" === xa.data.status ? (clearTimeout(m), "undefined" !== typeof xa.data.response ? A(xa.data.response) : Q(Error("unknown_error"))) : (clearTimeout(h), clearTimeout(m), Q(Error("invalid_response"))));
            }, p = {
                messageChannel: C,
                onMessage: g
            }, a.a.push(p), C.port1.addEventListener("message", g), a.c.postMessage({
                eventType: b,
                eventId: e,
                data: f
            }, [
                C.port2
            ])) : Q(Error("connection_unavailable"));
        }).then(function(A) {
            hk(a, p);
            return A;
        }).o(function(A) {
            hk(a, p);
            throw A;
        });
    }
    function hk(a, b) {
        if (b) {
            var c = b.messageChannel, d = b.onMessage;
            c && (c.port1.removeEventListener("message", d), c.port1.close());
            Ua(a.a, function(e) {
                return e == b;
            });
        }
    }
    fk.prototype.close = function() {
        for(; 0 < this.a.length;)hk(this, this.a[0]);
        this.b = !0;
    };
    function ik() {
        if (!jk()) throw new u("web-storage-unsupported");
        this.c = {};
        this.a = [];
        this.b = 0;
        this.u = l.indexedDB;
        this.type = "indexedDB";
        this.g = this.l = this.f = this.i = null;
        this.s = !1;
        this.h = null;
        var a = this;
        Ge() && self ? (this.l = ck(), dk(this.l, "keyChanged", function(b, c) {
            return kk(a).then(function(d) {
                0 < d.length && x(a.a, function(e) {
                    e(d);
                });
                return {
                    keyProcessed: Sa(d, c.key)
                };
            });
        }), dk(this.l, "ping", function() {
            return E([
                "keyChanged"
            ]);
        })) : bf().then(function(b) {
            if (a.h = b) a.g = new fk(new ek(b)), gk(a.g, "ping", null, !0).then(function(c) {
                c[0].fulfilled && Sa(c[0].value, "keyChanged") && (a.s = !0);
            }).o(function() {});
        });
    }
    var lk;
    function mk(a) {
        return new D(function(b, c) {
            var d = a.u.deleteDatabase("firebaseLocalStorageDb");
            d.onsuccess = function() {
                b();
            };
            d.onerror = function(e) {
                c(Error(e.target.error));
            };
        });
    }
    function nk(a) {
        return new D(function(b, c) {
            var d = a.u.open("firebaseLocalStorageDb", 1);
            d.onerror = function(e) {
                try {
                    e.preventDefault();
                } catch (f) {}
                c(Error(e.target.error));
            };
            d.onupgradeneeded = function(e) {
                e = e.target.result;
                try {
                    e.createObjectStore("firebaseLocalStorage", {
                        keyPath: "fbase_key"
                    });
                } catch (f) {
                    c(f);
                }
            };
            d.onsuccess = function(e) {
                e = e.target.result;
                e.objectStoreNames.contains("firebaseLocalStorage") ? b(e) : mk(a).then(function() {
                    return nk(a);
                }).then(function(f) {
                    b(f);
                }).o(function(f) {
                    c(f);
                });
            };
        });
    }
    function ok(a) {
        a.m || (a.m = nk(a));
        return a.m;
    }
    function jk() {
        try {
            return !!l.indexedDB;
        } catch (a) {
            return !1;
        }
    }
    function pk(a) {
        return a.objectStore("firebaseLocalStorage");
    }
    function qk(a, b) {
        return a.transaction([
            "firebaseLocalStorage"
        ], b ? "readwrite" : "readonly");
    }
    function rk(a) {
        return new D(function(b, c) {
            a.onsuccess = function(d) {
                d && d.target ? b(d.target.result) : b();
            };
            a.onerror = function(d) {
                c(d.target.error);
            };
        });
    }
    k = ik.prototype;
    k.set = function(a, b) {
        var c = !1, d, e = this;
        return ok(this).then(function(f) {
            d = f;
            f = pk(qk(d, !0));
            return rk(f.get(a));
        }).then(function(f) {
            var g = pk(qk(d, !0));
            if (f) return f.value = b, rk(g.put(f));
            e.b++;
            c = !0;
            f = {};
            f.fbase_key = a;
            f.value = b;
            return rk(g.add(f));
        }).then(function() {
            e.c[a] = b;
            return sk(e, a);
        }).ma(function() {
            c && e.b--;
        });
    };
    function sk(a, b) {
        return a.g && a.h && af() === a.h ? gk(a.g, "keyChanged", {
            key: b
        }, a.s).then(function() {}).o(function() {}) : E();
    }
    k.get = function(a) {
        return ok(this).then(function(b) {
            return rk(pk(qk(b, !1)).get(a));
        }).then(function(b) {
            return b && b.value;
        });
    };
    k.T = function(a) {
        var b = !1, c = this;
        return ok(this).then(function(d) {
            b = !0;
            c.b++;
            return rk(pk(qk(d, !0))["delete"](a));
        }).then(function() {
            delete c.c[a];
            return sk(c, a);
        }).ma(function() {
            b && c.b--;
        });
    };
    function kk(a) {
        return ok(a).then(function(b) {
            var c = pk(qk(b, !1));
            return c.getAll ? rk(c.getAll()) : new D(function(d, e) {
                var f = [], g = c.openCursor();
                g.onsuccess = function(h) {
                    (h = h.target.result) ? (f.push(h.value), h["continue"]()) : d(f);
                };
                g.onerror = function(h) {
                    e(h.target.error);
                };
            });
        }).then(function(b) {
            var c = {}, d = [];
            if (0 == a.b) {
                for(d = 0; d < b.length; d++)c[b[d].fbase_key] = b[d].value;
                d = qe(a.c, c);
                a.c = c;
            }
            return d;
        });
    }
    k.ba = function(a) {
        0 == this.a.length && tk(this);
        this.a.push(a);
    };
    k.ha = function(a) {
        Ua(this.a, function(b) {
            return b == a;
        });
        0 == this.a.length && uk(this);
    };
    function tk(a) {
        function b() {
            a.f = setTimeout(function() {
                a.i = kk(a).then(function(c) {
                    0 < c.length && x(a.a, function(d) {
                        d(c);
                    });
                }).then(function() {
                    b();
                }).o(function(c) {
                    "STOP_EVENT" != c.message && b();
                });
            }, 800);
        }
        uk(a);
        b();
    }
    function uk(a) {
        a.i && a.i.cancel("STOP_EVENT");
        a.f && (clearTimeout(a.f), a.f = null);
    }
    function vk(a) {
        var b = this, c = null;
        this.a = [];
        this.type = "indexedDB";
        this.c = a;
        this.b = E().then(function() {
            if (jk()) {
                var d = Ne(), e = "__sak" + d;
                lk || (lk = new ik);
                c = lk;
                return c.set(e, d).then(function() {
                    return c.get(e);
                }).then(function(f) {
                    if (f !== d) throw Error("indexedDB not supported!");
                    return c.T(e);
                }).then(function() {
                    return c;
                }).o(function() {
                    return b.c;
                });
            }
            return b.c;
        }).then(function(d) {
            b.type = d.type;
            d.ba(function(e) {
                x(b.a, function(f) {
                    f(e);
                });
            });
            return d;
        });
    }
    k = vk.prototype;
    k.get = function(a) {
        return this.b.then(function(b) {
            return b.get(a);
        });
    };
    k.set = function(a, b) {
        return this.b.then(function(c) {
            return c.set(a, b);
        });
    };
    k.T = function(a) {
        return this.b.then(function(b) {
            return b.T(a);
        });
    };
    k.ba = function(a) {
        this.a.push(a);
    };
    k.ha = function(a) {
        Ua(this.a, function(b) {
            return b == a;
        });
    };
    function wk() {
        this.a = {};
        this.type = "inMemory";
    }
    k = wk.prototype;
    k.get = function(a) {
        return E(this.a[a]);
    };
    k.set = function(a, b) {
        this.a[a] = b;
        return E();
    };
    k.T = function(a) {
        delete this.a[a];
        return E();
    };
    k.ba = function() {};
    k.ha = function() {};
    function xk() {
        if (!yk()) {
            if ("Node" == He()) throw new u("internal-error", "The LocalStorage compatibility library was not found.");
            throw new u("web-storage-unsupported");
        }
        this.a = zk() || (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.node.localStorage;
        this.type = "localStorage";
    }
    function zk() {
        try {
            var a = l.localStorage, b = Ne();
            a && (a.setItem(b, "1"), a.removeItem(b));
            return a;
        } catch (c) {
            return null;
        }
    }
    function yk() {
        var a = "Node" == He();
        a = zk() || a && (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.node && (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.node.localStorage;
        if (!a) return !1;
        try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    }
    k = xk.prototype;
    k.get = function(a) {
        var b = this;
        return E().then(function() {
            var c = b.a.getItem(a);
            return Te(c);
        });
    };
    k.set = function(a, b) {
        var c = this;
        return E().then(function() {
            var d = Re(b);
            null === d ? c.T(a) : c.a.setItem(a, d);
        });
    };
    k.T = function(a) {
        var b = this;
        return E().then(function() {
            b.a.removeItem(a);
        });
    };
    k.ba = function(a) {
        l.window && jd(l.window, "storage", a);
    };
    k.ha = function(a) {
        l.window && td(l.window, "storage", a);
    };
    function Ak() {
        this.type = "nullStorage";
    }
    k = Ak.prototype;
    k.get = function() {
        return E(null);
    };
    k.set = function() {
        return E();
    };
    k.T = function() {
        return E();
    };
    k.ba = function() {};
    k.ha = function() {};
    function Bk() {
        if (!Ck()) {
            if ("Node" == He()) throw new u("internal-error", "The SessionStorage compatibility library was not found.");
            throw new u("web-storage-unsupported");
        }
        this.a = Dk() || (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.node.sessionStorage;
        this.type = "sessionStorage";
    }
    function Dk() {
        try {
            var a = l.sessionStorage, b = Ne();
            a && (a.setItem(b, "1"), a.removeItem(b));
            return a;
        } catch (c) {
            return null;
        }
    }
    function Ck() {
        var a = "Node" == He();
        a = Dk() || a && (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.node && (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.node.sessionStorage;
        if (!a) return !1;
        try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    }
    k = Bk.prototype;
    k.get = function(a) {
        var b = this;
        return E().then(function() {
            var c = b.a.getItem(a);
            return Te(c);
        });
    };
    k.set = function(a, b) {
        var c = this;
        return E().then(function() {
            var d = Re(b);
            null === d ? c.T(a) : c.a.setItem(a, d);
        });
    };
    k.T = function(a) {
        var b = this;
        return E().then(function() {
            b.a.removeItem(a);
        });
    };
    k.ba = function() {};
    k.ha = function() {};
    function Ek() {
        var a = {};
        a.Browser = Fk;
        a.Node = Gk;
        a.ReactNative = Hk;
        a.Worker = Ik;
        this.a = a[He()];
    }
    var Jk, Fk = {
        F: xk,
        $a: Bk
    }, Gk = {
        F: xk,
        $a: Bk
    }, Hk = {
        F: Zj,
        $a: Ak
    }, Ik = {
        F: xk,
        $a: Ak
    }; /*

 Copyright 2017 Google LLC

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
    var Kk = {
        od: "local",
        NONE: "none",
        qd: "session"
    };
    function Lk(a) {
        var b = new u("invalid-persistence-type"), c = new u("unsupported-persistence-type");
        a: {
            for(d in Kk)if (Kk[d] == a) {
                var d = !0;
                break a;
            }
            d = !1;
        }
        if (!d || "string" !== typeof a) throw b;
        switch(He()){
            case "ReactNative":
                if ("session" === a) throw c;
                break;
            case "Node":
                if ("none" !== a) throw c;
                break;
            case "Worker":
                if ("session" === a || !jk() && "none" !== a) throw c;
                break;
            default:
                if (!Me() && "none" !== a) throw c;
        }
    }
    function Mk() {
        var a = !Ue(I()) && Fe() ? !0 : !1, b = Qe(), c = Me();
        this.m = a;
        this.h = b;
        this.l = c;
        this.a = {};
        Jk || (Jk = new Ek);
        a = Jk;
        try {
            this.g = !ne() && $e() || !l.indexedDB ? new a.a.F : new vk(Ge() ? new wk : new a.a.F);
        } catch (d) {
            this.g = new wk, this.h = !0;
        }
        try {
            this.i = new a.a.$a;
        } catch (d) {
            this.i = new wk;
        }
        this.u = new wk;
        this.f = r(this.Vb, this);
        this.b = {};
    }
    var Nk;
    function Ok() {
        Nk || (Nk = new Mk);
        return Nk;
    }
    function Pk(a, b) {
        switch(b){
            case "session":
                return a.i;
            case "none":
                return a.u;
            default:
                return a.g;
        }
    }
    function Qk(a, b) {
        return "firebase:" + a.name + (b ? ":" + b : "");
    }
    function Rk(a, b, c) {
        var d = Qk(b, c), e = Pk(a, b.F);
        return a.get(b, c).then(function(f) {
            var g = null;
            try {
                g = Te(l.localStorage.getItem(d));
            } catch (h) {}
            if (g && !f) return l.localStorage.removeItem(d), a.set(b, g, c);
            g && f && "localStorage" != e.type && l.localStorage.removeItem(d);
        });
    }
    k = Mk.prototype;
    k.get = function(a, b) {
        return Pk(this, a.F).get(Qk(a, b));
    };
    function Sk(a, b, c) {
        c = Qk(b, c);
        "local" == b.F && (a.b[c] = null);
        return Pk(a, b.F).T(c);
    }
    k.set = function(a, b, c) {
        var d = Qk(a, c), e = this, f = Pk(this, a.F);
        return f.set(d, b).then(function() {
            return f.get(d);
        }).then(function(g) {
            "local" == a.F && (e.b[d] = g);
        });
    };
    k.addListener = function(a, b, c) {
        a = Qk(a, b);
        this.l && (this.b[a] = l.localStorage.getItem(a));
        jb(this.a) && (Pk(this, "local").ba(this.f), this.h || (ne() || !$e()) && l.indexedDB || !this.l || Tk(this));
        this.a[a] || (this.a[a] = []);
        this.a[a].push(c);
    };
    k.removeListener = function(a, b, c) {
        a = Qk(a, b);
        this.a[a] && (Ua(this.a[a], function(d) {
            return d == c;
        }), 0 == this.a[a].length && delete this.a[a]);
        jb(this.a) && (Pk(this, "local").ha(this.f), Uk(this));
    };
    function Tk(a) {
        Uk(a);
        a.c = setInterval(function() {
            for(var b in a.a){
                var c = l.localStorage.getItem(b), d = a.b[b];
                c != d && (a.b[b] = c, c = new Yc({
                    type: "storage",
                    key: b,
                    target: window,
                    oldValue: d,
                    newValue: c,
                    a: !0
                }), a.Vb(c));
            }
        }, 1E3);
    }
    function Uk(a) {
        a.c && (clearInterval(a.c), a.c = null);
    }
    k.Vb = function(a) {
        if (a && a.f) {
            var b = a.a.key;
            if (null == b) for(var c in this.a){
                var d = this.b[c];
                "undefined" === typeof d && (d = null);
                var e = l.localStorage.getItem(c);
                e !== d && (this.b[c] = e, this.ib(c));
            }
            else if (0 == b.indexOf("firebase:") && this.a[b]) {
                "undefined" !== typeof a.a.a ? Pk(this, "local").ha(this.f) : Uk(this);
                if (this.m) {
                    if (c = l.localStorage.getItem(b), d = a.a.newValue, d !== c) null !== d ? l.localStorage.setItem(b, d) : l.localStorage.removeItem(b);
                    else if (this.b[b] === d && "undefined" === typeof a.a.a) return;
                }
                var f = this;
                c = function() {
                    if ("undefined" !== typeof a.a.a || f.b[b] !== l.localStorage.getItem(b)) f.b[b] = l.localStorage.getItem(b), f.ib(b);
                };
                Sb && cc && 10 == cc && l.localStorage.getItem(b) !== a.a.newValue && a.a.newValue !== a.a.oldValue ? setTimeout(c, 10) : c();
            }
        } else x(a, r(this.ib, this));
    };
    k.ib = function(a) {
        this.a[a] && x(this.a[a], function(b) {
            b();
        });
    };
    function Vk(a) {
        this.a = a;
        this.b = Ok();
    }
    var Wk = {
        name: "authEvent",
        F: "local"
    };
    function Xk(a) {
        return a.b.get(Wk, a.a).then(function(b) {
            return ph(b);
        });
    }
    function Yk() {
        this.a = Ok();
    }
    function Zk() {
        this.b = -1;
    }
    function $k(a, b) {
        this.b = al;
        this.f = l.Uint8Array ? new Uint8Array(this.b) : Array(this.b);
        this.g = this.c = 0;
        this.a = [];
        this.i = a;
        this.h = b;
        this.l = l.Int32Array ? new Int32Array(64) : Array(64);
        void 0 === bl && (l.Int32Array ? bl = new Int32Array(cl) : bl = cl);
        this.reset();
    }
    var bl;
    t($k, Zk);
    for(var al = 64, dl = al - 1, el = [], fl = 0; fl < dl; fl++)el[fl] = 0;
    var gl = Va(128, el);
    $k.prototype.reset = function() {
        this.g = this.c = 0;
        this.a = l.Int32Array ? new Int32Array(this.h) : Wa(this.h);
    };
    function hl(a) {
        for(var b = a.f, c = a.l, d = 0, e = 0; e < b.length;)c[d++] = b[e] << 24 | b[e + 1] << 16 | b[e + 2] << 8 | b[e + 3], e = 4 * d;
        for(b = 16; 64 > b; b++){
            e = c[b - 15] | 0;
            d = c[b - 2] | 0;
            var f = (c[b - 16] | 0) + ((e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3) | 0, g = (c[b - 7] | 0) + ((d >>> 17 | d << 15) ^ (d >>> 19 | d << 13) ^ d >>> 10) | 0;
            c[b] = f + g | 0;
        }
        d = a.a[0] | 0;
        e = a.a[1] | 0;
        var h = a.a[2] | 0, m = a.a[3] | 0, p = a.a[4] | 0, v = a.a[5] | 0, C = a.a[6] | 0;
        f = a.a[7] | 0;
        for(b = 0; 64 > b; b++){
            var A = ((d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10)) + (d & e ^ d & h ^ e & h) | 0;
            g = p & v ^ ~p & C;
            f = f + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) | 0;
            g = g + (bl[b] | 0) | 0;
            g = f + (g + (c[b] | 0) | 0) | 0;
            f = C;
            C = v;
            v = p;
            p = m + g | 0;
            m = h;
            h = e;
            e = d;
            d = g + A | 0;
        }
        a.a[0] = a.a[0] + d | 0;
        a.a[1] = a.a[1] + e | 0;
        a.a[2] = a.a[2] + h | 0;
        a.a[3] = a.a[3] + m | 0;
        a.a[4] = a.a[4] + p | 0;
        a.a[5] = a.a[5] + v | 0;
        a.a[6] = a.a[6] + C | 0;
        a.a[7] = a.a[7] + f | 0;
    }
    function il(a, b, c) {
        void 0 === c && (c = b.length);
        var d = 0, e = a.c;
        if ("string" === typeof b) for(; d < c;)a.f[e++] = b.charCodeAt(d++), e == a.b && (hl(a), e = 0);
        else if (ma(b)) for(; d < c;){
            var f = b[d++];
            if (!("number" == typeof f && 0 <= f && 255 >= f && f == (f | 0))) throw Error("message must be a byte array");
            a.f[e++] = f;
            e == a.b && (hl(a), e = 0);
        }
        else throw Error("message must be string or array");
        a.c = e;
        a.g += c;
    }
    var cl = [
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
    ];
    function jl() {
        $k.call(this, 8, kl);
    }
    t(jl, $k);
    var kl = [
        1779033703,
        3144134277,
        1013904242,
        2773480762,
        1359893119,
        2600822924,
        528734635,
        1541459225
    ];
    function ll(a, b, c, d, e) {
        this.u = a;
        this.i = b;
        this.l = c;
        this.m = d || null;
        this.s = e || null;
        this.h = b + ":" + c;
        this.w = new Yk;
        this.g = new Vk(this.h);
        this.f = null;
        this.b = [];
        this.a = this.c = null;
    }
    function ml(a) {
        return new u("invalid-cordova-configuration", a);
    }
    k = ll.prototype;
    k.ka = function() {
        return this.Ga ? this.Ga : this.Ga = Ce().then(function() {
            if ("function" !== typeof J("universalLinks.subscribe", l)) throw ml("cordova-universal-links-plugin-fix is not installed");
            if ("undefined" === typeof J("BuildInfo.packageName", l)) throw ml("cordova-plugin-buildinfo is not installed");
            if ("function" !== typeof J("cordova.plugins.browsertab.openUrl", l)) throw ml("cordova-plugin-browsertab is not installed");
            if ("function" !== typeof J("cordova.InAppBrowser.open", l)) throw ml("cordova-plugin-inappbrowser is not installed");
        }, function() {
            throw new u("cordova-not-ready");
        });
    };
    function nl() {
        for(var a = 20, b = []; 0 < a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
        return b.join("");
    }
    function ol(a) {
        var b = new jl;
        il(b, a);
        a = [];
        var c = 8 * b.g;
        56 > b.c ? il(b, gl, 56 - b.c) : il(b, gl, b.b - (b.c - 56));
        for(var d = 63; 56 <= d; d--)b.f[d] = c & 255, c /= 256;
        hl(b);
        for(d = c = 0; d < b.i; d++)for(var e = 24; 0 <= e; e -= 8)a[c++] = b.a[d] >> e & 255;
        return $f(a);
    }
    k.Lb = function(a, b) {
        b(new u("operation-not-supported-in-this-environment"));
        return E();
    };
    k.Jb = function() {
        return F(new u("operation-not-supported-in-this-environment"));
    };
    k.Xb = function() {
        return !1;
    };
    k.Ub = function() {
        return !0;
    };
    k.Qb = function() {
        return !0;
    };
    k.Kb = function(a, b, c, d) {
        if (this.c) return F(new u("redirect-operation-pending"));
        var e = this, f = l.document, g = null, h = null, m = null, p = null;
        return this.c = E().then(function() {
            nh(b);
            return pl(e);
        }).then(function() {
            return ql(e, a, b, c, d);
        }).then(function() {
            return new D(function(v, C) {
                h = function() {
                    var A = J("cordova.plugins.browsertab.close", l);
                    v();
                    "function" === typeof A && A();
                    e.a && "function" === typeof e.a.close && (e.a.close(), e.a = null);
                    return !1;
                };
                e.Ca(h);
                m = function() {
                    g || (g = Bd(2E3).then(function() {
                        C(new u("redirect-cancelled-by-user"));
                    }));
                };
                p = function() {
                    Xe() && m();
                };
                f.addEventListener("resume", m, !1);
                I().toLowerCase().match(/android/) || f.addEventListener("visibilitychange", p, !1);
            }).o(function(v) {
                return rl(e).then(function() {
                    throw v;
                });
            });
        }).ma(function() {
            m && f.removeEventListener("resume", m, !1);
            p && f.removeEventListener("visibilitychange", p, !1);
            g && g.cancel();
            h && e.Qa(h);
            e.c = null;
        });
    };
    function ql(a, b, c, d, e) {
        var f = nl(), g = new oh(b, d, null, f, new u("no-auth-event"), null, e), h = J("BuildInfo.packageName", l);
        if ("string" !== typeof h) throw new u("invalid-cordova-configuration");
        var m = J("BuildInfo.displayName", l), p = {};
        if (I().toLowerCase().match(/iphone|ipad|ipod/)) p.ibi = h;
        else if (I().toLowerCase().match(/android/)) p.apn = h;
        else return F(new u("operation-not-supported-in-this-environment"));
        m && (p.appDisplayName = m);
        f = ol(f);
        p.sessionId = f;
        var v = Yj(a.u, a.i, a.l, b, c, null, d, a.m, p, a.s, e);
        return a.ka().then(function() {
            var C = a.h;
            return a.w.a.set(Wk, g.v(), C);
        }).then(function() {
            var C = J("cordova.plugins.browsertab.isAvailable", l);
            if ("function" !== typeof C) throw new u("invalid-cordova-configuration");
            var A = null;
            C(function(Q) {
                if (Q) {
                    A = J("cordova.plugins.browsertab.openUrl", l);
                    if ("function" !== typeof A) throw new u("invalid-cordova-configuration");
                    A(v);
                } else {
                    A = J("cordova.InAppBrowser.open", l);
                    if ("function" !== typeof A) throw new u("invalid-cordova-configuration");
                    Q = I();
                    a.a = A(v, Q.match(/(iPad|iPhone|iPod).*OS 7_\d/i) || Q.match(/(iPad|iPhone|iPod).*OS 8_\d/i) ? "_blank" : "_system", "location=yes");
                }
            });
        });
    }
    function sl(a, b) {
        for(var c = 0; c < a.b.length; c++)try {
            a.b[c](b);
        } catch (d) {}
    }
    function pl(a) {
        a.f || (a.f = a.ka().then(function() {
            return new D(function(b) {
                function c(d) {
                    b(d);
                    a.Qa(c);
                    return !1;
                }
                a.Ca(c);
                tl(a);
            });
        }));
        return a.f;
    }
    function rl(a) {
        var b = null;
        return Xk(a.g).then(function(c) {
            b = c;
            c = a.g;
            return Sk(c.b, Wk, c.a);
        }).then(function() {
            return b;
        });
    }
    function tl(a) {
        function b(g) {
            d = !0;
            e && e.cancel();
            rl(a).then(function(h) {
                var m = c;
                if (h && g && g.url) {
                    var p = null;
                    m = ug(g.url);
                    -1 != m.indexOf("/__/auth/callback") && (p = Zd(m), p = Te(Yd(p, "firebaseError") || null), p = (p = "object" === typeof p ? wa(p) : null) ? new oh(h.c, h.b, null, null, p, null, h.S()) : new oh(h.c, h.b, m, h.f, null, null, h.S()));
                    m = p || c;
                }
                sl(a, m);
            });
        }
        var c = new oh("unknown", null, null, null, new u("no-auth-event")), d = !1, e = Bd(500).then(function() {
            return rl(a).then(function() {
                d || sl(a, c);
            });
        }), f = l.handleOpenURL;
        l.handleOpenURL = function(g) {
            0 == g.toLowerCase().indexOf(J("BuildInfo.packageName", l).toLowerCase() + "://") && b({
                url: g
            });
            if ("function" === typeof f) try {
                f(g);
            } catch (h) {
                console.error(h);
            }
        };
        rh || (rh = new qh);
        sh(b);
    }
    k.Ca = function(a) {
        this.b.push(a);
        pl(this).o(function(b) {
            "auth/invalid-cordova-configuration" === b.code && (b = new oh("unknown", null, null, null, new u("no-auth-event")), a(b));
        });
    };
    k.Qa = function(a) {
        Ua(this.b, function(b) {
            return b == a;
        });
    };
    function ul(a) {
        this.a = a;
        this.b = Ok();
    }
    var vl = {
        name: "pendingRedirect",
        F: "session"
    };
    function wl(a) {
        return a.b.set(vl, "pending", a.a);
    }
    function xl(a) {
        return Sk(a.b, vl, a.a);
    }
    function yl(a) {
        return a.b.get(vl, a.a).then(function(b) {
            return "pending" == b;
        });
    }
    function zl(a, b, c) {
        this.i = {};
        this.w = 0;
        this.D = a;
        this.u = b;
        this.m = c;
        this.h = [];
        this.f = !1;
        this.l = r(this.s, this);
        this.b = new Al;
        this.B = new Bl;
        this.g = new ul(this.u + ":" + this.m);
        this.c = {};
        this.c.unknown = this.b;
        this.c.signInViaRedirect = this.b;
        this.c.linkViaRedirect = this.b;
        this.c.reauthViaRedirect = this.b;
        this.c.signInViaPopup = this.B;
        this.c.linkViaPopup = this.B;
        this.c.reauthViaPopup = this.B;
        this.a = Cl(this.D, this.u, this.m, Aa);
    }
    function Cl(a, b, c, d) {
        var e = (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION || null;
        return De() ? new ll(a, b, c, e, d) : new Sj(a, b, c, e, d);
    }
    zl.prototype.reset = function() {
        this.f = !1;
        this.a.Qa(this.l);
        this.a = Cl(this.D, this.u, this.m);
        this.i = {};
    };
    function Dl(a) {
        a.f || (a.f = !0, a.a.Ca(a.l));
        var b = a.a;
        return a.a.ka().o(function(c) {
            a.a == b && a.reset();
            throw c;
        });
    }
    function El(a) {
        a.a.Ub() && Dl(a).o(function(b) {
            var c = new oh("unknown", null, null, null, new u("operation-not-supported-in-this-environment"));
            Fl(b) && a.s(c);
        });
        a.a.Qb() || Gl(a.b);
    }
    function Hl(a, b) {
        Sa(a.h, b) || a.h.push(b);
        a.f || yl(a.g).then(function(c) {
            c ? xl(a.g).then(function() {
                Dl(a).o(function(d) {
                    var e = new oh("unknown", null, null, null, new u("operation-not-supported-in-this-environment"));
                    Fl(d) && a.s(e);
                });
            }) : El(a);
        }).o(function() {
            El(a);
        });
    }
    function Il(a, b) {
        Ua(a.h, function(c) {
            return c == b;
        });
    }
    zl.prototype.s = function(a) {
        if (!a) throw new u("invalid-auth-event");
        6E5 <= ta() - this.w && (this.i = {}, this.w = 0);
        if (a && a.getUid() && this.i.hasOwnProperty(a.getUid())) return !1;
        for(var b = !1, c = 0; c < this.h.length; c++){
            var d = this.h[c];
            if (d.Cb(a.c, a.b)) {
                if (b = this.c[a.c]) b.h(a, d), a && (a.f || a.b) && (this.i[a.getUid()] = !0, this.w = ta());
                b = !0;
                break;
            }
        }
        Gl(this.b);
        return b;
    };
    var Jl = new We(2E3, 1E4), Kl = new We(3E4, 6E4);
    zl.prototype.pa = function() {
        return this.b.pa();
    };
    function Ll(a, b, c, d, e, f, g) {
        return a.a.Jb(b, c, d, function() {
            a.f || (a.f = !0, a.a.Ca(a.l));
        }, function() {
            a.reset();
        }, e, f, g);
    }
    function Fl(a) {
        return a && "auth/cordova-not-ready" == a.code ? !0 : !1;
    }
    function Ml(a, b, c, d, e) {
        var f;
        return wl(a.g).then(function() {
            return a.a.Kb(b, c, d, e).o(function(g) {
                if (Fl(g)) throw new u("operation-not-supported-in-this-environment");
                f = g;
                return xl(a.g).then(function() {
                    throw f;
                });
            }).then(function() {
                return a.a.Xb() ? new D(function() {}) : xl(a.g).then(function() {
                    return a.pa();
                }).then(function() {}).o(function() {});
            });
        });
    }
    function Nl(a, b, c, d, e) {
        return a.a.Lb(d, function(f) {
            b.la(c, null, f, e);
        }, Jl.get());
    }
    var Ol = {};
    function Pl(a, b, c) {
        var d = b + ":" + c;
        Ol[d] || (Ol[d] = new zl(a, b, c));
        return Ol[d];
    }
    function Al() {
        this.b = null;
        this.f = [];
        this.c = [];
        this.a = null;
        this.i = this.g = !1;
    }
    Al.prototype.reset = function() {
        this.b = null;
        this.a && (this.a.cancel(), this.a = null);
    };
    Al.prototype.h = function(a, b) {
        if (a) {
            this.reset();
            this.g = !0;
            var c = a.c, d = a.b, e = a.a && "auth/web-storage-unsupported" == a.a.code, f = a.a && "auth/operation-not-supported-in-this-environment" == a.a.code;
            this.i = !(!e && !f);
            "unknown" != c || e || f ? a.a ? (Ql(this, !0, null, a.a), E()) : b.Da(c, d) ? Rl(this, a, b) : F(new u("invalid-auth-event")) : (Ql(this, !1, null, null), E());
        } else F(new u("invalid-auth-event"));
    };
    function Gl(a) {
        a.g || (a.g = !0, Ql(a, !1, null, null));
    }
    function Sl(a) {
        a.g && !a.i && Ql(a, !1, null, null);
    }
    function Rl(a, b, c) {
        c = c.Da(b.c, b.b);
        var d = b.g, e = b.f, f = b.i, g = b.S(), h = !!b.c.match(/Redirect$/);
        c(d, e, g, f).then(function(m) {
            Ql(a, h, m, null);
        }).o(function(m) {
            Ql(a, h, null, m);
        });
    }
    function Tl(a, b) {
        a.b = function() {
            return F(b);
        };
        if (a.c.length) for(var c = 0; c < a.c.length; c++)a.c[c](b);
    }
    function Ul(a, b) {
        a.b = function() {
            return E(b);
        };
        if (a.f.length) for(var c = 0; c < a.f.length; c++)a.f[c](b);
    }
    function Ql(a, b, c, d) {
        b ? d ? Tl(a, d) : Ul(a, c) : Ul(a, {
            user: null
        });
        a.f = [];
        a.c = [];
    }
    Al.prototype.pa = function() {
        var a = this;
        return new D(function(b, c) {
            a.b ? a.b().then(b, c) : (a.f.push(b), a.c.push(c), Vl(a));
        });
    };
    function Vl(a) {
        var b = new u("timeout");
        a.a && a.a.cancel();
        a.a = Bd(Kl.get()).then(function() {
            a.b || (a.g = !0, Ql(a, !0, null, b));
        });
    }
    function Bl() {}
    Bl.prototype.h = function(a, b) {
        if (a) {
            var c = a.c, d = a.b;
            a.a ? (b.la(a.c, null, a.a, a.b), E()) : b.Da(c, d) ? Wl(a, b) : F(new u("invalid-auth-event"));
        } else F(new u("invalid-auth-event"));
    };
    function Wl(a, b) {
        var c = a.b, d = a.c;
        b.Da(d, c)(a.g, a.f, a.S(), a.i).then(function(e) {
            b.la(d, e, null, c);
        }).o(function(e) {
            b.la(d, null, e, c);
        });
    }
    function Xl() {
        this.Bb = !1;
        Object.defineProperty(this, "appVerificationDisabled", {
            get: function() {
                return this.Bb;
            },
            set: function(a) {
                this.Bb = a;
            },
            enumerable: !1
        });
    }
    function Yl(a, b) {
        this.a = b;
        K(this, "verificationId", a);
    }
    Yl.prototype.confirm = function(a) {
        a = lh(this.verificationId, a);
        return this.a(a);
    };
    function Zl(a, b, c, d) {
        return new hh(a).cb(b, c).then(function(e) {
            return new Yl(e, d);
        });
    }
    function $l(a) {
        var b = fg(a);
        if (!(b && b.exp && b.auth_time && b.iat)) throw new u("internal-error", "An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");
        L(this, {
            token: a,
            expirationTime: Ze(1E3 * b.exp),
            authTime: Ze(1E3 * b.auth_time),
            issuedAtTime: Ze(1E3 * b.iat),
            signInProvider: b.firebase && b.firebase.sign_in_provider ? b.firebase.sign_in_provider : null,
            signInSecondFactor: b.firebase && b.firebase.sign_in_second_factor ? b.firebase.sign_in_second_factor : null,
            claims: b
        });
    }
    function am(a, b, c) {
        var d = b && b[bm];
        if (!d) throw new u("argument-error", "Internal assert: Invalid MultiFactorResolver");
        this.a = a;
        this.f = kb(b);
        this.g = c;
        this.c = new vg(null, d);
        this.b = [];
        var e = this;
        x(b[cm] || [], function(f) {
            (f = qf(f)) && e.b.push(f);
        });
        K(this, "auth", this.a);
        K(this, "session", this.c);
        K(this, "hints", this.b);
    }
    var cm = "mfaInfo", bm = "mfaPendingCredential";
    am.prototype.Pc = function(a) {
        var b = this;
        return a.ob(this.a.b, this.c).then(function(c) {
            var d = kb(b.f);
            delete d[cm];
            delete d[bm];
            B(d, c);
            return b.g(d);
        });
    };
    function dm(a, b, c, d) {
        u.call(this, "multi-factor-auth-required", d, b);
        this.b = new am(a, b, c);
        K(this, "resolver", this.b);
    }
    t(dm, u);
    function em(a, b, c) {
        if (a && q(a.serverResponse) && "auth/multi-factor-auth-required" === a.code) try {
            return new dm(b, a.serverResponse, c, a.message);
        } catch (d) {}
        return null;
    }
    function fm() {}
    fm.prototype.ob = function(a, b, c) {
        return b.type == wg ? gm(this, a, b, c) : hm(this, a, b);
    };
    function gm(a, b, c, d) {
        return c.Fa().then(function(e) {
            e = {
                idToken: e
            };
            "undefined" !== typeof d && (e.displayName = d);
            B(e, {
                phoneVerificationInfo: dh(a.a)
            });
            return N(b, Aj, e);
        });
    }
    function hm(a, b, c) {
        return c.Fa().then(function(d) {
            d = {
                mfaPendingCredential: d
            };
            B(d, {
                phoneVerificationInfo: dh(a.a)
            });
            return N(b, Bj, d);
        });
    }
    function im(a) {
        K(this, "factorId", a.ea);
        this.a = a;
    }
    t(im, fm);
    function jm(a) {
        im.call(this, a);
        if (this.a.ea != hh.PROVIDER_ID) throw new u("argument-error", "firebase.auth.PhoneMultiFactorAssertion requires a valid firebase.auth.PhoneAuthCredential");
    }
    t(jm, im);
    function km(a, b) {
        Xc.call(this, a);
        for(var c in b)this[c] = b[c];
    }
    t(km, Xc);
    function lm(a, b) {
        this.a = a;
        this.b = [];
        this.c = r(this.wc, this);
        jd(this.a, "userReloaded", this.c);
        var c = [];
        b && b.multiFactor && b.multiFactor.enrolledFactors && x(b.multiFactor.enrolledFactors, function(d) {
            var e = null, f = {};
            if (d) {
                d.uid && (f[nf] = d.uid);
                d.displayName && (f[of] = d.displayName);
                d.enrollmentTime && (f[pf] = new Date(d.enrollmentTime).toISOString());
                d.phoneNumber && (f[mf] = d.phoneNumber);
                try {
                    e = new rf(f);
                } catch (g) {}
                d = e;
            } else d = null;
            d && c.push(d);
        });
        mm(this, c);
    }
    function nm(a) {
        var b = [];
        x(a.mfaInfo || [], function(c) {
            (c = qf(c)) && b.push(c);
        });
        return b;
    }
    k = lm.prototype;
    k.wc = function(a) {
        mm(this, nm(a.ed));
    };
    function mm(a, b) {
        a.b = b;
        K(a, "enrolledFactors", b);
    }
    k.Ob = function() {
        return this.a.I().then(function(a) {
            return new vg(a, null);
        });
    };
    k.dc = function(a, b) {
        var c = this, d = this.a.a;
        return this.Ob().then(function(e) {
            return a.ob(d, e, b);
        }).then(function(e) {
            om(c.a, e);
            return c.a.reload();
        });
    };
    k.$c = function(a) {
        var b = this, c = "string" === typeof a ? a : a.uid, d = this.a.a;
        return this.a.I().then(function(e) {
            return N(d, Fj, {
                idToken: e,
                mfaEnrollmentId: c
            });
        }).then(function(e) {
            var f = Na(b.b, function(g) {
                return g.uid != c;
            });
            mm(b, f);
            om(b.a, e);
            return b.a.reload().o(function(g) {
                if ("auth/user-token-expired" != g.code) throw g;
            });
        });
    };
    k.v = function() {
        return {
            multiFactor: {
                enrolledFactors: Oa(this.b, function(a) {
                    return a.v();
                })
            }
        };
    };
    function pm(a, b, c) {
        this.h = a;
        this.i = b;
        this.g = c;
        this.c = 3E4;
        this.f = 96E4;
        this.b = null;
        this.a = this.c;
        if (this.f < this.c) throw Error("Proactive refresh lower bound greater than upper bound!");
    }
    pm.prototype.start = function() {
        this.a = this.c;
        qm(this, !0);
    };
    function rm(a, b) {
        if (b) return a.a = a.c, a.g();
        b = a.a;
        a.a *= 2;
        a.a > a.f && (a.a = a.f);
        return b;
    }
    function qm(a, b) {
        a.stop();
        a.b = Bd(rm(a, b)).then(function() {
            return Ye();
        }).then(function() {
            return a.h();
        }).then(function() {
            qm(a, !0);
        }).o(function(c) {
            a.i(c) && qm(a, !1);
        });
    }
    pm.prototype.stop = function() {
        this.b && (this.b.cancel(), this.b = null);
    };
    function sm(a) {
        this.c = a;
        this.b = this.a = null;
    }
    sm.prototype.v = function() {
        return {
            apiKey: this.c.c,
            refreshToken: this.a,
            accessToken: this.b && this.b.toString(),
            expirationTime: tm(this)
        };
    };
    function tm(a) {
        return a.b && 1E3 * a.b.c || 0;
    }
    function um(a, b) {
        var c = b.refreshToken;
        a.b = gg(b[Ag] || "");
        a.a = c;
    }
    function vm(a, b) {
        a.b = b.b;
        a.a = b.a;
    }
    function wm(a, b) {
        return Qi(a.c, b).then(function(c) {
            a.b = gg(c.access_token);
            a.a = c.refresh_token;
            return {
                accessToken: a.b.toString(),
                refreshToken: a.a
            };
        }).o(function(c) {
            "auth/user-token-expired" == c.code && (a.a = null);
            throw c;
        });
    }
    sm.prototype.getToken = function(a) {
        a = !!a;
        return this.b && !this.a ? F(new u("user-token-expired")) : a || !this.b || ta() > tm(this) - 3E4 ? this.a ? wm(this, {
            grant_type: "refresh_token",
            refresh_token: this.a
        }) : E(null) : E({
            accessToken: this.b.toString(),
            refreshToken: this.a
        });
    };
    function xm(a, b) {
        this.a = a || null;
        this.b = b || null;
        L(this, {
            lastSignInTime: Ze(b || null),
            creationTime: Ze(a || null)
        });
    }
    function ym(a) {
        return new xm(a.a, a.b);
    }
    xm.prototype.v = function() {
        return {
            lastLoginAt: this.b,
            createdAt: this.a
        };
    };
    function zm(a, b, c, d, e, f) {
        L(this, {
            uid: a,
            displayName: d || null,
            photoURL: e || null,
            email: c || null,
            phoneNumber: f || null,
            providerId: b
        });
    }
    function P(a, b, c) {
        this.N = [];
        this.l = a.apiKey;
        this.m = a.appName;
        this.s = a.authDomain || null;
        a = (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION ? Le((0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION) : null;
        this.a = new Ei(this.l, za(Aa), a);
        this.b = new sm(this.a);
        Am(this, b[Ag]);
        um(this.b, b);
        K(this, "refreshToken", this.b.a);
        Bm(this, c || {});
        G.call(this);
        this.P = !1;
        this.s && Oe() && (this.i = Pl(this.s, this.l, this.m));
        this.R = [];
        this.h = null;
        this.B = Cm(this);
        this.Z = r(this.Ma, this);
        var d = this;
        this.oa = null;
        this.za = function(e) {
            d.va(e.g);
        };
        this.aa = null;
        this.W = [];
        this.ya = function(e) {
            Dm(d, e.c);
        };
        this.$ = null;
        this.O = new lm(this, c);
        K(this, "multiFactor", this.O);
    }
    t(P, G);
    P.prototype.va = function(a) {
        this.oa = a;
        Ki(this.a, a);
    };
    P.prototype.ja = function() {
        return this.oa;
    };
    function Em(a, b) {
        a.aa && td(a.aa, "languageCodeChanged", a.za);
        (a.aa = b) && jd(b, "languageCodeChanged", a.za);
    }
    function Dm(a, b) {
        a.W = b;
        Li(a.a, (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION ? Le((0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION, a.W) : null);
    }
    P.prototype.Ea = function() {
        return Wa(this.W);
    };
    function Fm(a, b) {
        a.$ && td(a.$, "frameworkChanged", a.ya);
        (a.$ = b) && jd(b, "frameworkChanged", a.ya);
    }
    P.prototype.Ma = function() {
        this.B.b && (this.B.stop(), this.B.start());
    };
    function Gm(a) {
        try {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).app(a.m).auth();
        } catch (b) {
            throw new u("internal-error", "No firebase.auth.Auth instance is available for the Firebase App '" + a.m + "'!");
        }
    }
    function Cm(a) {
        return new pm(function() {
            return a.I(!0);
        }, function(b) {
            return b && "auth/network-request-failed" == b.code ? !0 : !1;
        }, function() {
            var b = tm(a.b) - ta() - 3E5;
            return 0 < b ? b : 0;
        });
    }
    function Hm(a) {
        a.D || a.B.b || (a.B.start(), td(a, "tokenChanged", a.Z), jd(a, "tokenChanged", a.Z));
    }
    function Im(a) {
        td(a, "tokenChanged", a.Z);
        a.B.stop();
    }
    function Am(a, b) {
        a.xa = b;
        K(a, "_lat", b);
    }
    function Jm(a, b) {
        Ua(a.R, function(c) {
            return c == b;
        });
    }
    function Km(a) {
        for(var b = [], c = 0; c < a.R.length; c++)b.push(a.R[c](a));
        return Ec(b).then(function() {
            return a;
        });
    }
    function Lm(a) {
        a.i && !a.P && (a.P = !0, Hl(a.i, a));
    }
    function Bm(a, b) {
        L(a, {
            uid: b.uid,
            displayName: b.displayName || null,
            photoURL: b.photoURL || null,
            email: b.email || null,
            emailVerified: b.emailVerified || !1,
            phoneNumber: b.phoneNumber || null,
            isAnonymous: b.isAnonymous || !1,
            tenantId: b.tenantId || null,
            metadata: new xm(b.createdAt, b.lastLoginAt),
            providerData: []
        });
        a.a.b = a.tenantId;
    }
    K(P.prototype, "providerId", "firebase");
    function Mm() {}
    function Nm(a) {
        return E().then(function() {
            if (a.D) throw new u("app-deleted");
        });
    }
    function Om(a) {
        return Oa(a.providerData, function(b) {
            return b.providerId;
        });
    }
    function Pm(a, b) {
        b && (Qm(a, b.providerId), a.providerData.push(b));
    }
    function Qm(a, b) {
        Ua(a.providerData, function(c) {
            return c.providerId == b;
        });
    }
    function Rm(a, b, c) {
        ("uid" != b || c) && a.hasOwnProperty(b) && K(a, b, c);
    }
    function Sm(a, b) {
        a != b && (L(a, {
            uid: b.uid,
            displayName: b.displayName,
            photoURL: b.photoURL,
            email: b.email,
            emailVerified: b.emailVerified,
            phoneNumber: b.phoneNumber,
            isAnonymous: b.isAnonymous,
            tenantId: b.tenantId,
            providerData: []
        }), b.metadata ? K(a, "metadata", ym(b.metadata)) : K(a, "metadata", new xm), x(b.providerData, function(c) {
            Pm(a, c);
        }), vm(a.b, b.b), K(a, "refreshToken", a.b.a), mm(a.O, b.O.b));
    }
    k = P.prototype;
    k.reload = function() {
        var a = this;
        return R(this, Nm(this).then(function() {
            return Tm(a).then(function() {
                return Km(a);
            }).then(Mm);
        }));
    };
    function Tm(a) {
        return a.I().then(function(b) {
            var c = a.isAnonymous;
            return Um(a, b).then(function() {
                c || Rm(a, "isAnonymous", !1);
                return b;
            });
        });
    }
    k.mc = function(a) {
        return this.I(a).then(function(b) {
            return new $l(b);
        });
    };
    k.I = function(a) {
        var b = this;
        return R(this, Nm(this).then(function() {
            return b.b.getToken(a);
        }).then(function(c) {
            if (!c) throw new u("internal-error");
            c.accessToken != b.xa && (Am(b, c.accessToken), b.dispatchEvent(new km("tokenChanged")));
            Rm(b, "refreshToken", c.refreshToken);
            return c.accessToken;
        }));
    };
    function om(a, b) {
        b[Ag] && a.xa != b[Ag] && (um(a.b, b), a.dispatchEvent(new km("tokenChanged")), Am(a, b[Ag]), Rm(a, "refreshToken", a.b.a));
    }
    function Um(a, b) {
        return N(a.a, Cj, {
            idToken: b
        }).then(r(a.Ic, a));
    }
    k.Ic = function(a) {
        a = a.users;
        if (!a || !a.length) throw new u("internal-error");
        a = a[0];
        Bm(this, {
            uid: a.localId,
            displayName: a.displayName,
            photoURL: a.photoUrl,
            email: a.email,
            emailVerified: !!a.emailVerified,
            phoneNumber: a.phoneNumber,
            lastLoginAt: a.lastLoginAt,
            createdAt: a.createdAt,
            tenantId: a.tenantId
        });
        for(var b = Vm(a), c = 0; c < b.length; c++)Pm(this, b[c]);
        Rm(this, "isAnonymous", !(this.email && a.passwordHash) && !(this.providerData && this.providerData.length));
        this.dispatchEvent(new km("userReloaded", {
            ed: a
        }));
    };
    function Vm(a) {
        return (a = a.providerUserInfo) && a.length ? Oa(a, function(b) {
            return new zm(b.rawId, b.providerId, b.email, b.displayName, b.photoUrl, b.phoneNumber);
        }) : [];
    }
    k.Jc = function(a) {
        df("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");
        return this.pb(a);
    };
    k.pb = function(a) {
        var b = this, c = null;
        return R(this, a.c(this.a, this.uid).then(function(d) {
            om(b, d);
            c = Wm(b, d, "reauthenticate");
            b.h = null;
            return b.reload();
        }).then(function() {
            return c;
        }), !0);
    };
    function Xm(a, b) {
        return Tm(a).then(function() {
            if (Sa(Om(a), b)) return Km(a).then(function() {
                throw new u("provider-already-linked");
            });
        });
    }
    k.Ac = function(a) {
        df("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");
        return this.mb(a);
    };
    k.mb = function(a) {
        var b = this, c = null;
        return R(this, Xm(this, a.providerId).then(function() {
            return b.I();
        }).then(function(d) {
            return a.b(b.a, d);
        }).then(function(d) {
            c = Wm(b, d, "link");
            return Ym(b, d);
        }).then(function() {
            return c;
        }));
    };
    k.Bc = function(a, b) {
        var c = this;
        return R(this, Xm(this, "phone").then(function() {
            return Zl(Gm(c), a, b, r(c.mb, c));
        }));
    };
    k.Kc = function(a, b) {
        var c = this;
        return R(this, E().then(function() {
            return Zl(Gm(c), a, b, r(c.pb, c));
        }), !0);
    };
    function Wm(a, b, c) {
        var d = mh(b);
        b = lg(b);
        return gf({
            user: a,
            credential: d,
            additionalUserInfo: b,
            operationType: c
        });
    }
    function Ym(a, b) {
        om(a, b);
        return a.reload().then(function() {
            return a;
        });
    }
    k.xb = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.xb(c, a);
        }).then(function(c) {
            om(b, c);
            return b.reload();
        }));
    };
    k.cd = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return a.b(b.a, c);
        }).then(function(c) {
            om(b, c);
            return b.reload();
        }));
    };
    k.yb = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.yb(c, a);
        }).then(function(c) {
            om(b, c);
            return b.reload();
        }));
    };
    k.zb = function(a) {
        if (void 0 === a.displayName && void 0 === a.photoURL) return Nm(this);
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.zb(c, {
                displayName: a.displayName,
                photoUrl: a.photoURL
            });
        }).then(function(c) {
            om(b, c);
            Rm(b, "displayName", c.displayName || null);
            Rm(b, "photoURL", c.photoUrl || null);
            x(b.providerData, function(d) {
                "password" === d.providerId && (K(d, "displayName", b.displayName), K(d, "photoURL", b.photoURL));
            });
            return Km(b);
        }).then(Mm));
    };
    k.ad = function(a) {
        var b = this;
        return R(this, Tm(this).then(function(c) {
            return Sa(Om(b), a) ? lj(b.a, c, [
                a
            ]).then(function(d) {
                var e = {};
                x(d.providerUserInfo || [], function(f) {
                    e[f.providerId] = !0;
                });
                x(Om(b), function(f) {
                    e[f] || Qm(b, f);
                });
                e[hh.PROVIDER_ID] || K(b, "phoneNumber", null);
                return Km(b);
            }) : Km(b).then(function() {
                throw new u("no-such-provider");
            });
        }));
    };
    k.delete = function() {
        var a = this;
        return R(this, this.I().then(function(b) {
            return N(a.a, zj, {
                idToken: b
            });
        }).then(function() {
            a.dispatchEvent(new km("userDeleted"));
        })).then(function() {
            for(var b = 0; b < a.N.length; b++)a.N[b].cancel("app-deleted");
            Em(a, null);
            Fm(a, null);
            a.N = [];
            a.D = !0;
            Im(a);
            K(a, "refreshToken", null);
            a.i && Il(a.i, a);
        });
    };
    k.Cb = function(a, b) {
        return "linkViaPopup" == a && (this.g || null) == b && this.f || "reauthViaPopup" == a && (this.g || null) == b && this.f || "linkViaRedirect" == a && (this.fa || null) == b || "reauthViaRedirect" == a && (this.fa || null) == b ? !0 : !1;
    };
    k.la = function(a, b, c, d) {
        "linkViaPopup" != a && "reauthViaPopup" != a || d != (this.g || null) || (c && this.w ? this.w(c) : b && !c && this.f && this.f(b), this.c && (this.c.cancel(), this.c = null), delete this.f, delete this.w);
    };
    k.Da = function(a, b) {
        return "linkViaPopup" == a && b == (this.g || null) ? r(this.Hb, this) : "reauthViaPopup" == a && b == (this.g || null) ? r(this.Ib, this) : "linkViaRedirect" == a && (this.fa || null) == b ? r(this.Hb, this) : "reauthViaRedirect" == a && (this.fa || null) == b ? r(this.Ib, this) : null;
    };
    k.Cc = function(a) {
        var b = this;
        return Zm(this, "linkViaPopup", a, function() {
            return Xm(b, a.providerId).then(function() {
                return Km(b);
            });
        }, !1);
    };
    k.Lc = function(a) {
        return Zm(this, "reauthViaPopup", a, function() {
            return E();
        }, !0);
    };
    function Zm(a, b, c, d, e) {
        if (!Oe()) return F(new u("operation-not-supported-in-this-environment"));
        if (a.h && !e) return F(a.h);
        var f = kg(c.providerId), g = Ne(a.uid + ":::"), h = null;
        (!Qe() || Fe()) && a.s && c.isOAuthProvider && (h = Yj(a.s, a.l, a.m, b, c, null, g, (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION || null, null, null, a.tenantId));
        var m = we(h, f && f.ta, f && f.sa);
        d = d().then(function() {
            $m(a);
            if (!e) return a.I().then(function() {});
        }).then(function() {
            return Ll(a.i, m, b, c, g, !!h, a.tenantId);
        }).then(function() {
            return new D(function(p, v) {
                a.la(b, null, new u("cancelled-popup-request"), a.g || null);
                a.f = p;
                a.w = v;
                a.g = g;
                a.c = Nl(a.i, a, b, m, g);
            });
        }).then(function(p) {
            m && ve(m);
            return p ? gf(p) : null;
        }).o(function(p) {
            m && ve(m);
            throw p;
        });
        return R(a, d, e);
    }
    k.Dc = function(a) {
        var b = this;
        return an(this, "linkViaRedirect", a, function() {
            return Xm(b, a.providerId);
        }, !1);
    };
    k.Mc = function(a) {
        return an(this, "reauthViaRedirect", a, function() {
            return E();
        }, !0);
    };
    function an(a, b, c, d, e) {
        if (!Oe()) return F(new u("operation-not-supported-in-this-environment"));
        if (a.h && !e) return F(a.h);
        var f = null, g = Ne(a.uid + ":::");
        d = d().then(function() {
            $m(a);
            if (!e) return a.I().then(function() {});
        }).then(function() {
            a.fa = g;
            return Km(a);
        }).then(function(h) {
            a.ga && (h = a.ga, h = h.b.set(bn, a.v(), h.a));
            return h;
        }).then(function() {
            return Ml(a.i, b, c, g, a.tenantId);
        }).o(function(h) {
            f = h;
            if (a.ga) return cn(a.ga);
            throw f;
        }).then(function() {
            if (f) throw f;
        });
        return R(a, d, e);
    }
    function $m(a) {
        if (!a.i || !a.P) {
            if (a.i && !a.P) throw new u("internal-error");
            throw new u("auth-domain-config-required");
        }
    }
    k.Hb = function(a, b, c, d) {
        var e = this;
        this.c && (this.c.cancel(), this.c = null);
        var f = null;
        c = this.I().then(function(g) {
            return Eg(e.a, {
                requestUri: a,
                postBody: d,
                sessionId: b,
                idToken: g
            });
        }).then(function(g) {
            f = Wm(e, g, "link");
            return Ym(e, g);
        }).then(function() {
            return f;
        });
        return R(this, c);
    };
    k.Ib = function(a, b, c, d) {
        var e = this;
        this.c && (this.c.cancel(), this.c = null);
        var f = null, g = E().then(function() {
            return zg(Fg(e.a, {
                requestUri: a,
                sessionId: b,
                postBody: d,
                tenantId: c
            }), e.uid);
        }).then(function(h) {
            f = Wm(e, h, "reauthenticate");
            om(e, h);
            e.h = null;
            return e.reload();
        }).then(function() {
            return f;
        });
        return R(this, g, !0);
    };
    k.qb = function(a) {
        var b = this, c = null;
        return R(this, this.I().then(function(d) {
            c = d;
            return "undefined" === typeof a || jb(a) ? {} : Zf(new Pf(a));
        }).then(function(d) {
            return b.a.qb(c, d);
        }).then(function(d) {
            if (b.email != d) return b.reload();
        }).then(function() {}));
    };
    k.Ab = function(a, b) {
        var c = this, d = null;
        return R(this, this.I().then(function(e) {
            d = e;
            return "undefined" === typeof b || jb(b) ? {} : Zf(new Pf(b));
        }).then(function(e) {
            return c.a.Ab(d, a, e);
        }).then(function(e) {
            if (c.email != e) return c.reload();
        }).then(function() {}));
    };
    function R(a, b, c) {
        var d = dn(a, b, c);
        a.N.push(d);
        d.ma(function() {
            Ta(a.N, d);
        });
        return d.o(function(e) {
            var f = null;
            e && "auth/multi-factor-auth-required" === e.code && (f = em(e.v(), Gm(a), r(a.hc, a)));
            throw f || e;
        });
    }
    k.hc = function(a) {
        var b = null, c = this;
        a = zg(E(a), c.uid).then(function(d) {
            b = Wm(c, d, "reauthenticate");
            om(c, d);
            c.h = null;
            return c.reload();
        }).then(function() {
            return b;
        });
        return R(this, a, !0);
    };
    function dn(a, b, c) {
        return a.h && !c ? (b.cancel(), F(a.h)) : b.o(function(d) {
            !d || "auth/user-disabled" != d.code && "auth/user-token-expired" != d.code || (a.h || a.dispatchEvent(new km("userInvalidated")), a.h = d);
            throw d;
        });
    }
    k.toJSON = function() {
        return this.v();
    };
    k.v = function() {
        var a = {
            uid: this.uid,
            displayName: this.displayName,
            photoURL: this.photoURL,
            email: this.email,
            emailVerified: this.emailVerified,
            phoneNumber: this.phoneNumber,
            isAnonymous: this.isAnonymous,
            tenantId: this.tenantId,
            providerData: [],
            apiKey: this.l,
            appName: this.m,
            authDomain: this.s,
            stsTokenManager: this.b.v(),
            redirectEventId: this.fa || null
        };
        this.metadata && B(a, this.metadata.v());
        x(this.providerData, function(b) {
            a.providerData.push(hf(b));
        });
        B(a, this.O.v());
        return a;
    };
    function en(a) {
        if (!a.apiKey) return null;
        var b = {
            apiKey: a.apiKey,
            authDomain: a.authDomain,
            appName: a.appName
        }, c = {};
        if (a.stsTokenManager && a.stsTokenManager.accessToken) c[Ag] = a.stsTokenManager.accessToken, c.refreshToken = a.stsTokenManager.refreshToken || null;
        else return null;
        var d = new P(b, c, a);
        a.providerData && x(a.providerData, function(e) {
            e && Pm(d, gf(e));
        });
        a.redirectEventId && (d.fa = a.redirectEventId);
        return d;
    }
    function fn(a, b, c, d) {
        var e = new P(a, b);
        c && (e.ga = c);
        d && Dm(e, d);
        return e.reload().then(function() {
            return e;
        });
    }
    function gn(a, b, c, d) {
        var e = a.b, f = {};
        f[Ag] = e.b && e.b.toString();
        f.refreshToken = e.a;
        b = new P(b || {
            apiKey: a.l,
            authDomain: a.s,
            appName: a.m
        }, f);
        c && (b.ga = c);
        d && Dm(b, d);
        Sm(b, a);
        return b;
    }
    function hn(a) {
        this.a = a;
        this.b = Ok();
    }
    var bn = {
        name: "redirectUser",
        F: "session"
    };
    function cn(a) {
        return Sk(a.b, bn, a.a);
    }
    function jn(a, b) {
        return a.b.get(bn, a.a).then(function(c) {
            c && b && (c.authDomain = b);
            return en(c || {});
        });
    }
    function kn(a) {
        this.a = a;
        this.b = Ok();
        this.c = null;
        this.f = ln(this);
        this.b.addListener(mn("local"), this.a, r(this.g, this));
    }
    kn.prototype.g = function() {
        var a = this, b = mn("local");
        nn(this, function() {
            return E().then(function() {
                return a.c && "local" != a.c.F ? a.b.get(b, a.a) : null;
            }).then(function(c) {
                if (c) return on(a, "local").then(function() {
                    a.c = b;
                });
            });
        });
    };
    function on(a, b) {
        var c = [], d;
        for(d in Kk)Kk[d] !== b && c.push(Sk(a.b, mn(Kk[d]), a.a));
        c.push(Sk(a.b, pn, a.a));
        return Dc(c);
    }
    function ln(a) {
        var b = mn("local"), c = mn("session"), d = mn("none");
        return Rk(a.b, b, a.a).then(function() {
            return a.b.get(c, a.a);
        }).then(function(e) {
            return e ? c : a.b.get(d, a.a).then(function(f) {
                return f ? d : a.b.get(b, a.a).then(function(g) {
                    return g ? b : a.b.get(pn, a.a).then(function(h) {
                        return h ? mn(h) : b;
                    });
                });
            });
        }).then(function(e) {
            a.c = e;
            return on(a, e.F);
        }).o(function() {
            a.c || (a.c = b);
        });
    }
    var pn = {
        name: "persistence",
        F: "session"
    };
    function mn(a) {
        return {
            name: "authUser",
            F: a
        };
    }
    kn.prototype.tb = function(a) {
        var b = null, c = this;
        Lk(a);
        return nn(this, function() {
            return a != c.c.F ? c.b.get(c.c, c.a).then(function(d) {
                b = d;
                return on(c, a);
            }).then(function() {
                c.c = mn(a);
                if (b) return c.b.set(c.c, b, c.a);
            }) : E();
        });
    };
    function qn(a) {
        return nn(a, function() {
            return a.b.set(pn, a.c.F, a.a);
        });
    }
    function rn(a, b) {
        return nn(a, function() {
            return a.b.set(a.c, b.v(), a.a);
        });
    }
    function sn(a) {
        return nn(a, function() {
            return Sk(a.b, a.c, a.a);
        });
    }
    function tn(a, b) {
        return nn(a, function() {
            return a.b.get(a.c, a.a).then(function(c) {
                c && b && (c.authDomain = b);
                return en(c || {});
            });
        });
    }
    function nn(a, b) {
        a.f = a.f.then(b, b);
        return a.f;
    }
    function un(a) {
        this.l = !1;
        K(this, "settings", new Xl);
        K(this, "app", a);
        if (S(this).options && S(this).options.apiKey) a = (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION ? Le((0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION) : null, this.b = new Ei(S(this).options && S(this).options.apiKey, za(Aa), a);
        else throw new u("invalid-api-key");
        this.P = [];
        this.m = [];
        this.O = [];
        this.$b = (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.createSubscribe(r(this.xc, this));
        this.W = void 0;
        this.ac = (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.createSubscribe(r(this.yc, this));
        vn(this, null);
        this.i = new kn(S(this).options.apiKey + ":" + S(this).name);
        this.B = new hn(S(this).options.apiKey + ":" + S(this).name);
        this.Z = T(this, wn(this));
        this.h = T(this, xn(this));
        this.aa = !1;
        this.oa = r(this.Xc, this);
        this.Ma = r(this.ca, this);
        this.xa = r(this.jc, this);
        this.ya = r(this.uc, this);
        this.za = r(this.vc, this);
        this.a = null;
        yn(this);
        this.INTERNAL = {};
        this.INTERNAL["delete"] = r(this.delete, this);
        this.INTERNAL.logFramework = r(this.Ec, this);
        this.s = 0;
        G.call(this);
        zn(this);
        this.N = [];
    }
    t(un, G);
    function An(a) {
        Xc.call(this, "languageCodeChanged");
        this.g = a;
    }
    t(An, Xc);
    function Bn(a) {
        Xc.call(this, "frameworkChanged");
        this.c = a;
    }
    t(Bn, Xc);
    k = un.prototype;
    k.tb = function(a) {
        a = this.i.tb(a);
        return T(this, a);
    };
    k.va = function(a) {
        this.$ === a || this.l || (this.$ = a, Ki(this.b, this.$), this.dispatchEvent(new An(this.ja())));
    };
    k.ja = function() {
        return this.$;
    };
    k.dd = function() {
        var a = l.navigator;
        this.va(a ? a.languages && a.languages[0] || a.language || a.userLanguage || null : null);
    };
    k.Ec = function(a) {
        this.N.push(a);
        Li(this.b, (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION ? Le((0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION, this.N) : null);
        this.dispatchEvent(new Bn(this.N));
    };
    k.Ea = function() {
        return Wa(this.N);
    };
    k.ub = function(a) {
        this.R === a || this.l || (this.R = a, this.b.b = this.R);
    };
    k.S = function() {
        return this.R;
    };
    function zn(a) {
        Object.defineProperty(a, "lc", {
            get: function() {
                return this.ja();
            },
            set: function(b) {
                this.va(b);
            },
            enumerable: !1
        });
        a.$ = null;
        Object.defineProperty(a, "ti", {
            get: function() {
                return this.S();
            },
            set: function(b) {
                this.ub(b);
            },
            enumerable: !1
        });
        a.R = null;
    }
    k.toJSON = function() {
        return {
            apiKey: S(this).options.apiKey,
            authDomain: S(this).options.authDomain,
            appName: S(this).name,
            currentUser: U(this) && U(this).v()
        };
    };
    function Cn(a) {
        return a.Zb || F(new u("auth-domain-config-required"));
    }
    function yn(a) {
        var b = S(a).options.authDomain, c = S(a).options.apiKey;
        b && Oe() && (a.Zb = a.Z.then(function() {
            if (!a.l) {
                a.a = Pl(b, c, S(a).name);
                Hl(a.a, a);
                U(a) && Lm(U(a));
                if (a.D) {
                    Lm(a.D);
                    var d = a.D;
                    d.va(a.ja());
                    Em(d, a);
                    d = a.D;
                    Dm(d, a.N);
                    Fm(d, a);
                    a.D = null;
                }
                return a.a;
            }
        }));
    }
    k.Cb = function(a, b) {
        switch(a){
            case "unknown":
            case "signInViaRedirect":
                return !0;
            case "signInViaPopup":
                return this.g == b && !!this.f;
            default:
                return !1;
        }
    };
    k.la = function(a, b, c, d) {
        "signInViaPopup" == a && this.g == d && (c && this.w ? this.w(c) : b && !c && this.f && this.f(b), this.c && (this.c.cancel(), this.c = null), delete this.f, delete this.w);
    };
    k.Da = function(a, b) {
        return "signInViaRedirect" == a || "signInViaPopup" == a && this.g == b && this.f ? r(this.gc, this) : null;
    };
    k.gc = function(a, b, c, d) {
        var e = this, f = {
            requestUri: a,
            postBody: d,
            sessionId: b,
            tenantId: c
        };
        this.c && (this.c.cancel(), this.c = null);
        return e.Z.then(function() {
            return Dn(e, Cg(e.b, f));
        });
    };
    k.Vc = function(a) {
        if (!Oe()) return F(new u("operation-not-supported-in-this-environment"));
        var b = this, c = kg(a.providerId), d = Ne(), e = null;
        (!Qe() || Fe()) && S(this).options.authDomain && a.isOAuthProvider && (e = Yj(S(this).options.authDomain, S(this).options.apiKey, S(this).name, "signInViaPopup", a, null, d, (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION || null, null, null, this.S()));
        var f = we(e, c && c.ta, c && c.sa);
        c = Cn(this).then(function(g) {
            return Ll(g, f, "signInViaPopup", a, d, !!e, b.S());
        }).then(function() {
            return new D(function(g, h) {
                b.la("signInViaPopup", null, new u("cancelled-popup-request"), b.g);
                b.f = g;
                b.w = h;
                b.g = d;
                b.c = Nl(b.a, b, "signInViaPopup", f, d);
            });
        }).then(function(g) {
            f && ve(f);
            return g ? gf(g) : null;
        }).o(function(g) {
            f && ve(f);
            throw g;
        });
        return T(this, c);
    };
    k.Wc = function(a) {
        if (!Oe()) return F(new u("operation-not-supported-in-this-environment"));
        var b = this, c = Cn(this).then(function() {
            return qn(b.i);
        }).then(function() {
            return Ml(b.a, "signInViaRedirect", a, void 0, b.S());
        });
        return T(this, c);
    };
    function En(a) {
        if (!Oe()) return F(new u("operation-not-supported-in-this-environment"));
        var b = Cn(a).then(function() {
            return a.a.pa();
        }).then(function(c) {
            return c ? gf(c) : null;
        });
        return T(a, b);
    }
    k.pa = function() {
        var a = this;
        return En(this).then(function(b) {
            a.a && Sl(a.a.b);
            return b;
        }).o(function(b) {
            a.a && Sl(a.a.b);
            throw b;
        });
    };
    k.bd = function(a) {
        if (!a) return F(new u("null-user"));
        if (this.R != a.tenantId) return F(new u("tenant-id-mismatch"));
        var b = this, c = {};
        c.apiKey = S(this).options.apiKey;
        c.authDomain = S(this).options.authDomain;
        c.appName = S(this).name;
        var d = gn(a, c, b.B, b.Ea());
        return T(this, this.h.then(function() {
            if (S(b).options.apiKey != a.l) return d.reload();
        }).then(function() {
            if (U(b) && a.uid == U(b).uid) return Sm(U(b), a), b.ca(a);
            vn(b, d);
            Lm(d);
            return b.ca(d);
        }).then(function() {
            Fn(b);
        }));
    };
    function Gn(a, b) {
        var c = {};
        c.apiKey = S(a).options.apiKey;
        c.authDomain = S(a).options.authDomain;
        c.appName = S(a).name;
        return a.Z.then(function() {
            return fn(c, b, a.B, a.Ea());
        }).then(function(d) {
            if (U(a) && d.uid == U(a).uid) return Sm(U(a), d), a.ca(d);
            vn(a, d);
            Lm(d);
            return a.ca(d);
        }).then(function() {
            Fn(a);
        });
    }
    function vn(a, b) {
        U(a) && (Jm(U(a), a.Ma), td(U(a), "tokenChanged", a.xa), td(U(a), "userDeleted", a.ya), td(U(a), "userInvalidated", a.za), Im(U(a)));
        b && (b.R.push(a.Ma), jd(b, "tokenChanged", a.xa), jd(b, "userDeleted", a.ya), jd(b, "userInvalidated", a.za), 0 < a.s && Hm(b));
        K(a, "currentUser", b);
        b && (b.va(a.ja()), Em(b, a), Dm(b, a.N), Fm(b, a));
    }
    k.wb = function() {
        var a = this, b = this.h.then(function() {
            a.a && Sl(a.a.b);
            if (!U(a)) return E();
            vn(a, null);
            return sn(a.i).then(function() {
                Fn(a);
            });
        });
        return T(this, b);
    };
    function Hn(a) {
        var b = jn(a.B, S(a).options.authDomain).then(function(c) {
            if (a.D = c) c.ga = a.B;
            return cn(a.B);
        });
        return T(a, b);
    }
    function wn(a) {
        var b = S(a).options.authDomain, c = Hn(a).then(function() {
            return tn(a.i, b);
        }).then(function(d) {
            return d ? (d.ga = a.B, a.D && (a.D.fa || null) == (d.fa || null) ? d : d.reload().then(function() {
                return rn(a.i, d).then(function() {
                    return d;
                });
            }).o(function(e) {
                return "auth/network-request-failed" == e.code ? d : sn(a.i);
            })) : null;
        }).then(function(d) {
            vn(a, d || null);
        });
        return T(a, c);
    }
    function xn(a) {
        return a.Z.then(function() {
            return En(a);
        }).o(function() {}).then(function() {
            if (!a.l) return a.oa();
        }).o(function() {}).then(function() {
            if (!a.l) {
                a.aa = !0;
                var b = a.i;
                b.b.addListener(mn("local"), b.a, a.oa);
            }
        });
    }
    k.Xc = function() {
        var a = this;
        return tn(this.i, S(this).options.authDomain).then(function(b) {
            if (!a.l) {
                var c;
                if (c = U(a) && b) {
                    c = U(a).uid;
                    var d = b.uid;
                    c = void 0 === c || null === c || "" === c || void 0 === d || null === d || "" === d ? !1 : c == d;
                }
                if (c) return Sm(U(a), b), U(a).I();
                if (U(a) || b) vn(a, b), b && (Lm(b), b.ga = a.B), a.a && Hl(a.a, a), Fn(a);
            }
        });
    };
    k.ca = function(a) {
        return rn(this.i, a);
    };
    k.jc = function() {
        Fn(this);
        this.ca(U(this));
    };
    k.uc = function() {
        this.wb();
    };
    k.vc = function() {
        this.wb();
    };
    function Dn(a, b) {
        var c = null, d = null;
        return T(a, b.then(function(e) {
            c = mh(e);
            d = lg(e);
            return Gn(a, e);
        }, function(e) {
            var f = null;
            e && "auth/multi-factor-auth-required" === e.code && (f = em(e.v(), a, r(a.ic, a)));
            throw f || e;
        }).then(function() {
            return gf({
                user: U(a),
                credential: c,
                additionalUserInfo: d,
                operationType: "signIn"
            });
        }));
    }
    k.ic = function(a) {
        var b = this;
        return this.h.then(function() {
            return Dn(b, E(a));
        });
    };
    k.xc = function(a) {
        var b = this;
        this.addAuthTokenListener(function() {
            a.next(U(b));
        });
    };
    k.yc = function(a) {
        var b = this;
        In(this, function() {
            a.next(U(b));
        });
    };
    k.Gc = function(a, b, c) {
        var d = this;
        this.aa && Promise.resolve().then(function() {
            n(a) ? a(U(d)) : n(a.next) && a.next(U(d));
        });
        return this.$b(a, b, c);
    };
    k.Fc = function(a, b, c) {
        var d = this;
        this.aa && Promise.resolve().then(function() {
            d.W = d.getUid();
            n(a) ? a(U(d)) : n(a.next) && a.next(U(d));
        });
        return this.ac(a, b, c);
    };
    k.kc = function(a) {
        var b = this, c = this.h.then(function() {
            return U(b) ? U(b).I(a).then(function(d) {
                return {
                    accessToken: d
                };
            }) : null;
        });
        return T(this, c);
    };
    k.Rc = function(a) {
        var b = this;
        return this.h.then(function() {
            return Dn(b, N(b.b, Ej, {
                token: a
            }));
        }).then(function(c) {
            var d = c.user;
            Rm(d, "isAnonymous", !1);
            b.ca(d);
            return c;
        });
    };
    k.Sc = function(a, b) {
        var c = this;
        return this.h.then(function() {
            return Dn(c, N(c.b, Xg, {
                email: a,
                password: b
            }));
        });
    };
    k.cc = function(a, b) {
        var c = this;
        return this.h.then(function() {
            return Dn(c, N(c.b, yj, {
                email: a,
                password: b
            }));
        });
    };
    k.Ya = function(a) {
        var b = this;
        return this.h.then(function() {
            return Dn(b, a.ia(b.b));
        });
    };
    k.Qc = function(a) {
        df("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");
        return this.Ya(a);
    };
    k.vb = function() {
        var a = this;
        return this.h.then(function() {
            var b = U(a);
            if (b && b.isAnonymous) {
                var c = gf({
                    providerId: null,
                    isNewUser: !1
                });
                return gf({
                    user: b,
                    credential: null,
                    additionalUserInfo: c,
                    operationType: "signIn"
                });
            }
            return Dn(a, a.b.vb()).then(function(d) {
                var e = d.user;
                Rm(e, "isAnonymous", !0);
                a.ca(e);
                return d;
            });
        });
    };
    function S(a) {
        return a.app;
    }
    function U(a) {
        return a.currentUser;
    }
    k.getUid = function() {
        return U(this) && U(this).uid || null;
    };
    function Jn(a) {
        return U(a) && U(a)._lat || null;
    }
    function Fn(a) {
        if (a.aa) {
            for(var b = 0; b < a.m.length; b++)if (a.m[b]) a.m[b](Jn(a));
            if (a.W !== a.getUid() && a.O.length) {
                for(a.W = a.getUid(), b = 0; b < a.O.length; b++)if (a.O[b]) a.O[b](Jn(a));
            }
        }
    }
    k.bc = function(a) {
        this.addAuthTokenListener(a);
        this.s++;
        0 < this.s && U(this) && Hm(U(this));
    };
    k.Nc = function(a) {
        var b = this;
        x(this.m, function(c) {
            c == a && b.s--;
        });
        0 > this.s && (this.s = 0);
        0 == this.s && U(this) && Im(U(this));
        this.removeAuthTokenListener(a);
    };
    k.addAuthTokenListener = function(a) {
        var b = this;
        this.m.push(a);
        T(this, this.h.then(function() {
            b.l || Sa(b.m, a) && a(Jn(b));
        }));
    };
    k.removeAuthTokenListener = function(a) {
        Ua(this.m, function(b) {
            return b == a;
        });
    };
    function In(a, b) {
        a.O.push(b);
        T(a, a.h.then(function() {
            !a.l && Sa(a.O, b) && a.W !== a.getUid() && (a.W = a.getUid(), b(Jn(a)));
        }));
    }
    k.delete = function() {
        this.l = !0;
        for(var a = 0; a < this.P.length; a++)this.P[a].cancel("app-deleted");
        this.P = [];
        this.i && (a = this.i, a.b.removeListener(mn("local"), a.a, this.oa));
        this.a && (Il(this.a, this), Sl(this.a.b));
        return Promise.resolve();
    };
    function T(a, b) {
        a.P.push(b);
        b.ma(function() {
            Ta(a.P, b);
        });
        return b;
    }
    k.fc = function(a) {
        return T(this, Vi(this.b, a));
    };
    k.zc = function(a) {
        return !!bh(a);
    };
    k.sb = function(a, b) {
        var c = this;
        return T(this, E().then(function() {
            var d = new Pf(b);
            if (!d.c) throw new u("argument-error", Xf + " must be true when sending sign in link to email");
            return Zf(d);
        }).then(function(d) {
            return c.b.sb(a, d);
        }).then(function() {}));
    };
    k.fd = function(a) {
        return this.Pa(a).then(function(b) {
            return b.data.email;
        });
    };
    k.jb = function(a, b) {
        return T(this, this.b.jb(a, b).then(function() {}));
    };
    k.Pa = function(a) {
        return T(this, this.b.Pa(a).then(function(b) {
            return new sf(b);
        }));
    };
    k.fb = function(a) {
        return T(this, this.b.fb(a).then(function() {}));
    };
    k.rb = function(a, b) {
        var c = this;
        return T(this, E().then(function() {
            return "undefined" === typeof b || jb(b) ? {} : Zf(new Pf(b));
        }).then(function(d) {
            return c.b.rb(a, d);
        }).then(function() {}));
    };
    k.Uc = function(a, b) {
        return T(this, Zl(this, a, b, r(this.Ya, this)));
    };
    k.Tc = function(a, b) {
        var c = this;
        return T(this, E().then(function() {
            var d = b || oe(), e = ah(a, d);
            d = bh(d);
            if (!d) throw new u("argument-error", "Invalid email link!");
            if (d.tenantId !== c.S()) throw new u("tenant-id-mismatch");
            return c.Ya(e);
        }));
    };
    function Kn() {}
    Kn.prototype.render = function() {};
    Kn.prototype.reset = function() {};
    Kn.prototype.getResponse = function() {};
    Kn.prototype.execute = function() {};
    function Ln() {
        this.a = {};
        this.b = 1E12;
    }
    var Mn = null;
    Ln.prototype.render = function(a, b) {
        this.a[this.b.toString()] = new Nn(a, b);
        return this.b++;
    };
    Ln.prototype.reset = function(a) {
        var b = On(this, a);
        a = Pn(a);
        b && a && (b.delete(), delete this.a[a]);
    };
    Ln.prototype.getResponse = function(a) {
        return (a = On(this, a)) ? a.getResponse() : null;
    };
    Ln.prototype.execute = function(a) {
        (a = On(this, a)) && a.execute();
    };
    function On(a, b) {
        return (b = Pn(b)) ? a.a[b] || null : null;
    }
    function Pn(a) {
        return (a = "undefined" === typeof a ? 1E12 : a) ? a.toString() : null;
    }
    function Nn(a, b) {
        this.g = !1;
        this.c = b;
        this.a = this.b = null;
        this.h = "invisible" !== this.c.size;
        this.f = ec(a);
        var c = this;
        this.i = function() {
            c.execute();
        };
        this.h ? this.execute() : jd(this.f, "click", this.i);
    }
    Nn.prototype.getResponse = function() {
        Qn(this);
        return this.b;
    };
    Nn.prototype.execute = function() {
        Qn(this);
        var a = this;
        this.a || (this.a = setTimeout(function() {
            a.b = Je();
            var b = a.c.callback, c = a.c["expired-callback"];
            if (b) try {
                b(a.b);
            } catch (d) {}
            a.a = setTimeout(function() {
                a.a = null;
                a.b = null;
                if (c) try {
                    c();
                } catch (d) {}
                a.h && a.execute();
            }, 6E4);
        }, 500));
    };
    Nn.prototype.delete = function() {
        Qn(this);
        this.g = !0;
        clearTimeout(this.a);
        this.a = null;
        td(this.f, "click", this.i);
    };
    function Qn(a) {
        if (a.g) throw Error("reCAPTCHA mock was already deleted!");
    }
    function Rn() {}
    K(Rn, "FACTOR_ID", "phone");
    function Sn() {}
    Sn.prototype.g = function() {
        Mn || (Mn = new Ln);
        return E(Mn);
    };
    Sn.prototype.c = function() {};
    var Tn = null;
    function Un() {
        this.b = l.grecaptcha ? Infinity : 0;
        this.f = null;
        this.a = "__rcb" + Math.floor(1E6 * Math.random()).toString();
    }
    var Vn = new nb(ob, "https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"), Wn = new We(3E4, 6E4);
    Un.prototype.g = function(a) {
        var b = this;
        return new D(function(c, d) {
            var e = setTimeout(function() {
                d(new u("network-request-failed"));
            }, Wn.get());
            if (!l.grecaptcha || a !== b.f && !b.b) {
                l[b.a] = function() {
                    if (l.grecaptcha) {
                        b.f = a;
                        var g = l.grecaptcha.render;
                        l.grecaptcha.render = function(h, m) {
                            h = g(h, m);
                            b.b++;
                            return h;
                        };
                        clearTimeout(e);
                        c(l.grecaptcha);
                    } else clearTimeout(e), d(new u("internal-error"));
                    delete l[b.a];
                };
                var f = wb(Vn, {
                    onload: b.a,
                    hl: a || ""
                });
                E(xi(f)).o(function() {
                    clearTimeout(e);
                    d(new u("internal-error", "Unable to load external reCAPTCHA dependencies!"));
                });
            } else clearTimeout(e), c(l.grecaptcha);
        });
    };
    Un.prototype.c = function() {
        this.b--;
    };
    var Xn = null;
    function Yn(a, b, c, d, e, f, g) {
        K(this, "type", "recaptcha");
        this.c = this.f = null;
        this.D = !1;
        this.u = b;
        this.g = null;
        g ? (Tn || (Tn = new Sn), g = Tn) : (Xn || (Xn = new Un), g = Xn);
        this.m = g;
        this.a = c || {
            theme: "light",
            type: "image"
        };
        this.h = [];
        if (this.a[Zn]) throw new u("argument-error", "sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");
        this.i = "invisible" === this.a[$n];
        if (!l.document) throw new u("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
        if (!ec(b) || !this.i && ec(b).hasChildNodes()) throw new u("argument-error", "reCAPTCHA container is either not found or already contains inner elements!");
        this.s = new Ei(a, f || null, e || null);
        this.w = d || function() {
            return null;
        };
        var h = this;
        this.l = [];
        var m = this.a[ao];
        this.a[ao] = function(v) {
            bo(h, v);
            if ("function" === typeof m) m(v);
            else if ("string" === typeof m) {
                var C = J(m, l);
                "function" === typeof C && C(v);
            }
        };
        var p = this.a[co];
        this.a[co] = function() {
            bo(h, null);
            if ("function" === typeof p) p();
            else if ("string" === typeof p) {
                var v = J(p, l);
                "function" === typeof v && v();
            }
        };
    }
    var ao = "callback", co = "expired-callback", Zn = "sitekey", $n = "size";
    function bo(a, b) {
        for(var c = 0; c < a.l.length; c++)try {
            a.l[c](b);
        } catch (d) {}
    }
    function eo(a, b) {
        Ua(a.l, function(c) {
            return c == b;
        });
    }
    function fo(a, b) {
        a.h.push(b);
        b.ma(function() {
            Ta(a.h, b);
        });
        return b;
    }
    k = Yn.prototype;
    k.Ga = function() {
        var a = this;
        return this.f ? this.f : this.f = fo(this, E().then(function() {
            if (Pe() && !Ge()) return Be();
            throw new u("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");
        }).then(function() {
            return a.m.g(a.w());
        }).then(function(b) {
            a.g = b;
            return N(a.s, Dj, {});
        }).then(function(b) {
            a.a[Zn] = b.recaptchaSiteKey;
        }).o(function(b) {
            a.f = null;
            throw b;
        }));
    };
    k.render = function() {
        go(this);
        var a = this;
        return fo(this, this.Ga().then(function() {
            if (null === a.c) {
                var b = a.u;
                if (!a.i) {
                    var c = ec(b);
                    b = hc("DIV");
                    c.appendChild(b);
                }
                a.c = a.g.render(b, a.a);
            }
            return a.c;
        }));
    };
    k.verify = function() {
        go(this);
        var a = this;
        return fo(this, this.render().then(function(b) {
            return new D(function(c) {
                var d = a.g.getResponse(b);
                if (d) c(d);
                else {
                    var e = function(f) {
                        f && (eo(a, e), c(f));
                    };
                    a.l.push(e);
                    a.i && a.g.execute(a.c);
                }
            });
        }));
    };
    k.reset = function() {
        go(this);
        null !== this.c && this.g.reset(this.c);
    };
    function go(a) {
        if (a.D) throw new u("internal-error", "RecaptchaVerifier instance has been destroyed.");
    }
    k.clear = function() {
        go(this);
        this.D = !0;
        this.m.c();
        for(var a = 0; a < this.h.length; a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");
        if (!this.i) {
            a = ec(this.u);
            for(var b; b = a.firstChild;)a.removeChild(b);
        }
    };
    function ho(a, b, c) {
        var d = !1;
        try {
            this.b = c || (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).app();
        } catch (g) {
            throw new u("argument-error", "No firebase.app.App instance is currently initialized.");
        }
        if (this.b.options && this.b.options.apiKey) c = this.b.options.apiKey;
        else throw new u("invalid-api-key");
        var e = this, f = null;
        try {
            f = this.b.auth().Ea();
        } catch (g) {}
        try {
            d = this.b.auth().settings.appVerificationDisabledForTesting;
        } catch (g) {}
        f = (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION ? Le((0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).SDK_VERSION, f) : null;
        Yn.call(this, c, a, b, function() {
            try {
                var g = e.b.auth().ja();
            } catch (h) {
                g = null;
            }
            return g;
        }, f, za(Aa), d);
    }
    t(ho, Yn);
    function io(a, b, c, d) {
        a: {
            c = Array.prototype.slice.call(c);
            var e = 0;
            for(var f = !1, g = 0; g < b.length; g++)if (b[g].optional) f = !0;
            else {
                if (f) throw new u("internal-error", "Argument validator encountered a required argument after an optional argument.");
                e++;
            }
            f = b.length;
            if (c.length < e || f < c.length) d = "Expected " + (e == f ? 1 == e ? "1 argument" : e + " arguments" : e + "-" + f + " arguments") + " but got " + c.length + ".";
            else {
                for(e = 0; e < c.length; e++)if (f = b[e].optional && void 0 === c[e], !b[e].K(c[e]) && !f) {
                    b = b[e];
                    if (0 > e || e >= jo.length) throw new u("internal-error", "Argument validator received an unsupported number of arguments.");
                    c = jo[e];
                    d = (d ? "" : c + " argument ") + (b.name ? '"' + b.name + '" ' : "") + "must be " + b.J + ".";
                    break a;
                }
                d = null;
            }
        }
        if (d) throw new u("argument-error", a + " failed: " + d);
    }
    var jo = "First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");
    function V(a, b) {
        return {
            name: a || "",
            J: "a valid string",
            optional: !!b,
            K: function(c) {
                return "string" === typeof c;
            }
        };
    }
    function ko(a, b) {
        return {
            name: a || "",
            J: "a boolean",
            optional: !!b,
            K: function(c) {
                return "boolean" === typeof c;
            }
        };
    }
    function W(a, b) {
        return {
            name: a || "",
            J: "a valid object",
            optional: !!b,
            K: q
        };
    }
    function lo(a, b) {
        return {
            name: a || "",
            J: "a function",
            optional: !!b,
            K: n
        };
    }
    function mo(a, b) {
        return {
            name: a || "",
            J: "null",
            optional: !!b,
            K: function(c) {
                return null === c;
            }
        };
    }
    function no() {
        return {
            name: "",
            J: "an HTML element",
            optional: !1,
            K: function(a) {
                return !!(a && a instanceof Element);
            }
        };
    }
    function oo() {
        return {
            name: "auth",
            J: "an instance of Firebase Auth",
            optional: !0,
            K: function(a) {
                return !!(a && a instanceof un);
            }
        };
    }
    function po() {
        return {
            name: "app",
            J: "an instance of Firebase App",
            optional: !0,
            K: function(a) {
                return !!(a && a instanceof (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).app.App);
            }
        };
    }
    function qo(a) {
        return {
            name: a ? a + "Credential" : "credential",
            J: a ? "a valid " + a + " credential" : "a valid credential",
            optional: !1,
            K: function(b) {
                if (!b) return !1;
                var c = !a || b.providerId === a;
                return !(!b.ia || !c);
            }
        };
    }
    function ro() {
        return {
            name: "multiFactorAssertion",
            J: "a valid multiFactorAssertion",
            optional: !1,
            K: function(a) {
                return a ? !!a.ob : !1;
            }
        };
    }
    function so() {
        return {
            name: "authProvider",
            J: "a valid Auth provider",
            optional: !1,
            K: function(a) {
                return !!(a && a.providerId && a.hasOwnProperty && a.hasOwnProperty("isOAuthProvider"));
            }
        };
    }
    function to(a, b) {
        return q(a) && "string" === typeof a.type && a.type === b && n(a.Fa);
    }
    function uo(a) {
        return q(a) && "string" === typeof a.uid;
    }
    function vo() {
        return {
            name: "applicationVerifier",
            J: "an implementation of firebase.auth.ApplicationVerifier",
            optional: !1,
            K: function(a) {
                return !(!a || "string" !== typeof a.type || !n(a.verify));
            }
        };
    }
    function X(a, b, c, d) {
        return {
            name: c || "",
            J: a.J + " or " + b.J,
            optional: !!d,
            K: function(e) {
                return a.K(e) || b.K(e);
            }
        };
    }
    function Y(a, b) {
        for(var c in b){
            var d = b[c].name;
            a[d] = wo(d, a[c], b[c].j);
        }
    }
    function xo(a, b) {
        for(var c in b){
            var d = b[c].name;
            d !== c && Object.defineProperty(a, d, {
                get: sa(function(e) {
                    return this[e];
                }, c),
                set: sa(function(e, f, g, h) {
                    io(e, [
                        g
                    ], [
                        h
                    ], !0);
                    this[f] = h;
                }, d, c, b[c].gb),
                enumerable: !0
            });
        }
    }
    function Z(a, b, c, d) {
        a[b] = wo(b, c, d);
    }
    function wo(a, b, c) {
        function d() {
            var g = Array.prototype.slice.call(arguments);
            io(e, c, g);
            return b.apply(this, g);
        }
        if (!c) return b;
        var e = yo(a), f;
        for(f in b)d[f] = b[f];
        for(f in b.prototype)d.prototype[f] = b.prototype[f];
        return d;
    }
    function yo(a) {
        a = a.split(".");
        return a[a.length - 1];
    }
    Y(un.prototype, {
        fb: {
            name: "applyActionCode",
            j: [
                V("code")
            ]
        },
        Pa: {
            name: "checkActionCode",
            j: [
                V("code")
            ]
        },
        jb: {
            name: "confirmPasswordReset",
            j: [
                V("code"),
                V("newPassword")
            ]
        },
        cc: {
            name: "createUserWithEmailAndPassword",
            j: [
                V("email"),
                V("password")
            ]
        },
        fc: {
            name: "fetchSignInMethodsForEmail",
            j: [
                V("email")
            ]
        },
        pa: {
            name: "getRedirectResult",
            j: []
        },
        zc: {
            name: "isSignInWithEmailLink",
            j: [
                V("emailLink")
            ]
        },
        Fc: {
            name: "onAuthStateChanged",
            j: [
                X(W(), lo(), "nextOrObserver"),
                lo("opt_error", !0),
                lo("opt_completed", !0)
            ]
        },
        Gc: {
            name: "onIdTokenChanged",
            j: [
                X(W(), lo(), "nextOrObserver"),
                lo("opt_error", !0),
                lo("opt_completed", !0)
            ]
        },
        rb: {
            name: "sendPasswordResetEmail",
            j: [
                V("email"),
                X(W("opt_actionCodeSettings", !0), mo(null, !0), "opt_actionCodeSettings", !0)
            ]
        },
        sb: {
            name: "sendSignInLinkToEmail",
            j: [
                V("email"),
                W("actionCodeSettings")
            ]
        },
        tb: {
            name: "setPersistence",
            j: [
                V("persistence")
            ]
        },
        Qc: {
            name: "signInAndRetrieveDataWithCredential",
            j: [
                qo()
            ]
        },
        vb: {
            name: "signInAnonymously",
            j: []
        },
        Ya: {
            name: "signInWithCredential",
            j: [
                qo()
            ]
        },
        Rc: {
            name: "signInWithCustomToken",
            j: [
                V("token")
            ]
        },
        Sc: {
            name: "signInWithEmailAndPassword",
            j: [
                V("email"),
                V("password")
            ]
        },
        Tc: {
            name: "signInWithEmailLink",
            j: [
                V("email"),
                V("emailLink", !0)
            ]
        },
        Uc: {
            name: "signInWithPhoneNumber",
            j: [
                V("phoneNumber"),
                vo()
            ]
        },
        Vc: {
            name: "signInWithPopup",
            j: [
                so()
            ]
        },
        Wc: {
            name: "signInWithRedirect",
            j: [
                so()
            ]
        },
        bd: {
            name: "updateCurrentUser",
            j: [
                X(function(a) {
                    return {
                        name: "user",
                        J: "an instance of Firebase User",
                        optional: !!a,
                        K: function(b) {
                            return !!(b && b instanceof P);
                        }
                    };
                }(), mo(), "user")
            ]
        },
        wb: {
            name: "signOut",
            j: []
        },
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        },
        dd: {
            name: "useDeviceLanguage",
            j: []
        },
        fd: {
            name: "verifyPasswordResetCode",
            j: [
                V("code")
            ]
        }
    });
    xo(un.prototype, {
        lc: {
            name: "languageCode",
            gb: X(V(), mo(), "languageCode")
        },
        ti: {
            name: "tenantId",
            gb: X(V(), mo(), "tenantId")
        }
    });
    un.Persistence = Kk;
    un.Persistence.LOCAL = "local";
    un.Persistence.SESSION = "session";
    un.Persistence.NONE = "none";
    Y(P.prototype, {
        "delete": {
            name: "delete",
            j: []
        },
        mc: {
            name: "getIdTokenResult",
            j: [
                ko("opt_forceRefresh", !0)
            ]
        },
        I: {
            name: "getIdToken",
            j: [
                ko("opt_forceRefresh", !0)
            ]
        },
        Ac: {
            name: "linkAndRetrieveDataWithCredential",
            j: [
                qo()
            ]
        },
        mb: {
            name: "linkWithCredential",
            j: [
                qo()
            ]
        },
        Bc: {
            name: "linkWithPhoneNumber",
            j: [
                V("phoneNumber"),
                vo()
            ]
        },
        Cc: {
            name: "linkWithPopup",
            j: [
                so()
            ]
        },
        Dc: {
            name: "linkWithRedirect",
            j: [
                so()
            ]
        },
        Jc: {
            name: "reauthenticateAndRetrieveDataWithCredential",
            j: [
                qo()
            ]
        },
        pb: {
            name: "reauthenticateWithCredential",
            j: [
                qo()
            ]
        },
        Kc: {
            name: "reauthenticateWithPhoneNumber",
            j: [
                V("phoneNumber"),
                vo()
            ]
        },
        Lc: {
            name: "reauthenticateWithPopup",
            j: [
                so()
            ]
        },
        Mc: {
            name: "reauthenticateWithRedirect",
            j: [
                so()
            ]
        },
        reload: {
            name: "reload",
            j: []
        },
        qb: {
            name: "sendEmailVerification",
            j: [
                X(W("opt_actionCodeSettings", !0), mo(null, !0), "opt_actionCodeSettings", !0)
            ]
        },
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        },
        ad: {
            name: "unlink",
            j: [
                V("provider")
            ]
        },
        xb: {
            name: "updateEmail",
            j: [
                V("email")
            ]
        },
        yb: {
            name: "updatePassword",
            j: [
                V("password")
            ]
        },
        cd: {
            name: "updatePhoneNumber",
            j: [
                qo("phone")
            ]
        },
        zb: {
            name: "updateProfile",
            j: [
                W("profile")
            ]
        },
        Ab: {
            name: "verifyBeforeUpdateEmail",
            j: [
                V("email"),
                X(W("opt_actionCodeSettings", !0), mo(null, !0), "opt_actionCodeSettings", !0)
            ]
        }
    });
    Y(Ln.prototype, {
        execute: {
            name: "execute"
        },
        render: {
            name: "render"
        },
        reset: {
            name: "reset"
        },
        getResponse: {
            name: "getResponse"
        }
    });
    Y(Kn.prototype, {
        execute: {
            name: "execute"
        },
        render: {
            name: "render"
        },
        reset: {
            name: "reset"
        },
        getResponse: {
            name: "getResponse"
        }
    });
    Y(D.prototype, {
        ma: {
            name: "finally"
        },
        o: {
            name: "catch"
        },
        then: {
            name: "then"
        }
    });
    xo(Xl.prototype, {
        appVerificationDisabled: {
            name: "appVerificationDisabledForTesting",
            gb: ko("appVerificationDisabledForTesting")
        }
    });
    Y(Yl.prototype, {
        confirm: {
            name: "confirm",
            j: [
                V("verificationCode")
            ]
        }
    });
    Z(yg, "fromJSON", function(a) {
        a = "string" === typeof a ? JSON.parse(a) : a;
        for(var b, c = [
            Jg,
            $g,
            gh,
            Gg
        ], d = 0; d < c.length; d++)if (b = c[d](a)) return b;
        return null;
    }, [
        X(V(), W(), "json")
    ]);
    Z(Vg, "credential", function(a, b) {
        return new Ug(a, b);
    }, [
        V("email"),
        V("password")
    ]);
    Y(Ug.prototype, {
        v: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(Mg.prototype, {
        Aa: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ia: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Mg, "credential", Ng, [
        X(V(), W(), "token")
    ]);
    Z(Vg, "credentialWithLink", ah, [
        V("email"),
        V("emailLink")
    ]);
    Y(Og.prototype, {
        Aa: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ia: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Og, "credential", Pg, [
        X(V(), W(), "token")
    ]);
    Y(Qg.prototype, {
        Aa: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ia: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Qg, "credential", Rg, [
        X(V(), X(W(), mo()), "idToken"),
        X(V(), mo(), "accessToken", !0)
    ]);
    Y(Sg.prototype, {
        Ia: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Sg, "credential", Tg, [
        X(V(), W(), "token"),
        V("secret", !0)
    ]);
    Y(M.prototype, {
        Aa: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        credential: {
            name: "credential",
            j: [
                X(V(), X(W(), mo()), "optionsOrIdToken"),
                X(V(), mo(), "accessToken", !0)
            ]
        },
        Ia: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Y(Hg.prototype, {
        v: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(Bg.prototype, {
        v: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Z(hh, "credential", lh, [
        V("verificationId"),
        V("verificationCode")
    ]);
    Y(hh.prototype, {
        cb: {
            name: "verifyPhoneNumber",
            j: [
                X(V(), function(a, b) {
                    return {
                        name: a || "phoneInfoOptions",
                        J: "valid phone info options",
                        optional: !!b,
                        K: function(c) {
                            return c ? c.session && c.phoneNumber ? to(c.session, wg) && "string" === typeof c.phoneNumber : c.session && c.multiFactorHint ? to(c.session, xg) && uo(c.multiFactorHint) : c.session && c.multiFactorUid ? to(c.session, xg) && "string" === typeof c.multiFactorUid : c.phoneNumber ? "string" === typeof c.phoneNumber : !1 : !1;
                        }
                    };
                }(), "phoneInfoOptions"),
                vo()
            ]
        }
    });
    Y(ch.prototype, {
        v: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(u.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(uh.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(th.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(dm.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(am.prototype, {
        Pc: {
            name: "resolveSignIn",
            j: [
                ro()
            ]
        }
    });
    Y(lm.prototype, {
        Ob: {
            name: "getSession",
            j: []
        },
        dc: {
            name: "enroll",
            j: [
                ro(),
                V("displayName", !0)
            ]
        },
        $c: {
            name: "unenroll",
            j: [
                X({
                    name: "multiFactorInfo",
                    J: "a valid multiFactorInfo",
                    optional: !1,
                    K: uo
                }, V(), "multiFactorInfoIdentifier")
            ]
        }
    });
    Y(ho.prototype, {
        clear: {
            name: "clear",
            j: []
        },
        render: {
            name: "render",
            j: []
        },
        verify: {
            name: "verify",
            j: []
        }
    });
    Z(Gf, "parseLink", Of, [
        V("link")
    ]);
    Z(Rn, "assertion", function(a) {
        return new jm(a);
    }, [
        qo("phone")
    ]);
    (function() {
        if ("undefined" !== typeof (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))) && (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL && (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.registerComponent) {
            var a = {
                ActionCodeInfo: {
                    Operation: {
                        EMAIL_SIGNIN: xf,
                        PASSWORD_RESET: "PASSWORD_RESET",
                        RECOVER_EMAIL: "RECOVER_EMAIL",
                        REVERT_SECOND_FACTOR_ADDITION: zf,
                        VERIFY_AND_CHANGE_EMAIL: yf,
                        VERIFY_EMAIL: "VERIFY_EMAIL"
                    }
                },
                Auth: un,
                AuthCredential: yg,
                Error: u
            };
            Z(a, "EmailAuthProvider", Vg, []);
            Z(a, "FacebookAuthProvider", Mg, []);
            Z(a, "GithubAuthProvider", Og, []);
            Z(a, "GoogleAuthProvider", Qg, []);
            Z(a, "TwitterAuthProvider", Sg, []);
            Z(a, "OAuthProvider", M, [
                V("providerId")
            ]);
            Z(a, "SAMLAuthProvider", Lg, [
                V("providerId")
            ]);
            Z(a, "PhoneAuthProvider", hh, [
                oo()
            ]);
            Z(a, "RecaptchaVerifier", ho, [
                X(V(), no(), "recaptchaContainer"),
                W("recaptchaParameters", !0),
                po()
            ]);
            Z(a, "ActionCodeURL", Gf, []);
            Z(a, "PhoneMultiFactorGenerator", Rn, []);
            (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.registerComponent({
                name: "auth",
                instanceFactory: function(b) {
                    b = b.getProvider("app").getImmediate();
                    return new un(b);
                },
                multipleInstances: !1,
                serviceProps: a,
                instantiationMode: "LAZY",
                type: "PUBLIC"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.registerComponent({
                name: "auth-internal",
                instanceFactory: function(b) {
                    b = b.getProvider("auth").getImmediate();
                    return {
                        getUid: r(b.getUid, b),
                        getToken: r(b.kc, b),
                        addAuthTokenListener: r(b.bc, b),
                        removeAuthTokenListener: r(b.Nc, b)
                    };
                },
                multipleInstances: !1,
                instantiationMode: "LAZY",
                type: "PRIVATE"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).registerVersion("@firebase/auth", "0.14.6");
            (0, (/*@__PURE__*/$parcel$interopDefault($cFTls))).INTERNAL.extendNamespace({
                User: P
            });
        } else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
    })();
}).apply(typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

});
parcelRegister("cFTls", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $3wkQl = parcelRequire("3wkQl");

var $9S9QJ = parcelRequire("9S9QJ");

var $1hod4 = parcelRequire("1hod4");

var $jDYxh = parcelRequire("jDYxh");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $93a43ec266f62d6f$var$_a;
var $93a43ec266f62d6f$var$ERRORS = ($93a43ec266f62d6f$var$_a = {}, $93a43ec266f62d6f$var$_a["no-app" /* NO_APP */ ] = "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()", $93a43ec266f62d6f$var$_a["bad-app-name" /* BAD_APP_NAME */ ] = "Illegal App name: '{$appName}", $93a43ec266f62d6f$var$_a["duplicate-app" /* DUPLICATE_APP */ ] = "Firebase App named '{$appName}' already exists", $93a43ec266f62d6f$var$_a["app-deleted" /* APP_DELETED */ ] = "Firebase App named '{$appName}' already deleted", $93a43ec266f62d6f$var$_a["invalid-app-argument" /* INVALID_APP_ARGUMENT */ ] = "firebase.{$appName}() takes either no argument or a Firebase App instance.", $93a43ec266f62d6f$var$_a["invalid-log-argument" /* INVALID_LOG_ARGUMENT */ ] = 'First argument to `onLog` must be null or a function.', $93a43ec266f62d6f$var$_a);
var $93a43ec266f62d6f$var$ERROR_FACTORY = new $9S9QJ.ErrorFactory('app', 'Firebase', $93a43ec266f62d6f$var$ERRORS);
var $93a43ec266f62d6f$var$name$1 = "@firebase/app";
var $93a43ec266f62d6f$var$version = "0.6.4";
var $93a43ec266f62d6f$var$name$2 = "@firebase/analytics";
var $93a43ec266f62d6f$var$name$3 = "@firebase/auth";
var $93a43ec266f62d6f$var$name$4 = "@firebase/database";
var $93a43ec266f62d6f$var$name$5 = "@firebase/functions";
var $93a43ec266f62d6f$var$name$6 = "@firebase/installations";
var $93a43ec266f62d6f$var$name$7 = "@firebase/messaging";
var $93a43ec266f62d6f$var$name$8 = "@firebase/performance";
var $93a43ec266f62d6f$var$name$9 = "@firebase/remote-config";
var $93a43ec266f62d6f$var$name$a = "@firebase/storage";
var $93a43ec266f62d6f$var$name$b = "@firebase/firestore";
var $93a43ec266f62d6f$var$name$c = "firebase-wrapper";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $93a43ec266f62d6f$var$_a$1;
var $93a43ec266f62d6f$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
var $93a43ec266f62d6f$var$PLATFORM_LOG_STRING = ($93a43ec266f62d6f$var$_a$1 = {}, $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$1] = 'fire-core', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$2] = 'fire-analytics', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$3] = 'fire-auth', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$4] = 'fire-rtdb', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$5] = 'fire-fn', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$6] = 'fire-iid', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$7] = 'fire-fcm', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$8] = 'fire-perf', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$9] = 'fire-rc', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$a] = 'fire-gcs', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$b] = 'fire-fst', $93a43ec266f62d6f$var$_a$1['fire-js'] = 'fire-js', $93a43ec266f62d6f$var$_a$1[$93a43ec266f62d6f$var$name$c] = 'fire-js-all', $93a43ec266f62d6f$var$_a$1);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $93a43ec266f62d6f$var$logger = new $jDYxh.Logger('@firebase/app');
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Global context object for a collection of services using
 * a shared authentication state.
 */ var $93a43ec266f62d6f$var$FirebaseAppImpl = /** @class */ function() {
    function FirebaseAppImpl(options, config, firebase_) {
        var e_1, _a;
        var _this = this;
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ = config.automaticDataCollectionEnabled || false;
        this.options_ = $9S9QJ.deepCopy(options);
        this.container = new $1hod4.ComponentContainer(config.name);
        // add itself to container
        this._addComponent(new $1hod4.Component('app', function() {
            return _this;
        }, "PUBLIC" /* PUBLIC */ ));
        try {
            // populate ComponentContainer with existing components
            for(var _b = $3wkQl.__values(this.firebase_.INTERNAL.components.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var component$1 = _c.value;
                this._addComponent(component$1);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function() {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function(val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function() {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function() {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function() {
        var _this = this;
        return new Promise(function(resolve) {
            _this.checkDestroyed_();
            resolve();
        }).then(function() {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            return Promise.all(_this.container.getProviders().map(function(provider) {
                return provider.delete();
            }));
        }).then(function() {
            _this.isDeleted_ = true;
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */ FirebaseAppImpl.prototype._getService = function(name1, instanceIdentifier) {
        if (instanceIdentifier === void 0) instanceIdentifier = $93a43ec266f62d6f$var$DEFAULT_ENTRY_NAME;
        this.checkDestroyed_();
        // getImmediate will always succeed because _getService is only called for registered components.
        return this.container.getProvider(name1).getImmediate({
            identifier: instanceIdentifier
        });
    };
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get this service again.
     *
     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */ FirebaseAppImpl.prototype._removeServiceInstance = function(name1, instanceIdentifier) {
        if (instanceIdentifier === void 0) instanceIdentifier = $93a43ec266f62d6f$var$DEFAULT_ENTRY_NAME;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.container.getProvider(name1).clearInstance(instanceIdentifier);
    };
    /**
     * @param component the component being added to this app's container
     */ FirebaseAppImpl.prototype._addComponent = function(component) {
        try {
            this.container.addComponent(component);
        } catch (e) {
            $93a43ec266f62d6f$var$logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
        }
    };
    FirebaseAppImpl.prototype._addOrOverwriteComponent = function(component) {
        this.container.addOrOverwriteComponent(component);
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ FirebaseAppImpl.prototype.checkDestroyed_ = function() {
        if (this.isDeleted_) throw $93a43ec266f62d6f$var$ERROR_FACTORY.create("app-deleted" /* APP_DELETED */ , {
            appName: this.name_
        });
    };
    return FirebaseAppImpl;
}();
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
$93a43ec266f62d6f$var$FirebaseAppImpl.prototype.name && $93a43ec266f62d6f$var$FirebaseAppImpl.prototype.options || $93a43ec266f62d6f$var$FirebaseAppImpl.prototype.delete || console.log('dc');
var $93a43ec266f62d6f$var$version$1 = "7.14.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */ function $93a43ec266f62d6f$var$createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var components = new Map();
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        registerVersion: registerVersion,
        setLogLevel: $jDYxh.setLogLevel,
        onLog: onLog,
        // @ts-ignore
        apps: null,
        SDK_VERSION: $93a43ec266f62d6f$var$version$1,
        INTERNAL: {
            registerComponent: registerComponent,
            removeApp: removeApp,
            components: components,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */ function removeApp(name1) {
        delete apps[name1];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */ function app(name1) {
        name1 = name1 || $93a43ec266f62d6f$var$DEFAULT_ENTRY_NAME;
        if (!$9S9QJ.contains(apps, name1)) throw $93a43ec266f62d6f$var$ERROR_FACTORY.create("no-app" /* NO_APP */ , {
            appName: name1
        });
        return apps[name1];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) rawConfig = {};
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = {
                name: name_1
            };
        }
        var config = rawConfig;
        if (config.name === undefined) config.name = $93a43ec266f62d6f$var$DEFAULT_ENTRY_NAME;
        var name1 = config.name;
        if (typeof name1 !== 'string' || !name1) throw $93a43ec266f62d6f$var$ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */ , {
            appName: String(name1)
        });
        if ($9S9QJ.contains(apps, name1)) throw $93a43ec266f62d6f$var$ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */ , {
            appName: name1
        });
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name1] = app;
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */ function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function(name1) {
            return apps[name1];
        });
    }
    function registerComponent(component) {
        var e_1, _a;
        var componentName = component.name;
        if (components.has(componentName)) {
            $93a43ec266f62d6f$var$logger.debug("There were multiple attempts to register component " + componentName + ".");
            return component.type === "PUBLIC" /* PUBLIC */  ? namespace[componentName] : null;
        }
        components.set(componentName, component);
        // create service namespace for public components
        if (component.type === "PUBLIC" /* PUBLIC */ ) {
            // The Service namespace is an accessor function ...
            var serviceNamespace = function(appArg) {
                if (appArg === void 0) appArg = app();
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentName] !== 'function') // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                throw $93a43ec266f62d6f$var$ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */ , {
                    appName: componentName
                });
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentName]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) $9S9QJ.deepExtend(serviceNamespace, component.serviceProps);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentName] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentName] = // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
            // option added to the no-explicit-any rule when ESlint releases it.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var serviceFxn = this._getService.bind(this, componentName);
                return serviceFxn.apply(this, component.multipleInstances ? args : []);
            };
        }
        try {
            // add the component to existing app instances
            for(var _b = $3wkQl.__values(Object.keys(apps)), _c = _b.next(); !_c.done; _c = _b.next()){
                var appName = _c.value;
                apps[appName]._addComponent(component);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return component.type === "PUBLIC" /* PUBLIC */  ? namespace[componentName] : null;
    }
    function registerVersion(libraryKeyOrName, version, variant) {
        var _a;
        // TODO: We can use this check to whitelist strings when/if we set up
        // a good whitelist system.
        var library = (_a = $93a43ec266f62d6f$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
        if (variant) library += "-" + variant;
        var libraryMismatch = library.match(/\s|\//);
        var versionMismatch = version.match(/\s|\//);
        if (libraryMismatch || versionMismatch) {
            var warning = [
                "Unable to register library \"" + library + "\" with version \"" + version + "\":"
            ];
            if (libraryMismatch) warning.push("library name \"" + library + "\" contains illegal characters (whitespace or \"/\")");
            if (libraryMismatch && versionMismatch) warning.push('and');
            if (versionMismatch) warning.push("version name \"" + version + "\" contains illegal characters (whitespace or \"/\")");
            $93a43ec266f62d6f$var$logger.warn(warning.join(' '));
            return;
        }
        registerComponent(new $1hod4.Component(library + "-version", function() {
            return {
                library: library,
                version: version
            };
        }, "VERSION" /* VERSION */ ));
    }
    function onLog(logCallback, options) {
        if (logCallback !== null && typeof logCallback !== 'function') throw $93a43ec266f62d6f$var$ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */ , {
            appName: name
        });
        $jDYxh.setUserLogHandler(logCallback, options);
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name1) {
        if (name1 === 'serverAuth') return null;
        var useService = name1;
        return useService;
    }
    return namespace;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */ function $93a43ec266f62d6f$var$createFirebaseNamespace() {
    var namespace = $93a43ec266f62d6f$var$createFirebaseNamespaceCore($93a43ec266f62d6f$var$FirebaseAppImpl);
    namespace.INTERNAL = $3wkQl.__assign($3wkQl.__assign({}, namespace.INTERNAL), {
        createFirebaseNamespace: $93a43ec266f62d6f$var$createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: $9S9QJ.createSubscribe,
        ErrorFactory: $9S9QJ.ErrorFactory,
        deepExtend: $9S9QJ.deepExtend
    });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */ function extendNamespace(props) {
        $9S9QJ.deepExtend(namespace, props);
    }
    return namespace;
}
var $93a43ec266f62d6f$var$firebase = $93a43ec266f62d6f$var$createFirebaseNamespace();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $93a43ec266f62d6f$var$PlatformLoggerService = /** @class */ function() {
    function PlatformLoggerService(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    PlatformLoggerService.prototype.getPlatformInfoString = function() {
        var providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map(function(provider) {
            if ($93a43ec266f62d6f$var$isVersionServiceProvider(provider)) {
                var service = provider.getImmediate();
                return service.library + "/" + service.version;
            } else return null;
        }).filter(function(logString) {
            return logString;
        }).join(' ');
    };
    return PlatformLoggerService;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $93a43ec266f62d6f$var$isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $93a43ec266f62d6f$var$registerCoreComponents(firebase, variant) {
    firebase.INTERNAL.registerComponent(new $1hod4.Component('platform-logger', function(container) {
        return new $93a43ec266f62d6f$var$PlatformLoggerService(container);
    }, "PRIVATE" /* PRIVATE */ ));
    // Register `app` package.
    firebase.registerVersion($93a43ec266f62d6f$var$name$1, $93a43ec266f62d6f$var$version, variant);
    // Register platform SDK identifier (no version).
    firebase.registerVersion('fire-js', '');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Firebase Lite detection test
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ($9S9QJ.isBrowser() && self.firebase !== undefined) {
    $93a43ec266f62d6f$var$logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var $93a43ec266f62d6f$var$sdkVersion = self.firebase.SDK_VERSION;
    if ($93a43ec266f62d6f$var$sdkVersion && $93a43ec266f62d6f$var$sdkVersion.indexOf('LITE') >= 0) $93a43ec266f62d6f$var$logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
}
var $93a43ec266f62d6f$var$initializeApp = $93a43ec266f62d6f$var$firebase.initializeApp;
// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
// the no-explicit-any rule when ESlint releases it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$93a43ec266f62d6f$var$firebase.initializeApp = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if ($9S9QJ.isNode()) $93a43ec266f62d6f$var$logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
    return $93a43ec266f62d6f$var$initializeApp.apply(undefined, args);
};
var $93a43ec266f62d6f$var$firebase$1 = $93a43ec266f62d6f$var$firebase;
$93a43ec266f62d6f$var$registerCoreComponents($93a43ec266f62d6f$var$firebase$1);
module.exports.default = $93a43ec266f62d6f$var$firebase$1;
module.exports.firebase = $93a43ec266f62d6f$var$firebase$1;

});
parcelRegister("3wkQl", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $29048748a60567cb$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $29048748a60567cb$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $29048748a60567cb$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $29048748a60567cb$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $29048748a60567cb$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $29048748a60567cb$export$8d051b38c9118094);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $29048748a60567cb$var$extendStatics = function(d, b) {
    $29048748a60567cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $29048748a60567cb$var$extendStatics(d, b);
};
function $29048748a60567cb$export$a8ba968b8961cb8a(d, b) {
    $29048748a60567cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $29048748a60567cb$export$18ce0697a983be9b = function() {
    $29048748a60567cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $29048748a60567cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $29048748a60567cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $29048748a60567cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $29048748a60567cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $29048748a60567cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $29048748a60567cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $29048748a60567cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $29048748a60567cb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $29048748a60567cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $29048748a60567cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $29048748a60567cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($29048748a60567cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $29048748a60567cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $29048748a60567cb$export$10c90e4f7922046c(v) {
    return this instanceof $29048748a60567cb$export$10c90e4f7922046c ? (this.v = v, this) : new $29048748a60567cb$export$10c90e4f7922046c(v);
}
function $29048748a60567cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $29048748a60567cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $29048748a60567cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $29048748a60567cb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $29048748a60567cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $29048748a60567cb$export$19a8beecd37a4c45 === "function" ? $29048748a60567cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $29048748a60567cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $29048748a60567cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $29048748a60567cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $29048748a60567cb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $29048748a60567cb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("9S9QJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $3wkQl = parcelRequire("3wkQl");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ var $7300cc1b735492d0$var$CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ var $7300cc1b735492d0$var$assert = function(assertion, message) {
    if (!assertion) throw $7300cc1b735492d0$var$assertionError(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ var $7300cc1b735492d0$var$assertionError = function(message) {
    return new Error('Firebase Database (' + $7300cc1b735492d0$var$CONSTANTS.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7300cc1b735492d0$var$stringToByteArray = function(str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ var $7300cc1b735492d0$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while(pos < bytes.length){
        var c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var $7300cc1b735492d0$var$base64 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray: function(input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for(var i = 0; i < input.length; i += 3){
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($7300cc1b735492d0$var$stringToByteArray(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $7300cc1b735492d0$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray: function(input, webSafe) {
        this.init_();
        var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for(var i = 0; i < input.length;){
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_: function() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(var i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ var $7300cc1b735492d0$var$base64Encode = function(str) {
    var utf8Bytes = $7300cc1b735492d0$var$stringToByteArray(str);
    return $7300cc1b735492d0$var$base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ var $7300cc1b735492d0$var$base64Decode = function(str) {
    try {
        return $7300cc1b735492d0$var$base64.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $7300cc1b735492d0$var$deepCopy(value) {
    return $7300cc1b735492d0$var$deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */ function $7300cc1b735492d0$var$deepExtend(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(var prop in source){
        if (!source.hasOwnProperty(prop)) continue;
        target[prop] = $7300cc1b735492d0$var$deepExtend(target[prop], source[prop]);
    }
    return target;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7300cc1b735492d0$var$Deferred = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this.reject = function() {};
        this.resolve = function() {};
        this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ Deferred.prototype.wrapCallback = function(callback) {
        var _this = this;
        return function(error, value) {
            if (error) _this.reject(error);
            else _this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function() {});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    };
    return Deferred;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $7300cc1b735492d0$var$getUA() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $7300cc1b735492d0$var$isMobileCordova() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($7300cc1b735492d0$var$getUA());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $7300cc1b735492d0$var$isNode() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $7300cc1b735492d0$var$isBrowser() {
    return typeof self === 'object' && self.self === self;
}
function $7300cc1b735492d0$var$isBrowserExtension() {
    var runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $7300cc1b735492d0$var$isReactNative() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $7300cc1b735492d0$var$isElectron() {
    return $7300cc1b735492d0$var$getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $7300cc1b735492d0$var$isIE() {
    var ua = $7300cc1b735492d0$var$getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $7300cc1b735492d0$var$isUWP() {
    return $7300cc1b735492d0$var$getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $7300cc1b735492d0$var$isNodeSdk() {
    return $7300cc1b735492d0$var$CONSTANTS.NODE_CLIENT === true || $7300cc1b735492d0$var$CONSTANTS.NODE_ADMIN === true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7300cc1b735492d0$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var $7300cc1b735492d0$var$FirebaseError = /** @class */ function(_super) {
    $3wkQl.__extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = $7300cc1b735492d0$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(_this, $7300cc1b735492d0$var$ErrorFactory.prototype.create);
        return _this;
    }
    return FirebaseError;
}(Error);
var $7300cc1b735492d0$var$ErrorFactory = /** @class */ function() {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function(code) {
        var data = [];
        for(var _i = 1; _i < arguments.length; _i++)data[_i - 1] = arguments[_i];
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? $7300cc1b735492d0$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new $7300cc1b735492d0$var$FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for(var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++){
            var key = _b[_a];
            if (key.slice(-1) !== '_') {
                if (key in error) console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
                error[key] = customData[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}();
function $7300cc1b735492d0$var$replaceTemplate(template, data) {
    return template.replace($7300cc1b735492d0$var$PATTERN, function(_, key) {
        var value = data[key];
        return value != null ? value.toString() : "<" + key + "?>";
    });
}
var $7300cc1b735492d0$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $7300cc1b735492d0$var$jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $7300cc1b735492d0$var$stringify(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $7300cc1b735492d0$var$decode = function(token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = $7300cc1b735492d0$var$jsonEval($7300cc1b735492d0$var$base64Decode(parts[0]) || '');
        claims = $7300cc1b735492d0$var$jsonEval($7300cc1b735492d0$var$base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $7300cc1b735492d0$var$isValidTimestamp = function(token) {
    var claims = $7300cc1b735492d0$var$decode(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $7300cc1b735492d0$var$issuedAtTime = function(token) {
    var claims = $7300cc1b735492d0$var$decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $7300cc1b735492d0$var$isValidFormat = function(token) {
    var decoded = $7300cc1b735492d0$var$decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $7300cc1b735492d0$var$isAdmin = function(token) {
    var claims = $7300cc1b735492d0$var$decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $7300cc1b735492d0$var$contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $7300cc1b735492d0$var$safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $7300cc1b735492d0$var$isEmpty(obj) {
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $7300cc1b735492d0$var$map(obj, fn, contextObj) {
    var res = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $7300cc1b735492d0$var$querystring(querystringParams) {
    var params = [];
    var _loop_1 = function(key, value) {
        if (Array.isArray(value)) value.forEach(function(arrayVal) {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
        });
        else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    };
    for(var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $7300cc1b735492d0$var$querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function(token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ var $7300cc1b735492d0$var$Sha1 = /** @class */ function() {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(var i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    Sha1.prototype.reset = function() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ Sha1.prototype.compress_ = function(buf, offset) {
        if (!offset) offset = 0;
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(var i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(var i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(var i = 16; i < 80; i++){
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(var i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            var t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    };
    Sha1.prototype.update = function(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */ Sha1.prototype.digest = function() {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(var i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for(var i = 0; i < 5; i++)for(var j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    };
    return Sha1;
}();
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $7300cc1b735492d0$var$createSubscribe(executor, onNoObservers) {
    var proxy = new $7300cc1b735492d0$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ var $7300cc1b735492d0$var$ObserverProxy = /** @class */ function() {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function() {
            executor(_this);
        }).catch(function(e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function(value) {
        this.forEachObserver(function(observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function(error) {
        this.forEachObserver(function(observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function() {
        this.forEachObserver(function(observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ ObserverProxy.prototype.subscribe = function(nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($7300cc1b735492d0$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $7300cc1b735492d0$var$noop;
        if (observer.error === undefined) observer.error = $7300cc1b735492d0$var$noop;
        if (observer.complete === undefined) observer.complete = $7300cc1b735492d0$var$noop;
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            try {
                if (_this.finalError) observer.error(_this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    };
    ObserverProxy.prototype.forEachObserver = function(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(var i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function(i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) try {
                fn(_this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    };
    ObserverProxy.prototype.close = function(err) {
        var _this = this;
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */ function $7300cc1b735492d0$var$async(fn, onError) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        Promise.resolve(true).then(function() {
            fn.apply(void 0, args);
        }).catch(function(error) {
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $7300cc1b735492d0$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for(var _i = 0, methods_1 = methods; _i < methods_1.length; _i++){
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $7300cc1b735492d0$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ var $7300cc1b735492d0$var$validateArgCount = function(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        var error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argumentNumber The index of the argument
 * @param optional Whether or not the argument is optional
 * @return The prefix to add to the error thrown for validation.
 */ function $7300cc1b735492d0$var$errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch(argumentNumber){
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $7300cc1b735492d0$var$validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($7300cc1b735492d0$var$errorPrefix(fnName, argumentNumber, optional) + 'must be a valid firebase namespace.');
}
function $7300cc1b735492d0$var$validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($7300cc1b735492d0$var$errorPrefix(fnName, argumentNumber, optional) + 'must be a valid function.');
}
function $7300cc1b735492d0$var$validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($7300cc1b735492d0$var$errorPrefix(fnName, argumentNumber, optional) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ var $7300cc1b735492d0$var$stringToByteArray$1 = function(str) {
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            $7300cc1b735492d0$var$assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ var $7300cc1b735492d0$var$stringLength = function(str) {
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
module.exports.CONSTANTS = $7300cc1b735492d0$var$CONSTANTS;
module.exports.Deferred = $7300cc1b735492d0$var$Deferred;
module.exports.ErrorFactory = $7300cc1b735492d0$var$ErrorFactory;
module.exports.FirebaseError = $7300cc1b735492d0$var$FirebaseError;
module.exports.Sha1 = $7300cc1b735492d0$var$Sha1;
module.exports.assert = $7300cc1b735492d0$var$assert;
module.exports.assertionError = $7300cc1b735492d0$var$assertionError;
module.exports.async = $7300cc1b735492d0$var$async;
module.exports.base64 = $7300cc1b735492d0$var$base64;
module.exports.base64Decode = $7300cc1b735492d0$var$base64Decode;
module.exports.base64Encode = $7300cc1b735492d0$var$base64Encode;
module.exports.contains = $7300cc1b735492d0$var$contains;
module.exports.createSubscribe = $7300cc1b735492d0$var$createSubscribe;
module.exports.decode = $7300cc1b735492d0$var$decode;
module.exports.deepCopy = $7300cc1b735492d0$var$deepCopy;
module.exports.deepExtend = $7300cc1b735492d0$var$deepExtend;
module.exports.errorPrefix = $7300cc1b735492d0$var$errorPrefix;
module.exports.getUA = $7300cc1b735492d0$var$getUA;
module.exports.isAdmin = $7300cc1b735492d0$var$isAdmin;
module.exports.isBrowser = $7300cc1b735492d0$var$isBrowser;
module.exports.isBrowserExtension = $7300cc1b735492d0$var$isBrowserExtension;
module.exports.isElectron = $7300cc1b735492d0$var$isElectron;
module.exports.isEmpty = $7300cc1b735492d0$var$isEmpty;
module.exports.isIE = $7300cc1b735492d0$var$isIE;
module.exports.isMobileCordova = $7300cc1b735492d0$var$isMobileCordova;
module.exports.isNode = $7300cc1b735492d0$var$isNode;
module.exports.isNodeSdk = $7300cc1b735492d0$var$isNodeSdk;
module.exports.isReactNative = $7300cc1b735492d0$var$isReactNative;
module.exports.isUWP = $7300cc1b735492d0$var$isUWP;
module.exports.isValidFormat = $7300cc1b735492d0$var$isValidFormat;
module.exports.isValidTimestamp = $7300cc1b735492d0$var$isValidTimestamp;
module.exports.issuedAtTime = $7300cc1b735492d0$var$issuedAtTime;
module.exports.jsonEval = $7300cc1b735492d0$var$jsonEval;
module.exports.map = $7300cc1b735492d0$var$map;
module.exports.querystring = $7300cc1b735492d0$var$querystring;
module.exports.querystringDecode = $7300cc1b735492d0$var$querystringDecode;
module.exports.safeGet = $7300cc1b735492d0$var$safeGet;
module.exports.stringLength = $7300cc1b735492d0$var$stringLength;
module.exports.stringToByteArray = $7300cc1b735492d0$var$stringToByteArray$1;
module.exports.stringify = $7300cc1b735492d0$var$stringify;
module.exports.validateArgCount = $7300cc1b735492d0$var$validateArgCount;
module.exports.validateCallback = $7300cc1b735492d0$var$validateCallback;
module.exports.validateContextObject = $7300cc1b735492d0$var$validateContextObject;
module.exports.validateNamespace = $7300cc1b735492d0$var$validateNamespace;

});

parcelRegister("1hod4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $3wkQl = parcelRequire("3wkQl");

var $9S9QJ = parcelRequire("9S9QJ");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ var $0eea2884455e3fba$var$Component = /** @class */ function() {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ function Component(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
    }
    Component.prototype.setInstantiationMode = function(mode) {
        this.instantiationMode = mode;
        return this;
    };
    Component.prototype.setMultipleInstances = function(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    };
    Component.prototype.setServiceProps = function(props) {
        this.serviceProps = props;
        return this;
    };
    return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0eea2884455e3fba$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ var $0eea2884455e3fba$var$Provider = /** @class */ function() {
    function Provider(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ Provider.prototype.get = function(identifier) {
        if (identifier === void 0) identifier = $0eea2884455e3fba$var$DEFAULT_ENTRY_NAME;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            var deferred = new $9S9QJ.Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            // If the service instance is available, resolve the promise with it immediately
            try {
                var instance = this.getOrInitializeService(normalizedIdentifier);
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    };
    Provider.prototype.getImmediate = function(options) {
        var _a = $3wkQl.__assign({
            identifier: $0eea2884455e3fba$var$DEFAULT_ENTRY_NAME,
            optional: false
        }, options), identifier = _a.identifier, optional = _a.optional;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        try {
            var instance = this.getOrInitializeService(normalizedIdentifier);
            if (!instance) {
                if (optional) return null;
                throw Error("Service " + this.name + " is not available");
            }
            return instance;
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
    };
    Provider.prototype.getComponent = function() {
        return this.component;
    };
    Provider.prototype.setComponent = function(component) {
        var e_1, _a;
        if (component.name !== this.name) throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
        if (this.component) throw Error("Component for " + this.name + " has already been provided");
        this.component = component;
        // if the service is eager, initialize the default instance
        if ($0eea2884455e3fba$var$isComponentEager(component)) try {
            this.getOrInitializeService($0eea2884455e3fba$var$DEFAULT_ENTRY_NAME);
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        try {
            // Create service instances for the pending promises and resolve them
            // NOTE: if this.multipleInstances is false, only the default instance will be created
            // and all promises with resolve with it regardless of the identifier.
            for(var _b = $3wkQl.__values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $3wkQl.__read(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                try {
                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                    var instance = this.getOrInitializeService(normalizedIdentifier);
                    instanceDeferred.resolve(instance);
                } catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Provider.prototype.clearInstance = function(identifier) {
        if (identifier === void 0) identifier = $0eea2884455e3fba$var$DEFAULT_ENTRY_NAME;
        this.instancesDeferred.delete(identifier);
        this.instances.delete(identifier);
    };
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    Provider.prototype.delete = function() {
        return $3wkQl.__awaiter(this, void 0, void 0, function() {
            var services;
            return $3wkQl.__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        services = Array.from(this.instances.values());
                        return [
                            4 /*yield*/ ,
                            Promise.all(services.filter(function(service) {
                                return 'INTERNAL' in service;
                            })// eslint-disable-next-line @typescript-eslint/no-explicit-any
                            .map(function(service) {
                                return service.INTERNAL.delete();
                            }))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Provider.prototype.isComponentSet = function() {
        return this.component != null;
    };
    Provider.prototype.getOrInitializeService = function(identifier) {
        var instance = this.instances.get(identifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, $0eea2884455e3fba$var$normalizeIdentifierForFactory(identifier));
            this.instances.set(identifier, instance);
        }
        return instance || null;
    };
    Provider.prototype.normalizeInstanceIdentifier = function(identifier) {
        if (this.component) return this.component.multipleInstances ? identifier : $0eea2884455e3fba$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    };
    return Provider;
}();
// undefined should be passed to the service factory for the default instance
function $0eea2884455e3fba$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $0eea2884455e3fba$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $0eea2884455e3fba$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ var $0eea2884455e3fba$var$ComponentContainer = /** @class */ function() {
    function ComponentContainer(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ ComponentContainer.prototype.addComponent = function(component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error("Component " + component.name + " has already been registered with " + this.name);
        provider.setComponent(component);
    };
    ComponentContainer.prototype.addOrOverwriteComponent = function(component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    };
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ ComponentContainer.prototype.getProvider = function(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        var provider = new $0eea2884455e3fba$var$Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    };
    ComponentContainer.prototype.getProviders = function() {
        return Array.from(this.providers.values());
    };
    return ComponentContainer;
}();
module.exports.Component = $0eea2884455e3fba$var$Component;
module.exports.ComponentContainer = $0eea2884455e3fba$var$ComponentContainer;
module.exports.Provider = $0eea2884455e3fba$var$Provider;

});

parcelRegister("jDYxh", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $e4d09dfb7b14685c$export$efa9a398d6368992);
$parcel$export(module.exports, "setLogLevel", () => $e4d09dfb7b14685c$export$c622e99c0ce7b1c9);
$parcel$export(module.exports, "setUserLogHandler", () => $e4d09dfb7b14685c$export$29577d29c84db5f6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function $e4d09dfb7b14685c$var$__spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e4d09dfb7b14685c$var$_a;
/**
 * A container for all of the Logger instances
 */ var $e4d09dfb7b14685c$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $e4d09dfb7b14685c$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($e4d09dfb7b14685c$export$243e62d78d3b544d || ($e4d09dfb7b14685c$export$243e62d78d3b544d = {}));
var $e4d09dfb7b14685c$var$levelStringToEnum = {
    'debug': $e4d09dfb7b14685c$export$243e62d78d3b544d.DEBUG,
    'verbose': $e4d09dfb7b14685c$export$243e62d78d3b544d.VERBOSE,
    'info': $e4d09dfb7b14685c$export$243e62d78d3b544d.INFO,
    'warn': $e4d09dfb7b14685c$export$243e62d78d3b544d.WARN,
    'error': $e4d09dfb7b14685c$export$243e62d78d3b544d.ERROR,
    'silent': $e4d09dfb7b14685c$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ var $e4d09dfb7b14685c$var$defaultLogLevel = $e4d09dfb7b14685c$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ var $e4d09dfb7b14685c$var$ConsoleMethod = ($e4d09dfb7b14685c$var$_a = {}, $e4d09dfb7b14685c$var$_a[$e4d09dfb7b14685c$export$243e62d78d3b544d.DEBUG] = 'log', $e4d09dfb7b14685c$var$_a[$e4d09dfb7b14685c$export$243e62d78d3b544d.VERBOSE] = 'log', $e4d09dfb7b14685c$var$_a[$e4d09dfb7b14685c$export$243e62d78d3b544d.INFO] = 'info', $e4d09dfb7b14685c$var$_a[$e4d09dfb7b14685c$export$243e62d78d3b544d.WARN] = 'warn', $e4d09dfb7b14685c$var$_a[$e4d09dfb7b14685c$export$243e62d78d3b544d.ERROR] = 'error', $e4d09dfb7b14685c$var$_a);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ var $e4d09dfb7b14685c$var$defaultLogHandler = function(instance, logType) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (logType < instance.logLevel) return;
    var now = new Date().toISOString();
    var method = $e4d09dfb7b14685c$var$ConsoleMethod[logType];
    if (method) console[method].apply(console, $e4d09dfb7b14685c$var$__spreadArrays([
        "[" + now + "]  " + instance.name + ":"
    ], args));
    else throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
};
var $e4d09dfb7b14685c$export$efa9a398d6368992 = /** @class */ function() {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $e4d09dfb7b14685c$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $e4d09dfb7b14685c$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $e4d09dfb7b14685c$var$instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function() {
            return this._logLevel;
        },
        set: function(val) {
            if (!(val in $e4d09dfb7b14685c$export$243e62d78d3b544d)) throw new TypeError('Invalid value assigned to `logLevel`');
            this._logLevel = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function() {
            return this._logHandler;
        },
        set: function(val) {
            if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
            this._logHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "userLogHandler", {
        get: function() {
            return this._userLogHandler;
        },
        set: function(val) {
            this._userLogHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */ Logger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $e4d09dfb7b14685c$var$__spreadArrays([
            this,
            $e4d09dfb7b14685c$export$243e62d78d3b544d.DEBUG
        ], args));
        this._logHandler.apply(this, $e4d09dfb7b14685c$var$__spreadArrays([
            this,
            $e4d09dfb7b14685c$export$243e62d78d3b544d.DEBUG
        ], args));
    };
    Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $e4d09dfb7b14685c$var$__spreadArrays([
            this,
            $e4d09dfb7b14685c$export$243e62d78d3b544d.VERBOSE
        ], args));
        this._logHandler.apply(this, $e4d09dfb7b14685c$var$__spreadArrays([
            this,
            $e4d09dfb7b14685c$export$243e62d78d3b544d.VERBOSE
        ], args));
    };
    Logger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $e4d09dfb7b14685c$var$__spreadArrays([
            this,
            $e4d09dfb7b14685c$export$243e62d78d3b544d.INFO
        ], args));
        this._logHandler.apply(this, $e4d09dfb7b14685c$var$__spreadArrays([
            this,
            $e4d09dfb7b14685c$export$243e62d78d3b544d.INFO
        ], args));
    };
    Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $e4d09dfb7b14685c$var$__spreadArrays([
            this,
            $e4d09dfb7b14685c$export$243e62d78d3b544d.WARN
        ], args));
        this._logHandler.apply(this, $e4d09dfb7b14685c$var$__spreadArrays([
            this,
            $e4d09dfb7b14685c$export$243e62d78d3b544d.WARN
        ], args));
    };
    Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $e4d09dfb7b14685c$var$__spreadArrays([
            this,
            $e4d09dfb7b14685c$export$243e62d78d3b544d.ERROR
        ], args));
        this._logHandler.apply(this, $e4d09dfb7b14685c$var$__spreadArrays([
            this,
            $e4d09dfb7b14685c$export$243e62d78d3b544d.ERROR
        ], args));
    };
    return Logger;
}();
function $e4d09dfb7b14685c$export$c622e99c0ce7b1c9(level) {
    var newLevel = typeof level === 'string' ? $e4d09dfb7b14685c$var$levelStringToEnum[level] : level;
    $e4d09dfb7b14685c$var$instances.forEach(function(inst) {
        inst.logLevel = newLevel;
    });
}
function $e4d09dfb7b14685c$export$29577d29c84db5f6(logCallback, options) {
    var _loop_1 = function(instance) {
        var customLogLevel = null;
        if (options && options.level) customLogLevel = $e4d09dfb7b14685c$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = function(instance, level) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
            var message = args.map(function(arg) {
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter(function(arg) {
                return arg;
            }).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $e4d09dfb7b14685c$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    };
    for(var _i = 0, instances_1 = $e4d09dfb7b14685c$var$instances; _i < instances_1.length; _i++){
        var instance = instances_1[_i];
        _loop_1(instance);
    }
}

});




parcelRegister("aXvn5", function(module, exports) {
'use strict';
function $7fa7bfc40f9a7767$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $7fa7bfc40f9a7767$var$firebase = $7fa7bfc40f9a7767$var$_interopDefault((parcelRequire("cFTls")));
var $7fa7bfc40f9a7767$var$name = "firebase";
var $7fa7bfc40f9a7767$var$version = "7.14.6";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $7fa7bfc40f9a7767$var$firebase.registerVersion($7fa7bfc40f9a7767$var$name, $7fa7bfc40f9a7767$var$version, 'app');
module.exports = $7fa7bfc40f9a7767$var$firebase;

});

parcelRegister("hvId1", function(module, exports) {

$parcel$export(module.exports, "SocialLoginButtonComponent", () => $2bd08c9678fd7f19$export$b0bcd04f193c4507);

var $g0n63 = parcelRequire("g0n63");

var $eG1Pq = parcelRequire("eG1Pq");
parcelRequire("9hU4p");
var $iyT88 = parcelRequire("iyT88");
var $cKTX1 = parcelRequire("cKTX1");
var $8W3rT = parcelRequire("8W3rT");
var $b6i8I = parcelRequire("b6i8I");
var $7ZLqs = parcelRequire("7ZLqs");
class $2bd08c9678fd7f19$export$b0bcd04f193c4507 extends (0, $eG1Pq.LitElement) {
    OnInit() {
        if (this.active) this.hover();
    }
    hover() {
        this.color = '#222';
        this.bgColor = '#ffffff';
        this.textColor = '#222';
    }
    leave() {
        this.color = '#333';
        this.bgColor = '';
        this.textColor = '#333';
    }
    mouseEnter() {
        if (!this.active) this.hover();
    }
    mouseLeave() {
        if (!this.active) this.leave();
    }
    constructor(...args){
        super(...args), this.color = '#333', this.bgColor = '', this.textColor = '#333', this.type = 'github', this.icons = {
            facebook: $iyT88.facebook,
            github: $cKTX1.github,
            twitter: $7ZLqs.twitter,
            google: $8W3rT.google,
            terra: $b6i8I.terra
        };
    }
}
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)()
], $2bd08c9678fd7f19$export$b0bcd04f193c4507.prototype, "color", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)()
], $2bd08c9678fd7f19$export$b0bcd04f193c4507.prototype, "bgColor", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)()
], $2bd08c9678fd7f19$export$b0bcd04f193c4507.prototype, "textColor", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        type: Boolean
    })
], $2bd08c9678fd7f19$export$b0bcd04f193c4507.prototype, "active", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)()
], $2bd08c9678fd7f19$export$b0bcd04f193c4507.prototype, "type", void 0);
$2bd08c9678fd7f19$export$b0bcd04f193c4507 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'social-login-button',
        style: (0, $eG1Pq.css)`
    .container {
      border-radius: 5px;
      padding: 10px;
      cursor: pointer;
    }
    .container .icon {
      width: 45px;
    }
    .container .text {
      margin-left: 15px;
      margin-top: 13px;
    }
  `,
        template () {
            return (0, $eG1Pq.html)`
      <div
        @pointerenter=${this.mouseEnter}
        @pointerleave=${this.mouseLeave}
        class="container"
        style="background-color:${this.bgColor}; display:flex; "
      >
        <div class="icon">${this.icons[this.type](this.color)}</div>
        <div class="text" style="color: ${this.textColor}">
          <slot></slot>
        </div>
      </div>
    `;
        }
    })
], $2bd08c9678fd7f19$export$b0bcd04f193c4507);

});
parcelRegister("eG1Pq", function(module, exports) {
"use strict";
var $aaf6680b26119079$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aaf6680b26119079$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $aaf6680b26119079$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$aaf6680b26119079$var$__exportStar((parcelRequire("8JlYn")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("hFLKi")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("hxu36")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("bNBnP")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("b7oCz")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("ldnf6")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("ddeES")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("areLk")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("7gMqP")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("h4sgq")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("fAP44")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("da2ea")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("d3QZ9")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("j6Fml")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("kPKGx")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("21y8E")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("f4O1R")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("i7OBu")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("dOkbv")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("cjxiH")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("iR4m5")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("8N59e")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("2wEj5")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("92JOY")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("jowVr")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("5CGIK")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("eLXxM")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("49Jw8")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("bYWMS")), module.exports);

$aaf6680b26119079$var$__exportStar((parcelRequire("hrtRG")), module.exports);

});
parcelRegister("8JlYn", function(module, exports) {
"use strict";
var $65b39210a7ce0f63$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $65b39210a7ce0f63$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $65b39210a7ce0f63$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$65b39210a7ce0f63$var$__exportStar((parcelRequire("h5Ijp")), module.exports);

$65b39210a7ce0f63$var$__exportStar((parcelRequire("l5A7e")), module.exports);

});
parcelRegister("h5Ijp", function(module, exports) {
"use strict";
var $c71546c4305add55$var$__setFunctionName = module.exports && module.exports.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Component = void 0;

var $hxu36 = parcelRequire("hxu36");
const $c71546c4305add55$var$legacyCustomElement = (tagName, clazz, options)=>{
    window.customElements.define(tagName, clazz, options);
    return clazz;
};
const $c71546c4305add55$var$standardCustomElement = (tagName, descriptor, options)=>{
    const { kind: kind, elements: elements } = descriptor;
    return {
        kind: kind,
        elements: elements,
        // This callback is called once the class is otherwise fully defined
        finisher (clazz) {
            window.customElements.define(tagName, clazz, options);
        }
    };
};
const $c71546c4305add55$var$isFunction = (v)=>typeof v === 'function';
const $c71546c4305add55$var$customElement = (tag, config = {})=>(Base)=>{
        var _a;
        var _b;
        /* Feature flag implementation where we don't define at all components when they are excluded */ if ((_a = window._excluded_components) === null || _a === void 0 ? void 0 : _a.includes(config.selector)) return Base;
        if (!tag || tag && tag.indexOf('-') <= 0) throw new Error(`You need at least 1 dash in the custom element name! ${Base}`);
        config.styles = config.styles || [];
        config.components = config.components || [];
        const OnInit = Base.prototype.OnInit || function() {};
        const OnDestroy = Base.prototype.OnDestroy || function() {};
        const OnUpdate = Base.prototype.OnUpdate || function() {};
        const OnUpdateFirst = Base.prototype.OnUpdateFirst || function() {};
        const connectedCallback = Base.prototype.connectedCallback || function() {};
        const disconnectedCallback = Base.prototype.disconnectedCallback || function() {};
        const update = Base.prototype.update || function() {};
        const firstUpdated = Base.prototype.firstUpdated || function() {};
        if (!config.template) config.template = Base.prototype.render || (()=>(0, $hxu36.html)``);
        if (config.style) config.styles.push(config.style);
        const ModifiedClass = (_b = class extends Base {
            static is() {
                return tag;
            }
            getTemplateResult() {
                return this;
            }
            OnInit() {
                if (config.container) {
                    (0, $hxu36.render)(config.template.call(this), config.container);
                    if (config.style) {
                        const style = document.createElement('style');
                        style.type = 'text/css';
                        if (style['styleSheet']) // This is required for IE8 and below.
                        style['styleSheet'].cssText = config.style.toString();
                        else style.appendChild(document.createTextNode(config.style.toString()));
                        config.container.prepend(style);
                    }
                }
                return OnInit.call(this);
            }
            disconnectedCallback() {
                var _a;
                OnDestroy.call(this);
                disconnectedCallback.call(this);
                (_a = this._registry) === null || _a === void 0 || _a.unsubscribe();
                this._registry = null;
            }
            connectedCallback() {
                var _a, _c;
                connectedCallback.call(this);
                OnInit.call(this);
                if ($c71546c4305add55$var$isFunction(config.registry)) this._registry = config.registry.call(this);
                if ((_a = config.modifiers) === null || _a === void 0 ? void 0 : _a.length) for (const modifier of config.modifiers){
                    if (!modifier) throw new Error(`Provided null value inside modifiers for component "${config.selector}"`);
                    if (!modifier.options) throw new Error(`Missing options for attribute inside ${config.selector}`);
                    if (!((_c = modifier.options) === null || _c === void 0 ? void 0 : _c.selector)) throw new Error(`Missing attribute selector inside component "${config.selector}"`);
                    if (!this._registry && typeof modifier.options.registry === 'function') this._registry = modifier.options.registry.call(this);
                    if (!this._registry) throw new Error(`Missing attribute registry for attribute "${modifier.options.selector}" and no default registry specified inside component "${config.selector}"`);
                    this._registry.define(modifier.options.selector, modifier);
                }
            }
            render() {
                return config.template.call(this);
            }
            update() {
                update.call(this);
                OnUpdate.call(this);
            }
            firstUpdated() {
                firstUpdated.call(this);
                OnUpdateFirst.call(this);
            }
        }, $c71546c4305add55$var$__setFunctionName(_b, "ModifiedClass"), _b.styles = config.styles, _b);
        const registeredElement = window.customElements.get(tag);
        if (registeredElement) {
            console.error(`** IMPORTANT!!! **
              ------------------------------------------
< ${tag} > </${tag}> Component re-defined multiple times and it is already registered inside customElements registry
Possible Solutions:
* Bundle problem where multiple versions of the component are used
            * @Component decorator is used twice for the same component
              * Defined "selector" with the same name in multiple components

                ** If this is Server Side Rendering you can ignore this message **
                  ------------------------------------------
                    `);
            return registeredElement;
        }
        if (typeof ModifiedClass === 'function') $c71546c4305add55$var$legacyCustomElement(tag, ModifiedClass, {
            extends: config.extends
        });
        else $c71546c4305add55$var$standardCustomElement(tag, ModifiedClass, {
            extends: config.extends
        });
        return ModifiedClass;
    };
const $c71546c4305add55$var$Component = (config)=>$c71546c4305add55$var$customElement(config.selector, config);
module.exports.Component = $c71546c4305add55$var$Component;

});
parcelRegister("hxu36", function(module, exports) {

$parcel$export(module.exports, "html", () => $cc4cd3d7d7fb5dc8$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $cc4cd3d7d7fb5dc8$export$7ed1367e7fa1ad68);
$parcel$export(module.exports, "noChange", () => $cc4cd3d7d7fb5dc8$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee);
$parcel$export(module.exports, "_$LH", () => $cc4cd3d7d7fb5dc8$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $cc4cd3d7d7fb5dc8$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $cc4cd3d7d7fb5dc8$var$t;
const $cc4cd3d7d7fb5dc8$var$i = window, $cc4cd3d7d7fb5dc8$var$s = $cc4cd3d7d7fb5dc8$var$i.trustedTypes, $cc4cd3d7d7fb5dc8$var$e = $cc4cd3d7d7fb5dc8$var$s ? $cc4cd3d7d7fb5dc8$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $cc4cd3d7d7fb5dc8$var$o = `lit$${(Math.random() + "").slice(9)}$`, $cc4cd3d7d7fb5dc8$var$n = "?" + $cc4cd3d7d7fb5dc8$var$o, $cc4cd3d7d7fb5dc8$var$l = `<${$cc4cd3d7d7fb5dc8$var$n}>`, $cc4cd3d7d7fb5dc8$var$h = document, $cc4cd3d7d7fb5dc8$var$r = (t = "")=>$cc4cd3d7d7fb5dc8$var$h.createComment(t), $cc4cd3d7d7fb5dc8$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $cc4cd3d7d7fb5dc8$var$u = Array.isArray, $cc4cd3d7d7fb5dc8$var$c = (t)=>$cc4cd3d7d7fb5dc8$var$u(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $cc4cd3d7d7fb5dc8$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $cc4cd3d7d7fb5dc8$var$a = /-->/g, $cc4cd3d7d7fb5dc8$var$f = />/g, $cc4cd3d7d7fb5dc8$var$_ = RegExp(">|[ \t\n\f\r](?:([^\\s\"'>=/]+)([ \t\n\f\r]*=[ \t\n\f\r]*(?:[^ \t\n\f\r\"'`<>=]|(\"|')|))|$)", "g"), $cc4cd3d7d7fb5dc8$var$m = /'/g, $cc4cd3d7d7fb5dc8$var$p = /"/g, $cc4cd3d7d7fb5dc8$var$$ = /^(?:script|style|textarea|title)$/i, $cc4cd3d7d7fb5dc8$var$g = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $cc4cd3d7d7fb5dc8$export$c0bb0b647f701bb5 = $cc4cd3d7d7fb5dc8$var$g(1), $cc4cd3d7d7fb5dc8$export$7ed1367e7fa1ad68 = $cc4cd3d7d7fb5dc8$var$g(2), $cc4cd3d7d7fb5dc8$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $cc4cd3d7d7fb5dc8$var$T = new WeakMap, $cc4cd3d7d7fb5dc8$var$A = $cc4cd3d7d7fb5dc8$var$h.createTreeWalker($cc4cd3d7d7fb5dc8$var$h, 129, null, !1), $cc4cd3d7d7fb5dc8$var$E = (t, i)=>{
    const s = t.length - 1, n = [];
    let h, r = 2 === i ? "<svg>" : "", d = $cc4cd3d7d7fb5dc8$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let e, u, c = -1, g = 0;
        for(; g < s.length && (d.lastIndex = g, u = d.exec(s), null !== u);)g = d.lastIndex, d === $cc4cd3d7d7fb5dc8$var$v ? "!--" === u[1] ? d = $cc4cd3d7d7fb5dc8$var$a : void 0 !== u[1] ? d = $cc4cd3d7d7fb5dc8$var$f : void 0 !== u[2] ? ($cc4cd3d7d7fb5dc8$var$$.test(u[2]) && (h = RegExp("</" + u[2], "g")), d = $cc4cd3d7d7fb5dc8$var$_) : void 0 !== u[3] && (d = $cc4cd3d7d7fb5dc8$var$_) : d === $cc4cd3d7d7fb5dc8$var$_ ? ">" === u[0] ? (d = null != h ? h : $cc4cd3d7d7fb5dc8$var$v, c = -1) : void 0 === u[1] ? c = -2 : (c = d.lastIndex - u[2].length, e = u[1], d = void 0 === u[3] ? $cc4cd3d7d7fb5dc8$var$_ : '"' === u[3] ? $cc4cd3d7d7fb5dc8$var$p : $cc4cd3d7d7fb5dc8$var$m) : d === $cc4cd3d7d7fb5dc8$var$p || d === $cc4cd3d7d7fb5dc8$var$m ? d = $cc4cd3d7d7fb5dc8$var$_ : d === $cc4cd3d7d7fb5dc8$var$a || d === $cc4cd3d7d7fb5dc8$var$f ? d = $cc4cd3d7d7fb5dc8$var$v : (d = $cc4cd3d7d7fb5dc8$var$_, h = void 0);
        const y = d === $cc4cd3d7d7fb5dc8$var$_ && t[i + 1].startsWith("/>") ? " " : "";
        r += d === $cc4cd3d7d7fb5dc8$var$v ? s + $cc4cd3d7d7fb5dc8$var$l : c >= 0 ? (n.push(e), s.slice(0, c) + "$lit$" + s.slice(c) + $cc4cd3d7d7fb5dc8$var$o + y) : s + $cc4cd3d7d7fb5dc8$var$o + (-2 === c ? (n.push(void 0), i) : y);
    }
    const u = r + (t[s] || "<?>") + (2 === i ? "</svg>" : "");
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== $cc4cd3d7d7fb5dc8$var$e ? $cc4cd3d7d7fb5dc8$var$e.createHTML(u) : u,
        n
    ];
};
class $cc4cd3d7d7fb5dc8$var$C {
    constructor({ strings: t, _$litType$: i }, e){
        let l;
        this.parts = [];
        let h = 0, d = 0;
        const u = t.length - 1, c = this.parts, [v, a] = $cc4cd3d7d7fb5dc8$var$E(t, i);
        if (this.el = $cc4cd3d7d7fb5dc8$var$C.createElement(v, e), $cc4cd3d7d7fb5dc8$var$A.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (l = $cc4cd3d7d7fb5dc8$var$A.nextNode()) && c.length < u;){
            if (1 === l.nodeType) {
                if (l.hasAttributes()) {
                    const t = [];
                    for (const i of l.getAttributeNames())if (i.endsWith("$lit$") || i.startsWith($cc4cd3d7d7fb5dc8$var$o)) {
                        const s = a[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = l.getAttribute(s.toLowerCase() + "$lit$").split($cc4cd3d7d7fb5dc8$var$o), i = /([.?@])?(.*)/.exec(s);
                            c.push({
                                type: 1,
                                index: h,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $cc4cd3d7d7fb5dc8$var$M : "?" === i[1] ? $cc4cd3d7d7fb5dc8$var$k : "@" === i[1] ? $cc4cd3d7d7fb5dc8$var$H : $cc4cd3d7d7fb5dc8$var$S
                            });
                        } else c.push({
                            type: 6,
                            index: h
                        });
                    }
                    for (const i of t)l.removeAttribute(i);
                }
                if ($cc4cd3d7d7fb5dc8$var$$.test(l.tagName)) {
                    const t = l.textContent.split($cc4cd3d7d7fb5dc8$var$o), i = t.length - 1;
                    if (i > 0) {
                        l.textContent = $cc4cd3d7d7fb5dc8$var$s ? $cc4cd3d7d7fb5dc8$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)l.append(t[s], $cc4cd3d7d7fb5dc8$var$r()), $cc4cd3d7d7fb5dc8$var$A.nextNode(), c.push({
                            type: 2,
                            index: ++h
                        });
                        l.append(t[i], $cc4cd3d7d7fb5dc8$var$r());
                    }
                }
            } else if (8 === l.nodeType) {
                if (l.data === $cc4cd3d7d7fb5dc8$var$n) c.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = l.data.indexOf($cc4cd3d7d7fb5dc8$var$o, t + 1));)c.push({
                        type: 7,
                        index: h
                    }), t += $cc4cd3d7d7fb5dc8$var$o.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $cc4cd3d7d7fb5dc8$var$h.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $cc4cd3d7d7fb5dc8$var$P(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $cc4cd3d7d7fb5dc8$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $cc4cd3d7d7fb5dc8$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $cc4cd3d7d7fb5dc8$var$P(t, r._$AS(t, i.values), r, e)), i;
}
class $cc4cd3d7d7fb5dc8$var$V {
    constructor(t, i){
        this.u = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    v(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $cc4cd3d7d7fb5dc8$var$h).importNode(s, !0);
        $cc4cd3d7d7fb5dc8$var$A.currentNode = o;
        let n = $cc4cd3d7d7fb5dc8$var$A.nextNode(), l = 0, r = 0, d = e[0];
        for(; void 0 !== d;){
            if (l === d.index) {
                let i;
                2 === d.type ? i = new $cc4cd3d7d7fb5dc8$var$N(n, n.nextSibling, this, t) : 1 === d.type ? i = new d.ctor(n, d.name, d.strings, this, t) : 6 === d.type && (i = new $cc4cd3d7d7fb5dc8$var$I(n, this, t)), this.u.push(i), d = e[++r];
            }
            l !== (null == d ? void 0 : d.index) && (n = $cc4cd3d7d7fb5dc8$var$A.nextNode(), l++);
        }
        return o;
    }
    p(t) {
        let i = 0;
        for (const s of this.u)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $cc4cd3d7d7fb5dc8$var$N {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cm = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cm;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $cc4cd3d7d7fb5dc8$var$P(this, t, i), $cc4cd3d7d7fb5dc8$var$d(t) ? t === $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee && this._$AR(), this._$AH = $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee) : t !== this._$AH && t !== $cc4cd3d7d7fb5dc8$export$9c068ae9cc5db4e8 && this.g(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $cc4cd3d7d7fb5dc8$var$c(t) ? this.k(t) : this.g(t);
    }
    O(t, i = this._$AB) {
        return this._$AA.parentNode.insertBefore(t, i);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    g(t) {
        this._$AH !== $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee && $cc4cd3d7d7fb5dc8$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.T($cc4cd3d7d7fb5dc8$var$h.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $cc4cd3d7d7fb5dc8$var$C.createElement(e.h, this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.p(s);
        else {
            const t = new $cc4cd3d7d7fb5dc8$var$V(o, this), i = t.v(this.options);
            t.p(s), this.T(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $cc4cd3d7d7fb5dc8$var$T.get(t.strings);
        return void 0 === i && $cc4cd3d7d7fb5dc8$var$T.set(t.strings, i = new $cc4cd3d7d7fb5dc8$var$C(t)), i;
    }
    k(t) {
        $cc4cd3d7d7fb5dc8$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $cc4cd3d7d7fb5dc8$var$N(this.O($cc4cd3d7d7fb5dc8$var$r()), this.O($cc4cd3d7d7fb5dc8$var$r()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cm = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $cc4cd3d7d7fb5dc8$var$S {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $cc4cd3d7d7fb5dc8$var$P(this, t, i, 0), n = !$cc4cd3d7d7fb5dc8$var$d(t) || t !== this._$AH && t !== $cc4cd3d7d7fb5dc8$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $cc4cd3d7d7fb5dc8$var$P(this, e[s + l], i, l), h === $cc4cd3d7d7fb5dc8$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$cc4cd3d7d7fb5dc8$var$d(h) || h !== this._$AH[l]), h === $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee ? t = $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee : t !== $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $cc4cd3d7d7fb5dc8$var$M extends $cc4cd3d7d7fb5dc8$var$S {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $cc4cd3d7d7fb5dc8$var$R = $cc4cd3d7d7fb5dc8$var$s ? $cc4cd3d7d7fb5dc8$var$s.emptyScript : "";
class $cc4cd3d7d7fb5dc8$var$k extends $cc4cd3d7d7fb5dc8$var$S {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $cc4cd3d7d7fb5dc8$var$R) : this.element.removeAttribute(this.name);
    }
}
class $cc4cd3d7d7fb5dc8$var$H extends $cc4cd3d7d7fb5dc8$var$S {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $cc4cd3d7d7fb5dc8$var$P(this, t, i, 0)) && void 0 !== s ? s : $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee) === $cc4cd3d7d7fb5dc8$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee && e !== $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee && (e === $cc4cd3d7d7fb5dc8$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $cc4cd3d7d7fb5dc8$var$I {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $cc4cd3d7d7fb5dc8$var$P(this, t);
    }
}
const $cc4cd3d7d7fb5dc8$export$8613d1ca9052b22e = {
    P: "$lit$",
    A: $cc4cd3d7d7fb5dc8$var$o,
    M: $cc4cd3d7d7fb5dc8$var$n,
    C: 1,
    L: $cc4cd3d7d7fb5dc8$var$E,
    R: $cc4cd3d7d7fb5dc8$var$V,
    D: $cc4cd3d7d7fb5dc8$var$c,
    V: $cc4cd3d7d7fb5dc8$var$P,
    I: $cc4cd3d7d7fb5dc8$var$N,
    H: $cc4cd3d7d7fb5dc8$var$S,
    N: $cc4cd3d7d7fb5dc8$var$k,
    U: $cc4cd3d7d7fb5dc8$var$H,
    B: $cc4cd3d7d7fb5dc8$var$M,
    F: $cc4cd3d7d7fb5dc8$var$I
}, $cc4cd3d7d7fb5dc8$var$z = $cc4cd3d7d7fb5dc8$var$i.litHtmlPolyfillSupport;
null == $cc4cd3d7d7fb5dc8$var$z || $cc4cd3d7d7fb5dc8$var$z($cc4cd3d7d7fb5dc8$var$C, $cc4cd3d7d7fb5dc8$var$N), (null !== ($cc4cd3d7d7fb5dc8$var$t = $cc4cd3d7d7fb5dc8$var$i.litHtmlVersions) && void 0 !== $cc4cd3d7d7fb5dc8$var$t ? $cc4cd3d7d7fb5dc8$var$t : $cc4cd3d7d7fb5dc8$var$i.litHtmlVersions = []).push("2.5.0");
const $cc4cd3d7d7fb5dc8$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $cc4cd3d7d7fb5dc8$var$N(i.insertBefore($cc4cd3d7d7fb5dc8$var$r(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});


parcelRegister("l5A7e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("hFLKi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.async = void 0;

var $bNBnP = parcelRequire("bNBnP");

var $7gMqP = parcelRequire("7gMqP");

var $hxu36 = parcelRequire("hxu36");
class $cddb4d4ea527566b$var$ObserveDirective extends $7gMqP.AsyncDirective {
    // When the observable changes, unsubscribe to the old one and
    // subscribe to the new one
    render(asyncResult) {
        if ('then' in asyncResult) {
            Promise.resolve(asyncResult).then((v)=>this.setValue(v));
            return '';
        }
        if (this.observable !== asyncResult) {
            this.unsubscribe();
            this.observable = asyncResult;
            if (this.isConnected) this.subscribe(asyncResult);
        }
        return $hxu36.noChange;
    }
    // Subscribes to the observable, calling the directive's asynchronous
    // setValue API each time the value changes
    subscribe(observable) {
        this.subscription = observable.subscribe((v)=>{
            this.setValue(v);
        });
    }
    // When the directive is disconnected from the DOM, unsubscribe to ensure
    // the directive instance can be garbage collected
    disconnected() {
        this.unsubscribe();
    }
    unsubscribe() {
        if (this.subscription) this.subscription.unsubscribe();
    }
    // If the subtree the directive is in was disconneted and subsequently
    // re-connected, re-subscribe to make the directive operable again
    reconnected() {
        this.subscribe(this.observable);
    }
}
module.exports.async = (0, $bNBnP.directive)($cddb4d4ea527566b$var$ObserveDirective);

});
parcelRegister("bNBnP", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $897144dca4e5c2e3$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $897144dca4e5c2e3$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $897144dca4e5c2e3$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $897144dca4e5c2e3$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $897144dca4e5c2e3$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $897144dca4e5c2e3$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});

parcelRegister("7gMqP", function(module, exports) {

$parcel$export(module.exports, "AsyncDirective", () => $54af989063e7cba2$export$7d025501802325e);
$parcel$export(module.exports, "Directive", () => (parcelRequire("bNBnP")).Directive);
$parcel$export(module.exports, "PartType", () => (parcelRequire("bNBnP")).PartType);
$parcel$export(module.exports, "directive", () => (parcelRequire("bNBnP")).directive);

var $areLk = parcelRequire("areLk");

var $bNBnP = parcelRequire("bNBnP");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $54af989063e7cba2$var$s = (i, t)=>{
    var e, o;
    const r = i._$AN;
    if (void 0 === r) return !1;
    for (const i of r)null === (o = (e = i)._$AO) || void 0 === o || o.call(e, t, !1), $54af989063e7cba2$var$s(i, t);
    return !0;
}, $54af989063e7cba2$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === (null == e ? void 0 : e.size));
}, $54af989063e7cba2$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $54af989063e7cba2$var$l(t);
    }
};
function $54af989063e7cba2$var$n(i) {
    void 0 !== this._$AN ? ($54af989063e7cba2$var$o(this), this._$AM = i, $54af989063e7cba2$var$r(this)) : this._$AM = i;
}
function $54af989063e7cba2$var$h(i, t = !1, e = 0) {
    const r = this._$AH, n = this._$AN;
    if (void 0 !== n && 0 !== n.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$54af989063e7cba2$var$s(r[i], !1), $54af989063e7cba2$var$o(r[i]);
            else null != r && ($54af989063e7cba2$var$s(r, !1), $54af989063e7cba2$var$o(r));
        } else $54af989063e7cba2$var$s(this, i);
    }
}
const $54af989063e7cba2$var$l = (i)=>{
    var t, s, o, r;
    i.type == (0, $bNBnP.PartType).CHILD && (null !== (t = (o = i)._$AP) && void 0 !== t || (o._$AP = $54af989063e7cba2$var$h), null !== (s = (r = i)._$AQ) && void 0 !== s || (r._$AQ = $54af989063e7cba2$var$n));
};
class $54af989063e7cba2$export$7d025501802325e extends (0, $bNBnP.Directive) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $54af989063e7cba2$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        var e, r;
        i !== this.isConnected && (this.isConnected = i, i ? null === (e = this.reconnected) || void 0 === e || e.call(this) : null === (r = this.disconnected) || void 0 === r || r.call(this)), t && ($54af989063e7cba2$var$s(this, i), $54af989063e7cba2$var$o(this));
    }
    setValue(t) {
        if ((0, $areLk.isSingleExpression)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}

});
parcelRegister("areLk", function(module, exports) {

$parcel$export(module.exports, "isPrimitive", () => $7997e0852a319a18$export$c3825b437cbdea5c);
$parcel$export(module.exports, "TemplateResultType", () => $7997e0852a319a18$export$80c36ae3cab9881d);
$parcel$export(module.exports, "isTemplateResult", () => $7997e0852a319a18$export$6b6d145ec2a44ca9);
$parcel$export(module.exports, "isDirectiveResult", () => $7997e0852a319a18$export$2f448fec17d50a3e);
$parcel$export(module.exports, "getDirectiveClass", () => $7997e0852a319a18$export$f28e31de6a6eaf32);
$parcel$export(module.exports, "isSingleExpression", () => $7997e0852a319a18$export$7f431ad0fff82fd9);
$parcel$export(module.exports, "insertPart", () => $7997e0852a319a18$export$291b2338ad9b0b30);
$parcel$export(module.exports, "setChildPartValue", () => $7997e0852a319a18$export$cb8bf9562088e9f4);
$parcel$export(module.exports, "setCommittedValue", () => $7997e0852a319a18$export$ea70d9dd5965b1c8);
$parcel$export(module.exports, "getCommittedValue", () => $7997e0852a319a18$export$59e9bce518cde500);
$parcel$export(module.exports, "removePart", () => $7997e0852a319a18$export$3133b3144bbba267);
$parcel$export(module.exports, "clearPart", () => $7997e0852a319a18$export$7f600b8138c094dc);

var $hxu36 = parcelRequire("hxu36");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $7997e0852a319a18$var$l } = (0, $hxu36._$LH), $7997e0852a319a18$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $7997e0852a319a18$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $7997e0852a319a18$export$6b6d145ec2a44ca9 = (o, l)=>void 0 === l ? void 0 !== (null == o ? void 0 : o._$litType$) : (null == o ? void 0 : o._$litType$) === l, $7997e0852a319a18$export$2f448fec17d50a3e = (o)=>void 0 !== (null == o ? void 0 : o._$litDirective$), $7997e0852a319a18$export$f28e31de6a6eaf32 = (o)=>null == o ? void 0 : o._$litDirective$, $7997e0852a319a18$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $7997e0852a319a18$var$c = ()=>document.createComment(""), $7997e0852a319a18$export$291b2338ad9b0b30 = (o, t, i)=>{
    var n;
    const d = o._$AA.parentNode, v = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        const t = d.insertBefore($7997e0852a319a18$var$c(), v), n = d.insertBefore($7997e0852a319a18$var$c(), v);
        i = new $7997e0852a319a18$var$l(t, n, o, o.options);
    } else {
        const l = i._$AB.nextSibling, t = i._$AM, e = t !== o;
        if (e) {
            let l;
            null === (n = i._$AQ) || void 0 === n || n.call(i, o), i._$AM = o, void 0 !== i._$AP && (l = o._$AU) !== t._$AU && i._$AP(l);
        }
        if (l !== v || e) {
            let o = i._$AA;
            for(; o !== l;){
                const l = o.nextSibling;
                d.insertBefore(o, v), o = l;
            }
        }
    }
    return i;
}, $7997e0852a319a18$export$cb8bf9562088e9f4 = (o, l, t = o)=>(o._$AI(l, t), o), $7997e0852a319a18$var$f = {}, $7997e0852a319a18$export$ea70d9dd5965b1c8 = (o, l = $7997e0852a319a18$var$f)=>o._$AH = l, $7997e0852a319a18$export$59e9bce518cde500 = (o)=>o._$AH, $7997e0852a319a18$export$3133b3144bbba267 = (o)=>{
    var l;
    null === (l = o._$AP) || void 0 === l || l.call(o, !1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $7997e0852a319a18$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};

});



parcelRegister("b7oCz", function(module, exports) {

$parcel$export(module.exports, "hydrate", () => $81837264d30c0d81$export$fa8d919ba61d84db);
$parcel$export(module.exports, "digestForTemplateResult", () => $81837264d30c0d81$export$a57460192a70a9b0);

var $hxu36 = parcelRequire("hxu36");

var $bNBnP = parcelRequire("bNBnP");

var $areLk = parcelRequire("areLk");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { R: $81837264d30c0d81$var$i, D: $81837264d30c0d81$var$a, V: $81837264d30c0d81$var$s, I: $81837264d30c0d81$var$c, F: $81837264d30c0d81$var$d } = (0, $hxu36._$LH), $81837264d30c0d81$export$fa8d919ba61d84db = (e, t, r = {})=>{
    if (void 0 !== t._$litPart$) throw Error("container already contains a live render");
    let n, o;
    const l = [], i = document.createTreeWalker(t, NodeFilter.SHOW_COMMENT, null, !1);
    let a;
    for(; null !== (a = i.nextNode());){
        const t = a.data;
        if (t.startsWith("lit-part")) {
            if (0 === l.length && void 0 !== n) throw Error("there must be only one root part per container");
            o = $81837264d30c0d81$var$p(e, a, l, r), null != n || (n = o);
        } else if (t.startsWith("lit-node")) $81837264d30c0d81$var$h(a, l, r);
        else if (t.startsWith("/lit-part")) {
            if (1 === l.length && o !== n) throw Error("internal error");
            o = $81837264d30c0d81$var$u(a, o, l);
        }
    }
    console.assert(void 0 !== n, "there should be exactly one root part in a render container"), t._$litPart$ = n;
}, $81837264d30c0d81$var$p = (t, r, l, d)=>{
    let f, p;
    if (0 === l.length) p = new $81837264d30c0d81$var$c(r, null, void 0, d), f = t;
    else {
        const e = l[l.length - 1];
        if ("template-instance" === e.type) p = new $81837264d30c0d81$var$c(r, null, e.instance, d), e.instance.u.push(p), f = e.result.values[e.instancePartIndex++], e.templatePartIndex++;
        else if ("iterable" === e.type) {
            p = new $81837264d30c0d81$var$c(r, null, e.part, d);
            const t = e.iterator.next();
            if (t.done) throw f = void 0, e.done = !0, Error("Unhandled shorter than expected iterable");
            f = t.value, e.part._$AH.push(p);
        } else p = new $81837264d30c0d81$var$c(r, null, e.part, d);
    }
    if (f = $81837264d30c0d81$var$s(p, f), f === (0, $hxu36.noChange)) l.push({
        part: p,
        type: "leaf"
    });
    else if ((0, $areLk.isPrimitive)(f)) l.push({
        part: p,
        type: "leaf"
    }), p._$AH = f;
    else if ((0, $areLk.isTemplateResult)(f)) {
        const e = "lit-part " + $81837264d30c0d81$export$a57460192a70a9b0(f);
        if (r.data !== e) throw Error("Hydration value mismatch: Unexpected TemplateResult rendered to part");
        {
            const e = $81837264d30c0d81$var$c.prototype._$AC(f), t = new $81837264d30c0d81$var$i(e, p);
            l.push({
                type: "template-instance",
                instance: t,
                part: p,
                templatePartIndex: 0,
                instancePartIndex: 0,
                result: f
            }), p._$AH = t;
        }
    } else $81837264d30c0d81$var$a(f) ? (l.push({
        part: p,
        type: "iterable",
        value: f,
        iterator: f[Symbol.iterator](),
        done: !1
    }), p._$AH = []) : (l.push({
        part: p,
        type: "leaf"
    }), p._$AH = null == f ? "" : f);
    return p;
}, $81837264d30c0d81$var$u = (e, t, r)=>{
    if (void 0 === t) throw Error("unbalanced part marker");
    t._$AB = e;
    const n = r.pop();
    if ("iterable" === n.type && !n.iterator.next().done) throw Error("unexpected longer than expected iterable");
    if (r.length > 0) return r[r.length - 1].part;
}, $81837264d30c0d81$var$h = (e, t, n)=>{
    var o;
    const i = /lit-node (\d+)/.exec(e.data), a = parseInt(i[1]), c = null !== (o = e.previousElementSibling) && void 0 !== o ? o : e.parentElement;
    if (null === c) throw Error("could not find node for attribute parts");
    c.removeAttribute("defer-hydration");
    const f = t[t.length - 1];
    if ("template-instance" !== f.type) throw Error("internal error");
    {
        const e = f.instance;
        for(;;){
            const t = e._$AD.parts[f.templatePartIndex];
            if (void 0 === t || t.type !== (0, $bNBnP.PartType).ATTRIBUTE && t.type !== (0, $bNBnP.PartType).ELEMENT || t.index !== a) break;
            if (t.type === (0, $bNBnP.PartType).ATTRIBUTE) {
                const o = new t.ctor(c, t.name, t.strings, f.instance, n), i = (0, $areLk.isSingleExpression)(o) ? f.result.values[f.instancePartIndex] : f.result.values, a = !(o.type === (0, $bNBnP.PartType).EVENT || o.type === (0, $bNBnP.PartType).PROPERTY);
                o._$AI(i, o, f.instancePartIndex, a), f.instancePartIndex += t.strings.length - 1, e.u.push(o);
            } else {
                const t = new $81837264d30c0d81$var$d(c, f.instance, n);
                $81837264d30c0d81$var$s(t, f.result.values[f.instancePartIndex++]), e.u.push(t);
            }
            f.templatePartIndex++;
        }
    }
}, $81837264d30c0d81$export$a57460192a70a9b0 = (e)=>{
    const t = new Uint32Array(2).fill(5381);
    for (const r of e.strings)for(let e = 0; e < r.length; e++)t[e % 2] = 33 * t[e % 2] ^ r.charCodeAt(e);
    return btoa(String.fromCharCode(...new Uint8Array(t.buffer)));
};

});

parcelRegister("ldnf6", function(module, exports) {

var $hxu36 = parcelRequire("hxu36");

var $b7oCz = parcelRequire("b7oCz");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ globalThis.litElementHydrateSupport = ({ LitElement: s })=>{
    const e = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(s), "observedAttributes").get;
    Object.defineProperty(s, "observedAttributes", {
        get () {
            return [
                ...e.call(this),
                "defer-hydration"
            ];
        }
    });
    const h = s.prototype.attributeChangedCallback;
    s.prototype.attributeChangedCallback = function(t, i, s) {
        "defer-hydration" === t && null === s && n.call(this), h.call(this, t, i, s);
    };
    const n = s.prototype.connectedCallback;
    s.prototype.connectedCallback = function() {
        this.hasAttribute("defer-hydration") || n.call(this);
    };
    const o = s.prototype.createRenderRoot;
    s.prototype.createRenderRoot = function() {
        return this.shadowRoot ? (this._$AG = !0, this.shadowRoot) : o.call(this);
    };
    const r = Object.getPrototypeOf(s.prototype).update;
    s.prototype.update = function(s) {
        const e = this.render();
        r.call(this, s), this._$AG ? (this._$AG = !1, (0, $b7oCz.hydrate)(e, this.renderRoot, this.renderOptions)) : (0, $hxu36.render)(e, this.renderRoot, this.renderOptions);
    };
};

});

parcelRegister("ddeES", function(module, exports) {
!function(i) {
    "function" == typeof define && define.amd ? define(i) : i();
}(function() {
    "use strict";
    /**
     * @license
     * Copyright 2017 Google LLC
     * SPDX-License-Identifier: BSD-3-Clause
     */ var i, n = new Set, o = new Map;
    null !== (i = globalThis.litHtmlPolyfillSupport) && void 0 !== i || (globalThis.litHtmlPolyfillSupport = function(i, t) {
        if (void 0 !== window.ShadyCSS && (!window.ShadyCSS.nativeShadow || window.ShadyCSS.ApplyShim)) {
            var d = function(i) {
                return void 0 !== i && !n.has(i);
            }, e = function(i) {
                var n = o.get(i);
                return void 0 === n && o.set(i, n = []), n;
            }, v = new Map, u = i.createElement;
            i.createElement = function(n, o) {
                var t = u.call(i, n, o), v = null == o ? void 0 : o.scope;
                if (void 0 !== v && (window.ShadyCSS.nativeShadow || window.ShadyCSS.prepareTemplateDom(t, v), d(v))) {
                    var l = e(v), r = t.content.querySelectorAll("style");
                    l.push.apply(l, Array.from(r).map(function(i) {
                        var n;
                        return null === (n = i.parentNode) || void 0 === n || n.removeChild(i), i.textContent;
                    }));
                }
                return t;
            };
            var l = document.createDocumentFragment(), r = document.createComment(""), a = t.prototype, s = a._$AI;
            a._$AI = function(i, t) {
                var v, u;
                void 0 === t && (t = this);
                var a = this._$AA.parentNode, w = null === (v = this.options) || void 0 === v ? void 0 : v.scope;
                if (a instanceof ShadowRoot && d(w)) {
                    var f = this._$AA, c = this._$AB;
                    l.appendChild(r), this._$AA = r, this._$AB = null, s.call(this, i, t);
                    var h = (null == i ? void 0 : i._$litType$) ? this._$AH._$AD.el : document.createElement("template");
                    if (function(i, t) {
                        var d, v = e(i), u = 0 !== v.length;
                        u && ((d = document.createElement("style")).textContent = v.join("\n"), t.content.appendChild(d)), n.add(i), o.delete(i), window.ShadyCSS.prepareTemplateStyles(t, i), u && window.ShadyCSS.nativeShadow && null !== (d = t.content.querySelector("style")) && t.content.appendChild(d);
                    }(w, h), l.removeChild(r), null === (u = window.ShadyCSS) || void 0 === u ? void 0 : u.nativeShadow) {
                        var y = h.content.querySelector("style");
                        null !== y && l.appendChild(y.cloneNode(!0));
                    }
                    a.insertBefore(l, c), this._$AA = f, this._$AB = c;
                } else s.call(this, i, t);
            }, a._$AC = function(n) {
                var o, t = null === (o = this.options) || void 0 === o ? void 0 : o.scope, d = v.get(t);
                void 0 === d && v.set(t, d = new Map);
                var e = d.get(n.strings);
                return void 0 === e && d.set(n.strings, e = new i(n, this.options)), e;
            };
        }
    });
});

});

parcelRegister("h4sgq", function(module, exports) {

$parcel$export(module.exports, "LitElement", () => (parcelRequire("k9ibF")).LitElement);
$parcel$export(module.exports, "UpdatingElement", () => (parcelRequire("k9ibF")).UpdatingElement);
$parcel$export(module.exports, "_$LE", () => (parcelRequire("k9ibF"))._$LE);

var $iQTCZ = parcelRequire("iQTCZ");

var $hxu36 = parcelRequire("hxu36");

var $k9ibF = parcelRequire("k9ibF");

var $j3yyq = parcelRequire("j3yyq");

var $dDyHN = parcelRequire("dDyHN");

var $i4pZm = parcelRequire("i4pZm");

var $2YaOa = parcelRequire("2YaOa");

var $2KZp6 = parcelRequire("2KZp6");

var $lJyLe = parcelRequire("lJyLe");

var $1vzxt = parcelRequire("1vzxt");

var $higFK = parcelRequire("higFK");

var $fsDPG = parcelRequire("fsDPG");

var $6bPAo = parcelRequire("6bPAo");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ console.warn("The main 'lit-element' module entrypoint is deprecated. Please update your imports to use the 'lit' package: 'lit' and 'lit/decorators.ts' or import from 'lit-element/lit-element.ts'. See https://lit.dev/msg/deprecated-import-path for more information.");
$parcel$exportWildcard(module.exports, $iQTCZ);
$parcel$exportWildcard(module.exports, $hxu36);
$parcel$exportWildcard(module.exports, $j3yyq);
$parcel$exportWildcard(module.exports, $dDyHN);
$parcel$exportWildcard(module.exports, $i4pZm);
$parcel$exportWildcard(module.exports, $2YaOa);
$parcel$exportWildcard(module.exports, $2KZp6);
$parcel$exportWildcard(module.exports, $lJyLe);
$parcel$exportWildcard(module.exports, $1vzxt);
$parcel$exportWildcard(module.exports, $higFK);
$parcel$exportWildcard(module.exports, $fsDPG);
$parcel$exportWildcard(module.exports, $6bPAo);

});
parcelRegister("iQTCZ", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", () => $db983bd72bd45574$export$7312b35fbf521afb);
$parcel$export(module.exports, "notEqual", () => $db983bd72bd45574$export$53a6892c50694894);
$parcel$export(module.exports, "ReactiveElement", () => $db983bd72bd45574$export$c7c07a37856565d);
$parcel$export(module.exports, "CSSResult", () => (parcelRequire("lAvNC")).CSSResult);
$parcel$export(module.exports, "adoptStyles", () => (parcelRequire("lAvNC")).adoptStyles);
$parcel$export(module.exports, "css", () => (parcelRequire("lAvNC")).css);
$parcel$export(module.exports, "getCompatibleStyle", () => (parcelRequire("lAvNC")).getCompatibleStyle);
$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => (parcelRequire("lAvNC")).supportsAdoptingStyleSheets);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("lAvNC")).unsafeCSS);

var $lAvNC = parcelRequire("lAvNC");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $db983bd72bd45574$var$s;
const $db983bd72bd45574$var$e = window, $db983bd72bd45574$var$r = $db983bd72bd45574$var$e.trustedTypes, $db983bd72bd45574$var$h = $db983bd72bd45574$var$r ? $db983bd72bd45574$var$r.emptyScript : "", $db983bd72bd45574$var$o = $db983bd72bd45574$var$e.reactiveElementPolyfillSupport, $db983bd72bd45574$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $db983bd72bd45574$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $db983bd72bd45574$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $db983bd72bd45574$var$l = {
    attribute: !0,
    type: String,
    converter: $db983bd72bd45574$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $db983bd72bd45574$export$53a6892c50694894
};
class $db983bd72bd45574$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this.u();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $db983bd72bd45574$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $db983bd72bd45574$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty("finalized")) return !1;
        this.finalized = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $lAvNC.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $lAvNC.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    u() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $lAvNC.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $db983bd72bd45574$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $db983bd72bd45574$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $db983bd72bd45574$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $db983bd72bd45574$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$db983bd72bd45574$export$c7c07a37856565d.finalized = !0, $db983bd72bd45574$export$c7c07a37856565d.elementProperties = new Map, $db983bd72bd45574$export$c7c07a37856565d.elementStyles = [], $db983bd72bd45574$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $db983bd72bd45574$var$o || $db983bd72bd45574$var$o({
    ReactiveElement: $db983bd72bd45574$export$c7c07a37856565d
}), (null !== ($db983bd72bd45574$var$s = $db983bd72bd45574$var$e.reactiveElementVersions) && void 0 !== $db983bd72bd45574$var$s ? $db983bd72bd45574$var$s : $db983bd72bd45574$var$e.reactiveElementVersions = []).push("1.5.0");

});
parcelRegister("lAvNC", function(module, exports) {

$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => $fb75a0712ac0371a$export$b4d10f6001c083c2);
$parcel$export(module.exports, "CSSResult", () => $fb75a0712ac0371a$export$505d1e8739bad805);
$parcel$export(module.exports, "unsafeCSS", () => $fb75a0712ac0371a$export$8d80f9cac07cdb3);
$parcel$export(module.exports, "css", () => $fb75a0712ac0371a$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $fb75a0712ac0371a$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $fb75a0712ac0371a$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fb75a0712ac0371a$var$t = window, $fb75a0712ac0371a$export$b4d10f6001c083c2 = $fb75a0712ac0371a$var$t.ShadowRoot && (void 0 === $fb75a0712ac0371a$var$t.ShadyCSS || $fb75a0712ac0371a$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $fb75a0712ac0371a$var$s = Symbol(), $fb75a0712ac0371a$var$n = new WeakMap;
class $fb75a0712ac0371a$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $fb75a0712ac0371a$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($fb75a0712ac0371a$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $fb75a0712ac0371a$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $fb75a0712ac0371a$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $fb75a0712ac0371a$export$8d80f9cac07cdb3 = (t)=>new $fb75a0712ac0371a$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $fb75a0712ac0371a$var$s), $fb75a0712ac0371a$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $fb75a0712ac0371a$export$505d1e8739bad805(n, t, $fb75a0712ac0371a$var$s);
}, $fb75a0712ac0371a$export$2ca4a66ec4cecb90 = (s, n)=>{
    $fb75a0712ac0371a$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $fb75a0712ac0371a$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $fb75a0712ac0371a$export$ee69dfd951e24778 = $fb75a0712ac0371a$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $fb75a0712ac0371a$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("k9ibF", function(module, exports) {

$parcel$export(module.exports, "UpdatingElement", () => $eab2c181197868ab$export$8bf27daf9e8907c9);
$parcel$export(module.exports, "LitElement", () => $eab2c181197868ab$export$3f2f9f5909897157);
$parcel$export(module.exports, "_$LE", () => $eab2c181197868ab$export$f5c524615a7708d6);

var $iQTCZ = parcelRequire("iQTCZ");

var $hxu36 = parcelRequire("hxu36");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $eab2c181197868ab$var$l, $eab2c181197868ab$var$o;
const $eab2c181197868ab$export$8bf27daf9e8907c9 = (0, $iQTCZ.ReactiveElement);
class $eab2c181197868ab$export$3f2f9f5909897157 extends (0, $iQTCZ.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $hxu36.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $hxu36.noChange;
    }
}
$eab2c181197868ab$export$3f2f9f5909897157.finalized = !0, $eab2c181197868ab$export$3f2f9f5909897157._$litElement$ = !0, null === ($eab2c181197868ab$var$l = globalThis.litElementHydrateSupport) || void 0 === $eab2c181197868ab$var$l || $eab2c181197868ab$var$l.call(globalThis, {
    LitElement: $eab2c181197868ab$export$3f2f9f5909897157
});
const $eab2c181197868ab$var$n = globalThis.litElementPolyfillSupport;
null == $eab2c181197868ab$var$n || $eab2c181197868ab$var$n({
    LitElement: $eab2c181197868ab$export$3f2f9f5909897157
});
const $eab2c181197868ab$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($eab2c181197868ab$var$o = globalThis.litElementVersions) && void 0 !== $eab2c181197868ab$var$o ? $eab2c181197868ab$var$o : globalThis.litElementVersions = []).push("3.2.2");

});

parcelRegister("j3yyq", function(module, exports) {

$parcel$export(module.exports, "legacyPrototypeMethod", () => $ddf919df6689bc29$export$29fd0ed4087278b5);
$parcel$export(module.exports, "standardPrototypeMethod", () => $ddf919df6689bc29$export$18eb0154d0069a01);
$parcel$export(module.exports, "decorateProperty", () => $ddf919df6689bc29$export$757d561a932dc1cb);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ddf919df6689bc29$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $ddf919df6689bc29$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $ddf919df6689bc29$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };

});

parcelRegister("dDyHN", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $9ed9d6a021cd60e6$export$da64fc29f17f9d0e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9ed9d6a021cd60e6$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);

});

parcelRegister("i4pZm", function(module, exports) {

$parcel$export(module.exports, "property", () => $d27cc28ab600f1d1$export$d541bacb2bda4494);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d27cc28ab600f1d1$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    };
function $d27cc28ab600f1d1$export$d541bacb2bda4494(e) {
    return (n, t)=>void 0 !== t ? ((i, e, n)=>{
            e.constructor.createProperty(n, i);
        })(e, n, t) : $d27cc28ab600f1d1$var$i(e, n);
}

});

parcelRegister("2YaOa", function(module, exports) {

$parcel$export(module.exports, "state", () => $229991aa5263d494$export$ca000e230c0caa3e);

var $i4pZm = parcelRequire("i4pZm");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $229991aa5263d494$export$ca000e230c0caa3e(t) {
    return (0, $i4pZm.property)({
        ...t,
        state: !0
    });
}

});

parcelRegister("2KZp6", function(module, exports) {

$parcel$export(module.exports, "eventOptions", () => $201f8232cd769abb$export$b2b799818fbabcf3);

var $j3yyq = parcelRequire("j3yyq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $201f8232cd769abb$export$b2b799818fbabcf3(e) {
    return (0, $j3yyq.decorateProperty)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}

});

parcelRegister("lJyLe", function(module, exports) {

$parcel$export(module.exports, "query", () => $fd28c3bd0dea03ae$export$2fa187e846a241c4);

var $j3yyq = parcelRequire("j3yyq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $fd28c3bd0dea03ae$export$2fa187e846a241c4(i, n) {
    return (0, $j3yyq.decorateProperty)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}

});

parcelRegister("1vzxt", function(module, exports) {

$parcel$export(module.exports, "queryAll", () => $1194410145d824c8$export$dcd0d083aa86c355);

var $j3yyq = parcelRequire("j3yyq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1194410145d824c8$export$dcd0d083aa86c355(e) {
    return (0, $j3yyq.decorateProperty)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("higFK", function(module, exports) {

$parcel$export(module.exports, "queryAsync", () => $c9710cdd9901acce$export$163dfc35cc43f240);

var $j3yyq = parcelRequire("j3yyq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c9710cdd9901acce$export$163dfc35cc43f240(e) {
    return (0, $j3yyq.decorateProperty)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("fsDPG", function(module, exports) {

$parcel$export(module.exports, "queryAssignedElements", () => $b4185e71db81c4f2$export$4682af2d9ee91415);

var $j3yyq = parcelRequire("j3yyq");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $b4185e71db81c4f2$var$n;
const $b4185e71db81c4f2$var$e = null != (null === ($b4185e71db81c4f2$var$n = window.HTMLSlotElement) || void 0 === $b4185e71db81c4f2$var$n ? void 0 : $b4185e71db81c4f2$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $b4185e71db81c4f2$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $j3yyq.decorateProperty)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $b4185e71db81c4f2$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("6bPAo", function(module, exports) {

$parcel$export(module.exports, "queryAssignedNodes", () => $481bc90baca0cfed$export$1bdbe53f9df1b8);

var $j3yyq = parcelRequire("j3yyq");

var $fsDPG = parcelRequire("fsDPG");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $481bc90baca0cfed$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $fsDPG.queryAssignedElements)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $j3yyq.decorateProperty)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});


parcelRegister("fAP44", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $b5a1d42cec814e01$export$56cc687933817664);

var $hxu36 = parcelRequire("hxu36");

var $bNBnP = parcelRequire("bNBnP");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b5a1d42cec814e01$export$56cc687933817664 = (0, $bNBnP.directive)(class extends (0, $bNBnP.Directive) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $bNBnP.PartType).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.nt) {
            this.nt = new Set, void 0 !== i.strings && (this.st = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.st) || void 0 === r ? void 0 : r.has(t)) && this.nt.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.nt.forEach((t)=>{
            t in s || (e.remove(t), this.nt.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.nt.has(t) || (null === (o = this.st) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.nt.add(t)) : (e.remove(t), this.nt.delete(t)));
        }
        return 0, $hxu36.noChange;
    }
});

});

parcelRegister("da2ea", function(module, exports) {

$parcel$export(module.exports, "asyncAppend", () => $994defda34aae07a$export$eaa89ade56b7c0c1);

var $bNBnP = parcelRequire("bNBnP");

var $d3QZ9 = parcelRequire("d3QZ9");

var $areLk = parcelRequire("areLk");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $994defda34aae07a$export$eaa89ade56b7c0c1 = (0, $bNBnP.directive)(class extends (0, $d3QZ9.AsyncReplaceDirective) {
    constructor(r){
        if (super(r), r.type !== (0, $bNBnP.PartType).CHILD) throw Error("asyncAppend can only be used in child expressions");
    }
    update(r, e) {
        return this._$Ctt = r, super.update(r, e);
    }
    commitValue(r, e) {
        0 === e && (0, $areLk.clearPart)(this._$Ctt);
        const s = (0, $areLk.insertPart)(this._$Ctt);
        (0, $areLk.setChildPartValue)(s, r);
    }
});

});
parcelRegister("d3QZ9", function(module, exports) {

$parcel$export(module.exports, "AsyncReplaceDirective", () => $9824a7f32faac022$export$39a433aa22cdf479);
$parcel$export(module.exports, "asyncReplace", () => $9824a7f32faac022$export$662eef59ff6bd56a);

var $hxu36 = parcelRequire("hxu36");

var $7gMqP = parcelRequire("7gMqP");

var $9LFJ6 = parcelRequire("9LFJ6");

var $bNBnP = parcelRequire("bNBnP");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $9824a7f32faac022$export$39a433aa22cdf479 extends (0, $7gMqP.AsyncDirective) {
    constructor(){
        super(...arguments), this._$CK = new (0, $9LFJ6.PseudoWeakRef)(this), this._$CX = new (0, $9LFJ6.Pauser);
    }
    render(i, s) {
        return 0, $hxu36.noChange;
    }
    update(i, [s, r]) {
        if (this.isConnected || this.disconnected(), s === this._$CJ) return;
        this._$CJ = s;
        let n = 0;
        const { _$CK: o, _$CX: h } = this;
        return (0, $9LFJ6.forAwaitOf)(s, async (t)=>{
            for(; h.get();)await h.get();
            const i = o.deref();
            if (void 0 !== i) {
                if (i._$CJ !== s) return !1;
                void 0 !== r && (t = r(t, n)), i.commitValue(t, n), n++;
            }
            return !0;
        }), $hxu36.noChange;
    }
    commitValue(t, i) {
        this.setValue(t);
    }
    disconnected() {
        this._$CK.disconnect(), this._$CX.pause();
    }
    reconnected() {
        this._$CK.reconnect(this), this._$CX.resume();
    }
}
const $9824a7f32faac022$export$662eef59ff6bd56a = (0, $bNBnP.directive)($9824a7f32faac022$export$39a433aa22cdf479);

});
parcelRegister("9LFJ6", function(module, exports) {

$parcel$export(module.exports, "forAwaitOf", () => $71c8ded2fb96ad58$export$74673a32c6041f3e);
$parcel$export(module.exports, "PseudoWeakRef", () => $71c8ded2fb96ad58$export$71341b9b69479007);
$parcel$export(module.exports, "Pauser", () => $71c8ded2fb96ad58$export$193ea5a420bb5c41);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $71c8ded2fb96ad58$export$74673a32c6041f3e = async (t, s)=>{
    for await (const i of t)if (!1 === await s(i)) return;
};
class $71c8ded2fb96ad58$export$71341b9b69479007 {
    constructor(t){
        this.Y = t;
    }
    disconnect() {
        this.Y = void 0;
    }
    reconnect(t) {
        this.Y = t;
    }
    deref() {
        return this.Y;
    }
}
class $71c8ded2fb96ad58$export$193ea5a420bb5c41 {
    constructor(){
        this.Z = void 0, this.q = void 0;
    }
    get() {
        return this.Z;
    }
    pause() {
        var t;
        null !== (t = this.Z) && void 0 !== t || (this.Z = new Promise((t)=>this.q = t));
    }
    resume() {
        var t;
        null === (t = this.q) || void 0 === t || t.call(this), this.Z = this.q = void 0;
    }
}

});



parcelRegister("j6Fml", function(module, exports) {

$parcel$export(module.exports, "cache", () => $de8ea8fc7efc62dc$export$69a3209f1a06c04d);

var $hxu36 = parcelRequire("hxu36");

var $bNBnP = parcelRequire("bNBnP");

var $areLk = parcelRequire("areLk");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $de8ea8fc7efc62dc$export$69a3209f1a06c04d = (0, $bNBnP.directive)(class extends (0, $bNBnP.Directive) {
    constructor(t){
        super(t), this.et = new WeakMap;
    }
    render(t) {
        return [
            t
        ];
    }
    update(s, [e]) {
        if ((0, $areLk.isTemplateResult)(this.it) && (!(0, $areLk.isTemplateResult)(e) || this.it.strings !== e.strings)) {
            const e = (0, $areLk.getCommittedValue)(s).pop();
            let o = this.et.get(this.it.strings);
            if (void 0 === o) {
                const s = document.createDocumentFragment();
                o = (0, $hxu36.render)((0, $hxu36.nothing), s), o.setConnected(!1), this.et.set(this.it.strings, o);
            }
            (0, $areLk.setCommittedValue)(o, [
                e
            ]), (0, $areLk.insertPart)(o, void 0, e);
        }
        if ((0, $areLk.isTemplateResult)(e)) {
            if (!(0, $areLk.isTemplateResult)(this.it) || this.it.strings !== e.strings) {
                const t = this.et.get(e.strings);
                if (void 0 !== t) {
                    const i = (0, $areLk.getCommittedValue)(t).pop();
                    (0, $areLk.clearPart)(s), (0, $areLk.insertPart)(s, void 0, i), (0, $areLk.setCommittedValue)(s, [
                        i
                    ]);
                }
            }
            this.it = e;
        } else this.it = void 0;
        return this.render(e);
    }
});

});

parcelRegister("kPKGx", function(module, exports) {

$parcel$export(module.exports, "guard", () => $f2acc8bc1d536348$export$864d727b48066337);

var $hxu36 = parcelRequire("hxu36");

var $bNBnP = parcelRequire("bNBnP");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f2acc8bc1d536348$var$e = {}, $f2acc8bc1d536348$export$864d727b48066337 = (0, $bNBnP.directive)(class extends (0, $bNBnP.Directive) {
    constructor(){
        super(...arguments), this.ot = $f2acc8bc1d536348$var$e;
    }
    render(r, t) {
        return t();
    }
    update(t, [s, e]) {
        if (Array.isArray(s)) {
            if (Array.isArray(this.ot) && this.ot.length === s.length && s.every((r, t)=>r === this.ot[t])) return 0, $hxu36.noChange;
        } else if (this.ot === s) return 0, $hxu36.noChange;
        return this.ot = Array.isArray(s) ? Array.from(s) : s, this.render(s, e);
    }
});

});

parcelRegister("21y8E", function(module, exports) {

$parcel$export(module.exports, "ifDefined", () => $179627f5fe6f3a17$export$f68dd208b5df064d);

var $hxu36 = parcelRequire("hxu36");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $179627f5fe6f3a17$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $hxu36.nothing);

});

parcelRegister("f4O1R", function(module, exports) {

$parcel$export(module.exports, "live", () => $af9e0972d81179b7$export$28cf49ad70f82d12);

var $hxu36 = parcelRequire("hxu36");

var $bNBnP = parcelRequire("bNBnP");

var $areLk = parcelRequire("areLk");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $af9e0972d81179b7$export$28cf49ad70f82d12 = (0, $bNBnP.directive)(class extends (0, $bNBnP.Directive) {
    constructor(r){
        if (super(r), r.type !== (0, $bNBnP.PartType).PROPERTY && r.type !== (0, $bNBnP.PartType).ATTRIBUTE && r.type !== (0, $bNBnP.PartType).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!(0, $areLk.isSingleExpression)(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i, [t]) {
        if (t === (0, $hxu36.noChange) || t === (0, $hxu36.nothing)) return t;
        const o = i.element, l = i.name;
        if (i.type === (0, $bNBnP.PartType).PROPERTY) {
            if (t === o[l]) return 0, $hxu36.noChange;
        } else if (i.type === (0, $bNBnP.PartType).BOOLEAN_ATTRIBUTE) {
            if (!!t === o.hasAttribute(l)) return 0, $hxu36.noChange;
        } else if (i.type === (0, $bNBnP.PartType).ATTRIBUTE && o.getAttribute(l) === t + "") return 0, $hxu36.noChange;
        return (0, $areLk.setCommittedValue)(i), t;
    }
});

});

parcelRegister("i7OBu", function(module, exports) {

$parcel$export(module.exports, "createRef", () => $d320224700eb9fe1$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "ref", () => $d320224700eb9fe1$export$eff4d24c3ff7876e);

var $hxu36 = parcelRequire("hxu36");

var $7gMqP = parcelRequire("7gMqP");

var $bNBnP = parcelRequire("bNBnP");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d320224700eb9fe1$export$7d1e3a5e95ceca43 = ()=>new $d320224700eb9fe1$var$o;
class $d320224700eb9fe1$var$o {
}
const $d320224700eb9fe1$var$h = new WeakMap, $d320224700eb9fe1$export$eff4d24c3ff7876e = (0, $bNBnP.directive)(class extends (0, $7gMqP.AsyncDirective) {
    render(t) {
        return 0, $hxu36.nothing;
    }
    update(t, [s]) {
        var e;
        const o = s !== this.Y;
        return o && void 0 !== this.Y && this.rt(void 0), (o || this.lt !== this.ct) && (this.Y = s, this.dt = null === (e = t.options) || void 0 === e ? void 0 : e.host, this.rt(this.ct = t.element)), $hxu36.nothing;
    }
    rt(i) {
        var t;
        if ("function" == typeof this.Y) {
            const s = null !== (t = this.dt) && void 0 !== t ? t : globalThis;
            let e = $d320224700eb9fe1$var$h.get(s);
            void 0 === e && (e = new WeakMap, $d320224700eb9fe1$var$h.set(s, e)), void 0 !== e.get(this.Y) && this.Y.call(this.dt, void 0), e.set(this.Y, i), void 0 !== i && this.Y.call(this.dt, i);
        } else this.Y.value = i;
    }
    get lt() {
        var i, t, s;
        return "function" == typeof this.Y ? null === (t = $d320224700eb9fe1$var$h.get(null !== (i = this.dt) && void 0 !== i ? i : globalThis)) || void 0 === t ? void 0 : t.get(this.Y) : null === (s = this.Y) || void 0 === s ? void 0 : s.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});

});

parcelRegister("dOkbv", function(module, exports) {

$parcel$export(module.exports, "repeat", () => $a0df9a19dfde5edb$export$76d90c956114f2c2);

var $hxu36 = parcelRequire("hxu36");

var $bNBnP = parcelRequire("bNBnP");

var $areLk = parcelRequire("areLk");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a0df9a19dfde5edb$var$u = (e, s, t)=>{
    const r = new Map;
    for(let l = s; l <= t; l++)r.set(e[l], l);
    return r;
}, $a0df9a19dfde5edb$export$76d90c956114f2c2 = (0, $bNBnP.directive)(class extends (0, $bNBnP.Directive) {
    constructor(e){
        if (super(e), e.type !== (0, $bNBnP.PartType).CHILD) throw Error("repeat() can only be used in text expressions");
    }
    ht(e, s, t) {
        let r;
        void 0 === t ? t = s : void 0 !== s && (r = s);
        const l = [], o = [];
        let i = 0;
        for (const s of e)l[i] = r ? r(s, i) : i, o[i] = t(s, i), i++;
        return {
            values: o,
            keys: l
        };
    }
    render(e, s, t) {
        return this.ht(e, s, t).values;
    }
    update(s, [t, r, c]) {
        var d;
        const a = (0, $areLk.getCommittedValue)(s), { values: p, keys: v } = this.ht(t, r, c);
        if (!Array.isArray(a)) return this.ut = v, p;
        const h = null !== (d = this.ut) && void 0 !== d ? d : this.ut = [], m = [];
        let y, x, j = 0, k = a.length - 1, w = 0, A = p.length - 1;
        for(; j <= k && w <= A;)if (null === a[j]) j++;
        else if (null === a[k]) k--;
        else if (h[j] === v[w]) m[w] = (0, $areLk.setChildPartValue)(a[j], p[w]), j++, w++;
        else if (h[k] === v[A]) m[A] = (0, $areLk.setChildPartValue)(a[k], p[A]), k--, A--;
        else if (h[j] === v[A]) m[A] = (0, $areLk.setChildPartValue)(a[j], p[A]), (0, $areLk.insertPart)(s, m[A + 1], a[j]), j++, A--;
        else if (h[k] === v[w]) m[w] = (0, $areLk.setChildPartValue)(a[k], p[w]), (0, $areLk.insertPart)(s, a[j], a[k]), k--, w++;
        else if (void 0 === y && (y = $a0df9a19dfde5edb$var$u(v, w, A), x = $a0df9a19dfde5edb$var$u(h, j, k)), y.has(h[j])) {
            if (y.has(h[k])) {
                const e = x.get(v[w]), t = void 0 !== e ? a[e] : null;
                if (null === t) {
                    const e = (0, $areLk.insertPart)(s, a[j]);
                    (0, $areLk.setChildPartValue)(e, p[w]), m[w] = e;
                } else m[w] = (0, $areLk.setChildPartValue)(t, p[w]), (0, $areLk.insertPart)(s, a[j], t), a[e] = null;
                w++;
            } else (0, $areLk.removePart)(a[k]), k--;
        } else (0, $areLk.removePart)(a[j]), j++;
        for(; w <= A;){
            const e = (0, $areLk.insertPart)(s, m[A + 1]);
            (0, $areLk.setChildPartValue)(e, p[w]), m[w++] = e;
        }
        for(; j <= k;){
            const e = a[j++];
            null !== e && (0, $areLk.removePart)(e);
        }
        return this.ut = v, (0, $areLk.setCommittedValue)(s, m), $hxu36.noChange;
    }
});

});

parcelRegister("cjxiH", function(module, exports) {

$parcel$export(module.exports, "styleMap", () => $8f71172fe6005ea3$export$1e5b4ce2fa884e6a);

var $hxu36 = parcelRequire("hxu36");

var $bNBnP = parcelRequire("bNBnP");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8f71172fe6005ea3$export$1e5b4ce2fa884e6a = (0, $bNBnP.directive)(class extends (0, $bNBnP.Directive) {
    constructor(t){
        var e;
        if (super(t), t.type !== (0, $bNBnP.PartType).ATTRIBUTE || "style" !== t.name || (null === (e = t.strings) || void 0 === e ? void 0 : e.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.vt) {
            this.vt = new Set;
            for(const t in r)this.vt.add(t);
            return this.render(r);
        }
        this.vt.forEach((t)=>{
            null == r[t] && (this.vt.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = "");
        });
        for(const t in r){
            const e = r[t];
            null != e && (this.vt.add(t), t.includes("-") ? s.setProperty(t, e) : s[t] = e);
        }
        return 0, $hxu36.noChange;
    }
});

});

parcelRegister("iR4m5", function(module, exports) {

$parcel$export(module.exports, "templateContent", () => $dba08e11b3618493$export$e446d0492332fcd4);

var $hxu36 = parcelRequire("hxu36");

var $bNBnP = parcelRequire("bNBnP");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $dba08e11b3618493$export$e446d0492332fcd4 = (0, $bNBnP.directive)(class extends (0, $bNBnP.Directive) {
    constructor(t){
        if (super(t), t.type !== (0, $bNBnP.PartType).CHILD) throw Error("templateContent can only be used in child bindings");
    }
    render(r) {
        return this.ft === r ? (0, $hxu36.noChange) : (this.ft = r, document.importNode(r.content, !0));
    }
});

});

parcelRegister("8N59e", function(module, exports) {

$parcel$export(module.exports, "UnsafeHTMLDirective", () => $6666e49c3dd6f0ae$export$3bebd1f0e3943985);
$parcel$export(module.exports, "unsafeHTML", () => $6666e49c3dd6f0ae$export$b6e69390c23686fb);

var $hxu36 = parcelRequire("hxu36");

var $bNBnP = parcelRequire("bNBnP");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $6666e49c3dd6f0ae$export$3bebd1f0e3943985 extends (0, $bNBnP.Directive) {
    constructor(i){
        if (super(i), this.it = (0, $hxu36.nothing), i.type !== (0, $bNBnP.PartType).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $hxu36.nothing) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $hxu36.noChange)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$6666e49c3dd6f0ae$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $6666e49c3dd6f0ae$export$3bebd1f0e3943985.resultType = 1;
const $6666e49c3dd6f0ae$export$b6e69390c23686fb = (0, $bNBnP.directive)($6666e49c3dd6f0ae$export$3bebd1f0e3943985);

});

parcelRegister("2wEj5", function(module, exports) {

$parcel$export(module.exports, "unsafeSVG", () => $1d6dd60a097f0ad5$export$1cb98903879b8bf5);

var $bNBnP = parcelRequire("bNBnP");

var $8N59e = parcelRequire("8N59e");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $1d6dd60a097f0ad5$var$t extends (0, $8N59e.UnsafeHTMLDirective) {
}
$1d6dd60a097f0ad5$var$t.directiveName = "unsafeSVG", $1d6dd60a097f0ad5$var$t.resultType = 2;
const $1d6dd60a097f0ad5$export$1cb98903879b8bf5 = (0, $bNBnP.directive)($1d6dd60a097f0ad5$var$t);

});

parcelRegister("92JOY", function(module, exports) {

$parcel$export(module.exports, "UntilDirective", () => $6957d811d62a9d2b$export$51c6edf8ee19b71a);
$parcel$export(module.exports, "until", () => $6957d811d62a9d2b$export$a40009bd2c363351);

var $hxu36 = parcelRequire("hxu36");

var $areLk = parcelRequire("areLk");

var $7gMqP = parcelRequire("7gMqP");

var $9LFJ6 = parcelRequire("9LFJ6");

var $bNBnP = parcelRequire("bNBnP");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6957d811d62a9d2b$var$n = (t)=>!(0, $areLk.isPrimitive)(t) && "function" == typeof t.then;
class $6957d811d62a9d2b$export$51c6edf8ee19b71a extends (0, $7gMqP.AsyncDirective) {
    constructor(){
        super(...arguments), this._$Cwt = 1073741823, this._$Cyt = [], this._$CK = new (0, $9LFJ6.PseudoWeakRef)(this), this._$CX = new (0, $9LFJ6.Pauser);
    }
    render(...s) {
        var i;
        return null !== (i = s.find((t)=>!$6957d811d62a9d2b$var$n(t))) && void 0 !== i ? i : (0, $hxu36.noChange);
    }
    update(s, i) {
        const r = this._$Cyt;
        let e = r.length;
        this._$Cyt = i;
        const o = this._$CK, h = this._$CX;
        this.isConnected || this.disconnected();
        for(let t = 0; t < i.length && !(t > this._$Cwt); t++){
            const s = i[t];
            if (!$6957d811d62a9d2b$var$n(s)) return this._$Cwt = t, s;
            t < e && s === r[t] || (this._$Cwt = 1073741823, e = 0, Promise.resolve(s).then(async (t)=>{
                for(; h.get();)await h.get();
                const i = o.deref();
                if (void 0 !== i) {
                    const r = i._$Cyt.indexOf(s);
                    r > -1 && r < i._$Cwt && (i._$Cwt = r, i.setValue(t));
                }
            }));
        }
        return 0, $hxu36.noChange;
    }
    disconnected() {
        this._$CK.disconnect(), this._$CX.pause();
    }
    reconnected() {
        this._$CK.reconnect(this), this._$CX.resume();
    }
}
const $6957d811d62a9d2b$export$a40009bd2c363351 = (0, $bNBnP.directive)($6957d811d62a9d2b$export$51c6edf8ee19b71a);

});

parcelRegister("jowVr", function(module, exports) {

$parcel$export(module.exports, "choose", () => $e1e9cc83487d94c1$export$7877a478dd30fd3d);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e1e9cc83487d94c1$export$7877a478dd30fd3d = (o, r, n)=>{
    for (const n of r)if (n[0] === o) return (0, n[1])();
    return null == n ? void 0 : n();
};

});

parcelRegister("5CGIK", function(module, exports) {

$parcel$export(module.exports, "join", () => $4181a3caa35b31be$export$f7e2c8231c57a8bd);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $4181a3caa35b31be$export$f7e2c8231c57a8bd(o, t) {
    const f = "function" == typeof t;
    if (void 0 !== o) {
        let i = -1;
        for (const n of o)i > -1 && (yield f ? t(i) : t), i++, yield n;
    }
}

});

parcelRegister("eLXxM", function(module, exports) {

$parcel$export(module.exports, "keyed", () => $ac13a49db10c012a$export$8dbf9c790527241e);

var $hxu36 = parcelRequire("hxu36");

var $bNBnP = parcelRequire("bNBnP");

var $areLk = parcelRequire("areLk");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ac13a49db10c012a$export$8dbf9c790527241e = (0, $bNBnP.directive)(class extends (0, $bNBnP.Directive) {
    constructor(){
        super(...arguments), this.key = (0, $hxu36.nothing);
    }
    render(r, t) {
        return this.key = r, t;
    }
    update(r, [t, e]) {
        return t !== this.key && ((0, $areLk.setCommittedValue)(r), this.key = t), e;
    }
});

});

parcelRegister("49Jw8", function(module, exports) {

$parcel$export(module.exports, "map", () => $306b4f7d83072c8c$export$871de8747c9eaa88);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $306b4f7d83072c8c$export$871de8747c9eaa88(o, f) {
    if (void 0 !== o) {
        let i = 0;
        for (const t of o)yield f(t, i++);
    }
}

});

parcelRegister("bYWMS", function(module, exports) {

$parcel$export(module.exports, "range", () => $8b92e63cdecd1a03$export$d02631cccf789723);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $8b92e63cdecd1a03$export$d02631cccf789723(o1, l, n = 1) {
    const t = void 0 === l ? 0 : o1;
    null != l || (l = o1);
    for(let o = t; n > 0 ? o < l : l < o; o += n)yield o;
}

});

parcelRegister("hrtRG", function(module, exports) {

$parcel$export(module.exports, "when", () => $cb2c1fcf4c9815aa$export$a55877ca9db47377);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $cb2c1fcf4c9815aa$export$a55877ca9db47377(n, o, r) {
    return n ? o() : null == r ? void 0 : r();
}

});


parcelRegister("9hU4p", function(module, exports) {
$parcel$export(module.exports, "facebook", () => (parcelRequire("iyT88")).facebook);
$parcel$export(module.exports, "github", () => (parcelRequire("cKTX1")).github);
$parcel$export(module.exports, "twitter", () => (parcelRequire("7ZLqs")).twitter);
$parcel$export(module.exports, "google", () => (parcelRequire("8W3rT")).google);
$parcel$export(module.exports, "terra", () => (parcelRequire("b6i8I")).terra);
parcelRequire("iyT88");
parcelRequire("cKTX1");
parcelRequire("7ZLqs");
parcelRequire("8W3rT");
parcelRequire("b6i8I");

});
parcelRegister("iyT88", function(module, exports) {

$parcel$export(module.exports, "facebook", () => $2889039a92dbcc67$export$e98652cea9b09aa);

var $eG1Pq = parcelRequire("eG1Pq");
function $2889039a92dbcc67$export$e98652cea9b09aa(fill = '#FFF') {
    return (0, $eG1Pq.svg)`<svg fill='${fill}'
    role='img'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'>
    <title>Facebook icon</title>
    <path
        d='M23.9981 11.9991C23.9981 5.37216 18.626 0 11.9991 0C5.37216 0 0 5.37216 0 11.9991C0 17.9882 4.38789 22.9522 10.1242 23.8524V15.4676H7.07758V11.9991H10.1242V9.35553C10.1242 6.34826 11.9156 4.68714 14.6564 4.68714C15.9692 4.68714 17.3424 4.92149 17.3424 4.92149V7.87439H15.8294C14.3388 7.87439 13.8739 8.79933 13.8739 9.74824V11.9991H17.2018L16.6698 15.4676H13.8739V23.8524C19.6103 22.9522 23.9981 17.9882 23.9981 11.9991Z'/>
    </svg>`;
}

});

parcelRegister("cKTX1", function(module, exports) {

$parcel$export(module.exports, "github", () => $ddfaef7a10c91eb2$export$85c7dd0b0150981e);

var $eG1Pq = parcelRequire("eG1Pq");
function $ddfaef7a10c91eb2$export$85c7dd0b0150981e(fill = '#FFF') {
    return (0, $eG1Pq.svg)`<svg fill="${fill}"
    aria-labelledby="simpleicons-github-icon"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <title id="simpleicons-github-icon">GitHub icon</title>
    <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg>`;
}

});

parcelRegister("7ZLqs", function(module, exports) {

$parcel$export(module.exports, "twitter", () => $d3d3b670cc2fe5fe$export$87453108c2dd3831);

var $eG1Pq = parcelRequire("eG1Pq");
function $d3d3b670cc2fe5fe$export$87453108c2dd3831(fill = '#FFF') {
    return (0, $eG1Pq.svg)`<svg fill="${fill}"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <title>Twitter icon</title>
    <path d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"/></svg>`;
}

});

parcelRegister("8W3rT", function(module, exports) {

$parcel$export(module.exports, "google", () => $04b71bc6b6f88196$export$2d1fdedcfa4b711e);

var $eG1Pq = parcelRequire("eG1Pq");
function $04b71bc6b6f88196$export$2d1fdedcfa4b711e(fill = '#FFF') {
    return (0, $eG1Pq.svg)`<svg fill="${fill}"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <title>Google icon</title>
    <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z"/></svg>`;
}

});

parcelRegister("b6i8I", function(module, exports) {

$parcel$export(module.exports, "terra", () => $a2f58bb1a51ee5d1$export$a0faaedc55eea3a0);

var $eG1Pq = parcelRequire("eG1Pq");
function $a2f58bb1a51ee5d1$export$a0faaedc55eea3a0() {
    return (0, $eG1Pq.svg)`<?xml version="1.0" encoding="utf-8"?>
  <!-- Generator: Adobe Illustrator 24.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg style="width: 59px;" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1172 886" style="enable-background:new 0 0 1172 886;" xml:space="preserve">
    <style type="text/css">
    .st0{fill:#2845AD;}
    .st1{fill:#5494F8;}
    .st2{fill:none;}
  </style>
    <title>Terra icon</title>
    <path class="st0" d="M461.1,119.9c38.9-16,81.2-21.2,122.9-22.5c62.8,0.8,127.1,8.8,184.4,35.8c45,20.8,82.5,55.1,112.1,94.3
    c-9.3-6.8-14.6-17.8-22.9-25.7c-15.2-14.5-28.8-31.9-48.9-39.8c-19.8-6.8-41.1-8.5-61.9-7.5c-52.1,3.7-102.9,17.7-152,35.2
    c-53.9,21.2-108.1,47.2-148.3,90.1c-8,8-12.7,18.6-20.5,26.7c-18.4-12.5-36.3-27.4-47.2-47.1c-0.5-1-1.6-3.1-2.1-4.2
    c33.8-15.8,66.7-35.2,92.6-62.4c13.4-14.5,25.9-34.8,19-55.1C484.2,126,470.8,124.5,461.1,119.9 M605.5,525.8
    c50.5,18.6,101.5,35.8,153.2,50.7c45.3,12.3,91.6,24.3,138.8,24c-4.9,11.9-10.7,23.4-17.3,34.4c-41.6,13.4-81.5,31.8-118.7,54.8
    c-22.8,14.9-46,31.5-59.4,55.8c-5.4,9.5-5.5,20.7-2.6,30.9c-0.6,0.7-1.8,2-2.3,2.7c-16.2,4.2-33.1,13.2-50,6.7
    c-28.3-9.1-51.6-29.1-71.1-50.8c-23.8-28.2-43.3-62.5-45.7-100c-0.7-35.3,21.3-66.1,47.1-88.1C586.3,539.3,596,532.6,605.5,525.8
    L605.5,525.8z" />
    <path class="st1" d="M429.7,122c10.3-2.5,20.9-1.1,31.4-2c9.7,4.6,23.1,6.1,27.2,17.7c6.8,20.3-5.6,40.6-19,55.1
    c-25.9,27.2-58.8,46.6-92.6,62.4c0.5,1,1.5,3.1,2.1,4.2c-3.9-2.7-8.7-1.2-12.6,0.6c-25.7,11.5-52.5,20.5-80,27
    c-10.6,2.2-21.3,4.5-32.2,3.3c0-6.3,4.4-11.3,7-16.7c26-47.1,62-88,105.4-119.9C385.6,139.9,405.8,125.4,429.7,122 M594.8,189.7
    c49-17.5,99.8-31.5,152-35.2c20.8-1,42.1,0.7,61.9,7.5c20.1,8,33.7,25.4,48.9,39.8c8.3,7.9,13.6,19,22.9,25.7
    c4.8,2.4,6.5,8.4,9.9,12.4c69.4,98.2,85.9,231.2,42.9,343.5c-4.2,15-23,15.6-35.8,17.1c-47.3,0.3-93.5-11.7-138.8-24
    C707,561.6,656,544.4,605.5,525.8c-47.7-18.8-94.1-42.1-134.1-74.5c-25-21.4-48.2-48.2-54.5-81.4c-4.2-17.3-1.6-35.5,4.9-51.8
    c1.6-3.8,4.2-7.4,4.2-11.6c7.9-8.1,12.5-18.7,20.5-26.7C486.7,236.9,540.9,210.9,594.8,189.7 M237.4,325.5l2,0.8
    c15,18.3,30.3,36.5,45.4,54.6c31.8,36.4,59,76.4,84.5,117.4c35.7,55,67.7,115.3,74.2,181.5c0.6,35.7,0.8,71.7-5,107.1
    c-10.3,2.6-20.5-4-29.7-8c-68.7-37-124.8-96.6-158.3-167.2C208.4,523.2,203.4,417.6,237.4,325.5 M880.2,634.9
    c9.1-2.4,18.2-6,27.8-5.6c2.6,6.6-2.4,12.2-5.5,17.6c-30.2,48.8-71.4,90.8-120.3,120.9c-16.4,10.3-33.9,21.7-54,20.7
    c-9.6,0.7-18.9-3.4-26-9.7c-1.2,0.1-3.8,0.3-5,0.4c0.6-0.7,1.8-2,2.3-2.7c-2.8-10.2-2.7-21.5,2.6-30.9
    c13.4-24.3,36.6-40.9,59.4-55.8C798.7,666.7,838.6,648.3,880.2,634.9z" />
    <rect x="186" y="43" class="st2" width="800" height="800" />
  </svg>
  `;
}

});



parcelRegister("2cx1H", function(module, exports) {

$parcel$export(module.exports, "SocialService", () => $826c8712b87c022a$export$2ad3502e5d69a818);

var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");

var $aXvn5 = parcelRequire("aXvn5");

var $lBKT3 = parcelRequire("lBKT3");
var $82Kdl = parcelRequire("82Kdl");
var $8fifx = parcelRequire("8fifx");
var $35ZUd = parcelRequire("35ZUd");
var $36siL = parcelRequire("36siL");

var $3abYj = parcelRequire("3abYj");
var $dY50F = parcelRequire("dY50F");
var $3XkaH = parcelRequire("3XkaH");
var $iuXHq = parcelRequire("iuXHq");
var $37rZb = parcelRequire("37rZb");
class $826c8712b87c022a$export$2ad3502e5d69a818 {
    constructor(){
        this._isLoggedIn = new (0, $35ZUd.Subject)();
        this.isLoggedIn = this._isLoggedIn.asObservable();
        $aXvn5.auth().onAuthStateChanged((user)=>{
            this._isLoggedIn.next(!!user);
        });
        /* Get user token based on URI parameteres /?token=mytoken */ const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        if (token) this.checkLoggedIn().pipe((0, $iuXHq.switchMap)((isLoggedIn)=>(0, $lBKT3.from)($aXvn5.auth().signInWithCustomToken(token)).pipe((0, $3XkaH.map)(()=>isLoggedIn), (0, $3abYj.catchError)(()=>(0, $8fifx.of)(isLoggedIn))))).subscribe(()=>{
            window.history.pushState({}, document.title, window.location.pathname);
        });
    }
    userloggedIn() {
        this._isLoggedIn.next(true);
    }
    getUser() {
        return new (0, $82Kdl.Observable)((observer)=>{
            const sub = $aXvn5.auth().onAuthStateChanged((user)=>{
                observer.next(user);
                observer.complete();
            });
            return sub;
        });
    }
    getUserRef() {
        return (0, $8fifx.of)($aXvn5.auth().currentUser);
    }
    signInWithGithub(fn = (p)=>p) {
        return (0, $lBKT3.from)($aXvn5.auth().signInWithPopup(fn(new $aXvn5.auth.GithubAuthProvider())));
    }
    signInWithFacebook(fn = (p)=>p) {
        return (0, $lBKT3.from)($aXvn5.auth().signInWithPopup(fn(new $aXvn5.auth.FacebookAuthProvider())));
    }
    sendSignInLinkToEmail(email, returnUrl) {
        if (!returnUrl) return (0, $36siL.throwError)('missing-return-url');
        return (0, $lBKT3.from)($aXvn5.auth().sendSignInLinkToEmail(email, {
            handleCodeInApp: true,
            url: returnUrl
        }));
    }
    signInWithGoogle(fn = (p)=>p) {
        return (0, $lBKT3.from)($aXvn5.auth().signInWithPopup(fn(new $aXvn5.auth.GoogleAuthProvider())));
    }
    signInWithTwitter(fn = (p)=>p) {
        return (0, $lBKT3.from)($aXvn5.auth().signInWithPopup(fn(new $aXvn5.auth.TwitterAuthProvider())));
    }
    signInWithEmailAndPassword(email, password) {
        return (0, $lBKT3.from)($aXvn5.auth().signInWithEmailAndPassword(email, password));
    }
    createUserWithEmailAndPassword(email, password) {
        return (0, $lBKT3.from)($aXvn5.auth().createUserWithEmailAndPassword(email, password));
    }
    signOut() {
        return (0, $lBKT3.from)($aXvn5.auth().signOut()).pipe((0, $37rZb.tap)(()=>{
            this._isLoggedIn.next(false);
            localStorage.clear();
        }));
    }
    checkLoggedIn() {
        return new (0, $82Kdl.Observable)((o)=>{
            const unsubscribe = $aXvn5.auth().onAuthStateChanged((user)=>{
                o.next(!!user);
                o.complete();
                this._isLoggedIn.next(!!user);
                unsubscribe();
            });
            return ()=>unsubscribe();
        });
    }
    resetPassword(email) {
        return (0, $lBKT3.from)($aXvn5.auth().sendPasswordResetEmail(email));
    }
    linkAccount(type) {
        return this.getUserRef().pipe((0, $dY50F.filter)((userRef)=>!!userRef), (0, $iuXHq.switchMap)((userRef)=>userRef.linkWithPopup(this.getProvider(type))));
    }
    getProvider(type) {
        if (type === 'facebook') return new $aXvn5.auth.FacebookAuthProvider();
        if (type === 'github') return new $aXvn5.auth.GithubAuthProvider();
        if (type === 'google') return new $aXvn5.auth.GoogleAuthProvider();
        if (type === 'twitter') return new $aXvn5.auth.TwitterAuthProvider();
    }
    updateProfile(displayName, photoURL) {
        return this.getUserRef().pipe((0, $iuXHq.switchMap)((res)=>res.updateProfile({
                displayName: displayName,
                photoURL: photoURL
            })));
    }
}
$826c8712b87c022a$export$2ad3502e5d69a818 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)({
        init: true
    })
], $826c8712b87c022a$export$2ad3502e5d69a818);

});
parcelRegister("36siL", function(module, exports) {

$parcel$export(module.exports, "throwError", () => $2427e2bc0c48b89d$export$8bf7aba4a9e09055);

var $82Kdl = parcelRequire("82Kdl");

var $1hO6f = parcelRequire("1hO6f");
function $2427e2bc0c48b89d$export$8bf7aba4a9e09055(errorOrErrorFactory, scheduler) {
    var errorFactory = (0, $1hO6f.isFunction)(errorOrErrorFactory) ? errorOrErrorFactory : function() {
        return errorOrErrorFactory;
    };
    var init = function(subscriber) {
        return subscriber.error(errorFactory());
    };
    return new (0, $82Kdl.Observable)(scheduler ? function(subscriber) {
        return scheduler.schedule(init, 0, subscriber);
    } : init);
}

});

parcelRegister("3abYj", function(module, exports) {

$parcel$export(module.exports, "catchError", () => $24db97985a733aca$export$3dede90624df3ba9);

var $9IWtL = parcelRequire("9IWtL");

var $fyrlr = parcelRequire("fyrlr");

var $4J4s9 = parcelRequire("4J4s9");
function $24db97985a733aca$export$3dede90624df3ba9(selector) {
    return (0, $4J4s9.operate)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $9IWtL.innerFrom)(selector(err, $24db97985a733aca$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}

});

parcelRegister("37rZb", function(module, exports) {

$parcel$export(module.exports, "tap", () => $2457bbf2717f46d9$export$3f23594af5f37336);

var $1hO6f = parcelRequire("1hO6f");

var $4J4s9 = parcelRequire("4J4s9");

var $fyrlr = parcelRequire("fyrlr");

var $4YhJE = parcelRequire("4YhJE");
function $2457bbf2717f46d9$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $1hO6f.isFunction)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $4J4s9.operate)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $4YhJE.identity);
}

});




parcelRegister("23prF", function(module, exports) {

/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */ /* global define */ (function(define1) {
    define1([
        'jquery'
    ], function($) {
        return function() {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };
            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.4',
                warning: warning
            };
            var previousToast;
            return toastr;
            ////////////////
            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }
            function getContainer(options, create) {
                if (!options) options = getOptions();
                $container = $('#' + options.containerId);
                if ($container.length) return $container;
                if (create) $container = createContainer(options);
                return $container;
            }
            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }
            function subscribe(callback) {
                listener = callback;
            }
            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }
            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }
            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) getContainer(options);
                if (!clearToast($toastElement, options, clearOptions)) clearContainer(options);
            }
            function remove($toastElement) {
                var options = getOptions();
                if (!$container) getContainer(options);
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) $container.remove();
            }
            // internal functions
            function clearContainer(options) {
                var toastsToClear = $container.children();
                for(var i = toastsToClear.length - 1; i >= 0; i--)clearToast($(toastsToClear[i]), options);
            }
            function clearToast($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function() {
                            removeToast($toastElement);
                        }
                    });
                    return true;
                }
                return false;
            }
            function createContainer(options) {
                $container = $('<div/>').attr('id', options.containerId).addClass(options.positionClass);
                $container.appendTo($(options.target));
                return $container;
            }
            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,
                    showMethod: 'fadeIn',
                    showDuration: 300,
                    showEasing: 'swing',
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,
                    closeMethod: false,
                    closeDuration: false,
                    closeEasing: false,
                    closeOnHover: true,
                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000,
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    escapeHtml: false,
                    target: 'body',
                    closeHtml: '<button type="button">&times;</button>',
                    closeClass: 'toast-close-button',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false,
                    progressClass: 'toast-progress',
                    rtl: false
                };
            }
            function publish(args) {
                if (!listener) return;
                listener(args);
            }
            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;
                if (typeof map.optionsOverride !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }
                if (shouldExit(options, map)) return;
                toastId++;
                $container = getContainer(options, true);
                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };
                personalizeToast();
                displayToast();
                handleEvents();
                publish(response);
                if (options.debug && console) console.log(response);
                return $toastElement;
                function escapeHtml(source) {
                    if (source == null) source = '';
                    return source.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                }
                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setRTL();
                    setSequence();
                    setAria();
                }
                function setAria() {
                    var ariaValue = '';
                    switch(map.iconClass){
                        case 'toast-success':
                        case 'toast-info':
                            ariaValue = 'polite';
                            break;
                        default:
                            ariaValue = 'assertive';
                    }
                    $toastElement.attr('aria-live', ariaValue);
                }
                function handleEvents() {
                    if (options.closeOnHover) $toastElement.hover(stickAround, delayedHideToast);
                    if (!options.onclick && options.tapToDismiss) $toastElement.click(hideToast);
                    if (options.closeButton && $closeElement) $closeElement.click(function(event) {
                        if (event.stopPropagation) event.stopPropagation();
                        else if (event.cancelBubble !== undefined && event.cancelBubble !== true) event.cancelBubble = true;
                        if (options.onCloseClick) options.onCloseClick(event);
                        hideToast(true);
                    });
                    if (options.onclick) $toastElement.click(function(event) {
                        options.onclick(event);
                        hideToast();
                    });
                }
                function displayToast() {
                    $toastElement.hide();
                    $toastElement[options.showMethod]({
                        duration: options.showDuration,
                        easing: options.showEasing,
                        complete: options.onShown
                    });
                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) progressBar.intervalId = setInterval(updateProgress, 10);
                    }
                }
                function setIcon() {
                    if (map.iconClass) $toastElement.addClass(options.toastClass).addClass(iconClass);
                }
                function setSequence() {
                    if (options.newestOnTop) $container.prepend($toastElement);
                    else $container.append($toastElement);
                }
                function setTitle() {
                    if (map.title) {
                        var suffix = map.title;
                        if (options.escapeHtml) suffix = escapeHtml(map.title);
                        $titleElement.append(suffix).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }
                function setMessage() {
                    if (map.message) {
                        var suffix = map.message;
                        if (options.escapeHtml) suffix = escapeHtml(map.message);
                        $messageElement.append(suffix).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }
                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass(options.closeClass).attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }
                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass(options.progressClass);
                        $toastElement.prepend($progressElement);
                    }
                }
                function setRTL() {
                    if (options.rtl) $toastElement.addClass('rtl');
                }
                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) return true;
                        else previousToast = map.message;
                    }
                    return false;
                }
                function hideToast(override) {
                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
                    var duration = override && options.closeDuration !== false ? options.closeDuration : options.hideDuration;
                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
                    if ($(':focus', $toastElement).length && !override) return;
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[method]({
                        duration: duration,
                        easing: easing,
                        complete: function() {
                            removeToast($toastElement);
                            clearTimeout(intervalId);
                            if (options.onHidden && response.state !== 'hidden') options.onHidden();
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }
                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }
                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod]({
                        duration: options.showDuration,
                        easing: options.showEasing
                    });
                }
                function updateProgress() {
                    var percentage = (progressBar.hideEta - new Date().getTime()) / progressBar.maxHideTime * 100;
                    $progressElement.width(percentage + '%');
                }
            }
            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }
            function removeToast($toastElement) {
                if (!$container) $container = getContainer();
                if ($toastElement.is(':visible')) return;
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }
        }();
    });
})(typeof define === 'function' && define.amd ? define : function(deps, factory) {
    if (module.exports) module.exports = factory((parcelRequire("gDMly")));
    else window.toastr = factory(window.jQuery);
});

});
parcelRegister("gDMly", function(module, exports) {
/*!
 * jQuery JavaScript Library v4.0.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.com/license/
 *
 * Date: 2026-01-18T00:20Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    module.exports = factory(global, true);
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    "use strict";
    if (!window1.document) throw new Error("jQuery requires a window with a document");
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    // Support: IE 11+
    // IE doesn't have Array#flat; provide a fallback.
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    // [[Class]] -> type pairs
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    // All support tests are defined in their respective modules.
    var support = {};
    function toType(obj) {
        if (obj == null) return obj + "";
        return typeof obj === "object" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    function isWindow(obj) {
        return obj != null && obj === obj.window;
    }
    function isArrayLike(obj) {
        var length = !!obj && obj.length, type = toType(obj);
        if (typeof obj === "function" || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var document$1 = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document$1;
        var i, script = doc.createElement("script");
        script.text = code;
        for(i in preservedScriptAttributes)if (node && node[i]) script[i] = node[i];
        if (doc.head.appendChild(script).parentNode) script.parentNode.removeChild(script);
    }
    var version = "4.0.0", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        }
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && typeof target !== "function") target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Note: an element does not contain itself
        contains: function(a, b) {
            var bup = b && b.parentNode;
            return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
            // IE doesn't have `contains` on SVG.
            (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
        },
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    // https://www.w3.org/TR/css3-selectors/#whitespace
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var isIE = document$1.documentMode;
    var rbuggyQSA = isIE && new RegExp(// Support: IE 9 - 11+
    // IE's :disabled selector does not pick up the children of disabled fieldsets
    ":enabled|:disabled|\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
    var identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+";
    var rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*");
    var rdescend = new RegExp(whitespace + "|>");
    var rsibling = /[+~]/;
    var documentElement$1 = document$1.documentElement;
    // Support: IE 9 - 11+
    // IE requires a prefix.
    var matches = documentElement$1.matches || documentElement$1.msMatchesSelector;
    /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
        var keys = [];
        function cache(key, value) {
            // Use (key + " ") to avoid collision with native prototype properties
            // (see https://github.com/jquery/sizzle/issues/157)
            if (keys.push(key + " ") > jQuery.expr.cacheLength) // Only keep the most recent entries
            delete cache[keys.shift()];
            return cache[key + " "] = value;
        }
        return cache;
    }
    /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
        return context && typeof context.getElementsByTagName !== "undefined" && context;
    }
    // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
    var attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
    "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]";
    var pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
    // 1. quoted (capture 3; capture 4 or capture 5)
    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
    ".*" + ")\\)|)";
    var filterMatchExpr = {
        ID: new RegExp("^#(" + identifier + ")"),
        CLASS: new RegExp("^\\.(" + identifier + ")"),
        TAG: new RegExp("^(" + identifier + "|[*])"),
        ATTR: new RegExp("^" + attributes),
        PSEUDO: new RegExp("^" + pseudos),
        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i")
    };
    var rpseudo = new RegExp(pseudos);
    // CSS escapes
    // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
    var runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
        var high = "0x" + escape.slice(1) - 0x10000;
        if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
        return nonHex;
        // Replace a hexadecimal escape sequence with the encoded Unicode code point
        // Support: IE <=11+
        // For values outside the Basic Multilingual Plane (BMP), manually construct a
        // surrogate pair
        return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
    };
    function unescapeSelector(sel) {
        return sel.replace(runescape, funescape);
    }
    function selectorError(msg) {
        jQuery.error("Syntax error, unrecognized expression: " + msg);
    }
    var rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*");
    var tokenCache = createCache();
    function tokenize(selector, parseOnly) {
        var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
        if (cached) return parseOnly ? 0 : cached.slice(0);
        soFar = selector;
        groups = [];
        preFilters = jQuery.expr.preFilter;
        while(soFar){
            // Comma and first run
            if (!matched || (match = rcomma.exec(soFar))) {
                if (match) // Don't consume trailing commas as valid
                soFar = soFar.slice(match[0].length) || soFar;
                groups.push(tokens = []);
            }
            matched = false;
            // Combinators
            if (match = rleadingCombinator.exec(soFar)) {
                matched = match.shift();
                tokens.push({
                    value: matched,
                    // Cast descendant combinators to space
                    type: match[0].replace(rtrimCSS, " ")
                });
                soFar = soFar.slice(matched.length);
            }
            // Filters
            for(type in filterMatchExpr)if ((match = jQuery.expr.match[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                matched = match.shift();
                tokens.push({
                    value: matched,
                    type: type,
                    matches: match
                });
                soFar = soFar.slice(matched.length);
            }
            if (!matched) break;
        }
        // Return the length of the invalid excess
        // if we're just parsing
        // Otherwise, throw an error or return tokens
        if (parseOnly) return soFar.length;
        return soFar ? selectorError(selector) : // Cache the tokens
        tokenCache(selector, groups).slice(0);
    }
    var preFilter = {
        ATTR: function(match) {
            match[1] = unescapeSelector(match[1]);
            // Move the given value to match[3] whether quoted or unquoted
            match[3] = unescapeSelector(match[3] || match[4] || match[5] || "");
            if (match[2] === "~=") match[3] = " " + match[3] + " ";
            return match.slice(0, 4);
        },
        CHILD: function(match) {
            /* matches from filterMatchExpr["CHILD"]
			1 type (only|nth|...)
			2 what (child|of-type)
			3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
			4 xn-component of xn+y argument ([+-]?\d*n|)
			5 sign of xn-component
			6 x of xn-component
			7 sign of y-component
			8 y of y-component
		*/ match[1] = match[1].toLowerCase();
            if (match[1].slice(0, 3) === "nth") {
                // nth-* requires argument
                if (!match[3]) selectorError(match[0]);
                // numeric x and y parameters for jQuery.expr.filter.CHILD
                // remember that false/true cast respectively to 0/1
                match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                match[5] = +(match[7] + match[8] || match[3] === "odd");
            // other types prohibit arguments
            } else if (match[3]) selectorError(match[0]);
            return match;
        },
        PSEUDO: function(match) {
            var excess, unquoted = !match[6] && match[2];
            if (filterMatchExpr.CHILD.test(match[0])) return null;
            // Accept quoted arguments as-is
            if (match[3]) match[2] = match[4] || match[5] || "";
            else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
            (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
            (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                // excess is a negative index
                match[0] = match[0].slice(0, excess);
                match[2] = unquoted.slice(0, excess);
            }
            // Return only captures needed by the pseudo filter method (type and argument)
            return match.slice(0, 3);
        }
    };
    function toSelector(tokens) {
        var i = 0, len = tokens.length, selector = "";
        for(; i < len; i++)selector += tokens[i].value;
        return selector;
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    function access(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (typeof value !== "function") raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    }
    // Only count HTML whitespace
    // Other whitespace should count in values
    // https://infra.spec.whatwg.org/#ascii-whitespace
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()];
            if (value !== undefined) {
                if (value === null || // For compat with previous handling of boolean attributes,
                // remove when `false` passed. For ARIA attributes -
                // many of which recognize a `"false"` value - continue to
                // set the `"false"` value as jQuery <4 did.
                value === false && name.toLowerCase().indexOf("aria-") !== 0) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value);
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = elem.getAttribute(name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {},
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Support: IE <=11+
    // An input loses its value after becoming a radio
    if (isIE) jQuery.attrHooks.type = {
        set: function(elem, value) {
            if (value === "radio" && nodeName(elem, "input")) {
                var val = elem.value;
                elem.setAttribute("type", value);
                if (val) elem.value = val;
                return value;
            }
        }
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var sort = arr.sort;
    var splice = arr.splice;
    var hasDuplicate;
    // Document order sorting
    function sortOrder(a, b) {
        // Flag for duplicate removal
        if (a === b) {
            hasDuplicate = true;
            return 0;
        }
        // Sort on method existence if only one input has compareDocumentPosition
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if (compare) return compare;
        // Calculate position if both inputs belong to the same document
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
        1;
        // Disconnected nodes
        if (compare & 1) {
            // Choose the first element that is related to the document
            // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (a == document$1 || a.ownerDocument == document$1 && jQuery.contains(document$1, a)) return -1;
            // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (b == document$1 || b.ownerDocument == document$1 && jQuery.contains(document$1, b)) return 1;
            // Maintain original order
            return 0;
        }
        return compare & 4 ? -1 : 1;
    }
    /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
        var elem, duplicates = [], j = 0, i = 0;
        hasDuplicate = false;
        sort.call(results, sortOrder);
        if (hasDuplicate) {
            while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
            while(j--)splice.call(results, duplicates[j], 1);
        }
        return results;
    };
    jQuery.fn.uniqueSort = function() {
        return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
    };
    var i, outermostContext, // Local document vars
    document, documentElement, documentIsHTML, // Instance-specific data
    dirruns = 0, done = 0, classCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), // Regular expressions
    // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
    rwhitespace = new RegExp(whitespace + "+", "g"), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = jQuery.extend({
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
    }, filterMatchExpr), rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
    rquickExpr$1 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, // Used for iframes; see `setDocument`.
    // Support: IE 9 - 11+
    // Removing the function wrapper causes a "Permission Denied"
    // error in IE.
    unloadHandler = function() {
        setDocument();
    }, inDisabledFieldset = addCombinator(function(elem) {
        return elem.disabled === true && nodeName(elem, "fieldset");
    }, {
        dir: "parentNode",
        next: "legend"
    });
    function find(selector, context, results, seed) {
        var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
        nodeType = context ? context.nodeType : 9;
        results = results || [];
        // Return early from calls with invalid selector or context
        if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
        // Try to shortcut find operations (as opposed to filters) in HTML documents
        if (!seed) {
            setDocument(context);
            context = context || document;
            if (documentIsHTML) {
                // If the selector is sufficiently simple, try using a "get*By*" DOM method
                // (excepting DocumentFragment context, where the methods don't exist)
                if (nodeType !== 11 && (match = rquickExpr$1.exec(selector))) {
                    // ID selector
                    if (m = match[1]) {
                        // Document context
                        if (nodeType === 9) {
                            if (elem = context.getElementById(m)) push.call(results, elem);
                            return results;
                        // Element context
                        } else if (newContext && (elem = newContext.getElementById(m)) && jQuery.contains(context, elem)) {
                            push.call(results, elem);
                            return results;
                        }
                    // Type selector
                    } else if (match[2]) {
                        push.apply(results, context.getElementsByTagName(selector));
                        return results;
                    // Class selector
                    } else if ((m = match[3]) && context.getElementsByClassName) {
                        push.apply(results, context.getElementsByClassName(m));
                        return results;
                    }
                }
                // Take advantage of querySelectorAll
                if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                    newSelector = selector;
                    newContext = context;
                    // qSA considers elements outside a scoping root when evaluating child or
                    // descendant combinators, which is not what we want.
                    // In such cases, we work around the behavior by prefixing every selector in the
                    // list with an ID selector referencing the scope context.
                    // The technique has to be used as well when a leading combinator is used
                    // as such selectors are not recognized by querySelectorAll.
                    // Thanks to Andrew Dupont for this technique.
                    if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                        // Expand context for sibling selectors
                        newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                        // Outside of IE, if we're not changing the context we can
                        // use :scope instead of an ID.
                        // Support: IE 11+
                        // IE sometimes throws a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (newContext != context || isIE) {
                            // Capture the context ID, setting it first if necessary
                            if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                            else context.setAttribute("id", nid = jQuery.expando);
                        }
                        // Prefix every selector in the list
                        groups = tokenize(selector);
                        i = groups.length;
                        while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                        newSelector = groups.join(",");
                    }
                    try {
                        push.apply(results, newContext.querySelectorAll(newSelector));
                        return results;
                    } catch (qsaError) {
                        nonnativeSelectorCache(selector, true);
                    } finally{
                        if (nid === jQuery.expando) context.removeAttribute("id");
                    }
                }
            }
        }
        // All others
        return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
    }
    /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
        fn[jQuery.expando] = true;
        return fn;
    }
    /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
        return function(elem) {
            return nodeName(elem, "input") && elem.type === type;
        };
    }
    /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
        return function(elem) {
            return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
        };
    }
    /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
        // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
        return function(elem) {
            // Only certain elements can match :enabled or :disabled
            // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
            // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
            if ("form" in elem) {
                // Check for inherited disabledness on relevant non-disabled elements:
                // * listed form-associated elements in a disabled fieldset
                //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                // * option elements in a disabled optgroup
                //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                // All such elements have a "form" property.
                if (elem.parentNode && elem.disabled === false) {
                    // Option elements defer to a parent optgroup if present
                    if ("label" in elem) {
                        if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                        else return elem.disabled === disabled;
                    }
                    // Support: IE 6 - 11+
                    // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                    return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                    elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                }
                return elem.disabled === disabled;
            // Try to winnow out elements that can't be disabled before trusting the disabled property.
            // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
            // even exist on them, let alone have a boolean value.
            } else if ("label" in elem) return elem.disabled === disabled;
            // Remaining elements are neither :enabled nor :disabled
            return false;
        };
    }
    /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
        return markFunction(function(argument) {
            argument = +argument;
            return markFunction(function(seed, matches) {
                var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                // Match elements found at the specified indexes
                while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
            });
        });
    }
    /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 */ function setDocument(node) {
        var subWindow, doc = node ? node.ownerDocument || node : document$1;
        // Return early if doc is invalid or already selected
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (doc == document || doc.nodeType !== 9) return;
        // Update global variables
        document = doc;
        documentElement = document.documentElement;
        documentIsHTML = !jQuery.isXMLDoc(document);
        // Support: IE 9 - 11+
        // Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (isIE && document$1 != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) subWindow.addEventListener("unload", unloadHandler);
    }
    find.matches = function(expr, elements) {
        return find(expr, null, null, elements);
    };
    find.matchesSelector = function(elem, expr) {
        setDocument(elem);
        if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
            return matches.call(elem, expr);
        } catch (e) {
            nonnativeSelectorCache(expr, true);
        }
        return find(expr, document, null, [
            elem
        ]).length > 0;
    };
    jQuery.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: markFunction,
        match: matchExpr,
        find: {
            ID: function(id, context) {
                if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                    var elem = context.getElementById(id);
                    return elem ? [
                        elem
                    ] : [];
                }
            },
            TAG: function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            },
            CLASS: function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            }
        },
        relative: {
            ">": {
                dir: "parentNode",
                first: true
            },
            " ": {
                dir: "parentNode"
            },
            "+": {
                dir: "previousSibling",
                first: true
            },
            "~": {
                dir: "previousSibling"
            }
        },
        preFilter: preFilter,
        filter: {
            ID: function(id) {
                var attrId = unescapeSelector(id);
                return function(elem) {
                    return elem.getAttribute("id") === attrId;
                };
            },
            TAG: function(nodeNameSelector) {
                var expectedNodeName = unescapeSelector(nodeNameSelector).toLowerCase();
                return nodeNameSelector === "*" ? function() {
                    return true;
                } : function(elem) {
                    return nodeName(elem, expectedNodeName);
                };
            },
            CLASS: function(className) {
                var pattern = classCache[className + " "];
                return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                    return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                }));
            },
            ATTR: function(name, operator, check) {
                return function(elem) {
                    var result = jQuery.attr(elem, name);
                    if (result == null) return operator === "!=";
                    if (!operator) return true;
                    result += "";
                    if (operator === "=") return result === check;
                    if (operator === "!=") return result !== check;
                    if (operator === "^=") return check && result.indexOf(check) === 0;
                    if (operator === "*=") return check && result.indexOf(check) > -1;
                    if (operator === "$=") return check && result.slice(-check.length) === check;
                    if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                    if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                    return false;
                };
            },
            CHILD: function(type, what, _argument, first, last) {
                var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                function(elem) {
                    return !!elem.parentNode;
                } : function(elem, _context, xml) {
                    var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                    if (parent) {
                        // :(first|last|only)-(child|of-type)
                        if (simple) {
                            while(dir){
                                node = elem;
                                while(node = node[dir]){
                                    if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                }
                                // Reverse direction for :only-* (if we haven't yet done so)
                                start = dir = type === "only" && !start && "nextSibling";
                            }
                            return true;
                        }
                        start = [
                            forward ? parent.firstChild : parent.lastChild
                        ];
                        // non-xml :nth-child(...) stores cache data on `parent`
                        if (forward && useCache) {
                            // Seek `elem` from a previously-cached index
                            outerCache = parent[jQuery.expando] || (parent[jQuery.expando] = {});
                            cache = outerCache[type] || [];
                            nodeIndex = cache[0] === dirruns && cache[1];
                            diff = nodeIndex && cache[2];
                            node = nodeIndex && parent.childNodes[nodeIndex];
                            while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                            (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                            if (node.nodeType === 1 && ++diff && node === elem) {
                                outerCache[type] = [
                                    dirruns,
                                    nodeIndex,
                                    diff
                                ];
                                break;
                            }
                        } else {
                            // Use previously-cached element index if available
                            if (useCache) {
                                outerCache = elem[jQuery.expando] || (elem[jQuery.expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex;
                            }
                            // xml :nth-child(...)
                            // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                            if (diff === false) {
                                // Use the same loop as above to seek `elem` from the start
                                while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                    // Cache the index of each encountered element
                                    if (useCache) {
                                        outerCache = node[jQuery.expando] || (node[jQuery.expando] = {});
                                        outerCache[type] = [
                                            dirruns,
                                            diff
                                        ];
                                    }
                                    if (node === elem) break;
                                }
                            }
                        }
                        // Incorporate the offset, then check against cycle size
                        diff -= last;
                        return diff === first || diff % first === 0 && diff / first >= 0;
                    }
                };
            },
            PSEUDO: function(pseudo, argument) {
                // pseudo-class names are case-insensitive
                // https://www.w3.org/TR/selectors/#pseudo-classes
                // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                // Remember that setFilters inherits from pseudos
                var fn = jQuery.expr.pseudos[pseudo] || jQuery.expr.setFilters[pseudo.toLowerCase()] || selectorError("unsupported pseudo: " + pseudo);
                // The user may use createPseudo to indicate that
                // arguments are needed to create the filter function
                // just as jQuery does
                if (fn[jQuery.expando]) return fn(argument);
                return fn;
            }
        },
        pseudos: {
            // Potentially complex pseudos
            not: markFunction(function(selector) {
                // Trim the selector passed to compile
                // to avoid treating leading and trailing
                // spaces as combinators
                var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                return matcher[jQuery.expando] ? markFunction(function(seed, matches, _context, xml) {
                    var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                    // Match elements unmatched by `matcher`
                    while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                }) : function(elem, _context, xml) {
                    input[0] = elem;
                    matcher(input, null, xml, results);
                    // Don't keep the element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    input[0] = null;
                    return !results.pop();
                };
            }),
            has: markFunction(function(selector) {
                return function(elem) {
                    return find(selector, elem).length > 0;
                };
            }),
            contains: markFunction(function(text) {
                text = unescapeSelector(text);
                return function(elem) {
                    return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                };
            }),
            // "Whether an element is represented by a :lang() selector
            // is based solely on the element's language value
            // being equal to the identifier C,
            // or beginning with the identifier C immediately followed by "-".
            // The matching of C against the element's language value is performed case-insensitively.
            // The identifier C does not have to be a valid language name."
            // https://www.w3.org/TR/selectors/#lang-pseudo
            lang: markFunction(function(lang) {
                // lang value must be a valid identifier
                if (!ridentifier.test(lang || "")) selectorError("unsupported lang: " + lang);
                lang = unescapeSelector(lang).toLowerCase();
                return function(elem) {
                    var elemLang;
                    do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                        elemLang = elemLang.toLowerCase();
                        return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                    }
                    while ((elem = elem.parentNode) && elem.nodeType === 1);
                    return false;
                };
            }),
            // Miscellaneous
            target: function(elem) {
                var hash = window1.location && window1.location.hash;
                return hash && hash.slice(1) === elem.id;
            },
            root: function(elem) {
                return elem === documentElement;
            },
            focus: function(elem) {
                return elem === document.activeElement && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
            },
            // Boolean properties
            enabled: createDisabledPseudo(false),
            disabled: createDisabledPseudo(true),
            checked: function(elem) {
                // In CSS3, :checked should return both checked and selected elements
                // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
            },
            selected: function(elem) {
                // Support: IE <=11+
                // Accessing the selectedIndex property
                // forces the browser to treat the default option as
                // selected when in an optgroup.
                if (isIE && elem.parentNode) // eslint-disable-next-line no-unused-expressions
                elem.parentNode.selectedIndex;
                return elem.selected === true;
            },
            // Contents
            empty: function(elem) {
                // https://www.w3.org/TR/selectors/#empty-pseudo
                // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                //   but not by others (comment: 8; processing instruction: 7; etc.)
                // nodeType < 6 works because attributes (2) do not appear as children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                    if (elem.nodeType < 6) return false;
                }
                return true;
            },
            parent: function(elem) {
                return !jQuery.expr.pseudos.empty(elem);
            },
            // Element/input types
            header: function(elem) {
                return rheader.test(elem.nodeName);
            },
            input: function(elem) {
                return rinputs.test(elem.nodeName);
            },
            button: function(elem) {
                return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
            },
            text: function(elem) {
                return nodeName(elem, "input") && elem.type === "text";
            },
            // Position-in-collection
            first: createPositionalPseudo(function() {
                return [
                    0
                ];
            }),
            last: createPositionalPseudo(function(_matchIndexes, length) {
                return [
                    length - 1
                ];
            }),
            eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                return [
                    argument < 0 ? argument + length : argument
                ];
            }),
            even: createPositionalPseudo(function(matchIndexes, length) {
                var i = 0;
                for(; i < length; i += 2)matchIndexes.push(i);
                return matchIndexes;
            }),
            odd: createPositionalPseudo(function(matchIndexes, length) {
                var i = 1;
                for(; i < length; i += 2)matchIndexes.push(i);
                return matchIndexes;
            }),
            lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i;
                if (argument < 0) i = argument + length;
                else if (argument > length) i = length;
                else i = argument;
                for(; --i >= 0;)matchIndexes.push(i);
                return matchIndexes;
            }),
            gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i = argument < 0 ? argument + length : argument;
                for(; ++i < length;)matchIndexes.push(i);
                return matchIndexes;
            })
        }
    };
    jQuery.expr.pseudos.nth = jQuery.expr.pseudos.eq;
    // Add button/input type pseudos
    for(i in {
        radio: true,
        checkbox: true,
        file: true,
        password: true,
        image: true
    })jQuery.expr.pseudos[i] = createInputPseudo(i);
    for(i in {
        submit: true,
        reset: true
    })jQuery.expr.pseudos[i] = createButtonPseudo(i);
    // Easy API for creating new setFilters
    function setFilters() {}
    setFilters.prototype = jQuery.expr.pseudos;
    jQuery.expr.setFilters = new setFilters();
    function addCombinator(matcher, combinator, base) {
        var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
        return combinator.first ? // Check against closest ancestor/preceding element
        function(elem, context, xml) {
            while(elem = elem[dir]){
                if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
            }
            return false;
        } : // Check against all ancestor/preceding elements
        function(elem, context, xml) {
            var oldCache, outerCache, newCache = [
                dirruns,
                doneName
            ];
            // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
            if (xml) {
                while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                    if (matcher(elem, context, xml)) return true;
                }
            } else {
                while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                    outerCache = elem[jQuery.expando] || (elem[jQuery.expando] = {});
                    if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                    else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                    return newCache[2] = oldCache[2];
                    else {
                        // Reuse newcache so results back-propagate to previous elements
                        outerCache[key] = newCache;
                        // A match means we're done; a fail means we have to keep checking
                        if (newCache[2] = matcher(elem, context, xml)) return true;
                    }
                }
            }
            return false;
        };
    }
    function elementMatcher(matchers) {
        return matchers.length > 1 ? function(elem, context, xml) {
            var i = matchers.length;
            while(i--){
                if (!matchers[i](elem, context, xml)) return false;
            }
            return true;
        } : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
        var i = 0, len = contexts.length;
        for(; i < len; i++)find(selector, contexts[i], results);
        return results;
    }
    function condense(unmatched, map, filter, context, xml) {
        var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
        for(; i < len; i++){
            if (elem = unmatched[i]) {
                if (!filter || filter(elem, context, xml)) {
                    newUnmatched.push(elem);
                    if (mapped) map.push(i);
                }
            }
        }
        return newUnmatched;
    }
    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
        if (postFilter && !postFilter[jQuery.expando]) postFilter = setMatcher(postFilter);
        if (postFinder && !postFinder[jQuery.expando]) postFinder = setMatcher(postFinder, postSelector);
        return markFunction(function(seed, results, context, xml) {
            var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
            elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                context
            ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
            matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
            if (matcher) {
                // If we have a postFinder, or filtered seed, or non-seed postFilter
                // or preexisting results,
                matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results;
                // Find primary matches
                matcher(matcherIn, matcherOut, context, xml);
            } else matcherOut = matcherIn;
            // Apply postFilter
            if (postFilter) {
                temp = condense(matcherOut, postMap);
                postFilter(temp, [], context, xml);
                // Un-match failing elements by moving them back to matcherIn
                i = temp.length;
                while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
            if (seed) {
                if (postFinder || preFilter) {
                    if (postFinder) {
                        // Get the final matcherOut by condensing this intermediate into postFinder contexts
                        temp = [];
                        i = matcherOut.length;
                        while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                        temp.push(matcherIn[i] = elem);
                        postFinder(null, matcherOut = [], temp, xml);
                    }
                    // Move matched elements from seed to results to keep them synchronized
                    i = matcherOut.length;
                    while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                }
            } else {
                matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                if (postFinder) postFinder(null, results, matcherOut, xml);
                else push.apply(results, matcherOut);
            }
        });
    }
    function matcherFromTokens(tokens) {
        var checkContext, matcher, j, len = tokens.length, leadingRelative = jQuery.expr.relative[tokens[0].type], implicitRelative = leadingRelative || jQuery.expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
        matchContext = addCombinator(function(elem) {
            return elem === checkContext;
        }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
            return indexOf.call(checkContext, elem) > -1;
        }, implicitRelative, true), matchers = [
            function(elem, context, xml) {
                // Support: IE 11+
                // IE sometimes throws a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                // Avoid hanging onto element
                // (see https://github.com/jquery/sizzle/issues/299)
                checkContext = null;
                return ret;
            }
        ];
        for(; i < len; i++)if (matcher = jQuery.expr.relative[tokens[i].type]) matchers = [
            addCombinator(elementMatcher(matchers), matcher)
        ];
        else {
            matcher = jQuery.expr.filter[tokens[i].type].apply(null, tokens[i].matches);
            // Return special upon seeing a positional matcher
            if (matcher[jQuery.expando]) {
                // Find the next relative operator (if any) for proper handling
                j = ++i;
                for(; j < len; j++){
                    if (jQuery.expr.relative[tokens[j].type]) break;
                }
                return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                tokens.slice(0, i - 1).concat({
                    value: tokens[i - 2].type === " " ? "*" : ""
                })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
            }
            matchers.push(matcher);
        }
        return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
        var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
            var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
            elems = seed || byElement && jQuery.expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
            dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1;
            if (outermost) // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            outermostContext = context == document || context || outermost;
            // Add elements passing elementMatchers directly to results
            for(; (elem = elems[i]) != null; i++){
                if (byElement && elem) {
                    j = 0;
                    // Support: IE 11+
                    // IE sometimes throws a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (!context && elem.ownerDocument != document) {
                        setDocument(elem);
                        xml = !documentIsHTML;
                    }
                    while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                        push.call(results, elem);
                        break;
                    }
                    if (outermost) dirruns = dirrunsUnique;
                }
                // Track unmatched elements for set filters
                if (bySet) {
                    // They will have gone through all possible matchers
                    if (elem = !matcher && elem) matchedCount--;
                    // Lengthen the array for every element, matched or not
                    if (seed) unmatched.push(elem);
                }
            }
            // `i` is now the count of elements visited above, and adding it to `matchedCount`
            // makes the latter nonnegative.
            matchedCount += i;
            // Apply set filters to unmatched elements
            // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
            // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
            // no element matchers and no seed.
            // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
            // case, which will result in a "00" `matchedCount` that differs from `i` but is also
            // numerically zero.
            if (bySet && i !== matchedCount) {
                j = 0;
                while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                if (seed) {
                    // Reintegrate element matches to eliminate the need for sorting
                    if (matchedCount > 0) {
                        while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                    }
                    // Discard index placeholder values to get only actual matches
                    setMatched = condense(setMatched);
                }
                // Add matches to results
                push.apply(results, setMatched);
                // Seedless set matches succeeding multiple successful matchers stipulate sorting
                if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
            }
            // Override manipulation of globals by nested matchers
            if (outermost) {
                dirruns = dirrunsUnique;
                outermostContext = contextBackup;
            }
            return unmatched;
        };
        return bySet ? markFunction(superMatcher) : superMatcher;
    }
    function compile(selector, match /* Internal Use Only */ ) {
        var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
        if (!cached) {
            // Generate a function of recursive functions that can be used to check each element
            if (!match) match = tokenize(selector);
            i = match.length;
            while(i--){
                cached = matcherFromTokens(match[i]);
                if (cached[jQuery.expando]) setMatchers.push(cached);
                else elementMatchers.push(cached);
            }
            // Cache the compiled function
            cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
            // Save selector and tokenization
            cached.selector = selector;
        }
        return cached;
    }
    /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
        var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
        results = results || [];
        // Try to minimize operations if there is only one selector in the list and no seed
        // (the latter of which guarantees us context)
        if (match.length === 1) {
            // Reduce context if the leading compound selector is an ID
            tokens = match[0] = match[0].slice(0);
            if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && jQuery.expr.relative[tokens[1].type]) {
                context = (jQuery.expr.find.ID(unescapeSelector(token.matches[0]), context) || [])[0];
                if (!context) return results;
                else if (compiled) context = context.parentNode;
                selector = selector.slice(tokens.shift().value.length);
            }
            // Fetch a seed set for right-to-left matching
            i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
            while(i--){
                token = tokens[i];
                // Abort if we hit a combinator
                if (jQuery.expr.relative[type = token.type]) break;
                if (find = jQuery.expr.find[type]) // Search, expanding context for leading sibling combinators
                {
                    if (seed = find(unescapeSelector(token.matches[0]), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                        // If seed is empty or no tokens remain, we can return early
                        tokens.splice(i, 1);
                        selector = seed.length && toSelector(tokens);
                        if (!selector) {
                            push.apply(results, seed);
                            return results;
                        }
                        break;
                    }
                }
            }
        }
        // Compile and execute a filtering function if one is not provided
        // Provide `match` to avoid retokenization if we modified the selector above
        (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
        return results;
    }
    // Initialize against the default document
    setDocument();
    jQuery.find = find;
    // These have always been private, but they used to be documented as part of
    // Sizzle so let's maintain them for now for backwards compatibility purposes.
    find.compile = compile;
    find.select = select;
    find.setDocument = setDocument;
    find.tokenize = tokenize;
    function dir(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    }
    function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    }
    var rneedsContext = jQuery.expr.match.needsContext;
    // rsingleTag matches a string consisting of a single HTML element with no attributes
    // and captures the element's name
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function isObviousHtml(input) {
        return input[0] === "<" && input[input.length - 1] === ">" && input.length >= 3;
    }
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (typeof qualifier === "function") return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // HANDLE: $(DOMElement)
        if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (typeof selector === "function") return rootjQuery.ready !== undefined ? rootjQuery.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        else {
            // Handle obvious HTML strings
            match = selector + "";
            if (isObviousHtml(match)) // Assume that strings that start and end with <> are HTML and skip
            // the regex check. This also handles browser-supported HTML wrappers
            // like TrustedHTML.
            match = [
                null,
                selector,
                null
            ];
            else if (typeof selector === "string") match = rquickExpr.exec(selector);
            else return jQuery.makeArray(selector, this);
            // Match html or make sure no context is specified for #id
            // Note: match[1] may be a string or a TrustedHTML wrapper
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document$1, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (typeof this[match] === "function") this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document$1.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || rootjQuery).find(selector);
            else return this.constructor(context).find(selector);
        }
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document$1);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11+
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (typeof arg === "function") {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && typeof (method = value.promise) === "function") method.call(value).done(resolve).fail(reject);
            else if (value && typeof (method = value.then) === "function") method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            reject(value);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                catch: function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = typeof fns[tuple[4]] === "function" && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && typeof returned.promise === "function") returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (typeof then === "function") {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, typeof onProgress === "function" ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, typeof onFulfilled === "function" ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, typeof onRejected === "function" ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || typeof (resolveValues[i] && resolveValues[i].then) === "function") return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        if (error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception", error, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document$1, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document$1.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    if (document$1.readyState !== "loading") // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document$1.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Matches dashed string for camelizing
    var rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase
    function camelCase(string) {
        return string.replace(rdashAlpha, fcamelCase);
    }
    /**
 * Determines whether an object can have data
 */ function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    }
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = Object.create(null);
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return value;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45+
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11+
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.set(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.set(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    // isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
    // through the CSS cascade), which is useful in deciding whether or not to make it visible.
    // It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
    // * A hidden ancestor does not force an element to be classified as hidden.
    // * Being disconnected from the document does not force an element to be classified as hidden.
    // These differences improve the behavior of .toggle() et al. when applied to elements that are
    // detached or contained within hidden ancestors (gh-2404, gh-2863).
    function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && jQuery.css(elem, "display") === "none";
    }
    var ralphaStart = /^[a-z]/, // The regex visualized:
    //
    //                         /----------\
    //                        |            |    /-------\
    //                        |  / Top  \  |   |         |
    //         /--- Border ---+-| Right  |-+---+- Width -+---\
    //        |                 | Bottom |                    |
    //        |                  \ Left /                     |
    //        |                                               |
    //        |                              /----------\     |
    //        |          /-------------\    |            |    |- END
    //        |         |               |   |  / Top  \  |    |
    //        |         |  / Margin  \  |   | | Right  | |    |
    //        |---------+-|           |-+---+-| Bottom |-+----|
    //        |            \ Padding /         \ Left /       |
    // BEGIN -|                                               |
    //        |                /---------\                    |
    //        |               |           |                   |
    //        |               |  / Min \  |    / Width  \     |
    //         \--------------+-|       |-+---|          |---/
    //                           \ Max /       \ Height /
    rautoPx = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
    function isAutoPx(prop) {
        // The first test is used to ensure that:
        // 1. The prop starts with a lowercase letter (as we uppercase it for the second regex).
        // 2. The prop is not empty.
        return ralphaStart.test(prop) && rautoPx.test(prop[0].toUpperCase() + prop.slice(1));
    }
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (isAutoPx(prop) ? "px" : ""), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (!isAutoPx(prop) || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54 - 66+
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/;
    // Convert dashed to camelCase, handle vendor prefixes.
    // Used by the css & effects modules.
    // Support: IE <=9 - 11+
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function cssCamelCase(string) {
        return camelCase(string.replace(rmsPrefix, "ms-"));
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+
    // Check attachment across shadow DOM boundaries when possible (gh-3504).
    // Provide a fallback for browsers without Shadow DOM v1 support.
    if (!documentElement$1.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    };
    // rtagName captures the name from the first start tag in a string of HTML
    // https://html.spec.whatwg.org/multipage/syntax.html#tag-open-state
    // https://html.spec.whatwg.org/multipage/syntax.html#tag-name-state
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var wrapMap = {
        // Table parts need to be wrapped with `<table>` or they're
        // stripped to their contents when put in a div.
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do, so we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            "table"
        ],
        col: [
            "colgroup",
            "table"
        ],
        tr: [
            "tbody",
            "table"
        ],
        td: [
            "tr",
            "tbody",
            "table"
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    function getAll(context, tag) {
        // Support: IE <=9 - 11+
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") // Use slice to snapshot the live collection from gEBTN
        ret = arr.slice.call(context.getElementsByTagName(tag || "*"));
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object" && (elem.nodeType || isArrayLike(elem))) jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || arr;
                    // Create wrappers & descend into them.
                    j = wrap.length;
                    while(--j > -1)tmp = tmp.appendChild(context.createElement(wrap[j]));
                    tmp.innerHTML = jQuery.htmlPrefilter(elem);
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = typeof value === "function";
        if (valueIsFunction) return collection.each(function(index) {
            var self = collection.eq(index);
            args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.get(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce,
                                    crossOrigin: node.crossOrigin
                                }, doc);
                            } else DOMEval(node.textContent, node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement$1, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: Firefox <=42 - 66+
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11+
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: typeof hook === "function" ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: jQuery.extend(Object.create(null), {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    if (event.result !== undefined) // Setting `event.originalEvent.returnValue` in modern
                    // browsers does the same as just calling `preventDefault()`,
                    // the browsers ignore the value anyway.
                    // Incidentally, IE 11 is the only browser from our supported
                    // ones which respects the value returned from a `beforeunload`
                    // handler attached by `addEventListener`; other browsers do
                    // so only for inline handlers, so not setting the value
                    // directly shouldn't reduce any functionality.
                    event.preventDefault();
                }
            }
        })
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                // This controller function is invoked under multiple circumstances,
                // differentiated by the stored value in `saved`:
                // 1. For an outer synthetic `.trigger()`ed event (detected by
                //    `event.isTrigger & 1` and non-array `saved`), it records arguments
                //    as an array and fires an [inner] native event to prompt state
                //    changes that should be observed by registered listeners (such as
                //    checkbox toggling and focus updating), then clears the stored value.
                // 2. For an [inner] native event (detected by `saved` being
                //    an array), it triggers an inner synthetic event, records the
                //    result, and preempts propagation to further jQuery listeners.
                // 3. For an inner synthetic event (detected by `event.isTrigger & 1` and
                //    array `saved`), it prevents double-propagation of surrogate events
                //    but otherwise allows everything to proceed (particularly including
                //    further listeners).
                // Possible `saved` data shapes: `[...], `{ value }`, `false`.
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object),
                        // so this array will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is
                            // blurred by clicking outside of it, it invokes the handler
                            // synchronously. If that handler calls `.remove()` on
                            // the element, the data is cleared, leaving `result`
                            // undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling
                    // surrogate (focus or blur), assume that the surrogate already
                    // propagated from triggering the native event and prevent that
                    // from happening again here.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order.
                // Fire an inner synthetic event with the original arguments.
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(saved[0], saved.slice(1), this)
                    });
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ? returnTrue : returnFalse;
            // Create target properties
            this.target = src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        // Support: IE 11+
        // Attach a single focusin/focusout handler on the document while someone wants focus/blur.
        // This is because the former are synchronous in IE while the latter are async. In other
        // browsers, all those handlers are invoked synchronously.
        function focusMappedHandler(nativeEvent) {
            // `eventHandle` would already wrap the event, but we need to change the `type` here.
            var event = jQuery.event.fix(nativeEvent);
            event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
            event.isSimulated = true;
            // focus/blur don't bubble while focusin/focusout do; simulate the former by only
            // invoking the handler at the lower level.
            if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
            // `jQuery.event.add`, so event handle will already have been set
            // by this point.
            dataPriv.get(this, "handle")(event);
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (isIE) this.addEventListener(delegateType, focusMappedHandler);
                else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                if (isIE) this.removeEventListener(delegateType, focusMappedHandler);
                else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11+
    // In IE using regex groups here causes severe slowdowns.
    rnoInnerhtml = /<script|<style|<link/i;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var type, i, l, events = dataPriv.get(src, "events");
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (events) {
            dataPriv.remove(dest, "handle events");
            for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) dataUser.set(dest, jQuery.extend({}, dataUser.get(src)));
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (isIE && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)// Support: IE <=11+
                // IE fails to set the defaultValue to the correct value when
                // cloning textareas.
                if (nodeName(destElements[i], "textarea")) destElements[i].defaultValue = srcElements[i].defaultValue;
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                push.apply(ret, elems);
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    function getStyles(elem) {
        // Support: IE <=11+ (trac-14150)
        // In IE popup's `window` is the opener window which makes `window.getComputedStyle( elem )`
        // break. Using `elem.ownerDocument.defaultView` avoids the issue.
        var view = elem.ownerDocument.defaultView;
        // `document.implementation.createHTMLDocument( "" )` has a `null` `defaultView`
        // property; check `defaultView` truthiness to fallback to window in such a case.
        if (!view) view = window1;
        return view.getComputedStyle(elem);
    }
    // A method for quickly swapping in/out CSS properties to get correct calculations.
    function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    }
    function curCSS(elem, name, computed) {
        var ret, isCustomProp = rcustomProp.test(name);
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for `.css('--customProperty')` (gh-3144)
        if (computed) {
            // A fallback to direct property access is needed as `computed`, being
            // the output of `getComputedStyle`, contains camelCased keys and
            // `getPropertyValue` requires kebab-case ones.
            //
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105 - 135+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
        }
        return ret !== undefined ? // Support: IE <=9 - 11+
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document$1.createElement("div").style;
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped vendor prefixed property
    function finalPropName(name) {
        if (name in emptyStyle) return name;
        return vendorPropName(name) || name;
    }
    var reliableTrDimensionsVal, reliableColDimensionsVal, table = document$1.createElement("table");
    // Executing table tests requires only one layout, so they're executed
    // at the same time to save the second computation.
    function computeTableStyleTests() {
        if (// This is a singleton, we need to execute it only once
        !table || // Finish early in limited (non-browser) environments
        !table.style) return;
        var trStyle, col = document$1.createElement("col"), tr = document$1.createElement("tr"), td = document$1.createElement("td");
        table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate;border-spacing:0";
        tr.style.cssText = "box-sizing:content-box;border:1px solid;height:1px";
        td.style.cssText = "height:9px;width:9px;padding:0";
        col.span = 2;
        documentElement$1.appendChild(table).appendChild(col).parentNode.appendChild(tr).appendChild(td).parentNode.appendChild(td.cloneNode(true));
        // Don't run until window is visible
        if (table.offsetWidth === 0) {
            documentElement$1.removeChild(table);
            return;
        }
        trStyle = window1.getComputedStyle(tr);
        // Support: Firefox 135+
        // Firefox always reports computed width as if `span` was 1.
        // Support: Safari 18.3+
        // In Safari, computed width for columns is always 0.
        // In both these browsers, using `offsetWidth` solves the issue.
        // Support: IE 11+
        // In IE, `<col>` computed width is `"auto"` unless `width` is set
        // explicitly via CSS so measurements there remain incorrect. Because of
        // the lack of a proper workaround, we accept this limitation, treating
        // IE as passing the test.
        reliableColDimensionsVal = isIE || Math.round(parseFloat(window1.getComputedStyle(col).width)) === 18;
        // Support: IE 10 - 11+
        // IE misreports `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Support: Firefox 70 - 135+
        // Only Firefox includes border widths
        // in computed dimensions for table rows. (gh-4529)
        reliableTrDimensionsVal = Math.round(parseFloat(trStyle.height) + parseFloat(trStyle.borderTopWidth) + parseFloat(trStyle.borderBottomWidth)) === tr.offsetHeight;
        documentElement$1.removeChild(table);
        // Nullify the table so it wouldn't be stored in the memory;
        // it will also be a sign that checks were already performed.
        table = null;
    }
    jQuery.extend(support, {
        reliableTrDimensions: function() {
            computeTableStyleTests();
            return reliableTrDimensionsVal;
        },
        reliableColDimensions: function() {
            computeTableStyleTests();
            return reliableColDimensionsVal;
        }
    });
    var cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = isIE || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        if (// Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        (val === "auto" || // Support: IE 9 - 11+
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        isIE && isBorderBox || !support.reliableColDimensions() && nodeName(elem, "col") || !support.reliableTrDimensions() && nodeName(elem, "tr")) && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = cssCamelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If the value is a number, add `px` for certain CSS properties
                if (type === "number") value += ret && ret[3] || (isAutoPx(origName) ? "px" : "");
                // Support: IE <=9 - 11+
                // background-* props of a cloned element affect the source element (trac-8908)
                if (isIE && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = cssCamelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Elements with `display: none` can have dimension info if
                // we invisibly show them.
                return jQuery.css(elem, "display") === "none" ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                isBorderBox = extra && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (isAutoPx(prop) ? "px" : "");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document$1.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, 13);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11+
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.set(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                // eslint-disable-next-line no-loop-func
                anim.done(function() {
                    // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = cssCamelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), percent = 1 - (remaining / animation.duration || 0), index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (typeof result.stop === "function") jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (typeof animation.opts.start === "function") animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (typeof props === "function") {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || easing || typeof speed === "function" && speed,
            duration: speed,
            easing: fn && easing || easing && typeof easing !== "function" && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (typeof opt.old === "function") opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11+
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = elem.getAttribute("tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || // href-less anchor's `tabIndex` property value is `0` and
                    // the `tabindex` attribute value: `null`. We want `-1`.
                    rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11+
    // Accessing the selectedIndex property forces the browser to respect
    // setting selected on the option. The getter ensures a default option
    // is selected when in an optgroup. ESLint rule "no-unused-expressions"
    // is disabled for this code since it considers such accessions noop.
    if (isIE) jQuery.propHooks.selected = {
        get: function(elem) {
            var parent = elem.parentNode;
            if (parent && parent.parentNode) // eslint-disable-next-line no-unused-expressions
            parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            var parent = elem.parentNode;
            if (parent) {
                // eslint-disable-next-line no-unused-expressions
                parent.selectedIndex;
                if (parent.parentNode) // eslint-disable-next-line no-unused-expressions
                parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (typeof value === "function") return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (typeof value === "function") return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self;
            if (typeof value === "function") return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean") return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                // Toggle individual class names
                self = jQuery(this);
                for(i = 0; i < classNames.length; i++){
                    className = classNames[i];
                    // Check each className given, space separated list
                    if (self.hasClass(className)) self.removeClass(className);
                    else self.addClass(className);
                }
            });
            return this;
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = typeof value === "function";
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        if (option.selected && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        if (option.selected = jQuery.inArray(jQuery(option).val(), values) > -1) optionSet = true;
                    }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    if (isIE) jQuery.valHooks.option = {
        get: function(elem) {
            var val = elem.getAttribute("value");
            return val != null ? val : // Support: IE <=10 - 11+
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            stripAndCollapse(jQuery.text(elem));
        }
    };
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
    });
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document$1
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document$1;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document$1)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && typeof elem[type] === "function" && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11+
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = typeof valueOrFunction === "function" ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document$1.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (typeof func === "function") {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))// Support: IE 11+
                            // `getResponseHeader( key )` in IE doesn't combine all header
                            // values for the provided key into a single result with values
                            // joined by commas as other browsers do. Instead, it returns
                            // them on separate lines.
                            responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document$1.createElement("a");
                // Support: IE <=8 - 11+
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11+
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an ESM-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted.
            // Handle the null callback placeholder.
            if (typeof data === "function" || data === null) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            scriptAttrs: options.crossOrigin ? {
                "crossOrigin": options.crossOrigin
            } : undefined,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (typeof html === "function") html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (typeof html === "function") return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = typeof html === "function";
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        return new window1.XMLHttpRequest();
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200
    };
    jQuery.ajaxTransport(function(options) {
        var callback;
        return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                            xhr.status, xhr.statusText);
                            else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") === "text" ? {
                                text: xhr.responseText
                            } : {
                                binary: xhr.response
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                xhr.onabort = xhr.onerror = xhr.ontimeout = callback("error");
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    function canUseScriptTag(s) {
        // A script tag can only be used for async, cross domain or forced-by-attrs requests.
        // Requests with headers cannot use a script tag. However, when both `scriptAttrs` &
        // `headers` options are specified, both are impossible to satisfy together; we
        // prefer `scriptAttrs` then.
        // Sync requests remain handled differently to preserve strict script ordering.
        return s.scriptAttrs || !s.headers && (s.crossDomain || // When dealing with JSONP (`s.dataTypes` include "json" then)
        // don't use a script tag so that error responses still may have
        // `responseJSON` set. Continue using a script tag for JSONP requests that:
        //   * are cross-domain as AJAX requests won't work without a CORS setup
        //   * have `scriptAttrs` set as that's a script-only functionality
        // Note that this means JSONP requests violate strict CSP script-src settings.
        // A proper solution is to migrate from using JSONP to a CORS setup.
        s.async && jQuery.inArray("json", s.dataTypes) < 0);
    }
    // Install script dataType. Don't specify `contents.script` so that an explicit
    // `dataType: "script"` is required (see gh-2432, gh-4822)
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        // These types of requests are handled via a script tag
        // so force their methods to GET.
        if (canUseScriptTag(s)) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        if (canUseScriptTag(s)) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document$1.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Get callback name, remembering preexisting value associated with it
        callbackName = s.jsonpCallback = typeof s.jsonpCallback === "function" ? s.jsonpCallback() : s.jsonpCallback;
        // Insert callback into url or form data
        if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
        else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
        // Use data converter to retrieve json after script execution
        s.converters["script json"] = function() {
            if (!responseContainer) jQuery.error(callbackName + " was not called");
            return responseContainer[0];
        };
        // Force json dataType
        s.dataTypes[0] = "json";
        // Install callback
        overwritten = window1[callbackName];
        window1[callbackName] = function() {
            responseContainer = arguments;
        };
        // Clean-up function (fires after converters)
        jqXHR.always(function() {
            // If previous value didn't exist - remove it
            if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
            else window1[callbackName] = overwritten;
            // Save back as free
            if (s[callbackName]) {
                // Make sure that re-using the options doesn't screw things around
                s.jsonpCallback = originalSettings.jsonpCallback;
                // Save the callback name for future use
                oldCallbacks.push(callbackName);
            }
            // Call if it was a function and we have a response
            if (responseContainer && typeof overwritten === "function") overwritten(responseContainer[0]);
            responseContainer = overwritten = undefined;
        });
        // Delegate to script
        return "script";
    });
    jQuery.ajaxPrefilter(function(s, origOptions) {
        // Binary data needs to be passed to XHR as-is without stringification.
        if (typeof s.data !== "string" && !jQuery.isPlainObject(s.data) && !Array.isArray(s.data) && // Don't disable data processing if explicitly set by the user.
        !("processData" in origOptions)) s.processData = false;
        // `Content-Type` for requests with `FormData` bodies needs to be set
        // by the browser as it needs to append the `boundary` it generated.
        if (s.data instanceof window1.FormData) s.contentType = false;
    });
    // Argument "data" should be string of html or a TrustedHTML wrapper of obvious HTML
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string" && !isObviousHtml(data + "")) return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var parsed, scripts;
        if (!context) // Stop scripts or inline event handlers from being executed immediately
        // by using DOMParser
        context = new window1.DOMParser().parseFromString("", "text/html");
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (typeof params === "function") {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (typeof options === "function") // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11+
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && offsetParent !== doc.documentElement && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent || doc.documentElement;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 && jQuery.css(offsetParent, "position") !== "static") {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement$1;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (typeof fn !== "function") return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.expr[":"] = jQuery.expr.filters = jQuery.expr.pseudos;
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, gh-557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});


parcelRegister("66ItK", function(module, exports) {
"use strict";
var $4725ce2b11abfccf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4725ce2b11abfccf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4725ce2b11abfccf$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4725ce2b11abfccf$var$__createBinding(exports1, m, p);
};
var $4725ce2b11abfccf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4725ce2b11abfccf$var$GraphqlModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InMemoryCache = module.exports.GraphqlModule = void 0;

var $4XQlz = parcelRequire("4XQlz");

var $4TNVq = parcelRequire("4TNVq");


var $hHjSo = parcelRequire("hHjSo");
var $irVrB = parcelRequire("irVrB");
var $9JsUy = parcelRequire("9JsUy");
var $khEaU = parcelRequire("khEaU");
var $jXDjt = parcelRequire("jXDjt");parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");
var $4LC1k = parcelRequire("4LC1k");

var $fSlNw = parcelRequire("fSlNw");

var $9IwMP = parcelRequire("9IwMP");

var $aPfFa = parcelRequire("aPfFa");

var $cpB4j = parcelRequire("cpB4j");
let $4725ce2b11abfccf$var$GraphqlModule = $4725ce2b11abfccf$var$GraphqlModule_1 = class GraphqlModule {
    static forRoot({ uri: uri, pubsub: pubsub, refreshOnUnauthenticated: refreshOnUnauthenticated, onRequest: onRequest, cache: cache, apolloRequestHandler: apolloRequestHandler, cancelPendingRequests: cancelPendingRequests, apolloClientOptions: apolloClientOptions, httpOptions: httpOptions = {}, pubsubOptions: pubsubOptions = {} } = {}, documents = {}) {
        const headers = {};
        const connections = {};
        return {
            module: $4725ce2b11abfccf$var$GraphqlModule_1,
            providers: [
                {
                    provide: (parcelRequire("gu0Mj")).GraphqlDocuments,
                    useValue: Object.keys(documents).reduce((prev, doc)=>Object.assign(Object.assign({}, prev), {
                            [doc.split('/').pop()]: documents[doc]
                        }), {})
                },
                {
                    provide: (parcelRequire("gu0Mj")).ApolloClient,
                    useFactory: ()=>new $hHjSo.ApolloClient(Object.assign({
                            link: (0, $9JsUy.concat)((0, $jXDjt.from)([
                                (0, $cpB4j.setContext)((operation)=>$4725ce2b11abfccf$var$__awaiter(this, void 0, void 0, function*() {
                                        const method = onRequest || (parcelRequire("gu0Mj")).noopHeaders;
                                        let headersMap = (yield method.call(operation)) || {};
                                        headersMap.forEach((v, k)=>{
                                            headers[k] = v;
                                        });
                                        return {
                                            headers: headers
                                        };
                                    })),
                                new $irVrB.ApolloLink(typeof apolloRequestHandler === 'function' ? apolloRequestHandler : (operation, forward)=>{
                                    /* Start cancel request */ if (cancelPendingRequests) return new $1ieNy.Observable((observer)=>{
                                        const context = operation.getContext();
                                        const connectionHandle = forward(operation).subscribe({
                                            next: (...arg)=>observer.next(...arg),
                                            error: (...arg)=>{
                                                cleanUp();
                                                observer.error(...arg);
                                            },
                                            complete: (...arg)=>{
                                                cleanUp();
                                                observer.complete(...arg);
                                            }
                                        });
                                        const cleanUp = ()=>{
                                            connectionHandle === null || connectionHandle === void 0 || connectionHandle.unsubscribe();
                                            delete connections[context.requestTrackerId];
                                        };
                                        if (context.requestTrackerId) {
                                            const controller = new AbortController();
                                            controller.signal.onabort = cleanUp;
                                            operation.setContext(Object.assign(Object.assign({}, context), {
                                                fetchOptions: Object.assign({
                                                    signal: controller.signal
                                                }, context === null || context === void 0 ? void 0 : context.fetchOptions)
                                            }));
                                            if (connections[context.requestTrackerId]) // If a controller exists, that means this operation should be aborted.
                                            connections[context.requestTrackerId].abort();
                                            connections[context.requestTrackerId] = controller;
                                        }
                                        return connectionHandle;
                                    });
                                    /* End cancel request */ return forward(operation);
                                })
                            ]), (0, $4LC1k.split)(({ query: query })=>{
                                const { kind: kind, operation: operation } = (0, $aPfFa.getMainDefinition)(query);
                                return kind === 'OperationDefinition' && operation === 'subscription';
                            }, (()=>{
                                const wsLink = new $fSlNw.WebSocketLink(new $9IwMP.SubscriptionClient(pubsub, Object.assign({
                                    lazy: true,
                                    connectionParams: ()=>({
                                            get authorization () {
                                                return headers['authorization'];
                                            }
                                        }),
                                    connectionCallback: (error)=>{
                                        console.error('[Subscription]: ', error);
                                        if ((error === null || error === void 0 ? void 0 : error['message']) === 'Unauthorized') {
                                            if (refreshOnUnauthenticated) location.reload();
                                            wsLink['subscriptionClient'].close(false, false);
                                        }
                                    },
                                    reconnect: true
                                }, pubsubOptions)));
                                return wsLink;
                            })(), (0, $khEaU.createHttpLink)(Object.assign({
                                uri: uri
                            }, httpOptions)))),
                            cache: cache || new $4TNVq.InMemoryCache()
                        }, apolloClientOptions))
                }
            ]
        };
    }
};
module.exports.GraphqlModule = $4725ce2b11abfccf$var$GraphqlModule;
module.exports.GraphqlModule = $4725ce2b11abfccf$var$GraphqlModule = $4725ce2b11abfccf$var$GraphqlModule_1 = $4725ce2b11abfccf$var$__decorate([
    (0, $4XQlz.Module)({})
], $4725ce2b11abfccf$var$GraphqlModule);

$4725ce2b11abfccf$var$__exportStar((parcelRequire("gu0Mj")), module.exports);

$4725ce2b11abfccf$var$__exportStar((parcelRequire("3L9PA")), module.exports);

var $4TNVq = parcelRequire("4TNVq");
Object.defineProperty(module.exports, "InMemoryCache", {
    enumerable: true,
    get: function() {
        return $4TNVq.InMemoryCache;
    }
});

});
parcelRegister("4TNVq", function(module, exports) {

$parcel$export(module.exports, "InMemoryCache", () => $39130690a1429cce$export$467265324939f47f);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");


var $elxhT = parcelRequire("elxhT");

var $5nLer = parcelRequire("5nLer");

var $4kIqK = parcelRequire("4kIqK");

var $beqrA = parcelRequire("beqrA");

var $fOMXV = parcelRequire("fOMXV");
var $6cKaj = parcelRequire("6cKaj");
var $7Szzy = parcelRequire("7Szzy");
var $8JTgn = parcelRequire("8JTgn");
var $eSohM = parcelRequire("eSohM");
var $4YPPO = parcelRequire("4YPPO");
var $lAW9R = parcelRequire("lAW9R");

var $alOLy = parcelRequire("alOLy");

var $f9OU7 = parcelRequire("f9OU7");

var $kbMHn = parcelRequire("kbMHn");

var $fpOnH = parcelRequire("fpOnH");

var $21Oj9 = parcelRequire("21Oj9");

var $aqsBN = parcelRequire("aqsBN");

var $bCfQ0 = parcelRequire("bCfQ0");
var $39130690a1429cce$export$467265324939f47f = /** @class */ function(_super) {
    (0, $5Rzv1.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $8JTgn.DocumentTransform)((0, $fOMXV.addTypenameToDocument));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $fpOnH.makeVar);
        _this.txCount = 0;
        if (globalThis.__DEV__ !== false) {
            (0, $4YPPO.warnRemovedOption)(config, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`.");
            (0, $4YPPO.warnRemovedOption)(config, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.");
        }
        _this.config = (0, $aqsBN.normalizeConfig)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $21Oj9.Policies)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, $kbMHn.EntityStore).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.addTypenameTransform.resetCache();
        fragments === null || fragments === void 0 || fragments.resetCaches();
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $f9OU7.StoreWriter)(this, this.storeReader = new (0, $alOLy.StoreReader)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $aqsBN.shouldCanonizeResults)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $elxhT.wrap)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $6cKaj.cacheSizes)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $kbMHn.supportsResultCaching)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $7Szzy.canonicalStringify)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnRemovedOption)(options, "canonizeResults", "cache.read");
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $beqrA.MissingFieldError)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $aqsBN.hasOwn).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnRemovedOption)(options, "canonizeResults", "cache.diff");
        return this.storeReader.diffQueryAgainstStore((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $fpOnH.recallCache)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $fpOnH.forgetCache)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnRemovedOption)(options || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option.");
        (0, $7Szzy.canonicalStringify).reset();
        (0, $lAW9R.print).reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $eSohM.isReference)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $aqsBN.hasOwn).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $7Szzy.canonicalStringify).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $fpOnH.forgetCache)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.fragmentMatches = function(fragment, typename) {
        return this.policies.fragmentMatches(fragment, typename);
    };
    InMemoryCache.prototype.lookupFragment = function(fragmentName) {
        var _a;
        return ((_a = this.config.fragments) === null || _a === void 0 ? void 0 : _a.lookup(fragmentName)) || null;
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var _this = this;
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = (0, $4YPPO.muteDeprecations)("canonizeResults", function() {
            return _this.diff(c);
        });
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $5nLer.equal)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $4kIqK.ApolloCache));
if (globalThis.__DEV__ !== false) $39130690a1429cce$export$467265324939f47f.prototype.getMemoryInternals = (0, $bCfQ0.getInMemoryCacheMemoryInternals);

});
parcelRegister("5Rzv1", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $444d706fc3ed70c4$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $444d706fc3ed70c4$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $444d706fc3ed70c4$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $444d706fc3ed70c4$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $444d706fc3ed70c4$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArray", () => $444d706fc3ed70c4$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $444d706fc3ed70c4$var$extendStatics = function(d, b) {
    $444d706fc3ed70c4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $444d706fc3ed70c4$var$extendStatics(d, b);
};
function $444d706fc3ed70c4$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $444d706fc3ed70c4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $444d706fc3ed70c4$export$18ce0697a983be9b = function() {
    $444d706fc3ed70c4$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $444d706fc3ed70c4$export$18ce0697a983be9b.apply(this, arguments);
};
function $444d706fc3ed70c4$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $444d706fc3ed70c4$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $444d706fc3ed70c4$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $444d706fc3ed70c4$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $444d706fc3ed70c4$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $444d706fc3ed70c4$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $444d706fc3ed70c4$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $444d706fc3ed70c4$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $444d706fc3ed70c4$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $444d706fc3ed70c4$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $444d706fc3ed70c4$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $444d706fc3ed70c4$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $444d706fc3ed70c4$export$45d3717a4c69092e(o, m, p);
}
function $444d706fc3ed70c4$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $444d706fc3ed70c4$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $444d706fc3ed70c4$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($444d706fc3ed70c4$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $444d706fc3ed70c4$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $444d706fc3ed70c4$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $444d706fc3ed70c4$export$10c90e4f7922046c(v) {
    return this instanceof $444d706fc3ed70c4$export$10c90e4f7922046c ? (this.v = v, this) : new $444d706fc3ed70c4$export$10c90e4f7922046c(v);
}
function $444d706fc3ed70c4$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $444d706fc3ed70c4$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $444d706fc3ed70c4$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $444d706fc3ed70c4$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $444d706fc3ed70c4$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $444d706fc3ed70c4$export$19a8beecd37a4c45 === "function" ? $444d706fc3ed70c4$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $444d706fc3ed70c4$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $444d706fc3ed70c4$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $444d706fc3ed70c4$var$ownKeys = function(o) {
    $444d706fc3ed70c4$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $444d706fc3ed70c4$var$ownKeys(o);
};
function $444d706fc3ed70c4$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $444d706fc3ed70c4$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $444d706fc3ed70c4$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $444d706fc3ed70c4$var$__setModuleDefault(result, mod);
    return result;
}
function $444d706fc3ed70c4$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $444d706fc3ed70c4$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $444d706fc3ed70c4$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $444d706fc3ed70c4$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $444d706fc3ed70c4$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $444d706fc3ed70c4$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $444d706fc3ed70c4$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $444d706fc3ed70c4$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $444d706fc3ed70c4$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $444d706fc3ed70c4$export$2e2bcd8739ae039 = {
    __extends: $444d706fc3ed70c4$export$a8ba968b8961cb8a,
    __assign: $444d706fc3ed70c4$export$18ce0697a983be9b,
    __rest: $444d706fc3ed70c4$export$3c9a16f847548506,
    __decorate: $444d706fc3ed70c4$export$29e00dfd3077644b,
    __param: $444d706fc3ed70c4$export$d5ad3fd78186038f,
    __esDecorate: $444d706fc3ed70c4$export$3a84e1ae4e97e9b0,
    __runInitializers: $444d706fc3ed70c4$export$d831c04e792af3d,
    __propKey: $444d706fc3ed70c4$export$6a2a36740a146cb8,
    __setFunctionName: $444d706fc3ed70c4$export$d1a06452d3489bc7,
    __metadata: $444d706fc3ed70c4$export$f1db080c865becb9,
    __awaiter: $444d706fc3ed70c4$export$1050f835b63b671e,
    __generator: $444d706fc3ed70c4$export$67ebef60e6f28a6,
    __createBinding: $444d706fc3ed70c4$export$45d3717a4c69092e,
    __exportStar: $444d706fc3ed70c4$export$f33643c0debef087,
    __values: $444d706fc3ed70c4$export$19a8beecd37a4c45,
    __read: $444d706fc3ed70c4$export$8d051b38c9118094,
    __spread: $444d706fc3ed70c4$export$afc72e2116322959,
    __spreadArrays: $444d706fc3ed70c4$export$6388937ca91ccae8,
    __spreadArray: $444d706fc3ed70c4$export$1216008129fb82ed,
    __await: $444d706fc3ed70c4$export$10c90e4f7922046c,
    __asyncGenerator: $444d706fc3ed70c4$export$e427f37a30a4de9b,
    __asyncDelegator: $444d706fc3ed70c4$export$bbd80228419bb833,
    __asyncValues: $444d706fc3ed70c4$export$e3b29a3d6162315f,
    __makeTemplateObject: $444d706fc3ed70c4$export$4fb47efe1390b86f,
    __importStar: $444d706fc3ed70c4$export$c21735bcef00d192,
    __importDefault: $444d706fc3ed70c4$export$da59b14a69baef04,
    __classPrivateFieldGet: $444d706fc3ed70c4$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $444d706fc3ed70c4$export$d40a35129aaff81f,
    __classPrivateFieldIn: $444d706fc3ed70c4$export$81fdc39f203e4e04,
    __addDisposableResource: $444d706fc3ed70c4$export$88ac25d8e944e405,
    __disposeResources: $444d706fc3ed70c4$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $444d706fc3ed70c4$export$889dfb5d17574b0b
};

});

parcelRegister("7aKgP", function(module, exports) {

$parcel$export(module.exports, "maybe", () => (parcelRequire("fRFeB")).maybe);
$parcel$export(module.exports, "global", () => (parcelRequire("iXyoi")).default);
$parcel$export(module.exports, "invariant", () => (parcelRequire("jWokI")).invariant);
$parcel$export(module.exports, "newInvariantError", () => (parcelRequire("jWokI")).newInvariantError);

var $jWokI = parcelRequire("jWokI");

var $fRFeB = parcelRequire("fRFeB");

var $iXyoi = parcelRequire("iXyoi");
var $538d5bf063c54f9d$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;

});
parcelRegister("jWokI", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $e8464f272c3a51e4$export$f5708dca728d7177);
$parcel$export(module.exports, "newInvariantError", () => $e8464f272c3a51e4$export$3991762405098ea);

var $89fwQ = parcelRequire("89fwQ");

var $oNTBC = parcelRequire("oNTBC");

var $iXyoi = parcelRequire("iXyoi");

var $gtD0h = parcelRequire("gtD0h");
function $e8464f272c3a51e4$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $e8464f272c3a51e4$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $e8464f272c3a51e4$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $e8464f272c3a51e4$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $89fwQ.invariant)(condition, $e8464f272c3a51e4$var$getHandledErrorMsg(message, args) || $e8464f272c3a51e4$var$getFallbackErrorMsg(message, args));
}, {
    debug: $e8464f272c3a51e4$var$wrap((0, $89fwQ.invariant).debug),
    log: $e8464f272c3a51e4$var$wrap((0, $89fwQ.invariant).log),
    warn: $e8464f272c3a51e4$var$wrap((0, $89fwQ.invariant).warn),
    error: $e8464f272c3a51e4$var$wrap((0, $89fwQ.invariant).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $e8464f272c3a51e4$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $89fwQ.InvariantError)($e8464f272c3a51e4$var$getHandledErrorMsg(message, optionalParams) || $e8464f272c3a51e4$var$getFallbackErrorMsg(message, optionalParams));
}
var $e8464f272c3a51e4$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $oNTBC.version));
function $e8464f272c3a51e4$var$stringify(arg) {
    if (typeof arg == "string") return arg;
    try {
        return (0, $gtD0h.stringifyForDisplay)(arg, 2).slice(0, 1000);
    } catch (_a) {
        return "<non-serializable>";
    }
}
function $e8464f272c3a51e4$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $iXyoi.default)[$e8464f272c3a51e4$export$b8ca975fa04efdf3] && (0, $iXyoi.default)[$e8464f272c3a51e4$export$b8ca975fa04efdf3](message, messageArgs.map($e8464f272c3a51e4$var$stringify));
}
function $e8464f272c3a51e4$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $oNTBC.version),
        message: message,
        args: messageArgs.map($e8464f272c3a51e4$var$stringify)
    })));
}

});
parcelRegister("89fwQ", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $5eeb35ad8b158264$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $5eeb35ad8b158264$export$f5708dca728d7177);

var $8E20x = parcelRequire("8E20x");
var $5eeb35ad8b158264$var$genericMessage = "Invariant Violation";
var $5eeb35ad8b158264$var$_a = Object.setPrototypeOf, $5eeb35ad8b158264$var$setPrototypeOf = $5eeb35ad8b158264$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $5eeb35ad8b158264$var$_a;
var $5eeb35ad8b158264$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $8E20x.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $5eeb35ad8b158264$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $5eeb35ad8b158264$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $5eeb35ad8b158264$var$genericMessage;
        $5eeb35ad8b158264$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $5eeb35ad8b158264$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $5eeb35ad8b158264$export$cea12affaee22fe8(message);
}
var $5eeb35ad8b158264$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $5eeb35ad8b158264$var$verbosityLevel = $5eeb35ad8b158264$var$verbosityLevels.indexOf("log");
function $5eeb35ad8b158264$var$wrapConsoleMethod(name) {
    return function() {
        if ($5eeb35ad8b158264$var$verbosityLevels.indexOf(name) >= $5eeb35ad8b158264$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $5eeb35ad8b158264$var$wrapConsoleMethod("debug");
    invariant.log = $5eeb35ad8b158264$var$wrapConsoleMethod("log");
    invariant.warn = $5eeb35ad8b158264$var$wrapConsoleMethod("warn");
    invariant.error = $5eeb35ad8b158264$var$wrapConsoleMethod("error");
})($5eeb35ad8b158264$export$f5708dca728d7177 || ($5eeb35ad8b158264$export$f5708dca728d7177 = {}));
function $5eeb35ad8b158264$export$a80e09f2cd325fb8(level) {
    var old = $5eeb35ad8b158264$var$verbosityLevels[$5eeb35ad8b158264$var$verbosityLevel];
    $5eeb35ad8b158264$var$verbosityLevel = Math.max(0, $5eeb35ad8b158264$var$verbosityLevels.indexOf(level));
    return old;
}
var $5eeb35ad8b158264$export$2e2bcd8739ae039 = $5eeb35ad8b158264$export$f5708dca728d7177;

});
parcelRegister("8E20x", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $64b39dd443f187c0$export$a8ba968b8961cb8a);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $64b39dd443f187c0$var$extendStatics = function(d, b) {
    $64b39dd443f187c0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $64b39dd443f187c0$var$extendStatics(d, b);
};
function $64b39dd443f187c0$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $64b39dd443f187c0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $64b39dd443f187c0$export$18ce0697a983be9b = function() {
    $64b39dd443f187c0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $64b39dd443f187c0$export$18ce0697a983be9b.apply(this, arguments);
};
function $64b39dd443f187c0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $64b39dd443f187c0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $64b39dd443f187c0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $64b39dd443f187c0$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $64b39dd443f187c0$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $64b39dd443f187c0$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $64b39dd443f187c0$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $64b39dd443f187c0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $64b39dd443f187c0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $64b39dd443f187c0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $64b39dd443f187c0$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $64b39dd443f187c0$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $64b39dd443f187c0$export$45d3717a4c69092e(o, m, p);
}
function $64b39dd443f187c0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $64b39dd443f187c0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $64b39dd443f187c0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($64b39dd443f187c0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $64b39dd443f187c0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $64b39dd443f187c0$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $64b39dd443f187c0$export$10c90e4f7922046c(v) {
    return this instanceof $64b39dd443f187c0$export$10c90e4f7922046c ? (this.v = v, this) : new $64b39dd443f187c0$export$10c90e4f7922046c(v);
}
function $64b39dd443f187c0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $64b39dd443f187c0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $64b39dd443f187c0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $64b39dd443f187c0$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $64b39dd443f187c0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $64b39dd443f187c0$export$19a8beecd37a4c45 === "function" ? $64b39dd443f187c0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $64b39dd443f187c0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $64b39dd443f187c0$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $64b39dd443f187c0$var$ownKeys = function(o) {
    $64b39dd443f187c0$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $64b39dd443f187c0$var$ownKeys(o);
};
function $64b39dd443f187c0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $64b39dd443f187c0$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $64b39dd443f187c0$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $64b39dd443f187c0$var$__setModuleDefault(result, mod);
    return result;
}
function $64b39dd443f187c0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $64b39dd443f187c0$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $64b39dd443f187c0$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $64b39dd443f187c0$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $64b39dd443f187c0$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $64b39dd443f187c0$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $64b39dd443f187c0$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $64b39dd443f187c0$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $64b39dd443f187c0$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $64b39dd443f187c0$export$2e2bcd8739ae039 = {
    __extends: $64b39dd443f187c0$export$a8ba968b8961cb8a,
    __assign: $64b39dd443f187c0$export$18ce0697a983be9b,
    __rest: $64b39dd443f187c0$export$3c9a16f847548506,
    __decorate: $64b39dd443f187c0$export$29e00dfd3077644b,
    __param: $64b39dd443f187c0$export$d5ad3fd78186038f,
    __esDecorate: $64b39dd443f187c0$export$3a84e1ae4e97e9b0,
    __runInitializers: $64b39dd443f187c0$export$d831c04e792af3d,
    __propKey: $64b39dd443f187c0$export$6a2a36740a146cb8,
    __setFunctionName: $64b39dd443f187c0$export$d1a06452d3489bc7,
    __metadata: $64b39dd443f187c0$export$f1db080c865becb9,
    __awaiter: $64b39dd443f187c0$export$1050f835b63b671e,
    __generator: $64b39dd443f187c0$export$67ebef60e6f28a6,
    __createBinding: $64b39dd443f187c0$export$45d3717a4c69092e,
    __exportStar: $64b39dd443f187c0$export$f33643c0debef087,
    __values: $64b39dd443f187c0$export$19a8beecd37a4c45,
    __read: $64b39dd443f187c0$export$8d051b38c9118094,
    __spread: $64b39dd443f187c0$export$afc72e2116322959,
    __spreadArrays: $64b39dd443f187c0$export$6388937ca91ccae8,
    __spreadArray: $64b39dd443f187c0$export$1216008129fb82ed,
    __await: $64b39dd443f187c0$export$10c90e4f7922046c,
    __asyncGenerator: $64b39dd443f187c0$export$e427f37a30a4de9b,
    __asyncDelegator: $64b39dd443f187c0$export$bbd80228419bb833,
    __asyncValues: $64b39dd443f187c0$export$e3b29a3d6162315f,
    __makeTemplateObject: $64b39dd443f187c0$export$4fb47efe1390b86f,
    __importStar: $64b39dd443f187c0$export$c21735bcef00d192,
    __importDefault: $64b39dd443f187c0$export$da59b14a69baef04,
    __classPrivateFieldGet: $64b39dd443f187c0$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $64b39dd443f187c0$export$d40a35129aaff81f,
    __classPrivateFieldIn: $64b39dd443f187c0$export$81fdc39f203e4e04,
    __addDisposableResource: $64b39dd443f187c0$export$88ac25d8e944e405,
    __disposeResources: $64b39dd443f187c0$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $64b39dd443f187c0$export$889dfb5d17574b0b
};

});


parcelRegister("oNTBC", function(module, exports) {

$parcel$export(module.exports, "version", () => $04a8f2492c092753$export$83d89fbfd8236492);
var $04a8f2492c092753$export$83d89fbfd8236492 = "3.14.1";

});

parcelRegister("iXyoi", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcd86a012f3b584f$export$2e2bcd8739ae039);

var $fRFeB = parcelRequire("fRFeB");
var $dcd86a012f3b584f$export$2e2bcd8739ae039 = (0, $fRFeB.maybe)(function() {
    return globalThis;
}) || (0, $fRFeB.maybe)(function() {
    return window;
}) || (0, $fRFeB.maybe)(function() {
    return self;
}) || (0, $fRFeB.maybe)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $fRFeB.maybe)(function() {
    return (0, $fRFeB.maybe).constructor("return this")();
});

});
parcelRegister("fRFeB", function(module, exports) {

$parcel$export(module.exports, "maybe", () => $b8cbca911c4ecf89$export$f8b8b9ce72e9ccbf);
function $b8cbca911c4ecf89$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}

});


parcelRegister("gtD0h", function(module, exports) {

$parcel$export(module.exports, "stringifyForDisplay", () => $bfed9c0f4ce43d8e$export$f341b4883239463f);

var $egfXt = parcelRequire("egfXt");
function $bfed9c0f4ce43d8e$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $egfXt.makeUniqueId)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}

});
parcelRegister("egfXt", function(module, exports) {

$parcel$export(module.exports, "makeUniqueId", () => $a61ef04bc9567092$export$d0c8ec0fe1b18b70);
var $a61ef04bc9567092$var$prefixCounts = new Map();
function $a61ef04bc9567092$export$d0c8ec0fe1b18b70(prefix) {
    var count = $a61ef04bc9567092$var$prefixCounts.get(prefix) || 1;
    $a61ef04bc9567092$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

});




parcelRegister("elxhT", function(module, exports) {

$parcel$export(module.exports, "wrap", () => $a71cd913f65cab9a$export$4997ffc0176396a6);
$parcel$export(module.exports, "Slot", () => (parcelRequire("j3PV9")).Slot);
$parcel$export(module.exports, "dep", () => (parcelRequire("4OdSC")).dep);

var $ehE1V = parcelRequire("ehE1V");

var $dtVfu = parcelRequire("dtVfu");

var $6GwOY = parcelRequire("6GwOY");

var $kvSSw = parcelRequire("kvSSw");
var $j3PV9 = parcelRequire("j3PV9");

var $4OdSC = parcelRequire("4OdSC");
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $a71cd913f65cab9a$var$defaultKeyTrie;
function $a71cd913f65cab9a$export$cd3144f8dd136006(...args) {
    const trie = $a71cd913f65cab9a$var$defaultKeyTrie || ($a71cd913f65cab9a$var$defaultKeyTrie = new (0, $ehE1V.Trie)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $a71cd913f65cab9a$var$caches = new Set();
function $a71cd913f65cab9a$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $a71cd913f65cab9a$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $dtVfu.StrongCache) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $6GwOY.Entry)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $a71cd913f65cab9a$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $kvSSw.parentEntrySlot).hasValue()) {
            $a71cd913f65cab9a$var$caches.forEach((cache)=>cache.clean());
            $a71cd913f65cab9a$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}

});
parcelRegister("ehE1V", function(module, exports) {

$parcel$export(module.exports, "Trie", () => $a661b457ea4596c4$export$73571c50d0f2507e);
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $a661b457ea4596c4$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $a661b457ea4596c4$var$forEach, slice: $a661b457ea4596c4$var$slice } = Array.prototype;
const { hasOwnProperty: $a661b457ea4596c4$var$hasOwnProperty } = Object.prototype;
class $a661b457ea4596c4$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $a661b457ea4596c4$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $a661b457ea4596c4$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $a661b457ea4596c4$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($a661b457ea4596c4$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($a661b457ea4596c4$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $a661b457ea4596c4$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $a661b457ea4596c4$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $a661b457ea4596c4$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

});

parcelRegister("dtVfu", function(module, exports) {

$parcel$export(module.exports, "StrongCache", () => $9d0a643a43428702$export$d3a0331d2c286dc8);
function $9d0a643a43428702$var$defaultDispose() {}
class $9d0a643a43428702$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $9d0a643a43428702$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

});

parcelRegister("6GwOY", function(module, exports) {

$parcel$export(module.exports, "Entry", () => $4de01fecd524cd43$export$3bb977b3ba9d3b59);

var $kvSSw = parcelRequire("kvSSw");

var $hbqcg = parcelRequire("hbqcg");
const $4de01fecd524cd43$var$emptySetPool = [];
const $4de01fecd524cd43$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $4de01fecd524cd43$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $4de01fecd524cd43$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $4de01fecd524cd43$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $4de01fecd524cd43$var$valueCopy(value) {
    return value.slice(0);
}
class $4de01fecd524cd43$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$4de01fecd524cd43$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$4de01fecd524cd43$var$mightBeDirty(this)) {
            $4de01fecd524cd43$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $4de01fecd524cd43$var$assert(!this.recomputing, "already recomputing");
        $4de01fecd524cd43$var$rememberParent(this);
        return $4de01fecd524cd43$var$mightBeDirty(this) ? $4de01fecd524cd43$var$reallyRecompute(this, args) : $4de01fecd524cd43$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $4de01fecd524cd43$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $hbqcg.maybeUnsubscribe)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $4de01fecd524cd43$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $4de01fecd524cd43$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $4de01fecd524cd43$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $4de01fecd524cd43$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $hbqcg.arrayFromSet)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $4de01fecd524cd43$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$4de01fecd524cd43$export$3bb977b3ba9d3b59.count = 0;
function $4de01fecd524cd43$var$rememberParent(child) {
    const parent = (0, $kvSSw.parentEntrySlot).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($4de01fecd524cd43$var$mightBeDirty(child)) $4de01fecd524cd43$var$reportDirtyChild(parent, child);
        else $4de01fecd524cd43$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $4de01fecd524cd43$var$reallyRecompute(entry, args) {
    $4de01fecd524cd43$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $kvSSw.parentEntrySlot).withValue(entry, $4de01fecd524cd43$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($4de01fecd524cd43$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $4de01fecd524cd43$var$setClean(entry);
    return $4de01fecd524cd43$var$valueGet(entry.value);
}
function $4de01fecd524cd43$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $4de01fecd524cd43$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$4de01fecd524cd43$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $4de01fecd524cd43$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $4de01fecd524cd43$var$setClean(entry) {
    entry.dirty = false;
    if ($4de01fecd524cd43$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $4de01fecd524cd43$var$reportClean(entry);
}
function $4de01fecd524cd43$var$reportDirty(child) {
    $4de01fecd524cd43$var$eachParent(child, $4de01fecd524cd43$var$reportDirtyChild);
}
function $4de01fecd524cd43$var$reportClean(child) {
    $4de01fecd524cd43$var$eachParent(child, $4de01fecd524cd43$var$reportCleanChild);
}
function $4de01fecd524cd43$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $hbqcg.arrayFromSet)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $4de01fecd524cd43$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $4de01fecd524cd43$var$assert(parent.childValues.has(child));
    $4de01fecd524cd43$var$assert($4de01fecd524cd43$var$mightBeDirty(child));
    const parentWasClean = !$4de01fecd524cd43$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $4de01fecd524cd43$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $4de01fecd524cd43$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $4de01fecd524cd43$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $4de01fecd524cd43$var$assert(parent.childValues.has(child));
    $4de01fecd524cd43$var$assert(!$4de01fecd524cd43$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $4de01fecd524cd43$var$valueCopy(child.value));
    else if (!$4de01fecd524cd43$var$valueIs(childValue, child.value)) parent.setDirty();
    $4de01fecd524cd43$var$removeDirtyChild(parent, child);
    if ($4de01fecd524cd43$var$mightBeDirty(parent)) return;
    $4de01fecd524cd43$var$reportClean(parent);
}
function $4de01fecd524cd43$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($4de01fecd524cd43$var$emptySetPool.length < $4de01fecd524cd43$var$POOL_TARGET_SIZE) $4de01fecd524cd43$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $4de01fecd524cd43$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $4de01fecd524cd43$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $4de01fecd524cd43$var$assert(parent.dirtyChildren === null);
}
function $4de01fecd524cd43$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $4de01fecd524cd43$var$removeDirtyChild(parent, child);
}
function $4de01fecd524cd43$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $hbqcg.maybeUnsubscribe)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

});
parcelRegister("kvSSw", function(module, exports) {

$parcel$export(module.exports, "parentEntrySlot", () => $eef1459de4b62589$export$11fa9682b6ba79b1);
$parcel$export(module.exports, "Slot", () => (parcelRequire("j3PV9")).Slot);
parcelRequire("7RiYT");
var $j3PV9 = parcelRequire("j3PV9");
const $eef1459de4b62589$export$11fa9682b6ba79b1 = new (0, $j3PV9.Slot)();
function $eef1459de4b62589$export$d906efd39458576(fn) {
    return $eef1459de4b62589$export$11fa9682b6ba79b1.withValue(void 0, fn);
}

});
parcelRegister("7RiYT", function(module, exports) {

$parcel$export(module.exports, "Slot", () => (parcelRequire("j3PV9")).Slot);

var $j3PV9 = parcelRequire("j3PV9");
const { bind: $5b8c34eac8e779f7$export$2385a24977818dd0, noContext: $5b8c34eac8e779f7$export$9fa6f2e300a97f8 } = (0, $j3PV9.Slot);
function $5b8c34eac8e779f7$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($5b8c34eac8e779f7$export$2385a24977818dd0(callback), delay);
}
function $5b8c34eac8e779f7$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $5b8c34eac8e779f7$export$2385a24977818dd0(gen.next);
        const boundThrow = $5b8c34eac8e779f7$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($5b8c34eac8e779f7$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $5b8c34eac8e779f7$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $5b8c34eac8e779f7$var$wrappedFibers = [];
function $5b8c34eac8e779f7$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($5b8c34eac8e779f7$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $5b8c34eac8e779f7$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $5b8c34eac8e779f7$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});
parcelRegister("j3PV9", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $de06928656dd882a$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $de06928656dd882a$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $de06928656dd882a$var$MISSING_VALUE = {};
let $de06928656dd882a$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $de06928656dd882a$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $de06928656dd882a$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $de06928656dd882a$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $de06928656dd882a$var$MISSING_VALUE) break;
                if (context !== $de06928656dd882a$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $de06928656dd882a$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($de06928656dd882a$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $de06928656dd882a$var$currentContext.slots[this.id] = $de06928656dd882a$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $de06928656dd882a$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $de06928656dd882a$var$currentContext;
            $de06928656dd882a$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $de06928656dd882a$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $de06928656dd882a$var$currentContext;
            return function() {
                const saved = $de06928656dd882a$var$currentContext;
                try {
                    $de06928656dd882a$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $de06928656dd882a$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($de06928656dd882a$var$currentContext) {
                const saved = $de06928656dd882a$var$currentContext;
                try {
                    $de06928656dd882a$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $de06928656dd882a$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $de06928656dd882a$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $de06928656dd882a$var$globalKey = "@wry/context:Slot";
const $de06928656dd882a$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$de06928656dd882a$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$de06928656dd882a$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $de06928656dd882a$var$globalHost = $de06928656dd882a$var$host;
const $de06928656dd882a$export$8c6ed5c666ac1360 = $de06928656dd882a$var$globalHost[$de06928656dd882a$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$de06928656dd882a$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($de06928656dd882a$var$globalHost, $de06928656dd882a$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($de06928656dd882a$var$makeSlotClass());

});



parcelRegister("hbqcg", function(module, exports) {

$parcel$export(module.exports, "hasOwnProperty", () => $c827c8ddaed71aaf$export$5a15a386532a5ea4);
$parcel$export(module.exports, "arrayFromSet", () => $c827c8ddaed71aaf$export$1eb72f2488cedd93);
$parcel$export(module.exports, "maybeUnsubscribe", () => $c827c8ddaed71aaf$export$50527b97338c0f71);
const { hasOwnProperty: $c827c8ddaed71aaf$export$5a15a386532a5ea4 } = Object.prototype;
const $c827c8ddaed71aaf$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $c827c8ddaed71aaf$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

});


parcelRegister("4OdSC", function(module, exports) {

$parcel$export(module.exports, "dep", () => $38069937531449fe$export$c723b7eff9d8f870);

var $kvSSw = parcelRequire("kvSSw");

var $hbqcg = parcelRequire("hbqcg");
const $38069937531449fe$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $38069937531449fe$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $kvSSw.parentEntrySlot).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $hbqcg.maybeUnsubscribe)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $hbqcg.hasOwnProperty).call($38069937531449fe$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $hbqcg.arrayFromSet)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $hbqcg.maybeUnsubscribe)(dep);
        }
    };
    return depend;
}

});


parcelRegister("5nLer", function(module, exports) {

$parcel$export(module.exports, "equal", () => $3eb3bd060aae91b6$export$411ce8e5a71e3069);
$parcel$export(module.exports, "default", () => $3eb3bd060aae91b6$export$2e2bcd8739ae039);
const { toString: $3eb3bd060aae91b6$var$toString, hasOwnProperty: $3eb3bd060aae91b6$var$hasOwnProperty } = Object.prototype;
const $3eb3bd060aae91b6$var$fnToStr = Function.prototype.toString;
const $3eb3bd060aae91b6$var$previousComparisons = new Map();
function $3eb3bd060aae91b6$export$411ce8e5a71e3069(a, b) {
    try {
        return $3eb3bd060aae91b6$var$check(a, b);
    } finally{
        $3eb3bd060aae91b6$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$3eb3bd060aae91b6$export$2e2bcd8739ae039 = $3eb3bd060aae91b6$export$411ce8e5a71e3069;
function $3eb3bd060aae91b6$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $3eb3bd060aae91b6$var$toString.call(a);
    const bTag = $3eb3bd060aae91b6$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            {
                if ($3eb3bd060aae91b6$var$previouslyCompared(a, b)) return true;
                const aKeys = $3eb3bd060aae91b6$var$definedKeys(a);
                const bKeys = $3eb3bd060aae91b6$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$3eb3bd060aae91b6$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$3eb3bd060aae91b6$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]':
            {
                if (a.size !== b.size) return false;
                if ($3eb3bd060aae91b6$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === '[object Map]';
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$3eb3bd060aae91b6$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            {
                const aCode = $3eb3bd060aae91b6$var$fnToStr.call(a);
                if (aCode !== $3eb3bd060aae91b6$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$3eb3bd060aae91b6$var$endsWith(aCode, $3eb3bd060aae91b6$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $3eb3bd060aae91b6$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($3eb3bd060aae91b6$var$isDefinedKey, obj);
}
function $3eb3bd060aae91b6$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $3eb3bd060aae91b6$var$nativeCodeSuffix = "{ [native code] }";
function $3eb3bd060aae91b6$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $3eb3bd060aae91b6$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $3eb3bd060aae91b6$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $3eb3bd060aae91b6$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}

});

parcelRegister("4kIqK", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $327b7ea4271a8c53$export$5fc74f25506aa9c);

var $5Rzv1 = parcelRequire("5Rzv1");

var $elxhT = parcelRequire("elxhT");

var $6cKaj = parcelRequire("6cKaj");
var $aPfFa = parcelRequire("aPfFa");
var $2BGiW = parcelRequire("2BGiW");
var $9waFp = parcelRequire("9waFp");
var $4YPPO = parcelRequire("4YPPO");parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");

var $fBtNg = parcelRequire("fBtNg");

var $bCfQ0 = parcelRequire("bCfQ0");

var $iKyVm = parcelRequire("iKyVm");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $9HcNb = parcelRequire("9HcNb");
var $327b7ea4271a8c53$export$5fc74f25506aa9c = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, $elxhT.wrap)((0, $2BGiW.getFragmentQueryDocument), {
            max: (0, $6cKaj.cacheSizes)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, $fBtNg.WeakCache)
        });
    }
    // Function used to lookup a fragment when a fragment definition is not part
    // of the GraphQL document. This is useful for caches, such as InMemoryCache,
    // that register fragments ahead of time so they can be referenced by name.
    ApolloCache.prototype.lookupFragment = function(fragmentName) {
        return null;
    };
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        var _this = this;
        if (optimistic === void 0) optimistic = !!options.optimistic;
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnRemovedOption)(options, "canonizeResults", "cache.readQuery");
        return (0, $4YPPO.muteDeprecations)("canonizeResults", function() {
            return _this.read((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
                rootId: options.id || "ROOT_QUERY",
                optimistic: optimistic
            }));
        });
    };
    /** {@inheritDoc @apollo/client!ApolloClient#watchFragment:member(1)} */ ApolloCache.prototype.watchFragment = function(options) {
        var _this = this;
        var fragment = options.fragment, fragmentName = options.fragmentName, from = options.from, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, otherOptions = (0, $5Rzv1.__rest)(options, [
            "fragment",
            "fragmentName",
            "from",
            "optimistic"
        ]);
        var query = this.getFragmentDoc(fragment, fragmentName);
        // While our TypeScript types do not allow for `undefined` as a valid
        // `from`, its possible `useFragment` gives us an `undefined` since it
        // calls` cache.identify` and provides that value to `from`. We are
        // adding this fix here however to ensure those using plain JavaScript
        // and using `cache.identify` themselves will avoid seeing the obscure
        // warning.
        var id = typeof from === "undefined" || typeof from === "string" ? from : this.identify(from);
        var dataMasking = !!options[Symbol.for("apollo.dataMasking")];
        if (globalThis.__DEV__ !== false) {
            var actualFragmentName = fragmentName || (0, $aPfFa.getFragmentDefinition)(fragment).name.value;
            if (!id) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(1, actualFragmentName);
        }
        var diffOptions = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, otherOptions), {
            returnPartialData: true,
            id: id,
            query: query,
            optimistic: optimistic
        });
        var latestDiff;
        return new (0, $1ieNy.Observable)(function(observer) {
            return _this.watch((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, diffOptions), {
                immediate: true,
                callback: function(diff) {
                    var data = dataMasking ? (0, $9HcNb.maskFragment)(diff.result, fragment, _this, fragmentName) : diff.result;
                    if (// Always ensure we deliver the first result
                    latestDiff && (0, $iKyVm.equalByQuery)(query, {
                        data: latestDiff.result
                    }, {
                        data: data
                    }, // TODO: Fix the type on WatchFragmentOptions so that TVars
                    // extends OperationVariables
                    options.variables)) return;
                    var result = {
                        data: data,
                        complete: !!diff.complete
                    };
                    if (diff.missing) result.missing = (0, $9waFp.mergeDeepArray)(diff.missing.map(function(error) {
                        return error.missing;
                    }));
                    latestDiff = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, diff), {
                        result: data
                    });
                    observer.next(result);
                }
            }));
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        var _this = this;
        if (optimistic === void 0) optimistic = !!options.optimistic;
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnRemovedOption)(options, "canonizeResults", "cache.readFragment");
        return (0, $4YPPO.muteDeprecations)("canonizeResults", function() {
            return _this.read((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
                query: _this.getFragmentDoc(options.fragment, options.fragmentName),
                rootId: options.id,
                optimistic: optimistic
            }));
        });
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $5Rzv1.__rest)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $5Rzv1.__rest)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnRemovedOption)(options, "canonizeResults", "cache.updateQuery");
        return this.batch({
            update: function(cache) {
                var value = (0, $4YPPO.muteDeprecations)("canonizeResults", function() {
                    return cache.readQuery(options);
                });
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnRemovedOption)(options, "canonizeResults", "cache.updateFragment");
        return this.batch({
            update: function(cache) {
                var value = (0, $4YPPO.muteDeprecations)("canonizeResults", function() {
                    return cache.readFragment(options);
                });
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) $327b7ea4271a8c53$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $bCfQ0.getApolloCacheMemoryInternals);

});
parcelRegister("6cKaj", function(module, exports) {

$parcel$export(module.exports, "cacheSizes", () => $4847ac86ad88159c$export$f29926b23b28936b);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $iXyoi = parcelRequire("iXyoi");
var $4847ac86ad88159c$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $4847ac86ad88159c$export$f29926b23b28936b = (0, $5Rzv1.__assign)({}, (0, $iXyoi.default)[$4847ac86ad88159c$var$cacheSizeSymbol]);

});

parcelRegister("aPfFa", function(module, exports) {

$parcel$export(module.exports, "checkDocument", () => $7e1ad12709440e4b$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $7e1ad12709440e4b$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $7e1ad12709440e4b$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $7e1ad12709440e4b$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $7e1ad12709440e4b$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getFragmentDefinition", () => $7e1ad12709440e4b$export$772111caef41b3f5);
$parcel$export(module.exports, "getMainDefinition", () => $7e1ad12709440e4b$export$f431198736b7f96d);
$parcel$export(module.exports, "getDefaultValues", () => $7e1ad12709440e4b$export$84c19026e616569e);
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $eSohM = parcelRequire("eSohM");
function $7e1ad12709440e4b$export$a7d0d8111d2386df(doc) {
    (0, $jWokI.invariant)(doc && doc.kind === "Document", 115);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $jWokI.newInvariantError)(116, definition.kind);
        return definition;
    });
    (0, $jWokI.invariant)(operations.length <= 1, 117, operations.length);
    return doc;
}
function $7e1ad12709440e4b$export$7a5b1fa979d2c158(doc) {
    $7e1ad12709440e4b$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $7e1ad12709440e4b$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $7e1ad12709440e4b$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $7e1ad12709440e4b$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $7e1ad12709440e4b$export$7a5b1fa979d2c158(doc);
    (0, $jWokI.invariant)(queryDef && queryDef.operation === "query", 118);
    return queryDef;
}
function $7e1ad12709440e4b$export$772111caef41b3f5(doc) {
    (0, $jWokI.invariant)(doc.kind === "Document", 119);
    (0, $jWokI.invariant)(doc.definitions.length <= 1, 120);
    var fragmentDef = doc.definitions[0];
    (0, $jWokI.invariant)(fragmentDef.kind === "FragmentDefinition", 121);
    return fragmentDef;
}
function $7e1ad12709440e4b$export$f431198736b7f96d(queryDoc) {
    $7e1ad12709440e4b$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $jWokI.newInvariantError)(122);
}
function $7e1ad12709440e4b$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $eSohM.valueToObjectRepresentation)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}

});
parcelRegister("eSohM", function(module, exports) {

$parcel$export(module.exports, "makeReference", () => $ad48f276bdd15721$export$634ae0e932e9be99);
$parcel$export(module.exports, "isReference", () => $ad48f276bdd15721$export$fa99cac1c0883c47);
$parcel$export(module.exports, "isDocumentNode", () => $ad48f276bdd15721$export$540432d49fcec6c9);
$parcel$export(module.exports, "valueToObjectRepresentation", () => $ad48f276bdd15721$export$a1dab82d368d6525);
$parcel$export(module.exports, "storeKeyNameFromField", () => $ad48f276bdd15721$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $ad48f276bdd15721$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $ad48f276bdd15721$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $ad48f276bdd15721$export$7d1ad22471852218);
$parcel$export(module.exports, "getTypenameFromResult", () => $ad48f276bdd15721$export$cf7bf7e4f289cc26);
$parcel$export(module.exports, "isField", () => $ad48f276bdd15721$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $ad48f276bdd15721$export$22a1cdafaf27bcff);
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $9qEGC = parcelRequire("9qEGC");

var $2BGiW = parcelRequire("2BGiW");

var $7Szzy = parcelRequire("7Szzy");
function $ad48f276bdd15721$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $ad48f276bdd15721$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $ad48f276bdd15721$export$540432d49fcec6c9(value) {
    return (0, $9qEGC.isNonNullObject)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $ad48f276bdd15721$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $ad48f276bdd15721$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $ad48f276bdd15721$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $ad48f276bdd15721$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $ad48f276bdd15721$var$isVariable(value) {
    return value.kind === "Variable";
}
function $ad48f276bdd15721$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $ad48f276bdd15721$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $ad48f276bdd15721$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $ad48f276bdd15721$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $ad48f276bdd15721$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($ad48f276bdd15721$var$isIntValue(value) || $ad48f276bdd15721$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($ad48f276bdd15721$var$isBooleanValue(value) || $ad48f276bdd15721$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($ad48f276bdd15721$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $ad48f276bdd15721$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($ad48f276bdd15721$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($ad48f276bdd15721$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $ad48f276bdd15721$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($ad48f276bdd15721$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($ad48f276bdd15721$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $jWokI.newInvariantError)(123, name.value, value.kind);
}
function $ad48f276bdd15721$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $ad48f276bdd15721$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $ad48f276bdd15721$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $ad48f276bdd15721$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $ad48f276bdd15721$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $ad48f276bdd15721$var$storeKeyNameStringify = (0, $7Szzy.canonicalStringify);
var $ad48f276bdd15721$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($ad48f276bdd15721$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $ad48f276bdd15721$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($ad48f276bdd15721$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($ad48f276bdd15721$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $ad48f276bdd15721$var$storeKeyNameStringify;
        $ad48f276bdd15721$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $ad48f276bdd15721$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $ad48f276bdd15721$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $ad48f276bdd15721$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $ad48f276bdd15721$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($ad48f276bdd15721$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$ad48f276bdd15721$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $ad48f276bdd15721$export$cf7bf7e4f289cc26(result, (0, $2BGiW.getFragmentFromSelection)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $ad48f276bdd15721$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $ad48f276bdd15721$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}

});
parcelRegister("9qEGC", function(module, exports) {

$parcel$export(module.exports, "isNonNullObject", () => $6dd61a39c845d32c$export$417207af72fad9c9);
function $6dd61a39c845d32c$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $6dd61a39c845d32c$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}

});

parcelRegister("2BGiW", function(module, exports) {

$parcel$export(module.exports, "getFragmentQueryDocument", () => $1e5fda48bb4a6f3a$export$abbf37c7cf644e41);
$parcel$export(module.exports, "createFragmentMap", () => $1e5fda48bb4a6f3a$export$193789b4c8246dd4);
$parcel$export(module.exports, "getFragmentFromSelection", () => $1e5fda48bb4a6f3a$export$f80bdb85f299186);
$parcel$export(module.exports, "isFullyUnmaskedOperation", () => $1e5fda48bb4a6f3a$export$5b84f3d7865d4e49);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $1Ojkk = parcelRequire("1Ojkk");
function $1e5fda48bb4a6f3a$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $jWokI.newInvariantError)(112, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $jWokI.invariant)(fragments.length === 1, 113, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, document), {
        definitions: (0, $5Rzv1.__spreadArray)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $1e5fda48bb4a6f3a$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $1e5fda48bb4a6f3a$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $jWokI.invariant)(fragment, 114, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}
function $1e5fda48bb4a6f3a$export$5b84f3d7865d4e49(document) {
    var isUnmasked = true;
    (0, $1Ojkk.visit)(document, {
        FragmentSpread: function(node) {
            isUnmasked = !!node.directives && node.directives.some(function(directive) {
                return directive.name.value === "unmask";
            });
            if (!isUnmasked) return 0, $1Ojkk.BREAK;
        }
    });
    return isUnmasked;
}

});
parcelRegister("1Ojkk", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $df19bbc52fd7fc45$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $df19bbc52fd7fc45$export$bf638b60ea8b89b7);

var $bsv6R = parcelRequire("bsv6R");

var $lWXTg = parcelRequire("lWXTg");

var $7yAwh = parcelRequire("7yAwh");

var $4ceQ1 = parcelRequire("4ceQ1");
const $df19bbc52fd7fc45$export$a89c95c098ac2a58 = Object.freeze({});
function $df19bbc52fd7fc45$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $7yAwh.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $4ceQ1.Kind)))enterLeaveMap.set(kind, $df19bbc52fd7fc45$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = {
                        ...node
                    };
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $7yAwh.isNode)(node) || (0, $bsv6R.devAssert)(false, `Invalid AST Node: ${(0, $lWXTg.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $df19bbc52fd7fc45$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $7yAwh.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $df19bbc52fd7fc45$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $4ceQ1.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $df19bbc52fd7fc45$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $df19bbc52fd7fc45$export$a89c95c098ac2a58) skipping[i] = $df19bbc52fd7fc45$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $df19bbc52fd7fc45$export$a89c95c098ac2a58) skipping[i] = $df19bbc52fd7fc45$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $df19bbc52fd7fc45$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $df19bbc52fd7fc45$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $df19bbc52fd7fc45$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}

});
parcelRegister("bsv6R", function(module, exports) {

$parcel$export(module.exports, "devAssert", () => $a09588a8b7106276$export$b6cb5906f04696c8);
function $a09588a8b7106276$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("lWXTg", function(module, exports) {

$parcel$export(module.exports, "inspect", () => $30bfaafd6fdbbdb0$export$9dec5d1b3b6a130d);
const $30bfaafd6fdbbdb0$var$MAX_ARRAY_LENGTH = 10;
const $30bfaafd6fdbbdb0$var$MAX_RECURSIVE_DEPTH = 2;
function $30bfaafd6fdbbdb0$export$9dec5d1b3b6a130d(value) {
    return $30bfaafd6fdbbdb0$var$formatValue(value, []);
}
function $30bfaafd6fdbbdb0$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $30bfaafd6fdbbdb0$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $30bfaafd6fdbbdb0$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($30bfaafd6fdbbdb0$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $30bfaafd6fdbbdb0$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $30bfaafd6fdbbdb0$var$formatArray(value, seenValues);
    return $30bfaafd6fdbbdb0$var$formatObject(value, seenValues);
}
function $30bfaafd6fdbbdb0$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $30bfaafd6fdbbdb0$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $30bfaafd6fdbbdb0$var$MAX_RECURSIVE_DEPTH) return '[' + $30bfaafd6fdbbdb0$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $30bfaafd6fdbbdb0$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $30bfaafd6fdbbdb0$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $30bfaafd6fdbbdb0$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($30bfaafd6fdbbdb0$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($30bfaafd6fdbbdb0$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $30bfaafd6fdbbdb0$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});

parcelRegister("7yAwh", function(module, exports) {

$parcel$export(module.exports, "QueryDocumentKeys", () => $1ef2741e129d199d$export$4fcd777a40ccf407);
$parcel$export(module.exports, "isNode", () => $1ef2741e129d199d$export$8ee0fc9ee280b4ee);
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $1ef2741e129d199d$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $1ef2741e129d199d$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $1ef2741e129d199d$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'description',
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'directives',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    DirectiveExtension: [
        'name',
        'directives'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    TypeCoordinate: [
        'name'
    ],
    MemberCoordinate: [
        'name',
        'memberName'
    ],
    ArgumentCoordinate: [
        'name',
        'fieldName',
        'argumentName'
    ],
    DirectiveCoordinate: [
        'name'
    ],
    DirectiveArgumentCoordinate: [
        'name',
        'argumentName'
    ]
};
const $1ef2741e129d199d$var$kindValues = new Set(Object.keys($1ef2741e129d199d$export$4fcd777a40ccf407));
function $1ef2741e129d199d$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $1ef2741e129d199d$var$kindValues.has(maybeKind);
}
/** Name */ var $1ef2741e129d199d$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($1ef2741e129d199d$export$f58c50edb4aef9d4 || ($1ef2741e129d199d$export$f58c50edb4aef9d4 = {}));

});

parcelRegister("4ceQ1", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $bcdf5c5102ae670d$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $bcdf5c5102ae670d$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['DIRECTIVE_EXTENSION'] = 'DirectiveExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
    Kind['TYPE_COORDINATE'] = 'TypeCoordinate';
    Kind['MEMBER_COORDINATE'] = 'MemberCoordinate';
    Kind['ARGUMENT_COORDINATE'] = 'ArgumentCoordinate';
    Kind['DIRECTIVE_COORDINATE'] = 'DirectiveCoordinate';
    Kind['DIRECTIVE_ARGUMENT_COORDINATE'] = 'DirectiveArgumentCoordinate';
})($bcdf5c5102ae670d$export$a84bdc57c5122798 || ($bcdf5c5102ae670d$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});



parcelRegister("7Szzy", function(module, exports) {

$parcel$export(module.exports, "canonicalStringify", () => $5bc92b8476ef6dc8$export$88a0ad9b6f961b51);

var $gPdQG = parcelRequire("gPdQG");
var $6cKaj = parcelRequire("6cKaj");

var $bCfQ0 = parcelRequire("bCfQ0");
var $5bc92b8476ef6dc8$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $5bc92b8476ef6dc8$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $5bc92b8476ef6dc8$var$sortingMap = new (0, $gPdQG.AutoCleanedStrongCache)((0, $6cKaj.cacheSizes).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $bCfQ0.registerGlobalCache)("canonicalStringify", function() {
    return $5bc92b8476ef6dc8$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $5bc92b8476ef6dc8$var$sortingMap;
$5bc92b8476ef6dc8$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $5bc92b8476ef6dc8$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($5bc92b8476ef6dc8$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $5bc92b8476ef6dc8$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $5bc92b8476ef6dc8$var$sortingMap.get(sortedKey) || keys;
                $5bc92b8476ef6dc8$var$sortingMap.set(unsortedKey, sortedKeys);
                $5bc92b8476ef6dc8$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $5bc92b8476ef6dc8$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}

});
parcelRegister("gPdQG", function(module, exports) {

$parcel$export(module.exports, "AutoCleanedWeakCache", () => $03293a6ed3e8d29a$export$8dbad6f439bb2331);
$parcel$export(module.exports, "AutoCleanedStrongCache", () => $03293a6ed3e8d29a$export$5b4f745137d91413);

var $dtVfu = parcelRequire("dtVfu");
var $fBtNg = parcelRequire("fBtNg");
var $03293a6ed3e8d29a$var$scheduledCleanup = new WeakSet();
function $03293a6ed3e8d29a$var$schedule(cache) {
    if (cache.size <= (cache.max || -1)) return;
    if (!$03293a6ed3e8d29a$var$scheduledCleanup.has(cache)) {
        $03293a6ed3e8d29a$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $03293a6ed3e8d29a$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $03293a6ed3e8d29a$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $fBtNg.WeakCache)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $fBtNg.WeakCache).prototype.set.call(this, key, value);
        $03293a6ed3e8d29a$var$schedule(this);
        return ret;
    };
    return cache;
};
var $03293a6ed3e8d29a$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $dtVfu.StrongCache)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $dtVfu.StrongCache).prototype.set.call(this, key, value);
        $03293a6ed3e8d29a$var$schedule(this);
        return ret;
    };
    return cache;
};

});
parcelRegister("fBtNg", function(module, exports) {

$parcel$export(module.exports, "WeakCache", () => $b5c16c1908fda4ff$export$87b462129af3b7d4);
function $b5c16c1908fda4ff$var$noop() {}
const $b5c16c1908fda4ff$var$defaultDispose = $b5c16c1908fda4ff$var$noop;
const $b5c16c1908fda4ff$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $b5c16c1908fda4ff$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $b5c16c1908fda4ff$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $b5c16c1908fda4ff$var$noop,
        unregister: $b5c16c1908fda4ff$var$noop
    };
};
const $b5c16c1908fda4ff$var$finalizationBatchSize = 10024;
class $b5c16c1908fda4ff$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $b5c16c1908fda4ff$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $b5c16c1908fda4ff$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $b5c16c1908fda4ff$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $b5c16c1908fda4ff$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $b5c16c1908fda4ff$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}

});


parcelRegister("bCfQ0", function(module, exports) {

$parcel$export(module.exports, "registerGlobalCache", () => $874f8765fcb16f7a$export$a8fcd406d9e37621);
$parcel$export(module.exports, "getApolloClientMemoryInternals", () => $874f8765fcb16f7a$export$dfdba94ce46d2ea5);
$parcel$export(module.exports, "getInMemoryCacheMemoryInternals", () => $874f8765fcb16f7a$export$e95a5a2210e62466);
$parcel$export(module.exports, "getApolloCacheMemoryInternals", () => $874f8765fcb16f7a$export$e7ed438e82606689);

var $5Rzv1 = parcelRequire("5Rzv1");

var $6cKaj = parcelRequire("6cKaj");
var $874f8765fcb16f7a$var$globalCaches = {};
function $874f8765fcb16f7a$export$a8fcd406d9e37621(name, getSize) {
    $874f8765fcb16f7a$var$globalCaches[name] = getSize;
}
var $874f8765fcb16f7a$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $874f8765fcb16f7a$var$_getApolloClientMemoryInternals : undefined;
var $874f8765fcb16f7a$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $874f8765fcb16f7a$var$_getInMemoryCacheMemoryInternals : undefined;
var $874f8765fcb16f7a$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $874f8765fcb16f7a$var$_getApolloCacheMemoryInternals : undefined;
function $874f8765fcb16f7a$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $6cKaj.cacheSizes)[k] || v
        ];
    }));
}
function $874f8765fcb16f7a$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $874f8765fcb16f7a$var$getCurrentCacheSizes(),
        sizes: (0, $5Rzv1.__assign)({
            print: (_a = $874f8765fcb16f7a$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($874f8765fcb16f7a$var$globalCaches),
            parser: (_b = $874f8765fcb16f7a$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($874f8765fcb16f7a$var$globalCaches),
            canonicalStringify: (_c = $874f8765fcb16f7a$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($874f8765fcb16f7a$var$globalCaches),
            links: $874f8765fcb16f7a$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $874f8765fcb16f7a$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $874f8765fcb16f7a$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $874f8765fcb16f7a$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $874f8765fcb16f7a$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, $874f8765fcb16f7a$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $874f8765fcb16f7a$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $874f8765fcb16f7a$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $874f8765fcb16f7a$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $874f8765fcb16f7a$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $874f8765fcb16f7a$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $874f8765fcb16f7a$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $874f8765fcb16f7a$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $874f8765fcb16f7a$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $874f8765fcb16f7a$var$getWrapperInformation(f) {
    return $874f8765fcb16f7a$var$isWrapper(f) ? f.size : undefined;
}
function $874f8765fcb16f7a$var$isDefined(value) {
    return value != null;
}
function $874f8765fcb16f7a$var$transformInfo(transform) {
    return $874f8765fcb16f7a$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $874f8765fcb16f7a$var$recurseTransformInfo(transform) {
    return transform ? (0, $5Rzv1.__spreadArray)((0, $5Rzv1.__spreadArray)([
        $874f8765fcb16f7a$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $874f8765fcb16f7a$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $874f8765fcb16f7a$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($874f8765fcb16f7a$var$isDefined) : [];
}
function $874f8765fcb16f7a$var$linkInfo(link) {
    var _a;
    return link ? (0, $5Rzv1.__spreadArray)((0, $5Rzv1.__spreadArray)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $874f8765fcb16f7a$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $874f8765fcb16f7a$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($874f8765fcb16f7a$var$isDefined) : [];
}

});




parcelRegister("9waFp", function(module, exports) {

$parcel$export(module.exports, "mergeDeep", () => $6edf606bc69f4672$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $6edf606bc69f4672$export$160070228be94b08);
$parcel$export(module.exports, "DeepMerger", () => $6edf606bc69f4672$export$509e11c221f576c0);

var $5Rzv1 = parcelRequire("5Rzv1");

var $9qEGC = parcelRequire("9qEGC");
var $6edf606bc69f4672$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6edf606bc69f4672$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $6edf606bc69f4672$export$160070228be94b08(sources);
}
function $6edf606bc69f4672$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $6edf606bc69f4672$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $6edf606bc69f4672$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $6edf606bc69f4672$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $6edf606bc69f4672$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $9qEGC.isNonNullObject);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $9qEGC.isNonNullObject)(source) && (0, $9qEGC.isNonNullObject)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($6edf606bc69f4672$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $5Rzv1.__spreadArray)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $9qEGC.isNonNullObject)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $5Rzv1.__assign)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();

});

parcelRegister("4YPPO", function(module, exports) {

$parcel$export(module.exports, "muteDeprecations", () => $3a04f950b7b2c628$export$d18d1529326946c4);
$parcel$export(module.exports, "warnRemovedOption", () => $3a04f950b7b2c628$export$6d0d09df4c29a84a);
$parcel$export(module.exports, "warnDeprecated", () => $3a04f950b7b2c628$export$606a5c06d13e04b6);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("elxhT");
var $j3PV9 = parcelRequire("j3PV9");
parcelRequire("7aKgP");
var $iXyoi = parcelRequire("iXyoi");
var $jWokI = parcelRequire("jWokI");
var $3a04f950b7b2c628$var$_a;
var $3a04f950b7b2c628$var$muteAllDeprecations = Symbol.for("apollo.deprecations");
var $3a04f950b7b2c628$var$deprecationsSlot = Symbol.for("apollo.deprecations.slot");
var $3a04f950b7b2c628$var$global = (0, $iXyoi.default);
var $3a04f950b7b2c628$var$slot = ($3a04f950b7b2c628$var$_a = $3a04f950b7b2c628$var$global[$3a04f950b7b2c628$var$deprecationsSlot]) !== null && $3a04f950b7b2c628$var$_a !== void 0 ? $3a04f950b7b2c628$var$_a : $3a04f950b7b2c628$var$global[$3a04f950b7b2c628$var$deprecationsSlot] = new (0, $j3PV9.Slot)();
function $3a04f950b7b2c628$var$isMuted(name) {
    return $3a04f950b7b2c628$var$global[$3a04f950b7b2c628$var$muteAllDeprecations] || ($3a04f950b7b2c628$var$slot.getValue() || []).includes(name);
}
function $3a04f950b7b2c628$export$d18d1529326946c4(name) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $3a04f950b7b2c628$var$slot.withValue.apply($3a04f950b7b2c628$var$slot, (0, $5Rzv1.__spreadArray)([
        Array.isArray(name) ? name : [
            name
        ]
    ], args, false));
}
function $3a04f950b7b2c628$export$6d0d09df4c29a84a(options, name, callSite, recommendation) {
    if (recommendation === void 0) recommendation = "Please remove this option.";
    $3a04f950b7b2c628$export$606a5c06d13e04b6(name, function() {
        if (name in options) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(103, callSite, name, recommendation);
    });
}
function $3a04f950b7b2c628$export$606a5c06d13e04b6(name, cb) {
    if (!$3a04f950b7b2c628$var$isMuted(name)) cb();
}

});

parcelRegister("fu5HQ", function(module, exports) {

$parcel$export(module.exports, "Observable", () => (parcelRequire("1ieNy")).Observable);

var $1ieNy = parcelRequire("1ieNy");
parcelRequire("8kbu1");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $b45e1579579014b9$var$prototype = (0, $1ieNy.Observable).prototype;
var $b45e1579579014b9$var$fakeObsSymbol = "@@observable";
if (!$b45e1579579014b9$var$prototype[$b45e1579579014b9$var$fakeObsSymbol]) // @ts-expect-error
$b45e1579579014b9$var$prototype[$b45e1579579014b9$var$fakeObsSymbol] = function() {
    return this;
};

});
parcelRegister("1ieNy", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $0f12f381940f3db7$export$77cea355fa80b5f4);
function $0f12f381940f3db7$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0f12f381940f3db7$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0f12f381940f3db7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0f12f381940f3db7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0f12f381940f3db7$var$_arrayLikeToArray(o, minLen);
}
function $0f12f381940f3db7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0f12f381940f3db7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0f12f381940f3db7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0f12f381940f3db7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0f12f381940f3db7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $0f12f381940f3db7$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $0f12f381940f3db7$var$hasSymbol = function(name) {
    return $0f12f381940f3db7$var$hasSymbols() && Boolean(Symbol[name]);
};
var $0f12f381940f3db7$var$getSymbol = function(name) {
    return $0f12f381940f3db7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($0f12f381940f3db7$var$hasSymbols() && !$0f12f381940f3db7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $0f12f381940f3db7$var$SymbolIterator = $0f12f381940f3db7$var$getSymbol('iterator');
var $0f12f381940f3db7$var$SymbolObservable = $0f12f381940f3db7$var$getSymbol('observable');
var $0f12f381940f3db7$var$SymbolSpecies = $0f12f381940f3db7$var$getSymbol('species'); // === Abstract Operations ===
function $0f12f381940f3db7$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $0f12f381940f3db7$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$0f12f381940f3db7$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $0f12f381940f3db7$export$77cea355fa80b5f4;
}
function $0f12f381940f3db7$var$isObservable(x) {
    return x instanceof $0f12f381940f3db7$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $0f12f381940f3db7$var$hostReportError(e) {
    if ($0f12f381940f3db7$var$hostReportError.log) $0f12f381940f3db7$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $0f12f381940f3db7$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $0f12f381940f3db7$var$hostReportError(e);
        }
    });
}
function $0f12f381940f3db7$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $0f12f381940f3db7$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $0f12f381940f3db7$var$hostReportError(e);
    }
}
function $0f12f381940f3db7$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $0f12f381940f3db7$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $0f12f381940f3db7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $0f12f381940f3db7$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $0f12f381940f3db7$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $0f12f381940f3db7$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $0f12f381940f3db7$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $0f12f381940f3db7$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $0f12f381940f3db7$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $0f12f381940f3db7$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $0f12f381940f3db7$var$enqueue(function() {
            return $0f12f381940f3db7$var$flushSubscription(subscription);
        });
        return;
    }
    $0f12f381940f3db7$var$notifySubscription(subscription, type, value);
}
var $0f12f381940f3db7$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $0f12f381940f3db7$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $0f12f381940f3db7$var$closeSubscription(this);
            $0f12f381940f3db7$var$cleanupSubscription(this);
        }
    };
    $0f12f381940f3db7$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $0f12f381940f3db7$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $0f12f381940f3db7$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $0f12f381940f3db7$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $0f12f381940f3db7$var$onNotify(this._subscription, 'complete');
    };
    $0f12f381940f3db7$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $0f12f381940f3db7$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $0f12f381940f3db7$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $0f12f381940f3db7$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $0f12f381940f3db7$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $0f12f381940f3db7$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $0f12f381940f3db7$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $0f12f381940f3db7$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$0f12f381940f3db7$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $0f12f381940f3db7$var$getMethod(x, $0f12f381940f3db7$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($0f12f381940f3db7$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($0f12f381940f3db7$var$hasSymbol('iterator')) {
            method = $0f12f381940f3db7$var$getMethod(x, $0f12f381940f3db7$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $0f12f381940f3db7$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $0f12f381940f3db7$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $0f12f381940f3db7$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $0f12f381940f3db7$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $0f12f381940f3db7$var$_createClass(Observable, null, [
        {
            key: $0f12f381940f3db7$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($0f12f381940f3db7$var$hasSymbols()) Object.defineProperty($0f12f381940f3db7$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $0f12f381940f3db7$var$SymbolObservable,
        hostReportError: $0f12f381940f3db7$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("8kbu1", function(module, exports) {
/* global window */ 
var $duahn = parcelRequire("duahn");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $duahn.default)(root);
var $60f9194c43f0d573$export$2e2bcd8739ae039 = result;

});
parcelRegister("duahn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d160cf8e32fd3e6$export$2e2bcd8739ae039);
function $9d160cf8e32fd3e6$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});



parcelRegister("iKyVm", function(module, exports) {

$parcel$export(module.exports, "equalByQuery", () => $da679d197bee4b1f$export$5e40714c5ad44445);

var $5Rzv1 = parcelRequire("5Rzv1");

var $5nLer = parcelRequire("5nLer");

var $2BGiW = parcelRequire("2BGiW");
var $aPfFa = parcelRequire("aPfFa");
var $eSohM = parcelRequire("eSohM");
var $3nA2J = parcelRequire("3nA2J");
function $da679d197bee4b1f$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $5Rzv1.__rest)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $5Rzv1.__rest)(_b, [
        "data"
    ]);
    return (0, $5nLer.default)(aRest, bRest) && $da679d197bee4b1f$var$equalBySelectionSet((0, $aPfFa.getMainDefinition)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $2BGiW.createFragmentMap)((0, $aPfFa.getFragmentDefinitions)(query)),
        variables: variables
    });
}
function $da679d197bee4b1f$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $3nA2J.shouldInclude)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($da679d197bee4b1f$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $eSohM.isField)(selection)) {
            var resultKey = (0, $eSohM.resultKeyNameFromField)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $5nLer.default)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$da679d197bee4b1f$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $da679d197bee4b1f$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $2BGiW.getFragmentFromSelection)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($da679d197bee4b1f$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $da679d197bee4b1f$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $da679d197bee4b1f$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($da679d197bee4b1f$var$directiveIsNonreactive);
}
function $da679d197bee4b1f$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}

});
parcelRegister("3nA2J", function(module, exports) {

$parcel$export(module.exports, "shouldInclude", () => $275f7a80c01ece11$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $275f7a80c01ece11$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $275f7a80c01ece11$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentMaskMode", () => $275f7a80c01ece11$export$d6913ace4214003);
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $1Ojkk = parcelRequire("1Ojkk");
var $4ceQ1 = parcelRequire("4ceQ1");
function $275f7a80c01ece11$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $275f7a80c01ece11$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $jWokI.invariant)(evaledValue !== void 0, 105, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $275f7a80c01ece11$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $1Ojkk.visit)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $275f7a80c01ece11$export$528b5e7d8ba07fbf = function(names, root) {
    return $275f7a80c01ece11$export$2dafb573e282fe8d(names, root, false);
};
var $275f7a80c01ece11$export$ad1b63b26c1a9b76 = function(names, root) {
    return $275f7a80c01ece11$export$2dafb573e282fe8d(names, root, true);
};
function $275f7a80c01ece11$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $1Ojkk.visit)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $1Ojkk.BREAK;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $275f7a80c01ece11$export$8d1e9e5bbfa5d09a(document) {
    return document && $275f7a80c01ece11$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $275f7a80c01ece11$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $275f7a80c01ece11$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$275f7a80c01ece11$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $jWokI.invariant)(directiveArguments && directiveArguments.length === 1, 106, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $jWokI.invariant)(ifArgument.name && ifArgument.name.value === "if", 107, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $jWokI.invariant)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 108, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}
function $275f7a80c01ece11$export$d6913ace4214003(fragment) {
    var _a, _b;
    var directive = (_a = fragment.directives) === null || _a === void 0 ? void 0 : _a.find(function(_a) {
        var name = _a.name;
        return name.value === "unmask";
    });
    if (!directive) return "mask";
    var modeArg = (_b = directive.arguments) === null || _b === void 0 ? void 0 : _b.find(function(_a) {
        var name = _a.name;
        return name.value === "mode";
    });
    if (globalThis.__DEV__ !== false) {
        if (modeArg) {
            if (modeArg.value.kind === (0, $4ceQ1.Kind).VARIABLE) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(109);
            else if (modeArg.value.kind !== (0, $4ceQ1.Kind).STRING) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(110);
            else if (modeArg.value.value !== "migrate") globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(111, modeArg.value.value);
        }
    }
    if (modeArg && "value" in modeArg.value && modeArg.value.value === "migrate") return "migrate";
    return "unmask";
}

});


parcelRegister("9HcNb", function(module, exports) {

$parcel$export(module.exports, "maskFragment", () => $70f20d7f162d80b2$export$adbebb59d1aeea97);

var $4ceQ1 = parcelRequire("4ceQ1");

var $8tCCc = parcelRequire("8tCCc");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $5nLer = parcelRequire("5nLer");

var $1LRWb = parcelRequire("1LRWb");

var $2BGiW = parcelRequire("2BGiW");
var $aPfFa = parcelRequire("aPfFa");
function $70f20d7f162d80b2$export$adbebb59d1aeea97(data, document, cache, fragmentName) {
    if (!cache.fragmentMatches) {
        if (globalThis.__DEV__ !== false) (0, $8tCCc.warnOnImproperCacheImplementation)();
        return data;
    }
    var fragments = document.definitions.filter(function(node) {
        return node.kind === (0, $4ceQ1.Kind).FRAGMENT_DEFINITION;
    });
    if (typeof fragmentName === "undefined") {
        (0, $jWokI.invariant)(fragments.length === 1, 61, fragments.length);
        fragmentName = fragments[0].name.value;
    }
    var fragment = fragments.find(function(fragment) {
        return fragment.name.value === fragmentName;
    });
    (0, $jWokI.invariant)(!!fragment, 62, fragmentName);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    if ((0, $5nLer.default)(data, {})) // Return early and skip the masking algorithm if we don't have any data
    // yet. This can happen when cache.diff returns an empty object which is
    // used from watchFragment.
    return data;
    return (0, $1LRWb.maskDefinition)(data, fragment.selectionSet, {
        operationType: "fragment",
        operationName: fragment.name.value,
        fragmentMap: (0, $2BGiW.createFragmentMap)((0, $aPfFa.getFragmentDefinitions)(document)),
        cache: cache,
        mutableTargets: new (0, $8tCCc.MapImpl)(),
        knownChanged: new (0, $8tCCc.SetImpl)()
    });
}

});
parcelRegister("8tCCc", function(module, exports) {

$parcel$export(module.exports, "MapImpl", () => $62befc57038c4c0f$export$dadc3b13206cb3ad);
$parcel$export(module.exports, "SetImpl", () => $62befc57038c4c0f$export$de8324a23c9fae9a);
$parcel$export(module.exports, "disableWarningsSlot", () => $62befc57038c4c0f$export$2ddf8815a8abe8b);
$parcel$export(module.exports, "warnOnImproperCacheImplementation", () => $62befc57038c4c0f$export$f21dbf49e2bec78b);
parcelRequire("elxhT");
var $j3PV9 = parcelRequire("j3PV9");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $dx1F4 = parcelRequire("dx1F4");
var $62befc57038c4c0f$export$dadc3b13206cb3ad = (0, $dx1F4.canUseWeakMap) ? WeakMap : Map;
var $62befc57038c4c0f$export$de8324a23c9fae9a = (0, $dx1F4.canUseWeakSet) ? WeakSet : Set;
var $62befc57038c4c0f$export$2ddf8815a8abe8b = new (0, $j3PV9.Slot)();
var $62befc57038c4c0f$var$issuedWarning = false;
function $62befc57038c4c0f$export$f21dbf49e2bec78b() {
    if (!$62befc57038c4c0f$var$issuedWarning) {
        $62befc57038c4c0f$var$issuedWarning = true;
        globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(64);
    }
}

});
parcelRegister("dx1F4", function(module, exports) {

$parcel$export(module.exports, "canUseWeakMap", () => $9d9fa55eeceda36d$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "canUseWeakSet", () => $9d9fa55eeceda36d$export$7293b8a0b474028d);
$parcel$export(module.exports, "canUseSymbol", () => $9d9fa55eeceda36d$export$23ba675b4b838b92);
$parcel$export(module.exports, "canUseAsyncIteratorSymbol", () => $9d9fa55eeceda36d$export$c34f882e9f1c1637);
parcelRequire("7aKgP");
var $fRFeB = parcelRequire("fRFeB");
var $9d9fa55eeceda36d$var$isReactNative = (0, $fRFeB.maybe)(function() {
    return navigator.product;
}) == "ReactNative";
var $9d9fa55eeceda36d$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !($9d9fa55eeceda36d$var$isReactNative && !$parcel$global.HermesInternal);
var $9d9fa55eeceda36d$export$7293b8a0b474028d = typeof WeakSet === "function";
var $9d9fa55eeceda36d$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $9d9fa55eeceda36d$export$c34f882e9f1c1637 = $9d9fa55eeceda36d$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $9d9fa55eeceda36d$export$71594e8a50f746f4 = typeof (0, $fRFeB.maybe)(function() {
    return window.document.createElement;
}) === "function";
var $9d9fa55eeceda36d$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $fRFeB.maybe)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $9d9fa55eeceda36d$export$4001f6cd4a62405b = ($9d9fa55eeceda36d$export$71594e8a50f746f4 || $9d9fa55eeceda36d$var$isReactNative) && !$9d9fa55eeceda36d$var$usingJSDOM;

});


parcelRegister("1LRWb", function(module, exports) {

$parcel$export(module.exports, "maskDefinition", () => $14a40517bc96655f$export$d4ee6fea56447c82);

var $4ceQ1 = parcelRequire("4ceQ1");

var $3nA2J = parcelRequire("3nA2J");
var $2fgBC = parcelRequire("2fgBC");
var $eSohM = parcelRequire("eSohM");

var $8tCCc = parcelRequire("8tCCc");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");
function $14a40517bc96655f$export$d4ee6fea56447c82(data, selectionSet, context) {
    return (0, $8tCCc.disableWarningsSlot).withValue(true, function() {
        var masked = $14a40517bc96655f$var$maskSelectionSet(data, selectionSet, context, false);
        if (Object.isFrozen(data)) (0, $2fgBC.maybeDeepFreeze)(masked);
        return masked;
    });
}
function $14a40517bc96655f$var$getMutableTarget(data, mutableTargets) {
    if (mutableTargets.has(data)) return mutableTargets.get(data);
    var mutableTarget = Array.isArray(data) ? [] : Object.create(null);
    mutableTargets.set(data, mutableTarget);
    return mutableTarget;
}
function $14a40517bc96655f$var$maskSelectionSet(data, selectionSet, context, migration, path) {
    var _a;
    var knownChanged = context.knownChanged;
    var memo = $14a40517bc96655f$var$getMutableTarget(data, context.mutableTargets);
    if (Array.isArray(data)) {
        for(var _i = 0, _b = Array.from(data.entries()); _i < _b.length; _i++){
            var _c = _b[_i], index = _c[0], item = _c[1];
            if (item === null) {
                memo[index] = null;
                continue;
            }
            var masked = $14a40517bc96655f$var$maskSelectionSet(item, selectionSet, context, migration, globalThis.__DEV__ !== false ? "".concat(path || "", "[").concat(index, "]") : void 0);
            if (knownChanged.has(masked)) knownChanged.add(memo);
            memo[index] = masked;
        }
        return knownChanged.has(memo) ? memo : data;
    }
    for(var _d = 0, _e = selectionSet.selections; _d < _e.length; _d++){
        var selection = _e[_d];
        var value = void 0;
        // we later want to add acessor warnings to the final result
        // so we need a new object to add the accessor warning to
        if (migration) knownChanged.add(memo);
        if (selection.kind === (0, $4ceQ1.Kind).FIELD) {
            var keyName = (0, $eSohM.resultKeyNameFromField)(selection);
            var childSelectionSet = selection.selectionSet;
            value = memo[keyName] || data[keyName];
            if (value === void 0) continue;
            if (childSelectionSet && value !== null) {
                var masked = $14a40517bc96655f$var$maskSelectionSet(data[keyName], childSelectionSet, context, migration, globalThis.__DEV__ !== false ? "".concat(path || "", ".").concat(keyName) : void 0);
                if (knownChanged.has(masked)) value = masked;
            }
            if (!(globalThis.__DEV__ !== false)) memo[keyName] = value;
            if (globalThis.__DEV__ !== false) {
                if (migration && keyName !== "__typename" && // either the field is not present in the memo object
                // or it has a `get` descriptor, not a `value` descriptor
                // => it is a warning accessor and we can overwrite it
                // with another accessor
                !((_a = Object.getOwnPropertyDescriptor(memo, keyName)) === null || _a === void 0 ? void 0 : _a.value)) Object.defineProperty(memo, keyName, $14a40517bc96655f$var$getAccessorWarningDescriptor(keyName, value, path || "", context.operationName, context.operationType));
                else {
                    delete memo[keyName];
                    memo[keyName] = value;
                }
            }
        }
        if (selection.kind === (0, $4ceQ1.Kind).INLINE_FRAGMENT && (!selection.typeCondition || context.cache.fragmentMatches(selection, data.__typename))) value = $14a40517bc96655f$var$maskSelectionSet(data, selection.selectionSet, context, migration, path);
        if (selection.kind === (0, $4ceQ1.Kind).FRAGMENT_SPREAD) {
            var fragmentName = selection.name.value;
            var fragment = context.fragmentMap[fragmentName] || (context.fragmentMap[fragmentName] = context.cache.lookupFragment(fragmentName));
            (0, $jWokI.invariant)(fragment, 59, fragmentName);
            var mode = (0, $3nA2J.getFragmentMaskMode)(selection);
            if (mode !== "mask") value = $14a40517bc96655f$var$maskSelectionSet(data, fragment.selectionSet, context, mode === "migrate", path);
        }
        if (knownChanged.has(value)) knownChanged.add(memo);
    }
    if ("__typename" in data && !("__typename" in memo)) memo.__typename = data.__typename;
    // This check prevents cases where masked fields may accidentally be
    // returned as part of this object when the fragment also selects
    // additional fields from the same child selection.
    if (Object.keys(memo).length !== Object.keys(data).length) knownChanged.add(memo);
    return knownChanged.has(memo) ? memo : data;
}
function $14a40517bc96655f$var$getAccessorWarningDescriptor(fieldName, value, path, operationName, operationType) {
    var getValue = function() {
        if ((0, $8tCCc.disableWarningsSlot).getValue()) return value;
        globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(60, operationName ? "".concat(operationType, " '").concat(operationName, "'") : "anonymous ".concat(operationType), "".concat(path, ".").concat(fieldName).replace(/^\./, ""));
        getValue = function() {
            return value;
        };
        return value;
    };
    return {
        get: function() {
            return getValue();
        },
        set: function(newValue) {
            getValue = function() {
                return newValue;
            };
        },
        enumerable: true,
        configurable: true
    };
}

});
parcelRegister("2fgBC", function(module, exports) {

$parcel$export(module.exports, "maybeDeepFreeze", () => $1a29dd05c6207a28$export$7f9c177735b71f18);

var $9qEGC = parcelRequire("9qEGC");
function $1a29dd05c6207a28$export$7e32b29e1cb162e1(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $9qEGC.isNonNullObject)(obj) && $1a29dd05c6207a28$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $9qEGC.isNonNullObject)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $1a29dd05c6207a28$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $1a29dd05c6207a28$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $1a29dd05c6207a28$export$7e32b29e1cb162e1(obj);
    return obj;
}

});




parcelRegister("beqrA", function(module, exports) {

$parcel$export(module.exports, "MissingFieldError", () => $82d583b73298e53c$export$257c68286583b0f9);

var $5Rzv1 = parcelRequire("5Rzv1");
var $82d583b73298e53c$export$257c68286583b0f9 = /** @class */ function(_super) {
    (0, $5Rzv1.__extends)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);

});

parcelRegister("fOMXV", function(module, exports) {

$parcel$export(module.exports, "removeDirectivesFromDocument", () => $b8418209b8f22995$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $b8418209b8f22995$export$43b332f87950a467);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $b8418209b8f22995$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b8418209b8f22995$export$8eae69e876ee321e);
$parcel$export(module.exports, "addNonReactiveToNamedFragments", () => $b8418209b8f22995$export$b6125cad5877ac5e);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $4ceQ1 = parcelRequire("4ceQ1");
var $1Ojkk = parcelRequire("1Ojkk");

var $aPfFa = parcelRequire("aPfFa");

var $eSohM = parcelRequire("eSohM");

var $2BGiW = parcelRequire("2BGiW");

var $gvWmV = parcelRequire("gvWmV");
var $b8418209b8f22995$var$TYPENAME_FIELD = {
    kind: (0, $4ceQ1.Kind).FIELD,
    name: {
        kind: (0, $4ceQ1.Kind).NAME,
        value: "__typename"
    }
};
function $b8418209b8f22995$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $4ceQ1.Kind).FRAGMENT_SPREAD && $b8418209b8f22995$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $b8418209b8f22995$var$nullIfDocIsEmpty(doc) {
    return $b8418209b8f22995$var$isEmpty((0, $aPfFa.getOperationDefinition)(doc) || (0, $aPfFa.getFragmentDefinition)(doc), (0, $2BGiW.createFragmentMap)((0, $aPfFa.getFragmentDefinitions)(doc))) ? null : doc;
}
function $b8418209b8f22995$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $b8418209b8f22995$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $b8418209b8f22995$export$e5ae0530da5fe96c(directives, doc) {
    (0, $aPfFa.checkDocument)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $b8418209b8f22995$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $b8418209b8f22995$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $gvWmV.isArray)(ancestor)) continue;
            if (ancestor.kind === (0, $4ceQ1.Kind).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $4ceQ1.Kind).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $jWokI.invariant).error(124);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $4ceQ1.Kind).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $b8418209b8f22995$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $gvWmV.isNonEmptyArray)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $1Ojkk.visit)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $4ceQ1.Kind).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $4ceQ1.Kind).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $4ceQ1.Kind).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $b8418209b8f22995$var$nullIfDocIsEmpty((0, $1Ojkk.visit)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $b8418209b8f22995$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $1Ojkk.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $4ceQ1.Kind).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $eSohM.isField)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $eSohM.isField)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, node), {
                    selections: (0, $5Rzv1.__spreadArray)((0, $5Rzv1.__spreadArray)([], selections, true), [
                        $b8418209b8f22995$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $b8418209b8f22995$var$TYPENAME_FIELD;
    }
});
var $b8418209b8f22995$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(125);
        }
        return willRemove;
    }
};
function $b8418209b8f22995$export$74985f3324559867(doc) {
    return $b8418209b8f22995$export$e5ae0530da5fe96c([
        $b8418209b8f22995$var$connectionRemoveConfig
    ], (0, $aPfFa.checkDocument)(doc));
}
function $b8418209b8f22995$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $b8418209b8f22995$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $b8418209b8f22995$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $eSohM.isField)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($b8418209b8f22995$var$getDirectiveMatcher(directives)) || nestedCheck && $b8418209b8f22995$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $b8418209b8f22995$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $4ceQ1.Kind).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $b8418209b8f22995$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $b8418209b8f22995$var$getArgumentMatcher(config);
    return $b8418209b8f22995$var$nullIfDocIsEmpty((0, $1Ojkk.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $b8418209b8f22995$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $b8418209b8f22995$var$nullIfDocIsEmpty((0, $1Ojkk.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $b8418209b8f22995$export$57c368c23873f32b(document) {
    var definition = (0, $aPfFa.getMainDefinition)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $1Ojkk.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $b8418209b8f22995$export$8eae69e876ee321e(document) {
    (0, $aPfFa.checkDocument)(document);
    var modifiedDoc = $b8418209b8f22995$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}
function $b8418209b8f22995$export$b6125cad5877ac5e(document) {
    (0, $aPfFa.checkDocument)(document);
    return (0, $1Ojkk.visit)(document, {
        FragmentSpread: function(node) {
            var _a;
            // Do not add `@nonreactive` if the fragment is marked with `@unmask`
            // since we want to react to changes in this fragment.
            if ((_a = node.directives) === null || _a === void 0 ? void 0 : _a.some(function(directive) {
                return directive.name.value === "unmask";
            })) return;
            return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, node), {
                directives: (0, $5Rzv1.__spreadArray)((0, $5Rzv1.__spreadArray)([], node.directives || [], true), [
                    {
                        kind: (0, $4ceQ1.Kind).DIRECTIVE,
                        name: {
                            kind: (0, $4ceQ1.Kind).NAME,
                            value: "nonreactive"
                        }
                    }
                ], false)
            });
        }
    });
}

});
parcelRegister("gvWmV", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $c05cd16621d69ae6$export$43bee75e5e14138e);
$parcel$export(module.exports, "isNonEmptyArray", () => $c05cd16621d69ae6$export$d307f5934e447d0e);
// A version of Array.isArray that works better with readonly arrays.
var $c05cd16621d69ae6$export$43bee75e5e14138e = Array.isArray;
function $c05cd16621d69ae6$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

});


parcelRegister("8JTgn", function(module, exports) {

$parcel$export(module.exports, "DocumentTransform", () => $65cd64cbb7ba5dbb$export$f887060e48e5dc1b);

var $ehE1V = parcelRequire("ehE1V");

var $dx1F4 = parcelRequire("dx1F4");

var $aPfFa = parcelRequire("aPfFa");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $fBtNg = parcelRequire("fBtNg");

var $elxhT = parcelRequire("elxhT");

var $6cKaj = parcelRequire("6cKaj");
function $65cd64cbb7ba5dbb$var$identity(document) {
    return document;
}
var $65cd64cbb7ba5dbb$export$f887060e48e5dc1b = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $dx1F4.canUseWeakSet) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform($65cd64cbb7ba5dbb$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, $ehE1V.Trie)((0, $dx1F4.canUseWeakMap));
            this.performWork = (0, $elxhT.wrap)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $jWokI.invariant)(Array.isArray(cacheKeys), 104);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, $6cKaj.cacheSizes)["documentTransform.cache"],
                cache: (0, $fBtNg.WeakCache)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, $aPfFa.checkDocument)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();

});

parcelRegister("lAW9R", function(module, exports) {

$parcel$export(module.exports, "print", () => $fb8a12b906188f99$export$c2d084dc44961371);

var $7TqeT = parcelRequire("7TqeT");

var $gPdQG = parcelRequire("gPdQG");
var $6cKaj = parcelRequire("6cKaj");

var $bCfQ0 = parcelRequire("bCfQ0");
var $fb8a12b906188f99$var$printCache;
var $fb8a12b906188f99$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $fb8a12b906188f99$var$printCache.get(ast);
    if (!result) {
        result = (0, $7TqeT.print)(ast);
        $fb8a12b906188f99$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $fb8a12b906188f99$var$printCache = new (0, $gPdQG.AutoCleanedWeakCache)((0, $6cKaj.cacheSizes).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$fb8a12b906188f99$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $bCfQ0.registerGlobalCache)("print", function() {
    return $fb8a12b906188f99$var$printCache ? $fb8a12b906188f99$var$printCache.size : 0;
});

});
parcelRegister("7TqeT", function(module, exports) {

$parcel$export(module.exports, "print", () => $280625b23d4a09be$export$c2d084dc44961371);

var $9FoY8 = parcelRequire("9FoY8");

var $iHZbu = parcelRequire("iHZbu");

var $1Ojkk = parcelRequire("1Ojkk");
function $280625b23d4a09be$export$c2d084dc44961371(ast) {
    return (0, $1Ojkk.visit)(ast, $280625b23d4a09be$var$printDocASTReducer);
}
const $280625b23d4a09be$var$MAX_LINE_LENGTH = 80;
const $280625b23d4a09be$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$280625b23d4a09be$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $280625b23d4a09be$var$hasMultilineItems(node.variableDefinitions) ? $280625b23d4a09be$var$wrap('(\n', $280625b23d4a09be$var$join(node.variableDefinitions, '\n'), '\n)') : $280625b23d4a09be$var$wrap('(', $280625b23d4a09be$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $280625b23d4a09be$var$wrap('', node.description, '\n') + $280625b23d4a09be$var$join([
                node.operation,
                $280625b23d4a09be$var$join([
                    node.name,
                    varDefs
                ]),
                $280625b23d4a09be$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives, description: description })=>$280625b23d4a09be$var$wrap('', description, '\n') + variable + ': ' + type + $280625b23d4a09be$var$wrap(' = ', defaultValue) + $280625b23d4a09be$var$wrap(' ', $280625b23d4a09be$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$280625b23d4a09be$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $280625b23d4a09be$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $280625b23d4a09be$var$wrap('(', $280625b23d4a09be$var$join(args, ', '), ')');
            if (argsLine.length > $280625b23d4a09be$var$MAX_LINE_LENGTH) argsLine = prefix + $280625b23d4a09be$var$wrap('(\n', $280625b23d4a09be$var$indent($280625b23d4a09be$var$join(args, '\n')), '\n)');
            return $280625b23d4a09be$var$join([
                argsLine,
                $280625b23d4a09be$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $280625b23d4a09be$var$wrap(' ', $280625b23d4a09be$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$280625b23d4a09be$var$join([
                '...',
                $280625b23d4a09be$var$wrap('on ', typeCondition),
                $280625b23d4a09be$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet, description: description })=>$280625b23d4a09be$var$wrap('', description, '\n') + // Note: fragment variable definitions are experimental and may be changed
            // or removed in the future.
            `fragment ${name}${$280625b23d4a09be$var$wrap('(', $280625b23d4a09be$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$280625b23d4a09be$var$wrap('', $280625b23d4a09be$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $9FoY8.printBlockString)(value) : (0, $iHZbu.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $280625b23d4a09be$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $280625b23d4a09be$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $280625b23d4a09be$var$wrap('(', $280625b23d4a09be$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$280625b23d4a09be$var$wrap('', description, '\n') + $280625b23d4a09be$var$join([
                'schema',
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$280625b23d4a09be$var$wrap('', description, '\n') + $280625b23d4a09be$var$join([
                'scalar',
                name,
                $280625b23d4a09be$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$280625b23d4a09be$var$wrap('', description, '\n') + $280625b23d4a09be$var$join([
                'type',
                name,
                $280625b23d4a09be$var$wrap('implements ', $280625b23d4a09be$var$join(interfaces, ' & ')),
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$280625b23d4a09be$var$wrap('', description, '\n') + name + ($280625b23d4a09be$var$hasMultilineItems(args) ? $280625b23d4a09be$var$wrap('(\n', $280625b23d4a09be$var$indent($280625b23d4a09be$var$join(args, '\n')), '\n)') : $280625b23d4a09be$var$wrap('(', $280625b23d4a09be$var$join(args, ', '), ')')) + ': ' + type + $280625b23d4a09be$var$wrap(' ', $280625b23d4a09be$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$280625b23d4a09be$var$wrap('', description, '\n') + $280625b23d4a09be$var$join([
                name + ': ' + type,
                $280625b23d4a09be$var$wrap('= ', defaultValue),
                $280625b23d4a09be$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$280625b23d4a09be$var$wrap('', description, '\n') + $280625b23d4a09be$var$join([
                'interface',
                name,
                $280625b23d4a09be$var$wrap('implements ', $280625b23d4a09be$var$join(interfaces, ' & ')),
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$280625b23d4a09be$var$wrap('', description, '\n') + $280625b23d4a09be$var$join([
                'union',
                name,
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$wrap('= ', $280625b23d4a09be$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$280625b23d4a09be$var$wrap('', description, '\n') + $280625b23d4a09be$var$join([
                'enum',
                name,
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$280625b23d4a09be$var$wrap('', description, '\n') + $280625b23d4a09be$var$join([
                name,
                $280625b23d4a09be$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$280625b23d4a09be$var$wrap('', description, '\n') + $280625b23d4a09be$var$join([
                'input',
                name,
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, directives: directives, repeatable: repeatable, locations: locations })=>$280625b23d4a09be$var$wrap('', description, '\n') + 'directive @' + name + ($280625b23d4a09be$var$hasMultilineItems(args) ? $280625b23d4a09be$var$wrap('(\n', $280625b23d4a09be$var$indent($280625b23d4a09be$var$join(args, '\n')), '\n)') : $280625b23d4a09be$var$wrap('(', $280625b23d4a09be$var$join(args, ', '), ')')) + $280625b23d4a09be$var$wrap(' ', $280625b23d4a09be$var$join(directives, ' ')) + (repeatable ? ' repeatable' : '') + ' on ' + $280625b23d4a09be$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$280625b23d4a09be$var$join([
                'extend schema',
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$280625b23d4a09be$var$join([
                'extend scalar',
                name,
                $280625b23d4a09be$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$280625b23d4a09be$var$join([
                'extend type',
                name,
                $280625b23d4a09be$var$wrap('implements ', $280625b23d4a09be$var$join(interfaces, ' & ')),
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$280625b23d4a09be$var$join([
                'extend interface',
                name,
                $280625b23d4a09be$var$wrap('implements ', $280625b23d4a09be$var$join(interfaces, ' & ')),
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$280625b23d4a09be$var$join([
                'extend union',
                name,
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$wrap('= ', $280625b23d4a09be$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$280625b23d4a09be$var$join([
                'extend enum',
                name,
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$280625b23d4a09be$var$join([
                'extend input',
                name,
                $280625b23d4a09be$var$join(directives, ' '),
                $280625b23d4a09be$var$block(fields)
            ], ' ')
    },
    DirectiveExtension: {
        leave: ({ name: name, directives: directives })=>$280625b23d4a09be$var$join([
                'extend directive @' + name,
                $280625b23d4a09be$var$join(directives, ' ')
            ], ' ')
    },
    // Schema Coordinates
    TypeCoordinate: {
        leave: ({ name: name })=>name
    },
    MemberCoordinate: {
        leave: ({ name: name, memberName: memberName })=>$280625b23d4a09be$var$join([
                name,
                $280625b23d4a09be$var$wrap('.', memberName)
            ])
    },
    ArgumentCoordinate: {
        leave: ({ name: name, fieldName: fieldName, argumentName: argumentName })=>$280625b23d4a09be$var$join([
                name,
                $280625b23d4a09be$var$wrap('.', fieldName),
                $280625b23d4a09be$var$wrap('(', argumentName, ':)')
            ])
    },
    DirectiveCoordinate: {
        leave: ({ name: name })=>$280625b23d4a09be$var$join([
                '@',
                name
            ])
    },
    DirectiveArgumentCoordinate: {
        leave: ({ name: name, argumentName: argumentName })=>$280625b23d4a09be$var$join([
                '@',
                name,
                $280625b23d4a09be$var$wrap('(', argumentName, ':)')
            ])
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $280625b23d4a09be$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $280625b23d4a09be$var$block(array) {
    return $280625b23d4a09be$var$wrap('{\n', $280625b23d4a09be$var$indent($280625b23d4a09be$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $280625b23d4a09be$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $280625b23d4a09be$var$indent(str) {
    return $280625b23d4a09be$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $280625b23d4a09be$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("9FoY8", function(module, exports) {

$parcel$export(module.exports, "printBlockString", () => $2b268f71ca880b1b$export$adb6ca997eeb1f45);

var $f1JsZ = parcelRequire("f1JsZ");
function $2b268f71ca880b1b$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $2b268f71ca880b1b$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $2b268f71ca880b1b$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $f1JsZ.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $2b268f71ca880b1b$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $2b268f71ca880b1b$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $f1JsZ.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $f1JsZ.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}

});
parcelRegister("f1JsZ", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", () => $028dce25798bc6cb$export$3c52dd84024ae72c);
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $028dce25798bc6cb$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $028dce25798bc6cb$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $028dce25798bc6cb$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $028dce25798bc6cb$export$45a677ea7cb6d5c8(code) {
    return $028dce25798bc6cb$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $028dce25798bc6cb$export$d3f406ff46035894(code) {
    return $028dce25798bc6cb$export$79c5d5217943d6a7(code) || $028dce25798bc6cb$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("iHZbu", function(module, exports) {

$parcel$export(module.exports, "printString", () => $aebe091b9ce379f0$export$3cdec7cf614a0ecc);
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $aebe091b9ce379f0$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($aebe091b9ce379f0$var$escapedRegExp, $aebe091b9ce379f0$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $aebe091b9ce379f0$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $aebe091b9ce379f0$var$escapedReplacer(str) {
    return $aebe091b9ce379f0$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $aebe091b9ce379f0$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];

});



parcelRegister("alOLy", function(module, exports) {

$parcel$export(module.exports, "StoreReader", () => $78933ea238f3a4d2$export$628ef07ba8965f12);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $4ceQ1 = parcelRequire("4ceQ1");

var $elxhT = parcelRequire("elxhT");

var $fOMXV = parcelRequire("fOMXV");
var $6cKaj = parcelRequire("6cKaj");
var $7Szzy = parcelRequire("7Szzy");
var $dx1F4 = parcelRequire("dx1F4");
var $bRE5f = parcelRequire("bRE5f");
var $9waFp = parcelRequire("9waFp");
var $aPfFa = parcelRequire("aPfFa");
var $2BGiW = parcelRequire("2BGiW");
var $eSohM = parcelRequire("eSohM");
var $9qEGC = parcelRequire("9qEGC");
var $2fgBC = parcelRequire("2fgBC");
var $3nA2J = parcelRequire("3nA2J");

var $kbMHn = parcelRequire("kbMHn");

var $aqsBN = parcelRequire("aqsBN");
var $gvWmV = parcelRequire("gvWmV");

var $beqrA = parcelRequire("beqrA");

var $eRiNT = parcelRequire("eRiNT");
function $78933ea238f3a4d2$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var $78933ea238f3a4d2$export$628ef07ba8965f12 = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $dx1F4.canUseWeakMap) ? WeakMap : Map)();
        this.config = (0, $bRE5f.compact)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $aqsBN.shouldCanonizeResults)(config)
        });
        this.canon = config.canon || new (0, $eRiNT.ObjectCanon)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $elxhT.wrap)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $78933ea238f3a4d2$var$execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, $kbMHn.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $6cKaj.cacheSizes)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $78933ea238f3a4d2$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $kbMHn.supportsResultCaching)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $eSohM.isReference)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $elxhT.wrap)(function(options) {
            (0, $kbMHn.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $6cKaj.cacheSizes)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $kbMHn.supportsResultCaching)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $eRiNT.ObjectCanon)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, (0, $aPfFa.getDefaultValues)((0, $aPfFa.getQueryDefinition)(query))), variables);
        var rootRef = (0, $eSohM.makeReference)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $aPfFa.getMainDefinition)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $5Rzv1.__assign)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $7Szzy.canonicalStringify)(variables),
                canonizeResults: canonizeResults
            }, (0, $aqsBN.extractFragmentContext)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, $beqrA.MissingFieldError)($78933ea238f3a4d2$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $kbMHn.supportsResultCaching)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $eSohM.isReference)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $9waFp.DeepMerger)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $3nA2J.shouldInclude)(selection, variables)) return;
            if ((0, $eSohM.isField)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $eSohM.resultKeyNameFromField)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $fOMXV.addTypenameToDocument).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $eSohM.isReference)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $gvWmV.isArray)(fieldValue)) {
                    if (fieldValue.length > 0) fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context
                    }), resultName);
                } else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $eSohM.isReference)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $2BGiW.getFragmentFromSelection)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $4ceQ1.Kind).FRAGMENT_SPREAD) throw (0, $jWokI.newInvariantError)(10, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $9waFp.mergeDeepArray)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $2fgBC.maybeDeepFreeze)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $9waFp.DeepMerger)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $gvWmV.isArray)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $eSohM.isReference)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $78933ea238f3a4d2$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $78933ea238f3a4d2$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $78933ea238f3a4d2$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $9qEGC.isNonNullObject)(value)) {
                (0, $jWokI.invariant)(!(0, $eSohM.isReference)(value), 11, (0, $aqsBN.getTypenameFromStoreObject)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

});
parcelRegister("bRE5f", function(module, exports) {

$parcel$export(module.exports, "compact", () => $8a33bcb4f9efd143$export$8e16b83750b44988);
/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $8a33bcb4f9efd143$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

});

parcelRegister("kbMHn", function(module, exports) {

$parcel$export(module.exports, "EntityStore", () => $eb2a9c4278af0287$export$cb507f57054c7321);
$parcel$export(module.exports, "maybeDependOnExistenceOfEntity", () => $eb2a9c4278af0287$export$f8068a30967ddc18);
$parcel$export(module.exports, "supportsResultCaching", () => $eb2a9c4278af0287$export$488c0743feab3d61);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");
parcelRequire("elxhT");
var $4OdSC = parcelRequire("4OdSC");

var $5nLer = parcelRequire("5nLer");

var $ehE1V = parcelRequire("ehE1V");

var $dx1F4 = parcelRequire("dx1F4");
var $9waFp = parcelRequire("9waFp");
var $9qEGC = parcelRequire("9qEGC");
var $eSohM = parcelRequire("eSohM");
var $2fgBC = parcelRequire("2fgBC");

var $aqsBN = parcelRequire("aqsBN");
var $eb2a9c4278af0287$var$DELETE = Object.create(null);
var $eb2a9c4278af0287$var$delModifier = function() {
    return $eb2a9c4278af0287$var$DELETE;
};
var $eb2a9c4278af0287$var$INVALIDATE = Object.create(null);
var $eb2a9c4278af0287$export$cb507f57054c7321 = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $2fgBC.maybeDeepFreeze)((0, $eSohM.isReference)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, $eSohM.isReference)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $eSohM.makeReference)(objOrIdOrRef);
            if ((0, $eSohM.isReference)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $eSohM.makeReference)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, $5Rzv1.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $aqsBN.hasOwn).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $aqsBN.hasOwn).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $aqsBN.hasOwn).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $eb2a9c4278af0287$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $aqsBN.hasOwn).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $eb2a9c4278af0287$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, $eSohM.isReference)(older)) older = older.__ref;
        if ((0, $eSohM.isReference)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $jWokI.invariant)(typeof dataId === "string", 2);
        var merged = new (0, $9waFp.DeepMerger)($eb2a9c4278af0287$var$storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, $aqsBN.fieldNameFromStoreName)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $eb2a9c4278af0287$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $eb2a9c4278af0287$var$DELETE,
                INVALIDATE: $eb2a9c4278af0287$var$INVALIDATE,
                isReference: (0, $eSohM.isReference),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $eSohM.makeReference)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $aqsBN.fieldNameFromStoreName)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $eb2a9c4278af0287$var$delModifier ? $eb2a9c4278af0287$var$DELETE : modify((0, $2fgBC.maybeDeepFreeze)(fieldValue), (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $eb2a9c4278af0287$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $eb2a9c4278af0287$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(3, ref);
                                        return true;
                                    }
                                };
                                if ((0, $eSohM.isReference)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, $eSohM.isReference)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(4, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $eb2a9c4278af0287$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $eb2a9c4278af0287$var$delModifier, _a) : $eb2a9c4278af0287$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $aqsBN.hasOwn).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $eb2a9c4278af0287$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $aqsBN.hasOwn).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $aqsBN.hasOwn).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $5Rzv1.__rest)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $eb2a9c4278af0287$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $aqsBN.hasOwn).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $eb2a9c4278af0287$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $aqsBN.hasOwn).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, $eSohM.isReference)(obj)) found_1[obj.__ref] = true;
                if ((0, $9qEGC.isNonNullObject)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $9qEGC.isNonNullObject)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var $eb2a9c4278af0287$var$CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $4OdSC.dep)() : null;
        this.keyMaker = new (0, $ehE1V.Trie)((0, $dx1F4.canUseWeakMap));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($eb2a9c4278af0287$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $aqsBN.fieldNameFromStoreName)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($eb2a9c4278af0287$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($eb2a9c4278af0287$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $eb2a9c4278af0287$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $eb2a9c4278af0287$export$f8068a30967ddc18(store, entityId) {
    if ($eb2a9c4278af0287$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, $5Rzv1.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $eb2a9c4278af0287$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $eb2a9c4278af0287$var$Stump(_this);
            _this.storageTrie = new (0, $ehE1V.Trie)((0, $dx1F4.canUseWeakMap));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($eb2a9c4278af0287$export$cb507f57054c7321 || ($eb2a9c4278af0287$export$cb507f57054c7321 = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var $eb2a9c4278af0287$var$Layer = /** @class */ function(_super) {
    (0, $5Rzv1.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $5nLer.equal)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $aqsBN.hasOwn).call(this.data, dataId) ? (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}($eb2a9c4278af0287$export$cb507f57054c7321);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var $eb2a9c4278af0287$var$Stump = /** @class */ function(_super) {
    (0, $5Rzv1.__extends)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $eb2a9c4278af0287$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}($eb2a9c4278af0287$var$Layer);
function $eb2a9c4278af0287$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $5nLer.equal)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $eb2a9c4278af0287$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof $eb2a9c4278af0287$export$cb507f57054c7321 && store.group.caching);
}

});
parcelRegister("aqsBN", function(module, exports) {

$parcel$export(module.exports, "hasOwn", () => $79728626caf376d4$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $79728626caf376d4$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "normalizeConfig", () => $79728626caf376d4$export$fa542f9ee3f7f4e2);
$parcel$export(module.exports, "shouldCanonizeResults", () => $79728626caf376d4$export$3ac2a95fbd99c479);
$parcel$export(module.exports, "getTypenameFromStoreObject", () => $79728626caf376d4$export$fdef206c83ff2c09);
$parcel$export(module.exports, "TypeOrFieldNameRegExp", () => $79728626caf376d4$export$6ed54d4784f1ce28);
$parcel$export(module.exports, "fieldNameFromStoreName", () => $79728626caf376d4$export$37874422037b6029);
$parcel$export(module.exports, "selectionSetMatchesResult", () => $79728626caf376d4$export$60bd1cbb09c1a4a2);
$parcel$export(module.exports, "storeValueIsStoreObject", () => $79728626caf376d4$export$4f39afca21bd938e);
$parcel$export(module.exports, "makeProcessedFieldsMerger", () => $79728626caf376d4$export$b874a818f7a2fa6d);
$parcel$export(module.exports, "extractFragmentContext", () => $79728626caf376d4$export$3a33c00f0ae4a480);
$parcel$export(module.exports, "isArray", () => (parcelRequire("gvWmV")).isArray);

var $bRE5f = parcelRequire("bRE5f");
var $2BGiW = parcelRequire("2BGiW");
var $9waFp = parcelRequire("9waFp");
var $aPfFa = parcelRequire("aPfFa");
var $gvWmV = parcelRequire("gvWmV");
var $eSohM = parcelRequire("eSohM");
var $9qEGC = parcelRequire("9qEGC");
var $3nA2J = parcelRequire("3nA2J");
var $79728626caf376d4$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $79728626caf376d4$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $79728626caf376d4$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$79728626caf376d4$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$79728626caf376d4$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if ($79728626caf376d4$export$b931b78cbb3caf86(id) && !$79728626caf376d4$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$79728626caf376d4$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $79728626caf376d4$var$defaultConfig = {
    dataIdFromObject: $79728626caf376d4$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function $79728626caf376d4$export$fa542f9ee3f7f4e2(config) {
    return (0, $bRE5f.compact)($79728626caf376d4$var$defaultConfig, config);
}
function $79728626caf376d4$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $79728626caf376d4$var$defaultConfig.canonizeResults : value;
}
function $79728626caf376d4$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $eSohM.isReference)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $79728626caf376d4$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $79728626caf376d4$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($79728626caf376d4$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $79728626caf376d4$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $9qEGC.isNonNullObject)(result)) return (0, $gvWmV.isArray)(result) ? result.every(function(item) {
        return $79728626caf376d4$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $eSohM.isField)(field) && (0, $3nA2J.shouldInclude)(field, variables)) {
            var key = (0, $eSohM.resultKeyNameFromField)(field);
            return $79728626caf376d4$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $79728626caf376d4$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $79728626caf376d4$export$4f39afca21bd938e(value) {
    return (0, $9qEGC.isNonNullObject)(value) && !(0, $eSohM.isReference)(value) && !(0, $gvWmV.isArray)(value);
}
function $79728626caf376d4$export$b874a818f7a2fa6d() {
    return new (0, $9waFp.DeepMerger)();
}
function $79728626caf376d4$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, $2BGiW.createFragmentMap)((0, $aPfFa.getFragmentDefinitions)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}

});


parcelRegister("eRiNT", function(module, exports) {

$parcel$export(module.exports, "ObjectCanon", () => $ad1499f342b04ba1$export$c2e7fdd82233f4a4);

var $5Rzv1 = parcelRequire("5Rzv1");

var $ehE1V = parcelRequire("ehE1V");

var $dx1F4 = parcelRequire("dx1F4");
var $9qEGC = parcelRequire("9qEGC");
parcelRequire("aqsBN");
var $gvWmV = parcelRequire("gvWmV");
function $ad1499f342b04ba1$var$shallowCopy(value) {
    if ((0, $9qEGC.isNonNullObject)(value)) return (0, $gvWmV.isArray)(value) ? value.slice(0) : (0, $5Rzv1.__assign)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var $ad1499f342b04ba1$export$c2e7fdd82233f4a4 = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, $dx1F4.canUseWeakSet) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, $ehE1V.Trie)((0, $dx1F4.canUseWeakMap));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $9qEGC.isNonNullObject)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $9qEGC.isNonNullObject)(value)) {
            var copy = $ad1499f342b04ba1$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $9qEGC.isNonNullObject)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();

});


parcelRegister("f9OU7", function(module, exports) {

$parcel$export(module.exports, "StoreWriter", () => $b08f2ecbf8c92d7a$export$eb8361c5d132fb8f);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $5nLer = parcelRequire("5nLer");

var $ehE1V = parcelRequire("ehE1V");

var $4ceQ1 = parcelRequire("4ceQ1");

var $fOMXV = parcelRequire("fOMXV");
var $eSohM = parcelRequire("eSohM");
var $7Szzy = parcelRequire("7Szzy");
var $llKlL = parcelRequire("llKlL");
var $aPfFa = parcelRequire("aPfFa");
var $2BGiW = parcelRequire("2BGiW");
var $gvWmV = parcelRequire("gvWmV");
var $3nA2J = parcelRequire("3nA2J");

var $aqsBN = parcelRequire("aqsBN");
var $gvWmV = parcelRequire("gvWmV");

var $21Oj9 = parcelRequire("21Oj9");
// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $b08f2ecbf8c92d7a$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $b08f2ecbf8c92d7a$export$eb8361c5d132fb8f = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $aPfFa.getOperationDefinition)(query);
        var merger = (0, $aqsBN.makeProcessedFieldsMerger)();
        variables = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, (0, $aPfFa.getDefaultValues)(operationDefinition)), variables);
        var context = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $7Szzy.canonicalStringify)(variables)
        }, (0, $aqsBN.extractFragmentContext)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $eSohM.isReference)(ref)) throw (0, $jWokI.newInvariantError)(12, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $eSohM.makeReference)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $eSohM.isReference)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $aqsBN.fieldNameFromStoreName)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $b08f2ecbf8c92d7a$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $eSohM.getTypenameFromResult)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, $21Oj9.normalizeReadFieldOptions)(arguments, incoming, context.variables);
            if ((0, $eSohM.isReference)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $eSohM.resultKeyNameFromField)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $b08f2ecbf8c92d7a$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $b08f2ecbf8c92d7a$var$getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $eSohM.isReference)(incomingValue) || (0, $aqsBN.storeValueIsStoreObject)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $b08f2ecbf8c92d7a$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $fOMXV.addTypenameToDocument).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $jWokI.invariant).error(13, (0, $eSohM.resultKeyNameFromField)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $eSohM.makeReference)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $b08f2ecbf8c92d7a$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $b08f2ecbf8c92d7a$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, $llKlL.cloneDeep)(value) : value;
        if ((0, $gvWmV.isArray)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $b08f2ecbf8c92d7a$var$getChildMergeTree(mergeTree, i));
            $b08f2ecbf8c92d7a$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $eSohM.getTypenameFromResult)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $ehE1V.Trie)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $3nA2J.shouldInclude)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $gvWmV.isNonEmptyArray)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $eSohM.argumentsObjectFromField)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $eSohM.isField)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $b08f2ecbf8c92d7a$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $2BGiW.getFragmentFromSelection)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $4ceQ1.Kind).FRAGMENT_SPREAD) throw (0, $jWokI.newInvariantError)(14, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $b08f2ecbf8c92d7a$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $eSohM.isReference)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $gvWmV.isArray)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $eSohM.isReference)(existing) || (0, $aqsBN.storeValueIsStoreObject)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $eSohM.isReference)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $gvWmV.isArray)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $jWokI.invariant)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $gvWmV.isArray)(i_1) ? i_1.slice(0) : (0, $5Rzv1.__assign)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $b08f2ecbf8c92d7a$var$emptyMergeTreePool = [];
function $b08f2ecbf8c92d7a$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $b08f2ecbf8c92d7a$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $b08f2ecbf8c92d7a$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $b08f2ecbf8c92d7a$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $b08f2ecbf8c92d7a$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $b08f2ecbf8c92d7a$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $b08f2ecbf8c92d7a$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $b08f2ecbf8c92d7a$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $b08f2ecbf8c92d7a$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $b08f2ecbf8c92d7a$var$mergeTreeIsEmpty(childTree)) {
        $b08f2ecbf8c92d7a$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $b08f2ecbf8c92d7a$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $b08f2ecbf8c92d7a$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $eSohM.isReference)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $5nLer.equal)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $aqsBN.fieldNameFromStoreName)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if ($b08f2ecbf8c92d7a$var$warnings.has(typeDotName)) return;
    $b08f2ecbf8c92d7a$var$warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $gvWmV.isArray)(existing) && !(0, $gvWmV.isArray)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(15, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, (0, $5Rzv1.__assign)({}, existing), (0, $5Rzv1.__assign)({}, incoming));
}

});
parcelRegister("llKlL", function(module, exports) {

$parcel$export(module.exports, "cloneDeep", () => $f8af834545db5fad$export$629a2bd3f5a49ecc);
var $f8af834545db5fad$var$toString = Object.prototype.toString;
function $f8af834545db5fad$export$629a2bd3f5a49ecc(value) {
    return $f8af834545db5fad$var$cloneDeepHelper(value);
}
function $f8af834545db5fad$var$cloneDeepHelper(val, seen) {
    switch($f8af834545db5fad$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $f8af834545db5fad$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $f8af834545db5fad$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

});

parcelRegister("21Oj9", function(module, exports) {

$parcel$export(module.exports, "Policies", () => $17a2b2de9af0e3cf$export$e9859ad90648930b);
$parcel$export(module.exports, "normalizeReadFieldOptions", () => $17a2b2de9af0e3cf$export$1ad7a877581bdf2e);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $eSohM = parcelRequire("eSohM");
var $9qEGC = parcelRequire("9qEGC");
var $gtD0h = parcelRequire("gtD0h");

var $aqsBN = parcelRequire("aqsBN");
var $gvWmV = parcelRequire("gvWmV");

var $fpOnH = parcelRequire("fpOnH");

var $lvpNC = parcelRequire("lvpNC");

var $8tCCc = parcelRequire("8tCCc");
function $17a2b2de9af0e3cf$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $eSohM.argumentsObjectFromField)(spec.field, spec.variables) : null;
}
var $17a2b2de9af0e3cf$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $17a2b2de9af0e3cf$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var $17a2b2de9af0e3cf$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $17a2b2de9af0e3cf$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $17a2b2de9af0e3cf$export$e9859ad90648930b = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $5Rzv1.__assign)({
            dataIdFromObject: (0, $aqsBN.defaultDataIdFromObject)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $17a2b2de9af0e3cf$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        (0, $8tCCc.disableWarningsSlot).withValue(true, function() {
            while(keyFn){
                var specifierOrId = keyFn((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, object), storeObject), context);
                if ((0, $gvWmV.isArray)(specifierOrId)) keyFn = (0, $lvpNC.keyFieldsFnFromSpecifier)(specifierOrId);
                else {
                    id = specifierOrId;
                    break;
                }
            }
        });
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $5Rzv1.__rest)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $aqsBN.hasOwn).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming, existingFieldPolicies) {
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $17a2b2de9af0e3cf$var$mergeTrueFn : merge === false ? $17a2b2de9af0e3cf$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $17a2b2de9af0e3cf$var$nullKeyFieldsFn : (0, $gvWmV.isArray)(keyFields) ? (0, $lvpNC.keyFieldsFnFromSpecifier)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = existingFieldPolicies[fieldName];
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            // So here we avoid merging an inherited field policy with an updated one.
            if (!existing || (existing === null || existing === void 0 ? void 0 : existing.typename) !== typename) existing = existingFieldPolicies[fieldName] = {
                typename: typename
            };
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $17a2b2de9af0e3cf$var$simpleKeyArgsFn : (0, $gvWmV.isArray)(keyArgs) ? (0, $lvpNC.keyArgsFnFromSpecifier)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $17a2b2de9af0e3cf$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $jWokI.invariant)(!old || old === which, 6, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $aqsBN.TypeOrFieldNameRegExp));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $aqsBN.hasOwn).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $5Rzv1.__rest)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy, _this.typePolicies[typename].fields);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName) {
        if (typename) return this.getTypePolicy(typename).fields[fieldName];
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(7, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $aqsBN.selectionSetMatchesResult)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $17a2b2de9af0e3cf$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $gvWmV.isArray)(specifierOrString)) keyFn = (0, $lvpNC.keyArgsFnFromSpecifier)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $eSohM.storeKeyNameFromField)(fieldSpec.field, fieldSpec.variables) : (0, $eSohM.getStoreKeyName)(fieldName, $17a2b2de9af0e3cf$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $aqsBN.fieldNameFromStoreName)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $aqsBN.fieldNameFromStoreName)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $17a2b2de9af0e3cf$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $eSohM.isReference)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $fpOnH.cacheSlot).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $17a2b2de9af0e3cf$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $17a2b2de9af0e3cf$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $17a2b2de9af0e3cf$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $17a2b2de9af0e3cf$var$makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $17a2b2de9af0e3cf$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $aqsBN.fieldNameFromStoreName)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $17a2b2de9af0e3cf$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $eSohM.isReference),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($17a2b2de9af0e3cf$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $17a2b2de9af0e3cf$var$makeMergeObjectsFunction(context.store)
    };
}
function $17a2b2de9af0e3cf$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $5Rzv1.__assign)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $aqsBN.hasOwn).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(8, (0, $gtD0h.stringifyForDisplay)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $17a2b2de9af0e3cf$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $gvWmV.isArray)(existing) || (0, $gvWmV.isArray)(incoming)) throw (0, $jWokI.newInvariantError)(9);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $9qEGC.isNonNullObject)(existing) && (0, $9qEGC.isNonNullObject)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $eSohM.isReference)(existing) && (0, $aqsBN.storeValueIsStoreObject)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $aqsBN.storeValueIsStoreObject)(existing) && (0, $eSohM.isReference)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $aqsBN.storeValueIsStoreObject)(existing) && (0, $aqsBN.storeValueIsStoreObject)(incoming)) return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, existing), incoming);
        }
        return incoming;
    };
}

});
parcelRegister("fpOnH", function(module, exports) {

$parcel$export(module.exports, "cacheSlot", () => $b390457fa8f1e270$export$ac9723609f5c76c2);
$parcel$export(module.exports, "forgetCache", () => $b390457fa8f1e270$export$cbe12faed7725318);
$parcel$export(module.exports, "recallCache", () => $b390457fa8f1e270$export$f342bdd61b3e9412);
$parcel$export(module.exports, "makeVar", () => $b390457fa8f1e270$export$5345c8ac69b4a9db);
parcelRequire("elxhT");
var $4OdSC = parcelRequire("4OdSC");
var $j3PV9 = parcelRequire("j3PV9");
var $b390457fa8f1e270$export$ac9723609f5c76c2 = new (0, $j3PV9.Slot)();
var $b390457fa8f1e270$var$cacheInfoMap = new WeakMap();
function $b390457fa8f1e270$var$getCacheInfo(cache) {
    var info = $b390457fa8f1e270$var$cacheInfoMap.get(cache);
    if (!info) $b390457fa8f1e270$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $4OdSC.dep)()
    });
    return info;
}
function $b390457fa8f1e270$export$cbe12faed7725318(cache) {
    $b390457fa8f1e270$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $b390457fa8f1e270$export$f342bdd61b3e9412(cache) {
    $b390457fa8f1e270$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $b390457fa8f1e270$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $b390457fa8f1e270$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $b390457fa8f1e270$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = $b390457fa8f1e270$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $b390457fa8f1e270$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $b390457fa8f1e270$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $b390457fa8f1e270$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}

});

parcelRegister("lvpNC", function(module, exports) {

$parcel$export(module.exports, "keyFieldsFnFromSpecifier", () => $fa80816815a6d2ff$export$f1953a0407594d2c);
$parcel$export(module.exports, "keyArgsFnFromSpecifier", () => $fa80816815a6d2ff$export$550737ee0cc371ac);
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $eSohM = parcelRequire("eSohM");
var $9waFp = parcelRequire("9waFp");
var $gvWmV = parcelRequire("gvWmV");
var $9qEGC = parcelRequire("9qEGC");

var $aqsBN = parcelRequire("aqsBN");
var $gvWmV = parcelRequire("gvWmV");
// Mapping from JSON-encoded KeySpecifier strings to associated information.
var $fa80816815a6d2ff$var$specifierInfoCache = Object.create(null);
function $fa80816815a6d2ff$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return $fa80816815a6d2ff$var$specifierInfoCache[cacheKey] || ($fa80816815a6d2ff$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $fa80816815a6d2ff$export$f1953a0407594d2c(specifier) {
    var info = $fa80816815a6d2ff$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $fa80816815a6d2ff$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $fa80816815a6d2ff$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $aqsBN.hasOwn).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $fa80816815a6d2ff$export$e8f64f7a025887d3(object, schemaKeyPath, $fa80816815a6d2ff$var$extractKey);
            (0, $jWokI.invariant)(extracted !== void 0, 5, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $fa80816815a6d2ff$export$550737ee0cc371ac(specifier) {
    var info = $fa80816815a6d2ff$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $fa80816815a6d2ff$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $gvWmV.isNonEmptyArray)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, $eSohM.argumentsObjectFromField)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $fa80816815a6d2ff$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $aqsBN.hasOwn).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $fa80816815a6d2ff$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $fa80816815a6d2ff$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $fa80816815a6d2ff$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, $9waFp.DeepMerger)();
    return $fa80816815a6d2ff$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $fa80816815a6d2ff$export$eca459f173e85801(spec) {
    var info = $fa80816815a6d2ff$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $gvWmV.isArray)(s)) {
                $fa80816815a6d2ff$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $gvWmV.isArray)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $fa80816815a6d2ff$var$extractKey(object, key) {
    return object[key];
}
function $fa80816815a6d2ff$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $fa80816815a6d2ff$var$extractKey;
    return $fa80816815a6d2ff$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $gvWmV.isArray)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $fa80816815a6d2ff$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $9qEGC.isNonNullObject)(value)) {
        if ((0, $gvWmV.isArray)(value)) return value.map($fa80816815a6d2ff$var$normalize);
        return $fa80816815a6d2ff$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $fa80816815a6d2ff$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}

});




parcelRegister("gu0Mj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.noop = module.exports.noopHeaders = module.exports.GraphqlDocuments = module.exports.ApolloClient = void 0;

var $4XQlz = parcelRequire("4XQlz");
module.exports.ApolloClient = new $4XQlz.InjectionToken('apollo-link');
module.exports.GraphqlDocuments = new $4XQlz.InjectionToken('graphql-documents');
const $c0000d3faa897c2a$var$noopHeaders = ()=>new Headers();
module.exports.noopHeaders = $c0000d3faa897c2a$var$noopHeaders;
const $c0000d3faa897c2a$var$noop = ()=>null;
module.exports.noop = $c0000d3faa897c2a$var$noop;

});

parcelRegister("hHjSo", function(module, exports) {

$parcel$export(module.exports, "ApolloClient", () => $ce25ded360f850bd$export$13f5a5f0f1dbab88);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $irVrB = parcelRequire("irVrB");
var $5xB32 = parcelRequire("5xB32");

var $oNTBC = parcelRequire("oNTBC");

var $1t3R9 = parcelRequire("1t3R9");

var $hUJU9 = parcelRequire("hUJU9");

var $hEYvw = parcelRequire("hEYvw");

var $jKMI2 = parcelRequire("jKMI2");
var $4YPPO = parcelRequire("4YPPO");

var $bCfQ0 = parcelRequire("bCfQ0");
var $ce25ded360f850bd$var$hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an `ApolloLink` instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through `Observable` instances.
 */ var $ce25ded360f850bd$export$13f5a5f0f1dbab88 = /** @class */ function() {
    /**
     * Constructs an instance of `ApolloClient`.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        var _a, _b, _c;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $jWokI.newInvariantError)(16);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _d = options.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = options.ssrForceFetchDelay, ssrForceFetchDelay = _e === void 0 ? 0 : _e, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = options.connectToDevTools, _f = options.queryDeduplication, queryDeduplication = _f === void 0 ? true : _f, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _g = options.assumeImmutableResults, assumeImmutableResults = _g === void 0 ? cache.assumeImmutableResults : _g, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwareness = options.clientAwareness, clientAwarenessName = options.name, clientAwarenessVersion = options.version, devtools = options.devtools, dataMasking = options.dataMasking;
        if (globalThis.__DEV__ !== false) {
            (0, $4YPPO.warnRemovedOption)(options, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead.");
            (0, $4YPPO.warnRemovedOption)(options, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead.");
            (0, $4YPPO.warnRemovedOption)(options, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead.");
            (0, $4YPPO.warnRemovedOption)(options, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead.");
            (0, $4YPPO.warnRemovedOption)(options, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead.");
            (0, $4YPPO.warnRemovedOption)(options, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead.");
            (0, $4YPPO.warnRemovedOption)(options, "typeDefs", "ApolloClient");
            if (!options.link) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(17);
        }
        var link = options.link;
        if (!link) link = uri ? new (0, $1t3R9.HttpLink)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $irVrB.ApolloLink).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        this.devtoolsConfig = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, devtools), {
            enabled: (_a = devtools === null || devtools === void 0 ? void 0 : devtools.enabled) !== null && _a !== void 0 ? _a : connectToDevTools
        });
        if (this.devtoolsConfig.enabled === undefined) this.devtoolsConfig.enabled = globalThis.__DEV__ !== false;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.watchFragment = this.watchFragment.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $oNTBC.version);
        this.localState = new (0, $hEYvw.LocalState)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $hUJU9.QueryManager)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            dataMasking: !!dataMasking,
            clientAwareness: {
                name: (_b = clientAwareness === null || clientAwareness === void 0 ? void 0 : clientAwareness.name) !== null && _b !== void 0 ? _b : clientAwarenessName,
                version: (_c = clientAwareness === null || clientAwareness === void 0 ? void 0 : clientAwareness.version) !== null && _c !== void 0 ? _c : clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: this.devtoolsConfig.enabled ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (this.devtoolsConfig.enabled) this.connectToDevTools();
    }
    Object.defineProperty(ApolloClient.prototype, "prioritizeCacheValues", {
        /**
         * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
         * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
         * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
         *
         * This can e.g. be used to prioritize the cache during the first render after SSR.
         */ get: function() {
            return this.disableNetworkFetches;
        },
        set: function(value) {
            this.disableNetworkFetches = value;
        },
        enumerable: false,
        configurable: true
    });
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "undefined") return;
        var windowWithDevTools = window;
        var devtoolsSymbol = Symbol.for("apollo.devtools");
        (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
        windowWithDevTools.__APOLLO_CLIENT__ = this;
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$ce25ded360f850bd$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $ce25ded360f850bd$var$hasSuggestedDevtools = true;
            if (window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol)) setTimeout(function() {
                if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $jWokI.invariant).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an `ObservableQuery`. We can subscribe to this `ObservableQuery` and
     * receive updated results through an observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $jKMI2.mergeOptions)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        if (globalThis.__DEV__ !== false) {
            (0, $4YPPO.warnRemovedOption)(options, "canonizeResults", "client.watchQuery");
            (0, $4YPPO.warnRemovedOption)(options, "partialRefetch", "client.watchQuery");
        }
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type `QueryOptions` that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $jKMI2.mergeOptions)(this.defaultOptions.query, options);
        (0, $jWokI.invariant)(options.fetchPolicy !== "cache-and-network", 18);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        if (globalThis.__DEV__ !== false) {
            (0, $4YPPO.warnRemovedOption)(options, "canonizeResults", "client.query");
            (0, $4YPPO.warnRemovedOption)(options, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed.");
            if (options.fetchPolicy === "standby") globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(19);
        }
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $jKMI2.mergeOptions)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * `Observable` which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        var _this = this;
        var id = this.queryManager.generateQueryId();
        return this.queryManager.startGraphQLSubscription(options).map(function(result) {
            return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, result), {
                data: _this.queryManager.maskOperation({
                    document: options.query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    id: id
                })
            });
        });
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Watches the cache store of the fragment according to the options specified
     * and returns an `Observable`. We can subscribe to this
     * `Observable` and receive updated results through an
     * observer when the cache store changes.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @since 3.10.0
     * @param options - An object of type `WatchFragmentOptions` that allows
     * the cache to identify the fragment and optionally specify whether to react
     * to optimistic updates.
     */ ApolloClient.prototype.watchFragment = function(options) {
        var _a;
        return this.cache.watchFragment((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), (_a = {}, _a[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, _a)));
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $5xB32.execute)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $jWokI.invariant).debug(20, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     *
     * @deprecated `addResolvers` will been removed in Apollo Client 4.0. It is
     * safe to continue using this method in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * No action needed
     *
     * **When upgrading**
     *
     * Use `client.localState.addResolvers(resolvers)`. Alternatively, store
     * the `LocalState` instance in a separate variable and call `addResolvers` on
     * that.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     *
     * @deprecated `setResolvers` will been removed in Apollo Client 4.0. It is
     * safe to continue using this method in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * If possible, stop using the `setResolvers` method.
     *
     * **When upgrading**
     *
     * Remove the use of `setResolvers`.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     *
     * @deprecated `getResolvers` will be removed in Apollo Client 4.0. It is
     * safe to continue using this method in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * If possible, stop using the `getResolvers` method.
     *
     * **When upgrading**
     *
     * Remove the use of `getResolvers`.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     *
     * @deprecated Custom fragment matchers will no longer be supported in Apollo
     * Client 4.0 and has been replaced by `cache.fragmentMatches`. It is safe to
     * continue using `setLocalStateFragmentMatcher` in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * No action needed
     *
     * **When upgrading**
     *
     * Leverage `possibleTypes` with `InMemoryCache` to ensure fragments match
     * correctly. Ensure `possibleTypes` include local types if needed. If working
     * with a 3rd party cache implementation, ensure the 3rd party cache implements
     * the `cache.fragmentMatches` method. This function should no longer be used.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) $ce25ded360f850bd$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $bCfQ0.getApolloClientMemoryInternals);

});
parcelRegister("irVrB", function(module, exports) {

$parcel$export(module.exports, "ApolloLink", () => $d6e74ed765b7d991$export$2fed3d61f740bc7f);
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");
parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");
var $4YPPO = parcelRequire("4YPPO");

var $j5swF = parcelRequire("j5swF");
var $dlpl9 = parcelRequire("dlpl9");
var $g3DSw = parcelRequire("g3DSw");
function $d6e74ed765b7d991$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $1ieNy.Observable).of();
}
function $d6e74ed765b7d991$var$toLink(handler) {
    return typeof handler === "function" ? new $d6e74ed765b7d991$export$2fed3d61f740bc7f(handler) : handler;
}
function $d6e74ed765b7d991$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $d6e74ed765b7d991$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $1ieNy.Observable).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($d6e74ed765b7d991$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $d6e74ed765b7d991$var$toLink(left);
        var rightLink = $d6e74ed765b7d991$var$toLink(right || new ApolloLink($d6e74ed765b7d991$var$passthrough));
        var ret;
        if ($d6e74ed765b7d991$var$isTerminating(leftLink) && $d6e74ed765b7d991$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $1ieNy.Observable).of() : rightLink.request(operation) || (0, $1ieNy.Observable).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $1ieNy.Observable).of() : rightLink.request(operation, forward) || (0, $1ieNy.Observable).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $j5swF.createOperation)(operation.context, (0, $dlpl9.transformOperation)((0, $g3DSw.validateOperation)(operation)))) || (0, $1ieNy.Observable).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $d6e74ed765b7d991$var$toLink(first);
        if ($d6e74ed765b7d991$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(47, firstLink);
            return firstLink;
        }
        var nextLink = $d6e74ed765b7d991$var$toLink(second);
        var ret;
        if ($d6e74ed765b7d991$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $1ieNy.Observable).of();
            }) || (0, $1ieNy.Observable).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $1ieNy.Observable).of();
            }) || (0, $1ieNy.Observable).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($d6e74ed765b7d991$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $jWokI.newInvariantError)(48);
    };
    /**
     * @deprecated `onError` will be removed with Apollo Client 4.0. Please
     * discontinue using this method.
     */ ApolloLink.prototype.onError = function(error, observer) {
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnDeprecated)("onError", function() {
            globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(49);
        });
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    /**
     * @deprecated `setOnError` will be removed with Apollo Client 4.0. Please
     * discontinue using this method.
     */ ApolloLink.prototype.setOnError = function(fn) {
        if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(50);
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();

});
parcelRegister("j5swF", function(module, exports) {

$parcel$export(module.exports, "createOperation", () => $de549c9ca7f44d0e$export$f29bedd62f56fcb2);

var $5Rzv1 = parcelRequire("5Rzv1");
function $de549c9ca7f44d0e$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $5Rzv1.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, context), next(context));
        else context = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, context), next);
    };
    var getContext = function() {
        return (0, $5Rzv1.__assign)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}

});

parcelRegister("dlpl9", function(module, exports) {

$parcel$export(module.exports, "transformOperation", () => $9b70e49035c58bd4$export$4f3f7df1b558c729);

var $aPfFa = parcelRequire("aPfFa");
function $9b70e49035c58bd4$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $aPfFa.getOperationName)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}

});

parcelRegister("g3DSw", function(module, exports) {

$parcel$export(module.exports, "validateOperation", () => $bb0bdc2b136ec947$export$a92a48117d546c9);
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");
function $bb0bdc2b136ec947$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $jWokI.newInvariantError)(58, key);
    }
    return operation;
}

});


parcelRegister("5xB32", function(module, exports) {

$parcel$export(module.exports, "execute", () => $408cc5c62e03d70d$export$51396ec711da548b);

var $irVrB = parcelRequire("irVrB");
var $408cc5c62e03d70d$export$51396ec711da548b = (0, $irVrB.ApolloLink).execute;

});

parcelRegister("1t3R9", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $111b7daae95423c0$export$f4bbf1aec241cc1);

var $5Rzv1 = parcelRequire("5Rzv1");

var $irVrB = parcelRequire("irVrB");

var $khEaU = parcelRequire("khEaU");
var $111b7daae95423c0$export$f4bbf1aec241cc1 = /** @class */ function(_super) {
    (0, $5Rzv1.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $khEaU.createHttpLink)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $irVrB.ApolloLink));

});
parcelRegister("khEaU", function(module, exports) {

$parcel$export(module.exports, "createHttpLink", () => $ec448f12480093a8$export$95180a16573d6675);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $irVrB = parcelRequire("irVrB");

var $aPfFa = parcelRequire("aPfFa");
var $3nA2J = parcelRequire("3nA2J");parcelRequire("7aKgP");
var $fRFeB = parcelRequire("fRFeB");parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");
var $fOMXV = parcelRequire("fOMXV");

var $3UrrG = parcelRequire("3UrrG");

var $KCnMl = parcelRequire("KCnMl");

var $1CZnA = parcelRequire("1CZnA");

var $2G9o3 = parcelRequire("2G9o3");

var $j8qDE = parcelRequire("j8qDE");

var $cNBmG = parcelRequire("cNBmG");

var $2TV0K = parcelRequire("2TV0K");
var $iJDUC = parcelRequire("iJDUC");
var $ec448f12480093a8$var$backupFetch = (0, $fRFeB.maybe)(function() {
    return fetch;
});
var $ec448f12480093a8$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $j8qDE.defaultPrinter) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $5Rzv1.__rest)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $2G9o3.checkFetcher)(preferredFetch || $ec448f12480093a8$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $irVrB.ApolloLink)(function(operation) {
        var chosenURI = (0, $KCnMl.selectURI)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $3nA2J.hasDirectives)([
            "client"
        ], operation.query)) {
            if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(52);
            var transformedQuery = (0, $fOMXV.removeClientSetsFromDocument)(operation.query);
            if (!transformedQuery) return (0, $iJDUC.fromError)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $j8qDE.selectHttpOptionsAndBodyInternal)(operation, print, (0, $j8qDE.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $2TV0K.filterOperationVariables)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $aPfFa.getMainDefinition)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $3nA2J.hasDirectives)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(53);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $cNBmG.rewriteURIForGET)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $iJDUC.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $3UrrG.serializeFetchParameter)(body, "Payload");
        } catch (parseError) {
            return (0, $iJDUC.fromError)(parseError);
        }
        return new (0, $1ieNy.Observable)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $fRFeB.maybe)(function() {
                return fetch;
            }) || $ec448f12480093a8$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $1CZnA.readMultipartBody)(response, observerNext);
                else return (0, $1CZnA.parseAndCheckHttpResponse)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $1CZnA.handleError)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};

});
parcelRegister("3UrrG", function(module, exports) {

$parcel$export(module.exports, "serializeFetchParameter", () => $2d8be427bc1ae0e6$export$5f8e80ac52052e28);
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");
var $2d8be427bc1ae0e6$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $jWokI.newInvariantError)(54, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};

});

parcelRegister("KCnMl", function(module, exports) {

$parcel$export(module.exports, "selectURI", () => $08c211f676a125c0$export$63ccc2571850f81a);
var $08c211f676a125c0$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};

});

parcelRegister("1CZnA", function(module, exports) {

$parcel$export(module.exports, "readMultipartBody", () => $12f8f3c14e5e8299$export$ccb60864026baf09);
$parcel$export(module.exports, "handleError", () => $12f8f3c14e5e8299$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $12f8f3c14e5e8299$export$d4051215bea0639f);

var $5Rzv1 = parcelRequire("5Rzv1");

var $1alV6 = parcelRequire("1alV6");

var $1Vbax = parcelRequire("1Vbax");

var $iIE8V = parcelRequire("iIE8V");

var $75kDF = parcelRequire("75kDF");
var $12f8f3c14e5e8299$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $12f8f3c14e5e8299$export$ccb60864026baf09(response, nextValue) {
    return (0, $5Rzv1.__awaiter)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return (0, $5Rzv1.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $1alV6.responseIterator)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $12f8f3c14e5e8299$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $12f8f3c14e5e8299$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $75kDF.isApolloPayloadResult)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) return [
                                            2 /*return*/ 
                                        ];
                                        next = (0, $5Rzv1.__assign)({}, result.payload);
                                    }
                                    if ("errors" in result) next = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, next), {
                                        extensions: (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[0, $iIE8V.PROTOCOL_ERRORS_SYMBOL] = result.errors, _c))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $12f8f3c14e5e8299$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $12f8f3c14e5e8299$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $1Vbax.throwServerError)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $12f8f3c14e5e8299$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $12f8f3c14e5e8299$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $12f8f3c14e5e8299$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$12f8f3c14e5e8299$var$hasOwnProperty.call(result, "data") && !$12f8f3c14e5e8299$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $1Vbax.throwServerError)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}

});
parcelRegister("1alV6", function(module, exports) {

$parcel$export(module.exports, "responseIterator", () => $0d97ba740d573fd5$export$7e4ac9ed9577f145);
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
var $dx1F4 = parcelRequire("dx1F4");

var $9OcoQ = parcelRequire("9OcoQ");

var $3xZFM = parcelRequire("3xZFM");

var $3ZzPT = parcelRequire("3ZzPT");

var $ext8S = parcelRequire("ext8S");
function $0d97ba740d573fd5$var$isNodeResponse(value) {
    return !!value.body;
}
function $0d97ba740d573fd5$var$isReadableStream(value) {
    return !!value.getReader;
}
function $0d97ba740d573fd5$var$isAsyncIterableIterator(value) {
    return !!((0, $dx1F4.canUseAsyncIteratorSymbol) && value[Symbol.asyncIterator]);
}
function $0d97ba740d573fd5$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $0d97ba740d573fd5$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $0d97ba740d573fd5$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $0d97ba740d573fd5$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($0d97ba740d573fd5$var$isNodeResponse(response)) body = response.body;
    if ($0d97ba740d573fd5$var$isAsyncIterableIterator(body)) return (0, $9OcoQ.default)(body);
    if ($0d97ba740d573fd5$var$isReadableStream(body)) return (0, $ext8S.default)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($0d97ba740d573fd5$var$isStreamableBlob(body)) return (0, $ext8S.default)(body.stream().getReader());
    if ($0d97ba740d573fd5$var$isBlob(body)) return (0, $3ZzPT.default)(body.arrayBuffer());
    if ($0d97ba740d573fd5$var$isNodeReadableStream(body)) return (0, $3xZFM.default)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}

});
parcelRegister("9OcoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $724266e4f43a4527$export$2e2bcd8739ae039);
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $724266e4f43a4527$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}

});

parcelRegister("3xZFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $29544b1eb3b61809$export$2e2bcd8739ae039);
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
var $dx1F4 = parcelRequire("dx1F4");
function $29544b1eb3b61809$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $dx1F4.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});

parcelRegister("3ZzPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e82dddc8f7f1048$export$2e2bcd8739ae039);
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
var $dx1F4 = parcelRequire("dx1F4");
function $2e82dddc8f7f1048$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $dx1F4.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});

parcelRegister("ext8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $a95ac0c9b87785e3$export$2e2bcd8739ae039);
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
var $dx1F4 = parcelRequire("dx1F4");
function $a95ac0c9b87785e3$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $dx1F4.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});


parcelRegister("1Vbax", function(module, exports) {

$parcel$export(module.exports, "throwServerError", () => $1663c738850df8f6$export$c33ef9219f27efd7);
/**
 * @deprecated `throwServerError` will be removed in Apollo Client 4.0. This is
 * safe to use in Apollo Client 3.x.
 *
 * **Recommended now**
 *
 * No action needed
 *
 * **When migrating**
 *
 * `ServerError` is a subclass of `Error`. To throw a server error, use
 * `throw new ServerError(...)` instead.
 *
 * ```ts
 * throw new ServerError("error message", { response, result });
 * ```
 */ var $1663c738850df8f6$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};

});

parcelRegister("iIE8V", function(module, exports) {

$parcel$export(module.exports, "PROTOCOL_ERRORS_SYMBOL", () => $da0b799f644156c3$export$4995664c1b49842e);
$parcel$export(module.exports, "graphQLResultHasProtocolErrors", () => $da0b799f644156c3$export$345f95cc6b6b9b0b);
$parcel$export(module.exports, "isApolloError", () => $da0b799f644156c3$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $da0b799f644156c3$export$26a337512320b8c6);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");

var $9qEGC = parcelRequire("9qEGC");
var $da0b799f644156c3$export$4995664c1b49842e = Symbol();
function $da0b799f644156c3$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$da0b799f644156c3$export$4995664c1b49842e]);
    return false;
}
function $da0b799f644156c3$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $da0b799f644156c3$var$generateErrorMessage = function(err) {
    var errors = (0, $5Rzv1.__spreadArray)((0, $5Rzv1.__spreadArray)((0, $5Rzv1.__spreadArray)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $9qEGC.isNonNullObject)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $da0b799f644156c3$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $5Rzv1.__extends)(ApolloError, _super);
    // Constructs an instance of ApolloError given serialized GraphQL errors,
    // client errors, protocol errors or network errors.
    // Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $da0b799f644156c3$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.cause = (0, $5Rzv1.__spreadArray)((0, $5Rzv1.__spreadArray)((0, $5Rzv1.__spreadArray)([
            networkError
        ], graphQLErrors || [], true), protocolErrors || [], true), clientErrors || [], true).find(function(e) {
            return !!e;
        }) || null;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);

});

parcelRegister("75kDF", function(module, exports) {

$parcel$export(module.exports, "isExecutionPatchIncrementalResult", () => $5289027d39891f2f$export$879767c5cdf33cb3);
$parcel$export(module.exports, "isExecutionPatchResult", () => $5289027d39891f2f$export$f90dc0a3531b8b83);
$parcel$export(module.exports, "isApolloPayloadResult", () => $5289027d39891f2f$export$3f32b6369f408f33);
$parcel$export(module.exports, "mergeIncrementalData", () => $5289027d39891f2f$export$9a905f57d6393874);

var $9qEGC = parcelRequire("9qEGC");

var $gvWmV = parcelRequire("gvWmV");

var $9waFp = parcelRequire("9waFp");
function $5289027d39891f2f$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $5289027d39891f2f$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $5289027d39891f2f$export$f90dc0a3531b8b83(value) {
    return $5289027d39891f2f$export$879767c5cdf33cb3(value) || $5289027d39891f2f$export$6c17a45d8c64ff02(value);
}
function $5289027d39891f2f$export$3f32b6369f408f33(value) {
    return (0, $9qEGC.isNonNullObject)(value) && "payload" in value;
}
function $5289027d39891f2f$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $9waFp.DeepMerger)();
    if ($5289027d39891f2f$export$879767c5cdf33cb3(result) && (0, $gvWmV.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}

});


parcelRegister("2G9o3", function(module, exports) {

$parcel$export(module.exports, "checkFetcher", () => $1f36c90e98e9bbc9$export$8423f0cd3773115e);
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");
var $1f36c90e98e9bbc9$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $jWokI.newInvariantError)(51);
};

});

parcelRegister("j8qDE", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $dee36d887bae7f21$export$dd86f00dc866e75d);
$parcel$export(module.exports, "defaultPrinter", () => $dee36d887bae7f21$export$e88934976ca4fd65);
$parcel$export(module.exports, "selectHttpOptionsAndBodyInternal", () => $dee36d887bae7f21$export$12d90ccf75844275);

var $5Rzv1 = parcelRequire("5Rzv1");

var $lAW9R = parcelRequire("lAW9R");
var $dee36d887bae7f21$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $dee36d887bae7f21$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $dee36d887bae7f21$var$defaultOptions = {
    method: "POST"
};
var $dee36d887bae7f21$export$dd86f00dc866e75d = {
    http: $dee36d887bae7f21$var$defaultHttpOptions,
    headers: $dee36d887bae7f21$var$defaultHeaders,
    options: $dee36d887bae7f21$var$defaultOptions
};
var $dee36d887bae7f21$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $dee36d887bae7f21$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $dee36d887bae7f21$export$12d90ccf75844275.apply(void 0, (0, $5Rzv1.__spreadArray)([
        operation,
        $dee36d887bae7f21$export$e88934976ca4fd65
    ], configs, false));
}
function $dee36d887bae7f21$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), config.options), {
            headers: (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, http), config.http);
    });
    if (options.headers) options.headers = $dee36d887bae7f21$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $lAW9R.print));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $dee36d887bae7f21$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = {};
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = {};
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = {};
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}

});

parcelRegister("cNBmG", function(module, exports) {

$parcel$export(module.exports, "rewriteURIForGET", () => $95170b811d78a662$export$fb82bb094b6f76b5);

var $3UrrG = parcelRequire("3UrrG");
function $95170b811d78a662$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $3UrrG.serializeFetchParameter)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $3UrrG.serializeFetchParameter)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}

});

parcelRegister("2TV0K", function(module, exports) {

$parcel$export(module.exports, "filterOperationVariables", () => $21ccf105d8874d98$export$de246493ae27fe3f);

var $5Rzv1 = parcelRequire("5Rzv1");

var $1Ojkk = parcelRequire("1Ojkk");
function $21ccf105d8874d98$export$de246493ae27fe3f(variables, query) {
    var result = (0, $5Rzv1.__assign)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $1Ojkk.visit)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}

});

parcelRegister("iJDUC", function(module, exports) {

$parcel$export(module.exports, "fromError", () => $da3b63b0f96b2c5f$export$4fd972edbe7450d3);
parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");
function $da3b63b0f96b2c5f$export$4fd972edbe7450d3(errorValue) {
    return new (0, $1ieNy.Observable)(function(observer) {
        observer.error(errorValue);
    });
}

});



parcelRegister("hUJU9", function(module, exports) {

$parcel$export(module.exports, "QueryManager", () => $d0ab46553ebca11e$export$b986383a50b53ea4);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $5nLer = parcelRequire("5nLer");

var $5xB32 = parcelRequire("5xB32");

var $fOMXV = parcelRequire("fOMXV");
var $4jzBp = parcelRequire("4jzBp");
var $gPdQG = parcelRequire("gPdQG");
var $6cKaj = parcelRequire("6cKaj");
var $MMf7r = parcelRequire("MMf7r");
var $8JTgn = parcelRequire("8JTgn");
var $aPfFa = parcelRequire("aPfFa");
var $5p1wj = parcelRequire("5p1wj");
var $3nA2J = parcelRequire("3nA2J");
var $eSohM = parcelRequire("eSohM");
var $75kDF = parcelRequire("75kDF");
var $2BGiW = parcelRequire("2BGiW");
var $gvWmV = parcelRequire("gvWmV");
var $9qEGC = parcelRequire("9qEGC");
var $egfXt = parcelRequire("egfXt");
var $4YPPO = parcelRequire("4YPPO");parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");
var $lAW9R = parcelRequire("lAW9R");

var $7Szzy = parcelRequire("7Szzy");

var $75kDF = parcelRequire("75kDF");

var $iIE8V = parcelRequire("iIE8V");

var $eKWCE = parcelRequire("eKWCE");

var $5m7wF = parcelRequire("5m7wF");

var $8LKmj = parcelRequire("8LKmj");

var $ehE1V = parcelRequire("ehE1V");

var $9HcNb = parcelRequire("9HcNb");
var $gaJpV = parcelRequire("gaJpV");
var $d0ab46553ebca11e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $d0ab46553ebca11e$var$IGNORE = Object.create(null);
var $d0ab46553ebca11e$export$b986383a50b53ea4 = /** @class */ function() {
    function QueryManager(options) {
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, $gPdQG.AutoCleanedWeakCache)((0, $6cKaj.cacheSizes)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, $ehE1V.Trie)(false);
        this.noCacheWarningsByQueryId = new Set();
        var defaultDocumentTransform = new (0, $8JTgn.DocumentTransform)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = options.cache;
        this.link = options.link;
        this.defaultOptions = options.defaultOptions;
        this.queryDeduplication = options.queryDeduplication;
        this.clientAwareness = options.clientAwareness;
        this.localState = options.localState;
        this.ssrMode = options.ssrMode;
        this.assumeImmutableResults = options.assumeImmutableResults;
        this.dataMasking = options.dataMasking;
        var documentTransform = options.documentTransform;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = options.defaultContext || Object.create(null);
        if (this.onBroadcast = options.onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $jWokI.newInvariantError)(35));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        return (0, $5Rzv1.__awaiter)(this, arguments, void 0, function(_b) {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            var _c, _d;
            var mutation = _b.mutation, variables = _b.variables, optimisticResponse = _b.optimisticResponse, updateQueries = _b.updateQueries, _e = _b.refetchQueries, refetchQueries = _e === void 0 ? [] : _e, _f = _b.awaitRefetchQueries, awaitRefetchQueries = _f === void 0 ? false : _f, updateWithProxyFn = _b.update, onQueryUpdated = _b.onQueryUpdated, _g = _b.fetchPolicy, fetchPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.fetchPolicy) || "network-only" : _g, _h = _b.errorPolicy, errorPolicy = _h === void 0 ? ((_d = this.defaultOptions.mutate) === null || _d === void 0 ? void 0 : _d.errorPolicy) || "none" : _h, keepRootFields = _b.keepRootFields, context = _b.context;
            return (0, $5Rzv1.__generator)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        (0, $jWokI.invariant)(mutation, 36);
                        (0, $jWokI.invariant)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 37);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, $4jzBp.asyncMap)(self.getObservableFromLink(mutation, (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, {}, false), function(result) {
                                    if ((0, $5p1wj.graphQLResultHasError)(result) && errorPolicy === "none") throw new (0, $iIE8V.ApolloError)({
                                        graphQLErrors: (0, $5p1wj.getGraphQLErrorsFromResult)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $5Rzv1.__assign)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $5p1wj.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, storeResult), {
                                            data: self.maskOperation({
                                                document: mutation,
                                                data: storeResult.data,
                                                fetchPolicy: fetchPolicy,
                                                id: mutationId
                                            })
                                        }));
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $iIE8V.ApolloError) ? err : new (0, $iIE8V.ApolloError)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $8LKmj.shouldWriteResult)(result, mutation.errorPolicy)) {
            if (!(0, $75kDF.isExecutionPatchIncrementalResult)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $75kDF.isExecutionPatchIncrementalResult)(result) && (0, $gvWmV.isNonEmptyArray)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $75kDF.mergeIncrementalData)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$d0ab46553ebca11e$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $aPfFa.getOperationName)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, $75kDF.isExecutionPatchResult)(result) || (0, $75kDF.isExecutionPatchIncrementalResult)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $d0ab46553ebca11e$var$IGNORE
        }) : optimisticResponse;
        if (data === $d0ab46553ebca11e$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $jWokI.invariant).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(this.getOrCreateQuery(queryId), options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $3nA2J.hasClientExports)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $3nA2J.hasDirectives)([
                    "nonreactive"
                ], document),
                nonReactiveQuery: (0, $fOMXV.addNonReactiveToNamedFragments)(document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $fOMXV.removeDirectivesFromDocument)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    },
                    {
                        name: "unmask"
                    }
                ], document),
                defaultVars: (0, $aPfFa.getDefaultValues)((0, $aPfFa.getOperationDefinition)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $8LKmj.QueryInfo)(this);
        var observable = new (0, $eKWCE.ObservableQuery)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        if (!(0, $eKWCE.ObservableQuery)["inactiveOnCreation"].getValue()) this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $jWokI.invariant)(options.query, 38);
        (0, $jWokI.invariant)(options.query.kind === "Document", 39);
        (0, $jWokI.invariant)(!options.returnPartialData, 40);
        (0, $jWokI.invariant)(!options.pollInterval, 41);
        var query = this.transform(options.query);
        return this.fetchQuery(queryId, (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
            query: query
        })).then(function(result) {
            return result && (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, result), {
                data: _this.maskOperation({
                    document: query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    id: queryId
                })
            });
        }).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $jWokI.newInvariantError)(42));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, $5m7wF.NetworkStatus).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNames = new Map();
        var queryNamesAndQueryStrings = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") {
                queryNames.set(desc, desc);
                queryNamesAndQueryStrings.set(desc, false);
            } else if ((0, $eSohM.isDocumentNode)(desc)) {
                var queryString = (0, $lAW9R.print)(_this.transform(desc));
                queryNames.set(queryString, (0, $aPfFa.getOperationName)(desc));
                queryNamesAndQueryStrings.set(queryString, false);
            } else if ((0, $9qEGC.isNonNullObject)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndQueryStrings.has(queryName) || document && queryNamesAndQueryStrings.has((0, $lAW9R.print)(document))) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndQueryStrings.set(queryName, true);
                    if (document) queryNamesAndQueryStrings.set((0, $lAW9R.print)(document), true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, $egfXt.makeUniqueId)("legacyOneTimeQuery");
            var queryInfo = _this.getOrCreateQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $eKWCE.ObservableQuery)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $jWokI.invariant)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndQueryStrings.size) queryNamesAndQueryStrings.forEach(function(included, nameOrQueryString) {
            if (!included) {
                var queryName = queryNames.get(nameOrQueryString);
                if (queryName) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(43, queryName);
                else globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(44);
            }
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            (0, $4YPPO.muteDeprecations)("resetLastResults", function() {
                return observableQuery.resetLastResults();
            });
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            (_this.queries.get(queryId) || observableQuery["queryInfo"]).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.startGraphQLSubscription = function(options) {
        var _this = this;
        var query = options.query, variables = options.variables;
        var fetchPolicy = options.fetchPolicy, _a = options.errorPolicy, errorPolicy = _a === void 0 ? "none" : _a, _b = options.context, context = _b === void 0 ? {} : _b, _c = options.extensions, extensions = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables, extensions).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, $8LKmj.shouldWriteResult)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $5p1wj.graphQLResultHasError)(result);
                var hasProtocolErrors = (0, $iIE8V.graphQLResultHasProtocolErrors)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $iIE8V.PROTOCOL_ERRORS_SYMBOL];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $iIE8V.ApolloError)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $1ieNy.Observable)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        var _a;
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            (_a = this.queries.get(queryId)) === null || _a === void 0 || _a.stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            var _a;
            return (_a = info.observableQuery) === null || _a === void 0 ? void 0 : _a["notify"]();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, extensions, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $aPfFa.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, context), {
                    forceFetch: !deduplication
                })),
                extensions: extensions
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $lAW9R.print)(serverQuery);
                var varJson_1 = (0, $7Szzy.canonicalStringify)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast_1 = new (0, $MMf7r.Concast)([
                        (0, $5xB32.execute)(link, operation)
                    ]);
                    observable = entry.observable = concast_1;
                    concast_1.beforeNext(function cb(method, arg) {
                        if (method === "next" && "hasNext" in arg && arg.hasNext) concast_1.beforeNext(cb);
                        else inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, $MMf7r.Concast)([
                (0, $5xB32.execute)(link, operation)
            ]);
        } else {
            observable = new (0, $MMf7r.Concast)([
                (0, $1ieNy.Observable).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $4jzBp.asyncMap)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $4jzBp.asyncMap)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $5p1wj.getGraphQLErrorsFromResult)(result);
            var hasErrors = graphQLErrors.length > 0;
            var errorPolicy = options.errorPolicy;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, $iIE8V.ApolloError)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $5m7wF.NetworkStatus).ready
            };
            // In the case we start multiple network requests simulatenously, we
            // want to ensure we properly set `data` if we're reporting on an old
            // result which will not be caught by the conditional above that ends up
            // throwing the markError result.
            if (hasErrors && errorPolicy === "none") aqr.data = void 0;
            if (hasErrors && errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $5m7wF.NetworkStatus).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $iIE8V.isApolloError)(networkError) ? networkError : new (0, $iIE8V.ApolloError)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryInfo, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $5m7wF.NetworkStatus).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryInfo.queryId);
        };
        this.fetchCancelFns.set(queryInfo.queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $MMf7r.Concast)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $MMf7r.Concast)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $egfXt.makeUniqueId)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: (_this.queries.get(queryId) || oq["queryInfo"]).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $8LKmj.QueryInfo) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) diff = (0, $4YPPO.muteDeprecations)("canonizeResults", function() {
                    return _this.cache.diff(oq["queryInfo"]["getDiffOptions"]());
                });
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.maskOperation = function(options) {
        var _a, _b, _c;
        var document = options.document, data = options.data;
        if (globalThis.__DEV__ !== false) {
            var fetchPolicy = options.fetchPolicy, id = options.id;
            var operationType = (_a = (0, $aPfFa.getOperationDefinition)(document)) === null || _a === void 0 ? void 0 : _a.operation;
            var operationId = ((_b = operationType === null || operationType === void 0 ? void 0 : operationType[0]) !== null && _b !== void 0 ? _b : "o") + id;
            if (this.dataMasking && fetchPolicy === "no-cache" && !(0, $2BGiW.isFullyUnmaskedOperation)(document) && !this.noCacheWarningsByQueryId.has(operationId)) {
                this.noCacheWarningsByQueryId.add(operationId);
                globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(45, (_c = (0, $aPfFa.getOperationName)(document)) !== null && _c !== void 0 ? _c : "Unnamed ".concat(operationType !== null && operationType !== void 0 ? operationType : "operation"));
            }
        }
        return this.dataMasking ? (0, $gaJpV.maskOperation)(data, document, this.cache) : data;
    };
    QueryManager.prototype.maskFragment = function(options) {
        var data = options.data, fragment = options.fragment, fragmentName = options.fragmentName;
        return this.dataMasking ? (0, $9HcNb.maskFragment)(data, fragment, this.cache, fragmentName) : data;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $5m7wF.NetworkStatus).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $5nLer.equal)(data, {})) (0, $eKWCE.logMissingFieldErrors)(diff.missing);
            var fromData = function(data) {
                return (0, $1ieNy.Observable).of((0, $5Rzv1.__assign)({
                    data: data,
                    loading: (0, $5m7wF.isNetworkRequestInFlight)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $5m7wF.NetworkStatus).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $5m7wF.NetworkStatus).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $5m7wF.isNetworkRequestInFlight)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getOrCreateQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $8LKmj.QueryInfo)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();

});
parcelRegister("4jzBp", function(module, exports) {

$parcel$export(module.exports, "asyncMap", () => $32448da6f78544d0$export$707ee4c4c95d39e3);
parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");
function $32448da6f78544d0$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $1ieNy.Observable)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}

});

parcelRegister("MMf7r", function(module, exports) {

$parcel$export(module.exports, "Concast", () => $0929e7d5daefdc95$export$ae0cf2ec7a6fa78e);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");

var $87Qwv = parcelRequire("87Qwv");

var $34VIy = parcelRequire("34VIy");
function $0929e7d5daefdc95$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var $0929e7d5daefdc95$export$ae0cf2ec7a6fa78e = /** @class */ function(_super) {
    (0, $5Rzv1.__extends)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $87Qwv.iterateObserversSafely)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $87Qwv.iterateObserversSafely)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, $87Qwv.iterateObserversSafely)(_this.observers, "complete");
                    } else if ($0929e7d5daefdc95$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.error(reason);
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, $1ieNy.Observable)(sources)
        ];
        if ($0929e7d5daefdc95$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $1ieNy.Observable));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, $34VIy.fixObservableSubclass)($0929e7d5daefdc95$export$ae0cf2ec7a6fa78e);

});
parcelRegister("87Qwv", function(module, exports) {

$parcel$export(module.exports, "iterateObserversSafely", () => $5ea7b835054f6d7c$export$9f6c99ae166dbeca);
/**
 * @deprecated `iterateObserversSafely` will be removed with Apollo Client 4.0.
 * Please discontinue using this function.
 */ function $5ea7b835054f6d7c$export$9f6c99ae166dbeca(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}

});

parcelRegister("34VIy", function(module, exports) {

$parcel$export(module.exports, "fixObservableSubclass", () => $23de8459697e1de3$export$33c8bd820eece9b2);
parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");

var $dx1F4 = parcelRequire("dx1F4");
function $23de8459697e1de3$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, $1ieNy.Observable)
        });
    }
    if ((0, $dx1F4.canUseSymbol) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}

});


parcelRegister("5p1wj", function(module, exports) {

$parcel$export(module.exports, "graphQLResultHasError", () => $3ef0776dcc6e9659$export$b4df399e879e53ab);
$parcel$export(module.exports, "getGraphQLErrorsFromResult", () => $3ef0776dcc6e9659$export$a163557155188b6e);

var $gvWmV = parcelRequire("gvWmV");

var $75kDF = parcelRequire("75kDF");
function $3ef0776dcc6e9659$export$b4df399e879e53ab(result) {
    var errors = $3ef0776dcc6e9659$export$a163557155188b6e(result);
    return (0, $gvWmV.isNonEmptyArray)(errors);
}
function $3ef0776dcc6e9659$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $gvWmV.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $75kDF.isExecutionPatchIncrementalResult)(result) && (0, $gvWmV.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}

});

parcelRegister("eKWCE", function(module, exports) {

$parcel$export(module.exports, "ObservableQuery", () => $abe2d5c39a1db491$export$6c1b56eac59c9584);
$parcel$export(module.exports, "logMissingFieldErrors", () => $abe2d5c39a1db491$export$b7e1973aacac3ae7);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $5nLer = parcelRequire("5nLer");

var $5m7wF = parcelRequire("5m7wF");

var $llKlL = parcelRequire("llKlL");
var $bRE5f = parcelRequire("bRE5f");
var $34VIy = parcelRequire("34VIy");
var $aPfFa = parcelRequire("aPfFa");
var $87Qwv = parcelRequire("87Qwv");
var $4YPPO = parcelRequire("4YPPO");parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");
var $6ZcEn = parcelRequire("6ZcEn");

var $iIE8V = parcelRequire("iIE8V");

var $iKyVm = parcelRequire("iKyVm");
parcelRequire("elxhT");
var $j3PV9 = parcelRequire("j3PV9");
var $abe2d5c39a1db491$var$assign = Object.assign, $abe2d5c39a1db491$var$hasOwnProperty = Object.hasOwnProperty;
var $abe2d5c39a1db491$export$6c1b56eac59c9584 = /** @class */ function(_super) {
    (0, $5Rzv1.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = this;
        var startedInactive = ObservableQuery.inactiveOnCreation.getValue();
        _this = _super.call(this, function(observer) {
            _this._getOrCreateQuery();
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $abe2d5c39a1db491$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(_this.maskResult(last.result));
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.dirty = false;
        _this._getOrCreateQuery = function() {
            if (startedInactive) {
                queryManager["queries"].set(_this.queryId, queryInfo);
                startedInactive = false;
            }
            return _this.queryManager.getOrCreateQuery(_this.queryId);
        };
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = $abe2d5c39a1db491$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        _this.subscribeToMore = _this.subscribeToMore.bind(_this);
        _this.maskResult = _this.maskResult.bind(_this);
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $aPfFa.getOperationDefinition)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @deprecated `result` will be removed in Apollo Client 4.0.
     *
     * **Recommended now**
     *
     * If you continue to need this functionality, subscribe to `ObservableQuery`
     * to get the first value emitted from the observable, then immediately unsubscribe.
     *
     * **When upgrading**
     *
     * Use RxJS's [`firstResultFrom`](https://rxjs.dev/api/index/function/firstValueFrom) function to mimic this functionality.
     *
     * ```ts
     * const result = await firstValueFrom(from(observableQuery));
     * ```
     */ ObservableQuery.prototype.result = function() {
        var _this = this;
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnDeprecated)("observableQuery.result", function() {
            globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(23);
        });
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentFullResult = function(saveAsLastResult) {
        var _this = this;
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = (0, $4YPPO.muteDeprecations)("getLastResult", function() {
            return _this.getLastResult(true);
        });
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $5m7wF.NetworkStatus).ready;
        var result = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, lastResult), {
            loading: (0, $5m7wF.isNetworkRequestInFlight)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        $abe2d5c39a1db491$var$skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $5nLer.equal)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, $5m7wF.NetworkStatus).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $5m7wF.NetworkStatus).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            // We need to check for both both `error` and `errors` field because there
            // are cases where sometimes `error` is set, but not `errors` and
            // vice-versa. This will be updated in the next major version when
            // `errors` is deprecated in favor of `error`.
            if (result.networkStatus === (0, $5m7wF.NetworkStatus).ready && (result.error || result.errors)) result.networkStatus = (0, $5m7wF.NetworkStatus).error;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $abe2d5c39a1db491$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        return this.maskResult(this.getCurrentFullResult(saveAsLastResult));
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var documentInfo = this.queryManager.getDocumentInfo(this.query);
        var dataMasking = this.queryManager.dataMasking;
        var query = dataMasking ? documentInfo.nonReactiveQuery : this.query;
        var resultIsDifferent = dataMasking || documentInfo.hasNonreactiveDirective ? !(0, $iKyVm.equalByQuery)(query, this.last.result, newResult, this.variables) : !(0, $5nLer.equal)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $5nLer.equal)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $5nLer.equal)(last.variables, this.variables))) return last[key];
    };
    /**
     * @deprecated `getLastResult` will be removed in Apollo Client 4.0. Please
     * discontinue using this method.
     */ ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnDeprecated)("getLastResult", function() {
            globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(24);
        });
        return this.getLast("result", variablesMustMatch);
    };
    /**
     * @deprecated `getLastError` will be removed in Apollo Client 4.0. Please
     * discontinue using this method.
     */ ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnDeprecated)("getLastError", function() {
            globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(25);
        });
        return this.getLast("error", variablesMustMatch);
    };
    /**
     * @deprecated `resetLastResults` will be removed in Apollo Client 4.0. Please
     * discontinue using this method.
     */ ObservableQuery.prototype.resetLastResults = function() {
        if (globalThis.__DEV__ !== false) (0, $4YPPO.warnDeprecated)("resetLastResults", function() {
            globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(26);
        });
        delete this.last;
        this.isTornDown = false;
    };
    /**
     * @deprecated `resetQueryStoreErrors` will be removed in Apollo Client 4.0.
     * Please discontinue using this method.
     */ ObservableQuery.prototype.resetQueryStoreErrors = function() {
        if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(27);
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $abe2d5c39a1db491$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $aPfFa.getQueryDefinition)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(28, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $5nLer.equal)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $5m7wF.NetworkStatus).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $5m7wF.NetworkStatus).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        var updateQuery = fetchMoreOptions === null || fetchMoreOptions === void 0 ? void 0 : fetchMoreOptions.updateQuery;
        var isCached = this.options.fetchPolicy !== "no-cache";
        if (!isCached) (0, $jWokI.invariant)(updateQuery, 29);
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $5m7wF.NetworkStatus).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $5m7wF.NetworkStatus).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            if (isCached) // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            else {
                // There is a possibility `lastResult` may not be set when
                // `fetchMore` is called which would cause this to crash. This should
                // only happen if we haven't previously reported a result. We don't
                // quite know what the right behavior should be here since this block
                // of code runs after the fetch result has executed on the network.
                // We plan to let it crash in the meantime.
                //
                // If we get bug reports due to the `data` property access on
                // undefined, this should give us a real-world scenario that we can
                // use to test against and determine the right behavior. If we do end
                // up changing this behavior, this may require, for example, an
                // adjustment to the types on `updateQuery` since that function
                // expects that the first argument always contains previous result
                // data, but not `undefined`.
                var lastResult = _this.getLast("result");
                var data = updateQuery(lastResult.data, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
                _this.reportResult((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, lastResult), {
                    networkStatus: originalNetworkStatus,
                    loading: (0, $5m7wF.isNetworkRequestInFlight)(originalNetworkStatus),
                    data: data
                }), _this.variables);
            }
            return _this.maskResult(fetchMoreResult);
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (isCached && !updatedQuerySet.has(_this.query)) _this.reobserveCacheFirst();
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, updateOptions) {
                    return updateQuery(previous, (0, $5Rzv1.__assign)({
                        subscriptionData: subscriptionData
                    }, updateOptions));
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $jWokI.invariant).error(30, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    /**
     * @deprecated `setOptions` will be removed in Apollo Client 4.0. Please use
     * `observableQuery.reobserve(newOptions)` instead.
     */ ObservableQuery.prototype.setOptions = function(newOptions) {
        if (globalThis.__DEV__ !== false) {
            (0, $4YPPO.warnRemovedOption)(newOptions, "canonizeResults", "setOptions");
            (0, $4YPPO.warnDeprecated)("setOptions", function() {
                globalThis.__DEV__ !== false && (0, $jWokI.invariant).warn(31);
            });
        }
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $bRE5f.compact)(this.options, newOptions || {});
        $abe2d5c39a1db491$var$assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        var _this = this;
        if ((0, $5nLer.equal)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? (0, $4YPPO.muteDeprecations)("observableQuery.result", function() {
            return _this.result();
        }) : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $5m7wF.NetworkStatus).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }), result = _a.result, complete = _a.complete;
        var newResult = mapFn(result, {
            variables: this.variables,
            complete: !!complete,
            previousData: result
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        var queryInfo = this._getOrCreateQuery();
        queryInfo.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](queryInfo, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval || !this.hasObservers()) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $jWokI.invariant)(pollInterval, 32);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, $5m7wF.isNetworkRequestInFlight)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $5m7wF.NetworkStatus).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var error = (0, $4YPPO.muteDeprecations)("getLastError", function() {
            return _this.getLastError();
        });
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, $5nLer.equal)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $5Rzv1.__assign)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $llKlL.cloneDeep)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $5m7wF.NetworkStatus).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, $5m7wF.NetworkStatus).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $5m7wF.NetworkStatus).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $bRE5f.compact)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $abe2d5c39a1db491$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $5nLer.equal)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            (options.fetchPolicy === oldFetchPolicy || // A `nextFetchPolicy` function has even higher priority, though,
            // so in that case `applyNextFetchPolicy` must be called.
            typeof options.nextFetchPolicy === "function")) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $5m7wF.NetworkStatus).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = $abe2d5c39a1db491$var$skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, $5Rzv1.__assign)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, $5nLer.equal)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, $5nLer.equal)(_this.variables, variables)) {
                    // Coming from `getResultsFromLink`, `error` here should always be an `ApolloError`.
                    // However, calling `concast.cancel` can inject another type of error, so we have to
                    // wrap it again here.
                    if (!(0, $iIE8V.isApolloError)(error)) error = new (0, $iIE8V.ApolloError)({
                        networkError: error
                    });
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return (0, $6ZcEn.preventUnhandledRejection)(this.reobserveAsConcast(newOptions, newNetworkStatus).promise.then(this.maskResult));
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        (0, $4YPPO.muteDeprecations)("resetLastResults", function() {
            return _this.resetLastResults();
        });
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var _this = this;
        var lastError = (0, $4YPPO.muteDeprecations)("getLastError", function() {
            return _this.getLastError();
        });
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $87Qwv.iterateObserversSafely)(this.observers, "next", this.maskResult(result));
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        var _this = this;
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, (0, $4YPPO.muteDeprecations)("getLastResult", function() {
            return _this.getLastResult();
        })), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $5m7wF.NetworkStatus).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $87Qwv.iterateObserversSafely)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    ObservableQuery.prototype.maskResult = function(result) {
        return result && "data" in result ? (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, result), {
            data: this.queryManager.maskOperation({
                document: this.query,
                data: result.data,
                fetchPolicy: this.options.fetchPolicy,
                id: this.queryId
            })
        }) : result;
    };
    /** @internal */ ObservableQuery.prototype.resetNotifications = function() {
        this.cancelNotifyTimeout();
        this.dirty = false;
    };
    ObservableQuery.prototype.cancelNotifyTimeout = function() {
        if (this.notifyTimeout) {
            clearTimeout(this.notifyTimeout);
            this.notifyTimeout = void 0;
        }
    };
    /** @internal */ ObservableQuery.prototype.scheduleNotify = function() {
        var _this = this;
        if (this.dirty) return;
        this.dirty = true;
        if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
            return _this.notify();
        }, 0);
    };
    /** @internal */ ObservableQuery.prototype.notify = function() {
        this.cancelNotifyTimeout();
        if (this.dirty) {
            if (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !(0, $5m7wF.isNetworkRequestInFlight)(this.queryInfo.networkStatus)) {
                var diff = this.queryInfo.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                this.observe();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                this.reobserveCacheFirst();
            }
        }
        this.dirty = false;
    };
    // Reobserve with fetchPolicy effectively set to "cache-first", triggering
    // delivery of any new data from the cache, possibly falling back to the network
    // if any cache data are missing. This allows _complete_ cache results to be
    // delivered without also kicking off unnecessary network requests when
    // this.options.fetchPolicy is "cache-and-network" or "network-only". When
    // this.options.fetchPolicy is any other policy ("cache-first", "cache-only",
    // "standby", or "no-cache"), we call this.reobserve() as usual.
    ObservableQuery.prototype.reobserveCacheFirst = function() {
        var _a = this.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
        if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return this.reobserve({
            fetchPolicy: "cache-first",
            // Use a temporary nextFetchPolicy function that replaces itself with the
            // previous nextFetchPolicy value and returns the original fetchPolicy.
            nextFetchPolicy: function(currentFetchPolicy, context) {
                // Replace this nextFetchPolicy function in the options object with the
                // original this.options.nextFetchPolicy value.
                this.nextFetchPolicy = nextFetchPolicy;
                // If the original nextFetchPolicy value was a function, give it a
                // chance to decide what happens here.
                if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
                // Otherwise go back to the original this.options.fetchPolicy.
                return fetchPolicy;
            }
        });
        return this.reobserve();
    };
    /**
     * @internal
     * A slot used by the `useQuery` hook to indicate that `client.watchQuery`
     * should not register the query immediately, but instead wait for the query to
     * be started registered with the `QueryManager` when `useSyncExternalStore`
     * actively subscribes to it.
     */ ObservableQuery.inactiveOnCreation = new (0, $j3PV9.Slot)();
    return ObservableQuery;
}((0, $1ieNy.Observable));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, $34VIy.fixObservableSubclass)($abe2d5c39a1db491$export$6c1b56eac59c9584);
function $abe2d5c39a1db491$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $jWokI.invariant).error(33, error.message, error.stack);
}
function $abe2d5c39a1db491$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $jWokI.invariant).debug(34, missing);
}
function $abe2d5c39a1db491$var$skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}

});
parcelRegister("5m7wF", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $3e64d84fd32da212$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isNetworkRequestInFlight", () => $3e64d84fd32da212$export$37509604341a3464);
/**
 * The current status of a query’s execution in our system.
 */ var $3e64d84fd32da212$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($3e64d84fd32da212$export$bd096ddbd246c79c || ($3e64d84fd32da212$export$bd096ddbd246c79c = {}));
function $3e64d84fd32da212$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $3e64d84fd32da212$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}

});

parcelRegister("6ZcEn", function(module, exports) {

$parcel$export(module.exports, "preventUnhandledRejection", () => $516240ae8c3926bb$export$7ff41c6e01127226);
function $516240ae8c3926bb$export$7ff41c6e01127226(promise) {
    promise.catch(function() {});
    return promise;
}

});


parcelRegister("8LKmj", function(module, exports) {

$parcel$export(module.exports, "QueryInfo", () => $6626ac718c370412$export$79a6120a39c90b6a);
$parcel$export(module.exports, "shouldWriteResult", () => $6626ac718c370412$export$5f47a9fb9a521654);

var $5Rzv1 = parcelRequire("5Rzv1");

var $5nLer = parcelRequire("5nLer");

var $dx1F4 = parcelRequire("dx1F4");
var $9waFp = parcelRequire("9waFp");
var $5p1wj = parcelRequire("5p1wj");
var $gvWmV = parcelRequire("gvWmV");
var $75kDF = parcelRequire("75kDF");
var $4YPPO = parcelRequire("4YPPO");

var $5m7wF = parcelRequire("5m7wF");
var $6626ac718c370412$var$destructiveMethodCounts = new ((0, $dx1F4.canUseWeakMap) ? WeakMap : Map)();
function $6626ac718c370412$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $6626ac718c370412$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($6626ac718c370412$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var $6626ac718c370412$export$79a6120a39c90b6a = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$6626ac718c370412$var$destructiveMethodCounts.has(cache)) {
            $6626ac718c370412$var$destructiveMethodCounts.set(cache, 0);
            $6626ac718c370412$var$wrapDestructiveCacheMethod(cache, "evict");
            $6626ac718c370412$var$wrapDestructiveCacheMethod(cache, "modify");
            $6626ac718c370412$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $5m7wF.NetworkStatus).loading;
        if (this.variables && this.networkStatus !== (0, $5m7wF.NetworkStatus).loading && !(0, $5nLer.equal)(this.variables, query.variables)) networkStatus = (0, $5m7wF.NetworkStatus).setVariables;
        if (!(0, $5nLer.equal)(query.variables, this.variables)) {
            this.lastDiff = void 0;
            // Ensure we don't continue to receive cache updates for old variables
            this.cancel();
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var _this = this;
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $5nLer.equal)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = (0, $4YPPO.muteDeprecations)("canonizeResults", function() {
            return _this.cache.diff(options);
        });
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we are trying to deliver an incomplete cache result, we avoid
        // reporting it if the query has errored, otherwise we let the broadcast try
        // and repair the partial result by refetching the query. This check avoids
        // a situation where a query that errors and another succeeds with
        // overlapping data does not report the partial data result to the errored
        // query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && (0, $4YPPO.muteDeprecations)("getLastError", function() {
            var _a;
            return (_a = _this.observableQuery) === null || _a === void 0 ? void 0 : _a.getLastError();
        })) return;
        this.updateLastDiff(diff);
        if (!(0, $5nLer.equal)(oldDiff && oldDiff.result, diff && diff.result)) (_a = this.observableQuery) === null || _a === void 0 || _a["scheduleNotify"]();
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        if (oq === this.observableQuery) return;
        this.observableQuery = oq;
        if (oq) oq["queryInfo"] = this;
    };
    QueryInfo.prototype.stop = function() {
        var _a;
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
            this.cancel();
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function() {
        var _a;
        (_a = this.cancelWatch) === null || _a === void 0 || _a.call(this);
        this.cancelWatch = void 0;
    };
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $5nLer.equal)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancelWatch = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $6626ac718c370412$var$destructiveMethodCounts.get(this.cache) && (0, $5nLer.equal)(variables, lastWrite.variables) && (0, $5nLer.equal)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var _a;
        var merger = new (0, $9waFp.DeepMerger)();
        var graphQLErrors = (0, $gvWmV.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
        if ("incremental" in result && (0, $gvWmV.isNonEmptyArray)(result.incremental)) {
            var mergedData = (0, $75kDF.mergeIncrementalData)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($6626ac718c370412$export$5f47a9fb9a521654(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $6626ac718c370412$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = (0, $4YPPO.muteDeprecations)("canonizeResults", function() {
                    return cache.diff(diffOptions);
                });
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, $5nLer.equal)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $5m7wF.NetworkStatus).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        var _a;
        this.networkStatus = (0, $5m7wF.NetworkStatus).error;
        this.lastWrite = void 0;
        (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $6626ac718c370412$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $5p1wj.graphQLResultHasError)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}

});

parcelRegister("gaJpV", function(module, exports) {

$parcel$export(module.exports, "maskOperation", () => $bc60cf6dceed57a7$export$74a61e4252a4a2ef);
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $2BGiW = parcelRequire("2BGiW");
var $aPfFa = parcelRequire("aPfFa");

var $1LRWb = parcelRequire("1LRWb");

var $8tCCc = parcelRequire("8tCCc");
function $bc60cf6dceed57a7$export$74a61e4252a4a2ef(data, document, cache) {
    var _a;
    if (!cache.fragmentMatches) {
        if (globalThis.__DEV__ !== false) (0, $8tCCc.warnOnImproperCacheImplementation)();
        return data;
    }
    var definition = (0, $aPfFa.getOperationDefinition)(document);
    (0, $jWokI.invariant)(definition, 63);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    return (0, $1LRWb.maskDefinition)(data, definition.selectionSet, {
        operationType: definition.operation,
        operationName: (_a = definition.name) === null || _a === void 0 ? void 0 : _a.value,
        fragmentMap: (0, $2BGiW.createFragmentMap)((0, $aPfFa.getFragmentDefinitions)(document)),
        cache: cache,
        mutableTargets: new (0, $8tCCc.MapImpl)(),
        knownChanged: new (0, $8tCCc.SetImpl)()
    });
}

});


parcelRegister("hEYvw", function(module, exports) {

$parcel$export(module.exports, "LocalState", () => $cdb51ba0e74fae9b$export$19901bcd339c3ded);

var $5Rzv1 = parcelRequire("5Rzv1");
parcelRequire("7aKgP");
var $jWokI = parcelRequire("jWokI");

var $1Ojkk = parcelRequire("1Ojkk");
var $3NXsc = parcelRequire("3NXsc");

var $eSohM = parcelRequire("eSohM");
var $fOMXV = parcelRequire("fOMXV");
var $2BGiW = parcelRequire("2BGiW");
var $aPfFa = parcelRequire("aPfFa");
var $3nA2J = parcelRequire("3nA2J");
var $9waFp = parcelRequire("9waFp");

var $fpOnH = parcelRequire("fpOnH");
var $cdb51ba0e74fae9b$export$19901bcd339c3ded = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $9waFp.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $9waFp.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        return (0, $5Rzv1.__awaiter)(this, arguments, void 0, function(_b) {
            var document = _b.document, remoteResult = _b.remoteResult, context = _b.context, variables = _b.variables, _c = _b.onlyRunForcedResolvers, onlyRunForcedResolvers = _c === void 0 ? false : _c;
            return (0, $5Rzv1.__generator)(this, function(_d) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $3nA2J.hasDirectives)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, $fOMXV.removeClientSetsFromDocument)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document_1) {
        return (0, $5Rzv1.__awaiter)(this, arguments, void 0, function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, $5Rzv1.__generator)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, $5Rzv1.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $1Ojkk.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $1Ojkk.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $fOMXV.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document_1, rootValue_1) {
        return (0, $5Rzv1.__awaiter)(this, arguments, void 0, function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, $5Rzv1.__generator)(this, function(_b) {
                mainDefinition = (0, $aPfFa.getMainDefinition)(document);
                fragments = (0, $aPfFa.getFragmentDefinitions)(document);
                fragmentMap = (0, $2BGiW.createFragmentMap)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $5Rzv1.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $5Rzv1.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $5Rzv1.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $5Rzv1.__generator)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, $3nA2J.shouldInclude)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, $eSohM.isField)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $eSohM.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $eSohM.isInlineFragment)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, $jWokI.invariant)(fragment, 21, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $9waFp.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $5Rzv1.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $5Rzv1.__generator)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $eSohM.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, $fpOnH.cacheSlot).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $eSohM.argumentsObjectFromField)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $1Ojkk.visit)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $3NXsc.isSelectionNode)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $jWokI.invariant)(fragment, 22, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $3NXsc.isSelectionNode)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();

});
parcelRegister("3NXsc", function(module, exports) {

$parcel$export(module.exports, "isSelectionNode", () => $f1f2b6eae0d46d32$export$65772b71e1d017ba);

var $4ceQ1 = parcelRequire("4ceQ1");
function $f1f2b6eae0d46d32$export$e7ecd7c16613ccfd(node) {
    return $f1f2b6eae0d46d32$export$4cedd8740794bd78(node) || $f1f2b6eae0d46d32$export$b05c7141ec7770ba(node) || $f1f2b6eae0d46d32$export$fbc18e88163d676d(node);
}
function $f1f2b6eae0d46d32$export$4cedd8740794bd78(node) {
    return node.kind === (0, $4ceQ1.Kind).OPERATION_DEFINITION || node.kind === (0, $4ceQ1.Kind).FRAGMENT_DEFINITION;
}
function $f1f2b6eae0d46d32$export$65772b71e1d017ba(node) {
    return node.kind === (0, $4ceQ1.Kind).FIELD || node.kind === (0, $4ceQ1.Kind).FRAGMENT_SPREAD || node.kind === (0, $4ceQ1.Kind).INLINE_FRAGMENT;
}
function $f1f2b6eae0d46d32$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $4ceQ1.Kind).VARIABLE || node.kind === (0, $4ceQ1.Kind).INT || node.kind === (0, $4ceQ1.Kind).FLOAT || node.kind === (0, $4ceQ1.Kind).STRING || node.kind === (0, $4ceQ1.Kind).BOOLEAN || node.kind === (0, $4ceQ1.Kind).NULL || node.kind === (0, $4ceQ1.Kind).ENUM || node.kind === (0, $4ceQ1.Kind).LIST || node.kind === (0, $4ceQ1.Kind).OBJECT;
}
function $f1f2b6eae0d46d32$export$f95bfad9e6aea45f(node) {
    return $f1f2b6eae0d46d32$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $4ceQ1.Kind).LIST ? node.values.some($f1f2b6eae0d46d32$export$f95bfad9e6aea45f) : node.kind === (0, $4ceQ1.Kind).OBJECT ? node.fields.some((field)=>$f1f2b6eae0d46d32$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $4ceQ1.Kind).VARIABLE);
}
function $f1f2b6eae0d46d32$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $4ceQ1.Kind).NAMED_TYPE || node.kind === (0, $4ceQ1.Kind).LIST_TYPE || node.kind === (0, $4ceQ1.Kind).NON_NULL_TYPE;
}
function $f1f2b6eae0d46d32$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $4ceQ1.Kind).SCHEMA_DEFINITION || $f1f2b6eae0d46d32$export$a3584bba04f5bfe0(node) || node.kind === (0, $4ceQ1.Kind).DIRECTIVE_DEFINITION;
}
function $f1f2b6eae0d46d32$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $4ceQ1.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, $4ceQ1.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, $4ceQ1.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, $4ceQ1.Kind).UNION_TYPE_DEFINITION || node.kind === (0, $4ceQ1.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, $4ceQ1.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function $f1f2b6eae0d46d32$export$fbc18e88163d676d(node) {
    return node.kind === (0, $4ceQ1.Kind).SCHEMA_EXTENSION || node.kind === (0, $4ceQ1.Kind).DIRECTIVE_EXTENSION || $f1f2b6eae0d46d32$export$d7907721b241e11f(node);
}
function $f1f2b6eae0d46d32$export$d7907721b241e11f(node) {
    return node.kind === (0, $4ceQ1.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, $4ceQ1.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, $4ceQ1.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, $4ceQ1.Kind).UNION_TYPE_EXTENSION || node.kind === (0, $4ceQ1.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, $4ceQ1.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}
function $f1f2b6eae0d46d32$export$9c93c002c59dc2d6(node) {
    return node.kind === (0, $4ceQ1.Kind).TYPE_COORDINATE || node.kind === (0, $4ceQ1.Kind).MEMBER_COORDINATE || node.kind === (0, $4ceQ1.Kind).ARGUMENT_COORDINATE || node.kind === (0, $4ceQ1.Kind).DIRECTIVE_COORDINATE || node.kind === (0, $4ceQ1.Kind).DIRECTIVE_ARGUMENT_COORDINATE;
}

});


parcelRegister("jKMI2", function(module, exports) {

$parcel$export(module.exports, "mergeOptions", () => $e61818d82a61290b$export$235b7fc70b9fc359);

var $5Rzv1 = parcelRequire("5Rzv1");

var $bRE5f = parcelRequire("bRE5f");
function $e61818d82a61290b$export$235b7fc70b9fc359(defaults, options) {
    return (0, $bRE5f.compact)(defaults, options, options.variables && {
        variables: (0, $bRE5f.compact)((0, $5Rzv1.__assign)((0, $5Rzv1.__assign)({}, defaults && defaults.variables), options.variables))
    });
}

});


parcelRegister("9JsUy", function(module, exports) {

$parcel$export(module.exports, "concat", () => $715ebe2deca9337e$export$ee1b3e54f0441b22);

var $irVrB = parcelRequire("irVrB");
var $715ebe2deca9337e$export$ee1b3e54f0441b22 = (0, $irVrB.ApolloLink).concat;

});

parcelRegister("jXDjt", function(module, exports) {

$parcel$export(module.exports, "from", () => $e88205c9e4000df5$export$6788812c4e6611e6);

var $irVrB = parcelRequire("irVrB");
var $e88205c9e4000df5$export$6788812c4e6611e6 = (0, $irVrB.ApolloLink).from;

});

parcelRegister("4LC1k", function(module, exports) {

$parcel$export(module.exports, "split", () => $37890b4b31467452$export$65980d18b75784e2);

var $irVrB = parcelRequire("irVrB");
var $37890b4b31467452$export$65980d18b75784e2 = (0, $irVrB.ApolloLink).split;

});

parcelRegister("fSlNw", function(module, exports) {

$parcel$export(module.exports, "WebSocketLink", () => $b8ecceb8fe193222$export$c6ec1f112bd949a0);

var $5Rzv1 = parcelRequire("5Rzv1");

var $9IwMP = parcelRequire("9IwMP");

var $irVrB = parcelRequire("irVrB");
var $b8ecceb8fe193222$export$c6ec1f112bd949a0 = /** @class */ function(_super) {
    (0, $5Rzv1.__extends)(WebSocketLink, _super);
    function WebSocketLink(paramsOrClient) {
        var _this = _super.call(this) || this;
        if (paramsOrClient instanceof (0, $9IwMP.SubscriptionClient)) _this.subscriptionClient = paramsOrClient;
        else _this.subscriptionClient = new (0, $9IwMP.SubscriptionClient)(paramsOrClient.uri, paramsOrClient.options, paramsOrClient.webSocketImpl);
        return _this;
    }
    WebSocketLink.prototype.request = function(operation) {
        return this.subscriptionClient.request(operation);
    };
    return WebSocketLink;
}((0, $irVrB.ApolloLink));

});
parcelRegister("9IwMP", function(module, exports) {
"use strict";
var $7131a7d194997dfd$var$__assign = module.exports && module.exports.__assign || function() {
    $7131a7d194997dfd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7131a7d194997dfd$var$__assign.apply(this, arguments);
};
var $7131a7d194997dfd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7131a7d194997dfd$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7131a7d194997dfd$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SubscriptionClient = void 0;
var $7131a7d194997dfd$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : {};
var $7131a7d194997dfd$var$NativeWebSocket = $7131a7d194997dfd$var$_global.WebSocket || $7131a7d194997dfd$var$_global.MozWebSocket;

var $dkxwb = parcelRequire("dkxwb");

var $aAI5W = parcelRequire("aAI5W");

var $cfohG = parcelRequire("cfohG");

var $iR5Az = parcelRequire("iR5Az");

var $euNGW = parcelRequire("euNGW");

var $kXWrW = parcelRequire("kXWrW");

var $4jE47 = parcelRequire("4jE47");

var $g1EHn = parcelRequire("g1EHn");

var $d4fXk = parcelRequire("d4fXk");

var $h3eh8 = parcelRequire("h3eh8");
var $7131a7d194997dfd$var$SubscriptionClient = function() {
    function SubscriptionClient(url, options, webSocketImpl, webSocketProtocols) {
        var _a = options || {}, _b = _a.connectionCallback, connectionCallback = _b === void 0 ? undefined : _b, _c = _a.connectionParams, connectionParams = _c === void 0 ? {} : _c, _d = _a.minTimeout, minTimeout = _d === void 0 ? $d4fXk.MIN_WS_TIMEOUT : _d, _e = _a.timeout, timeout = _e === void 0 ? $d4fXk.WS_TIMEOUT : _e, _f = _a.reconnect, reconnect = _f === void 0 ? false : _f, _g = _a.reconnectionAttempts, reconnectionAttempts = _g === void 0 ? Infinity : _g, _h = _a.lazy, lazy = _h === void 0 ? false : _h, _j = _a.inactivityTimeout, inactivityTimeout = _j === void 0 ? 0 : _j, _k = _a.wsOptionArguments, wsOptionArguments = _k === void 0 ? [] : _k;
        this.wsImpl = webSocketImpl || $7131a7d194997dfd$var$NativeWebSocket;
        if (!this.wsImpl) throw new Error('Unable to find native implementation, or alternative implementation for WebSocket!');
        this.wsProtocols = webSocketProtocols || $g1EHn.GRAPHQL_WS;
        this.connectionCallback = connectionCallback;
        this.url = url;
        this.operations = {};
        this.nextOperationId = 0;
        this.minWsTimeout = minTimeout;
        this.wsTimeout = timeout;
        this.unsentMessagesQueue = [];
        this.reconnect = reconnect;
        this.reconnecting = false;
        this.reconnectionAttempts = reconnectionAttempts;
        this.lazy = !!lazy;
        this.inactivityTimeout = inactivityTimeout;
        this.closedByUser = false;
        this.backoff = new $dkxwb({
            jitter: 0.5
        });
        this.eventEmitter = new $aAI5W.EventEmitter();
        this.middlewares = [];
        this.client = null;
        this.maxConnectTimeGenerator = this.createMaxConnectTimeGenerator();
        this.connectionParams = this.getConnectionParams(connectionParams);
        this.wsOptionArguments = wsOptionArguments;
        if (!this.lazy) this.connect();
    }
    Object.defineProperty(SubscriptionClient.prototype, "status", {
        get: function() {
            if (this.client === null) return this.wsImpl.CLOSED;
            return this.client.readyState;
        },
        enumerable: false,
        configurable: true
    });
    SubscriptionClient.prototype.close = function(isForced, closedByUser) {
        if (isForced === void 0) isForced = true;
        if (closedByUser === void 0) closedByUser = true;
        this.clearInactivityTimeout();
        if (this.client !== null) {
            this.closedByUser = closedByUser;
            if (isForced) {
                this.clearCheckConnectionInterval();
                this.clearMaxConnectTimeout();
                this.clearTryReconnectTimeout();
                this.unsubscribeAll();
                this.sendMessage(undefined, $h3eh8.default.GQL_CONNECTION_TERMINATE, null);
            }
            this.client.close();
            this.client.onopen = null;
            this.client.onclose = null;
            this.client.onerror = null;
            this.client.onmessage = null;
            this.client = null;
            this.eventEmitter.emit('disconnected');
            if (!isForced) this.tryReconnect();
        }
    };
    SubscriptionClient.prototype.request = function(request) {
        var _a;
        var getObserver = this.getObserver.bind(this);
        var executeOperation = this.executeOperation.bind(this);
        var unsubscribe = this.unsubscribe.bind(this);
        var opId;
        this.clearInactivityTimeout();
        return _a = {}, _a[$4jE47.default] = function() {
            return this;
        }, _a.subscribe = function(observerOrNext, onError, onComplete) {
            var observer = getObserver(observerOrNext, onError, onComplete);
            opId = executeOperation(request, function(error, result) {
                if (error === null && result === null) {
                    if (observer.complete) observer.complete();
                } else if (error) {
                    if (observer.error) observer.error(error[0]);
                } else if (observer.next) observer.next(result);
            });
            return {
                unsubscribe: function() {
                    if (opId) {
                        unsubscribe(opId);
                        opId = null;
                    }
                }
            };
        }, _a;
    };
    SubscriptionClient.prototype.on = function(eventName, callback, context) {
        var handler = this.eventEmitter.on(eventName, callback, context);
        return function() {
            handler.off(eventName, callback, context);
        };
    };
    SubscriptionClient.prototype.onConnected = function(callback, context) {
        return this.on('connected', callback, context);
    };
    SubscriptionClient.prototype.onConnecting = function(callback, context) {
        return this.on('connecting', callback, context);
    };
    SubscriptionClient.prototype.onDisconnected = function(callback, context) {
        return this.on('disconnected', callback, context);
    };
    SubscriptionClient.prototype.onReconnected = function(callback, context) {
        return this.on('reconnected', callback, context);
    };
    SubscriptionClient.prototype.onReconnecting = function(callback, context) {
        return this.on('reconnecting', callback, context);
    };
    SubscriptionClient.prototype.onError = function(callback, context) {
        return this.on('error', callback, context);
    };
    SubscriptionClient.prototype.unsubscribeAll = function() {
        var _this = this;
        Object.keys(this.operations).forEach(function(subId) {
            _this.unsubscribe(subId);
        });
    };
    SubscriptionClient.prototype.applyMiddlewares = function(options) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var queue = function(funcs, scope) {
                var next = function(error) {
                    if (error) reject(error);
                    else if (funcs.length > 0) {
                        var f = funcs.shift();
                        if (f) f.applyMiddleware.apply(scope, [
                            options,
                            next
                        ]);
                    } else resolve(options);
                };
                next();
            };
            queue($7131a7d194997dfd$var$__spreadArrays(_this.middlewares), _this);
        });
    };
    SubscriptionClient.prototype.use = function(middlewares) {
        var _this = this;
        middlewares.map(function(middleware) {
            if (typeof middleware.applyMiddleware === 'function') _this.middlewares.push(middleware);
            else throw new Error('Middleware must implement the applyMiddleware function.');
        });
        return this;
    };
    SubscriptionClient.prototype.getConnectionParams = function(connectionParams) {
        return function() {
            return new Promise(function(resolve, reject) {
                if (typeof connectionParams === 'function') try {
                    return resolve(connectionParams.call(null));
                } catch (error) {
                    return reject(error);
                }
                resolve(connectionParams);
            });
        };
    };
    SubscriptionClient.prototype.executeOperation = function(options, handler) {
        var _this = this;
        if (this.client === null) this.connect();
        var opId = this.generateOperationId();
        this.operations[opId] = {
            options: options,
            handler: handler
        };
        this.applyMiddlewares(options).then(function(processedOptions) {
            _this.checkOperationOptions(processedOptions, handler);
            if (_this.operations[opId]) {
                _this.operations[opId] = {
                    options: processedOptions,
                    handler: handler
                };
                _this.sendMessage(opId, $h3eh8.default.GQL_START, processedOptions);
            }
        }).catch(function(error) {
            _this.unsubscribe(opId);
            handler(_this.formatErrors(error));
        });
        return opId;
    };
    SubscriptionClient.prototype.getObserver = function(observerOrNext, error, complete) {
        if (typeof observerOrNext === 'function') return {
            next: function(v) {
                return observerOrNext(v);
            },
            error: function(e) {
                return error && error(e);
            },
            complete: function() {
                return complete && complete();
            }
        };
        return observerOrNext;
    };
    SubscriptionClient.prototype.createMaxConnectTimeGenerator = function() {
        var minValue = this.minWsTimeout;
        var maxValue = this.wsTimeout;
        return new $dkxwb({
            min: minValue,
            max: maxValue,
            factor: 1.2
        });
    };
    SubscriptionClient.prototype.clearCheckConnectionInterval = function() {
        if (this.checkConnectionIntervalId) {
            clearInterval(this.checkConnectionIntervalId);
            this.checkConnectionIntervalId = null;
        }
    };
    SubscriptionClient.prototype.clearMaxConnectTimeout = function() {
        if (this.maxConnectTimeoutId) {
            clearTimeout(this.maxConnectTimeoutId);
            this.maxConnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearTryReconnectTimeout = function() {
        if (this.tryReconnectTimeoutId) {
            clearTimeout(this.tryReconnectTimeoutId);
            this.tryReconnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearInactivityTimeout = function() {
        if (this.inactivityTimeoutId) {
            clearTimeout(this.inactivityTimeoutId);
            this.inactivityTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.setInactivityTimeout = function() {
        var _this = this;
        if (this.inactivityTimeout > 0 && Object.keys(this.operations).length === 0) this.inactivityTimeoutId = setTimeout(function() {
            if (Object.keys(_this.operations).length === 0) _this.close();
        }, this.inactivityTimeout);
    };
    SubscriptionClient.prototype.checkOperationOptions = function(options, handler) {
        var query = options.query, variables = options.variables, operationName = options.operationName;
        if (!query) throw new Error('Must provide a query.');
        if (!handler) throw new Error('Must provide an handler.');
        if (!$cfohG.default(query) && !$kXWrW.getOperationAST(query, operationName) || operationName && !$cfohG.default(operationName) || variables && !$iR5Az.default(variables)) throw new Error("Incorrect option types. query must be a string or a document,`operationName` must be a string, and `variables` must be an object.");
    };
    SubscriptionClient.prototype.buildMessage = function(id, type, payload) {
        var payloadToReturn = payload && payload.query ? $7131a7d194997dfd$var$__assign($7131a7d194997dfd$var$__assign({}, payload), {
            query: typeof payload.query === 'string' ? payload.query : $euNGW.print(payload.query)
        }) : payload;
        return {
            id: id,
            type: type,
            payload: payloadToReturn
        };
    };
    SubscriptionClient.prototype.formatErrors = function(errors) {
        if (Array.isArray(errors)) return errors;
        if (errors && errors.errors) return this.formatErrors(errors.errors);
        if (errors && errors.message) return [
            errors
        ];
        return [
            {
                name: 'FormatedError',
                message: 'Unknown error',
                originalError: errors
            }
        ];
    };
    SubscriptionClient.prototype.sendMessage = function(id, type, payload) {
        this.sendMessageRaw(this.buildMessage(id, type, payload));
    };
    SubscriptionClient.prototype.sendMessageRaw = function(message) {
        switch(this.status){
            case this.wsImpl.OPEN:
                var serializedMessage = JSON.stringify(message);
                try {
                    JSON.parse(serializedMessage);
                } catch (e) {
                    this.eventEmitter.emit('error', new Error("Message must be JSON-serializable. Got: " + message));
                }
                this.client.send(serializedMessage);
                break;
            case this.wsImpl.CONNECTING:
                this.unsentMessagesQueue.push(message);
                break;
            default:
                if (!this.reconnecting) this.eventEmitter.emit('error', new Error("A message was not sent because socket is not connected, is closing or is already closed. Message was: " + JSON.stringify(message)));
        }
    };
    SubscriptionClient.prototype.generateOperationId = function() {
        return String(++this.nextOperationId);
    };
    SubscriptionClient.prototype.tryReconnect = function() {
        var _this = this;
        if (!this.reconnect || this.backoff.attempts >= this.reconnectionAttempts) return;
        if (!this.reconnecting) {
            Object.keys(this.operations).forEach(function(key) {
                _this.unsentMessagesQueue.push(_this.buildMessage(key, $h3eh8.default.GQL_START, _this.operations[key].options));
            });
            this.reconnecting = true;
        }
        this.clearTryReconnectTimeout();
        var delay = this.backoff.duration();
        this.tryReconnectTimeoutId = setTimeout(function() {
            _this.connect();
        }, delay);
    };
    SubscriptionClient.prototype.flushUnsentMessagesQueue = function() {
        var _this = this;
        this.unsentMessagesQueue.forEach(function(message) {
            _this.sendMessageRaw(message);
        });
        this.unsentMessagesQueue = [];
    };
    SubscriptionClient.prototype.checkConnection = function() {
        if (this.wasKeepAliveReceived) {
            this.wasKeepAliveReceived = false;
            return;
        }
        if (!this.reconnecting) this.close(false, true);
    };
    SubscriptionClient.prototype.checkMaxConnectTimeout = function() {
        var _this = this;
        this.clearMaxConnectTimeout();
        this.maxConnectTimeoutId = setTimeout(function() {
            if (_this.status !== _this.wsImpl.OPEN) {
                _this.reconnecting = true;
                _this.close(false, true);
            }
        }, this.maxConnectTimeGenerator.duration());
    };
    SubscriptionClient.prototype.connect = function() {
        var _a;
        var _this = this;
        this.client = new ((_a = this.wsImpl).bind.apply(_a, $7131a7d194997dfd$var$__spreadArrays([
            void 0,
            this.url,
            this.wsProtocols
        ], this.wsOptionArguments)))();
        this.checkMaxConnectTimeout();
        this.client.onopen = function() {
            return $7131a7d194997dfd$var$__awaiter(_this, void 0, void 0, function() {
                var connectionParams, error_1;
                return $7131a7d194997dfd$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(this.status === this.wsImpl.OPEN)) return [
                                3,
                                4
                            ];
                            this.clearMaxConnectTimeout();
                            this.closedByUser = false;
                            this.eventEmitter.emit(this.reconnecting ? 'reconnecting' : 'connecting');
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                this.connectionParams()
                            ];
                        case 2:
                            connectionParams = _a.sent();
                            this.sendMessage(undefined, $h3eh8.default.GQL_CONNECTION_INIT, connectionParams);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error_1 = _a.sent();
                            this.sendMessage(undefined, $h3eh8.default.GQL_CONNECTION_ERROR, error_1);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
        this.client.onclose = function() {
            if (!_this.closedByUser) _this.close(false, false);
        };
        this.client.onerror = function(err) {
            _this.eventEmitter.emit('error', err);
        };
        this.client.onmessage = function(_a) {
            var data = _a.data;
            _this.processReceivedData(data);
        };
    };
    SubscriptionClient.prototype.processReceivedData = function(receivedData) {
        var parsedMessage;
        var opId;
        try {
            parsedMessage = JSON.parse(receivedData);
            opId = parsedMessage.id;
        } catch (e) {
            throw new Error("Message must be JSON-parseable. Got: " + receivedData);
        }
        if ([
            $h3eh8.default.GQL_DATA,
            $h3eh8.default.GQL_COMPLETE,
            $h3eh8.default.GQL_ERROR
        ].indexOf(parsedMessage.type) !== -1 && !this.operations[opId]) {
            this.unsubscribe(opId);
            return;
        }
        switch(parsedMessage.type){
            case $h3eh8.default.GQL_CONNECTION_ERROR:
                if (this.connectionCallback) this.connectionCallback(parsedMessage.payload);
                break;
            case $h3eh8.default.GQL_CONNECTION_ACK:
                this.eventEmitter.emit(this.reconnecting ? 'reconnected' : 'connected', parsedMessage.payload);
                this.reconnecting = false;
                this.backoff.reset();
                this.maxConnectTimeGenerator.reset();
                if (this.connectionCallback) this.connectionCallback();
                break;
            case $h3eh8.default.GQL_COMPLETE:
                var handler = this.operations[opId].handler;
                delete this.operations[opId];
                handler.call(this, null, null);
                break;
            case $h3eh8.default.GQL_ERROR:
                this.operations[opId].handler(this.formatErrors(parsedMessage.payload), null);
                delete this.operations[opId];
                break;
            case $h3eh8.default.GQL_DATA:
                var parsedPayload = !parsedMessage.payload.errors ? parsedMessage.payload : $7131a7d194997dfd$var$__assign($7131a7d194997dfd$var$__assign({}, parsedMessage.payload), {
                    errors: this.formatErrors(parsedMessage.payload.errors)
                });
                this.operations[opId].handler(null, parsedPayload);
                break;
            case $h3eh8.default.GQL_CONNECTION_KEEP_ALIVE:
                var firstKA = typeof this.wasKeepAliveReceived === 'undefined';
                this.wasKeepAliveReceived = true;
                if (firstKA) this.checkConnection();
                if (this.checkConnectionIntervalId) {
                    clearInterval(this.checkConnectionIntervalId);
                    this.checkConnection();
                }
                this.checkConnectionIntervalId = setInterval(this.checkConnection.bind(this), this.wsTimeout);
                break;
            default:
                throw new Error('Invalid message type!');
        }
    };
    SubscriptionClient.prototype.unsubscribe = function(opId) {
        if (this.operations[opId]) {
            delete this.operations[opId];
            this.setInactivityTimeout();
            this.sendMessage(opId, $h3eh8.default.GQL_STOP, undefined);
        }
    };
    return SubscriptionClient;
}();
module.exports.SubscriptionClient = $7131a7d194997dfd$var$SubscriptionClient;

});
parcelRegister("dkxwb", function(module, exports) {
/**
 * Expose `Backoff`.
 */ module.exports = $9b4724a0da55e4ed$var$Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $9b4724a0da55e4ed$var$Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $9b4724a0da55e4ed$var$Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $9b4724a0da55e4ed$var$Backoff.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $9b4724a0da55e4ed$var$Backoff.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $9b4724a0da55e4ed$var$Backoff.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $9b4724a0da55e4ed$var$Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});

parcelRegister("aAI5W", function(module, exports) {
'use strict';
var $7b5f787d5f57d350$var$has = Object.prototype.hasOwnProperty, $7b5f787d5f57d350$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $7b5f787d5f57d350$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $7b5f787d5f57d350$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $7b5f787d5f57d350$var$Events().__proto__) $7b5f787d5f57d350$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $7b5f787d5f57d350$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $7b5f787d5f57d350$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $7b5f787d5f57d350$var$EE(fn, context || emitter, once), evt = $7b5f787d5f57d350$var$prefix ? $7b5f787d5f57d350$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $7b5f787d5f57d350$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $7b5f787d5f57d350$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $7b5f787d5f57d350$var$EventEmitter() {
    this._events = new $7b5f787d5f57d350$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $7b5f787d5f57d350$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($7b5f787d5f57d350$var$has.call(events, name)) names.push($7b5f787d5f57d350$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $7b5f787d5f57d350$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $7b5f787d5f57d350$var$prefix ? $7b5f787d5f57d350$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $7b5f787d5f57d350$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $7b5f787d5f57d350$var$prefix ? $7b5f787d5f57d350$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $7b5f787d5f57d350$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $7b5f787d5f57d350$var$prefix ? $7b5f787d5f57d350$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7b5f787d5f57d350$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $7b5f787d5f57d350$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7b5f787d5f57d350$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $7b5f787d5f57d350$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7b5f787d5f57d350$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $7b5f787d5f57d350$var$prefix ? $7b5f787d5f57d350$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $7b5f787d5f57d350$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $7b5f787d5f57d350$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $7b5f787d5f57d350$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7b5f787d5f57d350$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $7b5f787d5f57d350$var$prefix ? $7b5f787d5f57d350$var$prefix + event : event;
        if (this._events[evt]) $7b5f787d5f57d350$var$clearEvent(this, evt);
    } else {
        this._events = new $7b5f787d5f57d350$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$7b5f787d5f57d350$var$EventEmitter.prototype.off = $7b5f787d5f57d350$var$EventEmitter.prototype.removeListener;
$7b5f787d5f57d350$var$EventEmitter.prototype.addListener = $7b5f787d5f57d350$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$7b5f787d5f57d350$var$EventEmitter.prefixed = $7b5f787d5f57d350$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$7b5f787d5f57d350$var$EventEmitter.EventEmitter = $7b5f787d5f57d350$var$EventEmitter;
module.exports = $7b5f787d5f57d350$var$EventEmitter;

});

parcelRegister("cfohG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $8ea9b91d48d28a5f$var$isString(value) {
    return typeof value === 'string';
}
module.exports.default = $8ea9b91d48d28a5f$var$isString;

});

parcelRegister("iR5Az", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $dba1830ea75f676a$var$isObject(value) {
    return value !== null && typeof value === 'object';
}
module.exports.default = $dba1830ea75f676a$var$isObject;

});

parcelRegister("euNGW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.print = $a8da69c4cc14c2b4$var$print;

var $k6zLG = parcelRequire("k6zLG");

var $9DV5w = parcelRequire("9DV5w");
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $a8da69c4cc14c2b4$var$print(ast) {
    return (0, $k6zLG.visit)(ast, {
        leave: $a8da69c4cc14c2b4$var$printDocASTReducer
    });
} // TODO: provide better type coverage in future
var $a8da69c4cc14c2b4$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $a8da69c4cc14c2b4$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $a8da69c4cc14c2b4$var$wrap('(', $a8da69c4cc14c2b4$var$join(node.variableDefinitions, ', '), ')');
        var directives = $a8da69c4cc14c2b4$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $a8da69c4cc14c2b4$var$join([
            op,
            $a8da69c4cc14c2b4$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $a8da69c4cc14c2b4$var$wrap(' = ', defaultValue) + $a8da69c4cc14c2b4$var$wrap(' ', $a8da69c4cc14c2b4$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $a8da69c4cc14c2b4$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        return $a8da69c4cc14c2b4$var$join([
            $a8da69c4cc14c2b4$var$wrap('', alias, ': ') + name + $a8da69c4cc14c2b4$var$wrap('(', $a8da69c4cc14c2b4$var$join(args, ', '), ')'),
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $a8da69c4cc14c2b4$var$wrap(' ', $a8da69c4cc14c2b4$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $a8da69c4cc14c2b4$var$join([
            '...',
            $a8da69c4cc14c2b4$var$wrap('on ', typeCondition),
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($a8da69c4cc14c2b4$var$wrap('(', $a8da69c4cc14c2b4$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($a8da69c4cc14c2b4$var$wrap('', $a8da69c4cc14c2b4$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $9DV5w.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $a8da69c4cc14c2b4$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $a8da69c4cc14c2b4$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $a8da69c4cc14c2b4$var$wrap('(', $a8da69c4cc14c2b4$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: function SchemaDefinition(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $a8da69c4cc14c2b4$var$join([
            'schema',
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            $a8da69c4cc14c2b4$var$block(operationTypes)
        ], ' ');
    },
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $a8da69c4cc14c2b4$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $a8da69c4cc14c2b4$var$join([
            'scalar',
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $a8da69c4cc14c2b4$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $a8da69c4cc14c2b4$var$join([
            'type',
            name,
            $a8da69c4cc14c2b4$var$wrap('implements ', $a8da69c4cc14c2b4$var$join(interfaces, ' & ')),
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            $a8da69c4cc14c2b4$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $a8da69c4cc14c2b4$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($a8da69c4cc14c2b4$var$hasMultilineItems(args) ? $a8da69c4cc14c2b4$var$wrap('(\n', $a8da69c4cc14c2b4$var$indent($a8da69c4cc14c2b4$var$join(args, '\n')), '\n)') : $a8da69c4cc14c2b4$var$wrap('(', $a8da69c4cc14c2b4$var$join(args, ', '), ')')) + ': ' + type + $a8da69c4cc14c2b4$var$wrap(' ', $a8da69c4cc14c2b4$var$join(directives, ' '));
    }),
    InputValueDefinition: $a8da69c4cc14c2b4$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $a8da69c4cc14c2b4$var$join([
            name + ': ' + type,
            $a8da69c4cc14c2b4$var$wrap('= ', defaultValue),
            $a8da69c4cc14c2b4$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $a8da69c4cc14c2b4$var$addDescription(function(_ref26) {
        var name = _ref26.name, directives = _ref26.directives, fields = _ref26.fields;
        return $a8da69c4cc14c2b4$var$join([
            'interface',
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            $a8da69c4cc14c2b4$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $a8da69c4cc14c2b4$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $a8da69c4cc14c2b4$var$join([
            'union',
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $a8da69c4cc14c2b4$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $a8da69c4cc14c2b4$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $a8da69c4cc14c2b4$var$join([
            'enum',
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            $a8da69c4cc14c2b4$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $a8da69c4cc14c2b4$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $a8da69c4cc14c2b4$var$join([
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $a8da69c4cc14c2b4$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $a8da69c4cc14c2b4$var$join([
            'input',
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            $a8da69c4cc14c2b4$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $a8da69c4cc14c2b4$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($a8da69c4cc14c2b4$var$hasMultilineItems(args) ? $a8da69c4cc14c2b4$var$wrap('(\n', $a8da69c4cc14c2b4$var$indent($a8da69c4cc14c2b4$var$join(args, '\n')), '\n)') : $a8da69c4cc14c2b4$var$wrap('(', $a8da69c4cc14c2b4$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $a8da69c4cc14c2b4$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $a8da69c4cc14c2b4$var$join([
            'extend schema',
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            $a8da69c4cc14c2b4$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $a8da69c4cc14c2b4$var$join([
            'extend scalar',
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $a8da69c4cc14c2b4$var$join([
            'extend type',
            name,
            $a8da69c4cc14c2b4$var$wrap('implements ', $a8da69c4cc14c2b4$var$join(interfaces, ' & ')),
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            $a8da69c4cc14c2b4$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, directives = _ref35.directives, fields = _ref35.fields;
        return $a8da69c4cc14c2b4$var$join([
            'extend interface',
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            $a8da69c4cc14c2b4$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $a8da69c4cc14c2b4$var$join([
            'extend union',
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $a8da69c4cc14c2b4$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $a8da69c4cc14c2b4$var$join([
            'extend enum',
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            $a8da69c4cc14c2b4$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $a8da69c4cc14c2b4$var$join([
            'extend input',
            name,
            $a8da69c4cc14c2b4$var$join(directives, ' '),
            $a8da69c4cc14c2b4$var$block(fields)
        ], ' ');
    }
};
function $a8da69c4cc14c2b4$var$addDescription(cb) {
    return function(node) {
        return $a8da69c4cc14c2b4$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $a8da69c4cc14c2b4$var$join(maybeArray, separator) {
    return maybeArray ? maybeArray.filter(function(x) {
        return x;
    }).join(separator || '') : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $a8da69c4cc14c2b4$var$block(array) {
    return array && array.length !== 0 ? '{\n' + $a8da69c4cc14c2b4$var$indent($a8da69c4cc14c2b4$var$join(array, '\n')) + '\n}' : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */ function $a8da69c4cc14c2b4$var$wrap(start, maybeString, end) {
    return maybeString ? start + maybeString + (end || '') : '';
}
function $a8da69c4cc14c2b4$var$indent(maybeString) {
    return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}
function $a8da69c4cc14c2b4$var$isMultiline(string) {
    return string.indexOf('\n') !== -1;
}
function $a8da69c4cc14c2b4$var$hasMultilineItems(maybeArray) {
    return maybeArray && maybeArray.some($a8da69c4cc14c2b4$var$isMultiline);
}

});
parcelRegister("k6zLG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.visit = $ea301cf90a35b3b3$var$visit;
module.exports.visitInParallel = $ea301cf90a35b3b3$var$visitInParallel;
module.exports.visitWithTypeInfo = $ea301cf90a35b3b3$var$visitWithTypeInfo;
module.exports.getVisitFn = $ea301cf90a35b3b3$var$getVisitFn;
module.exports.BREAK = module.exports.QueryDocumentKeys = void 0;

var $ea301cf90a35b3b3$var$_inspect = $ea301cf90a35b3b3$var$_interopRequireDefault((parcelRequire("indTx")));
function $ea301cf90a35b3b3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ea301cf90a35b3b3$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
module.exports.QueryDocumentKeys = $ea301cf90a35b3b3$var$QueryDocumentKeys;
var $ea301cf90a35b3b3$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ module.exports.BREAK = $ea301cf90a35b3b3$var$BREAK;
function $ea301cf90a35b3b3$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ea301cf90a35b3b3$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!$ea301cf90a35b3b3$var$isNode(node)) throw new Error('Invalid AST Node: ' + (0, $ea301cf90a35b3b3$var$_inspect.default)(node));
            var visitFn = $ea301cf90a35b3b3$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $ea301cf90a35b3b3$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ($ea301cf90a35b3b3$var$isNode(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : visitorKeys[node.kind] || [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $ea301cf90a35b3b3$var$isNode(maybeNode) {
    return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $ea301cf90a35b3b3$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (!skipping[i]) {
                var fn = $ea301cf90a35b3b3$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $ea301cf90a35b3b3$var$BREAK) skipping[i] = $ea301cf90a35b3b3$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (!skipping[i]) {
                    var fn = $ea301cf90a35b3b3$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $ea301cf90a35b3b3$var$BREAK) skipping[i] = $ea301cf90a35b3b3$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */ function $ea301cf90a35b3b3$var$visitWithTypeInfo(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = $ea301cf90a35b3b3$var$getVisitFn(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ($ea301cf90a35b3b3$var$isNode(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = $ea301cf90a35b3b3$var$getVisitFn(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $ea301cf90a35b3b3$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("indTx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6052731273f10ce$var$inspect;

var $d6052731273f10ce$var$_nodejsCustomInspectSymbol = $d6052731273f10ce$var$_interopRequireDefault((parcelRequire("5ic4Y")));
function $d6052731273f10ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d6052731273f10ce$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d6052731273f10ce$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d6052731273f10ce$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d6052731273f10ce$var$_typeof(obj);
}
var $d6052731273f10ce$var$MAX_ARRAY_LENGTH = 10;
var $d6052731273f10ce$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $d6052731273f10ce$var$inspect(value) {
    return $d6052731273f10ce$var$formatValue(value, []);
}
function $d6052731273f10ce$var$formatValue(value, seenValues) {
    switch($d6052731273f10ce$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $d6052731273f10ce$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $d6052731273f10ce$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $d6052731273f10ce$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        // $FlowFixMe(>=0.90.0)
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $d6052731273f10ce$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $d6052731273f10ce$var$formatArray(value, seenValues);
    return $d6052731273f10ce$var$formatObject(value, seenValues);
}
function $d6052731273f10ce$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $d6052731273f10ce$var$MAX_RECURSIVE_DEPTH) return '[' + $d6052731273f10ce$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $d6052731273f10ce$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $d6052731273f10ce$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $d6052731273f10ce$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($d6052731273f10ce$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($d6052731273f10ce$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $d6052731273f10ce$var$getCustomFn(object) {
    var customInspectFn = object[String($d6052731273f10ce$var$_nodejsCustomInspectSymbol.default)];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $d6052731273f10ce$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("5ic4Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3da800e25a0cc45b$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $3da800e25a0cc45b$var$_default = $3da800e25a0cc45b$var$nodejsCustomInspectSymbol;
module.exports.default = $3da800e25a0cc45b$var$_default;

});



parcelRegister("9DV5w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dedentBlockStringValue = $70540a1544f3e077$var$dedentBlockStringValue;
module.exports.getBlockStringIndentation = $70540a1544f3e077$var$getBlockStringIndentation;
module.exports.printBlockString = $70540a1544f3e077$var$printBlockString;
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */ function $70540a1544f3e077$var$dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $70540a1544f3e077$var$getBlockStringIndentation(lines);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    while(lines.length > 0 && $70540a1544f3e077$var$isBlank(lines[0]))lines.shift();
    while(lines.length > 0 && $70540a1544f3e077$var$isBlank(lines[lines.length - 1]))lines.pop();
     // Return a string of the lines joined with U+000A.
    return lines.join('\n');
} // @internal
function $70540a1544f3e077$var$getBlockStringIndentation(lines) {
    var commonIndent = null;
    for(var i = 1; i < lines.length; i++){
        var line = lines[i];
        var indent = $70540a1544f3e077$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        if (commonIndent === null || indent < commonIndent) {
            commonIndent = indent;
            if (commonIndent === 0) break;
        }
    }
    return commonIndent === null ? 0 : commonIndent;
}
function $70540a1544f3e077$var$leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (str[i] === ' ' || str[i] === '\t'))i++;
    return i;
}
function $70540a1544f3e077$var$isBlank(str) {
    return $70540a1544f3e077$var$leadingWhitespace(str) === str.length;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */ function $70540a1544f3e077$var$printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("kXWrW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getOperationAST = $f436a837e5727a9b$var$getOperationAST;

var $1ssDT = parcelRequire("1ssDT");
/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */ function $f436a837e5727a9b$var$getOperationAST(documentAST, operationName) {
    var operation = null;
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var definition = _documentAST$definiti2[_i2];
        if (definition.kind === $1ssDT.Kind.OPERATION_DEFINITION) {
            if (!operationName) {
                // If no operation name was provided, only return an Operation if there
                // is one defined in the document. Upon encountering the second, return
                // null.
                if (operation) return null;
                operation = definition;
            } else if (definition.name && definition.name.value === operationName) return definition;
        }
    }
    return operation;
}

});
parcelRegister("1ssDT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Kind = void 0;
/**
 * The set of allowed kind values for AST nodes.
 */ var $10fe9fc4b9dca645$var$Kind = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */ module.exports.Kind = $10fe9fc4b9dca645$var$Kind;

});


parcelRegister("4jE47", function(module, exports) {

$parcel$export(module.exports, "default", () => $324803e938dce12c$export$2e2bcd8739ae039);
/* global window */ 
var $9ZapD = parcelRequire("9ZapD");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $9ZapD.default)(root);
var $324803e938dce12c$export$2e2bcd8739ae039 = result;

});
parcelRegister("9ZapD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7451e3447391d6b6$export$2e2bcd8739ae039);
function $7451e3447391d6b6$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("g1EHn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRAPHQL_SUBSCRIPTIONS = module.exports.GRAPHQL_WS = void 0;
var $baac4f3ea79a2697$var$GRAPHQL_WS = 'graphql-ws';
module.exports.GRAPHQL_WS = $baac4f3ea79a2697$var$GRAPHQL_WS;
var $baac4f3ea79a2697$var$GRAPHQL_SUBSCRIPTIONS = 'graphql-subscriptions';
module.exports.GRAPHQL_SUBSCRIPTIONS = $baac4f3ea79a2697$var$GRAPHQL_SUBSCRIPTIONS;

});

parcelRegister("d4fXk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WS_TIMEOUT = module.exports.MIN_WS_TIMEOUT = void 0;
var $9838069a6f461875$var$MIN_WS_TIMEOUT = 1000;
module.exports.MIN_WS_TIMEOUT = $9838069a6f461875$var$MIN_WS_TIMEOUT;
var $9838069a6f461875$var$WS_TIMEOUT = 30000;
module.exports.WS_TIMEOUT = $9838069a6f461875$var$WS_TIMEOUT;

});

parcelRegister("h3eh8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c69dca45b9358834$var$MessageTypes = function() {
    function MessageTypes() {
        throw new Error('Static Class');
    }
    MessageTypes.GQL_CONNECTION_INIT = 'connection_init';
    MessageTypes.GQL_CONNECTION_ACK = 'connection_ack';
    MessageTypes.GQL_CONNECTION_ERROR = 'connection_error';
    MessageTypes.GQL_CONNECTION_KEEP_ALIVE = 'ka';
    MessageTypes.GQL_CONNECTION_TERMINATE = 'connection_terminate';
    MessageTypes.GQL_START = 'start';
    MessageTypes.GQL_DATA = 'data';
    MessageTypes.GQL_ERROR = 'error';
    MessageTypes.GQL_COMPLETE = 'complete';
    MessageTypes.GQL_STOP = 'stop';
    MessageTypes.SUBSCRIPTION_START = 'subscription_start';
    MessageTypes.SUBSCRIPTION_DATA = 'subscription_data';
    MessageTypes.SUBSCRIPTION_SUCCESS = 'subscription_success';
    MessageTypes.SUBSCRIPTION_FAIL = 'subscription_fail';
    MessageTypes.SUBSCRIPTION_END = 'subscription_end';
    MessageTypes.INIT = 'init';
    MessageTypes.INIT_SUCCESS = 'init_success';
    MessageTypes.INIT_FAIL = 'init_fail';
    MessageTypes.KEEP_ALIVE = 'keepalive';
    return MessageTypes;
}();
module.exports.default = $c69dca45b9358834$var$MessageTypes;

});



parcelRegister("cpB4j", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $909492e4d0b37f39$export$2f04de43fe27971a);

var $5Rzv1 = parcelRequire("5Rzv1");

var $irVrB = parcelRequire("irVrB");
parcelRequire("fu5HQ");
var $1ieNy = parcelRequire("1ieNy");
function $909492e4d0b37f39$export$2f04de43fe27971a(setter) {
    return new (0, $irVrB.ApolloLink)(function(operation, forward) {
        var request = (0, $5Rzv1.__rest)(operation, []);
        return new (0, $1ieNy.Observable)(function(observer) {
            var handle;
            var closed = false;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                // if the observer is already closed, no need to subscribe.
                if (closed) return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                closed = true;
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("3L9PA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deepCopy = module.exports.convertToPossibleTypes = void 0;
module.exports.importQuery = $2bcd631d63e3a70e$var$importQuery;

var $4XQlz = parcelRequire("4XQlz");

var $gu0Mj = parcelRequire("gu0Mj");
function $2bcd631d63e3a70e$var$importQuery(search) {
    const DOCUMENTS = $4XQlz.Container.get($gu0Mj.GraphqlDocuments);
    if (!DOCUMENTS[search]) throw new Error(`Missing query: ${search}`);
    return DOCUMENTS[search];
}
const $2bcd631d63e3a70e$var$convertToPossibleTypes = (introspectionQuery)=>introspectionQuery.__schema.types.reduce((acc, curr)=>Object.assign(Object.assign({}, acc), {
            [curr.name]: curr.possibleTypes.map((type)=>type.name)
        }), {});
module.exports.convertToPossibleTypes = $2bcd631d63e3a70e$var$convertToPossibleTypes;
/* Utility function helping us to get a new object using the apollo-store */ const $2bcd631d63e3a70e$var$deepCopy = (state)=>JSON.parse(JSON.stringify(state));
module.exports.deepCopy = $2bcd631d63e3a70e$var$deepCopy;

});


parcelRegister("rc2P5", function(module, exports) {
$parcel$export(module.exports, "BlogService", () => (parcelRequire("fG7Ap")).BlogService);
$parcel$export(module.exports, "AiService", () => (parcelRequire("7fUEc")).AiService);
$parcel$export(module.exports, "CategoryService", () => (parcelRequire("8H3st")).CategoryService);
$parcel$export(module.exports, "AnalyticsService", () => (parcelRequire("hGKun")).AnalyticsService);
$parcel$export(module.exports, "SeoService", () => (parcelRequire("eIehW")).SeoService);
parcelRequire("5X8fD");
parcelRequire("28UZO");
parcelRequire("7BKxG");
parcelRequire("2lWWM");
parcelRequire("eQclL");

});
parcelRegister("5X8fD", function(module, exports) {
$parcel$export(module.exports, "BlogService", () => (parcelRequire("fG7Ap")).BlogService);
parcelRequire("fG7Ap");

});
parcelRegister("fG7Ap", function(module, exports) {

$parcel$export(module.exports, "BlogService", () => $bc0adbcf1aaf4f44$export$fdb587005591e03a);

var $g0n63 = parcelRequire("g0n63");

var $l2PfP = parcelRequire("l2PfP");

var $4XQlz = parcelRequire("4XQlz");

var $3XkaH = parcelRequire("3XkaH");
class $bc0adbcf1aaf4f44$export$fdb587005591e03a extends (0, $l2PfP.BaseGraphqlLayer) {
    listPosts(searchKey, draft) {
        return this.query({
            query: 'list-posts.query.graphql',
            variables: {
                searchKey: searchKey,
                draft: draft
            }
        }).pipe((0, $3XkaH.map)((res)=>res.data.listPosts));
    }
    getBlog(id) {
        return this.query({
            query: 'find-post.query.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $3XkaH.map)((res)=>res.data.findPost));
    }
    findPostBySearchKey(searchKey) {
        return this.query({
            query: 'find-post-by-search-key.query.graphql',
            variables: {
                searchKey: searchKey
            }
        }).pipe((0, $3XkaH.map)((res)=>res.data.findPostBySearchKey));
    }
    updatePost(id, payload) {
        return this.mutate({
            mutation: 'update-post.mutation.graphql',
            variables: {
                id: id,
                payload: payload
            }
        }).pipe((0, $3XkaH.map)((res)=>res.data.updatePost));
    }
    createPost(payload) {
        return this.mutate({
            mutation: 'create-post.mutation.graphql',
            variables: {
                payload: payload
            }
        }).pipe((0, $3XkaH.map)((res)=>res.data.createPost));
    }
    deletePost(id) {
        return this.mutate({
            mutation: 'delete-post.mutation.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $3XkaH.map)((res)=>res.data.deletePost));
    }
}
$bc0adbcf1aaf4f44$export$fdb587005591e03a = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)()
], $bc0adbcf1aaf4f44$export$fdb587005591e03a);

});
parcelRegister("l2PfP", function(module, exports) {

$parcel$export(module.exports, "BaseGraphqlLayer", () => $41437ad4dcf82dd3$export$835fdb8499efe118);

var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");

var $66ItK = parcelRequire("66ItK");

var $lBKT3 = parcelRequire("lBKT3");
class $41437ad4dcf82dd3$export$835fdb8499efe118 {
    query(options) {
        options.query = (0, $66ItK.importQuery)(options.query);
        return (0, $lBKT3.from)(this.graphql.query.bind(this.graphql)(options));
    }
    mutate(options) {
        options.mutation = (0, $66ItK.importQuery)(options.mutation);
        return (0, $lBKT3.from)(this.graphql.mutate.bind(this.graphql)(options));
    }
    subscribe(options) {
        options.query = (0, $66ItK.importQuery)(options.query);
        return (0, $lBKT3.from)(this.graphql.subscribe.bind(this.graphql)(options));
    }
}
(0, $g0n63.__decorate)([
    (0, $4XQlz.Injector)((0, $66ItK.ApolloClient))
], $41437ad4dcf82dd3$export$835fdb8499efe118.prototype, "graphql", void 0);

});



parcelRegister("28UZO", function(module, exports) {
$parcel$export(module.exports, "AiService", () => (parcelRequire("7fUEc")).AiService);
parcelRequire("7fUEc");

});
parcelRegister("7fUEc", function(module, exports) {

$parcel$export(module.exports, "AiService", () => $8893b90a98bde6b7$export$ad07b006b681e00d);

var $g0n63 = parcelRequire("g0n63");

var $l2PfP = parcelRequire("l2PfP");

var $4XQlz = parcelRequire("4XQlz");

var $3XkaH = parcelRequire("3XkaH");
class $8893b90a98bde6b7$export$ad07b006b681e00d extends (0, $l2PfP.BaseGraphqlLayer) {
    createCompletion(payload) {
        return this.mutate({
            mutation: 'create-completion-gemini.mutation.graphql',
            variables: {
                payload: payload
            }
        }).pipe((0, $3XkaH.map)((res)=>res.data.createCompletionGemini));
    }
}
$8893b90a98bde6b7$export$ad07b006b681e00d = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)()
], $8893b90a98bde6b7$export$ad07b006b681e00d);

});


parcelRegister("7BKxG", function(module, exports) {
$parcel$export(module.exports, "CategoryService", () => (parcelRequire("8H3st")).CategoryService);
parcelRequire("8H3st");

});
parcelRegister("8H3st", function(module, exports) {

$parcel$export(module.exports, "CategoryService", () => $5806616042154fbf$export$f5504725dc934335);

var $g0n63 = parcelRequire("g0n63");

var $l2PfP = parcelRequire("l2PfP");

var $4XQlz = parcelRequire("4XQlz");

var $66ItK = parcelRequire("66ItK");

var $3XkaH = parcelRequire("3XkaH");
class $5806616042154fbf$export$f5504725dc934335 extends (0, $l2PfP.BaseGraphqlLayer) {
    createCategory(payload) {
        return this.mutate({
            mutation: 'create-category.mutation.graphql',
            variables: {
                payload: payload
            },
            update: (proxy, res)=>{
                const query = (0, $66ItK.importQuery)('list-categories.query.graphql');
                const state = proxy.readQuery({
                    query: query
                });
                proxy.writeQuery({
                    data: {
                        ...state,
                        listCategories: [
                            ...state.listCategories,
                            ...res.data.createCategory
                        ]
                    },
                    query: query
                });
            }
        }).pipe((0, $3XkaH.map)((res)=>res.data.createCategory));
    }
    deleteCategory(id) {
        return this.mutate({
            mutation: 'delete-category.mutation.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $3XkaH.map)((res)=>res.data.deleteCategory));
    }
    listCategories() {
        return this.query({
            query: 'list-categories.query.graphql'
        }).pipe((0, $3XkaH.map)((res)=>res.data.listCategories));
    }
    findCategory() {
        return this.query({
            query: 'find-category.query.graphql'
        }).pipe((0, $3XkaH.map)((res)=>res.data.listCategories));
    }
}
$5806616042154fbf$export$f5504725dc934335 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)()
], $5806616042154fbf$export$f5504725dc934335);

});


parcelRegister("2lWWM", function(module, exports) {
$parcel$export(module.exports, "AnalyticsService", () => (parcelRequire("hGKun")).AnalyticsService);
parcelRequire("hGKun");

});
parcelRegister("hGKun", function(module, exports) {

$parcel$export(module.exports, "AnalyticsService", () => $3bdaec3ea96d634c$export$a63ba6b63d0ef2e0);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $g0n63 = parcelRequire("g0n63");

var $4QMof = parcelRequire("4QMof");

var $4XQlz = parcelRequire("4XQlz");
class $3bdaec3ea96d634c$export$a63ba6b63d0ef2e0 {
    constructor(){
        this.trackingId = (0, $4QMof.ENVIRONMENT).GOOGLE_MEASUREMENT_ID;
        if (!window.origin.includes('localhost')) this.initGA();
    }
    initGA() {
        if (typeof window === 'undefined') return;
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${this.trackingId}`;
        document.head.appendChild(script);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function() {
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', this.trackingId);
        console.log('GA4 Loaded dynamically successfully via Vanilla JS');
    }
    page(data) {
        if (typeof window !== 'undefined' && window.gtag) window.gtag('event', 'page_view', {
            page_title: data?.title || document.title,
            page_path: data?.path || window.location.pathname
        });
    }
    track(eventName, properties) {
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', eventName, properties);
            console.log(`GA4 Tracked Event: ${eventName}`, properties);
        }
    }
}
$3bdaec3ea96d634c$export$a63ba6b63d0ef2e0 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)({
        init: true
    })
], $3bdaec3ea96d634c$export$a63ba6b63d0ef2e0);

});
parcelRegister("4QMof", function(module, exports) {

$parcel$export(module.exports, "ENVIRONMENT", () => $358c4e67a1022603$export$be46596bc6608f3b);
const $358c4e67a1022603$export$df77466336fe5355 = ()=>false;
const $358c4e67a1022603$export$be46596bc6608f3b = {
    DOMAIN_NAME: 'graphql-server.com',
    GRAPH_URL: $358c4e67a1022603$export$df77466336fe5355() ? 'http://localhost:9000/graphql' : 'https://lambda.reactivum.com/68ac38641fbf0b1a1e53e6ee/graphql',
    GRAPH_WS_URL: $358c4e67a1022603$export$df77466336fe5355() ? 'ws://localhost:9000/subscriptions' : '',
    GOOGLE_API_KEY: "AIzaSyCFRK5iIFzdXIbB_uB4uVioIQetU-5ogOM",
    GOOGLE_AUTH_DOMAIN: "reactive-x.firebaseapp.com",
    GOOGLE_DATABASE_URL: undefined,
    GOOGLE_PROJECT_ID: "reactive-x",
    GOOGLE_STORAGE_BUCKET: "reactive-x.firebasestorage.app",
    GOOGLE_MESSAGE_SENDER_ID: "860643341321",
    GOOGLE_APP_ID: "1:860643341321:web:4ceed071b4aab97203b4d8",
    GOOGLE_MEASUREMENT_ID: "G-XQVFEKSWFP",
    SENTRY_DSN: undefined ?? 'https://2f2772c093124e3ea9ce2b1777c86e7f@sentry.io/1774993'
};

});



parcelRegister("eQclL", function(module, exports) {
$parcel$export(module.exports, "SeoService", () => (parcelRequire("eIehW")).SeoService);
parcelRequire("eIehW");

});
parcelRegister("eIehW", function(module, exports) {

$parcel$export(module.exports, "SeoService", () => $568accd441f49d8b$export$c836995727999a15);

var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");
class $568accd441f49d8b$export$c836995727999a15 {
    updateMeta(config) {
        if (config.title) document.title = config.title;
        if (config.description) this.setMetaTag('description', config.description);
        if (config.ogTitle) this.setMetaProperty('og:title', config.ogTitle);
        if (config.ogDescription) this.setMetaProperty('og:description', config.ogDescription);
        if (config.ogType) this.setMetaProperty('og:type', config.ogType);
        if (config.ogUrl) this.setMetaProperty('og:url', config.ogUrl);
        if (config.ogImage) this.setMetaProperty('og:image', config.ogImage);
        if (config.twitterCard) this.setMetaProperty('twitter:card', config.twitterCard);
        if (config.twitterTitle) this.setMetaProperty('twitter:title', config.twitterTitle);
        if (config.twitterDescription) this.setMetaProperty('twitter:description', config.twitterDescription);
        if (config.twitterImage) this.setMetaProperty('twitter:image', config.twitterImage);
    }
    updateJsonLd(schema, id) {
        this.clearJsonLd(id);
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = `jsonld-${id}`;
        script.textContent = JSON.stringify({
            '@context': 'https://schema.org',
            ...schema
        });
        document.head.appendChild(script);
        this.activeJsonLdIds.push(`jsonld-${id}`);
    }
    clearJsonLd(id) {
        const script = document.getElementById(`jsonld-${id}`);
        if (script) {
            script.remove();
            this.activeJsonLdIds = this.activeJsonLdIds.filter((sid)=>sid !== `jsonld-${id}`);
        }
    }
    clearAllJsonLd() {
        this.activeJsonLdIds.forEach((id)=>{
            const script = document.getElementById(id);
            if (script) script.remove();
        });
        this.activeJsonLdIds = [];
    }
    updateOrganizationSchema(config) {
        this.updateJsonLd({
            '@type': 'Organization',
            name: config.name,
            url: config.url,
            ...config.logo && {
                logo: config.logo
            },
            ...config.email && {
                email: config.email,
                contactPoint: {
                    '@type': 'ContactPoint',
                    email: config.email,
                    contactType: 'sales',
                    ...config.phone && {
                        telephone: config.phone
                    }
                }
            },
            ...config.phone && !config.email && {
                contactPoint: {
                    '@type': 'ContactPoint',
                    telephone: config.phone,
                    contactType: 'sales'
                }
            }
        }, 'organization');
    }
    updateFaqSchema(questions) {
        this.updateJsonLd({
            '@type': 'FAQPage',
            mainEntity: questions.map((q)=>({
                    '@type': 'Question',
                    name: q.question,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: q.answer
                    }
                }))
        }, 'faq');
    }
    setMetaTag(name, content) {
        let el = document.querySelector(`meta[name="${name}"]`);
        if (!el) {
            el = document.createElement('meta');
            el.setAttribute('name', name);
            document.head.appendChild(el);
        }
        el.setAttribute('content', content);
    }
    setMetaProperty(property, content) {
        let el = document.querySelector(`meta[property="${property}"]`);
        if (!el) {
            el = document.createElement('meta');
            el.setAttribute('property', property);
            document.head.appendChild(el);
        }
        el.setAttribute('content', content);
    }
    constructor(){
        this.activeJsonLdIds = [];
    }
}
$568accd441f49d8b$export$c836995727999a15 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)({
        init: true
    })
], $568accd441f49d8b$export$c836995727999a15);

});



parcelRegister("c22PD", function(module, exports) {
"use strict";
var $8c27de48a7a5f32c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8c27de48a7a5f32c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8c27de48a7a5f32c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8c27de48a7a5f32c$var$__createBinding(exports1, m, p);
};
var $8c27de48a7a5f32c$var$RouterModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RouterModule = void 0;

var $4XQlz = parcelRequire("4XQlz");



let $8c27de48a7a5f32c$var$RouterModule = $8c27de48a7a5f32c$var$RouterModule_1 = class RouterModule {
    static forRoot(routes, options) {
        return {
            module: $8c27de48a7a5f32c$var$RouterModule_1,
            services: [
                {
                    provide: (parcelRequire("1C5KP")).RouterOptions,
                    useValue: options || {}
                },
                {
                    provide: (parcelRequire("1C5KP")).Routes,
                    useValue: (0, (parcelRequire("bHPYb")).loadRoutes)(routes)
                }
            ],
            components: [
                (parcelRequire("A0OUw")).RouterComponent
            ]
        };
    }
    static forChild(routes) {
        (parcelRequire("bHPYb")).ChildRoutesObservable.next((0, (parcelRequire("bHPYb")).loadRoutes)(routes));
        return $8c27de48a7a5f32c$var$RouterModule_1;
    }
};
module.exports.RouterModule = $8c27de48a7a5f32c$var$RouterModule;
module.exports.RouterModule = $8c27de48a7a5f32c$var$RouterModule = $8c27de48a7a5f32c$var$RouterModule_1 = $8c27de48a7a5f32c$var$__decorate([
    (0, $4XQlz.Module)()
], $8c27de48a7a5f32c$var$RouterModule);

$8c27de48a7a5f32c$var$__exportStar((parcelRequire("1C5KP")), module.exports);

$8c27de48a7a5f32c$var$__exportStar((parcelRequire("bhQ3B")), module.exports);

$8c27de48a7a5f32c$var$__exportStar((parcelRequire("gfO92")), module.exports);

$8c27de48a7a5f32c$var$__exportStar((parcelRequire("A0OUw")), module.exports);

$8c27de48a7a5f32c$var$__exportStar((parcelRequire("l0I9v")), module.exports);

$8c27de48a7a5f32c$var$__exportStar((parcelRequire("bHPYb")), module.exports);

});
parcelRegister("bHPYb", function(module, exports) {
"use strict";
var $0233085a99cedacb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChildRoutesObservable = void 0;
module.exports.loadRoutes = $0233085a99cedacb$var$loadRoutes;
module.exports.getQueryParams = $0233085a99cedacb$var$getQueryParams;

var $4XQlz = parcelRequire("4XQlz");

var $jS6MW = parcelRequire("jS6MW");
var $6s0Lm = parcelRequire("6s0Lm");
var $4aogj = parcelRequire("4aogj");

var $1C5KP = parcelRequire("1C5KP");
const $0233085a99cedacb$var$RouteCache = new Map();
module.exports.ChildRoutesObservable = new $jS6MW.BehaviorSubject(null);
function $0233085a99cedacb$var$assignChildren(route) {
    if (route.children && typeof route.children === 'function') {
        const lazyModule = route.children;
        route.children = function(context, commands) {
            return $0233085a99cedacb$var$__awaiter(this, void 0, void 0, function*() {
                const loadedModule = yield lazyModule(context, commands);
                let routes = module.exports.ChildRoutesObservable.getValue();
                if (loadedModule && Array.isArray(loadedModule.ROUTES)) routes = loadedModule.ROUTES;
                const params = [
                    ...(routes || []).map((r)=>Object.assign({}, r))
                ];
                if (!$0233085a99cedacb$var$RouteCache.has(route.path)) $0233085a99cedacb$var$RouteCache.set(route.path, params);
                return $0233085a99cedacb$var$RouteCache.get(route.path);
            });
        };
    }
    return route;
}
function $0233085a99cedacb$var$activateGuard(result, commands, route) {
    return $0233085a99cedacb$var$__awaiter(this, void 0, void 0, function*() {
        if ((0, $6s0Lm.isObservable)(result)) result = (0, $4aogj.lastValueFrom)(result);
        if (yield result) return result;
        else {
            const routerOptions = $4XQlz.Container.get($1C5KP.RouterOptions);
            let redirect;
            if (route.path === '/') redirect = commands.redirect('/not-found');
            else redirect = commands.redirect(route.parent.path || '/');
            if (routerOptions.log) console.error(`Guard ${route.canActivate['originalName']} activated!`);
            return redirect;
        }
    });
}
function $0233085a99cedacb$var$assignAction(route) {
    if (route.canActivate) {
        const guard = $4XQlz.Container.get(route.canActivate);
        if (route.action) {
            const originalAction = route.action;
            route.action = function(context, commands) {
                return $0233085a99cedacb$var$__awaiter(this, void 0, void 0, function*() {
                    yield originalAction(context, commands);
                    const result = guard.canActivate.bind(guard)(context, commands);
                    return $0233085a99cedacb$var$activateGuard(result, commands, route);
                });
            };
        } else {
            route.action = guard.canActivate.bind(guard);
            const originalAction = route.action;
            route.action = function(context, commands) {
                return $0233085a99cedacb$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield originalAction(context, commands);
                    return $0233085a99cedacb$var$activateGuard(result, commands, route);
                });
            };
        }
    }
    return route;
}
function $0233085a99cedacb$var$assignStaticIs(route) {
    if (typeof route.component === 'function') route.component = route.component.is();
    if (Array.isArray(route.children)) route.children = route.children.map((child)=>$0233085a99cedacb$var$assignStaticIs($0233085a99cedacb$var$assignAction($0233085a99cedacb$var$assignChildren(child))));
    return route;
}
function $0233085a99cedacb$var$loadRoutes(routes) {
    const notFoundRoute = routes.find((v)=>v.path === '(.*)');
    routes = routes.sort(function(a, b) {
        if (a.path < b.path) return -1;
        if (b.path < a.path) return 1;
        return 0;
    });
    if (notFoundRoute) {
        routes.splice(routes.indexOf(notFoundRoute), 1);
        routes.push(notFoundRoute);
    }
    const loadedRoutes = [
        ...routes
    ].map((route)=>$0233085a99cedacb$var$assignStaticIs($0233085a99cedacb$var$assignAction($0233085a99cedacb$var$assignChildren(route))));
    module.exports.ChildRoutesObservable.next(null);
    return loadedRoutes;
}
function $0233085a99cedacb$var$getQueryParams() {
    return [
        ...new URLSearchParams(location.search)
    ].reduce((prev, [key, value])=>Object.assign(Object.assign({}, prev), {
            [key]: value
        }), {});
}

});
parcelRegister("6s0Lm", function(module, exports) {

$parcel$export(module.exports, "isObservable", () => $4b25f3137daa523c$export$5cd057a6046189f9);

var $82Kdl = parcelRequire("82Kdl");

var $1hO6f = parcelRequire("1hO6f");
function $4b25f3137daa523c$export$5cd057a6046189f9(obj) {
    return !!obj && (obj instanceof (0, $82Kdl.Observable) || (0, $1hO6f.isFunction)(obj.lift) && (0, $1hO6f.isFunction)(obj.subscribe));
}

});

parcelRegister("4aogj", function(module, exports) {

$parcel$export(module.exports, "lastValueFrom", () => $308aea8b135f638b$export$a175cc82f1f2275e);

var $8sjrU = parcelRequire("8sjrU");
function $308aea8b135f638b$export$a175cc82f1f2275e(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
            next: function(value) {
                _value = value;
                _hasValue = true;
            },
            error: reject,
            complete: function() {
                if (_hasValue) resolve(_value);
                else if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $8sjrU.EmptyError)());
            }
        });
    });
}

});
parcelRegister("8sjrU", function(module, exports) {

$parcel$export(module.exports, "EmptyError", () => $6280066e71db0765$export$78f6d1b1dbcda304);

var $4syGL = parcelRequire("4syGL");
var $6280066e71db0765$export$78f6d1b1dbcda304 = (0, $4syGL.createErrorClass)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});

});


parcelRegister("1C5KP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RouterOptions = module.exports.Routes = module.exports.RouterRoutlet = void 0;
module.exports.Router = $12cdcdb9db668164$var$Router;

var $4XQlz = parcelRequire("4XQlz");
function $12cdcdb9db668164$var$Router() {
    return (target, propertyKey)=>{
        Object.defineProperty(target, propertyKey, {
            get: ()=>$4XQlz.Container.get(module.exports.RouterRoutlet)
        });
    };
}
module.exports.RouterRoutlet = 'router-outlet';
module.exports.Routes = 'router-routes';
module.exports.RouterOptions = new $4XQlz.InjectionToken('router-options');

});


parcelRegister("A0OUw", function(module, exports) {
"use strict";
var $06c3ffc517dbae9e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $06c3ffc517dbae9e$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RouterComponent = void 0;

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");

var $1C5KP = parcelRequire("1C5KP");

var $bhQ3B = parcelRequire("bhQ3B");
/**
 * @customElement router-outlet
 */ let $06c3ffc517dbae9e$var$RouterComponent = class RouterComponent extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.id = 'router-identifier';
    }
    OnUpdateFirst() {
        const router = new $bhQ3B.Outlet(this.shadowRoot.getElementById(this.id), $4XQlz.Container.get($1C5KP.RouterOptions));
        router.setRoutes(this.routes ? this.routes : $4XQlz.Container.get($1C5KP.Routes));
        $4XQlz.Container.set('router-outlet', router);
        this.dispatchEvent(new CustomEvent('onRouterLoaded', {
            detail: router
        }));
    }
};
module.exports.RouterComponent = $06c3ffc517dbae9e$var$RouterComponent;
$06c3ffc517dbae9e$var$__decorate([
    (0, $eG1Pq.property)(),
    $06c3ffc517dbae9e$var$__metadata("design:type", Object)
], $06c3ffc517dbae9e$var$RouterComponent.prototype, "id", void 0);
$06c3ffc517dbae9e$var$__decorate([
    (0, $eG1Pq.property)({
        type: Array
    }),
    $06c3ffc517dbae9e$var$__metadata("design:type", Object)
], $06c3ffc517dbae9e$var$RouterComponent.prototype, "routes", void 0);
module.exports.RouterComponent = $06c3ffc517dbae9e$var$RouterComponent = $06c3ffc517dbae9e$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'router-outlet',
        template () {
            return (0, $eG1Pq.html)`
      <slot name="header"></slot>
      ${(0, $eG1Pq.html)` <main id="${this.id}"></main> `}
      <slot name="footer"></slot>
    `;
        }
    })
], $06c3ffc517dbae9e$var$RouterComponent);

});
parcelRegister("bhQ3B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Outlet = void 0;

var $jqXHu = parcelRequire("jqXHu");

var $37rZb = parcelRequire("37rZb");

var $bHPYb = parcelRequire("bHPYb");

var $bocCZ = parcelRequire("bocCZ");
class $8379a9b814fbc98f$var$Outlet extends $bocCZ.Router {
    constructor(element, options){
        super(element, options);
        this.options = options;
        this.activePath = '/';
        this.subscription = this.onSnapshotChange().pipe((0, $37rZb.tap)((event)=>{
            if (this.options.log) console.log(`You are at '${event.detail.location.pathname}'`);
            this.activePath = event.detail.location.pathname;
        })).subscribe();
    }
    onSnapshotChange() {
        return (0, $jqXHu.fromEvent)(window, 'router-location-changed');
    }
    freezeRouter() {
        this.freeze = true;
    }
    unfreezeRouter() {
        this.freeze = false;
    }
    getQueryParams() {
        return (0, $bHPYb.getQueryParams)();
    }
    /**
     * Triggers navigation to a new path. Returns a boolean without waiting until the navigation is complete. Returns true if at least one Router has handled the navigation (was subscribed and had baseUrl matching the pathname argument), otherwise returns false.
     * @param pathnamea new in-app path
     * @returns void
     */ go(path) {
        if (this.activePath === path || this.freeze) return false;
        this.activePath = path;
        if (this.options.freeze) this.freezeRouter();
        // window.dispatchEvent(new CustomEvent('router-go', {detail: {pathname: '/to/path'}}));
        return $bocCZ.Router.go(path);
    }
    /**
     * Removes the subscription to navigation events created in the subscribe() method.
     */ unsubscribe() {
        if (this.subscription) this.subscription.unsubscribe();
        super.unsubscribe();
    }
}
module.exports.Outlet = $8379a9b814fbc98f$var$Outlet;

});
parcelRegister("jqXHu", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => $e25ec1473ae9a6f5$export$a36e16046ae8f1bb);

var $cAivK = parcelRequire("cAivK");

var $9IWtL = parcelRequire("9IWtL");

var $82Kdl = parcelRequire("82Kdl");

var $hyQIa = parcelRequire("hyQIa");

var $hv4Mv = parcelRequire("hv4Mv");

var $1hO6f = parcelRequire("1hO6f");

var $d05JU = parcelRequire("d05JU");
var $e25ec1473ae9a6f5$var$nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var $e25ec1473ae9a6f5$var$eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var $e25ec1473ae9a6f5$var$jqueryMethods = [
    'on',
    'off'
];
function $e25ec1473ae9a6f5$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $1hO6f.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $e25ec1473ae9a6f5$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $d05JU.mapOneOrManyArgs)(resultSelector));
    var _a = (0, $cAivK.__read)($e25ec1473ae9a6f5$var$isEventTarget(target) ? $e25ec1473ae9a6f5$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $e25ec1473ae9a6f5$var$isNodeStyleEventEmitter(target) ? $e25ec1473ae9a6f5$var$nodeEventEmitterMethods.map($e25ec1473ae9a6f5$var$toCommonHandlerRegistry(target, eventName)) : $e25ec1473ae9a6f5$var$isJQueryStyleEventEmitter(target) ? $e25ec1473ae9a6f5$var$jqueryMethods.map($e25ec1473ae9a6f5$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $hv4Mv.isArrayLike)(target)) return (0, $hyQIa.mergeMap)(function(subTarget) {
            return $e25ec1473ae9a6f5$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $9IWtL.innerFrom)(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new (0, $82Kdl.Observable)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $e25ec1473ae9a6f5$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $e25ec1473ae9a6f5$var$isNodeStyleEventEmitter(target) {
    return (0, $1hO6f.isFunction)(target.addListener) && (0, $1hO6f.isFunction)(target.removeListener);
}
function $e25ec1473ae9a6f5$var$isJQueryStyleEventEmitter(target) {
    return (0, $1hO6f.isFunction)(target.on) && (0, $1hO6f.isFunction)(target.off);
}
function $e25ec1473ae9a6f5$var$isEventTarget(target) {
    return (0, $1hO6f.isFunction)(target.addEventListener) && (0, $1hO6f.isFunction)(target.removeEventListener);
}

});
parcelRegister("hyQIa", function(module, exports) {

$parcel$export(module.exports, "mergeMap", () => $cc8e80097134e07b$export$6b9f6c0d32c093f9);

var $3XkaH = parcelRequire("3XkaH");

var $9IWtL = parcelRequire("9IWtL");

var $4J4s9 = parcelRequire("4J4s9");

var $3J0mu = parcelRequire("3J0mu");

var $1hO6f = parcelRequire("1hO6f");
function $cc8e80097134e07b$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $1hO6f.isFunction)(resultSelector)) return $cc8e80097134e07b$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $3XkaH.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $9IWtL.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $4J4s9.operate)(function(source, subscriber) {
        return (0, $3J0mu.mergeInternals)(source, subscriber, project, concurrent);
    });
}

});
parcelRegister("3J0mu", function(module, exports) {

$parcel$export(module.exports, "mergeInternals", () => $2b65daebe4c8fa4f$export$600918ebaa9e0a1b);

var $9IWtL = parcelRequire("9IWtL");

var $6X9r0 = parcelRequire("6X9r0");

var $fyrlr = parcelRequire("fyrlr");
function $2b65daebe4c8fa4f$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $9IWtL.innerFrom)(project(value, index++)).subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $6X9r0.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

});



parcelRegister("bocCZ", function(module, exports) {
"use strict";
var $84abbb36742cd4db$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $84abbb36742cd4db$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $84abbb36742cd4db$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Router = module.exports.Resolver = void 0;

var $deveZ = parcelRequire("deveZ");
Object.defineProperty(module.exports, "Resolver", {
    enumerable: true,
    get: function() {
        return $deveZ.Resolver;
    }
});

var $kDlmf = parcelRequire("kDlmf");
Object.defineProperty(module.exports, "Router", {
    enumerable: true,
    get: function() {
        return $kDlmf.Router;
    }
});

$84abbb36742cd4db$var$__exportStar((parcelRequire("bPGEb")), module.exports);

});
parcelRegister("deveZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Resolver = void 0;
module.exports.generateUrls = $9a24d0f51902f356$var$generateUrls;

var $16tih = parcelRequire("16tih");

var $bPGEb = parcelRequire("bPGEb");

var $9GKLl = parcelRequire("9GKLl");
const { hasOwnProperty: $9a24d0f51902f356$var$hasOwnProperty } = Object.prototype;
const $9a24d0f51902f356$var$cache = new Map();
$9a24d0f51902f356$var$cache.set('|false', {
    keys: [],
    pattern: /(?:)/
});
function $9a24d0f51902f356$var$decodeParam(val) {
    try {
        return decodeURIComponent(val);
    } catch (err) {
        return val;
    }
}
function $9a24d0f51902f356$var$matchPath(routepath, path, exact, parentKeys, parentParams) {
    exact = !!exact;
    const cacheKey = `${routepath}|${exact}`;
    let regexp = $9a24d0f51902f356$var$cache.get(cacheKey);
    if (!regexp) {
        const keys = [];
        regexp = {
            keys: keys,
            pattern: (0, $16tih.pathToRegexp)(routepath, keys, {
                end: exact,
                strict: routepath === ''
            })
        };
        $9a24d0f51902f356$var$cache.set(cacheKey, regexp);
    }
    const m = regexp.pattern.exec(path);
    if (!m) return null;
    const params = Object.assign({}, parentParams);
    for(let i = 1; i < m.length; i++){
        const key = regexp.keys[i - 1];
        const prop = key.name;
        const value = m[i];
        if (value !== undefined || !$9a24d0f51902f356$var$hasOwnProperty.call(params, prop)) {
            if (key.repeat) params[prop] = value ? value.split(key.delimiter).map($9a24d0f51902f356$var$decodeParam) : [];
            else params[prop] = value ? $9a24d0f51902f356$var$decodeParam(value) : value;
        }
    }
    return {
        path: m[0],
        keys: (parentKeys || []).concat(regexp.keys),
        params: params
    };
}
function $9a24d0f51902f356$var$matchRoute(route, pathname, ignoreLeadingSlash, parentKeys, parentParams) {
    let match;
    let childMatches;
    let childIndex = 0;
    let routepath = route.path || '';
    let isAbsolute = false;
    if (Array.isArray(routepath)) routepath = routepath.map((path)=>{
        if (path.charAt(0) === '/') {
            isAbsolute = true;
            return ignoreLeadingSlash ? path.substr(1) : path;
        }
        return path;
    });
    else if (routepath.charAt(0) === '/') {
        isAbsolute = true;
        if (ignoreLeadingSlash) routepath = routepath.substr(1);
    }
    if (isAbsolute) ignoreLeadingSlash = true;
    return {
        next (routeToSkip) {
            if (route === routeToSkip) return {
                done: true,
                value: undefined
            };
            const children = route.__children = route.__children || route.children;
            if (!match) {
                match = $9a24d0f51902f356$var$matchPath(routepath, pathname, !children, parentKeys, parentParams);
                if (match) return {
                    done: false,
                    value: {
                        route: route,
                        keys: match.keys,
                        params: match.params,
                        path: match.path
                    }
                };
            }
            if (match && children) while(childIndex < children.length){
                if (!childMatches) {
                    const childRoute = children[childIndex];
                    childRoute.parent = route;
                    let matchedLength = match.path.length;
                    if (matchedLength > 0 && pathname.charAt(matchedLength) === '/') matchedLength += 1;
                    childMatches = $9a24d0f51902f356$var$matchRoute(childRoute, pathname.substr(matchedLength), ignoreLeadingSlash, match.keys, match.params);
                }
                const childMatch = childMatches.next(routeToSkip);
                if (!childMatch.done) return {
                    done: false,
                    value: childMatch.value
                };
                childMatches = null;
                childIndex++;
            }
            return {
                done: true,
                value: undefined
            };
        }
    };
}
function $9a24d0f51902f356$var$resolveRoute(context) {
    if ((0, $9GKLl.isFunction)(context.route.action)) return context.route.action(context);
    return undefined;
}
function $9a24d0f51902f356$var$isChildRoute(parentRoute, childRoute) {
    let route = childRoute;
    while(route){
        route = route.parent;
        if (route === parentRoute) return true;
    }
    return false;
}
function $9a24d0f51902f356$var$generateErrorMessage(currentContext) {
    let errorMessage = `Path '${currentContext.pathname}' is not properly resolved due to an error.`;
    const routePath = (currentContext.route || {}).path;
    if (routePath) errorMessage += ` Resolution had failed on route: '${routePath}'`;
    return errorMessage;
}
function $9a24d0f51902f356$var$updateChainForRoute(context, match) {
    const { route: route, path: path } = match;
    if (route && !route.__synthetic) {
        const item = {
            path: path,
            route: route
        };
        if (!context.chain) context.chain = [];
        else if (route.parent) {
            let i = context.chain.length;
            while(i-- && context.chain[i].route && context.chain[i].route !== route.parent)context.chain.pop();
        }
        context.chain.push(item);
    }
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ class $9a24d0f51902f356$var$Resolver {
    constructor(routes, options = {}){
        if (Object(routes) !== routes) throw new TypeError('Invalid routes');
        this.baseUrl = options.baseUrl || '';
        this.errorHandler = options.errorHandler;
        this.resolveRoute = options.resolveRoute || $9a24d0f51902f356$var$resolveRoute;
        this.context = Object.assign({
            resolver: this
        }, options.context);
        this.root = Array.isArray(routes) ? {
            path: '',
            __children: routes,
            parent: null,
            __synthetic: true
        } : routes;
        this.root.parent = null;
    }
    /**
     * Returns the current list of routes (as a shallow copy). Adding / removing
     * routes to / from the returned array does not affect the routing config,
     * but modifying the route objects does.
     *
     * @return
     */ getRoutes() {
        const children = this.root.__children;
        return Array.isArray(children) ? [
            ...children
        ] : [];
    }
    /**
     * Sets the routing config (replacing the existing one).
     *
     * @param routes a single route or an array of those
     *    (the array is shallow copied)
     */ setRoutes(routes) {
        (0, $9GKLl.ensureRoutes)(routes);
        const newRoutes = [
            ...(0, $9GKLl.toArray)(routes)
        ];
        this.root.__children = newRoutes;
    }
    /**
     * Appends one or several routes to the routing config and returns the
     * effective routing config after the operation.
     *
     * @param routes a single route or an array of those
     *    (the array is shallow copied)
     * @return
     * @protected
     */ addRoutes(routes) {
        (0, $9GKLl.ensureRoutes)(routes);
        if (!this.root.__children || !Array.isArray(this.root.__children)) this.root.__children = [];
        this.root.__children.push(...(0, $9GKLl.toArray)(routes));
        return this.getRoutes();
    }
    /**
     * Removes all existing routes from the routing config.
     */ removeRoutes() {
        this.setRoutes([]);
    }
    /**
     * Asynchronously resolves the given pathname, i.e. finds all routes matching
     * the pathname and tries resolving them one after another in the order they
     * are listed in the routes config until the first non-null result.
     *
     * Returns a promise that is fulfilled with the return value of an object that consists of the first
     * route handler result that returns something other than `null` or `undefined` and context used to get this result.
     *
     * If no route handlers return a non-null result, or if no route matches the
     * given pathname the returned promise is rejected with a 'page not found'
     * `Error`.
     *
     * @param pathnameOrContext the pathname to
     *    resolve or a context object with a `pathname` property and other
     *    properties to pass to the route resolver functions.
     * @return
     */ resolve(pathnameOrContext) {
        const context = Object.assign({}, this.context, (0, $9GKLl.isString)(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext);
        const match = $9a24d0f51902f356$var$matchRoute(this.root, this.__normalizePathname(context.pathname), !!this.baseUrl);
        const resolve = this.resolveRoute;
        let matches = null;
        let nextMatches = null;
        let currentContext = context;
        function next(resume, parent = matches.value.route, prevResult) {
            const routeToSkip = prevResult === null && matches.value.route;
            matches = nextMatches || match.next(routeToSkip);
            nextMatches = null;
            if (!resume) {
                if (matches.done || !$9a24d0f51902f356$var$isChildRoute(parent, matches.value.route)) {
                    nextMatches = matches;
                    return Promise.resolve($bPGEb.notFoundResult);
                }
            }
            if (matches.done) return Promise.reject((0, $9GKLl.getNotFoundError)(context));
            currentContext = Object.assign(currentContext ? {
                chain: currentContext.chain ? currentContext.chain.slice(0) : []
            } : {}, context, matches.value);
            $9a24d0f51902f356$var$updateChainForRoute(currentContext, matches.value);
            return Promise.resolve(resolve(currentContext)).then((resolution)=>{
                if (resolution !== null && resolution !== undefined && resolution !== $bPGEb.notFoundResult) {
                    currentContext.result = resolution.redirect ? resolution : resolution.tagName ? resolution : resolution;
                    return currentContext;
                }
                return next(resume, parent, resolution);
            });
        }
        context.next = next;
        return Promise.resolve().then(()=>next(true, this.root)).then((result)=>{
            if (result === $bPGEb.notFoundResult) throw (0, $9GKLl.getNotFoundError)(context);
            return result;
        }).catch((error)=>{
            const errorMessage = $9a24d0f51902f356$var$generateErrorMessage(currentContext);
            if (!error) error = new Error(errorMessage);
            else console.warn(errorMessage);
            error.context = error.context || currentContext;
            if (!(error instanceof DOMException)) error.code = error.code || 500;
            if (this.errorHandler) {
                currentContext.result = this.errorHandler(error);
                return currentContext;
            }
            throw error;
        });
    }
    static __createUrl(url, base) {
        return new URL(url, base);
    }
    __getEffectiveBaseUrl() {
        return this.baseUrl ? this.constructor.__createUrl(this.baseUrl, document.baseURI || document.URL).href.replace(/[^\/]*$/, '') : '';
    }
    __normalizePathname(pathname) {
        if (!this.baseUrl) return pathname;
        const base = this.__getEffectiveBaseUrl();
        const normalizedUrl = this.constructor.__createUrl(pathname, base).href;
        if (normalizedUrl.slice(0, base.length) === base) return normalizedUrl.slice(base.length);
        return undefined;
    }
}
module.exports.Resolver = $9a24d0f51902f356$var$Resolver;
const $9a24d0f51902f356$var$cache$1 = new Map();
function $9a24d0f51902f356$var$cacheRoutes(routesByName, route, routes) {
    const name = route.name || route.component;
    if (name) {
        if (routesByName.has(name)) routesByName.get(name).push(route);
        else routesByName.set(name, [
            route
        ]);
    }
    if (Array.isArray(routes)) for(let i = 0; i < routes.length; i++){
        const childRoute = routes[i];
        childRoute.parent = route;
        $9a24d0f51902f356$var$cacheRoutes(routesByName, childRoute, childRoute.__children || childRoute.children);
    }
}
function $9a24d0f51902f356$var$getRouteByName(routesByName, routeName) {
    const routes = routesByName.get(routeName);
    if (routes && routes.length > 1) throw new Error(`Duplicate route with name "${routeName}".` + ` Try seting unique 'name' route properties.`);
    return routes && routes[0];
}
function $9a24d0f51902f356$var$getRoutePath(route) {
    let path = route.path;
    path = Array.isArray(path) ? path[0] : path;
    return path !== undefined ? path : '';
}
function $9a24d0f51902f356$var$generateUrls(router, options = {}) {
    if (!(router instanceof $9a24d0f51902f356$var$Resolver)) throw new TypeError('An instance of Resolver is expected');
    const routesByName = new Map();
    return (routeName, params)=>{
        let route = $9a24d0f51902f356$var$getRouteByName(routesByName, routeName);
        if (!route) {
            routesByName.clear();
            $9a24d0f51902f356$var$cacheRoutes(routesByName, router.root, router.root.__children);
            route = $9a24d0f51902f356$var$getRouteByName(routesByName, routeName);
            if (!route) throw new Error(`Route "${routeName}" not found`);
        }
        let regexp = $9a24d0f51902f356$var$cache$1.get(route.fullPath);
        if (!regexp) {
            let fullPath = $9a24d0f51902f356$var$getRoutePath(route);
            let rt = route.parent;
            while(rt){
                const path = $9a24d0f51902f356$var$getRoutePath(rt);
                if (path) fullPath = path.replace(/\/$/, '') + '/' + fullPath.replace(/^\//, '');
                rt = rt.parent;
            }
            const tokens = (0, $16tih.parse)(fullPath);
            const toPath = (0, $16tih.tokensToFunction)(tokens);
            const keys = Object.create(null);
            for(let i = 0; i < tokens.length; i++)if (!(0, $9GKLl.isString)(tokens[i])) keys[tokens[i].name] = true;
            regexp = {
                toPath: toPath,
                keys: keys
            };
            $9a24d0f51902f356$var$cache$1.set(fullPath, regexp);
            route.fullPath = fullPath;
        }
        let url = regexp.toPath(params, options) || '/';
        if (options.stringifyQueryParams && params) {
            const queryParams = {};
            const keys = Object.keys(params);
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                if (!regexp.keys[key]) queryParams[key] = params[key];
            }
            const query = options.stringifyQueryParams(queryParams);
            if (query) url += query.charAt(0) === '?' ? query : `?${query}`;
        }
        return url;
    };
}

});
parcelRegister("16tih", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $0cdd1324d85a6b7e$var$parse;
module.exports.compile = $0cdd1324d85a6b7e$var$compile;
module.exports.tokensToFunction = $0cdd1324d85a6b7e$var$tokensToFunction;
module.exports.tokensToRegExp = $0cdd1324d85a6b7e$var$tokensToRegExp;
module.exports.pathToRegexp = $0cdd1324d85a6b7e$var$pathToRegexp;
const $0cdd1324d85a6b7e$var$DEFAULT_DELIMITER = '/';
const $0cdd1324d85a6b7e$var$DEFAULT_DELIMITERS = './';
const $0cdd1324d85a6b7e$var$PATH_REGEXP = new RegExp([
    '(\\\\.)',
    '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
].join('|'), 'g');
function $0cdd1324d85a6b7e$var$parse(str, options) {
    const tokens = [];
    let key = 0;
    let index = 0;
    let path = '';
    const defaultDelimiter = options && options.delimiter || $0cdd1324d85a6b7e$var$DEFAULT_DELIMITER;
    const delimiters = options && options.delimiters || $0cdd1324d85a6b7e$var$DEFAULT_DELIMITERS;
    let pathEscaped = false;
    let res;
    while((res = $0cdd1324d85a6b7e$var$PATH_REGEXP.exec(str)) !== null){
        const m = res[0];
        const escaped = res[1];
        const offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        if (escaped) {
            path += escaped[1];
            pathEscaped = true;
            continue;
        }
        let prev = '';
        const next = str[index];
        const name = res[2];
        const capture = res[3];
        const group = res[4];
        const modifier = res[5];
        if (!pathEscaped && path.length) {
            const k = path.length - 1;
            if (delimiters.indexOf(path[k]) > -1) {
                prev = path[k];
                path = path.slice(0, k);
            }
        }
        if (path) {
            tokens.push(path);
            path = '';
            pathEscaped = false;
        }
        const partial = prev !== '' && next !== undefined && next !== prev;
        const repeat = modifier === '+' || modifier === '*';
        const optional = modifier === '?' || modifier === '*';
        const delimiter = prev || defaultDelimiter;
        const pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prev,
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            pattern: pattern ? $0cdd1324d85a6b7e$var$escapeGroup(pattern) : '[^' + $0cdd1324d85a6b7e$var$escapeString(delimiter) + ']+?'
        });
    }
    if (path || index < str.length) tokens.push(path + str.substr(index));
    return tokens;
}
function $0cdd1324d85a6b7e$var$compile(str, options) {
    return $0cdd1324d85a6b7e$var$tokensToFunction($0cdd1324d85a6b7e$var$parse(str, options));
}
function $0cdd1324d85a6b7e$var$tokensToFunction(tokens) {
    const matches = new Array(tokens.length);
    for(let i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    return function(data, options) {
        let path = '';
        const encode = options && options.encode || encodeURIComponent;
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            const value = data ? data[token.name] : undefined;
            let segment;
            if (Array.isArray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
                if (value.length === 0) {
                    if (token.optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(let j = 0; j < value.length; j++){
                    segment = encode(value[j], token);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                segment = encode(String(value), token);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment;
                continue;
            }
            if (token.optional) {
                if (token.partial) path += token.prefix;
                continue;
            }
            throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'));
        }
        return path;
    };
}
function $0cdd1324d85a6b7e$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
function $0cdd1324d85a6b7e$var$escapeGroup(group) {
    return group.replace(/([=!:$/()])/g, '\\$1');
}
function $0cdd1324d85a6b7e$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
function $0cdd1324d85a6b7e$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    const groups = path.source.match(/\((?!\?)/g);
    if (groups) for(let i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: '',
        delimiter: '',
        optional: false,
        repeat: false,
        partial: false,
        pattern: ''
    });
    return path;
}
function $0cdd1324d85a6b7e$var$arrayToRegexp(path, keys, options) {
    const parts = [];
    for(let i = 0; i < path.length; i++)parts.push($0cdd1324d85a6b7e$var$pathToRegexp(path[i], keys, options).source);
    return new RegExp('(?:' + parts.join('|') + ')', $0cdd1324d85a6b7e$var$flags(options));
}
function $0cdd1324d85a6b7e$var$stringToRegexp(path, keys, options) {
    return $0cdd1324d85a6b7e$var$tokensToRegExp($0cdd1324d85a6b7e$var$parse(path, options), keys, options);
}
function $0cdd1324d85a6b7e$var$tokensToRegExp(tokens, keys, options) {
    options = options || {};
    const strict = options.strict;
    const start = options.start !== false;
    const end = options.end !== false;
    const delimiter = $0cdd1324d85a6b7e$var$escapeString(options.delimiter || $0cdd1324d85a6b7e$var$DEFAULT_DELIMITER);
    const delimiters = options.delimiters || $0cdd1324d85a6b7e$var$DEFAULT_DELIMITERS;
    const endsWith = [].concat(options.endsWith || []).map($0cdd1324d85a6b7e$var$escapeString).concat('$').join('|');
    let route = start ? '^' : '';
    let isEndDelimited = tokens.length === 0;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (typeof token === 'string') {
            route += $0cdd1324d85a6b7e$var$escapeString(token);
            isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1;
        } else {
            const capture = token.repeat ? '(?:' + token.pattern + ')(?:' + $0cdd1324d85a6b7e$var$escapeString(token.delimiter) + '(?:' + token.pattern + '))*' : token.pattern;
            if (keys) keys.push(token);
            if (token.optional) {
                if (token.partial) route += $0cdd1324d85a6b7e$var$escapeString(token.prefix) + '(' + capture + ')?';
                else route += '(?:' + $0cdd1324d85a6b7e$var$escapeString(token.prefix) + '(' + capture + '))?';
            } else route += $0cdd1324d85a6b7e$var$escapeString(token.prefix) + '(' + capture + ')';
        }
    }
    if (end) {
        if (!strict) route += '(?:' + delimiter + ')?';
        route += endsWith === '$' ? '$' : '(?=' + endsWith + ')';
    } else {
        if (!strict) route += '(?:' + delimiter + '(?=' + endsWith + '))?';
        if (!isEndDelimited) route += '(?=' + delimiter + '|' + endsWith + ')';
    }
    return new RegExp(route, $0cdd1324d85a6b7e$var$flags(options));
}
function $0cdd1324d85a6b7e$var$pathToRegexp(path, keys, options) {
    if (path instanceof RegExp) return $0cdd1324d85a6b7e$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $0cdd1324d85a6b7e$var$arrayToRegexp(path, keys, options);
    return $0cdd1324d85a6b7e$var$stringToRegexp(path, keys, options);
} // Attach static methods to pathToRegexp to match original usage if needed,
 // but since we are exporting them individually, consumers can just import them.
 // However, the original code used `pathToRegexp_1` which had static methods attached.
 // We can just export them as named exports.

});

parcelRegister("bPGEb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.notFoundResult = void 0;
// TODO: Move this to a better place or import it
module.exports.notFoundResult = new class NotFoundResult {
}();

});

parcelRegister("9GKLl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toArray = $70dc4f616982797a$var$toArray;
module.exports.log = $70dc4f616982797a$var$log;
module.exports.logValue = $70dc4f616982797a$var$logValue;
module.exports.ensureBundle = $70dc4f616982797a$var$ensureBundle;
module.exports.isObject = $70dc4f616982797a$var$isObject;
module.exports.isFunction = $70dc4f616982797a$var$isFunction;
module.exports.isString = $70dc4f616982797a$var$isString;
module.exports.ensureRoute = $70dc4f616982797a$var$ensureRoute;
module.exports.ensureRoutes = $70dc4f616982797a$var$ensureRoutes;
module.exports.loadScript = $70dc4f616982797a$var$loadScript;
module.exports.loadBundle = $70dc4f616982797a$var$loadBundle;
module.exports.fireRouterEvent = $70dc4f616982797a$var$fireRouterEvent;
module.exports.getNotFoundError = $70dc4f616982797a$var$getNotFoundError;
module.exports.getAnchorOrigin = $70dc4f616982797a$var$getAnchorOrigin;
module.exports.runCallbackIfPossible = $70dc4f616982797a$var$runCallbackIfPossible;

var $fSD8F = parcelRequire("fSD8F");
function $70dc4f616982797a$var$toArray(objectOrArray) {
    objectOrArray = objectOrArray || [];
    return Array.isArray(objectOrArray) ? objectOrArray : [
        objectOrArray
    ];
}
function $70dc4f616982797a$var$log(msg) {
    return `[Router] ${msg}`;
}
function $70dc4f616982797a$var$logValue(value) {
    if (typeof value !== 'object') return String(value);
    const stringType = Object.prototype.toString.call(value).match(/ (.*)\]$/)[1];
    if (stringType === 'Object' || stringType === 'Array') return `${stringType} ${JSON.stringify(value)}`;
    else return stringType;
}
function $70dc4f616982797a$var$ensureBundle(src) {
    if (!src.match(/.+\.[m]?js$/)) throw new Error($70dc4f616982797a$var$log(`Unsupported type for bundle "${src}": .js or .mjs expected.`));
}
function $70dc4f616982797a$var$isObject(o) {
    return typeof o === 'object' && !!o;
}
function $70dc4f616982797a$var$isFunction(f) {
    return typeof f === 'function';
}
function $70dc4f616982797a$var$isString(s) {
    return typeof s === 'string';
}
function $70dc4f616982797a$var$ensureRoute(route) {
    if (!route || !$70dc4f616982797a$var$isString(route.path)) throw new Error($70dc4f616982797a$var$log(`Expected route config to be an object with a "path" string property, or an array of such objects`));
    const bundle = route.bundle;
    const stringKeys = [
        'component',
        'redirect',
        'bundle'
    ];
    if (!$70dc4f616982797a$var$isFunction(route.action) && !Array.isArray(route.children) && !$70dc4f616982797a$var$isFunction(route.children) && !$70dc4f616982797a$var$isObject(bundle) && !stringKeys.some((key)=>$70dc4f616982797a$var$isString(route[key]))) throw new Error($70dc4f616982797a$var$log(`Expected route config "${route.path}" to include either "${stringKeys.join('", "')}" ` + `or "action" function but none found.`));
    if (bundle) {
        if ($70dc4f616982797a$var$isString(bundle)) $70dc4f616982797a$var$ensureBundle(bundle);
        else if (!$fSD8F.bundleKeys.some((key)=>key in bundle)) throw new Error($70dc4f616982797a$var$log('Expected route bundle to include either "' + $fSD8F.NOMODULE + '" or "' + $fSD8F.MODULE + '" keys, or both'));
        else $fSD8F.bundleKeys.forEach((key)=>key in bundle && $70dc4f616982797a$var$ensureBundle(bundle[key]));
    }
    if (route.redirect) [
        'bundle',
        'component'
    ].forEach((overriddenProp)=>{
        if (overriddenProp in route) console.warn($70dc4f616982797a$var$log(`Route config "${route.path}" has both "redirect" and "${overriddenProp}" properties, ` + `and "redirect" will always override the latter. Did you mean to only use "${overriddenProp}"?`));
    });
}
function $70dc4f616982797a$var$ensureRoutes(routes) {
    $70dc4f616982797a$var$toArray(routes).forEach((route)=>$70dc4f616982797a$var$ensureRoute(route));
}
function $70dc4f616982797a$var$loadScript(src, key) {
    let script = document.head.querySelector('script[src="' + src + '"][async]');
    if (!script) {
        script = document.createElement('script');
        script.setAttribute('src', src);
        if (key === $fSD8F.MODULE) script.setAttribute('type', $fSD8F.MODULE);
        else if (key === $fSD8F.NOMODULE) script.setAttribute($fSD8F.NOMODULE, '');
        script.async = true;
    }
    return new Promise((resolve, reject)=>{
        script['onreadystatechange'] = script.onload = (e)=>{
            script.__dynamicImportLoaded = true;
            resolve(e);
        };
        script.onerror = (e)=>{
            if (script.parentNode) script.parentNode.removeChild(script);
            reject(e);
        };
        if (script.parentNode === null) document.head.appendChild(script);
        else if (script.__dynamicImportLoaded) resolve();
    });
}
function $70dc4f616982797a$var$loadBundle(bundle) {
    if ($70dc4f616982797a$var$isString(bundle)) return $70dc4f616982797a$var$loadScript(bundle).then(()=>{
    //
    });
    else return Promise.race($fSD8F.bundleKeys.filter((key)=>key in bundle).map((key)=>$70dc4f616982797a$var$loadScript(bundle[key], key))).then(()=>{
    //
    });
}
function $70dc4f616982797a$var$fireRouterEvent(type, detail) {
    return !window.dispatchEvent(new CustomEvent(`router-${type}`, {
        cancelable: type === 'go',
        detail: detail
    }));
}
function $70dc4f616982797a$var$getNotFoundError(context) {
    const error = new Error($70dc4f616982797a$var$log(`Page not found (${context.pathname})`));
    error.context = context;
    error.code = 404;
    return error;
}
function $70dc4f616982797a$var$getAnchorOrigin(anchor) {
    const port = anchor.port;
    const protocol = anchor.protocol;
    const defaultHttp = protocol === 'http:' && port === '80';
    const defaultHttps = protocol === 'https:' && port === '443';
    const host = defaultHttp || defaultHttps ? anchor.hostname : anchor.host;
    return `${protocol}//${host}`;
}
function $70dc4f616982797a$var$runCallbackIfPossible(callback, args, thisArg) {
    if ($70dc4f616982797a$var$isFunction(callback)) return callback.apply(thisArg, args);
    return undefined;
}

});
parcelRegister("fSD8F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bundleKeys = module.exports.NOMODULE = module.exports.MODULE = void 0;
module.exports.MODULE = 'module';
module.exports.NOMODULE = 'nomodule';
module.exports.bundleKeys = [
    module.exports.MODULE,
    module.exports.NOMODULE
];

});



parcelRegister("kDlmf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Router = void 0;

var $16tih = parcelRequire("16tih");

var $deveZ = parcelRequire("deveZ");

var $e2ohW = parcelRequire("e2ohW");

var $bPGEb = parcelRequire("bPGEb");

var $9GKLl = parcelRequire("9GKLl");
const $f0580465dc009b5e$var$willAnimate = (elem)=>{
    const name = getComputedStyle(elem).getPropertyValue('animation-name');
    return name && name !== 'none';
};
const $f0580465dc009b5e$var$waitForAnimation = (elem, cb)=>{
    const listener = ()=>{
        elem.removeEventListener('animationend', listener);
        cb();
    };
    elem.addEventListener('animationend', listener);
};
function $f0580465dc009b5e$var$animate(elem, className) {
    elem.classList.add(className);
    return new Promise((resolve)=>{
        if ($f0580465dc009b5e$var$willAnimate(elem)) {
            const rect = elem.getBoundingClientRect();
            const size = `height: ${rect.bottom - rect.top}px; width: ${rect.right - rect.left}px`;
            elem.setAttribute('style', `position: absolute; ${size}`);
            $f0580465dc009b5e$var$waitForAnimation(elem, ()=>{
                elem.classList.remove(className);
                elem.removeAttribute('style');
                resolve();
            });
        } else {
            elem.classList.remove(className);
            resolve();
        }
    });
}
const $f0580465dc009b5e$var$MAX_REDIRECT_COUNT = 256;
function $f0580465dc009b5e$var$isResultNotEmpty(result) {
    return result !== null && result !== undefined;
}
function $f0580465dc009b5e$var$copyContextWithoutNext(context) {
    const copy = Object.assign({}, context);
    delete copy.next;
    return copy;
}
function $f0580465dc009b5e$var$getPathnameForRouter(pathname, router) {
    const base = router.__getEffectiveBaseUrl();
    return base ? router.constructor.__createUrl(pathname.replace(/^\//, ''), base).pathname : pathname;
}
function $f0580465dc009b5e$var$getMatchedPath(chain) {
    return chain.map((item)=>{
        const path = item.path || item.path || '';
        return Array.isArray(path) ? path[0] : path;
    }).reduce((a, b)=>{
        if (b.length) return a.replace(/\/$/, '') + '/' + b.replace(/^\//, '');
        return a;
    }, '');
}
function $f0580465dc009b5e$var$createLocation({ pathname: pathname = '', search: search = '', hash: hash = '', chain: chain = [], params: params = {}, redirectFrom: redirectFrom, resolver: resolver }, route) {
    const routes = chain.map((item)=>item.route);
    return {
        baseUrl: resolver && resolver.baseUrl || '',
        pathname: pathname,
        search: search,
        hash: hash,
        routes: routes,
        route: route || routes.length && routes[routes.length - 1] || null,
        params: params,
        redirectFrom: redirectFrom,
        getUrl: (userParams = {})=>$f0580465dc009b5e$var$getPathnameForRouter((0, $16tih.compile)($f0580465dc009b5e$var$getMatchedPath(routes))(Object.assign({}, params, userParams)), resolver)
    };
}
function $f0580465dc009b5e$var$createRedirect(context, pathname) {
    const params = Object.assign({}, context.params);
    return {
        redirect: {
            pathname: pathname,
            from: context.pathname,
            params: params
        }
    };
}
function $f0580465dc009b5e$var$renderElement(context, element) {
    element.location = $f0580465dc009b5e$var$createLocation(context);
    const index = context.chain.map((item)=>item.route).indexOf(context.route);
    context.chain[index].element = element;
    return element;
}
function $f0580465dc009b5e$var$amend(amendmentFunction, args, element) {
    return (amendmentResult)=>{
        if (amendmentResult && (amendmentResult.cancel || amendmentResult.redirect)) return amendmentResult;
        if (element) return (0, $9GKLl.runCallbackIfPossible)(element[amendmentFunction], args, element);
        return undefined;
    };
}
function $f0580465dc009b5e$var$processNewChildren(newChildren, route) {
    if (!Array.isArray(newChildren) && !(0, $9GKLl.isObject)(newChildren)) throw new Error((0, $9GKLl.log)(`Incorrect "children" value for the route ${route.path}: expected array or object, but got ${newChildren}`));
    route.__children = [];
    const childRoutes = (0, $9GKLl.toArray)(newChildren);
    for(let i = 0; i < childRoutes.length; i++){
        (0, $9GKLl.ensureRoute)(childRoutes[i]);
        route.__children.push(childRoutes[i]);
    }
}
function $f0580465dc009b5e$var$removeDomNodes(nodes) {
    if (nodes && nodes.length) {
        const parent = nodes[0].parentNode;
        for(let i = 0; i < nodes.length; i++)parent.removeChild(nodes[i]);
    }
}
/**
 * A simple client-side router for single-page applications. It uses
 * express-style middleware and has a first-class support for Web Components and
 * lazy-loading. Works great in Polymer and non-Polymer apps.
 *
 * Use `new Router(outlet, options)` to create a new Router instance.
 *
 * * The `outlet` parameter is a reference to the DOM node to render
 *   the content into.
 *
 * * The `options` parameter is an optional object with options. The following
 *   keys are supported:
 *   * `baseUrl` — the initial value for [
 *     the `baseUrl` property
 *   ](#/classes/Router#property-baseUrl)
 *
 * The Router instance is automatically subscribed to navigation events
 * on `window`.
 *
 * See [Live Examples](#/classes/Router/demos/demo/index.html) for the detailed usage demo and code snippets.
 *
 * See also detailed API docs for the following methods, for the advanced usage:
 *
 * * [setOutlet](#/classes/Router#method-setOutlet) – should be used to configure the outlet.
 * * [setTriggers](#/classes/Router#method-setTriggers) – should be used to configure the navigation events.
 * * [setRoutes](#/classes/Router#method-setRoutes) – should be used to configure the routes.
 *
 * Only `setRoutes` has to be called manually, others are automatically invoked when creating a new instance.
 *
 * @extends Resolver
 * @demo demo/index.html
 * @summary JavaScript class that renders different DOM content depending on
 *    a given path. It can re-render when triggered or automatically on
 *    'popstate' and / or 'click' events.
 */ class $f0580465dc009b5e$var$Router extends $deveZ.Resolver {
    /**
     * Creates a new Router instance with a given outlet, and
     * automatically subscribes it to navigation events on the `window`.
     * Using a constructor argument or a setter for outlet is equivalent:
     *
     * ```
     * const router = new Router();
     * router.setOutlet(outlet);
     * ```
     * @param outlet
     * @param options
     */ constructor(outlet, options){
        const baseElement = document.head.querySelector('base');
        const baseHref = baseElement && baseElement.getAttribute('href');
        super([], Object.assign({
            baseUrl: baseHref && $deveZ.Resolver.__createUrl(baseHref, document.URL).pathname.replace(/[^\/]*$/, '')
        }, options));
        this.resolveRoute = (context)=>this.__resolveRoute(context);
        (0, $e2ohW.setNavigationTriggers)([
            $e2ohW.POPSTATE,
            $e2ohW.CLICK
        ]);
        this.ready = Promise.resolve(outlet);
        this.location = $f0580465dc009b5e$var$createLocation({
            resolver: this
        });
        this.__lastStartedRenderId = 0;
        this.__navigationEventHandler = this.__onNavigationEvent.bind(this);
        this.setOutlet(outlet);
        this.subscribe();
        this.__createdByRouter = new WeakMap();
        this.__addedByRouter = new WeakMap();
    }
    __resolveRoute(context) {
        const route = context.route;
        let callbacks = Promise.resolve();
        if ((0, $9GKLl.isFunction)(route.children)) callbacks = callbacks.then(()=>route.children($f0580465dc009b5e$var$copyContextWithoutNext(context))).then((children)=>{
            if (!$f0580465dc009b5e$var$isResultNotEmpty(children) && !(0, $9GKLl.isFunction)(route.children)) children = route.children;
            $f0580465dc009b5e$var$processNewChildren(children, route);
        });
        const commands = {
            redirect: (path)=>$f0580465dc009b5e$var$createRedirect(context, path),
            component: (component)=>{
                const element = document.createElement(component);
                this.__createdByRouter.set(element, true);
                return element;
            }
        };
        return callbacks.then(()=>{
            if (this.__isLatestRender(context)) return (0, $9GKLl.runCallbackIfPossible)(route.action, [
                context,
                commands
            ], route);
            return undefined;
        }).then((result)=>{
            if ($f0580465dc009b5e$var$isResultNotEmpty(result)) {
                if (result instanceof HTMLElement || result.redirect || result === $bPGEb.notFoundResult) return result;
            }
            if ((0, $9GKLl.isString)(route.redirect)) return commands.redirect(route.redirect);
            if (route.bundle) return (0, $9GKLl.loadBundle)(route.bundle).then(()=>undefined, ()=>{
                throw new Error((0, $9GKLl.log)(`Bundle not found: ${route.bundle}. Check if the file name is correct`));
            });
            return undefined;
        }).then((result)=>{
            if ($f0580465dc009b5e$var$isResultNotEmpty(result)) return result;
            if ((0, $9GKLl.isString)(route.component)) return commands.component(route.component);
            return undefined;
        });
    }
    /**
     * Takes current routes and set it
     * @param routes: Route<C>[]
     * @returns void
     */ /**
     * Sets the router outlet (the DOM node where the content for the current
     * route is inserted). Any content pre-existing in the router outlet is
     * removed at the end of each render pass.
     *
     * NOTE: this method is automatically invoked first time when creating a new Router instance.
     *
     * @param outlet the DOM node where the content for the current route
     *     is inserted.
     */ setOutlet(outlet) {
        if (outlet) this.__ensureOutlet(outlet);
        this.__outlet = outlet;
    }
    /**
     * Returns the current router outlet. The initial value is undefined.
     */ /**
     * Returns the current router outlet. The initial value is undefined.
     *
     * @return the current router outlet (or `undefined`)
     */ getOutlet() {
        return this.__outlet;
    }
    /**
     * Takes current routes and set it
     * @param routes: Route | Route[]
     * @returns Route | Route[]
     */ /**
     * Sets the routing config (replacing the existing one) and triggers a
     * navigation event so that the router outlet is refreshed according to the
     * current `window.location` and the new routing config.
     *
     * Each route object may have the following properties, listed here in the processing order:
     * * `path` – the route path (relative to the parent route if any) in the
     * [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
     *
     * * `children` – an array of nested routes or a function that provides this
     * array at the render time. The function can be synchronous or asynchronous:
     * in the latter case the render is delayed until the returned promise is
     * resolved. The `children` function is executed every time when this route is
     * being rendered. This allows for dynamic route structures (e.g. backend-defined),
     * but it might have a performance impact as well. In order to avoid calling
     * the function on subsequent renders, you can override the `children` property
     * of the route object and save the calculated array there
     * (via `context.route.children = [ route1, route2, ...];`).
     * Parent routes are fully resolved before resolving the children. Children
     * 'path' values are relative to the parent ones.
     *
     * * `action` – the action that is executed before the route is resolved.
     * The value for this property should be a function, accepting `context`
     * and `commands` parameters described below. If present, this function is
     * always invoked first, disregarding of the other properties' presence.
     * The action can return a result directly or within a `Promise`, which
     * resolves to the result. If the action result is an `HTMLElement` instance,
     * a `commands.component(name)` result, a `commands.redirect(path)` result,
     * or a `context.next()` result, the current route resolution is finished,
     * and other route config properties are ignored.
     * See also **Route Actions** section in [Live Examples](#/classes/Router/demos/demo/index.html).
     *
     * * `redirect` – other route's path to redirect to. Passes all route parameters to the redirect target.
     * The target route should also be defined.
     * See also **Redirects** section in [Live Examples](#/classes/Router/demos/demo/index.html).
     *
     * * `bundle` – string containing the path to `.js` or `.mjs` bundle to load before resolving the route,
     * or the object with "module" and "nomodule" keys referring to different bundles.
     * Each bundle is only loaded once. If "module" and "nomodule" are set, only one bundle is loaded,
     * depending on whether the browser supports ES modules or not.
     * The property is ignored when either an `action` returns the result or `redirect` property is present.
     * Any error, e.g. 404 while loading bundle will cause route resolution to throw.
     * See also **Code Splitting** section in [Live Examples](#/classes/Router/demos/demo/index.html).
     *
     * * `component` – the tag name of the Web Component to resolve the route to.
     * The property is ignored when either an `action` returns the result or `redirect` property is present.
     * If route contains the `component` property (or an action that return a component)
     * and its child route also contains the `component` property, child route's component
     * will be rendered as a light dom child of a parent component.
     *
     * * `name` – the string name of the route to use in the
     * [`router.urlForName(name, params)`](#/classes/Router#method-urlForName)
     * navigation helper method.
     *
     * For any route function (`action`, `children`) defined, the corresponding `route` object is available inside the callback
     * through the `this` reference. If you need to access it, make sure you define the callback as a non-arrow function
     * because arrow functions do not have their own `this` reference.
     *
     * `context` object that is passed to `action` function holds the following properties:
     * * `context.pathname` – string with the pathname being resolved
     *
     * * `context.search` – search query string
     *
     * * `context.hash` – hash string
     *
     * * `context.params` – object with route parameters
     *
     * * `context.route` – object that holds the route that is currently being rendered.
     *
     * * `context.next()` – function for asynchronously getting the next route
     * contents from the resolution chain (if any)
     *
     * `commands` object that is passed to `action` function has
     * the following methods:
     *
     * * `commands.redirect(path)` – function that creates a redirect data
     * for the path specified.
     *
     * * `commands.component(component)` – function that creates a new HTMLElement
     * with current context. Note: the component created by this function is reused if visiting the same path twice in row.
     *
     *
     * @param routes a single route or an array of those
     * @param skipRender configure the router but skip rendering the
     *     route corresponding to the current `window.location` values
     *
     * @return
     */ setRoutes(routes, skipRender = false) {
        this.__previousContext = undefined;
        this.__urlForName = undefined;
        super.setRoutes(routes);
        if (!skipRender) this.__onNavigationEvent();
        return this.ready;
    }
    /**
     * Asynchronously resolves the given pathname and renders the resolved route component into the router outlet. If no router outlet is set at the time of calling this method, or at the time when the route resolution is completed, a TypeError is thrown.
     * Returns a promise that is fulfilled with the router outlet DOM Node after the route component is created and inserted into the router outlet, or rejected if no route matches the given path.
     * If another render pass is started before the previous one is completed, the result of the previous render pass is ignored.
     * @param pathnameOrContext — the pathname to render or a context object with a pathname property and other properties to pass to the resolver.
     * @param shouldUpdateHistory
     */ /**
     * Asynchronously resolves the given pathname and renders the resolved route
     * component into the router outlet. If no router outlet is set at the time of
     * calling this method, or at the time when the route resolution is completed,
     * a `TypeError` is thrown.
     *
     * Returns a promise that is fulfilled with the router outlet DOM Node after
     * the route component is created and inserted into the router outlet, or
     * rejected if no route matches the given path.
     *
     * If another render pass is started before the previous one is completed, the
     * result of the previous render pass is ignored.
     *
     * @param pathnameOrContext
     *    the pathname to render or a context object with a `pathname` property,
     *    optional `search` and `hash` properties, and other properties
     *    to pass to the resolver.
     * @param shouldUpdateHistory
     *    update browser history with the rendered location
     * @return
     */ render(pathnameOrContext, shouldUpdateHistory) {
        const renderId = ++this.__lastStartedRenderId;
        const context = Object.assign({
            search: '',
            hash: ''
        }, (0, $9GKLl.isString)(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext, {
            __renderId: renderId
        });
        this.ready = this.resolve(context).then((context)=>this.__fullyResolveChain(context)).then((context)=>{
            if (this.__isLatestRender(context)) {
                const previousContext = this.__previousContext;
                if (context === previousContext) {
                    this.__updateBrowserHistory(previousContext, true);
                    return this.location;
                }
                this.location = $f0580465dc009b5e$var$createLocation(context);
                if (shouldUpdateHistory) this.__updateBrowserHistory(context, renderId === 1);
                (0, $9GKLl.fireRouterEvent)('location-changed', {
                    location: this.location
                });
                if (context.__skipAttach) {
                    this.__copyUnchangedElements(context, previousContext);
                    this.__previousContext = context;
                    return this.location;
                }
                this.__addAppearingContent(context, previousContext);
                const animationDone = this.__animateIfNeeded(context);
                this.__runOnAfterEnterCallbacks(context);
                this.__runOnAfterLeaveCallbacks(context, previousContext);
                return animationDone.then(()=>{
                    if (this.__isLatestRender(context)) {
                        this.__removeDisappearingContent();
                        this.__previousContext = context;
                        return this.location;
                    }
                    return undefined;
                });
            }
            return undefined;
        }).catch((error)=>{
            if (renderId === this.__lastStartedRenderId) {
                if (shouldUpdateHistory) this.__updateBrowserHistory(context);
                $f0580465dc009b5e$var$removeDomNodes(this.__outlet && this.__outlet.children);
                this.location = $f0580465dc009b5e$var$createLocation(Object.assign(context, {
                    resolver: this
                }));
                (0, $9GKLl.fireRouterEvent)('error', Object.assign({
                    router: this,
                    error: error
                }, context));
                throw error;
            }
            return undefined;
        });
        return this.ready;
    }
    __fullyResolveChain(topOfTheChainContextBeforeRedirects, contextBeforeRedirects = topOfTheChainContextBeforeRedirects) {
        return this.__findComponentContextAfterAllRedirects(contextBeforeRedirects).then((contextAfterRedirects)=>{
            const redirectsHappened = contextAfterRedirects !== contextBeforeRedirects;
            const topOfTheChainContextAfterRedirects = redirectsHappened ? contextAfterRedirects : topOfTheChainContextBeforeRedirects;
            const matchedPath = $f0580465dc009b5e$var$getPathnameForRouter($f0580465dc009b5e$var$getMatchedPath(contextAfterRedirects.chain), contextAfterRedirects.resolver);
            const isFound = matchedPath === contextAfterRedirects.pathname;
            const findNextContextIfAny = (context, parent = context.route, prevResult)=>{
                return context.next(undefined, parent, prevResult).then((nextContext)=>{
                    if (nextContext === null || nextContext === $bPGEb.notFoundResult) {
                        if (isFound) return context;
                        else if (parent.parent !== null) return findNextContextIfAny(context, parent.parent, nextContext);
                        else return nextContext;
                    }
                    return nextContext;
                });
            };
            return findNextContextIfAny(contextAfterRedirects).then((nextContext)=>{
                if (nextContext === null || nextContext === $bPGEb.notFoundResult) throw (0, $9GKLl.getNotFoundError)(topOfTheChainContextAfterRedirects);
                return nextContext && nextContext !== $bPGEb.notFoundResult && nextContext !== contextAfterRedirects ? this.__fullyResolveChain(topOfTheChainContextAfterRedirects, nextContext) : this.__amendWithOnBeforeCallbacks(contextAfterRedirects);
            });
        });
    }
    __findComponentContextAfterAllRedirects(context) {
        const result = context.result;
        if (result instanceof HTMLElement) {
            $f0580465dc009b5e$var$renderElement(context, result);
            return Promise.resolve(context);
        } else if (result && result.redirect) return this.__redirect(result.redirect, context.__redirectCount, context.__renderId).then((context)=>this.__findComponentContextAfterAllRedirects(context));
        else if (result instanceof Error) return Promise.reject(result);
        else return Promise.reject(new Error((0, $9GKLl.log)(`Invalid route resolution result for path "${context.pathname}". ` + `Expected redirect object or HTML element, but got: "${(0, $9GKLl.logValue)(result)}". ` + `Double check the action return value for the route.`)));
    }
    __amendWithOnBeforeCallbacks(contextWithFullChain) {
        return this.__runOnBeforeCallbacks(contextWithFullChain).then((amendedContext)=>{
            if (amendedContext === this.__previousContext || amendedContext === contextWithFullChain) return amendedContext;
            return this.__fullyResolveChain(amendedContext);
        });
    }
    __runOnBeforeCallbacks(newContext) {
        const previousContext = this.__previousContext || {};
        const previousChain = previousContext.chain || [];
        const newChain = newContext.chain;
        let callbacks = Promise.resolve();
        const prevent = ()=>({
                cancel: true
            });
        const redirect = (pathname)=>$f0580465dc009b5e$var$createRedirect(newContext, pathname);
        newContext.__divergedChainIndex = 0;
        newContext.__skipAttach = false;
        if (previousChain.length) {
            for(let i = 0; i < Math.min(previousChain.length, newChain.length); i = ++newContext.__divergedChainIndex){
                if (previousChain[i].route !== newChain[i].route || previousChain[i].path !== newChain[i].path && previousChain[i].element !== newChain[i].element || !this.__isReusableElement(previousChain[i].element, newChain[i].element)) break;
            }
            newContext.__skipAttach = newChain.length === previousChain.length && newContext.__divergedChainIndex == newChain.length && this.__isReusableElement(newContext.result, previousContext.result);
            if (newContext.__skipAttach) {
                for(let i = newChain.length - 1; i >= 0; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                    prevent: prevent
                }, previousChain[i]);
                for(let i = 0; i < newChain.length; i++){
                    callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                        prevent: prevent,
                        redirect: redirect
                    }, newChain[i]);
                    previousChain[i].element.location = $f0580465dc009b5e$var$createLocation(newContext, previousChain[i].route);
                }
            } else for(let i = previousChain.length - 1; i >= newContext.__divergedChainIndex; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                prevent: prevent
            }, previousChain[i]);
        }
        if (!newContext.__skipAttach) for(let i = 0; i < newChain.length; i++){
            if (i < newContext.__divergedChainIndex) {
                if (i < previousChain.length && previousChain[i].element) previousChain[i].element.location = $f0580465dc009b5e$var$createLocation(newContext, previousChain[i].route);
            } else {
                callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                    prevent: prevent,
                    redirect: redirect
                }, newChain[i]);
                if (newChain[i].element) newChain[i].element.location = $f0580465dc009b5e$var$createLocation(newContext, newChain[i].route);
            }
        }
        return callbacks.then((amendmentResult)=>{
            if (amendmentResult) {
                if (amendmentResult.cancel) {
                    this.__previousContext.__renderId = newContext.__renderId;
                    return this.__previousContext;
                }
                if (amendmentResult.redirect) return this.__redirect(amendmentResult.redirect, newContext.__redirectCount, newContext.__renderId);
            }
            return newContext;
        });
    }
    __runOnBeforeLeaveCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $f0580465dc009b5e$var$createLocation(newContext);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const afterLeaveFunction = $f0580465dc009b5e$var$amend('onBeforeLeave', [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return afterLeaveFunction(result);
            }
            return undefined;
        }).then((result)=>{
            if (!(result || {}).redirect) return result;
            return undefined;
        });
    }
    __runOnBeforeEnterCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $f0580465dc009b5e$var$createLocation(newContext, chainElement.route);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const beforeEnterFunction = $f0580465dc009b5e$var$amend('onBeforeEnter', [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return beforeEnterFunction(result);
            }
            return undefined;
        });
    }
    __isReusableElement(element, otherElement) {
        if (element && otherElement) return this.__createdByRouter.get(element) && this.__createdByRouter.get(otherElement) ? element.localName === otherElement.localName : element === otherElement;
        return false;
    }
    __isLatestRender(context) {
        return context.__renderId === this.__lastStartedRenderId;
    }
    __redirect(redirectData, counter, renderId) {
        if ((counter || 0) > $f0580465dc009b5e$var$MAX_REDIRECT_COUNT) throw new Error((0, $9GKLl.log)(`Too many redirects when rendering ${redirectData.from}`));
        return this.resolve({
            pathname: this.urlForPath(redirectData.pathname, redirectData.params),
            redirectFrom: redirectData.from,
            __redirectCount: (counter || 0) + 1,
            __renderId: renderId
        });
    }
    __ensureOutlet(outlet = this.__outlet) {
        if (!(outlet instanceof Node)) throw new TypeError((0, $9GKLl.log)(`Expected router outlet to be a valid DOM Node (but got ${outlet})`));
    }
    __updateBrowserHistory({ pathname: pathname, search: search = '', hash: hash = '' }, replace) {
        if (window.location.pathname !== pathname || window.location.search !== search || window.location.hash !== hash) {
            const changeState = replace ? 'replaceState' : 'pushState';
            window.history[changeState](null, document.title, pathname + search + hash);
            window.dispatchEvent(new PopStateEvent('popstate', {
                state: 'router-ignore'
            }));
        }
    }
    __copyUnchangedElements(context, previousContext) {
        let deepestCommonParent = this.__outlet;
        for(let i = 0; i < context.__divergedChainIndex; i++){
            const unchangedElement = previousContext && previousContext.chain[i].element;
            if (unchangedElement) {
                if (unchangedElement.parentNode === deepestCommonParent) {
                    context.chain[i].element = unchangedElement;
                    deepestCommonParent = unchangedElement;
                } else break;
            }
        }
        return deepestCommonParent;
    }
    __addAppearingContent(context, previousContext) {
        this.__ensureOutlet();
        this.__removeAppearingContent();
        const deepestCommonParent = this.__copyUnchangedElements(context, previousContext);
        this.__appearingContent = [];
        this.__disappearingContent = Array.from(deepestCommonParent.children).filter((e)=>this.__addedByRouter.get(e) && e !== context.result);
        let parentElement = deepestCommonParent;
        for(let i = context.__divergedChainIndex; i < context.chain.length; i++){
            const elementToAdd = context.chain[i].element;
            if (elementToAdd) {
                parentElement.appendChild(elementToAdd);
                this.__addedByRouter.set(elementToAdd, true);
                if (parentElement === deepestCommonParent) this.__appearingContent.push(elementToAdd);
                parentElement = elementToAdd;
            }
        }
    }
    __removeDisappearingContent() {
        if (this.__disappearingContent) $f0580465dc009b5e$var$removeDomNodes(this.__disappearingContent);
        this.__disappearingContent = null;
        this.__appearingContent = null;
    }
    __removeAppearingContent() {
        if (this.__disappearingContent && this.__appearingContent) {
            $f0580465dc009b5e$var$removeDomNodes(this.__appearingContent);
            this.__disappearingContent = null;
            this.__appearingContent = null;
        }
    }
    __runOnAfterLeaveCallbacks(currentContext, targetContext) {
        if (!targetContext) return;
        for(let i = targetContext.chain.length - 1; i >= currentContext.__divergedChainIndex; i--){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = targetContext.chain[i].element;
            if (!currentComponent) continue;
            try {
                const location = $f0580465dc009b5e$var$createLocation(currentContext);
                (0, $9GKLl.runCallbackIfPossible)(currentComponent.onAfterLeave, [
                    location,
                    {},
                    targetContext.resolver
                ], currentComponent);
            } finally{
                if (this.__disappearingContent.indexOf(currentComponent) > -1) $f0580465dc009b5e$var$removeDomNodes(currentComponent.children);
            }
        }
    }
    __runOnAfterEnterCallbacks(currentContext) {
        for(let i = currentContext.__divergedChainIndex; i < currentContext.chain.length; i++){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = currentContext.chain[i].element || {};
            const location = $f0580465dc009b5e$var$createLocation(currentContext, currentContext.chain[i].route);
            (0, $9GKLl.runCallbackIfPossible)(currentComponent.onAfterEnter, [
                location,
                {},
                currentContext.resolver
            ], currentComponent);
        }
    }
    __animateIfNeeded(context) {
        const from = (this.__disappearingContent || [])[0];
        const to = (this.__appearingContent || [])[0];
        const promises = [];
        const chain = context.chain;
        let config;
        for(let i = chain.length; i > 0; i--)if (chain[i - 1].route.animate) {
            config = chain[i - 1].route.animate;
            break;
        }
        if (from && to && config) {
            const leave = (0, $9GKLl.isObject)(config) && config.leave || 'leaving';
            const enter = (0, $9GKLl.isObject)(config) && config.enter || 'entering';
            promises.push($f0580465dc009b5e$var$animate(from, leave));
            promises.push($f0580465dc009b5e$var$animate(to, enter));
        }
        return Promise.all(promises).then(()=>context);
    }
    /**
     * Subscribes this instance to navigation events on the `window`.
     *
     * NOTE: beware of resource leaks. For as long as a router instance is
     * subscribed to navigation events, it won't be garbage collected.
     */ subscribe() {
        window.addEventListener('router-go', this.__navigationEventHandler);
    }
    /**
     * Removes the subscription to navigation events created in the `subscribe()`
     * method.
     */ unsubscribe() {
        window.removeEventListener('router-go', this.__navigationEventHandler);
    }
    __onNavigationEvent(event) {
        const { pathname: pathname, search: search, hash: hash } = event ? event.detail : window.location;
        if ((0, $9GKLl.isString)(this.__normalizePathname(pathname))) {
            if (event && event.preventDefault) event.preventDefault();
            this.render({
                pathname: pathname,
                search: search,
                hash: hash
            }, true);
        }
    }
    /**
     * Generates a URL for the route with the given name, optionally performing
     * substitution of parameters.
     *
     * The route is searched in all the Router instances subscribed to
     * navigation events.
     *
     * **Note:** For child route names, only array children are considered.
     * It is not possible to generate URLs using a name for routes set with
     * a children function.
     *
     * @param name the route name or the route’s `component` name.
     * @param params Optional object with route path parameters.
     * Named parameters are passed by name (`params[name] = value`), unnamed
     * parameters are passed by index (`params[index] = value`).
     *
     * @return
     */ urlForName(name, params) {
        if (!this.__urlForName) this.__urlForName = (0, $deveZ.generateUrls)(this);
        return $f0580465dc009b5e$var$getPathnameForRouter(this.__urlForName(name, params), this);
    }
    /**
     * Generates a URL for the given route path, optionally performing
     * substitution of parameters.
     *
     * @param path string route path declared in [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
     * @param params Optional object with route path parameters.
     * Named parameters are passed by name (`params[name] = value`), unnamed
     * parameters are passed by index (`params[index] = value`).
     *
     * @return
     */ urlForPath(path, params) {
        return $f0580465dc009b5e$var$getPathnameForRouter((0, $16tih.compile)(path)(params), this);
    }
    /**
     * Triggers navigation to a new path. Returns a boolean without waiting until
     * the navigation is complete. Returns `true` if at least one `Router`
     * has handled the navigation (was subscribed and had `baseUrl` matching
     * the `path` argument), otherwise returns `false`.
     *
     * @param path
     *   a new in-app path string, or an URL-like object with `pathname`
     *   string property, and optional `search` and `hash` string properties.
     * @return
     */ static go(path) {
        const { pathname: pathname, search: search, hash: hash } = (0, $9GKLl.isString)(path) ? this.__createUrl(path, 'http://a') : path;
        return (0, $9GKLl.fireRouterEvent)('go', {
            pathname: pathname,
            search: search || '',
            hash: hash || ''
        });
    }
}
module.exports.Router = $f0580465dc009b5e$var$Router;

});
parcelRegister("e2ohW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.POPSTATE = module.exports.CLICK = void 0;
module.exports.RouterGlobalClickHandler = $a38417c09c4f7558$var$RouterGlobalClickHandler;
module.exports.RouterGlobalPopstateHandler = $a38417c09c4f7558$var$RouterGlobalPopstateHandler;
module.exports.setNavigationTriggers = $a38417c09c4f7558$var$setNavigationTriggers;

var $9GKLl = parcelRequire("9GKLl");
// IE Polyfill for PopStateEvent
const $a38417c09c4f7558$var$isIE = /Trident/.test(navigator.userAgent);
if ($a38417c09c4f7558$var$isIE && !(0, $9GKLl.isFunction)(window.PopStateEvent)) {
    window.PopStateEvent = function(inType, params) {
        params = params || {};
        const e = document.createEvent('Event');
        e.initEvent(inType, Boolean(params.bubbles), Boolean(params.cancelable));
        e.state = params.state || null;
        return e;
    };
    window.PopStateEvent.prototype = window.Event.prototype;
}
function $a38417c09c4f7558$var$RouterGlobalClickHandler(event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) return;
    let anchor = event.target;
    const path = event.composedPath ? event.composedPath() : event.path || [];
    for(let i = 0; i < path.length; i++){
        const target = path[i];
        if (target.nodeName && target.nodeName.toLowerCase() === 'a') {
            anchor = target;
            break;
        }
    }
    while(anchor && anchor.nodeName && anchor.nodeName.toLowerCase() !== 'a')anchor = anchor.parentNode;
    if (!anchor || anchor.nodeName.toLowerCase() !== 'a') return;
    const anchorElement = anchor;
    if (anchorElement.target && anchorElement.target.toLowerCase() !== '_self') return;
    if (anchorElement.hasAttribute('download')) return;
    if (anchorElement.hasAttribute('router-ignore')) return;
    if (anchorElement.pathname === window.location.pathname && anchorElement.hash !== '') return;
    const origin = anchorElement.origin || (0, $9GKLl.getAnchorOrigin)(anchorElement);
    if (origin !== window.location.origin) return;
    const { pathname: pathname, search: search, hash: hash } = anchorElement;
    if ((0, $9GKLl.fireRouterEvent)('go', {
        pathname: pathname,
        search: search,
        hash: hash
    })) event.preventDefault();
}
module.exports.CLICK = {
    activate () {
        window.document.addEventListener('click', $a38417c09c4f7558$var$RouterGlobalClickHandler);
    },
    inactivate () {
        window.document.removeEventListener('click', $a38417c09c4f7558$var$RouterGlobalClickHandler);
    }
};
function $a38417c09c4f7558$var$RouterGlobalPopstateHandler(event) {
    if (event.state === 'router-ignore') return;
    const { pathname: pathname, search: search, hash: hash } = window.location;
    (0, $9GKLl.fireRouterEvent)('go', {
        pathname: pathname,
        search: search,
        hash: hash
    });
}
module.exports.POPSTATE = {
    activate () {
        window.addEventListener('popstate', $a38417c09c4f7558$var$RouterGlobalPopstateHandler);
    },
    inactivate () {
        window.removeEventListener('popstate', $a38417c09c4f7558$var$RouterGlobalPopstateHandler);
    }
};
let $a38417c09c4f7558$var$triggers = [];
function $a38417c09c4f7558$var$setNavigationTriggers(newTriggers) {
    $a38417c09c4f7558$var$triggers.forEach((trigger)=>trigger.inactivate());
    newTriggers.forEach((trigger)=>trigger.activate());
    $a38417c09c4f7558$var$triggers = newTriggers;
}

});





parcelRegister("gfO92", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RouteParams = $bd54f1c83f8fdd3f$var$RouteParams;
/**
 * Define getter to `this.location.params` from component `this` and assign params to decorated property
 *
 * @param target: LitElement | HTMLElement
 * @returns this.location.params as getter (lazy evaluated)
 * Usage:
 *
 *
```
{path: '/profile/:name', component: 'x-user-profile'},

import { customElement, LitElement } from '@rxdi/lit-html';

@customElement('x-user-profile')
export class UserProfile extends LitElement {

  @RouteParams()
  params: { name: string }

  render() {
    return html`${this.params.name}`;
  }
}
```
   */ function $bd54f1c83f8fdd3f$var$RouteParams() {
    return function(target, propertyKey) {
        Object.defineProperty(target, propertyKey, {
            get: function() {
                return this.location.params;
            }
        });
    };
}

});

parcelRegister("l0I9v", function(module, exports) {
"use strict";
var $f4bbd8cd28ae858d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotFoundPathConfig = module.exports.NotFoundComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
let $f4bbd8cd28ae858d$var$NotFoundComponent = class NotFoundComponent extends $eG1Pq.LitElement {
};
module.exports.NotFoundComponent = $f4bbd8cd28ae858d$var$NotFoundComponent;
module.exports.NotFoundComponent = $f4bbd8cd28ae858d$var$NotFoundComponent = $f4bbd8cd28ae858d$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'not-found-component-rxdi',
        template: ()=>(0, $eG1Pq.html)`
    <h1>Not found component!</h1>
    <p>Please check your URL.2222daad</p>
  `
    })
], $f4bbd8cd28ae858d$var$NotFoundComponent);
module.exports.NotFoundPathConfig = {
    path: '(.*)',
    component: 'not-found-component-rxdi'
};

});


parcelRegister("8JEqy", function(module, exports) {
"use strict";
var $65c1e2be0c4c3aad$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $65c1e2be0c4c3aad$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $65c1e2be0c4c3aad$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Renderer = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
function $65c1e2be0c4c3aad$var$Render(config) {
    return function(cls) {
        if (!window.customElements.get(config.selector)) return (0, $eG1Pq.Component)(config)(cls);
    };
}
/**
 * @customElement r-renderer
 */ let $65c1e2be0c4c3aad$var$Renderer = class Renderer extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.options = {
            state: {},
            render: (res, setState, shadowRoot)=>(0, $eG1Pq.html)` ${res} `,
            style: (0, $eG1Pq.css)``,
            styles: [],
            deepCloneState: false,
            loading: ()=>(0, $eG1Pq.html)``,
            error: (e)=>(0, $eG1Pq.html)`${e === null || e === void 0 ? void 0 : e.message}`
        };
        this.loading = true;
        this.state = {};
    }
    OnUpdateFirst() {
        var _a, _b, _c;
        return $65c1e2be0c4c3aad$var$__awaiter(this, void 0, void 0, function*() {
            if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.style) (0, $eG1Pq.adoptStyles)(this.shadowRoot, [
                this.options.style
            ]);
            if ((_c = (_b = this.options) === null || _b === void 0 ? void 0 : _b.styles) === null || _c === void 0 ? void 0 : _c.length) (0, $eG1Pq.adoptStyles)(this.shadowRoot, this.options.styles);
            this.options.state = yield this.options.state;
            if (this.options.state) {
                if (this.isObservable(this.options.state)) this.subscription = this.options.state['subscribe']((detail)=>{
                    this.state = detail;
                    this.loading = false;
                    this.dispatchEvent(new CustomEvent('onData', {
                        detail: detail
                    }));
                }, (error)=>{
                    this.state = null;
                    this.error = error;
                    this.loading = false;
                    this.dispatchEvent(new CustomEvent('onError', {
                        detail: error
                    }));
                });
                else {
                    this.loading = false;
                    this.state = this.options.state;
                }
                yield this.updateComplete;
                yield new Promise(requestAnimationFrame);
                this.dispatchEvent(new CustomEvent('loaded'));
            }
        });
    }
    isObservable(value) {
        return this.isFunction(value.lift) && this.isFunction(value.subscribe);
    }
    isFunction(value) {
        return typeof value === 'function';
    }
    OnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }
    renderContent() {
        if (!this.error && this.options.render) {
            const template = this.options.render(this.options.deepCloneState ? JSON.parse(JSON.stringify(this.state)) : this.state, (state)=>this.state = Object.assign({}, state), this.shadowRoot);
            if (template === null || template === void 0 ? void 0 : template.strings) return template;
            return (0, $eG1Pq.html)``;
        }
        return this.state;
    }
};
module.exports.Renderer = $65c1e2be0c4c3aad$var$Renderer;
$65c1e2be0c4c3aad$var$__decorate([
    (0, $eG1Pq.property)({
        type: Object
    }),
    $65c1e2be0c4c3aad$var$__metadata("design:type", Object)
], $65c1e2be0c4c3aad$var$Renderer.prototype, "options", void 0);
$65c1e2be0c4c3aad$var$__decorate([
    (0, $eG1Pq.property)({
        type: Boolean
    }),
    $65c1e2be0c4c3aad$var$__metadata("design:type", Object)
], $65c1e2be0c4c3aad$var$Renderer.prototype, "loading", void 0);
$65c1e2be0c4c3aad$var$__decorate([
    (0, $eG1Pq.property)({
        type: Object
    }),
    $65c1e2be0c4c3aad$var$__metadata("design:type", Error)
], $65c1e2be0c4c3aad$var$Renderer.prototype, "error", void 0);
$65c1e2be0c4c3aad$var$__decorate([
    (0, $eG1Pq.property)(),
    $65c1e2be0c4c3aad$var$__metadata("design:type", Object)
], $65c1e2be0c4c3aad$var$Renderer.prototype, "state", void 0);
module.exports.Renderer = $65c1e2be0c4c3aad$var$Renderer = $65c1e2be0c4c3aad$var$__decorate([
    $65c1e2be0c4c3aad$var$Render({
        selector: 'r-renderer',
        template () {
            return (0, $eG1Pq.html)`
      ${!this.loading ? this.renderContent() : ''}
      ${this.loading ? (0, $eG1Pq.html)`
            ${this.isFunction(this.options.loading) ? this.options.loading() : (0, $eG1Pq.html)``}
          ` : ''}
      ${this.error ? (0, $eG1Pq.html)`
            ${this.isFunction(this.options.error) ? this.options.error(this.error) : (0, $eG1Pq.html)` ${this.error} `}
          ` : ''}
    `;
        }
    })
], $65c1e2be0c4c3aad$var$Renderer);

});

parcelRegister("3jEhc", function(module, exports) {
"use strict";
var $26a2637ae9121fbb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $26a2637ae9121fbb$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ForOperator = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
/**
 * @customElement r-for
 */ let $26a2637ae9121fbb$var$ForOperator = class ForOperator extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.of = [];
    }
    OnUpdate() {
        const slotNodes = this.shadowRoot.querySelector('slot').assignedNodes();
        if (slotNodes.length) {
            const slotNode = slotNodes[0];
            const letOperator = slotNode.nextSibling;
            if (letOperator) letOperator.data = this.of;
        }
    }
};
module.exports.ForOperator = $26a2637ae9121fbb$var$ForOperator;
$26a2637ae9121fbb$var$__decorate([
    (0, $eG1Pq.property)({
        type: Array
    }),
    $26a2637ae9121fbb$var$__metadata("design:type", Object)
], $26a2637ae9121fbb$var$ForOperator.prototype, "of", void 0);
module.exports.ForOperator = $26a2637ae9121fbb$var$ForOperator = $26a2637ae9121fbb$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'r-for',
        styles: [
            (0, $eG1Pq.css)`
      :host {
        display: none;
      }
    `
        ],
        template () {
            return (0, $eG1Pq.html)` <slot></slot> `;
        }
    })
], $26a2637ae9121fbb$var$ForOperator);

});

parcelRegister("cOpHU", function(module, exports) {
"use strict";
var $953e18775b69f670$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $953e18775b69f670$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LetOperator = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
/**
 * @customElement r-let
 */ let $953e18775b69f670$var$LetOperator = class LetOperator extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.data = [];
        this.item = (v)=>(0, $eG1Pq.html)` ${v} `;
    }
    OnUpdateFirst() {
        if (!this.isObservable(this.data)) this.parentElement.parentNode.insertBefore(this.shadowRoot, this.parentElement.nextSibling);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    normalizeArray(state) {
        if (!state || typeof state === 'string') return [];
        if (typeof state === 'number') return Array.from(Array(state), (v, i)=>i);
        /* https://javascript.info/map-set */ if (state instanceof Map || state instanceof Set) return [
            ...state.entries()
        ];
        if (!Array.isArray(state)) return Object.entries(state);
        return state;
    }
    isObservable(value) {
        return value && this.isFunction(value.lift) && this.isFunction(value.subscribe);
    }
    isFunction(value) {
        return typeof value === 'function';
    }
};
module.exports.LetOperator = $953e18775b69f670$var$LetOperator;
$953e18775b69f670$var$__decorate([
    (0, $eG1Pq.property)({
        type: Array
    }),
    $953e18775b69f670$var$__metadata("design:type", Object)
], $953e18775b69f670$var$LetOperator.prototype, "data", void 0);
$953e18775b69f670$var$__decorate([
    (0, $eG1Pq.property)({
        type: Object
    }),
    $953e18775b69f670$var$__metadata("design:type", Object)
], $953e18775b69f670$var$LetOperator.prototype, "item", void 0);
module.exports.LetOperator = $953e18775b69f670$var$LetOperator = $953e18775b69f670$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'r-let',
        template () {
            return (0, $eG1Pq.html)`
      ${this.isObservable(this.data) ? (0, $eG1Pq.html)`
            <r-renderer
              .options=${{
                state: this.data,
                render: (state, set, shadowRoot)=>{
                    this.parentElement.parentNode.insertBefore(shadowRoot, this.parentElement.nextSibling);
                    return (0, $eG1Pq.html)`${this.normalizeArray(state).map(this.item)}`;
                }
            }}
            ></r-renderer>
          ` : this.normalizeArray(this.data).map(this.item)}
    `;
        }
    })
], $953e18775b69f670$var$LetOperator);

});

parcelRegister("1eatX", function(module, exports) {
"use strict";
var $0e4f3ac5a37fc418$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0e4f3ac5a37fc418$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IfOperator = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
/**
 * @customElement r-if
 */ let $0e4f3ac5a37fc418$var$IfOperator = class IfOperator extends $eG1Pq.LitElement {
    OnUpdateFirst() {
    // this.parentNode.insertBefore(this.shadowRoot, this.nextSibling);
    }
};
module.exports.IfOperator = $0e4f3ac5a37fc418$var$IfOperator;
$0e4f3ac5a37fc418$var$__decorate([
    (0, $eG1Pq.property)({
        type: Boolean
    }),
    $0e4f3ac5a37fc418$var$__metadata("design:type", Boolean)
], $0e4f3ac5a37fc418$var$IfOperator.prototype, "exp", void 0);
module.exports.IfOperator = $0e4f3ac5a37fc418$var$IfOperator = $0e4f3ac5a37fc418$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'r-if',
        template () {
            return (0, $eG1Pq.html)` ${this.exp ? (0, $eG1Pq.html)` <slot></slot> ` : ''} `;
        }
    })
], $0e4f3ac5a37fc418$var$IfOperator);

});

parcelRegister("jWytf", function(module, exports) {
"use strict";
var $e84e2c483e59296b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e84e2c483e59296b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e84e2c483e59296b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e84e2c483e59296b$var$__exportStar((parcelRequire("kyzKn")), module.exports);

$e84e2c483e59296b$var$__exportStar((parcelRequire("d4xL1")), module.exports);

$e84e2c483e59296b$var$__exportStar((parcelRequire("dueyX")), module.exports);

});
parcelRegister("kyzKn", function(module, exports) {
"use strict";
var $ef72b63ecd9400f6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ef72b63ecd9400f6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ef72b63ecd9400f6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ef72b63ecd9400f6$var$__createBinding(exports1, m, p);
};
var $ef72b63ecd9400f6$var$ReactiveUiModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactiveUiModule = void 0;

var $4XQlz = parcelRequire("4XQlz");

var $1WKsL = parcelRequire("1WKsL");

var $jS6MW = parcelRequire("jS6MW");

var $amuTJ = parcelRequire("amuTJ");

var $kEETh = parcelRequire("kEETh");

var $4IHFd = parcelRequire("4IHFd");

var $67wp6 = parcelRequire("67wp6");

var $a3mpd = parcelRequire("a3mpd");

var $hegzL = parcelRequire("hegzL");

var $5Ur5L = parcelRequire("5Ur5L");

var $dd9i7 = parcelRequire("dd9i7");
let $ef72b63ecd9400f6$var$ReactiveUiModule = $ef72b63ecd9400f6$var$ReactiveUiModule_1 = class ReactiveUiModule {
    static forRoot(options = {}) {
        return {
            module: $ef72b63ecd9400f6$var$ReactiveUiModule_1,
            providers: [
                $hegzL.ResponsiveService,
                {
                    provide: $1WKsL.Palettes,
                    useValue: new $jS6MW.BehaviorSubject(options.palettes || {
                        root: $dd9i7.ROOT,
                        default: $amuTJ.DEFAULT,
                        primary: $kEETh.PRIMARY,
                        secondary: $67wp6.SECONDARY,
                        danger: $4IHFd.DANGER,
                        warning: $5Ur5L.WARNING
                    })
                },
                $a3mpd.DynamicCssService
            ]
        };
    }
};
module.exports.ReactiveUiModule = $ef72b63ecd9400f6$var$ReactiveUiModule;
module.exports.ReactiveUiModule = $ef72b63ecd9400f6$var$ReactiveUiModule = $ef72b63ecd9400f6$var$ReactiveUiModule_1 = $ef72b63ecd9400f6$var$__decorate([
    (0, $4XQlz.Module)()
], $ef72b63ecd9400f6$var$ReactiveUiModule);

$ef72b63ecd9400f6$var$__exportStar((parcelRequire("dZ7sk")), module.exports);

});
parcelRegister("1WKsL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Styles = module.exports.Palettes = module.exports.PalettesUnion = void 0;

var $h2qoy = parcelRequire("h2qoy");
module.exports.PalettesUnion = (0, $h2qoy.strEnum)([
    'root',
    'default',
    'primary',
    'secondary',
    'danger',
    'warning'
]);
module.exports.Palettes = 'palettes';
module.exports.Styles = (0, $h2qoy.strEnum)([
    'spacer',
    'pointer',
    'images',
    'flex',
    'center',
    'transitions'
]);

});
parcelRegister("h2qoy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.strEnum = $c677190d1ebb57e5$var$strEnum;
function $c677190d1ebb57e5$var$strEnum(o) {
    return o.reduce((res, key)=>{
        res[key] = key;
        return res;
    }, Object.create(null));
}

});


parcelRegister("amuTJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.DEFAULT = (0, $eG1Pq.css)`
  :root {
    --default-bg-color: transparent;
    --default-color: #222;
    --default-border: 1px solid #e5e5e5;
    --default-hover-color: transparent;
    --default-hover-border: 1px solid #999;
  }
`;

});

parcelRegister("kEETh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PRIMARY = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.PRIMARY = (0, $eG1Pq.css)`
  :root {
    --primary-bg-color: #1e87f0;
    --primary-color: #fff;
    --primary-border: 1px solid transparent;
    --primary-hover-color: #0f7ae5;
    --primary-active-color: #0e6dcd;
  }
`;

});

parcelRegister("4IHFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DANGER = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.DANGER = (0, $eG1Pq.css)`
  :root {
    --danger-bg-color: #f0506e;
    --danger-color: #fff;
    --danger-border: 1px solid transparent;
    --danger-hover-color: #ee395b;
    --danger-active-color: #ec2147;
  }
`;

});

parcelRegister("67wp6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SECONDARY = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.SECONDARY = (0, $eG1Pq.css)`
  :root {
    --secondary-bg-color: #222;
    --secondary-color: #fff;
    --secondary-border: 1px solid transparent;
    --secondary-hover-color: #333;
    --secondary-active-color: #000;
  }
`;

});

parcelRegister("a3mpd", function(module, exports) {
"use strict";
var $751b9081ffc1d648$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DynamicCssService = void 0;

var $4XQlz = parcelRequire("4XQlz");

var $1WKsL = parcelRequire("1WKsL");

var $3XkaH = parcelRequire("3XkaH");
var $bzMF7 = parcelRequire("bzMF7");
let $751b9081ffc1d648$var$DynamicCssService = class DynamicCssService {
    constructor(){
        this.palletes = $4XQlz.Container.get($1WKsL.Palettes);
    }
    changeStyle(palettes) {
        this.palletes.next(palettes);
    }
    OnInit() {
        this.palletes.subscribe((stream)=>{
            if (this.style) this.style.remove();
            this.style = document.createElement('style');
            this.style.innerHTML = Object.entries(stream).map(([key, css])=>` /* ${key} pallete */ ${css.cssText}`).join(' ');
            document.head.appendChild(this.style);
        });
    }
    getStyles() {
        return this.palletes.asObservable().pipe((0, $3XkaH.map)((res)=>Object.values(res)), (0, $3XkaH.map)((styles)=>styles.map((s)=>s.cssText)), (0, $bzMF7.shareReplay)({
            bufferSize: 1,
            refCount: true
        }));
    }
};
module.exports.DynamicCssService = $751b9081ffc1d648$var$DynamicCssService;
module.exports.DynamicCssService = $751b9081ffc1d648$var$DynamicCssService = $751b9081ffc1d648$var$__decorate([
    (0, $4XQlz.Injectable)({
        init: true
    })
], $751b9081ffc1d648$var$DynamicCssService); // import { Injectable, Inject, Container } from "@rxdi/core";
 // import { Palettes } from "@rxdi/ui-kit/settings";
 // import { BehaviorSubject } from "rxjs";
 // import { map, shareReplay } from "rxjs/operators";
 // import { css } from "@rxdi/lit-html";
 // @Injectable({ init: true })
 // export class DynamicCssService {
 //   private palletes: BehaviorSubject<Palettes>;
 //   private style: HTMLStyleElement;
 //   changeStyle(palettes: Palettes) {
 //     this.palletes.next(palettes);
 //   }
 //   OnInit() {
 //     this.palletes = Container.get<BehaviorSubject<Palettes>>(Palettes);
 //     const styleSheets = document.styleSheets[0] as CSSStyleSheet;
 //     this.palletes.subscribe(palettes => {
 //       this.addRules(styleSheets, palettes);
 //     });
 //     setTimeout(() => {
 //       this.addRules(styleSheets as CSSStyleSheet, {
 //         default: css`
 //           :root {
 //             --default-bg-color: transparent;
 //             --default-color: #222;
 //             --default-border-color: 1px solid #e5e5e5;
 //           }
 //         `,
 //         primary: css`
 //           :root {
 //             --primary-bg-color: #1e87f0;
 //             --primary-color: #fff;
 //             --primary-border-color: 1px solid transparent;
 //           }
 //         `,
 //         secondary: css`
 //           :root {
 //             --secondary-bg-color: #222;
 //             --secondary-color: #fff;
 //             --secondary-border-color: 1px solid transparent;
 //           }
 //         `
 //       })
 //       this.removeRules(styleSheets as CSSStyleSheet)
 //       this.removeRules(styleSheets as CSSStyleSheet)
 //       this.removeRules(styleSheets as CSSStyleSheet)
 //     }, 1000);
 //   }
 //   removeRules(styleSheets: CSSStyleSheet) {
 //     styleSheets.deleteRule(1)
 //   }
 //   addRules(styleSheets: CSSStyleSheet, palettes: Palettes) {
 //     styleSheets.insertRule(palettes.default.cssText, 0);
 //     styleSheets.insertRule(palettes.primary.cssText, 0);
 //     styleSheets.insertRule(palettes.secondary.cssText, 0);
 //   }
 //   getStyles() {
 //     return this.palletes.asObservable().pipe(
 //       map(res => Object.values(res)),
 //       map(styles => styles.map(s => s.cssText)),
 //       shareReplay({ bufferSize: 1, refCount: true })
 //     );
 //   }
 // }

});

parcelRegister("hegzL", function(module, exports) {
"use strict";
var $c8b09a19f50ebfef$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c8b09a19f50ebfef$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c8b09a19f50ebfef$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c8b09a19f50ebfef$var$__exportStar((parcelRequire("ao8k7")), module.exports);

$c8b09a19f50ebfef$var$__exportStar((parcelRequire("a3mpd")), module.exports);

});
parcelRegister("ao8k7", function(module, exports) {
"use strict";
var $79029a29a08393fa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $79029a29a08393fa$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResponsiveService = void 0;

var $4XQlz = parcelRequire("4XQlz");

var $jS6MW = parcelRequire("jS6MW");
var $jqXHu = parcelRequire("jqXHu");
var $8fifx = parcelRequire("8fifx");

var $fHjnr = parcelRequire("fHjnr");
var $9egfi = parcelRequire("9egfi");
var $3XkaH = parcelRequire("3XkaH");
let $79029a29a08393fa$var$ResponsiveService = class ResponsiveService {
    constructor(){
        this.width = new $jS6MW.BehaviorSubject(document.body.clientWidth);
        this.height = new $jS6MW.BehaviorSubject(document.body.clientHeight);
        this.scrollDebounceTime = 10;
        this.scrollSubscription = (0, $jqXHu.fromEvent)(window, 'scroll').pipe((0, $9egfi.debounceTime)(this.scrollDebounceTime));
        this.isPositionFixed = true;
        window.addEventListener('resize', ()=>this.setWindowSize());
    }
    setWindowSize() {
        this.height.next(document.body.clientHeight);
        this.width.next(document.body.clientWidth);
    }
    getBoth() {
        return {
            width: this.width.getValue(),
            height: this.height.getValue()
        };
    }
    combineBoth() {
        return (0, $8fifx.of)(this.getBoth()).pipe((0, $fHjnr.combineLatest)(this.height, this.width), (0, $3XkaH.map)(()=>this.getBoth()));
    }
};
module.exports.ResponsiveService = $79029a29a08393fa$var$ResponsiveService;
module.exports.ResponsiveService = $79029a29a08393fa$var$ResponsiveService = $79029a29a08393fa$var$__decorate([
    (0, $4XQlz.Injectable)({
        init: true
    }),
    $79029a29a08393fa$var$__metadata("design:paramtypes", [])
], $79029a29a08393fa$var$ResponsiveService);

});
parcelRegister("fHjnr", function(module, exports) {

$parcel$export(module.exports, "combineLatest", () => $b6d9e70c5c644c02$export$77fa7d86f5204e8a);

var $cAivK = parcelRequire("cAivK");

var $bj4Fa = parcelRequire("bj4Fa");

var $4J4s9 = parcelRequire("4J4s9");

var $1XQzS = parcelRequire("1XQzS");

var $d05JU = parcelRequire("d05JU");

var $4ArhZ = parcelRequire("4ArhZ");

var $3jBRy = parcelRequire("3jBRy");
function $b6d9e70c5c644c02$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = (0, $3jBRy.popResultSelector)(args);
    return resultSelector ? (0, $4ArhZ.pipe)($b6d9e70c5c644c02$export$77fa7d86f5204e8a.apply(void 0, (0, $cAivK.__spreadArray)([], (0, $cAivK.__read)(args))), (0, $d05JU.mapOneOrManyArgs)(resultSelector)) : (0, $4J4s9.operate)(function(source, subscriber) {
        (0, $bj4Fa.combineLatestInit)((0, $cAivK.__spreadArray)([
            source
        ], (0, $cAivK.__read)((0, $1XQzS.argsOrArgArray)(args))))(subscriber);
    });
}

});
parcelRegister("1XQzS", function(module, exports) {

$parcel$export(module.exports, "argsOrArgArray", () => $16e415f7fef186fd$export$24e1bb79414042be);
var $16e415f7fef186fd$var$isArray = Array.isArray;
function $16e415f7fef186fd$export$24e1bb79414042be(args) {
    return args.length === 1 && $16e415f7fef186fd$var$isArray(args[0]) ? args[0] : args;
}

});


parcelRegister("9egfi", function(module, exports) {

$parcel$export(module.exports, "debounceTime", () => $6b8205e9c8012782$export$7843a4469d64c07e);

var $knJUy = parcelRequire("knJUy");

var $4J4s9 = parcelRequire("4J4s9");

var $fyrlr = parcelRequire("fyrlr");
function $6b8205e9c8012782$export$7843a4469d64c07e(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, $knJUy.asyncScheduler);
    return (0, $4J4s9.operate)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}

});



parcelRegister("5Ur5L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WARNING = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.WARNING = (0, $eG1Pq.css)`
  :root {
    --warning-bg-color: #faa05a;
    --warning-color: #fff;
    --warning-border: 1px solid transparent;
    --warning-hover-color: #e19457;
    --warning-active-color: #ef9a56;
  }
`;

});

parcelRegister("dd9i7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ROOT = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.ROOT = (0, $eG1Pq.css)`
  :root {
    --bp-s: 640px;
    --bp-m: 960px;
    --bp-l: 1200px;
    --bp-xl: 1600px;
  }
`;

});

parcelRegister("dZ7sk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactiveElement = void 0;

var $eG1Pq = parcelRequire("eG1Pq");

var $jS6MW = parcelRequire("jS6MW");

var $3XkaH = parcelRequire("3XkaH");
class $a2e6c16e740c1dce$var$ReactiveElement extends $eG1Pq.LitElement {
    constructor(v){
        super();
        this.select = (mapFn)=>{
            return this.state.pipe((0, $3XkaH.map)(mapFn));
        };
        this.setState = (newState)=>{
            this.state.next(Object.assign(Object.assign({}, this.state.getValue()), newState));
        };
        this.getState = ()=>{
            return this.state.getValue();
        };
        this.state = new $jS6MW.BehaviorSubject(v || {});
    }
    get state$() {
        return this.state.asObservable();
    }
}
module.exports.ReactiveElement = $a2e6c16e740c1dce$var$ReactiveElement;

});


parcelRegister("d4xL1", function(module, exports) {
"use strict";
var $9845d596bb64261b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9845d596bb64261b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9845d596bb64261b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9845d596bb64261b$var$__exportStar((parcelRequire("87Ne1")), module.exports);

$9845d596bb64261b$var$__exportStar((parcelRequire("6wpHG")), module.exports);

});
parcelRegister("87Ne1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAIN_CSS = void 0;

var $eG1Pq = parcelRequire("eG1Pq");

var $amuTJ = parcelRequire("amuTJ");

var $1rC9i = parcelRequire("1rC9i");

var $31Zfw = parcelRequire("31Zfw");

var $4gOyo = parcelRequire("4gOyo");

var $3G5kF = parcelRequire("3G5kF");

var $kEETh = parcelRequire("kEETh");

var $67wp6 = parcelRequire("67wp6");
module.exports.MAIN_CSS = (0, $eG1Pq.css)`
  ${$1rC9i.FLEX}
  ${$3G5kF.SPACER}
  ${$31Zfw.POINTER}
  ${$4gOyo.CENTER}
  ${$amuTJ.DEFAULT}
  ${$kEETh.PRIMARY}
  ${$67wp6.SECONDARY}
`;

});
parcelRegister("1rC9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FLEX = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.FLEX = (0, $eG1Pq.css)`
  .flex {
    display: flex;
  }
`;

});

parcelRegister("31Zfw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.POINTER = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.POINTER = (0, $eG1Pq.css)`
  .pointer {
    cursor: pointer;
  }
`;

});

parcelRegister("4gOyo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CENTER = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.CENTER = (0, $eG1Pq.css)`
  .center {
    margin: 0 auto;
  }
`;

});

parcelRegister("3G5kF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SPACER = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.SPACER = (0, $eG1Pq.css)`
  .spacer {
    flex: 1 3 auto;
  }
`;

});


parcelRegister("6wpHG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TRANSITIONS = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.TRANSITIONS = (0, $eG1Pq.css)`
  /* ========================================================================
   Component: Transition
 ========================================================================== */
  /* Toggle (Hover + Focus)
 ========================================================================== */
  /*
 * 1. Prevent tab highlighting on iOS.
 */
  .transition-toggle {
    /* 1 */
    -webkit-tap-highlight-color: transparent;
  }

  .transition-toggle:focus {
    outline: none;
  }
  /* Transitions
 ========================================================================== */
  /*
 * The toggle is triggered on touch devices by two methods:
 * 1. Using :focus and tabindex
 * 2. Using :hover and a touchstart event listener registered on the document
 *    (Doesn't work on Surface touch devices)
 *
 * Note: Transitions don't work with postion-center-* classes because they also use transform,
 *       therefore it's recommended to use an extra div for the transition.
 */
  .transition-fade,
  [class*='transition-scale'],
  [class*='transition-slide'] {
    transition: 0.3s ease-out;
    transition-property: opacity, transform, filter;
    opacity: 0;
  }
  /*
 * Fade
 */
  .transition-toggle:hover .transition-fade,
  .transition-toggle:focus .transition-fade,
  .transition-active.active .transition-fade {
    opacity: 1;
  }
  /*
 * Scale
 */
  .transition-scale-up {
    transform: scale(1, 1);
  }
  .transition-scale-down {
    transform: scale(1.1, 1.1);
  }
  /* Show */
  .transition-toggle:hover .transition-scale-up,
  .transition-toggle:focus .transition-scale-up,
  .transition-active.active .transition-scale-up {
    opacity: 1;
    transform: scale(1.1, 1.1);
  }
  .transition-toggle:hover .transition-scale-down,
  .transition-toggle:focus .transition-scale-down,
  .transition-active.active .transition-scale-down {
    opacity: 1;
    transform: scale(1, 1);
  }
  /*
 * Slide
 */
  .transition-reset {
    transform: translateY(0) translateX(0);
  }
  .transition-slide-top {
    transform: translateY(-100%);
  }
  .transition-slide-bottom {
    transform: translateY(100%);
  }
  .transition-slide-left {
    transform: translateX(-100%);
  }
  .transition-slide-right {
    transform: translateX(100%);
  }
  .transition-slide-top-small {
    transform: translateY(-10px);
  }
  .transition-slide-bottom-small {
    transform: translateY(10px);
  }
  .transition-slide-left-small {
    transform: translateX(-10px);
  }
  .transition-slide-right-small {
    transform: translateX(10px);
  }
  .transition-slide-top-medium {
    transform: translateY(-50px);
  }
  .transition-slide-bottom-medium {
    transform: translateY(50px);
  }
  .transition-slide-left-medium {
    transform: translateX(-50px);
  }
  .transition-slide-right-medium {
    transform: translateX(50px);
  }
  /* Show */
  .transition-toggle:hover
    [class*='transition-slide']
    .transition-toggle:focus
    [class*='transition-slide'],
  .transition-active.active [class*='transition-slide'] {
    opacity: 1;
    transform: translate(0, 0);
  }
  /* Opacity modifier
 ========================================================================== */
  .transition-opaque {
    opacity: 1;
  }
  /* Duration modifiers
 ========================================================================== */
  .transition-slow {
    transition-duration: 0.7s;
  }
`;

});


parcelRegister("dueyX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Render = module.exports.State = module.exports.Providers = module.exports.Settings = module.exports.Monad = module.exports.Compose = module.exports.DefineDependencies = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
parcelRequire("i5Kt5");
const $9d195f8eed840c88$var$DefineDependencies = (...deps)=>(injection)=>{
        for (const [index, dep] of deps.entries())Object.defineProperty(deps, index, {
            get: ()=>injection && injection.has(dep) ? injection.get(dep) : dep
        });
        return deps;
    };
module.exports.DefineDependencies = $9d195f8eed840c88$var$DefineDependencies;
const $9d195f8eed840c88$var$Compose = (options)=>(deps = [])=>(state)=>(render)=>(0, $eG1Pq.Component)(Object.assign(Object.assign({}, options), {
                    template () {
                        return (0, $eG1Pq.html)`
    <rx-monad>
     <rx-state .value=${state.bind(this).call(this, deps)}></rx-state>
     <rx-render
      .state=${(state, setState, shadowRoot)=>{
                            this.shadowRoot.append(shadowRoot);
                            return render(deps).bind(this).call(this, state, setState, shadowRoot);
                        }}
     ></rx-render>
    </rx-monad>
   `;
                    }
                }));
module.exports.Compose = $9d195f8eed840c88$var$Compose;
const $9d195f8eed840c88$var$Monad = ([options, deps, state, render])=>(0, module.exports.Compose)(options)(deps)(state)(render);
module.exports.Monad = $9d195f8eed840c88$var$Monad;
const $9d195f8eed840c88$var$Settings = (o)=>o;
module.exports.Settings = $9d195f8eed840c88$var$Settings;
// export const λettings = (o: Options) => o;
const $9d195f8eed840c88$var$Providers = (o)=>o;
module.exports.Providers = $9d195f8eed840c88$var$Providers;
// export const ρroviders = <S, D, K>(o: D) => o;
const $9d195f8eed840c88$var$State = (o)=>o;
module.exports.State = $9d195f8eed840c88$var$State;
// export const ςtate = <S, D, K extends LitElement>(o: StateToRender<S, D, K>) => o;
const $9d195f8eed840c88$var$Render = (o)=>o;
module.exports.Render = $9d195f8eed840c88$var$Render; // export const πender = <S, D, K extends LitElement>(o: RenderResult<S, D, K>) => o;

});
parcelRegister("i5Kt5", function(module, exports) {
"use strict";
var $d2bcbd3aacf6215d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d2bcbd3aacf6215d$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $d2bcbd3aacf6215d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GraphComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");

const $d2bcbd3aacf6215d$var$graphql_tag_1 = $d2bcbd3aacf6215d$var$__importDefault((parcelRequire("grzLl")));

var $iHxiM = parcelRequire("iHxiM");

var $4XQlz = parcelRequire("4XQlz");

var $3abYj = parcelRequire("3abYj");
var $3XkaH = parcelRequire("3XkaH");
var $37rZb = parcelRequire("37rZb");

var $jS6MW = parcelRequire("jS6MW");
var $6s0Lm = parcelRequire("6s0Lm");
var $8fifx = parcelRequire("8fifx");
var $5rqBH = parcelRequire("5rqBH");

var $iJtLY = parcelRequire("iJtLY");
parcelRequire("5BC26");
parcelRequire("niAfA");
parcelRequire("b2mAJ");
parcelRequire("fHl3k");
parcelRequire("iL2mo");
parcelRequire("gtQax");
parcelRequire("6I4sE");
/**
 * @customElement rx-graph
 */ let $d2bcbd3aacf6215d$var$GraphComponent = class GraphComponent extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.options = {
            fetch: '',
            state: new $jS6MW.BehaviorSubject({}),
            render: (res)=>(0, $eG1Pq.html)` ${res} `,
            loading: ()=>(0, $eG1Pq.html)``,
            error: ()=>(0, $eG1Pq.html)``,
            style: (0, $eG1Pq.css)``,
            settings: {},
            defaultConfig: true
        };
        this.loading = true;
        this.error = '';
    }
    OnInit() {
        this.result = new $5rqBH.ReplaySubject();
    }
    OnUpdateFirst() {
        let task;
        if (this.options.state) {
            if ((0, $6s0Lm.isObservable)(this.options.state)) task = this.options.state;
            else this.result.next(this.options.state);
        } else try {
            task = this.query();
        } catch (e) {
            this.result.error(e);
            this.result.complete();
        }
        if (this.options.subscribe) this.pubsubSubscription = this.graphql.subscribe({
            query: (0, $d2bcbd3aacf6215d$var$graphql_tag_1.default)`
            ${this.options.subscribe}
          `
        }).subscribe((data)=>this.result.next(data), (e)=>this.result.error(e));
        if (!task) return;
        this.subscription = task.subscribe((detail)=>{
            this.result.next(detail);
            this.dispatchEvent(new CustomEvent('onData', {
                detail: detail
            }));
        }, (error)=>{
            if (error.networkError) error.message = `${JSON.stringify(error.networkError.result.errors)} ${error.message}`;
            this.result.error(error);
            this.dispatchEvent(new CustomEvent('onError', {
                detail: error
            }));
        });
    // const monad = this.getRootNode().host.getRootNode();
    // monad.append(this.shadowRoot)
    // const monad = this.getRootNode().host;
    // if (monad.parentElement) {
    //     monad.parentElement.prepend(this.shadowRoot)
    // }
    }
    OnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
        if (this.pubsubSubscription) this.pubsubSubscription.unsubscribe();
        this.result.complete();
    }
    query() {
        let fetch = this.options.fetch;
        this.options.settings = this.options.settings || {};
        this.options.fetch = this.options.fetch || '';
        if (this.options.fetch.loc && this.options.fetch.loc.source) fetch = this.options.fetch.loc.source.body;
        if (typeof fetch === 'string' && fetch.includes('mutation')) {
            this.options.settings.mutation = (0, $d2bcbd3aacf6215d$var$graphql_tag_1.default)`
        ${fetch}
      `;
            return this.graphql.mutate(this.options.settings);
        }
        this.options.settings.query = typeof fetch !== 'string' ? fetch : (0, $d2bcbd3aacf6215d$var$graphql_tag_1.default)`
            ${fetch}
          `;
        if (typeof fetch === 'string' && fetch.includes('subscription')) return this.graphql.subscribe(this.options.settings);
        return this.graphql.query(this.options.settings);
    }
    isPrimitive(test) {
        return test !== Object(test);
    }
};
module.exports.GraphComponent = $d2bcbd3aacf6215d$var$GraphComponent;
$d2bcbd3aacf6215d$var$__decorate([
    (0, $eG1Pq.property)({
        type: Object
    }),
    $d2bcbd3aacf6215d$var$__metadata("design:type", Object)
], $d2bcbd3aacf6215d$var$GraphComponent.prototype, "options", void 0);
$d2bcbd3aacf6215d$var$__decorate([
    (0, $4XQlz.Inject)($iHxiM.BaseService),
    $d2bcbd3aacf6215d$var$__metadata("design:type", $iHxiM.BaseService)
], $d2bcbd3aacf6215d$var$GraphComponent.prototype, "graphql", void 0);
$d2bcbd3aacf6215d$var$__decorate([
    (0, $eG1Pq.property)({
        type: Boolean
    }),
    $d2bcbd3aacf6215d$var$__metadata("design:type", Object)
], $d2bcbd3aacf6215d$var$GraphComponent.prototype, "loading", void 0);
$d2bcbd3aacf6215d$var$__decorate([
    (0, $eG1Pq.property)({
        type: String
    }),
    $d2bcbd3aacf6215d$var$__metadata("design:type", Object)
], $d2bcbd3aacf6215d$var$GraphComponent.prototype, "error", void 0);
module.exports.GraphComponent = $d2bcbd3aacf6215d$var$GraphComponent = $d2bcbd3aacf6215d$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-graph',
        template () {
            var _a;
            return (0, $eG1Pq.html)`
      <style>
        ${(_a = this.options) === null || _a === void 0 ? void 0 : _a.style}
      </style>
      ${(0, $eG1Pq.async)(this.result.pipe((0, $3XkaH.map)((state)=>{
                return this.options.render ? this.options.render(state, (data)=>this.result.next(data), this.shadowRoot) : state;
            }), (0, $37rZb.tap)(()=>this.loading = false), (0, $3abYj.catchError)((e)=>{
                this.error = e;
                this.loading = false;
                return (0, $8fifx.of)('');
            })))}
      ${this.loading ? (0, $eG1Pq.html)`
            ${typeof this.options.loading === 'function' ? this.options.loading() : $4XQlz.Container.get($iJtLY.DEFAULTS).loading()}
          ` : ''}
      ${this.error ? (0, $eG1Pq.html)`
            ${typeof this.options.error === 'function' ? this.options.error(this.error) : $4XQlz.Container.get($iJtLY.DEFAULTS).error(this.error)}
          ` : ''}
      <slot></slot>
    `;
        }
    })
], $d2bcbd3aacf6215d$var$GraphComponent);

});
parcelRegister("grzLl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "gql", () => $bf8ae8a69aa99976$export$72e4926bf8358653);
$parcel$export(module.exports, "resetCaches", () => $bf8ae8a69aa99976$export$657554ef4dc7ac2d);
$parcel$export(module.exports, "disableFragmentWarnings", () => $bf8ae8a69aa99976$export$e4294e638636c6ab);
$parcel$export(module.exports, "enableExperimentalFragmentVariables", () => $bf8ae8a69aa99976$export$78cf889af350c840);
$parcel$export(module.exports, "disableExperimentalFragmentVariables", () => $bf8ae8a69aa99976$export$5290df9bbbd3cfa);
$parcel$export(module.exports, "default", () => $bf8ae8a69aa99976$export$2e2bcd8739ae039);

var $32BZc = parcelRequire("32BZc");

var $860MP = parcelRequire("860MP");
var $bf8ae8a69aa99976$var$docCache = new Map();
var $bf8ae8a69aa99976$var$fragmentSourceMap = new Map();
var $bf8ae8a69aa99976$var$printFragmentWarnings = true;
var $bf8ae8a69aa99976$var$experimentalFragmentVariables = false;
function $bf8ae8a69aa99976$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $bf8ae8a69aa99976$var$cacheKeyFromLoc(loc) {
    return $bf8ae8a69aa99976$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $bf8ae8a69aa99976$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $bf8ae8a69aa99976$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $bf8ae8a69aa99976$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($bf8ae8a69aa99976$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $bf8ae8a69aa99976$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $32BZc.__assign)((0, $32BZc.__assign)({}, ast), {
        definitions: definitions
    });
}
function $bf8ae8a69aa99976$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $bf8ae8a69aa99976$var$parseDocument(source) {
    var cacheKey = $bf8ae8a69aa99976$var$normalize(source);
    if (!$bf8ae8a69aa99976$var$docCache.has(cacheKey)) {
        var parsed = (0, $860MP.parse)(source, {
            experimentalFragmentVariables: $bf8ae8a69aa99976$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $bf8ae8a69aa99976$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $bf8ae8a69aa99976$var$docCache.set(cacheKey, $bf8ae8a69aa99976$var$stripLoc($bf8ae8a69aa99976$var$processFragments(parsed)));
    }
    return $bf8ae8a69aa99976$var$docCache.get(cacheKey);
}
function $bf8ae8a69aa99976$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $bf8ae8a69aa99976$var$parseDocument(result);
}
function $bf8ae8a69aa99976$export$657554ef4dc7ac2d() {
    $bf8ae8a69aa99976$var$docCache.clear();
    $bf8ae8a69aa99976$var$fragmentSourceMap.clear();
}
function $bf8ae8a69aa99976$export$e4294e638636c6ab() {
    $bf8ae8a69aa99976$var$printFragmentWarnings = false;
}
function $bf8ae8a69aa99976$export$78cf889af350c840() {
    $bf8ae8a69aa99976$var$experimentalFragmentVariables = true;
}
function $bf8ae8a69aa99976$export$5290df9bbbd3cfa() {
    $bf8ae8a69aa99976$var$experimentalFragmentVariables = false;
}
var $bf8ae8a69aa99976$var$extras = {
    gql: $bf8ae8a69aa99976$export$72e4926bf8358653,
    resetCaches: $bf8ae8a69aa99976$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $bf8ae8a69aa99976$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $bf8ae8a69aa99976$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $bf8ae8a69aa99976$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $bf8ae8a69aa99976$var$extras.gql, gql_1.resetCaches = $bf8ae8a69aa99976$var$extras.resetCaches, gql_1.disableFragmentWarnings = $bf8ae8a69aa99976$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $bf8ae8a69aa99976$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $bf8ae8a69aa99976$var$extras.disableExperimentalFragmentVariables;
})($bf8ae8a69aa99976$export$72e4926bf8358653 || ($bf8ae8a69aa99976$export$72e4926bf8358653 = {}));
$bf8ae8a69aa99976$export$72e4926bf8358653["default"] = $bf8ae8a69aa99976$export$72e4926bf8358653;
var $bf8ae8a69aa99976$export$2e2bcd8739ae039 = $bf8ae8a69aa99976$export$72e4926bf8358653;

});
parcelRegister("32BZc", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $236f063cea62d534$export$18ce0697a983be9b);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $236f063cea62d534$var$extendStatics = function(d, b) {
    $236f063cea62d534$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $236f063cea62d534$var$extendStatics(d, b);
};
function $236f063cea62d534$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $236f063cea62d534$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $236f063cea62d534$export$18ce0697a983be9b = function() {
    $236f063cea62d534$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $236f063cea62d534$export$18ce0697a983be9b.apply(this, arguments);
};
function $236f063cea62d534$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $236f063cea62d534$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $236f063cea62d534$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $236f063cea62d534$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $236f063cea62d534$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $236f063cea62d534$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $236f063cea62d534$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $236f063cea62d534$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $236f063cea62d534$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $236f063cea62d534$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $236f063cea62d534$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $236f063cea62d534$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $236f063cea62d534$export$45d3717a4c69092e(o, m, p);
}
function $236f063cea62d534$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $236f063cea62d534$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $236f063cea62d534$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($236f063cea62d534$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $236f063cea62d534$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $236f063cea62d534$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $236f063cea62d534$export$10c90e4f7922046c(v) {
    return this instanceof $236f063cea62d534$export$10c90e4f7922046c ? (this.v = v, this) : new $236f063cea62d534$export$10c90e4f7922046c(v);
}
function $236f063cea62d534$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $236f063cea62d534$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $236f063cea62d534$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $236f063cea62d534$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $236f063cea62d534$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $236f063cea62d534$export$19a8beecd37a4c45 === "function" ? $236f063cea62d534$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $236f063cea62d534$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $236f063cea62d534$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $236f063cea62d534$var$ownKeys = function(o) {
    $236f063cea62d534$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $236f063cea62d534$var$ownKeys(o);
};
function $236f063cea62d534$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $236f063cea62d534$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $236f063cea62d534$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $236f063cea62d534$var$__setModuleDefault(result, mod);
    return result;
}
function $236f063cea62d534$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $236f063cea62d534$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $236f063cea62d534$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $236f063cea62d534$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $236f063cea62d534$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $236f063cea62d534$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $236f063cea62d534$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $236f063cea62d534$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $236f063cea62d534$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $236f063cea62d534$export$2e2bcd8739ae039 = {
    __extends: $236f063cea62d534$export$a8ba968b8961cb8a,
    __assign: $236f063cea62d534$export$18ce0697a983be9b,
    __rest: $236f063cea62d534$export$3c9a16f847548506,
    __decorate: $236f063cea62d534$export$29e00dfd3077644b,
    __param: $236f063cea62d534$export$d5ad3fd78186038f,
    __esDecorate: $236f063cea62d534$export$3a84e1ae4e97e9b0,
    __runInitializers: $236f063cea62d534$export$d831c04e792af3d,
    __propKey: $236f063cea62d534$export$6a2a36740a146cb8,
    __setFunctionName: $236f063cea62d534$export$d1a06452d3489bc7,
    __metadata: $236f063cea62d534$export$f1db080c865becb9,
    __awaiter: $236f063cea62d534$export$1050f835b63b671e,
    __generator: $236f063cea62d534$export$67ebef60e6f28a6,
    __createBinding: $236f063cea62d534$export$45d3717a4c69092e,
    __exportStar: $236f063cea62d534$export$f33643c0debef087,
    __values: $236f063cea62d534$export$19a8beecd37a4c45,
    __read: $236f063cea62d534$export$8d051b38c9118094,
    __spread: $236f063cea62d534$export$afc72e2116322959,
    __spreadArrays: $236f063cea62d534$export$6388937ca91ccae8,
    __spreadArray: $236f063cea62d534$export$1216008129fb82ed,
    __await: $236f063cea62d534$export$10c90e4f7922046c,
    __asyncGenerator: $236f063cea62d534$export$e427f37a30a4de9b,
    __asyncDelegator: $236f063cea62d534$export$bbd80228419bb833,
    __asyncValues: $236f063cea62d534$export$e3b29a3d6162315f,
    __makeTemplateObject: $236f063cea62d534$export$4fb47efe1390b86f,
    __importStar: $236f063cea62d534$export$c21735bcef00d192,
    __importDefault: $236f063cea62d534$export$da59b14a69baef04,
    __classPrivateFieldGet: $236f063cea62d534$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $236f063cea62d534$export$d40a35129aaff81f,
    __classPrivateFieldIn: $236f063cea62d534$export$81fdc39f203e4e04,
    __addDisposableResource: $236f063cea62d534$export$88ac25d8e944e405,
    __disposeResources: $236f063cea62d534$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $236f063cea62d534$export$889dfb5d17574b0b
};

});

parcelRegister("860MP", function(module, exports) {

$parcel$export(module.exports, "parse", () => $5d50d097c01caf2e$export$98e6a39c04603d36);

var $bt9hf = parcelRequire("bt9hf");

var $gNvmC = parcelRequire("gNvmC");

var $dytfV = parcelRequire("dytfV");

var $7NVBI = parcelRequire("7NVBI");

var $9f2JI = parcelRequire("9f2JI");

var $10BJS = parcelRequire("10BJS");

var $6qwSL = parcelRequire("6qwSL");

var $7cP7m = parcelRequire("7cP7m");

var $h6aNg = parcelRequire("h6aNg");
function $5d50d097c01caf2e$export$98e6a39c04603d36(source, options) {
    var parser = new $5d50d097c01caf2e$var$Parser(source, options);
    return parser.parseDocument();
}
function $5d50d097c01caf2e$export$5303528d1070ff6f(source, options) {
    var parser = new $5d50d097c01caf2e$var$Parser(source, options);
    parser.expectToken((0, $h6aNg.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $h6aNg.TokenKind).EOF);
    return value;
}
function $5d50d097c01caf2e$export$28b8f402ccc88182(source, options) {
    var parser = new $5d50d097c01caf2e$var$Parser(source, options);
    parser.expectToken((0, $h6aNg.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $h6aNg.TokenKind).EOF);
    return type;
}
var $5d50d097c01caf2e$var$Parser = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = typeof source === 'string' ? new (0, $10BJS.Source)(source) : source;
        sourceObj instanceof (0, $10BJS.Source) || (0, $gNvmC.default)(0, "Must provide Source. Received: ".concat((0, $bt9hf.default)(sourceObj)));
        this._lexer = (0, $6qwSL.createLexer)(sourceObj);
        this._options = options || {};
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $h6aNg.TokenKind).NAME);
        return {
            kind: (0, $9f2JI.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
    ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $9f2JI.Kind).DOCUMENT,
            definitions: this.many((0, $h6aNg.TokenKind).SOF, this.parseDefinition, (0, $h6aNg.TokenKind).EOF),
            loc: this.loc(start)
        };
    };
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $h6aNg.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $h6aNg.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
    ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $h6aNg.TokenKind).BRACE_L)) return {
            kind: (0, $9f2JI.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $h6aNg.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $9f2JI.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $h6aNg.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    };
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $h6aNg.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $h6aNg.TokenKind).PAREN_R);
    };
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $9f2JI.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $h6aNg.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $h6aNg.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    };
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $h6aNg.TokenKind).DOLLAR);
        return {
            kind: (0, $9f2JI.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    };
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $9f2JI.Kind).SELECTION_SET,
            selections: this.many((0, $h6aNg.TokenKind).BRACE_L, this.parseSelection, (0, $h6aNg.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $h6aNg.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    };
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $h6aNg.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $9f2JI.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $h6aNg.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    };
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $h6aNg.TokenKind).PAREN_L, item, (0, $h6aNg.TokenKind).PAREN_R);
    };
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $h6aNg.TokenKind).COLON);
        return {
            kind: (0, $9f2JI.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $9f2JI.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $h6aNg.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
    ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $h6aNg.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $h6aNg.TokenKind).NAME)) return {
            kind: (0, $9f2JI.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $9f2JI.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.experimentalFragmentVariables) return {
            kind: (0, $9f2JI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $9f2JI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
    ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $h6aNg.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $h6aNg.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $h6aNg.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $9f2JI.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $h6aNg.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $9f2JI.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $h6aNg.TokenKind).STRING:
            case (0, $h6aNg.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $h6aNg.TokenKind).NAME:
                if (token.value === 'true' || token.value === 'false') {
                    this._lexer.advance();
                    return {
                        kind: (0, $9f2JI.Kind).BOOLEAN,
                        value: token.value === 'true',
                        loc: this.loc(token)
                    };
                } else if (token.value === 'null') {
                    this._lexer.advance();
                    return {
                        kind: (0, $9f2JI.Kind).NULL,
                        loc: this.loc(token)
                    };
                }
                this._lexer.advance();
                return {
                    kind: (0, $9f2JI.Kind).ENUM,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $h6aNg.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $9f2JI.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $h6aNg.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    };
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $9f2JI.Kind).LIST,
            values: this.any((0, $h6aNg.TokenKind).BRACKET_L, item, (0, $h6aNg.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $9f2JI.Kind).OBJECT,
            fields: this.any((0, $h6aNg.TokenKind).BRACE_L, item, (0, $h6aNg.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $h6aNg.TokenKind).COLON);
        return {
            kind: (0, $9f2JI.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
    ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $h6aNg.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    };
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $h6aNg.TokenKind).AT);
        return {
            kind: (0, $9f2JI.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
    ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $h6aNg.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $h6aNg.TokenKind).BRACKET_R);
            type = {
                kind: (0, $9f2JI.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $h6aNg.TokenKind).BANG)) return {
            kind: (0, $9f2JI.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    };
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $9f2JI.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
    ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $h6aNg.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $h6aNg.TokenKind).STRING) || this.peek((0, $h6aNg.TokenKind).BLOCK_STRING);
    };
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    };
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $h6aNg.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $h6aNg.TokenKind).BRACE_R);
        return {
            kind: (0, $9f2JI.Kind).SCHEMA_DEFINITION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $h6aNg.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $9f2JI.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $9f2JI.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $9f2JI.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var types = [];
        if (this.expectOptionalKeyword('implements')) {
            // Optional leading ampersand
            this.expectOptionalToken((0, $h6aNg.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $h6aNg.TokenKind).AMP) || // Legacy support for the SDL?
            this._options.allowLegacySDLImplementsInterfaces && this.peek((0, $h6aNg.TokenKind).NAME));
        }
        return types;
    };
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        // Legacy support for the SDL?
        if (this._options.allowLegacySDLEmptyFields && this.peek((0, $h6aNg.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $h6aNg.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $h6aNg.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $h6aNg.TokenKind).BRACE_R);
    };
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $h6aNg.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $9f2JI.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $h6aNg.TokenKind).PAREN_L, this.parseInputValueDef, (0, $h6aNg.TokenKind).PAREN_R);
    };
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $h6aNg.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $h6aNg.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $9f2JI.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $9f2JI.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $9f2JI.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        var types = [];
        if (this.expectOptionalToken((0, $h6aNg.TokenKind).EQUALS)) {
            // Optional leading pipe
            this.expectOptionalToken((0, $h6aNg.TokenKind).PIPE);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $h6aNg.TokenKind).PIPE));
        }
        return types;
    };
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $9f2JI.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $h6aNg.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $h6aNg.TokenKind).BRACE_R);
    };
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $9f2JI.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $9f2JI.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $h6aNg.TokenKind).BRACE_L, this.parseInputValueDef, (0, $h6aNg.TokenKind).BRACE_R);
    };
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $h6aNg.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $h6aNg.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $h6aNg.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $9f2JI.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $9f2JI.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $9f2JI.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $9f2JI.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $9f2JI.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $9f2JI.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $9f2JI.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $h6aNg.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $9f2JI.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        // Optional leading pipe
        this.expectOptionalToken((0, $h6aNg.TokenKind).PIPE);
        var locations = [];
        do locations.push(this.parseDirectiveLocation());
        while (this.expectOptionalToken((0, $h6aNg.TokenKind).PIPE));
        return locations;
    };
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $7cP7m.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
    ;
    _proto.loc = function loc(startToken) {
        if (!this._options.noLocation) return new $5d50d097c01caf2e$var$Loc(startToken, this._lexer.lastToken, this._lexer.source);
    };
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    };
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $7NVBI.syntaxError)(this._lexer.source, token.start, "Expected ".concat(kind, ", found ").concat($5d50d097c01caf2e$var$getTokenDesc(token)));
    };
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    };
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $h6aNg.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $7NVBI.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($5d50d097c01caf2e$var$getTokenDesc(token)));
    };
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $h6aNg.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    };
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken || this._lexer.token;
        return (0, $7NVBI.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($5d50d097c01caf2e$var$getTokenDesc(token)));
    };
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    };
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    };
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    return Parser;
}();
function $5d50d097c01caf2e$var$Loc(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.
(0, $dytfV.default)($5d50d097c01caf2e$var$Loc, function() {
    return {
        start: this.start,
        end: this.end
    };
});
/**
 * A helper function to describe a token as a string for debugging
 */ function $5d50d097c01caf2e$var$getTokenDesc(token) {
    var value = token.value;
    return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
}

});
parcelRegister("bt9hf", function(module, exports) {

$parcel$export(module.exports, "default", () => $89206695f3f85e73$export$2e2bcd8739ae039);

var $eJIv1 = parcelRequire("eJIv1");
function $89206695f3f85e73$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $89206695f3f85e73$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $89206695f3f85e73$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $89206695f3f85e73$var$_typeof(obj);
}
var $89206695f3f85e73$var$MAX_ARRAY_LENGTH = 10;
var $89206695f3f85e73$var$MAX_RECURSIVE_DEPTH = 2;
function $89206695f3f85e73$export$2e2bcd8739ae039(value) {
    return $89206695f3f85e73$var$formatValue(value, []);
}
function $89206695f3f85e73$var$formatValue(value, seenValues) {
    switch($89206695f3f85e73$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $89206695f3f85e73$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $89206695f3f85e73$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $89206695f3f85e73$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        // $FlowFixMe(>=0.90.0)
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $89206695f3f85e73$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $89206695f3f85e73$var$formatArray(value, seenValues);
    return $89206695f3f85e73$var$formatObject(value, seenValues);
}
function $89206695f3f85e73$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $89206695f3f85e73$var$MAX_RECURSIVE_DEPTH) return '[' + $89206695f3f85e73$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $89206695f3f85e73$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $89206695f3f85e73$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $89206695f3f85e73$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($89206695f3f85e73$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($89206695f3f85e73$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $89206695f3f85e73$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $eJIv1.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $89206695f3f85e73$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("eJIv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e7f62e76d343739$export$2e2bcd8739ae039);
var $3e7f62e76d343739$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $3e7f62e76d343739$export$2e2bcd8739ae039 = $3e7f62e76d343739$var$nodejsCustomInspectSymbol;

});


parcelRegister("gNvmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbefa92173d6471a$export$2e2bcd8739ae039);
function $fbefa92173d6471a$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("dytfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a1b16e8cb1b2486$export$2e2bcd8739ae039);

var $eJIv1 = parcelRequire("eJIv1");
function $7a1b16e8cb1b2486$export$2e2bcd8739ae039(classObject) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : classObject.prototype.toString;
    classObject.prototype.toJSON = fn;
    classObject.prototype.inspect = fn;
    if (0, $eJIv1.default) classObject.prototype[0, $eJIv1.default] = fn;
}

});

parcelRegister("7NVBI", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $209c8ec21f947afe$export$bbee0c6176c019d4);

var $eq1cf = parcelRequire("eq1cf");
function $209c8ec21f947afe$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $eq1cf.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("eq1cf", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $09a590491f6a6a18$export$92d6ed0888e7cb7f);

var $lEqWR = parcelRequire("lEqWR");

var $90O4P = parcelRequire("90O4P");

var $dV6jd = parcelRequire("dV6jd");
function $09a590491f6a6a18$export$92d6ed0888e7cb7f(message, nodes, source, positions, path, originalError, extensions) {
    // Compute list of blame nodes.
    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
        nodes
    ] : undefined; // Compute locations in the source for the given nodes/positions.
    var _source = source;
    if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
    }
    var _positions = positions;
    if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
        if (node.loc) list.push(node.loc.start);
        return list;
    }, []);
    if (_positions && _positions.length === 0) _positions = undefined;
    var _locations;
    if (positions && source) _locations = positions.map(function(pos) {
        return (0, $90O4P.getLocation)(source, pos);
    });
    else if (_nodes) _locations = _nodes.reduce(function(list, node) {
        if (node.loc) list.push((0, $90O4P.getLocation)(node.loc.source, node.loc.start));
        return list;
    }, []);
    var _extensions = extensions;
    if (_extensions == null && originalError != null) {
        var originalExtensions = originalError.extensions;
        if ((0, $lEqWR.default)(originalExtensions)) _extensions = originalExtensions;
    }
    Object.defineProperties(this, {
        message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
        },
        locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_locations)
        },
        path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(path)
        },
        nodes: {
            value: _nodes || undefined
        },
        source: {
            value: _source || undefined
        },
        positions: {
            value: _positions || undefined
        },
        originalError: {
            value: originalError
        },
        extensions: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _extensions || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_extensions)
        }
    }); // Include (non-enumerable) stack trace.
    if (originalError && originalError.stack) Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
    });
    else if (Error.captureStackTrace) Error.captureStackTrace(this, $09a590491f6a6a18$export$92d6ed0888e7cb7f);
    else Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
    });
}
$09a590491f6a6a18$export$92d6ed0888e7cb7f.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $09a590491f6a6a18$export$92d6ed0888e7cb7f
    },
    name: {
        value: 'GraphQLError'
    },
    toString: {
        value: function toString() {
            return $09a590491f6a6a18$export$55ee1551a3f962e6(this);
        }
    }
});
function $09a590491f6a6a18$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++){
        var node = _error$nodes2[_i2];
        if (node.loc) output += '\n\n' + (0, $dV6jd.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++){
        var location = _error$locations2[_i4];
        output += '\n\n' + (0, $dV6jd.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("lEqWR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cae5a15be0f07d2$export$2e2bcd8739ae039);
function $9cae5a15be0f07d2$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9cae5a15be0f07d2$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9cae5a15be0f07d2$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9cae5a15be0f07d2$var$_typeof(obj);
}
function $9cae5a15be0f07d2$export$2e2bcd8739ae039(value) {
    return $9cae5a15be0f07d2$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("90O4P", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $443066c6e56cfada$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $443066c6e56cfada$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("dV6jd", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $d9f0099fa68949e5$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $d9f0099fa68949e5$export$867940333fd9f869);

var $90O4P = parcelRequire("90O4P");
function $d9f0099fa68949e5$export$96a9681e539deed(location) {
    return $d9f0099fa68949e5$export$867940333fd9f869(location.source, (0, $90O4P.getLocation)(location.source, location.start));
}
function $d9f0099fa68949e5$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $d9f0099fa68949e5$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var sublineIndex = Math.floor(columnNum / 80);
        var sublineColumnNum = columnNum % 80;
        var sublines = [];
        for(var i = 0; i < locationLine.length; i += 80)sublines.push(locationLine.slice(i, i + 80));
        return locationStr + $d9f0099fa68949e5$var$printPrefixedLines([
            [
                "".concat(lineNum),
                sublines[0]
            ]
        ].concat(sublines.slice(1, sublineIndex + 1).map(function(subline) {
            return [
                '',
                subline
            ];
        }), [
            [
                ' ',
                $d9f0099fa68949e5$var$whitespace(sublineColumnNum - 1) + '^'
            ],
            [
                '',
                sublines[sublineIndex + 1]
            ]
        ]));
    }
    return locationStr + $d9f0099fa68949e5$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $d9f0099fa68949e5$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $d9f0099fa68949e5$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $d9f0099fa68949e5$var$lpad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $d9f0099fa68949e5$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $d9f0099fa68949e5$var$lpad(len, str) {
    return $d9f0099fa68949e5$var$whitespace(len - str.length) + str;
}

});



parcelRegister("9f2JI", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $9b843c1de83d74b3$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $9b843c1de83d74b3$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("10BJS", function(module, exports) {

$parcel$export(module.exports, "Source", () => $0e72a9eedb613c01$export$1d2df86270c81ecb);

var $gNvmC = parcelRequire("gNvmC");

var $lbdGl = parcelRequire("lbdGl");
var $0e72a9eedb613c01$export$1d2df86270c81ecb = function Source(body, name, locationOffset) {
    this.body = body;
    this.name = name || 'GraphQL request';
    this.locationOffset = locationOffset || {
        line: 1,
        column: 1
    };
    this.locationOffset.line > 0 || (0, $gNvmC.default)(0, 'line in locationOffset is 1-indexed and must be positive');
    this.locationOffset.column > 0 || (0, $gNvmC.default)(0, 'column in locationOffset is 1-indexed and must be positive');
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
(0, $lbdGl.default)($0e72a9eedb613c01$export$1d2df86270c81ecb);

});
parcelRegister("lbdGl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57462278e8c8ab7$export$2e2bcd8739ae039);
/**
 * The `defineToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method defineToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */ function $f57462278e8c8ab7$export$2e2bcd8739ae039(classObject) {
    if (typeof Symbol === 'function' && Symbol.toStringTag) Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
        get: function get() {
            return this.constructor.name;
        }
    });
}

});


parcelRegister("6qwSL", function(module, exports) {

$parcel$export(module.exports, "createLexer", () => $bf045906a0e003d2$export$542413421c3f8a82);

var $dytfV = parcelRequire("dytfV");

var $7NVBI = parcelRequire("7NVBI");

var $01vnQ = parcelRequire("01vnQ");

var $h6aNg = parcelRequire("h6aNg");
function $bf045906a0e003d2$export$542413421c3f8a82(source, options) {
    var startOfFileToken = new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).SOF, 0, 0, 0, 0, null);
    var lexer = {
        source: source,
        options: options,
        lastToken: startOfFileToken,
        token: startOfFileToken,
        line: 1,
        lineStart: 0,
        advance: $bf045906a0e003d2$var$advanceLexer,
        lookahead: $bf045906a0e003d2$var$lookahead
    };
    return lexer;
}
function $bf045906a0e003d2$var$advanceLexer() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
}
function $bf045906a0e003d2$var$lookahead() {
    var token = this.token;
    if (token.kind !== (0, $h6aNg.TokenKind).EOF) do // Note: next is only mutable during parsing, so we cast to allow this.
    token = token.next || (token.next = $bf045906a0e003d2$var$readToken(this, token));
    while (token.kind === (0, $h6aNg.TokenKind).COMMENT);
    return token;
}
function $bf045906a0e003d2$export$aebcc098ae68f143(token) {
    var kind = token.kind;
    return kind === (0, $h6aNg.TokenKind).BANG || kind === (0, $h6aNg.TokenKind).DOLLAR || kind === (0, $h6aNg.TokenKind).AMP || kind === (0, $h6aNg.TokenKind).PAREN_L || kind === (0, $h6aNg.TokenKind).PAREN_R || kind === (0, $h6aNg.TokenKind).SPREAD || kind === (0, $h6aNg.TokenKind).COLON || kind === (0, $h6aNg.TokenKind).EQUALS || kind === (0, $h6aNg.TokenKind).AT || kind === (0, $h6aNg.TokenKind).BRACKET_L || kind === (0, $h6aNg.TokenKind).BRACKET_R || kind === (0, $h6aNg.TokenKind).BRACE_L || kind === (0, $h6aNg.TokenKind).PIPE || kind === (0, $h6aNg.TokenKind).BRACE_R;
}
/**
 * Helper function for constructing the Token object.
 */ function $bf045906a0e003d2$var$Tok(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.
(0, $dytfV.default)($bf045906a0e003d2$var$Tok, function() {
    return {
        kind: this.kind,
        value: this.value,
        line: this.line,
        column: this.column
    };
});
function $bf045906a0e003d2$var$printCharCode(code) {
    return isNaN(code) ? (0, $h6aNg.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $bf045906a0e003d2$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = $bf045906a0e003d2$var$positionAfterWhitespace(body, prev.end, lexer);
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    if (pos >= bodyLength) return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
    var code = body.charCodeAt(pos); // SourceCharacter
    switch(code){
        // !
        case 33:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).BANG, pos, pos + 1, line, col, prev);
        // #
        case 35:
            return $bf045906a0e003d2$var$readComment(source, pos, line, col, prev);
        // $
        case 36:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).DOLLAR, pos, pos + 1, line, col, prev);
        // &
        case 38:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).AMP, pos, pos + 1, line, col, prev);
        // (
        case 40:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).PAREN_L, pos, pos + 1, line, col, prev);
        // )
        case 41:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).PAREN_R, pos, pos + 1, line, col, prev);
        // .
        case 46:
            if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).SPREAD, pos, pos + 3, line, col, prev);
            break;
        // :
        case 58:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).COLON, pos, pos + 1, line, col, prev);
        // =
        case 61:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).EQUALS, pos, pos + 1, line, col, prev);
        // @
        case 64:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).AT, pos, pos + 1, line, col, prev);
        // [
        case 91:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).BRACKET_L, pos, pos + 1, line, col, prev);
        // ]
        case 93:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).BRACKET_R, pos, pos + 1, line, col, prev);
        // {
        case 123:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).BRACE_L, pos, pos + 1, line, col, prev);
        // |
        case 124:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).PIPE, pos, pos + 1, line, col, prev);
        // }
        case 125:
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).BRACE_R, pos, pos + 1, line, col, prev);
        // A-Z _ a-z
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
        case 71:
        case 72:
        case 73:
        case 74:
        case 75:
        case 76:
        case 77:
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 89:
        case 90:
        case 95:
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
        case 109:
        case 110:
        case 111:
        case 112:
        case 113:
        case 114:
        case 115:
        case 116:
        case 117:
        case 118:
        case 119:
        case 120:
        case 121:
        case 122:
            return $bf045906a0e003d2$var$readName(source, pos, line, col, prev);
        // - 0-9
        case 45:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return $bf045906a0e003d2$var$readNumber(source, pos, code, line, col, prev);
        // "
        case 34:
            if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $bf045906a0e003d2$var$readBlockString(source, pos, line, col, prev, lexer);
            return $bf045906a0e003d2$var$readString(source, pos, line, col, prev);
    }
    throw (0, $7NVBI.syntaxError)(source, pos, $bf045906a0e003d2$var$unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $bf045906a0e003d2$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($bf045906a0e003d2$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($bf045906a0e003d2$var$printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * character, then returns the position of that character for lexing.
 */ function $bf045906a0e003d2$var$positionAfterWhitespace(body, startPosition, lexer) {
    var bodyLength = body.length;
    var position = startPosition;
    while(position < bodyLength){
        var code = body.charCodeAt(position); // tab | space | comma | BOM
        if (code === 9 || code === 32 || code === 44 || code === 0xfeff) ++position;
        else if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else break;
    }
    return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $bf045906a0e003d2$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $bf045906a0e003d2$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $7NVBI.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($bf045906a0e003d2$var$printCharCode(code), "."));
    } else {
        position = $bf045906a0e003d2$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $bf045906a0e003d2$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $bf045906a0e003d2$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or e
    if (code === 46 || code === 69 || code === 101) throw (0, $7NVBI.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($bf045906a0e003d2$var$printCharCode(code), "."));
    return new $bf045906a0e003d2$var$Tok(isFloat ? (0, $h6aNg.TokenKind).FLOAT : (0, $h6aNg.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $bf045906a0e003d2$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $7NVBI.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($bf045906a0e003d2$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $bf045906a0e003d2$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $7NVBI.syntaxError)(source, position, "Invalid character within String: ".concat($bf045906a0e003d2$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $bf045906a0e003d2$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $7NVBI.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $7NVBI.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $7NVBI.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $bf045906a0e003d2$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $01vnQ.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $7NVBI.syntaxError)(source, position, "Invalid character within String: ".concat($bf045906a0e003d2$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $7NVBI.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $bf045906a0e003d2$var$uniCharCode(a, b, c, d) {
    return $bf045906a0e003d2$var$char2hex(a) << 12 | $bf045906a0e003d2$var$char2hex(b) << 8 | $bf045906a0e003d2$var$char2hex(c) << 4 | $bf045906a0e003d2$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $bf045906a0e003d2$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $bf045906a0e003d2$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new $bf045906a0e003d2$var$Tok((0, $h6aNg.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
}

});
parcelRegister("01vnQ", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $6087b57660bcd734$export$fd88c0b652c46ccc);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */ function $6087b57660bcd734$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $6087b57660bcd734$export$3c95bfdc680af0c(lines);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    while(lines.length > 0 && $6087b57660bcd734$var$isBlank(lines[0]))lines.shift();
    while(lines.length > 0 && $6087b57660bcd734$var$isBlank(lines[lines.length - 1]))lines.pop();
     // Return a string of the lines joined with U+000A.
    return lines.join('\n');
} // @internal
function $6087b57660bcd734$export$3c95bfdc680af0c(lines) {
    var commonIndent = null;
    for(var i = 1; i < lines.length; i++){
        var line = lines[i];
        var indent = $6087b57660bcd734$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        if (commonIndent === null || indent < commonIndent) {
            commonIndent = indent;
            if (commonIndent === 0) break;
        }
    }
    return commonIndent === null ? 0 : commonIndent;
}
function $6087b57660bcd734$var$leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (str[i] === ' ' || str[i] === '\t'))i++;
    return i;
}
function $6087b57660bcd734$var$isBlank(str) {
    return $6087b57660bcd734$var$leadingWhitespace(str) === str.length;
}
function $6087b57660bcd734$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});

parcelRegister("h6aNg", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $6d3b6fd24452f2fc$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $6d3b6fd24452f2fc$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});


parcelRegister("7cP7m", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $0a4ce3f42da2fc5b$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $0a4ce3f42da2fc5b$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});



parcelRegister("iHxiM", function(module, exports) {
"use strict";
var $d9d61333928973aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d9d61333928973aa$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseService = void 0;

var $4XQlz = parcelRequire("4XQlz");

var $66ItK = parcelRequire("66ItK");

var $lBKT3 = parcelRequire("lBKT3");
let $d9d61333928973aa$var$BaseService = class BaseService {
    query(options) {
        return (0, $lBKT3.from)(this.graphql.query.bind(this.graphql)(options));
    }
    mutate(options) {
        return (0, $lBKT3.from)(this.graphql.mutate.bind(this.graphql)(options));
    }
    watchQuery(options) {
        return this.graphql.watchQuery(options);
    }
    subscribe(options) {
        return (0, $lBKT3.from)(this.graphql.subscribe.bind(this.graphql)(options));
    }
};
module.exports.BaseService = $d9d61333928973aa$var$BaseService;
$d9d61333928973aa$var$__decorate([
    (0, $4XQlz.Injector)($66ItK.ApolloClient),
    $d9d61333928973aa$var$__metadata("design:type", Object)
], $d9d61333928973aa$var$BaseService.prototype, "graphql", void 0);
module.exports.BaseService = $d9d61333928973aa$var$BaseService = $d9d61333928973aa$var$__decorate([
    (0, $4XQlz.Injectable)()
], $d9d61333928973aa$var$BaseService);

});

parcelRegister("iJtLY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULTS = void 0;

var $4XQlz = parcelRequire("4XQlz");
module.exports.DEFAULTS = new $4XQlz.InjectionToken();

});

parcelRegister("5BC26", function(module, exports) {
"use strict";
var $414de8fbfb775a49$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $414de8fbfb775a49$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
/**
 * @customElement rx-fetch
 */ let $414de8fbfb775a49$var$FetchComponent = class FetchComponent extends $eG1Pq.LitElement {
};
module.exports.FetchComponent = $414de8fbfb775a49$var$FetchComponent;
$414de8fbfb775a49$var$__decorate([
    (0, $eG1Pq.property)(),
    $414de8fbfb775a49$var$__metadata("design:type", String)
], $414de8fbfb775a49$var$FetchComponent.prototype, "query", void 0);
$414de8fbfb775a49$var$__decorate([
    (0, $eG1Pq.property)(),
    $414de8fbfb775a49$var$__metadata("design:type", String)
], $414de8fbfb775a49$var$FetchComponent.prototype, "mutate", void 0);
$414de8fbfb775a49$var$__decorate([
    (0, $eG1Pq.property)(),
    $414de8fbfb775a49$var$__metadata("design:type", String)
], $414de8fbfb775a49$var$FetchComponent.prototype, "subscribe", void 0);
module.exports.FetchComponent = $414de8fbfb775a49$var$FetchComponent = $414de8fbfb775a49$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-fetch'
    })
], $414de8fbfb775a49$var$FetchComponent);

});

parcelRegister("niAfA", function(module, exports) {
"use strict";
var $0460906e085aebba$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0460906e085aebba$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RenderComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
/**
 * @customElement rx-render
 */ let $0460906e085aebba$var$RenderComponent = class RenderComponent extends $eG1Pq.LitElement {
};
module.exports.RenderComponent = $0460906e085aebba$var$RenderComponent;
$0460906e085aebba$var$__decorate([
    (0, $eG1Pq.property)({
        type: Object
    }),
    $0460906e085aebba$var$__metadata("design:type", Function)
], $0460906e085aebba$var$RenderComponent.prototype, "state", void 0);
module.exports.RenderComponent = $0460906e085aebba$var$RenderComponent = $0460906e085aebba$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-render',
        template: ()=>(0, $eG1Pq.html)` <slot></slot> `
    })
], $0460906e085aebba$var$RenderComponent);

});

parcelRegister("b2mAJ", function(module, exports) {
"use strict";
var $809167ca70c6916b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $809167ca70c6916b$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $809167ca70c6916b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MonadComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");

var $6lA3Q = parcelRequire("6lA3Q");

var $6s0Lm = parcelRequire("6s0Lm");

var $3XkaH = parcelRequire("3XkaH");
/**
 * @customElement rx-monad
 */ let $809167ca70c6916b$var$MonadComponent = class MonadComponent extends $eG1Pq.LitElement {
    OnUpdateFirst() {
        return $809167ca70c6916b$var$__awaiter(this, void 0, void 0, function*() {
            const nodes = this.shadowRoot.querySelector('slot').assignedNodes();
            const renderComponent = this.findNode(nodes, 'rx-render');
            const fetchComponent = this.findNode(nodes, 'rx-fetch');
            const stateComponent = this.findNode(nodes, 'rx-state');
            const styleComponent = this.findNode(nodes, 'rx-style');
            const settingsComponent = this.findNode(nodes, 'rx-settings');
            const lensComponent = this.findNode(nodes, 'rx-lens');
            let fetch;
            let state = yield stateComponent.value;
            if (lensComponent.match) state = this.get(state, lensComponent.match);
            else if (lensComponent.get) {
                lensComponent.get = lensComponent.get.map((a)=>a === 'all' ? $6lA3Q.all : a);
                if ((0, $6s0Lm.isObservable)(state)) state = state.pipe((0, $3XkaH.map)((s)=>{
                    const expectedState = $6lA3Q.get(...lensComponent.get)(s);
                    if (!expectedState) return s;
                    return expectedState;
                }));
                else state = $6lA3Q.get(...lensComponent.get)(state);
                if (lensComponent.ray) state = lensComponent.ray(state);
            } else if (lensComponent.ray) {
                if ((0, $6s0Lm.isObservable)(state)) state = state.pipe((0, $3XkaH.map)((s)=>lensComponent.ray(s)));
                else state = lensComponent.ray(state);
            }
            if (fetchComponent.query) fetch = this.trim(fetchComponent.query, 'query');
            if (fetchComponent.subscribe) fetch = this.trim(fetchComponent.subscribe, 'subscription');
            if (fetchComponent.mutate) fetch = this.trim(fetchComponent.mutate, 'mutation');
            this.options = {
                settings: settingsComponent.value,
                state: state,
                fetch: fetch,
                style: styleComponent.value,
                render: renderComponent.state
            };
        });
    }
    trim(query = '', type) {
        if (query.includes(type)) return query;
        const trimmedQuery = query.trim().replace(/\s/g, '');
        return `${type} ${trimmedQuery}`;
    }
    modState(args, state) {
        return new Promise((resolve, reject)=>{
            try {
                (0, $6lA3Q.mod)(args[0], args[1], args[2], args[3], args[4])(resolve)(state);
            } catch (e) {
                reject(e);
            }
        });
    }
    findNode(nodes, localName) {
        const node = nodes.find((n)=>n && n.nextSibling && n.nextSibling.localName === localName);
        if (node) return node.nextSibling;
        return {
            value: null
        };
    }
    get(obj = {}, path = '', defaultValue) {
        return path.replace(/\[(.+?)\]/g, '.$1').split('.').reduce((o, key)=>o[key], obj) || defaultValue;
    }
};
module.exports.MonadComponent = $809167ca70c6916b$var$MonadComponent;
$809167ca70c6916b$var$__decorate([
    (0, $eG1Pq.property)({
        type: Object
    }),
    $809167ca70c6916b$var$__metadata("design:type", Object)
], $809167ca70c6916b$var$MonadComponent.prototype, "options", void 0);
module.exports.MonadComponent = $809167ca70c6916b$var$MonadComponent = $809167ca70c6916b$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-monad',
        template () {
            return (0, $eG1Pq.html)`
      <slot></slot>
      ${this.options ? (0, $eG1Pq.html)`
            <rx-graph .options=${this.options}></rx-graph>
          ` : ''}
    `;
        }
    })
], $809167ca70c6916b$var$MonadComponent);

});
parcelRegister("6lA3Q", function(module, exports) {

$parcel$export(module.exports, "get", () => $49f0ad2fe1d93ec1$export$3988ae62b71be9a3);
$parcel$export(module.exports, "mod", () => $49f0ad2fe1d93ec1$export$842a2cf37af977e1);
$parcel$export(module.exports, "all", () => $49f0ad2fe1d93ec1$export$84bf76cd7afc7469);
function $49f0ad2fe1d93ec1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $49f0ad2fe1d93ec1$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $49f0ad2fe1d93ec1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $49f0ad2fe1d93ec1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $49f0ad2fe1d93ec1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $49f0ad2fe1d93ec1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $49f0ad2fe1d93ec1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $49f0ad2fe1d93ec1$var$_typeof(obj);
}
function $49f0ad2fe1d93ec1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $49f0ad2fe1d93ec1$var$_slicedToArray(arr, i) {
    return $49f0ad2fe1d93ec1$var$_arrayWithHoles(arr) || $49f0ad2fe1d93ec1$var$_iterableToArrayLimit(arr, i) || $49f0ad2fe1d93ec1$var$_unsupportedIterableToArray(arr, i) || $49f0ad2fe1d93ec1$var$_nonIterableRest();
}
function $49f0ad2fe1d93ec1$var$_toArray(arr) {
    return $49f0ad2fe1d93ec1$var$_arrayWithHoles(arr) || $49f0ad2fe1d93ec1$var$_iterableToArray(arr) || $49f0ad2fe1d93ec1$var$_unsupportedIterableToArray(arr) || $49f0ad2fe1d93ec1$var$_nonIterableRest();
}
function $49f0ad2fe1d93ec1$var$_toConsumableArray(arr) {
    return $49f0ad2fe1d93ec1$var$_arrayWithoutHoles(arr) || $49f0ad2fe1d93ec1$var$_iterableToArray(arr) || $49f0ad2fe1d93ec1$var$_unsupportedIterableToArray(arr) || $49f0ad2fe1d93ec1$var$_nonIterableSpread();
}
function $49f0ad2fe1d93ec1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $49f0ad2fe1d93ec1$var$_arrayLikeToArray(arr);
}
function $49f0ad2fe1d93ec1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $49f0ad2fe1d93ec1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $49f0ad2fe1d93ec1$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $49f0ad2fe1d93ec1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $49f0ad2fe1d93ec1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $49f0ad2fe1d93ec1$var$_arrayLikeToArray(o, minLen);
}
function $49f0ad2fe1d93ec1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $49f0ad2fe1d93ec1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $49f0ad2fe1d93ec1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $49f0ad2fe1d93ec1$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $49f0ad2fe1d93ec1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $49f0ad2fe1d93ec1$var$attr = function(name) {
    return {
        get: function get(obj) {
            return !obj[name] && typeof obj.get === 'function' ? obj.get(name) : obj[name];
        },
        mod: function mod(f) {
            return function(obj) {
                var _len, params, _key, _arguments = arguments;
                return function() {
                    for(_len = _arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = _arguments[_key];
                    if (typeof obj.set === 'function') return obj.set(name, f(obj[name] || obj.get(name)));
                    else if (Array.isArray(obj)) return obj.slice(0, name).concat(f.apply(void 0, [
                        obj[name]
                    ].concat(params))).concat(obj.slice(name + 1));
                    else return $49f0ad2fe1d93ec1$var$_objectSpread2($49f0ad2fe1d93ec1$var$_objectSpread2({}, obj), {}, $49f0ad2fe1d93ec1$var$_defineProperty({}, name, f.apply(void 0, [
                        obj[name]
                    ].concat(params))));
                }();
            };
        },
        traversal: false
    };
};
var $49f0ad2fe1d93ec1$var$keys = function keys(obj) {
    return obj ? typeof obj.keys === 'function' ? obj.keys() : Object.keys(obj) : [];
};
var $49f0ad2fe1d93ec1$var$setter = function setter(constructor) {
    switch(constructor){
        case Map:
            return function(obj, key, value) {
                obj.set(key, value);
                return obj;
            };
        case Set:
            return function(obj, _, value) {
                return obj.add(value);
            };
        case Object:
            return function(obj, key, value) {
                obj[key] = value;
                return obj;
            };
    }
};
var $49f0ad2fe1d93ec1$var$getter = function getter(constructor) {
    switch(constructor){
        case Map:
            return function(obj, key) {
                return obj.get(key);
            };
        case Set:
            return function(_, key) {
                return key;
            };
        case Object:
            return function(obj, key) {
                return obj[key];
            };
    }
};
var $49f0ad2fe1d93ec1$var$toFP = function toFP(_ref) {
    var _native = _ref["native"], overrides = _ref.overrides;
    return function(f) {
        for(var _len = arguments.length, fixedArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)fixedArgs[_key - 1] = arguments[_key];
        return function(coll) {
            var fxn = $49f0ad2fe1d93ec1$export$cd7b322347cd567b(f);
            if (typeof coll === 'undefined' || coll === null) return coll;
            if (typeof coll[_native] === 'function') return coll[_native].apply(coll, [
                fxn
            ].concat(fixedArgs));
            else {
                var Constructor = Object.getPrototypeOf(coll).constructor;
                var override = overrides[Constructor];
                if (override) return override(Constructor, $49f0ad2fe1d93ec1$var$getter(Constructor), $49f0ad2fe1d93ec1$var$setter(Constructor)).apply(void 0, [
                    coll,
                    fxn
                ].concat(fixedArgs));
            }
        };
    };
};
var $49f0ad2fe1d93ec1$export$3dea766d36a8935f = function() {
    var _overrides;
    var iteratorFilter = function iteratorFilter(Constructor, get, set) {
        return function(obj, pred) {
            var acc = new Constructor();
            var _iterator = $49f0ad2fe1d93ec1$var$_createForOfIteratorHelper($49f0ad2fe1d93ec1$var$keys(obj)), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var key = _step.value;
                    var value = get(obj, key);
                    if (pred(value, key)) set(acc, key, value);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            return acc;
        };
    };
    return $49f0ad2fe1d93ec1$var$toFP({
        "native": 'filter',
        overrides: (_overrides = {}, $49f0ad2fe1d93ec1$var$_defineProperty(_overrides, Object, iteratorFilter), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides, Map, iteratorFilter), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides, Set, iteratorFilter), _overrides)
    });
}();
var $49f0ad2fe1d93ec1$export$871de8747c9eaa88 = function() {
    var _overrides2;
    var iteratorMap = function iteratorMap(Constructor, get, set) {
        return function(obj, f) {
            var acc = new Constructor();
            var _iterator2 = $49f0ad2fe1d93ec1$var$_createForOfIteratorHelper($49f0ad2fe1d93ec1$var$keys(obj)), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var key = _step2.value;
                    set(acc, key, f(get(obj, key), key));
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            return acc;
        };
    };
    return $49f0ad2fe1d93ec1$var$toFP({
        "native": 'map',
        overrides: (_overrides2 = {}, $49f0ad2fe1d93ec1$var$_defineProperty(_overrides2, Object, iteratorMap), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides2, Map, iteratorMap), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides2, Set, iteratorMap), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides2, Promise, function() {
            return function(promise, f) {
                return promise.then(f);
            };
        }), _overrides2)
    });
}();
var $49f0ad2fe1d93ec1$export$71aa6c912b956294 = function() {
    var _overrides3;
    var iteratorFind = function iteratorFind(_, get, __) {
        return function(obj, f) {
            var result;
            if (!obj) return result;
            var _iterator3 = $49f0ad2fe1d93ec1$var$_createForOfIteratorHelper($49f0ad2fe1d93ec1$var$keys(obj)), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var key = _step3.value;
                    var value = get(obj, key);
                    if (f(value, key)) return value;
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        };
    };
    return $49f0ad2fe1d93ec1$var$toFP({
        "native": 'find',
        overrides: (_overrides3 = {}, $49f0ad2fe1d93ec1$var$_defineProperty(_overrides3, Object, iteratorFind), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides3, Map, iteratorFind), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides3, Set, iteratorFind), _overrides3)
    });
}();
var $49f0ad2fe1d93ec1$export$ad14ef4001db2bcd = function() {
    var _overrides4;
    var iteratorSome = function iteratorSome(_, get, __) {
        return function(obj, pred) {
            var _iterator4 = $49f0ad2fe1d93ec1$var$_createForOfIteratorHelper($49f0ad2fe1d93ec1$var$keys(obj)), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var key = _step4.value;
                    if (pred(get(obj, key), key)) return true;
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
            return false;
        };
    };
    return $49f0ad2fe1d93ec1$var$toFP({
        "native": 'some',
        overrides: (_overrides4 = {}, $49f0ad2fe1d93ec1$var$_defineProperty(_overrides4, Object, iteratorSome), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides4, Map, iteratorSome), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides4, Set, iteratorSome), _overrides4)
    });
}();
var $49f0ad2fe1d93ec1$export$533b26079ad0b4b = function() {
    var _overrides5;
    var iteratorReduce = function iteratorReduce(Constructor, get, _) {
        return function(obj, f, base) {
            var acc = new Constructor();
            var _iterator5 = $49f0ad2fe1d93ec1$var$_createForOfIteratorHelper($49f0ad2fe1d93ec1$var$keys(obj)), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var key = _step5.value;
                    f(acc, get(obj, key), key);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
            return base;
        };
    };
    return $49f0ad2fe1d93ec1$var$toFP({
        "native": 'reduce',
        overrides: (_overrides5 = {}, $49f0ad2fe1d93ec1$var$_defineProperty(_overrides5, Object, iteratorReduce), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides5, Map, iteratorReduce), $49f0ad2fe1d93ec1$var$_defineProperty(_overrides5, Set, iteratorReduce), _overrides5)
    });
}();
var $49f0ad2fe1d93ec1$export$7ecc1a3b11b57dab = function every(arr) {
    var _iterator6 = $49f0ad2fe1d93ec1$var$_createForOfIteratorHelper(arr), _step6;
    try {
        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
            var elem = _step6.value;
            if (!elem) return false;
        }
    } catch (err) {
        _iterator6.e(err);
    } finally{
        _iterator6.f();
    }
    return true;
};
var $49f0ad2fe1d93ec1$export$8327ebbef2a0ba76 = function cons(x) {
    return function(xs) {
        return [].concat($49f0ad2fe1d93ec1$var$_toConsumableArray(xs), [
            x
        ]);
    };
};
var $49f0ad2fe1d93ec1$export$37cdb546b806ae87 = function unshift(x) {
    return function(xs) {
        return [
            x
        ].concat($49f0ad2fe1d93ec1$var$_toConsumableArray(xs));
    };
};
var $49f0ad2fe1d93ec1$export$43128fadae87b74a = function first(xs) {
    return xs[0];
};
var $49f0ad2fe1d93ec1$export$c58417706a208278 = function rest(_ref2) {
    var _ref3 = $49f0ad2fe1d93ec1$var$_toArray(_ref2);
    _ref3[0];
    var xs = _ref3.slice(1);
    return xs;
};
var $49f0ad2fe1d93ec1$export$4cbf152802aa238 = $49f0ad2fe1d93ec1$export$8327ebbef2a0ba76;
var $49f0ad2fe1d93ec1$export$ee1b3e54f0441b22 = function concat(xs) {
    return function(ys) {
        return [].concat($49f0ad2fe1d93ec1$var$_toConsumableArray(ys), $49f0ad2fe1d93ec1$var$_toConsumableArray(xs));
    };
};
var $49f0ad2fe1d93ec1$export$10d8903dec122b9d = $49f0ad2fe1d93ec1$export$ee1b3e54f0441b22;
var $49f0ad2fe1d93ec1$export$68159836694e22c1 = function prepend(ys) {
    return function(xs) {
        return [].concat($49f0ad2fe1d93ec1$var$_toConsumableArray(ys), $49f0ad2fe1d93ec1$var$_toConsumableArray(xs));
    };
};
var $49f0ad2fe1d93ec1$export$21cde5187c2605a3 = function compile(lens) {
    return [
        'string',
        'number'
    ].includes($49f0ad2fe1d93ec1$var$_typeof(lens)) ? $49f0ad2fe1d93ec1$var$attr(lens) : $49f0ad2fe1d93ec1$var$_objectSpread2({
        traversal: false,
        optional: false
    }, lens);
};
var $49f0ad2fe1d93ec1$export$f672e0b6f7222cd7 = function() {
    for(var _len = arguments.length, lenses = new Array(_len), _key = 0; _key < _len; _key++)lenses[_key] = arguments[_key];
    return lenses.length === 1 ? $49f0ad2fe1d93ec1$export$21cde5187c2605a3(lenses[0]) : {
        get: function get(obj) {
            return lenses.map($49f0ad2fe1d93ec1$export$21cde5187c2605a3).reduce(function(_ref, lens) {
                var traverser = _ref.traverser, state = _ref.state, shortCircuited = _ref.shortCircuited;
                var nextState = shortCircuited ? null : traverser(lens.get)(state);
                return {
                    state: nextState,
                    traverser: lens.traversal ? function(f) {
                        return $49f0ad2fe1d93ec1$export$871de8747c9eaa88(traverser(f));
                    } : traverser,
                    shortCircuited: shortCircuited || lens.optional && (nextState === null || nextState === undefined)
                };
            }, {
                state: obj,
                traverser: function traverser(x) {
                    return x;
                },
                shortCircuited: false
            }).state;
        },
        mod: function mod(f) {
            return function(obj) {
                var aux;
                for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                return aux = function aux(object, lenses) {
                    var _lenses, first, rest;
                    return _lenses = $49f0ad2fe1d93ec1$var$_toArray(lenses), first = _lenses[0], rest = _lenses.slice(1), rest.length === 0 ? first.mod(f).apply(void 0, [
                        object
                    ].concat(params)) : first.mod(function(obj) {
                        return aux(obj, rest);
                    }).apply(void 0, [
                        object
                    ].concat(params));
                }, aux(obj, lenses.map($49f0ad2fe1d93ec1$export$21cde5187c2605a3));
            };
        }
    };
};
var $49f0ad2fe1d93ec1$export$3988ae62b71be9a3 = function get() {
    return $49f0ad2fe1d93ec1$export$f672e0b6f7222cd7.apply(void 0, arguments).get;
};
var $49f0ad2fe1d93ec1$export$a4f4bb6b1453fff5 = function has(pattern) {
    return function(obj) {
        return pattern && $49f0ad2fe1d93ec1$var$_typeof(pattern) === 'object' ? !!obj && $49f0ad2fe1d93ec1$export$7ecc1a3b11b57dab(Object.keys(pattern).map(function(key) {
            return has($49f0ad2fe1d93ec1$export$3988ae62b71be9a3(key)(pattern))($49f0ad2fe1d93ec1$var$bindingGet(key)(obj));
        })) : typeof pattern === 'function' ? pattern(obj) : pattern === obj;
    };
};
var $49f0ad2fe1d93ec1$export$f517ea36c68d4644 = function greaterThan(a) {
    return function(b) {
        return b > a;
    };
};
var $49f0ad2fe1d93ec1$export$9b050841a3a1b328 = function lessThan(a) {
    return function(b) {
        return b < a;
    };
};
var $49f0ad2fe1d93ec1$export$36aa029c34b83c19 = function greaterThanEq(a) {
    return function(b) {
        return b >= a;
    };
};
var $49f0ad2fe1d93ec1$export$859c4b8b8840d9a3 = function lessThanEq(a) {
    return function(b) {
        return b <= a;
    };
};
var $49f0ad2fe1d93ec1$export$e03c1c3201ee8bb7 = function toggle(bool) {
    return !bool;
};
var $49f0ad2fe1d93ec1$export$42b74c557bc9df8 = function returns(val) {
    return function(f) {
        return f() === val;
    };
};
var $49f0ad2fe1d93ec1$var$bindingGet = function bindingGet(key) {
    return function(pattern) {
        var v;
        return v = $49f0ad2fe1d93ec1$export$3988ae62b71be9a3(key)(pattern), typeof v === 'function' ? v.bind(pattern) : v;
    };
};
var $49f0ad2fe1d93ec1$export$a6cdc56e425d0d0a = function isObject(x) {
    return $49f0ad2fe1d93ec1$var$_typeof(x) === 'object' && !Array.isArray(x) && x !== null;
};
var $49f0ad2fe1d93ec1$export$2fb7a00a48619649 = function isValue(x) {
    return x !== null && x !== undefined;
};
var $49f0ad2fe1d93ec1$export$cd7b322347cd567b = function into(f) {
    return typeof f === 'function' ? f : $49f0ad2fe1d93ec1$var$_typeof(f) === 'object' ? $49f0ad2fe1d93ec1$export$a4f4bb6b1453fff5(f) : $49f0ad2fe1d93ec1$export$3988ae62b71be9a3(f);
};
var $49f0ad2fe1d93ec1$export$f0954fd7d5368655 = function identity(a) {
    return a;
};
var $49f0ad2fe1d93ec1$export$8a83211c878a3f1f = function flip(f) {
    return function(a) {
        return function(b) {
            return f(b)(a);
        };
    };
};
var $49f0ad2fe1d93ec1$export$ba9e5d519bc326ca = function always(a) {
    return function(b) {
        return a;
    };
};
var $49f0ad2fe1d93ec1$export$6003a5f097c73977 = function not(f) {
    return function() {
        return !$49f0ad2fe1d93ec1$export$cd7b322347cd567b(f).apply(void 0, arguments);
    };
};
var $49f0ad2fe1d93ec1$export$21c0ac7fe1cef1b8 = function and() {
    for(var _len = arguments.length, fs = new Array(_len), _key = 0; _key < _len; _key++)fs[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return fs.reduce(function(acc, f) {
            return acc && f.apply(void 0, args);
        }, true);
    };
};
var $49f0ad2fe1d93ec1$export$252bb8b3bbdf6749 = function or() {
    for(var _len3 = arguments.length, fs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)fs[_key3] = arguments[_key3];
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return fs.reduce(function(acc, f) {
            return acc || f.apply(void 0, args);
        }, false);
    };
};
var $49f0ad2fe1d93ec1$export$c3095a23b368d1f2 = function curry(n) {
    return function(f) {
        return $49f0ad2fe1d93ec1$var$_curry(n, f);
    };
};
function $49f0ad2fe1d93ec1$var$_curry(n, f) {
    var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return function(arg) {
        return n ? $49f0ad2fe1d93ec1$var$_curry(n, f, $49f0ad2fe1d93ec1$export$8327ebbef2a0ba76(arg)(args)) : f.apply(void 0, $49f0ad2fe1d93ec1$var$_toConsumableArray(args));
    };
}
var $49f0ad2fe1d93ec1$export$e16d8520af44a096 = function add(a) {
    return function(b) {
        return a + b;
    };
};
var $49f0ad2fe1d93ec1$export$f93b5905241a7cca = function sub(a) {
    return function(b) {
        return b - a;
    };
};
var $49f0ad2fe1d93ec1$export$64d41e6bd9c791f3 = function inc(num) {
    return num + 1;
};
var $49f0ad2fe1d93ec1$export$732526d242a38a7f = function dec(num) {
    return num - 1;
};
var $49f0ad2fe1d93ec1$export$ee2e0f811dca1807 = function includes(snippet) {
    return function(text) {
        return text.includes(snippet);
    };
};
var $49f0ad2fe1d93ec1$export$e41e96bb88700ba3 = function includesi(snippet) {
    return function(text) {
        return text.toLowerCase().includes(snippet.toLowerCase());
    };
};
var $49f0ad2fe1d93ec1$export$52dcd5ad4274e359 = function foldOf(f) {
    return function(field) {
        var getter = $49f0ad2fe1d93ec1$export$cd7b322347cd567b(field);
        return function(acc, curr) {
            return f(acc, curr, getter);
        };
    };
};
var $49f0ad2fe1d93ec1$export$75e12408367c5187 = $49f0ad2fe1d93ec1$export$52dcd5ad4274e359(function(acc, curr, getter) {
    return getter(curr) > getter(acc) ? curr : acc;
});
var $49f0ad2fe1d93ec1$export$8ee782a1d8add48c = $49f0ad2fe1d93ec1$export$52dcd5ad4274e359(function(acc, curr, getter) {
    return getter(curr) < getter(acc) ? curr : acc;
});
var $49f0ad2fe1d93ec1$export$42468c76f380d4d8 = $49f0ad2fe1d93ec1$export$52dcd5ad4274e359(function(acc, curr, getter) {
    return getter(acc) ? acc : getter(curr) ? curr : null;
});
var $49f0ad2fe1d93ec1$export$226773add4f378f5 = $49f0ad2fe1d93ec1$export$52dcd5ad4274e359(function(acc, curr, getter) {
    return getter(curr) + (typeof acc === 'number' ? acc : getter(acc));
});
var $49f0ad2fe1d93ec1$export$7be5941944569cfd = $49f0ad2fe1d93ec1$export$52dcd5ad4274e359(function(acc, curr, getter) {
    return getter(curr) * (typeof acc === 'number' ? acc : getter(acc));
});
var $49f0ad2fe1d93ec1$export$842a2cf37af977e1 = function mod() {
    return $49f0ad2fe1d93ec1$export$f672e0b6f7222cd7.apply(void 0, arguments).mod;
};
var $49f0ad2fe1d93ec1$export$adaa4cf7ef1b65be = function set() {
    for(var _len = arguments.length, lenses = new Array(_len), _key = 0; _key < _len; _key++)lenses[_key] = arguments[_key];
    return function(newValue) {
        return $49f0ad2fe1d93ec1$export$f672e0b6f7222cd7.apply(void 0, lenses).mod($49f0ad2fe1d93ec1$export$ba9e5d519bc326ca(newValue));
    };
};
var $49f0ad2fe1d93ec1$export$ba4f22f061f42309 = function matching(pred) {
    var predFxn = $49f0ad2fe1d93ec1$export$cd7b322347cd567b(pred);
    return {
        get: $49f0ad2fe1d93ec1$export$3dea766d36a8935f(predFxn),
        mod: function mod(f) {
            return $49f0ad2fe1d93ec1$export$871de8747c9eaa88(function(n) {
                return predFxn(n) ? f(n) : n;
            });
        },
        traversal: true
    };
};
var $49f0ad2fe1d93ec1$var$all = function all() {
    return {
        get: $49f0ad2fe1d93ec1$export$f0954fd7d5368655,
        mod: $49f0ad2fe1d93ec1$export$871de8747c9eaa88,
        traversal: true
    };
};
var $49f0ad2fe1d93ec1$export$84bf76cd7afc7469 = Object.assign($49f0ad2fe1d93ec1$var$all, $49f0ad2fe1d93ec1$var$all());
var $49f0ad2fe1d93ec1$export$6f0673371501d6b6 = function(pred) {
    return $49f0ad2fe1d93ec1$export$ba4f22f061f42309($49f0ad2fe1d93ec1$export$6003a5f097c73977(pred));
};
var $49f0ad2fe1d93ec1$export$443b903547e5c42d = function updateAll() {
    for(var _len = arguments.length, updaters = new Array(_len), _key = 0; _key < _len; _key++)updaters[_key] = arguments[_key];
    return function(state) {
        return updaters.reduce(function(currState, transformer) {
            return transformer(currState);
        }, state);
    };
};
var $49f0ad2fe1d93ec1$var$withOf = function withOf(f) {
    f.of = f;
    return f;
};
var $49f0ad2fe1d93ec1$export$2a12373211ef4ed4 = function foldBy(reducer) {
    return function(field) {
        return $49f0ad2fe1d93ec1$export$21cde5187c2605a3({
            get: $49f0ad2fe1d93ec1$export$533b26079ad0b4b(reducer(field)),
            mod: function mod(f) {
                return function(obj) {
                    var matching = $49f0ad2fe1d93ec1$export$533b26079ad0b4b(reducer(field))(obj);
                    return $49f0ad2fe1d93ec1$export$871de8747c9eaa88(function(item) {
                        return item === matching ? f(item) : item;
                    })(obj);
                };
            }
        });
    };
};
var $49f0ad2fe1d93ec1$export$63d5f59f45ab3135 = $49f0ad2fe1d93ec1$var$withOf($49f0ad2fe1d93ec1$export$2a12373211ef4ed4($49f0ad2fe1d93ec1$export$42468c76f380d4d8));
var $49f0ad2fe1d93ec1$export$ad1963a493908da4 = $49f0ad2fe1d93ec1$var$withOf($49f0ad2fe1d93ec1$export$2a12373211ef4ed4($49f0ad2fe1d93ec1$export$75e12408367c5187));
var $49f0ad2fe1d93ec1$export$8c826aa0fa59ac68 = $49f0ad2fe1d93ec1$var$withOf($49f0ad2fe1d93ec1$export$2a12373211ef4ed4($49f0ad2fe1d93ec1$export$8ee782a1d8add48c));
var $49f0ad2fe1d93ec1$export$f8b8b9ce72e9ccbf = function(name) {
    var base = $49f0ad2fe1d93ec1$var$attr(name);
    return $49f0ad2fe1d93ec1$export$21cde5187c2605a3({
        get: function get(obj) {
            return obj && base.get(obj);
        },
        mod: function mod(f) {
            return function(obj) {
                return obj && base.get(obj) ? base.mod(f)(obj) : obj;
            };
        },
        optional: true
    });
};
var $49f0ad2fe1d93ec1$export$a1eaec3f779505d4 = function valueOr(def) {
    return $49f0ad2fe1d93ec1$export$21cde5187c2605a3({
        get: function get(val) {
            return $49f0ad2fe1d93ec1$export$2fb7a00a48619649(val) ? val : def;
        },
        mod: function mod(fn) {
            return function(val) {
                return $49f0ad2fe1d93ec1$export$2fb7a00a48619649(val) ? fn(val) : fn(def);
            };
        }
    });
};
var $49f0ad2fe1d93ec1$export$9563e054e6f787fb = function fill(filling) {
    return function(obj) {
        var out = $49f0ad2fe1d93ec1$var$_objectSpread2({}, obj);
        Object.entries(filling).forEach(function(_ref) {
            var _ref2 = $49f0ad2fe1d93ec1$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
            out[key] = $49f0ad2fe1d93ec1$export$2fb7a00a48619649(out[key]) ? out[key] : value;
            if (out.hasOwnProperty(key)) {
                if ($49f0ad2fe1d93ec1$export$a6cdc56e425d0d0a(out[key]) && $49f0ad2fe1d93ec1$export$a6cdc56e425d0d0a(value)) out[key] = fill(value)(obj[key]);
            }
        });
        return out;
    };
};

});


parcelRegister("fHl3k", function(module, exports) {
"use strict";
var $b6db33cdf2590afc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b6db33cdf2590afc$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LensComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
/**
 * @customElement rx-lens
 */ let $b6db33cdf2590afc$var$LensComponent = class LensComponent extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.ray = (res)=>res;
    }
};
module.exports.LensComponent = $b6db33cdf2590afc$var$LensComponent;
$b6db33cdf2590afc$var$__decorate([
    (0, $eG1Pq.property)({
        type: String
    }),
    $b6db33cdf2590afc$var$__metadata("design:type", String)
], $b6db33cdf2590afc$var$LensComponent.prototype, "match", void 0);
$b6db33cdf2590afc$var$__decorate([
    (0, $eG1Pq.property)({
        type: Array
    }),
    $b6db33cdf2590afc$var$__metadata("design:type", Array)
], $b6db33cdf2590afc$var$LensComponent.prototype, "get", void 0);
$b6db33cdf2590afc$var$__decorate([
    (0, $eG1Pq.property)({
        type: Object
    }),
    $b6db33cdf2590afc$var$__metadata("design:type", Function)
], $b6db33cdf2590afc$var$LensComponent.prototype, "ray", void 0);
module.exports.LensComponent = $b6db33cdf2590afc$var$LensComponent = $b6db33cdf2590afc$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-lens'
    })
], $b6db33cdf2590afc$var$LensComponent);

});

parcelRegister("iL2mo", function(module, exports) {
"use strict";
var $da7e72715ae056c5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $da7e72715ae056c5$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SettingsComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
/**
 * @customElement rx-settings
 */ let $da7e72715ae056c5$var$SettingsComponent = class SettingsComponent extends $eG1Pq.LitElement {
};
module.exports.SettingsComponent = $da7e72715ae056c5$var$SettingsComponent;
$da7e72715ae056c5$var$__decorate([
    (0, $eG1Pq.property)({
        type: Object
    }),
    $da7e72715ae056c5$var$__metadata("design:type", Object)
], $da7e72715ae056c5$var$SettingsComponent.prototype, "value", void 0);
module.exports.SettingsComponent = $da7e72715ae056c5$var$SettingsComponent = $da7e72715ae056c5$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-settings'
    })
], $da7e72715ae056c5$var$SettingsComponent);

});

parcelRegister("gtQax", function(module, exports) {
"use strict";
var $bff7d27713e67472$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bff7d27713e67472$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StateComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
/**
 * @customElement rx-state
 */ let $bff7d27713e67472$var$StateComponent = class StateComponent extends $eG1Pq.LitElement {
};
module.exports.StateComponent = $bff7d27713e67472$var$StateComponent;
$bff7d27713e67472$var$__decorate([
    (0, $eG1Pq.property)(),
    $bff7d27713e67472$var$__metadata("design:type", Object)
], $bff7d27713e67472$var$StateComponent.prototype, "value", void 0);
module.exports.StateComponent = $bff7d27713e67472$var$StateComponent = $bff7d27713e67472$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-state'
    })
], $bff7d27713e67472$var$StateComponent);

});

parcelRegister("6I4sE", function(module, exports) {
"use strict";
var $4e2a50055d64e46d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4e2a50055d64e46d$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StyleComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
/**
 * @customElement rx-style
 */ let $4e2a50055d64e46d$var$StyleComponent = class StyleComponent extends $eG1Pq.LitElement {
};
module.exports.StyleComponent = $4e2a50055d64e46d$var$StyleComponent;
$4e2a50055d64e46d$var$__decorate([
    (0, $eG1Pq.property)(),
    $4e2a50055d64e46d$var$__metadata("design:type", Object)
], $4e2a50055d64e46d$var$StyleComponent.prototype, "value", void 0);
module.exports.StyleComponent = $4e2a50055d64e46d$var$StyleComponent = $4e2a50055d64e46d$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-style'
    })
], $4e2a50055d64e46d$var$StyleComponent);

});




parcelRegister("hxTEf", function(module, exports) {
"use strict";
var $cc60af4a3ab8e04b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cc60af4a3ab8e04b$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArticleComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");

var $cSkRX = parcelRequire("cSkRX");
/**
 * @customElement rx-article
 */ let $cc60af4a3ab8e04b$var$ArticleComponent = class ArticleComponent extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.data = {};
    }
};
module.exports.ArticleComponent = $cc60af4a3ab8e04b$var$ArticleComponent;
$cc60af4a3ab8e04b$var$__decorate([
    (0, $eG1Pq.property)({
        type: Object
    }),
    $cc60af4a3ab8e04b$var$__metadata("design:type", Object)
], $cc60af4a3ab8e04b$var$ArticleComponent.prototype, "data", void 0);
module.exports.ArticleComponent = $cc60af4a3ab8e04b$var$ArticleComponent = $cc60af4a3ab8e04b$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-article',
        style: $cSkRX.style,
        template () {
            return (0, $eG1Pq.html)`
      <article class="article">
        <h1 class="title">
          <a>${this.data.heading}</a>
        </h1>
        <p class="article-meta">
          ${this.data.meta}
        </p>
        <p class="text-lead">
          ${this.data.lead}
        </p>
        <p>
          ${this.data.information}
        </p>
        <div class="section">
          ${this.data.section}
        </div>
      </article>
    `;
        }
    })
], $cc60af4a3ab8e04b$var$ArticleComponent);

});
parcelRegister("cSkRX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.style = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.style = (0, $eG1Pq.css)`
  .article {
    color: #666;
  }

  .title {
    font-size: 38px;
    line-height: 1.2;
    font-weight: 300;
    margin-top: 0px;
    text-transform: none;
  }

  a {
    cursor: pointer;
    user-select: none;
  }

  a:hover {
    color: #666;
  }
  h1 a {
    text-decoration: none;
  }

  .article-meta {
    font-size: 14px;
    line-height: 1.4;
    color: #999;
  }
  .text-lead {
    font-size: 24px;
    line-height: 1.5;
    font-weight: 300;
    color: #222;
  }
  .section {
    width: 250px;
    display: flex;
    text-transform: uppercase;
  }
  .section div {
    padding: 0;
    line-height: 1.5;
    background: none;
    color: #222;
    font-size: 14px;
    position: relative;
  }
  .section div:hover {
    cursor: pointer;
  }
  .section div:hover::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid #222;
    transition: right 0.3s ease-out;
  }
`;

});


parcelRegister("iQ1sC", function(module, exports) {
"use strict";
var $db6e375cefced7d1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $db6e375cefced7d1$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ButtonComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
parcelRequire("1WKsL");
/**
 * @customElement rx-button
 */ let $db6e375cefced7d1$var$ButtonComponent = class ButtonComponent extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.palette = 'default';
    }
    OnUpdateFirst() {
        if (this.type === 'submit') {
            const form = this.getFormElement();
            if (form) {
                const input = document.createElement('input');
                input.style.display = 'none';
                input.type = this.type;
                form.append(input);
                this.addEventListener('click', ()=>input.click());
            }
        }
    }
    getFormElement() {
        const defaultKey = 'parentElement';
        let selector = '';
        let form;
        for (const k of Array(100).fill(defaultKey)){
            const formElement = this.findForm(selector);
            if (formElement) {
                form = formElement;
                break;
            }
            selector += `.${k}`;
        }
        return form;
    }
    get(obj = {}, path = '') {
        return path.replace(/\[(.+?)\]/g, '.$1').split('.').reduce((o, key)=>!o[key] ? o : o[key], obj);
    }
    findForm(selector) {
        let form;
        if (!selector) form = this.parentElement;
        else form = this.get(this.parentElement, selector);
        if (form && form.tagName !== 'FORM') return null;
        return form;
    }
};
module.exports.ButtonComponent = $db6e375cefced7d1$var$ButtonComponent;
$db6e375cefced7d1$var$__decorate([
    (0, $eG1Pq.property)({
        type: String
    }),
    $db6e375cefced7d1$var$__metadata("design:type", String)
], $db6e375cefced7d1$var$ButtonComponent.prototype, "palette", void 0);
$db6e375cefced7d1$var$__decorate([
    (0, $eG1Pq.property)({
        type: Boolean
    }),
    $db6e375cefced7d1$var$__metadata("design:type", Boolean)
], $db6e375cefced7d1$var$ButtonComponent.prototype, "disabled", void 0);
$db6e375cefced7d1$var$__decorate([
    (0, $eG1Pq.property)({
        type: String
    }),
    $db6e375cefced7d1$var$__metadata("design:type", String)
], $db6e375cefced7d1$var$ButtonComponent.prototype, "type", void 0);
$db6e375cefced7d1$var$__decorate([
    (0, $eG1Pq.property)({
        type: Boolean
    }),
    $db6e375cefced7d1$var$__metadata("design:type", Boolean)
], $db6e375cefced7d1$var$ButtonComponent.prototype, "shadow", void 0);
module.exports.ButtonComponent = $db6e375cefced7d1$var$ButtonComponent = $db6e375cefced7d1$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-button',
        template () {
            return (0, $eG1Pq.html)`
      <style>
        :host {
          margin: 0;
          border: none;
          overflow: visible;
          font: inherit;
          color: var(--${this.palette}-color);
          background: var(--${this.palette}-bg-color);
          border: var(--${this.palette}-border);
          color: #222;
          cursor: pointer;
          color: inherit;
          text-transform: none;
          -webkit-appearance: none;
          border-radius: 0;
          display: inline-block;
          box-sizing: border-box;
          padding: 0 30px;
          vertical-align: middle;
          font-size: 14px;
          line-height: 38px;
          text-align: center;
          text-decoration: none;
          text-transform: uppercase;
          transition: 0.1s ease-in-out;
          transition-property: color, background-color, border-color;
          user-select: none;
          -webkit-user-select: none;
          -moz-user-select: none;
        }

        slot {
          user-select: none;
          color: var(--${this.palette}-color);
        }
      </style>
      ${this.disabled ? (0, $eG1Pq.html)`
            <style>
              :host {
                background: #929a9c;
              }
            </style>
          ` : (0, $eG1Pq.html)`
            <style>
              :host(:hover) {
                background-color: var(--${this.palette}-hover-color);
              }
              :host(:active) {
                background-color: var(--${this.palette}-active-color);
              }
            </style>
          `}
      ${this.shadow ? (0, $eG1Pq.html)`<style>
            :host {
              box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 3px,
                rgba(0, 0, 0, 0.14) 0px 1px 2px;
            }
          </style>` : ''}
      <slot part="text"></slot>
    `;
        }
    })
], $db6e375cefced7d1$var$ButtonComponent);

});

parcelRegister("8FDb6", function(module, exports) {
"use strict";
var $65008b045804c7c3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $65008b045804c7c3$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DividerComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");

var $ccs6N = parcelRequire("ccs6N");
/**
 * @customElement rx-divider
 */ let $65008b045804c7c3$var$DividerComponent = class DividerComponent extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.type = 'default';
    }
};
module.exports.DividerComponent = $65008b045804c7c3$var$DividerComponent;
$65008b045804c7c3$var$__decorate([
    (0, $eG1Pq.property)({
        type: String
    }),
    $65008b045804c7c3$var$__metadata("design:type", String)
], $65008b045804c7c3$var$DividerComponent.prototype, "type", void 0);
module.exports.DividerComponent = $65008b045804c7c3$var$DividerComponent = $65008b045804c7c3$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-divider',
        style: $ccs6N.style,
        template () {
            if (this.type === 'icon') return (0, $eG1Pq.html)`
        <hr class="icon" />
      `;
            return (0, $eG1Pq.html)`
      <hr class="default" />
    `;
        }
    })
], $65008b045804c7c3$var$DividerComponent);

});
parcelRegister("ccs6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.style = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.style = (0, $eG1Pq.css)`
  .icon {
    margin-bottom: 0;
    position: relative;
    height: 20px;
    background-image: url(data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22none%22%20stroke%3D%22%23e5e5e5%22%20stroke-width%3D%222%22%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%227%22%20%2F%3E%0A%3C%2Fsvg%3E%0A);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    margin: 20px 0 20px 0;
  }
  hr {
    border: 0;
  }
  .default {
    overflow: visible;
    text-align: inherit;
    margin: 20px 0 20px 0;
    border: 0;
    border-top: 1px solid #e5e5e5;
  }
  .icon::before {
    right: calc(50% + (50px / 2));
    width: 100%;
    content: '';
    position: absolute;
    top: 50%;
    max-width: calc(50% - (50px / 2));
    border-bottom: 1px solid #e5e5e5;
  }
  .icon::after {
    left: calc(50% + (50px / 2));
    width: 100%;
    content: '';
    position: absolute;
    top: 50%;
    max-width: calc(50% - (50px / 2));
    border-bottom: 1px solid #e5e5e5;
  }
`;

});


parcelRegister("a9fT9", function(module, exports) {
"use strict";
var $763711c1059663be$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $763711c1059663be$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabelComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
parcelRequire("1WKsL");
/**
 * @customElement rx-label
 */ let $763711c1059663be$var$LabelComponent = class LabelComponent extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.palette = 'default';
    }
};
module.exports.LabelComponent = $763711c1059663be$var$LabelComponent;
$763711c1059663be$var$__decorate([
    (0, $eG1Pq.property)(),
    $763711c1059663be$var$__metadata("design:type", String)
], $763711c1059663be$var$LabelComponent.prototype, "palette", void 0);
module.exports.LabelComponent = $763711c1059663be$var$LabelComponent = $763711c1059663be$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-label',
        template () {
            return (0, $eG1Pq.html)`
      <style>
        :host {
          color: var(--${this.palette}-color);
          background: var(--${this.palette}-bg-color);
          border: var(--${this.palette}-border);
          display: inline-block;
          padding: 0 10px;
          line-height: 1.5;
          font-size: 12px;
          vertical-align: middle;
          white-space: nowrap;
          border-radius: 2px;
          text-transform: uppercase;
        }
      </style>
      <slot></slot>
    `;
        }
    })
], $763711c1059663be$var$LabelComponent);

});

parcelRegister("c3REs", function(module, exports) {
"use strict";
var $8c7f61eb8d17f82d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8c7f61eb8d17f82d$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalService = void 0;

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");

var $82Kdl = parcelRequire("82Kdl");
var $8fifx = parcelRequire("8fifx");
var $5rqBH = parcelRequire("5rqBH");
var $35ZUd = parcelRequire("35ZUd");

var $evplY = parcelRequire("evplY");

var $h0UK9 = parcelRequire("h0UK9");
var $3XkaH = parcelRequire("3XkaH");
var $hgiLQ = parcelRequire("hgiLQ");
var $37rZb = parcelRequire("37rZb");

var $5YAWb = parcelRequire("5YAWb");
let $8c7f61eb8d17f82d$var$ModalService = class ModalService {
    constructor(){
        this.modalTemplate = new $5rqBH.ReplaySubject();
        this.closeSubject$ = new $35ZUd.Subject();
        this.$onScroll = new $35ZUd.Subject();
        this.originalOptions = Object.assign({}, this.options);
    }
    setScrollWidth(value) {
        this.$onScroll.next(value);
    }
    setContainerRef(element) {
        this.containerRef = element;
    }
    getContainerRef() {
        return this.containerRef;
    }
    scrollTo(value) {
        this.containerRef.scrollTo(0, value);
    }
    onScroll() {
        return this.$onScroll.asObservable();
    }
    open(template, dialogOptions) {
        this.overflow('hidden');
        return new $82Kdl.Observable((observer)=>{
            this.createModalPortal();
            if (dialogOptions) this.setSettings(dialogOptions);
            this.closeSubject$.pipe((0, $hgiLQ.take)(1)).subscribe((stream)=>{
                if (dialogOptions) this.setSettings(this.originalOptions);
                this.overflow('visible');
                observer.next(stream);
                observer.complete();
            });
            this.modalTemplate.next(template);
        });
    }
    openCustomModal(data, settings = {
        backdropClose: true
    }) {
        this.overflow('hidden');
        return this.openComponent($5YAWb.MainModalComponent, data, {
            backdropClose: settings.backdropClose,
            style: settings.style || (0, $eG1Pq.css)`
          .wrapper {
            position: fixed;
            top: 0;
            left: 0;
            align-items: center;
            justify-content: center;
            pointer-events: none;
            width: 100%;
            height: 100%;
            z-index: 200;
          }
          .content {
            width: 100%;
            height: 100%;
            z-index: 201;
            position: fixed;
            pointer-events: all;
          }
        `
        }).pipe((0, $37rZb.tap)(()=>this.overflow('visible')));
    }
    overflow(type) {
        if (this.options.hideScroll) document.body.style.overflow = type;
    }
    openComponent(component, options = {}, dialogOptions) {
        if (dialogOptions) this.setSettings(dialogOptions);
        this.overflow('hidden');
        return new $82Kdl.Observable((observer)=>{
            const tag = component.is;
            if (!tag) throw new Error('Provide static method `is` inside component or if you use regular html`` template use `open` method instead of `openComponent`');
            this.createModalPortal();
            $4XQlz.Container.remove($evplY.MODAL_DIALOG_DATA);
            $4XQlz.Container.set($evplY.MODAL_DIALOG_DATA, options);
            this.modalTemplate.next((0, $eG1Pq.html)` ${(0, $eG1Pq.unsafeHTML)(`<${tag()}></${tag()}>`)} `);
            this.closeSubject$.pipe((0, $hgiLQ.take)(1)).subscribe((stream)=>{
                if (dialogOptions) this.setSettings(this.originalOptions);
                observer.next(stream);
                this.overflow('visible');
                observer.complete();
            });
        });
    }
    setSettings(options) {
        $4XQlz.Container.remove($evplY.MODAL_DIALOG_OPTIONS);
        $4XQlz.Container.set($evplY.MODAL_DIALOG_OPTIONS, options);
    }
    openSequence(components) {
        const identity = (v)=>v;
        return (0, $8fifx.of)(components).pipe((0, $3XkaH.map)((val)=>val.map((v)=>this.openComponent(v.component, v.data, v.options))), (0, $h0UK9.concatMap)(identity), (0, $h0UK9.concatMap)(identity));
    }
    getTemplate() {
        return this.modalTemplate.asObservable();
    }
    getRef() {
        return this.modalRef;
    }
    close(result) {
        this.removeModalPortal();
        this.closeSubject$.next(result);
        this.closeSubject$.complete();
    }
    createModalContainer() {
        this.modalRef = document.createElement('modal-container');
    }
    appendReference() {
        document.body.appendChild(this.modalRef);
    }
    createModalPortal() {
        if (this.modalRef) this.removeModalPortal();
        this.closeSubject$.complete();
        this.closeSubject$ = new $35ZUd.Subject();
        this.createModalContainer();
        this.appendReference();
    }
    removeModalPortal() {
        this.modalRef.remove();
    }
};
module.exports.ModalService = $8c7f61eb8d17f82d$var$ModalService;
$8c7f61eb8d17f82d$var$__decorate([
    (0, $4XQlz.Injector)($evplY.MODAL_DIALOG_OPTIONS),
    $8c7f61eb8d17f82d$var$__metadata("design:type", Object)
], $8c7f61eb8d17f82d$var$ModalService.prototype, "options", void 0);
module.exports.ModalService = $8c7f61eb8d17f82d$var$ModalService = $8c7f61eb8d17f82d$var$__decorate([
    (0, $4XQlz.Injectable)(),
    $8c7f61eb8d17f82d$var$__metadata("design:paramtypes", [])
], $8c7f61eb8d17f82d$var$ModalService);

});
parcelRegister("evplY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MODAL_DIALOG_OPTIONS = module.exports.MODAL_DIALOG_DATA = void 0;

var $4XQlz = parcelRequire("4XQlz");
module.exports.MODAL_DIALOG_DATA = new $4XQlz.InjectionToken('rxdi-ui-kit-modal-data');
module.exports.MODAL_DIALOG_OPTIONS = new $4XQlz.InjectionToken('rxdi-ui-kit-modal-options');

});

parcelRegister("h0UK9", function(module, exports) {

$parcel$export(module.exports, "concatMap", () => $c62e73c930b76cc8$export$c28c8388be0ab31a);

var $hyQIa = parcelRequire("hyQIa");

var $1hO6f = parcelRequire("1hO6f");
function $c62e73c930b76cc8$export$c28c8388be0ab31a(project, resultSelector) {
    return (0, $1hO6f.isFunction)(resultSelector) ? (0, $hyQIa.mergeMap)(project, resultSelector, 1) : (0, $hyQIa.mergeMap)(project, 1);
}

});

parcelRegister("5YAWb", function(module, exports) {
"use strict";
var $459f355b1ed21c6a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $459f355b1ed21c6a$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MainModalComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");

var $4XQlz = parcelRequire("4XQlz");

var $c3REs = parcelRequire("c3REs");

var $evplY = parcelRequire("evplY");

var $9wkOj = parcelRequire("9wkOj");
let $459f355b1ed21c6a$var$MainModalComponent = class MainModalComponent extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.modalService = $4XQlz.Container.get($c3REs.ModalService);
    }
    OnUpdateFirst() {
        if (this.options.backdropClose) this.backdrop.addEventListener('click', ()=>this.close());
        this.modalService.setContainerRef(this.container);
    }
    close() {
        this.modalService.close();
    }
};
module.exports.MainModalComponent = $459f355b1ed21c6a$var$MainModalComponent;
$459f355b1ed21c6a$var$__decorate([
    (0, $4XQlz.Injector)($evplY.MODAL_DIALOG_DATA),
    $459f355b1ed21c6a$var$__metadata("design:type", Object)
], $459f355b1ed21c6a$var$MainModalComponent.prototype, "data", void 0);
$459f355b1ed21c6a$var$__decorate([
    (0, $4XQlz.Injector)($evplY.MODAL_DIALOG_OPTIONS),
    $459f355b1ed21c6a$var$__metadata("design:type", Object)
], $459f355b1ed21c6a$var$MainModalComponent.prototype, "options", void 0);
$459f355b1ed21c6a$var$__decorate([
    (0, $eG1Pq.query)('.backdrop'),
    $459f355b1ed21c6a$var$__metadata("design:type", HTMLElement)
], $459f355b1ed21c6a$var$MainModalComponent.prototype, "backdrop", void 0);
$459f355b1ed21c6a$var$__decorate([
    (0, $eG1Pq.query)('.container'),
    $459f355b1ed21c6a$var$__metadata("design:type", HTMLElement)
], $459f355b1ed21c6a$var$MainModalComponent.prototype, "container", void 0);
module.exports.MainModalComponent = $459f355b1ed21c6a$var$MainModalComponent = $459f355b1ed21c6a$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-modal-main',
        styles: [
            $9wkOj.style,
            $9wkOj.button
        ],
        template () {
            return (0, $eG1Pq.html)`
      <style>
        ${this.data.style}
      </style>
      <div class="container" @scroll=${(e)=>this.modalService.setScrollWidth(e.currentTarget.scrollTop)}>
        <div class="dialog">
          <button class="close-button" @click=${()=>this.close()}>
            ${(0, $eG1Pq.svg)`
              <svg width="14" height="14" viewBox="0 0 14 14">
                <line fill="none" stroke="#666" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"></line>
                <line fill="none" stroke="#666" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"></line>
              </svg>
            `}
          </button>
          ${this.data.template ? (0, $eG1Pq.html)`
                ${this.data.template}
              ` : (0, $eG1Pq.html)`
                <h1>${this.data.title}</h1>
                <p>
                  ${this.data.description}
                </p>
              `}
        </div>
      </div>
      <div class="backdrop"></div>
    `;
        }
    })
], $459f355b1ed21c6a$var$MainModalComponent);

});
parcelRegister("9wkOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.button = module.exports.style = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.style = (0, $eG1Pq.css)`

@keyframes scale {
   from {
    transform: scale(0);
   }
   to {
    transform: scale(1);
   }
  }

  @keyframes blur {
   to {
    backdrop-filter: blur(5px);
   }
  }

  .backdrop {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 10;
    animation: blur 0.3s linear forwards;
  }

  .container {
    padding: 50px 50px;

  }

  .dialog {
    position: relative;
    box-sizing: border-box;
    transform: translateY(0);
    margin: 0 auto;
    background: #fff;
    width: 600px;
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
      0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
    transition: 0.3s linear;
    transition-property: opacity, transform;
    max-width: calc(100% - 0.01px) !important;
    padding: 30px 30px;
    color: #666;
    z-index: 12;
    animation-name: scale;
   animation-duration: 300ms;
  }

  h1 {
    margin-top: 0;
    font-size: 30px;
    line-height: 1.3;
    margin: 0 0 0px 0;
    font-family: ProximaNova, -apple-system, BlinkMacSystemFont, 'Segoe UI',
      Roboto, 'Helvetica Neue', Arial, sans-serif;
    font-weight: 300;
    color: #222;
    text-transform: none;
  }

  .close-button {
    position: absolute;
    z-index: 1010;
    top: 10px;
    right: 10px;
    padding: 5px;
    border: none;
    cursor: pointer;
    text-transform: none;
    outline: none;
    background-color: transparent;
  }
  p {
    font-size: 15px;
    font-weight: normal;
    line-height: 1.5;
    color: #666;
  }
`;
module.exports.button = (0, $eG1Pq.css)`
  button {
    opacity: 0.7;
  }

  button:hover {
    opacity: 1;
  }
`;

});



parcelRegister("2wM9E", function(module, exports) {
"use strict";
var $1d73ec72f6d4b1a3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1d73ec72f6d4b1a3$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpinnerComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");

var $9390Y = parcelRequire("9390Y");
/**
 * @customElement rx-spinner
 */ let $1d73ec72f6d4b1a3$var$SpinnerComponent = class SpinnerComponent extends $eG1Pq.LitElement {
    constructor(){
        super(...arguments);
        this.speed = 2.4;
        this.color = '#666';
        this.width = 30;
        this.height = 30;
        this.stroke = 1;
    }
};
module.exports.SpinnerComponent = $1d73ec72f6d4b1a3$var$SpinnerComponent;
$1d73ec72f6d4b1a3$var$__decorate([
    (0, $eG1Pq.property)({
        type: Number
    }),
    $1d73ec72f6d4b1a3$var$__metadata("design:type", Object)
], $1d73ec72f6d4b1a3$var$SpinnerComponent.prototype, "speed", void 0);
$1d73ec72f6d4b1a3$var$__decorate([
    (0, $eG1Pq.property)({
        type: String
    }),
    $1d73ec72f6d4b1a3$var$__metadata("design:type", Object)
], $1d73ec72f6d4b1a3$var$SpinnerComponent.prototype, "color", void 0);
$1d73ec72f6d4b1a3$var$__decorate([
    (0, $eG1Pq.property)({
        type: Number
    }),
    $1d73ec72f6d4b1a3$var$__metadata("design:type", Object)
], $1d73ec72f6d4b1a3$var$SpinnerComponent.prototype, "width", void 0);
$1d73ec72f6d4b1a3$var$__decorate([
    (0, $eG1Pq.property)({
        type: Number
    }),
    $1d73ec72f6d4b1a3$var$__metadata("design:type", Object)
], $1d73ec72f6d4b1a3$var$SpinnerComponent.prototype, "height", void 0);
$1d73ec72f6d4b1a3$var$__decorate([
    (0, $eG1Pq.property)({
        type: Number
    }),
    $1d73ec72f6d4b1a3$var$__metadata("design:type", Object)
], $1d73ec72f6d4b1a3$var$SpinnerComponent.prototype, "stroke", void 0);
module.exports.SpinnerComponent = $1d73ec72f6d4b1a3$var$SpinnerComponent = $1d73ec72f6d4b1a3$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'rx-spinner',
        style: (0, $eG1Pq.css)`
    svg {
      vertical-align: middle;
    }

    .uk-spinner > * > * {
      stroke-dasharray: 88px;
      stroke-dashoffset: 0;
      transform-origin: center;


      stroke-linecap: round;
    }

    @keyframes uk-spinner-rotate {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(270deg);
      }
    }

    .uk-spinner > * > * {
      stroke-dasharray: 88px;
      stroke-dashoffset: 0;
      transform-origin: center;
      stroke-linecap: round;
    }

    @keyframes uk-spinner-dash {
      0% {
        stroke-dashoffset: 88px;
      }

      50% {
        stroke-dashoffset: 22px;
        transform: rotate(135deg);
      }

      100% {
        stroke-dashoffset: 88px;
        transform: rotate(450deg);
      }
    }
  `,
        template () {
            return (0, $eG1Pq.html)`
      <style>
        .uk-spinner > * {
          animation: uk-spinner-rotate ${(0, $eG1Pq.unsafeCSS)(this.speed)}s linear infinite;
        }

        .uk-spinner > * > * {
          stroke-width: var(--spinner-stroke-width, ${(0, $eG1Pq.unsafeCSS)(this.stroke)});
          animation: uk-spinner-dash ${(0, $eG1Pq.unsafeCSS)(this.speed)}s ease-in-out
            infinite;
          stroke: var(--spinner-stroke-color, ${(0, $eG1Pq.unsafeCSS)(this.color)});
        }
      </style>
      <div class="uk-icon uk-spinner" part="container">
        ${(0, $9390Y.Spinner)(this.width, this.height)}
      </div>
    `;
        }
    })
], $1d73ec72f6d4b1a3$var$SpinnerComponent);

});
parcelRegister("9390Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Spinner = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
// tslint:disable-next-line:max-line-length
const $696b63032b16b8f5$var$Spinner = (width, height)=>(0, $eG1Pq.svg)`<svg width=${width} height=${height} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" data-svg="spinner"><circle fill="none" stroke="#000" cx="15" cy="15" r="14"></circle></svg>`;
module.exports.Spinner = $696b63032b16b8f5$var$Spinner;

});


parcelRegister("jYHuY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Form = $e8b55cd1fd78a4d9$var$Form;

var $3CHs3 = parcelRequire("3CHs3");

var $rdCQr = parcelRequire("rdCQr");
function $e8b55cd1fd78a4d9$var$Form(options = {
    strategy: 'none'
}) {
    return function(clazz, name) {
        if (!options.name) throw new Error('Missing form name');
        const Destroy = clazz.constructor.prototype.disconnectedCallback || $3CHs3.noop;
        const UpdateFirst = clazz.constructor.prototype.firstUpdated || $3CHs3.noop;
        const Connect = clazz.constructor.prototype.connectedCallback || $3CHs3.noop;
        clazz.constructor.prototype.connectedCallback = function() {
            if (!(this[name] instanceof $rdCQr.FormGroup)) throw new Error('Value provided is not an instance of FormGroup!');
            this[name].setParentElement(this).setOptions(options).prepareValues();
            if (options.model && this[options.model]) this[name].patchValue(this[options.model]);
            return Connect.call(this);
        };
        clazz.constructor.prototype.firstUpdated = function() {
            /* Edge case for @rhtml/renderer */ const renderer = this.shadowRoot.querySelector('r-renderer');
            if (renderer) renderer.addEventListener('loaded', ()=>this[name].init());
            else this[name].init();
            return UpdateFirst.call(this);
        };
        clazz.constructor.prototype.disconnectedCallback = function() {
            this[name].unsubscribe();
            return Destroy.call(this);
        };
    };
}

});
parcelRegister("rdCQr", function(module, exports) {
"use strict";
var $051d177a379062d1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormGroup = void 0;

var $jS6MW = parcelRequire("jS6MW");

var $696L4 = parcelRequire("696L4");
var $3XkaH = parcelRequire("3XkaH");

var $3TyTd = parcelRequire("3TyTd");
class $051d177a379062d1$var$FormGroup {
    constructor(value, errors){
        this.validators = new Map();
        this.valid = true;
        this.invalid = false;
        this.errors = {};
        this.controls = new Map();
        this.errorMap = new Map();
        this.inputs = new Map();
        this.options = {};
        this.subscriptions = new Map();
        this._valueChanges = new $jS6MW.BehaviorSubject(value);
        if (value) Object.keys(value).forEach((key)=>{
            if (typeof value[key] === 'object' && value[key] !== null && (value[key]['controls'] || value[key]['push']) && value[key]['valueChanges']) {
                // It's likely a FormGroup or FormArray
                const control = value[key];
                if (control.name === '' || control.name === undefined) control.name = key;
                this.controls.set(key, control);
                if (control.valueChanges) this.subscriptions.set(key, control.valueChanges.subscribe(()=>{
                    this._valueChanges.next(this.value);
                }));
            }
        });
        this.prepareValues();
    }
    init() {
        if (!this.parentElement) return;
        this.setFormElement(this.querySelectForm(this.parentElement.shadowRoot || this.parentElement)).setInputs(this.mapEventToInputs(this.querySelectorAllInputs()));
        this.controls.forEach((c)=>{
            var _a;
            (_a = c.init) === null || _a === void 0 || _a.call(c);
        });
    }
    prepareValues() {
        Object.keys(this.value).forEach((v)=>{
            // Skip nested controls
            if (this.controls.has(v)) return;
            const value = this.value[v];
            this.errors[v] = this.errors[v] || {};
            if (value && value.constructor === Array) {
                if (value[1] && value[1].constructor === Array) value[1].forEach((val)=>{
                    const oldValidators = this.validators.get(v) || [];
                    this.validators.set(v, [
                        ...oldValidators,
                        val
                    ]);
                });
                if (value[0] === undefined || value[0] === null) this.value[v] = '';
                else if (value[0].constructor === String || value[0].constructor === Number || value[0].constructor === Boolean || value[0].constructor === Array) this.value[v] = value[0];
                else throw new Error(`Input value must be of type 'string', 'boolean', 'array' or 'number'`);
            }
        });
        return this;
    }
    setParentElement(parent) {
        this.parentElement = parent;
        this.controls.forEach((c)=>{
            var _a;
            (_a = c.setParentElement) === null || _a === void 0 || _a.call(c, parent);
        });
        return this;
    }
    getParentElement() {
        return this.parentElement;
    }
    setOptions(options) {
        this.options = options;
        this.controls.forEach((c)=>{
            var _a;
            (_a = c.setOptions) === null || _a === void 0 || _a.call(c, Object.assign(Object.assign({}, options), {
                namespace: this.options.namespace ? `${this.options.namespace}.${c.name}` : c.name
            }));
        });
        return this;
    }
    getOptions() {
        return this.options;
    }
    get valueChanges() {
        return this._valueChanges.asObservable();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateValueAndValidity() {
        return $051d177a379062d1$var$__awaiter(this, void 0, void 0, function*() {
            this.resetErrors();
            const inputs = yield Promise.all(this.querySelectorAllInputs().map((i)=>$051d177a379062d1$var$__awaiter(this, void 0, void 0, function*() {
                    i.setCustomValidity('');
                    this.setElementValidity(i);
                    this.setElementDirty(i);
                    return yield this.validate(i);
                })));
            const inputsWithErrors = inputs.filter((e)=>e.errors.length);
            const nestedErrors = [];
            for (const [key, control] of this.controls.entries())if (control.updateValueAndValidity) {
                const result = yield control.updateValueAndValidity();
                if (control.invalid) {
                    this.invalid = true;
                    this.valid = false;
                    if (Array.isArray(result)) nestedErrors.push(...result);
                }
            }
            this.getParentElement().requestUpdate();
            return [
                ...inputsWithErrors,
                ...nestedErrors
            ];
        });
    }
    updateValueAndValidityOnEvent(method) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        return function(event) {
            return $051d177a379062d1$var$__awaiter(this, void 0, void 0, function*() {
                self.setElementDirty(this);
                const selector = `input[name="${this.name}"]`;
                const hasMultipleBindings = [
                    ...self.getFormElement().querySelectorAll(selector).values()
                ].length;
                let value = this.value;
                if (hasMultipleBindings === 1) {
                    if (this.type === 'radio') value = String(this.checked);
                    if (this.type === 'checkbox') value = this.checked;
                }
                if (this.type === 'number') {
                    let val = Number(value);
                    const maxAttr = this.getAttribute('max');
                    if (maxAttr) {
                        const max = Number(maxAttr);
                        if (!isNaN(max) && val > max) {
                            val = max;
                            this.value = String(val);
                        }
                    }
                    const minAttr = this.getAttribute('min');
                    if (minAttr) {
                        const min = Number(minAttr);
                        if (!isNaN(min) && val < min) {
                            val = min;
                            this.value = String(val);
                        }
                    }
                    value = val;
                }
                const inputsWithBindings = [
                    ...self.getFormElement().querySelectorAll(`input[name="${this.name}"]:checked`).values()
                ];
                if (hasMultipleBindings > 1) {
                    if ((self.options.multi || this.hasAttribute('multiple')) && this.type === 'checkbox') value = inputsWithBindings.map((e)=>e.value);
                    if (!self.options.multi && !this.hasAttribute('multiple') && this.type === 'checkbox') {
                        inputsWithBindings.forEach((el)=>{
                            if (el !== this) el.checked = false;
                        });
                        this.checked = true;
                        value = this.value;
                    }
                }
                self.resetErrors();
                const isValid = self.applyValidationContext((yield self.validate(this)));
                if (self.options.strict) {
                    if (isValid) {
                        yield self.setElementValidity(this, isValid);
                        self.setValue(self.getModelKeyName(this.name), value);
                    }
                    self.parentElement.requestUpdate();
                    return method.call(self.parentElement, event);
                }
                yield self.setElementValidity(this, isValid);
                self.setValue(self.getModelKeyName(this.name), value);
                self.parentElement.requestUpdate();
                return method.call(self.parentElement, event);
            });
        };
    }
    applyValidationContext({ errors: errors, element: element }) {
        const form = this.getFormElement();
        if (errors.length) {
            this.invalid = form['invalid'] = true;
            this.valid = form['valid'] = false;
            return false;
        } else {
            this.errors[this.getModelKeyName(element.name)] = {};
            this.invalid = form['invalid'] = !form.checkValidity();
            this.valid = form['valid'] = form.checkValidity();
            return true;
        }
    }
    querySelectForm(shadowRoot) {
        if (this.options['form']) return this.options['form'];
        if (!(shadowRoot === null || shadowRoot === void 0 ? void 0 : shadowRoot.querySelector)) return null;
        const form = shadowRoot.querySelector(`form[name="${this.options.name}"]`);
        if (!form) throw new Error(`Form element with name "${this.options.name}" not present inside ${this.getParentElement().outerHTML} component`);
        form.addEventListener('submit', (e)=>{
            e.preventDefault();
            e.stopPropagation();
        });
        return form;
    }
    querySelectAll(name) {
        return [
            ...this.form.querySelectorAll(name).values()
        ];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    querySelectorAllInputs() {
        const customElements = this.options.customElements.map((v)=>typeof v === 'string' ? v : typeof v === 'function' ? v.is() : v);
        return [
            ...customElements !== null && customElements !== void 0 ? customElements : [],
            'input',
            'select',
            'textarea'
        ].map((item)=>this.querySelectAll(item)).flat().filter((el)=>this.isInputPresentOnStage(el)).filter((el)=>!!el.name);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapEventToInputs(inputs = []) {
        return inputs.map((el)=>{
            const strategy = `on${this.options.strategy}`;
            if (!el[strategy]) el[strategy] = function() {
            //
            };
            const customAttributes = Object.keys(el.attributes).map((k)=>el.attributes[k].name.startsWith('#') ? el.attributes[k] : null).filter((i)=>!!i);
            if (customAttributes.length) {
                const attr = customAttributes.find((a)=>a.name.startsWith('#'));
                this.parentElement[attr.name.replace('#', '')] = el;
            }
            if (!el._bound) {
                el.addEventListener('blur', ()=>$051d177a379062d1$var$__awaiter(this, void 0, void 0, function*() {
                        this.setElementDirty(el);
                        yield this.parentElement.requestUpdate();
                        yield this.setElementValidity(el);
                    }));
                el[strategy] = this.updateValueAndValidityOnEvent(el[strategy]);
                el._bound = true;
            }
            return el;
        });
    }
    setElementValidity(el, validity) {
        return $051d177a379062d1$var$__awaiter(this, void 0, void 0, function*() {
            const isValid = validity || this.applyValidationContext((yield this.validate(el)));
            el['valid'] = isValid;
            el['invalid'] = !isValid;
        });
    }
    setElementDirty(input) {
        input['touched'] = true;
        input['dirty'] = true;
    }
    isInputPresentOnStage(input) {
        if (input.outerHTML === '<input type="submit" style="display: none;">') return 0;
        const keyIndex = this.getModelKeyName(input.name);
        const isInputPresent = Object.keys(this.value).filter((v)=>v === keyIndex);
        return isInputPresent.length;
    }
    getModelKeyName(domName) {
        if (this.options['namespace']) {
            // pattern: namespace[key] or namespace.key
            // Example: allowedIps[0].ip -> namespace=allowedIps[0] -> key=ip
            if (domName.startsWith(this.options['namespace'])) {
                const suffix = domName.replace(this.options['namespace'], '');
                // Handle .key or [key]
                if (suffix.startsWith('.')) return suffix.substring(1);
                if (suffix.startsWith('[')) return suffix.substring(1, suffix.length - 1); // Not dealing with that yet
            }
            return domName;
        }
        return domName;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validate(element) {
        return $051d177a379062d1$var$__awaiter(this, void 0, void 0, function*() {
            let errors = [];
            if (typeof element.setCustomValidity === 'function') element.setCustomValidity('');
            if (typeof element.checkValidity === 'function' && !element.checkValidity()) return {
                errors: errors.concat(Object.keys($3TyTd.InputValidityState).map((key)=>element.validity[key] ? {
                        key: key,
                        message: element.validationMessage
                    } : null).filter((i)=>!!i)),
                element: element
            };
            errors = yield this.mapInputErrors(element);
            if (!errors.length) return {
                errors: [],
                element: element
            };
            element.setCustomValidity(errors[0].message);
            return {
                element: element,
                errors: errors
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapInputErrors(element) {
        return $051d177a379062d1$var$__awaiter(this, void 0, void 0, function*() {
            const modelKey = this.getModelKeyName(element.name);
            const res = yield Promise.all((this.validators.get(modelKey) || []).map((v)=>$051d177a379062d1$var$__awaiter(this, void 0, void 0, function*() {
                    this.errors[modelKey] = this.errors[modelKey] || {};
                    const error = yield v.bind(this.getParentElement())(element);
                    // if (error) {
                    //   element.focus();
                    // }
                    if (error && error.key) {
                        this.errors[modelKey][error.key] = error.message;
                        this.errorMap.set(v, error.key);
                        return {
                            key: error.key,
                            message: error.message
                        };
                    } else if (this.errorMap.has(v)) delete this.errors[modelKey][this.errorMap.get(v)];
                })));
            return res.filter((i)=>!!i);
        });
    }
    get(name) {
        if (this.controls.has(name)) return this.controls.get(name);
        if (String(name).includes('.')) {
            const names = String(name).split('.');
            const key = names.shift();
            const control = this.controls.get(key);
            if (control === null || control === void 0 ? void 0 : control.get) return control.get(names.join('.'));
        }
        const input = this.inputs.get(name);
        if (input) return input;
        /*
          If a user tries to subscribe on a constructor level or before the inputs are inside the DOM
          We create a fake Virtual Input so later on when elements present on stage to get the same subscription
        */ const key = name;
        // Check if key exists in the model value even if not in inputs map
        if (this._valueChanges.getValue() && key in this._valueChanges.getValue()) // Create a "Virtual" AbstractInput to prevent crashes and allow subscription even if no DOM element present
        return {
            valueChanges: this._valueChanges.pipe((0, $3XkaH.map)((value)=>value === null || value === void 0 ? void 0 : value[key]), (0, $696L4.distinctUntilChanged)()),
            value: this.getValue(key),
            name: String(key),
            valid: true,
            invalid: false,
            dirty: false,
            touched: false,
            // Mock HTMLInputElement properties to satisfy interface if needed
            type: 'text',
            checked: false,
            disabled: false
        };
        return undefined;
    }
    getError(inputName, errorKey) {
        return this.errors[inputName][errorKey];
    }
    hasError(inputName, errorKey) {
        return !!this.getError(inputName, errorKey);
    }
    reset() {
        this.form.reset();
        this.resetErrors();
        this.setFormValidity();
        this.inputs.clear();
    }
    setFormValidity(validity = true) {
        this.valid = validity;
        this.invalid = !validity;
        this.getParentElement().requestUpdate();
    }
    resetErrors() {
        this.errors = Object.keys(this.errors).reduce((object, key)=>{
            object[key] = {};
            return object;
        }, {});
        this.errorMap.clear();
    }
    get value() {
        const values = this._valueChanges.getValue();
        this.controls.forEach((control, key)=>{
            values[key] = control.value;
        });
        return values;
    }
    set value(value) {
        this._valueChanges.next(value);
    }
    unsubscribe() {
        this.reset();
        this._valueChanges.unsubscribe();
        this.subscriptions.forEach((s)=>s.unsubscribe());
        this.subscriptions.clear();
        this.controls.forEach((c)=>{
            var _a;
            return (_a = c.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(c);
        });
    }
    getValue(name) {
        return this.value[name];
    }
    patchValue(value) {
        if (!value) return;
        Object.keys(value).forEach((key)=>{
            const control = this.controls.get(key);
            if (control === null || control === void 0 ? void 0 : control.patchValue) control.patchValue(value[key]);
            else this.setValue(key, value[key]);
        });
    }
    setValue(name, value) {
        const input = this.get(name);
        input;
        if (input && input.value !== undefined && input.type !== 'checkbox' && input.type !== 'radio') input.value = value;
        const values = this.value;
        values[name] = value;
        this.value = values;
    }
    setFormValue(value) {
        this.value = value;
    }
    setFormElement(form) {
        this.form = form;
        this.controls.forEach((c)=>{
            var _a;
            (_a = c.setFormElement) === null || _a === void 0 || _a.call(c, form);
        });
        return this;
    }
    setInputs(inputs) {
        this.inputs = new Map(inputs.map((e)=>{
            const key = this.getModelKeyName(e.name);
            const modelValue = this.getValue(key);
            if (e.type === 'checkbox' || e.type === 'radio') {
                if (Array.isArray(modelValue)) e.checked = modelValue.includes(e.value);
                else if (typeof modelValue === 'boolean') e.checked = modelValue;
                else e.checked = modelValue === e.value;
            } else e.value = modelValue;
            e.valueChanges = this._valueChanges.pipe((0, $3XkaH.map)((value)=>value === null || value === void 0 ? void 0 : value[key]), (0, $696L4.distinctUntilChanged)());
            return [
                key,
                e
            ];
        }));
    }
    getFormElement() {
        return this.form;
    }
}
module.exports.FormGroup = $051d177a379062d1$var$FormGroup;

});
parcelRegister("696L4", function(module, exports) {

$parcel$export(module.exports, "distinctUntilChanged", () => $4798d3658ae255d9$export$779c5fb865a0172e);

var $4YhJE = parcelRequire("4YhJE");

var $4J4s9 = parcelRequire("4J4s9");

var $fyrlr = parcelRequire("fyrlr");
function $4798d3658ae255d9$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $4YhJE.identity);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $4798d3658ae255d9$var$defaultCompare;
    return (0, $4J4s9.operate)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $4798d3658ae255d9$var$defaultCompare(a, b) {
    return a === b;
}

});

parcelRegister("3TyTd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputValidityState = void 0;
function $2d6192788f0a0228$var$strEnum(o) {
    return o.reduce((res, key)=>{
        res[key] = key;
        return res;
    }, Object.create(null));
}
module.exports.InputValidityState = $2d6192788f0a0228$var$strEnum([
    'badInput',
    'customError',
    'patternMismatch',
    'rangeOverflow',
    'rangeUnderflow',
    'stepMismatch',
    'tooLong',
    'tooShort',
    'typeMismatch',
    'valid',
    'valueMissing'
]);

});



parcelRegister("dnEcI", function(module, exports) {
"use strict";
var $9bdc9c07ed6aa229$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormArray = void 0;

var $jS6MW = parcelRequire("jS6MW");
class $9bdc9c07ed6aa229$var$FormArray {
    constructor(controls = [], nameOrOptions = ''){
        this.controls = [];
        this.valid = true;
        this.invalid = false;
        this.errors = {};
        this.options = {};
        this.subscriptions = new Map();
        this.controls = controls;
        if (typeof nameOrOptions === 'string') this.name = nameOrOptions;
        else if (typeof nameOrOptions === 'function') this.options = {
            itemFactory: nameOrOptions
        };
        else this.options = nameOrOptions;
        this._valueChanges = new $jS6MW.BehaviorSubject(this.value);
        this.valueChanges = this._valueChanges;
        this.controls.forEach((c)=>this.subscribeToControl(c));
    }
    get value() {
        return this.controls.map((c)=>c.value);
    }
    getOptions() {
        return this.options;
    }
    setOptions(options) {
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.controls.forEach((c, index)=>{
            c.setOptions(Object.assign(Object.assign({}, options), {
                namespace: `${this.name}[${index}]`
            }));
        });
    }
    push(control) {
        return $9bdc9c07ed6aa229$var$__awaiter(this, void 0, void 0, function*() {
            this.controls.push(control);
            this.subscribeToControl(control);
            const index = this.controls.length - 1;
            control.setOptions(Object.assign(Object.assign(Object.assign({}, this.options), control.getOptions()), {
                namespace: `${this.name}[${index}]`
            }));
            this.updateValue();
            this.requestUpdate();
            if (this.parentElement) {
                yield this.parentElement.updateComplete;
                control.setParentElement(this.parentElement);
                if (this.form) {
                    control.setFormElement(this.form);
                    control.init();
                } else if (control.getFormElement()) control.init();
                else if (this.controls[0] && this.controls[0].getFormElement()) {
                    control.setFormElement(this.controls[0].getFormElement());
                    control.init();
                }
            }
        });
    }
    removeAt(index) {
        const control = this.controls[index];
        if (this.subscriptions.has(control)) {
            this.subscriptions.get(control).unsubscribe();
            this.subscriptions.delete(control);
        }
        this.controls.splice(index, 1);
        this.updateValue();
        this.requestUpdate();
    }
    subscribeToControl(control) {
        if (control.valueChanges) this.subscriptions.set(control, control.valueChanges.subscribe(()=>{
            this.updateValue();
        }));
    }
    unsubscribe() {
        this.subscriptions.forEach((sub)=>sub.unsubscribe());
        this.subscriptions.clear();
        this.controls.forEach((c)=>{
            var _a;
            return (_a = c.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(c);
        });
    }
    updateValue() {
        this._valueChanges.next(this.value);
    }
    requestUpdate() {
        var _a;
        (_a = this.parentElement) === null || _a === void 0 || _a.requestUpdate();
    }
    setParentElement(parent) {
        this.parentElement = parent;
        this.controls.forEach((c)=>c.setParentElement(parent));
    }
    setFormElement(form) {
        this.form = form;
        this.controls.forEach((c)=>c.setFormElement(form));
    }
    init() {
        this.controls.forEach((c)=>c.init());
    }
    getParentElement() {
        return this.parentElement;
    }
    // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set value(values) {
        if (!Array.isArray(values)) return;
        values.forEach((v, i)=>{
            this.controls[i] && (this.controls[i].value = v);
        });
        this.updateValue();
    }
    patchValue(values) {
        if (!Array.isArray(values)) return;
        values.forEach((v, i)=>{
            const control = this.controls[i];
            if (control) control.patchValue ? control.patchValue(v) : control.value = v;
            else if (this.options.itemFactory) this.push(this.options.itemFactory(v));
        });
        this.updateValue();
    }
    updateValueAndValidity() {
        return $9bdc9c07ed6aa229$var$__awaiter(this, void 0, void 0, function*() {
            this.valid = true;
            this.invalid = false;
            this.errors = {};
            const errors = [];
            for (const [index, control] of this.controls.entries())if (control.updateValueAndValidity) {
                const result = yield control.updateValueAndValidity();
                if (control.invalid) {
                    this.valid = false;
                    this.invalid = true;
                    this.errors[index] = result;
                    errors.push(...result);
                }
            }
            return errors;
        });
    }
}
module.exports.FormArray = $9bdc9c07ed6aa229$var$FormArray;

});

parcelRegister("czGZi", function(module, exports) {
$parcel$export(module.exports, "ScrollToService", () => (parcelRequire("56Yze")).ScrollToService);
$parcel$export(module.exports, "DateTimeProvider", () => (parcelRequire("iB2Sj")).DateTimeProvider);
$parcel$export(module.exports, "ModalViewService", () => (parcelRequire("9heTP")).ModalViewService);
parcelRequire("d7Rrd");
parcelRequire("j0yXv");
parcelRequire("lpJ2G");

});
parcelRegister("d7Rrd", function(module, exports) {
$parcel$export(module.exports, "ScrollToService", () => (parcelRequire("56Yze")).ScrollToService);
parcelRequire("56Yze");

});
parcelRegister("56Yze", function(module, exports) {

$parcel$export(module.exports, "ScrollToService", () => $5b8417848c6efbd5$export$b8181c9bd6f9601f);

var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");
class $5b8417848c6efbd5$export$b8181c9bd6f9601f {
    #elements;
    scrollToElement(elementName) {
        this.#elements.find((el)=>el.localName === elementName)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
    setElements(elements) {
        this.#elements = elements;
    }
}
$5b8417848c6efbd5$export$b8181c9bd6f9601f = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)()
], $5b8417848c6efbd5$export$b8181c9bd6f9601f);

});


parcelRegister("j0yXv", function(module, exports) {
$parcel$export(module.exports, "DateTimeProvider", () => (parcelRequire("iB2Sj")).DateTimeProvider);
parcelRequire("iB2Sj");

});
parcelRegister("iB2Sj", function(module, exports) {

$parcel$export(module.exports, "DateTimeProvider", () => $138e84f3b665b7bc$export$761b8f8bbc165703);

var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");
class $138e84f3b665b7bc$export$761b8f8bbc165703 {
    getDate(dateString) {
        const date = new Date(dateString || Date.now());
        const year = new Intl.DateTimeFormat('en', {
            year: 'numeric'
        }).format(date);
        const month = new Intl.DateTimeFormat('en', {
            month: 'short'
        }).format(date);
        const day = new Intl.DateTimeFormat('en', {
            day: '2-digit'
        }).format(date);
        return `${day}-${month}-${year}`;
    }
    getCommentDate(dateString) {
        const date = new Date(dateString || Date.now());
        const year = new Intl.DateTimeFormat('en', {
            year: 'numeric'
        }).format(date);
        const month = new Intl.DateTimeFormat('en', {
            month: 'short'
        }).format(date);
        const day = new Intl.DateTimeFormat('en', {
            day: '2-digit'
        }).format(date);
        const time = new Intl.DateTimeFormat('en', {
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
        return `${month} ${day}, ${year} at ${time}`;
    }
    getPostDate(dateString) {
        const date = new Date(dateString || Date.now());
        const year = new Intl.DateTimeFormat('en', {
            year: 'numeric'
        }).format(date);
        const month = new Intl.DateTimeFormat('en', {
            month: 'short'
        }).format(date);
        const day = new Intl.DateTimeFormat('en', {
            day: '2-digit'
        }).format(date);
        const time = new Intl.DateTimeFormat('en', {
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
        return `${month} ${day} ${year}`;
    }
    getDueDate(dateString = Date.now().toString()) {
        const date = new Date(dateString || Date.now());
        const year = new Intl.DateTimeFormat('en', {
            year: 'numeric'
        }).format(date);
        const month = new Intl.DateTimeFormat('en', {
            month: '2-digit'
        }).format(date);
        const day = new Intl.DateTimeFormat('en', {
            day: '2-digit'
        }).format(date);
        return `${month}/${day}/${year}`;
    }
    getHours(dateString) {
        return `${new Date(dateString).toLocaleTimeString(navigator.language, {
            hour: '2-digit',
            minute: '2-digit'
        })}`;
    }
    timeSince(time) {
        switch(typeof time){
            case 'number':
                break;
            case 'string':
                time = +new Date(time);
                break;
            case 'object':
                if (time.constructor === Date) time = time.getTime();
                break;
            default:
                time = +new Date();
        }
        const time_formats = [
            [
                60,
                'seconds',
                1
            ],
            [
                120,
                '1 minute ago',
                '1 minute from now'
            ],
            [
                3600,
                'minutes',
                60
            ],
            [
                7200,
                '1 hour ago',
                '1 hour from now'
            ],
            [
                86400,
                'hours',
                3600
            ],
            [
                172800,
                'Yesterday',
                'Tomorrow'
            ],
            [
                604800,
                'days',
                86400
            ],
            [
                1209600,
                'Last week',
                'Next week'
            ],
            [
                2419200,
                'weeks',
                604800
            ],
            [
                4838400,
                'Last month',
                'Next month'
            ],
            [
                29030400,
                'months',
                2419200
            ],
            [
                58060800,
                'Last year',
                'Next year'
            ],
            [
                2903040000,
                'years',
                29030400
            ],
            [
                5806080000,
                'Last century',
                'Next century'
            ],
            [
                58060800000,
                'centuries',
                2903040000
            ]
        ];
        let seconds = (+new Date() - time) / 1000, token = 'ago', list_choice = 1;
        if (seconds == 0) return 'Just now';
        if (seconds < 0) {
            seconds = Math.abs(seconds);
            token = 'from now';
            list_choice = 2;
        }
        let i = 0;
        let format;
        while(format = time_formats[i++])if (seconds < Number(format[0])) {
            if (typeof format[2] == 'string') return format[list_choice];
            else return Math.floor(seconds / Number(format[2])) + ' ' + format[1] + ' ' + token;
        }
        return time;
    }
}
$138e84f3b665b7bc$export$761b8f8bbc165703 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)()
], $138e84f3b665b7bc$export$761b8f8bbc165703);

});


parcelRegister("lpJ2G", function(module, exports) {
$parcel$export(module.exports, "ModalViewService", () => (parcelRequire("9heTP")).ModalViewService);
parcelRequire("9heTP");

});
parcelRegister("9heTP", function(module, exports) {

$parcel$export(module.exports, "ModalViewService", () => $96b9353831bec1e6$export$6e46589a054262b9);

var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");

var $9h1ql = parcelRequire("9h1ql");
class $96b9353831bec1e6$export$6e46589a054262b9 {
    openCustomModal() {
        return this.modalService.openCustomModal({
            title: `Default`,
            description: `
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
          ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
          `
        }, {
            backdropClose: true
        });
    }
    openBasicModal() {
        return this.modalService.open((0, $eG1Pq.html)`
        <div style="text-align: right;padding: 20px 20px;">
          <rx-button palette="primary" @click=${()=>this.modalService.close()}>Close</rx-button>
        </div>
      `);
    }
    openSelectCategoryModal(model = null, categories) {
        return this.modalService.openCustomModal({
            style: (0, $eG1Pq.css)`
          .dialog {
            padding: 0 !important;
          }
        `,
            template: (0, $eG1Pq.html)`<category-forms
          .model=${model}
          .categories=${categories}
          @submitted=${(e)=>this.modalService.close(e.detail)}
        ></category-forms>`
        }, {
            backdropClose: false
        });
    }
    openCreateCategoryModal(model = null, categories) {
        return this.modalService.openCustomModal({
            style: (0, $eG1Pq.css)`
          .dialog {
            padding: 0 !important;
          }
        `,
            template: (0, $eG1Pq.html)`<create-category-forms
          .model=${model}
          .categories=${categories}
          @submitted=${(e)=>this.modalService.close(e.detail)}
        ></create-category-forms>`
        }, {
            backdropClose: false
        });
    }
    openCustomMainModal() {
        return this.modalService.openCustomModal({
            template: (0, $eG1Pq.html)`
          <div style="padding: 15px 30px;border-bottom: 1px solid #e5e5e5;">
            <h1>Custom modal</h1>
          </div>
          <div style="padding: 10px 30px 10px 30px; border-bottom: 1px solid #e5e5e5;">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
              ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
              fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
              mollit anim id est laborum.
            </p>
          </div>
          <div style="text-align: right;padding: 20px 20px;">
            <rx-button @click=${()=>this.modalService.close()}>Cancel</rx-button>
            <rx-button palette="primary">Save</rx-button>
          </div>
        `,
            style: (0, $eG1Pq.css)`
          .dialog {
            padding: 0 !important;
          }
        `
        }, {
            backdropClose: false
        });
    }
    openOverflowCustomModal() {
        return this.modalService.openCustomModal({
            template: (0, $eG1Pq.html)`
          <div style="padding: 15px 30px;border-bottom: 1px solid #e5e5e5;">
            <h1>Overflow</h1>
          </div>
          <div class="content">
            <p>gagaga</p>
          </div>
          <div style="text-align: right;padding: 20px 20px;">
            <rx-button @click=${()=>this.modalService.close()}>Cancel</rx-button>
            <rx-button palette="warning">Save</rx-button>
          </div>
        `,
            style: (0, $eG1Pq.css)`
          .dialog {
            padding: 0 !important;
          }
          .content {
            padding: 10px 30px 10px 30px;
            border-bottom: 1px solid #e5e5e5;
            overflow: auto;
            min-height: 150px;
            max-height: 555px;
          }
        `
        }, {
            backdropClose: true
        });
    }
    openFullScreenModal() {
        return this.modalService.openCustomModal({
            template: (0, $eG1Pq.html)`
          <div class="flex-grid">
            <img src="https://getuikit.com/docs/images/photo.jpg" />
            <h1>Full-screen modal</h1>
          </div>
        `,
            style: (0, $eG1Pq.css)`
          .container {
            padding: 0px !important;
          }
          .flex-grid {
            display: flex;
            flex-wrap: wrap;
            margin: 0;
            padding: 0;
            list-style: none;
          }
          img {
            background-position: 50% 50%;
            background-repeat: no-repeat;
            width: 50%;
            min-height: calc(100vh);
            box-sizing: border-box;
            background-size: cover;
          }
          .dialog {
            padding: 0 !important;
            width: 100% !important;
            height: 100% !important;
          }

          .container {
            height: 100%;
          }
        `
        }, {
            backdropClose: false
        });
    }
}
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $9h1ql.ModalService))
], $96b9353831bec1e6$export$6e46589a054262b9.prototype, "modalService", void 0);
$96b9353831bec1e6$export$6e46589a054262b9 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)()
], $96b9353831bec1e6$export$6e46589a054262b9);

});
parcelRegister("9h1ql", function(module, exports) {
"use strict";
var $6c06ce58d702d623$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6c06ce58d702d623$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6c06ce58d702d623$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6c06ce58d702d623$var$__createBinding(exports1, m, p);
};
var $6c06ce58d702d623$var$ModalModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalModule = void 0;

var $4XQlz = parcelRequire("4XQlz");


var $xTZLh = parcelRequire("xTZLh");

var $evplY = parcelRequire("evplY");

var $iv28h = parcelRequire("iv28h");
let $6c06ce58d702d623$var$ModalModule = $6c06ce58d702d623$var$ModalModule_1 = class ModalModule {
    static forRoot(options = {}) {
        if (!options.style) options.style = $iv28h.defaultModalStyle;
        return {
            module: $6c06ce58d702d623$var$ModalModule_1,
            providers: [
                (parcelRequire("c3REs")).ModalService,
                {
                    provide: $evplY.MODAL_DIALOG_OPTIONS,
                    useValue: options
                }
            ],
            components: [
                $xTZLh.ModalContainerComponent
            ]
        };
    }
};
module.exports.ModalModule = $6c06ce58d702d623$var$ModalModule;
module.exports.ModalModule = $6c06ce58d702d623$var$ModalModule = $6c06ce58d702d623$var$ModalModule_1 = $6c06ce58d702d623$var$__decorate([
    (0, $4XQlz.Module)()
], $6c06ce58d702d623$var$ModalModule);

$6c06ce58d702d623$var$__exportStar((parcelRequire("c3REs")), module.exports);

});
parcelRegister("xTZLh", function(module, exports) {
"use strict";
var $065e84a73ed4b34e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $065e84a73ed4b34e$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalContainerComponent = void 0;

var $eG1Pq = parcelRequire("eG1Pq");

var $4XQlz = parcelRequire("4XQlz");

var $c3REs = parcelRequire("c3REs");

var $evplY = parcelRequire("evplY");
let $065e84a73ed4b34e$var$ModalContainerComponent = class ModalContainerComponent extends $eG1Pq.LitElement {
    OnInit() {
        this.template = this.modalService.getTemplate();
    }
};
module.exports.ModalContainerComponent = $065e84a73ed4b34e$var$ModalContainerComponent;
$065e84a73ed4b34e$var$__decorate([
    (0, $4XQlz.Inject)($c3REs.ModalService),
    $065e84a73ed4b34e$var$__metadata("design:type", $c3REs.ModalService)
], $065e84a73ed4b34e$var$ModalContainerComponent.prototype, "modalService", void 0);
$065e84a73ed4b34e$var$__decorate([
    (0, $4XQlz.Injector)($evplY.MODAL_DIALOG_OPTIONS),
    $065e84a73ed4b34e$var$__metadata("design:type", Object)
], $065e84a73ed4b34e$var$ModalContainerComponent.prototype, "options", void 0);
module.exports.ModalContainerComponent = $065e84a73ed4b34e$var$ModalContainerComponent = $065e84a73ed4b34e$var$__decorate([
    (0, $eG1Pq.Component)({
        selector: 'modal-container',
        template () {
            return (0, $eG1Pq.html)`
      <style>
        ${this.options.style}
      </style>
      <div class="wrapper">
        <div class="content">${(0, $eG1Pq.async)(this.template)}</div>
        <div
          @click=${()=>this.options.backdropClose && this.modalService.close()}
          class="backdrop"
        ></div>
      </div>
    `;
        }
    })
], $065e84a73ed4b34e$var$ModalContainerComponent);

});

parcelRegister("iv28h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultModalStyle = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
module.exports.defaultModalStyle = (0, $eG1Pq.css)`
  .wrapper {
    position: absolute;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }

  .backdrop {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    pointer-events: all;
    z-index: 10;
  }

  .content {
    z-index: 20;
    position: absolute;
    /* width: 100%; */
    /* height: 100%; */
    pointer-events: all;
  }
`;

});





parcelRegister("itgC7", function(module, exports) {
"use strict";
var $d727d29830cb4c09$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Component = module.exports.Partial = module.exports.DefineDependencies = void 0;
parcelRequire("a7Qz2");

var $eG1Pq = parcelRequire("eG1Pq");
const $d727d29830cb4c09$var$DefineDependencies = (...deps)=>(injection)=>{
        for (const [index, dep] of deps.entries())Object.defineProperty(deps, index, {
            get: ()=>(injection === null || injection === void 0 ? void 0 : injection.has(dep)) ? injection.get(dep) : dep
        });
        return deps;
    };
module.exports.DefineDependencies = $d727d29830cb4c09$var$DefineDependencies;
/**
 * This method waits for the parent component to finish loading and then triggers event
 * OnRendererLoaded is a specially designed hook to wait for the last dom rerender
 * before calling the callback
 */ function $d727d29830cb4c09$var$waitBeforeTrigger() {
    var _a;
    return $d727d29830cb4c09$var$__awaiter(this, void 0, void 0, function*() {
        yield this.updateComplete;
        yield new Promise(requestAnimationFrame);
        (_a = this.OnRendererLoaded) === null || _a === void 0 || _a.call(this);
    });
}
const $d727d29830cb4c09$var$Partial = (options)=>(deps = [])=>(state = ()=>({}))=>(loading = ()=>null)=>(error = ()=>null)=>(render = ()=>state)=>(0, $eG1Pq.Component)(Object.assign(Object.assign({}, options), {
                            template () {
                                return (0, $eG1Pq.html)`
          <r-renderer
            style="display: contents;"
            @loaded=${$d727d29830cb4c09$var$waitBeforeTrigger.bind(this)}
            .options=${{
                                    state: state.bind(this).call(this, deps),
                                    loading: loading.bind(this),
                                    style: options.style,
                                    styles: options.styles,
                                    error: error.bind(this),
                                    deepCloneState: options.deepCloneState,
                                    render: (state, setState, shadowRoot)=>{
                                        this.shadowRoot.append(shadowRoot);
                                        return render(deps).bind(this).call(this, state, setState, shadowRoot);
                                    }
                                }}
          ></r-renderer>
        `;
                            }
                        }));
module.exports.Partial = $d727d29830cb4c09$var$Partial;
function $d727d29830cb4c09$var$Component({ Settings: Settings, Providers: Providers, State: State, Render: Render, Loading: Loading, Error: Error }) {
    return (0, module.exports.Partial)(Settings)(Providers)(State)(Loading)(Error)(Render);
}
module.exports.Component = $d727d29830cb4c09$var$Component;

});
parcelRegister("a7Qz2", function(module, exports) {
"use strict";
var $75f354f2a187b844$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $75f354f2a187b844$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $75f354f2a187b844$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$75f354f2a187b844$var$__exportStar((parcelRequire("8JEqy")), module.exports);

});


parcelRegister("2Md89", function(module, exports) {
"use strict";
var $205a3fe91cf59f03$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $205a3fe91cf59f03$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $205a3fe91cf59f03$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$205a3fe91cf59f03$var$__exportStar((parcelRequire("70LsO")), module.exports);

$205a3fe91cf59f03$var$__exportStar((parcelRequire("uQyfj")), module.exports);

$205a3fe91cf59f03$var$__exportStar((parcelRequire("aGR5T")), module.exports);

});
parcelRegister("70LsO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AngularLayout = void 0;

var $bR3XJ = parcelRequire("bR3XJ");

var $1bJCV = parcelRequire("1bJCV");

var $jU5QM = parcelRequire("jU5QM");
module.exports.AngularLayout = [
    $1bJCV.Registry,
    $bR3XJ.IfOperator,
    $jU5QM.RouterLink
];

});
parcelRegister("bR3XJ", function(module, exports) {
"use strict";
var $8a17b7c64437c9f0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IfOperator = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $8a17b7c64437c9f0$var$IfOperator = class IfOperator extends $d1fLk.Attribute {
    OnInit() {
        this.originalDisplay = this.element.style.display;
        this.modify();
    }
    OnDestroy() {
        this.element.style.display = null;
    }
    OnUpdate() {
        this.modify();
    }
    modify() {
        if (!this.value || this.value === 'undefined' || this.value === '0' || this.value === 'null' || this.value === 'false') this.setStyles({
            display: 'none'
        })(this.element);
        else this.setStyles({
            display: this.originalDisplay
        })(this.element);
    }
};
module.exports.IfOperator = $8a17b7c64437c9f0$var$IfOperator;
module.exports.IfOperator = $8a17b7c64437c9f0$var$IfOperator = $8a17b7c64437c9f0$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'ngIf'
    })
], $8a17b7c64437c9f0$var$IfOperator);

});
parcelRegister("d1fLk", function(module, exports) {
"use strict";
var $97a7986a5e69fc36$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $97a7986a5e69fc36$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $97a7986a5e69fc36$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$97a7986a5e69fc36$var$__exportStar((parcelRequire("atxxX")), module.exports);

$97a7986a5e69fc36$var$__exportStar((parcelRequire("3o6bv")), module.exports);

$97a7986a5e69fc36$var$__exportStar((parcelRequire("diYhy")), module.exports);

$97a7986a5e69fc36$var$__exportStar((parcelRequire("eeRIF")), module.exports);

$97a7986a5e69fc36$var$__exportStar((parcelRequire("42T89")), module.exports);

$97a7986a5e69fc36$var$__exportStar((parcelRequire("kat4y")), module.exports);

});
parcelRegister("atxxX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Attribute = void 0;
/*  */ class $7a06a27abc97598e$var$Attribute {
    setStyles(keys) {
        return (div)=>{
            for (const [key, value] of Object.entries(keys))div['style'][key] = value;
        };
    }
    OnInit() {
    /* */ }
    OnDestroy() {
    /* */ }
    OnUpdate(_oldValue, _newValue) {
    /* */ }
    OnUpdateAttribute(_name, _value) {
    /* */ }
    OnChange(_records) {
    /* */ }
}
module.exports.Attribute = $7a06a27abc97598e$var$Attribute;

});

parcelRegister("3o6bv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomAttributeRegistry = void 0;

var $eeRIF = parcelRequire("eeRIF");
class $2778691aeb8cb773$var$CustomAttributeRegistry {
    constructor(parent){
        this.parent = parent;
        this._attrMap = new Map();
        this._elementMap = new Map();
        if (!parent) throw new Error('Must be given a parent element');
        this.observe();
    }
    define(attrName, Constructor) {
        this._attrMap.set(attrName.toLowerCase(), Constructor);
        this.upgradeAttribute(attrName);
    }
    get(element, attrName) {
        const map = this._elementMap.get(element);
        if (!map) return;
        return map.get(attrName.toLowerCase());
    }
    getConstructor(attrName) {
        return this._attrMap.get(attrName.toLowerCase());
    }
    observe() {
        var _a, _b;
        this.observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations)if (mutation.type === 'attributes') {
                const attr = this.getConstructor(mutation.attributeName);
                if (attr) this.found(mutation.attributeName, mutation.target, mutation.oldValue);
            } else {
                for (const node of mutation.removedNodes)this.downgrade(node);
                for (const node of mutation.addedNodes)this.upgradeElement(node);
            }
        });
        this.observer.observe((_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a['shadowRoot']) !== null && _b !== void 0 ? _b : this.parent, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeOldValue: true
        });
    }
    unsubscribe(force) {
        var _a;
        if (force) (_a = this.observer) === null || _a === void 0 || _a.disconnect();
        const values = [
            ...this._elementMap.values()
        ];
        for (const elModifiers of values){
            const modifiers = [
                ...elModifiers.values()
            ];
            for (const modifier of modifiers){
                modifier.OnDestroy();
                if (modifier.observer) modifier.observer.disconnect();
            }
            elModifiers.clear();
        }
        this._elementMap.clear();
    }
    upgradeAttribute(attrName, doc) {
        const parent = doc || this.parent;
        const matches = parent.querySelectorAll('[' + attrName + ']');
        for (const match of [
            ...matches
        ])this.found(attrName, match);
    }
    upgradeElement(element) {
        if (element.nodeType !== 1) return;
        for (const attr of element.attributes)if (this.getConstructor(attr.name)) this.found(attr.name, element);
        for (const [attr] of this._attrMap)this.upgradeAttribute(attr, element);
    }
    downgrade(element) {
        const map = this._elementMap.get(element);
        if (!map) return;
        for (const [, instance] of map)if (instance.OnDestroy) instance.OnDestroy();
        this._elementMap.delete(element);
    }
    found(attributeName, el, oldVal) {
        var _a, _b;
        let map = this._elementMap.get(el);
        if (!map) {
            map = new Map();
            this._elementMap.set(el, map);
        }
        let modifier = map.get(attributeName);
        const attribute = el.getAttribute(attributeName);
        if (!modifier) {
            const Modifier = this.getConstructor(attributeName);
            modifier = new Modifier();
            if ((_b = (_a = Modifier.options) === null || _a === void 0 ? void 0 : _a.observedAttributes) === null || _b === void 0 ? void 0 : _b.length) for (const observedAttribute of Modifier.options.observedAttributes)(0, $eeRIF.observe)(modifier, observedAttribute);
            modifier.element = el;
            modifier.selector = attributeName;
            modifier.value = attribute || modifier.value;
            modifier.parent = this.parent;
            if (modifier.OnInit) modifier.OnInit();
            if (Modifier.options.observe) {
                modifier.observer = new MutationObserver((records)=>modifier.OnChange(records));
                modifier.observer.observe(modifier.element, Modifier.options.observe);
            }
            map.set(attributeName, modifier);
            return;
        }
        if (attribute == null && !!modifier.value) {
            modifier.value = attribute;
            if (modifier.OnDestroy) modifier.OnDestroy();
            if (modifier.observer) modifier.observer.disconnect();
            map.delete(attributeName);
            return;
        }
        if (attribute !== modifier.value) {
            modifier.value = attribute;
            if (modifier.OnUpdate) modifier.OnUpdate(oldVal, attribute);
            return;
        }
    }
}
module.exports.CustomAttributeRegistry = $2778691aeb8cb773$var$CustomAttributeRegistry;

});
parcelRegister("eeRIF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.observe = module.exports.noop = void 0;
const $a5dc0b0aa87951e4$var$noop = function() {
/*  */ };
module.exports.noop = $a5dc0b0aa87951e4$var$noop;
const $a5dc0b0aa87951e4$var$observe = (target, memberName)=>{
    const prototype = target.constructor.prototype;
    const OnInit = prototype.OnInit || module.exports.noop;
    const OnDestroy = prototype.OnDestroy || module.exports.noop;
    const OnUpdateAttribute = prototype.OnUpdateAttribute || module.exports.noop;
    let observer;
    prototype.OnInit = function() {
        var _a;
        const element = (_a = this.element) !== null && _a !== void 0 ? _a : this;
        if (observer) observer.disconnect();
        observer = new MutationObserver(()=>{
            OnUpdateAttribute.call(this, memberName, element.getAttribute(memberName));
            target[memberName] = element.getAttribute(memberName);
        });
        observer.observe(element, {
            attributeFilter: [
                memberName
            ],
            attributes: true
        });
        return OnInit.call(this);
    };
    prototype.OnDestroy = function() {
        observer.disconnect();
        return OnDestroy.call(this);
    };
};
module.exports.observe = $a5dc0b0aa87951e4$var$observe;

});


parcelRegister("diYhy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Directive = module.exports.CustomAttribute = module.exports.Modifier = module.exports.Input = void 0;

var $eeRIF = parcelRequire("eeRIF");
/**
 * Decorator @Input
 * Used to get attribute from element
 */ const $9afbb78d9267b3cb$var$Input = (options)=>(target, memberName)=>{
        const OnInit = target.OnInit || $eeRIF.noop;
        Object.defineProperty(target, 'OnInit', {
            value () {
                var _a;
                let originalValue = this[memberName];
                const element = (_a = this.element) !== null && _a !== void 0 ? _a : this;
                Object.defineProperty(this, memberName, {
                    get: function() {
                        originalValue = element.getAttribute(memberName.toLowerCase());
                        return originalValue;
                    },
                    set (value) {
                        element.setAttribute(memberName.toLowerCase(), value);
                        originalValue = value;
                    },
                    configurable: true
                });
                return OnInit.call(this);
            },
            configurable: true
        });
        if (options === null || options === void 0 ? void 0 : options.observe) (0, $eeRIF.observe)(target, memberName);
    };
module.exports.Input = $9afbb78d9267b3cb$var$Input;
/**
 * Decorator @Modifier
 * Accepts parameter options with selector and registry
 */ const $9afbb78d9267b3cb$var$Modifier = (options)=>{
    return (target)=>{
        target['options'] = options;
    };
};
module.exports.Modifier = $9afbb78d9267b3cb$var$Modifier;
/**
 * Decorator @CustomAttribute
 * Accepts parameter options with selector and registry
 */ module.exports.CustomAttribute = module.exports.Modifier;
/**
 * Decorator @Directive
 * Accepts parameter options with selector and registry
 */ module.exports.Directive = module.exports.Modifier;

});

parcelRegister("42T89", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediaQueryAttribute = module.exports.createFiltersFromSelector = module.exports.Breakpoints = module.exports.MediaMatchers = void 0;

var $atxxX = parcelRequire("atxxX");
/**
 * Media query Attribute
 * for performance reasons it is key value pair
 */ module.exports.MediaMatchers = new Map([
    [
        'screen and (max-width: 599px)',
        'xs'
    ],
    [
        'screen and (min-width: 600px) and (max-width: 959px)',
        'sm'
    ],
    [
        'screen and (min-width: 960px) and (max-width: 1279px)',
        'md'
    ],
    [
        'screen and (min-width: 1280px) and (max-width: 1919px)',
        'lg'
    ],
    [
        'screen and (min-width: 1920px) and (max-width: 5000px)',
        'xl'
    ],
    [
        'screen and (max-width: 959px)',
        'lt-md'
    ],
    [
        'screen and (max-width: 1279px)',
        'lt-lg'
    ],
    [
        'screen and (max-width: 1919px)',
        'lt-xl'
    ],
    [
        'screen and (min-width: 600px)',
        'gt-xs'
    ],
    [
        'screen and (min-width: 960px)',
        'gt-sm'
    ],
    [
        'screen and (min-width: 1280px)',
        'gt-md'
    ],
    [
        'screen and (min-width: 1920px)',
        'gt-lg'
    ]
]);
module.exports.Breakpoints = [
    ...module.exports.MediaMatchers.values()
];
const $2f221d11866fbc4c$var$createFiltersFromSelector = (selector)=>[
        ...module.exports.Breakpoints.map((breakpoint)=>`${selector}.${breakpoint}`),
        selector
    ];
module.exports.createFiltersFromSelector = $2f221d11866fbc4c$var$createFiltersFromSelector;
class $2f221d11866fbc4c$var$MediaQueryAttribute extends $atxxX.Attribute {
    constructor(){
        super(...arguments);
        this.matchers = new Map();
        this.cachedAttributes = new Map();
        this.listener = (event)=>{
            const key = `${this.selector.toLowerCase()}.${module.exports.MediaMatchers.get(event.media)}`;
            const attribute = this.cachedAttributes.get(key);
            if (event.matches && attribute) return this.OnEnterMediaQuery([
                event,
                attribute
            ]);
            return this.OnExitMediaQuery([
                event,
                attribute
            ]);
        };
    }
    OnInit() {
        if (this.OnEnterMediaQuery || this.OnExitMediaQuery) for (const query of module.exports.MediaMatchers.keys()){
            const matcher = window.matchMedia(query);
            const attr = Object.values(this.element.attributes).find((v)=>v.name === `${this.selector.toLowerCase()}.${module.exports.MediaMatchers.get(query)}`);
            if (attr) {
                this.cachedAttributes.set(attr.name, attr);
                matcher.addEventListener('change', this.listener);
            }
            if (attr && matcher.matches) this.listener(matcher);
            this.matchers.set(matcher, matcher);
        }
    }
    OnDestroy() {
        for (const matcher of this.matchers.values())matcher.removeEventListener('change', this.listener);
        this.cachedAttributes.clear();
        this.matchers.clear();
    }
}
module.exports.MediaQueryAttribute = $2f221d11866fbc4c$var$MediaQueryAttribute;

});

parcelRegister("kat4y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("1bJCV", function(module, exports) {
"use strict";
var $0dda360e55cc5a97$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Registry = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $0dda360e55cc5a97$var$Registry = class Registry extends $d1fLk.Attribute {
};
module.exports.Registry = $0dda360e55cc5a97$var$Registry;
module.exports.Registry = $0dda360e55cc5a97$var$Registry = $0dda360e55cc5a97$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'angular-layout-registry',
        registry () {
            return new $d1fLk.CustomAttributeRegistry(this);
        }
    })
], $0dda360e55cc5a97$var$Registry);

});

parcelRegister("jU5QM", function(module, exports) {
"use strict";
var $e7d7c904f7f99624$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e7d7c904f7f99624$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getQueryParams = module.exports.stringify = module.exports.RouterLink = void 0;

var $d1fLk = parcelRequire("d1fLk");

var $64Pi0 = parcelRequire("64Pi0");
/**
 * @customAttribute routerLink
 */ let $e7d7c904f7f99624$var$RouterLink = class RouterLink extends $d1fLk.Attribute {
    onClick() {
        const { pathname: pathname, search: search, hash: hash } = this.getFullRoute();
        window.dispatchEvent(new CustomEvent(`router-go`, {
            cancelable: true,
            detail: {
                pathname: pathname,
                search: search || '',
                hash: hash || ''
            }
        }));
    }
    get queryParams() {
        return this.element.getAttribute('queryParams');
    }
    get hasParams() {
        return this.element.hasAttribute('queryParams');
    }
    getFullRoute() {
        if (this.hasParams) {
            const params = new URLSearchParams(this.parseParams());
            return this.getUrl([
                this.value,
                '?',
                params.toString()
            ].join(''));
        }
        return this.getUrl(this.value);
    }
    getUrl(path) {
        return new URL(path, 'http://a');
    }
    parseParams() {
        var _a;
        return JSON.parse((_a = this.queryParams) !== null && _a !== void 0 ? _a : '{}');
    }
};
module.exports.RouterLink = $e7d7c904f7f99624$var$RouterLink;
$e7d7c904f7f99624$var$__decorate([
    (0, $64Pi0.HostListener)('click'),
    $e7d7c904f7f99624$var$__metadata("design:type", Function),
    $e7d7c904f7f99624$var$__metadata("design:paramtypes", []),
    $e7d7c904f7f99624$var$__metadata("design:returntype", void 0)
], $e7d7c904f7f99624$var$RouterLink.prototype, "onClick", null);
module.exports.RouterLink = $e7d7c904f7f99624$var$RouterLink = $e7d7c904f7f99624$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'routerLink'
    })
], $e7d7c904f7f99624$var$RouterLink);
/**
 * Method helper for stringifying data so we can pass it to `queryParams` attribute
 * Without helper: `<div routerLink=${'/projects'} queryParams='{"tracingId": 123}'>CLICK</div>`
 * With helper: `<div routerLink=${'/projects'} queryParams=${stringify({ tracingId: 123 })}>CLICK</div>`
 */ const $e7d7c904f7f99624$var$stringify = (data)=>JSON.stringify(data);
module.exports.stringify = $e7d7c904f7f99624$var$stringify;
/**
 * Additionally for extracting query parameters we could use this method directly from the router @rhtml/router itself
 * const params = this.router.getQueryParams<{ tracingId: string }>();
 * console.log(params.tracingId);
 */ const $e7d7c904f7f99624$var$getQueryParams = ()=>[
        ...new URLSearchParams(location.search)
    ].reduce((prev, [key, value])=>Object.assign(Object.assign({}, prev), {
            [key]: value
        }), {});
module.exports.getQueryParams = $e7d7c904f7f99624$var$getQueryParams;

});
parcelRegister("64Pi0", function(module, exports) {
"use strict";
var $46cae6cd69c28388$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $46cae6cd69c28388$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $46cae6cd69c28388$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$46cae6cd69c28388$var$__exportStar((parcelRequire("4oq5h")), module.exports);

$46cae6cd69c28388$var$__exportStar((parcelRequire("b39iF")), module.exports);

});
parcelRegister("4oq5h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HostListener = void 0;
const $332da3141f5bfa4f$var$HostListener = (event)=>(target, key, propertyDescriptor)=>{
        const [type, eventName] = event.split(':');
        const wrapper = function(...args) {
            return propertyDescriptor.value.apply(this, args);
        };
        const OnInit = target['OnInit'] || function() {
        /*  */ };
        const OnDestroy = target['OnDestroy'] || function() {
        /*  */ };
        Object.defineProperty(target, 'OnInit', {
            value: function(...args) {
                var _a;
                const element = type === 'window' ? window : (_a = this.element) !== null && _a !== void 0 ? _a : this;
                const e = type === 'window' ? eventName : event;
                element.addEventListener(e, (...args)=>wrapper.apply(this, args));
                return OnInit.apply(this, args);
            },
            configurable: true,
            writable: true
        });
        Object.defineProperty(target, 'OnDestroy', {
            value: function(...args) {
                var _a;
                const element = type === 'window' ? window : (_a = this.element) !== null && _a !== void 0 ? _a : this;
                const e = type === 'window' ? eventName : event;
                element.removeEventListener(e, (...args)=>wrapper.apply(this, args));
                return OnDestroy.apply(this, args);
            },
            configurable: true,
            writable: true
        });
        return {
            get: ()=>wrapper
        };
    };
module.exports.HostListener = $332da3141f5bfa4f$var$HostListener;

});

parcelRegister("b39iF", function(module, exports) {
"use strict";
// type Class = 'class';
// type Style = 'style';
// type Type = Style | Class;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HostBinding = void 0;
// type Styles = keyof CSSStyleDeclaration;
// type Binding<T = Type> = T extends Style ? `${T}.${Styles}` : `${Class}.${string}`;
const $80b7304e529d7a83$var$HostBinding = (binding /* Binding<T> */ )=>(target, memberName)=>{
        const [type, key] = binding.split('.');
        const OnInit = target['OnInit'] || function() {
        /*  */ };
        const apply = (value)=>(element)=>{
                if (type === 'style') {
                    if (!value) element.style[key] = null;
                    else element.style[key] = value;
                }
                if (type === 'class') {
                    if (!value) element.classList.remove(key);
                    else element.classList.add(key);
                }
            };
        Object.defineProperty(target, 'OnInit', {
            value: function(...args) {
                var _a;
                let currentValue = this[memberName];
                const element = (_a = this.element) !== null && _a !== void 0 ? _a : this;
                Object.defineProperty(target, memberName, {
                    get: function() {
                        return currentValue;
                    },
                    set: function(value) {
                        apply(value)(element);
                        currentValue = value;
                    },
                    configurable: true
                });
                if (currentValue) apply(currentValue)(element);
                return OnInit.apply(this, args);
            },
            configurable: true,
            writable: true
        });
    };
module.exports.HostBinding = $80b7304e529d7a83$var$HostBinding;

});




parcelRegister("uQyfj", function(module, exports) {
"use strict";
var $05cb910fa9f529f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $05cb910fa9f529f0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $05cb910fa9f529f0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlexLayout = void 0;

var $aMraY = parcelRequire("aMraY");

var $6mxod = parcelRequire("6mxod");

var $cXsOL = parcelRequire("cXsOL");

var $6t4Dp = parcelRequire("6t4Dp");

var $dyOS8 = parcelRequire("dyOS8");


var $ymeia = parcelRequire("ymeia");

var $2gSY8 = parcelRequire("2gSY8");

var $ccTI5 = parcelRequire("ccTI5");

$05cb910fa9f529f0$var$__exportStar((parcelRequire("3n0aO")), module.exports);
module.exports.FlexLayout = [
    $ccTI5.Registry,
    (parcelRequire("3n0aO")).Layout,
    $ymeia.LayoutAlign,
    $2gSY8.LayoutGap,
    $cXsOL.FlexFill,
    $aMraY.Flex,
    $6mxod.FlexAlign,
    $6t4Dp.FlexOffset,
    $dyOS8.FlexOrder
];

});
parcelRegister("aMraY", function(module, exports) {
"use strict";
var $7d9377aa26d1fcad$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Flex = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $7d9377aa26d1fcad$var$Flex = class Flex extends $d1fLk.MediaQueryAttribute {
    OnInit() {
        this.modify();
        super.OnInit();
    }
    OnDestroy() {
        this.clean();
        super.OnDestroy();
    }
    OnUpdate() {
        this.modify();
    }
    OnEnterMediaQuery([, attribute]) {
        var _a;
        this.prevValue = this.value;
        this.value = (_a = attribute.value) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    OnExitMediaQuery() {
        var _a;
        this.value = (_a = this.prevValue) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    clean() {
        this.setStyles({
            boxSizing: null,
            flex: null,
            minWidth: null,
            maxWidth: null
        })(this.element);
    }
    modify() {
        let grow = '1';
        let shrink = '1';
        let basis = '0.000000001px';
        let flex = `${grow} ${shrink} ${basis}`;
        let maxWidth = null;
        if (this.value) {
            const parts = this.value.split(' ');
            if (parts.length === 1) {
                const val = parts[0];
                if (val === 'none') {
                    flex = 'none';
                    maxWidth = 'none';
                } else if (val === 'initial') flex = 'initial';
                else if (val === 'auto') {
                    grow = '1';
                    shrink = '1';
                    basis = 'auto';
                    flex = `${grow} ${shrink} ${basis}`;
                } else if (val.endsWith('%') || val.endsWith('px')) {
                    basis = val;
                    flex = `${grow} ${shrink} ${basis}`;
                    maxWidth = '100%';
                } else if (!isNaN(Number(val))) {
                    basis = `${val}%`;
                    flex = `${grow} ${shrink} ${basis}`;
                    maxWidth = '100%';
                } else {
                    basis = val;
                    flex = `${grow} ${shrink} ${basis}`;
                }
            } else {
                [grow = '1', shrink = '1', basis = '0.000000001px'] = parts;
                flex = `${grow} ${shrink} ${basis}`;
            }
        }
        this.setStyles({
            boxSizing: 'border-box',
            flex: flex,
            minWidth: '0',
            maxWidth: maxWidth
        })(this.element);
    }
};
module.exports.Flex = $7d9377aa26d1fcad$var$Flex;
module.exports.Flex = $7d9377aa26d1fcad$var$Flex = $7d9377aa26d1fcad$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'fxFlex'
    })
], $7d9377aa26d1fcad$var$Flex);

});

parcelRegister("6mxod", function(module, exports) {
"use strict";
var $4a1eb29d79cfc8b4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlexAlign = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $4a1eb29d79cfc8b4$var$FlexAlign = class FlexAlign extends $d1fLk.MediaQueryAttribute {
    OnInit() {
        this.modify();
        super.OnInit();
    }
    OnDestroy() {
        this.clean();
        super.OnDestroy();
    }
    OnUpdate() {
        this.modify();
    }
    OnEnterMediaQuery([, attribute]) {
        var _a;
        this.prevValue = this.value;
        this.value = (_a = attribute.value) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    OnExitMediaQuery() {
        var _a;
        this.value = (_a = this.prevValue) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    clean() {
        this.setStyles({
            alignSelf: null
        })(this.element);
    }
    modify() {
        this.setStyles({
            alignSelf: this.value || null
        })(this.element);
    }
};
module.exports.FlexAlign = $4a1eb29d79cfc8b4$var$FlexAlign;
module.exports.FlexAlign = $4a1eb29d79cfc8b4$var$FlexAlign = $4a1eb29d79cfc8b4$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'fxFlexAlign'
    })
], $4a1eb29d79cfc8b4$var$FlexAlign);

});

parcelRegister("cXsOL", function(module, exports) {
"use strict";
var $96f1595263cf26aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlexFill = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $96f1595263cf26aa$var$FlexFill = class FlexFill extends $d1fLk.Attribute {
    constructor(){
        super(...arguments);
        this.value = '100%';
    }
    OnInit() {
        this.modify();
    }
    OnDestroy() {
        this.clean();
    }
    OnUpdate() {
        this.modify();
    }
    clean() {
        this.setStyles({
            height: null,
            margin: null,
            minHeight: null,
            minWidth: null,
            width: null
        })(this.element);
    }
    modify() {
        this.setStyles({
            margin: '0',
            height: this.value,
            minHeight: this.value,
            minWidth: this.value,
            width: this.value
        })(this.element);
    }
};
module.exports.FlexFill = $96f1595263cf26aa$var$FlexFill;
module.exports.FlexFill = $96f1595263cf26aa$var$FlexFill = $96f1595263cf26aa$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'fxFlexFill'
    })
], $96f1595263cf26aa$var$FlexFill);

});

parcelRegister("6t4Dp", function(module, exports) {
"use strict";
var $4b590bdf9e8801f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlexOffset = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $4b590bdf9e8801f2$var$FlexOffset = class FlexOffset extends $d1fLk.Attribute {
    OnInit() {
        this.modify();
    }
    OnDestroy() {
        this.clean();
    }
    OnUpdate() {
        this.modify();
    }
    clean() {
        this.setStyles({
            marginLeft: null
        })(this.element);
    }
    modify() {
        this.setStyles({
            marginLeft: this.value || null
        })(this.element);
    }
};
module.exports.FlexOffset = $4b590bdf9e8801f2$var$FlexOffset;
module.exports.FlexOffset = $4b590bdf9e8801f2$var$FlexOffset = $4b590bdf9e8801f2$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'fxFlexOffset'
    })
], $4b590bdf9e8801f2$var$FlexOffset);

});

parcelRegister("dyOS8", function(module, exports) {
"use strict";
var $9df5e97aeae46666$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlexOrder = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $9df5e97aeae46666$var$FlexOrder = class FlexOrder extends $d1fLk.Attribute {
    OnInit() {
        this.modify();
    }
    OnDestroy() {
        this.clean();
    }
    OnUpdate() {
        this.modify();
    }
    clean() {
        this.setStyles({
            order: null
        })(this.element);
    }
    modify() {
        this.setStyles({
            order: this.value || null
        })(this.element);
    }
};
module.exports.FlexOrder = $9df5e97aeae46666$var$FlexOrder;
module.exports.FlexOrder = $9df5e97aeae46666$var$FlexOrder = $9df5e97aeae46666$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'fxFlexOrder'
    })
], $9df5e97aeae46666$var$FlexOrder);

});

parcelRegister("3n0aO", function(module, exports) {
"use strict";
var $2743a781e9564dc8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Layout = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $2743a781e9564dc8$var$Layout = class Layout extends $d1fLk.MediaQueryAttribute {
    constructor(){
        super(...arguments);
        this.value = 'row';
    }
    OnInit() {
        this.modify();
        super.OnInit();
    }
    OnDestroy() {
        this.clean();
        super.OnDestroy();
    }
    OnUpdate() {
        this.modify();
    }
    OnEnterMediaQuery([, attribute]) {
        var _a;
        this.prevValue = this.value;
        this.value = (_a = attribute.value) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    OnExitMediaQuery() {
        var _a;
        this.value = (_a = this.prevValue) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    clean() {
        this.setStyles({
            boxSizing: null,
            flexFlow: null,
            display: null
        })(this.element);
    }
    modify() {
        if (!this.value) return;
        this.element.setAttribute(this.selector, this.value);
        const splitted = this.value.split(' ');
        const [mainAxis, crossAxis] = splitted;
        let flexFlow = mainAxis;
        if (crossAxis === 'wrap' || crossAxis === 'inline') flexFlow = `${mainAxis} ${crossAxis}`;
        else if (crossAxis) flexFlow = `${mainAxis} ${crossAxis}`;
        this.setStyles({
            boxSizing: 'border-box',
            flexFlow: flexFlow,
            display: 'flex'
        })(this.element);
    }
};
module.exports.Layout = $2743a781e9564dc8$var$Layout;
module.exports.Layout = $2743a781e9564dc8$var$Layout = $2743a781e9564dc8$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'fxLayout'
    })
], $2743a781e9564dc8$var$Layout);

});

parcelRegister("ymeia", function(module, exports) {
"use strict";
var $06746b68d9f460c1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LayoutAlign = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $06746b68d9f460c1$var$LayoutAlign = class LayoutAlign extends $d1fLk.MediaQueryAttribute {
    OnInit() {
        this.modify();
        super.OnInit();
    }
    OnDestroy() {
        this.clean();
        super.OnDestroy();
    }
    OnUpdate() {
        this.modify();
    }
    OnEnterMediaQuery([, attribute]) {
        var _a;
        this.prevValue = this.value;
        this.value = (_a = attribute.value) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    OnExitMediaQuery() {
        var _a;
        this.value = (_a = this.prevValue) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    clean() {
        this.setStyles({
            justifyContent: null,
            alignItems: null,
            display: null
        })(this.element);
    }
    modify() {
        const [mainAxis, crossAxis] = this.value.split(' ');
        this.setStyles({
            justifyContent: mainAxis,
            alignItems: crossAxis || mainAxis,
            display: 'flex'
        })(this.element);
    }
};
module.exports.LayoutAlign = $06746b68d9f460c1$var$LayoutAlign;
module.exports.LayoutAlign = $06746b68d9f460c1$var$LayoutAlign = $06746b68d9f460c1$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'fxLayoutAlign'
    })
], $06746b68d9f460c1$var$LayoutAlign);

});

parcelRegister("2gSY8", function(module, exports) {
"use strict";
var $1a77b7151870ecfd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LayoutGap = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $1a77b7151870ecfd$var$LayoutGap = class LayoutGap extends $d1fLk.MediaQueryAttribute {
    OnInit() {
        this.modify();
        super.OnInit();
    }
    OnDestroy() {
        this.setStyles({
            gap: null
        })(this.element);
        super.OnDestroy();
    }
    OnUpdate() {
        this.modify();
    }
    OnChange() {
        this.modify();
    }
    OnEnterMediaQuery([, attribute]) {
        var _a;
        this.value = (_a = attribute.value) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    OnExitMediaQuery() {
        this.modify();
    }
    modify() {
        this.setStyles({
            gap: this.value
        })(this.element);
    }
};
module.exports.LayoutGap = $1a77b7151870ecfd$var$LayoutGap;
module.exports.LayoutGap = $1a77b7151870ecfd$var$LayoutGap = $1a77b7151870ecfd$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'fxLayoutGap',
        observe: {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: (0, $d1fLk.createFiltersFromSelector)('fxlayout')
        }
    })
], $1a77b7151870ecfd$var$LayoutGap);

});

parcelRegister("ccTI5", function(module, exports) {
"use strict";
var $8e31d1e0f5bcc449$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Registry = void 0;

var $d1fLk = parcelRequire("d1fLk");
let $8e31d1e0f5bcc449$var$Registry = class Registry extends $d1fLk.Attribute {
};
module.exports.Registry = $8e31d1e0f5bcc449$var$Registry;
module.exports.Registry = $8e31d1e0f5bcc449$var$Registry = $8e31d1e0f5bcc449$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'flex-layout-registry',
        registry () {
            return new $d1fLk.CustomAttributeRegistry(this);
        }
    })
], $8e31d1e0f5bcc449$var$Registry);

});


parcelRegister("aGR5T", function(module, exports) {
"use strict";
var $7c870301cc6357c7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7c870301cc6357c7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7c870301cc6357c7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7c870301cc6357c7$var$__exportStar((parcelRequire("6MASl")), module.exports);

$7c870301cc6357c7$var$__exportStar((parcelRequire("lPtvR")), module.exports);

$7c870301cc6357c7$var$__exportStar((parcelRequire("a3Nx2")), module.exports);

});
parcelRegister("6MASl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Animations = void 0;
module.exports.Animations = `
@charset "UTF-8";

/*!
 * animate.css -https://daneden.github.io/animate.css/
 * Version - 3.7.2
 * Licensed under the MIT license - http://opensource.org/licenses/MIT
 *
 * Copyright (c) 2019 Daniel Eden
 */

@-webkit-keyframes bounce {
	0%,
	20%,
	53%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	40%,
	43% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -30px, 0);
		transform: translate3d(0, -30px, 0)
	}
	70% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -15px, 0);
		transform: translate3d(0, -15px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -4px, 0);
		transform: translate3d(0, -4px, 0)
	}
}

@keyframes bounce {
	0%,
	20%,
	53%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	40%,
	43% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -30px, 0);
		transform: translate3d(0, -30px, 0)
	}
	70% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -15px, 0);
		transform: translate3d(0, -15px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -4px, 0);
		transform: translate3d(0, -4px, 0)
	}
}

.bounce {
	-webkit-animation-name: bounce;
	animation-name: bounce;
	-webkit-transform-origin: center bottom;
	transform-origin: center bottom
}

@-webkit-keyframes flash {
	0%,
	50%,
	to {
		opacity: 1
	}
	25%,
	75% {
		opacity: 0
	}
}

@keyframes flash {
	0%,
	50%,
	to {
		opacity: 1
	}
	25%,
	75% {
		opacity: 0
	}
}

.flash {
	-webkit-animation-name: flash;
	animation-name: flash
}

@-webkit-keyframes pulse {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	50% {
		-webkit-transform: scale3d(1.05, 1.05, 1.05);
		transform: scale3d(1.05, 1.05, 1.05)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes pulse {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	50% {
		-webkit-transform: scale3d(1.05, 1.05, 1.05);
		transform: scale3d(1.05, 1.05, 1.05)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.pulse {
	-webkit-animation-name: pulse;
	animation-name: pulse
}

@-webkit-keyframes rubberBand {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	30% {
		-webkit-transform: scale3d(1.25, .75, 1);
		transform: scale3d(1.25, .75, 1)
	}
	40% {
		-webkit-transform: scale3d(.75, 1.25, 1);
		transform: scale3d(.75, 1.25, 1)
	}
	50% {
		-webkit-transform: scale3d(1.15, .85, 1);
		transform: scale3d(1.15, .85, 1)
	}
	65% {
		-webkit-transform: scale3d(.95, 1.05, 1);
		transform: scale3d(.95, 1.05, 1)
	}
	75% {
		-webkit-transform: scale3d(1.05, .95, 1);
		transform: scale3d(1.05, .95, 1)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes rubberBand {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	30% {
		-webkit-transform: scale3d(1.25, .75, 1);
		transform: scale3d(1.25, .75, 1)
	}
	40% {
		-webkit-transform: scale3d(.75, 1.25, 1);
		transform: scale3d(.75, 1.25, 1)
	}
	50% {
		-webkit-transform: scale3d(1.15, .85, 1);
		transform: scale3d(1.15, .85, 1)
	}
	65% {
		-webkit-transform: scale3d(.95, 1.05, 1);
		transform: scale3d(.95, 1.05, 1)
	}
	75% {
		-webkit-transform: scale3d(1.05, .95, 1);
		transform: scale3d(1.05, .95, 1)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.rubberBand {
	-webkit-animation-name: rubberBand;
	animation-name: rubberBand
}

@-webkit-keyframes shake {
	0%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	10%,
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	20%,
	40%,
	60%,
	80% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
}

@keyframes shake {
	0%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	10%,
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	20%,
	40%,
	60%,
	80% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
}

.shake {
	-webkit-animation-name: shake;
	animation-name: shake
}

@-webkit-keyframes headShake {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
	6.5% {
		-webkit-transform: translateX(-6px) rotateY(-9deg);
		transform: translateX(-6px) rotateY(-9deg)
	}
	18.5% {
		-webkit-transform: translateX(5px) rotateY(7deg);
		transform: translateX(5px) rotateY(7deg)
	}
	31.5% {
		-webkit-transform: translateX(-3px) rotateY(-5deg);
		transform: translateX(-3px) rotateY(-5deg)
	}
	43.5% {
		-webkit-transform: translateX(2px) rotateY(3deg);
		transform: translateX(2px) rotateY(3deg)
	}
	50% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
}

@keyframes headShake {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
	6.5% {
		-webkit-transform: translateX(-6px) rotateY(-9deg);
		transform: translateX(-6px) rotateY(-9deg)
	}
	18.5% {
		-webkit-transform: translateX(5px) rotateY(7deg);
		transform: translateX(5px) rotateY(7deg)
	}
	31.5% {
		-webkit-transform: translateX(-3px) rotateY(-5deg);
		transform: translateX(-3px) rotateY(-5deg)
	}
	43.5% {
		-webkit-transform: translateX(2px) rotateY(3deg);
		transform: translateX(2px) rotateY(3deg)
	}
	50% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
}

.headShake {
	-webkit-animation-timing-function: ease-in-out;
	animation-timing-function: ease-in-out;
	-webkit-animation-name: headShake;
	animation-name: headShake
}

@-webkit-keyframes swing {
	20% {
		-webkit-transform: rotate(15deg);
		transform: rotate(15deg)
	}
	40% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	60% {
		-webkit-transform: rotate(5deg);
		transform: rotate(5deg)
	}
	80% {
		-webkit-transform: rotate(-5deg);
		transform: rotate(-5deg)
	}
	to {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg)
	}
}

@keyframes swing {
	20% {
		-webkit-transform: rotate(15deg);
		transform: rotate(15deg)
	}
	40% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	60% {
		-webkit-transform: rotate(5deg);
		transform: rotate(5deg)
	}
	80% {
		-webkit-transform: rotate(-5deg);
		transform: rotate(-5deg)
	}
	to {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg)
	}
}

.swing {
	-webkit-transform-origin: top center;
	transform-origin: top center;
	-webkit-animation-name: swing;
	animation-name: swing
}

@-webkit-keyframes tada {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	10%,
	20% {
		-webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
		transform: scale3d(.9, .9, .9) rotate(-3deg)
	}
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(3deg)
	}
	40%,
	60%,
	80% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes tada {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	10%,
	20% {
		-webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
		transform: scale3d(.9, .9, .9) rotate(-3deg)
	}
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(3deg)
	}
	40%,
	60%,
	80% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.tada {
	-webkit-animation-name: tada;
	animation-name: tada
}

@-webkit-keyframes wobble {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	15% {
		-webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
		transform: translate3d(-25%, 0, 0) rotate(-5deg)
	}
	30% {
		-webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
		transform: translate3d(20%, 0, 0) rotate(3deg)
	}
	45% {
		-webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
		transform: translate3d(-15%, 0, 0) rotate(-3deg)
	}
	60% {
		-webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
		transform: translate3d(10%, 0, 0) rotate(2deg)
	}
	75% {
		-webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
		transform: translate3d(-5%, 0, 0) rotate(-1deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes wobble {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	15% {
		-webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
		transform: translate3d(-25%, 0, 0) rotate(-5deg)
	}
	30% {
		-webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
		transform: translate3d(20%, 0, 0) rotate(3deg)
	}
	45% {
		-webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
		transform: translate3d(-15%, 0, 0) rotate(-3deg)
	}
	60% {
		-webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
		transform: translate3d(10%, 0, 0) rotate(2deg)
	}
	75% {
		-webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
		transform: translate3d(-5%, 0, 0) rotate(-1deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.wobble {
	-webkit-animation-name: wobble;
	animation-name: wobble
}

@-webkit-keyframes jello {
	0%,
	11.1%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	22.2% {
		-webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
		transform: skewX(-12.5deg) skewY(-12.5deg)
	}
	33.3% {
		-webkit-transform: skewX(6.25deg) skewY(6.25deg);
		transform: skewX(6.25deg) skewY(6.25deg)
	}
	44.4% {
		-webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
		transform: skewX(-3.125deg) skewY(-3.125deg)
	}
	55.5% {
		-webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
		transform: skewX(1.5625deg) skewY(1.5625deg)
	}
	66.6% {
		-webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
		transform: skewX(-.78125deg) skewY(-.78125deg)
	}
	77.7% {
		-webkit-transform: skewX(.390625deg) skewY(.390625deg);
		transform: skewX(.390625deg) skewY(.390625deg)
	}
	88.8% {
		-webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
		transform: skewX(-.1953125deg) skewY(-.1953125deg)
	}
}

@keyframes jello {
	0%,
	11.1%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	22.2% {
		-webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
		transform: skewX(-12.5deg) skewY(-12.5deg)
	}
	33.3% {
		-webkit-transform: skewX(6.25deg) skewY(6.25deg);
		transform: skewX(6.25deg) skewY(6.25deg)
	}
	44.4% {
		-webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
		transform: skewX(-3.125deg) skewY(-3.125deg)
	}
	55.5% {
		-webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
		transform: skewX(1.5625deg) skewY(1.5625deg)
	}
	66.6% {
		-webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
		transform: skewX(-.78125deg) skewY(-.78125deg)
	}
	77.7% {
		-webkit-transform: skewX(.390625deg) skewY(.390625deg);
		transform: skewX(.390625deg) skewY(.390625deg)
	}
	88.8% {
		-webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
		transform: skewX(-.1953125deg) skewY(-.1953125deg)
	}
}

.jello {
	-webkit-animation-name: jello;
	animation-name: jello;
	-webkit-transform-origin: center;
	transform-origin: center
}

@-webkit-keyframes heartBeat {
	0% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	14% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	28% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	42% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	70% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

@keyframes heartBeat {
	0% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	14% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	28% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	42% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	70% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

.heartBeat {
	-webkit-animation-name: heartBeat;
	animation-name: heartBeat;
	-webkit-animation-duration: 1.3s;
	animation-duration: 1.3s;
	-webkit-animation-timing-function: ease-in-out;
	animation-timing-function: ease-in-out
}

@-webkit-keyframes bounceIn {
	0%,
	20%,
	40%,
	60%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	20% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	40% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(1.03, 1.03, 1.03);
		transform: scale3d(1.03, 1.03, 1.03)
	}
	80% {
		-webkit-transform: scale3d(.97, .97, .97);
		transform: scale3d(.97, .97, .97)
	}
	to {
		opacity: 1;
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes bounceIn {
	0%,
	20%,
	40%,
	60%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	20% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	40% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(1.03, 1.03, 1.03);
		transform: scale3d(1.03, 1.03, 1.03)
	}
	80% {
		-webkit-transform: scale3d(.97, .97, .97);
		transform: scale3d(.97, .97, .97)
	}
	to {
		opacity: 1;
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.bounceIn {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: bounceIn;
	animation-name: bounceIn
}

@-webkit-keyframes bounceInDown {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -3000px, 0);
		transform: translate3d(0, -3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, 25px, 0);
		transform: translate3d(0, 25px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, 5px, 0);
		transform: translate3d(0, 5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInDown {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -3000px, 0);
		transform: translate3d(0, -3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, 25px, 0);
		transform: translate3d(0, 25px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, 5px, 0);
		transform: translate3d(0, 5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInDown {
	-webkit-animation-name: bounceInDown;
	animation-name: bounceInDown
}

@-webkit-keyframes bounceInLeft {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-3000px, 0, 0);
		transform: translate3d(-3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(25px, 0, 0);
		transform: translate3d(25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(5px, 0, 0);
		transform: translate3d(5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInLeft {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-3000px, 0, 0);
		transform: translate3d(-3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(25px, 0, 0);
		transform: translate3d(25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(5px, 0, 0);
		transform: translate3d(5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInLeft {
	-webkit-animation-name: bounceInLeft;
	animation-name: bounceInLeft
}

@-webkit-keyframes bounceInRight {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(3000px, 0, 0);
		transform: translate3d(3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(-25px, 0, 0);
		transform: translate3d(-25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(-5px, 0, 0);
		transform: translate3d(-5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInRight {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(3000px, 0, 0);
		transform: translate3d(3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(-25px, 0, 0);
		transform: translate3d(-25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(-5px, 0, 0);
		transform: translate3d(-5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInRight {
	-webkit-animation-name: bounceInRight;
	animation-name: bounceInRight
}

@-webkit-keyframes bounceInUp {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 3000px, 0);
		transform: translate3d(0, 3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -5px, 0);
		transform: translate3d(0, -5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInUp {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 3000px, 0);
		transform: translate3d(0, 3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -5px, 0);
		transform: translate3d(0, -5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInUp {
	-webkit-animation-name: bounceInUp;
	animation-name: bounceInUp
}

@-webkit-keyframes bounceOut {
	20% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	50%,
	55% {
		opacity: 1;
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
}

@keyframes bounceOut {
	20% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	50%,
	55% {
		opacity: 1;
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
}

.bounceOut {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: bounceOut;
	animation-name: bounceOut
}

@-webkit-keyframes bounceOutDown {
	20% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

@keyframes bounceOutDown {
	20% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

.bounceOutDown {
	-webkit-animation-name: bounceOutDown;
	animation-name: bounceOutDown
}

@-webkit-keyframes bounceOutLeft {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(20px, 0, 0);
		transform: translate3d(20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

@keyframes bounceOutLeft {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(20px, 0, 0);
		transform: translate3d(20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

.bounceOutLeft {
	-webkit-animation-name: bounceOutLeft;
	animation-name: bounceOutLeft
}

@-webkit-keyframes bounceOutRight {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(-20px, 0, 0);
		transform: translate3d(-20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

@keyframes bounceOutRight {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(-20px, 0, 0);
		transform: translate3d(-20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

.bounceOutRight {
	-webkit-animation-name: bounceOutRight;
	animation-name: bounceOutRight
}

@-webkit-keyframes bounceOutUp {
	20% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, 20px, 0);
		transform: translate3d(0, 20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

@keyframes bounceOutUp {
	20% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, 20px, 0);
		transform: translate3d(0, 20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

.bounceOutUp {
	-webkit-animation-name: bounceOutUp;
	animation-name: bounceOutUp
}

@-webkit-keyframes fadeIn {
	0% {
		opacity: 0
	}
	to {
		opacity: 1
	}
}

@keyframes fadeIn {
	0% {
		opacity: 0
	}
	to {
		opacity: 1
	}
}

.fadeIn {
	-webkit-animation-name: fadeIn;
	animation-name: fadeIn
}

@-webkit-keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInDown {
	-webkit-animation-name: fadeInDown;
	animation-name: fadeInDown
}

@-webkit-keyframes fadeInDownBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInDownBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInDownBig {
	-webkit-animation-name: fadeInDownBig;
	animation-name: fadeInDownBig
}

@-webkit-keyframes fadeInLeft {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInLeft {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInLeft {
	-webkit-animation-name: fadeInLeft;
	animation-name: fadeInLeft
}

@-webkit-keyframes fadeInLeftBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInLeftBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInLeftBig {
	-webkit-animation-name: fadeInLeftBig;
	animation-name: fadeInLeftBig
}

@-webkit-keyframes fadeInRight {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInRight {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInRight {
	-webkit-animation-name: fadeInRight;
	animation-name: fadeInRight
}

@-webkit-keyframes fadeInRightBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInRightBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInRightBig {
	-webkit-animation-name: fadeInRightBig;
	animation-name: fadeInRightBig
}

@-webkit-keyframes fadeInUp {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInUp {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInUp {
	-webkit-animation-name: fadeInUp;
	animation-name: fadeInUp
}

@-webkit-keyframes fadeInUpBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInUpBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInUpBig {
	-webkit-animation-name: fadeInUpBig;
	animation-name: fadeInUpBig
}

@-webkit-keyframes fadeOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0
	}
}

@keyframes fadeOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0
	}
}

.fadeOut {
	-webkit-animation-name: fadeOut;
	animation-name: fadeOut
}

@-webkit-keyframes fadeOutDown {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

@keyframes fadeOutDown {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

.fadeOutDown {
	-webkit-animation-name: fadeOutDown;
	animation-name: fadeOutDown
}

@-webkit-keyframes fadeOutDownBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

@keyframes fadeOutDownBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

.fadeOutDownBig {
	-webkit-animation-name: fadeOutDownBig;
	animation-name: fadeOutDownBig
}

@-webkit-keyframes fadeOutLeft {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

@keyframes fadeOutLeft {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

.fadeOutLeft {
	-webkit-animation-name: fadeOutLeft;
	animation-name: fadeOutLeft
}

@-webkit-keyframes fadeOutLeftBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

@keyframes fadeOutLeftBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

.fadeOutLeftBig {
	-webkit-animation-name: fadeOutLeftBig;
	animation-name: fadeOutLeftBig
}

@-webkit-keyframes fadeOutRight {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

@keyframes fadeOutRight {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

.fadeOutRight {
	-webkit-animation-name: fadeOutRight;
	animation-name: fadeOutRight
}

@-webkit-keyframes fadeOutRightBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

@keyframes fadeOutRightBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

.fadeOutRightBig {
	-webkit-animation-name: fadeOutRightBig;
	animation-name: fadeOutRightBig
}

@-webkit-keyframes fadeOutUp {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

@keyframes fadeOutUp {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

.fadeOutUp {
	-webkit-animation-name: fadeOutUp;
	animation-name: fadeOutUp
}

@-webkit-keyframes fadeOutUpBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

@keyframes fadeOutUpBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

.fadeOutUpBig {
	-webkit-animation-name: fadeOutUpBig;
	animation-name: fadeOutUpBig
}

@-webkit-keyframes flip {
	0% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	40% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	50% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	80% {
		-webkit-transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	to {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
}

@keyframes flip {
	0% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	40% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	50% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	80% {
		-webkit-transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	to {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
}

.animated.flip {
	-webkit-backface-visibility: visible;
	backface-visibility: visible;
	-webkit-animation-name: flip;
	animation-name: flip
}

@-webkit-keyframes flipInX {
	0% {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateX(10deg);
		transform: perspective(400px) rotateX(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateX(-5deg);
		transform: perspective(400px) rotateX(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

@keyframes flipInX {
	0% {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateX(10deg);
		transform: perspective(400px) rotateX(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateX(-5deg);
		transform: perspective(400px) rotateX(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

.flipInX {
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipInX;
	animation-name: flipInX
}

@-webkit-keyframes flipInY {
	0% {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateY(-20deg);
		transform: perspective(400px) rotateY(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateY(10deg);
		transform: perspective(400px) rotateY(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateY(-5deg);
		transform: perspective(400px) rotateY(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

@keyframes flipInY {
	0% {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateY(-20deg);
		transform: perspective(400px) rotateY(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateY(10deg);
		transform: perspective(400px) rotateY(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateY(-5deg);
		transform: perspective(400px) rotateY(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

.flipInY {
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipInY;
	animation-name: flipInY
}

@-webkit-keyframes flipOutX {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		opacity: 0
	}
}

@keyframes flipOutX {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		opacity: 0
	}
}

.flipOutX {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: flipOutX;
	animation-name: flipOutX;
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important
}

@-webkit-keyframes flipOutY {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateY(-15deg);
		transform: perspective(400px) rotateY(-15deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		opacity: 0
	}
}

@keyframes flipOutY {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateY(-15deg);
		transform: perspective(400px) rotateY(-15deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		opacity: 0
	}
}

.flipOutY {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipOutY;
	animation-name: flipOutY
}

@-webkit-keyframes lightSpeedIn {
	0% {
		-webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
		transform: translate3d(100%, 0, 0) skewX(-30deg);
		opacity: 0
	}
	60% {
		-webkit-transform: skewX(20deg);
		transform: skewX(20deg);
		opacity: 1
	}
	80% {
		-webkit-transform: skewX(-5deg);
		transform: skewX(-5deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes lightSpeedIn {
	0% {
		-webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
		transform: translate3d(100%, 0, 0) skewX(-30deg);
		opacity: 0
	}
	60% {
		-webkit-transform: skewX(20deg);
		transform: skewX(20deg);
		opacity: 1
	}
	80% {
		-webkit-transform: skewX(-5deg);
		transform: skewX(-5deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.lightSpeedIn {
	-webkit-animation-name: lightSpeedIn;
	animation-name: lightSpeedIn;
	-webkit-animation-timing-function: ease-out;
	animation-timing-function: ease-out
}

@-webkit-keyframes lightSpeedOut {
	0% {
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
		transform: translate3d(100%, 0, 0) skewX(30deg);
		opacity: 0
	}
}

@keyframes lightSpeedOut {
	0% {
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
		transform: translate3d(100%, 0, 0) skewX(30deg);
		opacity: 0
	}
}

.lightSpeedOut {
	-webkit-animation-name: lightSpeedOut;
	animation-name: lightSpeedOut;
	-webkit-animation-timing-function: ease-in;
	animation-timing-function: ease-in
}

@-webkit-keyframes rotateIn {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(-200deg);
		transform: rotate(-200deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateIn {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(-200deg);
		transform: rotate(-200deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateIn {
	-webkit-animation-name: rotateIn;
	animation-name: rotateIn
}

@-webkit-keyframes rotateInDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInDownLeft {
	-webkit-animation-name: rotateInDownLeft;
	animation-name: rotateInDownLeft
}

@-webkit-keyframes rotateInDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInDownRight {
	-webkit-animation-name: rotateInDownRight;
	animation-name: rotateInDownRight
}

@-webkit-keyframes rotateInUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInUpLeft {
	-webkit-animation-name: rotateInUpLeft;
	animation-name: rotateInUpLeft
}

@-webkit-keyframes rotateInUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-90deg);
		transform: rotate(-90deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-90deg);
		transform: rotate(-90deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInUpRight {
	-webkit-animation-name: rotateInUpRight;
	animation-name: rotateInUpRight
}

@-webkit-keyframes rotateOut {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		opacity: 1
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(200deg);
		transform: rotate(200deg);
		opacity: 0
	}
}

@keyframes rotateOut {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		opacity: 1
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(200deg);
		transform: rotate(200deg);
		opacity: 0
	}
}

.rotateOut {
	-webkit-animation-name: rotateOut;
	animation-name: rotateOut
}

@-webkit-keyframes rotateOutDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
}

@keyframes rotateOutDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
}

.rotateOutDownLeft {
	-webkit-animation-name: rotateOutDownLeft;
	animation-name: rotateOutDownLeft
}

@-webkit-keyframes rotateOutDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

@keyframes rotateOutDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

.rotateOutDownRight {
	-webkit-animation-name: rotateOutDownRight;
	animation-name: rotateOutDownRight
}

@-webkit-keyframes rotateOutUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

@keyframes rotateOutUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

.rotateOutUpLeft {
	-webkit-animation-name: rotateOutUpLeft;
	animation-name: rotateOutUpLeft
}

@-webkit-keyframes rotateOutUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(90deg);
		transform: rotate(90deg);
		opacity: 0
	}
}

@keyframes rotateOutUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(90deg);
		transform: rotate(90deg);
		opacity: 0
	}
}

.rotateOutUpRight {
	-webkit-animation-name: rotateOutUpRight;
	animation-name: rotateOutUpRight
}

@-webkit-keyframes hinge {
	0% {
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	20%,
	60% {
		-webkit-transform: rotate(80deg);
		transform: rotate(80deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	40%,
	80% {
		-webkit-transform: rotate(60deg);
		transform: rotate(60deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out;
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(0, 700px, 0);
		transform: translate3d(0, 700px, 0);
		opacity: 0
	}
}

@keyframes hinge {
	0% {
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	20%,
	60% {
		-webkit-transform: rotate(80deg);
		transform: rotate(80deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	40%,
	80% {
		-webkit-transform: rotate(60deg);
		transform: rotate(60deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out;
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(0, 700px, 0);
		transform: translate3d(0, 700px, 0);
		opacity: 0
	}
}

.hinge {
	-webkit-animation-duration: 2s;
	animation-duration: 2s;
	-webkit-animation-name: hinge;
	animation-name: hinge
}

@-webkit-keyframes jackInTheBox {
	0% {
		opacity: 0;
		-webkit-transform: scale(.1) rotate(30deg);
		transform: scale(.1) rotate(30deg);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom
	}
	50% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	70% {
		-webkit-transform: rotate(3deg);
		transform: rotate(3deg)
	}
	to {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

@keyframes jackInTheBox {
	0% {
		opacity: 0;
		-webkit-transform: scale(.1) rotate(30deg);
		transform: scale(.1) rotate(30deg);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom
	}
	50% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	70% {
		-webkit-transform: rotate(3deg);
		transform: rotate(3deg)
	}
	to {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

.jackInTheBox {
	-webkit-animation-name: jackInTheBox;
	animation-name: jackInTheBox
}

@-webkit-keyframes rollIn {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);
		transform: translate3d(-100%, 0, 0) rotate(-120deg)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes rollIn {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);
		transform: translate3d(-100%, 0, 0) rotate(-120deg)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.rollIn {
	-webkit-animation-name: rollIn;
	animation-name: rollIn
}

@-webkit-keyframes rollOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0) rotate(120deg);
		transform: translate3d(100%, 0, 0) rotate(120deg)
	}
}

@keyframes rollOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0) rotate(120deg);
		transform: translate3d(100%, 0, 0) rotate(120deg)
	}
}

.rollOut {
	-webkit-animation-name: rollOut;
	animation-name: rollOut
}

@-webkit-keyframes zoomIn {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	50% {
		opacity: 1
	}
}

@keyframes zoomIn {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	50% {
		opacity: 1
	}
}

.zoomIn {
	-webkit-animation-name: zoomIn;
	animation-name: zoomIn
}

@-webkit-keyframes zoomInDown {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInDown {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInDown {
	-webkit-animation-name: zoomInDown;
	animation-name: zoomInDown
}

@-webkit-keyframes zoomInLeft {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInLeft {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInLeft {
	-webkit-animation-name: zoomInLeft;
	animation-name: zoomInLeft
}

@-webkit-keyframes zoomInRight {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInRight {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInRight {
	-webkit-animation-name: zoomInRight;
	animation-name: zoomInRight
}

@-webkit-keyframes zoomInUp {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInUp {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInUp {
	-webkit-animation-name: zoomInUp;
	animation-name: zoomInUp
}

@-webkit-keyframes zoomOut {
	0% {
		opacity: 1
	}
	50% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	to {
		opacity: 0
	}
}

@keyframes zoomOut {
	0% {
		opacity: 1
	}
	50% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	to {
		opacity: 0
	}
}

.zoomOut {
	-webkit-animation-name: zoomOut;
	animation-name: zoomOut
}

@-webkit-keyframes zoomOutDown {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomOutDown {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomOutDown {
	-webkit-animation-name: zoomOutDown;
	animation-name: zoomOutDown
}

@-webkit-keyframes zoomOutLeft {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(-2000px, 0, 0);
		transform: scale(.1) translate3d(-2000px, 0, 0);
		-webkit-transform-origin: left center;
		transform-origin: left center
	}
}

@keyframes zoomOutLeft {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(-2000px, 0, 0);
		transform: scale(.1) translate3d(-2000px, 0, 0);
		-webkit-transform-origin: left center;
		transform-origin: left center
	}
}

.zoomOutLeft {
	-webkit-animation-name: zoomOutLeft;
	animation-name: zoomOutLeft
}

@-webkit-keyframes zoomOutRight {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(2000px, 0, 0);
		transform: scale(.1) translate3d(2000px, 0, 0);
		-webkit-transform-origin: right center;
		transform-origin: right center
	}
}

@keyframes zoomOutRight {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(2000px, 0, 0);
		transform: scale(.1) translate3d(2000px, 0, 0);
		-webkit-transform-origin: right center;
		transform-origin: right center
	}
}

.zoomOutRight {
	-webkit-animation-name: zoomOutRight;
	animation-name: zoomOutRight
}

@-webkit-keyframes zoomOutUp {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomOutUp {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomOutUp {
	-webkit-animation-name: zoomOutUp;
	animation-name: zoomOutUp
}

@-webkit-keyframes slideInDown {
	0% {
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInDown {
	0% {
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInDown {
	-webkit-animation-name: slideInDown;
	animation-name: slideInDown
}

@-webkit-keyframes slideInLeft {
	0% {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInLeft {
	0% {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInLeft {
	-webkit-animation-name: slideInLeft;
	animation-name: slideInLeft
}

@-webkit-keyframes slideInRight {
	0% {
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInRight {
	0% {
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInRight {
	-webkit-animation-name: slideInRight;
	animation-name: slideInRight
}

@-webkit-keyframes slideInUp {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInUp {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInUp {
	-webkit-animation-name: slideInUp;
	animation-name: slideInUp
}

@-webkit-keyframes slideOutDown {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

@keyframes slideOutDown {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

.slideOutDown {
	-webkit-animation-name: slideOutDown;
	animation-name: slideOutDown
}

@-webkit-keyframes slideOutLeft {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

@keyframes slideOutLeft {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

.slideOutLeft {
	-webkit-animation-name: slideOutLeft;
	animation-name: slideOutLeft
}

@-webkit-keyframes slideOutRight {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

@keyframes slideOutRight {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

.slideOutRight {
	-webkit-animation-name: slideOutRight;
	animation-name: slideOutRight
}

@-webkit-keyframes slideOutUp {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

@keyframes slideOutUp {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

.slideOutUp {
	-webkit-animation-name: slideOutUp;
	animation-name: slideOutUp
}

.animated {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both
}

.animated.infinite {
	-webkit-animation-iteration-count: infinite;
	animation-iteration-count: infinite
}

.animated.delay-1s {
	-webkit-animation-delay: 1s;
	animation-delay: 1s
}

.animated.delay-2s {
	-webkit-animation-delay: 2s;
	animation-delay: 2s
}

.animated.delay-3s {
	-webkit-animation-delay: 3s;
	animation-delay: 3s
}

.animated.delay-4s {
	-webkit-animation-delay: 4s;
	animation-delay: 4s
}

.animated.delay-5s {
	-webkit-animation-delay: 5s;
	animation-delay: 5s
}

.animated.duration-0 {
	-webkit-animation-duration: 0ms;
	animation-duration: 0ms
}
.animated.duration-100 {
	-webkit-animation-duration: 100ms;
	animation-duration: 100ms
}
.animated.duration-200 {
	-webkit-animation-duration: 200ms;
	animation-duration: 200ms
}
.animated.duration-300 {
	-webkit-animation-duration: 300ms;
	animation-duration: 300ms
}
.animated.duration-400 {
	-webkit-animation-duration: 400ms;
	animation-duration: 400ms
}
.animated.duration-500 {
	-webkit-animation-duration: 500ms;
	animation-duration: 500ms
}

.animated.duration-600 {
	-webkit-animation-duration: 600ms;
	animation-duration: 600ms
}

.animated.duration-700 {
	-webkit-animation-duration: 700ms;
	animation-duration: 700ms
}

.animated.duration-800 {
	-webkit-animation-duration: 800ms;
	animation-duration: 800ms
}

.animated.duration-1000 {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
}

.animated.duration-2000 {
	-webkit-animation-duration: 2s;
	animation-duration: 2s;
}


.animated.duration-3000 {
	-webkit-animation-duration: 3s;
	animation-duration: 3s;
}

.animated.duration-4000 {
	-webkit-animation-duration: 4s;
	animation-duration: 4s;
}

.animated.duration-5000 {
	-webkit-animation-duration: 5s;
	animation-duration: 5s;
}


.animated.stop {
	-webkit-animation-duration: 0s;
	animation-duration: 0s
}

.animated.slow {
	-webkit-animation-duration: 2s;
	animation-duration: 2s
}

.animated.slower {
	-webkit-animation-duration: 3s;
	animation-duration: 3s
}
/*
@media (prefers-reduced-motion:reduce),
(print) {
	.animated {
		-webkit-animation-duration: 1ms!important;
		animation-duration: 1ms!important;
		-webkit-transition-duration: 1ms!important;
		transition-duration: 1ms!important;
		-webkit-animation-iteration-count: 1!important;
		animation-iteration-count: 1!important
	}
} */
`;

});

parcelRegister("lPtvR", function(module, exports) {
"use strict";
var $fe45410e6fda80d0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fe45410e6fda80d0$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Animation = void 0;

var $d1fLk = parcelRequire("d1fLk");

var $6MASl = parcelRequire("6MASl");
let $fe45410e6fda80d0$var$Animation = class Animation extends $d1fLk.Attribute {
    OnInit() {
        this.pushStylesToParent();
        this.modify();
    }
    OnDestroy() {
        this.element.classList.remove('animated', this.value);
        this.setStyles({
            animationDelay: null
        })(this.element);
    }
    OnUpdate() {
        this.modify();
    }
    OnUpdateAttribute() {
        this.modify();
    }
    modify() {
        this.element.classList.add('animated', this.value);
        this.setStyles({
            animationDelay: this.delay
        })(this.element);
    }
    pushStylesToParent() {
        var _a;
        const style = document.createElement('style');
        style.innerHTML = $6MASl.Animations;
        const root = (_a = this.parent.shadowRoot) !== null && _a !== void 0 ? _a : this.parent;
        root.prepend(style);
    }
};
module.exports.Animation = $fe45410e6fda80d0$var$Animation;
$fe45410e6fda80d0$var$__decorate([
    (0, $d1fLk.Input)({
        observe: true
    }),
    $fe45410e6fda80d0$var$__metadata("design:type", String)
], $fe45410e6fda80d0$var$Animation.prototype, "delay", void 0);
module.exports.Animation = $fe45410e6fda80d0$var$Animation = $fe45410e6fda80d0$var$__decorate([
    (0, $d1fLk.Modifier)({
        selector: 'animated',
        registry () {
            return new $d1fLk.CustomAttributeRegistry(this);
        }
    })
], $fe45410e6fda80d0$var$Animation);

});

parcelRegister("a3Nx2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("j8NvH", function(module, exports) {

$parcel$export(module.exports, "Animation", () => $3c52f273581cb97a$export$c35d437ae5945fcd);

var $g0n63 = parcelRequire("g0n63");

var $d1fLk = parcelRequire("d1fLk");

var $64Pi0 = parcelRequire("64Pi0");

var $Iytat = parcelRequire("Iytat");
class $3c52f273581cb97a$export$c35d437ae5945fcd extends (0, $d1fLk.Attribute) {
    OnInit() {
        this.animated = true;
        this.prevValue = this.value;
        this.pushStylesToParent();
        this.modify();
    }
    OnDestroy() {
        this.element.classList.remove(this.value);
        this.element.classList.remove(this.prevValue);
        this.animated = false;
    }
    OnUpdate() {
        this.modify();
        this.prevValue = this.value;
    }
    modify() {
        this.element.classList.remove(this.prevValue);
        this.element.classList.add(this.value);
    }
    pushStylesToParent() {
        const style = document.createElement('style');
        style.innerHTML = (0, $Iytat.Animations);
        const root = this.parent.shadowRoot ?? this.parent;
        root.prepend(style);
    }
}
(0, $g0n63.__decorate)([
    (0, $d1fLk.Input)({
        observe: true
    }),
    (0, $64Pi0.HostBinding)('style.animationDelay')
], $3c52f273581cb97a$export$c35d437ae5945fcd.prototype, "delay", void 0);
(0, $g0n63.__decorate)([
    (0, $64Pi0.HostBinding)('class.animated')
], $3c52f273581cb97a$export$c35d437ae5945fcd.prototype, "animated", void 0);
$3c52f273581cb97a$export$c35d437ae5945fcd = (0, $g0n63.__decorate)([
    (0, $d1fLk.Modifier)({
        selector: 'animated',
        registry () {
            return new (0, $d1fLk.CustomAttributeRegistry)(this);
        }
    })
], $3c52f273581cb97a$export$c35d437ae5945fcd);

});
parcelRegister("Iytat", function(module, exports) {

$parcel$export(module.exports, "Animations", () => $319fd267913c6375$export$8ab227dac26677d);
const $319fd267913c6375$export$8ab227dac26677d = `
@charset "UTF-8";

/*!
 * animate.css -https://daneden.github.io/animate.css/
 * Version - 3.7.2
 * Licensed under the MIT license - http://opensource.org/licenses/MIT
 *
 * Copyright (c) 2019 Daniel Eden
 */

@-webkit-keyframes bounce {
	0%,
	20%,
	53%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	40%,
	43% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -30px, 0);
		transform: translate3d(0, -30px, 0)
	}
	70% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -15px, 0);
		transform: translate3d(0, -15px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -4px, 0);
		transform: translate3d(0, -4px, 0)
	}
}

@keyframes bounce {
	0%,
	20%,
	53%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	40%,
	43% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -30px, 0);
		transform: translate3d(0, -30px, 0)
	}
	70% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -15px, 0);
		transform: translate3d(0, -15px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -4px, 0);
		transform: translate3d(0, -4px, 0)
	}
}

.bounce {
	-webkit-animation-name: bounce;
	animation-name: bounce;
	-webkit-transform-origin: center bottom;
	transform-origin: center bottom
}

@-webkit-keyframes flash {
	0%,
	50%,
	to {
		opacity: 1
	}
	25%,
	75% {
		opacity: 0
	}
}

@keyframes flash {
	0%,
	50%,
	to {
		opacity: 1
	}
	25%,
	75% {
		opacity: 0
	}
}

.flash {
	-webkit-animation-name: flash;
	animation-name: flash
}

@-webkit-keyframes pulse {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	50% {
		-webkit-transform: scale3d(1.05, 1.05, 1.05);
		transform: scale3d(1.05, 1.05, 1.05)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes pulse {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	50% {
		-webkit-transform: scale3d(1.05, 1.05, 1.05);
		transform: scale3d(1.05, 1.05, 1.05)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.pulse {
	-webkit-animation-name: pulse;
	animation-name: pulse
}

@-webkit-keyframes rubberBand {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	30% {
		-webkit-transform: scale3d(1.25, .75, 1);
		transform: scale3d(1.25, .75, 1)
	}
	40% {
		-webkit-transform: scale3d(.75, 1.25, 1);
		transform: scale3d(.75, 1.25, 1)
	}
	50% {
		-webkit-transform: scale3d(1.15, .85, 1);
		transform: scale3d(1.15, .85, 1)
	}
	65% {
		-webkit-transform: scale3d(.95, 1.05, 1);
		transform: scale3d(.95, 1.05, 1)
	}
	75% {
		-webkit-transform: scale3d(1.05, .95, 1);
		transform: scale3d(1.05, .95, 1)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes rubberBand {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	30% {
		-webkit-transform: scale3d(1.25, .75, 1);
		transform: scale3d(1.25, .75, 1)
	}
	40% {
		-webkit-transform: scale3d(.75, 1.25, 1);
		transform: scale3d(.75, 1.25, 1)
	}
	50% {
		-webkit-transform: scale3d(1.15, .85, 1);
		transform: scale3d(1.15, .85, 1)
	}
	65% {
		-webkit-transform: scale3d(.95, 1.05, 1);
		transform: scale3d(.95, 1.05, 1)
	}
	75% {
		-webkit-transform: scale3d(1.05, .95, 1);
		transform: scale3d(1.05, .95, 1)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.rubberBand {
	-webkit-animation-name: rubberBand;
	animation-name: rubberBand
}

@-webkit-keyframes shake {
	0%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	10%,
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	20%,
	40%,
	60%,
	80% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
}

@keyframes shake {
	0%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	10%,
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	20%,
	40%,
	60%,
	80% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
}

.shake {
	-webkit-animation-name: shake;
	animation-name: shake
}

@-webkit-keyframes headShake {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
	6.5% {
		-webkit-transform: translateX(-6px) rotateY(-9deg);
		transform: translateX(-6px) rotateY(-9deg)
	}
	18.5% {
		-webkit-transform: translateX(5px) rotateY(7deg);
		transform: translateX(5px) rotateY(7deg)
	}
	31.5% {
		-webkit-transform: translateX(-3px) rotateY(-5deg);
		transform: translateX(-3px) rotateY(-5deg)
	}
	43.5% {
		-webkit-transform: translateX(2px) rotateY(3deg);
		transform: translateX(2px) rotateY(3deg)
	}
	50% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
}

@keyframes headShake {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
	6.5% {
		-webkit-transform: translateX(-6px) rotateY(-9deg);
		transform: translateX(-6px) rotateY(-9deg)
	}
	18.5% {
		-webkit-transform: translateX(5px) rotateY(7deg);
		transform: translateX(5px) rotateY(7deg)
	}
	31.5% {
		-webkit-transform: translateX(-3px) rotateY(-5deg);
		transform: translateX(-3px) rotateY(-5deg)
	}
	43.5% {
		-webkit-transform: translateX(2px) rotateY(3deg);
		transform: translateX(2px) rotateY(3deg)
	}
	50% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
}

.headShake {
	-webkit-animation-timing-function: ease-in-out;
	animation-timing-function: ease-in-out;
	-webkit-animation-name: headShake;
	animation-name: headShake
}

@-webkit-keyframes swing {
	20% {
		-webkit-transform: rotate(15deg);
		transform: rotate(15deg)
	}
	40% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	60% {
		-webkit-transform: rotate(5deg);
		transform: rotate(5deg)
	}
	80% {
		-webkit-transform: rotate(-5deg);
		transform: rotate(-5deg)
	}
	to {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg)
	}
}

@keyframes swing {
	20% {
		-webkit-transform: rotate(15deg);
		transform: rotate(15deg)
	}
	40% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	60% {
		-webkit-transform: rotate(5deg);
		transform: rotate(5deg)
	}
	80% {
		-webkit-transform: rotate(-5deg);
		transform: rotate(-5deg)
	}
	to {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg)
	}
}

.swing {
	-webkit-transform-origin: top center;
	transform-origin: top center;
	-webkit-animation-name: swing;
	animation-name: swing
}

@-webkit-keyframes tada {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	10%,
	20% {
		-webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
		transform: scale3d(.9, .9, .9) rotate(-3deg)
	}
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(3deg)
	}
	40%,
	60%,
	80% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes tada {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	10%,
	20% {
		-webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
		transform: scale3d(.9, .9, .9) rotate(-3deg)
	}
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(3deg)
	}
	40%,
	60%,
	80% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.tada {
	-webkit-animation-name: tada;
	animation-name: tada
}

@-webkit-keyframes wobble {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	15% {
		-webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
		transform: translate3d(-25%, 0, 0) rotate(-5deg)
	}
	30% {
		-webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
		transform: translate3d(20%, 0, 0) rotate(3deg)
	}
	45% {
		-webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
		transform: translate3d(-15%, 0, 0) rotate(-3deg)
	}
	60% {
		-webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
		transform: translate3d(10%, 0, 0) rotate(2deg)
	}
	75% {
		-webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
		transform: translate3d(-5%, 0, 0) rotate(-1deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes wobble {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	15% {
		-webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
		transform: translate3d(-25%, 0, 0) rotate(-5deg)
	}
	30% {
		-webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
		transform: translate3d(20%, 0, 0) rotate(3deg)
	}
	45% {
		-webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
		transform: translate3d(-15%, 0, 0) rotate(-3deg)
	}
	60% {
		-webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
		transform: translate3d(10%, 0, 0) rotate(2deg)
	}
	75% {
		-webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
		transform: translate3d(-5%, 0, 0) rotate(-1deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.wobble {
	-webkit-animation-name: wobble;
	animation-name: wobble
}

@-webkit-keyframes jello {
	0%,
	11.1%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	22.2% {
		-webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
		transform: skewX(-12.5deg) skewY(-12.5deg)
	}
	33.3% {
		-webkit-transform: skewX(6.25deg) skewY(6.25deg);
		transform: skewX(6.25deg) skewY(6.25deg)
	}
	44.4% {
		-webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
		transform: skewX(-3.125deg) skewY(-3.125deg)
	}
	55.5% {
		-webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
		transform: skewX(1.5625deg) skewY(1.5625deg)
	}
	66.6% {
		-webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
		transform: skewX(-.78125deg) skewY(-.78125deg)
	}
	77.7% {
		-webkit-transform: skewX(.390625deg) skewY(.390625deg);
		transform: skewX(.390625deg) skewY(.390625deg)
	}
	88.8% {
		-webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
		transform: skewX(-.1953125deg) skewY(-.1953125deg)
	}
}

@keyframes jello {
	0%,
	11.1%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	22.2% {
		-webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
		transform: skewX(-12.5deg) skewY(-12.5deg)
	}
	33.3% {
		-webkit-transform: skewX(6.25deg) skewY(6.25deg);
		transform: skewX(6.25deg) skewY(6.25deg)
	}
	44.4% {
		-webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
		transform: skewX(-3.125deg) skewY(-3.125deg)
	}
	55.5% {
		-webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
		transform: skewX(1.5625deg) skewY(1.5625deg)
	}
	66.6% {
		-webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
		transform: skewX(-.78125deg) skewY(-.78125deg)
	}
	77.7% {
		-webkit-transform: skewX(.390625deg) skewY(.390625deg);
		transform: skewX(.390625deg) skewY(.390625deg)
	}
	88.8% {
		-webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
		transform: skewX(-.1953125deg) skewY(-.1953125deg)
	}
}

.jello {
	-webkit-animation-name: jello;
	animation-name: jello;
	-webkit-transform-origin: center;
	transform-origin: center
}

@-webkit-keyframes heartBeat {
	0% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	14% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	28% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	42% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	70% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

@keyframes heartBeat {
	0% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	14% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	28% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	42% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	70% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

.heartBeat {
	-webkit-animation-name: heartBeat;
	animation-name: heartBeat;
	-webkit-animation-duration: 1.3s;
	animation-duration: 1.3s;
	-webkit-animation-timing-function: ease-in-out;
	animation-timing-function: ease-in-out
}

@-webkit-keyframes bounceIn {
	0%,
	20%,
	40%,
	60%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	20% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	40% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(1.03, 1.03, 1.03);
		transform: scale3d(1.03, 1.03, 1.03)
	}
	80% {
		-webkit-transform: scale3d(.97, .97, .97);
		transform: scale3d(.97, .97, .97)
	}
	to {
		opacity: 1;
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes bounceIn {
	0%,
	20%,
	40%,
	60%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	20% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	40% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(1.03, 1.03, 1.03);
		transform: scale3d(1.03, 1.03, 1.03)
	}
	80% {
		-webkit-transform: scale3d(.97, .97, .97);
		transform: scale3d(.97, .97, .97)
	}
	to {
		opacity: 1;
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.bounceIn {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: bounceIn;
	animation-name: bounceIn
}

@-webkit-keyframes bounceInDown {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -3000px, 0);
		transform: translate3d(0, -3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, 25px, 0);
		transform: translate3d(0, 25px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, 5px, 0);
		transform: translate3d(0, 5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInDown {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -3000px, 0);
		transform: translate3d(0, -3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, 25px, 0);
		transform: translate3d(0, 25px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, 5px, 0);
		transform: translate3d(0, 5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInDown {
	-webkit-animation-name: bounceInDown;
	animation-name: bounceInDown
}

@-webkit-keyframes bounceInLeft {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-3000px, 0, 0);
		transform: translate3d(-3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(25px, 0, 0);
		transform: translate3d(25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(5px, 0, 0);
		transform: translate3d(5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInLeft {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-3000px, 0, 0);
		transform: translate3d(-3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(25px, 0, 0);
		transform: translate3d(25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(5px, 0, 0);
		transform: translate3d(5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInLeft {
	-webkit-animation-name: bounceInLeft;
	animation-name: bounceInLeft
}

@-webkit-keyframes bounceInRight {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(3000px, 0, 0);
		transform: translate3d(3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(-25px, 0, 0);
		transform: translate3d(-25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(-5px, 0, 0);
		transform: translate3d(-5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInRight {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(3000px, 0, 0);
		transform: translate3d(3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(-25px, 0, 0);
		transform: translate3d(-25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(-5px, 0, 0);
		transform: translate3d(-5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInRight {
	-webkit-animation-name: bounceInRight;
	animation-name: bounceInRight
}

@-webkit-keyframes bounceInUp {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 3000px, 0);
		transform: translate3d(0, 3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -5px, 0);
		transform: translate3d(0, -5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInUp {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 3000px, 0);
		transform: translate3d(0, 3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -5px, 0);
		transform: translate3d(0, -5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInUp {
	-webkit-animation-name: bounceInUp;
	animation-name: bounceInUp
}

@-webkit-keyframes bounceOut {
	20% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	50%,
	55% {
		opacity: 1;
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
}

@keyframes bounceOut {
	20% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	50%,
	55% {
		opacity: 1;
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
}

.bounceOut {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: bounceOut;
	animation-name: bounceOut
}

@-webkit-keyframes bounceOutDown {
	20% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

@keyframes bounceOutDown {
	20% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

.bounceOutDown {
	-webkit-animation-name: bounceOutDown;
	animation-name: bounceOutDown
}

@-webkit-keyframes bounceOutLeft {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(20px, 0, 0);
		transform: translate3d(20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

@keyframes bounceOutLeft {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(20px, 0, 0);
		transform: translate3d(20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

.bounceOutLeft {
	-webkit-animation-name: bounceOutLeft;
	animation-name: bounceOutLeft
}

@-webkit-keyframes bounceOutRight {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(-20px, 0, 0);
		transform: translate3d(-20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

@keyframes bounceOutRight {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(-20px, 0, 0);
		transform: translate3d(-20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

.bounceOutRight {
	-webkit-animation-name: bounceOutRight;
	animation-name: bounceOutRight
}

@-webkit-keyframes bounceOutUp {
	20% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, 20px, 0);
		transform: translate3d(0, 20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

@keyframes bounceOutUp {
	20% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, 20px, 0);
		transform: translate3d(0, 20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

.bounceOutUp {
	-webkit-animation-name: bounceOutUp;
	animation-name: bounceOutUp
}

@-webkit-keyframes fadeIn {
	0% {
		opacity: 0
	}
	to {
		opacity: 1
	}
}

@keyframes fadeIn {
	0% {
		opacity: 0
	}
	to {
		opacity: 1
	}
}

.fadeIn {
	-webkit-animation-name: fadeIn;
	animation-name: fadeIn
}

@-webkit-keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInDown {
	-webkit-animation-name: fadeInDown;
	animation-name: fadeInDown
}

@-webkit-keyframes fadeInDownBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInDownBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInDownBig {
	-webkit-animation-name: fadeInDownBig;
	animation-name: fadeInDownBig
}

@-webkit-keyframes fadeInLeft {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInLeft {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInLeft {
	-webkit-animation-name: fadeInLeft;
	animation-name: fadeInLeft
}

@-webkit-keyframes fadeInLeftBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInLeftBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInLeftBig {
	-webkit-animation-name: fadeInLeftBig;
	animation-name: fadeInLeftBig
}

@-webkit-keyframes fadeInRight {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInRight {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInRight {
	-webkit-animation-name: fadeInRight;
	animation-name: fadeInRight
}

@-webkit-keyframes fadeInRightBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInRightBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInRightBig {
	-webkit-animation-name: fadeInRightBig;
	animation-name: fadeInRightBig
}

@-webkit-keyframes fadeInUp {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInUp {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInUp {
	-webkit-animation-name: fadeInUp;
	animation-name: fadeInUp
}

@-webkit-keyframes fadeInUpBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInUpBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInUpBig {
	-webkit-animation-name: fadeInUpBig;
	animation-name: fadeInUpBig
}

@-webkit-keyframes fadeOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0
	}
}

@keyframes fadeOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0
	}
}

.fadeOut {
	-webkit-animation-name: fadeOut;
	animation-name: fadeOut
}

@-webkit-keyframes fadeOutDown {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

@keyframes fadeOutDown {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

.fadeOutDown {
	-webkit-animation-name: fadeOutDown;
	animation-name: fadeOutDown
}

@-webkit-keyframes fadeOutDownBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

@keyframes fadeOutDownBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

.fadeOutDownBig {
	-webkit-animation-name: fadeOutDownBig;
	animation-name: fadeOutDownBig
}

@-webkit-keyframes fadeOutLeft {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

@keyframes fadeOutLeft {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

.fadeOutLeft {
	-webkit-animation-name: fadeOutLeft;
	animation-name: fadeOutLeft
}

@-webkit-keyframes fadeOutLeftBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

@keyframes fadeOutLeftBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

.fadeOutLeftBig {
	-webkit-animation-name: fadeOutLeftBig;
	animation-name: fadeOutLeftBig
}

@-webkit-keyframes fadeOutRight {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

@keyframes fadeOutRight {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

.fadeOutRight {
	-webkit-animation-name: fadeOutRight;
	animation-name: fadeOutRight
}

@-webkit-keyframes fadeOutRightBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

@keyframes fadeOutRightBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

.fadeOutRightBig {
	-webkit-animation-name: fadeOutRightBig;
	animation-name: fadeOutRightBig
}

@-webkit-keyframes fadeOutUp {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

@keyframes fadeOutUp {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

.fadeOutUp {
	-webkit-animation-name: fadeOutUp;
	animation-name: fadeOutUp
}

@-webkit-keyframes fadeOutUpBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

@keyframes fadeOutUpBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

.fadeOutUpBig {
	-webkit-animation-name: fadeOutUpBig;
	animation-name: fadeOutUpBig
}

@-webkit-keyframes flip {
	0% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	40% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	50% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	80% {
		-webkit-transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	to {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
}

@keyframes flip {
	0% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	40% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	50% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	80% {
		-webkit-transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	to {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
}

.animated.flip {
	-webkit-backface-visibility: visible;
	backface-visibility: visible;
	-webkit-animation-name: flip;
	animation-name: flip
}

@-webkit-keyframes flipInX {
	0% {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateX(10deg);
		transform: perspective(400px) rotateX(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateX(-5deg);
		transform: perspective(400px) rotateX(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

@keyframes flipInX {
	0% {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateX(10deg);
		transform: perspective(400px) rotateX(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateX(-5deg);
		transform: perspective(400px) rotateX(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

.flipInX {
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipInX;
	animation-name: flipInX
}

@-webkit-keyframes flipInY {
	0% {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateY(-20deg);
		transform: perspective(400px) rotateY(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateY(10deg);
		transform: perspective(400px) rotateY(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateY(-5deg);
		transform: perspective(400px) rotateY(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

@keyframes flipInY {
	0% {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateY(-20deg);
		transform: perspective(400px) rotateY(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateY(10deg);
		transform: perspective(400px) rotateY(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateY(-5deg);
		transform: perspective(400px) rotateY(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

.flipInY {
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipInY;
	animation-name: flipInY
}

@-webkit-keyframes flipOutX {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		opacity: 0
	}
}

@keyframes flipOutX {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		opacity: 0
	}
}

.flipOutX {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: flipOutX;
	animation-name: flipOutX;
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important
}

@-webkit-keyframes flipOutY {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateY(-15deg);
		transform: perspective(400px) rotateY(-15deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		opacity: 0
	}
}

@keyframes flipOutY {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateY(-15deg);
		transform: perspective(400px) rotateY(-15deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		opacity: 0
	}
}

.flipOutY {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipOutY;
	animation-name: flipOutY
}

@-webkit-keyframes lightSpeedIn {
	0% {
		-webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
		transform: translate3d(100%, 0, 0) skewX(-30deg);
		opacity: 0
	}
	60% {
		-webkit-transform: skewX(20deg);
		transform: skewX(20deg);
		opacity: 1
	}
	80% {
		-webkit-transform: skewX(-5deg);
		transform: skewX(-5deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes lightSpeedIn {
	0% {
		-webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
		transform: translate3d(100%, 0, 0) skewX(-30deg);
		opacity: 0
	}
	60% {
		-webkit-transform: skewX(20deg);
		transform: skewX(20deg);
		opacity: 1
	}
	80% {
		-webkit-transform: skewX(-5deg);
		transform: skewX(-5deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.lightSpeedIn {
	-webkit-animation-name: lightSpeedIn;
	animation-name: lightSpeedIn;
	-webkit-animation-timing-function: ease-out;
	animation-timing-function: ease-out
}

@-webkit-keyframes lightSpeedOut {
	0% {
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
		transform: translate3d(100%, 0, 0) skewX(30deg);
		opacity: 0
	}
}

@keyframes lightSpeedOut {
	0% {
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
		transform: translate3d(100%, 0, 0) skewX(30deg);
		opacity: 0
	}
}

.lightSpeedOut {
	-webkit-animation-name: lightSpeedOut;
	animation-name: lightSpeedOut;
	-webkit-animation-timing-function: ease-in;
	animation-timing-function: ease-in
}

@-webkit-keyframes rotateIn {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(-200deg);
		transform: rotate(-200deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateIn {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(-200deg);
		transform: rotate(-200deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateIn {
	-webkit-animation-name: rotateIn;
	animation-name: rotateIn
}

@-webkit-keyframes rotateInDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInDownLeft {
	-webkit-animation-name: rotateInDownLeft;
	animation-name: rotateInDownLeft
}

@-webkit-keyframes rotateInDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInDownRight {
	-webkit-animation-name: rotateInDownRight;
	animation-name: rotateInDownRight
}

@-webkit-keyframes rotateInUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInUpLeft {
	-webkit-animation-name: rotateInUpLeft;
	animation-name: rotateInUpLeft
}

@-webkit-keyframes rotateInUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-90deg);
		transform: rotate(-90deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-90deg);
		transform: rotate(-90deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInUpRight {
	-webkit-animation-name: rotateInUpRight;
	animation-name: rotateInUpRight
}

@-webkit-keyframes rotateOut {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		opacity: 1
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(200deg);
		transform: rotate(200deg);
		opacity: 0
	}
}

@keyframes rotateOut {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		opacity: 1
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(200deg);
		transform: rotate(200deg);
		opacity: 0
	}
}

.rotateOut {
	-webkit-animation-name: rotateOut;
	animation-name: rotateOut
}

@-webkit-keyframes rotateOutDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
}

@keyframes rotateOutDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
}

.rotateOutDownLeft {
	-webkit-animation-name: rotateOutDownLeft;
	animation-name: rotateOutDownLeft
}

@-webkit-keyframes rotateOutDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

@keyframes rotateOutDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

.rotateOutDownRight {
	-webkit-animation-name: rotateOutDownRight;
	animation-name: rotateOutDownRight
}

@-webkit-keyframes rotateOutUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

@keyframes rotateOutUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

.rotateOutUpLeft {
	-webkit-animation-name: rotateOutUpLeft;
	animation-name: rotateOutUpLeft
}

@-webkit-keyframes rotateOutUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(90deg);
		transform: rotate(90deg);
		opacity: 0
	}
}

@keyframes rotateOutUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(90deg);
		transform: rotate(90deg);
		opacity: 0
	}
}

.rotateOutUpRight {
	-webkit-animation-name: rotateOutUpRight;
	animation-name: rotateOutUpRight
}

@-webkit-keyframes hinge {
	0% {
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	20%,
	60% {
		-webkit-transform: rotate(80deg);
		transform: rotate(80deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	40%,
	80% {
		-webkit-transform: rotate(60deg);
		transform: rotate(60deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out;
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(0, 700px, 0);
		transform: translate3d(0, 700px, 0);
		opacity: 0
	}
}

@keyframes hinge {
	0% {
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	20%,
	60% {
		-webkit-transform: rotate(80deg);
		transform: rotate(80deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	40%,
	80% {
		-webkit-transform: rotate(60deg);
		transform: rotate(60deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out;
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(0, 700px, 0);
		transform: translate3d(0, 700px, 0);
		opacity: 0
	}
}

.hinge {
	-webkit-animation-duration: 2s;
	animation-duration: 2s;
	-webkit-animation-name: hinge;
	animation-name: hinge
}

@-webkit-keyframes jackInTheBox {
	0% {
		opacity: 0;
		-webkit-transform: scale(.1) rotate(30deg);
		transform: scale(.1) rotate(30deg);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom
	}
	50% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	70% {
		-webkit-transform: rotate(3deg);
		transform: rotate(3deg)
	}
	to {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

@keyframes jackInTheBox {
	0% {
		opacity: 0;
		-webkit-transform: scale(.1) rotate(30deg);
		transform: scale(.1) rotate(30deg);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom
	}
	50% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	70% {
		-webkit-transform: rotate(3deg);
		transform: rotate(3deg)
	}
	to {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

.jackInTheBox {
	-webkit-animation-name: jackInTheBox;
	animation-name: jackInTheBox
}

@-webkit-keyframes rollIn {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);
		transform: translate3d(-100%, 0, 0) rotate(-120deg)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes rollIn {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);
		transform: translate3d(-100%, 0, 0) rotate(-120deg)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.rollIn {
	-webkit-animation-name: rollIn;
	animation-name: rollIn
}

@-webkit-keyframes rollOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0) rotate(120deg);
		transform: translate3d(100%, 0, 0) rotate(120deg)
	}
}

@keyframes rollOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0) rotate(120deg);
		transform: translate3d(100%, 0, 0) rotate(120deg)
	}
}

.rollOut {
	-webkit-animation-name: rollOut;
	animation-name: rollOut
}

@-webkit-keyframes zoomIn {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	50% {
		opacity: 1
	}
}

@keyframes zoomIn {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	50% {
		opacity: 1
	}
}

.zoomIn {
	-webkit-animation-name: zoomIn;
	animation-name: zoomIn
}

@-webkit-keyframes zoomInDown {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInDown {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInDown {
	-webkit-animation-name: zoomInDown;
	animation-name: zoomInDown
}

@-webkit-keyframes zoomInLeft {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInLeft {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInLeft {
	-webkit-animation-name: zoomInLeft;
	animation-name: zoomInLeft
}

@-webkit-keyframes zoomInRight {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInRight {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInRight {
	-webkit-animation-name: zoomInRight;
	animation-name: zoomInRight
}

@-webkit-keyframes zoomInUp {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInUp {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInUp {
	-webkit-animation-name: zoomInUp;
	animation-name: zoomInUp
}

@-webkit-keyframes zoomOut {
	0% {
		opacity: 1
	}
	50% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	to {
		opacity: 0
	}
}

@keyframes zoomOut {
	0% {
		opacity: 1
	}
	50% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	to {
		opacity: 0
	}
}

.zoomOut {
	-webkit-animation-name: zoomOut;
	animation-name: zoomOut
}

@-webkit-keyframes zoomOutDown {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomOutDown {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomOutDown {
	-webkit-animation-name: zoomOutDown;
	animation-name: zoomOutDown
}

@-webkit-keyframes zoomOutLeft {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(-2000px, 0, 0);
		transform: scale(.1) translate3d(-2000px, 0, 0);
		-webkit-transform-origin: left center;
		transform-origin: left center
	}
}

@keyframes zoomOutLeft {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(-2000px, 0, 0);
		transform: scale(.1) translate3d(-2000px, 0, 0);
		-webkit-transform-origin: left center;
		transform-origin: left center
	}
}

.zoomOutLeft {
	-webkit-animation-name: zoomOutLeft;
	animation-name: zoomOutLeft
}

@-webkit-keyframes zoomOutRight {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(2000px, 0, 0);
		transform: scale(.1) translate3d(2000px, 0, 0);
		-webkit-transform-origin: right center;
		transform-origin: right center
	}
}

@keyframes zoomOutRight {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(2000px, 0, 0);
		transform: scale(.1) translate3d(2000px, 0, 0);
		-webkit-transform-origin: right center;
		transform-origin: right center
	}
}

.zoomOutRight {
	-webkit-animation-name: zoomOutRight;
	animation-name: zoomOutRight
}

@-webkit-keyframes zoomOutUp {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomOutUp {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomOutUp {
	-webkit-animation-name: zoomOutUp;
	animation-name: zoomOutUp
}

@-webkit-keyframes slideInDown {
	0% {
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInDown {
	0% {
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInDown {
	-webkit-animation-name: slideInDown;
	animation-name: slideInDown
}

@-webkit-keyframes slideInLeft {
	0% {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInLeft {
	0% {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInLeft {
	-webkit-animation-name: slideInLeft;
	animation-name: slideInLeft
}

@-webkit-keyframes slideInRight {
	0% {
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInRight {
	0% {
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInRight {
	-webkit-animation-name: slideInRight;
	animation-name: slideInRight
}

@-webkit-keyframes slideInUp {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInUp {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInUp {
	-webkit-animation-name: slideInUp;
	animation-name: slideInUp
}

@-webkit-keyframes slideOutDown {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

@keyframes slideOutDown {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

.slideOutDown {
	-webkit-animation-name: slideOutDown;
	animation-name: slideOutDown
}

@-webkit-keyframes slideOutLeft {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

@keyframes slideOutLeft {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

.slideOutLeft {
	-webkit-animation-name: slideOutLeft;
	animation-name: slideOutLeft
}

@-webkit-keyframes slideOutRight {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

@keyframes slideOutRight {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

.slideOutRight {
	-webkit-animation-name: slideOutRight;
	animation-name: slideOutRight
}

@-webkit-keyframes slideOutUp {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

@keyframes slideOutUp {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

.slideOutUp {
	-webkit-animation-name: slideOutUp;
	animation-name: slideOutUp
}

.animated {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both
}

.animated.infinite {
	-webkit-animation-iteration-count: infinite;
	animation-iteration-count: infinite
}

.animated.delay-1s {
	-webkit-animation-delay: 1s;
	animation-delay: 1s
}

.animated.delay-2s {
	-webkit-animation-delay: 2s;
	animation-delay: 2s
}

.animated.delay-3s {
	-webkit-animation-delay: 3s;
	animation-delay: 3s
}

.animated.delay-4s {
	-webkit-animation-delay: 4s;
	animation-delay: 4s
}

.animated.delay-5s {
	-webkit-animation-delay: 5s;
	animation-delay: 5s
}

.animated.duration-0 {
	-webkit-animation-duration: 0ms;
	animation-duration: 0ms
}
.animated.duration-100 {
	-webkit-animation-duration: 100ms;
	animation-duration: 100ms
}
.animated.duration-200 {
	-webkit-animation-duration: 200ms;
	animation-duration: 200ms
}
.animated.duration-300 {
	-webkit-animation-duration: 300ms;
	animation-duration: 300ms
}
.animated.duration-400 {
	-webkit-animation-duration: 400ms;
	animation-duration: 400ms
}
.animated.duration-500 {
	-webkit-animation-duration: 500ms;
	animation-duration: 500ms
}

.animated.duration-600 {
	-webkit-animation-duration: 600ms;
	animation-duration: 600ms
}

.animated.duration-700 {
	-webkit-animation-duration: 700ms;
	animation-duration: 700ms
}

.animated.duration-800 {
	-webkit-animation-duration: 800ms;
	animation-duration: 800ms
}

.animated.duration-1000 {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
}

.animated.duration-2000 {
	-webkit-animation-duration: 2s;
	animation-duration: 2s;
}


.animated.duration-3000 {
	-webkit-animation-duration: 3s;
	animation-duration: 3s;
}

.animated.duration-4000 {
	-webkit-animation-duration: 4s;
	animation-duration: 4s;
}

.animated.duration-5000 {
	-webkit-animation-duration: 5s;
	animation-duration: 5s;
}


.animated.stop {
	-webkit-animation-duration: 0s;
	animation-duration: 0s
}

.animated.slow {
	-webkit-animation-duration: 2s;
	animation-duration: 2s
}

.animated.slower {
	-webkit-animation-duration: 3s;
	animation-duration: 3s
}
/*
@media (prefers-reduced-motion:reduce),
(print) {
	.animated {
		-webkit-animation-duration: 1ms!important;
		animation-duration: 1ms!important;
		-webkit-transition-duration: 1ms!important;
		transition-duration: 1ms!important;
		-webkit-animation-iteration-count: 1!important;
		animation-iteration-count: 1!important
	}
} */
`;

});


parcelRegister("ekdYX", function(module, exports) {
module.exports = import("5i8gt").then(()=>parcelRequire('hZHwJ'));

});

parcelRegister("8nfYN", function(module, exports) {
module.exports = import("h7ULv").then(()=>parcelRequire('liy3g'));

});

parcelRegister("c2lOr", function(module, exports) {
module.exports = import("22ysJ").then(()=>parcelRequire('dVXJs'));

});

parcelRegister("1SxFh", function(module, exports) {
module.exports = import("crcLC").then(()=>parcelRequire('1x6nW'));

});


var $4QMof = parcelRequire("4QMof");
parcelRequire("6Lt8S");
var $cRdul = parcelRequire("cRdul");

var $4XQlz = parcelRequire("4XQlz");

var $iuXHq = parcelRequire("iuXHq");

var $23prF = parcelRequire("23prF");

var $g0n63 = parcelRequire("g0n63");

var $g0n63 = parcelRequire("g0n63");

var $4QMof = parcelRequire("4QMof");
/* tslint:disable */ /* eslint-disable prettier/prettier */ const $478f0ec0f0369b34$export$2cbd0be658ac061c = {
    "src/app/core/services/ai/mutation/create-completion-gemini.mutation.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "createCompletionGemini",
                    "loc": {
                        "start": 9,
                        "end": 31
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "payload",
                                "loc": {
                                    "start": 33,
                                    "end": 40
                                }
                            },
                            "loc": {
                                "start": 32,
                                "end": 40
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "CreateCompletionGeminiInputType",
                                    "loc": {
                                        "start": 42,
                                        "end": 73
                                    }
                                },
                                "loc": {
                                    "start": 42,
                                    "end": 73
                                }
                            },
                            "loc": {
                                "start": 42,
                                "end": 74
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 32,
                            "end": 74
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createCompletionGemini",
                                "loc": {
                                    "start": 80,
                                    "end": 102
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payload",
                                        "loc": {
                                            "start": 103,
                                            "end": 110
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "payload",
                                            "loc": {
                                                "start": 113,
                                                "end": 120
                                            }
                                        },
                                        "loc": {
                                            "start": 112,
                                            "end": 120
                                        }
                                    },
                                    "loc": {
                                        "start": 103,
                                        "end": 120
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "candidates",
                                            "loc": {
                                                "start": 128,
                                                "end": 138
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": {
                                            "kind": "SelectionSet",
                                            "selections": [
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "content",
                                                        "loc": {
                                                            "start": 147,
                                                            "end": 154
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": {
                                                        "kind": "SelectionSet",
                                                        "selections": [
                                                            {
                                                                "kind": "Field",
                                                                "alias": null,
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "parts",
                                                                    "loc": {
                                                                        "start": 165,
                                                                        "end": 170
                                                                    }
                                                                },
                                                                "arguments": [],
                                                                "directives": [],
                                                                "selectionSet": {
                                                                    "kind": "SelectionSet",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "Field",
                                                                            "alias": null,
                                                                            "name": {
                                                                                "kind": "Name",
                                                                                "value": "text",
                                                                                "loc": {
                                                                                    "start": 183,
                                                                                    "end": 187
                                                                                }
                                                                            },
                                                                            "arguments": [],
                                                                            "directives": [],
                                                                            "selectionSet": null,
                                                                            "loc": {
                                                                                "start": 183,
                                                                                "end": 187
                                                                            }
                                                                        }
                                                                    ],
                                                                    "loc": {
                                                                        "start": 171,
                                                                        "end": 197
                                                                    }
                                                                },
                                                                "loc": {
                                                                    "start": 165,
                                                                    "end": 197
                                                                }
                                                            },
                                                            {
                                                                "kind": "Field",
                                                                "alias": null,
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "role",
                                                                    "loc": {
                                                                        "start": 206,
                                                                        "end": 210
                                                                    }
                                                                },
                                                                "arguments": [],
                                                                "directives": [],
                                                                "selectionSet": null,
                                                                "loc": {
                                                                    "start": 206,
                                                                    "end": 210
                                                                }
                                                            }
                                                        ],
                                                        "loc": {
                                                            "start": 155,
                                                            "end": 218
                                                        }
                                                    },
                                                    "loc": {
                                                        "start": 147,
                                                        "end": 218
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "finishReason",
                                                        "loc": {
                                                            "start": 225,
                                                            "end": 237
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 225,
                                                        "end": 237
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "avgLogprobs",
                                                        "loc": {
                                                            "start": 244,
                                                            "end": 255
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 244,
                                                        "end": 255
                                                    }
                                                }
                                            ],
                                            "loc": {
                                                "start": 139,
                                                "end": 261
                                            }
                                        },
                                        "loc": {
                                            "start": 128,
                                            "end": 261
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "usageMetadata",
                                            "loc": {
                                                "start": 266,
                                                "end": 279
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": {
                                            "kind": "SelectionSet",
                                            "selections": [
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "promptTokenCount",
                                                        "loc": {
                                                            "start": 288,
                                                            "end": 304
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 288,
                                                        "end": 304
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "candidatesTokenCount",
                                                        "loc": {
                                                            "start": 311,
                                                            "end": 331
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 311,
                                                        "end": 331
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "totalTokenCount",
                                                        "loc": {
                                                            "start": 338,
                                                            "end": 353
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 338,
                                                        "end": 353
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "promptTokensDetails",
                                                        "loc": {
                                                            "start": 360,
                                                            "end": 379
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": {
                                                        "kind": "SelectionSet",
                                                        "selections": [
                                                            {
                                                                "kind": "Field",
                                                                "alias": null,
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "token",
                                                                    "loc": {
                                                                        "start": 390,
                                                                        "end": 395
                                                                    }
                                                                },
                                                                "arguments": [],
                                                                "directives": [],
                                                                "selectionSet": null,
                                                                "loc": {
                                                                    "start": 390,
                                                                    "end": 395
                                                                }
                                                            },
                                                            {
                                                                "kind": "Field",
                                                                "alias": null,
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "logprob",
                                                                    "loc": {
                                                                        "start": 404,
                                                                        "end": 411
                                                                    }
                                                                },
                                                                "arguments": [],
                                                                "directives": [],
                                                                "selectionSet": null,
                                                                "loc": {
                                                                    "start": 404,
                                                                    "end": 411
                                                                }
                                                            }
                                                        ],
                                                        "loc": {
                                                            "start": 380,
                                                            "end": 419
                                                        }
                                                    },
                                                    "loc": {
                                                        "start": 360,
                                                        "end": 419
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "candidatesTokensDetails",
                                                        "loc": {
                                                            "start": 426,
                                                            "end": 449
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": {
                                                        "kind": "SelectionSet",
                                                        "selections": [
                                                            {
                                                                "kind": "Field",
                                                                "alias": null,
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "token",
                                                                    "loc": {
                                                                        "start": 460,
                                                                        "end": 465
                                                                    }
                                                                },
                                                                "arguments": [],
                                                                "directives": [],
                                                                "selectionSet": null,
                                                                "loc": {
                                                                    "start": 460,
                                                                    "end": 465
                                                                }
                                                            },
                                                            {
                                                                "kind": "Field",
                                                                "alias": null,
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "logprob",
                                                                    "loc": {
                                                                        "start": 474,
                                                                        "end": 481
                                                                    }
                                                                },
                                                                "arguments": [],
                                                                "directives": [],
                                                                "selectionSet": null,
                                                                "loc": {
                                                                    "start": 474,
                                                                    "end": 481
                                                                }
                                                            }
                                                        ],
                                                        "loc": {
                                                            "start": 450,
                                                            "end": 489
                                                        }
                                                    },
                                                    "loc": {
                                                        "start": 426,
                                                        "end": 489
                                                    }
                                                }
                                            ],
                                            "loc": {
                                                "start": 280,
                                                "end": 495
                                            }
                                        },
                                        "loc": {
                                            "start": 266,
                                            "end": 495
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "modelVersion",
                                            "loc": {
                                                "start": 500,
                                                "end": 512
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 500,
                                            "end": 512
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "responseId",
                                            "loc": {
                                                "start": 517,
                                                "end": 527
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 517,
                                            "end": 527
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 122,
                                    "end": 531
                                }
                            },
                            "loc": {
                                "start": 80,
                                "end": 531
                            }
                        }
                    ],
                    "loc": {
                        "start": 76,
                        "end": 533
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 533
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 534
        },
        "name": {
            "kind": "Name",
            "value": "create-completion-gemini.mutation.graphql"
        }
    },
    "src/app/core/services/blog/fragments/post.fragment.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "PostFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "BlogType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 38,
                                    "end": 40
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 38,
                                "end": 40
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "title",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "content",
                                "loc": {
                                    "start": 51,
                                    "end": 58
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 58
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "category",
                                "loc": {
                                    "start": 61,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 79,
                                                "end": 95
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 76,
                                            "end": 95
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 70,
                                    "end": 99
                                }
                            },
                            "loc": {
                                "start": 61,
                                "end": 99
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "draft",
                                "loc": {
                                    "start": 102,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 102,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 110,
                                    "end": 119
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 110,
                                "end": 119
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user",
                                "loc": {
                                    "start": 122,
                                    "end": 126
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 133,
                                                "end": 135
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 133,
                                            "end": 135
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 140,
                                                "end": 144
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 140,
                                            "end": 144
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 127,
                                    "end": 148
                                }
                            },
                            "loc": {
                                "start": 122,
                                "end": 148
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createdAt",
                                "loc": {
                                    "start": 151,
                                    "end": 160
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 151,
                                "end": 160
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "updatedAt",
                                "loc": {
                                    "start": 163,
                                    "end": 172
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 163,
                                "end": 172
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 174
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 174
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 175
        },
        "name": {
            "kind": "Name",
            "value": "post.fragment.graphql"
        }
    },
    "src/app/core/services/blog/mutations/create-post.mutation.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "createPost",
                    "loc": {
                        "start": 9,
                        "end": 19
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "payload",
                                "loc": {
                                    "start": 21,
                                    "end": 28
                                }
                            },
                            "loc": {
                                "start": 20,
                                "end": 28
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "BlogInputType",
                                    "loc": {
                                        "start": 30,
                                        "end": 43
                                    }
                                },
                                "loc": {
                                    "start": 30,
                                    "end": 43
                                }
                            },
                            "loc": {
                                "start": 30,
                                "end": 44
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 20,
                            "end": 44
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createPost",
                                "loc": {
                                    "start": 50,
                                    "end": 60
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payload",
                                        "loc": {
                                            "start": 66,
                                            "end": 73
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "payload",
                                            "loc": {
                                                "start": 76,
                                                "end": 83
                                            }
                                        },
                                        "loc": {
                                            "start": 75,
                                            "end": 83
                                        }
                                    },
                                    "loc": {
                                        "start": 66,
                                        "end": 83
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "PostFragment",
                                            "loc": {
                                                "start": 97,
                                                "end": 109
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 94,
                                            "end": 109
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 88,
                                    "end": 113
                                }
                            },
                            "loc": {
                                "start": 50,
                                "end": 113
                            }
                        }
                    ],
                    "loc": {
                        "start": 46,
                        "end": 115
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 115
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "PostFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "BlogType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 38,
                                    "end": 40
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 38,
                                "end": 40
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "title",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "content",
                                "loc": {
                                    "start": 51,
                                    "end": 58
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 58
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "category",
                                "loc": {
                                    "start": 61,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 79,
                                                "end": 95
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 76,
                                            "end": 95
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 70,
                                    "end": 99
                                }
                            },
                            "loc": {
                                "start": 61,
                                "end": 99
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "draft",
                                "loc": {
                                    "start": 102,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 102,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 110,
                                    "end": 119
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 110,
                                "end": 119
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user",
                                "loc": {
                                    "start": 122,
                                    "end": 126
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 133,
                                                "end": 135
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 133,
                                            "end": 135
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 140,
                                                "end": 144
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 140,
                                            "end": 144
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 127,
                                    "end": 148
                                }
                            },
                            "loc": {
                                "start": 122,
                                "end": 148
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createdAt",
                                "loc": {
                                    "start": 151,
                                    "end": 160
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 151,
                                "end": 160
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "updatedAt",
                                "loc": {
                                    "start": 163,
                                    "end": 172
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 163,
                                "end": 172
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 174
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 174
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 116
        },
        "name": {
            "kind": "Name",
            "value": "create-post.mutation.graphql"
        }
    },
    "src/app/core/services/blog/mutations/delete-post.mutation.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "deletePost",
                    "loc": {
                        "start": 9,
                        "end": 19
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 21,
                                    "end": 23
                                }
                            },
                            "loc": {
                                "start": 20,
                                "end": 23
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 25,
                                        "end": 31
                                    }
                                },
                                "loc": {
                                    "start": 25,
                                    "end": 31
                                }
                            },
                            "loc": {
                                "start": 25,
                                "end": 32
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 20,
                            "end": 32
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "deletePost",
                                "loc": {
                                    "start": 38,
                                    "end": 48
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id",
                                        "loc": {
                                            "start": 54,
                                            "end": 56
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 59,
                                                "end": 61
                                            }
                                        },
                                        "loc": {
                                            "start": 58,
                                            "end": 61
                                        }
                                    },
                                    "loc": {
                                        "start": 54,
                                        "end": 61
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "PostFragment",
                                            "loc": {
                                                "start": 75,
                                                "end": 87
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 72,
                                            "end": 87
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 66,
                                    "end": 91
                                }
                            },
                            "loc": {
                                "start": 38,
                                "end": 91
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 93
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 93
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "PostFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "BlogType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 38,
                                    "end": 40
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 38,
                                "end": 40
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "title",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "content",
                                "loc": {
                                    "start": 51,
                                    "end": 58
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 58
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "category",
                                "loc": {
                                    "start": 61,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 79,
                                                "end": 95
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 76,
                                            "end": 95
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 70,
                                    "end": 99
                                }
                            },
                            "loc": {
                                "start": 61,
                                "end": 99
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "draft",
                                "loc": {
                                    "start": 102,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 102,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 110,
                                    "end": 119
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 110,
                                "end": 119
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user",
                                "loc": {
                                    "start": 122,
                                    "end": 126
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 133,
                                                "end": 135
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 133,
                                            "end": 135
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 140,
                                                "end": 144
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 140,
                                            "end": 144
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 127,
                                    "end": 148
                                }
                            },
                            "loc": {
                                "start": 122,
                                "end": 148
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createdAt",
                                "loc": {
                                    "start": 151,
                                    "end": 160
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 151,
                                "end": 160
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "updatedAt",
                                "loc": {
                                    "start": 163,
                                    "end": 172
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 163,
                                "end": 172
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 174
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 174
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 94
        },
        "name": {
            "kind": "Name",
            "value": "delete-post.mutation.graphql"
        }
    },
    "src/app/core/services/blog/mutations/update-post.mutation.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "updatePost",
                    "loc": {
                        "start": 9,
                        "end": 19
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 21,
                                    "end": 23
                                }
                            },
                            "loc": {
                                "start": 20,
                                "end": 23
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 25,
                                        "end": 31
                                    }
                                },
                                "loc": {
                                    "start": 25,
                                    "end": 31
                                }
                            },
                            "loc": {
                                "start": 25,
                                "end": 32
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 20,
                            "end": 32
                        }
                    },
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "payload",
                                "loc": {
                                    "start": 35,
                                    "end": 42
                                }
                            },
                            "loc": {
                                "start": 34,
                                "end": 42
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "BlogInputType",
                                    "loc": {
                                        "start": 44,
                                        "end": 57
                                    }
                                },
                                "loc": {
                                    "start": 44,
                                    "end": 57
                                }
                            },
                            "loc": {
                                "start": 44,
                                "end": 58
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 34,
                            "end": 58
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "updatePost",
                                "loc": {
                                    "start": 64,
                                    "end": 74
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id",
                                        "loc": {
                                            "start": 80,
                                            "end": 82
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 85,
                                                "end": 87
                                            }
                                        },
                                        "loc": {
                                            "start": 84,
                                            "end": 87
                                        }
                                    },
                                    "loc": {
                                        "start": 80,
                                        "end": 87
                                    }
                                },
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payload",
                                        "loc": {
                                            "start": 92,
                                            "end": 99
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "payload",
                                            "loc": {
                                                "start": 102,
                                                "end": 109
                                            }
                                        },
                                        "loc": {
                                            "start": 101,
                                            "end": 109
                                        }
                                    },
                                    "loc": {
                                        "start": 92,
                                        "end": 109
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "PostFragment",
                                            "loc": {
                                                "start": 123,
                                                "end": 135
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 120,
                                            "end": 135
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 114,
                                    "end": 139
                                }
                            },
                            "loc": {
                                "start": 64,
                                "end": 139
                            }
                        }
                    ],
                    "loc": {
                        "start": 60,
                        "end": 141
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 141
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "PostFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "BlogType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 38,
                                    "end": 40
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 38,
                                "end": 40
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "title",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "content",
                                "loc": {
                                    "start": 51,
                                    "end": 58
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 58
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "category",
                                "loc": {
                                    "start": 61,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 79,
                                                "end": 95
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 76,
                                            "end": 95
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 70,
                                    "end": 99
                                }
                            },
                            "loc": {
                                "start": 61,
                                "end": 99
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "draft",
                                "loc": {
                                    "start": 102,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 102,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 110,
                                    "end": 119
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 110,
                                "end": 119
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user",
                                "loc": {
                                    "start": 122,
                                    "end": 126
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 133,
                                                "end": 135
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 133,
                                            "end": 135
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 140,
                                                "end": 144
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 140,
                                            "end": 144
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 127,
                                    "end": 148
                                }
                            },
                            "loc": {
                                "start": 122,
                                "end": 148
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createdAt",
                                "loc": {
                                    "start": 151,
                                    "end": 160
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 151,
                                "end": 160
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "updatedAt",
                                "loc": {
                                    "start": 163,
                                    "end": 172
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 163,
                                "end": 172
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 174
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 174
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 142
        },
        "name": {
            "kind": "Name",
            "value": "update-post.mutation.graphql"
        }
    },
    "src/app/core/services/blog/queries/find-post-by-search-key.query.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "findPostBySearchKey",
                    "loc": {
                        "start": 6,
                        "end": 25
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 27,
                                    "end": 36
                                }
                            },
                            "loc": {
                                "start": 26,
                                "end": 36
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 38,
                                        "end": 44
                                    }
                                },
                                "loc": {
                                    "start": 38,
                                    "end": 44
                                }
                            },
                            "loc": {
                                "start": 38,
                                "end": 45
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 26,
                            "end": 45
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "findPostBySearchKey",
                                "loc": {
                                    "start": 51,
                                    "end": 70
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "searchKey",
                                        "loc": {
                                            "start": 71,
                                            "end": 80
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "searchKey",
                                            "loc": {
                                                "start": 83,
                                                "end": 92
                                            }
                                        },
                                        "loc": {
                                            "start": 82,
                                            "end": 92
                                        }
                                    },
                                    "loc": {
                                        "start": 71,
                                        "end": 92
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "PostFragment",
                                            "loc": {
                                                "start": 103,
                                                "end": 115
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 100,
                                            "end": 115
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 94,
                                    "end": 119
                                }
                            },
                            "loc": {
                                "start": 51,
                                "end": 119
                            }
                        }
                    ],
                    "loc": {
                        "start": 47,
                        "end": 121
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 121
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "PostFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "BlogType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 38,
                                    "end": 40
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 38,
                                "end": 40
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "title",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "content",
                                "loc": {
                                    "start": 51,
                                    "end": 58
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 58
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "category",
                                "loc": {
                                    "start": 61,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 79,
                                                "end": 95
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 76,
                                            "end": 95
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 70,
                                    "end": 99
                                }
                            },
                            "loc": {
                                "start": 61,
                                "end": 99
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "draft",
                                "loc": {
                                    "start": 102,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 102,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 110,
                                    "end": 119
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 110,
                                "end": 119
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user",
                                "loc": {
                                    "start": 122,
                                    "end": 126
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 133,
                                                "end": 135
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 133,
                                            "end": 135
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 140,
                                                "end": 144
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 140,
                                            "end": 144
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 127,
                                    "end": 148
                                }
                            },
                            "loc": {
                                "start": 122,
                                "end": 148
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createdAt",
                                "loc": {
                                    "start": 151,
                                    "end": 160
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 151,
                                "end": 160
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "updatedAt",
                                "loc": {
                                    "start": 163,
                                    "end": 172
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 163,
                                "end": 172
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 174
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 174
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 121
        },
        "name": {
            "kind": "Name",
            "value": "find-post-by-search-key.query.graphql"
        }
    },
    "src/app/core/services/blog/queries/find-post.query.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "findPost",
                    "loc": {
                        "start": 6,
                        "end": 14
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 16,
                                    "end": 18
                                }
                            },
                            "loc": {
                                "start": 15,
                                "end": 18
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 20,
                                        "end": 26
                                    }
                                },
                                "loc": {
                                    "start": 20,
                                    "end": 26
                                }
                            },
                            "loc": {
                                "start": 20,
                                "end": 27
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 15,
                            "end": 27
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "findPost",
                                "loc": {
                                    "start": 33,
                                    "end": 41
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id",
                                        "loc": {
                                            "start": 42,
                                            "end": 44
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 47,
                                                "end": 49
                                            }
                                        },
                                        "loc": {
                                            "start": 46,
                                            "end": 49
                                        }
                                    },
                                    "loc": {
                                        "start": 42,
                                        "end": 49
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "PostFragment",
                                            "loc": {
                                                "start": 60,
                                                "end": 72
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 57,
                                            "end": 72
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 51,
                                    "end": 76
                                }
                            },
                            "loc": {
                                "start": 33,
                                "end": 76
                            }
                        }
                    ],
                    "loc": {
                        "start": 29,
                        "end": 78
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 78
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "PostFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "BlogType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 38,
                                    "end": 40
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 38,
                                "end": 40
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "title",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "content",
                                "loc": {
                                    "start": 51,
                                    "end": 58
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 58
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "category",
                                "loc": {
                                    "start": 61,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 79,
                                                "end": 95
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 76,
                                            "end": 95
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 70,
                                    "end": 99
                                }
                            },
                            "loc": {
                                "start": 61,
                                "end": 99
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "draft",
                                "loc": {
                                    "start": 102,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 102,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 110,
                                    "end": 119
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 110,
                                "end": 119
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user",
                                "loc": {
                                    "start": 122,
                                    "end": 126
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 133,
                                                "end": 135
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 133,
                                            "end": 135
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 140,
                                                "end": 144
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 140,
                                            "end": 144
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 127,
                                    "end": 148
                                }
                            },
                            "loc": {
                                "start": 122,
                                "end": 148
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createdAt",
                                "loc": {
                                    "start": 151,
                                    "end": 160
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 151,
                                "end": 160
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "updatedAt",
                                "loc": {
                                    "start": 163,
                                    "end": 172
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 163,
                                "end": 172
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 174
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 174
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 78
        },
        "name": {
            "kind": "Name",
            "value": "find-post.query.graphql"
        }
    },
    "src/app/core/services/blog/queries/list-posts.query.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "listPosts",
                    "loc": {
                        "start": 6,
                        "end": 15
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 17,
                                    "end": 26
                                }
                            },
                            "loc": {
                                "start": 16,
                                "end": 26
                            }
                        },
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String",
                                "loc": {
                                    "start": 28,
                                    "end": 34
                                }
                            },
                            "loc": {
                                "start": 28,
                                "end": 34
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 16,
                            "end": 34
                        }
                    },
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "draft",
                                "loc": {
                                    "start": 37,
                                    "end": 42
                                }
                            },
                            "loc": {
                                "start": 36,
                                "end": 42
                            }
                        },
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Boolean",
                                "loc": {
                                    "start": 44,
                                    "end": 51
                                }
                            },
                            "loc": {
                                "start": 44,
                                "end": 51
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 36,
                            "end": 51
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "listPosts",
                                "loc": {
                                    "start": 57,
                                    "end": 66
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "searchKey",
                                        "loc": {
                                            "start": 67,
                                            "end": 76
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "searchKey",
                                            "loc": {
                                                "start": 79,
                                                "end": 88
                                            }
                                        },
                                        "loc": {
                                            "start": 78,
                                            "end": 88
                                        }
                                    },
                                    "loc": {
                                        "start": 67,
                                        "end": 88
                                    }
                                },
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "draft",
                                        "loc": {
                                            "start": 90,
                                            "end": 95
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "draft",
                                            "loc": {
                                                "start": 98,
                                                "end": 103
                                            }
                                        },
                                        "loc": {
                                            "start": 97,
                                            "end": 103
                                        }
                                    },
                                    "loc": {
                                        "start": 90,
                                        "end": 103
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "PostFragment",
                                            "loc": {
                                                "start": 114,
                                                "end": 126
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 111,
                                            "end": 126
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 105,
                                    "end": 130
                                }
                            },
                            "loc": {
                                "start": 57,
                                "end": 130
                            }
                        }
                    ],
                    "loc": {
                        "start": 53,
                        "end": 132
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 132
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "PostFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "BlogType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 38,
                                    "end": 40
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 38,
                                "end": 40
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "title",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "content",
                                "loc": {
                                    "start": 51,
                                    "end": 58
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 58
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "category",
                                "loc": {
                                    "start": 61,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 79,
                                                "end": 95
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 76,
                                            "end": 95
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 70,
                                    "end": 99
                                }
                            },
                            "loc": {
                                "start": 61,
                                "end": 99
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "draft",
                                "loc": {
                                    "start": 102,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 102,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 110,
                                    "end": 119
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 110,
                                "end": 119
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user",
                                "loc": {
                                    "start": 122,
                                    "end": 126
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 133,
                                                "end": 135
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 133,
                                            "end": 135
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 140,
                                                "end": 144
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 140,
                                            "end": 144
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 127,
                                    "end": 148
                                }
                            },
                            "loc": {
                                "start": 122,
                                "end": 148
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createdAt",
                                "loc": {
                                    "start": 151,
                                    "end": 160
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 151,
                                "end": 160
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "updatedAt",
                                "loc": {
                                    "start": 163,
                                    "end": 172
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 163,
                                "end": 172
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 174
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 174
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 133
        },
        "name": {
            "kind": "Name",
            "value": "list-posts.query.graphql"
        }
    },
    "src/app/core/services/category/fragments/category.fragment.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 84
        },
        "name": {
            "kind": "Name",
            "value": "category.fragment.graphql"
        }
    },
    "src/app/core/services/category/mutations/create-category.mutation.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "createCategory",
                    "loc": {
                        "start": 9,
                        "end": 23
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "payload",
                                "loc": {
                                    "start": 25,
                                    "end": 32
                                }
                            },
                            "loc": {
                                "start": 24,
                                "end": 32
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "ListType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "CategoryInputType",
                                        "loc": {
                                            "start": 35,
                                            "end": 52
                                        }
                                    },
                                    "loc": {
                                        "start": 35,
                                        "end": 52
                                    }
                                },
                                "loc": {
                                    "start": 34,
                                    "end": 53
                                }
                            },
                            "loc": {
                                "start": 34,
                                "end": 54
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 24,
                            "end": 54
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createCategory",
                                "loc": {
                                    "start": 60,
                                    "end": 74
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payload",
                                        "loc": {
                                            "start": 75,
                                            "end": 82
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "payload",
                                            "loc": {
                                                "start": 85,
                                                "end": 92
                                            }
                                        },
                                        "loc": {
                                            "start": 84,
                                            "end": 92
                                        }
                                    },
                                    "loc": {
                                        "start": 75,
                                        "end": 92
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 103,
                                                "end": 119
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 100,
                                            "end": 119
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 94,
                                    "end": 123
                                }
                            },
                            "loc": {
                                "start": 60,
                                "end": 123
                            }
                        }
                    ],
                    "loc": {
                        "start": 56,
                        "end": 125
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 125
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 126
        },
        "name": {
            "kind": "Name",
            "value": "create-category.mutation.graphql"
        }
    },
    "src/app/core/services/category/mutations/delete-category.mutation.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "deleteCategory",
                    "loc": {
                        "start": 9,
                        "end": 23
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 25,
                                    "end": 27
                                }
                            },
                            "loc": {
                                "start": 24,
                                "end": 27
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 29,
                                        "end": 35
                                    }
                                },
                                "loc": {
                                    "start": 29,
                                    "end": 35
                                }
                            },
                            "loc": {
                                "start": 29,
                                "end": 36
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 24,
                            "end": 36
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "deleteCategory",
                                "loc": {
                                    "start": 42,
                                    "end": 56
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id",
                                        "loc": {
                                            "start": 57,
                                            "end": 59
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 62,
                                                "end": 64
                                            }
                                        },
                                        "loc": {
                                            "start": 61,
                                            "end": 64
                                        }
                                    },
                                    "loc": {
                                        "start": 57,
                                        "end": 64
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 75,
                                                "end": 91
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 72,
                                            "end": 91
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 66,
                                    "end": 95
                                }
                            },
                            "loc": {
                                "start": 42,
                                "end": 95
                            }
                        }
                    ],
                    "loc": {
                        "start": 38,
                        "end": 97
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 97
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 98
        },
        "name": {
            "kind": "Name",
            "value": "delete-category.mutation.graphql"
        }
    },
    "src/app/core/services/category/queries/find-category.query.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "findCategory",
                    "loc": {
                        "start": 6,
                        "end": 18
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 20,
                                    "end": 22
                                }
                            },
                            "loc": {
                                "start": 19,
                                "end": 22
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 24,
                                        "end": 30
                                    }
                                },
                                "loc": {
                                    "start": 24,
                                    "end": 30
                                }
                            },
                            "loc": {
                                "start": 24,
                                "end": 31
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 19,
                            "end": 31
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "findCategory",
                                "loc": {
                                    "start": 37,
                                    "end": 49
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id",
                                        "loc": {
                                            "start": 50,
                                            "end": 52
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 54,
                                                "end": 56
                                            }
                                        },
                                        "loc": {
                                            "start": 53,
                                            "end": 56
                                        }
                                    },
                                    "loc": {
                                        "start": 50,
                                        "end": 56
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 67,
                                                "end": 83
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 64,
                                            "end": 83
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 58,
                                    "end": 87
                                }
                            },
                            "loc": {
                                "start": 37,
                                "end": 87
                            }
                        }
                    ],
                    "loc": {
                        "start": 33,
                        "end": 89
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 89
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 89
        },
        "name": {
            "kind": "Name",
            "value": "find-category.query.graphql"
        }
    },
    "src/app/core/services/category/queries/list-categories.query.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "listCategories",
                    "loc": {
                        "start": 6,
                        "end": 20
                    }
                },
                "variableDefinitions": [],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "listCategories",
                                "loc": {
                                    "start": 25,
                                    "end": 39
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CategoryFragment",
                                            "loc": {
                                                "start": 49,
                                                "end": 65
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 46,
                                            "end": 65
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 40,
                                    "end": 69
                                }
                            },
                            "loc": {
                                "start": 25,
                                "end": 69
                            }
                        }
                    ],
                    "loc": {
                        "start": 21,
                        "end": 71
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 71
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "CategoryFragment",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "CategoryType",
                        "loc": {
                            "start": 29,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 29,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 46,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "description",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "searchKey",
                                "loc": {
                                    "start": 72,
                                    "end": 81
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 81
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 83
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 83
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 71
        },
        "name": {
            "kind": "Name",
            "value": "list-categories.query.graphql"
        }
    },
    "src/app/core/services/user/fragments/user.fragment.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "UserFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "UserType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 38,
                                    "end": 40
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 38,
                                "end": 40
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "email",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "displayName",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user_id",
                                "loc": {
                                    "start": 72,
                                    "end": 79
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 79
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "tag",
                                "loc": {
                                    "start": 82,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 82,
                                "end": 85
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "photoURL",
                                "loc": {
                                    "start": 88,
                                    "end": 96
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 88,
                                "end": 96
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 99,
                                    "end": 103
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 99,
                                "end": 103
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "firebaseUserRecord",
                                "loc": {
                                    "start": 106,
                                    "end": 124
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "uid",
                                            "loc": {
                                                "start": 131,
                                                "end": 134
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 131,
                                            "end": 134
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "email",
                                            "loc": {
                                                "start": 139,
                                                "end": 144
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 139,
                                            "end": 144
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "emailVerified",
                                            "loc": {
                                                "start": 149,
                                                "end": 162
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 149,
                                            "end": 162
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "displayName",
                                            "loc": {
                                                "start": 167,
                                                "end": 178
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 167,
                                            "end": 178
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "photoURL",
                                            "loc": {
                                                "start": 183,
                                                "end": 191
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 183,
                                            "end": 191
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "phoneNumber",
                                            "loc": {
                                                "start": 196,
                                                "end": 207
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 196,
                                            "end": 207
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "disabled",
                                            "loc": {
                                                "start": 212,
                                                "end": 220
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 212,
                                            "end": 220
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "metadata",
                                            "loc": {
                                                "start": 225,
                                                "end": 233
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": {
                                            "kind": "SelectionSet",
                                            "selections": [
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "creationTime",
                                                        "loc": {
                                                            "start": 242,
                                                            "end": 254
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 242,
                                                        "end": 254
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "lastSignInTime",
                                                        "loc": {
                                                            "start": 261,
                                                            "end": 275
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 261,
                                                        "end": 275
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "lastRefreshTime",
                                                        "loc": {
                                                            "start": 282,
                                                            "end": 297
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 282,
                                                        "end": 297
                                                    }
                                                }
                                            ],
                                            "loc": {
                                                "start": 234,
                                                "end": 303
                                            }
                                        },
                                        "loc": {
                                            "start": 225,
                                            "end": 303
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "providerData",
                                            "loc": {
                                                "start": 308,
                                                "end": 320
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": {
                                            "kind": "SelectionSet",
                                            "selections": [
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "uid",
                                                        "loc": {
                                                            "start": 329,
                                                            "end": 332
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 329,
                                                        "end": 332
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "displayName",
                                                        "loc": {
                                                            "start": 339,
                                                            "end": 350
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 339,
                                                        "end": 350
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "email",
                                                        "loc": {
                                                            "start": 357,
                                                            "end": 362
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 357,
                                                        "end": 362
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "photoURL",
                                                        "loc": {
                                                            "start": 369,
                                                            "end": 377
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 369,
                                                        "end": 377
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "providerId",
                                                        "loc": {
                                                            "start": 384,
                                                            "end": 394
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 384,
                                                        "end": 394
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "phoneNumber",
                                                        "loc": {
                                                            "start": 401,
                                                            "end": 412
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 401,
                                                        "end": 412
                                                    }
                                                }
                                            ],
                                            "loc": {
                                                "start": 321,
                                                "end": 418
                                            }
                                        },
                                        "loc": {
                                            "start": 308,
                                            "end": 418
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "tokensValidAfterTime",
                                            "loc": {
                                                "start": 423,
                                                "end": 443
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 423,
                                            "end": 443
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 125,
                                    "end": 447
                                }
                            },
                            "loc": {
                                "start": 106,
                                "end": 447
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 449
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 449
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 450
        },
        "name": {
            "kind": "Name",
            "value": "user.fragment.graphql"
        }
    },
    "src/app/core/services/user/mutations/create-user-mutation.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "createFirebaseUser",
                    "loc": {
                        "start": 9,
                        "end": 27
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "payload",
                                "loc": {
                                    "start": 29,
                                    "end": 36
                                }
                            },
                            "loc": {
                                "start": 28,
                                "end": 36
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "CreateUserInputType",
                                    "loc": {
                                        "start": 38,
                                        "end": 57
                                    }
                                },
                                "loc": {
                                    "start": 38,
                                    "end": 57
                                }
                            },
                            "loc": {
                                "start": 38,
                                "end": 58
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 28,
                            "end": 58
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createFirebaseUser",
                                "loc": {
                                    "start": 63,
                                    "end": 81
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payload",
                                        "loc": {
                                            "start": 82,
                                            "end": 89
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "payload",
                                            "loc": {
                                                "start": 92,
                                                "end": 99
                                            }
                                        },
                                        "loc": {
                                            "start": 91,
                                            "end": 99
                                        }
                                    },
                                    "loc": {
                                        "start": 82,
                                        "end": 99
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "UserFragment",
                                            "loc": {
                                                "start": 108,
                                                "end": 120
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 105,
                                            "end": 120
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 101,
                                    "end": 123
                                }
                            },
                            "loc": {
                                "start": 63,
                                "end": 123
                            }
                        }
                    ],
                    "loc": {
                        "start": 60,
                        "end": 125
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 125
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "UserFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "UserType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 38,
                                    "end": 40
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 38,
                                "end": 40
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "email",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 51,
                                    "end": 55
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 51,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "displayName",
                                "loc": {
                                    "start": 58,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user_id",
                                "loc": {
                                    "start": 72,
                                    "end": 79
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 72,
                                "end": 79
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "tag",
                                "loc": {
                                    "start": 82,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 82,
                                "end": 85
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "photoURL",
                                "loc": {
                                    "start": 88,
                                    "end": 96
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 88,
                                "end": 96
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 99,
                                    "end": 103
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 99,
                                "end": 103
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "firebaseUserRecord",
                                "loc": {
                                    "start": 106,
                                    "end": 124
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "uid",
                                            "loc": {
                                                "start": 131,
                                                "end": 134
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 131,
                                            "end": 134
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "email",
                                            "loc": {
                                                "start": 139,
                                                "end": 144
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 139,
                                            "end": 144
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "emailVerified",
                                            "loc": {
                                                "start": 149,
                                                "end": 162
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 149,
                                            "end": 162
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "displayName",
                                            "loc": {
                                                "start": 167,
                                                "end": 178
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 167,
                                            "end": 178
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "photoURL",
                                            "loc": {
                                                "start": 183,
                                                "end": 191
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 183,
                                            "end": 191
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "phoneNumber",
                                            "loc": {
                                                "start": 196,
                                                "end": 207
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 196,
                                            "end": 207
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "disabled",
                                            "loc": {
                                                "start": 212,
                                                "end": 220
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 212,
                                            "end": 220
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "metadata",
                                            "loc": {
                                                "start": 225,
                                                "end": 233
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": {
                                            "kind": "SelectionSet",
                                            "selections": [
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "creationTime",
                                                        "loc": {
                                                            "start": 242,
                                                            "end": 254
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 242,
                                                        "end": 254
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "lastSignInTime",
                                                        "loc": {
                                                            "start": 261,
                                                            "end": 275
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 261,
                                                        "end": 275
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "lastRefreshTime",
                                                        "loc": {
                                                            "start": 282,
                                                            "end": 297
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 282,
                                                        "end": 297
                                                    }
                                                }
                                            ],
                                            "loc": {
                                                "start": 234,
                                                "end": 303
                                            }
                                        },
                                        "loc": {
                                            "start": 225,
                                            "end": 303
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "providerData",
                                            "loc": {
                                                "start": 308,
                                                "end": 320
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": {
                                            "kind": "SelectionSet",
                                            "selections": [
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "uid",
                                                        "loc": {
                                                            "start": 329,
                                                            "end": 332
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 329,
                                                        "end": 332
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "displayName",
                                                        "loc": {
                                                            "start": 339,
                                                            "end": 350
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 339,
                                                        "end": 350
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "email",
                                                        "loc": {
                                                            "start": 357,
                                                            "end": 362
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 357,
                                                        "end": 362
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "photoURL",
                                                        "loc": {
                                                            "start": 369,
                                                            "end": 377
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 369,
                                                        "end": 377
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "providerId",
                                                        "loc": {
                                                            "start": 384,
                                                            "end": 394
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 384,
                                                        "end": 394
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "phoneNumber",
                                                        "loc": {
                                                            "start": 401,
                                                            "end": 412
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 401,
                                                        "end": 412
                                                    }
                                                }
                                            ],
                                            "loc": {
                                                "start": 321,
                                                "end": 418
                                            }
                                        },
                                        "loc": {
                                            "start": 308,
                                            "end": 418
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "tokensValidAfterTime",
                                            "loc": {
                                                "start": 423,
                                                "end": 443
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 423,
                                            "end": 443
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 125,
                                    "end": 447
                                }
                            },
                            "loc": {
                                "start": 106,
                                "end": 447
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 449
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 449
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 126
        },
        "name": {
            "kind": "Name",
            "value": "create-user-mutation.graphql"
        }
    }
};


/* tslint:disable */ /* eslint-disable prettier/prettier */ const $ff5aa075d8c3eb6f$export$a988b149d1c415aa = {
    "__schema": {
        "types": []
    }
};



var $4XQlz = parcelRequire("4XQlz");

var $66ItK = parcelRequire("66ItK");

var $aXvn5 = parcelRequire("aXvn5");
parcelRequire("rc2P5");
var $7fUEc = parcelRequire("7fUEc");
var $hGKun = parcelRequire("hGKun");
var $8H3st = parcelRequire("8H3st");
var $eIehW = parcelRequire("eIehW");

var $fG7Ap = parcelRequire("fG7Ap");
class $a01636625a15fd06$export$d5dc740503fb3d20 {
}
$a01636625a15fd06$export$d5dc740503fb3d20 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Module)({
        imports: [
            (0, $66ItK.GraphqlModule).forRoot({
                async onRequest () {
                    const headers = new Headers();
                    const user = $aXvn5.auth().currentUser;
                    if (user) headers.append('authorization', await user.getIdToken());
                    return headers;
                },
                cache: new (0, $66ItK.InMemoryCache)({
                    possibleTypes: (0, $66ItK.convertToPossibleTypes)((0, $ff5aa075d8c3eb6f$export$a988b149d1c415aa))
                }),
                uri: (0, $4QMof.ENVIRONMENT).GRAPH_URL,
                pubsub: (0, $4QMof.ENVIRONMENT).GRAPH_WS_URL
            }, (0, $478f0ec0f0369b34$export$2cbd0be658ac061c))
        ],
        providers: [
            (0, $fG7Ap.BlogService),
            (0, $8H3st.CategoryService),
            (0, $7fUEc.AiService),
            (0, $eIehW.SeoService),
            (0, $hGKun.AnalyticsService)
        ]
    })
], $a01636625a15fd06$export$d5dc740503fb3d20);



var $4XQlz = parcelRequire("4XQlz");

var $c22PD = parcelRequire("c22PD");

var $g0n63 = parcelRequire("g0n63");
var $c06a86779e0ac857$exports = {};
"use strict";
var $c06a86779e0ac857$var$__createBinding = $c06a86779e0ac857$exports && $c06a86779e0ac857$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c06a86779e0ac857$var$__exportStar = $c06a86779e0ac857$exports && $c06a86779e0ac857$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c06a86779e0ac857$var$__createBinding(exports1, m, p);
};
Object.defineProperty($c06a86779e0ac857$exports, "__esModule", {
    value: true
});
parcelRequire("a7Qz2");

$c06a86779e0ac857$var$__exportStar((parcelRequire("3jEhc")), $c06a86779e0ac857$exports);

$c06a86779e0ac857$var$__exportStar((parcelRequire("cOpHU")), $c06a86779e0ac857$exports);

$c06a86779e0ac857$var$__exportStar((parcelRequire("1eatX")), $c06a86779e0ac857$exports);



var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");

var $jWytf = parcelRequire("jWytf");
var $ee6bbef35fc5b57b$exports = {};
"use strict";
var $ee6bbef35fc5b57b$var$__createBinding = $ee6bbef35fc5b57b$exports && $ee6bbef35fc5b57b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee6bbef35fc5b57b$var$__exportStar = $ee6bbef35fc5b57b$exports && $ee6bbef35fc5b57b$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ee6bbef35fc5b57b$var$__createBinding(exports1, m, p);
};
Object.defineProperty($ee6bbef35fc5b57b$exports, "__esModule", {
    value: true
});

$ee6bbef35fc5b57b$var$__exportStar((parcelRequire("hxTEf")), $ee6bbef35fc5b57b$exports);


var $3f47c4b7e6d52f16$exports = {};
"use strict";
var $3f47c4b7e6d52f16$var$__createBinding = $3f47c4b7e6d52f16$exports && $3f47c4b7e6d52f16$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3f47c4b7e6d52f16$var$__exportStar = $3f47c4b7e6d52f16$exports && $3f47c4b7e6d52f16$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3f47c4b7e6d52f16$var$__createBinding(exports1, m, p);
};
Object.defineProperty($3f47c4b7e6d52f16$exports, "__esModule", {
    value: true
});

$3f47c4b7e6d52f16$var$__exportStar((parcelRequire("iQ1sC")), $3f47c4b7e6d52f16$exports);


var $8400c4dc1fb0914b$exports = {};
"use strict";
var $8400c4dc1fb0914b$var$__createBinding = $8400c4dc1fb0914b$exports && $8400c4dc1fb0914b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8400c4dc1fb0914b$var$__exportStar = $8400c4dc1fb0914b$exports && $8400c4dc1fb0914b$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8400c4dc1fb0914b$var$__createBinding(exports1, m, p);
};
Object.defineProperty($8400c4dc1fb0914b$exports, "__esModule", {
    value: true
});

$8400c4dc1fb0914b$var$__exportStar((parcelRequire("8FDb6")), $8400c4dc1fb0914b$exports);


var $6ebc7bebf415bf23$exports = {};
"use strict";
var $6ebc7bebf415bf23$var$__createBinding = $6ebc7bebf415bf23$exports && $6ebc7bebf415bf23$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6ebc7bebf415bf23$var$__exportStar = $6ebc7bebf415bf23$exports && $6ebc7bebf415bf23$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6ebc7bebf415bf23$var$__createBinding(exports1, m, p);
};
Object.defineProperty($6ebc7bebf415bf23$exports, "__esModule", {
    value: true
});

$6ebc7bebf415bf23$var$__exportStar((parcelRequire("a9fT9")), $6ebc7bebf415bf23$exports);



var $9h1ql = parcelRequire("9h1ql");
var $9d861f533b36a789$exports = {};
"use strict";
var $9d861f533b36a789$var$__createBinding = $9d861f533b36a789$exports && $9d861f533b36a789$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9d861f533b36a789$var$__exportStar = $9d861f533b36a789$exports && $9d861f533b36a789$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9d861f533b36a789$var$__createBinding(exports1, m, p);
};
Object.defineProperty($9d861f533b36a789$exports, "__esModule", {
    value: true
});

$9d861f533b36a789$var$__exportStar((parcelRequire("2wM9E")), $9d861f533b36a789$exports);



var $g0n63 = parcelRequire("g0n63");
var $74695cee7a3893b7$exports = {};
"use strict";
var $74695cee7a3893b7$var$__createBinding = $74695cee7a3893b7$exports && $74695cee7a3893b7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $74695cee7a3893b7$var$__exportStar = $74695cee7a3893b7$exports && $74695cee7a3893b7$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $74695cee7a3893b7$var$__createBinding(exports1, m, p);
};
Object.defineProperty($74695cee7a3893b7$exports, "__esModule", {
    value: true
});

$74695cee7a3893b7$var$__exportStar((parcelRequire("jYHuY")), $74695cee7a3893b7$exports);

$74695cee7a3893b7$var$__exportStar((parcelRequire("rdCQr")), $74695cee7a3893b7$exports);

$74695cee7a3893b7$var$__exportStar((parcelRequire("3TyTd")), $74695cee7a3893b7$exports);

$74695cee7a3893b7$var$__exportStar((parcelRequire("dnEcI")), $74695cee7a3893b7$exports);



var $eG1Pq = parcelRequire("eG1Pq");
var $6e9baef138ca0007$exports = {};
"use strict";
Object.defineProperty($6e9baef138ca0007$exports, "__esModule", {
    value: true
});
$6e9baef138ca0007$exports.InputStyle = void 0;

var $eG1Pq = parcelRequire("eG1Pq");
$6e9baef138ca0007$exports.InputStyle = (0, $eG1Pq.css)`
  input[type='range'] {
    -webkit-appearance: slider-horizontal;
    color: rgb(157, 150, 142);
    border: initial;
    
  }

  .rx-input,
  .rx-select,
  .rx-textarea {
    max-width: 100%;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    color: #666;
    border: 1px solid #e5e5e5;
    transition: 0.2s ease-in-out;
    transition-property: color, background-color, border;
    outline: none;
  }
  .rx-radio,
  .rx-checkbox {
    display: inline-block;
    height: 16px;
    width: 16px;
    overflow: hidden;
    margin-top: -4px;
    vertical-align: middle;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: none;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    border: 1px solid #ccc;
    transition: 0.2s ease-in-out;
    transition-property: background-color, border;
    cursor: pointer;
  }
  .rx-range {
    box-sizing: border-box;
    margin: 0;
    vertical-align: middle;
    max-width: 100%;
    width: 100%;
    -webkit-appearance: none;
    background: transparent;
    padding: 0;
  }

  .rx-checkbox:checked {
    background-color: #1e87f0;
    background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2211%22%20viewBox%3D%220%200%2014%2011%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23fff%22%20points%3D%2212%201%205%207.5%202%205%201%205.5%205%2010%2013%201.5%22%20%2F%3E%0A%3C%2Fsvg%3E%0A');
  }
  .rx-radio {
    border-radius: 50%;
  }
  .rx-radio:checked {
    background-color: #1e87f0;
    background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22%23fff%22%20cx%3D%228%22%20cy%3D%228%22%20r%3D%222%22%20%2F%3E%0A%3C%2Fsvg%3E');
  }
  .rx-select {
    height: 40px;
    vertical-align: middle;
    display: inline-block;
    background: #fff;
  }
  .rx-input {
    height: 40px;
    vertical-align: middle;
    display: inline-block;
  }
  .rx-textarea {
    padding-top: 4px;
    padding-bottom: 4px;
    padding: 15px;
    vertical-align: top;
  }
  .rx-danger {
    color: #a94442;
    border-color: #a94442;
  }
  .rx-success {
    color: #32d296;
    border-color: #32d296;
  }
  .rx-outline:focus {
    outline: none;
    /* outline-color: blue; */
  }
  .rx-disabled {
    background-color: #f8f8f8;
    color: #999;
    border-color: #e5e5e5;
  }
  /* Switch */
  .rx-switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .rx-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .rx-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .rx-slider:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .rx-switch input:checked + .rx-slider {
    background-color: #2196f3;
  }

  .rx-switch input:focus + .rx-slider {
    box-shadow: 0 0 1px #2196f3;
  }

  .rx-switch input:checked + .rx-slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .rx-slider {
    border-radius: 34px;
  }

  .rx-slider:before {
    border-radius: 50%;
  }
`; /*
<label class="rx-switch">
  <input type="checkbox" checked />
  <span class="rx-slider"></span>
</label>
*/ 


class $1b0996d8e34d2b3a$export$a6651008bb5b591 extends (0, $eG1Pq.LitElement) {
    OnUpdateFirst() {
        const model = this.model || {};
        Object.keys(model).map((key)=>{
            if (this.form.get(key) && model[key]) this.form.setValue(key, model[key]);
        });
    }
    constructor(...args){
        super(...args), this.form = new (0, $74695cee7a3893b7$exports.FormGroup)({
            categoryId: ''
        });
    }
}
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        type: Object
    })
], $1b0996d8e34d2b3a$export$a6651008bb5b591.prototype, "model", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        type: Array
    })
], $1b0996d8e34d2b3a$export$a6651008bb5b591.prototype, "categories", void 0);
(0, $g0n63.__decorate)([
    (0, $74695cee7a3893b7$exports.Form)({
        name: 'category-form',
        strategy: 'change',
        strict: true
    })
], $1b0996d8e34d2b3a$export$a6651008bb5b591.prototype, "form", void 0);
$1b0996d8e34d2b3a$export$a6651008bb5b591 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'category-forms',
        styles: [
            (0, $6e9baef138ca0007$exports.InputStyle),
            (0, $eG1Pq.css)`
      input {
        margin-bottom: 10px;
      }
      p {
        margin-bottom: 0px;
      }
      .content {
        padding: 10px 30px 10px 30px;
        border-bottom: 1px solid #e5e5e5;
        overflow: auto;
        min-height: 100px;
        max-height: 385px;
      }
      .is-invalid {
        box-shadow: 0 0 1px 1px #c95454;
      }
    `
        ],
        template () {
            return (0, $eG1Pq.html)`
      <form
        name="category-form"
        @submit=${async ()=>{
                const validity = await this.form.updateValueAndValidity();
                if (!validity?.length) this.dispatchEvent(new CustomEvent('submitted', {
                    detail: {
                        id: this.form.value.categoryId
                    }
                }));
            }}
      >
        <div class="content">
          <p>Category</p>
          <select name="categoryId" class="rx-select" placeholder="Choose category" required>
            ${[
                ...this.categories.map((category)=>({
                        selected: this.model?.id === category.id,
                        name: category.name,
                        id: category.id
                    }))
            ].map((option)=>option?.selected ? (0, $eG1Pq.html)`<option value=${option?.id} selected>${option?.name}</option>` : (0, $eG1Pq.html)`<option value=${option?.id}>${option?.name}</option>`)}
          </select>
        </div>
        <div style="padding: 20px;">
          <sl-button style="width:100%;" type="submit" variant="primary">Choose Category</sl-button>
        </div>
      </form>
    `;
        }
    })
], $1b0996d8e34d2b3a$export$a6651008bb5b591);



var $g0n63 = parcelRequire("g0n63");


var $eG1Pq = parcelRequire("eG1Pq");


var $eG1Pq = parcelRequire("eG1Pq");
function $af4aa4334c20cde3$export$9726f96ae4b32c7c(input) {
    if (input && !input.checkValidity()) {
        input.classList.add('is-invalid');
        return (0, $eG1Pq.html)` <div style="color:red; font-size: 13px;">${input.validationMessage}</div> `;
    }
    input?.classList?.remove('is-invalid');
    return '';
}


class $5e9df50fa330fe0b$export$ab0e7d24cc58513 extends (0, $eG1Pq.LitElement) {
    OnUpdateFirst() {
        const model = this.model || {};
        Object.keys(model).map((key)=>{
            if (this.form.get(key) && model[key]) this.form.setValue(key, model[key]);
        });
    }
    validateExistingCategories(element) {
        if (this.categories.find((c)=>c.name === element.value)) return {
            key: 'category-present',
            message: 'Category present! Please specify different category'
        };
    }
    constructor(...args){
        super(...args), this.form = new (0, $74695cee7a3893b7$exports.FormGroup)({
            name: [
                '',
                [
                    this.validateExistingCategories
                ]
            ],
            description: ''
        });
    }
}
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        type: Object
    })
], $5e9df50fa330fe0b$export$ab0e7d24cc58513.prototype, "model", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        type: Array
    })
], $5e9df50fa330fe0b$export$ab0e7d24cc58513.prototype, "categories", void 0);
(0, $g0n63.__decorate)([
    (0, $74695cee7a3893b7$exports.Form)({
        name: 'create-category-forms',
        strategy: 'change',
        strict: true
    })
], $5e9df50fa330fe0b$export$ab0e7d24cc58513.prototype, "form", void 0);
$5e9df50fa330fe0b$export$ab0e7d24cc58513 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'create-category-forms',
        styles: [
            (0, $6e9baef138ca0007$exports.InputStyle),
            (0, $eG1Pq.css)`
      input {
        margin-bottom: 10px;
      }
      p {
        margin-bottom: 0px;
      }
      .content {
        padding: 10px 30px 10px 30px;
        border-bottom: 1px solid #e5e5e5;
        overflow: auto;
        min-height: 100px;
        max-height: 385px;
      }
      .is-invalid {
        box-shadow: 0 0 1px 1px #c95454;
      }
    `
        ],
        template () {
            return (0, $eG1Pq.html)`
      <form
        name="create-category-forms"
        novalidate
        @submit=${async ()=>{
                const validity = await this.form.updateValueAndValidity();
                if (!validity?.length) this.dispatchEvent(new CustomEvent('submitted', {
                    detail: this.form.value
                }));
            }}
      >
        <div class="content">
          <p>Name</p>
          <input
            type="text"
            name="name"
            class="rx-input"
            .disabled=${!!this.model?.name}
            minlength=${3}
            value=${this.model?.name ? this.model?.name : ''}
            required
          />
          ${(0, $af4aa4334c20cde3$export$9726f96ae4b32c7c)(this.form.get('name'))}
    

          <p>Description</p>
          <input
            type="text"
            name="description"
            class="rx-input"
            .disabled=${!!this.model?.description}
            minlength=${3}
            value=${this.model?.description ? this.model?.description : ''}
            required
          />
          ${(0, $af4aa4334c20cde3$export$9726f96ae4b32c7c)(this.form.get('description'))}
            </div>
        </div>
        <div style="padding: 20px;">
            <sl-button style="width:100%;" type="submit" variant="primary">Create Category</sl-button>
        </div>
      </form>
    `;
        }
    })
], $5e9df50fa330fe0b$export$ab0e7d24cc58513);






var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");

var $g0n63 = parcelRequire("g0n63");
/* eslint-disable @typescript-eslint/no-use-before-define */ /* eslint-disable no-var */ /* tslint:disable */ /* eslint-disable prettier/prettier */ /* http://prismjs.com/download.html?themes=prism-dark&languages=markup+css+clike+javascript+c+csharp+cpp+java+json+jsx+scss+typescript&plugins=show-language */ const $d5699406d24e78a1$var$_self = typeof window !== 'undefined' ? window // if in browser
 : typeof self['WorkerGlobalScope'] !== 'undefined' ? self // if in worker
 : {}; // if in node js
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 * MIT license http://www.opensource.org/licenses/mit-license.php/
 * @author Lea Verou http://lea.verou.me
 */ const $d5699406d24e78a1$var$Prism = function() {
    // Private helper vars
    const lang = /\blang(?:uage)?-(\w+)\b/i;
    let uniqueId = 0;
    var _ = $d5699406d24e78a1$var$_self['Prism'] = {
        util: {
            encode: function(tokens) {
                if (tokens instanceof Token) return new Token(tokens['type'], _.util.encode(tokens['content']), tokens['alias']);
                else if (_.util.type(tokens) === 'Array') return tokens.map(_.util.encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            type: function(o) {
                return Object.prototype.toString.call(o).match(/\[object (\w+)\]/)[1];
            },
            objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            // Deep clone a language definition (e.g. to extend it)
            clone: function(o) {
                const type = _.util.type(o);
                switch(type){
                    case 'Object':
                        var clone = {};
                        for(const key in o)if (o.hasOwnProperty(key)) clone[key] = _.util.clone(o[key]);
                        return clone;
                    case 'Array':
                        // Check for existence for IE8
                        return o.map && o.map(function(v) {
                            return _.util.clone(v);
                        });
                }
                return o;
            }
        },
        languages: {
            extend: function(id, redef) {
                const lang = _.util.clone(_.languages[id]);
                for(const key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
    * Insert a token before another token in a language literal
    * As this needs to recreate the object (we cannot actually insert before keys in object literals),
    * we cannot just provide an object, we need anobject and a key.
    * @param inside The key (or language id) of the parent
    * @param before The key to insert before. If not provided, the function appends instead.
    * @param insert Object with the key/value pairs to insert
    * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
    */ insertBefore: function(inside, before, insert, root) {
                root = root || _.languages;
                const grammar = root[inside];
                if (arguments.length == 2) {
                    // eslint-disable-next-line prefer-rest-params
                    insert = arguments[1];
                    for(var newToken in insert)if (insert.hasOwnProperty(newToken)) grammar[newToken] = insert[newToken];
                    return grammar;
                }
                const ret = {};
                for(const token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    ret[token] = grammar[token];
                }
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === root[inside] && key != inside) this[key] = ret;
                });
                return root[inside] = ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function(o, callback, type, visited) {
                visited = visited || {};
                for(const i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    if (_.util.type(o[i]) === 'Object' && !visited[_.util.objId(o[i])]) {
                        visited[_.util.objId(o[i])] = true;
                        _.languages.DFS(o[i], callback, null, visited);
                    } else if (_.util.type(o[i]) === 'Array' && !visited[_.util.objId(o[i])]) {
                        visited[_.util.objId(o[i])] = true;
                        _.languages.DFS(o[i], callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        highlightAll: function(async, callback) {
            _.highlightAllUnder(async, callback);
        },
        highlightAllUnder: function(async, callback) {
            const env = {
                callback: callback,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            const elements = env['elements'] || document.querySelectorAll(env.selector);
            for(var i = 0, element; element = elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        highlightElement: function(element, async, callback) {
            // Find language
            let language, grammar, parent = element;
            while(parent && !lang.test(parent.className))parent = parent.parentNode;
            if (parent) {
                language = (parent.className.match(lang) || [
                    ,
                    ''
                ])[1].toLowerCase();
                grammar = _.languages[language];
            }
            // Set language on the element, if not present
            element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
            // Set language on the parent, for styling
            parent = element.parentNode;
            if (/pre/i.test(parent.nodeName)) parent.className = parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
            const code = element.textContent;
            const env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            _.hooks.run('before-sanity-check', env);
            if (!env.code || !env.grammar) {
                _.hooks.run('complete', env);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (async && $d5699406d24e78a1$var$_self['Worker']) {
                const worker = new Worker(_['filename']);
                worker.onmessage = function(evt) {
                    env['highlightedCode'] = evt.data;
                    _.hooks.run('before-insert', env);
                    env.element.innerHTML = env['highlightedCode'];
                    callback && callback.call(env.element);
                    _.hooks.run('after-highlight', env);
                    _.hooks.run('complete', env);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else {
                env['highlightedCode'] = _.highlight(env.code, env.grammar, env.language);
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env['highlightedCode'];
                callback && callback.call(element);
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
            }
        },
        highlight: function(text, grammar, language) {
            const tokens = _.tokenize(text, grammar);
            return Token['stringify'](_.util.encode(tokens), language);
        },
        tokenize: function(text, grammar) {
            const Token = _['Token'];
            const strarr = [
                text
            ];
            const rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            tokenloop: for(var token in grammar){
                if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
                let patterns = grammar[token];
                patterns = _.util.type(patterns) === 'Array' ? patterns : [
                    patterns
                ];
                for(let j = 0; j < patterns.length; ++j){
                    let pattern = patterns[j];
                    let lookbehindLength = 0;
                    const inside = pattern.inside, lookbehind = !!pattern.lookbehind, greedy = !!pattern.greedy, alias = pattern.alias;
                    if (greedy && !pattern.pattern.global) {
                        // Without the global flag, lastIndex won't work
                        const flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
                        pattern.pattern = RegExp(pattern.pattern.source, flags + 'g');
                    }
                    pattern = pattern.pattern || pattern;
                    // Don’t cache length as it changes during the loop
                    for(let i = 0, pos = 0; i < strarr.length; pos += strarr[i].length, ++i){
                        let str = strarr[i];
                        if (strarr.length > text.length) break tokenloop;
                        if (str instanceof Token) continue;
                        pattern.lastIndex = 0;
                        var match = pattern.exec(str), delNum = 1;
                        // Greedy patterns can override/remove up to two previously matched tokens
                        if (!match && greedy && i != strarr.length - 1) {
                            pattern.lastIndex = pos;
                            match = pattern.exec(text);
                            if (!match) break;
                            var from = match.index + (lookbehind ? match[1].length : 0), to = match.index + match[0].length, k = i, p = pos;
                            for(let len = strarr.length; k < len && p < to; ++k){
                                p += strarr[k].length;
                                // Move the index i to the element in strarr that is closest to from
                                if (from >= p) {
                                    ++i;
                                    pos = p;
                                }
                            }
                            /*
        * If strarr[i] is a Token, then the match starts inside another Token, which is invalid
        * If strarr[k - 1] is greedy we are in conflict with another greedy pattern
        */ if (strarr[i] instanceof Token || strarr[k - 1].greedy) continue;
                            // Number of tokens to delete and replace with the new match
                            delNum = k - i;
                            str = text.slice(pos, p);
                            match.index -= pos;
                        }
                        if (!match) continue;
                        if (lookbehind) lookbehindLength = match[1].length;
                        var from = match.index + lookbehindLength, match = match[0].slice(lookbehindLength), to = from + match.length, before = str.slice(0, from), after = str.slice(to);
                        const args = [
                            i,
                            delNum
                        ];
                        if (before) args.push(before);
                        const wrapped = new Token(token, inside ? _.tokenize(match, inside) : match, alias, match, greedy);
                        args.push(wrapped);
                        if (after) args.push(after);
                        Array.prototype.splice.apply(strarr, args);
                    }
                }
            }
            return strarr;
        },
        hooks: {
            all: {},
            add: function(name, callback) {
                const hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            run: function(name, env) {
                const callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        }
    };
    var Token = _['Token'] = function(type, content, alias, matchedStr, greedy) {
        this.type = type;
        this.content = content;
        this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
        this.greedy = !!greedy;
    };
    Token['stringify'] = function(o, language, parent) {
        if (typeof o == 'string') return o;
        if (_.util.type(o) === 'Array') return o.map(function(element) {
            return Token['stringify'](element, language, o);
        }).join('');
        const env = {
            type: o.type,
            content: Token['stringify'](o.content, language, parent),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language,
            parent: parent
        };
        if (env.type == 'comment') env.attributes['spellcheck'] = 'true';
        if (o.alias) {
            const aliases = _.util.type(o.alias) === 'Array' ? o.alias : [
                o.alias
            ];
            Array.prototype.push.apply(env.classes, aliases);
        }
        _.hooks.run('wrap', env);
        let attributes = '';
        for(const name in env.attributes)attributes += (attributes ? ' ' : '') + name + '="' + (env.attributes[name] || '') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + (attributes ? ' ' + attributes : '') + '>' + env.content + '</' + env.tag + '>';
    };
    if (!$d5699406d24e78a1$var$_self['document']) {
        if (!$d5699406d24e78a1$var$_self['addEventListener']) // in Node.js
        return $d5699406d24e78a1$var$_self['Prism'];
        // In worker
        $d5699406d24e78a1$var$_self['addEventListener']('message', function(evt) {
            const message = JSON.parse(evt.data), lang = message.language, code = message.code, immediateClose = message.immediateClose;
            $d5699406d24e78a1$var$_self['postMessage'](_.highlight(code, _.languages[lang], lang));
            if (immediateClose) $d5699406d24e78a1$var$_self['close']();
        }, false);
        return $d5699406d24e78a1$var$_self['Prism'];
    }
    //Get current script and highlight
    const script = document.currentScript || [].slice.call(document.getElementsByTagName('script')).pop();
    if (script) {
        _['filename'] = script.src;
        if (document.addEventListener && !script.hasAttribute('data-manual')) {
            if (document.readyState !== 'loading') {
                if (window.requestAnimationFrame) window.requestAnimationFrame(_.highlightAll);
                else window.setTimeout(_.highlightAll, 16);
            } else document.addEventListener('DOMContentLoaded', _.highlightAll);
        }
    }
    return $d5699406d24e78a1$var$_self['Prism'];
}();
$d5699406d24e78a1$var$Prism.languages.markup = {
    comment: /<!--[\w\W]*?-->/,
    prolog: /<\?[\w\W]+?\?>/,
    doctype: /<!DOCTYPE[\w\W]+?>/i,
    cdata: /<!\[CDATA\[[\w\W]*?]]>/i,
    tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\\1|\\?(?!\1)[\w\W])*\1|[^\s'">=]+))?)*\s*\/?>/i,
        inside: {
            tag: {
                pattern: /^<\/?[^\s>\/]+/i,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[^\s>\/:]+:/
                }
            },
            'attr-value': {
                pattern: /=(?:('|")[\w\W]*?(\1)|[^\s>]+)/i,
                inside: {
                    punctuation: /[=>"']/
                }
            },
            punctuation: /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    namespace: /^[^\s>\/:]+:/
                }
            }
        }
    },
    entity: /&#?[\da-z]{1,8};/i
};
// Plugin to make entity title show the real entity, idea by Roman Komarov
$d5699406d24e78a1$var$Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
$d5699406d24e78a1$var$Prism.languages.xml = $d5699406d24e78a1$var$Prism.languages.markup;
$d5699406d24e78a1$var$Prism.languages.html = $d5699406d24e78a1$var$Prism.languages.markup;
$d5699406d24e78a1$var$Prism.languages.mathml = $d5699406d24e78a1$var$Prism.languages.markup;
$d5699406d24e78a1$var$Prism.languages.svg = $d5699406d24e78a1$var$Prism.languages.markup;
$d5699406d24e78a1$var$Prism.languages.css = {
    comment: /\/\*[\w\W]*?\*\//,
    atrule: {
        pattern: /@[\w-]+?.*?(;|(?=\s*\{))/i,
        inside: {
            rule: /@[\w-]+/
        }
    },
    url: /url\((?:(["'])(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
    selector: /[^\{\}\s][^\{\};]*?(?=\s*\{)/,
    string: {
        pattern: /("|')(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    property: /(\b|\B)[\w-]+(?=\s*:)/i,
    important: /\B!important\b/i,
    function: /[-a-z0-9]+(?=\()/i,
    punctuation: /[(){};:]/
};
$d5699406d24e78a1$var$Prism.languages.css['atrule'].inside.rest = $d5699406d24e78a1$var$Prism.util.clone($d5699406d24e78a1$var$Prism.languages.css);
if ($d5699406d24e78a1$var$Prism.languages.markup) {
    $d5699406d24e78a1$var$Prism.languages.insertBefore('markup', 'tag', {
        style: {
            pattern: /(<style[\w\W]*?>)[\w\W]*?(?=<\/style>)/i,
            lookbehind: true,
            inside: $d5699406d24e78a1$var$Prism.languages.css,
            alias: 'language-css'
        }
    });
    $d5699406d24e78a1$var$Prism.languages.insertBefore('inside', 'attr-value', {
        'style-attr': {
            pattern: /\s*style=("|').*?\1/i,
            inside: {
                'attr-name': {
                    pattern: /^\s*style/i,
                    inside: $d5699406d24e78a1$var$Prism.languages.markup.tag.inside
                },
                punctuation: /^\s*=\s*['"]|['"]\s*$/,
                'attr-value': {
                    pattern: /.+/i,
                    inside: $d5699406d24e78a1$var$Prism.languages.css
                }
            },
            alias: 'language-css'
        }
    }, $d5699406d24e78a1$var$Prism.languages.markup.tag);
}
$d5699406d24e78a1$var$Prism.languages.clike = {
    comment: [
        {
            pattern: /(^|[^\\])\/\*[\w\W]*?\*\//,
            lookbehind: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true
        }
    ],
    string: {
        pattern: /(["'])(\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[a-z0-9_\.\\]+/i,
        lookbehind: true,
        inside: {
            punctuation: /(\.|\\)/
        }
    },
    keyword: /\b(if|else|async|await|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
    boolean: /\b(true|false)\b/,
    function: /[a-z0-9_]+(?=\()/i,
    number: /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)\b/i,
    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
    punctuation: /[{}[\];(),.:]/
};
$d5699406d24e78a1$var$Prism.languages.javascript = $d5699406d24e78a1$var$Prism.languages.extend('clike', {
    keyword: /\b(as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
    number: /\b-?(0x[\dA-Fa-f]+|0b[01]+|0o[0-7]+|\d*\.?\d+([Ee][+-]?\d+)?|NaN|Infinity)\b/,
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*(?=\()/i,
    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*\*?|\/|~|\^|%|\.{3}/
});
$d5699406d24e78a1$var$Prism.languages.insertBefore('javascript', 'keyword', {
    regex: {
        pattern: /(^|[^/])\/(?!\/)(\[.+?]|\\.|[^/\\\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,
        lookbehind: true,
        greedy: true
    }
});
$d5699406d24e78a1$var$Prism.languages.insertBefore('javascript', 'string', {
    'template-string': {
        pattern: /`(?:\\\\|\\?[^\\])*?`/,
        greedy: true,
        inside: {
            interpolation: {
                pattern: /\$\{[^}]+\}/,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: $d5699406d24e78a1$var$Prism.languages.javascript
                }
            },
            string: /[\s\S]+/
        }
    }
});
if ($d5699406d24e78a1$var$Prism.languages.markup) $d5699406d24e78a1$var$Prism.languages.insertBefore('markup', 'tag', {
    script: {
        pattern: /(<script[\w\W]*?>)[\w\W]*?(?=<\/script>)/i,
        lookbehind: true,
        inside: $d5699406d24e78a1$var$Prism.languages.javascript,
        alias: 'language-javascript'
    }
});
$d5699406d24e78a1$var$Prism.languages.js = $d5699406d24e78a1$var$Prism.languages.javascript;
$d5699406d24e78a1$var$Prism.languages.c = $d5699406d24e78a1$var$Prism.languages.extend('clike', {
    keyword: /\b(asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while)\b/,
    operator: /\-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*\/]/,
    number: /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)[ful]*\b/i
});
$d5699406d24e78a1$var$Prism.languages.insertBefore('c', 'string', {
    macro: {
        // allow for multiline macro definitions
        // spaces after the # character compile fine with gcc
        pattern: /(^\s*)#\s*[a-z]+([^\r\n\\]|\\.|\\(?:\r\n?|\n))*/im,
        lookbehind: true,
        alias: 'property',
        inside: {
            // highlight the path of the include statement as a string
            string: {
                pattern: /(#\s*include\s*)(<.+?>|("|')(\\?.)+?\3)/,
                lookbehind: true
            },
            // highlight macro directives as keywords
            directive: {
                pattern: /(#\s*)\b(define|elif|else|endif|error|ifdef|ifndef|if|import|include|line|pragma|undef|using)\b/,
                lookbehind: true,
                alias: 'keyword'
            }
        }
    },
    // highlight predefined macros as constants
    constant: /\b(__FILE__|__LINE__|__DATE__|__TIME__|__TIMESTAMP__|__func__|EOF|NULL|stdin|stdout|stderr)\b/
});
delete $d5699406d24e78a1$var$Prism.languages.c['class-name'];
delete $d5699406d24e78a1$var$Prism.languages.c['boolean'];
$d5699406d24e78a1$var$Prism.languages.csharp = $d5699406d24e78a1$var$Prism.languages.extend('clike', {
    keyword: /\b(abstract|as|async|await|base|bool|break|byte|case|catch|char|checked|class|const|continue|decimal|default|delegate|do|double|else|enum|event|explicit|extern|false|finally|fixed|float|for|foreach|goto|if|implicit|in|int|interface|internal|is|lock|long|namespace|new|null|object|operator|out|override|params|private|protected|public|readonly|ref|return|sbyte|sealed|short|sizeof|stackalloc|static|string|struct|switch|this|throw|true|try|typeof|uint|ulong|unchecked|unsafe|ushort|using|virtual|void|volatile|while|add|alias|ascending|async|await|descending|dynamic|from|get|global|group|into|join|let|orderby|partial|remove|select|set|value|var|where|yield)\b/,
    string: [
        /@("|')(\1\1|\\\1|\\?(?!\1)[\s\S])*\1/,
        /("|')(\\?.)*?\1/
    ],
    number: /\b-?(0x[\da-f]+|\d*\.?\d+f?)\b/i
});
$d5699406d24e78a1$var$Prism.languages.insertBefore('csharp', 'keyword', {
    'generic-method': {
        pattern: /[a-z0-9_]+\s*<[^>\r\n]+?>\s*(?=\()/i,
        alias: 'function',
        inside: {
            keyword: $d5699406d24e78a1$var$Prism.languages.csharp.keyword,
            punctuation: /[<>(),.:]/
        }
    },
    preprocessor: {
        pattern: /(^\s*)#.*/m,
        lookbehind: true,
        alias: 'property',
        inside: {
            // highlight preprocessor directives as keywords
            directive: {
                pattern: /(\s*#)\b(define|elif|else|endif|endregion|error|if|line|pragma|region|undef|warning)\b/,
                lookbehind: true,
                alias: 'keyword'
            }
        }
    }
});
$d5699406d24e78a1$var$Prism.languages.cpp = $d5699406d24e78a1$var$Prism.languages.extend('c', {
    keyword: /\b(alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|class|compl|const|constexpr|const_cast|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|float|for|friend|goto|if|inline|int|long|mutable|namespace|new|noexcept|nullptr|operator|private|protected|public|register|reinterpret_cast|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/,
    boolean: /\b(true|false)\b/,
    operator: /[-+]{1,2}|!=?|<{1,2}=?|>{1,2}=?|\->|:{1,2}|={1,2}|\^|~|%|&{1,2}|\|?\||\?|\*|\/|\b(and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/
});
$d5699406d24e78a1$var$Prism.languages.insertBefore('cpp', 'keyword', {
    'class-name': {
        pattern: /(class\s+)[a-z0-9_]+/i,
        lookbehind: true
    }
});
$d5699406d24e78a1$var$Prism.languages.java = $d5699406d24e78a1$var$Prism.languages.extend('clike', {
    keyword: /\b(abstract|continue|for|new|switch|assert|default|goto|package|synchronized|boolean|do|if|private|this|break|double|implements|protected|throw|byte|else|import|public|throws|case|enum|instanceof|return|transient|catch|extends|int|short|try|char|final|interface|static|void|class|finally|long|strictfp|volatile|const|float|native|super|while)\b/,
    number: /\b0b[01]+\b|\b0x[\da-f]*\.?[\da-fp\-]+\b|\b\d*\.?\d+(?:e[+-]?\d+)?[df]?\b/i,
    operator: {
        pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|!=?|<<?=?|>>?>?=?|==?|&[&=]?|\|[|=]?|\*=?|\/=?|%=?|\^=?|[?:~])/m,
        lookbehind: true
    }
});
$d5699406d24e78a1$var$Prism.languages.insertBefore('java', 'function', {
    annotation: {
        alias: 'punctuation',
        pattern: /(^|[^.])@\w+/,
        lookbehind: true
    }
});
$d5699406d24e78a1$var$Prism.languages.insertBefore('graphql', 'function', {
    annotation: {
        lookbehind: true
    }
});
$d5699406d24e78a1$var$Prism.languages.json = {
    property: /"(?:\\.|[^|"])*"(?=\s*:)/gi,
    string: /"(?!:)(?:\\.|[^|"])*"(?!:)/g,
    number: /\b-?(0x[\dA-Fa-f]+|\d*\.?\d+([Ee][+-]?\d+)?)\b/g,
    punctuation: /[{}[\]);,]/g,
    operator: /:/g,
    boolean: /\b(true|false)\b/gi,
    null: /\bnull\b/gi
};
$d5699406d24e78a1$var$Prism.languages.jsonp = $d5699406d24e78a1$var$Prism.languages.json;
(function(Prism) {
    const javascript = Prism.util.clone(Prism.languages.javascript);
    Prism.languages.jsx = Prism.languages.extend('markup', javascript);
    Prism.languages.jsx.tag.pattern = /<\/?[\w\.:-]+\s*(?:\s+[\w\.:-]+(?:=(?:("|')(\\?[\w\W])*?\1|[^\s'">=]+|(\{[\w\W]*?\})))?\s*)*\/?>/i;
    Prism.languages.jsx.tag.inside['attr-value'].pattern = /=[^\{](?:('|")[\w\W]*?(\1)|[^\s>]+)/i;
    let jsxExpression = Prism.util.clone(Prism.languages.jsx);
    delete jsxExpression.punctuation;
    jsxExpression = Prism.languages.insertBefore('jsx', 'operator', {
        punctuation: /=(?={)|[{}[\];(),.:]/
    }, {
        jsx: jsxExpression
    });
    Prism.languages.insertBefore('inside', 'attr-value', {
        script: {
            // Allow for one level of nesting
            pattern: /=(\{(?:\{[^}]*\}|[^}])+\})/i,
            inside: jsxExpression,
            alias: 'language-javascript'
        }
    }, Prism.languages.jsx.tag);
})($d5699406d24e78a1$var$Prism);
$d5699406d24e78a1$var$Prism.languages.scss = $d5699406d24e78a1$var$Prism.languages.extend('css', {
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\w\W]*?\*\/|\/\/.*)/,
        lookbehind: true
    },
    atrule: {
        pattern: /@[\w-]+(?:\([^()]+\)|[^(])*?(?=\s+[{;])/,
        inside: {
            rule: /@[\w-]+/
        }
    },
    // url, compassified
    url: /(?:[-a-z]+-)*url(?=\()/i,
    // CSS selector regex is not appropriate for Sass
    // since there can be lot more things (var, @ directive, nesting..)
    // a selector must start at the end of a property or after a brace (end of other rules or nesting)
    // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
    // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
    // can "pass" as a selector- e.g: proper#{$erty})
    // this one was hard to do, so please be careful if you edit this one :)
    selector: {
        // Initial look-ahead is used to prevent matching of blank selectors
        pattern: /(?=\S)[^@;\{\}\(\)]?([^@;\{\}\(\)]|&|#\{\$[-_\w]+\})+(?=\s*\{(\}|\s|[^\}]+(:|\{)[^\}]+))/m,
        inside: {
            parent: {
                pattern: /&/,
                alias: 'important'
            },
            placeholder: /%[-_\w]+/,
            variable: /\$[-_\w]+|#\{\$[-_\w]+\}/
        }
    }
});
$d5699406d24e78a1$var$Prism.languages.insertBefore('scss', 'atrule', {
    keyword: [
        /@(?:if|else(?: if)?|for|each|while|import|extend|debug|warn|mixin|include|function|return|content)/i,
        {
            pattern: /( +)(?:from|through)(?= )/,
            lookbehind: true
        }
    ]
});
$d5699406d24e78a1$var$Prism.languages.scss.property = {
    pattern: /(?:[\w-]|\$[-_\w]+|#\{\$[-_\w]+\})+(?=\s*:)/i,
    inside: {
        variable: /\$[-_\w]+|#\{\$[-_\w]+\}/
    }
};
$d5699406d24e78a1$var$Prism.languages.insertBefore('scss', 'important', {
    // var and interpolated vars
    variable: /\$[-_\w]+|#\{\$[-_\w]+\}/
});
$d5699406d24e78a1$var$Prism.languages.insertBefore('scss', 'function', {
    placeholder: {
        pattern: /%[-_\w]+/,
        alias: 'selector'
    },
    statement: {
        pattern: /\B!(?:default|optional)\b/i,
        alias: 'keyword'
    },
    boolean: /\b(?:true|false)\b/,
    null: /\bnull\b/,
    operator: {
        pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|or|not)(?=\s)/,
        lookbehind: true
    }
});
$d5699406d24e78a1$var$Prism.languages.scss['atrule'].inside.rest = $d5699406d24e78a1$var$Prism.util.clone($d5699406d24e78a1$var$Prism.languages.scss);
$d5699406d24e78a1$var$Prism.languages.typescript = $d5699406d24e78a1$var$Prism.languages.extend('javascript', {
    keyword: /\b(break|case|async|await|readonly|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|false|finally|for|function|get|if|implements|import|in|instanceof|interface|let|new|null|package|private|protected|public|return|set|static|super|switch|this|throw|true|try|typeof|var|void|while|with|yield|module|declare|constructor|string|Function|any|number|boolean|Array|enum)\b/
});
(function() {
    if (typeof self === 'undefined' || !self['Prism'] || !self.document) return;
    // The languages map is built automatically with gulp
    const Languages = /*languages_placeholder[*/ {
        html: 'HTML',
        xml: 'XML',
        svg: 'SVG',
        mathml: 'MathML',
        css: 'CSS',
        clike: 'C-like',
        javascript: 'JavaScript',
        abap: 'ABAP',
        actionscript: 'ActionScript',
        apacheconf: 'Apache Configuration',
        apl: 'APL',
        applescript: 'AppleScript',
        asciidoc: 'AsciiDoc',
        aspnet: 'ASP.NET (C#)',
        autoit: 'AutoIt',
        autohotkey: 'AutoHotkey',
        basic: 'BASIC',
        csharp: 'C#',
        cpp: 'C++',
        coffeescript: 'CoffeeScript',
        'css-extras': 'CSS Extras',
        fsharp: 'F#',
        glsl: 'GLSL',
        graphql: 'GraphQL',
        http: 'HTTP',
        inform7: 'Inform 7',
        json: 'JSON',
        latex: 'LaTeX',
        livescript: 'LiveScript',
        lolcode: 'LOLCODE',
        matlab: 'MATLAB',
        mel: 'MEL',
        nasm: 'NASM',
        nginx: 'nginx',
        nsis: 'NSIS',
        objectivec: 'Objective-C',
        ocaml: 'OCaml',
        parigp: 'PARI/GP',
        php: 'PHP',
        'php-extras': 'PHP Extras',
        powershell: 'PowerShell',
        properties: '.properties',
        protobuf: 'Protocol Buffers',
        jsx: 'React JSX',
        rest: 'reST (reStructuredText)',
        sas: 'SAS',
        sass: 'Sass (Sass)',
        scss: 'Sass (Scss)',
        sql: 'SQL',
        typescript: 'TypeScript',
        vhdl: 'VHDL',
        vim: 'vim',
        wiki: 'Wiki markup',
        xojo: 'Xojo (REALbasic)',
        yaml: 'YAML'
    }; /*]*/ 
    $d5699406d24e78a1$var$Prism.hooks.add('before-highlight', function(env) {
        const pre = env.element.parentNode;
        if (!pre || !/pre/i.test(pre.nodeName)) return;
        const language = pre.getAttribute('data-language') || Languages[env.language] || env.language.substring(0, 1).toUpperCase() + env.language.substring(1);
        /* check if the divs already exist */ const sib = pre.previousSibling;
        let div, div2, div3;
        if (sib && /\s*\bprism-show-language\b\s*/.test(sib.className) && sib.firstChild && /\s*\bprism-show-language-label\b\s*/.test(sib.firstChild.className)) div2 = sib.firstChild;
        else {
            div = document.createElement('div');
            div2 = document.createElement('div');
            div3 = document.createElement('div');
            div2.className = 'prism-show-language-label';
            div.className = 'prism-show-language code-label';
            div.appendChild(div2);
            //  render(html`
            //     <div class="copy-icon" @click=${function(this: HTMLElement) {
            //     navigator.clipboard.writeText(this.parentElement.nextSibling.firstChild.firstChild.textContent);
            //   success('Code added to clipboard', 'Copy Success');
            //     }}>${CopyIcon}</div>
            //  `,div)
            pre.parentNode.insertBefore(div, pre);
        }
        div2.innerHTML = language;
    });
})();



var $4XQlz = parcelRequire("4XQlz");
function $6f2e6174c8aeac93$export$4028cc7750e95339() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
let $6f2e6174c8aeac93$export$3444e66eca2af284 = $6f2e6174c8aeac93$export$4028cc7750e95339();
function $6f2e6174c8aeac93$export$ca64cf607b16025d(newDefaults) {
    $6f2e6174c8aeac93$export$3444e66eca2af284 = newDefaults;
}




const $22a983b9ce46e66e$var$noopTest = {
    exec: ()=>null
};
function $22a983b9ce46e66e$var$edit(regex, opt = '') {
    let source = typeof regex === 'string' ? regex : regex.source;
    const obj = {
        replace: (name, val)=>{
            let valSource = typeof val === 'string' ? val : val.source;
            valSource = valSource.replace($22a983b9ce46e66e$export$70a00e0a8474f72a.caret, '$1');
            source = source.replace(name, valSource);
            return obj;
        },
        getRegex: ()=>{
            return new RegExp(source, opt);
        }
    };
    return obj;
}
const $22a983b9ce46e66e$export$70a00e0a8474f72a = {
    codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
    outputLinkReplace: /\\([\[\]])/g,
    indentCodeCompensation: /^(\s+)(?:```)/,
    beginningSpace: /^\s+/,
    endingHash: /#$/,
    startingSpaceChar: /^ /,
    endingSpaceChar: / $/,
    nonSpaceChar: /[^ ]/,
    newLineCharGlobal: /\n/g,
    tabCharGlobal: /\t/g,
    multipleSpaceGlobal: /\s+/g,
    blankLine: /^[ \t]*$/,
    doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
    blockquoteStart: /^ {0,3}>/,
    blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
    blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
    listReplaceTabs: /^\t+/,
    listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
    listIsTask: /^\[[ xX]\] /,
    listReplaceTask: /^\[[ xX]\] +/,
    anyLine: /\n.*\n/,
    hrefBrackets: /^<(.*)>$/,
    tableDelimiter: /[:|]/,
    tableAlignChars: /^\||\| *$/g,
    tableRowBlankLine: /\n[ \t]*$/,
    tableAlignRight: /^ *-+: *$/,
    tableAlignCenter: /^ *:-+: *$/,
    tableAlignLeft: /^ *:-+ *$/,
    startATag: /^<a /i,
    endATag: /^<\/a>/i,
    startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
    endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
    startAngleBracket: /^</,
    endAngleBracket: />$/,
    pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
    unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
    escapeTest: /[&<>"']/,
    escapeReplace: /[&<>"']/g,
    escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi,
    caret: /(^|[^\[])\^/g,
    percentDecode: /%25/g,
    findPipe: /\|/g,
    splitPipe: / \|/,
    slashPipe: /\\\|/g,
    carriageReturn: /\r\n|\r/g,
    spaceLine: /^ +$/gm,
    notSpaceStart: /^\S*/,
    endingNewline: /\n$/,
    listItemRegex: (bull)=>new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`),
    nextBulletRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`),
    hrRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
    fencesBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
    headingBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
    htmlBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, 'i')
};
/**
 * Block-Level Grammar
 */ const $22a983b9ce46e66e$var$newline = /^(?:[ \t]*(?:\n|$))+/;
const $22a983b9ce46e66e$var$blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
const $22a983b9ce46e66e$var$fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
const $22a983b9ce46e66e$var$hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
const $22a983b9ce46e66e$var$heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
const $22a983b9ce46e66e$var$bullet = /(?:[*+-]|\d{1,9}[.)])/;
const $22a983b9ce46e66e$var$lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
const $22a983b9ce46e66e$var$lheading = $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$lheadingCore).replace(/bull/g, $22a983b9ce46e66e$var$bullet) // lists can interrupt
.replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
.replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
.replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
.replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
.replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
.replace(/\|table/g, '') // table not in commonmark
.getRegex();
const $22a983b9ce46e66e$var$lheadingGfm = $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$lheadingCore).replace(/bull/g, $22a983b9ce46e66e$var$bullet) // lists can interrupt
.replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
.replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
.replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
.replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
.replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
.replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/) // table can interrupt
.getRegex();
const $22a983b9ce46e66e$var$_paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
const $22a983b9ce46e66e$var$blockText = /^[^\n]+/;
const $22a983b9ce46e66e$var$_blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
const $22a983b9ce46e66e$var$def = $22a983b9ce46e66e$var$edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace('label', $22a983b9ce46e66e$var$_blockLabel).replace('title', /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
const $22a983b9ce46e66e$var$list = $22a983b9ce46e66e$var$edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, $22a983b9ce46e66e$var$bullet).getRegex();
const $22a983b9ce46e66e$var$_tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
const $22a983b9ce46e66e$var$_comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
const $22a983b9ce46e66e$var$html = $22a983b9ce46e66e$var$edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", 'i').replace('comment', $22a983b9ce46e66e$var$_comment).replace('tag', $22a983b9ce46e66e$var$_tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
const $22a983b9ce46e66e$var$paragraph = $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$_paragraph).replace('hr', $22a983b9ce46e66e$var$hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
.replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
.replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', $22a983b9ce46e66e$var$_tag) // pars can be interrupted by type (6) html blocks
.getRegex();
const $22a983b9ce46e66e$var$blockquote = $22a983b9ce46e66e$var$edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace('paragraph', $22a983b9ce46e66e$var$paragraph).getRegex();
/**
 * Normal Block Grammar
 */ const $22a983b9ce46e66e$var$blockNormal = {
    blockquote: $22a983b9ce46e66e$var$blockquote,
    code: $22a983b9ce46e66e$var$blockCode,
    def: $22a983b9ce46e66e$var$def,
    fences: $22a983b9ce46e66e$var$fences,
    heading: $22a983b9ce46e66e$var$heading,
    hr: $22a983b9ce46e66e$var$hr,
    html: $22a983b9ce46e66e$var$html,
    lheading: $22a983b9ce46e66e$var$lheading,
    list: $22a983b9ce46e66e$var$list,
    newline: $22a983b9ce46e66e$var$newline,
    paragraph: $22a983b9ce46e66e$var$paragraph,
    table: $22a983b9ce46e66e$var$noopTest,
    text: $22a983b9ce46e66e$var$blockText
};
/**
 * GFM Block Grammar
 */ const $22a983b9ce46e66e$var$gfmTable = $22a983b9ce46e66e$var$edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)") // Cells
.replace('hr', $22a983b9ce46e66e$var$hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('blockquote', ' {0,3}>').replace('code', '(?: {4}| {0,3}\t)[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
.replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', $22a983b9ce46e66e$var$_tag) // tables can be interrupted by type (6) html blocks
.getRegex();
const $22a983b9ce46e66e$var$blockGfm = {
    ...$22a983b9ce46e66e$var$blockNormal,
    lheading: $22a983b9ce46e66e$var$lheadingGfm,
    table: $22a983b9ce46e66e$var$gfmTable,
    paragraph: $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$_paragraph).replace('hr', $22a983b9ce46e66e$var$hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
    .replace('table', $22a983b9ce46e66e$var$gfmTable) // interrupt paragraphs with table
    .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', $22a983b9ce46e66e$var$_tag) // pars can be interrupted by type (6) html blocks
    .getRegex()
};
/**
 * Pedantic grammar (original John Gruber's loose markdown specification)
 */ const $22a983b9ce46e66e$var$blockPedantic = {
    ...$22a983b9ce46e66e$var$blockNormal,
    html: $22a983b9ce46e66e$var$edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace('comment', $22a983b9ce46e66e$var$_comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: $22a983b9ce46e66e$var$noopTest,
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$_paragraph).replace('hr', $22a983b9ce46e66e$var$hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', $22a983b9ce46e66e$var$lheading).replace('|table', '').replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').replace('|tag', '').getRegex()
};
/**
 * Inline-Level Grammar
 */ const $22a983b9ce46e66e$var$escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
const $22a983b9ce46e66e$var$inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
const $22a983b9ce46e66e$var$br = /^( {2,}|\\)\n(?!\s*$)/;
const $22a983b9ce46e66e$var$inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
// list of unicode punctuation marks, plus any missing characters from CommonMark spec
const $22a983b9ce46e66e$var$_punctuation = /[\p{P}\p{S}]/u;
const $22a983b9ce46e66e$var$_punctuationOrSpace = /[\s\p{P}\p{S}]/u;
const $22a983b9ce46e66e$var$_notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
const $22a983b9ce46e66e$var$punctuation = $22a983b9ce46e66e$var$edit(/^((?![*_])punctSpace)/, 'u').replace(/punctSpace/g, $22a983b9ce46e66e$var$_punctuationOrSpace).getRegex();
// GFM allows ~ inside strong and em for strikethrough
const $22a983b9ce46e66e$var$_punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
const $22a983b9ce46e66e$var$_punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
const $22a983b9ce46e66e$var$_notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
// sequences em should skip over [title](link), `code`, <html>
const $22a983b9ce46e66e$var$blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<(?! )[^<>]*?>/g;
const $22a983b9ce46e66e$var$emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
const $22a983b9ce46e66e$var$emStrongLDelim = $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$emStrongLDelimCore, 'u').replace(/punct/g, $22a983b9ce46e66e$var$_punctuation).getRegex();
const $22a983b9ce46e66e$var$emStrongLDelimGfm = $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$emStrongLDelimCore, 'u').replace(/punct/g, $22a983b9ce46e66e$var$_punctuationGfmStrongEm).getRegex();
const $22a983b9ce46e66e$var$emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)"; // (6) a***a can be either Left or Right Delimiter
const $22a983b9ce46e66e$var$emStrongRDelimAst = $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$emStrongRDelimAstCore, 'gu').replace(/notPunctSpace/g, $22a983b9ce46e66e$var$_notPunctuationOrSpace).replace(/punctSpace/g, $22a983b9ce46e66e$var$_punctuationOrSpace).replace(/punct/g, $22a983b9ce46e66e$var$_punctuation).getRegex();
const $22a983b9ce46e66e$var$emStrongRDelimAstGfm = $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$emStrongRDelimAstCore, 'gu').replace(/notPunctSpace/g, $22a983b9ce46e66e$var$_notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, $22a983b9ce46e66e$var$_punctuationOrSpaceGfmStrongEm).replace(/punct/g, $22a983b9ce46e66e$var$_punctuationGfmStrongEm).getRegex();
// (6) Not allowed for _
const $22a983b9ce46e66e$var$emStrongRDelimUnd = $22a983b9ce46e66e$var$edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", 'gu') // (5) #___# can be either Left or Right Delimiter
.replace(/notPunctSpace/g, $22a983b9ce46e66e$var$_notPunctuationOrSpace).replace(/punctSpace/g, $22a983b9ce46e66e$var$_punctuationOrSpace).replace(/punct/g, $22a983b9ce46e66e$var$_punctuation).getRegex();
const $22a983b9ce46e66e$var$anyPunctuation = $22a983b9ce46e66e$var$edit(/\\(punct)/, 'gu').replace(/punct/g, $22a983b9ce46e66e$var$_punctuation).getRegex();
const $22a983b9ce46e66e$var$autolink = $22a983b9ce46e66e$var$edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace('scheme', /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace('email', /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
const $22a983b9ce46e66e$var$_inlineComment = $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$_comment).replace('(?:-->|$)', '-->').getRegex();
const $22a983b9ce46e66e$var$tag = $22a983b9ce46e66e$var$edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>") // CDATA section
.replace('comment', $22a983b9ce46e66e$var$_inlineComment).replace('attribute', /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
const $22a983b9ce46e66e$var$_inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
const $22a983b9ce46e66e$var$link = $22a983b9ce46e66e$var$edit(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace('label', $22a983b9ce46e66e$var$_inlineLabel).replace('href', /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace('title', /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
const $22a983b9ce46e66e$var$reflink = $22a983b9ce46e66e$var$edit(/^!?\[(label)\]\[(ref)\]/).replace('label', $22a983b9ce46e66e$var$_inlineLabel).replace('ref', $22a983b9ce46e66e$var$_blockLabel).getRegex();
const $22a983b9ce46e66e$var$nolink = $22a983b9ce46e66e$var$edit(/^!?\[(ref)\](?:\[\])?/).replace('ref', $22a983b9ce46e66e$var$_blockLabel).getRegex();
const $22a983b9ce46e66e$var$reflinkSearch = $22a983b9ce46e66e$var$edit('reflink|nolink(?!\\()', 'g').replace('reflink', $22a983b9ce46e66e$var$reflink).replace('nolink', $22a983b9ce46e66e$var$nolink).getRegex();
/**
 * Normal Inline Grammar
 */ const $22a983b9ce46e66e$var$inlineNormal = {
    _backpedal: $22a983b9ce46e66e$var$noopTest,
    anyPunctuation: $22a983b9ce46e66e$var$anyPunctuation,
    autolink: $22a983b9ce46e66e$var$autolink,
    blockSkip: $22a983b9ce46e66e$var$blockSkip,
    br: $22a983b9ce46e66e$var$br,
    code: $22a983b9ce46e66e$var$inlineCode,
    del: $22a983b9ce46e66e$var$noopTest,
    emStrongLDelim: $22a983b9ce46e66e$var$emStrongLDelim,
    emStrongRDelimAst: $22a983b9ce46e66e$var$emStrongRDelimAst,
    emStrongRDelimUnd: $22a983b9ce46e66e$var$emStrongRDelimUnd,
    escape: $22a983b9ce46e66e$var$escape,
    link: $22a983b9ce46e66e$var$link,
    nolink: $22a983b9ce46e66e$var$nolink,
    punctuation: $22a983b9ce46e66e$var$punctuation,
    reflink: $22a983b9ce46e66e$var$reflink,
    reflinkSearch: $22a983b9ce46e66e$var$reflinkSearch,
    tag: $22a983b9ce46e66e$var$tag,
    text: $22a983b9ce46e66e$var$inlineText,
    url: $22a983b9ce46e66e$var$noopTest
};
/**
 * Pedantic Inline Grammar
 */ const $22a983b9ce46e66e$var$inlinePedantic = {
    ...$22a983b9ce46e66e$var$inlineNormal,
    link: $22a983b9ce46e66e$var$edit(/^!?\[(label)\]\((.*?)\)/).replace('label', $22a983b9ce46e66e$var$_inlineLabel).getRegex(),
    reflink: $22a983b9ce46e66e$var$edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', $22a983b9ce46e66e$var$_inlineLabel).getRegex()
};
/**
 * GFM Inline Grammar
 */ const $22a983b9ce46e66e$var$inlineGfm = {
    ...$22a983b9ce46e66e$var$inlineNormal,
    emStrongRDelimAst: $22a983b9ce46e66e$var$emStrongRDelimAstGfm,
    emStrongLDelim: $22a983b9ce46e66e$var$emStrongLDelimGfm,
    url: $22a983b9ce46e66e$var$edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, 'i').replace('email', /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
/**
 * GFM + Line Breaks Inline Grammar
 */ const $22a983b9ce46e66e$var$inlineBreaks = {
    ...$22a983b9ce46e66e$var$inlineGfm,
    br: $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$br).replace('{2,}', '*').getRegex(),
    text: $22a983b9ce46e66e$var$edit($22a983b9ce46e66e$var$inlineGfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
};
const $22a983b9ce46e66e$export$837bd02682cd3db9 = {
    normal: $22a983b9ce46e66e$var$blockNormal,
    gfm: $22a983b9ce46e66e$var$blockGfm,
    pedantic: $22a983b9ce46e66e$var$blockPedantic
};
const $22a983b9ce46e66e$export$18c8ad048e32c7d5 = {
    normal: $22a983b9ce46e66e$var$inlineNormal,
    gfm: $22a983b9ce46e66e$var$inlineGfm,
    breaks: $22a983b9ce46e66e$var$inlineBreaks,
    pedantic: $22a983b9ce46e66e$var$inlinePedantic
};




/**
 * Helpers
 */ const $6b22f7e70ed0fce9$var$escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
const $6b22f7e70ed0fce9$var$getEscapeReplacement = (ch)=>$6b22f7e70ed0fce9$var$escapeReplacements[ch];
function $6b22f7e70ed0fce9$export$4e7f196112fea3c5(html, encode) {
    if (encode) {
        if ((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).escapeTest.test(html)) return html.replace((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).escapeReplace, $6b22f7e70ed0fce9$var$getEscapeReplacement);
    } else {
        if ((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).escapeTestNoEncode.test(html)) return html.replace((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).escapeReplaceNoEncode, $6b22f7e70ed0fce9$var$getEscapeReplacement);
    }
    return html;
}
function $6b22f7e70ed0fce9$export$e8bacd2802a88316(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).unescapeTest, (_, n)=>{
        n = n.toLowerCase();
        if (n === 'colon') return ':';
        if (n.charAt(0) === '#') return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
        return '';
    });
}
function $6b22f7e70ed0fce9$export$39cd5310d932e557(href) {
    try {
        href = encodeURI(href).replace((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).percentDecode, '%');
    } catch  {
        return null;
    }
    return href;
}
function $6b22f7e70ed0fce9$export$3c321cfecc99463(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    const row = tableRow.replace((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).findPipe, (match, offset, str)=>{
        let escaped = false;
        let curr = offset;
        while(--curr >= 0 && str[curr] === '\\')escaped = !escaped;
        if (escaped) // odd number of slashes means | is escaped
        // so we leave it alone
        return '|';
        else // add space before unescaped |
        return ' |';
    }), cells = row.split((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).splitPipe);
    let i = 0;
    // First/last cell in a row cannot be empty if it has no leading/trailing pipe
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !cells.at(-1)?.trim()) cells.pop();
    if (count) {
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push('');
    }
    for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
    cells[i] = cells[i].trim().replace((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).slashPipe, '|');
    return cells;
}
function $6b22f7e70ed0fce9$export$770c7916125832a9(str, c, invert) {
    const l = str.length;
    if (l === 0) return '';
    // Length of suffix matching the invert condition.
    let suffLen = 0;
    // Step left until we fail to match the invert condition.
    while(suffLen < l){
        const currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) suffLen++;
        else if (currChar !== c && invert) suffLen++;
        else break;
    }
    return str.slice(0, l - suffLen);
}
function $6b22f7e70ed0fce9$export$921c598b2d68388a(str, b) {
    if (str.indexOf(b[1]) === -1) return -1;
    let level = 0;
    for(let i = 0; i < str.length; i++){
        if (str[i] === '\\') i++;
        else if (str[i] === b[0]) level++;
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    if (level > 0) return -2;
    return -1;
}


function $c9a4fb86e2980742$var$outputLink(cap, link, raw, lexer, rules) {
    const href = link.href;
    const title = link.title || null;
    const text = cap[1].replace(rules.other.outputLinkReplace, '$1');
    lexer.state.inLink = true;
    const token = {
        type: cap[0].charAt(0) === '!' ? 'image' : 'link',
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer.inlineTokens(text)
    };
    lexer.state.inLink = false;
    return token;
}
function $c9a4fb86e2980742$var$indentCodeCompensation(raw, text, rules) {
    const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
    if (matchIndentToCode === null) return text;
    const indentToCode = matchIndentToCode[1];
    return text.split('\n').map((node)=>{
        const matchIndentInNode = node.match(rules.other.beginningSpace);
        if (matchIndentInNode === null) return node;
        const [indentInNode] = matchIndentInNode;
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join('\n');
}
class $c9a4fb86e2980742$export$13c4c5b7c8fc41f5 {
    constructor(options){
        this.options = options || (0, $6f2e6174c8aeac93$export$3444e66eca2af284);
    }
    space(src) {
        const cap = this.rules.block.newline.exec(src);
        if (cap && cap[0].length > 0) return {
            type: 'space',
            raw: cap[0]
        };
    }
    code(src) {
        const cap = this.rules.block.code.exec(src);
        if (cap) {
            const text = cap[0].replace(this.rules.other.codeRemoveIndent, '');
            return {
                type: 'code',
                raw: cap[0],
                codeBlockStyle: 'indented',
                text: !this.options.pedantic ? (0, $6b22f7e70ed0fce9$export$770c7916125832a9)(text, '\n') : text
            };
        }
    }
    fences(src) {
        const cap = this.rules.block.fences.exec(src);
        if (cap) {
            const raw = cap[0];
            const text = $c9a4fb86e2980742$var$indentCodeCompensation(raw, cap[3] || '', this.rules);
            return {
                type: 'code',
                raw: raw,
                lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, '$1') : cap[2],
                text: text
            };
        }
    }
    heading(src) {
        const cap = this.rules.block.heading.exec(src);
        if (cap) {
            let text = cap[2].trim();
            // remove trailing #s
            if (this.rules.other.endingHash.test(text)) {
                const trimmed = (0, $6b22f7e70ed0fce9$export$770c7916125832a9)(text, '#');
                if (this.options.pedantic) text = trimmed.trim();
                else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) // CommonMark requires space before trailing #s
                text = trimmed.trim();
            }
            return {
                type: 'heading',
                raw: cap[0],
                depth: cap[1].length,
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    hr(src) {
        const cap = this.rules.block.hr.exec(src);
        if (cap) return {
            type: 'hr',
            raw: (0, $6b22f7e70ed0fce9$export$770c7916125832a9)(cap[0], '\n')
        };
    }
    blockquote(src) {
        const cap = this.rules.block.blockquote.exec(src);
        if (cap) {
            let lines = (0, $6b22f7e70ed0fce9$export$770c7916125832a9)(cap[0], '\n').split('\n');
            let raw = '';
            let text = '';
            const tokens = [];
            while(lines.length > 0){
                let inBlockquote = false;
                const currentLines = [];
                let i;
                for(i = 0; i < lines.length; i++){
                    // get lines up to a continuation
                    if (this.rules.other.blockquoteStart.test(lines[i])) {
                        currentLines.push(lines[i]);
                        inBlockquote = true;
                    } else if (!inBlockquote) currentLines.push(lines[i]);
                    else break;
                }
                lines = lines.slice(i);
                const currentRaw = currentLines.join('\n');
                const currentText = currentRaw// precede setext continuation with 4 spaces so it isn't a setext
                .replace(this.rules.other.blockquoteSetextReplace, '\n    $1').replace(this.rules.other.blockquoteSetextReplace2, '');
                raw = raw ? `${raw}\n${currentRaw}` : currentRaw;
                text = text ? `${text}\n${currentText}` : currentText;
                // parse blockquote lines as top level tokens
                // merge paragraphs if this is a continuation
                const top = this.lexer.state.top;
                this.lexer.state.top = true;
                this.lexer.blockTokens(currentText, tokens, true);
                this.lexer.state.top = top;
                // if there is no continuation then we are done
                if (lines.length === 0) break;
                const lastToken = tokens.at(-1);
                if (lastToken?.type === 'code') break;
                else if (lastToken?.type === 'blockquote') {
                    // include continuation in nested blockquote
                    const oldToken = lastToken;
                    const newText = oldToken.raw + '\n' + lines.join('\n');
                    const newToken = this.blockquote(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                    break;
                } else if (lastToken?.type === 'list') {
                    // include continuation in nested list
                    const oldToken = lastToken;
                    const newText = oldToken.raw + '\n' + lines.join('\n');
                    const newToken = this.list(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                    lines = newText.substring(tokens.at(-1).raw.length).split('\n');
                    continue;
                }
            }
            return {
                type: 'blockquote',
                raw: raw,
                tokens: tokens,
                text: text
            };
        }
    }
    list(src) {
        let cap = this.rules.block.list.exec(src);
        if (cap) {
            let bull = cap[1].trim();
            const isordered = bull.length > 1;
            const list = {
                type: 'list',
                raw: '',
                ordered: isordered,
                start: isordered ? +bull.slice(0, -1) : '',
                loose: false,
                items: []
            };
            bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
            if (this.options.pedantic) bull = isordered ? bull : '[*+-]';
            // Get next list item
            const itemRegex = this.rules.other.listItemRegex(bull);
            let endsWithBlankLine = false;
            // Check if current bullet point can start a new List Item
            while(src){
                let endEarly = false;
                let raw = '';
                let itemContents = '';
                if (!(cap = itemRegex.exec(src))) break;
                if (this.rules.block.hr.test(src)) break;
                raw = cap[0];
                src = src.substring(raw.length);
                let line = cap[2].split('\n', 1)[0].replace(this.rules.other.listReplaceTabs, (t)=>' '.repeat(3 * t.length));
                let nextLine = src.split('\n', 1)[0];
                let blankLine = !line.trim();
                let indent = 0;
                if (this.options.pedantic) {
                    indent = 2;
                    itemContents = line.trimStart();
                } else if (blankLine) indent = cap[1].length + 1;
                else {
                    indent = cap[2].search(this.rules.other.nonSpaceChar); // Find first non-space char
                    indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                    itemContents = line.slice(indent);
                    indent += cap[1].length;
                }
                if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                    // Items begin with at most one blank line
                    raw += nextLine + '\n';
                    src = src.substring(nextLine.length + 1);
                    endEarly = true;
                }
                if (!endEarly) {
                    const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                    const hrRegex = this.rules.other.hrRegex(indent);
                    const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                    const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                    const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                    // Check if following lines should be included in List Item
                    while(src){
                        const rawLine = src.split('\n', 1)[0];
                        let nextLineWithoutTabs;
                        nextLine = rawLine;
                        // Re-align to follow commonmark nesting rules
                        if (this.options.pedantic) {
                            nextLine = nextLine.replace(this.rules.other.listReplaceNesting, '  ');
                            nextLineWithoutTabs = nextLine;
                        } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, '    ');
                        // End list item if found code fences
                        if (fencesBeginRegex.test(nextLine)) break;
                        // End list item if found start of new heading
                        if (headingBeginRegex.test(nextLine)) break;
                        // End list item if found start of html block
                        if (htmlBeginRegex.test(nextLine)) break;
                        // End list item if found start of new bullet
                        if (nextBulletRegex.test(nextLine)) break;
                        // Horizontal rule found
                        if (hrRegex.test(nextLine)) break;
                        if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) // Dedent if possible
                        itemContents += '\n' + nextLineWithoutTabs.slice(indent);
                        else {
                            // not enough indentation
                            if (blankLine) break;
                            // paragraph continuation unless last line was a different block level element
                            if (line.replace(this.rules.other.tabCharGlobal, '    ').search(this.rules.other.nonSpaceChar) >= 4) break;
                            if (fencesBeginRegex.test(line)) break;
                            if (headingBeginRegex.test(line)) break;
                            if (hrRegex.test(line)) break;
                            itemContents += '\n' + nextLine;
                        }
                        if (!blankLine && !nextLine.trim()) // Check if current line is blank
                        blankLine = true;
                        raw += rawLine + '\n';
                        src = src.substring(rawLine.length + 1);
                        line = nextLineWithoutTabs.slice(indent);
                    }
                }
                if (!list.loose) {
                    // If the previous item ended with a blank line, the list is loose
                    if (endsWithBlankLine) list.loose = true;
                    else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                }
                let istask = null;
                let ischecked;
                // Check for task list items
                if (this.options.gfm) {
                    istask = this.rules.other.listIsTask.exec(itemContents);
                    if (istask) {
                        ischecked = istask[0] !== '[ ] ';
                        itemContents = itemContents.replace(this.rules.other.listReplaceTask, '');
                    }
                }
                list.items.push({
                    type: 'list_item',
                    raw: raw,
                    task: !!istask,
                    checked: ischecked,
                    loose: false,
                    text: itemContents,
                    tokens: []
                });
                list.raw += raw;
            }
            // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
            const lastItem = list.items.at(-1);
            if (lastItem) {
                lastItem.raw = lastItem.raw.trimEnd();
                lastItem.text = lastItem.text.trimEnd();
            } else // not a list since there were no items
            return;
            list.raw = list.raw.trimEnd();
            // Item child tokens handled here at end because we needed to have the final item to trim it first
            for(let i = 0; i < list.items.length; i++){
                this.lexer.state.top = false;
                list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                if (!list.loose) {
                    // Check if list should be loose
                    const spacers = list.items[i].tokens.filter((t)=>t.type === 'space');
                    const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>this.rules.other.anyLine.test(t.raw));
                    list.loose = hasMultipleLineBreaks;
                }
            }
            // Set all items to loose if list is loose
            if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
            return list;
        }
    }
    html(src) {
        const cap = this.rules.block.html.exec(src);
        if (cap) {
            const token = {
                type: 'html',
                block: true,
                raw: cap[0],
                pre: cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style',
                text: cap[0]
            };
            return token;
        }
    }
    def(src) {
        const cap = this.rules.block.def.exec(src);
        if (cap) {
            const tag = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, ' ');
            const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, '$1').replace(this.rules.inline.anyPunctuation, '$1') : '';
            const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, '$1') : cap[3];
            return {
                type: 'def',
                tag: tag,
                raw: cap[0],
                href: href,
                title: title
            };
        }
    }
    table(src) {
        const cap = this.rules.block.table.exec(src);
        if (!cap) return;
        if (!this.rules.other.tableDelimiter.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
        return;
        const headers = (0, $6b22f7e70ed0fce9$export$3c321cfecc99463)(cap[1]);
        const aligns = cap[2].replace(this.rules.other.tableAlignChars, '').split('|');
        const rows = cap[3]?.trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, '').split('\n') : [];
        const item = {
            type: 'table',
            raw: cap[0],
            header: [],
            align: [],
            rows: []
        };
        if (headers.length !== aligns.length) // header and align columns must be equal, rows can be different.
        return;
        for (const align of aligns){
            if (this.rules.other.tableAlignRight.test(align)) item.align.push('right');
            else if (this.rules.other.tableAlignCenter.test(align)) item.align.push('center');
            else if (this.rules.other.tableAlignLeft.test(align)) item.align.push('left');
            else item.align.push(null);
        }
        for(let i = 0; i < headers.length; i++)item.header.push({
            text: headers[i],
            tokens: this.lexer.inline(headers[i]),
            header: true,
            align: item.align[i]
        });
        for (const row of rows)item.rows.push((0, $6b22f7e70ed0fce9$export$3c321cfecc99463)(row, item.header.length).map((cell, i)=>{
            return {
                text: cell,
                tokens: this.lexer.inline(cell),
                header: false,
                align: item.align[i]
            };
        }));
        return item;
    }
    lheading(src) {
        const cap = this.rules.block.lheading.exec(src);
        if (cap) return {
            type: 'heading',
            raw: cap[0],
            depth: cap[2].charAt(0) === '=' ? 1 : 2,
            text: cap[1],
            tokens: this.lexer.inline(cap[1])
        };
    }
    paragraph(src) {
        const cap = this.rules.block.paragraph.exec(src);
        if (cap) {
            const text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
            return {
                type: 'paragraph',
                raw: cap[0],
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    text(src) {
        const cap = this.rules.block.text.exec(src);
        if (cap) return {
            type: 'text',
            raw: cap[0],
            text: cap[0],
            tokens: this.lexer.inline(cap[0])
        };
    }
    escape(src) {
        const cap = this.rules.inline.escape.exec(src);
        if (cap) return {
            type: 'escape',
            raw: cap[0],
            text: cap[1]
        };
    }
    tag(src) {
        const cap = this.rules.inline.tag.exec(src);
        if (cap) {
            if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
            else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
            if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
            else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
            return {
                type: 'html',
                raw: cap[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: false,
                text: cap[0]
            };
        }
    }
    link(src) {
        const cap = this.rules.inline.link.exec(src);
        if (cap) {
            const trimmedUrl = cap[2].trim();
            if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                // commonmark requires matching angle brackets
                if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                // ending angle bracket cannot be escaped
                const rtrimSlash = (0, $6b22f7e70ed0fce9$export$770c7916125832a9)(trimmedUrl.slice(0, -1), '\\');
                if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
            } else {
                // find closing parenthesis
                const lastParenIndex = (0, $6b22f7e70ed0fce9$export$921c598b2d68388a)(cap[2], '()');
                if (lastParenIndex === -2) // more open parens than closed
                return;
                if (lastParenIndex > -1) {
                    const start = cap[0].indexOf('!') === 0 ? 5 : 4;
                    const linkLen = start + cap[1].length + lastParenIndex;
                    cap[2] = cap[2].substring(0, lastParenIndex);
                    cap[0] = cap[0].substring(0, linkLen).trim();
                    cap[3] = '';
                }
            }
            let href = cap[2];
            let title = '';
            if (this.options.pedantic) {
                // split pedantic href and title
                const link = this.rules.other.pedanticHrefTitle.exec(href);
                if (link) {
                    href = link[1];
                    title = link[3];
                }
            } else title = cap[3] ? cap[3].slice(1, -1) : '';
            href = href.trim();
            if (this.rules.other.startAngleBracket.test(href)) {
                if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                href = href.slice(1);
                else href = href.slice(1, -1);
            }
            return $c9a4fb86e2980742$var$outputLink(cap, {
                href: href ? href.replace(this.rules.inline.anyPunctuation, '$1') : href,
                title: title ? title.replace(this.rules.inline.anyPunctuation, '$1') : title
            }, cap[0], this.lexer, this.rules);
        }
    }
    reflink(src, links) {
        let cap;
        if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
            const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, ' ');
            const link = links[linkString.toLowerCase()];
            if (!link) {
                const text = cap[0].charAt(0);
                return {
                    type: 'text',
                    raw: text,
                    text: text
                };
            }
            return $c9a4fb86e2980742$var$outputLink(cap, link, cap[0], this.lexer, this.rules);
        }
    }
    emStrong(src, maskedSrc, prevChar = '') {
        let match = this.rules.inline.emStrongLDelim.exec(src);
        if (!match) return;
        // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
        if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
        const nextChar = match[1] || match[2] || '';
        if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
            // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
            const lLength = [
                ...match[0]
            ].length - 1;
            let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
            const endReg = match[0][0] === '*' ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
            endReg.lastIndex = 0;
            // Clip maskedSrc to same section of string as src (move to lexer?)
            maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
            while((match = endReg.exec(maskedSrc)) != null){
                rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                if (!rDelim) continue; // skip single * in __abc*abc__
                rLength = [
                    ...rDelim
                ].length;
                if (match[3] || match[4]) {
                    // found another Left Delim
                    delimTotal += rLength;
                    continue;
                } else if (match[5] || match[6]) // either Left or Right Delim
                {
                    if (lLength % 3 && !((lLength + rLength) % 3)) {
                        midDelimTotal += rLength;
                        continue; // CommonMark Emphasis Rules 9-10
                    }
                }
                delimTotal -= rLength;
                if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                // Remove extra characters. *a*** -> *a*
                rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                // char length can be >1 for unicode characters;
                const lastCharLength = [
                    ...match[0]
                ][0].length;
                const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                // Create `em` if smallest delimiter has odd char count. *a***
                if (Math.min(lLength, rLength) % 2) {
                    const text = raw.slice(1, -1);
                    return {
                        type: 'em',
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
                // Create 'strong' if smallest delimiter has even char count. **a***
                const text = raw.slice(2, -2);
                return {
                    type: 'strong',
                    raw: raw,
                    text: text,
                    tokens: this.lexer.inlineTokens(text)
                };
            }
        }
    }
    codespan(src) {
        const cap = this.rules.inline.code.exec(src);
        if (cap) {
            let text = cap[2].replace(this.rules.other.newLineCharGlobal, ' ');
            const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
            const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
            if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
            return {
                type: 'codespan',
                raw: cap[0],
                text: text
            };
        }
    }
    br(src) {
        const cap = this.rules.inline.br.exec(src);
        if (cap) return {
            type: 'br',
            raw: cap[0]
        };
    }
    del(src) {
        const cap = this.rules.inline.del.exec(src);
        if (cap) return {
            type: 'del',
            raw: cap[0],
            text: cap[2],
            tokens: this.lexer.inlineTokens(cap[2])
        };
    }
    autolink(src) {
        const cap = this.rules.inline.autolink.exec(src);
        if (cap) {
            let text, href;
            if (cap[2] === '@') {
                text = cap[1];
                href = 'mailto:' + text;
            } else {
                text = cap[1];
                href = text;
            }
            return {
                type: 'link',
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: 'text',
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    url(src) {
        let cap;
        if (cap = this.rules.inline.url.exec(src)) {
            let text, href;
            if (cap[2] === '@') {
                text = cap[0];
                href = 'mailto:' + text;
            } else {
                // do extended autolink path validation
                let prevCapZero;
                do {
                    prevCapZero = cap[0];
                    cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? '';
                }while (prevCapZero !== cap[0]);
                text = cap[0];
                if (cap[1] === 'www.') href = 'http://' + cap[0];
                else href = cap[0];
            }
            return {
                type: 'link',
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: 'text',
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    inlineText(src) {
        const cap = this.rules.inline.text.exec(src);
        if (cap) {
            const escaped = this.lexer.state.inRawBlock;
            return {
                type: 'text',
                raw: cap[0],
                text: cap[0],
                escaped: escaped
            };
        }
    }
}


class $6c0c5ccf54deec19$export$ff20f7639780cbb3 {
    constructor(options){
        // TokenList cannot be created in one go
        this.tokens = [];
        this.tokens.links = Object.create(null);
        this.options = options || (0, $6f2e6174c8aeac93$export$3444e66eca2af284);
        this.options.tokenizer = this.options.tokenizer || new (0, $c9a4fb86e2980742$export$13c4c5b7c8fc41f5)();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        const rules = {
            other: $22a983b9ce46e66e$export$70a00e0a8474f72a,
            block: (0, $22a983b9ce46e66e$export$837bd02682cd3db9).normal,
            inline: (0, $22a983b9ce46e66e$export$18c8ad048e32c7d5).normal
        };
        if (this.options.pedantic) {
            rules.block = (0, $22a983b9ce46e66e$export$837bd02682cd3db9).pedantic;
            rules.inline = (0, $22a983b9ce46e66e$export$18c8ad048e32c7d5).pedantic;
        } else if (this.options.gfm) {
            rules.block = (0, $22a983b9ce46e66e$export$837bd02682cd3db9).gfm;
            if (this.options.breaks) rules.inline = (0, $22a983b9ce46e66e$export$18c8ad048e32c7d5).breaks;
            else rules.inline = (0, $22a983b9ce46e66e$export$18c8ad048e32c7d5).gfm;
        }
        this.tokenizer.rules = rules;
    }
    /**
   * Expose Rules
   */ static get rules() {
        return {
            block: $22a983b9ce46e66e$export$837bd02682cd3db9,
            inline: $22a983b9ce46e66e$export$18c8ad048e32c7d5
        };
    }
    /**
   * Static Lex Method
   */ static lex(src, options) {
        const lexer = new $6c0c5ccf54deec19$export$ff20f7639780cbb3(options);
        return lexer.lex(src);
    }
    /**
   * Static Lex Inline Method
   */ static lexInline(src, options) {
        const lexer = new $6c0c5ccf54deec19$export$ff20f7639780cbb3(options);
        return lexer.inlineTokens(src);
    }
    /**
   * Preprocessing
   */ lex(src) {
        src = src.replace((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).carriageReturn, '\n');
        this.blockTokens(src, this.tokens);
        for(let i = 0; i < this.inlineQueue.length; i++){
            const next = this.inlineQueue[i];
            this.inlineTokens(next.src, next.tokens);
        }
        this.inlineQueue = [];
        return this.tokens;
    }
    blockTokens(src, tokens = [], lastParagraphClipped = false) {
        if (this.options.pedantic) src = src.replace((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).tabCharGlobal, '    ').replace((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).spaceLine, '');
        while(src){
            let token;
            if (this.options.extensions?.block?.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            // newline
            if (token = this.tokenizer.space(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (token.raw.length === 1 && lastToken !== undefined) // if there's a single \n as a spacer, it's terminating the last line,
                // so move it there so that we don't get unnecessary paragraph tags
                lastToken.raw += '\n';
                else tokens.push(token);
                continue;
            }
            // code
            if (token = this.tokenizer.code(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                // An indented code block cannot interrupt a paragraph.
                if (lastToken?.type === 'paragraph' || lastToken?.type === 'text') {
                    lastToken.raw += (lastToken.raw.endsWith('\n') ? '' : '\n') + token.raw;
                    lastToken.text += '\n' + token.text;
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            // fences
            if (token = this.tokenizer.fences(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // heading
            if (token = this.tokenizer.heading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // hr
            if (token = this.tokenizer.hr(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // blockquote
            if (token = this.tokenizer.blockquote(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // list
            if (token = this.tokenizer.list(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // html
            if (token = this.tokenizer.html(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // def
            if (token = this.tokenizer.def(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === 'paragraph' || lastToken?.type === 'text') {
                    lastToken.raw += (lastToken.raw.endsWith('\n') ? '' : '\n') + token.raw;
                    lastToken.text += '\n' + token.raw;
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else if (!this.tokens.links[token.tag]) {
                    this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    tokens.push(token);
                }
                continue;
            }
            // table (gfm)
            if (token = this.tokenizer.table(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // lheading
            if (token = this.tokenizer.lheading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // top-level paragraph
            // prevent paragraph consuming extensions by clipping 'src' to extension start
            let cutSrc = src;
            if (this.options.extensions?.startBlock) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startBlock.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                const lastToken = tokens.at(-1);
                if (lastParagraphClipped && lastToken?.type === 'paragraph') {
                    lastToken.raw += (lastToken.raw.endsWith('\n') ? '' : '\n') + token.raw;
                    lastToken.text += '\n' + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                lastParagraphClipped = cutSrc.length !== src.length;
                src = src.substring(token.raw.length);
                continue;
            }
            // text
            if (token = this.tokenizer.text(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === 'text') {
                    lastToken.raw += (lastToken.raw.endsWith('\n') ? '' : '\n') + token.raw;
                    lastToken.text += '\n' + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        this.state.top = true;
        return tokens;
    }
    inline(src, tokens = []) {
        this.inlineQueue.push({
            src: src,
            tokens: tokens
        });
        return tokens;
    }
    /**
   * Lexing/Compiling
   */ inlineTokens(src, tokens = []) {
        // String with links masked to avoid interference with em and strong
        let maskedSrc = src;
        let match = null;
        // Mask out reflinks
        if (this.tokens.links) {
            const links = Object.keys(this.tokens.links);
            if (links.length > 0) {
                while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
        }
        // Mask out escaped characters
        while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
        // Mask out other blocks
        while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        let keepPrevChar = false;
        let prevChar = '';
        while(src){
            if (!keepPrevChar) prevChar = '';
            keepPrevChar = false;
            let token;
            // extensions
            if (this.options.extensions?.inline?.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            // escape
            if (token = this.tokenizer.escape(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // tag
            if (token = this.tokenizer.tag(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // link
            if (token = this.tokenizer.link(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // reflink, nolink
            if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (token.type === 'text' && lastToken?.type === 'text') {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            // em & strong
            if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // code
            if (token = this.tokenizer.codespan(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // br
            if (token = this.tokenizer.br(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // del (gfm)
            if (token = this.tokenizer.del(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // autolink
            if (token = this.tokenizer.autolink(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // url (gfm)
            if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // text
            // prevent inlineText consuming extensions by clipping 'src' to extension start
            let cutSrc = src;
            if (this.options.extensions?.startInline) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startInline.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (token = this.tokenizer.inlineText(cutSrc)) {
                src = src.substring(token.raw.length);
                if (token.raw.slice(-1) !== '_') // Track prevChar before string of ____ started
                prevChar = token.raw.slice(-1);
                keepPrevChar = true;
                const lastToken = tokens.at(-1);
                if (lastToken?.type === 'text') {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        return tokens;
    }
}






class $e59f42e62bb6677e$export$8c6749b5a7f1d893 {
    constructor(options){
        this.options = options || (0, $6f2e6174c8aeac93$export$3444e66eca2af284);
    }
    space(token) {
        return '';
    }
    code({ text: text, lang: lang, escaped: escaped }) {
        const langString = (lang || '').match((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).notSpaceStart)?.[0];
        const code = text.replace((0, $22a983b9ce46e66e$export$70a00e0a8474f72a).endingNewline, '') + '\n';
        if (!langString) return '<pre><code>' + (escaped ? code : (0, $6b22f7e70ed0fce9$export$4e7f196112fea3c5)(code, true)) + '</code></pre>\n';
        return '<pre><code class="language-' + (0, $6b22f7e70ed0fce9$export$4e7f196112fea3c5)(langString) + '">' + (escaped ? code : (0, $6b22f7e70ed0fce9$export$4e7f196112fea3c5)(code, true)) + '</code></pre>\n';
    }
    blockquote({ tokens: tokens }) {
        const body = this.parser.parse(tokens);
        return `<blockquote>\n${body}</blockquote>\n`;
    }
    html({ text: text }) {
        return text;
    }
    def(token) {
        return '';
    }
    heading({ tokens: tokens, depth: depth }) {
        return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>\n`;
    }
    hr(token) {
        return '<hr>\n';
    }
    list(token) {
        const ordered = token.ordered;
        const start = token.start;
        let body = '';
        for(let j = 0; j < token.items.length; j++){
            const item = token.items[j];
            body += this.listitem(item);
        }
        const type = ordered ? 'ol' : 'ul';
        const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : '';
        return '<' + type + startAttr + '>\n' + body + '</' + type + '>\n';
    }
    listitem(item) {
        let itemBody = '';
        if (item.task) {
            const checkbox = this.checkbox({
                checked: !!item.checked
            });
            if (item.loose) {
                if (item.tokens[0]?.type === 'paragraph') {
                    item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                    if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                        item.tokens[0].tokens[0].text = checkbox + ' ' + (0, $6b22f7e70ed0fce9$export$4e7f196112fea3c5)(item.tokens[0].tokens[0].text);
                        item.tokens[0].tokens[0].escaped = true;
                    }
                } else item.tokens.unshift({
                    type: 'text',
                    raw: checkbox + ' ',
                    text: checkbox + ' ',
                    escaped: true
                });
            } else itemBody += checkbox + ' ';
        }
        itemBody += this.parser.parse(item.tokens, !!item.loose);
        return `<li>${itemBody}</li>\n`;
    }
    checkbox({ checked: checked }) {
        return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox">';
    }
    paragraph({ tokens: tokens }) {
        return `<p>${this.parser.parseInline(tokens)}</p>\n`;
    }
    table(token) {
        let header = '';
        // header
        let cell = '';
        for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
        header += this.tablerow({
            text: cell
        });
        let body = '';
        for(let j = 0; j < token.rows.length; j++){
            const row = token.rows[j];
            cell = '';
            for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
            body += this.tablerow({
                text: cell
            });
        }
        if (body) body = `<tbody>${body}</tbody>`;
        return "<table>\n<thead>\n" + header + '</thead>\n' + body + '</table>\n';
    }
    tablerow({ text: text }) {
        return `<tr>\n${text}</tr>\n`;
    }
    tablecell(token) {
        const content = this.parser.parseInline(token.tokens);
        const type = token.header ? 'th' : 'td';
        const tag = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
        return tag + content + `</${type}>\n`;
    }
    /**
   * span level renderer
   */ strong({ tokens: tokens }) {
        return `<strong>${this.parser.parseInline(tokens)}</strong>`;
    }
    em({ tokens: tokens }) {
        return `<em>${this.parser.parseInline(tokens)}</em>`;
    }
    codespan({ text: text }) {
        return `<code>${(0, $6b22f7e70ed0fce9$export$4e7f196112fea3c5)(text, true)}</code>`;
    }
    br(token) {
        return '<br>';
    }
    del({ tokens: tokens }) {
        return `<del>${this.parser.parseInline(tokens)}</del>`;
    }
    link({ href: href, title: title, tokens: tokens }) {
        const text = this.parser.parseInline(tokens);
        const cleanHref = (0, $6b22f7e70ed0fce9$export$39cd5310d932e557)(href);
        if (cleanHref === null) return text;
        href = cleanHref;
        let out = '<a href="' + href + '"';
        if (title) out += ' title="' + (0, $6b22f7e70ed0fce9$export$4e7f196112fea3c5)(title) + '"';
        out += '>' + text + '</a>';
        return out;
    }
    image({ href: href, title: title, text: text, tokens: tokens }) {
        if (tokens) text = this.parser.parseInline(tokens, this.parser.textRenderer);
        const cleanHref = (0, $6b22f7e70ed0fce9$export$39cd5310d932e557)(href);
        if (cleanHref === null) return (0, $6b22f7e70ed0fce9$export$4e7f196112fea3c5)(text);
        href = cleanHref;
        let out = `<img src="${href}" alt="${text}"`;
        if (title) out += ` title="${(0, $6b22f7e70ed0fce9$export$4e7f196112fea3c5)(title)}"`;
        out += '>';
        return out;
    }
    text(token) {
        return 'tokens' in token && token.tokens ? this.parser.parseInline(token.tokens) : 'escaped' in token && token.escaped ? token.text : (0, $6b22f7e70ed0fce9$export$4e7f196112fea3c5)(token.text);
    }
}


class $8c9627ce06e70251$export$9762f21387b3386d {
    // no need for block level renderers
    strong({ text: text }) {
        return text;
    }
    em({ text: text }) {
        return text;
    }
    codespan({ text: text }) {
        return text;
    }
    del({ text: text }) {
        return text;
    }
    html({ text: text }) {
        return text;
    }
    text({ text: text }) {
        return text;
    }
    link({ text: text }) {
        return '' + text;
    }
    image({ text: text }) {
        return '' + text;
    }
    br() {
        return '';
    }
}


class $e0173af3088aa6ae$export$d3c1bfa0f7d806e9 {
    constructor(options){
        this.options = options || (0, $6f2e6174c8aeac93$export$3444e66eca2af284);
        this.options.renderer = this.options.renderer || new (0, $e59f42e62bb6677e$export$8c6749b5a7f1d893)();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.renderer.parser = this;
        this.textRenderer = new (0, $8c9627ce06e70251$export$9762f21387b3386d)();
    }
    /**
   * Static Parse Method
   */ static parse(tokens, options) {
        const parser = new $e0173af3088aa6ae$export$d3c1bfa0f7d806e9(options);
        return parser.parse(tokens);
    }
    /**
   * Static Parse Inline Method
   */ static parseInline(tokens, options) {
        const parser = new $e0173af3088aa6ae$export$d3c1bfa0f7d806e9(options);
        return parser.parseInline(tokens);
    }
    /**
   * Parse Loop
   */ parse(tokens, top = true) {
        let out = '';
        for(let i = 0; i < tokens.length; i++){
            const anyToken = tokens[i];
            // Run any renderer extensions
            if (this.options.extensions?.renderers?.[anyToken.type]) {
                const genericToken = anyToken;
                const ret = this.options.extensions.renderers[genericToken.type].call({
                    parser: this
                }, genericToken);
                if (ret !== false || ![
                    'space',
                    'hr',
                    'heading',
                    'code',
                    'table',
                    'blockquote',
                    'list',
                    'html',
                    'def',
                    'paragraph',
                    'text'
                ].includes(genericToken.type)) {
                    out += ret || '';
                    continue;
                }
            }
            const token = anyToken;
            switch(token.type){
                case 'space':
                    out += this.renderer.space(token);
                    continue;
                case 'hr':
                    out += this.renderer.hr(token);
                    continue;
                case 'heading':
                    out += this.renderer.heading(token);
                    continue;
                case 'code':
                    out += this.renderer.code(token);
                    continue;
                case 'table':
                    out += this.renderer.table(token);
                    continue;
                case 'blockquote':
                    out += this.renderer.blockquote(token);
                    continue;
                case 'list':
                    out += this.renderer.list(token);
                    continue;
                case 'html':
                    out += this.renderer.html(token);
                    continue;
                case 'def':
                    out += this.renderer.def(token);
                    continue;
                case 'paragraph':
                    out += this.renderer.paragraph(token);
                    continue;
                case 'text':
                    {
                        let textToken = token;
                        let body = this.renderer.text(textToken);
                        while(i + 1 < tokens.length && tokens[i + 1].type === 'text'){
                            textToken = tokens[++i];
                            body += '\n' + this.renderer.text(textToken);
                        }
                        if (top) out += this.renderer.paragraph({
                            type: 'paragraph',
                            raw: body,
                            text: body,
                            tokens: [
                                {
                                    type: 'text',
                                    raw: body,
                                    text: body,
                                    escaped: true
                                }
                            ]
                        });
                        else out += body;
                        continue;
                    }
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return '';
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
    /**
   * Parse Inline Tokens
   */ parseInline(tokens, renderer = this.renderer) {
        let out = '';
        for(let i = 0; i < tokens.length; i++){
            const anyToken = tokens[i];
            // Run any renderer extensions
            if (this.options.extensions?.renderers?.[anyToken.type]) {
                const ret = this.options.extensions.renderers[anyToken.type].call({
                    parser: this
                }, anyToken);
                if (ret !== false || ![
                    'escape',
                    'html',
                    'link',
                    'image',
                    'strong',
                    'em',
                    'codespan',
                    'br',
                    'del',
                    'text'
                ].includes(anyToken.type)) {
                    out += ret || '';
                    continue;
                }
            }
            const token = anyToken;
            switch(token.type){
                case 'escape':
                    out += renderer.text(token);
                    break;
                case 'html':
                    out += renderer.html(token);
                    break;
                case 'link':
                    out += renderer.link(token);
                    break;
                case 'image':
                    out += renderer.image(token);
                    break;
                case 'strong':
                    out += renderer.strong(token);
                    break;
                case 'em':
                    out += renderer.em(token);
                    break;
                case 'codespan':
                    out += renderer.codespan(token);
                    break;
                case 'br':
                    out += renderer.br(token);
                    break;
                case 'del':
                    out += renderer.del(token);
                    break;
                case 'text':
                    out += renderer.text(token);
                    break;
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return '';
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
}


class $696302000bc49fd3$export$6ab53e2237e2cbe5 {
    constructor(options){
        this.options = options || (0, $6f2e6174c8aeac93$export$3444e66eca2af284);
    }
    static{
        this.passThroughHooks = new Set([
            'preprocess',
            'postprocess',
            'processAllTokens'
        ]);
    }
    /**
   * Process markdown before marked
   */ preprocess(markdown) {
        return markdown;
    }
    /**
   * Process HTML after marked is finished
   */ postprocess(html) {
        return html;
    }
    /**
   * Process all tokens before walk tokens
   */ processAllTokens(tokens) {
        return tokens;
    }
    /**
   * Provide function to tokenize markdown
   */ provideLexer() {
        return this.block ? (0, $6c0c5ccf54deec19$export$ff20f7639780cbb3).lex : (0, $6c0c5ccf54deec19$export$ff20f7639780cbb3).lexInline;
    }
    /**
   * Provide function to parse tokens
   */ provideParser() {
        return this.block ? (0, $e0173af3088aa6ae$export$d3c1bfa0f7d806e9).parse : (0, $e0173af3088aa6ae$export$d3c1bfa0f7d806e9).parseInline;
    }
}










class $9e0d07d5ab5af1ef$export$164128c95a350e30 {
    constructor(...args){
        this.defaults = (0, $6f2e6174c8aeac93$export$4028cc7750e95339)();
        this.options = this.setOptions;
        this.parse = this.parseMarkdown(true);
        this.parseInline = this.parseMarkdown(false);
        this.Parser = (0, $e0173af3088aa6ae$export$d3c1bfa0f7d806e9);
        this.Renderer = (0, $e59f42e62bb6677e$export$8c6749b5a7f1d893);
        this.TextRenderer = (0, $8c9627ce06e70251$export$9762f21387b3386d);
        this.Lexer = (0, $6c0c5ccf54deec19$export$ff20f7639780cbb3);
        this.Tokenizer = (0, $c9a4fb86e2980742$export$13c4c5b7c8fc41f5);
        this.Hooks = (0, $696302000bc49fd3$export$6ab53e2237e2cbe5);
        this.use(...args);
    }
    /**
   * Run callback for every token
   */ walkTokens(tokens, callback) {
        let values = [];
        for (const token of tokens){
            values = values.concat(callback.call(this, token));
            switch(token.type){
                case 'table':
                    {
                        const tableToken = token;
                        for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                        for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                        break;
                    }
                case 'list':
                    {
                        const listToken = token;
                        values = values.concat(this.walkTokens(listToken.items, callback));
                        break;
                    }
                default:
                    {
                        const genericToken = token;
                        if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                            const tokens = genericToken[childTokens].flat(Infinity);
                            values = values.concat(this.walkTokens(tokens, callback));
                        });
                        else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                    }
            }
        }
        return values;
    }
    use(...args) {
        const extensions = this.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        args.forEach((pack)=>{
            // copy options to new object
            const opts = {
                ...pack
            };
            // set async to true if it was set to true before
            opts.async = this.defaults.async || opts.async || false;
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                pack.extensions.forEach((ext)=>{
                    if (!ext.name) throw new Error('extension name required');
                    if ('renderer' in ext) {
                        // Renderer extensions
                        const prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function(...args) {
                            let ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if ('tokenizer' in ext) {
                        // Tokenizer Extensions
                        if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') throw new Error("extension level must be 'block' or 'inline'");
                        const extLevel = extensions[ext.level];
                        if (extLevel) extLevel.unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            // Function to check for start of token
                            if (ext.level === 'block') {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === 'inline') {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if ('childTokens' in ext && ext.childTokens) // Child tokens to be visited by walkTokens
                    extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) {
                const renderer = this.defaults.renderer || new (0, $e59f42e62bb6677e$export$8c6749b5a7f1d893)(this.defaults);
                for(const prop in pack.renderer){
                    if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                    if ([
                        'options',
                        'parser'
                    ].includes(prop)) continue;
                    const rendererProp = prop;
                    const rendererFunc = pack.renderer[rendererProp];
                    const prevRenderer = renderer[rendererProp];
                    // Replace renderer with func to run extension, but fall back if false
                    renderer[rendererProp] = (...args)=>{
                        let ret = rendererFunc.apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret || '';
                    };
                }
                opts.renderer = renderer;
            }
            if (pack.tokenizer) {
                const tokenizer = this.defaults.tokenizer || new (0, $c9a4fb86e2980742$export$13c4c5b7c8fc41f5)(this.defaults);
                for(const prop in pack.tokenizer){
                    if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                    if ([
                        'options',
                        'rules',
                        'lexer'
                    ].includes(prop)) continue;
                    const tokenizerProp = prop;
                    const tokenizerFunc = pack.tokenizer[tokenizerProp];
                    const prevTokenizer = tokenizer[tokenizerProp];
                    // Replace tokenizer with func to run extension, but fall back if false
                    tokenizer[tokenizerProp] = (...args)=>{
                        let ret = tokenizerFunc.apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                }
                opts.tokenizer = tokenizer;
            }
            // ==-- Parse Hooks extensions --== //
            if (pack.hooks) {
                const hooks = this.defaults.hooks || new (0, $696302000bc49fd3$export$6ab53e2237e2cbe5)();
                for(const prop in pack.hooks){
                    if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                    if ([
                        'options',
                        'block'
                    ].includes(prop)) continue;
                    const hooksProp = prop;
                    const hooksFunc = pack.hooks[hooksProp];
                    const prevHook = hooks[hooksProp];
                    if ((0, $696302000bc49fd3$export$6ab53e2237e2cbe5).passThroughHooks.has(prop)) // @ts-expect-error cannot type hook function dynamically
                    hooks[hooksProp] = (arg)=>{
                        if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                            return prevHook.call(hooks, ret);
                        });
                        const ret = hooksFunc.call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[hooksProp] = (...args)=>{
                        let ret = hooksFunc.apply(hooks, args);
                        if (ret === false) ret = prevHook.apply(hooks, args);
                        return ret;
                    };
                }
                opts.hooks = hooks;
            }
            // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                const walkTokens = this.defaults.walkTokens;
                const packWalktokens = pack.walkTokens;
                opts.walkTokens = function(token) {
                    let values = [];
                    values.push(packWalktokens.call(this, token));
                    if (walkTokens) values = values.concat(walkTokens.call(this, token));
                    return values;
                };
            }
            this.defaults = {
                ...this.defaults,
                ...opts
            };
        });
        return this;
    }
    setOptions(opt) {
        this.defaults = {
            ...this.defaults,
            ...opt
        };
        return this;
    }
    lexer(src, options) {
        return (0, $6c0c5ccf54deec19$export$ff20f7639780cbb3).lex(src, options ?? this.defaults);
    }
    parser(tokens, options) {
        return (0, $e0173af3088aa6ae$export$d3c1bfa0f7d806e9).parse(tokens, options ?? this.defaults);
    }
    parseMarkdown(blockType) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const parse = (src, options)=>{
            const origOpt = {
                ...options
            };
            const opt = {
                ...this.defaults,
                ...origOpt
            };
            const throwError = this.onError(!!opt.silent, !!opt.async);
            // throw error if an extension set async to true but parse was called with async: false
            if (this.defaults.async === true && origOpt.async === false) return throwError(new Error('marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise.'));
            // throw error in case of non string input
            if (typeof src === 'undefined' || src === null) return throwError(new Error('marked(): input parameter is undefined or null'));
            if (typeof src !== 'string') return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
            if (opt.hooks) {
                opt.hooks.options = opt;
                opt.hooks.block = blockType;
            }
            const lexer = opt.hooks ? opt.hooks.provideLexer() : blockType ? (0, $6c0c5ccf54deec19$export$ff20f7639780cbb3).lex : (0, $6c0c5ccf54deec19$export$ff20f7639780cbb3).lexInline;
            const parser = opt.hooks ? opt.hooks.provideParser() : blockType ? (0, $e0173af3088aa6ae$export$d3c1bfa0f7d806e9).parse : (0, $e0173af3088aa6ae$export$d3c1bfa0f7d806e9).parseInline;
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                let tokens = lexer(src, opt);
                if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                let html = parser(tokens, opt);
                if (opt.hooks) html = opt.hooks.postprocess(html);
                return html;
            } catch (e) {
                return throwError(e);
            }
        };
        return parse;
    }
    onError(silent, async) {
        return (e)=>{
            e.message += '\nPlease report this to https://github.com/markedjs/marked.';
            if (silent) {
                const msg = '<p>An error occurred:</p><pre>' + (0, $6b22f7e70ed0fce9$export$4e7f196112fea3c5)(e.message + '', true) + '</pre>';
                if (async) return Promise.resolve(msg);
                return msg;
            }
            if (async) return Promise.reject(e);
            throw e;
        };
    }
}







const $e03c11f58c6f88b7$var$markedInstance = new (0, $9e0d07d5ab5af1ef$export$164128c95a350e30)();
function $e03c11f58c6f88b7$export$db8f131360c543a5(src, opt) {
    return $e03c11f58c6f88b7$var$markedInstance.parse(src, opt);
}
/**
 * Sets the default options.
 *
 * @param options Hash of options
 */ $e03c11f58c6f88b7$export$db8f131360c543a5.options = $e03c11f58c6f88b7$export$db8f131360c543a5.setOptions = function(options) {
    $e03c11f58c6f88b7$var$markedInstance.setOptions(options);
    $e03c11f58c6f88b7$export$db8f131360c543a5.defaults = $e03c11f58c6f88b7$var$markedInstance.defaults;
    (0, $6f2e6174c8aeac93$export$ca64cf607b16025d)($e03c11f58c6f88b7$export$db8f131360c543a5.defaults);
    return $e03c11f58c6f88b7$export$db8f131360c543a5;
};
/**
 * Gets the original marked default options.
 */ $e03c11f58c6f88b7$export$db8f131360c543a5.getDefaults = (0, $6f2e6174c8aeac93$export$4028cc7750e95339);
$e03c11f58c6f88b7$export$db8f131360c543a5.defaults = (0, $6f2e6174c8aeac93$export$3444e66eca2af284);
/**
 * Use Extension
 */ $e03c11f58c6f88b7$export$db8f131360c543a5.use = function(...args) {
    $e03c11f58c6f88b7$var$markedInstance.use(...args);
    $e03c11f58c6f88b7$export$db8f131360c543a5.defaults = $e03c11f58c6f88b7$var$markedInstance.defaults;
    (0, $6f2e6174c8aeac93$export$ca64cf607b16025d)($e03c11f58c6f88b7$export$db8f131360c543a5.defaults);
    return $e03c11f58c6f88b7$export$db8f131360c543a5;
};
/**
 * Run callback for every token
 */ $e03c11f58c6f88b7$export$db8f131360c543a5.walkTokens = function(tokens, callback) {
    return $e03c11f58c6f88b7$var$markedInstance.walkTokens(tokens, callback);
};
/**
 * Compiles markdown to HTML without enclosing `p` tag.
 *
 * @param src String of markdown source to be compiled
 * @param options Hash of options
 * @return String of compiled HTML
 */ $e03c11f58c6f88b7$export$db8f131360c543a5.parseInline = $e03c11f58c6f88b7$var$markedInstance.parseInline;
/**
 * Expose
 */ $e03c11f58c6f88b7$export$db8f131360c543a5.Parser = (0, $e0173af3088aa6ae$export$d3c1bfa0f7d806e9);
$e03c11f58c6f88b7$export$db8f131360c543a5.parser = (0, $e0173af3088aa6ae$export$d3c1bfa0f7d806e9).parse;
$e03c11f58c6f88b7$export$db8f131360c543a5.Renderer = (0, $e59f42e62bb6677e$export$8c6749b5a7f1d893);
$e03c11f58c6f88b7$export$db8f131360c543a5.TextRenderer = (0, $8c9627ce06e70251$export$9762f21387b3386d);
$e03c11f58c6f88b7$export$db8f131360c543a5.Lexer = (0, $6c0c5ccf54deec19$export$ff20f7639780cbb3);
$e03c11f58c6f88b7$export$db8f131360c543a5.lexer = (0, $6c0c5ccf54deec19$export$ff20f7639780cbb3).lex;
$e03c11f58c6f88b7$export$db8f131360c543a5.Tokenizer = (0, $c9a4fb86e2980742$export$13c4c5b7c8fc41f5);
$e03c11f58c6f88b7$export$db8f131360c543a5.Hooks = (0, $696302000bc49fd3$export$6ab53e2237e2cbe5);
$e03c11f58c6f88b7$export$db8f131360c543a5.parse = $e03c11f58c6f88b7$export$db8f131360c543a5;
const $e03c11f58c6f88b7$export$41c562ebe57d11e2 = $e03c11f58c6f88b7$export$db8f131360c543a5.options;
const $e03c11f58c6f88b7$export$add91eafeaeab287 = $e03c11f58c6f88b7$export$db8f131360c543a5.setOptions;
const $e03c11f58c6f88b7$export$1f96ae73734a86cc = $e03c11f58c6f88b7$export$db8f131360c543a5.use;
const $e03c11f58c6f88b7$export$3eedd5437d43cb76 = $e03c11f58c6f88b7$export$db8f131360c543a5.walkTokens;
const $e03c11f58c6f88b7$export$c7679c2b5e355e6f = $e03c11f58c6f88b7$export$db8f131360c543a5.parseInline;
const $e03c11f58c6f88b7$export$98e6a39c04603d36 = $e03c11f58c6f88b7$export$db8f131360c543a5;
const $e03c11f58c6f88b7$export$8f49e4af10703ce3 = (0, $e0173af3088aa6ae$export$d3c1bfa0f7d806e9).parse;
const $e03c11f58c6f88b7$export$43feed32102720d2 = (0, $6c0c5ccf54deec19$export$ff20f7639780cbb3).lex;




class $656e4a2407cb8d72$export$ebc388bf5eb63689 {
    highlightElements(tags) {
        return [].forEach.call(tags, (code)=>{
            if (code.className) Prism.highlightElement(code);
        });
    }
    readAndCompile(text) {
        const html = `<div part="content" class="content" #contentReference>
      ${(0, $e03c11f58c6f88b7$export$db8f131360c543a5)(text, {
            renderer: this.renderer
        })}
    </div>`;
        return html + '\n';
    }
    async fetchMarkdown(link) {
        const res = await fetch(link);
        if (res.status !== 200) throw new Error(`Unable to load markdown status is ${res.status}`);
        const text = await res.text();
        return this.readAndCompile(text);
    }
    constructor(){
        this.renderer = new (0, $e59f42e62bb6677e$export$8c6749b5a7f1d893)();
    }
}
$656e4a2407cb8d72$export$ebc388bf5eb63689 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)()
], $656e4a2407cb8d72$export$ebc388bf5eb63689);



var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");


var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");

var $jS6MW = parcelRequire("jS6MW");
class $a88ce2da5c0698f3$export$5547599b96c72968 {
    setItems(items) {
        this.menu.next(items);
    }
    clearMenu() {
        this.menu.next([]);
    }
    addItem(item) {
        this.menu.next([
            ...this.menu.getValue(),
            item
        ]);
    }
    lookupHeadings(contentReference) {
        if (!contentReference) return;
        const headings = contentReference.querySelectorAll('h3, h4');
        const removeAnchor = (text)=>{
            const anchorId = text && text.indexOf('#');
            return anchorId >= 0 ? text.slice(0, anchorId) : text;
        };
        const heads = Array.from(headings).map((item)=>({
                offsetTop: item.offsetTop,
                textContent: removeAnchor(item.textContent),
                elementRef: item
            }));
        if (heads && heads.length) {
            const index = this.findCurrentHeading(headings);
            this.setItems([
                ...heads.map((e)=>({
                        elementRef: e.elementRef,
                        title: e.textContent
                    }))
            ]);
            if (index > 0) this.navigateToAnchor(heads[index].elementRef);
        }
    }
    findCurrentHeading(headings) {
        const marginOffset = 15;
        for(let i = 0; i < headings.length; i++){
            if (headings.length - 1 === i) return this.activeId = i;
            else if (headings[i + 1].offsetTop >= window.pageYOffset + this.scrollTopOffset + marginOffset) return this.activeId = i;
        }
    }
    navigateToAnchor(elementRef) {
        if (elementRef) window.scroll({
            top: elementRef.offsetTop - 100,
            behavior: 'smooth'
        });
    }
    constructor(){
        this.menu = new (0, $jS6MW.BehaviorSubject)([]);
        this.scrollTopOffset = 100;
    }
}
$a88ce2da5c0698f3$export$5547599b96c72968 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Injectable)()
], $a88ce2da5c0698f3$export$5547599b96c72968);



var $eG1Pq = parcelRequire("eG1Pq");
const $1c4c7dfa18937b7f$export$1d567c320f4763bc = (0, $eG1Pq.css)`
  .content h1 {
    font-size: 35px;
    font-weight: bold;
    margin-top: 30px;
  }
  .content h2 {
    font-size: 30px;
    font-weight: 500;
    margin-top: 25px;
  }
  .content h3 {
    font-size: 25px;
    font-weight: 500;
    margin-top: 20px;
  }
  p code {
    color: #2c3e5c !important;
  }
  .container {
    margin: 50px auto;
    width: 80%;
  }

  .filename {
    background: #151515;
    color: #fff;
    padding: 12px 30px;
    margin: 35px 0 -35px;
    display: block;
    min-height: 25px;
    position: relative;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
    font-size: 15px;
  }
  .language-yml {
    color: #930404 !important;
  }
  .filename + pre[class*='language-'],
  .hide + pre[class*='language-'],
  .filename + div + pre[class*='language-'],
  .hide + div + pre[class*='language-'] {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  code {
    font-family: Inconsolata, Consolas, 'Courier New', monospace;
    padding: 2px 6px;
    color: #2876d2;
    border-radius: 4px;
    font-size: 15px;
    white-space: pre-wrap;
    background: #f0f2f3;
  }
  /* pre {
  box-shadow: 0 5px 55px rgba(162, 162, 162, 0.25),
   0 10px 10px rgba(0, 0, 0, 0.22);
 } */
  pre {
    box-shadow: 0px 0px 3px rgba(162, 162, 162, 0.55);
  }
  pre code[class*='language-sh'] {
    color: #24292e;
  }
  .code-label {
    position: relative;

    margin-bottom: -24px;
    padding: 12px 24px;
    border-radius: 10px 10px 0px 0px;
    background-color: var(--primary-color);
    color: rgb(255, 255, 255);
    font-size: 16px;
    text-transform: capitalize;
    display: flex;
    place-content: stretch space-between;
  }
  .language-graphql {
    color: var(--parser-language-graphql, #444573) !important;
    font-size: 16px !important;
    line-height: 24px !important;
    user-select: text;
  }

  .language-graphql::selection {
    color: white;
    background: var(--parser-language-graphql, #444573);
  }
  .graphql {
    background: #f4f7fa !important;
    border-radius: 30px !important;
    margin: 0 !important;
    padding: 15px 30px 26px !important;
  }
  h6 {
    position: relative;
    z-index: 3;
    margin-bottom: -24px;
    padding: 12px 24px;
    border-radius: 10px 10px 0 0;
    background-color: #2a2b56;
    color: #fff;
    font-size: 16px;
  }

  pre[class*='language-sh'] {
    background: #f6f8fa;
  }
  code[class*='language-'],
  pre[class*='language-'] {
    letter-spacing: normal;
    color: #060607;
    background: none;
    font-family: Inconsolata, Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: 25px;
    font-size: 16px;
    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;
    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
  }
  @media print {
    code[class*='language-'],
    pre[class*='language-'] {
      text-shadow: none;
    }
  }
  pre[class*='language-'],
  :not(pre) > code[class*='language-'] {
    background: rgb(255 255 255);
    border-radius: 6px;
  }
  /* Code blocks */
  pre[class*='language-'] {
    padding: 30px;
    margin-bottom: 30px;
    margin-top: 20px;
    overflow: auto;
    border: 0;
  }
  /* Inline code */
  :not(pre) > code[class*='language-'] {
    padding: 0.15em 0.2em 0.05em;
    border-radius: 0.3em;
    border: 0.13em solid #7a6652;
    white-space: normal;
  }
  .token.comment,
  .token.prolog,
  .token.doctype,
  .token.cdata {
    color: #7a8186;
  }
  .token.punctuation {
    opacity: 0.7;
  }
  .namespace {
    opacity: 0.7;
  }
  .token.property,
  .token.tag,
  .token.boolean,
  .token.number,
  .token.constant,
  .token.symbol {
    color: #ffc093;
  }
  .language-html .tag {
    color: #2f74d0;
  }
  .language-html .punctuation {
    color: black;
  }
  .token.selector,
  .token.attr-name,
  .token.string,
  .token.char,
  .token.builtin,
  .token.inserted {
    color: #3594e2;
  }
  .token.entity,
  .token.url,
  .language-css .token.string,
  .style .token.string,
  .token.variable {
    color: #caffa8;
  }
  .token.function,
  .token.operator {
    color: #36a3b9;
  }
  .token.atrule,
  .token.attr-value,
  .token.keyword {
    color: #b32f82;
  }
  .token.regex,
  .token.important {
    color: #e90;
  }
  .token.important,
  .token.bold {
    font-weight: bold;
  }
  .token.italic {
    font-style: italic;
  }
  .token.entity {
    cursor: help;
  }
  .token.deleted {
    color: red;
  }
  div.prism-show-language {
    position: relative;
  }
  div.prism-show-language > div.prism-show-language-label {
    background: var(--primary-color);
    color: white;
    font-weight: 500;
  }
  .copy-icon {
    display: grid;
    align-content: center;
    cursor: pointer;
  }
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .transition {
    -webkit-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  .transition-fast {
    -webkit-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  .transition-slow {
    -webkit-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  /* CLEARFIX */
  .clearfix {
    *zoom: 1;
  }
  .clearfix:before,
  .clearfix:after {
    content: ' ';
    display: table;
  }
  .clearfix:after {
    clear: both;
  }
  .center-element {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    -o-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
  .center-left {
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  .center-top {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .box-sizing {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  html,
  body {
    width: 100%;
  }
  a {
    text-decoration: none;
  }
  *:focus {
    outline: none;
  }
  /* Main Layout */
  .bg {
    background-image: linear-gradient(#1c1f24, #24292f);
  }
  .bg.context {
    background-color: #21262c;
  }
  .version-labels {
    background-color: #6f42be;
  }
  .version-labels.new {
    background-color: #33a743;
  }
  .version-labels.new {
    background-color: #2767d7;
  }
  .version-labels .sha {
    background-color: #554888;
  }
  ul {
    /* border-left: 1px solid #303539;
  list-style-type: none; */
    border-left: 8px solid rgb(55 188 152);
    list-style-type: none;
    background: white;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 30px;
    /* padding-left: 10px; */
  }

  ul li {
    list-style-type: disc;
  }
  ol > li::marker {
    font-weight: bold;
  }

  ol {
    margin-left: 16px;
  }

  /* Hack */
  /*  ol > li {
  margin: 0;
  padding: 0 0 0 2em;
  text-indent: -2em;
  list-style-type: none;
  counter-increment: item;
 }
 ol > li:before {
  display: inline-block;
  width: 1.5em;
  padding-right: 0.5em;
  font-weight: bold;
  text-align: right;
  content: counter(item) '.';
 } */
  /* Hack */
  li {
    padding-bottom: 5px;
    list-style-type: decimal;
  }
  li p {
    margin: 10px;
  }
  .suggestion-label {
    background-color: #2766d6;
  }
  .flex {
    display: flex;
  }
  .spacer {
    flex: 1 3 auto;
  }
  .pointer {
    cursor: pointer;
  }
  .center {
    text-align: center;
  }
  a {
    text-decoration: none;
    color: #0894e2;
  }
  strong {
    font-weight: 600;
  }
  hr {
    width: 100%;
    height: 4px;
    background: #37a5bc;
    border: 0;
    margin: 50px 0;
  }
  h4 {
    font-size: 20px;
  }
  blockquote {
    line-height: 1.6;
    position: relative;
    margin: 35px 0;
    background: #f9eff1;
    padding: 20px;
  }
  blockquote::before {
    height: 100%;
    width: 5px;
    content: '';
    background: #37a5bc;
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
  }
  blockquote strong {
    color: #37a5bc;
  }
  blockquote strong:first-of-type {
    display: block;
    text-transform: uppercase;
    font-size: 15px;
    font-weight: bold;
  }
  blockquote.warning {
    background: rgb(255 255 255);
  }
  /* blockquote.warning::before { */
  /* background: #ffb36f; */
  /* } */
  blockquote.warning strong,
  blockquote.warning a {
    color: #ed8529;
  }
  blockquote.info {
    background: rgba(8, 148, 226, 0.038);
  }
  blockquote.info::before {
    background: #0894e2;
  }
  blockquote.info strong,
  blockquote.info a {
    color: #0894e2;
  }
  figure {
    margin: 60px 30px;
    text-align: center;
  }
  @media only screen and (max-width: 767px) {
    figure {
      margin: 60px 0;
    }
  }
  figure img {
    max-width: 100%;
    height: auto;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.08);
  }
  figcaption {
    color: rgba(243, 245, 247, 0.9);
    font-size: 16px;
    margin: 20px 0;
  }
  figcaption p {
    font-size: 16px;
  }
  table {
    width: 100%;
    margin: 40px 0;
  }
  @media only screen and (max-width: 767px) {
    tr {
      margin-bottom: 20px;
      /* display: block; */
    }
    tr:last-of-type {
      margin-bottom: 0;
    }
  }
  th {
    padding: 20px;
    background: #efefef;
  }
  tr:nth-of-type(even) td {
    background: rgb(64 113 191 / 5%);
  }
  tr:nth-of-type(odd) td:first-of-type {
    border-right: 1px solid #f0f2f3;
  }
  @media only screen and (max-width: 767px) {
    tr:nth-of-type(odd) td:first-of-type {
      border-right: 0;
      border-bottom: 1px solid #f0f2f3;
    }
  }
  tr:nth-of-type(even) td:first-of-type {
    border-right: 1px solid #fff;
  }
  @media only screen and (max-width: 767px) {
    tr:nth-of-type(even) td:first-of-type {
      border-right: 0;
      border-bottom: 1px solid #fff;
    }
  }
  tr td {
    padding: 20px 30px;
    vertical-align: top;
  }
  @media only screen and (max-width: 767px) {
    tr td {
      padding: 20px;
    }
  }
  .file-tree {
    background: #f9f9f9;
    border: 4px solid #f5f5f5;
    margin: 40px 0;
    padding: 16px 32px;
  }
  .file-tree .item {
    display: block;
    line-height: 32px;
    font-size: 15px;
    color: #5a5a5a;
  }
  .file-tree .children {
    padding-left: 30px;
    position: relative;
    overflow: hidden;
  }
  .file-tree .children .item {
    position: relative;
  }
  .file-tree .children .item:before {
    content: '';
    left: -18px;
    bottom: 16px;
    width: 16px;
    height: 9999px;
    position: absolute;
    border-width: 0 0 1px 1px;
    border-style: solid;
    border-color: #dbdbdb;
    border-radius: 0 0 0 3px;
  }
  .external {
    background: #f7f7f7;
  }
  .external::before {
    background: #e8e8e8;
  }
  .ps > .ps__scrollbar-y-rail {
    width: 10px;
  }
  .ps:hover > .ps__scrollbar-y-rail > .ps__scrollbar-y,
  .ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y,
  .ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y {
    width: 6px !important;
    background: #151515;
  }
  .ps > .ps__scrollbar-y-rail > .ps__scrollbar-y {
    border-radius: 0;
    -webkit-border-radius: 0;
  }
  .hide {
    display: none !important;
  }
  /*
   * Container style
   */
  .ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
  }
  /*
   * Scrollbar rail styles
   */
  .ps__rail-x {
    display: none;
    opacity: 0;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
    height: 15px;
    /* there must be 'bottom' or 'top' for ps__rail-x */
    bottom: 0px;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps__rail-y {
    display: none;
    opacity: 0;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
    width: 15px;
    /* there must be 'right' or 'left' for ps__rail-y */
    right: 0;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps--active-x > .ps__rail-x,
  .ps--active-y > .ps__rail-y {
    display: block;
    background-color: transparent;
  }
  .ps:hover > .ps__rail-x,
  .ps:hover > .ps__rail-y,
  .ps--focus > .ps__rail-x,
  .ps--focus > .ps__rail-y,
  .ps--scrolling-x > .ps__rail-x,
  .ps--scrolling-y > .ps__rail-y {
    opacity: 0.6;
  }
  .ps__rail-x:hover,
  .ps__rail-y:hover,
  .ps__rail-x:focus,
  .ps__rail-y:focus {
    background-color: #eee;
    opacity: 0.9;
  }
  /*
   * Scrollbar thumb styles
   */
  .ps__thumb-x {
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color 0.2s linear, height 0.2s ease-in-out;
    -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;
    height: 6px;
    /* there must be 'bottom' for ps__thumb-x */
    bottom: 2px;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps__thumb-y {
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color 0.2s linear, width 0.2s ease-in-out;
    -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
    width: 6px;
    /* there must be 'right' for ps__thumb-y */
    right: 2px;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps__rail-x:hover > .ps__thumb-x,
  .ps__rail-x:focus > .ps__thumb-x {
    background-color: #999;
    height: 11px;
  }
  .ps__rail-y:hover > .ps__thumb-y,
  .ps__rail-y:focus > .ps__thumb-y {
    background-color: #999;
    width: 11px;
  }
  /* MS supports */
  @supports (-ms-overflow-style: none) {
    .ps {
      overflow: auto !important;
    }
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .ps {
      overflow: auto !important;
    }
  }
  /*
   TODO: Remove important flags after this bug if fixed:
   https://github.com/angular/flex-layout/issues/381
   */
  perfect-scrollbar {
    position: relative;
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    /* stylelint-disable */
    /* stylelint-enable */
  }
  perfect-scrollbar[hidden] {
    display: none;
  }
  perfect-scrollbar[fxflex] {
    display: flex;
    flex-direction: column;
    -webkit-box-orient: column;
    -webkit-box-direction: column;
    height: auto;
    min-width: 0;
    min-height: 0;
  }
  perfect-scrollbar[fxflex] > .ps {
    flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    -webkit-box-flex: 1;
    width: auto;
    height: auto;
    min-width: 0;
    min-height: 0;
  }
  perfect-scrollbar[fxlayout] > .ps,
  perfect-scrollbar[fxlayout] > .ps > .ps-content {
    display: flex;
    flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    -webkit-box-flex: 1;
    /* align-item: inherit; */
    place-content: inherit;
    -webkit-box-pack: inherit;
    -webkit-box-align: inherit;
    flex-direction: inherit;
    -webkit-box-orient: inherit;
    -webkit-box-direction: inherit;
    width: 100%;
    height: 100%;
  }
  perfect-scrollbar[fxlayout='row'] > .ps,
  perfect-scrollbar[fxlayout='row'] > .ps > .ps-content {
    flex-direction: row !important;
    -webkit-box-orient: row !important;
    -webkit-box-direction: row !important;
  }
  perfect-scrollbar[fxlayout='column'] > .ps,
  perfect-scrollbar[fxlayout='column'] > .ps > .ps-content {
    flex-direction: column !important;
    -webkit-box-orient: column !important;
    -webkit-box-direction: column !important;
  }
  perfect-scrollbar > .ps {
    position: static;
    display: block;
    width: inherit;
    height: inherit;
    max-width: inherit;
    max-height: inherit;
  }
  perfect-scrollbar > .ps > .ps-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    overflow: hidden;
    pointer-events: none;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-top,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-left,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-right,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-bottom {
    position: absolute;
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-top,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-bottom {
    left: 0;
    min-width: 100%;
    min-height: 24px;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-left,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-right {
    top: 0;
    min-width: 24px;
    min-height: 100%;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-top {
    top: 0;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-left {
    left: 0;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-right {
    right: 0;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-bottom {
    bottom: 0;
  }
  perfect-scrollbar > .ps.ps--active-y > .ps__rail-y {
    top: 0 !important;
    right: 0 !important;
    width: 10px;
    cursor: default;
    transition: width 200ms linear, opacity 200ms linear, background-color 200ms linear;
  }
  perfect-scrollbar > .ps.ps--active-y > .ps__rail-y:hover {
    width: 15px;
  }
  perfect-scrollbar > .ps.ps--active-x > .ps__rail-x {
    bottom: 0 !important;
    left: 0 !important;
    height: 10px;
    cursor: default;
    transition: height 200ms linear, opacity 200ms linear, background-color 200ms linear;
  }
  perfect-scrollbar > .ps.ps--active-x > .ps__rail-x:hover {
    height: 15px;
  }
  perfect-scrollbar > .ps.ps--active-x.ps--active-y > .ps__rail-y {
    margin: 0 0 10px;
  }
  perfect-scrollbar > .ps.ps--active-x.ps--active-y > .ps__rail-x {
    margin: 0 10px 0 0;
  }
  perfect-scrollbar > .ps.ps--scrolling-y > .ps__rail-y {
    opacity: 0.9;
    background-color: #eee;
  }
  perfect-scrollbar > .ps.ps--scrolling-x > .ps__rail-x {
    opacity: 0.9;
    background-color: #eee;
  }
  perfect-scrollbar.ps-show-always > .ps.ps--active-y > .ps__rail-y {
    opacity: 0.6;
  }
  perfect-scrollbar.ps-show-always > .ps.ps--active-x > .ps__rail-x {
    opacity: 0.6;
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-y > .ps-overlay:not(.ps-at-top) .ps-indicator-top {
    opacity: 1;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-y > .ps-overlay:not(.ps-at-bottom) .ps-indicator-bottom {
    opacity: 1;
    background: linear-gradient(to top, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-x > .ps-overlay:not(.ps-at-left) .ps-indicator-left {
    opacity: 1;
    background: linear-gradient(to right, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-x > .ps-overlay:not(.ps-at-right) .ps-indicator-right {
    opacity: 1;
    background: linear-gradient(to left, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-y > .ps-overlay.ps-at-top .ps-indicator-top {
    background: linear-gradient(to bottom, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-y
    > .ps-overlay.ps-at-top
    .ps-indicator-top.ps-indicator-show {
    opacity: 1;
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-y > .ps-overlay.ps-at-bottom .ps-indicator-bottom {
    background: linear-gradient(to top, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-y
    > .ps-overlay.ps-at-bottom
    .ps-indicator-bottom.ps-indicator-show {
    opacity: 1;
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-x > .ps-overlay.ps-at-left .ps-indicator-left {
    background: linear-gradient(to right, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-x
    > .ps-overlay.ps-at-left
    .ps-indicator-left.ps-indicator-show {
    opacity: 1;
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-x > .ps-overlay.ps-at-right .ps-indicator-right {
    background: linear-gradient(to left, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-x
    > .ps-overlay.ps-at-right
    .ps-indicator-right.ps-indicator-show {
    opacity: 1;
  }
  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
  }
  .lds-ellipsis div {
    position: absolute;
    top: 27px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 6px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 6px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 26px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 45px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(19px, 0);
    }
  }

  @media screen and (max-width: 600px) {
    .container {
      width: 100%;
    }
    /* .content {
      padding-left: 10px;
      padding-right: 10px;
    } */

    code[class*='language-'] {
      font-size: 11px;
    }
  }
  table {
    width: 100%;
    border-collapse: collapse;
    overflow-x: auto;
    display: block; /* allows horizontal scroll */
  }

  th,
  td {
    padding: 10px;
    /* border: 1px solid #ddd; */
    text-align: left;
  }

  th {
    background: var(--primary-color);
    color: white;
    font-weight: bold;
    padding: 20px 30px;
    vertical-align: top;
  }

  tr:nth-child(even) {
    background: #fafafa;
  }

  ul > li > ul {
    border-left: none;
  }

  ul > li > ul > li {
    list-style-type: circle;
  }
  /* table thead tr th strong {
    margin-left: 20px;
  } */
`;


class $2c0f050551656244$export$2c172a09ed8d37d3 extends (0, $eG1Pq.LitElement) {
    OnUpdate() {
        this.mdParser.highlightElements(this.tags);
        this.mdParserMenu.lookupHeadings(this.shadowRoot);
    }
    compileMarkdown(template) {
        return this.mdParser.readAndCompile(template);
    }
}
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)()
], $2c0f050551656244$export$2c172a09ed8d37d3.prototype, "template", void 0);
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $656e4a2407cb8d72$export$ebc388bf5eb63689))
], $2c0f050551656244$export$2c172a09ed8d37d3.prototype, "mdParser", void 0);
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $a88ce2da5c0698f3$export$5547599b96c72968))
], $2c0f050551656244$export$2c172a09ed8d37d3.prototype, "mdParserMenu", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.queryAll)('code')
], $2c0f050551656244$export$2c172a09ed8d37d3.prototype, "tags", void 0);
$2c0f050551656244$export$2c172a09ed8d37d3 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'markdown-reader',
        style: $1c4c7dfa18937b7f$export$1d567c320f4763bc,
        template () {
            return (0, $eG1Pq.html)` ${(0, $eG1Pq.unsafeHTML)(this.compileMarkdown(this.template))} `;
        }
    })
], $2c0f050551656244$export$2c172a09ed8d37d3);




var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");

var $dY50F = parcelRequire("dY50F");
var $3XkaH = parcelRequire("3XkaH");


var $eG1Pq = parcelRequire("eG1Pq");
const $6f2b206a4d204467$export$1d567c320f4763bc = (0, $eG1Pq.css)`
  .transition {
    -webkit-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  .transition-fast {
    -webkit-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  .transition-slow {
    -webkit-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  /* CLEARFIX */
  .clearfix {
    *zoom: 1;
  }
  .clearfix:before,
  .clearfix:after {
    content: ' ';
    display: table;
  }
  .clearfix:after {
    clear: both;
  }
  .center-element {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    -o-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
  .center-left {
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  .center-top {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .box-sizing {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .toc-wrapper {
    width: 250px;
    padding-left: 32px;
    box-sizing: border-box;
    position: fixed;
    top: 65px;
    right: 0px;
    background-color: rgba(34, 39, 44, 0.9);
    border-radius: 10px;
    z-index: 1001;
  }
  .toc-wrapper ul {
    position: relative;
    padding: 0;
  }
  .toc-wrapper ul::before {
    content: '';
    position: absolute;
    left: 0;
    top: 10px;
    bottom: 10px;
    width: 2px;
    background: #efefef;
  }
  .toc-wrapper li {
    display: block;
    position: relative;
    padding-left: 30px;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 6px;
    cursor: pointer;
  }
  .toc-wrapper li:hover {
    color: #37a5bc;
  }
  .toc-wrapper .current {
    color: #37a5bc;
    font-weight: 600;
  }
  .toc-wrapper .current::before {
    background: #37a5bc;
    border-color: #37a5bc;
    border-width: 1px;
    left: -3px;
  }
  .toc-wrapper li::before {
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -moz-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    content: '';
    background: #fdfdfd;
    border: 2px solid #efefef;
    left: -4px;
    width: 6px;
    height: 6px;
    top: 50%;
    display: inline-block;
    position: absolute;
  }
  .toc-wrapper li:last-of-type::before {
    top: auto;
    bottom: 0;
  }
`;


class $f408db5f8ccb46f0$export$ffc1366d10787ec1 extends (0, $eG1Pq.LitElement) {
    OnInit() {
        this.menus = this.menuProvider.menu.pipe((0, $dY50F.filter)(()=>!!this.opened), (0, $3XkaH.map)((menus)=>this.createMenusTemplate(menus)));
    }
    clickAnchor(element) {
        this.menuProvider.navigateToAnchor(element);
    }
    createMenusTemplate(menus) {
        return (0, $eG1Pq.html)` ${menus.map((i)=>this.createSingleItem(i))} `;
    }
    createSingleItem(item) {
        return (0, $eG1Pq.html)` <li @click=${()=>this.clickAnchor(item.elementRef)}>${item.title}</li> `;
    }
    constructor(...args){
        super(...args), this.opened = true;
    }
}
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        type: Boolean
    })
], $f408db5f8ccb46f0$export$ffc1366d10787ec1.prototype, "opened", void 0);
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $a88ce2da5c0698f3$export$5547599b96c72968))
], $f408db5f8ccb46f0$export$ffc1366d10787ec1.prototype, "menuProvider", void 0);
$f408db5f8ccb46f0$export$ffc1366d10787ec1 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'toc-component',
        style: $6f2b206a4d204467$export$1d567c320f4763bc,
        template () {
            return (0, $eG1Pq.html)`
      <div class="toc-wrapper">
        <ul>
          ${(0, $eG1Pq.async)(this.menus)}
        </ul>
      </div>
    `;
        }
    })
], $f408db5f8ccb46f0$export$ffc1366d10787ec1);


class $8c4c26ff2319a8ee$export$790b57dd09b9e192 {
}
$8c4c26ff2319a8ee$export$790b57dd09b9e192 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Module)({
        components: [
            (0, $f408db5f8ccb46f0$export$ffc1366d10787ec1),
            (0, $2c0f050551656244$export$2c172a09ed8d37d3)
        ],
        providers: [
            (0, $656e4a2407cb8d72$export$ebc388bf5eb63689),
            (0, $a88ce2da5c0698f3$export$5547599b96c72968)
        ]
    })
], $8c4c26ff2319a8ee$export$790b57dd09b9e192);













var $g0n63 = parcelRequire("g0n63");
parcelRequire("rc2P5");
var $7fUEc = parcelRequire("7fUEc");

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");

var $dY50F = parcelRequire("dY50F");
var $jqXHu = parcelRequire("jqXHu");

var $23prF = parcelRequire("23prF");
/**
 * Loads a custom element if it is not already registered.
 *
 * @returns {void}
 */ const $9771055002b8f514$export$7c05c44a44181e30 = (tagName, elementDefinition)=>{
    if (window.customElements.get(tagName)) return;
    customElements.define(tagName, elementDefinition);
};
const $9771055002b8f514$export$8dbecaf88ead7e1d = ()=>Math.random().toString(24).substring(4, 10);
const $9771055002b8f514$export$276fa8a6c58b5930 = (file)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const { result: result } = reader;
            if (typeof result !== 'string') throw TypeError();
            resolve(result);
        });
        reader.addEventListener('error', ()=>reject(reader.error));
        reader.readAsDataURL(file);
    });



var $eG1Pq = parcelRequire("eG1Pq");

var $eG1Pq = parcelRequire("eG1Pq");
const $46bf646e66cb9120$var$iconStyles = (0, $eG1Pq.css)`
  :host {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-height: 100%;
  }
  svg {
    width: auto;
    max-height: 100%;
  }
`;
var $46bf646e66cb9120$export$2e2bcd8739ae039 = $46bf646e66cb9120$var$iconStyles;


const $32963d8fb8cd6901$export$45e0b80f1e500bd4 = 'bullet-list-icon';
class $32963d8fb8cd6901$export$e0ce8028735d9fe0 extends (0, $eG1Pq.LitElement) {
    static{
        this.styles = [
            (0, $46bf646e66cb9120$export$2e2bcd8739ae039)
        ];
    }
    render() {
        return (0, $eG1Pq.html)`<svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0, 0, 48, 48">
      <path
        d="M8.55 39q-1.05 0-1.8-.725T6 36.55q0-1.05.75-1.8t1.8-.75q1 0 1.725.75.725.75.725 1.8 0 1-.725 1.725Q9.55 39 8.55 39ZM16 38v-3h26v3ZM8.55 26.5q-1.05 0-1.8-.725T6 24q0-1.05.75-1.775.75-.725 1.8-.725 1 0 1.725.75Q11 23 11 24t-.725 1.75q-.725.75-1.725.75Zm7.45-1v-3h26v3ZM8.5 14q-1.05 0-1.775-.725Q6 12.55 6 11.5q0-1.05.725-1.775Q7.45 9 8.5 9q1.05 0 1.775.725Q11 10.45 11 11.5q0 1.05-.725 1.775Q9.55 14 8.5 14Zm7.5-1v-3h26v3Z"
      />
    </svg>`;
    }
}



var $eG1Pq = parcelRequire("eG1Pq");

const $1fa345877f5e966f$export$45e0b80f1e500bd4 = 'link-icon';
class $1fa345877f5e966f$export$69387b41dfc808f7 extends (0, $eG1Pq.LitElement) {
    static{
        this.styles = [
            (0, $46bf646e66cb9120$export$2e2bcd8739ae039)
        ];
    }
    render() {
        return (0, $eG1Pq.html)`<svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0, 0, 48, 48">
      <path
        d="M22.5 34H14q-4.15 0-7.075-2.925T4 24q0-4.15 2.925-7.075T14 14h8.5v3H14q-2.9 0-4.95 2.05Q7 21.1 7 24q0 2.9 2.05 4.95Q11.1 31 14 31h8.5Zm-6.25-8.5v-3h15.5v3ZM25.5 34v-3H34q2.9 0 4.95-2.05Q41 26.9 41 24q0-2.9-2.05-4.95Q36.9 17 34 17h-8.5v-3H34q4.15 0 7.075 2.925T44 24q0 4.15-2.925 7.075T34 34Z"
      />
    </svg>`;
    }
}



var $eG1Pq = parcelRequire("eG1Pq");

const $a81d286c44361ec9$export$45e0b80f1e500bd4 = 'loading-icon';
class $a81d286c44361ec9$export$b936c55164dcf1db extends (0, $eG1Pq.LitElement) {
    static{
        this.styles = [
            (0, $46bf646e66cb9120$export$2e2bcd8739ae039),
            (0, $eG1Pq.css)`
      svg {
        animation: spin 2s linear infinite;
      }

      @keyframes spin {
        100% {
          transform: rotate(360deg);
        }
      }
    `
        ];
    }
    render() {
        return (0, $eG1Pq.html)`<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0, 0, 24, 24">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
      />
    </svg>`;
    }
}



var $eG1Pq = parcelRequire("eG1Pq");

const $ddb89d8b91149c7e$export$45e0b80f1e500bd4 = 'new-picture-icon';
class $ddb89d8b91149c7e$export$a38eaa5219f9362e extends (0, $eG1Pq.LitElement) {
    static{
        this.styles = [
            (0, $46bf646e66cb9120$export$2e2bcd8739ae039)
        ];
    }
    render() {
        return (0, $eG1Pq.html)`<svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0, 0, 48, 48">
      <path
        d="M29.45 6v3H9v30h30V18.6h3V39q0 1.2-.9 2.1-.9.9-2.1.9H9q-1.2 0-2.1-.9Q6 40.2 6 39V9q0-1.2.9-2.1Q7.8 6 9 6ZM38 6v4.05h4.05v3H38v4.05h-3v-4.05h-4.05v-3H35V6ZM12 33.9h24l-7.2-9.6-6.35 8.35-4.7-6.2ZM9 9v30V9Z"
      />
    </svg>`;
    }
}



var $eG1Pq = parcelRequire("eG1Pq");

const $41cdaef8aca513c9$export$45e0b80f1e500bd4 = 'number-list-icon';
class $41cdaef8aca513c9$export$10ee68c6031cbac4 extends (0, $eG1Pq.LitElement) {
    static{
        this.styles = [
            (0, $46bf646e66cb9120$export$2e2bcd8739ae039)
        ];
    }
    render() {
        return (0, $eG1Pq.html)`<svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0, 0, 48, 48">
      <path
        d="M6 40v-1.7h4.2V37H8.1v-1.7h2.1V34H6v-1.7h5.9V40Zm10.45-2.45v-3H42v3ZM6 27.85v-1.6l3.75-4.4H6v-1.7h5.9v1.6l-3.8 4.4h3.8v1.7Zm10.45-2.45v-3H42v3ZM8.1 15.8V9.7H6V8h3.8v7.8Zm8.35-2.55v-3H42v3Z"
      />
    </svg>`;
    }
}



var $eG1Pq = parcelRequire("eG1Pq");

const $35ecfd8f4636a1a9$export$45e0b80f1e500bd4 = 'table-icon';
class $35ecfd8f4636a1a9$export$560b0277c649ed6b extends (0, $eG1Pq.LitElement) {
    static{
        this.styles = [
            (0, $46bf646e66cb9120$export$2e2bcd8739ae039)
        ];
    }
    render() {
        return (0, $eG1Pq.html)`<svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0, 0, 48, 48">
      <path
        d="M6 42V6h36v36Zm3-25h30V9H9Zm11 11h8v-8h-8Zm0 11h8v-8h-8ZM9 28h8v-8H9Zm22 0h8v-8h-8ZM9 39h8v-8H9Zm22 0h8v-8h-8Z"
      />
    </svg>`;
    }
}



var $eG1Pq = parcelRequire("eG1Pq");
const $bafcdeb22d4d3bfd$var$formStyles = (0, $eG1Pq.css)`
  div {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: 1rem auto;
  }

  div input {
    border: 1px solid rgb(214, 214, 214);
    border-radius: 4px;
    height: 40px;
    padding: 1rem;
  }

  div textarea {
    border: 1px solid rgb(214, 214, 214);
    border-radius: 4px;
    height: 200px;
    padding: 1rem;
  }

  input[type='file'] {
    opacity: 0;
    width: 0.1px;
    height: 0.1px;
    position: absolute;
  }

  .file-label {
    background-color: white;
    border: 1px solid rgb(214, 214, 214);
    border-radius: 8px;
    width: 80%;
    text-align: center;
    padding: 0.5rem 1rem;
    margin: 0 auto;
    cursor: pointer;
  }
`;
var $bafcdeb22d4d3bfd$export$2e2bcd8739ae039 = $bafcdeb22d4d3bfd$var$formStyles;



var $eG1Pq = parcelRequire("eG1Pq");
const $4016440d5e50913b$export$aa0e86c7c0d2f400 = (0, $eG1Pq.css)`
  html,
  body {
    padding: 0;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans,
      Helvetica Neue, sans-serif;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
    --secondary-color: rgb(214, 214, 214);
    --secondary-color-hover: rgb(224, 224, 224);
    --radius: 4px;
  }
`;



var $eG1Pq = parcelRequire("eG1Pq");
const $7e989c9048ba1ac5$export$66176acc5e7b2d51 = (0, $eG1Pq.css)`
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  ul {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    margin: 0;
    padding: 0 4px;
    width: 100%;
    height: 40px;
    list-style-type: none;
    border: 1px solid var(--secondary-color);
    border-radius: var(--radius);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    background-color: var(--secondary-color);
  }

  li {
    display: inline-flex;
    align-items: center;
    padding: 0.5rem;
    margin: 0;
    color: black;
    cursor: pointer;
    border-radius: var(--radius);
    max-height: 35px;
    max-width: 38px;
    min-width: 35px;
    user-select: none;
  }
  li:hover {
    background-color: var(--secondary-color-hover);
  }
  li em,
  li strong {
    margin: 0 auto;
  }

  textarea {
    border: 1px solid var(--secondary-color);
    border-radius: 0px;
    border-bottom-left-radius: var(--radius);
    border-bottom-right-radius: var(--radius);
    height: 100%;
    padding: 0.5rem;
    max-width: 100%;
    min-width: 367px;
    margin: 0;
    outline: none;
  }
`;


const $9e0ae11ef3a937dc$export$45e0b80f1e500bd4 = 'lit-markdown-editor';
class $9e0ae11ef3a937dc$export$277db37d2617e2a5 extends (0, $eG1Pq.LitElement) {
    static{
        this.formAssociated = true;
    }
    #required;
    get required() {
        return this.#required;
    }
    set required(newVal) {
        this.#required = newVal;
        this.internals && (this.internals.ariaRequired = String(this.required));
        this.renderToLightDom();
    }
    /**
   * Acts as an intermediate for this element to behave like a textarea.
   */ get value() {
        return this.textarea?.value ?? '';
    }
    set value(value) {
        if (typeof value !== 'string') throw TypeError('Value must be string.');
        if (!this.textarea) throw Error('Cannot set textarea value before render.');
        this.textarea.value = value;
        this.renderToLightDom();
        this.triggerInputEvent();
    }
    constructor(){
        super(), this.controller = new AbortController(), this.isCompletionLoading = false, this.loading = false, this.name = '', this.minlength = '', this.maxlength = '', this.#required = false, /**
   * Renders header Markdown symbols into the textarea.
   */ this.handleHeaderClick = (event)=>{
            const target = event.currentTarget;
            if (!(target instanceof HTMLElement)) throw TypeError();
            const id = target.id;
            const markdownSymbol = this.markdownMap.get(id) ?? '';
            const { selectionStart: selectionStart, value: value } = this.textarea;
            const isFullParagraph = selectionStart ? value.at(selectionStart - 1) === '\n' : true;
            const newText = `${isFullParagraph ? '' : '\n'}${markdownSymbol} `;
            const padding = markdownSymbol.length + 2;
            this.appendTextToTextArea(newText, padding);
        }, /**
   * Handles a click to modifiers like italics.
   * The textarea selection will be set to the middle of symbols.
   */ this.handleModifierClick = (event)=>{
            const target = event.currentTarget;
            if (!(target instanceof HTMLElement)) throw TypeError();
            const id = target.id;
            const markdownSymbol = this.markdownMap.get(id) ?? '';
            const { selectionStart: selectionStart, selectionEnd: selectionEnd, value: value } = this.textarea;
            const newValue = ` ${markdownSymbol}${value.substring(selectionStart, selectionEnd)}${markdownSymbol} `;
            const padding = markdownSymbol.length + 1;
            this.appendTextToTextArea(newValue, padding);
        }, /**
   * Renders templates when a template icon is clicked.
   */ this.handleTemplateClick = (event)=>{
            const target = event.currentTarget;
            if (!(target instanceof HTMLElement)) throw TypeError();
            const id = target.id;
            const markdownSymbol = this.markdownMap.get(id) ?? '';
            const newLine = '\n';
            const newValue = newLine + markdownSymbol + newLine;
            this.appendTextToTextArea(newValue);
        }, /**
   * Handles link icon click to wrap selected text in a URL markdown text.
   */ this.handleLinkClick = ()=>{
            const { selectionStart: selectionStart, selectionEnd: selectionEnd, value: value } = this.textarea;
            const selectedText = value.substring(selectionStart, selectionEnd);
            const markdown = `[${selectedText ? selectedText : 'URL'}](https://)`;
            this.appendTextToTextArea(markdown);
            const startOfURL = selectionStart + 1 + (selectedText ? selectedText.length : 3) + 2;
            this.textarea.setSelectionRange(startOfURL, startOfURL + 8);
        }, /**
   * Opens file selection dialogue on a click to the add picture icon.
   */ this.handleAddPictureClick = ()=>{
            if (this.loading) return;
            this.fileInput.click();
        }, /**
   * Handles Enter keydown event and adds a new line for lists.
   */ this.handleEnterKeydown = (event)=>{
            const { selectionStart: selectionStart, value: value } = this.textarea;
            const startOfParagraph = value.lastIndexOf('\n', selectionStart - 2);
            const currentParagraph = value.slice(startOfParagraph + 1, selectionStart);
            const olRegex = /^([1-9][0-9]*). [^\n ]+/;
            const isOl = currentParagraph.match(olRegex);
            const ulRegex = / - [^\n ]+/;
            const isUl = currentParagraph.match(ulRegex);
            const isEmptyUlOrOl = /^(([1-9][0-9]*).| -) +$/.test(currentParagraph);
            if (isOl || isUl || isEmptyUlOrOl) {
                event.preventDefault();
                if (isEmptyUlOrOl && 'execCommand' in document) {
                    this.textarea.focus();
                    this.textarea.setSelectionRange(startOfParagraph + 1, selectionStart);
                    return document.execCommand('delete', false);
                }
                const symbol = isOl ? `\n${Number(isOl[1]) + 1}. ` : '\n - ';
                this.appendTextToTextArea(symbol, symbol.length);
            }
        }, /**
   * Hanldes the keydown event when the meta key is held.
   */ this.handleMetaKeydown = (event)=>{
            const clickEvent = new Event('click');
            switch(event.key.toUpperCase()){
                case 'U':
                case 'K':
                case 'L':
                    event.preventDefault();
                    this.handleLinkClick(event);
                    break;
                case 'B':
                    event.preventDefault();
                    this.boldButton.dispatchEvent(clickEvent);
                    break;
                case 'I':
                    event.preventDefault();
                    this.italicsButton.dispatchEvent(clickEvent);
                case 'O':
                    event.preventDefault();
                    this.fileInput.click();
            }
        }, /**
   * Handles file input when add picture button is clicked
   */ this.handleFileInput = (event)=>{
            event.stopPropagation(); // stop input event from bleeding through to light DOM
            const { files: files } = this.fileInput;
            if (!files) throw Error('No files object was found on input');
            const file = files[0];
            if (!file || file.size === 0) return;
            this.loading = true;
            this.provideFileURL(file).then((url)=>this.renderImageToTextArea(file, url)).finally(()=>{
                this.loading = false;
                this.fileInput.value = '';
            });
        }, /**
   * Handles a file drop on the textarea element.
   * Can render multiple files at once.
   */ this.handleDrop = (event)=>{
            event.preventDefault();
            if (this.loading || !event.dataTransfer) return;
            const { files: files } = event.dataTransfer;
            const filesArray = Array.from(files);
            const regex = /(image|video)\/.*/;
            const filteredFiles = filesArray.filter(({ type: type })=>regex.test(type));
            this.loading = true;
            Promise.all(filteredFiles.map((file)=>{
                return this.provideFileURL(file).then((url)=>this.renderImageToTextArea(file, url));
            })).finally(()=>{
                this.loading = false;
            });
        };
        const elementInternalsSupported = 'attachInternals' in this;
        this.internals = elementInternalsSupported ? this.attachInternals() : null;
        this.markdownMap = new Map([
            [
                'h1',
                '#'
            ],
            [
                'h2',
                '##'
            ],
            [
                'h3',
                '###'
            ],
            [
                'h4',
                '####'
            ],
            [
                'h5',
                '#####'
            ],
            [
                'ul',
                ' -'
            ],
            [
                'ol',
                '1.'
            ],
            [
                'i',
                '_'
            ],
            [
                'b',
                '**'
            ],
            [
                'table',
                "| A | B |\n| --- | --- |\n| a | b |"
            ]
        ]);
        (0, $9771055002b8f514$export$7c05c44a44181e30)((0, $35ecfd8f4636a1a9$export$45e0b80f1e500bd4), (0, $35ecfd8f4636a1a9$export$560b0277c649ed6b));
        (0, $9771055002b8f514$export$7c05c44a44181e30)((0, $1fa345877f5e966f$export$45e0b80f1e500bd4), (0, $1fa345877f5e966f$export$69387b41dfc808f7));
        (0, $9771055002b8f514$export$7c05c44a44181e30)((0, $ddb89d8b91149c7e$export$45e0b80f1e500bd4), (0, $ddb89d8b91149c7e$export$a38eaa5219f9362e));
        (0, $9771055002b8f514$export$7c05c44a44181e30)((0, $a81d286c44361ec9$export$45e0b80f1e500bd4), (0, $a81d286c44361ec9$export$b936c55164dcf1db));
        (0, $9771055002b8f514$export$7c05c44a44181e30)((0, $32963d8fb8cd6901$export$45e0b80f1e500bd4), (0, $32963d8fb8cd6901$export$e0ce8028735d9fe0));
        (0, $9771055002b8f514$export$7c05c44a44181e30)((0, $41cdaef8aca513c9$export$45e0b80f1e500bd4), (0, $41cdaef8aca513c9$export$10ee68c6031cbac4));
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.value = this.textContent ?? '';
        this.renderToLightDom();
        const textareaKeydown$ = (0, $jqXHu.fromEvent)(this.textarea, 'keydown');
        const metaKeyDown$ = textareaKeydown$.pipe((0, $dY50F.filter)((event)=>!event.isComposing && event.metaKey));
        const enterKeyDown$ = textareaKeydown$.pipe((0, $dY50F.filter)((event)=>event.key === 'Enter'));
        metaKeyDown$.subscribe(this.handleMetaKeydown);
        enterKeyDown$.subscribe(this.handleEnterKeydown);
        this.textarea.addEventListener('input', ()=>{
            this.renderToLightDom();
            this.dispatchEvent(new CustomEvent('output', {
                composed: true,
                detail: {
                    value: this.value
                }
            }));
        }, {
            signal: this.controller.signal
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.controller.abort();
    }
    /**
   * Appends text to textarea.
   * Uses deprecated execCommand if available and defaults to substitution if fails.
   */ appendTextToTextArea(textToAdd, selectionPadding = 1) {
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, value: value } = this.textarea;
        const newSelectionStart = selectionStart + selectionPadding;
        const execCommandSupported = 'execCommand' in document;
        if (execCommandSupported) {
            this.textarea.focus();
            this.textarea.setSelectionRange(selectionStart, selectionEnd);
            const succeeded = document.execCommand('insertText', false, textToAdd);
            if (succeeded) {
                this.textarea.setSelectionRange(newSelectionStart, newSelectionStart);
                return;
            }
        }
        const textUntilSelectionStart = value.substring(0, selectionStart);
        const textAfterSelectionEnd = value.substring(selectionEnd);
        this.value = textUntilSelectionStart + textToAdd + textAfterSelectionEnd;
        this.textarea.focus();
        this.textarea.setSelectionRange(newSelectionStart, newSelectionStart);
    }
    /**
   * Renders a file to the text area as markdown text with a link to the objects URL.
   */ renderImageToTextArea(file, url) {
        const markdown = `![${file.name}](${url} "${file.name}")`;
        const padding = markdown.length + 1;
        this.appendTextToTextArea(markdown, padding);
    }
    /**
   * Processes a file for uploading to hosting provider before being rendered in the text editor.
   * By default, will simply return an object URL for the file.
   */ provideFileURL(file) {
        const objectURL = URL.createObjectURL(file);
        return Promise.resolve(objectURL);
    }
    /**
   * Triggers input event on button clicks.
   */ triggerInputEvent() {
        this.dispatchEvent(new Event('input', {
            composed: true
        }));
    }
    static{
        this.styles = [
            (0, $4016440d5e50913b$export$aa0e86c7c0d2f400),
            (0, $bafcdeb22d4d3bfd$export$2e2bcd8739ae039),
            (0, $7e989c9048ba1ac5$export$66176acc5e7b2d51)
        ];
    }
    /**
   * Renders a hidden textarea to the lightdom so this element can be used with forms.
   * Will use element internals later.
   */ renderToLightDom() {
        if (!this.textarea) return; // Do not allow render until element is fully loaded.
        if (!this.internals) {
            (0, $eG1Pq.render)((0, $eG1Pq.html)`<textarea
          slot="input"
          name=${this.name}
          hidden
          .value=${this.value}
          ?required=${this.required}
        ></textarea>`, this);
            return;
        }
        this.internals.setFormValue(this.value);
        if (this.required && this.value.length === 0) return this.internals.setValidity({
            valueMissing: true
        }, 'Editor is empty.', this.textarea);
        const maxlengthNum = Number(this.maxlength);
        if (Boolean(maxlengthNum) && this.value.length > maxlengthNum) return this.internals.setValidity({
            tooLong: true
        }, `Max character length is ${this.maxlength} characters. Current character length is ${this.value.length}.`, this.textarea);
        const minlengthNum = Number(this.minlength);
        if (Boolean(minlengthNum) && this.value.length < minlengthNum) return this.internals.setValidity({
            tooShort: true
        }, `At least ${this.minlength} characters are required.`, this.textarea);
        this.internals.setValidity({});
    }
    createCompletion(text) {
        return this.aiService.createCompletion({
            model: 'gemini-2.0-flash',
            prompt: `As a content blog writer, write a very detailed description in English or if asked Bulgarian language for blog post in beautiful markdown language do not add any explanation at all just the pure markdown based on this text "${text}"`
        });
    }
    render() {
        return (0, $eG1Pq.html)`
      <input @input=${this.handleFileInput} id="add-file" type="file" hidden accept="image/*" />
      <nav>
        <ul>
          <li @click=${this.handleHeaderClick} id="h1">H1</li>
          <li @click=${this.handleHeaderClick} id="h2">H2</li>
          <li @click=${this.handleHeaderClick} id="h3">H3</li>
          <li @click=${this.handleHeaderClick} id="h4">H4</li>
          <li @click=${this.handleHeaderClick} id="h5">H5</li>
          <li @click=${this.handleHeaderClick} id="ul"><bullet-list-icon></bullet-list-icon></li>
          <li @click=${this.handleHeaderClick} id="ol"><number-list-icon></number-list-icon></li>
          <li @click=${this.handleModifierClick} id="i" title="italics (cmd + I)"><em>i</em></li>
          <li @click=${this.handleModifierClick} id="b" title="bold (cmd + B)"><strong>B</strong></li>
          <li @click=${this.handleTemplateClick} id="table" title="table">
            <table-icon></table-icon>
          </li>
          <li @click=${this.handleLinkClick} id="link" title="link (cmd + K)">
            <link-icon></link-icon>
          </li>
          <li @click=${this.handleAddPictureClick} style="position: relative;" title="add photo (cmd + O)">
            ${this.loading ? (0, $eG1Pq.html)`<loading-icon small black></loading-icon>` : (0, $eG1Pq.html)`<new-picture-icon></new-picture-icon>`}
          </li>

          <li>
            ${this.isCompletionLoading ? (0, $eG1Pq.html)` <sl-spinner></sl-spinner> ` : (0, $eG1Pq.html)`
                  <sl-tooltip content="Generate chat completion using Gemini AI"
                    ><sl-icon
                      name="chat-left-text"
                      @click=${(e)=>{
            this.isCompletionLoading = true;
            this.createCompletion(this.textarea.value).subscribe({
                error: ()=>{
                    this.isCompletionLoading = false;
                    (0, $23prF.error)('Unable to generate completion');
                },
                next: (data)=>{
                    const text = data.candidates[0].content.parts[0].text;
                    this.textarea.value = text;
                    this.dispatchEvent(new CustomEvent('output', {
                        composed: true,
                        detail: {
                            value: text
                        }
                    }));
                    (0, $23prF.success)('Description successfully generated');
                    this.isCompletionLoading = false;
                }
            });
        }}
                      >AI</sl-icon
                    >
                  </sl-tooltip>
                `}
          </li>

          <li @click=${()=>this.dispatchEvent(new CustomEvent('publish'))}>
            <sl-tooltip content="Publish post">
              <sl-icon label="Publish" name="journal-check"></sl-icon>
            </sl-tooltip>
          </li>
          <li @click=${()=>this.dispatchEvent(new CustomEvent('draft'))}>
            <sl-tooltip content="Mark as Draft"><sl-icon label="Draft" name="journal-minus"></sl-icon> </sl-tooltip>
          </li>

          <li @click=${()=>this.dispatchEvent(new CustomEvent('save'))}>
            <sl-tooltip content="Save Post"><sl-icon name="floppy"></sl-icon></sl-tooltip>
          </li>
          <li @click=${()=>this.dispatchEvent(new CustomEvent('cancel'))}>
            <sl-tooltip content="Cancel Editing">
              <sl-icon name="x-circle"></sl-icon>
            </sl-tooltip>
          </li>
          <li @click=${()=>this.dispatchEvent(new CustomEvent('delete'))}>
            <sl-tooltip content="Delete post">
              <sl-icon label="Delete" name="trash"></sl-icon>
            </sl-tooltip>
          </li>
        </ul>
      </nav>
      <textarea name=${this.name} autocomplete="off" @drop=${this.handleDrop}></textarea>
      <slot name="input"></slot>
    `;
    }
}
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $7fUEc.AiService))
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "aiService", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.state)()
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "isCompletionLoading", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.state)()
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "loading", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        attribute: 'name'
    })
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "name", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        attribute: 'minlength'
    })
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "minlength", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        attribute: 'maxlength'
    })
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "maxlength", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.query)('textarea')
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "textarea", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.query)('input#add-file')
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "fileInput", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.query)('li#b')
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "boldButton", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.query)('li#i')
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "italicsButton", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        attribute: 'required',
        type: Boolean
    })
], $9e0ae11ef3a937dc$export$277db37d2617e2a5.prototype, "required", null);
$9e0ae11ef3a937dc$export$277db37d2617e2a5 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.customElement)($9e0ae11ef3a937dc$export$45e0b80f1e500bd4)
], $9e0ae11ef3a937dc$export$277db37d2617e2a5);


parcelRequire("czGZi");
var $iB2Sj = parcelRequire("iB2Sj");
var $9heTP = parcelRequire("9heTP");
var $56Yze = parcelRequire("56Yze");

var $g0n63 = parcelRequire("g0n63");


var $4XQlz = parcelRequire("4XQlz");
// node_modules/@lit/reactive-element/css-tag.js
var $a726e13e2eca4e53$var$t = window;
var $a726e13e2eca4e53$var$e = $a726e13e2eca4e53$var$t.ShadowRoot && (void 0 === $a726e13e2eca4e53$var$t.ShadyCSS || $a726e13e2eca4e53$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
var $a726e13e2eca4e53$var$s = Symbol();
var $a726e13e2eca4e53$var$n = /* @__PURE__ */ new WeakMap();
var $a726e13e2eca4e53$var$o = class {
    constructor(t3, e4, n5){
        if (this._$cssResult$ = true, n5 !== $a726e13e2eca4e53$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t3, this.t = e4;
    }
    get styleSheet() {
        let t3 = this.o;
        const s5 = this.t;
        if ($a726e13e2eca4e53$var$e && void 0 === t3) {
            const e4 = void 0 !== s5 && 1 === s5.length;
            e4 && (t3 = $a726e13e2eca4e53$var$n.get(s5)), void 0 === t3 && ((this.o = t3 = new CSSStyleSheet()).replaceSync(this.cssText), e4 && $a726e13e2eca4e53$var$n.set(s5, t3));
        }
        return t3;
    }
    toString() {
        return this.cssText;
    }
};
var $a726e13e2eca4e53$var$r = (t3)=>new $a726e13e2eca4e53$var$o("string" == typeof t3 ? t3 : t3 + "", void 0, $a726e13e2eca4e53$var$s);
var $a726e13e2eca4e53$export$23f2a1d2818174ef = (t3, ...e4)=>{
    const n5 = 1 === t3.length ? t3[0] : e4.reduce((e5, s5, n6)=>e5 + ((t4)=>{
            if (true === t4._$cssResult$) return t4.cssText;
            if ("number" == typeof t4) return t4;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t4 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s5) + t3[n6 + 1], t3[0]);
    return new $a726e13e2eca4e53$var$o(n5, t3, $a726e13e2eca4e53$var$s);
};
var $a726e13e2eca4e53$var$S = (s5, n5)=>{
    $a726e13e2eca4e53$var$e ? s5.adoptedStyleSheets = n5.map((t3)=>t3 instanceof CSSStyleSheet ? t3 : t3.styleSheet) : n5.forEach((e4)=>{
        const n6 = document.createElement("style"), o5 = $a726e13e2eca4e53$var$t.litNonce;
        void 0 !== o5 && n6.setAttribute("nonce", o5), n6.textContent = e4.cssText, s5.appendChild(n6);
    });
};
var $a726e13e2eca4e53$var$c = $a726e13e2eca4e53$var$e ? (t3)=>t3 : (t3)=>t3 instanceof CSSStyleSheet ? ((t4)=>{
        let e4 = "";
        for (const s5 of t4.cssRules)e4 += s5.cssText;
        return $a726e13e2eca4e53$var$r(e4);
    })(t3) : t3;
// node_modules/@lit/reactive-element/reactive-element.js
var $a726e13e2eca4e53$var$s2;
var $a726e13e2eca4e53$var$e2 = window;
var $a726e13e2eca4e53$var$r2 = $a726e13e2eca4e53$var$e2.trustedTypes;
var $a726e13e2eca4e53$var$h = $a726e13e2eca4e53$var$r2 ? $a726e13e2eca4e53$var$r2.emptyScript : "";
var $a726e13e2eca4e53$var$o2 = $a726e13e2eca4e53$var$e2.reactiveElementPolyfillSupport;
var $a726e13e2eca4e53$export$7ccc53e8f1e7dfc5 = {
    toAttribute (t3, i3) {
        switch(i3){
            case Boolean:
                t3 = t3 ? $a726e13e2eca4e53$var$h : null;
                break;
            case Object:
            case Array:
                t3 = null == t3 ? t3 : JSON.stringify(t3);
        }
        return t3;
    },
    fromAttribute (t3, i3) {
        let s5 = t3;
        switch(i3){
            case Boolean:
                s5 = null !== t3;
                break;
            case Number:
                s5 = null === t3 ? null : Number(t3);
                break;
            case Object:
            case Array:
                try {
                    s5 = JSON.parse(t3);
                } catch (t4) {
                    s5 = null;
                }
        }
        return s5;
    }
};
var $a726e13e2eca4e53$var$a = (t3, i3)=>i3 !== t3 && (i3 == i3 || t3 == t3);
var $a726e13e2eca4e53$var$l = {
    attribute: true,
    type: String,
    converter: $a726e13e2eca4e53$export$7ccc53e8f1e7dfc5,
    reflect: false,
    hasChanged: $a726e13e2eca4e53$var$a
};
var $a726e13e2eca4e53$var$d = class extends HTMLElement {
    constructor(){
        super(), this._$Ei = /* @__PURE__ */ new Map(), this.isUpdatePending = false, this.hasUpdated = false, this._$El = null, this.u();
    }
    static addInitializer(t3) {
        var i3;
        this.finalize(), (null !== (i3 = this.h) && void 0 !== i3 ? i3 : this.h = []).push(t3);
    }
    static get observedAttributes() {
        this.finalize();
        const t3 = [];
        return this.elementProperties.forEach((i3, s5)=>{
            const e4 = this._$Ep(s5, i3);
            void 0 !== e4 && (this._$Ev.set(e4, s5), t3.push(e4));
        }), t3;
    }
    static createProperty(t3, i3 = $a726e13e2eca4e53$var$l) {
        if (i3.state && (i3.attribute = false), this.finalize(), this.elementProperties.set(t3, i3), !i3.noAccessor && !this.prototype.hasOwnProperty(t3)) {
            const s5 = "symbol" == typeof t3 ? Symbol() : "__" + t3, e4 = this.getPropertyDescriptor(t3, s5, i3);
            void 0 !== e4 && Object.defineProperty(this.prototype, t3, e4);
        }
    }
    static getPropertyDescriptor(t3, i3, s5) {
        return {
            get () {
                return this[i3];
            },
            set (e4) {
                const r4 = this[t3];
                this[i3] = e4, this.requestUpdate(t3, r4, s5);
            },
            configurable: true,
            enumerable: true
        };
    }
    static getPropertyOptions(t3) {
        return this.elementProperties.get(t3) || $a726e13e2eca4e53$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty("finalized")) return false;
        this.finalized = true;
        const t3 = Object.getPrototypeOf(this);
        if (t3.finalize(), void 0 !== t3.h && (this.h = [
            ...t3.h
        ]), this.elementProperties = new Map(t3.elementProperties), this._$Ev = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
            const t4 = this.properties, i3 = [
                ...Object.getOwnPropertyNames(t4),
                ...Object.getOwnPropertySymbols(t4)
            ];
            for (const s5 of i3)this.createProperty(s5, t4[s5]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), true;
    }
    static finalizeStyles(i3) {
        const s5 = [];
        if (Array.isArray(i3)) {
            const e4 = new Set(i3.flat(1 / 0).reverse());
            for (const i4 of e4)s5.unshift($a726e13e2eca4e53$var$c(i4));
        } else void 0 !== i3 && s5.push($a726e13e2eca4e53$var$c(i3));
        return s5;
    }
    static _$Ep(t3, i3) {
        const s5 = i3.attribute;
        return false === s5 ? void 0 : "string" == typeof s5 ? s5 : "string" == typeof t3 ? t3.toLowerCase() : void 0;
    }
    u() {
        var t3;
        this._$E_ = new Promise((t4)=>this.enableUpdating = t4), this._$AL = /* @__PURE__ */ new Map(), this._$Eg(), this.requestUpdate(), null === (t3 = this.constructor.h) || void 0 === t3 || t3.forEach((t4)=>t4(this));
    }
    addController(t3) {
        var i3, s5;
        (null !== (i3 = this._$ES) && void 0 !== i3 ? i3 : this._$ES = []).push(t3), void 0 !== this.renderRoot && this.isConnected && (null === (s5 = t3.hostConnected) || void 0 === s5 || s5.call(t3));
    }
    removeController(t3) {
        var i3;
        null === (i3 = this._$ES) || void 0 === i3 || i3.splice(this._$ES.indexOf(t3) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t3, i3)=>{
            this.hasOwnProperty(i3) && (this._$Ei.set(i3, this[i3]), delete this[i3]);
        });
    }
    createRenderRoot() {
        var t3;
        const s5 = null !== (t3 = this.shadowRoot) && void 0 !== t3 ? t3 : this.attachShadow(this.constructor.shadowRootOptions);
        return $a726e13e2eca4e53$var$S(s5, this.constructor.elementStyles), s5;
    }
    connectedCallback() {
        var t3;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(true), null === (t3 = this._$ES) || void 0 === t3 || t3.forEach((t4)=>{
            var i3;
            return null === (i3 = t4.hostConnected) || void 0 === i3 ? void 0 : i3.call(t4);
        });
    }
    enableUpdating(t3) {}
    disconnectedCallback() {
        var t3;
        null === (t3 = this._$ES) || void 0 === t3 || t3.forEach((t4)=>{
            var i3;
            return null === (i3 = t4.hostDisconnected) || void 0 === i3 ? void 0 : i3.call(t4);
        });
    }
    attributeChangedCallback(t3, i3, s5) {
        this._$AK(t3, s5);
    }
    _$EO(t3, i3, s5 = $a726e13e2eca4e53$var$l) {
        var e4;
        const r4 = this.constructor._$Ep(t3, s5);
        if (void 0 !== r4 && true === s5.reflect) {
            const h3 = (void 0 !== (null === (e4 = s5.converter) || void 0 === e4 ? void 0 : e4.toAttribute) ? s5.converter : $a726e13e2eca4e53$export$7ccc53e8f1e7dfc5).toAttribute(i3, s5.type);
            this._$El = t3, null == h3 ? this.removeAttribute(r4) : this.setAttribute(r4, h3), this._$El = null;
        }
    }
    _$AK(t3, i3) {
        var s5;
        const e4 = this.constructor, r4 = e4._$Ev.get(t3);
        if (void 0 !== r4 && this._$El !== r4) {
            const t4 = e4.getPropertyOptions(r4), h3 = "function" == typeof t4.converter ? {
                fromAttribute: t4.converter
            } : void 0 !== (null === (s5 = t4.converter) || void 0 === s5 ? void 0 : s5.fromAttribute) ? t4.converter : $a726e13e2eca4e53$export$7ccc53e8f1e7dfc5;
            this._$El = r4, this[r4] = h3.fromAttribute(i3, t4.type), this._$El = null;
        }
    }
    requestUpdate(t3, i3, s5) {
        let e4 = true;
        void 0 !== t3 && (((s5 = s5 || this.constructor.getPropertyOptions(t3)).hasChanged || $a726e13e2eca4e53$var$a)(this[t3], i3) ? (this._$AL.has(t3) || this._$AL.set(t3, i3), true === s5.reflect && this._$El !== t3 && (void 0 === this._$EC && (this._$EC = /* @__PURE__ */ new Map()), this._$EC.set(t3, s5))) : e4 = false), !this.isUpdatePending && e4 && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = true;
        try {
            await this._$E_;
        } catch (t4) {
            Promise.reject(t4);
        }
        const t3 = this.scheduleUpdate();
        return null != t3 && await t3, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t3;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t4, i4)=>this[i4] = t4), this._$Ei = void 0);
        let i3 = false;
        const s5 = this._$AL;
        try {
            i3 = this.shouldUpdate(s5), i3 ? (this.willUpdate(s5), null === (t3 = this._$ES) || void 0 === t3 || t3.forEach((t4)=>{
                var i4;
                return null === (i4 = t4.hostUpdate) || void 0 === i4 ? void 0 : i4.call(t4);
            }), this.update(s5)) : this._$Ek();
        } catch (t4) {
            throw i3 = false, this._$Ek(), t4;
        }
        i3 && this._$AE(s5);
    }
    willUpdate(t3) {}
    _$AE(t3) {
        var i3;
        null === (i3 = this._$ES) || void 0 === i3 || i3.forEach((t4)=>{
            var i4;
            return null === (i4 = t4.hostUpdated) || void 0 === i4 ? void 0 : i4.call(t4);
        }), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t3)), this.updated(t3);
    }
    _$Ek() {
        this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t3) {
        return true;
    }
    update(t3) {
        void 0 !== this._$EC && (this._$EC.forEach((t4, i3)=>this._$EO(i3, this[i3], t4)), this._$EC = void 0), this._$Ek();
    }
    updated(t3) {}
    firstUpdated(t3) {}
};
$a726e13e2eca4e53$var$d.finalized = true, $a726e13e2eca4e53$var$d.elementProperties = /* @__PURE__ */ new Map(), $a726e13e2eca4e53$var$d.elementStyles = [], $a726e13e2eca4e53$var$d.shadowRootOptions = {
    mode: "open"
}, null == $a726e13e2eca4e53$var$o2 || $a726e13e2eca4e53$var$o2({
    ReactiveElement: $a726e13e2eca4e53$var$d
}), (null !== ($a726e13e2eca4e53$var$s2 = $a726e13e2eca4e53$var$e2.reactiveElementVersions) && void 0 !== $a726e13e2eca4e53$var$s2 ? $a726e13e2eca4e53$var$s2 : $a726e13e2eca4e53$var$e2.reactiveElementVersions = []).push("1.6.1");
// node_modules/lit-html/lit-html.js
var $a726e13e2eca4e53$var$t2;
var $a726e13e2eca4e53$var$i2 = window;
var $a726e13e2eca4e53$var$s3 = $a726e13e2eca4e53$var$i2.trustedTypes;
var $a726e13e2eca4e53$var$e3 = $a726e13e2eca4e53$var$s3 ? $a726e13e2eca4e53$var$s3.createPolicy("lit-html", {
    createHTML: (t3)=>t3
}) : void 0;
var $a726e13e2eca4e53$var$o3 = `lit$${(Math.random() + "").slice(9)}$`;
var $a726e13e2eca4e53$var$n3 = "?" + $a726e13e2eca4e53$var$o3;
var $a726e13e2eca4e53$var$l2 = `<${$a726e13e2eca4e53$var$n3}>`;
var $a726e13e2eca4e53$var$h2 = document;
var $a726e13e2eca4e53$var$r3 = (t3 = "")=>$a726e13e2eca4e53$var$h2.createComment(t3);
var $a726e13e2eca4e53$var$d2 = (t3)=>null === t3 || "object" != typeof t3 && "function" != typeof t3;
var $a726e13e2eca4e53$var$u = Array.isArray;
var $a726e13e2eca4e53$var$c2 = (t3)=>$a726e13e2eca4e53$var$u(t3) || "function" == typeof (null == t3 ? void 0 : t3[Symbol.iterator]);
var $a726e13e2eca4e53$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g;
var $a726e13e2eca4e53$var$a2 = /-->/g;
var $a726e13e2eca4e53$var$f = />/g;
var $a726e13e2eca4e53$var$_ = RegExp(`>|[ 	
\f\r](?:([^\\s"'>=/]+)([ 	
\f\r]*=[ 	
\f\r]*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g");
var $a726e13e2eca4e53$var$m = /'/g;
var $a726e13e2eca4e53$var$p = /"/g;
var $a726e13e2eca4e53$var$$ = /^(?:script|style|textarea|title)$/i;
var $a726e13e2eca4e53$var$g = (t3)=>(i3, ...s5)=>({
            _$litType$: t3,
            strings: i3,
            values: s5
        });
var $a726e13e2eca4e53$export$4a5767248b18ef41 = $a726e13e2eca4e53$var$g(1);
var $a726e13e2eca4e53$export$efccba1c4a2ef57b = $a726e13e2eca4e53$var$g(2);
var $a726e13e2eca4e53$export$d141bba7fdc215a3 = Symbol.for("lit-noChange");
var $a726e13e2eca4e53$export$8b22cf2602fb60ce = Symbol.for("lit-nothing");
var $a726e13e2eca4e53$var$T = /* @__PURE__ */ new WeakMap();
var $a726e13e2eca4e53$var$A = $a726e13e2eca4e53$var$h2.createTreeWalker($a726e13e2eca4e53$var$h2, 129, null, false);
var $a726e13e2eca4e53$var$E = (t3, i3)=>{
    const s5 = t3.length - 1, n5 = [];
    let h3, r4 = 2 === i3 ? "<svg>" : "", d3 = $a726e13e2eca4e53$var$v;
    for(let i4 = 0; i4 < s5; i4++){
        const s6 = t3[i4];
        let e4, u3, c3 = -1, g2 = 0;
        for(; g2 < s6.length && (d3.lastIndex = g2, u3 = d3.exec(s6), null !== u3);)g2 = d3.lastIndex, d3 === $a726e13e2eca4e53$var$v ? "!--" === u3[1] ? d3 = $a726e13e2eca4e53$var$a2 : void 0 !== u3[1] ? d3 = $a726e13e2eca4e53$var$f : void 0 !== u3[2] ? ($a726e13e2eca4e53$var$$.test(u3[2]) && (h3 = RegExp("</" + u3[2], "g")), d3 = $a726e13e2eca4e53$var$_) : void 0 !== u3[3] && (d3 = $a726e13e2eca4e53$var$_) : d3 === $a726e13e2eca4e53$var$_ ? ">" === u3[0] ? (d3 = null != h3 ? h3 : $a726e13e2eca4e53$var$v, c3 = -1) : void 0 === u3[1] ? c3 = -2 : (c3 = d3.lastIndex - u3[2].length, e4 = u3[1], d3 = void 0 === u3[3] ? $a726e13e2eca4e53$var$_ : '"' === u3[3] ? $a726e13e2eca4e53$var$p : $a726e13e2eca4e53$var$m) : d3 === $a726e13e2eca4e53$var$p || d3 === $a726e13e2eca4e53$var$m ? d3 = $a726e13e2eca4e53$var$_ : d3 === $a726e13e2eca4e53$var$a2 || d3 === $a726e13e2eca4e53$var$f ? d3 = $a726e13e2eca4e53$var$v : (d3 = $a726e13e2eca4e53$var$_, h3 = void 0);
        const y2 = d3 === $a726e13e2eca4e53$var$_ && t3[i4 + 1].startsWith("/>") ? " " : "";
        r4 += d3 === $a726e13e2eca4e53$var$v ? s6 + $a726e13e2eca4e53$var$l2 : c3 >= 0 ? (n5.push(e4), s6.slice(0, c3) + "$lit$" + s6.slice(c3) + $a726e13e2eca4e53$var$o3 + y2) : s6 + $a726e13e2eca4e53$var$o3 + (-2 === c3 ? (n5.push(void 0), i4) : y2);
    }
    const u2 = r4 + (t3[s5] || "<?>") + (2 === i3 ? "</svg>" : "");
    if (!Array.isArray(t3) || !t3.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== $a726e13e2eca4e53$var$e3 ? $a726e13e2eca4e53$var$e3.createHTML(u2) : u2,
        n5
    ];
};
var $a726e13e2eca4e53$var$C = class {
    constructor({ strings: t3, _$litType$: i3 }, e4){
        let l4;
        this.parts = [];
        let h3 = 0, d3 = 0;
        const u2 = t3.length - 1, c3 = this.parts, [v2, a3] = $a726e13e2eca4e53$var$E(t3, i3);
        if (this.el = $a726e13e2eca4e53$var$C.createElement(v2, e4), $a726e13e2eca4e53$var$A.currentNode = this.el.content, 2 === i3) {
            const t4 = this.el.content, i4 = t4.firstChild;
            i4.remove(), t4.append(...i4.childNodes);
        }
        for(; null !== (l4 = $a726e13e2eca4e53$var$A.nextNode()) && c3.length < u2;){
            if (1 === l4.nodeType) {
                if (l4.hasAttributes()) {
                    const t4 = [];
                    for (const i4 of l4.getAttributeNames())if (i4.endsWith("$lit$") || i4.startsWith($a726e13e2eca4e53$var$o3)) {
                        const s5 = a3[d3++];
                        if (t4.push(i4), void 0 !== s5) {
                            const t5 = l4.getAttribute(s5.toLowerCase() + "$lit$").split($a726e13e2eca4e53$var$o3), i5 = /([.?@])?(.*)/.exec(s5);
                            c3.push({
                                type: 1,
                                index: h3,
                                name: i5[2],
                                strings: t5,
                                ctor: "." === i5[1] ? $a726e13e2eca4e53$var$M : "?" === i5[1] ? $a726e13e2eca4e53$var$k : "@" === i5[1] ? $a726e13e2eca4e53$var$H : $a726e13e2eca4e53$var$S2
                            });
                        } else c3.push({
                            type: 6,
                            index: h3
                        });
                    }
                    for (const i4 of t4)l4.removeAttribute(i4);
                }
                if ($a726e13e2eca4e53$var$$.test(l4.tagName)) {
                    const t4 = l4.textContent.split($a726e13e2eca4e53$var$o3), i4 = t4.length - 1;
                    if (i4 > 0) {
                        l4.textContent = $a726e13e2eca4e53$var$s3 ? $a726e13e2eca4e53$var$s3.emptyScript : "";
                        for(let s5 = 0; s5 < i4; s5++)l4.append(t4[s5], $a726e13e2eca4e53$var$r3()), $a726e13e2eca4e53$var$A.nextNode(), c3.push({
                            type: 2,
                            index: ++h3
                        });
                        l4.append(t4[i4], $a726e13e2eca4e53$var$r3());
                    }
                }
            } else if (8 === l4.nodeType) {
                if (l4.data === $a726e13e2eca4e53$var$n3) c3.push({
                    type: 2,
                    index: h3
                });
                else {
                    let t4 = -1;
                    for(; -1 !== (t4 = l4.data.indexOf($a726e13e2eca4e53$var$o3, t4 + 1));)c3.push({
                        type: 7,
                        index: h3
                    }), t4 += $a726e13e2eca4e53$var$o3.length - 1;
                }
            }
            h3++;
        }
    }
    static createElement(t3, i3) {
        const s5 = $a726e13e2eca4e53$var$h2.createElement("template");
        return s5.innerHTML = t3, s5;
    }
};
function $a726e13e2eca4e53$var$P(t3, i3, s5 = t3, e4) {
    var o5, n5, l4, h3;
    if (i3 === $a726e13e2eca4e53$export$d141bba7fdc215a3) return i3;
    let r4 = void 0 !== e4 ? null === (o5 = s5._$Co) || void 0 === o5 ? void 0 : o5[e4] : s5._$Cl;
    const u2 = $a726e13e2eca4e53$var$d2(i3) ? void 0 : i3._$litDirective$;
    return (null == r4 ? void 0 : r4.constructor) !== u2 && (null === (n5 = null == r4 ? void 0 : r4._$AO) || void 0 === n5 || n5.call(r4, false), void 0 === u2 ? r4 = void 0 : (r4 = new u2(t3), r4._$AT(t3, s5, e4)), void 0 !== e4 ? (null !== (l4 = (h3 = s5)._$Co) && void 0 !== l4 ? l4 : h3._$Co = [])[e4] = r4 : s5._$Cl = r4), void 0 !== r4 && (i3 = $a726e13e2eca4e53$var$P(t3, r4._$AS(t3, i3.values), r4, e4)), i3;
}
var $a726e13e2eca4e53$var$V = class {
    constructor(t3, i3){
        this.u = [], this._$AN = void 0, this._$AD = t3, this._$AM = i3;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    v(t3) {
        var i3;
        const { el: { content: s5 }, parts: e4 } = this._$AD, o5 = (null !== (i3 = null == t3 ? void 0 : t3.creationScope) && void 0 !== i3 ? i3 : $a726e13e2eca4e53$var$h2).importNode(s5, true);
        $a726e13e2eca4e53$var$A.currentNode = o5;
        let n5 = $a726e13e2eca4e53$var$A.nextNode(), l4 = 0, r4 = 0, d3 = e4[0];
        for(; void 0 !== d3;){
            if (l4 === d3.index) {
                let i4;
                2 === d3.type ? i4 = new $a726e13e2eca4e53$var$N(n5, n5.nextSibling, this, t3) : 1 === d3.type ? i4 = new d3.ctor(n5, d3.name, d3.strings, this, t3) : 6 === d3.type && (i4 = new $a726e13e2eca4e53$var$I(n5, this, t3)), this.u.push(i4), d3 = e4[++r4];
            }
            l4 !== (null == d3 ? void 0 : d3.index) && (n5 = $a726e13e2eca4e53$var$A.nextNode(), l4++);
        }
        return o5;
    }
    p(t3) {
        let i3 = 0;
        for (const s5 of this.u)void 0 !== s5 && (void 0 !== s5.strings ? (s5._$AI(t3, s5, i3), i3 += s5.strings.length - 2) : s5._$AI(t3[i3])), i3++;
    }
};
var $a726e13e2eca4e53$var$N = class {
    constructor(t3, i3, s5, e4){
        var o5;
        this.type = 2, this._$AH = $a726e13e2eca4e53$export$8b22cf2602fb60ce, this._$AN = void 0, this._$AA = t3, this._$AB = i3, this._$AM = s5, this.options = e4, this._$Cm = null === (o5 = null == e4 ? void 0 : e4.isConnected) || void 0 === o5 || o5;
    }
    get _$AU() {
        var t3, i3;
        return null !== (i3 = null === (t3 = this._$AM) || void 0 === t3 ? void 0 : t3._$AU) && void 0 !== i3 ? i3 : this._$Cm;
    }
    get parentNode() {
        let t3 = this._$AA.parentNode;
        const i3 = this._$AM;
        return void 0 !== i3 && 11 === t3.nodeType && (t3 = i3.parentNode), t3;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t3, i3 = this) {
        t3 = $a726e13e2eca4e53$var$P(this, t3, i3), $a726e13e2eca4e53$var$d2(t3) ? t3 === $a726e13e2eca4e53$export$8b22cf2602fb60ce || null == t3 || "" === t3 ? (this._$AH !== $a726e13e2eca4e53$export$8b22cf2602fb60ce && this._$AR(), this._$AH = $a726e13e2eca4e53$export$8b22cf2602fb60ce) : t3 !== this._$AH && t3 !== $a726e13e2eca4e53$export$d141bba7fdc215a3 && this.g(t3) : void 0 !== t3._$litType$ ? this.$(t3) : void 0 !== t3.nodeType ? this.T(t3) : $a726e13e2eca4e53$var$c2(t3) ? this.k(t3) : this.g(t3);
    }
    O(t3, i3 = this._$AB) {
        return this._$AA.parentNode.insertBefore(t3, i3);
    }
    T(t3) {
        this._$AH !== t3 && (this._$AR(), this._$AH = this.O(t3));
    }
    g(t3) {
        this._$AH !== $a726e13e2eca4e53$export$8b22cf2602fb60ce && $a726e13e2eca4e53$var$d2(this._$AH) ? this._$AA.nextSibling.data = t3 : this.T($a726e13e2eca4e53$var$h2.createTextNode(t3)), this._$AH = t3;
    }
    $(t3) {
        var i3;
        const { values: s5, _$litType$: e4 } = t3, o5 = "number" == typeof e4 ? this._$AC(t3) : (void 0 === e4.el && (e4.el = $a726e13e2eca4e53$var$C.createElement(e4.h, this.options)), e4);
        if ((null === (i3 = this._$AH) || void 0 === i3 ? void 0 : i3._$AD) === o5) this._$AH.p(s5);
        else {
            const t4 = new $a726e13e2eca4e53$var$V(o5, this), i4 = t4.v(this.options);
            t4.p(s5), this.T(i4), this._$AH = t4;
        }
    }
    _$AC(t3) {
        let i3 = $a726e13e2eca4e53$var$T.get(t3.strings);
        return void 0 === i3 && $a726e13e2eca4e53$var$T.set(t3.strings, i3 = new $a726e13e2eca4e53$var$C(t3)), i3;
    }
    k(t3) {
        $a726e13e2eca4e53$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i3 = this._$AH;
        let s5, e4 = 0;
        for (const o5 of t3)e4 === i3.length ? i3.push(s5 = new $a726e13e2eca4e53$var$N(this.O($a726e13e2eca4e53$var$r3()), this.O($a726e13e2eca4e53$var$r3()), this, this.options)) : s5 = i3[e4], s5._$AI(o5), e4++;
        e4 < i3.length && (this._$AR(s5 && s5._$AB.nextSibling, e4), i3.length = e4);
    }
    _$AR(t3 = this._$AA.nextSibling, i3) {
        var s5;
        for(null === (s5 = this._$AP) || void 0 === s5 || s5.call(this, false, true, i3); t3 && t3 !== this._$AB;){
            const i4 = t3.nextSibling;
            t3.remove(), t3 = i4;
        }
    }
    setConnected(t3) {
        var i3;
        void 0 === this._$AM && (this._$Cm = t3, null === (i3 = this._$AP) || void 0 === i3 || i3.call(this, t3));
    }
};
var $a726e13e2eca4e53$var$S2 = class {
    constructor(t3, i3, s5, e4, o5){
        this.type = 1, this._$AH = $a726e13e2eca4e53$export$8b22cf2602fb60ce, this._$AN = void 0, this.element = t3, this.name = i3, this._$AM = e4, this.options = o5, s5.length > 2 || "" !== s5[0] || "" !== s5[1] ? (this._$AH = Array(s5.length - 1).fill(new String()), this.strings = s5) : this._$AH = $a726e13e2eca4e53$export$8b22cf2602fb60ce;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t3, i3 = this, s5, e4) {
        const o5 = this.strings;
        let n5 = false;
        if (void 0 === o5) t3 = $a726e13e2eca4e53$var$P(this, t3, i3, 0), n5 = !$a726e13e2eca4e53$var$d2(t3) || t3 !== this._$AH && t3 !== $a726e13e2eca4e53$export$d141bba7fdc215a3, n5 && (this._$AH = t3);
        else {
            const e5 = t3;
            let l4, h3;
            for(t3 = o5[0], l4 = 0; l4 < o5.length - 1; l4++)h3 = $a726e13e2eca4e53$var$P(this, e5[s5 + l4], i3, l4), h3 === $a726e13e2eca4e53$export$d141bba7fdc215a3 && (h3 = this._$AH[l4]), n5 || (n5 = !$a726e13e2eca4e53$var$d2(h3) || h3 !== this._$AH[l4]), h3 === $a726e13e2eca4e53$export$8b22cf2602fb60ce ? t3 = $a726e13e2eca4e53$export$8b22cf2602fb60ce : t3 !== $a726e13e2eca4e53$export$8b22cf2602fb60ce && (t3 += (null != h3 ? h3 : "") + o5[l4 + 1]), this._$AH[l4] = h3;
        }
        n5 && !e4 && this.j(t3);
    }
    j(t3) {
        t3 === $a726e13e2eca4e53$export$8b22cf2602fb60ce ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t3 ? t3 : "");
    }
};
var $a726e13e2eca4e53$var$M = class extends $a726e13e2eca4e53$var$S2 {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t3) {
        this.element[this.name] = t3 === $a726e13e2eca4e53$export$8b22cf2602fb60ce ? void 0 : t3;
    }
};
var $a726e13e2eca4e53$var$R = $a726e13e2eca4e53$var$s3 ? $a726e13e2eca4e53$var$s3.emptyScript : "";
var $a726e13e2eca4e53$var$k = class extends $a726e13e2eca4e53$var$S2 {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t3) {
        t3 && t3 !== $a726e13e2eca4e53$export$8b22cf2602fb60ce ? this.element.setAttribute(this.name, $a726e13e2eca4e53$var$R) : this.element.removeAttribute(this.name);
    }
};
var $a726e13e2eca4e53$var$H = class extends $a726e13e2eca4e53$var$S2 {
    constructor(t3, i3, s5, e4, o5){
        super(t3, i3, s5, e4, o5), this.type = 5;
    }
    _$AI(t3, i3 = this) {
        var s5;
        if ((t3 = null !== (s5 = $a726e13e2eca4e53$var$P(this, t3, i3, 0)) && void 0 !== s5 ? s5 : $a726e13e2eca4e53$export$8b22cf2602fb60ce) === $a726e13e2eca4e53$export$d141bba7fdc215a3) return;
        const e4 = this._$AH, o5 = t3 === $a726e13e2eca4e53$export$8b22cf2602fb60ce && e4 !== $a726e13e2eca4e53$export$8b22cf2602fb60ce || t3.capture !== e4.capture || t3.once !== e4.once || t3.passive !== e4.passive, n5 = t3 !== $a726e13e2eca4e53$export$8b22cf2602fb60ce && (e4 === $a726e13e2eca4e53$export$8b22cf2602fb60ce || o5);
        o5 && this.element.removeEventListener(this.name, this, e4), n5 && this.element.addEventListener(this.name, this, t3), this._$AH = t3;
    }
    handleEvent(t3) {
        var i3, s5;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s5 = null === (i3 = this.options) || void 0 === i3 ? void 0 : i3.host) && void 0 !== s5 ? s5 : this.element, t3) : this._$AH.handleEvent(t3);
    }
};
var $a726e13e2eca4e53$var$I = class {
    constructor(t3, i3, s5){
        this.element = t3, this.type = 6, this._$AN = void 0, this._$AM = i3, this.options = s5;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t3) {
        $a726e13e2eca4e53$var$P(this, t3);
    }
};
var $a726e13e2eca4e53$export$61196ced6d74a310 = {
    P: "$lit$",
    A: $a726e13e2eca4e53$var$o3,
    M: $a726e13e2eca4e53$var$n3,
    C: 1,
    L: $a726e13e2eca4e53$var$E,
    R: $a726e13e2eca4e53$var$V,
    D: $a726e13e2eca4e53$var$c2,
    V: $a726e13e2eca4e53$var$P,
    I: $a726e13e2eca4e53$var$N,
    H: $a726e13e2eca4e53$var$S2,
    N: $a726e13e2eca4e53$var$k,
    U: $a726e13e2eca4e53$var$H,
    B: $a726e13e2eca4e53$var$M,
    F: $a726e13e2eca4e53$var$I
};
var $a726e13e2eca4e53$var$z = $a726e13e2eca4e53$var$i2.litHtmlPolyfillSupport;
null == $a726e13e2eca4e53$var$z || $a726e13e2eca4e53$var$z($a726e13e2eca4e53$var$C, $a726e13e2eca4e53$var$N), (null !== ($a726e13e2eca4e53$var$t2 = $a726e13e2eca4e53$var$i2.litHtmlVersions) && void 0 !== $a726e13e2eca4e53$var$t2 ? $a726e13e2eca4e53$var$t2 : $a726e13e2eca4e53$var$i2.litHtmlVersions = []).push("2.6.1");
var $a726e13e2eca4e53$var$Z = (t3, i3, s5)=>{
    var e4, o5;
    const n5 = null !== (e4 = null == s5 ? void 0 : s5.renderBefore) && void 0 !== e4 ? e4 : i3;
    let l4 = n5._$litPart$;
    if (void 0 === l4) {
        const t4 = null !== (o5 = null == s5 ? void 0 : s5.renderBefore) && void 0 !== o5 ? o5 : null;
        n5._$litPart$ = l4 = new $a726e13e2eca4e53$var$N(i3.insertBefore($a726e13e2eca4e53$var$r3(), t4), t4, void 0, null != s5 ? s5 : {});
    }
    return l4._$AI(t3), l4;
};
// node_modules/lit-element/lit-element.js
var $a726e13e2eca4e53$var$l3;
var $a726e13e2eca4e53$var$o4;
var $a726e13e2eca4e53$export$2408f22a0fab9ae5 = class extends $a726e13e2eca4e53$var$d {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Dt = void 0;
    }
    createRenderRoot() {
        var t3, e4;
        const i3 = super.createRenderRoot();
        return null !== (t3 = (e4 = this.renderOptions).renderBefore) && void 0 !== t3 || (e4.renderBefore = i3.firstChild), i3;
    }
    update(t3) {
        const i3 = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t3), this._$Dt = $a726e13e2eca4e53$var$Z(i3, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t3;
        super.connectedCallback(), null === (t3 = this._$Dt) || void 0 === t3 || t3.setConnected(true);
    }
    disconnectedCallback() {
        var t3;
        super.disconnectedCallback(), null === (t3 = this._$Dt) || void 0 === t3 || t3.setConnected(false);
    }
    render() {
        return $a726e13e2eca4e53$export$d141bba7fdc215a3;
    }
};
$a726e13e2eca4e53$export$2408f22a0fab9ae5.finalized = true, $a726e13e2eca4e53$export$2408f22a0fab9ae5._$litElement$ = true, null === ($a726e13e2eca4e53$var$l3 = globalThis.litElementHydrateSupport) || void 0 === $a726e13e2eca4e53$var$l3 || $a726e13e2eca4e53$var$l3.call(globalThis, {
    LitElement: $a726e13e2eca4e53$export$2408f22a0fab9ae5
});
var $a726e13e2eca4e53$var$n4 = globalThis.litElementPolyfillSupport;
null == $a726e13e2eca4e53$var$n4 || $a726e13e2eca4e53$var$n4({
    LitElement: $a726e13e2eca4e53$export$2408f22a0fab9ae5
});
(null !== ($a726e13e2eca4e53$var$o4 = globalThis.litElementVersions) && void 0 !== $a726e13e2eca4e53$var$o4 ? $a726e13e2eca4e53$var$o4 : globalThis.litElementVersions = []).push("3.2.0");
 /*! Bundled license information:

@lit/reactive-element/css-tag.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/reactive-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/lit-html.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-element/lit-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/is-server.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 

// src/styles/component.styles.ts
var $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269 = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;



// src/components/breadcrumb/breadcrumb.styles.ts
var $4b36324fed99503d$export$1832f44b81141fb4 = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  .breadcrumb {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;


// node_modules/@shoelace-style/localize/dist/index.js
var $da2a8206311c55a2$var$connectedElements = /* @__PURE__ */ new Set();
var $da2a8206311c55a2$var$documentElementObserver = new MutationObserver($da2a8206311c55a2$var$update);
var $da2a8206311c55a2$var$translations = /* @__PURE__ */ new Map();
var $da2a8206311c55a2$var$documentDirection = document.documentElement.dir || "ltr";
var $da2a8206311c55a2$var$documentLanguage = document.documentElement.lang || navigator.language;
var $da2a8206311c55a2$var$fallback;
$da2a8206311c55a2$var$documentElementObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: [
        "dir",
        "lang"
    ]
});
function $da2a8206311c55a2$export$2332cb3ce32cc839(...translation) {
    translation.map((t)=>{
        const code = t.$code.toLowerCase();
        if ($da2a8206311c55a2$var$translations.has(code)) $da2a8206311c55a2$var$translations.set(code, Object.assign(Object.assign({}, $da2a8206311c55a2$var$translations.get(code)), t));
        else $da2a8206311c55a2$var$translations.set(code, t);
        if (!$da2a8206311c55a2$var$fallback) $da2a8206311c55a2$var$fallback = t;
    });
    $da2a8206311c55a2$var$update();
}
function $da2a8206311c55a2$var$update() {
    $da2a8206311c55a2$var$documentDirection = document.documentElement.dir || "ltr";
    $da2a8206311c55a2$var$documentLanguage = document.documentElement.lang || navigator.language;
    [
        ...$da2a8206311c55a2$var$connectedElements.keys()
    ].map((el)=>{
        if (typeof el.requestUpdate === "function") el.requestUpdate();
    });
}
var $da2a8206311c55a2$export$b1a2fed5bb41b893 = class {
    constructor(host){
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        $da2a8206311c55a2$var$connectedElements.add(this.host);
    }
    hostDisconnected() {
        $da2a8206311c55a2$var$connectedElements.delete(this.host);
    }
    dir() {
        return `${this.host.dir || $da2a8206311c55a2$var$documentDirection}`.toLowerCase();
    }
    lang() {
        return `${this.host.lang || $da2a8206311c55a2$var$documentLanguage}`.toLowerCase();
    }
    getTranslationData(lang) {
        var _a, _b;
        const locale = new Intl.Locale(lang);
        const language = locale === null || locale === void 0 ? void 0 : locale.language.toLowerCase();
        const region = (_b = (_a = locale === null || locale === void 0 ? void 0 : locale.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "";
        const primary = $da2a8206311c55a2$var$translations.get(`${language}-${region}`);
        const secondary = $da2a8206311c55a2$var$translations.get(language);
        return {
            locale: locale,
            language: language,
            region: region,
            primary: primary,
            secondary: secondary
        };
    }
    exists(key, options) {
        var _a;
        const { primary: primary, secondary: secondary } = this.getTranslationData((_a = options.lang) !== null && _a !== void 0 ? _a : this.lang());
        options = Object.assign({
            includeFallback: false
        }, options);
        if (primary && primary[key] || secondary && secondary[key] || options.includeFallback && $da2a8206311c55a2$var$fallback && $da2a8206311c55a2$var$fallback[key]) return true;
        return false;
    }
    term(key, ...args) {
        const { primary: primary, secondary: secondary } = this.getTranslationData(this.lang());
        let term;
        if (primary && primary[key]) term = primary[key];
        else if (secondary && secondary[key]) term = secondary[key];
        else if ($da2a8206311c55a2$var$fallback && $da2a8206311c55a2$var$fallback[key]) term = $da2a8206311c55a2$var$fallback[key];
        else {
            console.error(`No translation found for: ${String(key)}`);
            return String(key);
        }
        if (typeof term === "function") return term(...args);
        return term;
    }
    date(dateToFormat, options) {
        dateToFormat = new Date(dateToFormat);
        return new Intl.DateTimeFormat(this.lang(), options).format(dateToFormat);
    }
    number(numberToFormat, options) {
        numberToFormat = Number(numberToFormat);
        return isNaN(numberToFormat) ? "" : new Intl.NumberFormat(this.lang(), options).format(numberToFormat);
    }
    relativeTime(value, unit, options) {
        return new Intl.RelativeTimeFormat(this.lang(), options).format(value, unit);
    }
};


// src/utilities/localize.ts
var $50ed0f3a96e88fcc$export$b1a2fed5bb41b893 = class extends (0, $da2a8206311c55a2$export$b1a2fed5bb41b893) {
};
// src/translations/en.ts
var $50ed0f3a96e88fcc$var$translation = {
    $code: "en",
    $name: "English",
    $dir: "ltr",
    clearEntry: "Clear entry",
    close: "Close",
    copy: "Copy",
    currentValue: "Current value",
    goToSlide: (slide, count)=>`Go to slide ${slide} of ${count}`,
    hidePassword: "Hide password",
    loading: "Loading",
    nextSlide: "Next slide",
    numOptionsSelected: (num)=>{
        if (num === 0) return "No options selected";
        if (num === 1) return "1 option selected";
        return `${num} options selected`;
    },
    previousSlide: "Previous slide",
    progress: "Progress",
    remove: "Remove",
    resize: "Resize",
    scrollToEnd: "Scroll to end",
    scrollToStart: "Scroll to start",
    selectAColorFromTheScreen: "Select a color from the screen",
    showPassword: "Show password",
    toggleColorFormat: "Toggle color format"
};
(0, $da2a8206311c55a2$export$2332cb3ce32cc839)($50ed0f3a96e88fcc$var$translation);
var $50ed0f3a96e88fcc$export$802b895dc4aecf21 = $50ed0f3a96e88fcc$var$translation;



var $e49e29f9e0bf5d9a$var$__defProp = Object.defineProperty;
var $e49e29f9e0bf5d9a$var$__defProps = Object.defineProperties;
var $e49e29f9e0bf5d9a$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $e49e29f9e0bf5d9a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e49e29f9e0bf5d9a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e49e29f9e0bf5d9a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e49e29f9e0bf5d9a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e49e29f9e0bf5d9a$var$__defNormalProp = (obj, key, value)=>key in obj ? $e49e29f9e0bf5d9a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e49e29f9e0bf5d9a$export$7de063a7aa429f6c = (a, b)=>{
    for(var prop in b || (b = {}))if ($e49e29f9e0bf5d9a$var$__hasOwnProp.call(b, prop)) $e49e29f9e0bf5d9a$var$__defNormalProp(a, prop, b[prop]);
    if ($e49e29f9e0bf5d9a$var$__getOwnPropSymbols) {
        for (var prop of $e49e29f9e0bf5d9a$var$__getOwnPropSymbols(b))if ($e49e29f9e0bf5d9a$var$__propIsEnum.call(b, prop)) $e49e29f9e0bf5d9a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e49e29f9e0bf5d9a$export$f4da8f157c1253f7 = (a, b)=>$e49e29f9e0bf5d9a$var$__defProps(a, $e49e29f9e0bf5d9a$var$__getOwnPropDescs(b));
var $e49e29f9e0bf5d9a$export$f65b024d04874a6 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e49e29f9e0bf5d9a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e49e29f9e0bf5d9a$var$__getOwnPropSymbols) {
        for (var prop of $e49e29f9e0bf5d9a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e49e29f9e0bf5d9a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $e49e29f9e0bf5d9a$export$cd3da3bb63c78796 = (target, all)=>{
    for(var name in all)$e49e29f9e0bf5d9a$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $e49e29f9e0bf5d9a$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $e49e29f9e0bf5d9a$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $e49e29f9e0bf5d9a$var$__defProp(target, key, result);
    return result;
};


// node_modules/@lit/reactive-element/decorators/custom-element.js
var $ccaafd6984b825ef$export$f1e1789686576879 = (e5)=>(n2)=>"function" == typeof n2 ? ((e6, n3)=>(customElements.define(e6, n3), n3))(e5, n2) : ((e6, n3)=>{
            const { kind: t2, elements: s2 } = n3;
            return {
                kind: t2,
                elements: s2,
                finisher (n4) {
                    customElements.define(e6, n4);
                }
            };
        })(e5, n2);
// node_modules/@lit/reactive-element/decorators/property.js
var $ccaafd6984b825ef$var$i = (i3, e5)=>"method" === e5.kind && e5.descriptor && !("value" in e5.descriptor) ? (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, e5), {
        finisher (n2) {
            n2.createProperty(e5.key, i3);
        }
    }) : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e5.key,
        initializer () {
            "function" == typeof e5.initializer && (this[e5.key] = e5.initializer.call(this));
        },
        finisher (n2) {
            n2.createProperty(e5.key, i3);
        }
    };
function $ccaafd6984b825ef$export$5c585649956053b(e5) {
    return (n2, t2)=>void 0 !== t2 ? ((i3, e6, n3)=>{
            e6.constructor.createProperty(n3, i3);
        })(e5, n2, t2) : $ccaafd6984b825ef$var$i(e5, n2);
}
// node_modules/@lit/reactive-element/decorators/state.js
function $ccaafd6984b825ef$export$625550452a3fa3ec(t2) {
    return $ccaafd6984b825ef$export$5c585649956053b((0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, t2), {
        state: true
    }));
}
// node_modules/@lit/reactive-element/decorators/base.js
var $ccaafd6984b825ef$var$o = ({ finisher: e5, descriptor: t2 })=>(o2, n2)=>{
        var r;
        if (void 0 === n2) {
            const n3 = null !== (r = o2.originalKey) && void 0 !== r ? r : o2.key, i3 = null != t2 ? {
                kind: "method",
                placement: "prototype",
                key: n3,
                descriptor: t2(o2.key)
            } : (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, o2), {
                key: n3
            });
            return null != e5 && (i3.finisher = function(t3) {
                e5(t3, n3);
            }), i3;
        }
        {
            const r2 = o2.constructor;
            void 0 !== t2 && Object.defineProperty(o2, n2, t2(n2)), null == e5 || e5(r2, n2);
        }
    };
// node_modules/@lit/reactive-element/decorators/query.js
function $ccaafd6984b825ef$export$23f2a1d2818174ef(i3, n2) {
    return $ccaafd6984b825ef$var$o({
        descriptor: (o2)=>{
            const t2 = {
                get () {
                    var o3, n3;
                    return null !== (n3 = null === (o3 = this.renderRoot) || void 0 === o3 ? void 0 : o3.querySelector(i3)) && void 0 !== n3 ? n3 : null;
                },
                enumerable: true,
                configurable: true
            };
            if (n2) {
                const n3 = "symbol" == typeof o2 ? Symbol() : "__" + o2;
                t2.get = function() {
                    var o3, t3;
                    return void 0 === this[n3] && (this[n3] = null !== (t3 = null === (o3 = this.renderRoot) || void 0 === o3 ? void 0 : o3.querySelector(i3)) && void 0 !== t3 ? t3 : null), this[n3];
                };
            }
            return t2;
        }
    });
}
// node_modules/@lit/reactive-element/decorators/query-async.js
function $ccaafd6984b825ef$export$e6142e6054105de8(e5) {
    return $ccaafd6984b825ef$var$o({
        descriptor: (r)=>({
                async get () {
                    var r2;
                    return await this.updateComplete, null === (r2 = this.renderRoot) || void 0 === r2 ? void 0 : r2.querySelector(e5);
                },
                enumerable: true,
                configurable: true
            })
    });
}
// node_modules/@lit/reactive-element/decorators/query-assigned-elements.js
var $ccaafd6984b825ef$var$n;
var $ccaafd6984b825ef$var$e4 = null != (null === ($ccaafd6984b825ef$var$n = window.HTMLSlotElement) || void 0 === $ccaafd6984b825ef$var$n ? void 0 : $ccaafd6984b825ef$var$n.prototype.assignedElements) ? (o2, n2)=>o2.assignedElements(n2) : (o2, n2)=>o2.assignedNodes(n2).filter((o3)=>o3.nodeType === Node.ELEMENT_NODE);
// src/internal/shoelace-element.ts
var $ccaafd6984b825ef$export$6f25236e887097b = class extends (0, $a726e13e2eca4e53$export$2408f22a0fab9ae5) {
    emit(name, options) {
        const event = new CustomEvent(name, (0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {}
        }, options));
        this.dispatchEvent(event);
        return event;
    }
};
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    $ccaafd6984b825ef$export$5c585649956053b()
], $ccaafd6984b825ef$export$6f25236e887097b.prototype, "dir", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    $ccaafd6984b825ef$export$5c585649956053b()
], $ccaafd6984b825ef$export$6f25236e887097b.prototype, "lang", 2);
 /*! Bundled license information:

@lit/reactive-element/decorators/custom-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/property.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/state.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/base.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-async.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/event-options.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-all.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-nodes.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 



// src/components/breadcrumb/breadcrumb.ts
var $347bd21f4cb3b0b0$export$ad2daa0f973a734d = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $50ed0f3a96e88fcc$export$b1a2fed5bb41b893)(this);
        this.separatorDir = this.localize.dir();
        this.label = "";
    }
    // Generates a clone of the separator element to use for each breadcrumb item
    getSeparator() {
        const separator = this.separatorSlot.assignedElements({
            flatten: true
        })[0];
        const clone = separator.cloneNode(true);
        [
            clone,
            ...clone.querySelectorAll("[id]")
        ].forEach((el)=>el.removeAttribute("id"));
        clone.setAttribute("data-default", "");
        clone.slot = "separator";
        return clone;
    }
    handleSlotChange() {
        const items = [
            ...this.defaultSlot.assignedElements({
                flatten: true
            })
        ].filter((item)=>item.tagName.toLowerCase() === "sl-breadcrumb-item");
        items.forEach((item, index)=>{
            const separator = item.querySelector('[slot="separator"]');
            if (separator === null) item.append(this.getSeparator());
            else if (separator.hasAttribute("data-default")) separator.replaceWith(this.getSeparator());
            if (index === items.length - 1) item.setAttribute("aria-current", "page");
            else item.removeAttribute("aria-current");
        });
    }
    render() {
        if (this.separatorDir !== this.localize.dir()) {
            this.separatorDir = this.localize.dir();
            this.updateComplete.then(()=>this.handleSlotChange());
        }
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
      <nav part="base" class="breadcrumb" aria-label=${this.label}>
        <slot @slotchange=${this.handleSlotChange}></slot>
      </nav>

      <slot name="separator" hidden aria-hidden="true">
        <sl-icon name=${this.localize.dir() === "rtl" ? "chevron-left" : "chevron-right"} library="system"></sl-icon>
      </slot>
    `;
    }
};
$347bd21f4cb3b0b0$export$ad2daa0f973a734d.styles = (0, $4b36324fed99503d$export$1832f44b81141fb4);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)("slot")
], $347bd21f4cb3b0b0$export$ad2daa0f973a734d.prototype, "defaultSlot", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)('slot[name="separator"]')
], $347bd21f4cb3b0b0$export$ad2daa0f973a734d.prototype, "separatorSlot", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $347bd21f4cb3b0b0$export$ad2daa0f973a734d.prototype, "label", 2);
$347bd21f4cb3b0b0$export$ad2daa0f973a734d = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-breadcrumb")
], $347bd21f4cb3b0b0$export$ad2daa0f973a734d);





// src/components/icon/library.system.ts
var $a49aa038ea10c44d$var$icons = {
    caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
    check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
    "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
    "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
    eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
    "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
    indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
    "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
    "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
    radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
    "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
    "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
    "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
};
var $a49aa038ea10c44d$var$systemLibrary = {
    name: "system",
    resolver: (name)=>{
        if (name in $a49aa038ea10c44d$var$icons) return `data:image/svg+xml,${encodeURIComponent($a49aa038ea10c44d$var$icons[name])}`;
        return "";
    }
};
var $a49aa038ea10c44d$export$3139252f9828970f = $a49aa038ea10c44d$var$systemLibrary;


// src/utilities/base-path.ts
var $c3543a8fe00f2f16$var$basePath = "";
function $c3543a8fe00f2f16$export$784ad41d332938c6(path) {
    $c3543a8fe00f2f16$var$basePath = path;
}
function $c3543a8fe00f2f16$export$9099264ed9b1c55a() {
    if (!$c3543a8fe00f2f16$var$basePath) {
        const scripts = [
            ...document.getElementsByTagName("script")
        ];
        const configScript = scripts.find((script)=>script.hasAttribute("data-shoelace"));
        if (configScript) $c3543a8fe00f2f16$export$784ad41d332938c6(configScript.getAttribute("data-shoelace"));
        else {
            const fallbackScript = scripts.find((s)=>/shoelace(\.min)?\.js($|\?)/.test(s.src));
            let path = "";
            if (fallbackScript) path = fallbackScript.getAttribute("src");
            $c3543a8fe00f2f16$export$784ad41d332938c6(path.split("/").slice(0, -1).join("/"));
        }
    }
    return $c3543a8fe00f2f16$var$basePath.replace(/\/$/, "");
}


// src/components/icon/library.default.ts
var $d4af44a48e03ec32$var$library = {
    name: "default",
    resolver: (name)=>`${(0, $c3543a8fe00f2f16$export$9099264ed9b1c55a)()}/assets/icons/${name}.svg`
};
var $d4af44a48e03ec32$export$761783e099ce3526 = $d4af44a48e03ec32$var$library;


// src/components/icon/library.ts
var $341694bf0b023991$var$registry = [
    (0, $d4af44a48e03ec32$export$761783e099ce3526),
    (0, $a49aa038ea10c44d$export$3139252f9828970f)
];
var $341694bf0b023991$var$watchedIcons = [];
function $341694bf0b023991$export$da63f424a7208010(icon) {
    $341694bf0b023991$var$watchedIcons.push(icon);
}
function $341694bf0b023991$export$9e46b25ecab82f0b(icon) {
    $341694bf0b023991$var$watchedIcons = $341694bf0b023991$var$watchedIcons.filter((el)=>el !== icon);
}
function $341694bf0b023991$export$be026de5111f322b(name) {
    return $341694bf0b023991$var$registry.find((lib)=>lib.name === name);
}
function $341694bf0b023991$export$a482e04ad60c9b11(name, options) {
    $341694bf0b023991$export$8faa256e94012669(name);
    $341694bf0b023991$var$registry.push({
        name: name,
        resolver: options.resolver,
        mutator: options.mutator
    });
    $341694bf0b023991$var$watchedIcons.forEach((icon)=>{
        if (icon.library === name) icon.setIcon();
    });
}
function $341694bf0b023991$export$8faa256e94012669(name) {
    $341694bf0b023991$var$registry = $341694bf0b023991$var$registry.filter((lib)=>lib.name !== name);
}


// src/components/include/request.ts
var $b1aaa8125048ce15$var$includeFiles = /* @__PURE__ */ new Map();
function $b1aaa8125048ce15$export$9ffa5ba4f9903370(src, mode = "cors") {
    if ($b1aaa8125048ce15$var$includeFiles.has(src)) return $b1aaa8125048ce15$var$includeFiles.get(src);
    const fileDataPromise = fetch(src, {
        mode: mode
    }).then(async (response)=>{
        return {
            ok: response.ok,
            status: response.status,
            html: await response.text()
        };
    });
    $b1aaa8125048ce15$var$includeFiles.set(src, fileDataPromise);
    return fileDataPromise;
}


// src/components/icon/request.ts
var $da549538bee65227$var$iconFiles = /* @__PURE__ */ new Map();
async function $da549538bee65227$export$148cf4d96f62d603(url) {
    if ($da549538bee65227$var$iconFiles.has(url)) return $da549538bee65227$var$iconFiles.get(url);
    const fileData = await (0, $b1aaa8125048ce15$export$9ffa5ba4f9903370)(url);
    const iconFileData = {
        ok: fileData.ok,
        status: fileData.status,
        svg: null
    };
    if (fileData.ok) {
        const div = document.createElement("div");
        div.innerHTML = fileData.html;
        const svg = div.firstElementChild;
        iconFileData.svg = (svg == null ? void 0 : svg.tagName.toLowerCase()) === "svg" ? svg.outerHTML : "";
    }
    $da549538bee65227$var$iconFiles.set(url, iconFileData);
    return iconFileData;
}




// src/components/icon/icon.styles.ts
var $094978b8f2de73db$export$f0b0874d64866432 = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;



// src/internal/watch.ts
function $cd51242b3c047db3$export$3db5d71bdb2d5499(propertyName, options) {
    const resolvedOptions = (0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({
        waitUntilFirstUpdate: false
    }, options);
    return (proto, decoratedFnName)=>{
        const { update: update } = proto;
        const watchedProperties = Array.isArray(propertyName) ? propertyName : [
            propertyName
        ];
        proto.update = function(changedProps) {
            watchedProperties.forEach((property)=>{
                const key = property;
                if (changedProps.has(key)) {
                    const oldValue = changedProps.get(key);
                    const newValue = this[key];
                    if (oldValue !== newValue) {
                        if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) this[decoratedFnName](oldValue, newValue);
                    }
                }
            });
            update.call(this, changedProps);
        };
    };
}


// node_modules/lit-html/directive.js
var $c261e931c1ebfc35$export$625550452a3fa3ec = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
};
var $c261e931c1ebfc35$export$f1e1789686576879 = (t2)=>(...e2)=>({
            _$litDirective$: t2,
            values: e2
        });
var $c261e931c1ebfc35$export$23f2a1d2818174ef = class {
    constructor(t2){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t2, e2, i2) {
        this._$Ct = t2, this._$AM = e2, this._$Ci = i2;
    }
    _$AS(t2, e2) {
        return this.update(t2, e2);
    }
    update(t2, e2) {
        return this.render(...e2);
    }
};
 /*! Bundled license information:

lit-html/directive.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 




// node_modules/lit-html/directives/unsafe-html.js
var $b52452a275c155e1$var$e4 = class extends (0, $c261e931c1ebfc35$export$23f2a1d2818174ef) {
    constructor(i2){
        if (super(i2), this.it = (0, $a726e13e2eca4e53$export$8b22cf2602fb60ce), i2.type !== (0, $c261e931c1ebfc35$export$625550452a3fa3ec).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $a726e13e2eca4e53$export$8b22cf2602fb60ce) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $a726e13e2eca4e53$export$d141bba7fdc215a3)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
};
$b52452a275c155e1$var$e4.directiveName = "unsafeHTML", $b52452a275c155e1$var$e4.resultType = 1;
var $b52452a275c155e1$export$ae1af26003f05816 = (0, $c261e931c1ebfc35$export$f1e1789686576879)($b52452a275c155e1$var$e4);
// node_modules/lit-html/directives/unsafe-svg.js
var $b52452a275c155e1$var$t3 = class extends $b52452a275c155e1$var$e4 {
};
$b52452a275c155e1$var$t3.directiveName = "unsafeSVG", $b52452a275c155e1$var$t3.resultType = 2;
var $b52452a275c155e1$var$o2 = (0, $c261e931c1ebfc35$export$f1e1789686576879)($b52452a275c155e1$var$t3);
// src/components/icon/icon.ts
var $b52452a275c155e1$var$parser;
var $b52452a275c155e1$export$ef62a86bf282441 = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.svg = "";
        this.label = "";
        this.library = "default";
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $341694bf0b023991$export$da63f424a7208010)(this);
    }
    firstUpdated() {
        this.setIcon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $341694bf0b023991$export$9e46b25ecab82f0b)(this);
    }
    getUrl() {
        const library = (0, $341694bf0b023991$export$be026de5111f322b)(this.library);
        if (this.name && library) return library.resolver(this.name);
        return this.src;
    }
    handleLabelChange() {
        const hasLabel = typeof this.label === "string" && this.label.length > 0;
        if (hasLabel) {
            this.setAttribute("role", "img");
            this.setAttribute("aria-label", this.label);
            this.removeAttribute("aria-hidden");
        } else {
            this.removeAttribute("role");
            this.removeAttribute("aria-label");
            this.setAttribute("aria-hidden", "true");
        }
    }
    async setIcon() {
        var _a;
        const library = (0, $341694bf0b023991$export$be026de5111f322b)(this.library);
        const url = this.getUrl();
        if (!$b52452a275c155e1$var$parser) $b52452a275c155e1$var$parser = new DOMParser();
        if (url) try {
            const file = await (0, $da549538bee65227$export$148cf4d96f62d603)(url);
            if (url !== this.getUrl()) return;
            else if (file.ok) {
                const doc = $b52452a275c155e1$var$parser.parseFromString(file.svg, "text/html");
                const svgEl = doc.body.querySelector("svg");
                if (svgEl !== null) {
                    svgEl.part.add("svg");
                    (_a = library == null ? void 0 : library.mutator) == null || _a.call(library, svgEl);
                    this.svg = svgEl.outerHTML;
                    this.emit("sl-load");
                } else {
                    this.svg = "";
                    this.emit("sl-error");
                }
            } else {
                this.svg = "";
                this.emit("sl-error");
            }
        } catch (e5) {
            this.emit("sl-error");
        }
        else if (this.svg.length > 0) this.svg = "";
    }
    render() {
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)` ${$b52452a275c155e1$var$o2(this.svg)} `;
    }
};
$b52452a275c155e1$export$ef62a86bf282441.styles = (0, $094978b8f2de73db$export$f0b0874d64866432);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$625550452a3fa3ec)()
], $b52452a275c155e1$export$ef62a86bf282441.prototype, "svg", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        reflect: true
    })
], $b52452a275c155e1$export$ef62a86bf282441.prototype, "name", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $b52452a275c155e1$export$ef62a86bf282441.prototype, "src", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $b52452a275c155e1$export$ef62a86bf282441.prototype, "label", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        reflect: true
    })
], $b52452a275c155e1$export$ef62a86bf282441.prototype, "library", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)("label")
], $b52452a275c155e1$export$ef62a86bf282441.prototype, "handleLabelChange", 1);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)([
        "name",
        "src",
        "library"
    ])
], $b52452a275c155e1$export$ef62a86bf282441.prototype, "setIcon", 1);
$b52452a275c155e1$export$ef62a86bf282441 = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-icon")
], $b52452a275c155e1$export$ef62a86bf282441);
 /*! Bundled license information:

lit-html/directives/unsafe-html.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/directives/unsafe-svg.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 


















// src/components/breadcrumb-item/breadcrumb-item.styles.ts
var $8f660b876d6b2180$export$1e076222ea040899 = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    display: inline-flex;
  }

  .breadcrumb-item {
    display: inline-flex;
    align-items: center;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-semibold);
    color: var(--sl-color-neutral-600);
    line-height: var(--sl-line-height-normal);
    white-space: nowrap;
  }

  .breadcrumb-item__label {
    display: inline-block;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    text-decoration: none;
    color: inherit;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: var(--sl-transition-fast) --color;
  }

  :host(:not(:last-of-type)) .breadcrumb-item__label {
    color: var(--sl-color-primary-600);
  }

  :host(:not(:last-of-type)) .breadcrumb-item__label:hover {
    color: var(--sl-color-primary-500);
  }

  :host(:not(:last-of-type)) .breadcrumb-item__label:active {
    color: var(--sl-color-primary-600);
  }

  .breadcrumb-item__label:focus {
    outline: none;
  }

  .breadcrumb-item__label:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .breadcrumb-item__prefix,
  .breadcrumb-item__suffix {
    display: none;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .breadcrumb-item--has-prefix .breadcrumb-item__prefix {
    display: inline-flex;
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .breadcrumb-item--has-suffix .breadcrumb-item__suffix {
    display: inline-flex;
    margin-inline-start: var(--sl-spacing-x-small);
  }

  :host(:last-of-type) .breadcrumb-item__separator {
    display: none;
  }

  .breadcrumb-item__separator {
    display: inline-flex;
    align-items: center;
    margin: 0 var(--sl-spacing-x-small);
    user-select: none;
  }
`;



// node_modules/lit-html/directives/if-defined.js
var $3895cd18908d6544$export$882b5998b3b9117c = (l2)=>null != l2 ? l2 : (0, $a726e13e2eca4e53$export$8b22cf2602fb60ce);
 /*! Bundled license information:

lit-html/directives/if-defined.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 

// src/internal/slot.ts
var $889dad7d494bc02b$export$34f6a5ffaa663541 = class {
    constructor(host, ...slotNames){
        this.slotNames = [];
        (this.host = host).addController(this);
        this.slotNames = slotNames;
        this.handleSlotChange = this.handleSlotChange.bind(this);
    }
    hasDefaultSlot() {
        return [
            ...this.host.childNodes
        ].some((node)=>{
            if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== "") return true;
            if (node.nodeType === node.ELEMENT_NODE) {
                const el = node;
                const tagName = el.tagName.toLowerCase();
                if (tagName === "sl-visually-hidden") return false;
                if (!el.hasAttribute("slot")) return true;
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
    test(slotName) {
        return slotName === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(slotName);
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
    }
    handleSlotChange(event) {
        const slot = event.target;
        if (this.slotNames.includes("[default]") && !slot.name || slot.name && this.slotNames.includes(slot.name)) this.host.requestUpdate();
    }
};
function $889dad7d494bc02b$export$132e79e4118a78e0(slot) {
    if (!slot) return "";
    const nodes = slot.assignedNodes({
        flatten: true
    });
    let text = "";
    [
        ...nodes
    ].forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
    });
    return text;
}




// node_modules/lit-html/directives/class-map.js
var $16b9676b53049ea4$export$ae1af26003f05816 = (0, $c261e931c1ebfc35$export$f1e1789686576879)(class extends (0, $c261e931c1ebfc35$export$23f2a1d2818174ef) {
    constructor(t2){
        var i2;
        if (super(t2), t2.type !== (0, $c261e931c1ebfc35$export$625550452a3fa3ec).ATTRIBUTE || "class" !== t2.name || (null === (i2 = t2.strings) || void 0 === i2 ? void 0 : i2.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t2) {
        return " " + Object.keys(t2).filter((i2)=>t2[i2]).join(" ") + " ";
    }
    update(i2, [s]) {
        var r, o2;
        if (void 0 === this.nt) {
            this.nt = /* @__PURE__ */ new Set(), void 0 !== i2.strings && (this.st = new Set(i2.strings.join(" ").split(/\s/).filter((t2)=>"" !== t2)));
            for(const t2 in s)s[t2] && !(null === (r = this.st) || void 0 === r ? void 0 : r.has(t2)) && this.nt.add(t2);
            return this.render(s);
        }
        const e2 = i2.element.classList;
        this.nt.forEach((t2)=>{
            t2 in s || (e2.remove(t2), this.nt.delete(t2));
        });
        for(const t2 in s){
            const i3 = !!s[t2];
            i3 === this.nt.has(t2) || (null === (o2 = this.st) || void 0 === o2 ? void 0 : o2.has(t2)) || (i3 ? (e2.add(t2), this.nt.add(t2)) : (e2.remove(t2), this.nt.delete(t2)));
        }
        return 0, $a726e13e2eca4e53$export$d141bba7fdc215a3;
    }
});
 /*! Bundled license information:

lit-html/directives/class-map.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 




// src/components/breadcrumb-item/breadcrumb-item.ts
var $9f5bf4c8848ae7c2$export$e01f6a745a6728bd = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $889dad7d494bc02b$export$34f6a5ffaa663541)(this, "prefix", "suffix");
        this.rel = "noreferrer noopener";
    }
    render() {
        const isLink = this.href ? true : false;
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
      <div
        part="base"
        class=${(0, $16b9676b53049ea4$export$ae1af26003f05816)({
            "breadcrumb-item": true,
            "breadcrumb-item--has-prefix": this.hasSlotController.test("prefix"),
            "breadcrumb-item--has-suffix": this.hasSlotController.test("suffix")
        })}
      >
        <slot name="prefix" part="prefix" class="breadcrumb-item__prefix"></slot>

        ${isLink ? (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
              <a
                part="label"
                class="breadcrumb-item__label breadcrumb-item__label--link"
                href="${this.href}"
                target="${(0, $3895cd18908d6544$export$882b5998b3b9117c)(this.target ? this.target : void 0)}"
                rel=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(this.target ? this.rel : void 0)}
              >
                <slot></slot>
              </a>
            ` : (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
              <button part="label" type="button" class="breadcrumb-item__label breadcrumb-item__label--button">
                <slot></slot>
              </button>
            `}

        <slot name="suffix" part="suffix" class="breadcrumb-item__suffix"></slot>

        <slot name="separator" part="separator" class="breadcrumb-item__separator" aria-hidden="true"></slot>
      </div>
    `;
    }
};
$9f5bf4c8848ae7c2$export$e01f6a745a6728bd.styles = (0, $8f660b876d6b2180$export$1e076222ea040899);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $9f5bf4c8848ae7c2$export$e01f6a745a6728bd.prototype, "href", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $9f5bf4c8848ae7c2$export$e01f6a745a6728bd.prototype, "target", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $9f5bf4c8848ae7c2$export$e01f6a745a6728bd.prototype, "rel", 2);
$9f5bf4c8848ae7c2$export$e01f6a745a6728bd = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-breadcrumb-item")
], $9f5bf4c8848ae7c2$export$e01f6a745a6728bd);














// src/internal/form.ts
var $9c21c0ce148b596a$export$61a522b559454891 = /* @__PURE__ */ new WeakMap();
var $9c21c0ce148b596a$var$reportValidityOverloads = /* @__PURE__ */ new WeakMap();
var $9c21c0ce148b596a$var$userInteractedControls = /* @__PURE__ */ new Set();
var $9c21c0ce148b596a$var$interactions = /* @__PURE__ */ new WeakMap();
var $9c21c0ce148b596a$export$43da334182d34ab4 = class {
    constructor(host, options){
        (this.host = host).addController(this);
        this.options = (0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({
            form: (input)=>{
                if (input.hasAttribute("form") && input.getAttribute("form") !== "") {
                    const root = input.getRootNode();
                    const formId = input.getAttribute("form");
                    if (formId) return root.getElementById(formId);
                }
                return input.closest("form");
            },
            name: (input)=>input.name,
            value: (input)=>input.value,
            defaultValue: (input)=>input.defaultValue,
            disabled: (input)=>{
                var _a;
                return (_a = input.disabled) != null ? _a : false;
            },
            reportValidity: (input)=>typeof input.reportValidity === "function" ? input.reportValidity() : true,
            setValue: (input, value)=>input.value = value,
            assumeInteractionOn: [
                "sl-input"
            ]
        }, options);
        this.handleFormData = this.handleFormData.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleFormReset = this.handleFormReset.bind(this);
        this.reportFormValidity = this.reportFormValidity.bind(this);
        this.handleInteraction = this.handleInteraction.bind(this);
    }
    hostConnected() {
        const form = this.options.form(this.host);
        if (form) this.attachForm(form);
        $9c21c0ce148b596a$var$interactions.set(this.host, []);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.addEventListener(event, this.handleInteraction);
        });
    }
    hostDisconnected() {
        this.detachForm();
        $9c21c0ce148b596a$var$interactions.delete(this.host);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.removeEventListener(event, this.handleInteraction);
        });
    }
    hostUpdated() {
        const form = this.options.form(this.host);
        if (!form) this.detachForm();
        if (form && this.form !== form) {
            this.detachForm();
            this.attachForm(form);
        }
        if (this.host.hasUpdated) this.setValidity(this.host.validity.valid);
    }
    attachForm(form) {
        if (form) {
            this.form = form;
            if ($9c21c0ce148b596a$export$61a522b559454891.has(this.form)) $9c21c0ce148b596a$export$61a522b559454891.get(this.form).add(this.host);
            else $9c21c0ce148b596a$export$61a522b559454891.set(this.form, /* @__PURE__ */ new Set([
                this.host
            ]));
            this.form.addEventListener("formdata", this.handleFormData);
            this.form.addEventListener("submit", this.handleFormSubmit);
            this.form.addEventListener("reset", this.handleFormReset);
            if (!$9c21c0ce148b596a$var$reportValidityOverloads.has(this.form)) {
                $9c21c0ce148b596a$var$reportValidityOverloads.set(this.form, this.form.reportValidity);
                this.form.reportValidity = ()=>this.reportFormValidity();
            }
        } else this.form = void 0;
    }
    detachForm() {
        var _a;
        if (this.form) {
            (_a = $9c21c0ce148b596a$export$61a522b559454891.get(this.form)) == null || _a.delete(this.host);
            this.form.removeEventListener("formdata", this.handleFormData);
            this.form.removeEventListener("submit", this.handleFormSubmit);
            this.form.removeEventListener("reset", this.handleFormReset);
            if ($9c21c0ce148b596a$var$reportValidityOverloads.has(this.form)) {
                this.form.reportValidity = $9c21c0ce148b596a$var$reportValidityOverloads.get(this.form);
                $9c21c0ce148b596a$var$reportValidityOverloads.delete(this.form);
            }
        }
        this.form = void 0;
    }
    handleFormData(event) {
        const disabled = this.options.disabled(this.host);
        const name = this.options.name(this.host);
        const value = this.options.value(this.host);
        const isButton = this.host.tagName.toLowerCase() === "sl-button";
        if (!disabled && !isButton && typeof name === "string" && name.length > 0 && typeof value !== "undefined") {
            if (Array.isArray(value)) value.forEach((val)=>{
                event.formData.append(name, val.toString());
            });
            else event.formData.append(name, value.toString());
        }
    }
    handleFormSubmit(event) {
        var _a;
        const disabled = this.options.disabled(this.host);
        const reportValidity = this.options.reportValidity;
        if (this.form && !this.form.noValidate) (_a = $9c21c0ce148b596a$export$61a522b559454891.get(this.form)) == null || _a.forEach((control)=>{
            this.setUserInteracted(control, true);
        });
        if (this.form && !this.form.noValidate && !disabled && !reportValidity(this.host)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
    handleFormReset() {
        this.options.setValue(this.host, this.options.defaultValue(this.host));
        this.setUserInteracted(this.host, false);
        $9c21c0ce148b596a$var$interactions.set(this.host, []);
    }
    handleInteraction(event) {
        const emittedEvents = $9c21c0ce148b596a$var$interactions.get(this.host);
        if (!emittedEvents.includes(event.type)) emittedEvents.push(event.type);
        if (emittedEvents.length === this.options.assumeInteractionOn.length) this.setUserInteracted(this.host, true);
    }
    reportFormValidity() {
        if (this.form && !this.form.noValidate) {
            const elements = this.form.querySelectorAll("*");
            for (const element of elements)if (typeof element.reportValidity === "function") {
                if (!element.reportValidity()) return false;
            }
        }
        return true;
    }
    setUserInteracted(el, hasInteracted) {
        if (hasInteracted) $9c21c0ce148b596a$var$userInteractedControls.add(el);
        else $9c21c0ce148b596a$var$userInteractedControls.delete(el);
        el.requestUpdate();
    }
    doAction(type, invoker) {
        if (this.form) {
            const button = document.createElement("button");
            button.type = type;
            button.style.position = "absolute";
            button.style.width = "0";
            button.style.height = "0";
            button.style.clipPath = "inset(50%)";
            button.style.overflow = "hidden";
            button.style.whiteSpace = "nowrap";
            if (invoker) {
                button.name = invoker.name;
                button.value = invoker.value;
                [
                    "formaction",
                    "formenctype",
                    "formmethod",
                    "formnovalidate",
                    "formtarget"
                ].forEach((attr)=>{
                    if (invoker.hasAttribute(attr)) button.setAttribute(attr, invoker.getAttribute(attr));
                });
            }
            this.form.append(button);
            button.click();
            button.remove();
        }
    }
    /** Returns the associated `<form>` element, if one exists. */ getForm() {
        var _a;
        return (_a = this.form) != null ? _a : null;
    }
    /** Resets the form, restoring all the control to their default value */ reset(invoker) {
        this.doAction("reset", invoker);
    }
    /** Submits the form, triggering validation and form data injection. */ submit(invoker) {
        this.doAction("submit", invoker);
    }
    /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */ setValidity(isValid) {
        const host = this.host;
        const hasInteracted = Boolean($9c21c0ce148b596a$var$userInteractedControls.has(host));
        const required = Boolean(host.required);
        host.toggleAttribute("data-required", required);
        host.toggleAttribute("data-optional", !required);
        host.toggleAttribute("data-invalid", !isValid);
        host.toggleAttribute("data-valid", isValid);
        host.toggleAttribute("data-user-invalid", !isValid && hasInteracted);
        host.toggleAttribute("data-user-valid", isValid && hasInteracted);
    }
    /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */ updateValidity() {
        const host = this.host;
        this.setValidity(host.validity.valid);
    }
    /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */ emitInvalidEvent(originalInvalidEvent) {
        const slInvalidEvent = new CustomEvent("sl-invalid", {
            bubbles: false,
            composed: false,
            cancelable: true,
            detail: {}
        });
        if (!originalInvalidEvent) slInvalidEvent.preventDefault();
        if (!this.host.dispatchEvent(slInvalidEvent)) originalInvalidEvent == null || originalInvalidEvent.preventDefault();
    }
};
var $9c21c0ce148b596a$export$6c5960ddf0f5ff89 = Object.freeze({
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valid: true,
    valueMissing: false
});
var $9c21c0ce148b596a$export$bd584164a4d1886c = Object.freeze((0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, $9c21c0ce148b596a$export$6c5960ddf0f5ff89), {
    valid: false,
    valueMissing: true
}));
var $9c21c0ce148b596a$export$d17679f2bc5863d4 = Object.freeze((0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, $9c21c0ce148b596a$export$6c5960ddf0f5ff89), {
    valid: false,
    customError: true
}));




// src/components/button/button.styles.ts
var $b294225c31231d9c$export$172eea9c07ee1ffd = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    display: inline-block;
    position: relative;
    width: auto;
    cursor: pointer;
  }

  .button {
    display: inline-flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    border-style: solid;
    border-width: var(--sl-input-border-width);
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-font-weight-semibold);
    text-decoration: none;
    user-select: none;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0;
    transition: var(--sl-transition-x-fast) background-color, var(--sl-transition-x-fast) color,
      var(--sl-transition-x-fast) border, var(--sl-transition-x-fast) box-shadow;
    cursor: inherit;
  }

  .button::-moz-focus-inner {
    border: 0;
  }

  .button:focus {
    outline: none;
  }

  .button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When disabled, prevent mouse events from bubbling up from children */
  .button--disabled * {
    pointer-events: none;
  }

  .button__prefix,
  .button__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .button__label {
    display: inline-block;
  }

  .button__label::slotted(sl-icon) {
    vertical-align: -2px;
  }

  /*
   * Standard buttons
   */

  /* Default */
  .button--standard.button--default {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-neutral-300);
    color: var(--sl-color-neutral-700);
  }

  .button--standard.button--default:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-300);
    color: var(--sl-color-primary-700);
  }

  .button--standard.button--default:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-100);
    border-color: var(--sl-color-primary-400);
    color: var(--sl-color-primary-700);
  }

  /* Primary */
  .button--standard.button--primary {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--standard.button--success {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:hover:not(.button--disabled) {
    background-color: var(--sl-color-success-500);
    border-color: var(--sl-color-success-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:active:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--standard.button--neutral {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:hover:not(.button--disabled) {
    background-color: var(--sl-color-neutral-500);
    border-color: var(--sl-color-neutral-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:active:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--standard.button--warning {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }
  .button--standard.button--warning:hover:not(.button--disabled) {
    background-color: var(--sl-color-warning-500);
    border-color: var(--sl-color-warning-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--warning:active:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--standard.button--danger {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:hover:not(.button--disabled) {
    background-color: var(--sl-color-danger-500);
    border-color: var(--sl-color-danger-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:active:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  /*
   * Outline buttons
   */

  .button--outline {
    background: none;
    border: solid 1px;
  }

  /* Default */
  .button--outline.button--default {
    border-color: var(--sl-color-neutral-300);
    color: var(--sl-color-neutral-700);
  }

  .button--outline.button--default:hover:not(.button--disabled),
  .button--outline.button--default.button--checked:not(.button--disabled) {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--default:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Primary */
  .button--outline.button--primary {
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-primary-600);
  }

  .button--outline.button--primary:hover:not(.button--disabled),
  .button--outline.button--primary.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--primary:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--outline.button--success {
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-success-600);
  }

  .button--outline.button--success:hover:not(.button--disabled),
  .button--outline.button--success.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--success:active:not(.button--disabled) {
    border-color: var(--sl-color-success-700);
    background-color: var(--sl-color-success-700);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--outline.button--neutral {
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-600);
  }

  .button--outline.button--neutral:hover:not(.button--disabled),
  .button--outline.button--neutral.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--neutral:active:not(.button--disabled) {
    border-color: var(--sl-color-neutral-700);
    background-color: var(--sl-color-neutral-700);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--outline.button--warning {
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-warning-600);
  }

  .button--outline.button--warning:hover:not(.button--disabled),
  .button--outline.button--warning.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--warning:active:not(.button--disabled) {
    border-color: var(--sl-color-warning-700);
    background-color: var(--sl-color-warning-700);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--outline.button--danger {
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-danger-600);
  }

  .button--outline.button--danger:hover:not(.button--disabled),
  .button--outline.button--danger.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--danger:active:not(.button--disabled) {
    border-color: var(--sl-color-danger-700);
    background-color: var(--sl-color-danger-700);
    color: var(--sl-color-neutral-0);
  }

  @media (forced-colors: active) {
    .button.button--outline.button--checked:not(.button--disabled) {
      outline: solid 2px transparent;
    }
  }

  /*
   * Text buttons
   */

  .button--text {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-600);
  }

  .button--text:hover:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:focus-visible:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:active:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-700);
  }

  /*
   * Size modifiers
   */

  .button--small {
    font-size: var(--sl-button-font-size-small);
    height: var(--sl-input-height-small);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
  }

  .button--medium {
    font-size: var(--sl-button-font-size-medium);
    height: var(--sl-input-height-medium);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
  }

  .button--large {
    font-size: var(--sl-button-font-size-large);
    height: var(--sl-input-height-large);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
  }

  /*
   * Pill modifier
   */

  .button--pill.button--small {
    border-radius: var(--sl-input-height-small);
  }

  .button--pill.button--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .button--pill.button--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Circle modifier
   */

  .button--circle {
    padding-left: 0;
    padding-right: 0;
  }

  .button--circle.button--small {
    width: var(--sl-input-height-small);
    border-radius: 50%;
  }

  .button--circle.button--medium {
    width: var(--sl-input-height-medium);
    border-radius: 50%;
  }

  .button--circle.button--large {
    width: var(--sl-input-height-large);
    border-radius: 50%;
  }

  .button--circle .button__prefix,
  .button--circle .button__suffix,
  .button--circle .button__caret {
    display: none;
  }

  /*
   * Caret modifier
   */

  .button--caret .button__suffix {
    display: none;
  }

  .button--caret .button__caret {
    height: auto;
  }

  /*
   * Loading modifier
   */

  .button--loading {
    position: relative;
    cursor: wait;
  }

  .button--loading .button__prefix,
  .button--loading .button__label,
  .button--loading .button__suffix,
  .button--loading .button__caret {
    visibility: hidden;
  }

  .button--loading sl-spinner {
    --indicator-color: currentColor;
    position: absolute;
    font-size: 1em;
    height: 1em;
    width: 1em;
    top: calc(50% - 0.5em);
    left: calc(50% - 0.5em);
  }

  /*
   * Badges
   */

  .button ::slotted(sl-badge) {
    position: absolute;
    top: 0;
    right: 0;
    translate: 50% -50%;
    pointer-events: none;
  }

  .button--rtl ::slotted(sl-badge) {
    right: auto;
    left: 0;
    translate: -50% -50%;
  }

  /*
   * Button spacing
   */

  .button--has-label.button--small .button__label {
    padding: 0 var(--sl-spacing-small);
  }

  .button--has-label.button--medium .button__label {
    padding: 0 var(--sl-spacing-medium);
  }

  .button--has-label.button--large .button__label {
    padding: 0 var(--sl-spacing-large);
  }

  .button--has-prefix.button--small {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--small .button__label {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--medium {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--medium .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-suffix.button--small,
  .button--caret.button--small {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--small .button__label,
  .button--caret.button--small .button__label {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--medium,
  .button--caret.button--medium {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--medium .button__label,
  .button--caret.button--medium .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large,
  .button--caret.button--large {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large .button__label,
  .button--caret.button--large .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  /*
   * Button groups support a variety of button types (e.g. buttons with tooltips, buttons as dropdown triggers, etc.).
   * This means buttons aren't always direct descendants of the button group, thus we can't target them with the
   * ::slotted selector. To work around this, the button group component does some magic to add these special classes to
   * buttons and we style them here instead.
   */

  :host(.sl-button-group__button--first:not(.sl-button-group__button--last)) .button {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }

  :host(.sl-button-group__button--inner) .button {
    border-radius: 0;
  }

  :host(.sl-button-group__button--last:not(.sl-button-group__button--first)) .button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }

  /* All except the first */
  :host(.sl-button-group__button:not(.sl-button-group__button--first)) {
    margin-inline-start: calc(-1 * var(--sl-input-border-width));
  }

  /* Add a visual separator between solid buttons */
  :host(
      .sl-button-group__button:not(
          .sl-button-group__button--first,
          .sl-button-group__button--radio,
          [variant='default']
        ):not(:hover)
    )
    .button:after {
    content: '';
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    bottom: 0;
    border-left: solid 1px rgb(128 128 128 / 33%);
    mix-blend-mode: multiply;
  }

  /* Bump hovered, focused, and checked buttons up so their focus ring isn't clipped */
  :host(.sl-button-group__button--hover) {
    z-index: 1;
  }

  /* Focus and checked are always on top */
  :host(.sl-button-group__button--focus),
  :host(.sl-button-group__button[checked]) {
    z-index: 2;
  }
`;



// node_modules/lit-html/static.js
var $3b0a1705f9eec9f0$var$e = Symbol.for("");
var $3b0a1705f9eec9f0$var$l = (t)=>{
    if ((null == t ? void 0 : t.r) === $3b0a1705f9eec9f0$var$e) return null == t ? void 0 : t._$litStatic$;
};
var $3b0a1705f9eec9f0$export$23f2a1d2818174ef = (t, ...r)=>({
        _$litStatic$: r.reduce((r2, e2, l2)=>r2 + ((t2)=>{
                if (void 0 !== t2._$litStatic$) return t2._$litStatic$;
                throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t2}. Use 'unsafeStatic' to pass non-literal values, but
            take care to ensure page security.`);
            })(e2) + t[l2 + 1], t[0]),
        r: $3b0a1705f9eec9f0$var$e
    });
var $3b0a1705f9eec9f0$var$s = /* @__PURE__ */ new Map();
var $3b0a1705f9eec9f0$var$a = (t)=>(r, ...e2)=>{
        const o = e2.length;
        let i2, a2;
        const n2 = [], u2 = [];
        let c, $ = 0, f = false;
        for(; $ < o;){
            for(c = r[$]; $ < o && void 0 !== (a2 = e2[$], i2 = $3b0a1705f9eec9f0$var$l(a2));)c += i2 + r[++$], f = true;
            u2.push(a2), n2.push(c), $++;
        }
        if ($ === o && n2.push(r[o]), f) {
            const t2 = n2.join("$$lit$$");
            void 0 === (r = $3b0a1705f9eec9f0$var$s.get(t2)) && (n2.raw = n2, $3b0a1705f9eec9f0$var$s.set(t2, r = n2)), e2 = u2;
        }
        return t(r, ...e2);
    };
var $3b0a1705f9eec9f0$export$7ccc53e8f1e7dfc5 = $3b0a1705f9eec9f0$var$a((0, $a726e13e2eca4e53$export$4a5767248b18ef41));
var $3b0a1705f9eec9f0$var$u = $3b0a1705f9eec9f0$var$a((0, $a726e13e2eca4e53$export$efccba1c4a2ef57b));
 /*! Bundled license information:

lit-html/static.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 








// src/components/button/button.ts
var $fcc9d0c49feca6c4$export$e56d306ebf763f31 = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $9c21c0ce148b596a$export$43da334182d34ab4)(this, {
            form: (input)=>{
                if (input.hasAttribute("form")) {
                    const doc = input.getRootNode();
                    const formId = input.getAttribute("form");
                    return doc.getElementById(formId);
                }
                return input.closest("form");
            },
            assumeInteractionOn: [
                "click"
            ]
        });
        this.hasSlotController = new (0, $889dad7d494bc02b$export$34f6a5ffaa663541)(this, "[default]", "prefix", "suffix");
        this.localize = new (0, $50ed0f3a96e88fcc$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.invalid = false;
        this.title = "";
        this.variant = "default";
        this.size = "medium";
        this.caret = false;
        this.disabled = false;
        this.loading = false;
        this.outline = false;
        this.pill = false;
        this.circle = false;
        this.type = "button";
        this.name = "";
        this.value = "";
        this.href = "";
        this.rel = "noreferrer noopener";
    }
    /** Gets the validity state object */ get validity() {
        if (this.isButton()) return this.button.validity;
        return 0, $9c21c0ce148b596a$export$6c5960ddf0f5ff89;
    }
    /** Gets the validation message */ get validationMessage() {
        if (this.isButton()) return this.button.validationMessage;
        return "";
    }
    connectedCallback() {
        super.connectedCallback();
        this.handleHostClick = this.handleHostClick.bind(this);
        this.addEventListener("click", this.handleHostClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("click", this.handleHostClick);
    }
    firstUpdated() {
        if (this.isButton()) this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick() {
        if (this.type === "submit") this.formControlController.submit(this);
        if (this.type === "reset") this.formControlController.reset(this);
    }
    handleHostClick(event) {
        if (this.disabled || this.loading) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    isButton() {
        return this.href ? false : true;
    }
    isLink() {
        return this.href ? true : false;
    }
    handleDisabledChange() {
        if (this.isButton()) this.formControlController.setValidity(this.disabled);
    }
    /** Simulates a click on the button. */ click() {
        this.button.click();
    }
    /** Sets focus on the button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the button. */ blur() {
        this.button.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        if (this.isButton()) return this.button.checkValidity();
        return true;
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        if (this.isButton()) return this.button.reportValidity();
        return true;
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        if (this.isButton()) {
            this.button.setCustomValidity(message);
            this.formControlController.updateValidity();
        }
    }
    render() {
        const isLink = this.isLink();
        const tag = isLink ? (0, $3b0a1705f9eec9f0$export$23f2a1d2818174ef)`a` : (0, $3b0a1705f9eec9f0$export$23f2a1d2818174ef)`button`;
        return (0, $3b0a1705f9eec9f0$export$7ccc53e8f1e7dfc5)`
      <${tag}
        part="base"
        class=${(0, $16b9676b53049ea4$export$ae1af26003f05816)({
            button: true,
            "button--default": this.variant === "default",
            "button--primary": this.variant === "primary",
            "button--success": this.variant === "success",
            "button--neutral": this.variant === "neutral",
            "button--warning": this.variant === "warning",
            "button--danger": this.variant === "danger",
            "button--text": this.variant === "text",
            "button--small": this.size === "small",
            "button--medium": this.size === "medium",
            "button--large": this.size === "large",
            "button--caret": this.caret,
            "button--circle": this.circle,
            "button--disabled": this.disabled,
            "button--focused": this.hasFocus,
            "button--loading": this.loading,
            "button--standard": !this.outline,
            "button--outline": this.outline,
            "button--pill": this.pill,
            "button--rtl": this.localize.dir() === "rtl",
            "button--has-label": this.hasSlotController.test("[default]"),
            "button--has-prefix": this.hasSlotController.test("prefix"),
            "button--has-suffix": this.hasSlotController.test("suffix")
        })}
        ?disabled=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? void 0 : this.disabled)}
        type=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? void 0 : this.type)}
        title=${this.title}
        name=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? void 0 : this.name)}
        value=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? void 0 : this.value)}
        href=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? this.href : void 0)}
        target=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? this.target : void 0)}
        download=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? this.download : void 0)}
        rel=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? this.rel : void 0)}
        role=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="prefix" part="prefix" class="button__prefix"></slot>
        <slot part="label" class="button__label"></slot>
        <slot name="suffix" part="suffix" class="button__suffix"></slot>
        ${this.caret ? (0, $3b0a1705f9eec9f0$export$7ccc53e8f1e7dfc5)` <sl-icon part="caret" class="button__caret" library="system" name="caret"></sl-icon> ` : ""}
        ${this.loading ? (0, $3b0a1705f9eec9f0$export$7ccc53e8f1e7dfc5)`<sl-spinner></sl-spinner>` : ""}
      </${tag}>
    `;
    }
};
$fcc9d0c49feca6c4$export$e56d306ebf763f31.styles = (0, $b294225c31231d9c$export$172eea9c07ee1ffd);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)(".button")
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "button", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$625550452a3fa3ec)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "hasFocus", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$625550452a3fa3ec)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "invalid", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "title", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        reflect: true
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "variant", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        reflect: true
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "size", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "caret", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "disabled", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "loading", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "outline", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "pill", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "circle", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "type", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "name", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "value", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "href", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "target", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "rel", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "download", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "form", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "formaction"
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "formAction", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "formenctype"
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "formEnctype", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "formmethod"
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "formMethod", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "formnovalidate",
        type: Boolean
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "formNoValidate", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "formtarget"
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "formTarget", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $fcc9d0c49feca6c4$export$e56d306ebf763f31.prototype, "handleDisabledChange", 1);
$fcc9d0c49feca6c4$export$e56d306ebf763f31 = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-button")
], $fcc9d0c49feca6c4$export$e56d306ebf763f31);




// src/components/spinner/spinner.styles.ts
var $6d2c5598d91f7a6b$export$6a9ed4d91972acb3 = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    --track-width: 2px;
    --track-color: rgb(128 128 128 / 25%);
    --indicator-color: var(--sl-color-primary-600);
    --speed: 2s;

    display: inline-flex;
    width: 1em;
    height: 1em;
  }

  .spinner {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .spinner__track,
  .spinner__indicator {
    fill: none;
    stroke-width: var(--track-width);
    r: calc(0.5em - var(--track-width) / 2);
    cx: 0.5em;
    cy: 0.5em;
    transform-origin: 50% 50%;
  }

  .spinner__track {
    stroke: var(--track-color);
    transform-origin: 0% 0%;
  }

  .spinner__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    stroke-dasharray: 150% 75%;
    animation: spin var(--speed) linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      stroke-dasharray: 0.01em, 2.75em;
    }

    50% {
      transform: rotate(450deg);
      stroke-dasharray: 1.375em, 1.375em;
    }

    100% {
      transform: rotate(1080deg);
      stroke-dasharray: 0.01em, 2.75em;
    }
  }
`;






// src/components/spinner/spinner.ts
var $f166debd41d5f5ee$export$4e45ce56e46d2b00 = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $50ed0f3a96e88fcc$export$b1a2fed5bb41b893)(this);
    }
    render() {
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
      <svg part="base" class="spinner" role="progressbar" aria-valuetext=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
    }
};
$f166debd41d5f5ee$export$4e45ce56e46d2b00.styles = (0, $6d2c5598d91f7a6b$export$6a9ed4d91972acb3);
$f166debd41d5f5ee$export$4e45ce56e46d2b00 = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-spinner")
], $f166debd41d5f5ee$export$4e45ce56e46d2b00);





























// src/components/card/card.styles.ts
var $696b66001a458e88$export$eceb153d0f9bbd93 = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    --border-color: var(--sl-color-neutral-200);
    --border-radius: var(--sl-border-radius-medium);
    --border-width: 1px;
    --padding: var(--sl-spacing-large);

    display: inline-block;
  }

  .card {
    display: flex;
    flex-direction: column;
    background-color: var(--sl-panel-background-color);
    box-shadow: var(--sl-shadow-x-small);
    border: solid var(--border-width) var(--border-color);
    border-radius: var(--border-radius);
  }

  .card__image {
    display: flex;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    margin: calc(-1 * var(--border-width));
    overflow: hidden;
  }

  .card__image::slotted(img) {
    display: block;
    width: 100%;
  }

  .card:not(.card--has-image) .card__image {
    display: none;
  }

  .card__header {
    display: block;
    border-bottom: solid var(--border-width) var(--border-color);
    padding: calc(var(--padding) / 2) var(--padding);
  }

  .card:not(.card--has-header) .card__header {
    display: none;
  }

  .card:not(.card--has-image) .card__header {
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
  }

  .card__body {
    display: block;
    padding: var(--padding);
  }

  .card--has-footer .card__footer {
    display: block;
    border-top: solid var(--border-width) var(--border-color);
    padding: var(--padding);
  }

  .card:not(.card--has-footer) .card__footer {
    display: none;
  }
`;







// src/components/card/card.ts
var $b1108cce0f47d1e0$export$a93c76cb301d0cc8 = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $889dad7d494bc02b$export$34f6a5ffaa663541)(this, "footer", "header", "image");
    }
    render() {
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
      <div
        part="base"
        class=${(0, $16b9676b53049ea4$export$ae1af26003f05816)({
            card: true,
            "card--has-footer": this.hasSlotController.test("footer"),
            "card--has-image": this.hasSlotController.test("image"),
            "card--has-header": this.hasSlotController.test("header")
        })}
      >
        <slot name="image" part="image" class="card__image"></slot>
        <slot name="header" part="header" class="card__header"></slot>
        <slot part="body" class="card__body"></slot>
        <slot name="footer" part="footer" class="card__footer"></slot>
      </div>
    `;
    }
};
$b1108cce0f47d1e0$export$a93c76cb301d0cc8.styles = (0, $696b66001a458e88$export$eceb153d0f9bbd93);
$b1108cce0f47d1e0$export$a93c76cb301d0cc8 = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-card")
], $b1108cce0f47d1e0$export$a93c76cb301d0cc8);






























// src/components/icon-button/icon-button.styles.ts
var $6f1fe5d162ee3dae$export$e7174f10cedebf49 = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    display: inline-block;
    color: var(--sl-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--sl-color-primary-600);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--sl-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;







// src/components/icon-button/icon-button.ts
var $4d56e8bd2ce5debb$export$302c9d29315a4659 = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasFocus = false;
        this.label = "";
        this.disabled = false;
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /** Simulates a click on the icon button. */ click() {
        this.button.click();
    }
    /** Sets focus on the icon button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the icon button. */ blur() {
        this.button.blur();
    }
    render() {
        const isLink = this.href ? true : false;
        const tag = isLink ? (0, $3b0a1705f9eec9f0$export$23f2a1d2818174ef)`a` : (0, $3b0a1705f9eec9f0$export$23f2a1d2818174ef)`button`;
        return (0, $3b0a1705f9eec9f0$export$7ccc53e8f1e7dfc5)`
      <${tag}
        part="base"
        class=${(0, $16b9676b53049ea4$export$ae1af26003f05816)({
            "icon-button": true,
            "icon-button--disabled": !isLink && this.disabled,
            "icon-button--focused": this.hasFocus
        })}
        ?disabled=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? void 0 : this.disabled)}
        type=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? void 0 : "button")}
        href=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? this.href : void 0)}
        target=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? this.target : void 0)}
        download=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? this.download : void 0)}
        rel=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink && this.target ? "noreferrer noopener" : void 0)}
        role=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="${this.label}"
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <sl-icon
          class="icon-button__icon"
          name=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(this.name)}
          library=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(this.library)}
          src=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(this.src)}
          aria-hidden="true"
        ></sl-icon>
      </${tag}>
    `;
    }
};
$4d56e8bd2ce5debb$export$302c9d29315a4659.styles = (0, $6f1fe5d162ee3dae$export$e7174f10cedebf49);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)(".icon-button")
], $4d56e8bd2ce5debb$export$302c9d29315a4659.prototype, "button", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$625550452a3fa3ec)()
], $4d56e8bd2ce5debb$export$302c9d29315a4659.prototype, "hasFocus", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $4d56e8bd2ce5debb$export$302c9d29315a4659.prototype, "name", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $4d56e8bd2ce5debb$export$302c9d29315a4659.prototype, "library", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $4d56e8bd2ce5debb$export$302c9d29315a4659.prototype, "src", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $4d56e8bd2ce5debb$export$302c9d29315a4659.prototype, "href", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $4d56e8bd2ce5debb$export$302c9d29315a4659.prototype, "target", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $4d56e8bd2ce5debb$export$302c9d29315a4659.prototype, "download", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $4d56e8bd2ce5debb$export$302c9d29315a4659.prototype, "label", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $4d56e8bd2ce5debb$export$302c9d29315a4659.prototype, "disabled", 2);
$4d56e8bd2ce5debb$export$302c9d29315a4659 = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-icon-button")
], $4d56e8bd2ce5debb$export$302c9d29315a4659);
























// src/components/menu/menu.styles.ts
var $5b61e69304ca2141$export$c7293b7882f2b3d4 = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    display: block;
    position: relative;
    background: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-radius: var(--sl-border-radius-medium);
    padding: var(--sl-spacing-x-small) 0;
    overflow: auto;
    overscroll-behavior: none;
  }

  ::slotted(sl-divider) {
    --spacing: var(--sl-spacing-x-small);
  }
`;





// src/components/menu/menu.ts
var $6b7d0c471f5635fa$export$59279638cac230bf = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "menu");
    }
    handleClick(event) {
        const target = event.target;
        const item = target.closest("sl-menu-item");
        if (!item || item.disabled || item.inert) return;
        if (item.type === "checkbox") item.checked = !item.checked;
        this.emit("sl-select", {
            detail: {
                item: item
            }
        });
    }
    handleKeyDown(event) {
        if (event.key === "Enter") {
            const item = this.getCurrentItem();
            event.preventDefault();
            item == null || item.click();
        }
        if (event.key === " ") event.preventDefault();
        if ([
            "ArrowDown",
            "ArrowUp",
            "Home",
            "End"
        ].includes(event.key)) {
            const items = this.getAllItems();
            const activeItem = this.getCurrentItem();
            let index = activeItem ? items.indexOf(activeItem) : 0;
            if (items.length > 0) {
                event.preventDefault();
                if (event.key === "ArrowDown") index++;
                else if (event.key === "ArrowUp") index--;
                else if (event.key === "Home") index = 0;
                else if (event.key === "End") index = items.length - 1;
                if (index < 0) index = items.length - 1;
                if (index > items.length - 1) index = 0;
                this.setCurrentItem(items[index]);
                items[index].focus();
            }
        }
    }
    handleMouseDown(event) {
        const target = event.target;
        if (this.isMenuItem(target)) this.setCurrentItem(target);
    }
    handleSlotChange() {
        const items = this.getAllItems();
        if (items.length > 0) this.setCurrentItem(items[0]);
    }
    isMenuItem(item) {
        var _a;
        return item.tagName.toLowerCase() === "sl-menu-item" || [
            "menuitem",
            "menuitemcheckbox",
            "menuitemradio"
        ].includes((_a = item.getAttribute("role")) != null ? _a : "");
    }
    /** @internal Gets all slotted menu items, ignoring dividers, headers, and other elements. */ getAllItems() {
        return [
            ...this.defaultSlot.assignedElements({
                flatten: true
            })
        ].filter((el)=>{
            if (el.inert || !this.isMenuItem(el)) return false;
            return true;
        });
    }
    /**
   * @internal Gets the current menu item, which is the menu item that has `tabindex="0"` within the roving tab index.
   * The menu item may or may not have focus, but for keyboard interaction purposes it's considered the "active" item.
   */ getCurrentItem() {
        return this.getAllItems().find((i2)=>i2.getAttribute("tabindex") === "0");
    }
    /**
   * @internal Sets the current menu item to the specified element. This sets `tabindex="0"` on the target element and
   * `tabindex="-1"` to all other items. This method must be called prior to setting focus on a menu item.
   */ setCurrentItem(item) {
        const items = this.getAllItems();
        items.forEach((i2)=>{
            i2.setAttribute("tabindex", i2 === item ? "0" : "-1");
        });
    }
    render() {
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
      <slot
        @slotchange=${this.handleSlotChange}
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
        @mousedown=${this.handleMouseDown}
      ></slot>
    `;
    }
};
$6b7d0c471f5635fa$export$59279638cac230bf.styles = (0, $5b61e69304ca2141$export$c7293b7882f2b3d4);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)("slot")
], $6b7d0c471f5635fa$export$59279638cac230bf.prototype, "defaultSlot", 2);
$6b7d0c471f5635fa$export$59279638cac230bf = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-menu")
], $6b7d0c471f5635fa$export$59279638cac230bf);











// src/components/menu-item/menu-item.styles.ts
var $22322d2de317de2c$export$39d657da2cf50eaf = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    display: block;
  }

  :host([inert]) {
    display: none;
  }

  .menu-item {
    position: relative;
    display: flex;
    align-items: stretch;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-letter-spacing-normal);
    color: var(--sl-color-neutral-700);
    padding: var(--sl-spacing-2x-small) var(--sl-spacing-2x-small);
    transition: var(--sl-transition-fast) fill;
    user-select: none;
    white-space: nowrap;
    cursor: pointer;
  }

  .menu-item.menu-item--disabled {
    outline: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .menu-item .menu-item__label {
    flex: 1 1 auto;
    display: inline-block;
  }

  .menu-item .menu-item__prefix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .menu-item .menu-item__prefix::slotted(*) {
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .menu-item .menu-item__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .menu-item .menu-item__suffix::slotted(*) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  :host(:focus-visible) {
    outline: none;
  }

  :host(:hover:not([aria-disabled='true'])) .menu-item {
    background-color: var(--sl-color-neutral-100);
    color: var(--sl-color-neutral-1000);
  }

  :host(:focus-visible) .menu-item {
    outline: none;
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
    opacity: 1;
  }

  .menu-item .menu-item__check,
  .menu-item .menu-item__chevron {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5em;
    visibility: hidden;
  }

  .menu-item--checked .menu-item__check,
  .menu-item--has-submenu .menu-item__chevron {
    visibility: visible;
  }

  @media (forced-colors: active) {
    :host(:hover:not([aria-disabled='true'])) .menu-item,
    :host(:focus-visible) .menu-item {
      outline: dashed 1px SelectedItem;
      outline-offset: -1px;
    }
  }
`;








// src/components/menu-item/menu-item.ts
var $d9da14b52d0f25df$export$bd1a667628462930 = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.type = "normal";
        this.checked = false;
        this.value = "";
        this.disabled = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.handleHostClick = this.handleHostClick.bind(this);
        this.addEventListener("click", this.handleHostClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("click", this.handleHostClick);
    }
    handleDefaultSlotChange() {
        const textLabel = this.getTextLabel();
        if (typeof this.cachedTextLabel === "undefined") {
            this.cachedTextLabel = textLabel;
            return;
        }
        if (textLabel !== this.cachedTextLabel) {
            this.cachedTextLabel = textLabel;
            this.emit("slotchange", {
                bubbles: true,
                composed: false,
                cancelable: false
            });
        }
    }
    handleHostClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
    handleCheckedChange() {
        if (this.checked && this.type !== "checkbox") {
            this.checked = false;
            console.error('The checked attribute can only be used on menu items with type="checkbox"', this);
            return;
        }
        if (this.type === "checkbox") this.setAttribute("aria-checked", this.checked ? "true" : "false");
        else this.removeAttribute("aria-checked");
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    handleTypeChange() {
        if (this.type === "checkbox") {
            this.setAttribute("role", "menuitemcheckbox");
            this.setAttribute("aria-checked", this.checked ? "true" : "false");
        } else {
            this.setAttribute("role", "menuitem");
            this.removeAttribute("aria-checked");
        }
    }
    /** Returns a text label based on the contents of the menu item's default slot. */ getTextLabel() {
        return (0, $889dad7d494bc02b$export$132e79e4118a78e0)(this.defaultSlot);
    }
    render() {
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
      <div
        part="base"
        class=${(0, $16b9676b53049ea4$export$ae1af26003f05816)({
            "menu-item": true,
            "menu-item--checked": this.checked,
            "menu-item--disabled": this.disabled,
            "menu-item--has-submenu": false
        })}
      >
        <span part="checked-icon" class="menu-item__check">
          <sl-icon name="check" library="system" aria-hidden="true"></sl-icon>
        </span>

        <slot name="prefix" part="prefix" class="menu-item__prefix"></slot>

        <slot part="label" class="menu-item__label" @slotchange=${this.handleDefaultSlotChange}></slot>

        <slot name="suffix" part="suffix" class="menu-item__suffix"></slot>

        <span class="menu-item__chevron">
          <sl-icon name="chevron-right" library="system" aria-hidden="true"></sl-icon>
        </span>
      </div>
    `;
    }
};
$d9da14b52d0f25df$export$bd1a667628462930.styles = (0, $22322d2de317de2c$export$39d657da2cf50eaf);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)("slot:not([name])")
], $d9da14b52d0f25df$export$bd1a667628462930.prototype, "defaultSlot", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)(".menu-item")
], $d9da14b52d0f25df$export$bd1a667628462930.prototype, "menuItem", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $d9da14b52d0f25df$export$bd1a667628462930.prototype, "type", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $d9da14b52d0f25df$export$bd1a667628462930.prototype, "checked", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $d9da14b52d0f25df$export$bd1a667628462930.prototype, "value", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $d9da14b52d0f25df$export$bd1a667628462930.prototype, "disabled", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)("checked")
], $d9da14b52d0f25df$export$bd1a667628462930.prototype, "handleCheckedChange", 1);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)("disabled")
], $d9da14b52d0f25df$export$bd1a667628462930.prototype, "handleDisabledChange", 1);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)("type")
], $d9da14b52d0f25df$export$bd1a667628462930.prototype, "handleTypeChange", 1);
$d9da14b52d0f25df$export$bd1a667628462930 = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-menu-item")
], $d9da14b52d0f25df$export$bd1a667628462930);























// src/components/skeleton/skeleton.styles.ts
var $f934ead124a7a981$export$629c2ffa31a95a0d = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    --border-radius: var(--sl-border-radius-pill);
    --color: var(--sl-color-neutral-200);
    --sheen-color: var(--sl-color-neutral-300);

    display: block;
    position: relative;
  }

  .skeleton {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 1rem;
  }

  .skeleton__indicator {
    flex: 1 1 auto;
    background: var(--color);
    border-radius: var(--border-radius);
  }

  .skeleton--sheen .skeleton__indicator {
    background: linear-gradient(270deg, var(--sheen-color), var(--color), var(--color), var(--sheen-color));
    background-size: 400% 100%;
    background-size: 400% 100%;
    animation: sheen 8s ease-in-out infinite;
  }

  .skeleton--pulse .skeleton__indicator {
    animation: pulse 2s ease-in-out 0.5s infinite;
  }

  /* Forced colors mode */
  @media (forced-colors: active) {
    :host {
      --color: GrayText;
    }
  }

  @keyframes sheen {
    0% {
      background-position: 200% 0;
    }
    to {
      background-position: -200% 0;
    }
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
`;






// src/components/skeleton/skeleton.ts
var $74ee415e7de611e2$export$d3b5d44577dfd9a3 = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.effect = "none";
    }
    render() {
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
      <div
        part="base"
        class=${(0, $16b9676b53049ea4$export$ae1af26003f05816)({
            skeleton: true,
            "skeleton--pulse": this.effect === "pulse",
            "skeleton--sheen": this.effect === "sheen"
        })}
      >
        <div part="indicator" class="skeleton__indicator"></div>
      </div>
    `;
    }
};
$74ee415e7de611e2$export$d3b5d44577dfd9a3.styles = (0, $f934ead124a7a981$export$629c2ffa31a95a0d);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $74ee415e7de611e2$export$d3b5d44577dfd9a3.prototype, "effect", 2);
$74ee415e7de611e2$export$d3b5d44577dfd9a3 = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-skeleton")
], $74ee415e7de611e2$export$d3b5d44577dfd9a3);























// src/components/switch/switch.styles.ts
var $6530b99583d24d07$export$14e2900f6ef79e2b = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    display: inline-block;
  }

  :host([size='small']) {
    --height: var(--sl-toggle-size-small);
    --thumb-size: calc(var(--sl-toggle-size-small) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-small);
  }

  :host([size='medium']) {
    --height: var(--sl-toggle-size-medium);
    --thumb-size: calc(var(--sl-toggle-size-medium) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-medium);
  }

  :host([size='large']) {
    --height: var(--sl-toggle-size-large);
    --thumb-size: calc(var(--sl-toggle-size-large) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-large);
  }

  .switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    font-family: var(--sl-input-font-family);
    font-size: inherit;
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .switch__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--width);
    height: var(--height);
    background-color: var(--sl-color-neutral-400);
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    border-radius: var(--height);
    transition: var(--sl-transition-fast) border-color, var(--sl-transition-fast) background-color;
  }

  .switch__control .switch__thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    background-color: var(--sl-color-neutral-0);
    border-radius: 50%;
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    translate: calc((var(--width) - var(--height)) / -2);
    transition: var(--sl-transition-fast) translate ease, var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) border-color, var(--sl-transition-fast) box-shadow;
  }

  .switch__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-neutral-400);
  }

  /* Focus */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Checked */
  .switch--checked .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch--checked .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    translate: calc((var(--width) - var(--height)) / 2);
  }

  /* Checked + hover */
  .switch.switch--checked:not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
  }

  /* Checked + focus */
  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .switch--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .switch__label {
    display: inline-block;
    line-height: var(--height);
    margin-inline-start: 0.5em;
    user-select: none;
  }

  :host([required]) .switch__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
  }

  @media (forced-colors: active) {
    .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb,
    .switch--checked .switch__control .switch__thumb {
      background-color: ButtonText;
    }
  }
`;




// node_modules/lit-html/directive-helpers.js
var { I: $0b81354b509a306a$var$l } = (0, $a726e13e2eca4e53$export$61196ced6d74a310);
var $0b81354b509a306a$var$e2 = (o)=>void 0 === o.strings;
var $0b81354b509a306a$var$f = {};
var $0b81354b509a306a$var$s = (o, l3 = $0b81354b509a306a$var$f)=>o._$AH = l3;
// node_modules/lit-html/directives/live.js
var $0b81354b509a306a$export$882b5998b3b9117c = (0, $c261e931c1ebfc35$export$f1e1789686576879)(class extends (0, $c261e931c1ebfc35$export$23f2a1d2818174ef) {
    constructor(r){
        if (super(r), r.type !== (0, $c261e931c1ebfc35$export$625550452a3fa3ec).PROPERTY && r.type !== (0, $c261e931c1ebfc35$export$625550452a3fa3ec).ATTRIBUTE && r.type !== (0, $c261e931c1ebfc35$export$625550452a3fa3ec).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!$0b81354b509a306a$var$e2(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i2, [t2]) {
        if (t2 === (0, $a726e13e2eca4e53$export$d141bba7fdc215a3) || t2 === (0, $a726e13e2eca4e53$export$8b22cf2602fb60ce)) return t2;
        const o = i2.element, l3 = i2.name;
        if (i2.type === (0, $c261e931c1ebfc35$export$625550452a3fa3ec).PROPERTY) {
            if (t2 === o[l3]) return 0, $a726e13e2eca4e53$export$d141bba7fdc215a3;
        } else if (i2.type === (0, $c261e931c1ebfc35$export$625550452a3fa3ec).BOOLEAN_ATTRIBUTE) {
            if (!!t2 === o.hasAttribute(l3)) return 0, $a726e13e2eca4e53$export$d141bba7fdc215a3;
        } else if (i2.type === (0, $c261e931c1ebfc35$export$625550452a3fa3ec).ATTRIBUTE && o.getAttribute(l3) === t2 + "") return 0, $a726e13e2eca4e53$export$d141bba7fdc215a3;
        return $0b81354b509a306a$var$s(i2), t2;
    }
});
 /*! Bundled license information:

lit-html/directive-helpers.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/directives/live.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 


// src/internal/default-value.ts
var $e026b440f2606910$export$1a01ae0705bafd37 = (propertyName = "value")=>(proto, key)=>{
        const ctor = proto.constructor;
        const attributeChangedCallback = ctor.prototype.attributeChangedCallback;
        ctor.prototype.attributeChangedCallback = function(name, old, value) {
            var _a;
            const options = ctor.getPropertyOptions(propertyName);
            const attributeName = typeof options.attribute === "string" ? options.attribute : propertyName;
            if (name === attributeName) {
                const converter = options.converter || (0, $a726e13e2eca4e53$export$7ccc53e8f1e7dfc5);
                const fromAttribute = typeof converter === "function" ? converter : (_a = converter == null ? void 0 : converter.fromAttribute) != null ? _a : (0, $a726e13e2eca4e53$export$7ccc53e8f1e7dfc5).fromAttribute;
                const newValue = fromAttribute(value, options.type);
                if (this[propertyName] !== newValue) this[key] = newValue;
            }
            attributeChangedCallback.call(this, name, old, value);
        };
    };









// src/components/switch/switch.ts
var $4b83c7b40db027d1$export$8d28b91bbbe13ef5 = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $9c21c0ce148b596a$export$43da334182d34ab4)(this, {
            value: (control)=>control.checked ? control.value || "on" : void 0,
            defaultValue: (control)=>control.defaultChecked,
            setValue: (control, checked)=>control.checked = checked
        });
        this.hasFocus = false;
        this.title = "";
        this.name = "";
        this.size = "medium";
        this.disabled = false;
        this.checked = false;
        this.defaultChecked = false;
        this.form = "";
        this.required = false;
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleInput() {
        this.emit("sl-input");
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleClick() {
        this.checked = !this.checked;
        this.emit("sl-change");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleKeyDown(event) {
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.checked = false;
            this.emit("sl-change");
            this.emit("sl-input");
        }
        if (event.key === "ArrowRight") {
            event.preventDefault();
            this.checked = true;
            this.emit("sl-change");
            this.emit("sl-input");
        }
    }
    handleCheckedChange() {
        this.input.checked = this.checked;
        this.formControlController.updateValidity();
    }
    handleDisabledChange() {
        this.formControlController.setValidity(true);
    }
    /** Simulates a click on the switch. */ click() {
        this.input.click();
    }
    /** Sets focus on the switch. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the switch. */ blur() {
        this.input.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
      <label
        part="base"
        class=${(0, $16b9676b53049ea4$export$ae1af26003f05816)({
            switch: true,
            "switch--checked": this.checked,
            "switch--disabled": this.disabled,
            "switch--focused": this.hasFocus,
            "switch--small": this.size === "small",
            "switch--medium": this.size === "medium",
            "switch--large": this.size === "large"
        })}
      >
        <input
          class="switch__input"
          type="checkbox"
          title=${this.title}
          name=${this.name}
          value=${(0, $3895cd18908d6544$export$882b5998b3b9117c)(this.value)}
          .checked=${(0, $0b81354b509a306a$export$882b5998b3b9117c)(this.checked)}
          .disabled=${this.disabled}
          .required=${this.required}
          role="switch"
          aria-checked=${this.checked ? "true" : "false"}
          @click=${this.handleClick}
          @input=${this.handleInput}
          @invalid=${this.handleInvalid}
          @blur=${this.handleBlur}
          @focus=${this.handleFocus}
          @keydown=${this.handleKeyDown}
        />

        <span part="control" class="switch__control">
          <span part="thumb" class="switch__thumb"></span>
        </span>

        <slot part="label" class="switch__label"></slot>
      </label>
    `;
    }
};
$4b83c7b40db027d1$export$8d28b91bbbe13ef5.styles = (0, $6530b99583d24d07$export$14e2900f6ef79e2b);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)('input[type="checkbox"]')
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "input", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$625550452a3fa3ec)()
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "hasFocus", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "title", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "name", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "value", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        reflect: true
    })
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "size", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "disabled", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "checked", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $e026b440f2606910$export$1a01ae0705bafd37)("checked")
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "defaultChecked", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        reflect: true
    })
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "form", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "required", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)("checked", {
        waitUntilFirstUpdate: true
    })
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "handleCheckedChange", 1);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5.prototype, "handleDisabledChange", 1);
$4b83c7b40db027d1$export$8d28b91bbbe13ef5 = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-switch")
], $4b83c7b40db027d1$export$8d28b91bbbe13ef5);


















// src/components/tooltip/tooltip.styles.ts
var $314850bc0913e8fb$export$1c03bed7efcdda42 = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    --max-width: 20rem;
    --hide-delay: 0ms;
    --show-delay: 150ms;

    display: contents;
  }

  .tooltip {
    --arrow-size: var(--sl-tooltip-arrow-size);
    --arrow-color: var(--sl-tooltip-background-color);
  }

  .tooltip::part(popup) {
    pointer-events: none;
    z-index: var(--sl-z-index-tooltip);
  }

  .tooltip[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .tooltip[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .tooltip[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .tooltip[placement^='right']::part(popup) {
    transform-origin: left;
  }

  .tooltip__body {
    display: block;
    width: max-content;
    max-width: var(--max-width);
    border-radius: var(--sl-tooltip-border-radius);
    background-color: var(--sl-tooltip-background-color);
    font-family: var(--sl-tooltip-font-family);
    font-size: var(--sl-tooltip-font-size);
    font-weight: var(--sl-tooltip-font-weight);
    line-height: var(--sl-tooltip-line-height);
    color: var(--sl-tooltip-color);
    padding: var(--sl-tooltip-padding);
    pointer-events: none;
  }
`;



// src/utilities/animation-registry.ts
var $b56081e3200cb232$var$defaultAnimationRegistry = /* @__PURE__ */ new Map();
var $b56081e3200cb232$var$customAnimationRegistry = /* @__PURE__ */ new WeakMap();
function $b56081e3200cb232$var$ensureAnimation(animation) {
    return animation != null ? animation : {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}
function $b56081e3200cb232$var$getLogicalAnimation(animation, dir) {
    if (dir.toLowerCase() === "rtl") return {
        keyframes: animation.rtlKeyframes || animation.keyframes,
        options: animation.options
    };
    return animation;
}
function $b56081e3200cb232$export$6e92ecdbe15fda0b(animationName, animation) {
    $b56081e3200cb232$var$defaultAnimationRegistry.set(animationName, $b56081e3200cb232$var$ensureAnimation(animation));
}
function $b56081e3200cb232$export$ea45326d94a48a31(el, animationName, animation) {
    $b56081e3200cb232$var$customAnimationRegistry.set(el, (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, $b56081e3200cb232$var$customAnimationRegistry.get(el)), {
        [animationName]: $b56081e3200cb232$var$ensureAnimation(animation)
    }));
}
function $b56081e3200cb232$export$b1aed5dec0c2d368(el, animationName, options) {
    const customAnimation = $b56081e3200cb232$var$customAnimationRegistry.get(el);
    if (customAnimation == null ? void 0 : customAnimation[animationName]) return $b56081e3200cb232$var$getLogicalAnimation(customAnimation[animationName], options.dir);
    const defaultAnimation = $b56081e3200cb232$var$defaultAnimationRegistry.get(animationName);
    if (defaultAnimation) return $b56081e3200cb232$var$getLogicalAnimation(defaultAnimation, options.dir);
    return {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}


// src/internal/event.ts
function $c2cf2b91611b192d$export$6608ab6fe9313967(el, eventName) {
    return new Promise((resolve)=>{
        function done(event) {
            if (event.target === el) {
                el.removeEventListener(eventName, done);
                resolve();
            }
        }
        el.addEventListener(eventName, done);
    });
}



// src/internal/animate.ts
function $a89b6979a07920eb$export$3b755839a54e1bb0(el, keyframes, options) {
    return new Promise((resolve)=>{
        if ((options == null ? void 0 : options.duration) === Infinity) throw new Error("Promise-based animations must be finite.");
        const animation = el.animate(keyframes, (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, options), {
            duration: $a89b6979a07920eb$export$ff7706047246b98b() ? 0 : options.duration
        }));
        animation.addEventListener("cancel", resolve, {
            once: true
        });
        animation.addEventListener("finish", resolve, {
            once: true
        });
    });
}
function $a89b6979a07920eb$export$ecae829bb3747ea6(delay) {
    delay = delay.toString().toLowerCase();
    if (delay.indexOf("ms") > -1) return parseFloat(delay);
    if (delay.indexOf("s") > -1) return parseFloat(delay) * 1e3;
    return parseFloat(delay);
}
function $a89b6979a07920eb$export$ff7706047246b98b() {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    return query.matches;
}
function $a89b6979a07920eb$export$ad12f740028ccbea(el) {
    return Promise.all(el.getAnimations().map((animation)=>{
        return new Promise((resolve)=>{
            const handleAnimationEvent = requestAnimationFrame(resolve);
            animation.addEventListener("cancel", ()=>handleAnimationEvent, {
                once: true
            });
            animation.addEventListener("finish", ()=>handleAnimationEvent, {
                once: true
            });
            animation.cancel();
        });
    }));
}
function $a89b6979a07920eb$export$783a9b5bf095072a(keyframes, calculatedHeight) {
    return keyframes.map((keyframe)=>(0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, keyframe), {
            height: keyframe.height === "auto" ? `${calculatedHeight}px` : keyframe.height
        }));
}








// src/components/tooltip/tooltip.ts
var $be6ff600a108f5d2$export$2c14a50cec0c625c = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $50ed0f3a96e88fcc$export$b1a2fed5bb41b893)(this);
        this.content = "";
        this.placement = "top";
        this.disabled = false;
        this.distance = 8;
        this.open = false;
        this.skidding = 0;
        this.trigger = "hover focus";
        this.hoist = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.handleBlur = this.handleBlur.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);
        this.updateComplete.then(()=>{
            this.addEventListener("blur", this.handleBlur, true);
            this.addEventListener("focus", this.handleFocus, true);
            this.addEventListener("click", this.handleClick);
            this.addEventListener("keydown", this.handleKeyDown);
            this.addEventListener("mouseover", this.handleMouseOver);
            this.addEventListener("mouseout", this.handleMouseOut);
        });
    }
    firstUpdated() {
        this.body.hidden = !this.open;
        if (this.open) {
            this.popup.active = true;
            this.popup.reposition();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("blur", this.handleBlur, true);
        this.removeEventListener("focus", this.handleFocus, true);
        this.removeEventListener("click", this.handleClick);
        this.removeEventListener("keydown", this.handleKeyDown);
        this.removeEventListener("mouseover", this.handleMouseOver);
        this.removeEventListener("mouseout", this.handleMouseOut);
    }
    handleBlur() {
        if (this.hasTrigger("focus")) this.hide();
    }
    handleClick() {
        if (this.hasTrigger("click")) {
            if (this.open) this.hide();
            else this.show();
        }
    }
    handleFocus() {
        if (this.hasTrigger("focus")) this.show();
    }
    handleKeyDown(event) {
        if (this.open && event.key === "Escape") {
            event.stopPropagation();
            this.hide();
        }
    }
    handleMouseOver() {
        if (this.hasTrigger("hover")) {
            const delay = (0, $a89b6979a07920eb$export$ecae829bb3747ea6)(getComputedStyle(this).getPropertyValue("--show-delay"));
            clearTimeout(this.hoverTimeout);
            this.hoverTimeout = window.setTimeout(()=>this.show(), delay);
        }
    }
    handleMouseOut() {
        if (this.hasTrigger("hover")) {
            const delay = (0, $a89b6979a07920eb$export$ecae829bb3747ea6)(getComputedStyle(this).getPropertyValue("--hide-delay"));
            clearTimeout(this.hoverTimeout);
            this.hoverTimeout = window.setTimeout(()=>this.hide(), delay);
        }
    }
    hasTrigger(triggerType) {
        const triggers = this.trigger.split(" ");
        return triggers.includes(triggerType);
    }
    async handleOpenChange() {
        if (this.open) {
            if (this.disabled) return;
            this.emit("sl-show");
            await (0, $a89b6979a07920eb$export$ad12f740028ccbea)(this.body);
            this.body.hidden = false;
            this.popup.active = true;
            const { keyframes: keyframes, options: options } = (0, $b56081e3200cb232$export$b1aed5dec0c2d368)(this, "tooltip.show", {
                dir: this.localize.dir()
            });
            await (0, $a89b6979a07920eb$export$3b755839a54e1bb0)(this.popup.popup, keyframes, options);
            this.emit("sl-after-show");
        } else {
            this.emit("sl-hide");
            await (0, $a89b6979a07920eb$export$ad12f740028ccbea)(this.body);
            const { keyframes: keyframes, options: options } = (0, $b56081e3200cb232$export$b1aed5dec0c2d368)(this, "tooltip.hide", {
                dir: this.localize.dir()
            });
            await (0, $a89b6979a07920eb$export$3b755839a54e1bb0)(this.popup.popup, keyframes, options);
            this.popup.active = false;
            this.body.hidden = true;
            this.emit("sl-after-hide");
        }
    }
    async handleOptionsChange() {
        if (this.hasUpdated) {
            await this.updateComplete;
            this.popup.reposition();
        }
    }
    handleDisabledChange() {
        if (this.disabled && this.open) this.hide();
    }
    /** Shows the tooltip. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $c2cf2b91611b192d$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the tooltip */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $c2cf2b91611b192d$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    render() {
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
      <sl-popup
        part="base"
        exportparts="
          popup:base__popup,
          arrow:base__arrow
        "
        class=${(0, $16b9676b53049ea4$export$ae1af26003f05816)({
            tooltip: true,
            "tooltip--open": this.open
        })}
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        strategy=${this.hoist ? "fixed" : "absolute"}
        flip
        shift
        arrow
      >
        <slot slot="anchor" aria-describedby="tooltip"></slot>

        <slot
          name="content"
          part="body"
          id="tooltip"
          class="tooltip__body"
          role="tooltip"
          aria-live=${this.open ? "polite" : "off"}
        >
          ${this.content}
        </slot>
      </sl-popup>
    `;
    }
};
$be6ff600a108f5d2$export$2c14a50cec0c625c.styles = (0, $314850bc0913e8fb$export$1c03bed7efcdda42);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)("slot:not([name])")
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "defaultSlot", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)(".tooltip__body")
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "body", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)("sl-popup")
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "popup", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "content", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "placement", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "disabled", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Number
    })
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "distance", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "open", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Number
    })
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "skidding", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "trigger", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean
    })
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "hoist", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "handleOpenChange", 1);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)([
        "content",
        "distance",
        "hoist",
        "placement",
        "skidding"
    ])
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "handleOptionsChange", 1);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $cd51242b3c047db3$export$3db5d71bdb2d5499)("disabled")
], $be6ff600a108f5d2$export$2c14a50cec0c625c.prototype, "handleDisabledChange", 1);
$be6ff600a108f5d2$export$2c14a50cec0c625c = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-tooltip")
], $be6ff600a108f5d2$export$2c14a50cec0c625c);
(0, $b56081e3200cb232$export$6e92ecdbe15fda0b)("tooltip.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.8
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 150,
        easing: "ease"
    }
});
(0, $b56081e3200cb232$export$6e92ecdbe15fda0b)("tooltip.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.8
        }
    ],
    options: {
        duration: 150,
        easing: "ease"
    }
});





// src/components/popup/popup.styles.ts
var $bd9c72e8edc4e716$export$51897b955cb6c203 = (0, $a726e13e2eca4e53$export$23f2a1d2818174ef)`
  ${(0, $2b6feb7808ccbcfb$export$e1ac0a3ec62d1269)}

  :host {
    --arrow-color: var(--sl-color-neutral-1000);
    --arrow-size: 6px;

    /*
     * These properties are computed to account for the arrow's dimensions after being rotated 45º. The constant
     * 0.7071 is derived from sin(45), which is the diagonal size of the arrow's container after rotating.
     */
    --arrow-size-diagonal: calc(var(--arrow-size) * 0.7071);
    --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));

    display: contents;
  }

  .popup {
    position: absolute;
    isolation: isolate;
    max-width: var(--auto-size-available-width, none);
    max-height: var(--auto-size-available-height, none);
  }

  .popup--fixed {
    position: fixed;
  }

  .popup:not(.popup--active) {
    display: none;
  }

  .popup__arrow {
    position: absolute;
    width: calc(var(--arrow-size-diagonal) * 2);
    height: calc(var(--arrow-size-diagonal) * 2);
    rotate: 45deg;
    background: var(--arrow-color);
    z-index: -1;
  }
`;






// node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
function $647fa2982a2cf11b$var$t(t3) {
    return t3.split("-")[1];
}
function $647fa2982a2cf11b$var$e3(t3) {
    return "y" === t3 ? "height" : "width";
}
function $647fa2982a2cf11b$var$n(t3) {
    return t3.split("-")[0];
}
function $647fa2982a2cf11b$var$o2(t3) {
    return [
        "top",
        "bottom"
    ].includes($647fa2982a2cf11b$var$n(t3)) ? "x" : "y";
}
function $647fa2982a2cf11b$var$r(r4, i4, a3) {
    let { reference: l3, floating: s3 } = r4;
    const c3 = l3.x + l3.width / 2 - s3.width / 2, f3 = l3.y + l3.height / 2 - s3.height / 2, u3 = $647fa2982a2cf11b$var$o2(i4), m3 = $647fa2982a2cf11b$var$e3(u3), g3 = l3[m3] / 2 - s3[m3] / 2, d3 = "x" === u3;
    let p3;
    switch($647fa2982a2cf11b$var$n(i4)){
        case "top":
            p3 = {
                x: c3,
                y: l3.y - s3.height
            };
            break;
        case "bottom":
            p3 = {
                x: c3,
                y: l3.y + l3.height
            };
            break;
        case "right":
            p3 = {
                x: l3.x + l3.width,
                y: f3
            };
            break;
        case "left":
            p3 = {
                x: l3.x - s3.width,
                y: f3
            };
            break;
        default:
            p3 = {
                x: l3.x,
                y: l3.y
            };
    }
    switch($647fa2982a2cf11b$var$t(i4)){
        case "start":
            p3[u3] -= g3 * (a3 && d3 ? -1 : 1);
            break;
        case "end":
            p3[u3] += g3 * (a3 && d3 ? -1 : 1);
    }
    return p3;
}
var $647fa2982a2cf11b$var$i2 = async (t3, e4, n3)=>{
    const { placement: o5 = "bottom", strategy: i4 = "absolute", middleware: a3 = [], platform: l3 } = n3, s3 = a3.filter(Boolean), c3 = await (null == l3.isRTL ? void 0 : l3.isRTL(e4));
    let f3 = await l3.getElementRects({
        reference: t3,
        floating: e4,
        strategy: i4
    }), { x: u3, y: m3 } = $647fa2982a2cf11b$var$r(f3, o5, c3), g3 = o5, d3 = {}, p3 = 0;
    for(let n4 = 0; n4 < s3.length; n4++){
        const { name: a4, fn: h3 } = s3[n4], { x: y4, y: x3, data: w3, reset: v3 } = await h3({
            x: u3,
            y: m3,
            initialPlacement: o5,
            placement: g3,
            strategy: i4,
            middlewareData: d3,
            rects: f3,
            platform: l3,
            elements: {
                reference: t3,
                floating: e4
            }
        });
        u3 = null != y4 ? y4 : u3, m3 = null != x3 ? x3 : m3, d3 = (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, d3), {
            [a4]: (0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, d3[a4]), w3)
        }), v3 && p3 <= 50 && (p3++, "object" == typeof v3 && (v3.placement && (g3 = v3.placement), v3.rects && (f3 = true === v3.rects ? await l3.getElementRects({
            reference: t3,
            floating: e4,
            strategy: i4
        }) : v3.rects), { x: u3, y: m3 } = $647fa2982a2cf11b$var$r(f3, g3, c3)), n4 = -1);
    }
    return {
        x: u3,
        y: m3,
        placement: g3,
        strategy: i4,
        middlewareData: d3
    };
};
function $647fa2982a2cf11b$var$a(t3) {
    return "number" != typeof t3 ? function(t4) {
        return (0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, t4);
    }(t3) : {
        top: t3,
        right: t3,
        bottom: t3,
        left: t3
    };
}
function $647fa2982a2cf11b$var$l(t3) {
    return (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, t3), {
        top: t3.y,
        left: t3.x,
        right: t3.x + t3.width,
        bottom: t3.y + t3.height
    });
}
async function $647fa2982a2cf11b$var$s(t3, e4) {
    var n3;
    void 0 === e4 && (e4 = {});
    const { x: o5, y: r4, platform: i4, rects: s3, elements: c3, strategy: f3 } = t3, { boundary: u3 = "clippingAncestors", rootBoundary: m3 = "viewport", elementContext: g3 = "floating", altBoundary: d3 = false, padding: p3 = 0 } = e4, h3 = $647fa2982a2cf11b$var$a(p3), y4 = c3[d3 ? "floating" === g3 ? "reference" : "floating" : g3], x3 = $647fa2982a2cf11b$var$l(await i4.getClippingRect({
        element: null == (n3 = await (null == i4.isElement ? void 0 : i4.isElement(y4))) || n3 ? y4 : y4.contextElement || await (null == i4.getDocumentElement ? void 0 : i4.getDocumentElement(c3.floating)),
        boundary: u3,
        rootBoundary: m3,
        strategy: f3
    })), w3 = "floating" === g3 ? (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, s3.floating), {
        x: o5,
        y: r4
    }) : s3.reference, v3 = await (null == i4.getOffsetParent ? void 0 : i4.getOffsetParent(c3.floating)), b3 = await (null == i4.isElement ? void 0 : i4.isElement(v3)) && await (null == i4.getScale ? void 0 : i4.getScale(v3)) || {
        x: 1,
        y: 1
    }, R2 = $647fa2982a2cf11b$var$l(i4.convertOffsetParentRelativeRectToViewportRelativeRect ? await i4.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w3,
        offsetParent: v3,
        strategy: f3
    }) : w3);
    return {
        top: (x3.top - R2.top + h3.top) / b3.y,
        bottom: (R2.bottom - x3.bottom + h3.bottom) / b3.y,
        left: (x3.left - R2.left + h3.left) / b3.x,
        right: (R2.right - x3.right + h3.right) / b3.x
    };
}
var $647fa2982a2cf11b$var$c = Math.min;
var $647fa2982a2cf11b$var$f = Math.max;
function $647fa2982a2cf11b$var$u(t3, e4, n3) {
    return $647fa2982a2cf11b$var$f(t3, $647fa2982a2cf11b$var$c(e4, n3));
}
var $647fa2982a2cf11b$var$m = (n3)=>({
        name: "arrow",
        options: n3,
        async fn (r4) {
            const { element: i4, padding: l3 = 0 } = n3 || {}, { x: s3, y: c3, placement: f3, rects: m3, platform: g3 } = r4;
            if (null == i4) return {};
            const d3 = $647fa2982a2cf11b$var$a(l3), p3 = {
                x: s3,
                y: c3
            }, h3 = $647fa2982a2cf11b$var$o2(f3), y4 = $647fa2982a2cf11b$var$e3(h3), x3 = await g3.getDimensions(i4), w3 = "y" === h3 ? "top" : "left", v3 = "y" === h3 ? "bottom" : "right", b3 = m3.reference[y4] + m3.reference[h3] - p3[h3] - m3.floating[y4], R2 = p3[h3] - m3.reference[h3], A2 = await (null == g3.getOffsetParent ? void 0 : g3.getOffsetParent(i4));
            let P3 = A2 ? "y" === h3 ? A2.clientHeight || 0 : A2.clientWidth || 0 : 0;
            0 === P3 && (P3 = m3.floating[y4]);
            const T3 = b3 / 2 - R2 / 2, O3 = d3[w3], D3 = P3 - x3[y4] - d3[v3], E3 = P3 / 2 - x3[y4] / 2 + T3, L3 = $647fa2982a2cf11b$var$u(O3, E3, D3), k2 = null != $647fa2982a2cf11b$var$t(f3) && E3 != L3 && m3.reference[y4] / 2 - (E3 < O3 ? d3[w3] : d3[v3]) - x3[y4] / 2 < 0;
            return {
                [h3]: p3[h3] - (k2 ? E3 < O3 ? O3 - E3 : D3 - E3 : 0),
                data: {
                    [h3]: L3,
                    centerOffset: E3 - L3
                }
            };
        }
    });
var $647fa2982a2cf11b$var$g = [
    "top",
    "right",
    "bottom",
    "left"
];
var $647fa2982a2cf11b$var$d = $647fa2982a2cf11b$var$g.reduce((t3, e4)=>t3.concat(e4, e4 + "-start", e4 + "-end"), []);
var $647fa2982a2cf11b$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $647fa2982a2cf11b$var$h(t3) {
    return t3.replace(/left|right|bottom|top/g, (t4)=>$647fa2982a2cf11b$var$p[t4]);
}
function $647fa2982a2cf11b$var$y2(n3, r4, i4) {
    void 0 === i4 && (i4 = false);
    const a3 = $647fa2982a2cf11b$var$t(n3), l3 = $647fa2982a2cf11b$var$o2(n3), s3 = $647fa2982a2cf11b$var$e3(l3);
    let c3 = "x" === l3 ? a3 === (i4 ? "end" : "start") ? "right" : "left" : "start" === a3 ? "bottom" : "top";
    return r4.reference[s3] > r4.floating[s3] && (c3 = $647fa2982a2cf11b$var$h(c3)), {
        main: c3,
        cross: $647fa2982a2cf11b$var$h(c3)
    };
}
var $647fa2982a2cf11b$var$x = {
    start: "end",
    end: "start"
};
function $647fa2982a2cf11b$var$w(t3) {
    return t3.replace(/start|end/g, (t4)=>$647fa2982a2cf11b$var$x[t4]);
}
var $647fa2982a2cf11b$var$b = function(e4) {
    return void 0 === e4 && (e4 = {}), {
        name: "flip",
        options: e4,
        async fn (o5) {
            var r4;
            const { placement: i4, middlewareData: a3, rects: l3, initialPlacement: c3, platform: f3, elements: u3 } = o5, _a = e4, { mainAxis: m3 = true, crossAxis: g3 = true, fallbackPlacements: d3, fallbackStrategy: p3 = "bestFit", fallbackAxisSideDirection: x3 = "none", flipAlignment: v3 = true } = _a, b3 = (0, $e49e29f9e0bf5d9a$export$f65b024d04874a6)(_a, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]), R2 = $647fa2982a2cf11b$var$n(i4), A2 = $647fa2982a2cf11b$var$n(c3) === c3, P3 = await (null == f3.isRTL ? void 0 : f3.isRTL(u3.floating)), T3 = d3 || (A2 || !v3 ? [
                $647fa2982a2cf11b$var$h(c3)
            ] : function(t3) {
                const e5 = $647fa2982a2cf11b$var$h(t3);
                return [
                    $647fa2982a2cf11b$var$w(t3),
                    e5,
                    $647fa2982a2cf11b$var$w(e5)
                ];
            }(c3));
            d3 || "none" === x3 || T3.push(...function(e5, o6, r5, i5) {
                const a4 = $647fa2982a2cf11b$var$t(e5);
                let l4 = function(t3, e6, n3) {
                    const o7 = [
                        "left",
                        "right"
                    ], r6 = [
                        "right",
                        "left"
                    ], i6 = [
                        "top",
                        "bottom"
                    ], a5 = [
                        "bottom",
                        "top"
                    ];
                    switch(t3){
                        case "top":
                        case "bottom":
                            return n3 ? e6 ? r6 : o7 : e6 ? o7 : r6;
                        case "left":
                        case "right":
                            return e6 ? i6 : a5;
                        default:
                            return [];
                    }
                }($647fa2982a2cf11b$var$n(e5), "start" === r5, i5);
                return a4 && (l4 = l4.map((t3)=>t3 + "-" + a4), o6 && (l4 = l4.concat(l4.map($647fa2982a2cf11b$var$w)))), l4;
            }(c3, v3, x3, P3));
            const O3 = [
                c3,
                ...T3
            ], D3 = await $647fa2982a2cf11b$var$s(o5, b3), E3 = [];
            let L3 = (null == (r4 = a3.flip) ? void 0 : r4.overflows) || [];
            if (m3 && E3.push(D3[R2]), g3) {
                const { main: t3, cross: e5 } = $647fa2982a2cf11b$var$y2(i4, l3, P3);
                E3.push(D3[t3], D3[e5]);
            }
            if (L3 = [
                ...L3,
                {
                    placement: i4,
                    overflows: E3
                }
            ], !E3.every((t3)=>t3 <= 0)) {
                var k2, B;
                const t3 = ((null == (k2 = a3.flip) ? void 0 : k2.index) || 0) + 1, e5 = O3[t3];
                if (e5) return {
                    data: {
                        index: t3,
                        overflows: L3
                    },
                    reset: {
                        placement: e5
                    }
                };
                let n3 = null == (B = L3.filter((t4)=>t4.overflows[0] <= 0).sort((t4, e6)=>t4.overflows[1] - e6.overflows[1])[0]) ? void 0 : B.placement;
                if (!n3) switch(p3){
                    case "bestFit":
                        {
                            var C2;
                            const t4 = null == (C2 = L3.map((t5)=>[
                                    t5.placement,
                                    t5.overflows.filter((t6)=>t6 > 0).reduce((t6, e6)=>t6 + e6, 0)
                                ]).sort((t5, e6)=>t5[1] - e6[1])[0]) ? void 0 : C2[0];
                            t4 && (n3 = t4);
                            break;
                        }
                    case "initialPlacement":
                        n3 = c3;
                }
                if (i4 !== n3) return {
                    reset: {
                        placement: n3
                    }
                };
            }
            return {};
        }
    };
};
var $647fa2982a2cf11b$var$O = function(e4) {
    return void 0 === e4 && (e4 = 0), {
        name: "offset",
        options: e4,
        async fn (r4) {
            const { x: i4, y: a3 } = r4, l3 = await async function(e5, r5) {
                const { placement: i5, platform: a4, elements: l4 } = e5, s3 = await (null == a4.isRTL ? void 0 : a4.isRTL(l4.floating)), c3 = $647fa2982a2cf11b$var$n(i5), f3 = $647fa2982a2cf11b$var$t(i5), u3 = "x" === $647fa2982a2cf11b$var$o2(i5), m3 = [
                    "left",
                    "top"
                ].includes(c3) ? -1 : 1, g3 = s3 && u3 ? -1 : 1, d3 = "function" == typeof r5 ? r5(e5) : r5;
                let { mainAxis: p3, crossAxis: h3, alignmentAxis: y4 } = "number" == typeof d3 ? {
                    mainAxis: d3,
                    crossAxis: 0,
                    alignmentAxis: null
                } : (0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null
                }, d3);
                return f3 && "number" == typeof y4 && (h3 = "end" === f3 ? -1 * y4 : y4), u3 ? {
                    x: h3 * g3,
                    y: p3 * m3
                } : {
                    x: p3 * m3,
                    y: h3 * g3
                };
            }(r4, e4);
            return {
                x: i4 + l3.x,
                y: a3 + l3.y,
                data: l3
            };
        }
    };
};
function $647fa2982a2cf11b$var$D(t3) {
    return "x" === t3 ? "y" : "x";
}
var $647fa2982a2cf11b$var$E = function(t3) {
    return void 0 === t3 && (t3 = {}), {
        name: "shift",
        options: t3,
        async fn (e4) {
            const { x: r4, y: i4, placement: a3 } = e4, _a = t3, { mainAxis: l3 = true, crossAxis: c3 = false, limiter: f3 = {
                fn: (t4)=>{
                    let { x: e5, y: n3 } = t4;
                    return {
                        x: e5,
                        y: n3
                    };
                }
            } } = _a, m3 = (0, $e49e29f9e0bf5d9a$export$f65b024d04874a6)(_a, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]), g3 = {
                x: r4,
                y: i4
            }, d3 = await $647fa2982a2cf11b$var$s(e4, m3), p3 = $647fa2982a2cf11b$var$o2($647fa2982a2cf11b$var$n(a3)), h3 = $647fa2982a2cf11b$var$D(p3);
            let y4 = g3[p3], x3 = g3[h3];
            if (l3) {
                const t4 = "y" === p3 ? "bottom" : "right";
                y4 = $647fa2982a2cf11b$var$u(y4 + d3["y" === p3 ? "top" : "left"], y4, y4 - d3[t4]);
            }
            if (c3) {
                const t4 = "y" === h3 ? "bottom" : "right";
                x3 = $647fa2982a2cf11b$var$u(x3 + d3["y" === h3 ? "top" : "left"], x3, x3 - d3[t4]);
            }
            const w3 = f3.fn((0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, e4), {
                [p3]: y4,
                [h3]: x3
            }));
            return (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, w3), {
                data: {
                    x: w3.x - r4,
                    y: w3.y - i4
                }
            });
        }
    };
};
var $647fa2982a2cf11b$var$k = function(e4) {
    return void 0 === e4 && (e4 = {}), {
        name: "size",
        options: e4,
        async fn (r4) {
            const { placement: i4, rects: a3, platform: l3, elements: u3 } = r4, _a = e4, { apply: m3 = ()=>{} } = _a, g3 = (0, $e49e29f9e0bf5d9a$export$f65b024d04874a6)(_a, [
                "apply"
            ]), d3 = await $647fa2982a2cf11b$var$s(r4, g3), p3 = $647fa2982a2cf11b$var$n(i4), h3 = $647fa2982a2cf11b$var$t(i4), y4 = "x" === $647fa2982a2cf11b$var$o2(i4), { width: x3, height: w3 } = a3.floating;
            let v3, b3;
            "top" === p3 || "bottom" === p3 ? (v3 = p3, b3 = h3 === (await (null == l3.isRTL ? void 0 : l3.isRTL(u3.floating)) ? "start" : "end") ? "left" : "right") : (b3 = p3, v3 = "end" === h3 ? "top" : "bottom");
            const R2 = w3 - d3[v3], A2 = x3 - d3[b3];
            let P3 = R2, T3 = A2;
            if (y4 ? T3 = $647fa2982a2cf11b$var$c(x3 - d3.right - d3.left, A2) : P3 = $647fa2982a2cf11b$var$c(w3 - d3.bottom - d3.top, R2), !r4.middlewareData.shift && !h3) {
                const t3 = $647fa2982a2cf11b$var$f(d3.left, 0), e5 = $647fa2982a2cf11b$var$f(d3.right, 0), n3 = $647fa2982a2cf11b$var$f(d3.top, 0), o5 = $647fa2982a2cf11b$var$f(d3.bottom, 0);
                y4 ? T3 = x3 - 2 * (0 !== t3 || 0 !== e5 ? t3 + e5 : $647fa2982a2cf11b$var$f(d3.left, d3.right)) : P3 = w3 - 2 * (0 !== n3 || 0 !== o5 ? n3 + o5 : $647fa2982a2cf11b$var$f(d3.top, d3.bottom));
            }
            await m3((0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, r4), {
                availableWidth: T3,
                availableHeight: P3
            }));
            const O3 = await l3.getDimensions(u3.floating);
            return x3 !== O3.width || w3 !== O3.height ? {
                reset: {
                    rects: true
                }
            } : {};
        }
    };
};
// node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
function $647fa2982a2cf11b$var$n2(t3) {
    var e4;
    return (null == (e4 = t3.ownerDocument) ? void 0 : e4.defaultView) || window;
}
function $647fa2982a2cf11b$var$o3(t3) {
    return $647fa2982a2cf11b$var$n2(t3).getComputedStyle(t3);
}
var $647fa2982a2cf11b$var$i3 = Math.min;
var $647fa2982a2cf11b$var$r2 = Math.max;
var $647fa2982a2cf11b$var$l2 = Math.round;
function $647fa2982a2cf11b$var$c2(t3) {
    const e4 = $647fa2982a2cf11b$var$o3(t3);
    let n3 = parseFloat(e4.width), i4 = parseFloat(e4.height);
    const r4 = t3.offsetWidth, c3 = t3.offsetHeight, s3 = $647fa2982a2cf11b$var$l2(n3) !== r4 || $647fa2982a2cf11b$var$l2(i4) !== c3;
    return s3 && (n3 = r4, i4 = c3), {
        width: n3,
        height: i4,
        fallback: s3
    };
}
function $647fa2982a2cf11b$var$s2(t3) {
    return $647fa2982a2cf11b$var$h2(t3) ? (t3.nodeName || "").toLowerCase() : "";
}
var $647fa2982a2cf11b$var$f2;
function $647fa2982a2cf11b$var$u2() {
    if ($647fa2982a2cf11b$var$f2) return $647fa2982a2cf11b$var$f2;
    const t3 = navigator.userAgentData;
    return t3 && Array.isArray(t3.brands) ? ($647fa2982a2cf11b$var$f2 = t3.brands.map((t4)=>t4.brand + "/" + t4.version).join(" "), $647fa2982a2cf11b$var$f2) : navigator.userAgent;
}
function $647fa2982a2cf11b$var$a2(t3) {
    return t3 instanceof $647fa2982a2cf11b$var$n2(t3).HTMLElement;
}
function $647fa2982a2cf11b$var$d2(t3) {
    return t3 instanceof $647fa2982a2cf11b$var$n2(t3).Element;
}
function $647fa2982a2cf11b$var$h2(t3) {
    return t3 instanceof $647fa2982a2cf11b$var$n2(t3).Node;
}
function $647fa2982a2cf11b$var$p2(t3) {
    if ("undefined" == typeof ShadowRoot) return false;
    return t3 instanceof $647fa2982a2cf11b$var$n2(t3).ShadowRoot || t3 instanceof ShadowRoot;
}
function $647fa2982a2cf11b$var$g2(t3) {
    const { overflow: e4, overflowX: n3, overflowY: i4, display: r4 } = $647fa2982a2cf11b$var$o3(t3);
    return /auto|scroll|overlay|hidden|clip/.test(e4 + i4 + n3) && ![
        "inline",
        "contents"
    ].includes(r4);
}
function $647fa2982a2cf11b$var$m2(t3) {
    return [
        "table",
        "td",
        "th"
    ].includes($647fa2982a2cf11b$var$s2(t3));
}
function $647fa2982a2cf11b$var$y3(t3) {
    const e4 = /firefox/i.test($647fa2982a2cf11b$var$u2()), n3 = $647fa2982a2cf11b$var$o3(t3), i4 = n3.backdropFilter || n3.WebkitBackdropFilter;
    return "none" !== n3.transform || "none" !== n3.perspective || !!i4 && "none" !== i4 || e4 && "filter" === n3.willChange || e4 && !!n3.filter && "none" !== n3.filter || [
        "transform",
        "perspective"
    ].some((t4)=>n3.willChange.includes(t4)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t4)=>{
        const e5 = n3.contain;
        return null != e5 && e5.includes(t4);
    });
}
function $647fa2982a2cf11b$var$x2() {
    return /^((?!chrome|android).)*safari/i.test($647fa2982a2cf11b$var$u2());
}
function $647fa2982a2cf11b$var$w2(t3) {
    return [
        "html",
        "body",
        "#document"
    ].includes($647fa2982a2cf11b$var$s2(t3));
}
function $647fa2982a2cf11b$var$v2(t3) {
    return $647fa2982a2cf11b$var$d2(t3) ? t3 : t3.contextElement;
}
var $647fa2982a2cf11b$var$b2 = {
    x: 1,
    y: 1
};
function $647fa2982a2cf11b$var$L2(t3) {
    const e4 = $647fa2982a2cf11b$var$v2(t3);
    if (!$647fa2982a2cf11b$var$a2(e4)) return $647fa2982a2cf11b$var$b2;
    const n3 = e4.getBoundingClientRect(), { width: o5, height: i4, fallback: r4 } = $647fa2982a2cf11b$var$c2(e4);
    let s3 = (r4 ? $647fa2982a2cf11b$var$l2(n3.width) : n3.width) / o5, f3 = (r4 ? $647fa2982a2cf11b$var$l2(n3.height) : n3.height) / i4;
    return s3 && Number.isFinite(s3) || (s3 = 1), f3 && Number.isFinite(f3) || (f3 = 1), {
        x: s3,
        y: f3
    };
}
function $647fa2982a2cf11b$var$E2(t3, e4, o5, i4) {
    var r4, l3;
    void 0 === e4 && (e4 = false), void 0 === o5 && (o5 = false);
    const c3 = t3.getBoundingClientRect(), s3 = $647fa2982a2cf11b$var$v2(t3);
    let f3 = $647fa2982a2cf11b$var$b2;
    e4 && (i4 ? $647fa2982a2cf11b$var$d2(i4) && (f3 = $647fa2982a2cf11b$var$L2(i4)) : f3 = $647fa2982a2cf11b$var$L2(t3));
    const u3 = s3 ? $647fa2982a2cf11b$var$n2(s3) : window, a3 = $647fa2982a2cf11b$var$x2() && o5;
    let h3 = (c3.left + (a3 && (null == (r4 = u3.visualViewport) ? void 0 : r4.offsetLeft) || 0)) / f3.x, p3 = (c3.top + (a3 && (null == (l3 = u3.visualViewport) ? void 0 : l3.offsetTop) || 0)) / f3.y, g3 = c3.width / f3.x, m3 = c3.height / f3.y;
    if (s3) {
        const t4 = $647fa2982a2cf11b$var$n2(s3), e5 = i4 && $647fa2982a2cf11b$var$d2(i4) ? $647fa2982a2cf11b$var$n2(i4) : i4;
        let o6 = t4.frameElement;
        for(; o6 && i4 && e5 !== t4;){
            const t5 = $647fa2982a2cf11b$var$L2(o6), e6 = o6.getBoundingClientRect(), i5 = getComputedStyle(o6);
            e6.x += (o6.clientLeft + parseFloat(i5.paddingLeft)) * t5.x, e6.y += (o6.clientTop + parseFloat(i5.paddingTop)) * t5.y, h3 *= t5.x, p3 *= t5.y, g3 *= t5.x, m3 *= t5.y, h3 += e6.x, p3 += e6.y, o6 = $647fa2982a2cf11b$var$n2(o6).frameElement;
        }
    }
    return {
        width: g3,
        height: m3,
        top: p3,
        right: h3 + g3,
        bottom: p3 + m3,
        left: h3,
        x: h3,
        y: p3
    };
}
function $647fa2982a2cf11b$var$R(t3) {
    return (($647fa2982a2cf11b$var$h2(t3) ? t3.ownerDocument : t3.document) || window.document).documentElement;
}
function $647fa2982a2cf11b$var$T2(t3) {
    return $647fa2982a2cf11b$var$d2(t3) ? {
        scrollLeft: t3.scrollLeft,
        scrollTop: t3.scrollTop
    } : {
        scrollLeft: t3.pageXOffset,
        scrollTop: t3.pageYOffset
    };
}
function $647fa2982a2cf11b$var$C(t3) {
    return $647fa2982a2cf11b$var$E2($647fa2982a2cf11b$var$R(t3)).left + $647fa2982a2cf11b$var$T2(t3).scrollLeft;
}
function $647fa2982a2cf11b$var$F(t3) {
    if ("html" === $647fa2982a2cf11b$var$s2(t3)) return t3;
    const e4 = t3.assignedSlot || t3.parentNode || $647fa2982a2cf11b$var$p2(t3) && t3.host || $647fa2982a2cf11b$var$R(t3);
    return $647fa2982a2cf11b$var$p2(e4) ? e4.host : e4;
}
function $647fa2982a2cf11b$var$W(t3) {
    const e4 = $647fa2982a2cf11b$var$F(t3);
    return $647fa2982a2cf11b$var$w2(e4) ? e4.ownerDocument.body : $647fa2982a2cf11b$var$a2(e4) && $647fa2982a2cf11b$var$g2(e4) ? e4 : $647fa2982a2cf11b$var$W(e4);
}
function $647fa2982a2cf11b$var$D2(t3, e4) {
    var o5;
    void 0 === e4 && (e4 = []);
    const i4 = $647fa2982a2cf11b$var$W(t3), r4 = i4 === (null == (o5 = t3.ownerDocument) ? void 0 : o5.body), l3 = $647fa2982a2cf11b$var$n2(i4);
    return r4 ? e4.concat(l3, l3.visualViewport || [], $647fa2982a2cf11b$var$g2(i4) ? i4 : []) : e4.concat(i4, $647fa2982a2cf11b$var$D2(i4));
}
function $647fa2982a2cf11b$var$S(e4, i4, l3) {
    let c3;
    if ("viewport" === i4) c3 = function(t3, e5) {
        const o5 = $647fa2982a2cf11b$var$n2(t3), i5 = $647fa2982a2cf11b$var$R(t3), r4 = o5.visualViewport;
        let l4 = i5.clientWidth, c4 = i5.clientHeight, s4 = 0, f4 = 0;
        if (r4) {
            l4 = r4.width, c4 = r4.height;
            const t4 = $647fa2982a2cf11b$var$x2();
            (!t4 || t4 && "fixed" === e5) && (s4 = r4.offsetLeft, f4 = r4.offsetTop);
        }
        return {
            width: l4,
            height: c4,
            x: s4,
            y: f4
        };
    }(e4, l3);
    else if ("document" === i4) c3 = function(t3) {
        const e5 = $647fa2982a2cf11b$var$R(t3), n3 = $647fa2982a2cf11b$var$T2(t3), i5 = t3.ownerDocument.body, l4 = $647fa2982a2cf11b$var$r2(e5.scrollWidth, e5.clientWidth, i5.scrollWidth, i5.clientWidth), c4 = $647fa2982a2cf11b$var$r2(e5.scrollHeight, e5.clientHeight, i5.scrollHeight, i5.clientHeight);
        let s4 = -n3.scrollLeft + $647fa2982a2cf11b$var$C(t3);
        const f4 = -n3.scrollTop;
        return "rtl" === $647fa2982a2cf11b$var$o3(i5).direction && (s4 += $647fa2982a2cf11b$var$r2(e5.clientWidth, i5.clientWidth) - l4), {
            width: l4,
            height: c4,
            x: s4,
            y: f4
        };
    }($647fa2982a2cf11b$var$R(e4));
    else if ($647fa2982a2cf11b$var$d2(i4)) c3 = function(t3, e5) {
        const n3 = $647fa2982a2cf11b$var$E2(t3, true, "fixed" === e5), o5 = n3.top + t3.clientTop, i5 = n3.left + t3.clientLeft, r4 = $647fa2982a2cf11b$var$a2(t3) ? $647fa2982a2cf11b$var$L2(t3) : {
            x: 1,
            y: 1
        };
        return {
            width: t3.clientWidth * r4.x,
            height: t3.clientHeight * r4.y,
            x: i5 * r4.x,
            y: o5 * r4.y
        };
    }(i4, l3);
    else {
        const t3 = (0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, i4);
        if ($647fa2982a2cf11b$var$x2()) {
            var s3, f3;
            const o5 = $647fa2982a2cf11b$var$n2(e4);
            t3.x -= (null == (s3 = o5.visualViewport) ? void 0 : s3.offsetLeft) || 0, t3.y -= (null == (f3 = o5.visualViewport) ? void 0 : f3.offsetTop) || 0;
        }
        c3 = t3;
    }
    return $647fa2982a2cf11b$var$l(c3);
}
function $647fa2982a2cf11b$var$A(t3, e4) {
    return $647fa2982a2cf11b$var$a2(t3) && "fixed" !== $647fa2982a2cf11b$var$o3(t3).position ? e4 ? e4(t3) : t3.offsetParent : null;
}
function $647fa2982a2cf11b$var$H(t3, e4) {
    const i4 = $647fa2982a2cf11b$var$n2(t3);
    let r4 = $647fa2982a2cf11b$var$A(t3, e4);
    for(; r4 && $647fa2982a2cf11b$var$m2(r4) && "static" === $647fa2982a2cf11b$var$o3(r4).position;)r4 = $647fa2982a2cf11b$var$A(r4, e4);
    return r4 && ("html" === $647fa2982a2cf11b$var$s2(r4) || "body" === $647fa2982a2cf11b$var$s2(r4) && "static" === $647fa2982a2cf11b$var$o3(r4).position && !$647fa2982a2cf11b$var$y3(r4)) ? i4 : r4 || function(t4) {
        let e5 = $647fa2982a2cf11b$var$F(t4);
        for(; $647fa2982a2cf11b$var$a2(e5) && !$647fa2982a2cf11b$var$w2(e5);){
            if ($647fa2982a2cf11b$var$y3(e5)) return e5;
            e5 = $647fa2982a2cf11b$var$F(e5);
        }
        return null;
    }(t3) || i4;
}
function $647fa2982a2cf11b$var$V(t3, e4, n3) {
    const o5 = $647fa2982a2cf11b$var$a2(e4), i4 = $647fa2982a2cf11b$var$R(e4), r4 = $647fa2982a2cf11b$var$E2(t3, true, "fixed" === n3, e4);
    let l3 = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const c3 = {
        x: 0,
        y: 0
    };
    if (o5 || !o5 && "fixed" !== n3) {
        if (("body" !== $647fa2982a2cf11b$var$s2(e4) || $647fa2982a2cf11b$var$g2(i4)) && (l3 = $647fa2982a2cf11b$var$T2(e4)), $647fa2982a2cf11b$var$a2(e4)) {
            const t4 = $647fa2982a2cf11b$var$E2(e4, true);
            c3.x = t4.x + e4.clientLeft, c3.y = t4.y + e4.clientTop;
        } else i4 && (c3.x = $647fa2982a2cf11b$var$C(i4));
    }
    return {
        x: r4.left + l3.scrollLeft - c3.x,
        y: r4.top + l3.scrollTop - c3.y,
        width: r4.width,
        height: r4.height
    };
}
var $647fa2982a2cf11b$var$O2 = {
    getClippingRect: function(t3) {
        let { element: e4, boundary: n3, rootBoundary: l3, strategy: c3 } = t3;
        const f3 = "clippingAncestors" === n3 ? function(t4, e5) {
            const n4 = e5.get(t4);
            if (n4) return n4;
            let i4 = $647fa2982a2cf11b$var$D2(t4).filter((t5)=>$647fa2982a2cf11b$var$d2(t5) && "body" !== $647fa2982a2cf11b$var$s2(t5)), r4 = null;
            const l4 = "fixed" === $647fa2982a2cf11b$var$o3(t4).position;
            let c4 = l4 ? $647fa2982a2cf11b$var$F(t4) : t4;
            for(; $647fa2982a2cf11b$var$d2(c4) && !$647fa2982a2cf11b$var$w2(c4);){
                const t5 = $647fa2982a2cf11b$var$o3(c4), e6 = $647fa2982a2cf11b$var$y3(c4);
                "fixed" === t5.position ? r4 = null : (l4 ? e6 || r4 : e6 || "static" !== t5.position || !r4 || ![
                    "absolute",
                    "fixed"
                ].includes(r4.position)) ? r4 = t5 : i4 = i4.filter((t6)=>t6 !== c4), c4 = $647fa2982a2cf11b$var$F(c4);
            }
            return e5.set(t4, i4), i4;
        }(e4, this._c) : [].concat(n3), u3 = [
            ...f3,
            l3
        ], a3 = u3[0], h3 = u3.reduce((t4, n4)=>{
            const o5 = $647fa2982a2cf11b$var$S(e4, n4, c3);
            return t4.top = $647fa2982a2cf11b$var$r2(o5.top, t4.top), t4.right = $647fa2982a2cf11b$var$i3(o5.right, t4.right), t4.bottom = $647fa2982a2cf11b$var$i3(o5.bottom, t4.bottom), t4.left = $647fa2982a2cf11b$var$r2(o5.left, t4.left), t4;
        }, $647fa2982a2cf11b$var$S(e4, a3, c3));
        return {
            width: h3.right - h3.left,
            height: h3.bottom - h3.top,
            x: h3.left,
            y: h3.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t3) {
        let { rect: e4, offsetParent: n3, strategy: o5 } = t3;
        const i4 = $647fa2982a2cf11b$var$a2(n3), r4 = $647fa2982a2cf11b$var$R(n3);
        if (n3 === r4) return e4;
        let l3 = {
            scrollLeft: 0,
            scrollTop: 0
        }, c3 = {
            x: 1,
            y: 1
        };
        const f3 = {
            x: 0,
            y: 0
        };
        if ((i4 || !i4 && "fixed" !== o5) && (("body" !== $647fa2982a2cf11b$var$s2(n3) || $647fa2982a2cf11b$var$g2(r4)) && (l3 = $647fa2982a2cf11b$var$T2(n3)), $647fa2982a2cf11b$var$a2(n3))) {
            const t4 = $647fa2982a2cf11b$var$E2(n3);
            c3 = $647fa2982a2cf11b$var$L2(n3), f3.x = t4.x + n3.clientLeft, f3.y = t4.y + n3.clientTop;
        }
        return {
            width: e4.width * c3.x,
            height: e4.height * c3.y,
            x: e4.x * c3.x - l3.scrollLeft * c3.x + f3.x,
            y: e4.y * c3.y - l3.scrollTop * c3.y + f3.y
        };
    },
    isElement: $647fa2982a2cf11b$var$d2,
    getDimensions: function(t3) {
        return $647fa2982a2cf11b$var$a2(t3) ? $647fa2982a2cf11b$var$c2(t3) : t3.getBoundingClientRect();
    },
    getOffsetParent: $647fa2982a2cf11b$var$H,
    getDocumentElement: $647fa2982a2cf11b$var$R,
    getScale: $647fa2982a2cf11b$var$L2,
    async getElementRects (t3) {
        let { reference: e4, floating: n3, strategy: o5 } = t3;
        const i4 = this.getOffsetParent || $647fa2982a2cf11b$var$H, r4 = this.getDimensions;
        return {
            reference: $647fa2982a2cf11b$var$V(e4, await i4(n3), o5),
            floating: (0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({
                x: 0,
                y: 0
            }, await r4(n3))
        };
    },
    getClientRects: (t3)=>Array.from(t3.getClientRects()),
    isRTL: (t3)=>"rtl" === $647fa2982a2cf11b$var$o3(t3).direction
};
function $647fa2982a2cf11b$var$P2(t3, e4, n3, o5) {
    void 0 === o5 && (o5 = {});
    const { ancestorScroll: i4 = true, ancestorResize: r4 = true, elementResize: l3 = true, animationFrame: c3 = false } = o5, s3 = i4 && !c3, f3 = s3 || r4 ? [
        ...$647fa2982a2cf11b$var$d2(t3) ? $647fa2982a2cf11b$var$D2(t3) : t3.contextElement ? $647fa2982a2cf11b$var$D2(t3.contextElement) : [],
        ...$647fa2982a2cf11b$var$D2(e4)
    ] : [];
    f3.forEach((t4)=>{
        s3 && t4.addEventListener("scroll", n3, {
            passive: true
        }), r4 && t4.addEventListener("resize", n3);
    });
    let u3, a3 = null;
    if (l3) {
        let o6 = true;
        a3 = new ResizeObserver(()=>{
            o6 || n3(), o6 = false;
        }), $647fa2982a2cf11b$var$d2(t3) && !c3 && a3.observe(t3), $647fa2982a2cf11b$var$d2(t3) || !t3.contextElement || c3 || a3.observe(t3.contextElement), a3.observe(e4);
    }
    let h3 = c3 ? $647fa2982a2cf11b$var$E2(t3) : null;
    return c3 && function e5() {
        const o6 = $647fa2982a2cf11b$var$E2(t3);
        !h3 || o6.x === h3.x && o6.y === h3.y && o6.width === h3.width && o6.height === h3.height || n3();
        h3 = o6, u3 = requestAnimationFrame(e5);
    }(), n3(), ()=>{
        var t4;
        f3.forEach((t5)=>{
            s3 && t5.removeEventListener("scroll", n3), r4 && t5.removeEventListener("resize", n3);
        }), null == (t4 = a3) || t4.disconnect(), a3 = null, c3 && cancelAnimationFrame(u3);
    };
}
var $647fa2982a2cf11b$var$z = (t3, n3, o5)=>{
    const i4 = /* @__PURE__ */ new Map(), r4 = (0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({
        platform: $647fa2982a2cf11b$var$O2
    }, o5), l3 = (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, r4.platform), {
        _c: i4
    });
    return $647fa2982a2cf11b$var$i2(t3, n3, (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, r4), {
        platform: l3
    }));
};
// node_modules/composed-offset-position/dist/composed-offset-position.browser.min.mjs
function $647fa2982a2cf11b$var$t2(t3) {
    return $647fa2982a2cf11b$var$r3(t3);
}
function $647fa2982a2cf11b$var$o4(t3) {
    return t3.assignedSlot ? t3.assignedSlot : t3.parentNode instanceof ShadowRoot ? t3.parentNode.host : t3.parentNode;
}
function $647fa2982a2cf11b$var$r3(t3) {
    for(let e4 = t3; e4; e4 = $647fa2982a2cf11b$var$o4(e4))if (e4 instanceof Element && "none" === getComputedStyle(e4).display) return null;
    for(let e4 = $647fa2982a2cf11b$var$o4(t3); e4; e4 = $647fa2982a2cf11b$var$o4(e4)){
        if (!(e4 instanceof Element)) continue;
        const t4 = getComputedStyle(e4);
        if ("contents" !== t4.display) {
            if ("static" !== t4.position || "none" !== t4.filter) return e4;
            if ("BODY" === e4.tagName) return e4;
        }
    }
    return null;
}
// src/components/popup/popup.ts
var $647fa2982a2cf11b$export$6fe469f0a31d1d6e = class extends (0, $ccaafd6984b825ef$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.active = false;
        this.placement = "top";
        this.strategy = "absolute";
        this.distance = 0;
        this.skidding = 0;
        this.arrow = false;
        this.arrowPlacement = "anchor";
        this.arrowPadding = 10;
        this.flip = false;
        this.flipFallbackPlacements = "";
        this.flipFallbackStrategy = "best-fit";
        this.flipPadding = 0;
        this.shift = false;
        this.shiftPadding = 0;
        this.autoSizePadding = 0;
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.updateComplete;
        this.start();
    }
    disconnectedCallback() {
        this.stop();
    }
    async updated(changedProps) {
        super.updated(changedProps);
        if (changedProps.has("active")) {
            if (this.active) this.start();
            else this.stop();
        }
        if (changedProps.has("anchor")) this.handleAnchorChange();
        if (this.active) {
            await this.updateComplete;
            this.reposition();
        }
    }
    async handleAnchorChange() {
        await this.stop();
        if (this.anchor && typeof this.anchor === "string") {
            const root = this.getRootNode();
            this.anchorEl = root.getElementById(this.anchor);
        } else if (this.anchor instanceof Element) this.anchorEl = this.anchor;
        else this.anchorEl = this.querySelector('[slot="anchor"]');
        if (this.anchorEl instanceof HTMLSlotElement) this.anchorEl = this.anchorEl.assignedElements({
            flatten: true
        })[0];
        if (!this.anchorEl) throw new Error("Invalid anchor element: no anchor could be found using the anchor slot or the anchor attribute.");
        this.start();
    }
    start() {
        if (!this.anchorEl) return;
        this.cleanup = $647fa2982a2cf11b$var$P2(this.anchorEl, this.popup, ()=>{
            this.reposition();
        });
    }
    async stop() {
        return new Promise((resolve)=>{
            if (this.cleanup) {
                this.cleanup();
                this.cleanup = void 0;
                this.removeAttribute("data-current-placement");
                this.style.removeProperty("--auto-size-available-width");
                this.style.removeProperty("--auto-size-available-height");
                requestAnimationFrame(()=>resolve());
            } else resolve();
        });
    }
    /** Forces the popup to recalculate and reposition itself. */ reposition() {
        if (!this.active || !this.anchorEl) return;
        const middleware = [
            // The offset middleware goes first
            $647fa2982a2cf11b$var$O({
                mainAxis: this.distance,
                crossAxis: this.skidding
            })
        ];
        if (this.sync) middleware.push($647fa2982a2cf11b$var$k({
            apply: ({ rects: rects })=>{
                const syncWidth = this.sync === "width" || this.sync === "both";
                const syncHeight = this.sync === "height" || this.sync === "both";
                this.popup.style.width = syncWidth ? `${rects.reference.width}px` : "";
                this.popup.style.height = syncHeight ? `${rects.reference.height}px` : "";
            }
        }));
        else {
            this.popup.style.width = "";
            this.popup.style.height = "";
        }
        if (this.flip) middleware.push($647fa2982a2cf11b$var$b({
            boundary: this.flipBoundary,
            // @ts-expect-error - We're converting a string attribute to an array here
            fallbackPlacements: this.flipFallbackPlacements,
            fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
            padding: this.flipPadding
        }));
        if (this.shift) middleware.push($647fa2982a2cf11b$var$E({
            boundary: this.shiftBoundary,
            padding: this.shiftPadding
        }));
        if (this.autoSize) middleware.push($647fa2982a2cf11b$var$k({
            boundary: this.autoSizeBoundary,
            padding: this.autoSizePadding,
            apply: ({ availableWidth: availableWidth, availableHeight: availableHeight })=>{
                if (this.autoSize === "vertical" || this.autoSize === "both") this.style.setProperty("--auto-size-available-height", `${availableHeight}px`);
                else this.style.removeProperty("--auto-size-available-height");
                if (this.autoSize === "horizontal" || this.autoSize === "both") this.style.setProperty("--auto-size-available-width", `${availableWidth}px`);
                else this.style.removeProperty("--auto-size-available-width");
            }
        }));
        else {
            this.style.removeProperty("--auto-size-available-width");
            this.style.removeProperty("--auto-size-available-height");
        }
        if (this.arrow) middleware.push($647fa2982a2cf11b$var$m({
            element: this.arrowEl,
            padding: this.arrowPadding
        }));
        const getOffsetParent = this.strategy === "absolute" ? (element)=>$647fa2982a2cf11b$var$O2.getOffsetParent(element, $647fa2982a2cf11b$var$t2) : $647fa2982a2cf11b$var$O2.getOffsetParent;
        $647fa2982a2cf11b$var$z(this.anchorEl, this.popup, {
            placement: this.placement,
            middleware: middleware,
            strategy: this.strategy,
            platform: (0, $e49e29f9e0bf5d9a$export$f4da8f157c1253f7)((0, $e49e29f9e0bf5d9a$export$7de063a7aa429f6c)({}, $647fa2982a2cf11b$var$O2), {
                getOffsetParent: getOffsetParent
            })
        }).then(({ x: x3, y: y4, middlewareData: middlewareData, placement: placement })=>{
            const isRtl = getComputedStyle(this).direction === "rtl";
            const staticSide = {
                top: "bottom",
                right: "left",
                bottom: "top",
                left: "right"
            }[placement.split("-")[0]];
            this.setAttribute("data-current-placement", placement);
            Object.assign(this.popup.style, {
                left: `${x3}px`,
                top: `${y4}px`
            });
            if (this.arrow) {
                const arrowX = middlewareData.arrow.x;
                const arrowY = middlewareData.arrow.y;
                let top = "";
                let right = "";
                let bottom = "";
                let left = "";
                if (this.arrowPlacement === "start") {
                    const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    top = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    right = isRtl ? value : "";
                    left = isRtl ? "" : value;
                } else if (this.arrowPlacement === "end") {
                    const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    right = isRtl ? "" : value;
                    left = isRtl ? value : "";
                    bottom = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                } else if (this.arrowPlacement === "center") {
                    left = typeof arrowX === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
                    top = typeof arrowY === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
                } else {
                    left = typeof arrowX === "number" ? `${arrowX}px` : "";
                    top = typeof arrowY === "number" ? `${arrowY}px` : "";
                }
                Object.assign(this.arrowEl.style, {
                    top: top,
                    right: right,
                    bottom: bottom,
                    left: left,
                    [staticSide]: "calc(var(--arrow-size-diagonal) * -1)"
                });
            }
        });
        this.emit("sl-reposition");
    }
    render() {
        return (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <div
        part="popup"
        class=${(0, $16b9676b53049ea4$export$ae1af26003f05816)({
            popup: true,
            "popup--active": this.active,
            "popup--fixed": this.strategy === "fixed",
            "popup--has-arrow": this.arrow
        })}
      >
        <slot></slot>
        ${this.arrow ? (0, $a726e13e2eca4e53$export$4a5767248b18ef41)`<div part="arrow" class="popup__arrow" role="presentation"></div>` : ""}
      </div>
    `;
    }
};
$647fa2982a2cf11b$export$6fe469f0a31d1d6e.styles = (0, $bd9c72e8edc4e716$export$51897b955cb6c203);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)(".popup")
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "popup", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$23f2a1d2818174ef)(".popup__arrow")
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "arrowEl", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "anchor", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean,
        reflect: true
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "active", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        reflect: true
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "placement", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        reflect: true
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "strategy", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Number
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "distance", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Number
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "skidding", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "arrow", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "arrow-placement"
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "arrowPlacement", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "arrow-padding",
        type: Number
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "arrowPadding", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "flip", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "flip-fallback-placements",
        converter: {
            fromAttribute: (value)=>{
                return value.split(" ").map((p3)=>p3.trim()).filter((p3)=>p3 !== "");
            },
            toAttribute: (value)=>{
                return value.join(" ");
            }
        }
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "flipFallbackPlacements", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "flip-fallback-strategy"
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "flipFallbackStrategy", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Object
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "flipBoundary", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "flip-padding",
        type: Number
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "flipPadding", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Boolean
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "shift", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Object
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "shiftBoundary", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "shift-padding",
        type: Number
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "shiftPadding", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "auto-size"
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "autoSize", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)()
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "sync", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        type: Object
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "autoSizeBoundary", 2);
(0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$5c585649956053b)({
        attribute: "auto-size-padding",
        type: Number
    })
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e.prototype, "autoSizePadding", 2);
$647fa2982a2cf11b$export$6fe469f0a31d1d6e = (0, $e49e29f9e0bf5d9a$export$85c93885f16e8446)([
    (0, $ccaafd6984b825ef$export$f1e1789686576879)("sl-popup")
], $647fa2982a2cf11b$export$6fe469f0a31d1d6e);


























(0, $341694bf0b023991$export$a482e04ad60c9b11)('default', {
    resolver: (name)=>`https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.20.1/dist/assets/icons/${name}.svg`
});
class $2ca810133068c975$export$5c72981948cf123f {
}
$2ca810133068c975$export$5c72981948cf123f = (0, $g0n63.__decorate)([
    (0, $4XQlz.Module)({
        components: [
            (0, $347bd21f4cb3b0b0$export$ad2daa0f973a734d),
            (0, $9f5bf4c8848ae7c2$export$e01f6a745a6728bd),
            (0, $b1108cce0f47d1e0$export$a93c76cb301d0cc8),
            (0, $4d56e8bd2ce5debb$export$302c9d29315a4659),
            (0, $b52452a275c155e1$export$ef62a86bf282441),
            (0, $fcc9d0c49feca6c4$export$e56d306ebf763f31),
            (0, $74ee415e7de611e2$export$d3b5d44577dfd9a3),
            (0, $6b7d0c471f5635fa$export$59279638cac230bf),
            (0, $d9da14b52d0f25df$export$bd1a667628462930),
            (0, $4b83c7b40db027d1$export$8d28b91bbbe13ef5),
            (0, $f166debd41d5f5ee$export$4e45ce56e46d2b00),
            (0, $be6ff600a108f5d2$export$2c14a50cec0c625c)
        ]
    })
], $2ca810133068c975$export$5c72981948cf123f);


class $1da49d3f68760c7a$export$44568afb1bae0bd3 {
}
$1da49d3f68760c7a$export$44568afb1bae0bd3 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Module)({
        imports: [
            (0, $9h1ql.ModalModule).forRoot(),
            (0, $jWytf.ReactiveUiModule).forRoot({
                palettes: {
                    root: (0, $eG1Pq.css)`
          :root {
            --bp-s: 640px;
            --bp-m: 960px;
            --bp-l: 1200px;
            --bp-xl: 1600px;
            --sl-color-sky-600: var(--primary-color);
            --primary-color: #1481ba;
            --primary-dark: #306fcc;
            --secondary-color: #11b5e4;
            --accent-color: #06b6d4;
            --success-color: #10b981;
            --warning-color: #fce765 linear-gradient(90deg, #fedd0b 26.79%, #f6b71b 124.27%);
            --error-color: #ef4444;

            --text-primary: #1a1a1a;
            --text-secondary: #64748b;
            --text-muted: #94a3b8;

            --bg-primary: #ffffff;
            --bg-secondary: #f8fafc;
            --bg-tertiary: #f1f5f9;

            --border-light: #e2e8f0;
            --border-medium: #cbd5e1;
            --border-dark: #94a3b8;

            --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
            --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
            --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
            --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

            --radius-sm: 4px;
            --radius-md: 8px;
            --radius-lg: 12px;
            --radius-xl: 16px;
            --radius-full: 9999px;
          }
        `,
                    danger: (0, $eG1Pq.css)`
          :root {
            --danger-bg-color: #f0506e;
            --danger-color: #fff;
            --danger-border: 1px solid transparent;
            --danger-hover-color: #ee395b;
            --danger-active-color: #ec2147;
          }
        `,
                    default: (0, $eG1Pq.css)`
          :root {
            --default-bg-color: transparent;
            --default-color: #222;
            --default-border: 1px solid #e5e5e5;
            --default-hover-color: transparent;
            --default-hover-border: 1px solid #999;
          }
        `,
                    primary: (0, $eG1Pq.css)`
          :root {
            --primary-bg-color: #1e87f0;
            // --primary-color: #fff;
            --primary-border: 1px solid transparent;
            --primary-hover-color: #0f7ae5;
            --primary-active-color: #0e6dcd;
          }
        `,
                    secondary: (0, $eG1Pq.css)`
          :root {
            --secondary-bg-color: #222;
            // --secondary-color: #fff;
            --secondary-border: 1px solid transparent;
            --secondary-hover-color: #333;
            --secondary-active-color: #000;
          }
        `,
                    warning: (0, $eG1Pq.css)`
          :root {
            --warning-bg-color: #faa05a;
            // --warning-color: #fff;
            --warning-border: 1px solid transparent;
            --warning-hover-color: #e19457;
            --warning-active-color: #ef9a56;
          }
        `
                }
            }),
            (0, $8c4c26ff2319a8ee$export$790b57dd09b9e192),
            (0, $2ca810133068c975$export$5c72981948cf123f)
        ],
        components: [
            (0, $3f47c4b7e6d52f16$exports.ButtonComponent),
            (0, $8400c4dc1fb0914b$exports.DividerComponent),
            (0, $c06a86779e0ac857$exports.ForOperator),
            (0, $c06a86779e0ac857$exports.IfOperator),
            (0, $c06a86779e0ac857$exports.LetOperator),
            (0, $ee6bbef35fc5b57b$exports.ArticleComponent),
            (0, $6ebc7bebf415bf23$exports.LabelComponent),
            (0, $9d861f533b36a789$exports.SpinnerComponent),
            (0, $9e0ae11ef3a937dc$export$277db37d2617e2a5),
            (0, $1b0996d8e34d2b3a$export$a6651008bb5b591),
            (0, $5e9df50fa330fe0b$export$ab0e7d24cc58513)
        ],
        providers: [
            (0, $56Yze.ScrollToService),
            (0, $9heTP.ModalViewService),
            (0, $iB2Sj.DateTimeProvider)
        ]
    })
], $1da49d3f68760c7a$export$44568afb1bae0bd3);



var $g0n63 = parcelRequire("g0n63");
parcelRequire("rc2P5");
var $8H3st = parcelRequire("8H3st");

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");
class $cc004e4ef5db5bf0$export$1eefa63ea41131fe extends HTMLElement {
    OnInit() {
        // Preload endpoints for performance
        this.performanceOptimization();
        const loadingElement = document.querySelector('loading-screen-component');
        loadingElement?.remove();
    }
    performanceOptimization() {
        this.categoryService.listCategories().subscribe();
    }
}
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $8H3st.CategoryService))
], $cc004e4ef5db5bf0$export$1eefa63ea41131fe.prototype, "categoryService", void 0);
$cc004e4ef5db5bf0$export$1eefa63ea41131fe = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'app-component',
        template () {
            return (0, $eG1Pq.html)`
      <router-outlet>
        <navbar-component slot="header"></navbar-component>
        <footer-component slot="footer"></footer-component>
      </router-outlet>
    `;
        },
        container: document.body
    })
], $cc004e4ef5db5bf0$export$1eefa63ea41131fe);



var $g0n63 = parcelRequire("g0n63");
parcelRequire("rc2P5");
var $fG7Ap = parcelRequire("fG7Ap");
var $8H3st = parcelRequire("8H3st");
parcelRequire("6Lt8S");
var $2cx1H = parcelRequire("2cx1H");

var $itgC7 = parcelRequire("itgC7");

var $2Md89 = parcelRequire("2Md89");

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");

var $c22PD = parcelRequire("c22PD");
parcelRequire("czGZi");
var $9heTP = parcelRequire("9heTP");

var $dY50F = parcelRequire("dY50F");
var $iuXHq = parcelRequire("iuXHq");

var $23prF = parcelRequire("23prF");
class $3e1ab2764fc49be9$export$189e3f0ab56ac948 extends (0, $eG1Pq.LitElement) {
    createPost() {
        this.categoryService.listCategories().pipe((0, $iuXHq.switchMap)((categories)=>this.modal.openSelectCategoryModal(null, categories)), (0, $dY50F.filter)((v)=>!!v), (0, $iuXHq.switchMap)(({ id: id })=>this.blogService.createPost({
                category: id,
                content: 'Lorem Ipsum Dolor dolor simet',
                title: 'Ipsum mipsum boren pipsum ipsum simet',
                draft: true
            }))).subscribe(({ category: category, searchKey: searchKey })=>{
            this.router.go(`/blog/${category.searchKey}/${searchKey}/edit`);
            this.showMenu = false;
            (0, $23prF.success)('Post created successfully');
        });
    }
    createCategory() {
        this.categoryService.listCategories().pipe((0, $iuXHq.switchMap)((categories)=>this.modal.openCreateCategoryModal(null, categories)), (0, $dY50F.filter)((v)=>!!v), (0, $iuXHq.switchMap)((category)=>this.categoryService.createCategory([
                category
            ]))).subscribe(([category])=>{
            this.router.go(`/blog/${category.searchKey}`);
            this.showMenu = false;
            (0, $23prF.success)('Category created successfully');
        });
    }
    getMyDrafts() {
        this.router.go('/blog/all?draft=true');
        this.showMenu = false;
    }
    logout() {
        this.socialService.signOut().subscribe();
    }
}
(0, $g0n63.__decorate)([
    (0, $c22PD.Router)()
], $3e1ab2764fc49be9$export$189e3f0ab56ac948.prototype, "router", void 0);
(0, $g0n63.__decorate)([
    (0, $eG1Pq.state)()
], $3e1ab2764fc49be9$export$189e3f0ab56ac948.prototype, "showMenu", void 0);
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $fG7Ap.BlogService))
], $3e1ab2764fc49be9$export$189e3f0ab56ac948.prototype, "blogService", void 0);
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $8H3st.CategoryService))
], $3e1ab2764fc49be9$export$189e3f0ab56ac948.prototype, "categoryService", void 0);
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $9heTP.ModalViewService))
], $3e1ab2764fc49be9$export$189e3f0ab56ac948.prototype, "modal", void 0);
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $2cx1H.SocialService))
], $3e1ab2764fc49be9$export$189e3f0ab56ac948.prototype, "socialService", void 0);
$3e1ab2764fc49be9$export$189e3f0ab56ac948 = (0, $g0n63.__decorate)([
    (0, $itgC7.Component)({
        Settings: {
            selector: 'footer-component',
            style: (0, $eG1Pq.css)`
      .footer {
        position: fixed;
        right: 0;
        bottom: 0;
      }

      .icon {
        display: flex;
        padding: 10px;
        background: var(--primary-color);
        border-radius: 30px;
        margin-right: 15px;
        margin-bottom: 15px;
        cursor: pointer;
        position: absolute;
        bottom: 0;
        right: 0;
      }

      .icon:hover {
        opacity: 0.9;
      }

      sl-icon {
        color: white;
        width: 30px;
        height: 30px;
      }
    `,
            modifiers: [
                ...(0, $2Md89.AngularLayout)
            ]
        },
        Providers: (0, $itgC7.DefineDependencies)((0, $2cx1H.SocialService))((0, $4XQlz.Container)),
        State: function([socialService]) {
            return socialService.isLoggedIn;
        },
        Render: ()=>function(state) {
                console.log(state);
                return (0, $eG1Pq.html)`
        <div ngIf=${state} class="footer">
          ${this.showMenu ? (0, $eG1Pq.html)`
                <div style="position: absolute; bottom: 75px; right: 40px;">
                  <sl-menu>
                    <sl-menu-item @click=${()=>this.createPost()}>Create Post</sl-menu-item>
                    <sl-menu-item @click=${()=>this.createCategory()}>Create Category</sl-menu-item>
                    <sl-menu-item @click=${()=>this.getMyDrafts()}>My Drafts</sl-menu-item>
                    <sl-menu-item @click=${()=>this.logout()}>Logout</sl-menu-item>
                  </sl-menu>
                </div>
              ` : ''}
          <div
            class="icon"
            @click=${()=>{
                    this.showMenu = !this.showMenu;
                }}
          >
            <sl-icon name="patch-plus"></sl-icon>
          </div>
        </div>
      `;
            }
    })
], $3e1ab2764fc49be9$export$189e3f0ab56ac948);



var $g0n63 = parcelRequire("g0n63");

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");
parcelRequire("czGZi");
var $56Yze = parcelRequire("56Yze");

var $g0n63 = parcelRequire("g0n63");
parcelRequire("rc2P5");
var $hGKun = parcelRequire("hGKun");

var $2Md89 = parcelRequire("2Md89");

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");

/* eslint-disable lit/attribute-value-entities */ 
var $g0n63 = parcelRequire("g0n63");

var $eG1Pq = parcelRequire("eG1Pq");
class $0fdd2f4d8738caab$export$7247a66a181d9cf2 extends (0, $eG1Pq.LitElement) {
    constructor(...args){
        super(...args), this.address = '';
    }
}
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        type: String
    })
], $0fdd2f4d8738caab$export$7247a66a181d9cf2.prototype, "address", void 0);
$0fdd2f4d8738caab$export$7247a66a181d9cf2 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'google-map-component',
        styles: [
            (0, $eG1Pq.css)`
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }

      .map-container {
        width: 100%;
        height: 100%;
        min-height: 400px;
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid #e2e8f0;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        background: #f8fafc;
      }

      .map-placeholder {
        width: 100%;
        height: 100%;
        min-height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        color: #64748b;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
        font-size: 1rem;
        font-weight: 500;
      }

      .map-icon {
        width: 48px;
        height: 48px;
        margin-bottom: 16px;
        color: #0066ff;
      }

      iframe {
        width: 100%;
        height: 100%;
        border: 0;
        border-radius: 16px;
      }

      @media (max-width: 768px) {
        .map-container {
          min-height: 300px;
        }

        .map-placeholder {
          min-height: 300px;
        }
      }
    `
        ],
        template () {
            return (0, $eG1Pq.html)`
      <div class="map-container">
        <iframe
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyArEInk4_RHHhKu33RGFwqIpcPAdu0CoEg&q=${this.address}"
          allowfullscreen
        >
        </iframe>
      </div>
    `;
        }
    })
], $0fdd2f4d8738caab$export$7247a66a181d9cf2);



var $eG1Pq = parcelRequire("eG1Pq");
const $9e74e140c0a3f9ef$export$856a3733e3aa783 = (0, $eG1Pq.css)`
  /* Color Variables */

  /* Section Styles */
  .section {
    padding: 80px 0;
    position: relative;
  }

  .section-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--text-primary);
    text-align: center;
    margin-bottom: 1rem;
    line-height: 1.2;
  }

  .section-subtitle {
    font-size: 1.25rem;
    color: var(--text-secondary);
    text-align: center;
    margin-bottom: 3rem;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.6;
  }

  /* Container */
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  /* Button Styles */
  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    font-weight: 600;
    text-decoration: none;
    border-radius: var(--radius-md);
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
    // min-height: 48px;
  }

  .btn-primary {
    background: var(--primary-color);
    color: white;
  }

  .btn-primary:hover {
    background: var(--primary-dark);
    transform: translateY(-1px);
    box-shadow: var(--shadow-lg);
  }

  .btn-secondary {
    background: transparent;
    color: var(--primary-color);
    border: 2px solid var(--primary-color);
  }

  .btn-secondary:hover {
    background: var(--primary-color);
    color: white;
    transform: translateY(-1px);
  }

  .btn-outline {
    background: transparent;
    color: var(--text-primary);
    border: 2px solid var(--border-medium);
  }

  .btn-outline:hover {
    border-color: var(--primary-color);
    color: var(--primary-color);
  }

  /* Card Styles */
  .card {
    background: var(--bg-primary);
    border-radius: var(--radius-lg);
    padding: 2rem;
    box-shadow: var(--shadow-md);
    border: 1px solid var(--border-light);
    transition: all 0.3s ease;
  }

  .card:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-xl);
    border-color: var(--primary-color);
  }

  .card-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 1rem;
  }

  .card-description {
    color: var(--text-secondary);
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }

  /* Card Variants */
  .card-bordered {
    border-left: 4px solid var(--primary-color);
    margin-top: 20px;
  }

  .card-with-top-border::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  }

  .card.library-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  }

  /* Stats Card */
  .stats-card {
    text-align: center;
    padding: 40px 24px;
  }

  .stats-number {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--primary-color);
    margin-bottom: 12px;
    display: block;
    line-height: 1;
  }

  .stats-label {
    font-size: 1rem;
    color: var(--text-secondary);
    font-weight: 500;
  }

  /* Service Card */
  .service-card {
    height: 100%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .service-illustration {
    width: 100%;
    height: 180px;
    border-radius: var(--radius-lg);
    background: var(--bg-secondary);
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-light);
    transition: all 0.3s ease;
  }

  .service-card:hover .service-illustration {
    background: var(--bg-tertiary);
    border-color: var(--primary-color);
  }

  .service-illustration img {
    width: 80%;
    height: 80%;
    object-fit: contain;
    transition: transform 0.3s ease;
  }

  .service-card:hover .service-illustration img {
    transform: scale(1.1);
  }

  /* Library Card */
  .library-card {
    position: relative;
    overflow: hidden;
  }

  .library-features {
    list-style: none;
    padding: 0;
    margin: 20px 0;
  }

  .library-features li {
    padding: 8px 0;
    color: var(--text-secondary);
    position: relative;
    padding-left: 24px;
    font-weight: 400;
  }

  .library-features li::before {
    content: '🗹';
    position: absolute;
    left: 0;
    color: var(--primary-color);
  }

  .library-stats {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid var(--border-light);
  }

  .library-stat {
    text-align: center;
  }

  .library-stat-number {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--primary-color);
    display: block;
  }

  .library-stat-label {
    font-size: 0.875rem;
    color: var(--text-secondary);
    font-weight: 500;
  }

  /* Grid Layouts */
  .grid {
    display: grid;
    gap: 2rem;
  }

  .grid-2 {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }

  .grid-3 {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  .grid-4 {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  /* Flexbox Utilities */
  .flex {
    display: flex;
  }

  .flex-col {
    flex-direction: column;
  }

  .items-center {
    align-items: center;
  }

  .justify-center {
    justify-content: center;
  }

  .justify-between {
    justify-content: space-between;
  }

  .gap-4 {
    gap: 1rem;
  }

  .gap-6 {
    gap: 1.5rem;
  }

  .gap-8 {
    gap: 2rem;
  }

  /* Text Utilities */
  .text-center {
    text-align: center;
  }

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

  .font-bold {
    font-weight: 700;
  }

  .font-semibold {
    font-weight: 600;
  }

  .text-primary {
    color: var(--text-primary);
  }

  .text-secondary {
    color: var(--text-secondary);
  }

  .text-muted {
    color: var(--text-muted);
  }

  /* Spacing */
  .mb-4 {
    margin-bottom: 1rem;
  }

  .mb-6 {
    margin-bottom: 1.5rem;
  }

  .mb-8 {
    margin-bottom: 2rem;
  }

  .mb-12 {
    margin-bottom: 3rem;
  }

  .mt-4 {
    margin-top: 1rem;
  }

  .mt-6 {
    margin-top: 1.5rem;
  }

  .mt-8 {
    margin-top: 2rem;
  }

  .mt-12 {
    margin-top: 3rem;
  }

  /* Background Utilities */
  .bg-primary {
    background: var(--bg-primary);
  }

  .bg-secondary {
    background: var(--bg-secondary);
  }

  .bg-tertiary {
    background: var(--bg-tertiary);
  }

  /* Border Utilities */
  .border {
    border: 1px solid var(--border-light);
  }

  .border-t {
    border-top: 1px solid var(--border-light);
  }

  .border-b {
    border-bottom: 1px solid var(--border-light);
  }

  /* Shadow Utilities */
  .shadow-sm {
    box-shadow: var(--shadow-sm);
  }

  .shadow-md {
    box-shadow: var(--shadow-md);
  }

  .shadow-lg {
    box-shadow: var(--shadow-lg);
  }

  .shadow-xl {
    box-shadow: var(--shadow-xl);
  }

  /* Animation Classes */
  .animate-in {
    opacity: 1;
    transform: translateY(0);
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .container {
      padding: 0 1rem;
    }

    .section {
      padding: 60px 0;
    }

    .section-title {
      font-size: 2rem;
    }

    .section-subtitle {
      font-size: 1.125rem;
    }

    .grid-2,
    .grid-3,
    .grid-4 {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 480px) {
    .section-title {
      font-size: 1.75rem;
    }

    .card {
      padding: 1.5rem;
    }
  }
`;


class $5ad552b087a0a476$export$f5d4b1ce866dd389 extends (0, $eG1Pq.LitElement) {
}
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $hGKun.AnalyticsService))
], $5ad552b087a0a476$export$f5d4b1ce866dd389.prototype, "analytics", void 0);
$5ad552b087a0a476$export$f5d4b1ce866dd389 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'contact-component',
        components: [
            (0, $8400c4dc1fb0914b$exports.DividerComponent),
            (0, $0fdd2f4d8738caab$export$7247a66a181d9cf2)
        ],
        styles: [
            (0, $eG1Pq.css)`
      ${(0, $9e74e140c0a3f9ef$export$856a3733e3aa783)}

      :host {
        display: block;
        color: var(--text-primary);
      }

      .section-header {
        text-align: center;
        margin-bottom: 64px;
      }

      .section-description {
        color: var(--text-secondary);
        font-size: 1.125rem;
        line-height: 1.7;
        max-width: 600px;
        margin: 0 auto;
        font-weight: 400;
      }

      .contact-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 48px;
        max-width: 1200px;
        margin: 0 auto;
      }

      .contact-info {
        padding: 48px;
      }

      .contact-details {
        margin-top: 32px;
      }

      .contact-item {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 24px;
        color: var(--text-secondary);
        font-weight: 400;
      }

      .contact-item svg {
        width: 24px;
        height: 24px;
        color: var(--primary-color);
      }

      .contact-item a {
        color: var(--primary-color);
        text-decoration: none;
        transition: color 0.3s ease;
        font-weight: 500;
      }

      .contact-item a:hover {
        color: var(--primary-dark);
        text-decoration: underline;
      }

      .map-container {
        height: 100%;
        min-height: 400px;
        border-radius: var(--radius-xl);
        overflow: hidden;
        border: 1px solid var(--border-light);
        box-shadow: var(--shadow-sm);
      }

      @media (max-width: 1024px) {
        .contact-grid {
          grid-template-columns: 1fr;
          gap: 32px;
        }
      }

      @media (max-width: 768px) {
        .contact-info {
          padding: 32px;
        }

        .map-container {
          min-height: 300px;
        }
      }
    `
        ],
        modifiers: [
            ...(0, $2Md89.FlexLayout),
            ...(0, $2Md89.AngularLayout)
        ],
        template () {
            return (0, $eG1Pq.html)`
      <section class="section" id="contact">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">Get In Touch</h2>
            <rx-divider></rx-divider>
            <p class="section-description">
              Ready to start your next project? Let's discuss how we can help you build exceptional web applications
              with our modern frameworks and tools.
            </p>
          </div>

          <div class="contact-grid">
            <div class="card contact-info">
              <h3 class="card-title">Reactive Solutions</h3>
              <p style="color: var(--text-secondary); line-height: 1.6; margin-bottom: 24px;">
                We specialize in modern web development using cutting-edge technologies and frameworks to deliver
                exceptional user experiences.
              </p>

              <div class="contact-details">
                <div class="contact-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                    />
                  </svg>
                  <a
                    @click=${()=>this.analytics.track('contact_click', {
                    type: 'email',
                    action: 'click'
                })}
                    href="mailto:support@reactivum.com"
                    >support@reactivum.com</a
                  >
                </div>

                <div class="contact-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                    />
                  </svg>
                  <a
                    @click=${()=>this.analytics.track('contact_click', {
                    type: 'phone',
                    action: 'click'
                })}
                    href="tel:+359876667537"
                    >+359 876-667-537</a
                  >
                </div>

                <div class="contact-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                    />
                  </svg>
                  <span>Sofia, Bulgaria</span>
                </div>

                <div class="contact-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                    />
                  </svg>
                  <span>Available for new projects</span>
                </div>
              </div>
            </div>

            <div class="map-container">
              <google-map-component address="София, България, Леонардо Да Винчи 9"></google-map-component>
            </div>
          </div>
        </div>
      </section>
    `;
        }
    })
], $5ad552b087a0a476$export$f5d4b1ce866dd389);



var $g0n63 = parcelRequire("g0n63");

var $2Md89 = parcelRequire("2Md89");

var $eG1Pq = parcelRequire("eG1Pq");

class $76a74515b95de46b$export$ac64dc01870730c4 extends (0, $eG1Pq.LitElement) {
}
$76a74515b95de46b$export$ac64dc01870730c4 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'frameworks-component',
        styles: [
            (0, $eG1Pq.css)`
      ${(0, $9e74e140c0a3f9ef$export$856a3733e3aa783)}

      :host {
        display: block;
        color: var(--text-primary);
      }

      .libraries-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 32px;
        margin-top: 40px;
      }

      .library-name {
        font-size: 1.75rem;
        font-weight: 700;
        margin-bottom: 12px;
        color: var(--primary-color);
        font-family: 'Courier New', monospace;
      }

      .library-tagline {
        font-size: 1rem;
        color: var(--text-secondary);
        margin-bottom: 16px;
        font-style: italic;
        font-weight: 400;
      }

      .library-description {
        font-size: 1rem;
        line-height: 1.6;
        color: var(--text-secondary);
        margin-bottom: 20px;
        font-weight: 400;
      }

      .github-link {
        display: inline-flex;
        align-items: center;
        margin-top: 16px;
        padding: 10px 20px;
        background: var(--bg-secondary);
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        color: var(--primary-color);
        text-decoration: none;
        font-size: 0.9rem;
        font-weight: 500;
        transition: all 0.3s ease;
      }

      .github-link:hover {
        background: var(--primary-color);
        color: white;
        border-color: var(--primary-color);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 102, 255, 0.3);
      }

      @media (max-width: 768px) {
        .libraries-grid {
          grid-template-columns: 1fr;
          gap: 24px;
        }
      }
    `
        ],
        modifiers: [
            ...(0, $2Md89.FlexLayout),
            ...(0, $2Md89.AngularLayout)
        ],
        template () {
            return (0, $eG1Pq.html)`
      <section class="section" id="frameworks">
        <div class="container">
          <h2 class="section-title">Our Complete Technology Stack</h2>

          <!-- Why Choose Us Section -->
          <div class="card card-bordered">
            <h3 class="card-title">Why Reactive Solutions?</h3>
            <div class="card-description">
              <p>
                We offer a unique ecosystem of in-house, open-source tools designed for both frontend and backend
                development, built using the latest technologies and standards. Our solutions empower developers to work
                more efficiently and consistently, providing significant value to companies looking to scale.
              </p>
            </div>
          </div>

          <!-- Key Advantages Grid -->
          <div class="libraries-grid" style="margin-top: 40px;">
            <div class="card library-card">
              <div class="library-name">Expert Team</div>
              <div class="library-tagline">Compact Development Team of Experts</div>
              <div class="library-description">
                Our team consists of highly skilled developers with extensive experience in modern web technologies. We
                maintain a compact yet efficient team structure to ensure direct communication and rapid development.
              </div>
              <ul class="library-features">
                <li>Highly skilled developers</li>
                <li>Extensive modern tech experience</li>
                <li>Compact, efficient team structure</li>
                <li>Direct communication</li>
                <li>Rapid development cycles</li>
              </ul>
            </div>

            <div class="card library-card">
              <div class="library-name">Modern Web Components</div>
              <div class="library-tagline">@rhtml Web Component Approach</div>
              <div class="library-description">
                We specialize in modern web component development using our @rhtml framework with GraphQL queries. Our
                approach provides better performance, smaller bundle sizes, and native browser compatibility.
              </div>
              <ul class="library-features">
                <li>@rhtml web component framework</li>
                <li>GraphQL query integration</li>
                <li>Native browser compatibility</li>
                <li>Smaller bundle sizes</li>
                <li>Better performance</li>
              </ul>
            </div>

            <div class="card library-card">
              <div class="library-name">Productivity Focus</div>
              <div class="library-tagline">We Love Being Productive</div>
              <div class="library-description">
                Efficiency drives us - our mission is turning ideas into high quality software with smart solutions. We
                utilize cutting-edge tools and methodologies to maximize productivity and deliver results quickly.
              </div>
              <ul class="library-features">
                <li>Efficiency-driven development</li>
                <li>High quality software delivery</li>
                <li>Smart solution design</li>
                <li>Cutting-edge tools</li>
                <li>Rapid results delivery</li>
              </ul>
            </div>
          </div>

          <!-- Frontend Frameworks Section -->
          <div class="card card-bordered" style="margin-top: 60px;">
            <h3 class="card-title">The Well-Known Frontend Frameworks</h3>
            <div class="card-description">
              <p>
                Our frontend approach is built around modern web components and reactive programming, providing a
                lightweight, performant alternative to traditional frameworks.
              </p>
            </div>
          </div>

          <div class="libraries-grid" style="margin-top: 40px;">
            <div class="card library-card">
              <div class="library-name">@rhtml</div>
              <div class="library-tagline">Modern Web Components</div>
              <div class="library-description">
                The world's smallest dependency injection system at less than 1.4kb. Features @Component decorator,
                declarative operators, and monadic programming patterns for ultra-fast web applications.
              </div>
              <ul class="library-features">
                <li>&lt;1.4kb DI system</li>
                <li>@Component decorator</li>
                <li>Declarative operators (r-let, r-if)</li>
                <li>Server Side Rendering ready</li>
                <li>Monadic programming patterns</li>
              </ul>
              <div class="library-stats">
                <div class="library-stat">
                  <span class="library-stat-number">1.4kb</span>
                  <span class="library-stat-label">Size</span>
                </div>
                <div class="library-stat">
                  <span class="library-stat-number">0.3kb</span>
                  <span class="library-stat-label">Bundled</span>
                </div>
              </div>
              <a href="https://github.com/r-html/rhtml" class="github-link" target="_blank">View on GitHub →</a>
            </div>

            <div class="card library-card">
              <div class="library-name">@rxdi</div>
              <div class="library-tagline">Reactive Extension Dependency Injection</div>
              <div class="library-description">
                A powerful dependency injection container that works seamlessly in both browser and Node.js
                environments. Built with reactive programming principles, it provides the foundation for all our
                frameworks.
              </div>
              <ul class="library-features">
                <li>Cross-platform DI container</li>
                <li>Reactive programming support</li>
                <li>Angular-inspired decorators</li>
                <li>TypeScript-first design</li>
              </ul>
              <div class="library-stats">
                <div class="library-stat">
                  <span class="library-stat-number">6+</span>
                  <span class="library-stat-label">Years</span>
                </div>
                <div class="library-stat">
                  <span class="library-stat-number">∞</span>
                  <span class="library-stat-label">Flexibility</span>
                </div>
              </div>
              <a href="https://github.com/rxdi/rxdi" class="github-link" target="_blank">View on GitHub →</a>
            </div>
          </div>

          <!-- Backend Solutions Section -->
          <div class="card card-bordered" style="margin-top: 60px;">
            <h3 class="card-title">The Modern Backend Solutions</h3>
            <div class="card-description">
              <p>
                Our backend solutions are built with GraphQL-first architecture, providing powerful APIs with minimal
                effort and maximum flexibility.
              </p>
            </div>
          </div>

          <div class="libraries-grid" style="margin-top: 40px;">
            <div class="card library-card">
              <div class="library-name">@gapi</div>
              <div class="library-tagline">GraphQL API Framework</div>
              <div class="library-description">
                Inspired by Angular, @gapi provides complex Node.js GraphQL backend applications with minimum effort.
                Features decorators, guards, interceptors, and comprehensive TypeScript support.
              </div>
              <ul class="library-features">
                <li>GraphQL-first architecture</li>
                <li>Decorator-based development</li>
                <li>Built-in authentication & guards</li>
                <li>Heroku & AWS Serverless ready</li>
                <li>27+ GitHub stars</li>
              </ul>
              <div class="library-stats">
                <div class="library-stat">
                  <span class="library-stat-number">27</span>
                  <span class="library-stat-label">Stars</span>
                </div>
                <div class="library-stat">
                  <span class="library-stat-number">308</span>
                  <span class="library-stat-label">Releases</span>
                </div>
              </div>
              <a href="https://github.com/Stradivario/gapi" class="github-link" target="_blank">View on GitHub →</a>
            </div>

            <div class="card library-card">
              <div class="library-name">graphql-server.com</div>
              <div class="library-tagline">Serverless Backend Platform</div>
              <div class="library-description">
                Our flagship platform combining Agile/Kanban project management with instant GraphQL/REST backend
                generation using custom serverless architecture on Kubernetes.
              </div>
              <ul class="library-features">
                <li>Instant backend generation</li>
                <li>Agile/Kanban project management</li>
                <li>Serverless architecture</li>
                <li>Kubernetes orchestration</li>
                <li>&lt;100ms response times</li>
              </ul>
              <div class="library-stats">
                <div class="library-stat">
                  <span class="library-stat-number">&lt;100ms</span>
                  <span class="library-stat-label">Response</span>
                </div>
                <div class="library-stat">
                  <span class="library-stat-number">∞</span>
                  <span class="library-stat-label">Scalability</span>
                </div>
              </div>
              <a href="https://graphql-server.com" class="github-link" target="_blank">Visit Platform →</a>
            </div>
          </div>

          <!-- DevOps Tooling Section -->
          <div class="card card-bordered" style="margin-top: 60px;">
            <h3 class="card-title">DevOps Tooling</h3>
            <div class="card-description">
              <p>
                Our DevOps approach ensures reliable, scalable deployments with modern containerization and
                orchestration technologies.
              </p>
            </div>
          </div>

          <div class="libraries-grid" style="margin-top: 40px;">
            <div class="card library-card">
              <div class="library-name">Kubernetes</div>
              <div class="library-tagline">Container Orchestration</div>
              <div class="library-description">
                We leverage Kubernetes for container orchestration, providing scalable, reliable deployments for our
                serverless architecture and microservices.
              </div>
              <ul class="library-features">
                <li>Container orchestration</li>
                <li>Auto-scaling capabilities</li>
                <li>High availability</li>
                <li>Service discovery</li>
                <li>Load balancing</li>
              </ul>
            </div>

            <div class="card library-card">
              <div class="library-name">Serverless</div>
              <div class="library-tagline">Cloud-Native Architecture</div>
              <div class="library-description">
                Our serverless approach provides cost-effective, scalable solutions with automatic resource management
                and pay-per-use pricing.
              </div>
              <ul class="library-features">
                <li>Pay-per-use pricing</li>
                <li>Automatic scaling</li>
                <li>Zero server management</li>
                <li>High availability</li>
                <li>Event-driven architecture</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    `;
        }
    })
], $76a74515b95de46b$export$ac64dc01870730c4);



var $g0n63 = parcelRequire("g0n63");
parcelRequire("rc2P5");
var $hGKun = parcelRequire("hGKun");

var $2Md89 = parcelRequire("2Md89");

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");

var $j8NvH = parcelRequire("j8NvH");

var $g0n63 = parcelRequire("g0n63");

var $d1fLk = parcelRequire("d1fLk");
class $3d69e531819a5bb4$export$c7cad6b3e396923a extends (0, $d1fLk.Attribute) {
    OnInit() {
        // console.log('ScrollObserver: OnInit called');
        // Hide the element initially
        this.element.style.opacity = '0';
        this.element.style.transform = 'translateY(20px)';
        this.element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        this.setupObserver();
    }
    OnDestroy() {
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
    }
    OnUpdate() {
        this.hasAnimated = false;
        this.element.classList.remove('animate-in');
        // Reset to hidden state
        this.element.style.opacity = '0';
        this.element.style.transform = 'translateY(20px)';
    }
    setupObserver() {
        const threshold = parseFloat(this.threshold) || 0.1;
        const rootMargin = this.rootMargin || '0px 0px -50px 0px';
        // console.log('ScrollObserver: Setting up observer with threshold:', threshold);
        this.intersectionObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                // console.log('ScrollObserver: Element intersecting:', entry.isIntersecting, 'hasAnimated:', this.hasAnimated);
                if (entry.isIntersecting && !this.hasAnimated) // console.log('ScrollObserver: Triggering animation');
                this.triggerAnimation();
            });
        }, {
            threshold: threshold,
            rootMargin: rootMargin
        });
        this.intersectionObserver.observe(this.element);
    // console.log('ScrollObserver: Observer attached to element');
    }
    triggerAnimation() {
        // console.log('ScrollObserver: Animation triggered');
        this.hasAnimated = true;
        // Show the element first
        this.element.style.opacity = '1';
        this.element.style.transform = 'translateY(0)';
        // Add animate-in class
        this.element.classList.add('animate-in');
        // Trigger any existing animated attributes by dispatching a custom event
        const animatedElements = this.element.querySelectorAll('[animated]');
        // console.log('ScrollObserver: Found animated elements:', animatedElements.length);
        animatedElements.forEach((el)=>{
            if (el instanceof HTMLElement) {
                // Force the animation by dispatching a custom event
                const event = new CustomEvent('animation-trigger', {
                    bubbles: true,
                    detail: {
                        element: el
                    }
                });
                el.dispatchEvent(event);
                // Also try to force a re-render by toggling classes
                const animatedClass = el.getAttribute('animated');
                if (animatedClass) {
                    // console.log('ScrollObserver: Re-triggering animation for:', animatedClass);
                    el.classList.remove(animatedClass);
                    el.classList.remove('animated');
                    setTimeout(()=>{
                        el.classList.add('animated');
                        el.classList.add(animatedClass);
                    }, 50);
                }
            }
        });
    }
    constructor(...args){
        super(...args), this.threshold = '0.1', this.rootMargin = '0px 0px -50px 0px', this.intersectionObserver = null, this.hasAnimated = false;
    }
}
(0, $g0n63.__decorate)([
    (0, $d1fLk.Input)({
        observe: true
    })
], $3d69e531819a5bb4$export$c7cad6b3e396923a.prototype, "threshold", void 0);
(0, $g0n63.__decorate)([
    (0, $d1fLk.Input)({
        observe: true
    })
], $3d69e531819a5bb4$export$c7cad6b3e396923a.prototype, "rootMargin", void 0);
$3d69e531819a5bb4$export$c7cad6b3e396923a = (0, $g0n63.__decorate)([
    (0, $d1fLk.Modifier)({
        selector: 'scroll-observer',
        registry () {
            return new (0, $d1fLk.CustomAttributeRegistry)(this);
        }
    })
], $3d69e531819a5bb4$export$c7cad6b3e396923a);



var $g0n63 = parcelRequire("g0n63");

var $d1fLk = parcelRequire("d1fLk");
class $18f5d65820ae3466$export$1bc430945f060dd1 extends (0, $d1fLk.Attribute) {
    OnInit() {
        console.log('Parallax: OnInit called with speed:', this.speed, 'direction:', this.direction);
        this.boundHandleScroll = this.handleScroll.bind(this);
        this.setupParallax();
    }
    OnDestroy() {
        window.removeEventListener('scroll', this.boundHandleScroll);
    }
    OnUpdate() {
        // Recalculate position when attributes change
        this.updatePosition();
    }
    setupParallax() {
        // Set initial styles
        this.element.style.transform = 'translateZ(0)';
        this.element.style.willChange = 'transform';
        // Add scroll listener
        window.addEventListener('scroll', this.boundHandleScroll);
        // Initial position update
        this.updatePosition();
        console.log('Parallax: Setup complete');
    }
    updatePosition() {
        const speed = parseFloat(this.speed) || 0.5;
        const direction = this.direction || 'up';
        const rect = this.element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;
        // Calculate how much of the element is visible
        const elementTop = rect.top;
        const elementHeight = rect.height;
        const elementLeft = rect.left;
        const elementWidth = rect.width;
        // Calculate progress (0 to 1) based on element position
        let progress = 0;
        if (direction === 'up' || direction === 'down') progress = (windowHeight - elementTop) / (windowHeight + elementHeight);
        else progress = (windowWidth - elementLeft) / (windowWidth + elementWidth);
        progress = Math.max(0, Math.min(1, progress));
        // Calculate transform based on direction and speed
        let transform = '';
        switch(direction){
            case 'up':
                transform = `translateY(${progress * speed * 100}px)`;
                break;
            case 'down':
                transform = `translateY(${-progress * speed * 100}px)`;
                break;
            case 'left':
                transform = `translateX(${progress * speed * 100}px)`;
                break;
            case 'right':
                transform = `translateX(${-progress * speed * 100}px)`;
                break;
            default:
                transform = `translateY(${progress * speed * 100}px)`;
        }
        this.element.style.transform = `translateZ(0) ${transform}`;
        console.log('Parallax: Updated position - progress:', progress.toFixed(2), 'transform:', transform);
    }
    constructor(...args){
        super(...args), this.speed = '0.5', this.direction = 'up' // 'up', 'down', 'left', 'right'
        , this.ticking = false, this.currentY = 0, this.currentX = 0, this.handleScroll = ()=>{
            if (!this.ticking) {
                requestAnimationFrame(()=>{
                    this.updatePosition();
                    this.ticking = false;
                });
                this.ticking = true;
            }
        };
    }
}
(0, $g0n63.__decorate)([
    (0, $d1fLk.Input)({
        observe: true
    })
], $18f5d65820ae3466$export$1bc430945f060dd1.prototype, "speed", void 0);
(0, $g0n63.__decorate)([
    (0, $d1fLk.Input)({
        observe: true
    })
], $18f5d65820ae3466$export$1bc430945f060dd1.prototype, "direction", void 0);
$18f5d65820ae3466$export$1bc430945f060dd1 = (0, $g0n63.__decorate)([
    (0, $d1fLk.Modifier)({
        selector: 'parallaxx',
        registry () {
            return new (0, $d1fLk.CustomAttributeRegistry)(this);
        }
    })
], $18f5d65820ae3466$export$1bc430945f060dd1);




var $j8NvH = parcelRequire("j8NvH");

var $56Yze = parcelRequire("56Yze");

class $6a29ff4768ec260b$export$6e72650f8ca84b85 extends (0, $eG1Pq.LitElement) {
    scrollToSection(componentName) {
        this.scrollToService.scrollToElement(componentName);
    }
}
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $hGKun.AnalyticsService))
], $6a29ff4768ec260b$export$6e72650f8ca84b85.prototype, "analytics", void 0);
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $56Yze.ScrollToService))
], $6a29ff4768ec260b$export$6e72650f8ca84b85.prototype, "scrollToService", void 0);
$6a29ff4768ec260b$export$6e72650f8ca84b85 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'hero-component',
        styles: [
            (0, $eG1Pq.css)`
      ${(0, $9e74e140c0a3f9ef$export$856a3733e3aa783)}

      :host {
        display: block;
        color: var(--text-primary);
      }

      .hero-section {
        padding: 120px 0 100px 0;
        background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--border-light) 50%, var(--bg-tertiary) 100%);
        text-align: center;
        position: relative;
        overflow: hidden;
      }

      .hero-section::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><defs><linearGradient id="bgGrad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:%230066ff;stop-opacity:0.03"/><stop offset="50%" style="stop-color:%234f46e5;stop-opacity:0.02"/><stop offset="100%" style="stop-color:%230066ff;stop-opacity:0.03"/></linearGradient></defs><rect width="400" height="400" fill="url(%23bgGrad)"/><g opacity="0.4"><!-- Floating particles --><circle cx="50" cy="50" r="1.5" fill="%230066ff" opacity="0.3"/><circle cx="150" cy="80" r="1" fill="%230066ff" opacity="0.2"/><circle cx="250" cy="120" r="2" fill="%230066ff" opacity="0.25"/><circle cx="350" cy="60" r="1.5" fill="%230066ff" opacity="0.3"/><circle cx="100" cy="180" r="1" fill="%230066ff" opacity="0.2"/><circle cx="200" cy="220" r="1.5" fill="%230066ff" opacity="0.25"/><circle cx="300" cy="160" r="1" fill="%230066ff" opacity="0.3"/><circle cx="50" cy="280" r="2" fill="%230066ff" opacity="0.2"/><circle cx="150" cy="320" r="1.5" fill="%230066ff" opacity="0.25"/><circle cx="250" cy="260" r="1" fill="%230066ff" opacity="0.3"/><circle cx="350" cy="300" r="1.5" fill="%230066ff" opacity="0.2"/><!-- Subtle grid lines --><path d="M 0 100 L 400 100" stroke="%230066ff" stroke-width="0.5" opacity="0.1"/><path d="M 0 200 L 400 200" stroke="%230066ff" stroke-width="0.5" opacity="0.1"/><path d="M 0 300 L 400 300" stroke="%230066ff" stroke-width="0.5" opacity="0.1"/><path d="M 100 0 L 100 400" stroke="%230066ff" stroke-width="0.5" opacity="0.1"/><path d="M 200 0 L 200 400" stroke="%230066ff" stroke-width="0.5" opacity="0.1"/><path d="M 300 0 L 300 400" stroke="%230066ff" stroke-width="0.5" opacity="0.1"/><!-- Diagonal accent lines --><path d="M 0 0 L 100 100" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 100 0 L 200 100" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 200 0 L 300 100" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 300 0 L 400 100" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 0 100 L 100 200" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 100 100 L 200 200" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 200 100 L 300 200" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 300 100 L 400 200" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 0 200 L 100 300" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 100 200 L 200 300" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 200 200 L 300 300" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 300 200 L 400 300" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 0 300 L 100 400" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 100 300 L 200 400" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 200 300 L 300 400" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><path d="M 300 300 L 400 400" stroke="%230066ff" stroke-width="0.3" opacity="0.08"/><!-- Small decorative elements --><rect x="75" y="75" width="2" height="2" fill="%230066ff" opacity="0.15"/><rect x="175" y="175" width="1.5" height="1.5" fill="%230066ff" opacity="0.12"/><rect x="275" y="275" width="2" height="2" fill="%230066ff" opacity="0.15"/><rect x="125" y="125" width="1.5" height="1.5" fill="%230066ff" opacity="0.12"/><rect x="225" y="225" width="2" height="2" fill="%230066ff" opacity="0.15"/><rect x="325" y="325" width="1.5" height="1.5" fill="%230066ff" opacity="0.12"/></g></svg>');
        opacity: 0.8;
        animation: patternFloat 30s ease-in-out infinite;
      }

      @keyframes patternFloat {
        0%,
        100% {
          transform: translateY(0px) translateX(0px);
          opacity: 0.8;
        }
        25% {
          transform: translateY(-5px) translateX(2px);
          opacity: 0.9;
        }
        50% {
          transform: translateY(-2px) translateX(-1px);
          opacity: 0.7;
        }
        75% {
          transform: translateY(-8px) translateX(1px);
          opacity: 0.85;
        }
      }

      .hero-content {
        position: relative;
        z-index: 2;
        max-width: 800px;
        margin: 0 auto;
      }

      .hero-title {
        font-size: 3.5rem;
        font-weight: 700;
        margin-bottom: 24px;
        background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        line-height: 1.2;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
      }

      .hero-subtitle {
        font-size: 1.25rem;
        color: var(--text-secondary);
        max-width: 600px;
        margin: 0 auto 40px auto;
        line-height: 1.6;
        font-weight: 400;
      }

      .hero-buttons {
        display: flex;
        gap: 16px;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 40px;
      }

      .primary-button {
        background: var(--primary-color);
        color: white;
        padding: 16px 32px;
        border-radius: var(--radius-lg);
        text-decoration: none;
        font-weight: 600;
        font-size: 1rem;
        transition: all 0.3s ease;
        border: none;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(0, 102, 255, 0.3);
      }

      .primary-button:hover {
        background: var(--primary-dark);
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(0, 102, 255, 0.4);
      }

      .secondary-button {
        background: white;
        color: var(--primary-color);
        padding: 16px 32px;
        border-radius: var(--radius-lg);
        text-decoration: none;
        font-weight: 600;
        font-size: 1rem;
        transition: all 0.3s ease;
        border: 2px solid var(--border-light);
        cursor: pointer;
      }

      .secondary-button:hover {
        border-color: var(--primary-color);
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      }

      .hero-stats {
        display: flex;
        justify-content: center;
        gap: 60px;
        margin-top: 80px;
        flex-wrap: wrap;
      }

      .stat-item {
        text-align: center;
      }

      .stat-number {
        font-size: 2.5rem;
        font-weight: 700;
        color: var(--primary-color);
        display: block;
        line-height: 1;
      }

      .stat-label {
        font-size: 0.9rem;
        color: var(--text-secondary);
        margin-top: 8px;
        font-weight: 500;
      }

      @media (max-width: 768px) {
        .hero-section {
          padding: 100px 0 80px 0;
        }

        .hero-title {
          font-size: 2.5rem;
        }

        .hero-subtitle {
          font-size: 1.1rem;
        }

        .hero-buttons {
          flex-direction: column;
          align-items: center;
        }

        .hero-stats {
          gap: 40px;
        }
      }
    `
        ],
        modifiers: [
            ...(0, $2Md89.FlexLayout),
            ...(0, $2Md89.AngularLayout),
            (0, $j8NvH.Animation),
            (0, $3d69e531819a5bb4$export$c7cad6b3e396923a),
            (0, $18f5d65820ae3466$export$1bc430945f060dd1)
        ],
        template () {
            return (0, $eG1Pq.html)`
      <section class="hero-section" id="hero" scroll-observer threshold="0.3">
        <div class="container">
          <div class="hero-content" parallax speed="0.1" direction="up">
            <h1 class="hero-title" animated="fadeInDown" delay="0.3s">Modern Web Development Solutions</h1>
            <p class="hero-subtitle" animated="fadeInUp" delay="0.6s">
              Revolutionizing web development with innovative frameworks and tools that prioritize developer experience,
              code quality, and system maintainability.
            </p>

            <div class="hero-buttons" animated="fadeInUp" delay="0.9s">
              <a
                @click=${()=>{
                this.analytics.track('hero_cta_click', {
                    button_text: 'Contact Us',
                    action: 'navigate'
                });
                this.scrollToSection('contact-component');
            }}
                class="primary-button"
                >Contact Us</a
              >
              <a
                @click=${()=>{
                this.analytics.track('hero_cta_click', {
                    button_text: 'Explore Frameworks',
                    action: 'navigate'
                });
                this.scrollToSection('frameworks-component');
            }}
                class="secondary-button"
                >Explore Frameworks</a
              >
            </div>

            <div class="hero-stats" animated="fadeInUp" delay="1.2s">
              <div class="stat-item" animated="zoomIn" delay="1.4s">
                <span class="stat-number">6+</span>
                <span class="stat-label">Years of Innovation</span>
              </div>
              <div class="stat-item" animated="zoomIn" delay="1.6s">
                <span class="stat-number">10+</span>
                <span class="stat-label">Happy Custumers</span>
              </div>
              <div class="stat-item" animated="zoomIn" delay="1.8s">
                <span class="stat-number">100+</span>
                <span class="stat-label">Open Source Packages</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
        }
    })
], $6a29ff4768ec260b$export$6e72650f8ca84b85);



var $g0n63 = parcelRequire("g0n63");

var $2Md89 = parcelRequire("2Md89");

var $eG1Pq = parcelRequire("eG1Pq");

class $25dedc8fbfc4060d$export$3dbeb37e7f22b22 extends (0, $eG1Pq.LitElement) {
}
$25dedc8fbfc4060d$export$3dbeb37e7f22b22 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'mission-component',
        styles: [
            (0, $eG1Pq.css)`
      ${(0, $9e74e140c0a3f9ef$export$856a3733e3aa783)}

      :host {
        display: block;
        color: var(--text-primary);
      }

      .mission-section {
        background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--border-light) 50%, var(--bg-tertiary) 100%);
        padding: 100px 0;
        text-align: center;
        position: relative;
      }

      .mission-content {
        max-width: 900px;
        margin: 0 auto;
      }

      .mission-title {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 30px;
        color: var(--text-primary);
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
      }

      .mission-text {
        font-size: 1.25rem;
        line-height: 1.7;
        color: var(--text-secondary);
        margin-bottom: 60px;
        font-weight: 400;
      }

      @media (max-width: 768px) {
        .mission-section {
          padding: 80px 0;
        }

        .mission-title {
          font-size: 2rem;
        }

        .mission-text {
          font-size: 1.1rem;
        }
      }
    `
        ],
        modifiers: [
            ...(0, $2Md89.FlexLayout),
            ...(0, $2Md89.AngularLayout)
        ],
        template () {
            return (0, $eG1Pq.html)`
      <section class="mission-section">
        <div class="container">
          <div class="mission-content">
            <h2 class="mission-title">Our Mission</h2>
            <p class="mission-text">
              We're committed to revolutionizing web development by providing tools and frameworks that prioritize
              developer experience, code quality, and system maintainability. Our solutions eliminate the pain points
              that have plagued the industry for years, allowing teams to focus on building great products instead of
              fighting with their tools.
            </p>
          </div>
        </div>
      </section>
    `;
        }
    })
], $25dedc8fbfc4060d$export$3dbeb37e7f22b22);



var $g0n63 = parcelRequire("g0n63");

var $2Md89 = parcelRequire("2Md89");

var $eG1Pq = parcelRequire("eG1Pq");

class $ba9debb5ca0654ea$export$31e87b645dde4cb8 extends (0, $eG1Pq.LitElement) {
}
$ba9debb5ca0654ea$export$31e87b645dde4cb8 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'problem-component',
        styles: [
            (0, $eG1Pq.css)`
      ${(0, $9e74e140c0a3f9ef$export$856a3733e3aa783)}

      :host {
        display: block;
        color: var(--text-primary);
      }

      .story-content p {
        margin-bottom: 16px;
      }

      .story-content p:last-child {
        margin-bottom: 0;
      }
    `
        ],
        modifiers: [
            ...(0, $2Md89.FlexLayout),
            ...(0, $2Md89.AngularLayout)
        ],
        template () {
            return (0, $eG1Pq.html)`
      <section class="section" id="about">
        <div class="container">
          <h2 class="section-title">The Problem We Solved</h2>
          <div class="card card-bordered">
            <h3 class="card-title">The State of Web Development in 2019</h3>
            <div class="card-description">
              <p>
                When we started Reactive Solutions in 2019, the web development landscape was in disarray. Major
                frameworks like Angular 2 were introducing small version upgrades and minor features for years, while
                ignoring valuable community contributions. At that time, there were over 3,000 open pull requests in the
                Angular repository—many containing really nice features that never made it to production. The marketing
                strategy was to provide small changes, bump the version, then write 1,000 blog posts about it with
                clickbait titles and ads.
              </p>
              <p>
                Many of these tickets were bugs or library bumps to use newer versions of Node.js. Others were packages
                built with different versions of Angular that were compatible to a point, but if the maintainer didn't
                push new versions, it would stop you from upgrading or force you to postpone updates due to the multiple
                changes required.
              </p>
              <p>
                The backend world wasn't much better. It was missing types, and many developers resisted adopting
                technologies like TypeScript, causing code quality to suffer significantly. Many libraries had
                vulnerabilities, and some would break completely when introducing patch versions. Literally nobody was
                familiar with semantic versioning—what patch, major, and minor versions meant, and when to introduce
                them. Frameworks weren't abstract enough, and this is where the interesting part began.
              </p>
            </div>
          </div>

          <div class="card card-bordered">
            <h3 class="card-title">The Bold Decision</h3>
            <div class="card-description">
              <p>
                We at Reactive Solutions decided to make a bold move and create our own libraries and frameworks to
                provide better Developer Experience and easier maintainability of the systems we were building. This is
                where the fun began—we started with the basics using pure Node.js and decided to use Dependency
                Injection as the main pattern with TypeScript annotations (decorators) and create abstractions around
                them based on our understanding of Angular 2.
              </p>
              <p>
                Our main goal was to make it less coupled, still easy to maintain, and without introducing breaking
                changes—it was more like a mindset. We also wanted the injection to be async, but later we realized it
                was almost impossible due to the Node.js event loop and how it handles async jobs. This realization led
                us to create the @rhtml, @rxdi, and @gapi npm libraries.
              </p>
            </div>
          </div>
        </div>
      </section>
    `;
        }
    })
], $ba9debb5ca0654ea$export$31e87b645dde4cb8);


/* eslint-disable lit/attribute-value-entities */ 
var $g0n63 = parcelRequire("g0n63");

var $2Md89 = parcelRequire("2Md89");

var $eG1Pq = parcelRequire("eG1Pq");

var $j8NvH = parcelRequire("j8NvH");

var $c33079921562ebe4$exports = {};
$c33079921562ebe4$exports = import.meta.resolve("5UGZV");


var $3f994779d0750e3c$exports = {};
$3f994779d0750e3c$exports = import.meta.resolve("6wyvH");


var $ae44ef526219af70$exports = {};
$ae44ef526219af70$exports = import.meta.resolve("hAzHT");


class $5d3f53d1f0e82e64$export$7d999fd7250e20aa extends (0, $eG1Pq.LitElement) {
}
$5d3f53d1f0e82e64$export$7d999fd7250e20aa = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'services-component',
        styles: [
            (0, $eG1Pq.css)`
      ${(0, $9e74e140c0a3f9ef$export$856a3733e3aa783)}

      :host {
        display: block;
        color: var(--text-primary);
      }

      .services-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 32px;
        margin-top: 40px;
      }

      .service-button {
        display: inline-flex;
        align-items: center;
        padding: 12px 24px;
        background: var(--bg-secondary);
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        color: var(--primary-color);
        text-decoration: none;
        font-size: 0.9rem;
        font-weight: 500;
        transition: all 0.3s ease;
        cursor: pointer;
      }

      .service-button:hover {
        background: var(--primary-color);
        color: white;
        border-color: var(--primary-color);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 102, 255, 0.3);
      }

      @media (max-width: 768px) {
        .services-grid {
          grid-template-columns: 1fr;
          gap: 24px;
        }
      }
    `
        ],
        modifiers: [
            ...(0, $2Md89.FlexLayout),
            ...(0, $2Md89.AngularLayout),
            (0, $j8NvH.Animation),
            (0, $3d69e531819a5bb4$export$c7cad6b3e396923a),
            (0, $18f5d65820ae3466$export$1bc430945f060dd1)
        ],
        template () {
            return (0, $eG1Pq.html)`
      <section class="section" id="services" scroll-observer threshold="0.2">
        <div class="container">
          <h2 class="section-title" animated="fadeInDown" delay="0.2s">Our Services</h2>
          <p class="section-subtitle" animated="fadeInUp" delay="0.4s">
            We provide comprehensive web development solutions tailored to your specific needs, from complete project
            implementations to specialized consulting services.
          </p>

          <div class="services-grid">
            <!-- Complete Project Solutions -->
            <div class="card service-card" animated="slideInLeft" delay="0.1s" parallax speed="0.2" direction="up">
              <div class="service-illustration">
                <img src=${0, (/*@__PURE__*/$parcel$interopDefault($c33079921562ebe4$exports))} alt="Complete Project Solutions" />
              </div>
              <h3 class="card-title">Complete Project Solutions</h3>
              <p class="card-description">
                Work with us to implement the best possible long-term working solution to given idea, because
                scalability, performance and sustainability should not be just fancy words.
              </p>
              <div class="service-button">Learn More →</div>
            </div>

            <!-- Frontend & Backend Development -->
            <div class="card service-card" animated="slideInUp" delay="0.1s" parallax speed="0.15" direction="up">
              <div class="service-illustration">
                <img src=${0, (/*@__PURE__*/$parcel$interopDefault($ae44ef526219af70$exports))} alt="Frontend & Backend Development" />
              </div>
              <h3 class="card-title">Frontend & Backend Development</h3>
              <p class="card-description">
                Reactive Solutions delivers comprehensive frontend and backend development services, handling small to
                medium-sized projects with modern technologies and best practices.
              </p>
              <div class="service-button">Learn More →</div>
            </div>

            <!-- Web Development Consulting -->
            <div class="card service-card" animated="slideInRight" delay="0.1s" parallax speed="0.25" direction="up">
              <div class="service-illustration">
                <img src=${0, (/*@__PURE__*/$parcel$interopDefault($3f994779d0750e3c$exports))} alt="Web Development Consulting" />
              </div>
              <h3 class="card-title">Web Development Consulting</h3>
              <p class="card-description">
                Optimize your web application's architecture, implementation, performance, memory usage and scaling
                capabilities with our expert advice and guidance.
              </p>
              <div class="service-button">Learn More →</div>
            </div>
          </div>
        </div>
      </section>
    `;
        }
    })
], $5d3f53d1f0e82e64$export$7d999fd7250e20aa);



var $g0n63 = parcelRequire("g0n63");

var $2Md89 = parcelRequire("2Md89");

var $eG1Pq = parcelRequire("eG1Pq");


class $c1d96d0b7e2b3c45$export$c08652f9fbfd091f extends (0, $eG1Pq.LitElement) {
}
$c1d96d0b7e2b3c45$export$c08652f9fbfd091f = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'showcase-component',
        components: [
            (0, $8400c4dc1fb0914b$exports.DividerComponent)
        ],
        styles: [
            (0, $eG1Pq.css)`
      ${(0, $9e74e140c0a3f9ef$export$856a3733e3aa783)}

      :host {
        display: block;
        color: var(--text-primary);
      }

      .section-header {
        text-align: center;
        margin-bottom: 64px;
      }

      rx-divider {
        margin: 24px auto;
        width: 80px;
      }

      .section-description {
        color: var(--text-secondary);
        font-size: 1.125rem;
        line-height: 1.7;
        max-width: 600px;
        margin: 0 auto;
        font-weight: 400;
      }

      .tech-stack-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 32px;
        max-width: 1200px;
        margin: 0 auto 64px;
      }

      .tech-stack-icon {
        width: 48px;
        height: 48px;
        margin-bottom: 24px;
        color: var(--primary-color);
        opacity: 0.9;
      }

      .showcase-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 32px;
        max-width: 1200px;
        margin: 0 auto;
      }

      @media (max-width: 768px) {
        .tech-stack-grid,
        .showcase-grid {
          grid-template-columns: 1fr;
          gap: 24px;
        }
      }
    `
        ],
        modifiers: [
            ...(0, $2Md89.FlexLayout),
            ...(0, $2Md89.AngularLayout)
        ],
        template () {
            return (0, $eG1Pq.html)`
      <section class="section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">Our Technology Stack</h2>
            <rx-divider></rx-divider>
            <p class="section-description">
              We leverage cutting-edge technologies to deliver exceptional web applications with outstanding
              performance, scalability, and maintainability.
            </p>
          </div>

          <div class="tech-stack-grid">
            <div class="card">
              <div class="tech-stack-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                </svg>
              </div>
              <h3 class="card-title">Modern Frameworks</h3>
              <p class="card-description">
                We use the latest web technologies including @rhtml, @rxdi, and @gapi to build performant and scalable
                applications with modern development practices.
              </p>
            </div>

            <div class="card">
              <div class="tech-stack-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 class="card-title">Type Safety</h3>
              <p class="card-description">
                Full TypeScript integration ensures type safety across the entire stack, reducing bugs and improving
                developer experience.
              </p>
            </div>

            <div class="card">
              <div class="tech-stack-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 class="card-title">Performance</h3>
              <p class="card-description">
                Optimized for speed with serverless architecture, efficient bundling, and minimal bundle sizes for
                lightning-fast applications.
              </p>
            </div>
          </div>

          <div class="section-header">
            <h2 class="section-title">Showcase Projects</h2>
            <rx-divider></rx-divider>
            <p class="section-description">
              Discover how our frameworks and tools power real-world applications with exceptional performance and
              developer experience.
            </p>
          </div>

          <div class="showcase-grid">
            <div class="card">
              <h3 class="card-title">graphql-server.com</h3>
              <p class="card-description">
                Our flagship platform combining Agile/Kanban project management with instant GraphQL/REST backend
                generation using custom serverless architecture.
              </p>
            </div>

            <div class="card">
              <h3 class="card-title">@rhtml Framework</h3>
              <p class="card-description">
                The world's smallest dependency injection system at less than 1.4kb, featuring modern web components and
                declarative programming patterns.
              </p>
            </div>

            <div class="card">
              <h3 class="card-title">@gapi GraphQL</h3>
              <p class="card-description">
                Powerful GraphQL API framework with decorators, guards, and comprehensive TypeScript support for complex
                backend applications.
              </p>
            </div>
          </div>
        </div>
      </section>
    `;
        }
    })
], $c1d96d0b7e2b3c45$export$c08652f9fbfd091f);



var $g0n63 = parcelRequire("g0n63");

var $2Md89 = parcelRequire("2Md89");

var $eG1Pq = parcelRequire("eG1Pq");

var $j8NvH = parcelRequire("j8NvH");

class $8f92ef3fd72eb6d1$export$49f98cb065d4337b extends (0, $eG1Pq.LitElement) {
}
$8f92ef3fd72eb6d1$export$49f98cb065d4337b = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'timeline-component',
        styles: [
            (0, $eG1Pq.css)`
      ${(0, $9e74e140c0a3f9ef$export$856a3733e3aa783)}

      :host {
        display: block;
        color: var(--text-primary);
      }

      .timeline {
        position: relative;
        padding: 40px 0;
      }

      .timeline::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 0;
        bottom: 0;
        width: 3px;
        background: linear-gradient(180deg, var(--primary-color) 0%, var(--secondary-color) 100%);
        transform: translateX(-50%);
        border-radius: 2px;
      }

      .timeline-item {
        position: relative;
        margin-bottom: 60px;
        width: 45%;
        transform: translateZ(0);
        will-change: transform;
        cursor: pointer;
      }

      .timeline-item:nth-child(odd) {
        left: 0;
        text-align: right;
      }

      .timeline-item:nth-child(even) {
        left: 55%;
        text-align: left;
      }

      .timeline-content {
        background: var(--bg-primary);
        border-radius: var(--radius-xl);
        padding: 32px;
        position: relative;
        border: 1px solid var(--border-light);
        box-shadow: var(--shadow-sm);
        transition: all 0.3s ease;
      }

      .timeline-content:hover {
        transform: translateY(-4px);
        box-shadow: var(--shadow-lg);
        border-color: var(--primary-color);
      }

      .timeline-date {
        font-size: 1.1rem;
        font-weight: 600;
        color: var(--primary-color);
        margin-bottom: 12px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
      }

      .timeline-title {
        font-size: 1.3rem;
        font-weight: 600;
        margin-bottom: 12px;
        color: var(--text-primary);
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
      }

      .timeline-description {
        color: var(--text-secondary);
        line-height: 1.6;
        font-weight: 400;
      }

      @media (max-width: 768px) {
        .timeline::before {
          left: 20px;
        }

        .timeline-item {
          width: auto;
          left: 0 !important;
          text-align: left !important;
          padding-left: 50px;
        }

        .timeline-item:nth-child(odd) .timeline-content::after,
        .timeline-item:nth-child(even) .timeline-content::after {
          left: -10px !important;
          right: auto !important;
          border-right: 10px solid var(--border-light) !important;
          border-left: none !important;
        }

        .timeline-content {
          padding: 24px;
        }
      }
    `
        ],
        modifiers: [
            ...(0, $2Md89.FlexLayout),
            ...(0, $2Md89.AngularLayout),
            (0, $j8NvH.Animation),
            (0, $3d69e531819a5bb4$export$c7cad6b3e396923a)
        ],
        template () {
            return (0, $eG1Pq.html)`
      <section class="section" id="timeline" scroll-observer threshold="0.2">
        <div class="container">
          <h2 class="section-title" animated="fadeInDown" delay="0.1s">Our Journey</h2>
          <div class="timeline">
            <div class="timeline-item" animated="slideInLeft" delay="0.2s">
              <div class="timeline-content">
                <div class="timeline-date">2016-2017</div>
                <div class="timeline-title">The Birth of @rxdi</div>
                <div class="timeline-description">
                  Created the foundation with @rxdi - a reactive dependency injection container that works both in
                  browser and Node.js environments, inspired by Angular's DI but with reactive programming.
                </div>
              </div>
            </div>

            <div class="timeline-item" animated="slideInRight" delay="0.3s">
              <div class="timeline-content">
                <div class="timeline-date">2017</div>
                <div class="timeline-title">@gapi Framework</div>
                <div class="timeline-description">
                  Built @gapi on top of @rxdi - a GraphQL API framework designed to provide complex Node.js backend
                  applications with minimum effort, featuring decorators and dependency injection.
                </div>
              </div>
            </div>

            <div class="timeline-item" animated="slideInLeft" delay="0.4s">
              <div class="timeline-content">
                <div class="timeline-date">2019</div>
                <div class="timeline-title">@rhtml Revolution</div>
                <div class="timeline-description">
                  Created @rhtml - the world's smallest dependency injection at less than 1.4kb (0.3kb bundled). This
                  pure and fast DI system became the foundation for modern web component development.
                </div>
              </div>
            </div>

            <div class="timeline-item" animated="slideInRight" delay="0.5s">
              <div class="timeline-content">
                <div class="timeline-date">2020-2021</div>
                <div class="timeline-title">@Component & Abstractions</div>
                <div class="timeline-description">
                  Developed @Component decorator for web components and created powerful abstractions with @modifiers
                  and @custom-attributes, enabling declarative programming patterns.
                </div>
              </div>
            </div>

            <div class="timeline-item" animated="slideInLeft" delay="0.6s">
              <div class="timeline-content">
                <div class="timeline-date">2021-2022</div>
                <div class="timeline-title">Monadic Operators</div>
                <div class="timeline-description">
                  Pioneered the first declarative web component programming pattern using monadic approach. Created
                  operators like r-let and r-if for faster loading and Server Side Rendering.
                </div>
              </div>
            </div>

            <div class="timeline-item" animated="slideInRight" delay="0.7s">
              <div class="timeline-content">
                <div class="timeline-date">2022-Present</div>
                <div class="timeline-title">graphql-server.com</div>
                <div class="timeline-description">
                  Launched our flagship platform combining Agile/Kanban project management with instant GraphQL/REST
                  backend generation using custom serverless architecture on Kubernetes.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
        }
    })
], $8f92ef3fd72eb6d1$export$49f98cb065d4337b);


class $4d02718c9163d9e7$export$91ab848c4a468602 extends (0, $eG1Pq.LitElement) {
    OnUpdateFirst() {
        this.scrollToService.setElements(Array.from(this.shadowRoot.querySelectorAll('*')));
    }
}
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $56Yze.ScrollToService))
], $4d02718c9163d9e7$export$91ab848c4a468602.prototype, "scrollToService", void 0);
$4d02718c9163d9e7$export$91ab848c4a468602 = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'home-component',
        components: [
            (0, $6a29ff4768ec260b$export$6e72650f8ca84b85),
            (0, $ba9debb5ca0654ea$export$31e87b645dde4cb8),
            (0, $8f92ef3fd72eb6d1$export$49f98cb065d4337b),
            (0, $76a74515b95de46b$export$ac64dc01870730c4),
            (0, $25dedc8fbfc4060d$export$3dbeb37e7f22b22),
            (0, $5d3f53d1f0e82e64$export$7d999fd7250e20aa),
            (0, $c1d96d0b7e2b3c45$export$c08652f9fbfd091f),
            (0, $5ad552b087a0a476$export$f5d4b1ce866dd389)
        ],
        styles: [
            (0, $eG1Pq.css)`
      :host {
        display: block;
        color: white;
      }
    `
        ],
        template () {
            return (0, $eG1Pq.html)`
      <hero-component></hero-component>
      <services-component></services-component>
      <timeline-component></timeline-component>
      <mission-component></mission-component>
      <problem-component></problem-component>
      <frameworks-component></frameworks-component>
      <showcase-component></showcase-component>
      <contact-component></contact-component>
    `;
        }
    })
], $4d02718c9163d9e7$export$91ab848c4a468602);



var $g0n63 = parcelRequire("g0n63");

var $64Pi0 = parcelRequire("64Pi0");

var $2Md89 = parcelRequire("2Md89");

var $4XQlz = parcelRequire("4XQlz");

var $eG1Pq = parcelRequire("eG1Pq");

var $c22PD = parcelRequire("c22PD");

var $g0n63 = parcelRequire("g0n63");

var $d1fLk = parcelRequire("d1fLk");

var $64Pi0 = parcelRequire("64Pi0");
class $03e3df2a972ac8e7$export$8ee6ea94b5aedb49 extends (0, $d1fLk.Attribute) {
}
(0, $g0n63.__decorate)([
    (0, $d1fLk.Input)({
        observe: true
    }),
    (0, $64Pi0.HostBinding)('style.padding')
], $03e3df2a972ac8e7$export$8ee6ea94b5aedb49.prototype, "padding", void 0);
$03e3df2a972ac8e7$export$8ee6ea94b5aedb49 = (0, $g0n63.__decorate)([
    (0, $d1fLk.Modifier)({
        selector: 'padding'
    })
], $03e3df2a972ac8e7$export$8ee6ea94b5aedb49);



var $56Yze = parcelRequire("56Yze");


var $4aogj = parcelRequire("4aogj");

var $knJUy = parcelRequire("knJUy");

var $hyQIa = parcelRequire("hyQIa");

var $4YhJE = parcelRequire("4YhJE");
function $ea2bccd133985c25$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $hyQIa.mergeMap)((0, $4YhJE.identity), concurrent);
}


function $643f5dc7be86eb36$export$b314777ae20abca9() {
    return (0, $ea2bccd133985c25$export$18aef43295bbe906)(1);
}



var $3jBRy = parcelRequire("3jBRy");

var $lBKT3 = parcelRequire("lBKT3");
function $4421bd8dbbb8a0c7$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $643f5dc7be86eb36$export$b314777ae20abca9)()((0, $lBKT3.from)(args, (0, $3jBRy.popScheduler)(args)));
}



var $hgiLQ = parcelRequire("hgiLQ");

var $4J4s9 = parcelRequire("4J4s9");

var $fyrlr = parcelRequire("fyrlr");

var $3CHs3 = parcelRequire("3CHs3");
function $47c7c0df28ac535d$export$6953b97c7d866605() {
    return (0, $4J4s9.operate)(function(source, subscriber) {
        source.subscribe((0, $fyrlr.createOperatorSubscriber)(subscriber, (0, $3CHs3.noop)));
    });
}



var $3XkaH = parcelRequire("3XkaH");
function $748e47ba04b473f6$export$e0eaf3a86c03b2ad(value) {
    return (0, $3XkaH.map)(function() {
        return value;
    });
}



var $hyQIa = parcelRequire("hyQIa");

var $9IWtL = parcelRequire("9IWtL");
function $b2a2599f0e980fab$export$286ca829307725c9(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, $4421bd8dbbb8a0c7$export$ee1b3e54f0441b22)(subscriptionDelay.pipe((0, $hgiLQ.take)(1), (0, $47c7c0df28ac535d$export$6953b97c7d866605)()), source.pipe($b2a2599f0e980fab$export$286ca829307725c9(delayDurationSelector)));
    };
    return (0, $hyQIa.mergeMap)(function(value, index) {
        return (0, $9IWtL.innerFrom)(delayDurationSelector(value, index)).pipe((0, $hgiLQ.take)(1), (0, $748e47ba04b473f6$export$e0eaf3a86c03b2ad)(value));
    });
}



var $82Kdl = parcelRequire("82Kdl");

var $knJUy = parcelRequire("knJUy");

var $a2zXt = parcelRequire("a2zXt");

var $8xmUq = parcelRequire("8xmUq");
function $6eb2be060ac8c197$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $knJUy.async);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $a2zXt.isScheduler)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $82Kdl.Observable)(function(subscriber) {
        var due = (0, $8xmUq.isValidDate)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}


function $e28e9b7ce6ae78ef$export$1391212d75b2ee65(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, $knJUy.asyncScheduler);
    var duration = (0, $6eb2be060ac8c197$export$9dc4ecf953986f04)(due, scheduler);
    return (0, $b2a2599f0e980fab$export$286ca829307725c9)(function() {
        return duration;
    });
}


var $hgiLQ = parcelRequire("hgiLQ");
var $37rZb = parcelRequire("37rZb");

var $eG1Pq = parcelRequire("eG1Pq");
const $76393e3f49d98578$export$e6ff31bff12b7ff4 = (0, $eG1Pq.svg)`
<svg width="40" height="40" viewBox="0 0 900 1020.64" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#0066ff"/>
      <stop offset="100%" style="stop-color:#4f46e5"/>
    </linearGradient>
  </defs>
  
  <g id="Layer_2" data-name="Layer 2">
    <g id="Layer_1-2" data-name="Layer 1">
      <polygon points="179.46 622.96 683.77 688.07 683.16 686.57 449.6 511.27 179.46 622.96" style="fill:var(--primary-color)" />
      <polygon points="179.46 622.96 179.46 622.96 449.6 511.27 490.88 210.66 179.46 622.96" style="fill:var(--primary-color)" />
      <polygon points="683.37 687.17 491.38 210.06 490.88 210.66 449.6 511.27 683.37 687.17" style="fill:var(--primary-color)" />
      <polygon points="452.3 918.36 39.48 777.02 444.49 1020.64 873.55 779.83 529.36 171.09 760.82 745.17 452.3 918.36" style="fill:var(--primary-color);fill-rule:evenodd" />
      <path d="M582.47,277.27q56.06,122.61,112.72,244.52,28.56,61,56.92,121.81,27.5,58.59,55.1,117.2-90,50.78-179.75,101.57Q581.61,888.51,536,914.66q-44.79,25.7-89.48,51.39-81-37.57-161.82-74.93-82.06-37.57-163.83-74.93,80.72,39.66,161.72,79.34,82.07,40,164.33,79.83,92.75-52,185.58-104.08,93.78-53,187.77-106.37Q790.18,702.39,760,639.79,730.71,579.39,701.3,519,642.38,398,582.47,277.27Z" style="fill:#ffffff;fill-rule:evenodd" />
      <polygon points="808.12 290.8 898 717.62 900 245.12 473.45 0 126.55 607.23 501.4 114.49 808.12 290.8" style="fill:var(--primary-color);fill-rule:evenodd" />
      <path d="M190.58,507.26q76.65-111,152.41-222.07,37.72-55.6,75.55-111.09Q454.77,120.31,491,66.71,580.71,118,670.34,169q45.84,26,91.69,51.88,45.08,25.24,90,50.49,9.18,88.8,18.54,177.3,9.76,89.71,19.44,179.11-7.22-89.7-14.53-179.51-7.82-90.9-15.63-182-92.13-52.89-184.47-106.08Q581.7,106.83,487.77,53.39q-38.16,57.85-76.55,115.8-37,56-73.84,112.29-73.65,112.39-146.8,225.78Z" style="fill:#ffffff;fill-rule:evenodd" />
      <path d="M452.11,518.88c-6.22-6.41-2.11-11.82,5.51-7.21,76,57.3,170.64,128.62,225.65,175.7-60.43-39.87-155-111.19-231.16-168.49Z" style="fill:#ffffff;fill-rule:evenodd" />
      <path d="M442.38,510.37c8.82-2,11.33,4.21,3.51,8.41-88.17,36.07-197.79,81-266.43,104.18,65.23-31.55,174.75-76.43,262.92-112.59Z" style="fill:#ffffff;fill-rule:evenodd" />
      <path d="M445.89,504.16c.4,9,7.12,9.72,9,1.1,11.42-94.56,31.86-223.18,36-295.5-13.12,71.22-33.57,199.84-45,294.4Z" style="fill:#ffffff;fill-rule:evenodd" />
      <polygon points="820.24 585.6 763.83 322.05 627.55 244.31 820.24 585.6" style="fill:var(--primary-color)" />
      <polygon points="586.27 790.45 227.16 791.55 448.8 867.58 586.27 790.45" style="fill:var(--primary-color)" />
      <polygon points="323.55 161.48 135.47 329.46 135.47 493.14 323.55 161.48" style="fill:var(--primary-color)" />
      <polygon points="85.37 307.32 410.72 16.63 0 250.43 0 742.27 699.4 740.26 85.37 660.93 85.37 307.32" style="fill:var(--primary-color);fill-rule:evenodd" />
      <path d="M580.86,734.65q-134.37-11.26-268.54-21.43-67-5.12-134-10.12L49.1,693.78q-.3-103.21-.7-206.35c-.2-35.16-.5-70.32-.7-105.38q-.62-51.54-1-103.07Q119,226.69,191.18,174.5q72.9-53.19,145.59-106.08-74.1,50.93-148.39,102.07-75,52-150,104.18-.15,106.23-.2,212.76.45,107.73.9,215.77l138.67,8.71q67,4.07,134.17,8,134.22,7.68,268.94,14.73Z" style="fill:#ffffff;fill-rule:evenodd" />
      <polygon points="509.32 810.68 345.99 811.08 446.79 845.64 509.32 810.68" style="fill:#ffffff" />
      <polygon points="246.29 257.24 155.51 338.27 155.51 417.31 246.29 257.24" style="fill:#ffffff" />
      <polygon points="773.25 461.89 746.09 334.87 680.46 297.51 773.25 461.89" style="fill:#ffffff" />
      <polygon points="179.46 622.96 683.77 688.07 683.16 686.57 449.6 511.27 179.46 622.96" style="fill:var(--primary-color)" />
      <polygon points="179.46 622.96 179.46 622.96 449.6 511.27 490.88 210.66 179.46 622.96" style="fill:var(--primary-color)" />
      <polygon points="683.37 687.17 491.38 210.06 490.88 210.66 449.6 511.27 683.37 687.17" style="fill:var(--primary-color)" />
      <polygon points="294.79 607.64 576.15 644 445.29 545.43 319.04 597.62 294.79 607.64" style="fill:#ffffff" />
      <polygon points="422.25 490.14 445.49 320.45 269.74 553.24 422.25 490.14" style="fill:#ffffff" />
      <polygon points="615.23 598.22 505.41 325.25 481.66 497.95 481.66 497.95 615.23 598.22" style="fill:#ffffff" />
      <path d="M452.11,518.88c-6.22-6.41-2.11-11.82,5.51-7.21,76,57.3,170.64,128.62,225.65,175.7-60.43-39.87-155-111.19-231.16-168.49Z" style="fill:#ffffff;fill-rule:evenodd" />
      <path d="M442.38,510.37c8.82-2,11.33,4.21,3.51,8.41-88.17,36.07-197.79,81-266.43,104.18,65.23-31.55,174.75-76.43,262.92-112.59Z" style="fill:#ffffff;fill-rule:evenodd" />
      <path d="M445.89,504.16c.4,9,7.12,9.72,9,1.1,11.42-94.56,31.86-223.18,36-295.5-13.12,71.22-33.57,199.84-45,294.4Z" style="fill:#ffffff;fill-rule:evenodd" />
    </g>
  </g>
</svg>
`;


class $45750383e10888b4$export$7a91bf930e5240cd extends (0, $eG1Pq.LitElement) {
    onScroll() {
        const currentScrollY = window.scrollY;
        const navbar = this.shadowRoot?.getElementById('navbar');
        // Add scrolled class when scrolling down past threshold
        if (currentScrollY > this.scrollThreshold) navbar.classList.add('scrolled');
        else navbar.classList.remove('scrolled');
    }
    async scrollToSection(componentName) {
        if (this.router.activePath !== '/') {
            this.router.go('/');
            await (0, $4aogj.lastValueFrom)(this.router.onSnapshotChange().pipe((0, $e28e9b7ce6ae78ef$export$1391212d75b2ee65)(10), (0, $hgiLQ.take)(1), (0, $37rZb.tap)(()=>this.scrollToService.scrollToElement(componentName))));
            return;
        }
        this.scrollToService.scrollToElement(componentName);
    }
    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    onLogoClicked() {
        this.router.go('/');
        this.scrollToTop();
    }
    onBlogClicked() {
        this.router.go('/blog');
        this.scrollToTop();
    }
    constructor(...args){
        super(...args), this.counter = 0, this.scrollThreshold = 100;
    }
}
(0, $g0n63.__decorate)([
    (0, $eG1Pq.property)({
        type: Number
    })
], $45750383e10888b4$export$7a91bf930e5240cd.prototype, "counter", void 0);
(0, $g0n63.__decorate)([
    (0, $4XQlz.Inject)((0, $56Yze.ScrollToService))
], $45750383e10888b4$export$7a91bf930e5240cd.prototype, "scrollToService", void 0);
(0, $g0n63.__decorate)([
    (0, $c22PD.Router)()
], $45750383e10888b4$export$7a91bf930e5240cd.prototype, "router", void 0);
(0, $g0n63.__decorate)([
    (0, $64Pi0.HostListener)('window:scroll')
], $45750383e10888b4$export$7a91bf930e5240cd.prototype, "onScroll", null);
$45750383e10888b4$export$7a91bf930e5240cd = (0, $g0n63.__decorate)([
    (0, $eG1Pq.Component)({
        selector: 'navbar-component',
        styles: [
            (0, $eG1Pq.css)`
      ${(0, $9e74e140c0a3f9ef$export$856a3733e3aa783)}

      :host {
        display: block;
      }

      .navbar {
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(15px);
        position: fixed;
        top: 16px;
        left: 16px;
        right: 16px;
        z-index: 10;
        border-radius: var(--radius-xl);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(255, 255, 255, 0.2);
        transition: all 0.3s ease;
      }

      .navbar.scrolled {
        top: 0;
        left: 0;
        right: 0;
        border-radius: 0;
        box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
        border: none;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      }

      .navbar-container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 24px;
        height: 68px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .logo-section {
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
        transition: all 0.3s ease;
        padding: 8px 12px;
        border-radius: 10px;
      }

      .logo {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s ease;
      }

      .logo-section:hover .logo {
        transform: scale(1.05);
      }

      .company-name {
        font-size: 1.4rem;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
        background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        user-select: none;
      }

      .nav-links {
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .nav-link {
        color: var(--text-secondary);
        text-decoration: none;
        font-weight: 500;
        font-size: 0.95rem;
        transition: all 0.2s ease;
        position: relative;
        padding: 12px 20px;
        border-radius: 10px;
        user-select: none;
        cursor: pointer;
      }

      .nav-link:hover {
        color: var(--primary-color);
        background: rgba(0, 102, 255, 0.06);
      }

      .nav-link::after {
        content: '';
        position: absolute;
        bottom: 8px;
        left: 50%;
        width: 0;
        height: 2px;
        background: var(--primary-color);
        transition: all 0.2s ease;
        transform: translateX(-50%);
        border-radius: 1px;
      }

      .nav-link:hover::after {
        width: 40%;
      }

      .cta-button {
        padding: 12px 24px;
        border-radius: 10px;
        font-size: 0.9rem;
        margin-left: 8px;
      }

      @media (max-width: 768px) {
        .nav-links {
          display: none;
        }

        .navbar-container {
          justify-content: center;
        }

        .navbar {
          top: 8px;
          left: 8px;
          right: 8px;
        }

        .navbar.scrolled {
          top: 0;
          left: 0;
          right: 0;
        }
      }
    `
        ],
        modifiers: [
            ...(0, $2Md89.FlexLayout),
            (0, $03e3df2a972ac8e7$export$8ee6ea94b5aedb49)
        ],
        template () {
            return (0, $eG1Pq.html)`
      <nav class="navbar" id="navbar">
        <div class="navbar-container">
          <div class="logo-section" @click=${()=>this.onLogoClicked()}>
            <div class="logo">${0, $76393e3f49d98578$export$e6ff31bff12b7ff4}</div>
            <h1 class="company-name">Reactive Solutions</h1>
          </div>

          <div class="nav-links">
            <div class="nav-link" @click=${()=>this.scrollToSection('services-component')}>Services</div>
            <div class="nav-link" @click=${()=>this.scrollToSection('timeline-component')}>Journey</div>
            <div class="nav-link" @click=${()=>this.scrollToSection('mission-component')}>Mission</div>
            <div class="nav-link" @click=${()=>this.scrollToSection('frameworks-component')}>Frameworks</div>
            <div class="nav-link" @click=${()=>this.scrollToSection('showcase-component')}>Showcase</div>
            <div class="nav-link" @click=${()=>this.onBlogClicked()}>Blog</div>

            <div class="btn btn-primary cta-button" @click=${()=>this.scrollToSection('contact-component')}>
              Contact Us
            </div>
          </div>
        </div>
      </nav>
    `;
        }
    })
], $45750383e10888b4$export$7a91bf930e5240cd);


class $9100d899f67fd7ee$export$1a1a0c518124e6e0 {
}




$9100d899f67fd7ee$export$1a1a0c518124e6e0 = (0, $g0n63.__decorate)([
    (0, $4XQlz.Module)({
        components: [
            (0, $45750383e10888b4$export$7a91bf930e5240cd),
            (0, $4d02718c9163d9e7$export$91ab848c4a468602),
            (0, $3e1ab2764fc49be9$export$189e3f0ab56ac948)
        ],
        imports: [
            (0, $1da49d3f68760c7a$export$44568afb1bae0bd3),
            (0, $a01636625a15fd06$export$d5dc740503fb3d20),
            (0, $c22PD.RouterModule).forRoot([
                {
                    path: '/',
                    component: (0, $4d02718c9163d9e7$export$91ab848c4a468602)
                },
                {
                    path: '/flex',
                    children: ()=>(parcelRequire("ekdYX"))
                },
                {
                    path: '/blog',
                    children: ()=>(parcelRequire("8nfYN"))
                },
                {
                    path: '/login',
                    children: ()=>(parcelRequire("c2lOr"))
                },
                {
                    path: '(.*)',
                    component: 'not-found-component',
                    action: ()=>(parcelRequire("1SxFh"))
                }
            ], {
                log: true
            })
        ],
        bootstrap: [
            (0, $cc004e4ef5db5bf0$export$1eefa63ea41131fe)
        ]
    })
], $9100d899f67fd7ee$export$1a1a0c518124e6e0);


(0, $23prF.options).positionClass = 'toast-bottom-left';
const $215b3254c080dfcb$var$social = (0, $4XQlz.Bootstrap)((0, $cRdul.SocialModule).forRoot({
    apiKey: (0, $4QMof.ENVIRONMENT).GOOGLE_API_KEY,
    authDomain: (0, $4QMof.ENVIRONMENT).GOOGLE_AUTH_DOMAIN,
    databaseURL: (0, $4QMof.ENVIRONMENT).GOOGLE_DATABASE_URL,
    projectId: (0, $4QMof.ENVIRONMENT).GOOGLE_PROJECT_ID,
    storageBucket: (0, $4QMof.ENVIRONMENT).GOOGLE_STORAGE_BUCKET,
    messagingSenderId: (0, $4QMof.ENVIRONMENT).GOOGLE_MESSAGE_SENDER_ID,
    appId: (0, $4QMof.ENVIRONMENT).GOOGLE_APP_ID,
    measurmentId: (0, $4QMof.ENVIRONMENT).GOOGLE_MEASUREMENT_ID
}));
window.addEventListener('load', ()=>{
    $215b3254c080dfcb$var$social.pipe((0, $iuXHq.switchMap)(()=>(0, $4XQlz.Bootstrap)((0, $9100d899f67fd7ee$export$1a1a0c518124e6e0), {
            init: false
        }))).subscribe(()=>console.log('App Started!'), (err)=>console.error(err));
});
if (null) null.dispose(()=>document.body.innerHTML = '');


//# sourceMappingURL=reactivex.1a6f1c01.js.map
